/* tslint:disable */
/* eslint-disable */
/**
 * Wispr Backend
 * Wispr Backend API
 *
 * The version of the OpenAPI document: 0.5.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Deprecated flat request properties (language, surrounding text, app type, dictionary).
 * @export
 * @interface APIProperties
 */
export interface APIProperties {
    /**
     * 
     * @type {string}
     * @memberof APIProperties
     */
    'language'?: APIPropertiesLanguageEnum | null;
    /**
     * 
     * @type {string}
     * @memberof APIProperties
     */
    'before_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIProperties
     */
    'after_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIProperties
     */
    'selected_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIProperties
     */
    'app_type'?: APIPropertiesAppTypeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIProperties
     */
    'dictionary'?: Array<string> | null;
}

export const APIPropertiesLanguageEnum = {
    Empty: '',
    En: 'en',
    Engb: 'engb',
    Enca: 'enca',
    Zh: 'zh',
    Zhcn: 'zhcn',
    De: 'de',
    Dech: 'dech',
    Es: 'es',
    Ru: 'ru',
    Ko: 'ko',
    Fr: 'fr',
    Ja: 'ja',
    Pt: 'pt',
    Tr: 'tr',
    Pl: 'pl',
    Ca: 'ca',
    Nl: 'nl',
    Ar: 'ar',
    Sv: 'sv',
    It: 'it',
    Id: 'id',
    Hi: 'hi',
    Hien: 'hien',
    Fi: 'fi',
    Vi: 'vi',
    He: 'he',
    Uk: 'uk',
    El: 'el',
    Ms: 'ms',
    Cs: 'cs',
    Ro: 'ro',
    Da: 'da',
    Hu: 'hu',
    Ta: 'ta',
    No: 'no',
    Th: 'th',
    Ur: 'ur',
    Hr: 'hr',
    Bg: 'bg',
    Lt: 'lt',
    La: 'la',
    Mi: 'mi',
    Ml: 'ml',
    Cy: 'cy',
    Sk: 'sk',
    Te: 'te',
    Fa: 'fa',
    Lv: 'lv',
    Bn: 'bn',
    Sr: 'sr',
    Az: 'az',
    Sl: 'sl',
    Kn: 'kn',
    Et: 'et',
    Mk: 'mk',
    Br: 'br',
    Eu: 'eu',
    Is: 'is',
    Hy: 'hy',
    Ne: 'ne',
    Mn: 'mn',
    Bs: 'bs',
    Kk: 'kk',
    Sq: 'sq',
    Sw: 'sw',
    Gl: 'gl',
    Mr: 'mr',
    Pa: 'pa',
    Si: 'si',
    Km: 'km',
    Sn: 'sn',
    Yo: 'yo',
    So: 'so',
    Af: 'af',
    Oc: 'oc',
    Ka: 'ka',
    Be: 'be',
    Tg: 'tg',
    Sd: 'sd',
    Gu: 'gu',
    Am: 'am',
    Yi: 'yi',
    Lo: 'lo',
    Uz: 'uz',
    Fo: 'fo',
    Ht: 'ht',
    Ps: 'ps',
    Tk: 'tk',
    Nn: 'nn',
    Mt: 'mt',
    Sa: 'sa',
    Lb: 'lb',
    My: 'my',
    Bo: 'bo',
    Tl: 'tl',
    Mg: 'mg',
    As: 'as',
    Tt: 'tt',
    Haw: 'haw',
    Ln: 'ln',
    Ha: 'ha',
    Ba: 'ba',
    Jv: 'jv',
    Su: 'su',
    Yue: 'yue'
} as const;

export type APIPropertiesLanguageEnum = typeof APIPropertiesLanguageEnum[keyof typeof APIPropertiesLanguageEnum];
export const APIPropertiesAppTypeEnum = {
    Ai: 'ai',
    Email: 'email',
    Other: 'other'
} as const;

export type APIPropertiesAppTypeEnum = typeof APIPropertiesAppTypeEnum[keyof typeof APIPropertiesAppTypeEnum];

/**
 * Identifier of the enterprise invite being accepted.
 * @export
 * @interface AcceptEnterpriseInviteRequest
 */
export interface AcceptEnterpriseInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptEnterpriseInviteRequest
     */
    'invite_id': string;
}
/**
 * Identifier of the join request being accepted.
 * @export
 * @interface AcceptJoinRequestRequest
 */
export interface AcceptJoinRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptJoinRequestRequest
     */
    'join_request_id': string;
}
/**
 * Invite-link code used to join a team.
 * @export
 * @interface AcceptTeamInviteLinkRequest
 */
export interface AcceptTeamInviteLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptTeamInviteLinkRequest
     */
    'code': string;
}
/**
 * Every registered access key\'s decision for the current user.
 * @export
 * @interface AccessResponse
 */
export interface AccessResponse {
    /**
     * 
     * @type {{ [key: string]: FlagPayload; }}
     * @memberof AccessResponse
     */
    'flags': { [key: string]: FlagPayload; };
}
/**
 * One action event from the desktop or mobile client.
 * @export
 * @interface ActionEnvelope
 */
export interface ActionEnvelope {
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'client_event_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'platform'?: ActionEnvelopePlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof ActionEnvelope
     */
    'platform_version': string;
    /**
     * 
     * @type {AppContext}
     * @memberof ActionEnvelope
     */
    'app_context': AppContext;
    /**
     * 
     * @type {object}
     * @memberof ActionEnvelope
     */
    'payload'?: object;
}

export const ActionEnvelopePlatformEnum = {
    Desktop: 'desktop',
    Ios: 'ios',
    Android: 'android'
} as const;

export type ActionEnvelopePlatformEnum = typeof ActionEnvelopePlatformEnum[keyof typeof ActionEnvelopePlatformEnum];

/**
 * Why a requested ``has_action_items`` is false, so analytics can tell a miss from an unknown.  ``NO_OWNED_STEP`` is known without the flag, which is only asked when a step is owned. ``FLAG_UNKNOWN`` covers a timeout, an error and an ``ABSENT`` verdict: nothing says the flag is off.
 * @export
 * @enum {string}
 */

export const ActionItemsAbsentReason = {
    NoOwnedStep: 'no_owned_step',
    FlagOff: 'flag_off',
    FlagUnknown: 'flag_unknown'
} as const;

export type ActionItemsAbsentReason = typeof ActionItemsAbsentReason[keyof typeof ActionItemsAbsentReason];


/**
 * Why an action attempt failed or may not have landed, as the action card names it.
 * @export
 * @enum {string}
 */

export const ActionResultReason = {
    SendFailed: 'send_failed',
    RateLimited: 'rate_limited',
    ProviderUnavailable: 'provider_unavailable',
    Timeout: 'timeout',
    InvalidRecipient: 'invalid_recipient',
    RevokedMidSend: 'revoked_mid_send',
    AdminBlocked: 'admin_blocked'
} as const;

export type ActionResultReason = typeof ActionResultReason[keyof typeof ActionResultReason];


/**
 * One active member of a team in the caller\'s current cost center.  Powers the cost-center-scoped member picker in the create-department dialog: callers can pull anyone in their CC into a new team (an intra-CC move). ``team_id`` is the member\'s *current* team within the CC, used to filter successor-admin candidates to caller\'s old teammates.
 * @export
 * @interface ActiveCostCenterMemberResponse
 */
export interface ActiveCostCenterMemberResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'team_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'team_name': string;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof ActiveCostCenterMemberResponse
     */
    'team_role': TeamMemberRole | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterMemberResponse
     */
    'enterprise_role': string | null;
    /**
     * True when this member counts as an admin on their current team — team-role admin OR enterprise-role in admin/superadmin/it_admin.
     * @type {boolean}
     * @memberof ActiveCostCenterMemberResponse
     */
    'is_effective_team_admin': boolean;
}


/**
 * Caller\'s active cost center plus all active members of teams within it.  Returned by ``GET /me/active-cost-center``. The create-department dialog uses ``members`` (excluding the caller) to populate the picker. Successor admins are filtered client-side to members with ``team_id == caller_team_id``.
 * @export
 * @interface ActiveCostCenterResponse
 */
export interface ActiveCostCenterResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterResponse
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterResponse
     */
    'cost_center_name': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveCostCenterResponse
     */
    'caller_team_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveCostCenterResponse
     */
    'caller_is_effective_team_admin': boolean;
    /**
     * 
     * @type {Array<ActiveCostCenterMemberResponse>}
     * @memberof ActiveCostCenterResponse
     */
    'members': Array<ActiveCostCenterMemberResponse>;
}
/**
 * Request model for adding a domain to the block list.
 * @export
 * @interface AddBlockedDomainRequest
 */
export interface AddBlockedDomainRequest {
    /**
     * Domain to block
     * @type {string}
     * @memberof AddBlockedDomainRequest
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof AddBlockedDomainRequest
     */
    'notes'?: string | null;
}
/**
 * Response model for adding a blocked domain.
 * @export
 * @interface AddBlockedDomainResponse
 */
export interface AddBlockedDomainResponse {
    /**
     * 
     * @type {string}
     * @memberof AddBlockedDomainResponse
     */
    'warning'?: string | null;
}
/**
 * Result of creating a calendar event via a connector.  ``successful`` is the only payload; ``error`` carries a stable code the client maps to a toast (see ``GoogleCalendarConnector.add_calendar_event``).
 * @export
 * @interface AddCalendarEventResponse
 */
export interface AddCalendarEventResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AddCalendarEventResponse
     */
    'successful': boolean;
    /**
     * 
     * @type {string}
     * @memberof AddCalendarEventResponse
     */
    'error'?: string | null;
}
/**
 * Request model for adding a domain to an enterprise.
 * @export
 * @interface AddEnterpriseDomainRequest
 */
export interface AddEnterpriseDomainRequest {
    /**
     * 
     * @type {string}
     * @memberof AddEnterpriseDomainRequest
     */
    'enterprise_id': string;
    /**
     * Domain to add (e.g. acme.com)
     * @type {string}
     * @memberof AddEnterpriseDomainRequest
     */
    'domain': string;
    /**
     * Allow adding forbidden domains (e.g. .edu)
     * @type {boolean}
     * @memberof AddEnterpriseDomainRequest
     */
    'allow_forbidden_domain'?: boolean;
}
/**
 * Response model for adding a domain to an enterprise.
 * @export
 * @interface AddEnterpriseDomainResponse
 */
export interface AddEnterpriseDomainResponse {
    /**
     * 
     * @type {string}
     * @memberof AddEnterpriseDomainResponse
     */
    'message': string;
    /**
     * Whether the domain was successfully synced to WorkOS (only relevant for SSO-enabled enterprises)
     * @type {boolean}
     * @memberof AddEnterpriseDomainResponse
     */
    'workos_synced'?: boolean;
}
/**
 * Share a folder with one active department of the owner\'s company, or with the whole company.
 * @export
 * @interface AddFolderGrantRequest
 */
export interface AddFolderGrantRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFolderGrantRequest
     */
    'type': AddFolderGrantRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddFolderGrantRequest
     */
    'team_id'?: string | null;
}

export const AddFolderGrantRequestTypeEnum = {
    Department: 'department',
    Enterprise: 'enterprise'
} as const;

export type AddFolderGrantRequestTypeEnum = typeof AddFolderGrantRequestTypeEnum[keyof typeof AddFolderGrantRequestTypeEnum];

/**
 * What happened to the grant; ``grant`` is null only for ``not_eligible`` (the org allows no sharing).
 * @export
 * @interface AddFolderGrantResponse
 */
export interface AddFolderGrantResponse {
    /**
     * 
     * @type {string}
     * @memberof AddFolderGrantResponse
     */
    'outcome': AddFolderGrantResponseOutcomeEnum;
    /**
     * 
     * @type {FolderGrantEntry}
     * @memberof AddFolderGrantResponse
     */
    'grant'?: FolderGrantEntry | null;
    /**
     * 
     * @type {FolderSummary}
     * @memberof AddFolderGrantResponse
     */
    'folder': FolderSummary;
}

export const AddFolderGrantResponseOutcomeEnum = {
    Added: 'added',
    AlreadyGranted: 'already_granted',
    NotEligible: 'not_eligible'
} as const;

export type AddFolderGrantResponseOutcomeEnum = typeof AddFolderGrantResponseOutcomeEnum[keyof typeof AddFolderGrantResponseOutcomeEnum];

/**
 * Add one of the caller\'s own meetings to a folder.
 * @export
 * @interface AddFolderMeetingRequest
 */
export interface AddFolderMeetingRequest {
    /**
     * 
     * @type {string}
     * @memberof AddFolderMeetingRequest
     */
    'meeting_id': string;
}
/**
 * Result of adding a meeting; ``added`` is False when it was already in the folder.
 * @export
 * @interface AddFolderMeetingResponse
 */
export interface AddFolderMeetingResponse {
    /**
     * 
     * @type {string}
     * @memberof AddFolderMeetingResponse
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof AddFolderMeetingResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof AddFolderMeetingResponse
     */
    'slug': string;
    /**
     * 
     * @type {boolean}
     * @memberof AddFolderMeetingResponse
     */
    'added': boolean;
    /**
     * 
     * @type {string}
     * @memberof AddFolderMeetingResponse
     */
    'rule_domain'?: string | null;
}
/**
 * Add existing Wispr accounts to a folder by email.  Plain strings, not ``EmailStr``: a malformed address is a per-row ``invalid`` outcome, never a 422 for the batch. The list size is the only 422.
 * @export
 * @interface AddFolderMembersRequest
 */
export interface AddFolderMembersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddFolderMembersRequest
     */
    'emails': Array<string>;
}
/**
 * One outcome per requested address, in request order (a repeat of an earlier address is ``duplicate``).
 * @export
 * @interface AddFolderMembersResponse
 */
export interface AddFolderMembersResponse {
    /**
     * 
     * @type {Array<FolderMemberAddResult>}
     * @memberof AddFolderMembersResponse
     */
    'results': Array<FolderMemberAddResult>;
    /**
     * 
     * @type {FolderSummary}
     * @memberof AddFolderMembersResponse
     */
    'folder': FolderSummary;
}
/**
 * Batch request to invite recipients to a shared note.
 * @export
 * @interface AddRecipientsRequest
 */
export interface AddRecipientsRequest {
    /**
     * 
     * @type {Array<ShareRecipientInput>}
     * @memberof AddRecipientsRequest
     */
    'recipients': Array<ShareRecipientInput>;
}
/**
 * Outcome of a batch recipient add.  Every unique email in the request lands in exactly one bucket: - ``succeeded``: now an invited recipient (newly added, or already present). - ``not_eligible``: barred by the owner\'s enterprise note-sharing policy — an   external recipient while the org restricts sharing outside the enterprise. - ``failed``: rejected for any other reason (malformed email, owner self-invite,   unsupported role).  ``share`` carries the refreshed share state so the client needs no follow-up GET.
 * @export
 * @interface AddRecipientsResponse
 */
export interface AddRecipientsResponse {
    /**
     * 
     * @type {number}
     * @memberof AddRecipientsResponse
     */
    'succeeded': number;
    /**
     * 
     * @type {number}
     * @memberof AddRecipientsResponse
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof AddRecipientsResponse
     */
    'not_eligible': number;
    /**
     * 
     * @type {ShareStateResponse}
     * @memberof AddRecipientsResponse
     */
    'share': ShareStateResponse;
}
/**
 * Request to add an email to the waitlist for a given device type.
 * @export
 * @interface AddToWaitlistRequest
 */
export interface AddToWaitlistRequest {
    /**
     * 
     * @type {string}
     * @memberof AddToWaitlistRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddToWaitlistRequest
     */
    'device_type': string;
}
/**
 * Request model for bulk adding users to an enterprise.
 * @export
 * @interface AddUsersToEnterpriseRequest
 */
export interface AddUsersToEnterpriseRequest {
    /**
     * List of users to add (max 100). Only email is read; first_name and last_name are ignored.
     * @type {Array<UserInput>}
     * @memberof AddUsersToEnterpriseRequest
     */
    'users': Array<UserInput>;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof AddUsersToEnterpriseRequest
     */
    'role'?: EnterpriseRole;
    /**
     * When true, emails with no User row get a pending enterprise invitation instead of failing; existing users are still force-added. The field name is historical.
     * @type {boolean}
     * @memberof AddUsersToEnterpriseRequest
     */
    'create_missing_users'?: boolean;
}


/**
 * Response model for bulk add users operation.
 * @export
 * @interface AddUsersToEnterpriseResponse
 */
export interface AddUsersToEnterpriseResponse {
    /**
     * 
     * @type {number}
     * @memberof AddUsersToEnterpriseResponse
     */
    'added_count': number;
    /**
     * 
     * @type {number}
     * @memberof AddUsersToEnterpriseResponse
     * @deprecated
     */
    'created_count'?: number;
    /**
     * Number of new users successfully sent an invitation
     * @type {number}
     * @memberof AddUsersToEnterpriseResponse
     */
    'invited_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddUsersToEnterpriseResponse
     */
    'skipped_count'?: number;
    /**
     * 
     * @type {Array<FailedAddUserItem>}
     * @memberof AddUsersToEnterpriseResponse
     */
    'failed'?: Array<FailedAddUserItem>;
}
/**
 * Request model for applying a referral code to a user on their behalf.
 * @export
 * @interface AdminApplyReferralRequest
 */
export interface AdminApplyReferralRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminApplyReferralRequest
     */
    'user_email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminApplyReferralRequest
     */
    'referral_code': string;
}
/**
 * Response model for admin referral application.
 * @export
 * @interface AdminApplyReferralResponse
 */
export interface AdminApplyReferralResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminApplyReferralResponse
     */
    'message': string;
}
/**
 * Super-admin request: list all stored voice memories for each user.
 * @export
 * @interface AdminMemoryListRequest
 */
export interface AdminMemoryListRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminMemoryListRequest
     */
    'emails': Array<string>;
    /**
     * Required justification for accessing these users\' private memory; recorded in the audit log.
     * @type {string}
     * @memberof AdminMemoryListRequest
     */
    'reason': string;
    /**
     * 
     * @type {number}
     * @memberof AdminMemoryListRequest
     */
    'limit'?: number;
}
/**
 * Per-user results of an admin voice-memory listing.
 * @export
 * @interface AdminMemoryListResponse
 */
export interface AdminMemoryListResponse {
    /**
     * 
     * @type {Array<AdminMemoryListResult>}
     * @memberof AdminMemoryListResponse
     */
    'results': Array<AdminMemoryListResult>;
}
/**
 * Per-user list result. Payload dicts are stripped of internal Graphiti identifiers.
 * @export
 * @interface AdminMemoryListResult
 */
export interface AdminMemoryListResult {
    /**
     * 
     * @type {string}
     * @memberof AdminMemoryListResult
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMemoryListResult
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminMemoryListResult
     */
    'status': AdminMemoryListResultStatusEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdminMemoryListResult
     */
    'episodes'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AdminMemoryListResult
     */
    'error_code'?: string | null;
}

export const AdminMemoryListResultStatusEnum = {
    Ok: 'ok',
    NoMemories: 'no_memories',
    UserNotFound: 'user_not_found',
    Error: 'error',
    HipaaRestricted: 'hipaa_restricted'
} as const;

export type AdminMemoryListResultStatusEnum = typeof AdminMemoryListResultStatusEnum[keyof typeof AdminMemoryListResultStatusEnum];

/**
 * Super-admin request: semantic-search each user\'s voice memory by ``context``.
 * @export
 * @interface AdminMemorySearchRequest
 */
export interface AdminMemorySearchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminMemorySearchRequest
     */
    'emails': Array<string>;
    /**
     * Required justification for accessing these users\' private memory; recorded in the audit log.
     * @type {string}
     * @memberof AdminMemorySearchRequest
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMemorySearchRequest
     */
    'context': string;
    /**
     * 
     * @type {number}
     * @memberof AdminMemorySearchRequest
     */
    'max_facts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminMemorySearchRequest
     */
    'max_nodes'?: number;
}
/**
 * Per-user results of an admin voice-memory semantic search.
 * @export
 * @interface AdminMemorySearchResponse
 */
export interface AdminMemorySearchResponse {
    /**
     * 
     * @type {Array<AdminMemorySearchResult>}
     * @memberof AdminMemorySearchResponse
     */
    'results': Array<AdminMemorySearchResult>;
}
/**
 * Per-user search result. Payload dicts are stripped of internal Graphiti identifiers.
 * @export
 * @interface AdminMemorySearchResult
 */
export interface AdminMemorySearchResult {
    /**
     * 
     * @type {string}
     * @memberof AdminMemorySearchResult
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminMemorySearchResult
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminMemorySearchResult
     */
    'status': AdminMemorySearchResultStatusEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdminMemorySearchResult
     */
    'facts'?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdminMemorySearchResult
     */
    'nodes'?: Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AdminMemorySearchResult
     */
    'error_code'?: string | null;
}

export const AdminMemorySearchResultStatusEnum = {
    Ok: 'ok',
    NoMemories: 'no_memories',
    UserNotFound: 'user_not_found',
    Error: 'error',
    HipaaRestricted: 'hipaa_restricted'
} as const;

export type AdminMemorySearchResultStatusEnum = typeof AdminMemorySearchResultStatusEnum[keyof typeof AdminMemorySearchResultStatusEnum];

/**
 * Body for `POST /api/v1/enterprise/members/{user_id}/notetaker-data-erasure`.  Attributes:     confirm_email: The member\'s email, typed by the admin as a fat-finger guard. Compared         trimmed and case-insensitively; a mismatch is a 422.
 * @export
 * @interface AdminNotetakerErasureRequest
 */
export interface AdminNotetakerErasureRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminNotetakerErasureRequest
     */
    'confirm_email': string;
}
/**
 * Per-admin email notification opt-outs. Absent DB row means every field defaults True.
 * @export
 * @interface AdminNotificationPreferencesResponse
 */
export interface AdminNotificationPreferencesResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminNotificationPreferencesResponse
     */
    'teammates_added_digest_enabled': boolean;
}
/**
 * Paginated payload for ``GET /api/v1/dictionary/admin/shared``; ``total`` is pre-pagination.
 * @export
 * @interface AdminSharedDictionaryResponse
 */
export interface AdminSharedDictionaryResponse {
    /**
     * 
     * @type {Array<AdminSharedDictionaryRow>}
     * @memberof AdminSharedDictionaryResponse
     */
    'rows': Array<AdminSharedDictionaryRow>;
    /**
     * 
     * @type {number}
     * @memberof AdminSharedDictionaryResponse
     */
    'total': number;
}
/**
 * One shared entry in the admin portal\'s enterprise-wide library view.
 * @export
 * @interface AdminSharedDictionaryRow
 */
export interface AdminSharedDictionaryRow {
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSharedDictionaryRow
     */
    'is_snippet': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'team_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'team_name'?: string | null;
    /**
     * 
     * @type {TeamDictionaryStatus}
     * @memberof AdminSharedDictionaryRow
     */
    'status': TeamDictionaryStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'requested_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'requester_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminSharedDictionaryRow
     */
    'requester_email'?: string | null;
}


/**
 * 
 * @export
 * @interface AdminTestPublishOptions
 */
export interface AdminTestPublishOptions {
    /**
     * 
     * @type {string}
     * @memberof AdminTestPublishOptions
     */
    'meeting_id'?: string | null;
}
/**
 * 
 * @export
 * @interface AdminTestPublishRequest
 */
export interface AdminTestPublishRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminTestPublishRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTestPublishRequest
     */
    'event_type': AdminTestPublishRequestEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminTestPublishRequest
     */
    'reason'?: string | null;
    /**
     * 
     * @type {AdminTestPublishOptions}
     * @memberof AdminTestPublishRequest
     */
    'options'?: AdminTestPublishOptions | null;
}

export const AdminTestPublishRequestEventTypeEnum = {
    Heartbeat: 'heartbeat',
    ReconnectResync: 'reconnect_resync',
    GapTooLarge: 'gap_too_large',
    NotificationCreated: 'notification.created',
    PreferencesChanged: 'preferences.changed',
    NotesChanged: 'notes.changed',
    MeetingChanged: 'meeting.changed',
    MeetingTranscriptChanged: 'meeting.transcript_changed',
    CalendarChanged: 'calendar.changed',
    EnterpriseSettingsChanged: 'enterprise.settings_changed'
} as const;

export type AdminTestPublishRequestEventTypeEnum = typeof AdminTestPublishRequestEventTypeEnum[keyof typeof AdminTestPublishRequestEventTypeEnum];

/**
 * 
 * @export
 * @interface AdminTestPublishResponse
 */
export interface AdminTestPublishResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminTestPublishResponse
     */
    'published': number;
    /**
     * 
     * @type {string}
     * @memberof AdminTestPublishResponse
     */
    'last_entry_id': string | null;
}
/**
 * Request to overwrite a user\'s stripe_customer_id (dry-run by default).
 * @export
 * @interface AdminUpdateStripeCustomerIdRequest
 */
export interface AdminUpdateStripeCustomerIdRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdRequest
     */
    'stripe_customer_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateStripeCustomerIdRequest
     */
    'dry_run'?: boolean;
}
/**
 * Result of a stripe_customer_id overwrite, including the previous value and any warnings.
 * @export
 * @interface AdminUpdateStripeCustomerIdResponse
 */
export interface AdminUpdateStripeCustomerIdResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'old_stripe_customer_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'new_stripe_customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'stripe_customer_email': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'applied': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateStripeCustomerIdResponse
     */
    'warnings': Array<string>;
}
/**
 * Admin view of a user\'s profile and subscription info.
 * @export
 * @interface AdminUserLookupResponse
 */
export interface AdminUserLookupResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'referral_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'referrer_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'enterprise_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'enterprise_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'enterprise_role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserLookupResponse
     */
    'enforce_sso': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'stripe_customer_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'stripe_subscription_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'plan_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'subscription_status': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUserLookupResponse
     */
    'subscription_created_at': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUserLookupResponse
     */
    'trial_ends_at': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'workos_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUserLookupResponse
     */
    'workos_events_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserLookupResponse
     */
    'dictionary_import_blocked'?: boolean;
}
/**
 * One agentic pre-read deliverable keyed by the calendar event\'s ``external_id``.
 * @export
 * @interface AgenticPrereadSyncItemDTO
 */
export interface AgenticPrereadSyncItemDTO {
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncItemDTO
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncItemDTO
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncItemDTO
     */
    'contentMd': string;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncItemDTO
     */
    'generatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncItemDTO
     */
    'externalId': string;
}
/**
 * Response shape for ``GET /api/v1/calendar/prereads/agentic_sync``.  Mirrors the calendar sync cursor contract: desktop advances ``since`` to ``serverTime`` once ``nextCursor`` is null.
 * @export
 * @interface AgenticPrereadSyncResponse
 */
export interface AgenticPrereadSyncResponse {
    /**
     * 
     * @type {Array<AgenticPrereadSyncItemDTO>}
     * @memberof AgenticPrereadSyncResponse
     */
    'agenticPrereads': Array<AgenticPrereadSyncItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncResponse
     */
    'serverTime': string;
    /**
     * 
     * @type {string}
     * @memberof AgenticPrereadSyncResponse
     */
    'nextCursor'?: string | null;
}
/**
 * Multiplier of avg AI-prompt length vs the 8-word typed baseline (e.g. ``2.2`` renders as ``2.2x``).  Null when no AI dictations or avg words ≤ baseline.
 * @export
 * @interface AiPromptQuality
 */
export interface AiPromptQuality {
    /**
     * 
     * @type {number}
     * @memberof AiPromptQuality
     */
    'multiplier'?: number | null;
}
/**
 * Closed registry of consensus implementations exposed for preview.
 * @export
 * @enum {string}
 */

export const AlgorithmId = {
    ClusterV1: 'cluster-v1',
    SegmentV3: 'segment-v3'
} as const;

export type AlgorithmId = typeof AlgorithmId[keyof typeof AlgorithmId];


/**
 * Response model for list of all enterprises with pagination.
 * @export
 * @interface AllEnterprisesResponse
 */
export interface AllEnterprisesResponse {
    /**
     * 
     * @type {Array<EnterpriseListItem>}
     * @memberof AllEnterprisesResponse
     */
    'enterprises': Array<EnterpriseListItem>;
    /**
     * 
     * @type {number}
     * @memberof AllEnterprisesResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AllEnterprisesResponse
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof AllEnterprisesResponse
     */
    'offset': number;
}
/**
 * Top 6 users (plus the caller) for each all-time leaderboard metric.
 * @export
 * @interface AllTimePodiums
 */
export interface AllTimePodiums {
    /**
     * 
     * @type {MetricPodium}
     * @memberof AllTimePodiums
     */
    'total_words'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof AllTimePodiums
     */
    'desktop_words'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof AllTimePodiums
     */
    'mobile_words'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof AllTimePodiums
     */
    'day_streak'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof AllTimePodiums
     */
    'words_per_minute'?: MetricPodium;
}
/**
 * Shared analytics event fields used as the create payload.
 * @export
 * @interface AnalyticsEventBase
 */
export interface AnalyticsEventBase {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventBase
     */
    'event_key'?: string | null;
    /**
     * Display name for the event
     * @type {string}
     * @memberof AnalyticsEventBase
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventBase
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventBase
     */
    'trigger'?: string | null;
    /**
     * JSON schema for event properties
     * @type {object}
     * @memberof AnalyticsEventBase
     */
    'properties_schema'?: object;
    /**
     * Platforms where this event is used
     * @type {Array<AnalyticsPlatform>}
     * @memberof AnalyticsEventBase
     */
    'platforms'?: Array<AnalyticsPlatform>;
    /**
     * Lifecycle state of the event
     * @type {AnalyticsLifecycleState}
     * @memberof AnalyticsEventBase
     */
    'lifecycle_state'?: AnalyticsLifecycleState;
}


/**
 * A fully hydrated analytics event, including audit and status fields.
 * @export
 * @interface AnalyticsEventResponse
 */
export interface AnalyticsEventResponse {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'event_key': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'trigger'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof AnalyticsEventResponse
     */
    'properties_schema'?: object;
    /**
     * 
     * @type {Array<AnalyticsPlatform>}
     * @memberof AnalyticsEventResponse
     */
    'platforms'?: Array<AnalyticsPlatform>;
    /**
     * 
     * @type {AnalyticsLifecycleState}
     * @memberof AnalyticsEventResponse
     */
    'lifecycle_state'?: AnalyticsLifecycleState;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'updated_by': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'created_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'updated_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventResponse
     */
    'last_published_at'?: string | null;
    /**
     * Implementation status of the event
     * @type {AnalyticsEventStatus}
     * @memberof AnalyticsEventResponse
     */
    'status': AnalyticsEventStatus;
}


/**
 * Client-implementation status of an analytics event.
 * @export
 * @enum {string}
 */

export const AnalyticsEventStatus = {
    NeedsPublish: 'needs_publish',
    NotImplemented: 'not_implemented',
    Implemented: 'implemented'
} as const;

export type AnalyticsEventStatus = typeof AnalyticsEventStatus[keyof typeof AnalyticsEventStatus];


/**
 * Partial-update payload for an existing analytics event, keyed by id.
 * @export
 * @interface AnalyticsEventUpdate
 */
export interface AnalyticsEventUpdate {
    /**
     * Event ID to update
     * @type {string}
     * @memberof AnalyticsEventUpdate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventUpdate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventUpdate
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalyticsEventUpdate
     */
    'trigger'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof AnalyticsEventUpdate
     */
    'properties_schema'?: object | null;
    /**
     * 
     * @type {Array<AnalyticsPlatform>}
     * @memberof AnalyticsEventUpdate
     */
    'platforms'?: Array<AnalyticsPlatform> | null;
    /**
     * 
     * @type {AnalyticsLifecycleState}
     * @memberof AnalyticsEventUpdate
     */
    'lifecycle_state'?: AnalyticsLifecycleState | null;
}


/**
 * Lifecycle stage of an analytics event definition.
 * @export
 * @enum {string}
 */

export const AnalyticsLifecycleState = {
    Draft: 'draft',
    Active: 'active',
    Deprecated: 'deprecated'
} as const;

export type AnalyticsLifecycleState = typeof AnalyticsLifecycleState[keyof typeof AnalyticsLifecycleState];


/**
 * Client platform an analytics event is emitted from.
 * @export
 * @enum {string}
 */

export const AnalyticsPlatform = {
    Desktop: 'desktop',
    Ios: 'ios',
    Android: 'android'
} as const;

export type AnalyticsPlatform = typeof AnalyticsPlatform[keyof typeof AnalyticsPlatform];


/**
 * Response schema for GET /promos/android_waitlist_rank.
 * @export
 * @interface AndroidWaitlistRankResponse
 */
export interface AndroidWaitlistRankResponse {
    /**
     * 
     * @type {string}
     * @memberof AndroidWaitlistRankResponse
     */
    'referral_code': string;
    /**
     * 
     * @type {number}
     * @memberof AndroidWaitlistRankResponse
     */
    'current_rank': number;
    /**
     * 
     * @type {number}
     * @memberof AndroidWaitlistRankResponse
     */
    'starting_rank': number;
    /**
     * 
     * @type {number}
     * @memberof AndroidWaitlistRankResponse
     */
    'total_boost': number;
    /**
     * 
     * @type {number}
     * @memberof AndroidWaitlistRankResponse
     */
    'referrals_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'desktop_dictation_bonus_earned': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'phone_number_bonus_earned': boolean;
    /**
     * 
     * @type {number}
     * @memberof AndroidWaitlistRankResponse
     */
    'current_desktop_words': number;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'verified_share_twitter': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'verified_share_whatsapp': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'verified_share_linkedin': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'verified_share_slack': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AndroidWaitlistRankResponse
     */
    'verified_share_discord': boolean;
}
/**
 * 
 * @export
 * @interface AnswersValue
 */
export interface AnswersValue {
}
/**
 * Provider config for an Anthropic-backed model.
 * @export
 * @interface AnthropicProviderConfig
 */
export interface AnthropicProviderConfig {
    /**
     * 
     * @type {string}
     * @memberof AnthropicProviderConfig
     */
    'kind'?: AnthropicProviderConfigKindEnum;
    /**
     * 
     * @type {Model}
     * @memberof AnthropicProviderConfig
     */
    'model': Model;
}

export const AnthropicProviderConfigKindEnum = {
    Anthropic: 'anthropic'
} as const;

export type AnthropicProviderConfigKindEnum = typeof AnthropicProviderConfigKindEnum[keyof typeof AnthropicProviderConfigKindEnum];

/**
 * Foreground app the user is dictating into, with its category.
 * @export
 * @interface App
 */
export interface App {
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'bundle_id'?: string | null;
    /**
     * Category to which the app belongs
     * @type {AppType}
     * @memberof App
     */
    'type'?: AppType;
    /**
     * 
     * @type {string}
     * @memberof App
     */
    'url'?: string | null;
}


/**
 * Word and dictation count breakdown for one app category.
 * @export
 * @interface AppCategoryUsage
 */
export interface AppCategoryUsage {
    /**
     * 
     * @type {string}
     * @memberof AppCategoryUsage
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof AppCategoryUsage
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof AppCategoryUsage
     */
    'word_count': number;
    /**
     * 
     * @type {number}
     * @memberof AppCategoryUsage
     */
    'dictation_count': number;
    /**
     * 
     * @type {number}
     * @memberof AppCategoryUsage
     */
    'percentage': number;
}
/**
 * Identifying details of the app an action occurred in.
 * @export
 * @interface AppContext
 */
export interface AppContext {
    /**
     * 
     * @type {string}
     * @memberof AppContext
     */
    'app_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppContext
     */
    'app_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppContext
     */
    'bundle_id'?: string | null;
}
/**
 * A selectable app in the insights filter dropdown, with its display name and category.
 * @export
 * @interface AppFilterOption
 */
export interface AppFilterOption {
    /**
     * 
     * @type {string}
     * @memberof AppFilterOption
     */
    'app_key': string;
    /**
     * 
     * @type {string}
     * @memberof AppFilterOption
     */
    'display_name': string;
    /**
     * 
     * @type {string}
     * @memberof AppFilterOption
     */
    'category': string;
}
/**
 * Category of the foreground app the user is dictating into.
 * @export
 * @enum {string}
 */

export const AppType = {
    Email: 'email',
    Ai: 'ai',
    Word: 'word',
    Terminal: 'terminal',
    Other: 'other'
} as const;

export type AppType = typeof AppType[keyof typeof AppType];


/**
 * Append ``text`` at the end of ``section`` (a heading title); conflicts only on a file deleted since it was read.  A missing section is added as ``## {section}`` at the end of the file, and a missing or deleted file is created. ``section=None`` appends at the end of the file. ``seen_version`` is the head the writer read, when it read one: on a tombstone the append then conflicts instead of reviving the file with only the new text, since another writer may delete the file between checkout and commit.
 * @export
 * @interface AppendOp
 */
export interface AppendOp {
    /**
     * 
     * @type {string}
     * @memberof AppendOp
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof AppendOp
     */
    'kind'?: AppendOpKindEnum;
    /**
     * 
     * @type {string}
     * @memberof AppendOp
     */
    'section'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppendOp
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof AppendOp
     */
    'seen_version'?: number | null;
}

export const AppendOpKindEnum = {
    Append: 'append'
} as const;

export type AppendOpKindEnum = typeof AppendOpKindEnum[keyof typeof AppendOpKindEnum];

/**
 * Request to apply a promo code by its string.
 * @export
 * @interface ApplyPromoCodeRequest
 */
export interface ApplyPromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyPromoCodeRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ApplyPromoCodeRequest
     */
    'source'?: ApplyPromoCodeRequestSourceEnum;
}

export const ApplyPromoCodeRequestSourceEnum = {
    Manual: 'manual',
    Web: 'web'
} as const;

export type ApplyPromoCodeRequestSourceEnum = typeof ApplyPromoCodeRequestSourceEnum[keyof typeof ApplyPromoCodeRequestSourceEnum];

/**
 * Request to apply a referral code to the authenticated user.
 * @export
 * @interface ApplyReferralCodeRequest
 */
export interface ApplyReferralCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplyReferralCodeRequest
     */
    'referrer_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplyReferralCodeRequest
     */
    'dub_click_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyReferralCodeRequest
     */
    'check_credits'?: boolean;
}
/**
 * Request to archive a set of notifications by id.
 * @export
 * @interface ArchiveNotificationRequest
 */
export interface ArchiveNotificationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ArchiveNotificationRequest
     */
    'notification_ids': Array<string>;
}
/**
 * Write an Ask Anything action performs on its provider.
 * @export
 * @enum {string}
 */

export const AskAnythingAction = {
    SendEmail: 'send_email'
} as const;

export type AskAnythingAction = typeof AskAnythingAction[keyof typeof AskAnythingAction];


/**
 * Provider an Ask Anything action writes to; ``slack`` and ``notion`` are reserved and have no send route yet.
 * @export
 * @enum {string}
 */

export const AskAnythingActionProvider = {
    Gmail: 'gmail',
    Slack: 'slack',
    Notion: 'notion'
} as const;

export type AskAnythingActionProvider = typeof AskAnythingActionProvider[keyof typeof AskAnythingActionProvider];


/**
 * One suggested prompt; a chip that names a Skill runs it when the client has it, and asks ``label`` otherwise.
 * @export
 * @interface AskAnythingChip
 */
export interface AskAnythingChip {
    /**
     * 
     * @type {string}
     * @memberof AskAnythingChip
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof AskAnythingChip
     */
    'skill_command'?: string | null;
}
/**
 * The payload of both Ask Anything surfaces, type ``suggestion``, schema version 1.
 * @export
 * @interface AskAnythingSuggestionsPayload
 */
export interface AskAnythingSuggestionsPayload {
    /**
     * 
     * @type {string}
     * @memberof AskAnythingSuggestionsPayload
     */
    'placeholder': string;
    /**
     * 
     * @type {Array<AskAnythingChip>}
     * @memberof AskAnythingSuggestionsPayload
     */
    'chips': Array<AskAnythingChip>;
}
/**
 * Chunked ASR request carrying audio, pipeline steps, context, and prior-turn state.
 * @export
 * @interface AsrAudioChunksRequest
 */
export interface AsrAudioChunksRequest {
    /**
     * Access token for authentication
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'audio'?: string | null;
    /**
     * 
     * @type {BasetenAudioPackets}
     * @memberof AsrAudioChunksRequest
     */
    'audio_packets'?: BasetenAudioPackets | null;
    /**
     * List of pipeline steps to execute
     * @type {Array<string>}
     * @memberof AsrAudioChunksRequest
     */
    'pipeline': Array<string>;
    /**
     * Context information including dictionary and user details
     * @type {Context}
     * @memberof AsrAudioChunksRequest
     */
    'context': Context;
    /**
     * List of language codes to consider
     * @type {Array<string>}
     * @memberof AsrAudioChunksRequest
     */
    'language'?: Array<string>;
    /**
     * Application type (ai, email, other)
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'app': string;
    /**
     * User information including UUID
     * @type {object}
     * @memberof AsrAudioChunksRequest
     */
    'user': object;
    /**
     * Additional metadata including session ID and client version
     * @type {object}
     * @memberof AsrAudioChunksRequest
     */
    'metadata': object;
    /**
     * Previous ASR text for context
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'prev_asr_text'?: string;
    /**
     * Previous LLM text for context
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'prev_llm_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof AsrAudioChunksRequest
     */
    'prev_detected_language'?: string | null;
}
/**
 * GA4 event names for attribution tracking.  These map to GA4 Measurement Protocol event names. See: https://developers.google.com/analytics/devguides/collection/protocol/ga4/reference  USAGE_MILESTONE_REACHED is a single event name; individual milestones (words_200, words_500, words_2000) are distinguished via the `milestone_name` custom parameter, which should be registered as a GA4 custom dimension for reporting.
 * @export
 * @enum {string}
 */

export const AttributionEventName = {
    UsageMilestoneReached: 'usage_milestone_reached',
    FirstExternalDictation: 'first_external_dictation',
    OnboardingCompleted: 'onboarding_completed',
    PaywallViewed: 'paywall_viewed',
    BeginCheckout: 'begin_checkout',
    Purchase: 'purchase',
    Lead: 'lead',
    FirstNotetakerMeeting: 'first_notetaker_meeting',
    CompleteRegistration: 'complete_registration'
} as const;

export type AttributionEventName = typeof AttributionEventName[keyof typeof AttributionEventName];


/**
 * Valid platforms for attribution event tracking.  Desktop clients must use specific variants (DESKTOP_MAC, DESKTOP_WINDOWS).
 * @export
 * @enum {string}
 */

export const AttributionPlatform = {
    Web: 'web',
    DesktopMac: 'desktop_mac',
    DesktopWindows: 'desktop_windows',
    Ios: 'ios',
    Android: 'android'
} as const;

export type AttributionPlatform = typeof AttributionPlatform[keyof typeof AttributionPlatform];


/**
 * Response for attribution tracking endpoints.
 * @export
 * @interface AttributionTrackingResponse
 */
export interface AttributionTrackingResponse {
    /**
     * Whether the event was tracked successfully
     * @type {boolean}
     * @memberof AttributionTrackingResponse
     */
    'success': boolean;
    /**
     * Name of the tracked event
     * @type {AttributionEventName}
     * @memberof AttributionTrackingResponse
     */
    'event_name': AttributionEventName;
    /**
     * 
     * @type {string}
     * @memberof AttributionTrackingResponse
     */
    'message'?: string | null;
}


/**
 * Optional user data for enhanced conversions (Google Ads attribution).
 * @export
 * @interface AttributionUserData
 */
export interface AttributionUserData {
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'fbp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AttributionUserData
     */
    'fbc'?: string | null;
}
/**
 * Shared WorkOS action vocabulary.  Some members back the v1 derived-read union below; others (like NOTETAKER_CONSENT_CONFIRMED) only ever flow through the direct-emit path.
 * @export
 * @enum {string}
 */

export const AuditAction = {
    MemberAdded: 'member.added',
    MemberRemoved: 'member.removed',
    JoinRequestApproved: 'join_request.approved',
    JoinRequestRejected: 'join_request.rejected',
    NotetakerConsentConfirmed: 'notetaker.consent_confirmed',
    OrganizationSharingPolicyChanged: 'organization.sharing_policy_changed',
    OrganizationDataControlsChanged: 'organization.data_controls_changed',
    OrganizationNotetakerPolicyChanged: 'organization.notetaker_policy_changed',
    OrganizationNotetakerBlockedDomainsChanged: 'organization.notetaker_blocked_domains_changed',
    OrganizationAccessRestrictionChanged: 'organization.access_restriction_changed',
    OrganizationProductAccessChanged: 'organization.product_access_changed',
    OrganizationMembershipPolicyChanged: 'organization.membership_policy_changed',
    OrganizationHipaaBaaSigned: 'organization.hipaa_baa_signed',
    OrganizationHipaaBaaRevoked: 'organization.hipaa_baa_revoked',
    MemberHipaaBaaSigned: 'member.hipaa_baa_signed',
    MemberHipaaBaaRevoked: 'member.hipaa_baa_revoked',
    NoteViewed: 'note.viewed',
    NoteTranscriptViewed: 'note.transcript_viewed',
    NoteShareVisibilityChanged: 'note.share_visibility_changed',
    NoteShareRecipientsAdded: 'note.share_recipients_added',
    NoteShareRecipientRemoved: 'note.share_recipient_removed',
    FolderMemberAdded: 'folder.member_added',
    FolderMemberRemoved: 'folder.member_removed',
    FolderMemberLeft: 'folder.member_left',
    FolderNoteFiled: 'folder.note_filed',
    FolderNoteRemoved: 'folder.note_removed',
    FolderDeleted: 'folder.deleted',
    MemberRoleChanged: 'member.role_changed',
    MemberSeatChanged: 'member.seat_changed',
    MemberInvited: 'member.invited',
    MemberInvitationRevoked: 'member.invitation_revoked',
    MemberInvitationResent: 'member.invitation_resent',
    OrganizationDomainAdded: 'organization.domain_added',
    OrganizationDomainRemoved: 'organization.domain_removed',
    OrganizationSeatCommitmentChanged: 'organization.seat_commitment_changed',
    OrganizationSeatPreservationChanged: 'organization.seat_preservation_changed',
    OrganizationSeatCapChanged: 'organization.seat_cap_changed',
    MemberEntitlementOverrideChanged: 'member.entitlement_override_changed',
    OrganizationProductEntitlementGranted: 'organization.product_entitlement_granted',
    OrganizationGatesChanged: 'organization.gates_changed',
    DataExportCompleted: 'data_export.completed',
    DataExportFailed: 'data_export.failed',
    AccountDeletionRequested: 'account_deletion.requested',
    AccountDeletionCompleted: 'account_deletion.completed',
    AccountDeletionFailed: 'account_deletion.failed',
    UsageDataErasureRequested: 'usage_data_erasure.requested',
    UsageDataErasureCompleted: 'usage_data_erasure.completed',
    UsageDataErasureFailed: 'usage_data_erasure.failed',
    ResourceTrashed: 'resource.trashed',
    TranscriptRetentionDeleted: 'transcript.retention_deleted'
} as const;

export type AuditAction = typeof AuditAction[keyof typeof AuditAction];


/**
 * One derived audit event for the enterprise admin audit log.
 * @export
 * @interface AuditLogEntry
 */
export interface AuditLogEntry {
    /**
     * Stable per-event id, deterministic from the source row and action (e.g. `<uuid>:member.added`).
     * @type {string}
     * @memberof AuditLogEntry
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'timestamp': string;
    /**
     * 
     * @type {AuditAction}
     * @memberof AuditLogEntry
     */
    'action': AuditAction;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'actor_user_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'actor_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'actor_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'target_user_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'target_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'target_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogEntry
     */
    'method': string | null;
    /**
     * The table the event was derived from.
     * @type {string}
     * @memberof AuditLogEntry
     */
    'source': string;
}


/**
 * WorkOS\'s log-stream connection states (`AuditLogConfigurationLogStreamState`).
 * @export
 * @enum {string}
 */

export const AuditLogStreamState = {
    Active: 'active',
    Inactive: 'inactive',
    Error: 'error',
    Invalid: 'invalid'
} as const;

export type AuditLogStreamState = typeof AuditLogStreamState[keyof typeof AuditLogStreamState];


/**
 * The configured destination, when one exists.
 * @export
 * @interface AuditLogStreamStatus
 */
export interface AuditLogStreamStatus {
    /**
     * WorkOS destination type (e.g. Splunk, S3, Datadog).
     * @type {string}
     * @memberof AuditLogStreamStatus
     */
    'type': string;
    /**
     * 
     * @type {AuditLogStreamState}
     * @memberof AuditLogStreamStatus
     */
    'state': AuditLogStreamState;
    /**
     * 
     * @type {string}
     * @memberof AuditLogStreamStatus
     */
    'last_synced_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof AuditLogStreamStatus
     */
    'error_message'?: string | null;
}


/**
 * A short-lived WorkOS-hosted URL for setting up or managing the log stream.
 * @export
 * @interface AuditLogStreamingPortalLinkResponse
 */
export interface AuditLogStreamingPortalLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditLogStreamingPortalLinkResponse
     */
    'portal_url': string;
}
/**
 * Current SIEM streaming configuration for the enterprise\'s WorkOS organization.
 * @export
 * @interface AuditLogStreamingStatusResponse
 */
export interface AuditLogStreamingStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof AuditLogStreamingStatusResponse
     */
    'retention_period_in_days': number;
    /**
     * 
     * @type {AuditLogStreamStatus}
     * @memberof AuditLogStreamingStatusResponse
     */
    'log_stream': AuditLogStreamStatus | null;
}
/**
 * Paginated audit-log payload. `total` is the filtered event count before pagination.
 * @export
 * @interface AuditLogTableResponse
 */
export interface AuditLogTableResponse {
    /**
     * 
     * @type {Array<AuditLogEntry>}
     * @memberof AuditLogTableResponse
     */
    'rows': Array<AuditLogEntry>;
    /**
     * 
     * @type {number}
     * @memberof AuditLogTableResponse
     */
    'total': number;
}
/**
 * A short-lived WorkOS-hosted URL for viewing this enterprise\'s audit log events.
 * @export
 * @interface AuditLogsPortalLinkResponse
 */
export interface AuditLogsPortalLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditLogsPortalLinkResponse
     */
    'portal_url': string;
}
/**
 * Total auto-formatting applications with a per-category breakdown.
 * @export
 * @interface AutoFormatting
 */
export interface AutoFormatting {
    /**
     * 
     * @type {number}
     * @memberof AutoFormatting
     */
    'total': number;
    /**
     * 
     * @type {Array<AutoFormattingCategory>}
     * @memberof AutoFormatting
     */
    'by_category': Array<AutoFormattingCategory>;
}
/**
 * Auto-formatting application count for a single formatting category.
 * @export
 * @interface AutoFormattingCategory
 */
export interface AutoFormattingCategory {
    /**
     * 
     * @type {string}
     * @memberof AutoFormattingCategory
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof AutoFormattingCategory
     */
    'count': number;
}
/**
 * Automatic attendee sharing for calendar-backed notes; default off.
 * @export
 * @enum {string}
 */

export const AutoShareNotesPref = {
    Off: 'off',
    Domain: 'domain',
    All: 'all'
} as const;

export type AutoShareNotesPref = typeof AutoShareNotesPref[keyof typeof AutoShareNotesPref];


/**
 * Which calendar-backed meetings auto-share applies to; default all.
 * @export
 * @enum {string}
 */

export const AutoShareNotesType = {
    All: 'all',
    CalendarNotice: 'calendar_notice'
} as const;

export type AutoShareNotesType = typeof AutoShareNotesType[keyof typeof AutoShareNotesType];


/**
 * Body for ``POST /api/v1/automations/add-calendar``.  Creates an event on the user\'s connected Google Calendar account. ``start``/``end`` are ISO 8601 datetimes (a bare value without offset is treated as UTC by the connector). Attendees and description are optional; the organizer is always the authenticated principal.
 * @export
 * @interface AutomationAddCalendarRequest
 */
export interface AutomationAddCalendarRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomationAddCalendarRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationAddCalendarRequest
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationAddCalendarRequest
     */
    'end': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutomationAddCalendarRequest
     */
    'attendees'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AutomationAddCalendarRequest
     */
    'description'?: string | null;
}
/**
 * Body for ``POST /api/v1/automations/actions/gmail/send``.  Same bounds and sender rule as ``AutomationSendEmailRequest``, plus Cc; To and Cc together share its recipient cap. The body is sent as plain text. ``provider`` and ``action`` must be ``gmail`` and ``send_email``.
 * @export
 * @interface AutomationGmailSendActionRequest
 */
export interface AutomationGmailSendActionRequest {
    /**
     * 
     * @type {AskAnythingActionProvider}
     * @memberof AutomationGmailSendActionRequest
     */
    'provider': AskAnythingActionProvider;
    /**
     * 
     * @type {AskAnythingAction}
     * @memberof AutomationGmailSendActionRequest
     */
    'action': AskAnythingAction;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutomationGmailSendActionRequest
     */
    'to': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AutomationGmailSendActionRequest
     */
    'cc'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AutomationGmailSendActionRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationGmailSendActionRequest
     */
    'body': string;
}


/**
 * One automation a managed agent determined for an entity.  The action is ``send_email`` / ``add_calendar`` / ``no_action``. ``(entity_kind, entity_id)`` is the polymorphic target — ``\'todo\'`` here, but the row supports other kinds later. ``payload`` is the kind-specific data as stored; ``kind`` mirrors ``payload[\'kind\']``. ``created_at`` is Unix ms (symmetric with the todo timestamps).
 * @export
 * @interface AutomationOut
 */
export interface AutomationOut {
    /**
     * 
     * @type {string}
     * @memberof AutomationOut
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationOut
     */
    'entity_kind': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationOut
     */
    'entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationOut
     */
    'kind': string;
    /**
     * 
     * @type {object}
     * @memberof AutomationOut
     */
    'payload': object;
    /**
     * 
     * @type {string}
     * @memberof AutomationOut
     */
    'created_at': string;
}
/**
 * Body for ``POST /api/v1/automations/send-email``.  Sends mail via the user\'s connected Gmail account. Recipients are caller-supplied; the *sender* is always the authenticated principal\'s connected account (never taken from the body).
 * @export
 * @interface AutomationSendEmailRequest
 */
export interface AutomationSendEmailRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AutomationSendEmailRequest
     */
    'to': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AutomationSendEmailRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationSendEmailRequest
     */
    'body': string;
}
/**
 * Envelope for ``POST /api/v1/automations/sync``.  Pull-only: automations are server-authored (written by the managed-agent completion handler), so there is NO pushed-items field — the client only ever pulls. Mirrors the cursor/paging shape of ``TodoSyncRequest`` minus the push.
 * @export
 * @interface AutomationSyncRequest
 */
export interface AutomationSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof AutomationSyncRequest
     */
    'last_sync_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AutomationSyncRequest
     */
    'page_cursor'?: string | null;
    /**
     * When true, ignore last_sync_time and pull all of the user\'s automations regardless of it
     * @type {boolean}
     * @memberof AutomationSyncRequest
     */
    'hard_refresh'?: boolean;
}
/**
 * Response for ``POST /api/v1/automations/sync``.  ``automations`` is the server→client pull. ``sync_time`` is the server snapshot high-water mark (Unix ms); the client persists it as the next ``last_sync_time`` only when ``next_page_cursor`` is null. While ``next_page_cursor`` is non-null, the client keeps its previous ``last_sync_time`` and sends ``next_page_cursor`` to continue the same capped pull.
 * @export
 * @interface AutomationSyncResponse
 */
export interface AutomationSyncResponse {
    /**
     * 
     * @type {Array<AutomationOut>}
     * @memberof AutomationSyncResponse
     */
    'automations': Array<AutomationOut>;
    /**
     * 
     * @type {string}
     * @memberof AutomationSyncResponse
     */
    'sync_time': string;
    /**
     * 
     * @type {string}
     * @memberof AutomationSyncResponse
     */
    'next_page_cursor'?: string | null;
}
/**
 * Streamed audio delivered as discrete encoded packets with per-packet volumes.
 * @export
 * @interface BasetenAudioPackets
 */
export interface BasetenAudioPackets {
    /**
     * List of base64 encoded audio packets
     * @type {Array<string>}
     * @memberof BasetenAudioPackets
     */
    'packets': Array<string>;
    /**
     * List of volume levels for each packet
     * @type {Array<number>}
     * @memberof BasetenAudioPackets
     */
    'volumes': Array<number>;
    /**
     * Duration of each packet in seconds
     * @type {number}
     * @memberof BasetenAudioPackets
     */
    'packet_duration': number;
    /**
     * Audio encoding format (e.g. opus)
     * @type {string}
     * @memberof BasetenAudioPackets
     */
    'audio_encoding': string;
    /**
     * Byte encoding format
     * @type {string}
     * @memberof BasetenAudioPackets
     */
    'byte_encoding': string;
}
/**
 * Batch of event creates and updates to apply in one request.
 * @export
 * @interface BatchSaveRequest
 */
export interface BatchSaveRequest {
    /**
     * New events to create
     * @type {Array<AnalyticsEventBase>}
     * @memberof BatchSaveRequest
     */
    'creates'?: Array<AnalyticsEventBase>;
    /**
     * Existing events to update
     * @type {Array<AnalyticsEventUpdate>}
     * @memberof BatchSaveRequest
     */
    'updates'?: Array<AnalyticsEventUpdate>;
}
/**
 * Result of a batch save: created and updated events plus any errors.
 * @export
 * @interface BatchSaveResponse
 */
export interface BatchSaveResponse {
    /**
     * Newly created events
     * @type {Array<AnalyticsEventResponse>}
     * @memberof BatchSaveResponse
     */
    'created'?: Array<AnalyticsEventResponse>;
    /**
     * Updated events
     * @type {Array<AnalyticsEventResponse>}
     * @memberof BatchSaveResponse
     */
    'updated'?: Array<AnalyticsEventResponse>;
    /**
     * Any errors encountered
     * @type {Array<string>}
     * @memberof BatchSaveResponse
     */
    'errors'?: Array<string>;
}
/**
 * Billing address fields propagated to the Stripe customer address object.  All fields optional so admins can supply partial info. ISO 3166-1 alpha-2 country code (e.g. \"US\", \"GB\") is what Stripe expects.
 * @export
 * @interface BillingAddress
 */
export interface BillingAddress {
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'line1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'state'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'postal_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BillingAddress
     */
    'country'?: string | null;
}
/**
 * Billing info propagated to the Stripe customer record.  `billing_contact` is the email Stripe sends invoices and receipts to; overrides the Stripe customer\'s `email` (which otherwise defaults to the admin user\'s address). The Stripe customer `name` is always set to the enterprise name server-side.
 * @export
 * @interface BillingInfo
 */
export interface BillingInfo {
    /**
     * 
     * @type {string}
     * @memberof BillingInfo
     */
    'billing_contact'?: string | null;
    /**
     * 
     * @type {BillingAddress}
     * @memberof BillingInfo
     */
    'address'?: BillingAddress | null;
}
/**
 * The billing system that is the source of truth for a cost center.  `stripe` is the self-serve/PLG default (billed Stripe-direct); `sequence` marks a sales-led cost center whose billing brain is Sequence — no Stripe subscription, no enterprise_subscription row (Stripe may still be the payment rail underneath Sequence). A live `sequence` cost center is cost-center-native by data.  `sales_owned` marks an enterprise whose contract and billing live in Salesforce and whose access is granted by cost-center liveness alone: no Stripe customer/subscription/price, no invoices, no seat reconciliation. Suspended and resumed by sales-ops (see ``runbooks/sales-owned-enterprise.md``); ``num_seats`` is informational, the optional ``seat_cap`` limits member adds, and ``plan_ends_at`` is NULL (the contract end lives in Salesforce).  `self_serve` marks a cost center migrated to the self-serve billing engine. It is Stripe-billed like `stripe`, but the engine is the only writer of its Stripe subscription and billing fields: the legacy writers (subscription mirror, seat recount, reconciler, plan-variant switch) act on `stripe` rows only.
 * @export
 * @enum {string}
 */

export const BillingProvider = {
    Stripe: 'stripe',
    Sequence: 'sequence',
    SalesOwned: 'sales_owned',
    SelfServe: 'self_serve'
} as const;

export type BillingProvider = typeof BillingProvider[keyof typeof BillingProvider];


/**
 * Response model for a blocked domain.
 * @export
 * @interface BlockedDomainItem
 */
export interface BlockedDomainItem {
    /**
     * 
     * @type {string}
     * @memberof BlockedDomainItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BlockedDomainItem
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof BlockedDomainItem
     */
    'notes': string | null;
    /**
     * 
     * @type {string}
     * @memberof BlockedDomainItem
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof BlockedDomainItem
     */
    'created_at': string;
}
/**
 * Response model for list of blocked domains.
 * @export
 * @interface BlockedDomainsListResponse
 */
export interface BlockedDomainsListResponse {
    /**
     * 
     * @type {Array<BlockedDomainItem>}
     * @memberof BlockedDomainsListResponse
     */
    'blocked_domains': Array<BlockedDomainItem>;
    /**
     * 
     * @type {number}
     * @memberof BlockedDomainsListResponse
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface BodyAsrLlmAsrPost
 */
export interface BodyAsrLlmAsrPost {
    /**
     * Base64 encoded audio
     * @type {string}
     * @memberof BodyAsrLlmAsrPost
     */
    'audio': string;
    /**
     * Language of the audio
     * @type {string}
     * @memberof BodyAsrLlmAsrPost
     */
    'language'?: string;
    /**
     * Prompt for the audio
     * @type {string}
     * @memberof BodyAsrLlmAsrPost
     */
    'prompt'?: string;
}
/**
 * 
 * @export
 * @interface BodyFlowApiLlmApiPost
 */
export interface BodyFlowApiLlmApiPost {
    /**
     * Base64 encoded audio
     * @type {string}
     * @memberof BodyFlowApiLlmApiPost
     */
    'audio': string;
    /**
     * 
     * @type {Language}
     * @memberof BodyFlowApiLlmApiPost
     */
    'language'?: Language | null;
    /**
     * 
     * @type {Context}
     * @memberof BodyFlowApiLlmApiPost
     */
    'context'?: Context | null;
    /**
     * 
     * @type {APIProperties}
     * @memberof BodyFlowApiLlmApiPost
     */
    'properties'?: APIProperties | null;
    /**
     * Transcript Entity UUID
     * @type {string}
     * @memberof BodyFlowApiLlmApiPost
     */
    'transcript_id'?: string;
}
/**
 * 
 * @export
 * @interface BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost
 */
export interface BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost {
    /**
     * Base64 encoded audio
     * @type {string}
     * @memberof BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost
     */
    'audio': string;
    /**
     * 
     * @type {Language}
     * @memberof BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost
     */
    'language'?: Language | null;
    /**
     * 
     * @type {Context}
     * @memberof BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost
     */
    'context'?: Context | null;
    /**
     * 
     * @type {APIProperties}
     * @memberof BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost
     */
    'properties'?: APIProperties | null;
}
/**
 * 
 * @export
 * @interface BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost
 */
export interface BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost {
    /**
     * 
     * @type {string}
     * @memberof BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost
     */
    'is_student': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost
     */
    'from_now'?: boolean;
}
/**
 * Generic response for boost action endpoints.
 * @export
 * @interface BoostActionResponse
 */
export interface BoostActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BoostActionResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof BoostActionResponse
     */
    'action': string;
    /**
     * 
     * @type {number}
     * @memberof BoostActionResponse
     */
    'boost_earned': number;
    /**
     * 
     * @type {number}
     * @memberof BoostActionResponse
     */
    'current_rank': number;
    /**
     * 
     * @type {number}
     * @memberof BoostActionResponse
     */
    'total_boost': number;
    /**
     * 
     * @type {string}
     * @memberof BoostActionResponse
     */
    'error'?: string | null;
}
/**
 * Pre-checkout summary shown to admins initiating a break-away.  All amounts are integer cents in the source CC\'s currency. ``billing_interval`` is the underlying Stripe price interval; the annual amount is always pre-multiplied so the frontend never has to apply ``× 12`` itself.  Pricing fields are nullable so the preview can still surface team / member counts even when Stripe\'s price shape is incompatible with flat per-seat math (e.g. ``billing_scheme=tiered`` on most negotiated enterprise contracts). ``pricing_unavailable_reason`` is populated whenever any pricing field is null so the frontend can show a precise explanation instead of a generic \"try again\" fallback.
 * @export
 * @interface BreakAwayPreview
 */
export interface BreakAwayPreview {
    /**
     * 
     * @type {string}
     * @memberof BreakAwayPreview
     */
    'team_name': string;
    /**
     * 
     * @type {string}
     * @memberof BreakAwayPreview
     */
    'source_cost_center_name': string;
    /**
     * 
     * @type {number}
     * @memberof BreakAwayPreview
     */
    'members_moving': number;
    /**
     * 
     * @type {number}
     * @memberof BreakAwayPreview
     */
    'per_seat_amount_cents': number | null;
    /**
     * 
     * @type {string}
     * @memberof BreakAwayPreview
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof BreakAwayPreview
     */
    'billing_interval': BreakAwayPreviewBillingIntervalEnum | null;
    /**
     * 
     * @type {number}
     * @memberof BreakAwayPreview
     */
    'new_cc_annual_amount_cents': number | null;
    /**
     * 
     * @type {string}
     * @memberof BreakAwayPreview
     */
    'pricing_unavailable_reason'?: BreakAwayPreviewPricingUnavailableReasonEnum | null;
}

export const BreakAwayPreviewBillingIntervalEnum = {
    Month: 'month',
    Year: 'year'
} as const;

export type BreakAwayPreviewBillingIntervalEnum = typeof BreakAwayPreviewBillingIntervalEnum[keyof typeof BreakAwayPreviewBillingIntervalEnum];
export const BreakAwayPreviewPricingUnavailableReasonEnum = {
    TieredPricingNotSupported: 'tiered_pricing_not_supported',
    UnexpectedStripeShape: 'unexpected_stripe_shape'
} as const;

export type BreakAwayPreviewPricingUnavailableReasonEnum = typeof BreakAwayPreviewPricingUnavailableReasonEnum[keyof typeof BreakAwayPreviewPricingUnavailableReasonEnum];

/**
 * Identifiers of the join requests being accepted in bulk.
 * @export
 * @interface BulkAcceptJoinRequestRequest
 */
export interface BulkAcceptJoinRequestRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkAcceptJoinRequestRequest
     */
    'join_request_ids': Array<string>;
}
/**
 * Internal admin request to broadcast an announcement notification to all users.
 * @export
 * @interface BulkAnnouncementCreateRequest
 */
export interface BulkAnnouncementCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkAnnouncementCreateRequest
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof BulkAnnouncementCreateRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkAnnouncementCreateRequest
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkAnnouncementCreateRequest
     */
    'ios_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkAnnouncementCreateRequest
     */
    'ios_text'?: string | null;
    /**
     * 
     * @type {NotificationPlatformType}
     * @memberof BulkAnnouncementCreateRequest
     */
    'platform_type'?: NotificationPlatformType;
}


/**
 * Result summary of a bulk team dictionary import (imported and duplicate counts).
 * @export
 * @interface BulkCreateTeamDictionaryResult
 */
export interface BulkCreateTeamDictionaryResult {
    /**
     * 
     * @type {boolean}
     * @memberof BulkCreateTeamDictionaryResult
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTeamDictionaryResult
     */
    'imported_count': number;
    /**
     * 
     * @type {number}
     * @memberof BulkCreateTeamDictionaryResult
     */
    'duplicate_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof BulkCreateTeamDictionaryResult
     */
    'pending'?: boolean;
}
/**
 * Response model for a failed bulk invite item.
 * @export
 * @interface BulkInviteFailedItem
 */
export interface BulkInviteFailedItem {
    /**
     * 
     * @type {string}
     * @memberof BulkInviteFailedItem
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkInviteFailedItem
     */
    'error': string;
}
/**
 * A batch of enterprise invites to send at once.
 * @export
 * @interface BulkInviteRequest
 */
export interface BulkInviteRequest {
    /**
     * 
     * @type {Array<InviteRequest>}
     * @memberof BulkInviteRequest
     */
    'invites': Array<InviteRequest>;
}
/**
 * Response model for bulk invite operation.
 * @export
 * @interface BulkInviteResponse
 */
export interface BulkInviteResponse {
    /**
     * 
     * @type {Array<InviteResponse>}
     * @memberof BulkInviteResponse
     */
    'successful': Array<InviteResponse>;
    /**
     * 
     * @type {Array<BulkInviteFailedItem>}
     * @memberof BulkInviteResponse
     */
    'failed': Array<BulkInviteFailedItem>;
}
/**
 * Endpoint-specific user input with an optional personal trial end date.
 * @export
 * @interface BulkProvisionUserTrialEndInput
 */
export interface BulkProvisionUserTrialEndInput {
    /**
     * 
     * @type {string}
     * @memberof BulkProvisionUserTrialEndInput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkProvisionUserTrialEndInput
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkProvisionUserTrialEndInput
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkProvisionUserTrialEndInput
     */
    'trial_end'?: string | null;
}
/**
 * Request model for provisioning users and applying personal trial end dates.
 * @export
 * @interface BulkProvisionUserTrialEndRequest
 */
export interface BulkProvisionUserTrialEndRequest {
    /**
     * Users to provision or update (max 5). Same-date duplicates keep the first row; conflicting dates are rejected.
     * @type {Array<BulkProvisionUserTrialEndInput>}
     * @memberof BulkProvisionUserTrialEndRequest
     */
    'users': Array<BulkProvisionUserTrialEndInput>;
    /**
     * 
     * @type {string}
     * @memberof BulkProvisionUserTrialEndRequest
     */
    'trial_end'?: string | null;
}
/**
 * Request model for bulk-updating personal trial end dates (internal admin).
 * @export
 * @interface BulkUpdateUserTrialEndRequest
 */
export interface BulkUpdateUserTrialEndRequest {
    /**
     * Emails of the users to update (max 100). Duplicates are ignored.
     * @type {Array<string>}
     * @memberof BulkUpdateUserTrialEndRequest
     */
    'user_emails': Array<string>;
    /**
     * New trial end date (YYYY-MM-DD) applied to every user. Interpreted as 23:59:59 UTC on that day; must be in the future and at most 365 days from now (UTC).
     * @type {string}
     * @memberof BulkUpdateUserTrialEndRequest
     */
    'trial_end': string;
}
/**
 * Response model for bulk-updating personal trial end dates.
 * @export
 * @interface BulkUpdateUserTrialEndResponse
 */
export interface BulkUpdateUserTrialEndResponse {
    /**
     * 
     * @type {Array<BulkUpdateUserTrialEndResult>}
     * @memberof BulkUpdateUserTrialEndResponse
     */
    'results': Array<BulkUpdateUserTrialEndResult>;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateUserTrialEndResponse
     */
    'updated_count': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateUserTrialEndResponse
     */
    'failed_count': number;
    /**
     * Rows processed after lowercasing and deduping emails; may be less than the number of emails sent.
     * @type {number}
     * @memberof BulkUpdateUserTrialEndResponse
     */
    'total_count': number;
}
/**
 * Per-user outcome of a bulk trial end update.
 * @export
 * @interface BulkUpdateUserTrialEndResult
 */
export interface BulkUpdateUserTrialEndResult {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateUserTrialEndResult
     */
    'user_email': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateUserTrialEndResult
     */
    'status': BulkUpdateUserTrialEndResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateUserTrialEndResult
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateUserTrialEndResult
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateUserTrialEndResult
     */
    'trial_ends_at'?: number | null;
}

export const BulkUpdateUserTrialEndResultStatusEnum = {
    Updated: 'updated',
    NotFound: 'not_found',
    Error: 'error'
} as const;

export type BulkUpdateUserTrialEndResultStatusEnum = typeof BulkUpdateUserTrialEndResultStatusEnum[keyof typeof BulkUpdateUserTrialEndResultStatusEnum];

/**
 * Pricing for one self-serve Business purchase option, both billing cycles.
 * @export
 * @interface BusinessOptionPricingResponse
 */
export interface BusinessOptionPricingResponse {
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof BusinessOptionPricingResponse
     */
    'monthly': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof BusinessOptionPricingResponse
     */
    'yearly': ProductPricingResponse;
}
/**
 * Google and Outlook connection catalog in stable Provider order.
 * @export
 * @interface CalendarConnectionCatalogResponse
 */
export interface CalendarConnectionCatalogResponse {
    /**
     * 
     * @type {Array<CalendarConnectionProviderResponse>}
     * @memberof CalendarConnectionCatalogResponse
     */
    'providers': Array<CalendarConnectionProviderResponse>;
}
/**
 * Public lifecycle states for one calendar Connection Slot.
 * @export
 * @enum {string}
 */

export const CalendarConnectionLifecycle = {
    Pending: 'pending',
    Active: 'active',
    Failed: 'failed',
    NeedsReauth: 'needs_reauth',
    IncompleteScopes: 'incomplete_scopes',
    Retired: 'retired'
} as const;

export type CalendarConnectionLifecycle = typeof CalendarConnectionLifecycle[keyof typeof CalendarConnectionLifecycle];


/**
 * One Provider\'s Slots, non-retired Slot capacity, and Add eligibility.
 * @export
 * @interface CalendarConnectionProviderResponse
 */
export interface CalendarConnectionProviderResponse {
    /**
     * 
     * @type {string}
     * @memberof CalendarConnectionProviderResponse
     */
    'provider': CalendarConnectionProviderResponseProviderEnum;
    /**
     * Number of non-retired Slots currently counted for this Provider.
     * @type {number}
     * @memberof CalendarConnectionProviderResponse
     */
    'capacity_used': number;
    /**
     * Maximum non-retired Slots allowed for one user and Provider.
     * @type {number}
     * @memberof CalendarConnectionProviderResponse
     */
    'capacity_limit': number;
    /**
     * True only when policy allows Add and no Slot or legacy credential exists for this Provider.
     * @type {boolean}
     * @memberof CalendarConnectionProviderResponse
     */
    'add_eligible': boolean;
    /**
     * 
     * @type {Array<CalendarConnectionSlotResponse>}
     * @memberof CalendarConnectionProviderResponse
     */
    'slots': Array<CalendarConnectionSlotResponse>;
}

export const CalendarConnectionProviderResponseProviderEnum = {
    Calendar: 'calendar',
    Outlook: 'outlook'
} as const;

export type CalendarConnectionProviderResponseProviderEnum = typeof CalendarConnectionProviderResponseProviderEnum[keyof typeof CalendarConnectionProviderResponseProviderEnum];

/**
 * One stable, non-secret calendar Connection projection.
 * @export
 * @interface CalendarConnectionSlotResponse
 */
export interface CalendarConnectionSlotResponse {
    /**
     * 
     * @type {string}
     * @memberof CalendarConnectionSlotResponse
     */
    'slot_id': string;
    /**
     * 
     * @type {CalendarConnectionLifecycle}
     * @memberof CalendarConnectionSlotResponse
     */
    'lifecycle': CalendarConnectionLifecycle;
    /**
     * 
     * @type {string}
     * @memberof CalendarConnectionSlotResponse
     */
    'display_email': string | null;
}


/**
 * Response shape for ``GET /api/v1/calendar/events/batch``.  Returns events matching the requested ``externalId`` values. Missing ids (not in the DB, or belonging to another user) are simply absent.
 * @export
 * @interface CalendarEventBatchResponse
 */
export interface CalendarEventBatchResponse {
    /**
     * 
     * @type {Array<CalendarEventDTO>}
     * @memberof CalendarEventBatchResponse
     */
    'events': Array<CalendarEventDTO>;
}
/**
 * API contract for a mirrored calendar event.  Field aliases serialize to camelCase for the desktop client. `populate_by_name=True` accepts both snake_case and camelCase on input.
 * @export
 * @interface CalendarEventDTO
 */
export interface CalendarEventDTO {
    /**
     * 
     * @type {ConnectorKey}
     * @memberof CalendarEventDTO
     */
    'connectorKey'?: ConnectorKey;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'startAtUtc': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'endAtUtc': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'conferenceUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'alternateConferenceUrl'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarEventDTO
     */
    'participants'?: Array<string>;
    /**
     * 
     * @type {Array<ParticipantDTO>}
     * @memberof CalendarEventDTO
     */
    'participantDetails'?: Array<ParticipantDTO>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'status'?: CalendarEventDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'colorId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'selfResponseStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEventDTO
     */
    'selfIsOrganizer'?: boolean;
    /**
     * 
     * @type {CalendarNoticePref}
     * @memberof CalendarEventDTO
     */
    'notetakerCalendarNotice'?: CalendarNoticePref | null;
    /**
     * 
     * @type {AutoShareNotesPref}
     * @memberof CalendarEventDTO
     */
    'notetakerAutoShare'?: AutoShareNotesPref | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'seriesKey'?: string | null;
    /**
     * Current server-owned brief input version.
     * @type {number}
     * @memberof CalendarEventDTO
     */
    'prereadVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventDTO
     */
    'prereadCompletedVersion'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventDTO
     */
    'updatedAt': string;
}

export const CalendarEventDTOStatusEnum = {
    Active: 'active',
    Cancelled: 'cancelled'
} as const;

export type CalendarEventDTOStatusEnum = typeof CalendarEventDTOStatusEnum[keyof typeof CalendarEventDTOStatusEnum];

/**
 * Calendar-invite notice. Hidden unless the PostHog flag is on; default off.
 * @export
 * @enum {string}
 */

export const CalendarNoticePref = {
    Off: 'off',
    NoticeOnly: 'notice_only',
    NoticeAndLink: 'notice_and_link'
} as const;

export type CalendarNoticePref = typeof CalendarNoticePref[keyof typeof CalendarNoticePref];


/**
 * Provider-targeted Add intent; no Slot or Provider Identity is client-supplied.
 * @export
 * @interface CalendarOAuthAttemptCreateRequest
 */
export interface CalendarOAuthAttemptCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof CalendarOAuthAttemptCreateRequest
     */
    'provider': CalendarOAuthAttemptCreateRequestProviderEnum;
}

export const CalendarOAuthAttemptCreateRequestProviderEnum = {
    Calendar: 'calendar',
    Outlook: 'outlook'
} as const;

export type CalendarOAuthAttemptCreateRequestProviderEnum = typeof CalendarOAuthAttemptCreateRequestProviderEnum[keyof typeof CalendarOAuthAttemptCreateRequestProviderEnum];

/**
 * Opaque Attempt identity and Provider authorization redirect.
 * @export
 * @interface CalendarOAuthAttemptInitiationResponse
 */
export interface CalendarOAuthAttemptInitiationResponse {
    /**
     * 
     * @type {string}
     * @memberof CalendarOAuthAttemptInitiationResponse
     */
    'attempt_id': string;
    /**
     * 
     * @type {string}
     * @memberof CalendarOAuthAttemptInitiationResponse
     */
    'provider': CalendarOAuthAttemptInitiationResponseProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CalendarOAuthAttemptInitiationResponse
     */
    'redirect_url': string;
}

export const CalendarOAuthAttemptInitiationResponseProviderEnum = {
    Calendar: 'calendar',
    Outlook: 'outlook'
} as const;

export type CalendarOAuthAttemptInitiationResponseProviderEnum = typeof CalendarOAuthAttemptInitiationResponseProviderEnum[keyof typeof CalendarOAuthAttemptInitiationResponseProviderEnum];

/**
 * Closed terminal vocabulary exposed by Slot-bound Attempt polling.
 * @export
 * @enum {string}
 */

export const CalendarOAuthAttemptOutcome = {
    Succeeded: 'succeeded',
    WrongIdentity: 'wrong_identity',
    RetiredSlot: 'retired_slot',
    SupersededGeneration: 'superseded_generation',
    AdditionalSlotsDisabled: 'additional_slots_disabled',
    InvalidTarget: 'invalid_target',
    Replayed: 'replayed',
    Cancelled: 'cancelled',
    Failed: 'failed'
} as const;

export type CalendarOAuthAttemptOutcome = typeof CalendarOAuthAttemptOutcome[keyof typeof CalendarOAuthAttemptOutcome];


/**
 * Owner- and Provider-scoped terminal result, or null fields while pending.
 * @export
 * @interface CalendarOAuthAttemptStatusResponse
 */
export interface CalendarOAuthAttemptStatusResponse {
    /**
     * 
     * @type {CalendarOAuthAttemptOutcome}
     * @memberof CalendarOAuthAttemptStatusResponse
     */
    'outcome'?: CalendarOAuthAttemptOutcome | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarOAuthAttemptStatusResponse
     */
    'result_slot_id'?: string | null;
}


/**
 * A promo campaign summary row for the admin list view.
 * @export
 * @interface CampaignListItem
 */
export interface CampaignListItem {
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'campaign_type': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItem
     */
    'trial_days': number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'source_name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'attribution_message': string | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItem
     */
    'max_redemptions': number | null;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItem
     */
    'total_redemptions': number;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'starts_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'expires_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof CampaignListItem
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof CampaignListItem
     */
    'code_count': number;
}
/**
 * A page of promo campaigns with a total count.
 * @export
 * @interface CampaignListResponse
 */
export interface CampaignListResponse {
    /**
     * 
     * @type {Array<CampaignListItem>}
     * @memberof CampaignListResponse
     */
    'campaigns': Array<CampaignListItem>;
    /**
     * 
     * @type {number}
     * @memberof CampaignListResponse
     */
    'total': number;
}
/**
 * Resolved promo details for a validated code and its campaign.
 * @export
 * @interface CampaignPromoDetails
 */
export interface CampaignPromoDetails {
    /**
     * 
     * @type {number}
     * @memberof CampaignPromoDetails
     */
    'trial_days': number;
    /**
     * 
     * @type {string}
     * @memberof CampaignPromoDetails
     */
    'source_name': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignPromoDetails
     */
    'attribution_message': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignPromoDetails
     */
    'code_id': string;
    /**
     * 
     * @type {string}
     * @memberof CampaignPromoDetails
     */
    'campaign_id': string;
}
/**
 * Lifecycle status of a promotional campaign.
 * @export
 * @enum {string}
 */

export const CampaignStatus = {
    Active: 'active',
    Paused: 'paused',
    Ended: 'ended',
    Archived: 'archived'
} as const;

export type CampaignStatus = typeof CampaignStatus[keyof typeof CampaignStatus];


/**
 * Category of a promotional campaign.
 * @export
 * @enum {string}
 */

export const CampaignType = {
    Sponsor: 'sponsor',
    Affiliate: 'affiliate',
    Partnership: 'partnership',
    Community: 'community',
    Internal: 'internal'
} as const;

export type CampaignType = typeof CampaignType[keyof typeof CampaignType];


/**
 * Request to cancel a user\'s subscription with a chosen refund policy.
 * @export
 * @interface CancelSubscriptionRequest
 */
export interface CancelSubscriptionRequest {
    /**
     * User email
     * @type {string}
     * @memberof CancelSubscriptionRequest
     */
    'email': string;
    /**
     * Refund type: \"full\", \"partial\", or \"no\"
     * @type {string}
     * @memberof CancelSubscriptionRequest
     */
    'refund': string;
}
/**
 * Client that recorded a meeting.
 * @export
 * @enum {string}
 */

export const CapturePlatform = {
    Ios: 'ios',
    Android: 'android',
    Desktop: 'desktop'
} as const;

export type CapturePlatform = typeof CapturePlatform[keyof typeof CapturePlatform];


/**
 * Whether Zoom has a transcript or a summary for an occurrence.
 * @export
 * @enum {string}
 */

export const CatalogPiece = {
    Available: 'available',
    Absent: 'absent'
} as const;

export type CatalogPiece = typeof CatalogPiece[keyof typeof CatalogPiece];


/**
 * Why an occurrence cannot be imported.
 * @export
 * @enum {string}
 */

export const CatalogReason = {
    NoContent: 'no_content',
    MultipleTranscriptFiles: 'multiple_transcript_files',
    RecordingProcessing: 'recording_processing'
} as const;

export type CatalogReason = typeof CatalogReason[keyof typeof CatalogReason];


/**
 * A selectable app category in the insights filter dropdown.
 * @export
 * @interface CategoryFilterOption
 */
export interface CategoryFilterOption {
    /**
     * 
     * @type {string}
     * @memberof CategoryFilterOption
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryFilterOption
     */
    'display_name': string;
}
/**
 * Provider config for a Cerebras-backed model.
 * @export
 * @interface CerebrasProviderConfig
 */
export interface CerebrasProviderConfig {
    /**
     * 
     * @type {string}
     * @memberof CerebrasProviderConfig
     */
    'kind'?: CerebrasProviderConfigKindEnum;
    /**
     * 
     * @type {string}
     * @memberof CerebrasProviderConfig
     */
    'model': string;
}

export const CerebrasProviderConfigKindEnum = {
    Cerebras: 'cerebras'
} as const;

export type CerebrasProviderConfigKindEnum = typeof CerebrasProviderConfigKindEnum[keyof typeof CerebrasProviderConfigKindEnum];

/**
 * An atomic batch of seat changes; reuse request_id and changes when retrying.
 * @export
 * @interface ChangeCostCenterSeatsRequest
 */
export interface ChangeCostCenterSeatsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeCostCenterSeatsRequest
     */
    'request_id': string;
    /**
     * 
     * @type {Array<CostCenterSeatChange>}
     * @memberof ChangeCostCenterSeatsRequest
     */
    'changes': Array<CostCenterSeatChange>;
}
/**
 * The committed changes for this request, ordered by user_id.
 * @export
 * @interface ChangeCostCenterSeatsResponse
 */
export interface ChangeCostCenterSeatsResponse {
    /**
     * 
     * @type {string}
     * @memberof ChangeCostCenterSeatsResponse
     */
    'request_id': string;
    /**
     * 
     * @type {Array<CostCenterSeatChange>}
     * @memberof ChangeCostCenterSeatsResponse
     */
    'changes': Array<CostCenterSeatChange>;
}
/**
 * A registry change set with its status, snapshot, and audit fields.
 * @export
 * @interface ChangeSetResponse
 */
export interface ChangeSetResponse {
    /**
     * Unique identifier for the change set
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'change_set_id': string;
    /**
     * 
     * @type {ChangeSetStatus}
     * @memberof ChangeSetResponse
     */
    'status': ChangeSetStatus;
    /**
     * Immutable snapshot of the analytics registry
     * @type {object}
     * @memberof ChangeSetResponse
     */
    'snapshot': object;
    /**
     * 
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'last_error'?: string | null;
    /**
     * User ID who created this change set
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'created_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeSetResponse
     */
    'modified_at': string;
}


/**
 * Status of a change set within the publish pipeline.
 * @export
 * @enum {string}
 */

export const ChangeSetStatus = {
    Created: 'created',
    Published: 'published',
    Merged: 'merged'
} as const;

export type ChangeSetStatus = typeof ChangeSetStatus[keyof typeof ChangeSetStatus];


/**
 * A single message in a dictation conversation.
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * Role of the message sender
     * @type {ChatRole}
     * @memberof ChatMessage
     */
    'role': ChatRole;
    /**
     * Content of the message
     * @type {string}
     * @memberof ChatMessage
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessage
     */
    'sender_id'?: string | null;
}


/**
 * Author of a conversation message.
 * @export
 * @enum {string}
 */

export const ChatRole = {
    User: 'user',
    Human: 'human',
    Assistant: 'assistant'
} as const;

export type ChatRole = typeof ChatRole[keyof typeof ChatRole];


/**
 * An assistant turn where the model answered via the `chat` tool.
 * @export
 * @interface ChatStep
 */
export interface ChatStep {
    /**
     * 
     * @type {string}
     * @memberof ChatStep
     */
    'kind'?: ChatStepKindEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatStep
     */
    'text': string;
}

export const ChatStepKindEnum = {
    Chat: 'chat'
} as const;

export type ChatStepKindEnum = typeof ChatStepKindEnum[keyof typeof ChatStepKindEnum];

/**
 * Email address to check for enterprise eligibility.
 * @export
 * @interface CheckEnterpriseEligibilityRequest
 */
export interface CheckEnterpriseEligibilityRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckEnterpriseEligibilityRequest
     */
    'email': string;
}
/**
 * Request to score whether a transcript makes sense in its surrounding text/app context.
 * @export
 * @interface CheckSensibilityRequest
 */
export interface CheckSensibilityRequest {
    /**
     * The transcribed and formatted text to check
     * @type {string}
     * @memberof CheckSensibilityRequest
     */
    'transcript': string;
    /**
     * Text before the cursor/insertion point
     * @type {string}
     * @memberof CheckSensibilityRequest
     */
    'before_text'?: string;
    /**
     * Text after the cursor/insertion point
     * @type {string}
     * @memberof CheckSensibilityRequest
     */
    'after_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckSensibilityRequest
     */
    'app_context'?: string | null;
}
/**
 * Sensibility-check result with a 0.0–1.0 score.
 * @export
 * @interface CheckSensibilityResponse
 */
export interface CheckSensibilityResponse {
    /**
     * Sensibility score from 0.0 (nonsensical) to 1.0 (makes sense)
     * @type {number}
     * @memberof CheckSensibilityResponse
     */
    'score': number;
}
/**
 * A requested head, including explicit absence and stale-evidence outcomes.
 * @export
 * @interface CheckoutEntry
 */
export interface CheckoutEntry {
    /**
     * 
     * @type {string}
     * @memberof CheckoutEntry
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutEntry
     */
    'status': CheckoutEntryStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CheckoutEntry
     */
    'version'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CheckoutEntry
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CheckoutEntry
     */
    'actor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CheckoutEntry
     */
    'updated_at'?: string | null;
    /**
     * 
     * @type {Array<ContextEvidence>}
     * @memberof CheckoutEntry
     */
    'evidence'?: Array<ContextEvidence>;
}

export const CheckoutEntryStatusEnum = {
    Present: 'present',
    Missing: 'missing',
    Deleted: 'deleted',
    OverBudget: 'over_budget',
    StaleEvidence: 'stale_evidence'
} as const;

export type CheckoutEntryStatusEnum = typeof CheckoutEntryStatusEnum[keyof typeof CheckoutEntryStatusEnum];

/**
 * Select explicit paths or a bounded literal prefix page.
 * @export
 * @interface CheckoutRequest
 */
export interface CheckoutRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckoutRequest
     */
    'paths'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CheckoutRequest
     */
    'prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutRequest
     */
    'after_path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CheckoutRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CheckoutRequest
     */
    'max_bytes'?: number;
}
/**
 * Budgeted file contents with lifecycle and version preconditions.
 * @export
 * @interface CheckoutResponse
 */
export interface CheckoutResponse {
    /**
     * 
     * @type {Array<CheckoutEntry>}
     * @memberof CheckoutResponse
     */
    'entries': Array<CheckoutEntry>;
    /**
     * 
     * @type {ReadToken}
     * @memberof CheckoutResponse
     */
    'token': ReadToken;
    /**
     * 
     * @type {boolean}
     * @memberof CheckoutResponse
     */
    'truncated': boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponse
     */
    'next_path'?: string | null;
}
/**
 * A Stripe checkout URL for the client to redirect to.
 * @export
 * @interface CheckoutUrlResponse
 */
export interface CheckoutUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckoutUrlResponse
     */
    'url': string;
}
/**
 * Pre-auth request from the Chrome extension to mint a short-lived `client_key`.
 * @export
 * @interface ChromeExtensionClientKeyRequest
 */
export interface ChromeExtensionClientKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof ChromeExtensionClientKeyRequest
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof ChromeExtensionClientKeyRequest
     */
    'extension_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChromeExtensionClientKeyRequest
     */
    'build_channel'?: string | null;
}
/**
 * The minted Chrome-extension `client_key` and its lifetime.
 * @export
 * @interface ChromeExtensionClientKeyResponse
 */
export interface ChromeExtensionClientKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof ChromeExtensionClientKeyResponse
     */
    'client_key': string;
    /**
     * 
     * @type {number}
     * @memberof ChromeExtensionClientKeyResponse
     */
    'expires_in': number;
}
/**
 * How the dictation entered the classification flow.
 * @export
 * @enum {string}
 */

export const ClassificationMode = {
    AutoClassify: 'autoClassify',
    InstructShortcut: 'instructShortcut'
} as const;

export type ClassificationMode = typeof ClassificationMode[keyof typeof ClassificationMode];


/**
 * Outcome of the /llm/classify_intent call (null when classify-intent was not invoked).
 * @export
 * @enum {string}
 */

export const ClassifierStatus = {
    Succeeded: 'succeeded',
    Timeout: 'timeout',
    ShortCircuit: 'short_circuit',
    Error: 'error',
    NotInvoked: 'not_invoked'
} as const;

export type ClassifierStatus = typeof ClassifierStatus[keyof typeof ClassifierStatus];


/**
 * Screen/app context supplied to intent classification (ASR text, app, surrounding text, history).
 * @export
 * @interface ClassifyIntentContext
 */
export interface ClassifyIntentContext {
    /**
     * Raw ASR transcription text
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'asr_text': string;
    /**
     * Name of the foreground app
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'app_name'?: string;
    /**
     * URL within the foreground app
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'app_url'?: string;
    /**
     * Text before the cursor
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'before_text'?: string;
    /**
     * Currently selected text
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'selected_text'?: string;
    /**
     * Text after the cursor
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'after_text'?: string;
    /**
     * First 1000 chars of accessibility context
     * @type {string}
     * @memberof ClassifyIntentContext
     */
    'ax_context'?: string;
    /**
     * Prior instruct-chat turns for multi-turn follow-ups (e.g. clarifications after a settings confirmation).
     * @type {Array<InstructSessionHistoryMessage>}
     * @memberof ClassifyIntentContext
     */
    'session_history'?: Array<InstructSessionHistoryMessage>;
}
/**
 * Request to classify voice input against a set of routes, with provider config and context.
 * @export
 * @interface ClassifyIntentRequest
 */
export interface ClassifyIntentRequest {
    /**
     * Provider configuration for classification
     * @type {ClassifyIntentRoutesConfig}
     * @memberof ClassifyIntentRequest
     */
    'config': ClassifyIntentRoutesConfig;
    /**
     * Available routes to classify against
     * @type {Array<RouteDefinition>}
     * @memberof ClassifyIntentRequest
     */
    'routes': Array<RouteDefinition>;
    /**
     * 
     * @type {string}
     * @memberof ClassifyIntentRequest
     */
    'short_circuit_route'?: string | null;
    /**
     * Context (screen, app, etc) at the time of the intent classification request
     * @type {ClassifyIntentContext}
     * @memberof ClassifyIntentRequest
     */
    'context': ClassifyIntentContext;
}
/**
 * Intent-classification result: the matched route, optional route data, and an instruction flag.
 * @export
 * @interface ClassifyIntentResponse
 */
export interface ClassifyIntentResponse {
    /**
     * 
     * @type {string}
     * @memberof ClassifyIntentResponse
     */
    'route'?: string | null;
    /**
     * 
     * @type {ClassifyIntentRouteData}
     * @memberof ClassifyIntentResponse
     */
    'data'?: ClassifyIntentRouteData | null;
    /**
     * True if the user is instructing Flow, False if dictating text. Derived from `route`; kept for iOS compatibility.
     * @type {boolean}
     * @memberof ClassifyIntentResponse
     * @deprecated
     */
    'is_instruction': boolean;
}
/**
 * Per-route structured outputs from the classifier.  Only the field for the chosen route is populated; all other fields stay null. Adding a new route\'s structured output = adding a new optional field here.
 * @export
 * @interface ClassifyIntentRouteData
 */
export interface ClassifyIntentRouteData {
    /**
     * 
     * @type {TransformRouteData}
     * @memberof ClassifyIntentRouteData
     */
    'transform'?: TransformRouteData | null;
}
/**
 * Provider configs for the short-circuit and routing classify-intent calls.
 * @export
 * @interface ClassifyIntentRoutesConfig
 */
export interface ClassifyIntentRoutesConfig {
    /**
     * 
     * @type {DictationShortCircuitProvider}
     * @memberof ClassifyIntentRoutesConfig
     */
    'dictation_short_circuit_provider': DictationShortCircuitProvider;
    /**
     * 
     * @type {RouteProvider}
     * @memberof ClassifyIntentRoutesConfig
     */
    'route_provider': RouteProvider;
}
/**
 * A promo code summary row for the admin list view.
 * @export
 * @interface CodeListItem
 */
export interface CodeListItem {
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    'code': string;
    /**
     * 
     * @type {boolean}
     * @memberof CodeListItem
     */
    'is_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof CodeListItem
     */
    'max_redemptions': number | null;
    /**
     * 
     * @type {number}
     * @memberof CodeListItem
     */
    'total_redemptions': number;
    /**
     * 
     * @type {string}
     * @memberof CodeListItem
     */
    'created_at': string;
}
/**
 * A page of promo codes with a total count.
 * @export
 * @interface CodeListResponse
 */
export interface CodeListResponse {
    /**
     * 
     * @type {Array<CodeListItem>}
     * @memberof CodeListResponse
     */
    'codes': Array<CodeListItem>;
    /**
     * 
     * @type {number}
     * @memberof CodeListResponse
     */
    'total': number;
}
/**
 * Audio codec.
 * @export
 * @enum {string}
 */

export const Codec = {
    Opus: 'opus',
    Wav: 'wav',
    Aac: 'aac'
} as const;

export type Codec = typeof Codec[keyof typeof Codec];


/**
 * Command-mode request: an instruction to apply to selected text within the full text.
 * @export
 * @interface CommandModeRequest
 */
export interface CommandModeRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandModeRequest
     */
    'full_text': string;
    /**
     * 
     * @type {string}
     * @memberof CommandModeRequest
     */
    'selected_text': string;
    /**
     * 
     * @type {string}
     * @memberof CommandModeRequest
     */
    'instruction': string;
}
/**
 * Request to route a command-mode instruction (decide how to handle it) before executing.
 * @export
 * @interface CommandModeRouteRequest
 */
export interface CommandModeRouteRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandModeRouteRequest
     */
    'full_text': string;
    /**
     * 
     * @type {string}
     * @memberof CommandModeRouteRequest
     */
    'selected_text': string;
    /**
     * 
     * @type {string}
     * @memberof CommandModeRouteRequest
     */
    'instruction': string;
}
/**
 * Body to commit (execute) a billing operation against a cost center.
 * @export
 * @interface CommitRequest
 */
export interface CommitRequest {
    /**
     * Cost center the operation targets. Stripe customer/subscription artifacts are keyed on cost_center, not enterprise.
     * @type {string}
     * @memberof CommitRequest
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommitRequest
     */
    'operation_kind': string;
    /**
     * 
     * @type {object}
     * @memberof CommitRequest
     */
    'input': object;
    /**
     * Client-generated key (typically a UUID hex) mixed into every Stripe idempotency key emitted by this commit. The UI must generate it once per commit attempt and reuse it on retries so Stripe dedupes.
     * @type {string}
     * @memberof CommitRequest
     */
    'idempotency_root': string;
}
/**
 * Minimal commit ack — the op ran.  Stripe responses are surfaced so the UI can show what happened. No audit row is persisted; see the structured log line emitted by ``BillingOpsService.commit`` for the operational record.
 * @export
 * @interface CommitResponse
 */
export interface CommitResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CommitResponse
     */
    'ok'?: boolean;
    /**
     * 
     * @type {Array<object>}
     * @memberof CommitResponse
     */
    'stripe_responses': Array<object>;
}
/**
 * One version produced by the atomic changeset.
 * @export
 * @interface CommitVersion
 */
export interface CommitVersion {
    /**
     * 
     * @type {string}
     * @memberof CommitVersion
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof CommitVersion
     */
    'base_version': number | null;
    /**
     * 
     * @type {number}
     * @memberof CommitVersion
     */
    'version': number;
    /**
     * 
     * @type {boolean}
     * @memberof CommitVersion
     */
    'deleted': boolean;
}
/**
 * Chat-completion request with model, messages, sampling params, and optional tool definitions.
 * @export
 * @interface CompletionRequest
 */
export interface CompletionRequest {
    /**
     * Name of the model to use
     * @type {string}
     * @memberof CompletionRequest
     */
    'model': string;
    /**
     * Messages to send to the LLM
     * @type {Array<object>}
     * @memberof CompletionRequest
     */
    'messages': Array<object>;
    /**
     * Client type (OPENAI or FIREWORKS or OPENROUTER or OPENPIPE)
     * @type {string}
     * @memberof CompletionRequest
     */
    'client_type'?: string;
    /**
     * Sampling temperature
     * @type {number}
     * @memberof CompletionRequest
     */
    'temperature'?: number;
    /**
     * Maximum number of tokens
     * @type {number}
     * @memberof CompletionRequest
     */
    'max_tokens'?: number;
    /**
     * Nucleus sampling value
     * @type {number}
     * @memberof CompletionRequest
     */
    'top_p'?: number;
    /**
     * Penalty for frequency of tokens
     * @type {number}
     * @memberof CompletionRequest
     */
    'frequency_penalty'?: number;
    /**
     * Penalty for presence of tokens
     * @type {number}
     * @memberof CompletionRequest
     */
    'presence_penalty'?: number;
    /**
     * 
     * @type {Array<ToolCallDefinition>}
     * @memberof CompletionRequest
     */
    'tools'?: Array<ToolCallDefinition> | null;
    /**
     * UI surface that triggered this completion (observability tag only).
     * @type {SrcBackendServiceServicesLlmCostSource}
     * @memberof CompletionRequest
     */
    'source'?: SrcBackendServiceServicesLlmCostSource;
}


/**
 * @type Config
 * Client default; the backend routing policy for the surface may override it.
 * @export
 */
export type Config = { kind: 'anthropic_messages' } & WisprAgentAnthropicMessagesConfig | { kind: 'openai_responses' } & WisprAgentOpenAIResponsesConfig;

/**
 * 
 * @export
 * @interface ConnectionStatusResponse
 */
export interface ConnectionStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ConnectionStatusResponse
     */
    'connection_id': string;
    /**
     * 
     * @type {ConnectorStatus}
     * @memberof ConnectionStatusResponse
     */
    'status': ConnectorStatus;
    /**
     * 
     * @type {string}
     * @memberof ConnectionStatusResponse
     */
    'toolkit_slug': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectionStatusResponse
     */
    'incomplete_scopes'?: boolean;
    /**
     * Whether the stored grant can mutate calendar events. False for other connectors.
     * @type {boolean}
     * @memberof ConnectionStatusResponse
     */
    'has_write_scope'?: boolean;
    /**
     * Closed-vocabulary reason when this connection attempt failed.
     * @type {string}
     * @memberof ConnectionStatusResponse
     */
    'failure_reason'?: string | null;
}


/**
 * Envelope for a connector action send.  Handled outcomes, including enterprise-disabled connectors, return 200 with this body. ``error`` is a stable code on ``failed`` and ``unknown``. ``retry_after_s`` is set only when a throttled provider sent a ``Retry-After``; Gmail\'s quota 403 usually does not, so callers need their own default backoff. ``provider_ref`` holds the provider\'s ids for the written object and ``result_url`` links to it. ``reason`` is set only on a ``failed`` send the user can fix by connecting or reconnecting, or that their admin blocked; it is absent otherwise. ``result_reason`` is set on every ``failed`` and ``unknown`` send and absent on ``succeeded``.
 * @export
 * @interface ConnectorActionResponse
 */
export interface ConnectorActionResponse {
    /**
     * 
     * @type {ConnectorActionStatus}
     * @memberof ConnectorActionResponse
     */
    'status': ConnectorActionStatus;
    /**
     * 
     * @type {string}
     * @memberof ConnectorActionResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {ConnectorStatusReason}
     * @memberof ConnectorActionResponse
     */
    'reason'?: ConnectorStatusReason | null;
    /**
     * 
     * @type {ActionResultReason}
     * @memberof ConnectorActionResponse
     */
    'result_reason'?: ActionResultReason | null;
    /**
     * 
     * @type {number}
     * @memberof ConnectorActionResponse
     */
    'retry_after_s'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectorActionResponse
     */
    'result_url'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ConnectorActionResponse
     */
    'provider_ref'?: { [key: string]: string; } | null;
}


/**
 * Outcome of one provider write; ``unknown`` means the write may have landed and must not be resent blindly.
 * @export
 * @enum {string}
 */

export const ConnectorActionStatus = {
    Succeeded: 'succeeded',
    Failed: 'failed',
    Unknown: 'unknown'
} as const;

export type ConnectorActionStatus = typeof ConnectorActionStatus[keyof typeof ConnectorActionStatus];


/**
 * 
 * @export
 * @interface ConnectorInfo
 */
export interface ConnectorInfo {
    /**
     * 
     * @type {ConnectorKey}
     * @memberof ConnectorInfo
     */
    'key': ConnectorKey;
    /**
     * 
     * @type {string}
     * @memberof ConnectorInfo
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'connected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'has_credential'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'blocked_by_enterprise'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'incomplete_scopes'?: boolean;
    /**
     * Whether the stored grant can mutate calendar events. False for other connectors.
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'has_write_scope'?: boolean;
    /**
     * Whether the stored credential requires the user to reconnect.
     * @type {boolean}
     * @memberof ConnectorInfo
     */
    'needs_reauth'?: boolean;
    /**
     * Closed-vocabulary reason for the connector\'s current failure state.
     * @type {string}
     * @memberof ConnectorInfo
     */
    'failure_reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConnectorInfo
     */
    'connected_email'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorKey = {
    Calendar: 'calendar',
    Fireflies: 'fireflies',
    Github: 'github',
    Gmail: 'gmail',
    Linear: 'linear',
    Notion: 'notion',
    Outlook: 'outlook',
    Slack: 'slack',
    Wispr: 'wispr',
    Zoom: 'zoom'
} as const;

export type ConnectorKey = typeof ConnectorKey[keyof typeof ConnectorKey];


/**
 * 
 * @export
 * @enum {string}
 */

export const ConnectorStatus = {
    Pending: 'pending',
    Active: 'active',
    Failed: 'failed'
} as const;

export type ConnectorStatus = typeof ConnectorStatus[keyof typeof ConnectorStatus];


/**
 * Why a connector cannot act, as the action card names it; ``wrong_account`` is reserved: no send detects it.
 * @export
 * @enum {string}
 */

export const ConnectorStatusReason = {
    NotConnected: 'not_connected',
    InsufficientScope: 'insufficient_scope',
    Expired: 'expired',
    WrongAccount: 'wrong_account',
    AdminBlocked: 'admin_blocked'
} as const;

export type ConnectorStatusReason = typeof ConnectorStatusReason[keyof typeof ConnectorStatusReason];


/**
 * The list of connectors and their status for the user.
 * @export
 * @interface ConnectorsResponse
 */
export interface ConnectorsResponse {
    /**
     * 
     * @type {Array<ConnectorInfo>}
     * @memberof ConnectorsResponse
     */
    'connectors': Array<ConnectorInfo>;
}
/**
 * The implementation path that produced a preview result.
 * @export
 * @enum {string}
 */

export const ConsensusActualMode = {
    Anonymous: 'anonymous',
    Cluster: 'cluster',
    Segment: 'segment'
} as const;

export type ConsensusActualMode = typeof ConsensusActualMode[keyof typeof ConsensusActualMode];


/**
 * Explicit consensus implementation selection.
 * @export
 * @interface ConsensusPreviewRequest
 */
export interface ConsensusPreviewRequest {
    /**
     * 
     * @type {AlgorithmId}
     * @memberof ConsensusPreviewRequest
     */
    'algorithm_id': AlgorithmId;
}


/**
 * Ephemeral, non-persisted consensus preview result.
 * @export
 * @interface ConsensusPreviewResponse
 */
export interface ConsensusPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof ConsensusPreviewResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {AlgorithmId}
     * @memberof ConsensusPreviewResponse
     */
    'requested_algorithm_id': AlgorithmId;
    /**
     * 
     * @type {ConsensusActualMode}
     * @memberof ConsensusPreviewResponse
     */
    'consensus_mode': ConsensusActualMode;
    /**
     * 
     * @type {number}
     * @memberof ConsensusPreviewResponse
     */
    'algorithm_version': number;
    /**
     * 
     * @type {string}
     * @memberof ConsensusPreviewResponse
     */
    'reason'?: string | null;
    /**
     * 
     * @type {SignalQuality}
     * @memberof ConsensusPreviewResponse
     */
    'signal_quality': SignalQuality;
    /**
     * 
     * @type {object}
     * @memberof ConsensusPreviewResponse
     */
    'speaker_map'?: object | null;
    /**
     * 
     * @type {Array<TranscriptEntry>}
     * @memberof ConsensusPreviewResponse
     */
    'entries'?: Array<TranscriptEntry>;
}


/**
 * Why this row may hold Customer Data; ``NONE`` rows keep only the rating and note.
 * @export
 * @enum {string}
 */

export const ConsentBasis = {
    DisclosureV1: 'disclosure_v1',
    ShareDataElection: 'share_data_election',
    None: 'none'
} as const;

export type ConsentBasis = typeof ConsentBasis[keyof typeof ConsentBasis];


/**
 * A member\'s confirmation that consent was obtained before a Notetaker meeting starts.
 * @export
 * @interface ConsentConfirmRequest
 */
export interface ConsentConfirmRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsentConfirmRequest
     */
    'meeting_id'?: string | null;
}
/**
 * Acknowledgement of a recorded consent confirmation.
 * @export
 * @interface ConsentConfirmResponse
 */
export interface ConsentConfirmResponse {
    /**
     * 
     * @type {string}
     * @memberof ConsentConfirmResponse
     */
    'confirmed_at': string;
}
/**
 * Whether to post the consent chat notice, and when to ask again on wait.
 * @export
 * @interface ConsentNoticeClaimResponse
 */
export interface ConsentNoticeClaimResponse {
    /**
     * 
     * @type {ConsentNoticeDecision}
     * @memberof ConsentNoticeClaimResponse
     */
    'decision': ConsentNoticeDecision;
    /**
     * 
     * @type {ConsentNoticeReason}
     * @memberof ConsentNoticeClaimResponse
     */
    'reason': ConsentNoticeReason;
    /**
     * 
     * @type {number}
     * @memberof ConsentNoticeClaimResponse
     */
    'retry_after_ms'?: number | null;
}


/**
 * Acknowledgement of a posted consent chat notice.
 * @export
 * @interface ConsentNoticeConfirmResponse
 */
export interface ConsentNoticeConfirmResponse {
    /**
     * 
     * @type {ConsentNoticeConfirmResult}
     * @memberof ConsentNoticeConfirmResponse
     */
    'result': ConsentNoticeConfirmResult;
}


/**
 * Outcome of recording that a consent chat notice was posted.
 * @export
 * @enum {string}
 */

export const ConsentNoticeConfirmResult = {
    Confirmed: 'confirmed',
    NotApplicable: 'not_applicable',
    Unavailable: 'unavailable'
} as const;

export type ConsentNoticeConfirmResult = typeof ConsentNoticeConfirmResult[keyof typeof ConsentNoticeConfirmResult];


/**
 * Whether the caller should post the consent chat notice now.
 * @export
 * @enum {string}
 */

export const ConsentNoticeDecision = {
    Post: 'post',
    Skip: 'skip',
    Wait: 'wait'
} as const;

export type ConsentNoticeDecision = typeof ConsentNoticeDecision[keyof typeof ConsentNoticeDecision];


/**
 * Why a consent-notice claim got its decision.
 * @export
 * @enum {string}
 */

export const ConsentNoticeReason = {
    Claimed: 'claimed',
    OwnClaim: 'own_claim',
    PeerPosted: 'peer_posted',
    PeerPending: 'peer_pending',
    NotEnforced: 'not_enforced',
    NoScope: 'no_scope',
    NoIdentity: 'no_identity',
    Unavailable: 'unavailable'
} as const;

export type ConsentNoticeReason = typeof ConsentNoticeReason[keyof typeof ConsentNoticeReason];


/**
 * Whether the caller\'s pending consent-notice claim was released for colleagues to take.
 * @export
 * @interface ConsentNoticeReleaseResponse
 */
export interface ConsentNoticeReleaseResponse {
    /**
     * 
     * @type {ConsentNoticeReleaseResult}
     * @memberof ConsentNoticeReleaseResponse
     */
    'result': ConsentNoticeReleaseResult;
}


/**
 * Outcome of giving up a pending consent-notice claim that ended without a posted notice.
 * @export
 * @enum {string}
 */

export const ConsentNoticeReleaseResult = {
    Released: 'released',
    NotHeld: 'not_held',
    NotApplicable: 'not_applicable',
    Unavailable: 'unavailable'
} as const;

export type ConsentNoticeReleaseResult = typeof ConsentNoticeReleaseResult[keyof typeof ConsentNoticeReleaseResult];


/**
 * One consent chat notice attempt for a calendar event the caller joined.
 * @export
 * @interface ConsentNoticeRequest
 */
export interface ConsentNoticeRequest {
    /**
     * Generated by the client once per notice send attempt.
     * @type {string}
     * @memberof ConsentNoticeRequest
     */
    'claim_id': string;
    /**
     * The caller\'s own calendar event id for the meeting being recorded.
     * @type {string}
     * @memberof ConsentNoticeRequest
     */
    'calendar_external_id': string;
}
/**
 * Request model for contacting enterprise admins.
 * @export
 * @interface ContactAdminRequest
 */
export interface ContactAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactAdminRequest
     */
    'invite_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactAdminRequest
     */
    'message': string;
}
/**
 * Response model for contact admin endpoint.
 * @export
 * @interface ContactAdminResponse
 */
export interface ContactAdminResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactAdminResponse
     */
    'message': string;
}
/**
 * Contact IDs to resolve for the authenticated owner.
 * @export
 * @interface ContactBatchRequest
 */
export interface ContactBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactBatchRequest
     */
    'contactIds': Array<string>;
}
/**
 * Visible contacts resolved from a batch of requested IDs.
 * @export
 * @interface ContactBatchResponse
 */
export interface ContactBatchResponse {
    /**
     * 
     * @type {Array<ContactDetailResponse>}
     * @memberof ContactBatchResponse
     */
    'contacts': Array<ContactDetailResponse>;
}
/**
 * The user-provided details for a contact.
 * @export
 * @interface ContactCreateRequest
 */
export interface ContactCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContactCreateRequest
     */
    'email'?: string | null;
}
/**
 * A contact with optional professional metadata from existing enrichment data.
 * @export
 * @interface ContactDetailResponse
 */
export interface ContactDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'nameSource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactDetailResponse
     */
    'isSelf'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'jobTitle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactDetailResponse
     */
    'linkedInUrl'?: string | null;
}
/**
 * A contact and the metadata needed by People surfaces.
 * @export
 * @interface ContactResponse
 */
export interface ContactResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ContactResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactResponse
     */
    'nameSource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactResponse
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactResponse
     */
    'isSelf'?: boolean;
}
/**
 * One page of contacts ordered for the People search feed.
 * @export
 * @interface ContactSearchResponse
 */
export interface ContactSearchResponse {
    /**
     * 
     * @type {Array<ContactSearchResult>}
     * @memberof ContactSearchResponse
     */
    'contacts': Array<ContactSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSearchResponse
     */
    'hasMore': boolean;
}
/**
 * A contact annotated with calendar invitation evidence.
 * @export
 * @interface ContactSearchResult
 */
export interface ContactSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ContactSearchResult
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ContactSearchResult
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactSearchResult
     */
    'nameSource'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSearchResult
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSearchResult
     */
    'email'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSearchResult
     */
    'isSelf'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContactSearchResult
     */
    'is_invited': boolean;
    /**
     * Keep shipped contact pickers readable during client-first deployment.
     * @type {boolean}
     * @memberof ContactSearchResult
     * @deprecated
     */
    'isInMeeting': boolean;
}
/**
 * Editable details for one owned contact.
 * @export
 * @interface ContactUpdateRequest
 */
export interface ContactUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateRequest
     */
    'displayName'?: string;
}
/**
 * A named document passed to / returned from the transform endpoint.  ``read_only_content`` items are grounding the model reads but never outputs; ``editable_content`` items are documents the model may rewrite or append to (and are returned, updated, keyed by ``name``). ``description`` is the per-document prompting hook — it tells the model what the document is and what to include/exclude in the output (e.g. \"this is the title, don\'t repeat it as a heading in the body\").
 * @export
 * @interface Content
 */
export interface Content {
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    'content': string;
}
/**
 * Contextual signals (app, screen, dictionary, conversation) that steer formatting.
 * @export
 * @interface Context
 */
export interface Context {
    /**
     * 
     * @type {App}
     * @memberof Context
     */
    'app'?: App | null;
    /**
     * List of words from accessibility context
     * @type {Array<string>}
     * @memberof Context
     */
    'ax_context'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Context
     */
    'variable_names'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Context
     */
    'file_names'?: Array<string> | null;
    /**
     * List of names extracted from user screen content
     * @type {Array<string>}
     * @memberof Context
     */
    'ocr_context'?: Array<string>;
    /**
     * List of names in the user\'s dictionary
     * @type {Array<string>}
     * @memberof Context
     */
    'dictionary_context'?: Array<string>;
    /**
     * Mapping for replacing phrases/snippets in the user\'s dictionary
     * @type {{ [key: string]: string; }}
     * @memberof Context
     */
    'dictionary_replacements'?: { [key: string]: string; };
    /**
     * Mapping of stripped snippet triggers to full triggers
     * @type {{ [key: string]: Array<string>; }}
     * @memberof Context
     */
    'dictionary_snippets'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'user_identifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'user_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'user_last_name'?: string | null;
    /**
     * 
     * @type {TextboxContents}
     * @memberof Context
     */
    'textbox_contents'?: TextboxContents | null;
    /**
     * 
     * @type {File}
     * @memberof Context
     */
    'screenshot'?: File | null;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'content_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Context
     */
    'content_html'?: string | null;
    /**
     * 
     * @type {Conversation}
     * @memberof Context
     */
    'conversation'?: Conversation | null;
    /**
     * List of all applications (names, bundle IDs, URLs) used for dictation in this session
     * @type {Array<string>}
     * @memberof Context
     */
    'session_dictation_apps'?: Array<string>;
}
/**
 * Lineage required to decide whether a learned component is eligible.  ``source`` and ``object_id`` are snapshot at publication, so the cited source\'s authority is rechecked after its Inbox row expires; a citation without them authorizes nothing. Evidence is written by the server from the Inbox row it cites and is never accepted from a client.
 * @export
 * @interface ContextEvidence
 */
export interface ContextEvidence {
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'event_at': string;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'recorded_at': string;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'meeting_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'source_revision': string;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContextEvidence
     */
    'object_id'?: string | null;
}
/**
 * Aggregated dictation stats for a single application/domain context.
 * @export
 * @interface ContextStatsItem
 */
export interface ContextStatsItem {
    /**
     * 
     * @type {string}
     * @memberof ContextStatsItem
     */
    'domain': string;
    /**
     * 
     * @type {number}
     * @memberof ContextStatsItem
     */
    'total_words': number;
    /**
     * 
     * @type {string}
     * @memberof ContextStatsItem
     */
    'first_dictation_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContextStatsItem
     */
    'last_dictation_at'?: string | null;
}
/**
 * Per-context dictation stats for the current user.
 * @export
 * @interface ContextStatsResponse
 */
export interface ContextStatsResponse {
    /**
     * 
     * @type {Array<ContextStatsItem>}
     * @memberof ContextStatsResponse
     */
    'contexts': Array<ContextStatsItem>;
}
/**
 * Conversation history supplied as context for a dictation.
 * @export
 * @interface Conversation
 */
export interface Conversation {
    /**
     * Identifier of the conversation
     * @type {string}
     * @memberof Conversation
     */
    'id': string;
    /**
     * List of participants in the conversation
     * @type {Array<string>}
     * @memberof Conversation
     */
    'participants'?: Array<string>;
    /**
     * List of messages in the conversation
     * @type {Array<ChatMessage>}
     * @memberof Conversation
     */
    'messages'?: Array<ChatMessage>;
}
/**
 * A cost center with additional Stripe and billing-cycle detail.
 * @export
 * @interface CostCenterDetailResponse
 */
export interface CostCenterDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'billing_owner_user_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterDetailResponse
     */
    'num_seats': number | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterDetailResponse
     */
    'plan_ends_at': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CostCenterDetailResponse
     */
    'cancel_at_period_end': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'created_at': string;
    /**
     * 
     * @type {BillingProvider}
     * @memberof CostCenterDetailResponse
     */
    'billing_provider': BillingProvider;
    /**
     * 
     * @type {number}
     * @memberof CostCenterDetailResponse
     */
    'team_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'stripe_customer_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'stripe_subscription_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterDetailResponse
     */
    'seats_current_cycle': number | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'past_due_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterDetailResponse
     */
    'pilot_end': string | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterDetailResponse
     */
    'cancel_at': number | null;
}


/**
 * One row in the cost-center picker the operator UI renders.  ``name`` comes from ``CostCenter.name`` (default ``\"Default\"`` for legacy single-CC enterprises). ``status`` is the cost_center.status string (``active``, ``inactive``, ``trialing``, ``past_due``, etc.). The Stripe ids surface so the UI can show whether a cost_center has been wired up to Stripe before letting an operator queue an op against it.
 * @export
 * @interface CostCenterListItem
 */
export interface CostCenterListItem {
    /**
     * 
     * @type {string}
     * @memberof CostCenterListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterListItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterListItem
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterListItem
     */
    'stripe_customer_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterListItem
     */
    'stripe_subscription_id': string | null;
    /**
     * Whether this is the enterprise\'s General team cost center.
     * @type {boolean}
     * @memberof CostCenterListItem
     */
    'is_general'?: boolean;
}
/**
 * A list of cost centers for an enterprise.
 * @export
 * @interface CostCenterListResponse
 */
export interface CostCenterListResponse {
    /**
     * 
     * @type {Array<CostCenterResponse>}
     * @memberof CostCenterListResponse
     */
    'cost_centers': Array<CostCenterResponse>;
}
/**
 * A cost center\'s core billing and membership fields.
 * @export
 * @interface CostCenterResponse
 */
export interface CostCenterResponse {
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'billing_owner_user_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterResponse
     */
    'num_seats': number | null;
    /**
     * 
     * @type {number}
     * @memberof CostCenterResponse
     */
    'plan_ends_at': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CostCenterResponse
     */
    'cancel_at_period_end': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CostCenterResponse
     */
    'created_at': string;
    /**
     * 
     * @type {BillingProvider}
     * @memberof CostCenterResponse
     */
    'billing_provider': BillingProvider;
    /**
     * 
     * @type {number}
     * @memberof CostCenterResponse
     */
    'team_count'?: number;
}


/**
 * Set one member\'s seat type, with capacity allocated automatically.
 * @export
 * @interface CostCenterSeatChange
 */
export interface CostCenterSeatChange {
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChange
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChange
     */
    'seat_type': CostCenterSeatChangeSeatTypeEnum;
}

export const CostCenterSeatChangeSeatTypeEnum = {
    Dictation: 'dictation',
    Bundle: 'bundle'
} as const;

export type CostCenterSeatChangeSeatTypeEnum = typeof CostCenterSeatChangeSeatTypeEnum[keyof typeof CostCenterSeatChangeSeatTypeEnum];

/**
 * A rejected seat change or conflicting reuse of a recorded request UUID.
 * @export
 * @interface CostCenterSeatChangeConflictDetail
 */
export interface CostCenterSeatChangeConflictDetail {
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChangeConflictDetail
     */
    'code': CostCenterSeatChangeConflictDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChangeConflictDetail
     */
    'message': string;
}

export const CostCenterSeatChangeConflictDetailCodeEnum = {
    RequestIdReused: 'request_id_reused',
    SeatChangeRejected: 'seat_change_rejected'
} as const;

export type CostCenterSeatChangeConflictDetailCodeEnum = typeof CostCenterSeatChangeConflictDetailCodeEnum[keyof typeof CostCenterSeatChangeConflictDetailCodeEnum];

/**
 * The HTTP 409 envelope for a seat-change conflict.
 * @export
 * @interface CostCenterSeatChangeConflictResponse
 */
export interface CostCenterSeatChangeConflictResponse {
    /**
     * 
     * @type {CostCenterSeatChangeConflictDetail}
     * @memberof CostCenterSeatChangeConflictResponse
     */
    'detail': CostCenterSeatChangeConflictDetail;
}
/**
 * An unknown acceptance outcome requiring the same request UUID and changes.
 * @export
 * @interface CostCenterSeatChangeUnavailableDetail
 */
export interface CostCenterSeatChangeUnavailableDetail {
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChangeUnavailableDetail
     */
    'code': CostCenterSeatChangeUnavailableDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof CostCenterSeatChangeUnavailableDetail
     */
    'message': string;
}

export const CostCenterSeatChangeUnavailableDetailCodeEnum = {
    SeatChangeOutcomeUnknown: 'seat_change_outcome_unknown'
} as const;

export type CostCenterSeatChangeUnavailableDetailCodeEnum = typeof CostCenterSeatChangeUnavailableDetailCodeEnum[keyof typeof CostCenterSeatChangeUnavailableDetailCodeEnum];

/**
 * The HTTP 503 envelope for an unknown seat-change outcome.
 * @export
 * @interface CostCenterSeatChangeUnavailableResponse
 */
export interface CostCenterSeatChangeUnavailableResponse {
    /**
     * 
     * @type {CostCenterSeatChangeUnavailableDetail}
     * @memberof CostCenterSeatChangeUnavailableResponse
     */
    'detail': CostCenterSeatChangeUnavailableDetail;
}
/**
 * Request body for creating an organization API key.
 * @export
 * @interface CreateAPIKeyRequest
 */
export interface CreateAPIKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAPIKeyRequest
     */
    'name': string;
}
/**
 * Request to create a promo campaign.
 * @export
 * @interface CreateCampaignRequest
 */
export interface CreateCampaignRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'name': string;
    /**
     * 
     * @type {CampaignType}
     * @memberof CreateCampaignRequest
     */
    'campaign_type'?: CampaignType;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    'trial_days': number;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'source_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'attribution_message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignRequest
     */
    'max_redemptions'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'starts_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignRequest
     */
    'description'?: string | null;
}


/**
 * Request to create one or more promo codes for a campaign.
 * @export
 * @interface CreateCodesRequest
 */
export interface CreateCodesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCodesRequest
     */
    'codes': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CreateCodesRequest
     */
    'max_redemptions'?: number | null;
}
/**
 * Result of creating promo codes: count and the created rows.
 * @export
 * @interface CreateCodesResponse
 */
export interface CreateCodesResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateCodesResponse
     */
    'created_count': number;
    /**
     * 
     * @type {Array<CodeListItem>}
     * @memberof CreateCodesResponse
     */
    'created_codes': Array<CodeListItem>;
}
/**
 * @type CreateContact422Response
 * @export
 */
export type CreateContact422Response = CreateContact422ResponseOneOf | HTTPValidationError;

/**
 * 
 * @export
 * @interface CreateContact422ResponseOneOf
 */
export interface CreateContact422ResponseOneOf {
    /**
     * 
     * @type {string}
     * @memberof CreateContact422ResponseOneOf
     */
    'detail': string;
}
/**
 * Add the caller\'s meetings with someone from one email domain to a folder, as they sync.
 * @export
 * @interface CreateDomainRuleRequest
 */
export interface CreateDomainRuleRequest {
    /**
     * One of the caller\'s meetings whose outside attendees with a work address all share `domain`.
     * @type {string}
     * @memberof CreateDomainRuleRequest
     */
    'anchor_meeting_id': string;
    /**
     * The `rule_domain` adding the anchor to a folder returned.
     * @type {string}
     * @memberof CreateDomainRuleRequest
     */
    'domain': string;
    /**
     * Also add the caller\'s existing meetings with the domain, newest first, up to 500.
     * @type {boolean}
     * @memberof CreateDomainRuleRequest
     */
    'include_past'?: boolean;
}
/**
 * The domain rule, and what adding the caller\'s existing meetings with the domain did just now.
 * @export
 * @interface CreateDomainRuleResponse
 */
export interface CreateDomainRuleResponse {
    /**
     * 
     * @type {MeetingRule}
     * @memberof CreateDomainRuleResponse
     */
    'rule': MeetingRule;
    /**
     * False when the caller already held this rule; nothing is added then.
     * @type {boolean}
     * @memberof CreateDomainRuleResponse
     */
    'created': boolean;
    /**
     * Existing meetings with the domain this request newly added.
     * @type {Array<string>}
     * @memberof CreateDomainRuleResponse
     */
    'added_meeting_ids'?: Array<string>;
    /**
     * Existing meetings with the domain that could not be added.
     * @type {number}
     * @memberof CreateDomainRuleResponse
     */
    'failed_count'?: number;
    /**
     * True when the domain had more candidate meetings than one request checks, so some may be left out.
     * @type {boolean}
     * @memberof CreateDomainRuleResponse
     */
    'capped'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateEnterpriseCheckoutRequest
 */
export interface CreateEnterpriseCheckoutRequest {
    /**
     * 
     * @type {StripeProductOption}
     * @memberof CreateEnterpriseCheckoutRequest
     */
    'plan': StripeProductOption;
    /**
     * 
     * @type {number}
     * @memberof CreateEnterpriseCheckoutRequest
     */
    'seats': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnterpriseCheckoutRequest
     */
    'add_billing_info'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterpriseCheckoutRequest
     */
    'variant'?: CreateEnterpriseCheckoutRequestVariantEnum | null;
}

export const CreateEnterpriseCheckoutRequestVariantEnum = {
    Bundle: 'bundle',
    DictationOnly: 'dictation_only'
} as const;

export type CreateEnterpriseCheckoutRequestVariantEnum = typeof CreateEnterpriseCheckoutRequestVariantEnum[keyof typeof CreateEnterpriseCheckoutRequestVariantEnum];

/**
 * Request model for creating an enterprise with an admin user.
 * @export
 * @interface CreateEnterpriseFromAdminRequest
 */
export interface CreateEnterpriseFromAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'admin_email': string;
    /**
     * Domain cannot be empty
     * @type {string}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'enterprise_domain': string;
    /**
     * Name cannot be empty
     * @type {string}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'enterprise_name': string;
    /**
     * If true, seats are never automatically reduced
     * @type {boolean}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'preserve_contracted_seats'?: boolean;
    /**
     * 
     * @type {BillingInfo}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'billing_info'?: BillingInfo | null;
    /**
     * If true and admin_email has no Wispr user, provision one (requires admin_first_name and admin_last_name).
     * @type {boolean}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'create_admin_user_if_missing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'admin_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterpriseFromAdminRequest
     */
    'admin_last_name'?: string | null;
}
/**
 * Request model for creating an enterprise pilot.
 * @export
 * @interface CreateEnterprisePilotRequest
 */
export interface CreateEnterprisePilotRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEnterprisePilotRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterprisePilotRequest
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterprisePilotRequest
     */
    'enterprise_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnterprisePilotRequest
     */
    'trial_end': string;
    /**
     * Seat type new members get when their invitation doesn\'t pick one. Ignored for an existing org.
     * @type {SeatType}
     * @memberof CreateEnterprisePilotRequest
     */
    'default_seat_type'?: SeatType;
}


/**
 * Payload to create a new enterprise.
 * @export
 * @interface CreateEnterpriseRequestNew
 */
export interface CreateEnterpriseRequestNew {
    /**
     * 
     * @type {string}
     * @memberof CreateEnterpriseRequestNew
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnterpriseRequestNew
     */
    'autoInviteUsers'?: boolean;
}
/**
 * Create a folder.
 * @export
 * @interface CreateFolderRequest
 */
export interface CreateFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFolderRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFolderRequest
     */
    'description'?: string | null;
}
/**
 * The created folder.
 * @export
 * @interface CreateFolderResponse
 */
export interface CreateFolderResponse {
    /**
     * 
     * @type {FolderSummary}
     * @memberof CreateFolderResponse
     */
    'folder': FolderSummary;
}
/**
 * Add an upcoming calendar event\'s meeting to a folder.
 * @export
 * @interface CreateMeetingRuleRequest
 */
export interface CreateMeetingRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMeetingRuleRequest
     */
    'kind': CreateMeetingRuleRequestKindEnum;
    /**
     * The event\'s Flow Event Key (`calendar_external_id`), or a series rule\'s `match_value` as listed; never a path segment, as Microsoft keys break paths.
     * @type {string}
     * @memberof CreateMeetingRuleRequest
     */
    'match_value': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMeetingRuleRequest
     */
    'ends_at'?: string | null;
}

export const CreateMeetingRuleRequestKindEnum = {
    CalendarEvent: 'calendar_event'
} as const;

export type CreateMeetingRuleRequestKindEnum = typeof CreateMeetingRuleRequestKindEnum[keyof typeof CreateMeetingRuleRequestKindEnum];

/**
 * The rule, and which of the caller\'s existing meetings it added just now.
 * @export
 * @interface CreateMeetingRuleResponse
 */
export interface CreateMeetingRuleResponse {
    /**
     * 
     * @type {MeetingRule}
     * @memberof CreateMeetingRuleResponse
     */
    'rule': MeetingRule;
    /**
     * False when the caller already held this live rule.
     * @type {boolean}
     * @memberof CreateMeetingRuleResponse
     */
    'created': boolean;
    /**
     * Existing meetings with the key this request newly added.
     * @type {Array<string>}
     * @memberof CreateMeetingRuleResponse
     */
    'added_meeting_ids'?: Array<string>;
}
/**
 * Request body for creating a platform organization.
 * @export
 * @interface CreateOrgRequest
 */
export interface CreateOrgRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrgRequest
     */
    'name': string;
}
/**
 * Request model for the superadmin-only custom-billing sales-led path.  Adds `custom_billing_config` as a required field — the dedicated subclass surfaces the auth escalation in the route signature and OpenAPI rather than hiding it behind a runtime branch.
 * @export
 * @interface CreateSalesLedEnterpriseCustomBillingRequest
 */
export interface CreateSalesLedEnterpriseCustomBillingRequest {
    /**
     * `stripe` (default): Stripe subscription with deferred invoicing. `sales_owned`: no Stripe records; access granted by a live cost center, billing owned in Salesforce. `sequence` is not accepted.
     * @type {BillingProvider}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'billing_provider'?: BillingProvider;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'email': string;
    /**
     * Enterprise domain
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'domain': string;
    /**
     * Enterprise name
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'enterprise_name': string;
    /**
     * 
     * @type {StripeProductOption}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'plan'?: StripeProductOption | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'sku'?: CreateSalesLedEnterpriseCustomBillingRequestSkuEnum | null;
    /**
     * Number of seats
     * @type {number}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'seats': number;
    /**
     * 
     * @type {SeatType}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'default_seat_type'?: SeatType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'seat_cap'?: number | null;
    /**
     * Platform fee rate in $/month. For yearly plans, charged as 12x upfront. Must match a configured Stripe price. Ignored for sales_owned.
     * @type {number}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'platform_fee_monthly_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'days_until_due'?: number | null;
    /**
     * If true, seats are never automatically reduced
     * @type {boolean}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'preserve_contracted_seats'?: boolean;
    /**
     * 
     * @type {BillingInfo}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'billing_info'?: BillingInfo | null;
    /**
     * If true and email has no Wispr user, provision one (requires admin_first_name and admin_last_name).
     * @type {boolean}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'create_admin_user_if_missing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'admin_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'admin_last_name'?: string | null;
    /**
     * Negotiated per-seat pricing. Creates an EnterpriseBillingConfig row and attaches a custom Stripe Price to the subscription so renewals bill at the negotiated rate. Requires superadmin role.
     * @type {CustomBillingConfigInput}
     * @memberof CreateSalesLedEnterpriseCustomBillingRequest
     */
    'custom_billing_config': CustomBillingConfigInput;
}

export const CreateSalesLedEnterpriseCustomBillingRequestSkuEnum = {
    EnterpriseDictation: 'enterprise_dictation',
    EnterpriseNotetaker: 'enterprise_notetaker',
    EnterpriseBundle: 'enterprise_bundle'
} as const;

export type CreateSalesLedEnterpriseCustomBillingRequestSkuEnum = typeof CreateSalesLedEnterpriseCustomBillingRequestSkuEnum[keyof typeof CreateSalesLedEnterpriseCustomBillingRequestSkuEnum];

/**
 * Request model for creating a sales-led enterprise.  ``billing_provider=stripe`` (default) provisions a deferred-invoicing Stripe subscription. ``billing_provider=sales_owned`` provisions access only: the General cost center goes live with no Stripe customer/subscription/price; the contract and invoicing stay in Salesforce.
 * @export
 * @interface CreateSalesLedEnterpriseRequest
 */
export interface CreateSalesLedEnterpriseRequest {
    /**
     * `stripe` (default): Stripe subscription with deferred invoicing. `sales_owned`: no Stripe records; access granted by a live cost center, billing owned in Salesforce. `sequence` is not accepted.
     * @type {BillingProvider}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'billing_provider'?: BillingProvider;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'email': string;
    /**
     * Enterprise domain
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'domain': string;
    /**
     * Enterprise name
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'enterprise_name': string;
    /**
     * 
     * @type {StripeProductOption}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'plan'?: StripeProductOption | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'sku'?: CreateSalesLedEnterpriseRequestSkuEnum | null;
    /**
     * Number of seats
     * @type {number}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'seats': number;
    /**
     * 
     * @type {SeatType}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'default_seat_type'?: SeatType | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'seat_cap'?: number | null;
    /**
     * Platform fee rate in $/month. For yearly plans, charged as 12x upfront. Must match a configured Stripe price. Ignored for sales_owned.
     * @type {number}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'platform_fee_monthly_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'days_until_due'?: number | null;
    /**
     * If true, seats are never automatically reduced
     * @type {boolean}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'preserve_contracted_seats'?: boolean;
    /**
     * 
     * @type {BillingInfo}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'billing_info'?: BillingInfo | null;
    /**
     * If true and email has no Wispr user, provision one (requires admin_first_name and admin_last_name).
     * @type {boolean}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'create_admin_user_if_missing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'admin_first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseRequest
     */
    'admin_last_name'?: string | null;
}

export const CreateSalesLedEnterpriseRequestSkuEnum = {
    EnterpriseDictation: 'enterprise_dictation',
    EnterpriseNotetaker: 'enterprise_notetaker',
    EnterpriseBundle: 'enterprise_bundle'
} as const;

export type CreateSalesLedEnterpriseRequestSkuEnum = typeof CreateSalesLedEnterpriseRequestSkuEnum[keyof typeof CreateSalesLedEnterpriseRequestSkuEnum];

/**
 * Response model for creating a sales-led enterprise.
 * @export
 * @interface CreateSalesLedEnterpriseResponse
 */
export interface CreateSalesLedEnterpriseResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSalesLedEnterpriseResponse
     */
    'message': string;
}
/**
 * Request model for creating a sandbox user.
 * @export
 * @interface CreateSandboxUserRequest
 */
export interface CreateSandboxUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSandboxUserRequest
     */
    'plan'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSandboxUserRequest
     */
    'billing_interval'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSandboxUserRequest
     */
    'skip_default_trial'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSandboxUserRequest
     */
    'bonus_ends_at'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSandboxUserRequest
     */
    'words_this_week'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSandboxUserRequest
     */
    'first_weekly_limit_hit_at'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSandboxUserRequest
     */
    'is_student'?: boolean | null;
}
/**
 * Response model for sandbox user creation.
 * @export
 * @interface CreateSandboxUserResponse
 */
export interface CreateSandboxUserResponse {
    /**
     * Access token for authentication
     * @type {string}
     * @memberof CreateSandboxUserResponse
     */
    'access_token': string;
    /**
     * Refresh token
     * @type {string}
     * @memberof CreateSandboxUserResponse
     */
    'refresh_token': string;
    /**
     * The sandbox user\'s email
     * @type {string}
     * @memberof CreateSandboxUserResponse
     */
    'email': string;
    /**
     * The sandbox user\'s ID
     * @type {string}
     * @memberof CreateSandboxUserResponse
     */
    'user_id': string;
    /**
     * The sandbox user\'s password (use with email to sign into client apps)
     * @type {string}
     * @memberof CreateSandboxUserResponse
     */
    'password': string;
}
/**
 * Add the caller\'s meetings in an anchor\'s recurring series to a folder, now and as they sync.
 * @export
 * @interface CreateSeriesRuleRequest
 */
export interface CreateSeriesRuleRequest {
    /**
     * 
     * @type {SeriesRuleAnchor}
     * @memberof CreateSeriesRuleRequest
     */
    'anchor': SeriesRuleAnchor;
    /**
     * `all`: every occurrence, past and future. `from_this`: the anchor\'s occurrence and every later one.
     * @type {string}
     * @memberof CreateSeriesRuleRequest
     */
    'scope': CreateSeriesRuleRequestScopeEnum;
}

export const CreateSeriesRuleRequestScopeEnum = {
    All: 'all',
    FromThis: 'from_this'
} as const;

export type CreateSeriesRuleRequestScopeEnum = typeof CreateSeriesRuleRequestScopeEnum[keyof typeof CreateSeriesRuleRequestScopeEnum];

/**
 * The series rule, and what adding the caller\'s existing meetings in the series did just now.
 * @export
 * @interface CreateSeriesRuleResponse
 */
export interface CreateSeriesRuleResponse {
    /**
     * 
     * @type {MeetingRule}
     * @memberof CreateSeriesRuleResponse
     */
    'rule': MeetingRule;
    /**
     * False when the caller already held this live rule; meetings are then added only if this request moved its start earlier.
     * @type {boolean}
     * @memberof CreateSeriesRuleResponse
     */
    'created': boolean;
    /**
     * Existing meetings in the series this request newly added.
     * @type {Array<string>}
     * @memberof CreateSeriesRuleResponse
     */
    'added_meeting_ids'?: Array<string>;
    /**
     * Existing meetings in the series that could not be added.
     * @type {number}
     * @memberof CreateSeriesRuleResponse
     */
    'failed_count'?: number;
    /**
     * True when more existing meetings matched than one request adds, so some were left out.
     * @type {boolean}
     * @memberof CreateSeriesRuleResponse
     */
    'capped'?: boolean;
}
/**
 * Create a user or, with ``scope``, a team skill under a client-minted id; a replay returns the stored skill.
 * @export
 * @interface CreateSkillRequest
 */
export interface CreateSkillRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSkillRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSkillRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSkillRequest
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSkillRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSkillRequest
     */
    'instructions': string;
    /**
     * Defaults to every context.
     * @type {Array<SkillContext>}
     * @memberof CreateSkillRequest
     */
    'contexts'?: Array<SkillContext>;
    /**
     * 
     * @type {SkillScope}
     * @memberof CreateSkillRequest
     */
    'scope'?: SkillScope | null;
}


/**
 * Request payload for creating a single shared dictionary item.  Scope selector: omit ``enterprise_id`` → the caller\'s team; set it → org-wide row. A create can only ever target the caller\'s own team, so there is no team id on the wire — it is server-derived from the caller\'s membership.
 * @export
 * @interface CreateTeamDictionaryItem
 */
export interface CreateTeamDictionaryItem {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'replacement_html'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeamDictionaryItem
     */
    'is_manual': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTeamDictionaryItem
     */
    'frequency_used': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'last_used'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'source': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeamDictionaryItem
     */
    'is_snippet': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamDictionaryItem
     */
    'enterprise_id'?: string | null;
}
/**
 * Outcome of creating one shared dictionary entry.  ``pending`` is the whole reason this is an object rather than a bare boolean: 200 already means \"revived a soft-deleted row\" and 201 \"inserted\", so neither code is free to also mean \"stored but live nowhere\".
 * @export
 * @interface CreateTeamDictionaryResult
 */
export interface CreateTeamDictionaryResult {
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeamDictionaryResult
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeamDictionaryResult
     */
    'pending'?: boolean;
}
/**
 * Create a team, optionally migrating members and handing off the old team.
 * @export
 * @interface CreateTeamRequest
 */
export interface CreateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTeamRequest
     */
    'member_user_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTeamRequest
     */
    'successor_admin_email'?: string | null;
}
/**
 * Request body for inviting one or more users to an organization with a given role.
 * @export
 * @interface CreateUserInviteRequest
 */
export interface CreateUserInviteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserInviteRequest
     */
    'emails': Array<string>;
    /**
     * 
     * @type {Role}
     * @memberof CreateUserInviteRequest
     */
    'role': Role;
}


/**
 * Minimal user-creation payload (email and name).
 * @export
 * @interface CreateUserRequest
 */
export interface CreateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserRequest
     */
    'last_name': string;
}
/**
 * Supported billing currencies as lowercase ISO 4217 codes.
 * @export
 * @enum {string}
 */

export const Currency = {
    Usd: 'usd',
    Gbp: 'gbp',
    Eur: 'eur',
    Inr: 'inr',
    Cad: 'cad',
    Cny: 'cny',
    Aud: 'aud',
    Rub: 'rub',
    Pln: 'pln',
    Brl: 'brl',
    Ils: 'ils',
    Try: 'try',
    Jpy: 'jpy',
    Chf: 'chf',
    Mxn: 'mxn',
    Aed: 'aed',
    Sek: 'sek',
    Sgd: 'sgd',
    Zar: 'zar',
    Nzd: 'nzd',
    Thb: 'thb',
    Twd: 'twd',
    Czk: 'czk',
    Krw: 'krw'
} as const;

export type Currency = typeof Currency[keyof typeof Currency];


/**
 * Pricing for all Flow products in a single currency.
 * @export
 * @interface CurrencyPricingResponse
 */
export interface CurrencyPricingResponse {
    /**
     * 
     * @type {string}
     * @memberof CurrencyPricingResponse
     */
    'currency': string;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_PRO_MONTHLY': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_PRO_YEARLY': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_STUDENT_MONTHLY': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_STUDENT_YEARLY': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_BUSINESS_MONTHLY': ProductPricingResponse;
    /**
     * 
     * @type {ProductPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'FLOW_BUSINESS_YEARLY': ProductPricingResponse;
    /**
     * 
     * @type {BusinessOptionPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'business_dictation_only'?: BusinessOptionPricingResponse | null;
    /**
     * 
     * @type {BusinessOptionPricingResponse}
     * @memberof CurrencyPricingResponse
     */
    'business_bundle'?: BusinessOptionPricingResponse | null;
}
/**
 * Custom-pricing fields collected inline during sales-led enterprise creation.  All other billing-config fields are derived server-side: product_name from plan, true_up_period_days from plan cadence, payment_terms_days from days_until_due, currency is always USD (the sales-led subscription path is USD-only end-to-end — platform-fee prices and the subscription currency arg are both USD).
 * @export
 * @interface CustomBillingConfigInput
 */
export interface CustomBillingConfigInput {
    /**
     * Per-seat USD price in cents over the plan\'s billing period (year for *_YEARLY plans, month for *_MONTHLY).
     * @type {number}
     * @memberof CustomBillingConfigInput
     */
    'custom_unit_price_cents': number;
}
/**
 * Daily word count data for usage charts.
 * @export
 * @interface DailyWordCountData
 */
export interface DailyWordCountData {
    /**
     * 
     * @type {string}
     * @memberof DailyWordCountData
     */
    'day': string;
    /**
     * 
     * @type {number}
     * @memberof DailyWordCountData
     */
    'wordcount': number;
}
/**
 * A user-facing slice of usage data a scoped erasure or data export can target.  Also the `data_category` Postgres enum behind `gdpr_request.categories`, so adding a member needs a migration that extends the type. A full erasure (``categories=None``) covers every store; a scoped one only the stores/tables mapped to its categories (`STORES_BY_CATEGORY` here, the per-table map in `inventory.py`). Stores mapped to no category only run on a full erasure.
 * @export
 * @enum {string}
 */

export const DataCategory = {
    Dictation: 'dictation',
    Personalization: 'personalization',
    Notes: 'notes',
    Todos: 'todos',
    Meetings: 'meetings',
    Dictionary: 'dictionary'
} as const;

export type DataCategory = typeof DataCategory[keyof typeof DataCategory];


/**
 * Body for ``POST /api/v1/data-export``: the categories to export; omitted exports everything.  All six categories is still a scoped export: account-level sections ship only in a full one.
 * @export
 * @interface DataExportStartRequest
 */
export interface DataExportStartRequest {
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof DataExportStartRequest
     */
    'categories'?: Array<DataCategory>;
}
/**
 * The caller\'s latest export request, redacted.  Attributes:     state: Coarse state of the latest request, or ``not_found``.     request_id: Opaque id of the latest request; None for ``not_found``.     requested_at: When the request was accepted (UTC).     terminal_at: When it reached a terminal state (UTC); None while in flight.     failure_code: Bounded server code for a ``failed`` or ``cancelled`` request; None for a         member-initiated cancel or a success.     warning_codes: Bounded codes for sections that degraded on a ``completed_with_warnings``         export.     per_step: In-flight ``{step: state}`` progress from the workflow, bounded enum strings;         None when terminal or when the run could not be queried.     artifact_available: Whether a completed export\'s artifact is still within its         retention window. False past ``artifact_expires_at`` — request again.     artifact_expires_at: End of the artifact\'s retention window (UTC); None unless the         export completed.     categories: The categories the request exports, in canonical order; None for a full         export or ``not_found``.
 * @export
 * @interface DataExportStatusResponse
 */
export interface DataExportStatusResponse {
    /**
     * 
     * @type {DataExportStatusState}
     * @memberof DataExportStatusResponse
     */
    'state': DataExportStatusState;
    /**
     * 
     * @type {string}
     * @memberof DataExportStatusResponse
     */
    'request_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportStatusResponse
     */
    'requested_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportStatusResponse
     */
    'terminal_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataExportStatusResponse
     */
    'failure_code'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataExportStatusResponse
     */
    'warning_codes'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DataExportStatusResponse
     */
    'per_step'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataExportStatusResponse
     */
    'artifact_available'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DataExportStatusResponse
     */
    'artifact_expires_at'?: string | null;
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof DataExportStatusResponse
     */
    'categories'?: Array<DataCategory> | null;
}


/**
 * Coarse, non-PII state of the caller\'s latest export request.
 * @export
 * @enum {string}
 */

export const DataExportStatusState = {
    NotFound: 'not_found',
    InFlight: 'in_flight',
    Completed: 'completed',
    CompletedWithWarnings: 'completed_with_warnings',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type DataExportStatusState = typeof DataExportStatusState[keyof typeof DataExportStatusState];


/**
 * Identifier of the join request being deleted.
 * @export
 * @interface DeleteJoinRequestRequest
 */
export interface DeleteJoinRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteJoinRequestRequest
     */
    'join_request_id': string;
}
/**
 * Write a tombstone; the head must be at ``base_version`` (``None``: no live head).
 * @export
 * @interface DeleteOp
 */
export interface DeleteOp {
    /**
     * 
     * @type {string}
     * @memberof DeleteOp
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteOp
     */
    'kind'?: DeleteOpKindEnum;
    /**
     * 
     * @type {number}
     * @memberof DeleteOp
     */
    'base_version': number | null;
}

export const DeleteOpKindEnum = {
    Delete: 'delete'
} as const;

export type DeleteOpKindEnum = typeof DeleteOpKindEnum[keyof typeof DeleteOpKindEnum];

/**
 * One derived trait: its value, when it was evaluated, and the version of the rule that produced it.
 * @export
 * @interface DerivedTraitPayload
 */
export interface DerivedTraitPayload {
    /**
     * 
     * @type {boolean}
     * @memberof DerivedTraitPayload
     */
    'value': boolean;
    /**
     * 
     * @type {string}
     * @memberof DerivedTraitPayload
     */
    'evaluatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof DerivedTraitPayload
     */
    'ruleVersion': number;
}
/**
 * Derived user traits, one field per trait. A null trait is unknown and never clears a value a client cached.
 * @export
 * @interface DerivedTraitsPayload
 */
export interface DerivedTraitsPayload {
    /**
     * 
     * @type {DerivedTraitPayload}
     * @memberof DerivedTraitsPayload
     */
    'isMeetingBusyUser'?: DerivedTraitPayload | null;
    /**
     * 
     * @type {DerivedTraitPayload}
     * @memberof DerivedTraitsPayload
     */
    'inferredNotetakerIntent'?: DerivedTraitPayload | null;
}
/**
 * ``app_key`` is the canonical app name; display-name mapping is client-owned.
 * @export
 * @interface DesktopAppRow
 */
export interface DesktopAppRow {
    /**
     * 
     * @type {string}
     * @memberof DesktopAppRow
     */
    'app_key': string;
    /**
     * 
     * @type {string}
     * @memberof DesktopAppRow
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppRow
     */
    'word_count': number;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppRow
     */
    'pct_of_total': number;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppRow
     */
    'user_count': number;
}
/**
 * Per-app desktop dictation breakdown plus distinct-app-count headline and delta.
 * @export
 * @interface DesktopAppsResponse
 */
export interface DesktopAppsResponse {
    /**
     * 
     * @type {TeamInsightsFilters}
     * @memberof DesktopAppsResponse
     */
    'filters_applied': TeamInsightsFilters;
    /**
     * 
     * @type {Array<string>}
     * @memberof DesktopAppsResponse
     */
    'data_quality_flags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppsResponse
     */
    'distinct_app_count': number;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppsResponse
     */
    'distinct_app_count_pct_change_vs_prev_period'?: number | null;
    /**
     * 
     * @type {Array<DesktopAppRow>}
     * @memberof DesktopAppsResponse
     */
    'rows': Array<DesktopAppRow>;
    /**
     * 
     * @type {number}
     * @memberof DesktopAppsResponse
     */
    'total_distinct_app_count': number;
}
/**
 * Response model for sandbox user destruction.
 * @export
 * @interface DestroySandboxUserResponse
 */
export interface DestroySandboxUserResponse {
    /**
     * Human-readable message
     * @type {string}
     * @memberof DestroySandboxUserResponse
     */
    'message': string;
    /**
     * List of services that failed to delete data
     * @type {Array<string>}
     * @memberof DestroySandboxUserResponse
     */
    'failed_services'?: Array<string>;
}
/**
 * Request to classify a text message\'s formality level.
 * @export
 * @interface DetectFormalityRequest
 */
export interface DetectFormalityRequest {
    /**
     * Text message to classify for formality level
     * @type {string}
     * @memberof DetectFormalityRequest
     */
    'text': string;
}
/**
 * Formality-detection result with the detected formality level.
 * @export
 * @interface DetectFormalityResponse
 */
export interface DetectFormalityResponse {
    /**
     * Detected formality level of the text
     * @type {PersonalizationStyle}
     * @memberof DetectFormalityResponse
     */
    'formality_level': PersonalizationStyle;
}


/**
 * Device-auth poll result: status plus tokens and attribution when complete.
 * @export
 * @interface DeviceAuthResponse
 */
export interface DeviceAuthResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'status': DeviceAuthResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'access_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'refresh_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceAuthResponse
     */
    'onboarding_completed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'dub_click_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'referral'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'promo_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'fbp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'fbc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceAuthResponse
     */
    'team_invite_code'?: string | null;
    /**
     * 
     * @type {OnboardingContext}
     * @memberof DeviceAuthResponse
     */
    'onboarding_context'?: OnboardingContext | null;
    /**
     * 
     * @type {DeviceDerivedTraits}
     * @memberof DeviceAuthResponse
     */
    'derived_traits'?: DeviceDerivedTraits | null;
}

export const DeviceAuthResponseStatusEnum = {
    Complete: 'complete',
    Pending: 'pending',
    Timeout: 'timeout'
} as const;

export type DeviceAuthResponseStatusEnum = typeof DeviceAuthResponseStatusEnum[keyof typeof DeviceAuthResponseStatusEnum];

/**
 * Request completing a device-code auth flow with tokens and attribution.
 * @export
 * @interface DeviceCodeCompleteRequest
 */
export interface DeviceCodeCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'device_code': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'refresh_token': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'dub_click_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'referral'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'promo_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'fbp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'fbc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'gclid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'li_fat_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'wispr_click_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'msclkid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'ttclid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'ttp'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'ad_user_data'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'ad_personalization'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'linkedin_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'linkedin_ads_consent_type'?: DeviceCodeCompleteRequestLinkedinAdsConsentTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'meta_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'meta_ads_consent_type'?: DeviceCodeCompleteRequestMetaAdsConsentTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'microsoft_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'microsoft_ads_consent_type'?: DeviceCodeCompleteRequestMicrosoftAdsConsentTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'tiktok_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'tiktok_ads_consent_type'?: DeviceCodeCompleteRequestTiktokAdsConsentTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'tiktok_advanced_matching_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'tiktok_advanced_matching_consent_type'?: DeviceCodeCompleteRequestTiktokAdvancedMatchingConsentTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceCodeCompleteRequest
     */
    'gravity_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'gravity_ads_consent_type'?: DeviceCodeCompleteRequestGravityAdsConsentTypeEnum | null;
    /**
     * 
     * @type {object}
     * @memberof DeviceCodeCompleteRequest
     */
    'gravity_user_data'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof DeviceCodeCompleteRequest
     */
    'gravity_client_context'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'gravity_event_source_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'team_invite_code'?: string | null;
    /**
     * 
     * @type {UtmParams}
     * @memberof DeviceCodeCompleteRequest
     */
    'utm'?: UtmParams | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceCodeCompleteRequest
     */
    'first_landing_url'?: string | null;
}

export const DeviceCodeCompleteRequestLinkedinAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestLinkedinAdsConsentTypeEnum = typeof DeviceCodeCompleteRequestLinkedinAdsConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestLinkedinAdsConsentTypeEnum];
export const DeviceCodeCompleteRequestMetaAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestMetaAdsConsentTypeEnum = typeof DeviceCodeCompleteRequestMetaAdsConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestMetaAdsConsentTypeEnum];
export const DeviceCodeCompleteRequestMicrosoftAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestMicrosoftAdsConsentTypeEnum = typeof DeviceCodeCompleteRequestMicrosoftAdsConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestMicrosoftAdsConsentTypeEnum];
export const DeviceCodeCompleteRequestTiktokAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestTiktokAdsConsentTypeEnum = typeof DeviceCodeCompleteRequestTiktokAdsConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestTiktokAdsConsentTypeEnum];
export const DeviceCodeCompleteRequestTiktokAdvancedMatchingConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestTiktokAdvancedMatchingConsentTypeEnum = typeof DeviceCodeCompleteRequestTiktokAdvancedMatchingConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestTiktokAdvancedMatchingConsentTypeEnum];
export const DeviceCodeCompleteRequestGravityAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type DeviceCodeCompleteRequestGravityAdsConsentTypeEnum = typeof DeviceCodeCompleteRequestGravityAdsConsentTypeEnum[keyof typeof DeviceCodeCompleteRequestGravityAdsConsentTypeEnum];

/**
 * Derived traits for the signed-in account, relayed with the device sign-in tokens.
 * @export
 * @interface DeviceDerivedTraits
 */
export interface DeviceDerivedTraits {
    /**
     * 
     * @type {string}
     * @memberof DeviceDerivedTraits
     */
    'user_id': string;
    /**
     * 
     * @type {DerivedTraitsPayload}
     * @memberof DeviceDerivedTraits
     */
    'traits': DerivedTraitsPayload;
}
/**
 * Completeness of the hardware metadata a device reported at registration.
 * @export
 * @enum {string}
 */

export const DeviceInfoStatus = {
    Ok: 'ok',
    Partial: 'partial',
    Missing: 'missing',
    AccessDenied: 'access_denied',
    Error: 'error'
} as const;

export type DeviceInfoStatus = typeof DeviceInfoStatus[keyof typeof DeviceInfoStatus];


/**
 * @type DictationShortCircuitProvider
 * @export
 */
export type DictationShortCircuitProvider = CerebrasProviderConfig | OpenRouterProviderConfig;

/**
 * A personal dictionary word or snippet entry as sent by clients on write.
 * @export
 * @interface DictionaryItem
 */
export interface DictionaryItem {
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'replacement_html'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItem
     */
    'is_manual': boolean;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'modified_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItem
     */
    'is_deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof DictionaryItem
     */
    'frequency_used': number;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'last_used'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'source'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItem
     */
    'is_snippet': boolean;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'team_dictionary_id': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItem
     */
    'observed_source'?: string | null;
}
/**
 * Legacy dictionary/snippet item shape retained for backward compatibility.
 * @export
 * @interface DictionaryItemOld
 */
export interface DictionaryItemOld {
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'team_dictionary_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItemOld
     */
    'is_manual': boolean;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'modified_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItemOld
     */
    'is_deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof DictionaryItemOld
     */
    'frequency_used'?: number;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'last_used'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DictionaryItemOld
     */
    'source': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DictionaryItemOld
     */
    'is_snippet'?: boolean;
}
/**
 * Dictionary entry counts, broken out by how each entry was added.
 * @export
 * @interface DictionaryStats
 */
export interface DictionaryStats {
    /**
     * 
     * @type {number}
     * @memberof DictionaryStats
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryStats
     */
    'auto_learned': number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryStats
     */
    'manually_added': number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryStats
     */
    'phrases_added': number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryStats
     */
    'snippets_added': number;
}
/**
 * Request for a platform-specific direct download link email.
 * @export
 * @interface DirectDownloadLinkRequest
 */
export interface DirectDownloadLinkRequest {
    /**
     * 
     * @type {SrcBackendServiceSchemasApiReferralPlatform}
     * @memberof DirectDownloadLinkRequest
     */
    'platform': SrcBackendServiceSchemasApiReferralPlatform;
    /**
     * 
     * @type {string}
     * @memberof DirectDownloadLinkRequest
     */
    'recipient_email': string;
}


/**
 * Dry-run diff of a directory sync, shown to the admin before confirming.
 * @export
 * @interface DirectorySyncPreview
 */
export interface DirectorySyncPreview {
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncPreview
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncPreview
     */
    'enterprise_name': string;
    /**
     * 
     * @type {number}
     * @memberof DirectorySyncPreview
     */
    'workos_directory_user_count': number;
    /**
     * 
     * @type {number}
     * @memberof DirectorySyncPreview
     */
    'db_user_count': number;
    /**
     * 
     * @type {Array<DirectorySyncUserAction>}
     * @memberof DirectorySyncPreview
     */
    'to_provision': Array<DirectorySyncUserAction>;
    /**
     * 
     * @type {Array<DirectorySyncUserAction>}
     * @memberof DirectorySyncPreview
     */
    'to_remove': Array<DirectorySyncUserAction>;
    /**
     * 
     * @type {Array<DirectorySyncUserAction>}
     * @memberof DirectorySyncPreview
     */
    'to_link': Array<DirectorySyncUserAction>;
}
/**
 * Response for async directory sync endpoints (202 Accepted).
 * @export
 * @interface DirectorySyncStartedResponse
 */
export interface DirectorySyncStartedResponse {
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncStartedResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncStartedResponse
     */
    'log_query': string;
}
/**
 * A single user action from a directory sync operation.
 * @export
 * @interface DirectorySyncUserAction
 */
export interface DirectorySyncUserAction {
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncUserAction
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncUserAction
     */
    'action': DirectorySyncUserActionActionEnum;
    /**
     * 
     * @type {string}
     * @memberof DirectorySyncUserAction
     */
    'detail'?: string | null;
}

export const DirectorySyncUserActionActionEnum = {
    LinkedWorkosId: 'linked_workos_id',
    Provisioned: 'provisioned',
    Removed: 'removed',
    Skipped: 'skipped',
    Error: 'error'
} as const;

export type DirectorySyncUserActionActionEnum = typeof DirectorySyncUserActionActionEnum[keyof typeof DirectorySyncUserActionActionEnum];

/**
 * Request model for disbanding an enterprise.
 * @export
 * @interface DisbandEnterpriseRequest
 */
export interface DisbandEnterpriseRequest {
    /**
     * Reason for disbanding the enterprise
     * @type {string}
     * @memberof DisbandEnterpriseRequest
     */
    'reason': string;
}
/**
 * Response model for disbanding an enterprise.
 * @export
 * @interface DisbandEnterpriseResponse
 */
export interface DisbandEnterpriseResponse {
    /**
     * 
     * @type {string}
     * @memberof DisbandEnterpriseResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof DisbandEnterpriseResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof DisbandEnterpriseResponse
     */
    'enterprise_name': string;
}
/**
 * Request to disconnect a connector identified by its key.
 * @export
 * @interface DisconnectRequest
 */
export interface DisconnectRequest {
    /**
     * 
     * @type {ConnectorKey}
     * @memberof DisconnectRequest
     */
    'key': ConnectorKey;
}


/**
 * 
 * @export
 * @interface DisconnectResponse
 */
export interface DisconnectResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DisconnectResponse
     */
    'successful': boolean;
}
/**
 * Whether unclaimed users on a verified domain are required to request to join the enterprise.  ``unset`` indicates the admin has not chosen a policy — distinct from explicitly ``off``. Both ``off`` and ``require`` require a DNS-verified domain before they may be set; ``unset`` is the only value allowed when no domain has been verified yet. ``off`` means that they have intentionally turned off domain capture so users can keep using flow without being prompted to join the enterprise.
 * @export
 * @enum {string}
 */

export const DomainCapturePolicy = {
    Unset: 'unset',
    Off: 'off',
    Require: 'require'
} as const;

export type DomainCapturePolicy = typeof DomainCapturePolicy[keyof typeof DomainCapturePolicy];


/**
 * Response returned by the superadmin ``initiate-verification`` endpoint.  Narrower than :class:`DomainVerificationStatus` — does not expose check counters or capture policy, only what is needed to issue the TXT record.
 * @export
 * @interface DomainVerificationInitiateResponse
 */
export interface DomainVerificationInitiateResponse {
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationInitiateResponse
     */
    'domain_id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationInitiateResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationInitiateResponse
     */
    'domain': string;
    /**
     * 
     * @type {boolean}
     * @memberof DomainVerificationInitiateResponse
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationInitiateResponse
     */
    'verified_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationInitiateResponse
     */
    'verification_initiated_at': string | null;
    /**
     * 
     * @type {DomainVerificationRecord}
     * @memberof DomainVerificationInitiateResponse
     */
    'record': DomainVerificationRecord | null;
}
/**
 * TXT record the customer must publish to prove ownership of a domain.
 * @export
 * @interface DomainVerificationRecord
 */
export interface DomainVerificationRecord {
    /**
     * DNS record type. Always ``\"TXT\"`` for this flow.
     * @type {string}
     * @memberof DomainVerificationRecord
     */
    'type': string;
    /**
     * Fully-qualified DNS name to publish the TXT record at.
     * @type {string}
     * @memberof DomainVerificationRecord
     */
    'host': string;
    /**
     * Exact TXT record value to publish (our DNS token).
     * @type {string}
     * @memberof DomainVerificationRecord
     */
    'value': string;
}
/**
 * Per-domain verification state returned by the enterprise and internal APIs.  The ``record`` field is populated only on superadmin (internal) reads while the domain is still unverified. Admin-facing reads always set it to ``None``.
 * @export
 * @interface DomainVerificationStatus
 */
export interface DomainVerificationStatus {
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'domain_id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'domain': string;
    /**
     * 
     * @type {boolean}
     * @memberof DomainVerificationStatus
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'verified_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'verification_initiated_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DomainVerificationStatus
     */
    'last_verification_check_at': string | null;
    /**
     * Number of DNS check attempts made against this domain.
     * @type {number}
     * @memberof DomainVerificationStatus
     */
    'verification_attempts': number;
    /**
     * True iff a verification token is currently issued and the domain is not yet verified.
     * @type {boolean}
     * @memberof DomainVerificationStatus
     */
    'token_active': boolean;
    /**
     * 
     * @type {DomainVerificationRecord}
     * @memberof DomainVerificationStatus
     */
    'record': DomainVerificationRecord | null;
    /**
     * Per-domain capture policy. ``unset`` while unverified; ``off``/``require`` once verified.
     * @type {DomainCapturePolicy}
     * @memberof DomainVerificationStatus
     */
    'domain_capture_policy': DomainCapturePolicy;
}


/**
 * EU country codes Flow prices in EUR.
 * @export
 * @enum {string}
 */

export const EUCountry = {
    Nl: 'NL',
    De: 'DE',
    Fr: 'FR',
    Be: 'BE',
    Es: 'ES',
    Ie: 'IE'
} as const;

export type EUCountry = typeof EUCountry[keyof typeof EUCountry];


/**
 * User statistics enriched with profile information.
 * @export
 * @interface EnrichedUserStats
 */
export interface EnrichedUserStats {
    /**
     * 
     * @type {string}
     * @memberof EnrichedUserStats
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnrichedUserStats
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrichedUserStats
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnrichedUserStats
     */
    'last_name': string | null;
    /**
     * 
     * @type {UserStats}
     * @memberof EnrichedUserStats
     */
    'stats': UserStats;
    /**
     * 
     * @type {Array<DailyWordCountData>}
     * @memberof EnrichedUserStats
     */
    'daily_word_counts': Array<DailyWordCountData>;
}
/**
 * A short-lived widget credential scoped to the current user and organization.
 * @export
 * @interface EnterpriseAPIKeysWidgetTokenResponse
 */
export interface EnterpriseAPIKeysWidgetTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseAPIKeysWidgetTokenResponse
     */
    'token': string;
}
/**
 * Request model for creating a billing config.
 * @export
 * @interface EnterpriseBillingConfigCreate
 */
export interface EnterpriseBillingConfigCreate {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigCreate
     */
    'next_true_up_date': string;
    /**
     * Billing period in days (monthly, quarterly, annual)
     * @type {number}
     * @memberof EnterpriseBillingConfigCreate
     */
    'true_up_period_days': EnterpriseBillingConfigCreateTrueUpPeriodDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigCreate
     */
    'stripe_price_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigCreate
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigCreate
     */
    'payment_terms_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigCreate
     */
    'custom_unit_price_cents'?: number | null;
    /**
     * 
     * @type {Array<PricingTierSchema>}
     * @memberof EnterpriseBillingConfigCreate
     */
    'pricing_tiers'?: Array<PricingTierSchema> | null;
    /**
     * 
     * @type {Currency}
     * @memberof EnterpriseBillingConfigCreate
     */
    'currency'?: Currency;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigCreate
     */
    'seat_cap'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigCreate
     */
    'contract_end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigCreate
     */
    'contract_period_days'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigCreate
     */
    'enterprise_id': string;
}

export const EnterpriseBillingConfigCreateTrueUpPeriodDaysEnum = {
    NUMBER_30: 30,
    NUMBER_90: 90,
    NUMBER_365: 365
} as const;

export type EnterpriseBillingConfigCreateTrueUpPeriodDaysEnum = typeof EnterpriseBillingConfigCreateTrueUpPeriodDaysEnum[keyof typeof EnterpriseBillingConfigCreateTrueUpPeriodDaysEnum];

/**
 * Response model for list of billing configs.
 * @export
 * @interface EnterpriseBillingConfigListResponse
 */
export interface EnterpriseBillingConfigListResponse {
    /**
     * 
     * @type {Array<EnterpriseBillingConfigResponse>}
     * @memberof EnterpriseBillingConfigListResponse
     */
    'configs': Array<EnterpriseBillingConfigResponse>;
}
/**
 * Response model for a billing config.
 * @export
 * @interface EnterpriseBillingConfigResponse
 */
export interface EnterpriseBillingConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'next_true_up_date': string;
    /**
     * Billing period in days (monthly, quarterly, annual)
     * @type {number}
     * @memberof EnterpriseBillingConfigResponse
     */
    'true_up_period_days': EnterpriseBillingConfigResponseTrueUpPeriodDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'stripe_price_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigResponse
     */
    'payment_terms_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigResponse
     */
    'custom_unit_price_cents'?: number | null;
    /**
     * 
     * @type {Array<PricingTierSchema>}
     * @memberof EnterpriseBillingConfigResponse
     */
    'pricing_tiers'?: Array<PricingTierSchema> | null;
    /**
     * 
     * @type {Currency}
     * @memberof EnterpriseBillingConfigResponse
     */
    'currency'?: Currency;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigResponse
     */
    'seat_cap'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'contract_end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigResponse
     */
    'contract_period_days'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'enterprise_name': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigResponse
     */
    'created_at': string;
}

export const EnterpriseBillingConfigResponseTrueUpPeriodDaysEnum = {
    NUMBER_30: 30,
    NUMBER_90: 90,
    NUMBER_365: 365
} as const;

export type EnterpriseBillingConfigResponseTrueUpPeriodDaysEnum = typeof EnterpriseBillingConfigResponseTrueUpPeriodDaysEnum[keyof typeof EnterpriseBillingConfigResponseTrueUpPeriodDaysEnum];

/**
 * Request model for updating a billing config.
 * @export
 * @interface EnterpriseBillingConfigUpdate
 */
export interface EnterpriseBillingConfigUpdate {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'next_true_up_date': string;
    /**
     * Billing period in days (monthly, quarterly, annual)
     * @type {number}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'true_up_period_days': EnterpriseBillingConfigUpdateTrueUpPeriodDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'stripe_price_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'product_name': string;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'payment_terms_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'custom_unit_price_cents'?: number | null;
    /**
     * 
     * @type {Array<PricingTierSchema>}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'pricing_tiers'?: Array<PricingTierSchema> | null;
    /**
     * 
     * @type {Currency}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'currency'?: Currency;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'seat_cap'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'contract_end_date'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseBillingConfigUpdate
     */
    'contract_period_days'?: number | null;
}

export const EnterpriseBillingConfigUpdateTrueUpPeriodDaysEnum = {
    NUMBER_30: 30,
    NUMBER_90: 90,
    NUMBER_365: 365
} as const;

export type EnterpriseBillingConfigUpdateTrueUpPeriodDaysEnum = typeof EnterpriseBillingConfigUpdateTrueUpPeriodDaysEnum[keyof typeof EnterpriseBillingConfigUpdateTrueUpPeriodDaysEnum];

/**
 * Response model for enterprise details.
 * @export
 * @interface EnterpriseDetailsResponse
 */
export interface EnterpriseDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'name': string;
    /**
     * 
     * @type {EnterpriseStatus}
     * @memberof EnterpriseDetailsResponse
     */
    'status': EnterpriseStatus;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'disbanded_at': string | null;
    /**
     * 
     * @type {Array<EnterpriseDomainItem>}
     * @memberof EnterpriseDetailsResponse
     */
    'domains': Array<EnterpriseDomainItem>;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'preserve_contracted_seats': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'zdr': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'zdr_locked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'allow_cloud_sync': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'allow_share_data': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'granular_data_controls_ui_visible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'ip_allowlist_ui_visible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'ip_allowlist_locked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'audit_log_streaming_ui_visible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'dictionary_snippets_kill_switch_ui_visible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'dictionary_snippets_plan_eligible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'restrict_domain_access': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'usage_export_allowed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'show_last_used_at': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'allow_notetaker': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'context_awareness': EnterpriseDetailsResponseContextAwarenessEnum;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'hide_leaderboard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'auto_invite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDetailsResponse
     */
    'disable_team_trial': boolean;
    /**
     * 
     * @type {MdmUpdateIntent}
     * @memberof EnterpriseDetailsResponse
     */
    'mdm_update_intent': MdmUpdateIntent | null;
    /**
     * 
     * @type {Array<MdmProvider>}
     * @memberof EnterpriseDetailsResponse
     */
    'mdm_providers': Array<MdmProvider>;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'general_cost_center_id'?: string | null;
    /**
     * 
     * @type {BillingProvider}
     * @memberof EnterpriseDetailsResponse
     */
    'billing_provider'?: BillingProvider | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'plan_tier'?: EnterpriseDetailsResponsePlanTierEnum | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'workos_org_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'workos_con_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'workos_provider': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDetailsResponse
     */
    'workos_directory_id': string | null;
}

export const EnterpriseDetailsResponseContextAwarenessEnum = {
    Available: 'available',
    Disabled: 'disabled'
} as const;

export type EnterpriseDetailsResponseContextAwarenessEnum = typeof EnterpriseDetailsResponseContextAwarenessEnum[keyof typeof EnterpriseDetailsResponseContextAwarenessEnum];
export const EnterpriseDetailsResponsePlanTierEnum = {
    Business: 'business',
    Enterprise: 'enterprise'
} as const;

export type EnterpriseDetailsResponsePlanTierEnum = typeof EnterpriseDetailsResponsePlanTierEnum[keyof typeof EnterpriseDetailsResponsePlanTierEnum];

/**
 * Response model for an enterprise domain.
 * @export
 * @interface EnterpriseDomainItem
 */
export interface EnterpriseDomainItem {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDomainItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDomainItem
     */
    'domain': string;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseDomainItem
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDomainItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseDomainItem
     */
    'domain_capture_policy': EnterpriseDomainItemDomainCapturePolicyEnum;
}

export const EnterpriseDomainItemDomainCapturePolicyEnum = {
    Unset: 'unset',
    Off: 'off',
    Require: 'require'
} as const;

export type EnterpriseDomainItemDomainCapturePolicyEnum = typeof EnterpriseDomainItemDomainCapturePolicyEnum[keyof typeof EnterpriseDomainItemDomainCapturePolicyEnum];

/**
 * Response model for an enterprise in a list.
 * @export
 * @interface EnterpriseListItem
 */
export interface EnterpriseListItem {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseListItem
     */
    'name': string;
    /**
     * 
     * @type {EnterpriseStatus}
     * @memberof EnterpriseListItem
     */
    'status': EnterpriseStatus;
}


/**
 * Response model for an enterprise member.  ``firstName``, ``lastName``, ``email`` are nullable because the underlying ``User`` columns are nullable (see ``models/user.py``). ``role`` is nullable because the column is free-text and may contain stray strings outside the canonical ``EnterpriseRole`` enum (FLOW-BACKEND-8NW); the validator below silently coerces those to ``None``.  ``joinedAt`` is unix seconds of ``MIN(user_team_membership.added_at)`` across all the user\'s memberships in this enterprise (active + soft-deleted). ``None`` when the user has no membership row (edge case).
 * @export
 * @interface EnterpriseMember
 */
export interface EnterpriseMember {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMember
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMember
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMember
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMember
     */
    'email': string | null;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof EnterpriseMember
     */
    'role': EnterpriseRole | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMember
     */
    'joinedAt': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnterpriseMember
     */
    'notetakerEntitlement'?: boolean | null;
}


/**
 * Payload for ``GET /api/v1/enterprise/members/{user_id}``.  Inherits the full row shape (so a frontend can populate the detail header from a cached row optimistically). No extra fields today — the dictation rank that previously lived here was removed; the filter-aware chart totals come from ``/insights/words-dictated`` and ``/insights/desktop-apps``.
 * @export
 * @interface EnterpriseMemberDetailResponse
 */
export interface EnterpriseMemberDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'email': string | null;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof EnterpriseMemberDetailResponse
     */
    'role': EnterpriseRole | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'status': EnterpriseMemberDetailResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'trialEndsAt': number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'teamId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberDetailResponse
     */
    'teamName': string | null;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof EnterpriseMemberDetailResponse
     */
    'teamRole'?: TeamMemberRole | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'totalWords': number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'wordsInWindow': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'wpm': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'lastUsedAt': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberDetailResponse
     */
    'joinedAt': number | null;
}

export const EnterpriseMemberDetailResponseStatusEnum = {
    Active: 'active',
    Trialing: 'trialing'
} as const;

export type EnterpriseMemberDetailResponseStatusEnum = typeof EnterpriseMemberDetailResponseStatusEnum[keyof typeof EnterpriseMemberDetailResponseStatusEnum];

/**
 * One row of the admin-portal enterprise members table.  ``trialEndsAt`` is set only when ``status == \"trialing\"``; the field is omitted (``None``) for active members.  ``lastUsedAt`` is unix seconds (``GREATEST(desktop_last_transcript_timestamp, mobile_last_transcript_timestamp)``). ``None`` when the user has never dictated on either platform. ``wpm`` and ``lastUsedAt`` are lifetime values regardless of the active ``words_window`` — only the words column varies.  ``joinedAt`` is unix seconds of ``MIN(user_team_membership.added_at)`` across all membership rows for this user in this enterprise (active + soft-deleted) so it survives team moves. ``None`` when no membership rows exist (e.g. an SSO-provisioned user not yet placed on any team).  ``wpm`` is the user\'s lifetime average words-per-minute (``UserStats.words_per_minute``). ``None`` when the user has no dictation history so the UI can render an em-dash instead of a meaningless ``0 WPM``.  ``wordsInWindow`` mirrors ``totalWords`` but for the request\'s ``words_window``:   * ``None`` exactly when ``words_window == \"all_time\"`` — the UI should     read ``totalWords`` for the cell. ``None`` here means \"this field is     not in play for this request\"; it must not be used as a substitute for     zero.   * ``0`` when a window is active and the user has no dictations inside it     — the UI should render ``0`` (not an em-dash).   * Positive integer otherwise.
 * @export
 * @interface EnterpriseMemberRowResponse
 */
export interface EnterpriseMemberRowResponse {
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'email': string | null;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof EnterpriseMemberRowResponse
     */
    'role': EnterpriseRole | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'status': EnterpriseMemberRowResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'trialEndsAt': number | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'teamId': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterpriseMemberRowResponse
     */
    'teamName': string | null;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof EnterpriseMemberRowResponse
     */
    'teamRole'?: TeamMemberRole | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'totalWords': number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'wordsInWindow': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'wpm': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'lastUsedAt': number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMemberRowResponse
     */
    'joinedAt': number | null;
}

export const EnterpriseMemberRowResponseStatusEnum = {
    Active: 'active',
    Trialing: 'trialing'
} as const;

export type EnterpriseMemberRowResponseStatusEnum = typeof EnterpriseMemberRowResponseStatusEnum[keyof typeof EnterpriseMemberRowResponseStatusEnum];

/**
 * Payload for ``GET /api/v1/enterprise/members/count``.  ``total`` ignores search/status/team filters. It still respects the protected-enterprise admin-roles restriction so a non-admin viewer of a protected enterprise sees the same reduced denominator the table query enforces.
 * @export
 * @interface EnterpriseMembersCountResponse
 */
export interface EnterpriseMembersCountResponse {
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMembersCountResponse
     */
    'total': number;
}
/**
 * Response model for list of enterprise members with pagination.
 * @export
 * @interface EnterpriseMembersResponse
 */
export interface EnterpriseMembersResponse {
    /**
     * 
     * @type {Array<EnterpriseMember>}
     * @memberof EnterpriseMembersResponse
     */
    'members': Array<EnterpriseMember>;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMembersResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMembersResponse
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMembersResponse
     */
    'offset': number;
}
/**
 * Paginated payload for ``GET /api/v1/enterprise/members/table``.  ``total`` reflects the count *after* search/status/team filters but *before* pagination — the frontend uses it for the page-count widget.
 * @export
 * @interface EnterpriseMembersTableResponse
 */
export interface EnterpriseMembersTableResponse {
    /**
     * 
     * @type {Array<EnterpriseMemberRowResponse>}
     * @memberof EnterpriseMembersTableResponse
     */
    'rows': Array<EnterpriseMemberRowResponse>;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseMembersTableResponse
     */
    'total': number;
}
/**
 * Single enterprise pilot item for list response.
 * @export
 * @interface EnterprisePilotItem
 */
export interface EnterprisePilotItem {
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'enterprise_name': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'cost_center_name': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'pilot_end': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'stripe_subscription_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EnterprisePilotItem
     */
    'status': string;
    /**
     * 
     * @type {BillingProvider}
     * @memberof EnterprisePilotItem
     */
    'billing_provider': BillingProvider;
}


/**
 * Response model for listing enterprise pilots.
 * @export
 * @interface EnterprisePilotsResponse
 */
export interface EnterprisePilotsResponse {
    /**
     * 
     * @type {Array<EnterprisePilotItem>}
     * @memberof EnterprisePilotsResponse
     */
    'pilots': Array<EnterprisePilotItem>;
    /**
     * 
     * @type {number}
     * @memberof EnterprisePilotsResponse
     */
    'total': number;
}
/**
 * Response model for GET /history/stats/enterprise/podiums.
 * @export
 * @interface EnterprisePodiumsResponse
 */
export interface EnterprisePodiumsResponse {
    /**
     * Top 6 users for each leaderboard metric plus the caller\'s entry when they are outside the top 6, grouped by time window (``all_time`` with 5 categories, ``this_week`` with 3).
     * @type {LeaderboardPodiums}
     * @memberof EnterprisePodiumsResponse
     */
    'podiums': LeaderboardPodiums;
}
/**
 * A member\'s role within an enterprise.
 * @export
 * @enum {string}
 */

export const EnterpriseRole = {
    Admin: 'admin',
    Member: 'member',
    Superadmin: 'superadmin',
    ItAdmin: 'it_admin'
} as const;

export type EnterpriseRole = typeof EnterpriseRole[keyof typeof EnterpriseRole];


/**
 * Sortable metrics for enterprise leaderboard pagination.
 * @export
 * @enum {string}
 */

export const EnterpriseSortBy = {
    TotalWords: 'total_words',
    WordsPerMinute: 'words_per_minute',
    DayStreak: 'day_streak',
    DesktopWords: 'desktop_words',
    MobileWords: 'mobile_words',
    WordsThisWeek: 'words_this_week',
    DesktopWordsThisWeek: 'desktop_words_this_week',
    MobileWordsThisWeek: 'mobile_words_this_week'
} as const;

export type EnterpriseSortBy = typeof EnterpriseSortBy[keyof typeof EnterpriseSortBy];


/**
 * Sort direction for enterprise leaderboard.
 * @export
 * @enum {string}
 */

export const EnterpriseSortOrder = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type EnterpriseSortOrder = typeof EnterpriseSortOrder[keyof typeof EnterpriseSortOrder];


/**
 * Whether an enterprise or team is active or disbanded.
 * @export
 * @enum {string}
 */

export const EnterpriseStatus = {
    Active: 'active',
    Disbanded: 'disbanded'
} as const;

export type EnterpriseStatus = typeof EnterpriseStatus[keyof typeof EnterpriseStatus];


/**
 * Optional sections to omit from GET /history/stats/enterprise (smaller payloads).
 * @export
 * @enum {string}
 */

export const EnterpriseUsageOmit = {
    Apps: 'apps',
    DailyWordCounts: 'daily_word_counts'
} as const;

export type EnterpriseUsageOmit = typeof EnterpriseUsageOmit[keyof typeof EnterpriseUsageOmit];


/**
 * Response model for enterprise usage statistics.
 * @export
 * @interface EnterpriseUsageResponse
 */
export interface EnterpriseUsageResponse {
    /**
     * 
     * @type {Array<EnrichedUserStats>}
     * @memberof EnterpriseUsageResponse
     */
    'users': Array<EnrichedUserStats>;
    /**
     * Users counted in the ranked leaderboard query (those with stats rows).
     * @type {number}
     * @memberof EnterpriseUsageResponse
     */
    'total_count'?: number;
    /**
     * Total members on the enterprise team (roster size).
     * @type {number}
     * @memberof EnterpriseUsageResponse
     */
    'team_member_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseUsageResponse
     */
    'offset'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnterpriseUsageResponse
     */
    'limit'?: number | null;
}
/**
 * Response model for GET /history/stats/enterprise/weekly-ranks.
 * @export
 * @interface EnterpriseWeeklyRanksResponse
 */
export interface EnterpriseWeeklyRanksResponse {
    /**
     * 4 historical completed weeks of ranked leaderboards, newest first (index 0 = most recently closed week). Weeks are Sunday–Saturday UTC; a week is treated as closed after the Sunday 23:45 UTC reset_weekly_words cron. Enterprise-scoped. Current-week totals/rank are on each user\'s stats (words_this_week, words_this_week_rank).
     * @type {Array<WeeklyLeaderboard>}
     * @memberof EnterpriseWeeklyRanksResponse
     */
    'weekly_ranks': Array<WeeklyLeaderboard>;
}
/**
 * Body for `POST /api/v1/support/usage-data-erasure`.  Exactly one of `email` / `user_id` must be set.  Attributes:     email: The PRIMARY identifier — the target\'s email. Resolved server-side to a         single user_id; the operator stating the human identity IS the fat-finger         guard, so no separate confirm field is needed. 0 matches → 404, >1 → 422.     user_id: The orphan-only identifier — a raw user id reaching orphaned usage data         (no `User` row / no email). The user_id path targets ONLY orphaned data;         requires `confirm_orphan=True`; server-side path-char rejected before use.     confirm_orphan: Explicit acknowledgement that applies ONLY to the `user_id` /         orphan path. Invalid with `email` (rejected by the validator).     actor: The support caller\'s identity — caller-supplied free text stored verbatim in         the audit row; not validated and never authorization-bearing.     reason: The erasure reason — caller-supplied free text stored verbatim in the audit row.     categories: Erase only these categories (e.g. `[\"notes\"]`), echoed back sorted and         de-duplicated. Omitted ⇒ a full erasure of required stores, preserving ClickHouse.         No category reaches Wispr Memory (full erasure only), and the voice profile goes with `dictation`, not         `personalization`.
 * @export
 * @interface ErasureStartRequest
 */
export interface ErasureStartRequest {
    /**
     * 
     * @type {string}
     * @memberof ErasureStartRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErasureStartRequest
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ErasureStartRequest
     */
    'confirm_orphan'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErasureStartRequest
     */
    'actor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ErasureStartRequest
     */
    'reason'?: string | null;
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof ErasureStartRequest
     */
    'categories'?: Array<DataCategory> | null;
}
/**
 * Response for a started (or attached-to-existing) erasure.  Carries only the derived workflow id (non-PII; `usage-erasure:{user_id}`), the legacy `skipped_no_email` indicator that the request has no email (retained for compatibility), and the categories the run is scoped to (None ⇒ full erasure). ClickHouse data is preserved regardless of that indicator.
 * @export
 * @interface ErasureStartResponse
 */
export interface ErasureStartResponse {
    /**
     * 
     * @type {string}
     * @memberof ErasureStartResponse
     */
    'workflow_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof ErasureStartResponse
     */
    'skipped_no_email': boolean;
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof ErasureStartResponse
     */
    'categories'?: Array<DataCategory> | null;
}
/**
 * REDACTED status of an erasure — ids / enums / counts / timestamps only.  Never carries the raw email, row content, or a raw exception. `per_store` is the workflow\'s `{store: StepState}` progress map for an in-flight run (bounded enum strings) or omitted for a terminal/not-found read. `last_error` is a sanitized bounded code (e.g. `clickhouse_verification_timed_out`), never a stack/raw error.  Attributes:     state: Coarse status (`not_found` / `in_flight` / `completed` / `failed`).     workflow_id: The derived workflow id queried (non-PII), or None for not_found         when no id could be derived.     per_store: In-flight per-store progress `{ErasureStore: StepState}`; None for         terminal/not-found reads (terminal proof lives in the audit row).     outcome: Terminal outcome string (`completed`/`failed`) from the audit row; None         in-flight / not-found.     watermark_t0_epoch_s: T0 (epoch seconds) from the terminal audit row; None         in-flight / not-found.     completed_at_epoch_s: Terminal `completed_at` (epoch seconds) from the audit row.     last_error: Sanitized bounded failure code on a `failed` terminal; None otherwise.     proof: Per-store residual-count / empty-listing evidence from the audit row         (counts only, non-PII); None in-flight / not-found.     categories: The run\'s categories (sorted); None for a full erasure or not-found.
 * @export
 * @interface ErasureStatusResponse
 */
export interface ErasureStatusResponse {
    /**
     * 
     * @type {ErasureStatusState}
     * @memberof ErasureStatusResponse
     */
    'state': ErasureStatusState;
    /**
     * 
     * @type {string}
     * @memberof ErasureStatusResponse
     */
    'workflow_id'?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ErasureStatusResponse
     */
    'per_store'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof ErasureStatusResponse
     */
    'outcome'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ErasureStatusResponse
     */
    'watermark_t0_epoch_s'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ErasureStatusResponse
     */
    'completed_at_epoch_s'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ErasureStatusResponse
     */
    'last_error'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ErasureStatusResponse
     */
    'proof'?: object | null;
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof ErasureStatusResponse
     */
    'categories'?: Array<DataCategory> | null;
}


/**
 * Coarse, non-PII status of an erasure for the redacted status response.
 * @export
 * @enum {string}
 */

export const ErasureStatusState = {
    NotFound: 'not_found',
    InFlight: 'in_flight',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type ErasureStatusState = typeof ErasureStatusState[keyof typeof ErasureStatusState];


/**
 * Standard FastAPI HTTPException envelope: `{\"detail\": \"...\"}`.
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetail
     */
    'detail': string;
}
/**
 * One retained Inbox revision; agent outcomes live on invocations, so ``state`` and ``reason_code`` are null.
 * @export
 * @interface EventEntry
 */
export interface EventEntry {
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'object_id': string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'revision': string;
    /**
     * 
     * @type {EventKind}
     * @memberof EventEntry
     */
    'kind': EventKind;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'occurred_at': string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'recorded_at': string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'text': string | null;
    /**
     * 
     * @type {WorkState}
     * @memberof EventEntry
     */
    'state': WorkState | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'reason_code': string | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    'run_input_tokens'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'agent_id'?: string | null;
    /**
     * 
     * @type {EventWorkStatus}
     * @memberof EventEntry
     */
    'work_status'?: EventWorkStatus | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'run_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    'files_changed'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'failure_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    'rule_id'?: string | null;
}


/**
 * Semantic source changes, independent of transport delivery.
 * @export
 * @enum {string}
 */

export const EventKind = {
    Upsert: 'upsert',
    Delete: 'delete'
} as const;

export type EventKind = typeof EventKind[keyof typeof EventKind];


/**
 * A bounded page of authorized retained Inbox revisions.  Retention removes old revisions and a disconnect redacts its source\'s; this is not a complete source history.
 * @export
 * @interface EventPage
 */
export interface EventPage {
    /**
     * 
     * @type {Array<EventEntry>}
     * @memberof EventPage
     */
    'events': Array<EventEntry>;
    /**
     * 
     * @type {string}
     * @memberof EventPage
     */
    'next_id': string | null;
    /**
     * The current owner\'s learning generation.
     * @type {number}
     * @memberof EventPage
     */
    'learning_generation': number;
}
/**
 * Where the event\'s source agent is with it, from its invocation\'s admission and outcome.
 * @export
 * @enum {string}
 */

export const EventWorkStatus = {
    Queued: 'queued',
    Running: 'running',
    Changed: 'changed',
    NoChange: 'no_change',
    Failed: 'failed',
    Skipped: 'skipped'
} as const;

export type EventWorkStatus = typeof EventWorkStatus[keyof typeof EventWorkStatus];


/**
 * Versioned bounded diagnostics for one generation attempt.
 * @export
 * @interface EvidenceMetadata
 */
export interface EvidenceMetadata {
    /**
     * 
     * @type {number}
     * @memberof EvidenceMetadata
     */
    'version'?: EvidenceMetadataVersionEnum;
    /**
     * 
     * @type {number}
     * @memberof EvidenceMetadata
     */
    'recent_window_days'?: EvidenceMetadataRecentWindowDaysEnum;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: SourceEvidence; }; }}
     * @memberof EvidenceMetadata
     */
    'prefetch'?: { [key: string]: { [key: string]: SourceEvidence; }; };
    /**
     * 
     * @type {WriterResearch}
     * @memberof EvidenceMetadata
     */
    'writer_research'?: WriterResearch | null;
}

export const EvidenceMetadataVersionEnum = {
    NUMBER_1: 1
} as const;

export type EvidenceMetadataVersionEnum = typeof EvidenceMetadataVersionEnum[keyof typeof EvidenceMetadataVersionEnum];
export const EvidenceMetadataRecentWindowDaysEnum = {
    NUMBER_14: 14
} as const;

export type EvidenceMetadataRecentWindowDaysEnum = typeof EvidenceMetadataRecentWindowDaysEnum[keyof typeof EvidenceMetadataRecentWindowDaysEnum];

/**
 * A short-lived download capability for the selected bundle.
 * @export
 * @interface ExtensionBundleResponse
 */
export interface ExtensionBundleResponse {
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'sourceSha': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'platform': ExtensionBundleResponsePlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'releaseId': string;
    /**
     * 
     * @type {number}
     * @memberof ExtensionBundleResponse
     */
    'attempt': number;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'executionId': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'bundleKey': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'sha256': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtensionBundleResponse
     */
    'extensions': Array<string>;
    /**
     * 
     * @type {Array<SkippedExtension>}
     * @memberof ExtensionBundleResponse
     */
    'skipped': Array<SkippedExtension>;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionBundleResponse
     */
    'expiresAt': string;
}

export const ExtensionBundleResponsePlatformEnum = {
    MacArm64: 'mac-arm64'
} as const;

export type ExtensionBundleResponsePlatformEnum = typeof ExtensionBundleResponsePlatformEnum[keyof typeof ExtensionBundleResponsePlatformEnum];

/**
 * Request to extract candidate ASR vocabulary words from current textbox text.
 * @export
 * @interface ExtractASRWordsRequest
 */
export interface ExtractASRWordsRequest {
    /**
     * Text from the textbox to extract ASR words from
     * @type {string}
     * @memberof ExtractASRWordsRequest
     */
    'textbox_text': string;
}
/**
 * Compatible legacy and structured candidates for dictionary eligibility classification.
 * @export
 * @interface ExtractEditedWordsRequest
 */
export interface ExtractEditedWordsRequest {
    /**
     * Legacy space-separated candidate list
     * @type {string}
     * @memberof ExtractEditedWordsRequest
     */
    'potential_words': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtractEditedWordsRequest
     */
    'candidates'?: Array<string> | null;
    /**
     * Semantic edit surface used to select the classifier policy
     * @type {ExtractEditedWordsSource}
     * @memberof ExtractEditedWordsRequest
     */
    'source'?: ExtractEditedWordsSource;
}


/**
 * Legacy selected words plus accepted structured candidates.
 * @export
 * @interface ExtractEditedWordsResponse
 */
export interface ExtractEditedWordsResponse {
    /**
     * Comma-separated list of proper nouns, technical terms, or domain-specific terms
     * @type {string}
     * @memberof ExtractEditedWordsResponse
     */
    'words': string;
    /**
     * Accepted structured phrases in request order; empty for legacy-only requests
     * @type {Array<string>}
     * @memberof ExtractEditedWordsResponse
     */
    'accepted_candidates'?: Array<string>;
}
/**
 * Semantic edit surface whose policy should be used for candidate classification.
 * @export
 * @enum {string}
 */

export const ExtractEditedWordsSource = {
    UserEdits: 'user_edits',
    MeetingSummary: 'meeting_summary',
    MeetingTranscript: 'meeting_transcript'
} as const;

export type ExtractEditedWordsSource = typeof ExtractEditedWordsSource[keyof typeof ExtractEditedWordsSource];


/**
 * Details about a user that failed to be added.
 * @export
 * @interface FailedAddUserItem
 */
export interface FailedAddUserItem {
    /**
     * 
     * @type {string}
     * @memberof FailedAddUserItem
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof FailedAddUserItem
     */
    'reason': string;
}
/**
 * Details about a user that failed to have their role updated.
 * @export
 * @interface FailedUpdateUserItem
 */
export interface FailedUpdateUserItem {
    /**
     * 
     * @type {string}
     * @memberof FailedUpdateUserItem
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof FailedUpdateUserItem
     */
    'reason': string;
}
/**
 * Lifetime counts per feature (``dictionary`` / ``snippets`` / ``styles`` / ``transforms``).
 * @export
 * @interface FeatureUtilization
 */
export interface FeatureUtilization {
    /**
     * 
     * @type {string}
     * @memberof FeatureUtilization
     */
    'feature': string;
    /**
     * 
     * @type {number}
     * @memberof FeatureUtilization
     */
    'user_count': number;
    /**
     * 
     * @type {number}
     * @memberof FeatureUtilization
     */
    'feature_usage_count': number;
}
/**
 * Page-load filter dropdowns (teams + apps + categories).  Bundled so tab switches (Overview needs all three; Impact needs teams only) stay on a warm cache.
 * @export
 * @interface FilterOptionsResponse
 */
export interface FilterOptionsResponse {
    /**
     * 
     * @type {Array<TeamFilterOption>}
     * @memberof FilterOptionsResponse
     */
    'teams': Array<TeamFilterOption>;
    /**
     * 
     * @type {Array<AppFilterOption>}
     * @memberof FilterOptionsResponse
     */
    'apps': Array<AppFilterOption>;
    /**
     * 
     * @type {Array<CategoryFilterOption>}
     * @memberof FilterOptionsResponse
     */
    'categories': Array<CategoryFilterOption>;
}
/**
 * One Fireflies meeting the picker lists; ``source_id`` is the transcript id confirm takes.
 * @export
 * @interface FirefliesCatalogItem
 */
export interface FirefliesCatalogItem {
    /**
     * 
     * @type {string}
     * @memberof FirefliesCatalogItem
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof FirefliesCatalogItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof FirefliesCatalogItem
     */
    'started_at': string;
    /**
     * 
     * @type {number}
     * @memberof FirefliesCatalogItem
     */
    'duration_seconds': number;
    /**
     * 
     * @type {CatalogPiece}
     * @memberof FirefliesCatalogItem
     */
    'transcript': CatalogPiece;
    /**
     * 
     * @type {CatalogPiece}
     * @memberof FirefliesCatalogItem
     */
    'summary': CatalogPiece;
    /**
     * 
     * @type {boolean}
     * @memberof FirefliesCatalogItem
     */
    'importable': boolean;
    /**
     * 
     * @type {CatalogReason}
     * @memberof FirefliesCatalogItem
     */
    'reason'?: CatalogReason | null;
    /**
     * True when an earlier import run copied this meeting. Deleting the imported meeting does not clear it.
     * @type {boolean}
     * @memberof FirefliesCatalogItem
     */
    'already_imported': boolean;
}


/**
 * One page of the caller\'s Fireflies meetings, newest first. Ask again with ``skip=next_skip`` while ``has_more``.
 * @export
 * @interface FirefliesCatalogResponse
 */
export interface FirefliesCatalogResponse {
    /**
     * 
     * @type {Array<FirefliesCatalogItem>}
     * @memberof FirefliesCatalogResponse
     */
    'items': Array<FirefliesCatalogItem>;
    /**
     * 
     * @type {boolean}
     * @memberof FirefliesCatalogResponse
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof FirefliesCatalogResponse
     */
    'next_skip': number;
}
/**
 * A pasted personal Fireflies API key.
 * @export
 * @interface FirefliesConnectRequest
 */
export interface FirefliesConnectRequest {
    /**
     * 
     * @type {string}
     * @memberof FirefliesConnectRequest
     */
    'api_key': string;
}
/**
 * Whether the user\'s Fireflies account is connected, needs reconnecting, or is disconnected.
 * @export
 * @interface FirefliesConnectionResponse
 */
export interface FirefliesConnectionResponse {
    /**
     * 
     * @type {FirefliesConnectionStatus}
     * @memberof FirefliesConnectionResponse
     */
    'status': FirefliesConnectionStatus;
}


/**
 * Whether the user\'s Fireflies account can be used for an import.
 * @export
 * @enum {string}
 */

export const FirefliesConnectionStatus = {
    Connected: 'connected',
    NeedsReauth: 'needs_reauth',
    Disconnected: 'disconnected'
} as const;

export type FirefliesConnectionStatus = typeof FirefliesConnectionStatus[keyof typeof FirefliesConnectionStatus];


/**
 * Why a Fireflies call conflicted: ``fireflies_not_connected``, or ``import_run_active`` with the active run.
 * @export
 * @interface FirefliesImportConflictDetail
 */
export interface FirefliesImportConflictDetail {
    /**
     * 
     * @type {string}
     * @memberof FirefliesImportConflictDetail
     */
    'code': FirefliesImportConflictDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof FirefliesImportConflictDetail
     */
    'run_id'?: string | null;
}

export const FirefliesImportConflictDetailCodeEnum = {
    FirefliesNotConnected: 'fireflies_not_connected',
    ImportRunActive: 'import_run_active'
} as const;

export type FirefliesImportConflictDetailCodeEnum = typeof FirefliesImportConflictDetailCodeEnum[keyof typeof FirefliesImportConflictDetailCodeEnum];

/**
 * 409 envelope for the Fireflies catalog and confirm.
 * @export
 * @interface FirefliesImportConflictResponse
 */
export interface FirefliesImportConflictResponse {
    /**
     * 
     * @type {FirefliesImportConflictDetail}
     * @memberof FirefliesImportConflictResponse
     */
    'detail': FirefliesImportConflictDetail;
}
/**
 * 422 envelope for the Fireflies routes: one fixed detail, never the request that failed validation.
 * @export
 * @interface FirefliesInvalidRequestResponse
 */
export interface FirefliesInvalidRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof FirefliesInvalidRequestResponse
     */
    'detail': FirefliesInvalidRequestResponseDetailEnum;
}

export const FirefliesInvalidRequestResponseDetailEnum = {
    FirefliesInvalidRequest: 'fireflies_invalid_request'
} as const;

export type FirefliesInvalidRequestResponseDetailEnum = typeof FirefliesInvalidRequestResponseDetailEnum[keyof typeof FirefliesInvalidRequestResponseDetailEnum];

/**
 * Wire payload for one access key: only ``enabled`` leaves the server.
 * @export
 * @interface FlagPayload
 */
export interface FlagPayload {
    /**
     * 
     * @type {boolean}
     * @memberof FlagPayload
     */
    'enabled': boolean;
}
/**
 * Demo chat request: a workflow persona plus the conversation messages to respond to.
 * @export
 * @interface FlowResponseRequest
 */
export interface FlowResponseRequest {
    /**
     * 
     * @type {FlowWorkFlows}
     * @memberof FlowResponseRequest
     */
    'workflow': FlowWorkFlows;
    /**
     * 
     * @type {Array<{ [key: string]: string; }>}
     * @memberof FlowResponseRequest
     */
    'messages': Array<{ [key: string]: string; }>;
}


/**
 * User\'s Flow State 2025 recap: processing status plus computed usage stats and highlights.
 * @export
 * @interface FlowState2025Response
 */
export interface FlowState2025Response {
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'user_id': string;
    /**
     * 
     * @type {FlowStateProcessingStatus}
     * @memberof FlowState2025Response
     */
    'processing_status': FlowStateProcessingStatus;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'total_words'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'total_words_percentile'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'last_active'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'total_dictations_desktop'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'total_dictations_mobile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'wpm_desktop'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'wpm_mobile'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'longest_streak_days'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'top_app'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'top_app_day_of_week'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'top_app_hour_of_day'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'top_app_category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'secondary_app_category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'signature_phrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'signature_phrase_app'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'most_used_phrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'dictation_strength'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'alter_ego'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowState2025Response
     */
    'alter_ego_description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'avg_session_duration_desktop'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FlowState2025Response
     */
    'avg_session_duration_mobile'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowState2025Response
     */
    'goals'?: Array<string> | null;
}


/**
 * Month-level Flow State generation/send state for the admin portal.
 * @export
 * @interface FlowStateMonthSummaryResponse
 */
export interface FlowStateMonthSummaryResponse {
    /**
     * First day of the reporting month.
     * @type {string}
     * @memberof FlowStateMonthSummaryResponse
     */
    'reporting_month': string;
    /**
     * Profiles generated for this reporting month.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'generated_total': number;
    /**
     * Generated profiles still pending send.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'pending_send_total': number;
    /**
     * Profiles already sent.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'sent_total': number;
    /**
     * Profiles whose send failed.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'failed_send_total': number;
    /**
     * Profiles currently claimed for send.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'sending_total': number;
    /**
     * Profiles skipped during send.
     * @type {number}
     * @memberof FlowStateMonthSummaryResponse
     */
    'skipped_total': number;
    /**
     * 
     * @type {MarketingJobStatusResponse}
     * @memberof FlowStateMonthSummaryResponse
     */
    'active_job'?: MarketingJobStatusResponse | null;
    /**
     * 
     * @type {MarketingJobStatusResponse}
     * @memberof FlowStateMonthSummaryResponse
     */
    'latest_job'?: MarketingJobStatusResponse | null;
    /**
     * Whether already generated profiles can be sent.
     * @type {boolean}
     * @memberof FlowStateMonthSummaryResponse
     */
    'can_send_existing': boolean;
    /**
     * Whether regenerate-and-send can be enqueued.
     * @type {boolean}
     * @memberof FlowStateMonthSummaryResponse
     */
    'can_regenerate_send': boolean;
}
/**
 * Request body for previewing generated profiles before send.
 * @export
 * @interface FlowStatePreviewRequest
 */
export interface FlowStatePreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof FlowStatePreviewRequest
     */
    'reporting_month': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowStatePreviewRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof FlowStatePreviewRequest
     */
    'domain'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof FlowStatePreviewRequest
     */
    'user_ids'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof FlowStatePreviewRequest
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FlowStatePreviewRequest
     */
    'offset'?: number;
}
/**
 * Processing state of a user\'s Flow State 2025 recap computation.
 * @export
 * @enum {string}
 */

export const FlowStateProcessingStatus = {
    NotStarted: 'not_started',
    Processing: 'processing',
    Complete: 'complete',
    Failed: 'failed'
} as const;

export type FlowStateProcessingStatus = typeof FlowStateProcessingStatus[keyof typeof FlowStateProcessingStatus];


/**
 * Generated Flow State profile row for internal admin preview.
 * @export
 * @interface FlowStateProfilePreviewItem
 */
export interface FlowStateProfilePreviewItem {
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof FlowStateProfilePreviewItem
     */
    'eligibility_word_count': number;
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'generated_at': string;
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'send_status': string;
    /**
     * 
     * @type {number}
     * @memberof FlowStateProfilePreviewItem
     */
    'send_attempts': number;
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'sent_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FlowStateProfilePreviewItem
     */
    'send_error'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof FlowStateProfilePreviewItem
     */
    'profile': object;
}
/**
 * Paginated generated profile preview.
 * @export
 * @interface FlowStateProfilePreviewResponse
 */
export interface FlowStateProfilePreviewResponse {
    /**
     * 
     * @type {number}
     * @memberof FlowStateProfilePreviewResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<FlowStateProfilePreviewItem>}
     * @memberof FlowStateProfilePreviewResponse
     */
    'items': Array<FlowStateProfilePreviewItem>;
}
/**
 * Demo conversation workflow selecting which coworker/classmate persona prompt to use.
 * @export
 * @enum {string}
 */

export const FlowWorkFlows = {
    SlackDemo: 'slack_demo',
    WhatsappDemo: 'whatsapp_demo',
    ChatGptDemo: 'chat_gpt_demo'
} as const;

export type FlowWorkFlows = typeof FlowWorkFlows[keyof typeof FlowWorkFlows];


/**
 * A department or company grant in the folder roster.
 * @export
 * @interface FolderGrantEntry
 */
export interface FolderGrantEntry {
    /**
     * 
     * @type {string}
     * @memberof FolderGrantEntry
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantEntry
     */
    'type': FolderGrantEntryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantEntry
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantEntry
     */
    'team_id'?: string | null;
    /**
     * The department was disbanded; the grant admits nobody until the owner removes it.
     * @type {boolean}
     * @memberof FolderGrantEntry
     */
    'inactive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantEntry
     */
    'added_at': string;
}

export const FolderGrantEntryTypeEnum = {
    Department: 'department',
    Enterprise: 'enterprise'
} as const;

export type FolderGrantEntryTypeEnum = typeof FolderGrantEntryTypeEnum[keyof typeof FolderGrantEntryTypeEnum];

/**
 * A department or company grant on a folder, as a label: never the people it covers.
 * @export
 * @interface FolderGrantLabel
 */
export interface FolderGrantLabel {
    /**
     * 
     * @type {string}
     * @memberof FolderGrantLabel
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantLabel
     */
    'type': FolderGrantLabelTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantLabel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FolderGrantLabel
     */
    'team_id'?: string | null;
    /**
     * The department was disbanded; the grant admits nobody until the owner removes it.
     * @type {boolean}
     * @memberof FolderGrantLabel
     */
    'inactive'?: boolean;
}

export const FolderGrantLabelTypeEnum = {
    Department: 'department',
    Enterprise: 'enterprise'
} as const;

export type FolderGrantLabelTypeEnum = typeof FolderGrantLabelTypeEnum[keyof typeof FolderGrantLabelTypeEnum];

/**
 * Who the caller may share folders with; ``allowed`` is false when the org allows no sharing.
 * @export
 * @interface FolderGrantTargetsResponse
 */
export interface FolderGrantTargetsResponse {
    /**
     * 
     * @type {Array<GrantTargetDepartment>}
     * @memberof FolderGrantTargetsResponse
     */
    'departments': Array<GrantTargetDepartment>;
    /**
     * 
     * @type {GrantTargetEnterprise}
     * @memberof FolderGrantTargetsResponse
     */
    'enterprise': GrantTargetEnterprise | null;
    /**
     * 
     * @type {boolean}
     * @memberof FolderGrantTargetsResponse
     */
    'allowed': boolean;
}
/**
 * Folders the caller owns or is a member of; ``is_owner`` tells them apart.
 * @export
 * @interface FolderListResponse
 */
export interface FolderListResponse {
    /**
     * 
     * @type {Array<FolderSummary>}
     * @memberof FolderListResponse
     */
    'folders': Array<FolderSummary>;
}
/**
 * A meeting in a folder: full body for its owner, summary-only (``notes`` null) for a member.
 * @export
 * @interface FolderMeetingListItem
 */
export interface FolderMeetingListItem {
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'modified_at': string;
    /**
     * 
     * @type {Owner}
     * @memberof FolderMeetingListItem
     */
    'owner': Owner;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof FolderMeetingListItem
     */
    'caller_role': NoteShareRole;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'added_by_user_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'added_at': string;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListItem
     */
    'event_key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FolderMeetingListItem
     */
    'recorded_ms'?: number | null;
}


/**
 * One keyset page of a folder\'s meetings.
 * @export
 * @interface FolderMeetingListResponse
 */
export interface FolderMeetingListResponse {
    /**
     * 
     * @type {Array<FolderMeetingListItem>}
     * @memberof FolderMeetingListResponse
     */
    'meetings': Array<FolderMeetingListItem>;
    /**
     * 
     * @type {boolean}
     * @memberof FolderMeetingListResponse
     */
    'has_more'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FolderMeetingListResponse
     */
    'next_cursor'?: string | null;
}
/**
 * What happened to one requested address; ``user_id`` is set for ``added`` and ``already_member``.
 * @export
 * @interface FolderMemberAddResult
 */
export interface FolderMemberAddResult {
    /**
     * 
     * @type {string}
     * @memberof FolderMemberAddResult
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof FolderMemberAddResult
     */
    'outcome': FolderMemberAddResultOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof FolderMemberAddResult
     */
    'user_id'?: string | null;
}

export const FolderMemberAddResultOutcomeEnum = {
    Added: 'added',
    AlreadyMember: 'already_member',
    Duplicate: 'duplicate',
    Invalid: 'invalid',
    NotEligible: 'not_eligible',
    NoAccount: 'no_account',
    OwnAddress: 'own_address'
} as const;

export type FolderMemberAddResultOutcomeEnum = typeof FolderMemberAddResultOutcomeEnum[keyof typeof FolderMemberAddResultOutcomeEnum];

/**
 * One member of a folder; ``user_id`` is present only for the owner, who alone can remove.
 * @export
 * @interface FolderMemberEntry
 */
export interface FolderMemberEntry {
    /**
     * 
     * @type {string}
     * @memberof FolderMemberEntry
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMemberEntry
     */
    'email': string | null;
    /**
     * 
     * @type {Profile}
     * @memberof FolderMemberEntry
     */
    'profile'?: Profile | null;
    /**
     * 
     * @type {string}
     * @memberof FolderMemberEntry
     */
    'added_at': string;
}
/**
 * The folder owner and its members, oldest membership first.
 * @export
 * @interface FolderMemberListResponse
 */
export interface FolderMemberListResponse {
    /**
     * 
     * @type {FolderOwner}
     * @memberof FolderMemberListResponse
     */
    'owner': FolderOwner;
    /**
     * 
     * @type {Array<FolderMemberEntry>}
     * @memberof FolderMemberListResponse
     */
    'members': Array<FolderMemberEntry>;
    /**
     * Department and company grants, oldest first.
     * @type {Array<FolderGrantEntry>}
     * @memberof FolderMemberListResponse
     */
    'grants'?: Array<FolderGrantEntry>;
}
/**
 * The folder owner\'s identity for the \"shared by\" line.
 * @export
 * @interface FolderOwner
 */
export interface FolderOwner {
    /**
     * 
     * @type {string}
     * @memberof FolderOwner
     */
    'user_id': string;
    /**
     * 
     * @type {Profile}
     * @memberof FolderOwner
     */
    'profile'?: Profile | null;
}
/**
 * One folder row as listed for the caller.
 * @export
 * @interface FolderSummary
 */
export interface FolderSummary {
    /**
     * 
     * @type {string}
     * @memberof FolderSummary
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FolderSummary
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FolderSummary
     */
    'description': string | null;
    /**
     * 
     * @type {FolderOwner}
     * @memberof FolderSummary
     */
    'owner': FolderOwner;
    /**
     * 
     * @type {boolean}
     * @memberof FolderSummary
     */
    'is_owner': boolean;
    /**
     * 
     * @type {number}
     * @memberof FolderSummary
     */
    'meeting_count': number;
    /**
     * 
     * @type {number}
     * @memberof FolderSummary
     */
    'member_count': number;
    /**
     * 
     * @type {string}
     * @memberof FolderSummary
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof FolderSummary
     */
    'modified_at': string;
    /**
     * Department and company grants; people are in member_count.
     * @type {Array<FolderGrantLabel>}
     * @memberof FolderSummary
     */
    'grants'?: Array<FolderGrantLabel>;
    /**
     * The caller\'s widest access: owner, then a direct grant, department, company.
     * @type {string}
     * @memberof FolderSummary
     */
    'access_via'?: FolderSummaryAccessViaEnum;
    /**
     * The folder owner\'s org sharing policy shuts the caller out; see docs/meeting-recorder/sharing.md.
     * @type {boolean}
     * @memberof FolderSummary
     */
    'sharing_blocked': boolean;
}

export const FolderSummaryAccessViaEnum = {
    Owner: 'owner',
    Member: 'member',
    Department: 'department',
    Enterprise: 'enterprise'
} as const;

export type FolderSummaryAccessViaEnum = typeof FolderSummaryAccessViaEnum[keyof typeof FolderSummaryAccessViaEnum];

/**
 * Request to format raw transcript text with a named formatting model.
 * @export
 * @interface FormattingRequest
 */
export interface FormattingRequest {
    /**
     * Text content to format
     * @type {string}
     * @memberof FormattingRequest
     */
    'content': string;
    /**
     * Name of the model to use for formatting
     * @type {string}
     * @memberof FormattingRequest
     */
    'model_name': string;
}
/**
 * Supported GDPR request families.
 * @export
 * @enum {string}
 */

export const GdprKind = {
    AccountDeletion: 'account_deletion',
    UsageDataErasure: 'usage_data_erasure',
    DataExport: 'data_export',
    NotetakerPurge: 'notetaker_purge'
} as const;

export type GdprKind = typeof GdprKind[keyof typeof GdprKind];


/**
 * A durable request accepted for asynchronous processing.
 * @export
 * @interface GdprRequestAcceptedResponse
 */
export interface GdprRequestAcceptedResponse {
    /**
     * 
     * @type {string}
     * @memberof GdprRequestAcceptedResponse
     */
    'request_id': string;
    /**
     * 
     * @type {GdprKind}
     * @memberof GdprRequestAcceptedResponse
     */
    'kind': GdprKind;
    /**
     * 
     * @type {GdprRequestState}
     * @memberof GdprRequestAcceptedResponse
     */
    'state': GdprRequestState;
    /**
     * 
     * @type {string}
     * @memberof GdprRequestAcceptedResponse
     */
    'complete_by'?: string | null;
}


/**
 * Bounded terminal evidence for one attempt.
 * @export
 * @interface GdprRequestAttemptSummary
 */
export interface GdprRequestAttemptSummary {
    /**
     * 
     * @type {number}
     * @memberof GdprRequestAttemptSummary
     */
    'attempt': number;
    /**
     * 
     * @type {GdprRequestOutcome}
     * @memberof GdprRequestAttemptSummary
     */
    'outcome': GdprRequestOutcome;
    /**
     * 
     * @type {string}
     * @memberof GdprRequestAttemptSummary
     */
    'terminal_at': string;
    /**
     * 
     * @type {string}
     * @memberof GdprRequestAttemptSummary
     */
    'failure_code'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GdprRequestAttemptSummary
     */
    'warning_codes'?: Array<string>;
}


/**
 * Protected email lookup input; email is never echoed back.
 * @export
 * @interface GdprRequestLookupByEmailRequest
 */
export interface GdprRequestLookupByEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof GdprRequestLookupByEmailRequest
     */
    'email': string;
}
/**
 * Terminal outcomes recorded by a GDPR workflow attempt.
 * @export
 * @enum {string}
 */

export const GdprRequestOutcome = {
    Completed: 'completed',
    CompletedWithWarnings: 'completed_with_warnings',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type GdprRequestOutcome = typeof GdprRequestOutcome[keyof typeof GdprRequestOutcome];


/**
 * Optional support reason for an explicit failed-only retry.
 * @export
 * @interface GdprRequestRetryRequest
 */
export interface GdprRequestRetryRequest {
    /**
     * 
     * @type {string}
     * @memberof GdprRequestRetryRequest
     */
    'reason'?: string | null;
}
/**
 * Origin that determines GDPR-request authorization and timing.
 * @export
 * @enum {string}
 */

export const GdprRequestSource = {
    User: 'user',
    Support: 'support',
    Sandbox: 'sandbox'
} as const;

export type GdprRequestSource = typeof GdprRequestSource[keyof typeof GdprRequestSource];


/**
 * Optional support reason for an account-deletion request.
 * @export
 * @interface GdprRequestStartRequest
 */
export interface GdprRequestStartRequest {
    /**
     * 
     * @type {string}
     * @memberof GdprRequestStartRequest
     */
    'reason'?: string | null;
}
/**
 * Persisted lifecycle values shared by GDPR requests.
 * @export
 * @enum {string}
 */

export const GdprRequestState = {
    StartFailed: 'start_failed',
    Accepted: 'accepted',
    InitialCleanup: 'initial_cleanup',
    Waiting: 'waiting',
    Erasing: 'erasing',
    AwaitingClickhouse: 'awaiting_clickhouse',
    Completed: 'completed',
    CompletedWithWarnings: 'completed_with_warnings',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type GdprRequestState = typeof GdprRequestState[keyof typeof GdprRequestState];


/**
 * Operational status without raw identity or provider payloads.
 * @export
 * @interface GdprRequestStatusResponse
 */
export interface GdprRequestStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof GdprRequestStatusResponse
     */
    'request_id': string;
    /**
     * 
     * @type {GdprKind}
     * @memberof GdprRequestStatusResponse
     */
    'kind': GdprKind;
    /**
     * 
     * @type {GdprRequestSource}
     * @memberof GdprRequestStatusResponse
     */
    'source': GdprRequestSource;
    /**
     * 
     * @type {GdprRequestState}
     * @memberof GdprRequestStatusResponse
     */
    'state': GdprRequestState;
    /**
     * 
     * @type {number}
     * @memberof GdprRequestStatusResponse
     */
    'attempt': number;
    /**
     * 
     * @type {string}
     * @memberof GdprRequestStatusResponse
     */
    'complete_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GdprRequestStatusResponse
     */
    'failure_code'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GdprRequestStatusResponse
     */
    'warning_codes'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GdprRequestStatusResponse
     */
    'per_step'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Array<GdprRequestAttemptSummary>}
     * @memberof GdprRequestStatusResponse
     */
    'attempts'?: Array<GdprRequestAttemptSummary>;
}


/**
 * Request body for the backend-owned all-user generate-and-send endpoint.
 * @export
 * @interface GenerateAndSendFlowStateRequest
 */
export interface GenerateAndSendFlowStateRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateAndSendFlowStateRequest
     */
    'reporting_month': string;
    /**
     * 
     * @type {number}
     * @memberof GenerateAndSendFlowStateRequest
     */
    'min_word_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateAndSendFlowStateRequest
     */
    'min_app_count'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateAndSendFlowStateRequest
     */
    'dry_run'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateAndSendFlowStateRequest
     */
    'resend_failed'?: boolean;
}
/**
 * Request body for the marketing profile generation endpoint.
 * @export
 * @interface GenerateFlowStateRequest
 */
export interface GenerateFlowStateRequest {
    /**
     * 
     * @type {string}
     * @memberof GenerateFlowStateRequest
     */
    'reporting_month': string;
    /**
     * 
     * @type {number}
     * @memberof GenerateFlowStateRequest
     */
    'min_word_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof GenerateFlowStateRequest
     */
    'min_app_count'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateFlowStateRequest
     */
    'user_ids'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GenerateFlowStateRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GenerateFlowStateRequest
     */
    'domain'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateFlowStateRequest
     */
    'all_users'?: boolean;
}
/**
 * Response for the /geo endpoint with country code and region.
 * @export
 * @interface GeoResponse
 */
export interface GeoResponse {
    /**
     * 
     * @type {string}
     * @memberof GeoResponse
     */
    'country_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GeoResponse
     */
    'region': GeoResponseRegionEnum;
}

export const GeoResponseRegionEnum = {
    Us: 'us',
    Europe: 'europe',
    Apac: 'apac'
} as const;

export type GeoResponseRegionEnum = typeof GeoResponseRegionEnum[keyof typeof GeoResponseRegionEnum];

/**
 * A single calendar event surfaced by a connector search.
 * @export
 * @interface GoogleCalendarEvent
 */
export interface GoogleCalendarEvent {
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'end': string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'organizer'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleCalendarEvent
     */
    'attendees'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GoogleCalendarEvent
     */
    'url'?: string | null;
}
/**
 * An active department the caller may share a folder with.
 * @export
 * @interface GrantTargetDepartment
 */
export interface GrantTargetDepartment {
    /**
     * 
     * @type {string}
     * @memberof GrantTargetDepartment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantTargetDepartment
     */
    'name': string;
    /**
     * People in the department a department grant admits today.
     * @type {number}
     * @memberof GrantTargetDepartment
     */
    'member_count': number;
}
/**
 * The caller\'s company, for \"Everyone at <company>\".
 * @export
 * @interface GrantTargetEnterprise
 */
export interface GrantTargetEnterprise {
    /**
     * 
     * @type {string}
     * @memberof GrantTargetEnterprise
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GrantTargetEnterprise
     */
    'name': string;
    /**
     * People in the company a company grant admits today, the caller included.
     * @type {number}
     * @memberof GrantTargetEnterprise
     */
    'member_count': number;
}
/**
 * An exclusive searched position; a nonzero line resumes inside that exact file version.
 * @export
 * @interface GrepCursor
 */
export interface GrepCursor {
    /**
     * 
     * @type {string}
     * @memberof GrepCursor
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof GrepCursor
     */
    'line'?: number;
    /**
     * 
     * @type {number}
     * @memberof GrepCursor
     */
    'version': number;
    /**
     * 
     * @type {number}
     * @memberof GrepCursor
     */
    'erasure_epoch': number;
    /**
     * 
     * @type {number}
     * @memberof GrepCursor
     */
    'learning_generation': number;
}
/**
 * One matching source line at a named file version.
 * @export
 * @interface GrepMatch
 */
export interface GrepMatch {
    /**
     * 
     * @type {string}
     * @memberof GrepMatch
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof GrepMatch
     */
    'version': number;
    /**
     * 
     * @type {number}
     * @memberof GrepMatch
     */
    'line': number;
    /**
     * 
     * @type {string}
     * @memberof GrepMatch
     */
    'text': string;
}
/**
 * A bounded literal text search within a file prefix.
 * @export
 * @interface GrepRequest
 */
export interface GrepRequest {
    /**
     * 
     * @type {string}
     * @memberof GrepRequest
     */
    'query': string;
    /**
     * 
     * @type {string}
     * @memberof GrepRequest
     */
    'prefix'?: string;
    /**
     * 
     * @type {GrepCursor}
     * @memberof GrepRequest
     */
    'cursor'?: GrepCursor | null;
    /**
     * 
     * @type {number}
     * @memberof GrepRequest
     */
    'limit'?: number;
}
/**
 * Bounded literal matches and the observed generation.
 * @export
 * @interface GrepResponse
 */
export interface GrepResponse {
    /**
     * 
     * @type {Array<GrepMatch>}
     * @memberof GrepResponse
     */
    'matches': Array<GrepMatch>;
    /**
     * 
     * @type {ReadToken}
     * @memberof GrepResponse
     */
    'token': ReadToken;
    /**
     * 
     * @type {boolean}
     * @memberof GrepResponse
     */
    'truncated': boolean;
    /**
     * 
     * @type {GrepCursor}
     * @memberof GrepResponse
     */
    'next_cursor'?: GrepCursor | null;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Per-day data for the calendar heatmap.
 * @export
 * @interface HeatmapDay
 */
export interface HeatmapDay {
    /**
     * 
     * @type {string}
     * @memberof HeatmapDay
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof HeatmapDay
     */
    'desktop_words': number;
    /**
     * 
     * @type {number}
     * @memberof HeatmapDay
     */
    'mobile_words': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof HeatmapDay
     */
    'desktop_apps'?: { [key: string]: number; } | null;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof HeatmapDay
     */
    'mobile_apps'?: { [key: string]: number; } | null;
}
/**
 * Heatmap data for a date range.
 * @export
 * @interface HeatmapResponse
 */
export interface HeatmapResponse {
    /**
     * 
     * @type {Array<HeatmapDay>}
     * @memberof HeatmapResponse
     */
    'days': Array<HeatmapDay>;
    /**
     * 
     * @type {string}
     * @memberof HeatmapResponse
     */
    'account_created_at': string;
}
/**
 * User feedback on a single history transcript, with the surrounding context that produced it.
 * @export
 * @interface HistoryFeedbackRequest
 */
export interface HistoryFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'transcriptEntityId': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'asrText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'formattedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'serverFinalizedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'pastedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'feedback': string;
    /**
     * 
     * @type {File}
     * @memberof HistoryFeedbackRequest
     */
    'audio'?: File | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof HistoryFeedbackRequest
     */
    'logs'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryFeedbackRequest
     */
    'usedFallbackAsr'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof HistoryFeedbackRequest
     */
    'usedFallbackFormatting'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'architecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'region'?: string;
    /**
     * 
     * @type {Codec}
     * @memberof HistoryFeedbackRequest
     */
    'codec'?: Codec;
    /**
     * 
     * @type {SrcCommonConstantsPlatform}
     * @memberof HistoryFeedbackRequest
     */
    'platform'?: SrcCommonConstantsPlatform;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'imageData'?: string | null;
    /**
     * 
     * @type {ImageType}
     * @memberof HistoryFeedbackRequest
     */
    'imageType'?: ImageType | null;
    /**
     * 
     * @type {string}
     * @memberof HistoryFeedbackRequest
     */
    'appVersion'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof HistoryFeedbackRequest
     */
    'selectedLanguages'?: Array<string> | null;
}


/**
 * A single dictation-history entry (formatted text, timestamp, app, detected language).
 * @export
 * @interface HistoryRow
 */
export interface HistoryRow {
    /**
     * 
     * @type {string}
     * @memberof HistoryRow
     */
    'formatted_text': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryRow
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryRow
     */
    'app_name': string;
    /**
     * 
     * @type {string}
     * @memberof HistoryRow
     */
    'detected_language'?: string | null;
}
/**
 * Batch of history rows (with privacy mode and timezone) used to compute a recap.
 * @export
 * @interface HistoryRowsRequest
 */
export interface HistoryRowsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof HistoryRowsRequest
     */
    'privacy_mode': boolean;
    /**
     * 
     * @type {Array<HistoryRow>}
     * @memberof HistoryRowsRequest
     */
    'history_rows': Array<HistoryRow>;
    /**
     * 
     * @type {string}
     * @memberof HistoryRowsRequest
     */
    'timezone'?: string | null;
}
/**
 * Geographic location resolved from an IP address.
 * @export
 * @interface IPLocation
 */
export interface IPLocation {
    /**
     * 
     * @type {string}
     * @memberof IPLocation
     */
    'ip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPLocation
     */
    'country_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IPLocation
     */
    'country_name'?: string | null;
}
/**
 * An owner-scoped contact link, an observed label, or both.
 * @export
 * @interface IdentityTarget
 */
export interface IdentityTarget {
    /**
     * 
     * @type {string}
     * @memberof IdentityTarget
     */
    'room'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityTarget
     */
    'roomVoice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityTarget
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityTarget
     */
    'contactId'?: string | null;
}
/**
 * Supported screenshot format.
 * @export
 * @enum {string}
 */

export const ImageType = {
    ImagePng: 'image/png',
    ImageJpeg: 'image/jpeg',
    ImageBmp: 'image/bmp',
    ImageWebp: 'image/webp'
} as const;

export type ImageType = typeof ImageType[keyof typeof ImageType];


/**
 * Image the client wants to upload, declared inline with /notes/sync.
 * @export
 * @interface ImageUpload
 */
export interface ImageUpload {
    /**
     * 
     * @type {string}
     * @memberof ImageUpload
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof ImageUpload
     */
    'size_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof ImageUpload
     */
    'content_type': ImageUploadContentTypeEnum;
}

export const ImageUploadContentTypeEnum = {
    ImageWebp: 'image/webp',
    ImagePng: 'image/png',
    ImageJpeg: 'image/jpeg',
    ImageGif: 'image/gif'
} as const;

export type ImageUploadContentTypeEnum = typeof ImageUploadContentTypeEnum[keyof typeof ImageUploadContentTypeEnum];

/**
 * Presigned POST for a pending key whose blob is not yet in S3.
 * @export
 * @interface ImageUploadUrl
 */
export interface ImageUploadUrl {
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrl
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof ImageUploadUrl
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ImageUploadUrl
     */
    'fields': { [key: string]: string; };
}
/**
 * Impact-tab payload: minutes saved, prompt quality, dictionary, formatting, and ROI inputs.
 * @export
 * @interface ImpactResponse
 */
export interface ImpactResponse {
    /**
     * 
     * @type {TeamInsightsFilters}
     * @memberof ImpactResponse
     */
    'filters_applied': TeamInsightsFilters;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImpactResponse
     */
    'data_quality_flags'?: Array<string>;
    /**
     * 
     * @type {MinutesSaved}
     * @memberof ImpactResponse
     */
    'minutes_saved': MinutesSaved;
    /**
     * 
     * @type {AiPromptQuality}
     * @memberof ImpactResponse
     */
    'ai_prompt_quality': AiPromptQuality;
    /**
     * 
     * @type {DictionaryStats}
     * @memberof ImpactResponse
     */
    'dictionary': DictionaryStats;
    /**
     * 
     * @type {AutoFormatting}
     * @memberof ImpactResponse
     */
    'auto_formatting': AutoFormatting;
    /**
     * 
     * @type {Array<FeatureUtilization>}
     * @memberof ImpactResponse
     */
    'features_utilized': Array<FeatureUtilization>;
    /**
     * 
     * @type {ValueCalculator}
     * @memberof ImpactResponse
     */
    'value_calculator': ValueCalculator;
}
/**
 * Active incident details returned in the status response.
 * @export
 * @interface IncidentStatusDetail
 */
export interface IncidentStatusDetail {
    /**
     * 
     * @type {string}
     * @memberof IncidentStatusDetail
     */
    'state': IncidentStatusDetailStateEnum;
    /**
     * 
     * @type {string}
     * @memberof IncidentStatusDetail
     */
    'message': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IncidentStatusDetail
     */
    'affected_regions': Array<IncidentStatusDetailAffectedRegionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof IncidentStatusDetail
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof IncidentStatusDetail
     */
    'incident_url': string;
}

export const IncidentStatusDetailStateEnum = {
    Degraded: 'degraded',
    Outage: 'outage'
} as const;

export type IncidentStatusDetailStateEnum = typeof IncidentStatusDetailStateEnum[keyof typeof IncidentStatusDetailStateEnum];
export const IncidentStatusDetailAffectedRegionsEnum = {
    Us: 'us',
    Europe: 'europe',
    Apac: 'apac'
} as const;

export type IncidentStatusDetailAffectedRegionsEnum = typeof IncidentStatusDetailAffectedRegionsEnum[keyof typeof IncidentStatusDetailAffectedRegionsEnum];

/**
 * Response for the unauthenticated incident-status endpoint.
 * @export
 * @interface IncidentStatusResponse
 */
export interface IncidentStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof IncidentStatusResponse
     */
    'client_region': IncidentStatusResponseClientRegionEnum;
    /**
     * 
     * @type {IncidentStatusDetail}
     * @memberof IncidentStatusResponse
     */
    'incident_status': IncidentStatusDetail | null;
}

export const IncidentStatusResponseClientRegionEnum = {
    Us: 'us',
    Europe: 'europe',
    Apac: 'apac'
} as const;

export type IncidentStatusResponseClientRegionEnum = typeof IncidentStatusResponseClientRegionEnum[keyof typeof IncidentStatusResponseClientRegionEnum];

/**
 * Per-event ingest outcome, keyed by the client event id.
 * @export
 * @interface IngestResultRow
 */
export interface IngestResultRow {
    /**
     * 
     * @type {string}
     * @memberof IngestResultRow
     */
    'client_event_id': string;
    /**
     * 
     * @type {string}
     * @memberof IngestResultRow
     */
    'status': IngestResultRowStatusEnum;
}

export const IngestResultRowStatusEnum = {
    Accepted: 'accepted',
    Rejected: 'rejected'
} as const;

export type IngestResultRowStatusEnum = typeof IngestResultRowStatusEnum[keyof typeof IngestResultRowStatusEnum];

/**
 * Request to start connecting a connector identified by its key.
 * @export
 * @interface InitiateConnectionRequest
 */
export interface InitiateConnectionRequest {
    /**
     * 
     * @type {ConnectorKey}
     * @memberof InitiateConnectionRequest
     */
    'key': ConnectorKey;
    /**
     * 
     * @type {string}
     * @memberof InitiateConnectionRequest
     */
    'callback_url'?: string | null;
}


/**
 * 
 * @export
 * @interface InitiateConnectionResponse
 */
export interface InitiateConnectionResponse {
    /**
     * 
     * @type {string}
     * @memberof InitiateConnectionResponse
     */
    'connection_id': string;
    /**
     * 
     * @type {string}
     * @memberof InitiateConnectionResponse
     */
    'redirect_url'?: string | null;
}
/**
 * Independent voice targets; contact identity is the only shared human identity.
 * @export
 * @interface InlineSpeakerAssignment
 */
export interface InlineSpeakerAssignment {
    /**
     * 
     * @type {string}
     * @memberof InlineSpeakerAssignment
     */
    'room'?: string | null;
    /**
     * 
     * @type {IdentityTarget}
     * @memberof InlineSpeakerAssignment
     */
    'user'?: IdentityTarget | null;
    /**
     * 
     * @type {IdentityTarget}
     * @memberof InlineSpeakerAssignment
     */
    'dom'?: IdentityTarget | null;
    /**
     * 
     * @type {IdentityTarget}
     * @memberof InlineSpeakerAssignment
     */
    'mic'?: IdentityTarget | null;
    /**
     * 
     * @type {IdentityTarget}
     * @memberof InlineSpeakerAssignment
     */
    'llm'?: IdentityTarget | null;
}
/**
 * Stats-only insights data (no heatmap).
 * @export
 * @interface InsightsResponse
 */
export interface InsightsResponse {
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'words_per_minute': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'wpm_percentile': number;
    /**
     * Keyboard-typist WPM bucket boundaries (one per quantile in wpm_bucket_quantiles). Log-normal fit to the typing-speed distribution in Dhakal et al., \'Observations on Typing from 136 Million Keystrokes\' (CHI 2018): N=168,960, mean 51.56 WPM, SD 20.20 WPM. Intentionally the slower keyboard cohort so dictating users surface as exceptional. Clients use these with wpm_bucket_quantiles to recompute percentile locally after an optimistic WPM update.
     * @type {Array<number>}
     * @memberof InsightsResponse
     */
    'wpm_buckets'?: Array<number>;
    /**
     * Quantile labels (0.0-1.0) matching wpm_buckets one-to-one; currently 1-94 at 1% intervals then 95.0-99.9 at 0.1%. Shipped alongside the buckets so clients stay in sync if the backend reshapes the distribution.
     * @type {Array<number>}
     * @memberof InsightsResponse
     */
    'wpm_bucket_quantiles'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'desktop_total_words_corrected': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'mobile_total_words_corrected': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'desktop_total_dictionary_replacements': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'mobile_total_dictionary_replacements': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'total_words': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'desktop_total_words': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'mobile_total_words': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'monthly_word_delta_percent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'previous_month_total_words'?: number | null;
    /**
     * 
     * @type {Array<AppCategoryUsage>}
     * @memberof InsightsResponse
     */
    'desktop_usage': Array<AppCategoryUsage>;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'desktop_total_apps_used': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'current_streak': number;
    /**
     * 
     * @type {number}
     * @memberof InsightsResponse
     */
    'longest_streak': number;
}
/**
 * One instruct chat session grouping a back-and-forth of turns.
 * @export
 * @interface InstructChatSessionRecord
 */
export interface InstructChatSessionRecord {
    /**
     * 
     * @type {string}
     * @memberof InstructChatSessionRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InstructChatSessionRecord
     */
    'title'?: string | null;
}
/**
 * An instruct-mode feedback submission (thumbs up or down) forwarded to Slack.
 * @export
 * @interface InstructFeedbackRequest
 */
export interface InstructFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'feedback_text': string;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'rating'?: InstructFeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'utterance'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'response'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'app_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'instruct_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'sentry_trace_url'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof InstructFeedbackRequest
     */
    'report_data'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof InstructFeedbackRequest
     */
    'ax_report_html'?: string | null;
}

export const InstructFeedbackRequestRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type InstructFeedbackRequestRatingEnum = typeof InstructFeedbackRequestRatingEnum[keyof typeof InstructFeedbackRequestRatingEnum];

/**
 * User thumbs-up/down feedback on an instruct route, with optional text.
 * @export
 * @interface InstructHistoryFeedback
 */
export interface InstructHistoryFeedback {
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryFeedback
     */
    'rating': InstructHistoryFeedbackRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryFeedback
     */
    'text'?: string | null;
}

export const InstructHistoryFeedbackRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type InstructHistoryFeedbackRatingEnum = typeof InstructHistoryFeedbackRatingEnum[keyof typeof InstructHistoryFeedbackRatingEnum];

/**
 * One client-uploaded route-classification row.  A single dictation turn can run a *sequence* of tools (the realtime voice path chains them — e.g. query_user_local_data -> instruct -> paste). ``tool_calls`` is that execution log: one self-describing element per call with its own ``name``, input, output and latency. ``classifier_*`` fields describe the single classify-intent step (gRPC/HTTP path; the realtime path has no separate classifier). ``instruct_session_id``/``session_turn_index`` group turns of one instruct chat back-and-forth.
 * @export
 * @interface InstructHistoryRecord
 */
export interface InstructHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'transcript_entity_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'polish_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InstructHistoryRecord
     */
    'was_auto_routed'?: boolean;
    /**
     * 
     * @type {ClassificationMode}
     * @memberof InstructHistoryRecord
     */
    'classification_mode'?: ClassificationMode | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'short_circuit_route'?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof InstructHistoryRecord
     */
    'routes_payload'?: Array<object> | null;
    /**
     * 
     * @type {object}
     * @memberof InstructHistoryRecord
     */
    'context_payload'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof InstructHistoryRecord
     */
    'config_payload'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof InstructHistoryRecord
     */
    'classifier_route_data'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'classifier_model_version'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof InstructHistoryRecord
     */
    'classifier_used_provider'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof InstructHistoryRecord
     */
    'classifier_latency_ms'?: number | null;
    /**
     * 
     * @type {ClassifierStatus}
     * @memberof InstructHistoryRecord
     */
    'classifier_status'?: ClassifierStatus | null;
    /**
     * 
     * @type {InstructHistoryStatus}
     * @memberof InstructHistoryRecord
     */
    'route_status'?: InstructHistoryStatus | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'route_error'?: string | null;
    /**
     * 
     * @type {Array<InstructToolCall>}
     * @memberof InstructHistoryRecord
     */
    'tool_calls'?: Array<InstructToolCall> | null;
    /**
     * 
     * @type {InstructHistoryFeedback}
     * @memberof InstructHistoryRecord
     */
    'feedback'?: InstructHistoryFeedback | null;
    /**
     * 
     * @type {object}
     * @memberof InstructHistoryRecord
     */
    'edit_artifact'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'instruct_session_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InstructHistoryRecord
     */
    'session_turn_index'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof InstructHistoryRecord
     */
    'app_version': string;
}


/**
 * End-to-end outcome of the resolved dictation route.
 * @export
 * @enum {string}
 */

export const InstructHistoryStatus = {
    Succeeded: 'succeeded',
    ClassifierFailed: 'classifier_failed',
    ClassifierTimeout: 'classifier_timeout',
    ShortCircuitUsed: 'short_circuit_used',
    RouteError: 'route_error',
    PasteFailed: 'paste_failed',
    Cancelled: 'cancelled',
    NoText: 'no_text',
    NotEditable: 'not_editable'
} as const;

export type InstructHistoryStatus = typeof InstructHistoryStatus[keyof typeof InstructHistoryStatus];


/**
 * Instruct-mode request: an instruction plus screen/app context and prior session turns.
 * @export
 * @interface InstructModeRequest
 */
export interface InstructModeRequest {
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'instruction': string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'screen_context': string;
    /**
     * 
     * @type {TransformProviderConfig}
     * @memberof InstructModeRequest
     */
    'provider_config'?: TransformProviderConfig | null;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'selected_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'before_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'after_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'app_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'app_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstructModeRequest
     */
    'user_voice_preference'?: string | null;
    /**
     * 
     * @type {Array<InstructSessionHistoryMessage>}
     * @memberof InstructModeRequest
     */
    'session_history'?: Array<InstructSessionHistoryMessage>;
}
/**
 * Instruct-mode result containing the generated content.
 * @export
 * @interface InstructModeResponse
 */
export interface InstructModeResponse {
    /**
     * 
     * @type {string}
     * @memberof InstructModeResponse
     */
    'content': string;
}
/**
 * One prior turn of an instruct chat session, mirroring what the chat UI shows.
 * @export
 * @interface InstructSessionHistoryMessage
 */
export interface InstructSessionHistoryMessage {
    /**
     * 
     * @type {string}
     * @memberof InstructSessionHistoryMessage
     */
    'role': InstructSessionHistoryMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof InstructSessionHistoryMessage
     */
    'content': string;
}

export const InstructSessionHistoryMessageRoleEnum = {
    User: 'user',
    Assistant: 'assistant'
} as const;

export type InstructSessionHistoryMessageRoleEnum = typeof InstructSessionHistoryMessageRoleEnum[keyof typeof InstructSessionHistoryMessageRoleEnum];

/**
 * One tool/route invocation within a dictation turn, in execution order.  ``input``/``output`` shapes are owned by the desktop per tool; server-side enforcement would block adding a tool without a coordinated deploy.
 * @export
 * @interface InstructToolCall
 */
export interface InstructToolCall {
    /**
     * 
     * @type {string}
     * @memberof InstructToolCall
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof InstructToolCall
     */
    'input'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof InstructToolCall
     */
    'output'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof InstructToolCall
     */
    'latency_ms'?: number | null;
}
/**
 * Server-computed provisioning math plus warnings/blockers. No writes are performed.
 * @export
 * @interface InternalCostCenterProvisionPreviewResponse
 */
export interface InternalCostCenterProvisionPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'user_email': string;
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'team_name': string;
    /**
     * 
     * @type {number}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'committed_seats': number;
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'stripe_price_id': string;
    /**
     * 
     * @type {number}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'unit_amount_cents': number | null;
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'annual_total_cents': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'warnings': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalCostCenterProvisionPreviewResponse
     */
    'blocking_errors': Array<string>;
}
/**
 * Shared body for preview-provision and provision (same payload for both).
 * @export
 * @interface InternalCostCenterProvisionRequest
 */
export interface InternalCostCenterProvisionRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionRequest
     */
    'enterprise_id': string;
    /**
     * Picked user: becomes the cost center\'s billing owner and invoice recipient
     * @type {string}
     * @memberof InternalCostCenterProvisionRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionRequest
     */
    'team_name': string;
    /**
     * Committed seat count (high-water mark) the subscription is created with
     * @type {number}
     * @memberof InternalCostCenterProvisionRequest
     */
    'committed_seats': number;
    /**
     * Client-minted per commit; keys the Stripe create calls so a double submit can\'t duplicate them
     * @type {string}
     * @memberof InternalCostCenterProvisionRequest
     */
    'idempotency_root': string;
}
/**
 * Successful-provision result: the created cost center, team, and invoice.
 * @export
 * @interface InternalCostCenterProvisionResponse
 */
export interface InternalCostCenterProvisionResponse {
    /**
     * 
     * @type {ProvisionedCostCenterSummary}
     * @memberof InternalCostCenterProvisionResponse
     */
    'cost_center': ProvisionedCostCenterSummary;
    /**
     * 
     * @type {ProvisionedTeamSummary}
     * @memberof InternalCostCenterProvisionResponse
     */
    'team': ProvisionedTeamSummary;
    /**
     * 
     * @type {ProvisionedInvoiceSummary}
     * @memberof InternalCostCenterProvisionResponse
     */
    'invoice': ProvisionedInvoiceSummary;
    /**
     * 
     * @type {string}
     * @memberof InternalCostCenterProvisionResponse
     */
    'stripe_subscription_id': string;
}
/**
 * Internal admin request to send a notification to specific email addresses.
 * @export
 * @interface InternalNotificationCreateRequest
 */
export interface InternalNotificationCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalNotificationCreateRequest
     */
    'emails': Array<string>;
    /**
     * 
     * @type {NotificationCreateRequest}
     * @memberof InternalNotificationCreateRequest
     */
    'notification': NotificationCreateRequest;
}
/**
 * Result of resending one invitation; missing, foreign and non-resendable ids all report ``ineligible``.
 * @export
 * @enum {string}
 */

export const InvitationResendOutcome = {
    Sent: 'sent',
    SkippedCooldown: 'skipped_cooldown',
    Ineligible: 'ineligible',
    Failed: 'failed'
} as const;

export type InvitationResendOutcome = typeof InvitationResendOutcome[keyof typeof InvitationResendOutcome];


/**
 * One invitation\'s resend outcome; ``retry_after_seconds`` is set for ``sent`` and ``skipped_cooldown``.
 * @export
 * @interface InvitationResendResult
 */
export interface InvitationResendResult {
    /**
     * 
     * @type {string}
     * @memberof InvitationResendResult
     */
    'invitation_id': string;
    /**
     * 
     * @type {InvitationResendOutcome}
     * @memberof InvitationResendResult
     */
    'outcome': InvitationResendOutcome;
    /**
     * 
     * @type {number}
     * @memberof InvitationResendResult
     */
    'retry_after_seconds': number | null;
}


/**
 * A single enterprise invite: an email and the role to grant.
 * @export
 * @interface InviteRequest
 */
export interface InviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteRequest
     */
    'team_id'?: string | null;
    /**
     * 
     * @type {SeatType}
     * @memberof InviteRequest
     */
    'intended_seat_type'?: SeatType | null;
}


/**
 * Response model for a single invitation.
 * @export
 * @interface InviteResponse
 */
export interface InviteResponse {
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'email': string;
    /**
     * 
     * @type {InviteStatus}
     * @memberof InviteResponse
     */
    'status': InviteStatus;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'expiresAt': string;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof InviteResponse
     */
    'role': EnterpriseRole;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'invitedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'acceptedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'revokedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'removedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'lastSentAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteResponse
     */
    'team_id'?: string | null;
    /**
     * 
     * @type {SeatType}
     * @memberof InviteResponse
     */
    'intended_seat_type'?: SeatType | null;
}


/**
 * Status of an enterprise invitation.
 * @export
 * @enum {string}
 */

export const InviteStatus = {
    Pending: 'pending',
    Accepted: 'accepted',
    Expired: 'expired',
    Error: 'error',
    Removed: 'removed',
    Revoked: 'revoked',
    AdminRemoved: 'admin_removed',
    ScimRemoved: 'scim_removed'
} as const;

export type InviteStatus = typeof InviteStatus[keyof typeof InviteStatus];


/**
 * Response model for list of invitations.
 * @export
 * @interface InvitesResponse
 */
export interface InvitesResponse {
    /**
     * 
     * @type {Array<InviteResponse>}
     * @memberof InvitesResponse
     */
    'invitations': Array<InviteResponse>;
}
/**
 * A minimal Stripe invoice projection for the operator-UI picker.  Fields are taken directly from the Stripe ``Invoice`` object. ``amount_due`` is in the currency\'s minor unit (cents for USD). ``number`` is null on invoices that have never been finalized (drafts).
 * @export
 * @interface InvoiceSummary
 */
export interface InvoiceSummary {
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'number': string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'status': string;
    /**
     * Amount due in the currency\'s minor unit (e.g. cents).
     * @type {number}
     * @memberof InvoiceSummary
     */
    'amount_due': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'due_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceSummary
     */
    'hosted_invoice_url': string | null;
}
/**
 * Response model for an enterprise join request.
 * @export
 * @interface JoinRequest
 */
export interface JoinRequest {
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'user_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'user_first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'user_last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'user_avatar_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'status': JoinRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'approved_by_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'approved_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'rejected_by_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JoinRequest
     */
    'rejected_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JoinRequest
     */
    'teamTrialGiven'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof JoinRequest
     */
    'trialEndsAt'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof JoinRequest
     */
    'hasIndividualSubscription'?: boolean | null;
}

export const JoinRequestStatusEnum = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type JoinRequestStatusEnum = typeof JoinRequestStatusEnum[keyof typeof JoinRequestStatusEnum];

/**
 * A batch of keyboard touch aggregate cells uploaded by the client.
 * @export
 * @interface KbTouchBatch
 */
export interface KbTouchBatch {
    /**
     * 
     * @type {string}
     * @memberof KbTouchBatch
     */
    'batch_id': string;
    /**
     * 
     * @type {Array<KbTouchCell>}
     * @memberof KbTouchBatch
     */
    'cells': Array<KbTouchCell>;
}
/**
 * A single per-key moment-counter cell aggregated on-device.
 * @export
 * @interface KbTouchCell
 */
export interface KbTouchCell {
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'device_diag': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'device_model': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'os_major': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'app_version': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'layout_id': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'orientation': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'key_id': string;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sub_cell': number;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'intended_key': string;
    /**
     * 
     * @type {string}
     * @memberof KbTouchCell
     */
    'label_source': string;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'n': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_dx': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_dy': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_dx2': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_dy2': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_dxdy': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_t': number;
    /**
     * 
     * @type {number}
     * @memberof KbTouchCell
     */
    'sum_t2': number;
}
/**
 * Response reporting how many touch cells were accepted for ingestion.
 * @export
 * @interface KbTouchIngestResponse
 */
export interface KbTouchIngestResponse {
    /**
     * 
     * @type {number}
     * @memberof KbTouchIngestResponse
     */
    'accepted': number;
}
/**
 * A single keystroke event with key and timestamp.
 * @export
 * @interface Keystroke
 */
export interface Keystroke {
    /**
     * 
     * @type {string}
     * @memberof Keystroke
     */
    'key': string;
    /**
     * Timestamp in milliseconds
     * @type {number}
     * @memberof Keystroke
     */
    'time': number;
}
/**
 * List of languages the user speaks
 * @export
 * @interface Language
 */
export interface Language {
}
/**
 * A single leaderboard entry.
 * @export
 * @interface LeaderboardEntry
 */
export interface LeaderboardEntry {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardEntry
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardEntry
     */
    'display_name': string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardEntry
     */
    'typing_wpm': number;
}
/**
 * Top 6 users per leaderboard category (plus the caller), split by time window.
 * @export
 * @interface LeaderboardPodiums
 */
export interface LeaderboardPodiums {
    /**
     * 
     * @type {AllTimePodiums}
     * @memberof LeaderboardPodiums
     */
    'all_time'?: AllTimePodiums;
    /**
     * 
     * @type {ThisWeekPodiums}
     * @memberof LeaderboardPodiums
     */
    'this_week'?: ThisWeekPodiums;
}
/**
 * Leaderboard with top ranked users and the caller\'s best.
 * @export
 * @interface LeaderboardResponse
 */
export interface LeaderboardResponse {
    /**
     * 
     * @type {Array<LeaderboardEntry>}
     * @memberof LeaderboardResponse
     */
    'top_ranked': Array<LeaderboardEntry>;
    /**
     * 
     * @type {LeaderboardEntry}
     * @memberof LeaderboardResponse
     */
    'me'?: LeaderboardEntry | null;
}
/**
 * Public lifecycle for a learned preference profile.
 * @export
 * @enum {string}
 */

export const LearnedPreferenceLearningStatus = {
    NotStarted: 'not_started',
    Analyzing: 'analyzing',
    Ready: 'ready',
    Failed: 'failed',
    NeedsReauth: 'needs_reauth'
} as const;

export type LearnedPreferenceLearningStatus = typeof LearnedPreferenceLearningStatus[keyof typeof LearnedPreferenceLearningStatus];


/**
 * Data source used to learn a preference profile.
 * @export
 * @enum {string}
 */

export const LearnedPreferenceSource = {
    Email: 'email'
} as const;

export type LearnedPreferenceSource = typeof LearnedPreferenceSource[keyof typeof LearnedPreferenceSource];


/**
 * Rendered style prompt for instruct, or null when none is usable.
 * @export
 * @interface LearnedPreferencesPromptResponse
 */
export interface LearnedPreferencesPromptResponse {
    /**
     * 
     * @type {string}
     * @memberof LearnedPreferencesPromptResponse
     */
    'prompt'?: string | null;
}
/**
 * Connection and analysis state.
 * @export
 * @interface LearnedPreferencesResponse
 */
export interface LearnedPreferencesResponse {
    /**
     * 
     * @type {LearnedPreferenceSource}
     * @memberof LearnedPreferencesResponse
     */
    'source': LearnedPreferenceSource;
    /**
     * 
     * @type {boolean}
     * @memberof LearnedPreferencesResponse
     */
    'connected': boolean;
    /**
     * 
     * @type {LearnedPreferenceLearningStatus}
     * @memberof LearnedPreferencesResponse
     */
    'status': LearnedPreferenceLearningStatus;
    /**
     * 
     * @type {string}
     * @memberof LearnedPreferencesResponse
     */
    'last_generated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LearnedPreferencesResponse
     */
    'prompt'?: string | null;
}


/**
 * The result of a LinkedIn disconnect request.
 * @export
 * @interface LinkedInDisconnectResponse
 */
export interface LinkedInDisconnectResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LinkedInDisconnectResponse
     */
    'disconnected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedInDisconnectResponse
     */
    'was_connected': boolean;
}
/**
 * The user\'s LinkedIn connection status and last sync metadata.
 * @export
 * @interface LinkedInStatusResponse
 */
export interface LinkedInStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LinkedInStatusResponse
     */
    'connected': boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkedInStatusResponse
     */
    'linkedin_member_id_suffix': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedInStatusResponse
     */
    'is_top_user': boolean;
    /**
     * 
     * @type {string}
     * @memberof LinkedInStatusResponse
     */
    'last_sync_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkedInStatusResponse
     */
    'status': LinkedInStatusResponseStatusEnum | null;
}

export const LinkedInStatusResponseStatusEnum = {
    Pending: 'pending',
    Active: 'active',
    Failed: 'failed'
} as const;

export type LinkedInStatusResponseStatusEnum = typeof LinkedInStatusResponseStatusEnum[keyof typeof LinkedInStatusResponseStatusEnum];

/**
 * Request to list calendar events within a time window.
 * @export
 * @interface ListCalendarEventsRequest
 */
export interface ListCalendarEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof ListCalendarEventsRequest
     */
    'time_min': string;
    /**
     * 
     * @type {string}
     * @memberof ListCalendarEventsRequest
     */
    'time_max': string;
    /**
     * 
     * @type {number}
     * @memberof ListCalendarEventsRequest
     */
    'max_results'?: number | null;
}
/**
 * Calendar events returned by a list-events connector tool call.
 * @export
 * @interface ListCalendarEventsResponse
 */
export interface ListCalendarEventsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ListCalendarEventsResponse
     */
    'successful': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListCalendarEventsResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {Array<GoogleCalendarEvent>}
     * @memberof ListCalendarEventsResponse
     */
    'data'?: Array<GoogleCalendarEvent>;
}
/**
 * Cost centers under an enterprise, sorted by ``created_at`` ascending.  The UI uses this to populate a picker before running a billing op: when an enterprise has exactly one cost_center the picker auto-selects it; with multiple, the operator must choose explicitly.
 * @export
 * @interface ListCostCentersResponse
 */
export interface ListCostCentersResponse {
    /**
     * 
     * @type {Array<CostCenterListItem>}
     * @memberof ListCostCentersResponse
     */
    'cost_centers': Array<CostCenterListItem>;
}
/**
 * Response returned by the admin ``GET /domains/verifications`` endpoint.
 * @export
 * @interface ListDomainVerificationsResponse
 */
export interface ListDomainVerificationsResponse {
    /**
     * 
     * @type {Array<DomainVerificationStatus>}
     * @memberof ListDomainVerificationsResponse
     */
    'domains': Array<DomainVerificationStatus>;
}
/**
 * Keyset-paginated messages for one session.  Each page is chronological (oldest→newest within the page) so the client can append the first page at the bottom and prepend later pages when scrolling up. ``next_cursor`` is the oldest sequence index on this page. A forward page (``after``) continues with ``next_after`` instead.
 * @export
 * @interface ListNotetakerChatMessagesResponse
 */
export interface ListNotetakerChatMessagesResponse {
    /**
     * 
     * @type {Array<NotetakerChatMessageRecord>}
     * @memberof ListNotetakerChatMessagesResponse
     */
    'messages': Array<NotetakerChatMessageRecord>;
    /**
     * 
     * @type {string}
     * @memberof ListNotetakerChatMessagesResponse
     */
    'next_cursor'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ListNotetakerChatMessagesResponse
     */
    'next_after'?: number | null;
}
/**
 * Keyset-paginated Notetaker chat sessions (newest first).  ``next_cursor`` anchors the oldest row of this page and loads still-older chats on the next request. ``null`` means there is no older page.
 * @export
 * @interface ListNotetakerChatsResponse
 */
export interface ListNotetakerChatsResponse {
    /**
     * 
     * @type {Array<NotetakerChatRecord>}
     * @memberof ListNotetakerChatsResponse
     */
    'chats': Array<NotetakerChatRecord>;
    /**
     * 
     * @type {string}
     * @memberof ListNotetakerChatsResponse
     */
    'next_cursor'?: string | null;
}
/**
 * The registered billing operations available to the operator UI.
 * @export
 * @interface ListOperationsResponse
 */
export interface ListOperationsResponse {
    /**
     * 
     * @type {Array<OperationDescriptor>}
     * @memberof ListOperationsResponse
     */
    'operations': Array<OperationDescriptor>;
}
/**
 * The two most-recent invoices an operator might want to act on.  ``open`` covers the past_due case as well — Stripe treats past_due as just an ``open`` invoice past its due_date, so a single ``open`` slot is enough for the picker. Acting on the ``open`` row triggers the void-and-reissue flow inside ``add_po_to_invoice``; the ``draft`` row is editable in place. Either slot may be null when no such invoice exists for the customer.
 * @export
 * @interface ListRecentInvoicesResponse
 */
export interface ListRecentInvoicesResponse {
    /**
     * 
     * @type {InvoiceSummary}
     * @memberof ListRecentInvoicesResponse
     */
    'draft': InvoiceSummary | null;
    /**
     * 
     * @type {InvoiceSummary}
     * @memberof ListRecentInvoicesResponse
     */
    'open': InvoiceSummary | null;
}
/**
 * Skills the caller can run: built-ins in catalog order, then their own, their department\'s and their company\'s.  Each group after the built-ins is most recently edited first. Skills can share a command, and every client must run the same one: the caller\'s own, else their department\'s, else their company\'s, else the built-in.
 * @export
 * @interface ListSkillsResponse
 */
export interface ListSkillsResponse {
    /**
     * 
     * @type {Array<Skill>}
     * @memberof ListSkillsResponse
     */
    'skills': Array<Skill>;
    /**
     * 
     * @type {UserSkillsSupport}
     * @memberof ListSkillsResponse
     */
    'user_skills'?: UserSkillsSupport | null;
    /**
     * 
     * @type {TeamSkillsSupport}
     * @memberof ListSkillsResponse
     */
    'team_skills'?: TeamSkillsSupport | null;
}
/**
 * All voice preference rows for the authenticated user, newest first.
 * @export
 * @interface ListUserVoicePreferencesResponse
 */
export interface ListUserVoicePreferencesResponse {
    /**
     * 
     * @type {Array<VoicePreferenceRecord>}
     * @memberof ListUserVoicePreferencesResponse
     */
    'voice_preferences': Array<VoicePreferenceRecord>;
}
/**
 * One fold\'s change to the shown speaker map: keys set to new values, then keys removed.
 * @export
 * @interface LiveReplayFold
 */
export interface LiveReplayFold {
    /**
     * 
     * @type {number}
     * @memberof LiveReplayFold
     */
    'at_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayFold
     */
    'segment': number;
    /**
     * 
     * @type {{ [key: string]: LiveReplaySlot; }}
     * @memberof LiveReplayFold
     */
    'assignments': { [key: string]: LiveReplaySlot; };
    /**
     * 
     * @type {{ [key: string]: LiveReplayPerson; }}
     * @memberof LiveReplayFold
     */
    'people': { [key: string]: LiveReplayPerson; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LiveReplayFold
     */
    'lines': { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveReplayFold
     */
    'removed_assignments': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveReplayFold
     */
    'removed_people': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveReplayFold
     */
    'removed_lines': Array<string>;
}
/**
 * A live transcript line at its last revision; ``appear_ms`` is when the replay draws it.
 * @export
 * @interface LiveReplayLine
 */
export interface LiveReplayLine {
    /**
     * 
     * @type {string}
     * @memberof LiveReplayLine
     */
    'entry_id': string;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayLine
     */
    'segment': number;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayLine
     */
    'source': LiveReplayLineSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayLine
     */
    'speaker_id': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayLine
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayLine
     */
    'end_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayLine
     */
    'appear_ms': number;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayLine
     */
    'text': string;
}

export const LiveReplayLineSourceEnum = {
    Mic: 'mic',
    System: 'system'
} as const;

export type LiveReplayLineSourceEnum = typeof LiveReplayLineSourceEnum[keyof typeof LiveReplayLineSourceEnum];

/**
 * A person the map can name.
 * @export
 * @interface LiveReplayPerson
 */
export interface LiveReplayPerson {
    /**
     * 
     * @type {string}
     * @memberof LiveReplayPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayPerson
     */
    'origin'?: string | null;
}
/**
 * The live speaker map rebuilt fold by fold from stored evidence; nothing is persisted.
 * @export
 * @interface LiveReplayResponse
 */
export interface LiveReplayResponse {
    /**
     * 
     * @type {string}
     * @memberof LiveReplayResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'algorithm_version': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'batch_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'appear_lag_ms': number;
    /**
     * 
     * @type {boolean}
     * @memberof LiveReplayResponse
     */
    'has_live': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LiveReplayResponse
     */
    'has_observations': boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'event_count': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'segment_count': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayResponse
     */
    'truncated_at_ms'?: number | null;
    /**
     * 
     * @type {Array<LiveReplayLine>}
     * @memberof LiveReplayResponse
     */
    'lines': Array<LiveReplayLine>;
    /**
     * 
     * @type {Array<LiveReplayFold>}
     * @memberof LiveReplayResponse
     */
    'folds': Array<LiveReplayFold>;
    /**
     * 
     * @type {LiveReplayTiming}
     * @memberof LiveReplayResponse
     */
    'timing'?: LiveReplayTiming | null;
}
/**
 * Who a speaker slot shows: the DOM-matched person, else the mic owner.
 * @export
 * @interface LiveReplaySlot
 */
export interface LiveReplaySlot {
    /**
     * 
     * @type {string}
     * @memberof LiveReplaySlot
     */
    'dom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LiveReplaySlot
     */
    'mic'?: string | null;
}
/**
 * Optional observed activity and explicit gaps in its capture or retrieval.
 * @export
 * @interface LiveReplayTiming
 */
export interface LiveReplayTiming {
    /**
     * 
     * @type {string}
     * @memberof LiveReplayTiming
     */
    'status': LiveReplayTimingStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof LiveReplayTiming
     */
    'warnings': Array<LiveReplayTimingWarningsEnum>;
    /**
     * 
     * @type {Array<LiveReplayTimingSocket>}
     * @memberof LiveReplayTiming
     */
    'sockets': Array<LiveReplayTimingSocket>;
}

export const LiveReplayTimingStatusEnum = {
    Missing: 'missing',
    Available: 'available',
    Partial: 'partial',
    Unavailable: 'unavailable'
} as const;

export type LiveReplayTimingStatusEnum = typeof LiveReplayTimingStatusEnum[keyof typeof LiveReplayTimingStatusEnum];
export const LiveReplayTimingWarningsEnum = {
    InvalidCapture: 'invalid_capture',
    ReadLimit: 'read_limit',
    CaptureTruncated: 'capture_truncated',
    ReadFailed: 'read_failed'
} as const;

export type LiveReplayTimingWarningsEnum = typeof LiveReplayTimingWarningsEnum[keyof typeof LiveReplayTimingWarningsEnum];

/**
 * One provider batch; arrival is milliseconds since this connection\'s acknowledgement.
 * @export
 * @interface LiveReplayTimingBatch
 */
export interface LiveReplayTimingBatch {
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingBatch
     */
    'at_ms': number | null;
    /**
     * 
     * @type {Array<LiveReplayTimingToken>}
     * @memberof LiveReplayTimingBatch
     */
    'tokens': Array<LiveReplayTimingToken>;
}
/**
 * A connection-local activity history, independent of the transcript recording clock.
 * @export
 * @interface LiveReplayTimingSocket
 */
export interface LiveReplayTimingSocket {
    /**
     * 
     * @type {string}
     * @memberof LiveReplayTimingSocket
     */
    'socket_id': string;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayTimingSocket
     */
    'source': LiveReplayTimingSocketSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayTimingSocket
     */
    'provider': LiveReplayTimingSocketProviderEnum;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingSocket
     */
    'acked_epoch_ms': number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingSocket
     */
    'dropped_batches': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingSocket
     */
    'truncated_tokens': number;
    /**
     * 
     * @type {Array<LiveReplayTimingBatch>}
     * @memberof LiveReplayTimingSocket
     */
    'batches': Array<LiveReplayTimingBatch>;
}

export const LiveReplayTimingSocketSourceEnum = {
    Mic: 'mic',
    System: 'system'
} as const;

export type LiveReplayTimingSocketSourceEnum = typeof LiveReplayTimingSocketSourceEnum[keyof typeof LiveReplayTimingSocketSourceEnum];
export const LiveReplayTimingSocketProviderEnum = {
    Soniox: 'soniox',
    Muse: 'muse'
} as const;

export type LiveReplayTimingSocketProviderEnum = typeof LiveReplayTimingSocketProviderEnum[keyof typeof LiveReplayTimingSocketProviderEnum];

/**
 * One provider token, with positions on its connection\'s audio clock; captures before text was recorded have none.
 * @export
 * @interface LiveReplayTimingToken
 */
export interface LiveReplayTimingToken {
    /**
     * 
     * @type {boolean}
     * @memberof LiveReplayTimingToken
     */
    'is_final': boolean;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingToken
     */
    'speaker_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingToken
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingToken
     */
    'end_ms': number;
    /**
     * 
     * @type {number}
     * @memberof LiveReplayTimingToken
     */
    'audio_arrival_ms': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveReplayTimingToken
     */
    'replayed': boolean;
    /**
     * 
     * @type {string}
     * @memberof LiveReplayTimingToken
     */
    'text'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LiveReplayTimingToken
     */
    'is_endpoint'?: boolean;
}
/**
 * Request for a presigned S3 slot to upload a meeting\'s live-transcript NDJSON.  Sibling to :class:`SpeakerObservationsUploadUrlRequest`: same NDJSON content type, but the 64 MiB ``LIVE_TRANSCRIPT_MAX_BYTES`` cap and a distinct server-composed key.
 * @export
 * @interface LiveTranscriptUploadUrlRequest
 */
export interface LiveTranscriptUploadUrlRequest {
    /**
     * Live-transcript MIME type; must be application/x-ndjson
     * @type {string}
     * @memberof LiveTranscriptUploadUrlRequest
     */
    'content_type': string;
    /**
     * NDJSON body size in bytes
     * @type {number}
     * @memberof LiveTranscriptUploadUrlRequest
     */
    'size_bytes': number;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * Response returned after kicking off a generate-or-send job.
 * @export
 * @interface MarketingJobResponse
 */
export interface MarketingJobResponse {
    /**
     * 
     * @type {string}
     * @memberof MarketingJobResponse
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobResponse
     */
    'log_query': string;
}
/**
 * Latest persisted state of a marketing generate-or-send job.
 * @export
 * @interface MarketingJobStatusResponse
 */
export interface MarketingJobStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'job_type': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'reporting_month': string;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof MarketingJobStatusResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof MarketingJobStatusResponse
     */
    'succeeded': number;
    /**
     * 
     * @type {number}
     * @memberof MarketingJobStatusResponse
     */
    'failed': number;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'stage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'started_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'completed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarketingJobStatusResponse
     */
    'error'?: string | null;
}
/**
 * Which third-party MCP clients the user has connected, most recently connected first.  An empty list means the user has never connected. There is no disconnect signal — revoking happens inside the host app — so liveness is whatever `last_connected_at` recency the reader decides to treat as live.
 * @export
 * @interface McpConnectionStatusResponse
 */
export interface McpConnectionStatusResponse {
    /**
     * 
     * @type {Array<McpConnectionSummary>}
     * @memberof McpConnectionStatusResponse
     */
    'connections'?: Array<McpConnectionSummary>;
}
/**
 * One third-party MCP client the user has connected.
 * @export
 * @interface McpConnectionSummary
 */
export interface McpConnectionSummary {
    /**
     * Name the client claimed at the handshake, e.g. \'claude-ai\'.
     * @type {string}
     * @memberof McpConnectionSummary
     */
    'client_name': string;
    /**
     * Most recent handshake from this client.
     * @type {string}
     * @memberof McpConnectionSummary
     */
    'last_connected_at': string;
}
/**
 * An MDM product an org says it manages Wispr Flow updates with. A label only.
 * @export
 * @enum {string}
 */

export const MdmProvider = {
    Intune: 'intune',
    Jamf: 'jamf',
    Kandji: 'kandji',
    Mosyle: 'mosyle',
    WorkspaceOne: 'workspace_one',
    Jumpcloud: 'jumpcloud',
    Rippling: 'rippling',
    Fleet: 'fleet',
    Munki: 'munki',
    Other: 'other'
} as const;

export type MdmProvider = typeof MdmProvider[keyof typeof MdmProvider];


/**
 * How an org says it rolls out Wispr Flow updates through MDM. A label only; nothing enforces it.
 * @export
 * @enum {string}
 */

export const MdmUpdateIntent = {
    Auto: 'auto',
    Manual: 'manual'
} as const;

export type MdmUpdateIntent = typeof MdmUpdateIntent[keyof typeof MdmUpdateIntent];


/**
 * Recorded persist outcomes and claims; absent historical evidence is never reconstructed.
 * @export
 * @interface MeetingAttributionDiagnostics
 */
export interface MeetingAttributionDiagnostics {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionDiagnostics
     */
    'status'?: MeetingAttributionDiagnosticsStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionDiagnostics
     */
    'reason'?: MeetingAttributionDiagnosticsReasonEnum | null;
    /**
     * 
     * @type {Array<StageReport>}
     * @memberof MeetingAttributionDiagnostics
     */
    'stages'?: Array<StageReport>;
    /**
     * 
     * @type {Array<SpeakerAttributionProvenance>}
     * @memberof MeetingAttributionDiagnostics
     */
    'speakers'?: Array<SpeakerAttributionProvenance>;
}

export const MeetingAttributionDiagnosticsStatusEnum = {
    Available: 'available',
    Unavailable: 'unavailable'
} as const;

export type MeetingAttributionDiagnosticsStatusEnum = typeof MeetingAttributionDiagnosticsStatusEnum[keyof typeof MeetingAttributionDiagnosticsStatusEnum];
export const MeetingAttributionDiagnosticsReasonEnum = {
    NotRecorded: 'not_recorded',
    InvalidArtifact: 'invalid_artifact',
    RevisionMismatch: 'revision_mismatch'
} as const;

export type MeetingAttributionDiagnosticsReasonEnum = typeof MeetingAttributionDiagnosticsReasonEnum[keyof typeof MeetingAttributionDiagnosticsReasonEnum];

/**
 * A compute-only re-run of a refine job for one provider; it never publishes to the meeting.  Its transcript and speaker map are read with ``job_id`` like any other job\'s.
 * @export
 * @interface MeetingAttributionEvaluationJob
 */
export interface MeetingAttributionEvaluationJob {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionEvaluationJob
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionEvaluationJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionEvaluationJob
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionEvaluationJob
     */
    'provider': MeetingAttributionEvaluationJobProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionEvaluationJob
     */
    'origin': MeetingAttributionEvaluationJobOriginEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionEvaluationJob
     */
    'viewable': boolean;
}

export const MeetingAttributionEvaluationJobProviderEnum = {
    Soniox: 'soniox',
    Chorus: 'chorus'
} as const;

export type MeetingAttributionEvaluationJobProviderEnum = typeof MeetingAttributionEvaluationJobProviderEnum[keyof typeof MeetingAttributionEvaluationJobProviderEnum];
export const MeetingAttributionEvaluationJobOriginEnum = {
    Backfill: 'backfill',
    Sampler: 'sampler'
} as const;

export type MeetingAttributionEvaluationJobOriginEnum = typeof MeetingAttributionEvaluationJobOriginEnum[keyof typeof MeetingAttributionEvaluationJobOriginEnum];

/**
 * 409 body for a save or finalize whose preconditions no longer hold.
 * @export
 * @interface MeetingAttributionGtConflictResponse
 */
export interface MeetingAttributionGtConflictResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'reason': MeetingAttributionGtConflictResponseReasonEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'current_version'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'document_sha256'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'current_generation'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'turn_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtConflictResponse
     */
    'reviewed_count'?: number | null;
}

export const MeetingAttributionGtConflictResponseReasonEnum = {
    StaleVersion: 'stale_version',
    Conflict: 'conflict',
    NotComplete: 'not_complete',
    GenerationConflict: 'generation_conflict',
    Unchanged: 'unchanged',
    PrefillMismatch: 'prefill_mismatch',
    SourceUnavailable: 'source_unavailable',
    LegacySchema: 'legacy_schema'
} as const;

export type MeetingAttributionGtConflictResponseReasonEnum = typeof MeetingAttributionGtConflictResponseReasonEnum[keyof typeof MeetingAttributionGtConflictResponseReasonEnum];

/**
 * The working-copy version that a discard removed from Postgres.
 * @export
 * @interface MeetingAttributionGtDiscardResponse
 */
export interface MeetingAttributionGtDiscardResponse {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtDiscardResponse
     */
    'version': number;
}
/**
 * The mutable document: the reviewer\'s speaker table and turn list.
 * @export
 * @interface MeetingAttributionGtDocument
 */
export interface MeetingAttributionGtDocument {
    /**
     * 
     * @type {Array<MeetingAttributionGtSpeaker>}
     * @memberof MeetingAttributionGtDocument
     */
    'speakers'?: Array<MeetingAttributionGtSpeaker>;
    /**
     * 
     * @type {Array<MeetingAttributionGtTurn>}
     * @memberof MeetingAttributionGtDocument
     */
    'turns'?: Array<MeetingAttributionGtTurn>;
    /**
     * 
     * @type {Array<MeetingAttributionGtRoom>}
     * @memberof MeetingAttributionGtDocument
     */
    'rooms'?: Array<MeetingAttributionGtRoom>;
}
/**
 * A saved ground-truth document.
 * @export
 * @interface MeetingAttributionGtDocumentResponse
 */
export interface MeetingAttributionGtDocumentResponse {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'status': MeetingAttributionGtDocumentResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'prefill_version': string;
    /**
     * Which diarization seeded the prefill this document was annotated from.
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'prefill_origin': MeetingAttributionGtDocumentResponsePrefillOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'assigned_provider'?: MeetingAttributionGtDocumentResponseAssignedProviderEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'fallback_reason'?: MeetingAttributionGtDocumentResponseFallbackReasonEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'refined_raw_sha256': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'turn_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'reviewed_count': number;
    /**
     * 
     * @type {Array<MeetingAttributionGtSnapshotTurn>}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'turns_snapshot': Array<MeetingAttributionGtSnapshotTurn>;
    /**
     * 
     * @type {MeetingAttributionGtDocument}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'document': MeetingAttributionGtDocument;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'document_sha256': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'reviewer_user_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'created_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtDocumentResponse
     */
    'modified_at': string | null;
}

export const MeetingAttributionGtDocumentResponseStatusEnum = {
    NotStarted: 'not_started',
    InProgress: 'in_progress',
    Finalized: 'finalized',
    FinalizedWithEdits: 'finalized_with_edits'
} as const;

export type MeetingAttributionGtDocumentResponseStatusEnum = typeof MeetingAttributionGtDocumentResponseStatusEnum[keyof typeof MeetingAttributionGtDocumentResponseStatusEnum];
export const MeetingAttributionGtDocumentResponsePrefillOriginEnum = {
    Soniox: 'soniox',
    Inhouse: 'inhouse'
} as const;

export type MeetingAttributionGtDocumentResponsePrefillOriginEnum = typeof MeetingAttributionGtDocumentResponsePrefillOriginEnum[keyof typeof MeetingAttributionGtDocumentResponsePrefillOriginEnum];
export const MeetingAttributionGtDocumentResponseAssignedProviderEnum = {
    Soniox: 'soniox',
    Inhouse: 'inhouse'
} as const;

export type MeetingAttributionGtDocumentResponseAssignedProviderEnum = typeof MeetingAttributionGtDocumentResponseAssignedProviderEnum[keyof typeof MeetingAttributionGtDocumentResponseAssignedProviderEnum];
export const MeetingAttributionGtDocumentResponseFallbackReasonEnum = {
    AlignmentFailed: 'alignment_failed',
    LowPlacement: 'low_placement',
    TooLarge: 'too_large',
    AudioLost: 'audio_lost',
    SubmissionUnknown: 'submission_unknown',
    OutputExpired: 'output_expired',
    StalePreparing: 'stale_preparing',
    NotPermitted: 'not_permitted'
} as const;

export type MeetingAttributionGtDocumentResponseFallbackReasonEnum = typeof MeetingAttributionGtDocumentResponseFallbackReasonEnum[keyof typeof MeetingAttributionGtDocumentResponseFallbackReasonEnum];

/**
 * The full export response body.
 * @export
 * @interface MeetingAttributionGtExportResponse
 */
export interface MeetingAttributionGtExportResponse {
    /**
     * 
     * @type {MeetingAttributionGtFinalDocumentResponse}
     * @memberof MeetingAttributionGtExportResponse
     */
    'gt_final': MeetingAttributionGtFinalDocumentResponse;
    /**
     * 
     * @type {MeetingAttributionGtReplayContextResponse}
     * @memberof MeetingAttributionGtExportResponse
     */
    'replay_context': MeetingAttributionGtReplayContextResponse;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportResponse
     */
    'refined_raw_sha256': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtExportResponse
     */
    'generation': number;
    /**
     * Saved annotation source identity used for the raw-artifact handshake.
     * @type {string}
     * @memberof MeetingAttributionGtExportResponse
     */
    'prefill_version': string;
    /**
     * Whether the raw artifact is pinned to retained provider evidence.
     * @type {boolean}
     * @memberof MeetingAttributionGtExportResponse
     */
    'source_bound': boolean;
}
/**
 * A labelled room and the export keys of the voices the reviewer put in it.
 * @export
 * @interface MeetingAttributionGtExportRoomResponse
 */
export interface MeetingAttributionGtExportRoomResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportRoomResponse
     */
    'room_key': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportRoomResponse
     */
    'label': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtExportRoomResponse
     */
    'voice_keys': Array<string>;
}
/**
 * One named speaker in an export bundle; a room voice carries the room it belongs to.
 * @export
 * @interface MeetingAttributionGtExportSpeakerResponse
 */
export interface MeetingAttributionGtExportSpeakerResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportSpeakerResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportSpeakerResponse
     */
    'speaker_key': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportSpeakerResponse
     */
    'kind'?: MeetingAttributionGtExportSpeakerResponseKindEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportSpeakerResponse
     */
    'room_key'?: string | null;
}

export const MeetingAttributionGtExportSpeakerResponseKindEnum = {
    Person: 'person',
    Room: 'room'
} as const;

export type MeetingAttributionGtExportSpeakerResponseKindEnum = typeof MeetingAttributionGtExportSpeakerResponseKindEnum[keyof typeof MeetingAttributionGtExportSpeakerResponseKindEnum];

/**
 * One exported turn: a live document turn projected onto its snapshot evidence.
 * @export
 * @interface MeetingAttributionGtExportTurnResponse
 */
export interface MeetingAttributionGtExportTurnResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'turn_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'end_ms': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'cluster': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'speaker_key': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'speaker_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'provenance': MeetingAttributionGtExportTurnResponseProvenanceEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'text_provenance': MeetingAttributionGtExportTurnResponseTextProvenanceEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'speaker_kind'?: MeetingAttributionGtExportTurnResponseSpeakerKindEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'room_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtExportTurnResponse
     */
    'room_label'?: string | null;
}

export const MeetingAttributionGtExportTurnResponseProvenanceEnum = {
    Manual: 'manual'
} as const;

export type MeetingAttributionGtExportTurnResponseProvenanceEnum = typeof MeetingAttributionGtExportTurnResponseProvenanceEnum[keyof typeof MeetingAttributionGtExportTurnResponseProvenanceEnum];
export const MeetingAttributionGtExportTurnResponseTextProvenanceEnum = {
    Manual: 'manual',
    Refined: 'refined'
} as const;

export type MeetingAttributionGtExportTurnResponseTextProvenanceEnum = typeof MeetingAttributionGtExportTurnResponseTextProvenanceEnum[keyof typeof MeetingAttributionGtExportTurnResponseTextProvenanceEnum];
export const MeetingAttributionGtExportTurnResponseSpeakerKindEnum = {
    Person: 'person',
    Room: 'room'
} as const;

export type MeetingAttributionGtExportTurnResponseSpeakerKindEnum = typeof MeetingAttributionGtExportTurnResponseSpeakerKindEnum[keyof typeof MeetingAttributionGtExportTurnResponseSpeakerKindEnum];

/**
 * The ``gt_final_v1`` payload consumed by ``gt_attribution_guard.py stage``.
 * @export
 * @interface MeetingAttributionGtFinalDocumentResponse
 */
export interface MeetingAttributionGtFinalDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'generation': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'prefill_origin': MeetingAttributionGtFinalDocumentResponsePrefillOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'assigned_provider'?: MeetingAttributionGtFinalDocumentResponseAssignedProviderEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'fallback_reason'?: MeetingAttributionGtFinalDocumentResponseFallbackReasonEnum | null;
    /**
     * 
     * @type {Array<MeetingAttributionGtExportSpeakerResponse>}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'speakers': Array<MeetingAttributionGtExportSpeakerResponse>;
    /**
     * 
     * @type {Array<MeetingAttributionGtExportTurnResponse>}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'turns': Array<MeetingAttributionGtExportTurnResponse>;
    /**
     * 
     * @type {Array<MeetingAttributionGtExportRoomResponse>}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'rooms'?: Array<MeetingAttributionGtExportRoomResponse>;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalDocumentResponse
     */
    'schema': string;
}

export const MeetingAttributionGtFinalDocumentResponsePrefillOriginEnum = {
    Soniox: 'soniox',
    Inhouse: 'inhouse'
} as const;

export type MeetingAttributionGtFinalDocumentResponsePrefillOriginEnum = typeof MeetingAttributionGtFinalDocumentResponsePrefillOriginEnum[keyof typeof MeetingAttributionGtFinalDocumentResponsePrefillOriginEnum];
export const MeetingAttributionGtFinalDocumentResponseAssignedProviderEnum = {
    Soniox: 'soniox',
    Inhouse: 'inhouse'
} as const;

export type MeetingAttributionGtFinalDocumentResponseAssignedProviderEnum = typeof MeetingAttributionGtFinalDocumentResponseAssignedProviderEnum[keyof typeof MeetingAttributionGtFinalDocumentResponseAssignedProviderEnum];
export const MeetingAttributionGtFinalDocumentResponseFallbackReasonEnum = {
    AlignmentFailed: 'alignment_failed',
    LowPlacement: 'low_placement',
    TooLarge: 'too_large',
    AudioLost: 'audio_lost',
    SubmissionUnknown: 'submission_unknown',
    OutputExpired: 'output_expired',
    StalePreparing: 'stale_preparing',
    NotPermitted: 'not_permitted'
} as const;

export type MeetingAttributionGtFinalDocumentResponseFallbackReasonEnum = typeof MeetingAttributionGtFinalDocumentResponseFallbackReasonEnum[keyof typeof MeetingAttributionGtFinalDocumentResponseFallbackReasonEnum];

/**
 * Finalize the working copy at ``expected_version`` on top of ``base_generation`` (null if none).
 * @export
 * @interface MeetingAttributionGtFinalizeRequest
 */
export interface MeetingAttributionGtFinalizeRequest {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtFinalizeRequest
     */
    'expected_version': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtFinalizeRequest
     */
    'base_generation'?: number | null;
}
/**
 * What finalize wrote to the durable bundle store.
 * @export
 * @interface MeetingAttributionGtFinalizeResponse
 */
export interface MeetingAttributionGtFinalizeResponse {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtFinalizeResponse
     */
    'generation': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalizeResponse
     */
    'manifest_sha256': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtFinalizeResponse
     */
    's3_prefix': string;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtFinalizeResponse
     */
    'row_deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtFinalizeResponse
     */
    'bytes_written': number;
}
/**
 * The pilot evidence ladder\'s suggestion, present only when it disagrees with production.
 * @export
 * @interface MeetingAttributionGtHint
 */
export interface MeetingAttributionGtHint {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtHint
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtHint
     */
    'why'?: Array<string>;
}
/**
 * Which optional artifacts were available when a snapshot turn was drafted.
 * @export
 * @interface MeetingAttributionGtInputsPresent
 */
export interface MeetingAttributionGtInputsPresent {
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtInputsPresent
     */
    'observations': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtInputsPresent
     */
    'live': boolean;
}
/**
 * One phrase a reviewer should verify against the audio.
 * @export
 * @interface MeetingAttributionGtKeyword
 */
export interface MeetingAttributionGtKeyword {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeyword
     */
    'turn_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeyword
     */
    'phrase': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeyword
     */
    'category': MeetingAttributionGtKeywordCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeyword
     */
    'note'?: string | null;
}

export const MeetingAttributionGtKeywordCategoryEnum = {
    Name: 'name',
    Number: 'number',
    Term: 'term',
    Negation: 'negation'
} as const;

export type MeetingAttributionGtKeywordCategoryEnum = typeof MeetingAttributionGtKeywordCategoryEnum[keyof typeof MeetingAttributionGtKeywordCategoryEnum];

/**
 * A transcript turn submitted for keyword identification.
 * @export
 * @interface MeetingAttributionGtKeywordTurn
 */
export interface MeetingAttributionGtKeywordTurn {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeywordTurn
     */
    'turn_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeywordTurn
     */
    'speaker'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtKeywordTurn
     */
    'text': string;
}
/**
 * Transcript turns to inspect for high-value verification words.
 * @export
 * @interface MeetingAttributionGtKeywordsRequest
 */
export interface MeetingAttributionGtKeywordsRequest {
    /**
     * 
     * @type {Array<MeetingAttributionGtKeywordTurn>}
     * @memberof MeetingAttributionGtKeywordsRequest
     */
    'turns': Array<MeetingAttributionGtKeywordTurn>;
}
/**
 * Keyword phrases identified for the submitted turns.
 * @export
 * @interface MeetingAttributionGtKeywordsResponse
 */
export interface MeetingAttributionGtKeywordsResponse {
    /**
     * 
     * @type {Array<MeetingAttributionGtKeyword>}
     * @memberof MeetingAttributionGtKeywordsResponse
     */
    'keywords': Array<MeetingAttributionGtKeyword>;
}
/**
 * One meeting in an annotator\'s completed or incomplete list.
 * @export
 * @interface MeetingAttributionGtLeaderboardMeeting
 */
export interface MeetingAttributionGtLeaderboardMeeting {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'created_at': string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'speaker_count': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'duration_ms': number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'platform': MeetingAttributionGtLeaderboardMeetingPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'os': MeetingAttributionGtLeaderboardMeetingOsEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'reviewed_turns': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardMeeting
     */
    'total_turns': number | null;
}

export const MeetingAttributionGtLeaderboardMeetingPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type MeetingAttributionGtLeaderboardMeetingPlatformEnum = typeof MeetingAttributionGtLeaderboardMeetingPlatformEnum[keyof typeof MeetingAttributionGtLeaderboardMeetingPlatformEnum];
export const MeetingAttributionGtLeaderboardMeetingOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Unknown: 'unknown'
} as const;

export type MeetingAttributionGtLeaderboardMeetingOsEnum = typeof MeetingAttributionGtLeaderboardMeetingOsEnum[keyof typeof MeetingAttributionGtLeaderboardMeetingOsEnum];

/**
 * One annotator\'s email-free meeting lists; titles and timestamps follow the viewer access policy.
 * @export
 * @interface MeetingAttributionGtLeaderboardPerson
 */
export interface MeetingAttributionGtLeaderboardPerson {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardPerson
     */
    'name': string;
    /**
     * 
     * @type {Array<MeetingAttributionGtLeaderboardMeeting>}
     * @memberof MeetingAttributionGtLeaderboardPerson
     */
    'completed': Array<MeetingAttributionGtLeaderboardMeeting>;
    /**
     * 
     * @type {Array<MeetingAttributionGtLeaderboardMeeting>}
     * @memberof MeetingAttributionGtLeaderboardPerson
     */
    'incomplete': Array<MeetingAttributionGtLeaderboardMeeting>;
}
/**
 * Annotated coverage for one platform against its 30-day multi-speaker baseline.
 * @export
 * @interface MeetingAttributionGtLeaderboardPlatform
 */
export interface MeetingAttributionGtLeaderboardPlatform {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardPlatform
     */
    'platform': MeetingAttributionGtLeaderboardPlatformPlatformEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardPlatform
     */
    'annotated': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardPlatform
     */
    'baseline': number;
}

export const MeetingAttributionGtLeaderboardPlatformPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type MeetingAttributionGtLeaderboardPlatformPlatformEnum = typeof MeetingAttributionGtLeaderboardPlatformPlatformEnum[keyof typeof MeetingAttributionGtLeaderboardPlatformPlatformEnum];

/**
 * Per-person and per-platform annotation progress across all ground-truth meetings.
 * @export
 * @interface MeetingAttributionGtLeaderboardResponse
 */
export interface MeetingAttributionGtLeaderboardResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtLeaderboardResponse
     */
    'generated_at': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardResponse
     */
    'completed_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtLeaderboardResponse
     */
    'started_meetings': number;
    /**
     * 
     * @type {Array<MeetingAttributionGtLeaderboardPerson>}
     * @memberof MeetingAttributionGtLeaderboardResponse
     */
    'people': Array<MeetingAttributionGtLeaderboardPerson>;
    /**
     * 
     * @type {Array<MeetingAttributionGtLeaderboardPlatform>}
     * @memberof MeetingAttributionGtLeaderboardResponse
     */
    'platforms': Array<MeetingAttributionGtLeaderboardPlatform>;
}
/**
 * A machine-drafted prefill, plus annotation eligibility and the (always-present) document.
 * @export
 * @interface MeetingAttributionGtPrefillResponse
 */
export interface MeetingAttributionGtPrefillResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'prefill_version': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'refined_raw_sha256': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'current_refined_raw_sha256': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'annotatable': boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'annotatable_reason': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'status': MeetingAttributionGtPrefillResponseStatusEnum;
    /**
     * Prefill turns dropped for colliding with an already-minted turn_id.
     * @type {number}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'dropped_duplicate_turns'?: number;
    /**
     * Version-0 default (null created_at/modified_at) when nothing has been saved yet.
     * @type {MeetingAttributionGtDocumentResponse}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'document': MeetingAttributionGtDocumentResponse;
    /**
     * Where the working copy came from: the Postgres row, a finalized S3 bundle, or a fresh prefill.
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'source': MeetingAttributionGtPrefillResponseSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'finalized_generation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'finalized_document_sha256'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtPrefillResponse
     */
    'hydrated_from_generation'?: number | null;
}

export const MeetingAttributionGtPrefillResponseStatusEnum = {
    NotStarted: 'not_started',
    InProgress: 'in_progress',
    Finalized: 'finalized',
    FinalizedWithEdits: 'finalized_with_edits'
} as const;

export type MeetingAttributionGtPrefillResponseStatusEnum = typeof MeetingAttributionGtPrefillResponseStatusEnum[keyof typeof MeetingAttributionGtPrefillResponseStatusEnum];
export const MeetingAttributionGtPrefillResponseSourceEnum = {
    Db: 'db',
    S3: 's3',
    Prefill: 'prefill'
} as const;

export type MeetingAttributionGtPrefillResponseSourceEnum = typeof MeetingAttributionGtPrefillResponseSourceEnum[keyof typeof MeetingAttributionGtPrefillResponseSourceEnum];

/**
 * What production actually attributed for a snapshot turn\'s speaker key.
 * @export
 * @interface MeetingAttributionGtProduction
 */
export interface MeetingAttributionGtProduction {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtProduction
     */
    'label': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtProduction
     */
    'person_ids'?: Array<string>;
}
/**
 * 400/409 body for a typed save or export refusal.
 * @export
 * @interface MeetingAttributionGtRefusalResponse
 */
export interface MeetingAttributionGtRefusalResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRefusalResponse
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRefusalResponse
     */
    'detail': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRefusalResponse
     */
    'turn_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRefusalResponse
     */
    'speaker_id': string | null;
}
/**
 * Replay metadata captured at export time.
 * @export
 * @interface MeetingAttributionGtReplayContextResponse
 */
export interface MeetingAttributionGtReplayContextResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'self_display_name': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'attendees': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'has_calendar_link': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'room_card_speaker_split_enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'algorithm_version': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtReplayContextResponse
     */
    'captured_at': string;
}
/**
 * A shared device / conference room that one or more roster speakers (acoustic voices) belong to.
 * @export
 * @interface MeetingAttributionGtRoom
 */
export interface MeetingAttributionGtRoom {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRoom
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtRoom
     */
    'label': string;
}
/**
 * A reviewer\'s save/create request; the server computes the snapshot on create.
 * @export
 * @interface MeetingAttributionGtSaveRequest
 */
export interface MeetingAttributionGtSaveRequest {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSaveRequest
     */
    'expected_version': number;
    /**
     * 
     * @type {MeetingAttributionGtDocument}
     * @memberof MeetingAttributionGtSaveRequest
     */
    'document': MeetingAttributionGtDocument;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSaveRequest
     */
    'prefill_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSaveRequest
     */
    'refined_raw_sha256'?: string | null;
}
/**
 * The document state immediately after a successful save.
 * @export
 * @interface MeetingAttributionGtSaveResponse
 */
export interface MeetingAttributionGtSaveResponse {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSaveResponse
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSaveResponse
     */
    'document_sha256': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSaveResponse
     */
    'status': MeetingAttributionGtSaveResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSaveResponse
     */
    'turn_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSaveResponse
     */
    'reviewed_count': number;
}

export const MeetingAttributionGtSaveResponseStatusEnum = {
    NotStarted: 'not_started',
    InProgress: 'in_progress',
    Finalized: 'finalized',
    FinalizedWithEdits: 'finalized_with_edits'
} as const;

export type MeetingAttributionGtSaveResponseStatusEnum = typeof MeetingAttributionGtSaveResponseStatusEnum[keyof typeof MeetingAttributionGtSaveResponseStatusEnum];

/**
 * One frozen turn of evidence in ``turns_snapshot``; written once at create, never mutated.
 * @export
 * @interface MeetingAttributionGtSnapshotTurn
 */
export interface MeetingAttributionGtSnapshotTurn {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'turn_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'end_ms': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'cluster': string;
    /**
     * 
     * @type {MeetingAttributionGtProduction}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'production'?: MeetingAttributionGtProduction | null;
    /**
     * 
     * @type {MeetingAttributionGtHint}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'hint'?: MeetingAttributionGtHint | null;
    /**
     * 
     * @type {MeetingAttributionGtInputsPresent}
     * @memberof MeetingAttributionGtSnapshotTurn
     */
    'inputs_present': MeetingAttributionGtInputsPresent;
}
/**
 * One speaker in a ``gt_doc_v2`` document; ``id`` is minted client-side and never reused.  A speaker of ``kind == \"room\"`` is one acoustic voice of the room ``room_id`` points at; it keeps its own id, name and source ids so scoring can still see which voice said what.
 * @export
 * @interface MeetingAttributionGtSpeaker
 */
export interface MeetingAttributionGtSpeaker {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'voice_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'hotkey'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionGtSpeaker
     */
    'is_recorder'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtSpeaker
     */
    'source_person_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingAttributionGtSpeaker
     */
    'source_refined_speaker_ids'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'kind'?: MeetingAttributionGtSpeakerKindEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtSpeaker
     */
    'room_id'?: string | null;
}

export const MeetingAttributionGtSpeakerKindEnum = {
    Person: 'person',
    Room: 'room'
} as const;

export type MeetingAttributionGtSpeakerKindEnum = typeof MeetingAttributionGtSpeakerKindEnum[keyof typeof MeetingAttributionGtSpeakerKindEnum];

/**
 * One turn in a ``gt_doc_v2`` document — the document IS the transcript.
 * @export
 * @interface MeetingAttributionGtTurn
 */
export interface MeetingAttributionGtTurn {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtTurn
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionGtTurn
     */
    'end_ms': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'speaker_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'state'?: MeetingAttributionGtTurnStateEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'note'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'source_turn_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'reviewed_by'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionGtTurn
     */
    'reviewed_at'?: string | null;
}

export const MeetingAttributionGtTurnStateEnum = {
    Confirmed: 'confirmed',
    Deleted: 'deleted'
} as const;

export type MeetingAttributionGtTurnStateEnum = typeof MeetingAttributionGtTurnStateEnum[keyof typeof MeetingAttributionGtTurnStateEnum];

/**
 * One refine job available in the attribution viewer.
 * @export
 * @interface MeetingAttributionJob
 */
export interface MeetingAttributionJob {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'provider': MeetingAttributionJobProviderEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionJob
     */
    'viewable': boolean;
    /**
     * 
     * @type {Array<MeetingAttributionEvaluationJob>}
     * @memberof MeetingAttributionJob
     */
    'evaluation_jobs'?: Array<MeetingAttributionEvaluationJob>;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionJob
     */
    'audio_stop_seq'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionJob
     */
    'audio_retained'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingAttributionJob
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'last_error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJob
     */
    'summary'?: string | null;
}

export const MeetingAttributionJobProviderEnum = {
    Soniox: 'soniox',
    Chorus: 'chorus',
    Openai: 'openai'
} as const;

export type MeetingAttributionJobProviderEnum = typeof MeetingAttributionJobProviderEnum[keyof typeof MeetingAttributionJobProviderEnum];

/**
 * Start a new serving job from one job\'s retained audio; ``job_id`` makes retries idempotent.
 * @export
 * @interface MeetingAttributionJobRerunRequest
 */
export interface MeetingAttributionJobRerunRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJobRerunRequest
     */
    'job_id': string;
}
/**
 * The selected serving job, now running the full refine and summary pipeline.
 * @export
 * @interface MeetingAttributionJobRerunResponse
 */
export interface MeetingAttributionJobRerunResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJobRerunResponse
     */
    'job_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJobRerunResponse
     */
    'source_job_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionJobRerunResponse
     */
    'audio_stop_seq': number;
}
/**
 * The active meeting\'s refine jobs and currently displayed job.
 * @export
 * @interface MeetingAttributionJobsResponse
 */
export interface MeetingAttributionJobsResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJobsResponse
     */
    'displayed_job_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionJobsResponse
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {Array<MeetingAttributionJob>}
     * @memberof MeetingAttributionJobsResponse
     */
    'jobs': Array<MeetingAttributionJob>;
}
/**
 * One labelled slice of the votes.
 * @export
 * @interface MeetingAttributionTurnPreferenceBreakdownRow
 */
export interface MeetingAttributionTurnPreferenceBreakdownRow {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'soniox': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'chorus': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'no_preference': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'p_value': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'win_rate': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'ci_low': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'ci_high': number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceBreakdownRow
     */
    'label': string;
}
/**
 * The session was already submitted.
 * @export
 * @interface MeetingAttributionTurnPreferenceConflictResponse
 */
export interface MeetingAttributionTurnPreferenceConflictResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceConflictResponse
     */
    'reason': MeetingAttributionTurnPreferenceConflictResponseReasonEnum;
}

export const MeetingAttributionTurnPreferenceConflictResponseReasonEnum = {
    AlreadyFinished: 'already_finished'
} as const;

export type MeetingAttributionTurnPreferenceConflictResponseReasonEnum = typeof MeetingAttributionTurnPreferenceConflictResponseReasonEnum[keyof typeof MeetingAttributionTurnPreferenceConflictResponseReasonEnum];

/**
 * The annotator\'s blind comparison session for the meeting\'s displayed refinement.
 * @export
 * @interface MeetingAttributionTurnPreferenceResponse
 */
export interface MeetingAttributionTurnPreferenceResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'status': MeetingAttributionTurnPreferenceResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'reason'?: MeetingAttributionTurnPreferenceResponseReasonEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'pairing_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'finished_at'?: string | null;
    /**
     * 
     * @type {Array<MeetingAttributionTurnPreferenceUnit>}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'units'?: Array<MeetingAttributionTurnPreferenceUnit>;
    /**
     * The submitted picks; set only when finished.
     * @type {Array<MeetingAttributionTurnPreferenceVote>}
     * @memberof MeetingAttributionTurnPreferenceResponse
     */
    'votes'?: Array<MeetingAttributionTurnPreferenceVote>;
}

export const MeetingAttributionTurnPreferenceResponseStatusEnum = {
    Available: 'available',
    Unavailable: 'unavailable',
    Finished: 'finished'
} as const;

export type MeetingAttributionTurnPreferenceResponseStatusEnum = typeof MeetingAttributionTurnPreferenceResponseStatusEnum[keyof typeof MeetingAttributionTurnPreferenceResponseStatusEnum];
export const MeetingAttributionTurnPreferenceResponseReasonEnum = {
    NoDisplayedJob: 'no_displayed_job',
    RevisionChanged: 'revision_changed',
    CaptureUnavailable: 'capture_unavailable',
    CaptureTooLarge: 'capture_too_large',
    EvaluationUnavailable: 'evaluation_unavailable',
    TimingUnavailable: 'timing_unavailable',
    WordsUnmapped: 'words_unmapped',
    InsufficientUnits: 'insufficient_units',
    BeforeRoundStart: 'before_round_start'
} as const;

export type MeetingAttributionTurnPreferenceResponseReasonEnum = typeof MeetingAttributionTurnPreferenceResponseReasonEnum[keyof typeof MeetingAttributionTurnPreferenceResponseReasonEnum];

/**
 * Aggregate decoded votes over finished sessions; carries no unit ids, text, user ids or emails.
 * @export
 * @interface MeetingAttributionTurnPreferenceResultsResponse
 */
export interface MeetingAttributionTurnPreferenceResultsResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'generated_at': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'finished_sessions': number;
    /**
     * Finished sessions whose stored snapshot or votes did not parse.
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'skipped_sessions': number;
    /**
     * Distinct annotator labels, including the former-employee bucket.
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'annotators': number;
    /**
     * One trial per vote.
     * @type {MeetingAttributionTurnPreferenceTally}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'overall': MeetingAttributionTurnPreferenceTally;
    /**
     * 
     * @type {Array<MeetingAttributionTurnPreferenceBreakdownRow>}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'by_annotator': Array<MeetingAttributionTurnPreferenceBreakdownRow>;
    /**
     * 
     * @type {Array<MeetingAttributionTurnPreferenceBreakdownRow>}
     * @memberof MeetingAttributionTurnPreferenceResultsResponse
     */
    'by_picked_by': Array<MeetingAttributionTurnPreferenceBreakdownRow>;
}
/**
 * One anonymous side of a unit: its turns in time order.
 * @export
 * @interface MeetingAttributionTurnPreferenceSide
 */
export interface MeetingAttributionTurnPreferenceSide {
    /**
     * 
     * @type {Array<MeetingAttributionTurnPreferenceTurn>}
     * @memberof MeetingAttributionTurnPreferenceSide
     */
    'turns': Array<MeetingAttributionTurnPreferenceTurn>;
}
/**
 * The two anonymous sides of a unit; which transcript is `a` is randomized per annotator.
 * @export
 * @interface MeetingAttributionTurnPreferenceSides
 */
export interface MeetingAttributionTurnPreferenceSides {
    /**
     * 
     * @type {MeetingAttributionTurnPreferenceSide}
     * @memberof MeetingAttributionTurnPreferenceSides
     */
    'a': MeetingAttributionTurnPreferenceSide;
    /**
     * 
     * @type {MeetingAttributionTurnPreferenceSide}
     * @memberof MeetingAttributionTurnPreferenceSides
     */
    'b': MeetingAttributionTurnPreferenceSide;
}
/**
 * Votes per provider plus the sign test over the decided ones; the stats are null when none were decided.
 * @export
 * @interface MeetingAttributionTurnPreferenceTally
 */
export interface MeetingAttributionTurnPreferenceTally {
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'soniox': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'chorus': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'no_preference': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'p_value': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'win_rate': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'ci_low': number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTally
     */
    'ci_high': number | null;
}
/**
 * One speaker turn on one anonymous side of a unit.
 * @export
 * @interface MeetingAttributionTurnPreferenceTurn
 */
export interface MeetingAttributionTurnPreferenceTurn {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceTurn
     */
    'name': string;
    /**
     * True when the name is a generic `Speaker N` stand-in, not a person.
     * @type {boolean}
     * @memberof MeetingAttributionTurnPreferenceTurn
     */
    'is_placeholder': boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceTurn
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTurn
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceTurn
     */
    'end_ms': number;
}
/**
 * One comparison unit: the audio range both sides cover and the two sides.
 * @export
 * @interface MeetingAttributionTurnPreferenceUnit
 */
export interface MeetingAttributionTurnPreferenceUnit {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceUnit
     */
    'unit_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceUnit
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingAttributionTurnPreferenceUnit
     */
    'end_ms': number;
    /**
     * The rule that selected this unit.
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceUnit
     */
    'picked_by': MeetingAttributionTurnPreferenceUnitPickedByEnum;
    /**
     * 
     * @type {MeetingAttributionTurnPreferenceSides}
     * @memberof MeetingAttributionTurnPreferenceUnit
     */
    'sides': MeetingAttributionTurnPreferenceSides;
}

export const MeetingAttributionTurnPreferenceUnitPickedByEnum = {
    Speaker: 'speaker',
    Wer: 'wer'
} as const;

export type MeetingAttributionTurnPreferenceUnitPickedByEnum = typeof MeetingAttributionTurnPreferenceUnitPickedByEnum[keyof typeof MeetingAttributionTurnPreferenceUnitPickedByEnum];

/**
 * The side an annotator preferred for one unit; a unit without a vote means no preference.
 * @export
 * @interface MeetingAttributionTurnPreferenceVote
 */
export interface MeetingAttributionTurnPreferenceVote {
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceVote
     */
    'unit_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingAttributionTurnPreferenceVote
     */
    'choice': MeetingAttributionTurnPreferenceVoteChoiceEnum;
}

export const MeetingAttributionTurnPreferenceVoteChoiceEnum = {
    A: 'a',
    B: 'b'
} as const;

export type MeetingAttributionTurnPreferenceVoteChoiceEnum = typeof MeetingAttributionTurnPreferenceVoteChoiceEnum[keyof typeof MeetingAttributionTurnPreferenceVoteChoiceEnum];

/**
 * The annotator\'s submitted picks, at most one per served unit.
 * @export
 * @interface MeetingAttributionTurnPreferenceVotesRequest
 */
export interface MeetingAttributionTurnPreferenceVotesRequest {
    /**
     * 
     * @type {Array<MeetingAttributionTurnPreferenceVote>}
     * @memberof MeetingAttributionTurnPreferenceVotesRequest
     */
    'votes': Array<MeetingAttributionTurnPreferenceVote>;
}
/**
 * Presigned GET URL for one meeting\'s audio, if present.
 * @export
 * @interface MeetingAudioUrlResponse
 */
export interface MeetingAudioUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingAudioUrlResponse
     */
    'url'?: string | null;
}
/**
 * A shared folder the meeting clearly belongs in.
 * @export
 * @interface MeetingFolderSuggestion
 */
export interface MeetingFolderSuggestion {
    /**
     * 
     * @type {string}
     * @memberof MeetingFolderSuggestion
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingFolderSuggestion
     */
    'folder_name': string;
    /**
     * Distinct people with access to the folder, the caller included.
     * @type {number}
     * @memberof MeetingFolderSuggestion
     */
    'people_count': number;
}
/**
 * The meeting\'s live transcript so far.
 * @export
 * @interface MeetingFolderSuggestionRequest
 */
export interface MeetingFolderSuggestionRequest {
    /**
     * The settled live transcript so far, from its start.
     * @type {string}
     * @memberof MeetingFolderSuggestionRequest
     */
    'transcript': string;
}
/**
 * At most one shared-folder suggestion; `null` is the normal answer.
 * @export
 * @interface MeetingFolderSuggestionResponse
 */
export interface MeetingFolderSuggestionResponse {
    /**
     * 
     * @type {MeetingFolderSuggestion}
     * @memberof MeetingFolderSuggestionResponse
     */
    'suggestion': MeetingFolderSuggestion | null;
}
/**
 * Why a confirm conflicted: ``zoom_not_connected``, or ``import_run_active`` with the active run.
 * @export
 * @interface MeetingImportConflictDetail
 */
export interface MeetingImportConflictDetail {
    /**
     * 
     * @type {string}
     * @memberof MeetingImportConflictDetail
     */
    'code': MeetingImportConflictDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingImportConflictDetail
     */
    'run_id'?: string | null;
}

export const MeetingImportConflictDetailCodeEnum = {
    ZoomNotConnected: 'zoom_not_connected',
    ImportRunActive: 'import_run_active'
} as const;

export type MeetingImportConflictDetailCodeEnum = typeof MeetingImportConflictDetailCodeEnum[keyof typeof MeetingImportConflictDetailCodeEnum];

/**
 * 409 envelope for confirm.
 * @export
 * @interface MeetingImportConflictResponse
 */
export interface MeetingImportConflictResponse {
    /**
     * 
     * @type {MeetingImportConflictDetail}
     * @memberof MeetingImportConflictResponse
     */
    'detail': MeetingImportConflictDetail;
}
/**
 * Bounded reason stored on a failed run; items carry it only in the settle log.
 * @export
 * @enum {string}
 */

export const MeetingImportFailureClass = {
    NeedsReconnect: 'needs_reconnect',
    StartFailed: 'start_failed',
    ProviderUnavailable: 'provider_unavailable',
    TooLarge: 'too_large',
    MeetingIdConflict: 'meeting_id_conflict',
    CandidateLimit: 'candidate_limit',
    SwitchedOff: 'switched_off',
    BlockedByPolicy: 'blocked_by_policy',
    InternalError: 'internal_error'
} as const;

export type MeetingImportFailureClass = typeof MeetingImportFailureClass[keyof typeof MeetingImportFailureClass];


/**
 * What happened to one selected meeting.
 * @export
 * @enum {string}
 */

export const MeetingImportItemOutcome = {
    Pending: 'pending',
    Imported: 'imported',
    AlreadyImported: 'already_imported',
    DeletedByUser: 'deleted_by_user',
    OutsideRetention: 'outside_retention',
    BlockedByPolicy: 'blocked_by_policy',
    NothingToImport: 'nothing_to_import',
    NotReady: 'not_ready',
    Inaccessible: 'inaccessible',
    Unsupported: 'unsupported',
    Failed: 'failed'
} as const;

export type MeetingImportItemOutcome = typeof MeetingImportItemOutcome[keyof typeof MeetingImportItemOutcome];


/**
 * Confirm a selection. Resending the same ``idempotency_key`` returns the same run.
 * @export
 * @interface MeetingImportRunCreateRequest
 */
export interface MeetingImportRunCreateRequest {
    /**
     * 
     * @type {Array<MeetingImportSelection>}
     * @memberof MeetingImportRunCreateRequest
     */
    'items': Array<MeetingImportSelection>;
    /**
     * 
     * @type {string}
     * @memberof MeetingImportRunCreateRequest
     */
    'idempotency_key': string;
}
/**
 * Progress of one import run. Counts come from the run\'s items as they settle.
 * @export
 * @interface MeetingImportRunResponse
 */
export interface MeetingImportRunResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingImportRunResponse
     */
    'run_id': string;
    /**
     * 
     * @type {ConnectorKey}
     * @memberof MeetingImportRunResponse
     */
    'provider': ConnectorKey;
    /**
     * 
     * @type {MeetingImportRunStatus}
     * @memberof MeetingImportRunResponse
     */
    'status': MeetingImportRunStatus;
    /**
     * 
     * @type {MeetingImportFailureClass}
     * @memberof MeetingImportRunResponse
     */
    'failure_class'?: MeetingImportFailureClass | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingImportRunResponse
     */
    'requested_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingImportRunResponse
     */
    'imported_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingImportRunResponse
     */
    'skipped_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingImportRunResponse
     */
    'failed_count': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingImportRunResponse
     */
    'pending_count': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MeetingImportRunResponse
     */
    'outcome_counts': { [key: string]: number; };
}


/**
 * Lifecycle of one ``meeting_import_run`` row.
 * @export
 * @enum {string}
 */

export const MeetingImportRunStatus = {
    Accepted: 'accepted',
    Running: 'running',
    Completed: 'completed',
    Cancelled: 'cancelled',
    Failed: 'failed'
} as const;

export type MeetingImportRunStatus = typeof MeetingImportRunStatus[keyof typeof MeetingImportRunStatus];


/**
 * One selected Zoom meeting occurrence.
 * @export
 * @interface MeetingImportSelection
 */
export interface MeetingImportSelection {
    /**
     * 
     * @type {string}
     * @memberof MeetingImportSelection
     */
    'source_id': string;
}
/**
 * 503 envelope for confirm, the catalog and Fireflies connect.  ``detail`` is ``import_start_failed``, ``zoom_unavailable`` (the catalog could not reach Zoom), ``fireflies_unavailable`` (connect could not reach Fireflies or store the key), ``connector_disabled`` (the kill switch), or the rate limiter\'s \"Service temporarily unavailable. Please try again later.\" when Redis is down. A client treats any detail it does not know as try again later.
 * @export
 * @interface MeetingImportUnavailableResponse
 */
export interface MeetingImportUnavailableResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingImportUnavailableResponse
     */
    'detail': string;
}
/**
 * Server to client: one nudge for one surface, held until a newer one replaces it.  Stored before it is sent, and the current one is sent again on resume: a client drops a repeat, and may drop any.
 * @export
 * @interface MeetingNudge
 */
export interface MeetingNudge {
    /**
     * 
     * @type {string}
     * @memberof MeetingNudge
     */
    'type'?: MeetingNudgeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingNudge
     */
    'nudge_id': string;
    /**
     * 
     * @type {NudgeSurface}
     * @memberof MeetingNudge
     */
    'surface': NudgeSurface;
    /**
     * 
     * @type {NudgeType}
     * @memberof MeetingNudge
     */
    'nudge_type': NudgeType;
    /**
     * 
     * @type {number}
     * @memberof MeetingNudge
     */
    'schema_version': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingNudge
     */
    'created_at_ms': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MeetingNudge
     */
    'payload': { [key: string]: any; };
}

export const MeetingNudgeTypeEnum = {
    Nudge: 'nudge'
} as const;

export type MeetingNudgeTypeEnum = typeof MeetingNudgeTypeEnum[keyof typeof MeetingNudgeTypeEnum];

/**
 * Client to server: a batch of feedback events, numbered apart from evidence ``batch_seq``.
 * @export
 * @interface MeetingNudgeFeedback
 */
export interface MeetingNudgeFeedback {
    /**
     * 
     * @type {string}
     * @memberof MeetingNudgeFeedback
     */
    'type': MeetingNudgeFeedbackTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingNudgeFeedback
     */
    'feedback_seq': number;
    /**
     * 
     * @type {Array<NudgeFeedbackEvent>}
     * @memberof MeetingNudgeFeedback
     */
    'events': Array<NudgeFeedbackEvent>;
}

export const MeetingNudgeFeedbackTypeEnum = {
    NudgeFeedback: 'nudge_feedback'
} as const;

export type MeetingNudgeFeedbackTypeEnum = typeof MeetingNudgeFeedbackTypeEnum[keyof typeof MeetingNudgeFeedbackTypeEnum];

/**
 * Server to client: the batch is settled, so the client stops resending it; whatever was not recorded is dropped.
 * @export
 * @interface MeetingNudgeFeedbackAck
 */
export interface MeetingNudgeFeedbackAck {
    /**
     * 
     * @type {string}
     * @memberof MeetingNudgeFeedbackAck
     */
    'type'?: MeetingNudgeFeedbackAckTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingNudgeFeedbackAck
     */
    'feedback_seq': number;
}

export const MeetingNudgeFeedbackAckTypeEnum = {
    NudgeFeedbackAck: 'nudge_feedback_ack'
} as const;

export type MeetingNudgeFeedbackAckTypeEnum = typeof MeetingNudgeFeedbackAckTypeEnum[keyof typeof MeetingNudgeFeedbackAckTypeEnum];

/**
 * Every nudge message and payload in one model, so the OpenAPI spec and the generated clients carry them.
 * @export
 * @interface MeetingNudgeSchema
 */
export interface MeetingNudgeSchema {
    /**
     * 
     * @type {MeetingNudge}
     * @memberof MeetingNudgeSchema
     */
    'nudge': MeetingNudge;
    /**
     * 
     * @type {MeetingNudgeFeedback}
     * @memberof MeetingNudgeSchema
     */
    'feedback': MeetingNudgeFeedback;
    /**
     * 
     * @type {MeetingNudgeFeedbackAck}
     * @memberof MeetingNudgeSchema
     */
    'feedback_ack': MeetingNudgeFeedbackAck;
    /**
     * 
     * @type {AskAnythingSuggestionsPayload}
     * @memberof MeetingNudgeSchema
     */
    'ask_anything_suggestions': AskAnythingSuggestionsPayload;
}
/**
 * One person in a meeting: a speaker-map person, a calendar attendee, or the two merged.  Speaker-map people carry ``origin`` / ``contact_id`` / ``is_self``; attendees with no speaker-map counterpart carry ``organizer``. A person present in both sources appears once, with the union of those fields.
 * @export
 * @interface MeetingParticipant
 */
export interface MeetingParticipant {
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipant
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipant
     */
    'origin'?: MeetingParticipantOriginEnum | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipant
     */
    'contact_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingParticipant
     */
    'is_self'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingParticipant
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingParticipant
     */
    'spoke': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingParticipant
     */
    'organizer'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipant
     */
    'relationship': MeetingParticipantRelationshipEnum;
}

export const MeetingParticipantOriginEnum = {
    Platform: 'platform',
    Calendar: 'calendar',
    User: 'user',
    MergedCalPlatform: 'merged_cal_platform',
    Self: 'self',
    Llm: 'llm',
    Mention: 'mention'
} as const;

export type MeetingParticipantOriginEnum = typeof MeetingParticipantOriginEnum[keyof typeof MeetingParticipantOriginEnum];
export const MeetingParticipantRelationshipEnum = {
    Self: 'self',
    Colleague: 'colleague',
    External: 'external',
    Unknown: 'unknown'
} as const;

export type MeetingParticipantRelationshipEnum = typeof MeetingParticipantRelationshipEnum[keyof typeof MeetingParticipantRelationshipEnum];

/**
 * Everyone identified in one meeting, plus the caller they are classified against.
 * @export
 * @interface MeetingParticipantsResponse
 */
export interface MeetingParticipantsResponse {
    /**
     * 
     * @type {MeetingParticipantsUser}
     * @memberof MeetingParticipantsResponse
     */
    'user': MeetingParticipantsUser;
    /**
     * 
     * @type {Array<MeetingParticipant>}
     * @memberof MeetingParticipantsResponse
     */
    'participants': Array<MeetingParticipant>;
}
/**
 * The caller\'s own identity — the reference point every ``relationship`` is computed against.
 * @export
 * @interface MeetingParticipantsUser
 */
export interface MeetingParticipantsUser {
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipantsUser
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipantsUser
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingParticipantsUser
     */
    'domain'?: string | null;
}
/**
 * People-picker lookup for one meeting.  ``query`` travels in the body rather than a query string on purpose: on this surface it is a person\'s name or email, and the uvicorn access log records full request lines to CloudWatch, Logtail and Sentry Logs.
 * @export
 * @interface MeetingPeopleRequest
 */
export interface MeetingPeopleRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingPeopleRequest
     */
    'query'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingPeopleRequest
     */
    'limit'?: number;
}
/**
 * Ranked people for the picker; prefix matches precede substring matches.  ``has_calendar_event`` and ``attendee_total`` describe the blank-query (attendee) response and let a client tell \"no event\", \"empty event\" and \"everyone already invited\" apart. Both are ``None`` whenever a query is provided; ``attendee_total`` is also ``None`` on a blank-query response when no calendar event the caller owns resolves.
 * @export
 * @interface MeetingPeopleResponse
 */
export interface MeetingPeopleResponse {
    /**
     * 
     * @type {Array<MeetingPersonRow>}
     * @memberof MeetingPeopleResponse
     */
    'people': Array<MeetingPersonRow>;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingPeopleResponse
     */
    'has_calendar_event'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingPeopleResponse
     */
    'attendee_total'?: number | null;
}
/**
 * One suggestible person.  ``display_name`` is a single string, not a first/last pair: the underlying column is one opaque resolved name, and splitting it is lossy for mononyms, CJK ordering and ``\"Last, First\"`` directory exports.
 * @export
 * @interface MeetingPersonRow
 */
export interface MeetingPersonRow {
    /**
     * 
     * @type {string}
     * @memberof MeetingPersonRow
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingPersonRow
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingPersonRow
     */
    'photo_url'?: string | null;
    /**
     * 
     * @type {PersonSource}
     * @memberof MeetingPersonRow
     */
    'source': PersonSource;
}


/**
 * One spoken entry of the live transcript.
 * @export
 * @interface MeetingQuickSummaryEntry
 */
export interface MeetingQuickSummaryEntry {
    /**
     * 
     * @type {string}
     * @memberof MeetingQuickSummaryEntry
     */
    'text': string;
    /**
     * 
     * @type {MeetingQuickSummarySpeaker}
     * @memberof MeetingQuickSummaryEntry
     */
    'speaker': MeetingQuickSummarySpeaker;
}
/**
 * The live transcript to summarize and how the summary should be worded.
 * @export
 * @interface MeetingQuickSummaryRequest
 */
export interface MeetingQuickSummaryRequest {
    /**
     * 
     * @type {Array<MeetingQuickSummaryEntry>}
     * @memberof MeetingQuickSummaryRequest
     */
    'entries': Array<MeetingQuickSummaryEntry>;
    /**
     * Whether the summary refers to people as \"Speaker N\".
     * @type {boolean}
     * @memberof MeetingQuickSummaryRequest
     */
    'speaker_labels': boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingQuickSummaryRequest
     */
    'language'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingQuickSummaryRequest
     */
    'notes'?: string | null;
}
/**
 * A quick summary, or the reason there is none.
 * @export
 * @interface MeetingQuickSummaryResponse
 */
export interface MeetingQuickSummaryResponse {
    /**
     * 
     * @type {QuickSummaryOutcome}
     * @memberof MeetingQuickSummaryResponse
     */
    'outcome': QuickSummaryOutcome;
    /**
     * 
     * @type {string}
     * @memberof MeetingQuickSummaryResponse
     */
    'summary_markdown'?: string | null;
}


/**
 * Who spoke one live transcript entry: the audio stream and the speaker\'s number within it.
 * @export
 * @interface MeetingQuickSummarySpeaker
 */
export interface MeetingQuickSummarySpeaker {
    /**
     * 
     * @type {string}
     * @memberof MeetingQuickSummarySpeaker
     */
    'source': MeetingQuickSummarySpeakerSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingQuickSummarySpeaker
     */
    'id': number;
}

export const MeetingQuickSummarySpeakerSourceEnum = {
    Mic: 'mic',
    System: 'system'
} as const;

export type MeetingQuickSummarySpeakerSourceEnum = typeof MeetingQuickSummarySpeakerSourceEnum[keyof typeof MeetingQuickSummarySpeakerSourceEnum];

/**
 * Ordered report for one recording session; explicit false is terminal.
 * @export
 * @interface MeetingRecordingStateRequest
 */
export interface MeetingRecordingStateRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingRecordingStateRequest
     */
    'recording_session_id': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingRecordingStateRequest
     */
    'sequence': number;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRecordingStateRequest
     */
    'is_recording': boolean;
}
/**
 * Acknowledged report sequence and current meeting recording status.
 * @export
 * @interface MeetingRecordingStateResponse
 */
export interface MeetingRecordingStateResponse {
    /**
     * 
     * @type {number}
     * @memberof MeetingRecordingStateResponse
     */
    'sequence': number;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingRecordingStateResponse
     */
    'is_recording': boolean;
}
/**
 * Presigned S3 GET for a meeting\'s refined-transcript NDJSON.  The download twin of :class:`MeetingUploadUrlResponse` (same shape as the notes ``NoteImageKey`` payload): the desktop calls ``GET /meetings/{id}/refined-transcript`` when a pull row\'s ``refined_uploaded_at`` stamp beats its locally persisted fetched-through stamp, then downloads ``refined.ndjson`` straight from S3 — the bytes never transit the API.
 * @export
 * @interface MeetingRefinedTranscriptUrlResponse
 */
export interface MeetingRefinedTranscriptUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingRefinedTranscriptUrlResponse
     */
    'url': string;
    /**
     * Absolute UTC expiry of the presigned GET
     * @type {string}
     * @memberof MeetingRefinedTranscriptUrlResponse
     */
    'expires_at': string;
}
/**
 * One classified report with derived dimensions and read-time authorized links.
 * @export
 * @interface MeetingReportItem
 */
export interface MeetingReportItem {
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'reported_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'reporter_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'severity': MeetingReportItemSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'signature': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'known_issue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'report_type': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'report_category': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'job_status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'meeting_platform'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'output_device'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'output_device_family': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'mic_device'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'app_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'rationale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'slack_channel'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'slack_message_ts'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItem
     */
    'viewer_meeting_id'?: string | null;
}

export const MeetingReportItemSeverityEnum = {
    S0: 's0',
    S1: 's1',
    S2: 's2',
    S3: 's3'
} as const;

export type MeetingReportItemSeverityEnum = typeof MeetingReportItemSeverityEnum[keyof typeof MeetingReportItemSeverityEnum];

/**
 * Keyset-paginated reports, newest first.
 * @export
 * @interface MeetingReportItems
 */
export interface MeetingReportItems {
    /**
     * 
     * @type {Array<MeetingReportItem>}
     * @memberof MeetingReportItems
     */
    'items': Array<MeetingReportItem>;
    /**
     * 
     * @type {string}
     * @memberof MeetingReportItems
     */
    'next_cursor': string | null;
}
/**
 * A rule adding the caller\'s future meetings carrying ``match_value`` to ``folder_id``.
 * @export
 * @interface MeetingRule
 */
export interface MeetingRule {
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'folder_id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'kind': MeetingRuleKindEnum;
    /**
     * A `calendar_event` rule\'s Flow Event Key, a `recurring_series` rule\'s series key, or an `attendee_domain` rule\'s canonical domain, verbatim; echo it back unchanged to delete the rule.
     * @type {string}
     * @memberof MeetingRule
     */
    'match_value': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'expires_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingRule
     */
    'effective_from'?: string | null;
    /**
     * Whether the caller created this rule.
     * @type {boolean}
     * @memberof MeetingRule
     */
    'is_mine'?: boolean;
}

export const MeetingRuleKindEnum = {
    CalendarEvent: 'calendar_event',
    RecurringSeries: 'recurring_series',
    AttendeeDomain: 'attendee_domain'
} as const;

export type MeetingRuleKindEnum = typeof MeetingRuleKindEnum[keyof typeof MeetingRuleKindEnum];

/**
 * The company domain a rule may follow from one of the caller\'s meetings, read before adding it to a folder.
 * @export
 * @interface MeetingRuleDomainResponse
 */
export interface MeetingRuleDomainResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingRuleDomainResponse
     */
    'rule_domain'?: string | null;
}
/**
 * The caller\'s live rules on folders they can still add meetings to, newest first.
 * @export
 * @interface MeetingRuleListResponse
 */
export interface MeetingRuleListResponse {
    /**
     * 
     * @type {Array<MeetingRule>}
     * @memberof MeetingRuleListResponse
     */
    'rules': Array<MeetingRule>;
}
/**
 * Assign one refined speaker to an owner-scoped contact.
 * @export
 * @interface MeetingSpeakerContactAssignmentRequest
 */
export interface MeetingSpeakerContactAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerContactAssignmentRequest
     */
    'refinedSpeakerId': number;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerContactAssignmentRequest
     */
    'contactId': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerContactAssignmentRequest
     */
    'expected_refined_uploaded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerContactAssignmentRequest
     */
    'current_job_id'?: string | null;
}
/**
 * Collected meeting metadata with a read-time authorized artifact link.
 * @export
 * @interface MeetingSpeakerLabelMeeting
 */
export interface MeetingSpeakerLabelMeeting {
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'meeting_key': string;
    /**
     * Meeting creation time used for date filters and daily trends.
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'meeting_created_at': string;
    /**
     * Time the accepted summary result was completed.
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'completed_at': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'platform'?: MeetingSpeakerLabelMeetingPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'os'?: MeetingSpeakerLabelMeetingOsEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'client'?: MeetingSpeakerLabelMeetingClientEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'calendar_event'?: MeetingSpeakerLabelMeetingCalendarEventEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'backend_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'algorithm_version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'app_version'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'invited_attendee_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'user_meeting_number'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'recorded_ms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'active_speakers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'machine_labeled_speakers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'speech_ms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'ax_covered_speech_ms'?: number | null;
    /**
     * Active recording milliseconds; null when capture availability is unknown.
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'ax_capture_ms'?: number | null;
    /**
     * Readable AX milliseconds, including observed silence; null when unknown.
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'ax_readable_ms'?: number | null;
    /**
     * Availability of the independent AX capture measurement.
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'ax_capture_status'?: MeetingSpeakerLabelMeetingAxCaptureStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'words'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'machine_labeled_words'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'ax_measurement_status'?: MeetingSpeakerLabelMeetingAxMeasurementStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'label_measurement_status'?: MeetingSpeakerLabelMeetingLabelMeasurementStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'viewer_meeting_id'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingSpeakerLabelMeeting
     */
    'annotated'?: boolean | null;
}

export const MeetingSpeakerLabelMeetingPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type MeetingSpeakerLabelMeetingPlatformEnum = typeof MeetingSpeakerLabelMeetingPlatformEnum[keyof typeof MeetingSpeakerLabelMeetingPlatformEnum];
export const MeetingSpeakerLabelMeetingOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;

export type MeetingSpeakerLabelMeetingOsEnum = typeof MeetingSpeakerLabelMeetingOsEnum[keyof typeof MeetingSpeakerLabelMeetingOsEnum];
export const MeetingSpeakerLabelMeetingClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;

export type MeetingSpeakerLabelMeetingClientEnum = typeof MeetingSpeakerLabelMeetingClientEnum[keyof typeof MeetingSpeakerLabelMeetingClientEnum];
export const MeetingSpeakerLabelMeetingCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;

export type MeetingSpeakerLabelMeetingCalendarEventEnum = typeof MeetingSpeakerLabelMeetingCalendarEventEnum[keyof typeof MeetingSpeakerLabelMeetingCalendarEventEnum];
export const MeetingSpeakerLabelMeetingAxCaptureStatusEnum = {
    Measured: 'measured',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;

export type MeetingSpeakerLabelMeetingAxCaptureStatusEnum = typeof MeetingSpeakerLabelMeetingAxCaptureStatusEnum[keyof typeof MeetingSpeakerLabelMeetingAxCaptureStatusEnum];
export const MeetingSpeakerLabelMeetingAxMeasurementStatusEnum = {
    Measured: 'measured',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;

export type MeetingSpeakerLabelMeetingAxMeasurementStatusEnum = typeof MeetingSpeakerLabelMeetingAxMeasurementStatusEnum[keyof typeof MeetingSpeakerLabelMeetingAxMeasurementStatusEnum];
export const MeetingSpeakerLabelMeetingLabelMeasurementStatusEnum = {
    Measured: 'measured',
    Unknown: 'unknown',
    NotApplicable: 'not_applicable'
} as const;

export type MeetingSpeakerLabelMeetingLabelMeasurementStatusEnum = typeof MeetingSpeakerLabelMeetingLabelMeasurementStatusEnum[keyof typeof MeetingSpeakerLabelMeetingLabelMeasurementStatusEnum];

/**
 * Keyset-paginated current meeting projections.
 * @export
 * @interface MeetingSpeakerLabelMeetings
 */
export interface MeetingSpeakerLabelMeetings {
    /**
     * 
     * @type {Array<MeetingSpeakerLabelMeeting>}
     * @memberof MeetingSpeakerLabelMeetings
     */
    'items': Array<MeetingSpeakerLabelMeeting>;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerLabelMeetings
     */
    'next_cursor': string | null;
}
/**
 * Persisted durable speaker mapping for one meeting, if valid.
 * @export
 * @interface MeetingSpeakerMapResponse
 */
export interface MeetingSpeakerMapResponse {
    /**
     * 
     * @type {SpeakerMap}
     * @memberof MeetingSpeakerMapResponse
     */
    'speaker_map'?: SpeakerMap | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSpeakerMapResponse
     */
    'displayed_revision'?: string | null;
    /**
     * 
     * @type {MeetingAttributionDiagnostics}
     * @memberof MeetingSpeakerMapResponse
     */
    'diagnostics'?: MeetingAttributionDiagnostics;
}
/**
 * Refine-progress snapshot the desktop pulls as a backstop to sync.  The client polls ``GET /meetings/{id}/status`` with the refine status it currently believes, and the server inlines whatever the client is missing. ``refine_status`` is the server\'s job status, or ``None`` when no refine job row exists for the meeting (the client then has nothing to wait for). ``RefineJobStatus`` is a ``StrEnum``, so it serializes to its string value on the wire.  ``refined_transcript`` is inlined only when the server is ahead of the client (see ``MeetingsService.get_meeting_status``); it stays ``None`` otherwise, on a deleted meeting, and whenever the refined blob is absent, undecodable, or empty.
 * @export
 * @interface MeetingStatusResponse
 */
export interface MeetingStatusResponse {
    /**
     * 
     * @type {RefineJobStatus}
     * @memberof MeetingStatusResponse
     */
    'refine_status': RefineJobStatus | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'modified_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'refined_transcript'?: string | null;
    /**
     * 
     * @type {SpeakerMap}
     * @memberof MeetingStatusResponse
     */
    'speaker_map'?: SpeakerMap | null;
    /**
     * 
     * @type {{ [key: string]: InlineSpeakerAssignment; }}
     * @memberof MeetingStatusResponse
     */
    'speaker_assignments'?: { [key: string]: InlineSpeakerAssignment; } | null;
    /**
     * 
     * @type {Array<ContactResponse>}
     * @memberof MeetingStatusResponse
     */
    'contacts'?: Array<ContactResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingStatusResponse
     */
    'transcript_ready'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeetingStatusResponse
     */
    'summary_ready'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'summary_ready_event_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'refined_uploaded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingStatusResponse
     */
    'notes'?: string | null;
}


/**
 * One 👍/👎 on a meeting\'s summary. The client-generated ``id`` makes a retry idempotent.
 * @export
 * @interface MeetingSummaryFeedbackRequest
 */
export interface MeetingSummaryFeedbackRequest {
    /**
     * Client-generated submission id; resending the same payload is a no-op.
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'rating': MeetingSummaryFeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'feedback'?: string | null;
    /**
     * When the user submitted the rating, with a UTC offset.
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'disclosureVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingSummaryFeedbackRequest
     */
    'clientSummarySha256'?: string | null;
}

export const MeetingSummaryFeedbackRequestRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type MeetingSummaryFeedbackRequestRatingEnum = typeof MeetingSummaryFeedbackRequestRatingEnum[keyof typeof MeetingSummaryFeedbackRequestRatingEnum];

/**
 * Request model for meeting synchronization.
 * @export
 * @interface MeetingSyncRequest
 */
export interface MeetingSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingSyncRequest
     */
    'last_sync_time'?: string | null;
    /**
     * When true, ignore last_sync_time and return up to 1000 meetings from server regardless of modified_at
     * @type {boolean}
     * @memberof MeetingSyncRequest
     */
    'hard_refresh'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeetingSyncRequest
     */
    'cursor'?: string | null;
    /**
     * When true, the server omits inline refined_transcript bodies from pull rows and skips the refined S3 fan-out entirely; the client is declaring it fetches refined bytes out-of-band via GET /meetings/{id}/refined-transcript keyed on the refined_uploaded_at stamp.
     * @type {boolean}
     * @memberof MeetingSyncRequest
     */
    'supports_refined_stamp_fetch'?: boolean;
    /**
     * 
     * @type {Array<SyncMeetingInput>}
     * @memberof MeetingSyncRequest
     */
    'meetings': Array<SyncMeetingInput>;
    /**
     * 
     * @type {Array<SyncMeetingRecordingState>}
     * @memberof MeetingSyncRequest
     */
    'recording_states'?: Array<SyncMeetingRecordingState> | null;
}
/**
 * Response model for meeting synchronization.
 * @export
 * @interface MeetingSyncResponse
 */
export interface MeetingSyncResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingSyncResponse
     */
    'acked': Array<string>;
    /**
     * 
     * @type {Array<SyncMeetingOutput>}
     * @memberof MeetingSyncResponse
     */
    'pull': Array<SyncMeetingOutput>;
    /**
     * 
     * @type {string}
     * @memberof MeetingSyncResponse
     */
    'sync_time': string;
    /**
     * Always empty. Kept for wire compatibility: the Notetaker domain policy is enforced before a recording starts, never against a pushed meeting.
     * @type {Array<string>}
     * @memberof MeetingSyncResponse
     */
    'rejected'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MeetingSyncResponse
     */
    'next_cursor'?: string | null;
}
/**
 * Reassign selected refined transcript entries to an existing person.
 * @export
 * @interface MeetingTranscriptSpeakerReassignmentRequest
 */
export interface MeetingTranscriptSpeakerReassignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'expected_refined_uploaded_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'entry_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'target_person_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'target_refined_speaker_id'?: number | null;
    /**
     * 
     * @type {IdentityTarget}
     * @memberof MeetingTranscriptSpeakerReassignmentRequest
     */
    'target'?: IdentityTarget | null;
}
/**
 * Canonical revision created by a selective speaker reassignment.
 * @export
 * @interface MeetingTranscriptSpeakerReassignmentResponse
 */
export interface MeetingTranscriptSpeakerReassignmentResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerReassignmentResponse
     */
    'refined_uploaded_at': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingTranscriptSpeakerReassignmentResponse
     */
    'target_speaker_id': number;
    /**
     * 
     * @type {number}
     * @memberof MeetingTranscriptSpeakerReassignmentResponse
     */
    'changed_entry_count': number;
}
/**
 * Separate one refined speaker into several along its raw voices.  ``partitions`` groups the ``voices`` the speaker-map row for ``speaker_id`` carries: every listed voice must belong to that row, every row voice must be listed exactly once, and there must be at least two groups. The first group keeps ``speaker_id``; each further group gets a new refined speaker. Bubbles of ``speaker_id`` are cut wherever their raw voice crosses a group boundary; every other bubble is left byte-identical.
 * @export
 * @interface MeetingTranscriptSpeakerSplitRequest
 */
export interface MeetingTranscriptSpeakerSplitRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerSplitRequest
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerSplitRequest
     */
    'expected_refined_uploaded_at': string;
    /**
     * 
     * @type {number}
     * @memberof MeetingTranscriptSpeakerSplitRequest
     */
    'speaker_id': number;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof MeetingTranscriptSpeakerSplitRequest
     */
    'partitions': Array<Array<string>>;
}
/**
 * Canonical revision created by a speaker split.
 * @export
 * @interface MeetingTranscriptSpeakerSplitResponse
 */
export interface MeetingTranscriptSpeakerSplitResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingTranscriptSpeakerSplitResponse
     */
    'refined_uploaded_at': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MeetingTranscriptSpeakerSplitResponse
     */
    'speaker_ids': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof MeetingTranscriptSpeakerSplitResponse
     */
    'changed_entry_count': number;
}
/**
 * Request for a presigned S3 slot to upload a meeting\'s refine audio.
 * @export
 * @interface MeetingUploadUrlRequest
 */
export interface MeetingUploadUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof MeetingUploadUrlRequest
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeetingUploadUrlRequest
     */
    'audio_snapshot_identity'?: string | null;
    /**
     * Audio MIME type; one of audio/ogg, audio/wav
     * @type {string}
     * @memberof MeetingUploadUrlRequest
     */
    'content_type': string;
    /**
     * Encoded audio size in bytes
     * @type {number}
     * @memberof MeetingUploadUrlRequest
     */
    'size_bytes': number;
    /**
     * 
     * @type {object}
     * @memberof MeetingUploadUrlRequest
     */
    'context'?: object | null;
    /**
     * Optional dictation vocabulary snapshot; invalid snapshots are ignored without blocking audio upload.
     * @type {any}
     * @memberof MeetingUploadUrlRequest
     */
    'dictation_context'?: any;
    /**
     * Optional recording-bound native language snapshot; invalid evidence does not block audio upload.
     * @type {any}
     * @memberof MeetingUploadUrlRequest
     */
    'native_language_evidence'?: any;
    /**
     * Feature payload option: add per-user Google Contacts display names as weak refine terms.
     * @type {boolean}
     * @memberof MeetingUploadUrlRequest
     */
    'include_google_contact_names'?: boolean;
    /**
     * Feature payload option: add per-user workspace directory display names as weak refine terms.
     * @type {boolean}
     * @memberof MeetingUploadUrlRequest
     */
    'include_workspace_directory_names'?: boolean;
    /**
     * Optional text-language counts bound to the same recording as native_language_evidence; invalid or mismatched evidence does not block audio upload.
     * @type {any}
     * @memberof MeetingUploadUrlRequest
     */
    'text_language_evidence'?: any;
}
/**
 * Presigned S3 POST the desktop uses to upload refine audio directly.  The S3 object key is carried inside ``fields[\'key\']`` per the S3 presigned-POST contract, so it is not duplicated as a top-level field.
 * @export
 * @interface MeetingUploadUrlResponse
 */
export interface MeetingUploadUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof MeetingUploadUrlResponse
     */
    'url': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MeetingUploadUrlResponse
     */
    'fields': { [key: string]: string; };
    /**
     * ISO-8601 UTC expiry of the presigned POST
     * @type {string}
     * @memberof MeetingUploadUrlResponse
     */
    'expires_at': string;
}
/**
 * Response model for a single enterprise member.  NOTE: ``firstName``, ``lastName``, ``email``, ``role``, and ``avatarUrl`` are Optional because the underlying ``User`` columns (``first_name``, ``last_name``, ``email``, ``enterprise_role``, ``avatar_url`` in ``models/user.py``) are all nullable. Prior to switching this endpoint to ``MembersResponse.model_validate``, a runtime no-op ``cast()`` let nulls flow through to clients, so any user with a partial profile would 500 the endpoint if these were declared non-Optional here.
 * @export
 * @interface MemberResponse
 */
export interface MemberResponse {
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'firstName': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'lastName': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'email': string | null;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof MemberResponse
     */
    'role': EnterpriseRole | null;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'avatarUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'enterpriseId': string;
    /**
     * 
     * @type {boolean}
     * @memberof MemberResponse
     */
    'teamTrialGiven': boolean;
    /**
     * 
     * @type {number}
     * @memberof MemberResponse
     */
    'trialEndsAt': number | null;
    /**
     * 
     * @type {number}
     * @memberof MemberResponse
     */
    'gracePeriodEndsAt'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MemberResponse
     */
    'hasIndividualSubscription'?: boolean | null;
    /**
     * 
     * @type {SeatType}
     * @memberof MemberResponse
     */
    'seatType'?: SeatType | null;
    /**
     * 
     * @type {string}
     * @memberof MemberResponse
     */
    'costCenterId'?: string | null;
}


/**
 * Response model for list of enterprise members.
 * @export
 * @interface MembersResponse
 */
export interface MembersResponse {
    /**
     * 
     * @type {Array<MemberResponse>}
     * @memberof MembersResponse
     */
    'members': Array<MemberResponse>;
}
/**
 * An idempotent owner changeset against an observed generation.
 * @export
 * @interface MemoryCommitRequest
 */
export interface MemoryCommitRequest {
    /**
     * 
     * @type {string}
     * @memberof MemoryCommitRequest
     */
    'operation_id': string;
    /**
     * 
     * @type {ReadToken}
     * @memberof MemoryCommitRequest
     */
    'token': ReadToken;
    /**
     * 
     * @type {Array<OperationsInner>}
     * @memberof MemoryCommitRequest
     */
    'operations': Array<OperationsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MemoryCommitRequest
     */
    'strict_versions'?: boolean;
}
/**
 * Committed versions or the identical original operation result.
 * @export
 * @interface MemoryCommitResponse
 */
export interface MemoryCommitResponse {
    /**
     * 
     * @type {string}
     * @memberof MemoryCommitResponse
     */
    'operation_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof MemoryCommitResponse
     */
    'replayed': boolean;
    /**
     * 
     * @type {Array<CommitVersion>}
     * @memberof MemoryCommitResponse
     */
    'versions': Array<CommitVersion>;
    /**
     * 
     * @type {number}
     * @memberof MemoryCommitResponse
     */
    'learning_generation': number;
}
/**
 * Request for a synthesized memory prompt block given dictation context.
 * @export
 * @interface MemoryContextRequest
 */
export interface MemoryContextRequest {
    /**
     * 
     * @type {MemoryWarmUpContext}
     * @memberof MemoryContextRequest
     */
    'context'?: MemoryWarmUpContext;
    /**
     * 
     * @type {number}
     * @memberof MemoryContextRequest
     */
    'max_facts'?: number;
    /**
     * 
     * @type {number}
     * @memberof MemoryContextRequest
     */
    'max_nodes'?: number;
    /**
     * 
     * @type {number}
     * @memberof MemoryContextRequest
     */
    'max_prompt_chars'?: number;
}
/**
 * The synthesized memory prompt block to prepend for retrieval.
 * @export
 * @interface MemoryContextResponse
 */
export interface MemoryContextResponse {
    /**
     * 
     * @type {string}
     * @memberof MemoryContextResponse
     */
    'prompt_block': string;
}
/**
 * Health check reporting Graphiti reachability and detail.
 * @export
 * @interface MemoryHealthResponse
 */
export interface MemoryHealthResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MemoryHealthResponse
     */
    'graphiti_reachable': boolean;
    /**
     * 
     * @type {object}
     * @memberof MemoryHealthResponse
     */
    'graphiti'?: object | null;
}
/**
 * Batch of action events to ingest into memory.
 * @export
 * @interface MemoryIngestRequest
 */
export interface MemoryIngestRequest {
    /**
     * 
     * @type {Array<ActionEnvelope>}
     * @memberof MemoryIngestRequest
     */
    'actions': Array<ActionEnvelope>;
}
/**
 * Ingest summary: accepted/rejected counts and per-event results.
 * @export
 * @interface MemoryIngestResponse
 */
export interface MemoryIngestResponse {
    /**
     * 
     * @type {number}
     * @memberof MemoryIngestResponse
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof MemoryIngestResponse
     */
    'rejected': number;
    /**
     * 
     * @type {Array<IngestResultRow>}
     * @memberof MemoryIngestResponse
     */
    'results': Array<IngestResultRow>;
}
/**
 * Debug listing of a user\'s memory episodes, facts, and nodes.
 * @export
 * @interface MemoryListResponse
 */
export interface MemoryListResponse {
    /**
     * 
     * @type {string}
     * @memberof MemoryListResponse
     */
    'query': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof MemoryListResponse
     */
    'episodes': Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof MemoryListResponse
     */
    'facts': Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof MemoryListResponse
     */
    'nodes': Array<object>;
}
/**
 * Debug request to search memory facts and nodes for a context.
 * @export
 * @interface MemorySearchRequest
 */
export interface MemorySearchRequest {
    /**
     * 
     * @type {MemoryWarmUpContext}
     * @memberof MemorySearchRequest
     */
    'context'?: MemoryWarmUpContext;
    /**
     * 
     * @type {number}
     * @memberof MemorySearchRequest
     */
    'max_facts'?: number;
    /**
     * 
     * @type {number}
     * @memberof MemorySearchRequest
     */
    'max_nodes'?: number;
}
/**
 * Debug search results: the synthesized query plus matched facts and nodes.
 * @export
 * @interface MemorySearchResponse
 */
export interface MemorySearchResponse {
    /**
     * 
     * @type {string}
     * @memberof MemorySearchResponse
     */
    'query': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof MemorySearchResponse
     */
    'facts': Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof MemorySearchResponse
     */
    'nodes': Array<object>;
}
/**
 * Dictation context for retrieval; the server synthesizes the Graphiti query.
 * @export
 * @interface MemoryWarmUpContext
 */
export interface MemoryWarmUpContext {
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'app'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'app_category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'language'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'app_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'mode'?: MemoryWarmUpContextModeEnum | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemoryWarmUpContext
     */
    'proper_nouns'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MemoryWarmUpContext
     */
    'excerpt'?: string | null;
}

export const MemoryWarmUpContextModeEnum = {
    Dictation: 'dictation',
    Generation: 'generation'
} as const;

export type MemoryWarmUpContextModeEnum = typeof MemoryWarmUpContextModeEnum[keyof typeof MemoryWarmUpContextModeEnum];

/**
 * Top users for one leaderboard metric, plus the caller\'s entry when outside the top 6.
 * @export
 * @interface MetricPodium
 */
export interface MetricPodium {
    /**
     * Top min(6, total_users_ranked) PodiumUser rows by rank (ascending).
     * @type {Array<PodiumUser>}
     * @memberof MetricPodium
     */
    'top_entries'?: Array<PodiumUser>;
    /**
     * 
     * @type {PodiumUser}
     * @memberof MetricPodium
     */
    'requesting_user_entry'?: PodiumUser | null;
}
/**
 * Payload for the mic-quiz results email: heading text and the recommended microphones.
 * @export
 * @interface MicQuizEmailRequest
 */
export interface MicQuizEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof MicQuizEmailRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof MicQuizEmailRequest
     */
    'subtitle'?: string;
    /**
     * 
     * @type {Array<MicRecommendation>}
     * @memberof MicQuizEmailRequest
     */
    'recommendations': Array<MicRecommendation>;
    /**
     * 
     * @type {boolean}
     * @memberof MicQuizEmailRequest
     */
    'show_less_ideal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MicQuizEmailRequest
     */
    'less_ideal_text'?: string;
}
/**
 * Payload for the V2 mic quiz email.  Both fields are required — the template uses them directly without fallbacks, so missing data will render as an empty highlight/title.
 * @export
 * @interface MicQuizV2EmailRequest
 */
export interface MicQuizV2EmailRequest {
    /**
     * 
     * @type {string}
     * @memberof MicQuizV2EmailRequest
     */
    'best_match': MicQuizV2EmailRequestBestMatchEnum;
    /**
     * 
     * @type {string}
     * @memberof MicQuizV2EmailRequest
     */
    'title': string;
}

export const MicQuizV2EmailRequestBestMatchEnum = {
    PodcastMic: 'podcastMic',
    GooseneckMic: 'gooseneckMic',
    LavMic: 'lavMic',
    HeadsetWithMic: 'headsetWithMic'
} as const;

export type MicQuizV2EmailRequestBestMatchEnum = typeof MicQuizV2EmailRequestBestMatchEnum[keyof typeof MicQuizV2EmailRequestBestMatchEnum];

/**
 * A single recommended microphone shown in the mic-quiz results email.
 * @export
 * @interface MicRecommendation
 */
export interface MicRecommendation {
    /**
     * 
     * @type {string}
     * @memberof MicRecommendation
     */
    'badge': string;
    /**
     * 
     * @type {boolean}
     * @memberof MicRecommendation
     */
    'is_best'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MicRecommendation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MicRecommendation
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof MicRecommendation
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof MicRecommendation
     */
    'amazon_url'?: string;
}
/**
 * ``since`` is team creation date (when team-scoped) or enterprise creation date.
 * @export
 * @interface MinutesSaved
 */
export interface MinutesSaved {
    /**
     * 
     * @type {number}
     * @memberof MinutesSaved
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof MinutesSaved
     */
    'since': string;
}
/**
 * 
 * @export
 * @interface Model
 */
export interface Model {
}
/**
 * 
 * @export
 * @interface Model1
 */
export interface Model1 {
}
/**
 * Pull an existing enterprise user into this team from whichever team they\'re on now.
 * @export
 * @interface MoveMemberRequest
 */
export interface MoveMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveMemberRequest
     */
    'user_id': string;
}
/**
 * Reassign a team to a different cost center within the same enterprise.
 * @export
 * @interface MoveTeamToCostCenterRequest
 */
export interface MoveTeamToCostCenterRequest {
    /**
     * 
     * @type {string}
     * @memberof MoveTeamToCostCenterRequest
     */
    'cost_center_id': string;
}
/**
 * Response for GET /api/v1/enterprise/my-current-ip — returns the caller\'s anti-spoofed egress IP.
 * @export
 * @interface MyCurrentIpResponse
 */
export interface MyCurrentIpResponse {
    /**
     * 
     * @type {string}
     * @memberof MyCurrentIpResponse
     */
    'ip': string | null;
}
/**
 * Whether the caller has an open Full seat request in their current enterprise, and whether they may make one.
 * @export
 * @interface MySeatRequestResponse
 */
export interface MySeatRequestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MySeatRequestResponse
     */
    'pending': boolean;
    /**
     * 
     * @type {string}
     * @memberof MySeatRequestResponse
     */
    'requested_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MySeatRequestResponse
     */
    'eligible': boolean;
}
/**
 * Free-text NPS feedback submitted by a customer for a campaign.
 * @export
 * @interface NPSFeedbackRequest
 */
export interface NPSFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof NPSFeedbackRequest
     */
    'customer_id': string;
    /**
     * 
     * @type {string}
     * @memberof NPSFeedbackRequest
     */
    'feedback': string;
    /**
     * 
     * @type {string}
     * @memberof NPSFeedbackRequest
     */
    'campaign': string;
}
/**
 * An NPS numeric score submitted by a customer for a campaign.
 * @export
 * @interface NPSScoreRequest
 */
export interface NPSScoreRequest {
    /**
     * 
     * @type {string}
     * @memberof NPSScoreRequest
     */
    'customer_id': string;
    /**
     * 
     * @type {number}
     * @memberof NPSScoreRequest
     */
    'score': number;
    /**
     * 
     * @type {string}
     * @memberof NPSScoreRequest
     */
    'campaign': string;
}
/**
 * An assistant turn that produced a complete standalone document to open in a new tab.  E.g. a PRD or follow-up email. `text` is the document content; `summary` is a 1-2 word name the model gives it, used as the artifact\'s section/pill title on the client. `summary` is `None` on the text-mode catalog paths that reuse this step without a tool schema.
 * @export
 * @interface NewTabStep
 */
export interface NewTabStep {
    /**
     * 
     * @type {string}
     * @memberof NewTabStep
     */
    'kind'?: NewTabStepKindEnum;
    /**
     * 
     * @type {string}
     * @memberof NewTabStep
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof NewTabStep
     */
    'summary'?: string | null;
}

export const NewTabStepKindEnum = {
    NewTab: 'new_tab'
} as const;

export type NewTabStepKindEnum = typeof NewTabStepKindEnum[keyof typeof NewTabStepKindEnum];

/**
 * Request to format non-English transcript text, with app type and language hints.
 * @export
 * @interface NonEnglishFormattingRequest
 */
export interface NonEnglishFormattingRequest {
    /**
     * Text content to format
     * @type {string}
     * @memberof NonEnglishFormattingRequest
     */
    'content': string;
    /**
     * Application type, to help with selecting application specific prompt
     * @type {AppType}
     * @memberof NonEnglishFormattingRequest
     */
    'app_type': AppType;
    /**
     * 
     * @type {string}
     * @memberof NonEnglishFormattingRequest
     */
    'detected_language'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NonEnglishFormattingRequest
     */
    'user_languages'?: Array<string> | null;
}


/**
 * Delivery state of a share-invitation email.
 * @export
 * @enum {string}
 */

export const NoteEmailStatus = {
    Pending: 'pending',
    Sent: 'sent',
    Error: 'error'
} as const;

export type NoteEmailStatus = typeof NoteEmailStatus[keyof typeof NoteEmailStatus];


/**
 * Image reference attached to a note (sync request side).
 * @export
 * @interface NoteImageKey
 */
export interface NoteImageKey {
    /**
     * 
     * @type {string}
     * @memberof NoteImageKey
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NoteImageKey
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof NoteImageKey
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof NoteImageKey
     */
    'height': number;
    /**
     * 
     * @type {number}
     * @memberof NoteImageKey
     */
    'size_bytes': number;
}
/**
 * Image reference with a presigned GET URL (sync response side).
 * @export
 * @interface NoteImagePayload
 */
export interface NoteImagePayload {
    /**
     * 
     * @type {string}
     * @memberof NoteImagePayload
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NoteImagePayload
     */
    'key': string;
    /**
     * 
     * @type {number}
     * @memberof NoteImagePayload
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof NoteImagePayload
     */
    'height': number;
    /**
     * 
     * @type {number}
     * @memberof NoteImagePayload
     */
    'size_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof NoteImagePayload
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof NoteImagePayload
     */
    'expires_at': string;
}
/**
 * A recipient\'s access level on a shared note.
 * @export
 * @enum {string}
 */

export const NoteShareRole = {
    Owner: 'owner',
    Contributor: 'contributor',
    Viewer: 'viewer'
} as const;

export type NoteShareRole = typeof NoteShareRole[keyof typeof NoteShareRole];


/**
 * Request model for note synchronization.
 * @export
 * @interface NoteSyncRequest
 */
export interface NoteSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof NoteSyncRequest
     */
    'last_sync_time'?: string | null;
    /**
     * When true, ignore last_sync_time and return up to 1000 notes from server regardless of modified_at
     * @type {boolean}
     * @memberof NoteSyncRequest
     */
    'hard_refresh'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NoteSyncRequest
     */
    'cursor'?: string | null;
    /**
     * 
     * @type {Array<SyncNoteRequest>}
     * @memberof NoteSyncRequest
     */
    'notes': Array<SyncNoteRequest>;
    /**
     * 
     * @type {Array<ImageUpload>}
     * @memberof NoteSyncRequest
     */
    'image_uploads'?: Array<ImageUpload>;
    /**
     * Image ids the client wants fresh presigned GETs for (e.g. opened note with expired URLs).
     * @type {Array<string>}
     * @memberof NoteSyncRequest
     */
    'refresh_image_ids'?: Array<string>;
}
/**
 * Response model for note synchronization.
 * @export
 * @interface NoteSyncResponse
 */
export interface NoteSyncResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof NoteSyncResponse
     */
    'acked': Array<string>;
    /**
     * 
     * @type {Array<SyncNote>}
     * @memberof NoteSyncResponse
     */
    'pull': Array<SyncNote>;
    /**
     * 
     * @type {string}
     * @memberof NoteSyncResponse
     */
    'sync_time': string;
    /**
     * 
     * @type {Array<ImageUploadUrl>}
     * @memberof NoteSyncResponse
     */
    'upload_urls'?: Array<ImageUploadUrl>;
    /**
     * Fresh presigned GETs for the subset of refresh_image_ids the caller owns.
     * @type {Array<NoteImagePayload>}
     * @memberof NoteSyncResponse
     */
    'refreshed_images'?: Array<NoteImagePayload>;
    /**
     * 
     * @type {string}
     * @memberof NoteSyncResponse
     */
    'next_cursor'?: string | null;
}
/**
 * Who can access a shared note.
 * @export
 * @enum {string}
 */

export const NoteVisibility = {
    AnyoneWithLink: 'anyone_with_link',
    Domain: 'domain',
    InvitedOnly: 'invited_only'
} as const;

export type NoteVisibility = typeof NoteVisibility[keyof typeof NoteVisibility];


/**
 * Optional assistant-message rating and explanation.
 * @export
 * @interface NotetakerChatFeedback
 */
export interface NotetakerChatFeedback {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatFeedback
     */
    'rating': NotetakerChatFeedbackRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatFeedback
     */
    'text'?: string | null;
}

export const NotetakerChatFeedbackRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type NotetakerChatFeedbackRatingEnum = typeof NotetakerChatFeedbackRatingEnum[keyof typeof NotetakerChatFeedbackRatingEnum];

/**
 * Product surface that owns a persisted Notetaker chat session.
 * @export
 * @enum {string}
 */

export const NotetakerChatKind = {
    L2: 'L2',
    MeetingChat: 'meeting_chat'
} as const;

export type NotetakerChatKind = typeof NotetakerChatKind[keyof typeof NotetakerChatKind];


/**
 * Canonical sequence index acknowledged for a message.
 * @export
 * @interface NotetakerChatMessageAck
 */
export interface NotetakerChatMessageAck {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageAck
     */
    'message_id': string;
    /**
     * 
     * @type {number}
     * @memberof NotetakerChatMessageAck
     */
    'sequence_index': number;
}
/**
 * One canonical server-ordered chat message.
 * @export
 * @interface NotetakerChatMessageRecord
 */
export interface NotetakerChatMessageRecord {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageRecord
     */
    'message_id': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageRecord
     */
    'chat_id': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageRecord
     */
    'turn_id': string;
    /**
     * 
     * @type {number}
     * @memberof NotetakerChatMessageRecord
     */
    'sequence_index': number;
    /**
     * 
     * @type {NotetakerChatMessageStatus}
     * @memberof NotetakerChatMessageRecord
     */
    'status': NotetakerChatMessageStatus;
    /**
     * 
     * @type {WisprAgentMessageStepOutput}
     * @memberof NotetakerChatMessageRecord
     */
    'message': WisprAgentMessageStepOutput;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NotetakerChatMessageRecord
     */
    'metadata': { [key: string]: any; } | null;
    /**
     * 
     * @type {NotetakerChatFeedback}
     * @memberof NotetakerChatMessageRecord
     */
    'feedback': NotetakerChatFeedback | null;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageRecord
     */
    'created_at': string;
}


/**
 * Notetaker-specific terminal and in-flight message outcomes.
 * @export
 * @enum {string}
 */

export const NotetakerChatMessageStatus = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    RequestTimeout: 'request_timeout',
    RequestError: 'request_error',
    ToolError: 'tool_error',
    Cancelled: 'cancelled',
    Superseded: 'superseded',
    NoText: 'no_text',
    NotEditable: 'not_editable',
    Interrupted: 'interrupted'
} as const;

export type NotetakerChatMessageStatus = typeof NotetakerChatMessageStatus[keyof typeof NotetakerChatMessageStatus];


/**
 * One client message mutation.
 * @export
 * @interface NotetakerChatMessageUpload
 */
export interface NotetakerChatMessageUpload {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageUpload
     */
    'message_id': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatMessageUpload
     */
    'turn_id': string;
    /**
     * 
     * @type {NotetakerChatMessageStatus}
     * @memberof NotetakerChatMessageUpload
     */
    'status': NotetakerChatMessageStatus;
    /**
     * 
     * @type {WisprAgentMessageStepInput}
     * @memberof NotetakerChatMessageUpload
     */
    'message': WisprAgentMessageStepInput;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NotetakerChatMessageUpload
     */
    'metadata'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {NotetakerChatFeedback}
     * @memberof NotetakerChatMessageUpload
     */
    'feedback'?: NotetakerChatFeedback | null;
    /**
     * 
     * @type {NotetakerChatTurnContext}
     * @memberof NotetakerChatMessageUpload
     */
    'turn_context'?: NotetakerChatTurnContext | null;
}


/**
 * One active Notetaker chat session.
 * @export
 * @interface NotetakerChatRecord
 */
export interface NotetakerChatRecord {
    /**
     * Client-generated chat session id; stable across upload and list.
     * @type {string}
     * @memberof NotetakerChatRecord
     */
    'chat_id': string;
    /**
     * 
     * @type {NotetakerChatKind}
     * @memberof NotetakerChatRecord
     */
    'kind': NotetakerChatKind;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatRecord
     */
    'meeting_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatRecord
     */
    'title': string | null;
    /**
     * Highest server-assigned message sequence index in this chat (0 if empty).
     * @type {number}
     * @memberof NotetakerChatRecord
     */
    'last_message_sequence_index': number;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatRecord
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatRecord
     */
    'modified_at': string;
}


/**
 * History filtering mode for listing Notetaker chat sessions.
 * @export
 * @enum {string}
 */

export const NotetakerChatScope = {
    Hub: 'hub',
    Meeting: 'meeting'
} as const;

export type NotetakerChatScope = typeof NotetakerChatScope[keyof typeof NotetakerChatScope];


/**
 * Everything needed to re-run the agent call that produced a rated answer.  Sent by the client only alongside ``feedback``; relayed to the Ask Anything feedback channel and never persisted.
 * @export
 * @interface NotetakerChatTurnContext
 */
export interface NotetakerChatTurnContext {
    /**
     * The final /wispr_agent/response request of the turn, byte-for-byte as the client sent it.
     * @type {WisprAgentRequest}
     * @memberof NotetakerChatTurnContext
     */
    'request': WisprAgentRequest;
    /**
     * Trajectory returned by that request plus any client tool results, before local pruning.
     * @type {Array<WisprAgentStepInput>}
     * @memberof NotetakerChatTurnContext
     */
    'new_trajectory': Array<WisprAgentStepInput>;
    /**
     * How many /wispr_agent/response calls the turn took.
     * @type {number}
     * @memberof NotetakerChatTurnContext
     */
    'provider_invocations': number;
}
/**
 * One atomic chat mutation and its bounded message batch.
 * @export
 * @interface NotetakerChatUpload
 */
export interface NotetakerChatUpload {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatUpload
     */
    'chat_id': string;
    /**
     * 
     * @type {NotetakerChatKind}
     * @memberof NotetakerChatUpload
     */
    'kind': NotetakerChatKind;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatUpload
     */
    'meeting_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatUpload
     */
    'title'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotetakerChatUpload
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {Array<NotetakerChatMessageUpload>}
     * @memberof NotetakerChatUpload
     */
    'messages'?: Array<NotetakerChatMessageUpload>;
}


/**
 * Canonical state acknowledged for one uploaded chat.
 * @export
 * @interface NotetakerChatUploadAck
 */
export interface NotetakerChatUploadAck {
    /**
     * 
     * @type {string}
     * @memberof NotetakerChatUploadAck
     */
    'chat_id': string;
    /**
     * 
     * @type {Array<NotetakerChatMessageAck>}
     * @memberof NotetakerChatUploadAck
     */
    'messages': Array<NotetakerChatMessageAck>;
}
/**
 * Body for ``PATCH /events/{external_id}/notetaker-controls``. An omitted field is left unchanged.
 * @export
 * @interface NotetakerControlsRequest
 */
export interface NotetakerControlsRequest {
    /**
     * 
     * @type {CalendarNoticePref}
     * @memberof NotetakerControlsRequest
     */
    'calendarNotice'?: CalendarNoticePref | null;
    /**
     * 
     * @type {AutoShareNotesPref}
     * @memberof NotetakerControlsRequest
     */
    'autoShare'?: AutoShareNotesPref | null;
}


/**
 * Longest a single Notetaker recording runs before it stops automatically.
 * @export
 * @enum {string}
 */

export const NotetakerMaxRecordingLength = {
    _30min: '30min',
    _1hr: '1hr',
    _2hr: '2hr',
    _3hr: '3hr'
} as const;

export type NotetakerMaxRecordingLength = typeof NotetakerMaxRecordingLength[keyof typeof NotetakerMaxRecordingLength];


/**
 * ``armed`` = pre-meeting notice (scheduled or later armed). Notes-link writes go through share, not this route.
 * @export
 * @interface NotetakerNoticeRequest
 */
export interface NotetakerNoticeRequest {
    /**
     * 
     * @type {string}
     * @memberof NotetakerNoticeRequest
     */
    'trigger'?: NotetakerNoticeRequestTriggerEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotetakerNoticeRequest
     */
    'externalIds'?: Array<string>;
}

export const NotetakerNoticeRequestTriggerEnum = {
    Armed: 'armed'
} as const;

export type NotetakerNoticeRequestTriggerEnum = typeof NotetakerNoticeRequestTriggerEnum[keyof typeof NotetakerNoticeRequestTriggerEnum];

/**
 * Per-id outcomes, request order, first occurrence of each id.
 * @export
 * @interface NotetakerNoticeResponse
 */
export interface NotetakerNoticeResponse {
    /**
     * 
     * @type {Array<NotetakerNoticeResult>}
     * @memberof NotetakerNoticeResponse
     */
    'results': Array<NotetakerNoticeResult>;
}
/**
 * Always-200 outcome for one id. Only ``no_write_scope`` should prompt reconnect.
 * @export
 * @interface NotetakerNoticeResult
 */
export interface NotetakerNoticeResult {
    /**
     * 
     * @type {string}
     * @memberof NotetakerNoticeResult
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerNoticeResult
     */
    'status': string;
}
/**
 * Response shape for ``GET /api/v1/calendar/events/{external_id}/notetaker-policy``.  ``blocked`` is the RAW domain decision. ``notetakerDisabledAt`` and the BAA floor outrank it and are applied client-side, so this must never be read as final.
 * @export
 * @interface NotetakerPolicyResponse
 */
export interface NotetakerPolicyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NotetakerPolicyResponse
     */
    'blocked': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotetakerPolicyResponse
     */
    'matchedAttendees'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof NotetakerPolicyResponse
     */
    'matchedCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NotetakerPolicyResponse
     */
    'attendeesUntrustworthy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NotetakerPolicyResponse
     */
    'rulesVersion': string;
}
/**
 * One event\'s verdict on the delta feed. Carries no addresses by design.
 * @export
 * @interface NotetakerPolicySyncItemDTO
 */
export interface NotetakerPolicySyncItemDTO {
    /**
     * 
     * @type {string}
     * @memberof NotetakerPolicySyncItemDTO
     */
    'externalId': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotetakerPolicySyncItemDTO
     */
    'blocked': boolean;
}
/**
 * Response shape for ``GET /api/v1/calendar/notetaker-policy/sync``.  ``rulesVersion`` is what makes an admin\'s rules change re-deliver: verdicts are filed per version, so a client whose stored version differs must reset its cursor and ``since`` to null rather than wait for a `computed_at` that will never move.
 * @export
 * @interface NotetakerPolicySyncResponse
 */
export interface NotetakerPolicySyncResponse {
    /**
     * 
     * @type {Array<NotetakerPolicySyncItemDTO>}
     * @memberof NotetakerPolicySyncResponse
     */
    'verdicts': Array<NotetakerPolicySyncItemDTO>;
    /**
     * 
     * @type {string}
     * @memberof NotetakerPolicySyncResponse
     */
    'rulesVersion': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerPolicySyncResponse
     */
    'serverTime': string;
    /**
     * 
     * @type {string}
     * @memberof NotetakerPolicySyncResponse
     */
    'nextCursor'?: string | null;
}
/**
 * Synced Notetaker share + calendar-notice settings.
 * @export
 * @interface NotetakerPreference
 */
export interface NotetakerPreference {
    /**
     * 
     * @type {NoteVisibility}
     * @memberof NotetakerPreference
     */
    'default_note_visibility'?: NoteVisibility;
    /**
     * 
     * @type {CalendarNoticePref}
     * @memberof NotetakerPreference
     */
    'notetaker_calendar_notice'?: CalendarNoticePref;
    /**
     * 
     * @type {AutoShareNotesPref}
     * @memberof NotetakerPreference
     */
    'notetaker_auto_share_notes'?: AutoShareNotesPref;
    /**
     * 
     * @type {AutoShareNotesType}
     * @memberof NotetakerPreference
     */
    'notetaker_auto_share_notes_type'?: AutoShareNotesType;
    /**
     * 
     * @type {NotetakerMaxRecordingLength}
     * @memberof NotetakerPreference
     */
    'notetaker_max_recording_length'?: NotetakerMaxRecordingLength | null;
}


/**
 * Partial nested Notetaker settings; omitted keys are left untouched on merge.
 * @export
 * @interface NotetakerPreferenceUpdate
 */
export interface NotetakerPreferenceUpdate {
    /**
     * 
     * @type {NoteVisibility}
     * @memberof NotetakerPreferenceUpdate
     */
    'default_note_visibility'?: NoteVisibility | null;
    /**
     * 
     * @type {CalendarNoticePref}
     * @memberof NotetakerPreferenceUpdate
     */
    'notetaker_calendar_notice'?: CalendarNoticePref | null;
    /**
     * 
     * @type {AutoShareNotesPref}
     * @memberof NotetakerPreferenceUpdate
     */
    'notetaker_auto_share_notes'?: AutoShareNotesPref | null;
    /**
     * 
     * @type {AutoShareNotesType}
     * @memberof NotetakerPreferenceUpdate
     */
    'notetaker_auto_share_notes_type'?: AutoShareNotesType | null;
    /**
     * 
     * @type {NotetakerMaxRecordingLength}
     * @memberof NotetakerPreferenceUpdate
     */
    'notetaker_max_recording_length'?: NotetakerMaxRecordingLength | null;
}


/**
 * User-selectable retention window for Notetaker transcripts.
 * @export
 * @enum {string}
 */

export const NotetakerTranscriptRetention = {
    NeverDelete: 'never_delete',
    _1Day: '1_day',
    _7Days: '7_days',
    _30Days: '30_days',
    _90Days: '90_days',
    _180Days: '180_days',
    _365Days: '365_days'
} as const;

export type NotetakerTranscriptRetention = typeof NotetakerTranscriptRetention[keyof typeof NotetakerTranscriptRetention];


/**
 * The caller\'s Notetaker recording allowance for the current UTC-Monday week.
 * @export
 * @interface NotetakerWeeklyQuotaResponse
 */
export interface NotetakerWeeklyQuotaResponse {
    /**
     * Qualifying meetings already recorded this week
     * @type {number}
     * @memberof NotetakerWeeklyQuotaResponse
     */
    'counted': number;
    /**
     * Meetings allowed per week on the caller\'s plan, and their experiment arm if enrolled
     * @type {number}
     * @memberof NotetakerWeeklyQuotaResponse
     */
    'limit': number;
    /**
     * Meetings still available this week; never negative
     * @type {number}
     * @memberof NotetakerWeeklyQuotaResponse
     */
    'remaining': number;
    /**
     * UTC Monday 00:00 that opened the current week
     * @type {string}
     * @memberof NotetakerWeeklyQuotaResponse
     */
    'week_started_at': string;
    /**
     * UTC Monday 00:00 that closes the current week
     * @type {string}
     * @memberof NotetakerWeeklyQuotaResponse
     */
    'resets_at': string;
}
/**
 * Request body describing a notification to create.
 * @export
 * @interface NotificationCreateRequest
 */
export interface NotificationCreateRequest {
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationCreateRequest
     */
    'type': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'ios_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreateRequest
     */
    'ios_text'?: string | null;
    /**
     * 
     * @type {NotificationPlatformType}
     * @memberof NotificationCreateRequest
     */
    'platform_type'?: NotificationPlatformType;
}


/**
 * A page of notifications with unread and total counts.
 * @export
 * @interface NotificationListResponse
 */
export interface NotificationListResponse {
    /**
     * 
     * @type {Array<NotificationResponse>}
     * @memberof NotificationListResponse
     */
    'notifications': Array<NotificationResponse>;
    /**
     * 
     * @type {number}
     * @memberof NotificationListResponse
     */
    'unread_count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationListResponse
     */
    'total': number;
}
/**
 * Client platform(s) a notification targets.
 * @export
 * @enum {string}
 */

export const NotificationPlatformType = {
    Desktop: 'desktop',
    Ios: 'ios',
    Both: 'both'
} as const;

export type NotificationPlatformType = typeof NotificationPlatformType[keyof typeof NotificationPlatformType];


/**
 * A single notification as returned to the client.
 * @export
 * @interface NotificationResponse
 */
export interface NotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'id': string;
    /**
     * 
     * @type {NotificationType}
     * @memberof NotificationResponse
     */
    'type': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'text': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'ios_title': string | null;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'ios_text': string | null;
    /**
     * 
     * @type {NotificationPlatformType}
     * @memberof NotificationResponse
     */
    'platform_type': NotificationPlatformType;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponse
     */
    'created_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponse
     */
    'is_archived': boolean;
}


/**
 * Category of a user notification.
 * @export
 * @enum {string}
 */

export const NotificationType = {
    Achievement: 'achievement',
    Referral: 'referral',
    Announcement: 'announcement',
    NoteShared: 'note_shared'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * What the client did with one stored nudge; ``surface`` and ``nudge_type`` name the record it updates.
 * @export
 * @interface NudgeFeedbackEvent
 */
export interface NudgeFeedbackEvent {
    /**
     * 
     * @type {string}
     * @memberof NudgeFeedbackEvent
     */
    'client_event_id': string;
    /**
     * 
     * @type {string}
     * @memberof NudgeFeedbackEvent
     */
    'nudge_id': string;
    /**
     * 
     * @type {NudgeSurface}
     * @memberof NudgeFeedbackEvent
     */
    'surface': NudgeSurface;
    /**
     * 
     * @type {NudgeType}
     * @memberof NudgeFeedbackEvent
     */
    'nudge_type': NudgeType;
    /**
     * 
     * @type {string}
     * @memberof NudgeFeedbackEvent
     */
    'event': NudgeFeedbackEventEventEnum;
    /**
     * 
     * @type {number}
     * @memberof NudgeFeedbackEvent
     */
    'occurred_at_ms': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof NudgeFeedbackEvent
     */
    'payload'?: { [key: string]: any; };
}

export const NudgeFeedbackEventEventEnum = {
    Shown: 'shown',
    Interacted: 'interacted',
    Dismissed: 'dismissed'
} as const;

export type NudgeFeedbackEventEventEnum = typeof NudgeFeedbackEventEventEnum[keyof typeof NudgeFeedbackEventEventEnum];

/**
 * Where a nudge shows in the client.
 * @export
 * @enum {string}
 */

export const NudgeSurface = {
    AskAnything: 'ask_anything'
} as const;

export type NudgeSurface = typeof NudgeSurface[keyof typeof NudgeSurface];


/**
 * What a nudge carries for its surface.
 * @export
 * @enum {string}
 */

export const NudgeType = {
    Suggestion: 'suggestion'
} as const;

export type NudgeType = typeof NudgeType[keyof typeof NudgeType];


/**
 * Request to run OCR on a base64-encoded image.
 * @export
 * @interface OCRRequest
 */
export interface OCRRequest {
    /**
     * 
     * @type {string}
     * @memberof OCRRequest
     */
    'image': string;
}
/**
 * Bounded children for a cohort drill-down.
 * @export
 * @interface ObservationCohorts
 */
export interface ObservationCohorts {
    /**
     * 
     * @type {Array<ObservationGroup>}
     * @memberof ObservationCohorts
     */
    'groups': Array<ObservationGroup>;
    /**
     * True when more than 100 matching groups exist.
     * @type {boolean}
     * @memberof ObservationCohorts
     */
    'truncated'?: boolean;
}
/**
 * Recency of collected results; this does not measure missing meetings.
 * @export
 * @interface ObservationFreshness
 */
export interface ObservationFreshness {
    /**
     * Newest accepted completion among the filtered collected meetings.
     * @type {string}
     * @memberof ObservationFreshness
     */
    'latest_completed_at': string | null;
    /**
     * Latest successful usage write; does not measure collection completeness.
     * @type {string}
     * @memberof ObservationFreshness
     */
    'latest_persisted_at': string | null;
}
/**
 * One cohort and its complete set of weighted counters.
 * @export
 * @interface ObservationGroup
 */
export interface ObservationGroup {
    /**
     * 
     * @type {string}
     * @memberof ObservationGroup
     */
    'value': string;
    /**
     * 
     * @type {ObservationSummary}
     * @memberof ObservationGroup
     */
    'summary': ObservationSummary;
}
/**
 * The largest combined cohorts, ranked by complete-period meeting count.
 * @export
 * @interface ObservationGroupedTrend
 */
export interface ObservationGroupedTrend {
    /**
     * 
     * @type {Array<string>}
     * @memberof ObservationGroupedTrend
     */
    'group_by': Array<ObservationGroupedTrendGroupByEnum>;
    /**
     * 
     * @type {Array<ObservationTrendGroup>}
     * @memberof ObservationGroupedTrend
     */
    'groups': Array<ObservationTrendGroup>;
    /**
     * True when more than 12 matching combined groups exist.
     * @type {boolean}
     * @memberof ObservationGroupedTrend
     */
    'truncated': boolean;
}

export const ObservationGroupedTrendGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type ObservationGroupedTrendGroupByEnum = typeof ObservationGroupedTrendGroupByEnum[keyof typeof ObservationGroupedTrendGroupByEnum];

/**
 * Claims over the speakers actually evaluated by one source.
 * @export
 * @interface ObservationLabelEvaluation
 */
export interface ObservationLabelEvaluation {
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelEvaluation
     */
    'evaluated_speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelEvaluation
     */
    'claimed_speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelEvaluation
     */
    'measured_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelEvaluation
     */
    'evaluated_meetings': number;
}
/**
 * Final assignments and distinct matching meetings for one source rule.
 * @export
 * @interface ObservationLabelRule
 */
export interface ObservationLabelRule {
    /**
     * 
     * @type {string}
     * @memberof ObservationLabelRule
     */
    'rule': ObservationLabelRuleRuleEnum;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelRule
     */
    'speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelRule
     */
    'meetings': number;
}

export const ObservationLabelRuleRuleEnum = {
    Dom: 'dom',
    DomContested: 'dom_contested',
    Rescue: 'rescue',
    MicContentOwner: 'mic_content_owner',
    MicSoleSpeakerOwner: 'mic_sole_speaker_owner',
    SystemContentAttendee: 'system_content_attendee',
    PairedSoleAttendee: 'paired_sole_attendee',
    RosterCalendar: 'roster_calendar',
    RosterOther: 'roster_other',
    NamingLinkCalendar: 'naming_link_calendar',
    NamingLinkOther: 'naming_link_other',
    NamingCreated: 'naming_created',
    Prior: 'prior',
    Unknown: 'unknown'
} as const;

export type ObservationLabelRuleRuleEnum = typeof ObservationLabelRuleRuleEnum[keyof typeof ObservationLabelRuleRuleEnum];

/**
 * Final assignments and distinct matching meetings for one label source.
 * @export
 * @interface ObservationLabelSource
 */
export interface ObservationLabelSource {
    /**
     * 
     * @type {string}
     * @memberof ObservationLabelSource
     */
    'source': ObservationLabelSourceSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelSource
     */
    'speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelSource
     */
    'meetings': number;
    /**
     * 
     * @type {Array<ObservationLabelRule>}
     * @memberof ObservationLabelSource
     */
    'rules': Array<ObservationLabelRule>;
    /**
     * 
     * @type {ObservationLabelEvaluation}
     * @memberof ObservationLabelSource
     */
    'evaluation'?: ObservationLabelEvaluation | null;
}

export const ObservationLabelSourceSourceEnum = {
    Ax: 'ax',
    Channel: 'channel',
    Llm: 'llm',
    Unnamed: 'unnamed'
} as const;

export type ObservationLabelSourceSourceEnum = typeof ObservationLabelSourceSourceEnum[keyof typeof ObservationLabelSourceSourceEnum];

/**
 * Source partition over meetings with a complete, consistent speaker measurement.
 * @export
 * @interface ObservationLabelSources
 */
export interface ObservationLabelSources {
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelSources
     */
    'measured_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelSources
     */
    'unmeasured_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationLabelSources
     */
    'active_speakers': number;
    /**
     * 
     * @type {Array<ObservationLabelSource>}
     * @memberof ObservationLabelSources
     */
    'sources': Array<ObservationLabelSource>;
}
/**
 * Current fleet metrics and discoverable filter values.
 * @export
 * @interface ObservationOverview
 */
export interface ObservationOverview {
    /**
     * 
     * @type {ObservationSummary}
     * @memberof ObservationOverview
     */
    'summary': ObservationSummary;
    /**
     * 
     * @type {Array<ObservationTrendPoint>}
     * @memberof ObservationOverview
     */
    'trend': Array<ObservationTrendPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ObservationOverview
     */
    'facets': { [key: string]: Array<string>; };
    /**
     * 
     * @type {ObservationFreshness}
     * @memberof ObservationOverview
     */
    'freshness': ObservationFreshness;
}
/**
 * Pooled counters with explicit measured-population denominators.
 * @export
 * @interface ObservationSummary
 */
export interface ObservationSummary {
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'meeting_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'measured_label_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'machine_labeled_speakers'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'active_speakers'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'fully_machine_labeled_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'measured_ax_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'speech_ms'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'ax_covered_speech_ms'?: number;
    /**
     * Active recording milliseconds with measured capture availability.
     * @type {number}
     * @memberof ObservationSummary
     */
    'ax_capture_ms'?: number;
    /**
     * Recording milliseconds with readable AX evidence, including observed silence.
     * @type {number}
     * @memberof ObservationSummary
     */
    'ax_readable_ms'?: number;
    /**
     * Meetings contributing measured capture durations.
     * @type {number}
     * @memberof ObservationSummary
     */
    'measured_ax_capture_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'measured_word_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'words'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationSummary
     */
    'machine_labeled_words'?: number;
    /**
     * 
     * @type {ObservationLabelSources}
     * @memberof ObservationSummary
     */
    'label_sources'?: ObservationLabelSources | null;
}
/**
 * A ranked cohort and its daily measurements.
 * @export
 * @interface ObservationTrendGroup
 */
export interface ObservationTrendGroup {
    /**
     * 
     * @type {Array<ObservationTrendPathItem>}
     * @memberof ObservationTrendGroup
     */
    'path': Array<ObservationTrendPathItem>;
    /**
     * 
     * @type {Array<ObservationTrendPoint>}
     * @memberof ObservationTrendGroup
     */
    'trend': Array<ObservationTrendPoint>;
}
/**
 * One physical meeting dimension in an ordered trend path.
 * @export
 * @interface ObservationTrendPathItem
 */
export interface ObservationTrendPathItem {
    /**
     * 
     * @type {string}
     * @memberof ObservationTrendPathItem
     */
    'dimension': ObservationTrendPathItemDimensionEnum;
    /**
     * 
     * @type {string}
     * @memberof ObservationTrendPathItem
     */
    'value': string;
}

export const ObservationTrendPathItemDimensionEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type ObservationTrendPathItemDimensionEnum = typeof ObservationTrendPathItemDimensionEnum[keyof typeof ObservationTrendPathItemDimensionEnum];

/**
 * Daily cohort counts using the same overview denominator.
 * @export
 * @interface ObservationTrendPoint
 */
export interface ObservationTrendPoint {
    /**
     * 
     * @type {string}
     * @memberof ObservationTrendPoint
     */
    'date': string;
    /**
     * 
     * @type {ObservationTrendSummary}
     * @memberof ObservationTrendPoint
     */
    'summary': ObservationTrendSummary;
}
/**
 * Daily volume and pooled naming and AX evidence counters.
 * @export
 * @interface ObservationTrendSummary
 */
export interface ObservationTrendSummary {
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'meeting_count': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'measured_label_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'fully_machine_labeled_meetings': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'machine_labeled_speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'active_speakers': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'speech_ms': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'ax_covered_speech_ms': number;
    /**
     * Active recording milliseconds with measured capture availability.
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'ax_capture_ms'?: number;
    /**
     * Recording milliseconds with readable AX evidence, including observed silence.
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'ax_readable_ms'?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'words': number;
    /**
     * 
     * @type {number}
     * @memberof ObservationTrendSummary
     */
    'machine_labeled_words': number;
}
/**
 * Acknowledgement response after onboarding answers are submitted.
 * @export
 * @interface OnboardingAnswersResponse
 */
export interface OnboardingAnswersResponse {
    /**
     * 
     * @type {string}
     * @memberof OnboardingAnswersResponse
     */
    'message': string;
}
/**
 * Acquisition context for the signed-in account, relayed with the device sign-in tokens.
 * @export
 * @interface OnboardingContext
 */
export interface OnboardingContext {
    /**
     * 
     * @type {string}
     * @memberof OnboardingContext
     */
    'user_id': string;
    /**
     * 
     * @type {OnboardingContextSignals}
     * @memberof OnboardingContext
     */
    'signals': OnboardingContextSignals;
}
/**
 * Stored acquisition signals for an account; each is null when unknown or unusable.
 * @export
 * @interface OnboardingContextSignals
 */
export interface OnboardingContextSignals {
    /**
     * 
     * @type {string}
     * @memberof OnboardingContextSignals
     */
    'first_landing_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingContextSignals
     */
    'utm_source': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingContextSignals
     */
    'utm_medium': string | null;
    /**
     * 
     * @type {string}
     * @memberof OnboardingContextSignals
     */
    'utm_campaign': string | null;
}
/**
 * An onboarding step a user has fulfilled, tracked to drive completion flow.
 * @export
 * @enum {string}
 */

export const OnboardingIntent = {
    SpendTimeTyping: 'spend_time_typing',
    FlowUseCase: 'flow_use_case',
    AboutYourself: 'about_yourself',
    WorkEnvironment: 'work_environment',
    LanguagePreference: 'language_preference',
    Attribution: 'attribution',
    PrivacyConsent: 'privacy_consent',
    PersonalizationStyles: 'personalization_styles',
    PersonalizationStylesDefault: 'personalization_styles_default',
    TrialActivation: 'trial_activation',
    VoiceProfile: 'voice_profile',
    ProductValueProp: 'product_value_prop'
} as const;

export type OnboardingIntent = typeof OnboardingIntent[keyof typeof OnboardingIntent];


/**
 * Request schema for Customer.io onboarding webhook.
 * @export
 * @interface OnboardingWebhookRequest
 */
export interface OnboardingWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof OnboardingWebhookRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingWebhookRequest
     */
    'token': string;
}
/**
 * Provider config for an OpenAI-backed model.
 * @export
 * @interface OpenAIProviderConfig
 */
export interface OpenAIProviderConfig {
    /**
     * 
     * @type {string}
     * @memberof OpenAIProviderConfig
     */
    'kind'?: OpenAIProviderConfigKindEnum;
    /**
     * 
     * @type {Model1}
     * @memberof OpenAIProviderConfig
     */
    'model': Model1;
}

export const OpenAIProviderConfigKindEnum = {
    Openai: 'openai'
} as const;

export type OpenAIProviderConfigKindEnum = typeof OpenAIProviderConfigKindEnum[keyof typeof OpenAIProviderConfigKindEnum];

/**
 * Provider config for an OpenRouter-backed model.
 * @export
 * @interface OpenRouterProviderConfig
 */
export interface OpenRouterProviderConfig {
    /**
     * 
     * @type {string}
     * @memberof OpenRouterProviderConfig
     */
    'kind'?: OpenRouterProviderConfigKindEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenRouterProviderConfig
     */
    'model': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpenRouterProviderConfig
     */
    'provider_order'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OpenRouterProviderConfig
     */
    'allow_fallbacks'?: boolean;
}

export const OpenRouterProviderConfigKindEnum = {
    Openrouter: 'openrouter'
} as const;

export type OpenRouterProviderConfigKindEnum = typeof OpenRouterProviderConfigKindEnum[keyof typeof OpenRouterProviderConfigKindEnum];

/**
 * Open a self-serve subscription through hosted Checkout; reuse request_id and content when retrying.
 * @export
 * @interface OpenSelfServeCheckoutRequest
 */
export interface OpenSelfServeCheckoutRequest {
    /**
     * 
     * @type {string}
     * @memberof OpenSelfServeCheckoutRequest
     */
    'request_id': string;
    /**
     * 
     * @type {string}
     * @memberof OpenSelfServeCheckoutRequest
     */
    'interval': OpenSelfServeCheckoutRequestIntervalEnum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof OpenSelfServeCheckoutRequest
     */
    'seats': { [key: string]: number; };
}

export const OpenSelfServeCheckoutRequestIntervalEnum = {
    Month: 'month',
    Year: 'year'
} as const;

export type OpenSelfServeCheckoutRequestIntervalEnum = typeof OpenSelfServeCheckoutRequestIntervalEnum[keyof typeof OpenSelfServeCheckoutRequestIntervalEnum];

/**
 * Metadata for a single registered op, surfaced to the operator UI.
 * @export
 * @interface OperationDescriptor
 */
export interface OperationDescriptor {
    /**
     * 
     * @type {string}
     * @memberof OperationDescriptor
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof OperationDescriptor
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof OperationDescriptor
     */
    'enabled': boolean;
    /**
     * 
     * @type {object}
     * @memberof OperationDescriptor
     */
    'input_schema_json': object;
}
/**
 * @type OperationsInner
 * @export
 */
export type OperationsInner = { kind: 'append' } & AppendOp | { kind: 'delete' } & DeleteOp | { kind: 'put' } & PutOp | { kind: 'replace' } & ReplaceOp;

/**
 * Client-computed aggregate history stats that overwrite the stored totals for the user.
 * @export
 * @interface OverwriteHistoryStatsRequest
 */
export interface OverwriteHistoryStatsRequest {
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'weekStreak': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'dayStreak': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'totalWords': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'totalDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'totalNonEmptyDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'averageWPM': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'wordsThisWeek': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'lastTranscriptTimestamp': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OverwriteHistoryStatsRequest
     */
    'totalApps': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopTotalWords': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileTotalWords': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopTotalDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileTotalDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopTotalNonEmptyDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileTotalNonEmptyDuration': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopAverageWPM': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileAverageWPM': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopWordsThisWeek': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileWordsThisWeek': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopLastTranscriptTimestamp': number;
    /**
     * 
     * @type {number}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileLastTranscriptTimestamp': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OverwriteHistoryStatsRequest
     */
    'desktopTotalApps': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OverwriteHistoryStatsRequest
     */
    'mobileTotalApps': Array<string>;
}
/**
 * Derived owner of the shared note — not stored as a recipient row.
 * @export
 * @interface Owner
 */
export interface Owner {
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'email': string | null;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof Owner
     */
    'role'?: NoteShareRole;
    /**
     * 
     * @type {Profile}
     * @memberof Owner
     */
    'profile'?: Profile | null;
}


/**
 * Paging metadata for a page of query results.
 * @export
 * @interface PaginationMetadata
 */
export interface PaginationMetadata {
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'page_size': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'page_number': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'total_pages': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetadata
     */
    'total_rows': number;
}
/**
 * Per-attendee detail for the desktop: display name, optional real profile photo, and self flag.  Carried alongside the legacy ``participants: list[str]`` (display-name-only) field so existing consumers keep working; the desktop reads ``photoUrl`` / ``isSelf`` to render meeting avatars and ``email`` as the secondary line in attendee rosters.
 * @export
 * @interface ParticipantDTO
 */
export interface ParticipantDTO {
    /**
     * 
     * @type {string}
     * @memberof ParticipantDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ParticipantDTO
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParticipantDTO
     */
    'photoUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParticipantDTO
     */
    'isSelf'?: boolean;
}
/**
 * Response schema for GET /typing-test/passage.
 * @export
 * @interface PassageResponse
 */
export interface PassageResponse {
    /**
     * 
     * @type {number}
     * @memberof PassageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PassageResponse
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof PassageResponse
     */
    'text': string;
}
/**
 * Request for tracking paywall viewed event.  ga4_client_id is optional for native apps (desktop, iOS, Android) - the backend will derive it from user_id for cross-device attribution. Web clients should provide ga4_client_id from gtag.js cookies for pre-login tracking.
 * @export
 * @interface PaywallViewedRequest
 */
export interface PaywallViewedRequest {
    /**
     * 
     * @type {string}
     * @memberof PaywallViewedRequest
     */
    'ga4_client_id'?: string | null;
    /**
     * Platform where the event originated
     * @type {AttributionPlatform}
     * @memberof PaywallViewedRequest
     */
    'platform': AttributionPlatform;
    /**
     * Unix timestamp when paywall was viewed
     * @type {number}
     * @memberof PaywallViewedRequest
     */
    'timestamp': number;
    /**
     * 
     * @type {AttributionUserData}
     * @memberof PaywallViewedRequest
     */
    'user_data'?: AttributionUserData | null;
}


/**
 * Response model for checking pending invoice status.
 * @export
 * @interface PendingInvoiceResponse
 */
export interface PendingInvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof PendingInvoiceResponse
     */
    'pending_invoice_id'?: string | null;
}
/**
 * Which source produced a row, for the client\'s cross-source merge and analytics.
 * @export
 * @enum {string}
 */

export const PersonSource = {
    Attendee: 'attendee',
    Contact: 'contact'
} as const;

export type PersonSource = typeof PersonSource[keyof typeof PersonSource];


/**
 * 
 * @export
 * @interface Persona
 */
export interface Persona {
}
/**
 * Represents the style for personalization settings.
 * @export
 * @enum {string}
 */

export const PersonalizationStyle = {
    Formal: 'formal',
    Casual: 'casual',
    VeryCasual: 'veryCasual',
    Excited: 'excited',
    Genz: 'genz',
    Default: 'default'
} as const;

export type PersonalizationStyle = typeof PersonalizationStyle[keyof typeof PersonalizationStyle];


/**
 * Per-context personalization tone (personal, work, email, other) with an unset default.
 * @export
 * @interface PersonalizationStyles
 */
export interface PersonalizationStyles {
    /**
     * 
     * @type {PersonalizationStyle}
     * @memberof PersonalizationStyles
     */
    'personal'?: PersonalizationStyle;
    /**
     * 
     * @type {PersonalizationStyle}
     * @memberof PersonalizationStyles
     */
    'work'?: PersonalizationStyle;
    /**
     * 
     * @type {PersonalizationStyle}
     * @memberof PersonalizationStyles
     */
    'email'?: PersonalizationStyle;
    /**
     * 
     * @type {PersonalizationStyle}
     * @memberof PersonalizationStyles
     */
    'other'?: PersonalizationStyle;
    /**
     * 
     * @type {PersonalizationStyle}
     * @memberof PersonalizationStyles
     */
    'unset'?: PersonalizationStyle;
}


/**
 * Request schema for phone number boost submission.
 * @export
 * @interface PhoneNumberSubmitRequest
 */
export interface PhoneNumberSubmitRequest {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberSubmitRequest
     */
    'phone_number': string;
}
/**
 * One platform\'s soft and hard weekly word limits.
 * @export
 * @interface PlatformWeeklyWordLimits
 */
export interface PlatformWeeklyWordLimits {
    /**
     * 
     * @type {number}
     * @memberof PlatformWeeklyWordLimits
     */
    'soft': number;
    /**
     * 
     * @type {number}
     * @memberof PlatformWeeklyWordLimits
     */
    'hard': number;
    /**
     * 
     * @type {WeeklyWordLimitsSource}
     * @memberof PlatformWeeklyWordLimits
     */
    'source': WeeklyWordLimitsSource;
    /**
     * 
     * @type {WeeklyWordLimitsExperiment}
     * @memberof PlatformWeeklyWordLimits
     */
    'experiment': WeeklyWordLimitsExperiment | null;
}


/**
 * A single podium entry for a specific leaderboard metric.
 * @export
 * @interface PodiumUser
 */
export interface PodiumUser {
    /**
     * 
     * @type {string}
     * @memberof PodiumUser
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof PodiumUser
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof PodiumUser
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PodiumUser
     */
    'last_name': string | null;
    /**
     * 1-based rank within this metric\'s leaderboard.
     * @type {number}
     * @memberof PodiumUser
     */
    'rank': number;
    /**
     * 
     * @type {Value}
     * @memberof PodiumUser
     */
    'value': Value;
}
/**
 * Saved toggle rules for Polish transforms (built-in defaults + custom).
 * @export
 * @interface PolishInstructions
 */
export interface PolishInstructions {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PolishInstructions
     */
    'default'?: { [key: string]: boolean; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof PolishInstructions
     */
    'custom'?: { [key: string]: boolean; };
}
/**
 * A single polish prompt provided by the user for polish.
 * @export
 * @interface PolishPrompt
 */
export interface PolishPrompt {
    /**
     * 
     * @type {string}
     * @memberof PolishPrompt
     */
    'prompt': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PolishPrompt
     */
    'shortcut': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PolishPrompt
     */
    'prompt_name': string;
}
/**
 * A single polish record: the original text, its polished result, and metadata.
 * @export
 * @interface PolishRecord
 */
export interface PolishRecord {
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'polish_initial_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'polished_text'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PolishRecord
     */
    'polish_initial_word_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PolishRecord
     */
    'polished_word_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'app'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PolishRecord
     */
    'processing_time'?: number | null;
    /**
     * 
     * @type {PolishStatus}
     * @memberof PolishRecord
     */
    'status'?: PolishStatus | null;
    /**
     * 
     * @type {boolean}
     * @memberof PolishRecord
     */
    'polish_undone'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'instruction'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'app_version': string;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'model_version'?: string | null;
    /**
     * 
     * @type {UsedProvider}
     * @memberof PolishRecord
     */
    'used_provider'?: UsedProvider | null;
    /**
     * 
     * @type {number}
     * @memberof PolishRecord
     */
    'diff_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'prompt_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'shortcut_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishRecord
     */
    'instruct_history_id'?: string | null;
}


/**
 * Outcome of a Polish text-refinement request.
 * @export
 * @enum {string}
 */

export const PolishStatus = {
    Succeeded: 'succeeded',
    LongText: 'long_text',
    ShortText: 'short_text',
    Timeout: 'timeout',
    Error: 'error',
    Cancelled: 'cancelled',
    NoChanges: 'no_changes',
    NotEditable: 'not_editable',
    NoText: 'no_text',
    NoInstructions: 'no_instructions'
} as const;

export type PolishStatus = typeof PolishStatus[keyof typeof PolishStatus];


/**
 * Request to polish selected text using saved instructions, writing samples, or a custom prompt.
 * @export
 * @interface PolishTextRequest
 */
export interface PolishTextRequest {
    /**
     * 
     * @type {string}
     * @memberof PolishTextRequest
     */
    'selected_text': string;
    /**
     * 
     * @type {PolishInstructions}
     * @memberof PolishTextRequest
     */
    'instructions': PolishInstructions;
    /**
     * 
     * @type {{ [key: string]: WritingSample; }}
     * @memberof PolishTextRequest
     */
    'writing_samples'?: { [key: string]: WritingSample; } | null;
    /**
     * 
     * @type {PolishPrompt}
     * @memberof PolishTextRequest
     */
    'custom_prompt'?: PolishPrompt | null;
    /**
     * 
     * @type {TransformProviderConfig}
     * @memberof PolishTextRequest
     */
    'provider_config'?: TransformProviderConfig | null;
    /**
     * 
     * @type {string}
     * @memberof PolishTextRequest
     */
    'user_voice_preference'?: string | null;
}
/**
 * Polish result with status, the polished text, and the model/provider that served it.
 * @export
 * @interface PolishTextResponse
 */
export interface PolishTextResponse {
    /**
     * 
     * @type {PolishStatus}
     * @memberof PolishTextResponse
     */
    'status': PolishStatus;
    /**
     * 
     * @type {string}
     * @memberof PolishTextResponse
     */
    'polished_text'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolishTextResponse
     */
    'model_version'?: string | null;
    /**
     * 
     * @type {UsedProvider}
     * @memberof PolishTextResponse
     */
    'used_provider'?: UsedProvider | null;
}


/**
 * Feedback submitted before login, identified by explicit name and email.
 * @export
 * @interface PreLoginFeedbackRequest
 */
export interface PreLoginFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreLoginFeedbackRequest
     */
    'imageData'?: string | null;
    /**
     * 
     * @type {ImageType}
     * @memberof PreLoginFeedbackRequest
     */
    'imageType'?: ImageType | null;
    /**
     * 
     * @type {SrcCommonConstantsPlatform}
     * @memberof PreLoginFeedbackRequest
     */
    'platform'?: SrcCommonConstantsPlatform;
}


/**
 * Full snapshot of a user\'s preferences plus the server-assigned ``modified_at`` watermark.  Used as the inline payload for the ``preferences.changed`` sync event so peers can converge via last-writer-wins without an extra refetch.
 * @export
 * @interface PreferencesResponse
 */
export interface PreferencesResponse {
    /**
     * 
     * @type {UserPreferences}
     * @memberof PreferencesResponse
     */
    'preferences': UserPreferences;
    /**
     * 
     * @type {string}
     * @memberof PreferencesResponse
     */
    'modified_at': string;
}
/**
 * Meetings with this many generation attempts; the last entry counts that many or more.
 * @export
 * @interface PrereadAttemptsPerMeeting
 */
export interface PrereadAttemptsPerMeeting {
    /**
     * 
     * @type {number}
     * @memberof PrereadAttemptsPerMeeting
     */
    'attempts': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadAttemptsPerMeeting
     */
    'meetings': number;
}
/**
 * One report and its exact brief, subject to current data-sharing permission.
 * @export
 * @interface PrereadFeedbackDetail
 */
export interface PrereadFeedbackDetail {
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'rating': PrereadFeedbackDetailRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'source': PrereadFeedbackDetailSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'reporterEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'feedbackPreview': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'reportedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'generationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'association': PrereadFeedbackDetailAssociationEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'slackUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'model'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'feedback': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'meetingAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'briefTitle': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'briefContent': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackDetail
     */
    'contentWithheldReason': PrereadFeedbackDetailContentWithheldReasonEnum | null;
    /**
     * 
     * @type {EvidenceMetadata}
     * @memberof PrereadFeedbackDetail
     */
    'evidenceMetadata': EvidenceMetadata | null;
}

export const PrereadFeedbackDetailRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type PrereadFeedbackDetailRatingEnum = typeof PrereadFeedbackDetailRatingEnum[keyof typeof PrereadFeedbackDetailRatingEnum];
export const PrereadFeedbackDetailSourceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;

export type PrereadFeedbackDetailSourceEnum = typeof PrereadFeedbackDetailSourceEnum[keyof typeof PrereadFeedbackDetailSourceEnum];
export const PrereadFeedbackDetailAssociationEnum = {
    Matched: 'matched',
    Unmatched: 'unmatched',
    Ambiguous: 'ambiguous'
} as const;

export type PrereadFeedbackDetailAssociationEnum = typeof PrereadFeedbackDetailAssociationEnum[keyof typeof PrereadFeedbackDetailAssociationEnum];
export const PrereadFeedbackDetailContentWithheldReasonEnum = {
    ConsentRequired: 'consent_required',
    GenerationUnavailable: 'generation_unavailable',
    Unmatched: 'unmatched',
    Ambiguous: 'ambiguous'
} as const;

export type PrereadFeedbackDetailContentWithheldReasonEnum = typeof PrereadFeedbackDetailContentWithheldReasonEnum[keyof typeof PrereadFeedbackDetailContentWithheldReasonEnum];

/**
 * Newest reports with stable keyset pagination.
 * @export
 * @interface PrereadFeedbackList
 */
export interface PrereadFeedbackList {
    /**
     * 
     * @type {Array<PrereadFeedbackListItem>}
     * @memberof PrereadFeedbackList
     */
    'items': Array<PrereadFeedbackListItem>;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackList
     */
    'nextCursor': string | null;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackList
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackList
     */
    'matchedReports': number;
}
/**
 * One report without brief content or provider payloads.
 * @export
 * @interface PrereadFeedbackListItem
 */
export interface PrereadFeedbackListItem {
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'rating': PrereadFeedbackListItemRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'source': PrereadFeedbackListItemSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'reporterEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'feedbackPreview': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'reportedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'generationId': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'association': PrereadFeedbackListItemAssociationEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'slackUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackListItem
     */
    'model'?: string | null;
}

export const PrereadFeedbackListItemRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type PrereadFeedbackListItemRatingEnum = typeof PrereadFeedbackListItemRatingEnum[keyof typeof PrereadFeedbackListItemRatingEnum];
export const PrereadFeedbackListItemSourceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;

export type PrereadFeedbackListItemSourceEnum = typeof PrereadFeedbackListItemSourceEnum[keyof typeof PrereadFeedbackListItemSourceEnum];
export const PrereadFeedbackListItemAssociationEnum = {
    Matched: 'matched',
    Unmatched: 'unmatched',
    Ambiguous: 'ambiguous'
} as const;

export type PrereadFeedbackListItemAssociationEnum = typeof PrereadFeedbackListItemAssociationEnum[keyof typeof PrereadFeedbackListItemAssociationEnum];

/**
 * Reports grouped by their UTC day or Monday-start week.
 * @export
 * @interface PrereadFeedbackRatingBucket
 */
export interface PrereadFeedbackRatingBucket {
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingBucket
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingBucket
     */
    'down': number;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRatingBucket
     */
    'start': string;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof PrereadFeedbackRatingBucket
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingBucket
     */
    'pctUp': number | null;
}
/**
 * Counts of individual reports; empty populations have no percentage.
 * @export
 * @interface PrereadFeedbackRatingCounts
 */
export interface PrereadFeedbackRatingCounts {
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingCounts
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingCounts
     */
    'down': number;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof PrereadFeedbackRatingCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackRatingCounts
     */
    'pctUp': number | null;
}
/**
 * Ratings for every filtered report, independently of list pagination.
 * @export
 * @interface PrereadFeedbackRatingStats
 */
export interface PrereadFeedbackRatingStats {
    /**
     * 
     * @type {PrereadFeedbackRatingCounts}
     * @memberof PrereadFeedbackRatingStats
     */
    'overall': PrereadFeedbackRatingCounts;
    /**
     * 
     * @type {Array<PrereadFeedbackRatingBucket>}
     * @memberof PrereadFeedbackRatingStats
     */
    'buckets': Array<PrereadFeedbackRatingBucket>;
}
/**
 * Request shape for ``POST /api/v1/calendar/preread/feedback``.
 * @export
 * @interface PrereadFeedbackRequest
 */
export interface PrereadFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'rating': PrereadFeedbackRequestRatingEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'reporterName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrereadFeedbackRequest
     */
    'preread'?: string | null;
}

export const PrereadFeedbackRequestRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;

export type PrereadFeedbackRequestRatingEnum = typeof PrereadFeedbackRequestRatingEnum[keyof typeof PrereadFeedbackRequestRatingEnum];

/**
 * All counts generation attempts by generation time and current owner cohort.  Reported counts distinct linked generations by report time and stored report source; its buckets and attempts still group by generation time, which may fall before since. Report counts always use report time and stored report source, independently of generation counts. Diagnostics consider the newest successful candidates up to diagnostics_limit; truncation marks that cap. Unobserved counts sampled candidates with missing or invalid evidence.
 * @export
 * @interface PrereadFeedbackStats
 */
export interface PrereadFeedbackStats {
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'totalGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'successfulGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'emptyGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'failedGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'sampledGenerations': number;
    /**
     * 
     * @type {boolean}
     * @memberof PrereadFeedbackStats
     */
    'diagnosticsTruncated': boolean;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'diagnosticsLimit': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'observedGenerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'unobservedGenerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'researchObservedGenerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'researchCompleteGenerations'?: number;
    /**
     * 
     * @type {Array<PrereadPrefetchStats>}
     * @memberof PrereadFeedbackStats
     */
    'prefetch'?: Array<PrereadPrefetchStats>;
    /**
     * 
     * @type {Array<PrereadResearchStats>}
     * @memberof PrereadFeedbackStats
     */
    'research'?: Array<PrereadResearchStats>;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'totalReports': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadFeedbackStats
     */
    'matchedReports': number;
    /**
     * 
     * @type {Array<PrereadGenerationBucket>}
     * @memberof PrereadFeedbackStats
     */
    'buckets': Array<PrereadGenerationBucket>;
    /**
     * 
     * @type {Array<PrereadAttemptsPerMeeting>}
     * @memberof PrereadFeedbackStats
     */
    'attemptsPerMeeting': Array<PrereadAttemptsPerMeeting>;
}
/**
 * Generation outcomes in one UTC day or Monday-start week.
 * @export
 * @interface PrereadGenerationBucket
 */
export interface PrereadGenerationBucket {
    /**
     * 
     * @type {number}
     * @memberof PrereadGenerationBucket
     */
    'totalGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadGenerationBucket
     */
    'successfulGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadGenerationBucket
     */
    'emptyGenerations': number;
    /**
     * 
     * @type {number}
     * @memberof PrereadGenerationBucket
     */
    'failedGenerations': number;
    /**
     * 
     * @type {string}
     * @memberof PrereadGenerationBucket
     */
    'start': string;
}
/**
 * Measurements of supplied evidence, independently counted for each retrieval stage.
 * @export
 * @interface PrereadPrefetchStats
 */
export interface PrereadPrefetchStats {
    /**
     * 
     * @type {string}
     * @memberof PrereadPrefetchStats
     */
    'source': PrereadPrefetchStatsSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadPrefetchStats
     */
    'retrieval': PrereadPrefetchStatsRetrievalEnum;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'observedGenerations'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PrereadPrefetchStats
     */
    'statusCounts'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'retrievedCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'retainedCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'recentCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'retrievedMeasuredGenerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'retainedMeasuredGenerations'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadPrefetchStats
     */
    'recentMeasuredGenerations'?: number;
}

export const PrereadPrefetchStatsSourceEnum = {
    Gmail: 'gmail',
    Slack: 'slack',
    PriorMeetings: 'prior_meetings',
    Notion: 'notion',
    AttendeeDetails: 'attendee_details',
    Web: 'web',
    Wispr: 'wispr',
    Calendar: 'calendar',
    Unknown: 'unknown'
} as const;

export type PrereadPrefetchStatsSourceEnum = typeof PrereadPrefetchStatsSourceEnum[keyof typeof PrereadPrefetchStatsSourceEnum];
export const PrereadPrefetchStatsRetrievalEnum = {
    Provider: 'provider',
    Filtered: 'filtered',
    Contacts: 'contacts'
} as const;

export type PrereadPrefetchStatsRetrievalEnum = typeof PrereadPrefetchStatsRetrievalEnum[keyof typeof PrereadPrefetchStatsRetrievalEnum];

/**
 * Observed tool calls; incomplete research observations are lower bounds.
 * @export
 * @interface PrereadResearchStats
 */
export interface PrereadResearchStats {
    /**
     * 
     * @type {string}
     * @memberof PrereadResearchStats
     */
    'source': PrereadResearchStatsSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof PrereadResearchStats
     */
    'operation': PrereadResearchStatsOperationEnum;
    /**
     * 
     * @type {number}
     * @memberof PrereadResearchStats
     */
    'calls'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadResearchStats
     */
    'failedCalls'?: number;
    /**
     * 
     * @type {number}
     * @memberof PrereadResearchStats
     */
    'returnedItemCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PrereadResearchStats
     */
    'returnedMeasuredCalls'?: number;
}

export const PrereadResearchStatsSourceEnum = {
    Gmail: 'gmail',
    Slack: 'slack',
    PriorMeetings: 'prior_meetings',
    Notion: 'notion',
    AttendeeDetails: 'attendee_details',
    Web: 'web',
    Wispr: 'wispr',
    Calendar: 'calendar',
    Unknown: 'unknown'
} as const;

export type PrereadResearchStatsSourceEnum = typeof PrereadResearchStatsSourceEnum[keyof typeof PrereadResearchStatsSourceEnum];
export const PrereadResearchStatsOperationEnum = {
    Search: 'search',
    Read: 'read',
    Other: 'other'
} as const;

export type PrereadResearchStatsOperationEnum = typeof PrereadResearchStatsOperationEnum[keyof typeof PrereadResearchStatsOperationEnum];

/**
 * Response shape for ``GET /api/v1/calendar/events/{external_id}/preread``.  The endpoint generates the pre-read on-the-fly per request (no persistence), so ``generated_at`` is the response timestamp.  ``title`` is a very short calendar-event-label suitable for a notification card. ``summary`` is a single declarative sentence that describes what the meeting is about — surfaced under the calendar event title on the desktop hub.
 * @export
 * @interface PrereadResponse
 */
export interface PrereadResponse {
    /**
     * 
     * @type {string}
     * @memberof PrereadResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadResponse
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadResponse
     */
    'contentMd': string;
    /**
     * 
     * @type {string}
     * @memberof PrereadResponse
     */
    'generatedAt': string;
}
/**
 * Body for a dry-run preview of a billing operation.
 * @export
 * @interface PreviewRequest
 */
export interface PreviewRequest {
    /**
     * Cost center the operation targets. Stripe customer/subscription artifacts are keyed on cost_center, not enterprise.
     * @type {string}
     * @memberof PreviewRequest
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof PreviewRequest
     */
    'operation_kind': string;
    /**
     * 
     * @type {object}
     * @memberof PreviewRequest
     */
    'input': object;
}
/**
 * The dry-run preview payload for a billing operation.
 * @export
 * @interface PreviewResponse
 */
export interface PreviewResponse {
    /**
     * 
     * @type {object}
     * @memberof PreviewResponse
     */
    'preview': object;
}
/**
 * Full response for the GET /pricing/by-ip endpoint.
 * @export
 * @interface PricingByIpResponse
 */
export interface PricingByIpResponse {
    /**
     * 
     * @type {string}
     * @memberof PricingByIpResponse
     */
    'ip'?: string | null;
    /**
     * 
     * @type {IPLocation}
     * @memberof PricingByIpResponse
     */
    'location'?: IPLocation | null;
    /**
     * 
     * @type {string}
     * @memberof PricingByIpResponse
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PricingByIpResponse
     */
    'flag'?: string | null;
    /**
     * 
     * @type {CurrencyPricingResponse}
     * @memberof PricingByIpResponse
     */
    'pricing': CurrencyPricingResponse;
}
/**
 * Schema for a single pricing tier.
 * @export
 * @interface PricingTierSchema
 */
export interface PricingTierSchema {
    /**
     * 
     * @type {number}
     * @memberof PricingTierSchema
     */
    'max_seats'?: number | null;
    /**
     * Price per seat per year in cents
     * @type {number}
     * @memberof PricingTierSchema
     */
    'price_cents_per_seat_per_year': number;
}
/**
 * Stripe pricing details for a single product.
 * @export
 * @interface ProductPricingResponse
 */
export interface ProductPricingResponse {
    /**
     * 
     * @type {string}
     * @memberof ProductPricingResponse
     */
    'product_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProductPricingResponse
     */
    'price_id': string;
    /**
     * 
     * @type {number}
     * @memberof ProductPricingResponse
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ProductPricingResponse
     */
    'currency_factor': number;
}
/**
 * Enriched Flow profile fields when a participant email matches an existing user.
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'avatar_url': string | null;
}
/**
 * Structured ``detail`` body of a promo 400: the user or the campaign is not eligible.
 * @export
 * @interface PromoIneligibleErrorDetail
 */
export interface PromoIneligibleErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof PromoIneligibleErrorDetail
     */
    'code': PromoIneligibleErrorDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromoIneligibleErrorDetail
     */
    'message': string;
}

export const PromoIneligibleErrorDetailCodeEnum = {
    IsPro: 'is_pro',
    EnterpriseMember: 'enterprise_member',
    StudentPlan: 'student_plan',
    NotActive: 'not_active',
    NotStarted: 'not_started',
    Expired: 'expired',
    CampaignRedemptionLimitReached: 'campaign_redemption_limit_reached',
    CodeRedemptionLimitReached: 'code_redemption_limit_reached',
    CodeNotActive: 'code_not_active',
    MisconfiguredTrialDays: 'misconfigured_trial_days'
} as const;

export type PromoIneligibleErrorDetailCodeEnum = typeof PromoIneligibleErrorDetailCodeEnum[keyof typeof PromoIneligibleErrorDetailCodeEnum];

/**
 * Envelope for the 400 on ``/campaign/validate`` and ``/campaign/apply``.
 * @export
 * @interface PromoIneligibleErrorResponse
 */
export interface PromoIneligibleErrorResponse {
    /**
     * 
     * @type {PromoIneligibleErrorDetail}
     * @memberof PromoIneligibleErrorResponse
     */
    'detail': PromoIneligibleErrorDetail;
}
/**
 * 
 * @export
 * @interface Provider
 */
export interface Provider {
    /**
     * 
     * @type {string}
     * @memberof Provider
     */
    'kind'?: ProviderKindEnum;
    /**
     * 
     * @type {Model}
     * @memberof Provider
     */
    'model': Model;
    /**
     * 
     * @type {Array<string>}
     * @memberof Provider
     */
    'provider_order'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Provider
     */
    'allow_fallbacks'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Provider
     */
    'deadline_seconds': number;
    /**
     * 
     * @type {Array<TransformProviderConfig>}
     * @memberof Provider
     */
    'providers': Array<TransformProviderConfig>;
}

export const ProviderKindEnum = {
    Race: 'race'
} as const;

export type ProviderKindEnum = typeof ProviderKindEnum[keyof typeof ProviderKindEnum];

/**
 * One provider\'s unmodified raw JSON, distinct from an unavailable capture.
 * @export
 * @interface ProviderArtifact
 */
export interface ProviderArtifact {
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifact
     */
    'provider': ProviderArtifactProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifact
     */
    'status': ProviderArtifactStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifact
     */
    'reason'?: ProviderArtifactReasonEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifact
     */
    'raw_json'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifact
     */
    'raw_sha256'?: string | null;
}

export const ProviderArtifactProviderEnum = {
    Soniox: 'soniox',
    Chorus: 'chorus'
} as const;

export type ProviderArtifactProviderEnum = typeof ProviderArtifactProviderEnum[keyof typeof ProviderArtifactProviderEnum];
export const ProviderArtifactStatusEnum = {
    Available: 'available',
    Unavailable: 'unavailable'
} as const;

export type ProviderArtifactStatusEnum = typeof ProviderArtifactStatusEnum[keyof typeof ProviderArtifactStatusEnum];
export const ProviderArtifactReasonEnum = {
    NotRetained: 'not_retained',
    InvalidArtifact: 'invalid_artifact',
    LegacySource: 'legacy_source',
    UnsupportedProvider: 'unsupported_provider'
} as const;

export type ProviderArtifactReasonEnum = typeof ProviderArtifactReasonEnum[keyof typeof ProviderArtifactReasonEnum];

/**
 * Provider inputs bound to the refinement currently displayed by the meeting.
 * @export
 * @interface ProviderArtifactsResponse
 */
export interface ProviderArtifactsResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifactsResponse
     */
    'displayed_revision'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifactsResponse
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifactsResponse
     */
    'served_provider'?: ProviderArtifactsResponseServedProviderEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderArtifactsResponse
     */
    'provenance'?: ProviderArtifactsResponseProvenanceEnum | null;
    /**
     * 
     * @type {Array<ProviderArtifact>}
     * @memberof ProviderArtifactsResponse
     */
    'providers': Array<ProviderArtifact>;
}

export const ProviderArtifactsResponseServedProviderEnum = {
    Soniox: 'soniox',
    Chorus: 'chorus',
    Openai: 'openai'
} as const;

export type ProviderArtifactsResponseServedProviderEnum = typeof ProviderArtifactsResponseServedProviderEnum[keyof typeof ProviderArtifactsResponseServedProviderEnum];
export const ProviderArtifactsResponseProvenanceEnum = {
    RetainedJob: 'retained_job',
    Legacy: 'legacy'
} as const;

export type ProviderArtifactsResponseProvenanceEnum = typeof ProviderArtifactsResponseProvenanceEnum[keyof typeof ProviderArtifactsResponseProvenanceEnum];

/**
 * The cost center created by a successful provision.
 * @export
 * @interface ProvisionedCostCenterSummary
 */
export interface ProvisionedCostCenterSummary {
    /**
     * 
     * @type {string}
     * @memberof ProvisionedCostCenterSummary
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedCostCenterSummary
     */
    'name': string;
}
/**
 * The invoice sent (or already paid) by a successful provision.
 * @export
 * @interface ProvisionedInvoiceSummary
 */
export interface ProvisionedInvoiceSummary {
    /**
     * 
     * @type {string}
     * @memberof ProvisionedInvoiceSummary
     */
    'stripe_invoice_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedInvoiceSummary
     */
    'status': ProvisionedInvoiceSummaryStatusEnum;
}

export const ProvisionedInvoiceSummaryStatusEnum = {
    Sent: 'sent',
    AlreadyPaid: 'already_paid'
} as const;

export type ProvisionedInvoiceSummaryStatusEnum = typeof ProvisionedInvoiceSummaryStatusEnum[keyof typeof ProvisionedInvoiceSummaryStatusEnum];

/**
 * The team created by a successful provision.
 * @export
 * @interface ProvisionedTeamSummary
 */
export interface ProvisionedTeamSummary {
    /**
     * 
     * @type {string}
     * @memberof ProvisionedTeamSummary
     */
    'name': string;
}
/**
 * An enterprise\'s prod Public API entitlement and organization admission policy.
 * @export
 * @interface PublicAPIPolicy
 */
export interface PublicAPIPolicy {
    /**
     * 
     * @type {boolean}
     * @memberof PublicAPIPolicy
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicAPIPolicy
     */
    'bucket_capacity': number;
    /**
     * 
     * @type {number}
     * @memberof PublicAPIPolicy
     */
    'refill_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof PublicAPIPolicy
     */
    'refill_period_seconds': number;
    /**
     * 
     * @type {number}
     * @memberof PublicAPIPolicy
     */
    'policy_version': number;
    /**
     * 
     * @type {string}
     * @memberof PublicAPIPolicy
     */
    'modified_at': string;
}
/**
 * Response model for the static public/webmail domain list.
 * @export
 * @interface PublicDomainsListResponse
 */
export interface PublicDomainsListResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PublicDomainsListResponse
     */
    'domains': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PublicDomainsListResponse
     */
    'total': number;
}
/**
 * Write ``content`` as the whole file; the head must be at ``base_version`` (``None``: no live head).
 * @export
 * @interface PutOp
 */
export interface PutOp {
    /**
     * 
     * @type {string}
     * @memberof PutOp
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof PutOp
     */
    'kind'?: PutOpKindEnum;
    /**
     * 
     * @type {string}
     * @memberof PutOp
     */
    'content': string;
    /**
     * 
     * @type {number}
     * @memberof PutOp
     */
    'base_version': number | null;
}

export const PutOpKindEnum = {
    Put: 'put'
} as const;

export type PutOpKindEnum = typeof PutOpKindEnum[keyof typeof PutOpKindEnum];

/**
 * Choose an original issue or a manual email; identity and creation policy remain server-owned.
 * @export
 * @interface PylonAccountUpdateRequest
 */
export interface PylonAccountUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PylonAccountUpdateRequest
     */
    'issue_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PylonAccountUpdateRequest
     */
    'email'?: string | null;
}
/**
 * Select an existing enterprise account using its backend enterprise ID.
 * @export
 * @interface PylonEnterpriseRefreshRequest
 */
export interface PylonEnterpriseRefreshRequest {
    /**
     * Backend Enterprise ID, not a Pylon account ID
     * @type {string}
     * @memberof PylonEnterpriseRefreshRequest
     */
    'enterprise_id': string;
}
/**
 * Durable acceptance of enterprise account refresh work.
 * @export
 * @interface PylonEnterpriseRefreshResponse
 */
export interface PylonEnterpriseRefreshResponse {
    /**
     * 
     * @type {string}
     * @memberof PylonEnterpriseRefreshResponse
     */
    'status'?: PylonEnterpriseRefreshResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PylonEnterpriseRefreshResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof PylonEnterpriseRefreshResponse
     */
    'message_id': string;
}

export const PylonEnterpriseRefreshResponseStatusEnum = {
    Accepted: 'accepted'
} as const;

export type PylonEnterpriseRefreshResponseStatusEnum = typeof PylonEnterpriseRefreshResponseStatusEnum[keyof typeof PylonEnterpriseRefreshResponseStatusEnum];

/**
 * SQS acceptance of an issue obligation, not confirmation that reconciliation finished.
 * @export
 * @interface PylonIssueAcceptedResponse
 */
export interface PylonIssueAcceptedResponse {
    /**
     * 
     * @type {string}
     * @memberof PylonIssueAcceptedResponse
     */
    'status'?: PylonIssueAcceptedResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PylonIssueAcceptedResponse
     */
    'message_id': string;
}

export const PylonIssueAcceptedResponseStatusEnum = {
    Accepted: 'accepted'
} as const;

export type PylonIssueAcceptedResponseStatusEnum = typeof PylonIssueAcceptedResponseStatusEnum[keyof typeof PylonIssueAcceptedResponseStatusEnum];

/**
 * How a quick summary request ended.
 * @export
 * @enum {string}
 */

export const QuickSummaryOutcome = {
    Ok: 'ok',
    TooShort: 'too_short',
    Unavailable: 'unavailable'
} as const;

export type QuickSummaryOutcome = typeof QuickSummaryOutcome[keyof typeof QuickSummaryOutcome];


/**
 * Provider config that races several sub-providers, preferring earlier ones.
 * @export
 * @interface RaceProviderConfig
 */
export interface RaceProviderConfig {
    /**
     * 
     * @type {string}
     * @memberof RaceProviderConfig
     */
    'kind'?: RaceProviderConfigKindEnum;
    /**
     * 
     * @type {number}
     * @memberof RaceProviderConfig
     */
    'deadline_seconds': number;
    /**
     * 
     * @type {Array<TransformProviderConfig>}
     * @memberof RaceProviderConfig
     */
    'providers': Array<TransformProviderConfig>;
}

export const RaceProviderConfigKindEnum = {
    Race: 'race'
} as const;

export type RaceProviderConfigKindEnum = typeof RaceProviderConfigKindEnum[keyof typeof RaceProviderConfigKindEnum];

/**
 * Lightweight email signup capturing name and attribution fields.
 * @export
 * @interface RawEmailSignupRequest
 */
export interface RawEmailSignupRequest {
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'dub_click_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'referral'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RawEmailSignupRequest
     */
    'promo_code'?: string | null;
    /**
     * 
     * @type {UtmParams}
     * @memberof RawEmailSignupRequest
     */
    'utm'?: UtmParams | null;
}
/**
 * Request to start connecting a connector identified by a raw app string.
 * @export
 * @interface RawInitiateConnectionRequest
 */
export interface RawInitiateConnectionRequest {
    /**
     * 
     * @type {string}
     * @memberof RawInitiateConnectionRequest
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof RawInitiateConnectionRequest
     */
    'callback_url'?: string | null;
}
/**
 * Request model for reactivating a canceled enterprise pilot.  The enterprise is identified by path param; the server resolves the admin email + primary domain from existing records so callers don\'t have to re-supply them.
 * @export
 * @interface ReactivateEnterprisePilotRequest
 */
export interface ReactivateEnterprisePilotRequest {
    /**
     * 
     * @type {string}
     * @memberof ReactivateEnterprisePilotRequest
     */
    'trial_end': string;
}
/**
 * Observed lifecycle and file versions; this token does not hold a lock.
 * @export
 * @interface ReadToken
 */
export interface ReadToken {
    /**
     * 
     * @type {number}
     * @memberof ReadToken
     */
    'erasure_epoch': number;
    /**
     * 
     * @type {number}
     * @memberof ReadToken
     */
    'learning_generation': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ReadToken
     */
    'versions'?: { [key: string]: number; };
}
/**
 * A single invited recipient in the share state response.
 * @export
 * @interface RecipientEntry
 */
export interface RecipientEntry {
    /**
     * 
     * @type {string}
     * @memberof RecipientEntry
     */
    'email': string;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof RecipientEntry
     */
    'role': NoteShareRole;
    /**
     * 
     * @type {NoteEmailStatus}
     * @memberof RecipientEntry
     */
    'email_status': NoteEmailStatus;
    /**
     * 
     * @type {Profile}
     * @memberof RecipientEntry
     */
    'profile'?: Profile | null;
}


/**
 * A single dictation-history record uploaded from a client.
 * @export
 * @interface Record
 */
export interface Record {
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'transcriptEntityId': string;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'asrText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'formattedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'serverFinalizedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'pastedText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'formattingDivergenceScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'textboxContents'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'editedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'editedTextUnbounded'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'timestamp'?: string | null;
    /**
     * 
     * @type {File}
     * @memberof Record
     */
    'audio'?: File | null;
    /**
     * 
     * @type {object}
     * @memberof Record
     */
    'opusChunks'?: object | null;
    /**
     * 
     * @type {File}
     * @memberof Record
     */
    'builtInAudio'?: File | null;
    /**
     * 
     * @type {File}
     * @memberof Record
     */
    'screenshot'?: File | null;
    /**
     * 
     * @type {object}
     * @memberof Record
     */
    'additionalContext'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'app'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'e2eLatency'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'shareType': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Record
     */
    'needsUploading': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'speechDuration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'numWords'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'appVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'toneMatchedText'?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof Record
     */
    'toneMatchPairs'?: Array<object> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Record
     */
    'isArchived'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'feedback'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'language'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'micDevice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'defaultAsrText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'fallbackAsrText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'defaultFormattedText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'fallbackFormattedText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'fallbackAsrDivergenceScore'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'fallbackFormattingDivergenceScore'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'detectedLanguage'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'averageLogProb'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'axText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'axHTML'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'desiredAsr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'desiredFormatted'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof Record
     */
    'userEditMetaData'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof Record
     */
    'calledExternalAsr'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'transcriptOrigin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'platform'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'transcriptCommand'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof Record
     */
    'personalizationStyleSettings'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'numWordsCorrected'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'numDictionaryReplacements'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'timezoneOffsetMinutes'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'contentObservationEndReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'contentObservationEndLastKeystroke'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Record
     */
    'editDistanceToDictated'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Record
     */
    'audio_encoding'?: string | null;
}
/**
 * A promo redemption summary row for the admin list view.
 * @export
 * @interface RedemptionListItem
 */
export interface RedemptionListItem {
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'campaign_name': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'code_string': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'outcome': string;
    /**
     * 
     * @type {number}
     * @memberof RedemptionListItem
     */
    'trial_days_granted': number | null;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'stripe_subscription_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof RedemptionListItem
     */
    'created_at': string;
}
/**
 * A page of promo redemptions with a total count.
 * @export
 * @interface RedemptionListResponse
 */
export interface RedemptionListResponse {
    /**
     * 
     * @type {Array<RedemptionListItem>}
     * @memberof RedemptionListResponse
     */
    'redemptions': Array<RedemptionListItem>;
    /**
     * 
     * @type {number}
     * @memberof RedemptionListResponse
     */
    'total': number;
}
/**
 * Request to send referral invites to a list of email addresses.
 * @export
 * @interface ReferEmailsRequest
 */
export interface ReferEmailsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ReferEmailsRequest
     */
    'emails': Array<string>;
}
/**
 * A single referral\'s status, credits, and referee metadata.
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    'credits': number;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'avatar_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Referral
     */
    'is_student'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'student_challenge_status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    'referee_created_at'?: string | null;
}
/**
 * The authenticated user\'s referral code.
 * @export
 * @interface ReferralCodeResponse
 */
export interface ReferralCodeResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralCodeResponse
     */
    'referral_code': string;
}
/**
 * The user\'s referral code, name, and list of referrals.
 * @export
 * @interface ReferralInfoResponse
 */
export interface ReferralInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferralInfoResponse
     */
    'referral_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferralInfoResponse
     */
    'referer_name'?: string | null;
    /**
     * 
     * @type {Array<Referral>}
     * @memberof ReferralInfoResponse
     */
    'referrals'?: Array<Referral> | null;
}
/**
 * Lifecycle status of a meeting refine job.
 * @export
 * @enum {string}
 */

export const RefineJobStatus = {
    AwaitingAudio: 'awaiting_audio',
    Transcribing: 'transcribing',
    Summarizing: 'summarizing',
    Complete: 'complete',
    Failed: 'failed',
    Abandoned: 'abandoned'
} as const;

export type RefineJobStatus = typeof RefineJobStatus[keyof typeof RefineJobStatus];


/**
 * Device identity and hardware metadata submitted when registering a device.
 * @export
 * @interface RegisterDeviceRequest
 */
export interface RegisterDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_id': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_type': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_manufacturer': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_model': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_os_name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_os_version': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_family'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'device_sku'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'baseboard_product'?: string | null;
    /**
     * 
     * @type {DeviceInfoStatus}
     * @memberof RegisterDeviceRequest
     */
    'device_info_status'?: DeviceInfoStatus | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceRequest
     */
    'appsflyer_id'?: string | null;
}


/**
 * The relabeler\'s counters and its display label per speaker key.
 * @export
 * @interface RelabelerArm
 */
export interface RelabelerArm {
    /**
     * 
     * @type {RelabelerStats}
     * @memberof RelabelerArm
     */
    'stats': RelabelerStats;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RelabelerArm
     */
    'labels': { [key: string]: string; };
}
/**
 * Consensus\'s and the relabeler\'s speaker keys per speech entry, with each side\'s display labels.
 * @export
 * @interface RelabelerComparison
 */
export interface RelabelerComparison {
    /**
     * 
     * @type {Array<RelabelerRow>}
     * @memberof RelabelerComparison
     */
    'rows': Array<RelabelerRow>;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerComparison
     */
    'current_model': boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RelabelerComparison
     */
    'original_labels': { [key: string]: string; };
    /**
     * 
     * @type {RelabelerArm}
     * @memberof RelabelerComparison
     */
    'relabeled': RelabelerArm;
    /**
     * 
     * @type {string}
     * @memberof RelabelerComparison
     */
    'model_sha256': string;
}
/**
 * The stored relabeler comparison for a meeting\'s current refined revision, if there is a usable one.  ``replayed`` marks a comparison an on-demand replay stored rather than refine. ``status``, ``mode`` and ``comparison`` describe the current relabeler model only; ``shipped_mode`` looks across models.
 * @export
 * @interface RelabelerComparisonResponse
 */
export interface RelabelerComparisonResponse {
    /**
     * 
     * @type {RelabelerComparisonStatus}
     * @memberof RelabelerComparisonResponse
     */
    'status': RelabelerComparisonStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerComparisonResponse
     */
    'edited': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerComparisonResponse
     */
    'replayed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelabelerComparisonResponse
     */
    'revision_digest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelabelerComparisonResponse
     */
    'displayed_revision'?: string | null;
    /**
     * 
     * @type {RelabelerSidecarMode}
     * @memberof RelabelerComparisonResponse
     */
    'mode'?: RelabelerSidecarMode | null;
    /**
     * 
     * @type {RelabelerComparison}
     * @memberof RelabelerComparisonResponse
     */
    'comparison'?: RelabelerComparison | null;
    /**
     * 
     * @type {RelabelerSidecarMode}
     * @memberof RelabelerComparisonResponse
     */
    'shipped_mode'?: RelabelerSidecarMode | null;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerComparisonResponse
     */
    'shipped_edited'?: boolean | null;
}


/**
 * Whether a meeting has a usable stored relabeler comparison for its current refined revision.
 * @export
 * @enum {string}
 */

export const RelabelerComparisonStatus = {
    Absent: 'absent',
    Unreadable: 'unreadable',
    Fresh: 'fresh'
} as const;

export type RelabelerComparisonStatus = typeof RelabelerComparisonStatus[keyof typeof RelabelerComparisonStatus];


/**
 * An eligible finalized meeting; metadata does not assert raw artifact availability.
 * @export
 * @interface RelabelerInventoryItem
 */
export interface RelabelerInventoryItem {
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryItem
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryItem
     */
    'refined_revision_digest': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryItem
     */
    'refined_uploaded_at': string | null;
}
/**
 * A bounded metadata scan whose cursor advances even when no meetings are eligible.
 * @export
 * @interface RelabelerInventoryResponse
 */
export interface RelabelerInventoryResponse {
    /**
     * 
     * @type {Array<RelabelerInventoryItem>}
     * @memberof RelabelerInventoryResponse
     */
    'items': Array<RelabelerInventoryItem>;
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryResponse
     */
    'cutoff': string;
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryResponse
     */
    'next_cursor': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerInventoryResponse
     */
    'has_more': boolean;
    /**
     * 
     * @type {number}
     * @memberof RelabelerInventoryResponse
     */
    'scanned_count': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerInventoryResponse
     */
    'excluded_count': number;
    /**
     * 
     * @type {string}
     * @memberof RelabelerInventoryResponse
     */
    'model_sha256': string;
}
/**
 * Why an on-demand relabeler replay produced no comparison.
 * @export
 * @enum {string}
 */

export const RelabelerReplayReason = {
    NoJoin: 'no_join',
    TooLarge: 'too_large',
    Timeout: 'timeout',
    Unreadable: 'unreadable',
    OutOfScope: 'out_of_scope',
    Failed: 'failed'
} as const;

export type RelabelerReplayReason = typeof RelabelerReplayReason[keyof typeof RelabelerReplayReason];


/**
 * A relabeler comparison rebuilt from the stored artifacts, or why there is none.  ``saved`` is true once stored as the refined revision\'s sidecar; false can be a false negative, so the GET decides.
 * @export
 * @interface RelabelerReplayResponse
 */
export interface RelabelerReplayResponse {
    /**
     * 
     * @type {RelabelerReplayReason}
     * @memberof RelabelerReplayResponse
     */
    'reason'?: RelabelerReplayReason | null;
    /**
     * 
     * @type {RelabelerComparison}
     * @memberof RelabelerReplayResponse
     */
    'comparison'?: RelabelerComparison | null;
    /**
     * 
     * @type {boolean}
     * @memberof RelabelerReplayResponse
     */
    'saved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelabelerReplayResponse
     */
    'revision_digest'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelabelerReplayResponse
     */
    'save_outcome'?: RelabelerReplayResponseSaveOutcomeEnum | null;
}

export const RelabelerReplayResponseSaveOutcomeEnum = {
    Saved: 'saved',
    Exists: 'exists',
    RevisionChanged: 'revision_changed',
    LegacyRevision: 'legacy_revision',
    NoWriterId: 'no_writer_id',
    NoTime: 'no_time',
    TooLarge: 'too_large',
    Timeout: 'timeout',
    Failed: 'failed',
    Erased: 'erased',
    Unconfirmed: 'unconfirmed',
    InvalidExisting: 'invalid_existing',
    OutOfScope: 'out_of_scope'
} as const;

export type RelabelerReplayResponseSaveOutcomeEnum = typeof RelabelerReplayResponseSaveOutcomeEnum[keyof typeof RelabelerReplayResponseSaveOutcomeEnum];

/**
 * One speech entry\'s timing and the speaker key each arm gave it; the text is never included.
 * @export
 * @interface RelabelerRow
 */
export interface RelabelerRow {
    /**
     * 
     * @type {string}
     * @memberof RelabelerRow
     */
    'id': string | null;
    /**
     * 
     * @type {number}
     * @memberof RelabelerRow
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerRow
     */
    'end_ms': number;
    /**
     * 
     * @type {string}
     * @memberof RelabelerRow
     */
    'original': string | null;
    /**
     * 
     * @type {string}
     * @memberof RelabelerRow
     */
    'relabeled': string | null;
}
/**
 * Whether the relabeler only ran beside consensus or its speaker ids were applied.
 * @export
 * @enum {string}
 */

export const RelabelerSidecarMode = {
    Shadow: 'shadow',
    Apply: 'apply'
} as const;

export type RelabelerSidecarMode = typeof RelabelerSidecarMode[keyof typeof RelabelerSidecarMode];


/**
 * Name-free counters comparing the relabeler\'s speaker ids with consensus\'s.
 * @export
 * @interface RelabelerStats
 */
export interface RelabelerStats {
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'entries': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'entries_changed': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'words_changed': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'named': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'renamed': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'unmapped': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof RelabelerStats
     */
    'vacated': number;
}
/**
 * Result of removing a meeting from a folder.
 * @export
 * @interface RemoveFolderMeetingResponse
 */
export interface RemoveFolderMeetingResponse {
    /**
     * 
     * @type {string}
     * @memberof RemoveFolderMeetingResponse
     */
    'rule_domain'?: string | null;
}
/**
 * Request model for removing users from an enterprise by email.
 * @export
 * @interface RemoveUsersFromEnterpriseRequest
 */
export interface RemoveUsersFromEnterpriseRequest {
    /**
     * List of user emails to remove (max 100)
     * @type {Array<string>}
     * @memberof RemoveUsersFromEnterpriseRequest
     */
    'emails': Array<string>;
}
/**
 * Response model for remove users operation.
 * @export
 * @interface RemoveUsersFromEnterpriseResponse
 */
export interface RemoveUsersFromEnterpriseResponse {
    /**
     * 
     * @type {string}
     * @memberof RemoveUsersFromEnterpriseResponse
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof RemoveUsersFromEnterpriseResponse
     */
    'removed_count': number;
}
/**
 * A single targeted edit: replace the unique `old_string` with `new_string` in doc `name`.  The server validates that `old_string` occurs exactly once in the target before applying.
 * @export
 * @interface ReplaceEdit
 */
export interface ReplaceEdit {
    /**
     * 
     * @type {string}
     * @memberof ReplaceEdit
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceEdit
     */
    'old_string': string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceEdit
     */
    'new_string': string;
}
/**
 * Replace the one occurrence of ``old_text`` in the head; none, or more than one, conflicts.  Occurrences are counted overlapping, and a missing or deleted file has none.
 * @export
 * @interface ReplaceOp
 */
export interface ReplaceOp {
    /**
     * 
     * @type {string}
     * @memberof ReplaceOp
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceOp
     */
    'kind'?: ReplaceOpKindEnum;
    /**
     * 
     * @type {string}
     * @memberof ReplaceOp
     */
    'old_text': string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceOp
     */
    'new_text': string;
}

export const ReplaceOpKindEnum = {
    Replace: 'replace'
} as const;

export type ReplaceOpKindEnum = typeof ReplaceOpKindEnum[keyof typeof ReplaceOpKindEnum];

/**
 * An assistant turn that edited documents with targeted replacements, not full rewrites.  Cheaper on tokens and, on the client, applied as a precise editor edit rather than a whole-document re-render.  Free-form-tool-only. The server validates each edit (`old_string` must occur exactly once in the named editable doc) and returns the `ReplaceStep` for the client to apply by `name`. The deprecated `transformed_text` mirror still carries the full post-edit content for older clients that can\'t apply a `ReplaceStep`.
 * @export
 * @interface ReplaceStep
 */
export interface ReplaceStep {
    /**
     * 
     * @type {string}
     * @memberof ReplaceStep
     */
    'kind'?: ReplaceStepKindEnum;
    /**
     * 
     * @type {Array<ReplaceEdit>}
     * @memberof ReplaceStep
     */
    'edits': Array<ReplaceEdit>;
}

export const ReplaceStepKindEnum = {
    Replace: 'replace'
} as const;

export type ReplaceStepKindEnum = typeof ReplaceStepKindEnum[keyof typeof ReplaceStepKindEnum];

/**
 * Top values of one dimension inside the filtered population.
 * @export
 * @interface ReportCohort
 */
export interface ReportCohort {
    /**
     * 
     * @type {string}
     * @memberof ReportCohort
     */
    'dimension': ReportCohortDimensionEnum;
    /**
     * 
     * @type {Array<ReportCohortValue>}
     * @memberof ReportCohort
     */
    'values': Array<ReportCohortValue>;
    /**
     * Reports outside the listed values.
     * @type {number}
     * @memberof ReportCohort
     */
    'other_count'?: number;
}

export const ReportCohortDimensionEnum = {
    Signature: 'signature',
    OutputDeviceFamily: 'output_device_family',
    OutputDevice: 'output_device',
    MicDevice: 'mic_device',
    MeetingPlatform: 'meeting_platform',
    AppVersion: 'app_version',
    KnownIssue: 'known_issue',
    JobStatus: 'job_status',
    ReportCategory: 'report_category',
    ReportType: 'report_type',
    Severity: 'severity'
} as const;

export type ReportCohortDimensionEnum = typeof ReportCohortDimensionEnum[keyof typeof ReportCohortDimensionEnum];

/**
 * One value inside a cohort card.
 * @export
 * @interface ReportCohortValue
 */
export interface ReportCohortValue {
    /**
     * 
     * @type {string}
     * @memberof ReportCohortValue
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof ReportCohortValue
     */
    'report_count': number;
    /**
     * 
     * @type {number}
     * @memberof ReportCohortValue
     */
    's0_count'?: number;
}
/**
 * Every cohort card for the detail drawer in one response.
 * @export
 * @interface ReportCohorts
 */
export interface ReportCohorts {
    /**
     * 
     * @type {number}
     * @memberof ReportCohorts
     */
    'report_count': number;
    /**
     * 
     * @type {Array<ReportCohort>}
     * @memberof ReportCohorts
     */
    'cohorts': Array<ReportCohort>;
}
/**
 * One board row: a dimension value with its counters and signature context.
 * @export
 * @interface ReportGroup
 */
export interface ReportGroup {
    /**
     * 
     * @type {string}
     * @memberof ReportGroup
     */
    'value': string;
    /**
     * 
     * @type {ReportSummary}
     * @memberof ReportGroup
     */
    'summary': ReportSummary;
    /**
     * 
     * @type {number}
     * @memberof ReportGroup
     */
    'previous_report_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportGroup
     */
    'top_signature'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportGroup
     */
    's0_signatures'?: Array<string>;
}
/**
 * Bounded board rows for one dimension.
 * @export
 * @interface ReportGroups
 */
export interface ReportGroups {
    /**
     * 
     * @type {string}
     * @memberof ReportGroups
     */
    'dimension': ReportGroupsDimensionEnum;
    /**
     * 
     * @type {Array<ReportGroup>}
     * @memberof ReportGroups
     */
    'groups': Array<ReportGroup>;
    /**
     * True when more than 100 matching groups exist.
     * @type {boolean}
     * @memberof ReportGroups
     */
    'truncated'?: boolean;
}

export const ReportGroupsDimensionEnum = {
    Signature: 'signature',
    OutputDeviceFamily: 'output_device_family',
    OutputDevice: 'output_device',
    MicDevice: 'mic_device',
    MeetingPlatform: 'meeting_platform',
    AppVersion: 'app_version',
    KnownIssue: 'known_issue',
    JobStatus: 'job_status',
    ReportCategory: 'report_category',
    ReportType: 'report_type',
    Severity: 'severity'
} as const;

export type ReportGroupsDimensionEnum = typeof ReportGroupsDimensionEnum[keyof typeof ReportGroupsDimensionEnum];

/**
 * Current window, the equal-length prior window, daily trend, and filter values.
 * @export
 * @interface ReportOverview
 */
export interface ReportOverview {
    /**
     * 
     * @type {ReportSummary}
     * @memberof ReportOverview
     */
    'summary': ReportSummary;
    /**
     * 
     * @type {ReportSummary}
     * @memberof ReportOverview
     */
    'previous': ReportSummary;
    /**
     * Sparse: only UTC days with at least one report appear.
     * @type {Array<ReportTrendPoint>}
     * @memberof ReportOverview
     */
    'trend': Array<ReportTrendPoint>;
    /**
     * Distinct values per dimension, sorted, capped at 100 each; not exhaustive past the cap.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ReportOverview
     */
    'facets': { [key: string]: Array<string>; };
    /**
     * 
     * @type {string}
     * @memberof ReportOverview
     */
    'latest_created_at': string | null;
}
/**
 * Counters over one filtered report population.
 * @export
 * @interface ReportSummary
 */
export interface ReportSummary {
    /**
     * 
     * @type {number}
     * @memberof ReportSummary
     */
    'report_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportSummary
     */
    'meeting_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportSummary
     */
    'reporter_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportSummary
     */
    'signature_count'?: number;
    /**
     * Severity-weighted volume: S0×8, S1×4, S2×2, S3×1.
     * @type {number}
     * @memberof ReportSummary
     */
    'weighted'?: number;
    /**
     * 
     * @type {SeverityCounts}
     * @memberof ReportSummary
     */
    'severity'?: SeverityCounts;
}
/**
 * Reports per UTC day, split by severity.
 * @export
 * @interface ReportTrendPoint
 */
export interface ReportTrendPoint {
    /**
     * 
     * @type {string}
     * @memberof ReportTrendPoint
     */
    'date': string;
    /**
     * 
     * @type {SeverityCounts}
     * @memberof ReportTrendPoint
     */
    'severity': SeverityCounts;
}
/**
 * Password-reset-email request guarded by a required captcha token.
 * @export
 * @interface RequestResetPasswordCaptchaRequest
 */
export interface RequestResetPasswordCaptchaRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestResetPasswordCaptchaRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RequestResetPasswordCaptchaRequest
     */
    'captcha_token': string;
}
/**
 * Request to send a password-reset email to the given address.
 * @export
 * @interface RequestResetPasswordRequest
 */
export interface RequestResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestResetPasswordRequest
     */
    'email': string;
}
/**
 * A bounded observation with no arguments, identifiers or response content.
 * @export
 * @interface ResearchCall
 */
export interface ResearchCall {
    /**
     * 
     * @type {string}
     * @memberof ResearchCall
     */
    'source': ResearchCallSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ResearchCall
     */
    'operation': ResearchCallOperationEnum;
    /**
     * 
     * @type {string}
     * @memberof ResearchCall
     */
    'status': ResearchCallStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ResearchCall
     */
    'error_category'?: ResearchCallErrorCategoryEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ResearchCall
     */
    'returned_item_count'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResearchCall
     */
    'truncated'?: boolean | null;
}

export const ResearchCallSourceEnum = {
    Gmail: 'gmail',
    Slack: 'slack',
    PriorMeetings: 'prior_meetings',
    Notion: 'notion',
    AttendeeDetails: 'attendee_details',
    Web: 'web',
    Wispr: 'wispr',
    Calendar: 'calendar',
    Unknown: 'unknown'
} as const;

export type ResearchCallSourceEnum = typeof ResearchCallSourceEnum[keyof typeof ResearchCallSourceEnum];
export const ResearchCallOperationEnum = {
    Search: 'search',
    Read: 'read',
    Other: 'other'
} as const;

export type ResearchCallOperationEnum = typeof ResearchCallOperationEnum[keyof typeof ResearchCallOperationEnum];
export const ResearchCallStatusEnum = {
    NotAttempted: 'not_attempted',
    Success: 'success',
    NotConnected: 'not_connected',
    PermissionDenied: 'permission_denied',
    EnterpriseDisabled: 'enterprise_disabled',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type ResearchCallStatusEnum = typeof ResearchCallStatusEnum[keyof typeof ResearchCallStatusEnum];
export const ResearchCallErrorCategoryEnum = {
    Timeout: 'timeout',
    PermissionDenied: 'permission_denied',
    InvalidArguments: 'invalid_arguments',
    Unavailable: 'unavailable',
    Truncated: 'truncated',
    ProviderError: 'provider_error',
    Unknown: 'unknown'
} as const;

export type ResearchCallErrorCategoryEnum = typeof ResearchCallErrorCategoryEnum[keyof typeof ResearchCallErrorCategoryEnum];

/**
 * Invitation ids to resend; duplicates are collapsed server-side.
 * @export
 * @interface ResendInvitationsRequest
 */
export interface ResendInvitationsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResendInvitationsRequest
     */
    'invitation_ids': Array<string>;
}
/**
 * One result per unique requested invitation id, in request order.
 * @export
 * @interface ResendInvitationsResponse
 */
export interface ResendInvitationsResponse {
    /**
     * 
     * @type {Array<InvitationResendResult>}
     * @memberof ResendInvitationsResponse
     */
    'results': Array<InvitationResendResult>;
}
/**
 * Resend-verification request guarded by a required captcha token.
 * @export
 * @interface ResendVerificationEmailCaptchaRequest
 */
export interface ResendVerificationEmailCaptchaRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendVerificationEmailCaptchaRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResendVerificationEmailCaptchaRequest
     */
    'captcha_token': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResendVerificationEmailCaptchaRequest
     */
    'workos_capable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResendVerificationEmailCaptchaRequest
     */
    'redirect_url'?: string | null;
}
/**
 * Request to resend the verification email to the given address.
 * @export
 * @interface ResendVerificationEmailRequest
 */
export interface ResendVerificationEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ResendVerificationEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof ResendVerificationEmailRequest
     */
    'workos_capable'?: boolean;
}
/**
 * Password-reset request authenticated by access and refresh tokens.
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'refresh_token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'new_password': string;
}
/**
 * Password-reset confirmation for the WorkOS opaque-token flow.
 * @export
 * @interface ResetPasswordWorkosRequest
 */
export interface ResetPasswordWorkosRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordWorkosRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordWorkosRequest
     */
    'new_password': string;
}
/**
 * Where a suggestion\'s output lands in the client.  The backend is the single source of truth — each suggestion declares what kind of artifact its prompt produces, and the client dispatches accordingly. Prompts and targets are tightly coupled (an email draft IS a new document; a \"more concise\" rewrite IS a replacement of the current doc), so they live together.  Contract with the backend:   - CHAT:     `transformed_text` is the assistant\'s reply message.   - APPEND:   `transformed_text` is a fragment to concatenate onto the current doc.   - REWRITE:  `transformed_text` is the full replacement for the current doc.   - REPLACE:  a targeted (old_string -> new_string) edit returned as a               `ReplaceStep`. Used only as a free-form tool; the server               validates each edit (old_string unique in its target) and the               client applies the precise edit. `transformed_text` mirrors the               full post-edit content for older clients.   - NEW_TAB:  `transformed_text` is a complete new document (opened in a new tab).  Deprecated on the response in favour of the discriminated-union ``result`` (``TransformApplyResult``); still populated for older clients.
 * @export
 * @enum {string}
 */

export const ResponseTarget = {
    Chat: 'chat',
    Append: 'append',
    Rewrite: 'rewrite',
    Replace: 'replace',
    NewTab: 'new_tab'
} as const;

export type ResponseTarget = typeof ResponseTarget[keyof typeof ResponseTarget];


/**
 * Response shape for ``POST /api/v1/calendar/resync``.  ``eventsCount`` is the current aggregate mirror count. ``success`` means at least one active provider completed or was durably accepted; Outlook rows may arrive after the response.
 * @export
 * @interface ResyncResponse
 */
export interface ResyncResponse {
    /**
     * 
     * @type {number}
     * @memberof ResyncResponse
     */
    'eventsCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof ResyncResponse
     */
    'success': boolean;
}
/**
 * Request to revoke an invitation, optionally scoped to a specific enterprise.
 * @export
 * @interface RevokeInvitationRequest
 */
export interface RevokeInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof RevokeInvitationRequest
     */
    'enterprise_id'?: string | null;
}
/**
 * Response model for suspending a sales-owned enterprise\'s access.
 * @export
 * @interface RevokeSalesOwnedAccessResponse
 */
export interface RevokeSalesOwnedAccessResponse {
    /**
     * 
     * @type {string}
     * @memberof RevokeSalesOwnedAccessResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof RevokeSalesOwnedAccessResponse
     */
    'message': string;
}
/**
 * Request to revoke an access token.
 * @export
 * @interface RevokeTokenRequest
 */
export interface RevokeTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RevokeTokenRequest
     */
    'access_token': string;
}
/**
 * A single named document edit: replace the editable document `name` with `text`.  The client applies it by `name`.
 * @export
 * @interface RewriteDocument
 */
export interface RewriteDocument {
    /**
     * 
     * @type {string}
     * @memberof RewriteDocument
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RewriteDocument
     */
    'text': string;
}
/**
 * An assistant turn where the model rewrote one or more editable documents.  `documents` holds the new content for each document the model changed (a subset of the request\'s `editable_content`, keyed by `name`). APPEND suggestions also surface as a rewrite — the server stitches the section into the target document and returns its full new content here.
 * @export
 * @interface RewriteStep
 */
export interface RewriteStep {
    /**
     * 
     * @type {string}
     * @memberof RewriteStep
     */
    'kind'?: RewriteStepKindEnum;
    /**
     * 
     * @type {Array<RewriteDocument>}
     * @memberof RewriteStep
     */
    'documents': Array<RewriteDocument>;
}

export const RewriteStepKindEnum = {
    Rewrite: 'rewrite'
} as const;

export type RewriteStepKindEnum = typeof RewriteStepKindEnum[keyof typeof RewriteStepKindEnum];

/**
 * A platform team member\'s role.
 * @export
 * @enum {string}
 */

export const Role = {
    Admin: 'admin',
    Member: 'member'
} as const;

export type Role = typeof Role[keyof typeof Role];


/**
 * A classifiable intent route: its name and a prompt describing when it applies.
 * @export
 * @interface RouteDefinition
 */
export interface RouteDefinition {
    /**
     * Route name, e.g. \'instruct\', \'dictation\'
     * @type {string}
     * @memberof RouteDefinition
     */
    'name': string;
    /**
     * Description of when this route applies
     * @type {string}
     * @memberof RouteDefinition
     */
    'route_prompt': string;
}
/**
 * @type RouteProvider
 * @export
 */
export type RouteProvider = CerebrasProviderConfig | OpenRouterProviderConfig;

/**
 * An install identity and the account the client prepared the request for.
 * @export
 * @interface SaveAppsFlyerIdentityRequest
 */
export interface SaveAppsFlyerIdentityRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveAppsFlyerIdentityRequest
     */
    'appsflyer_id': string;
    /**
     * 
     * @type {string}
     * @memberof SaveAppsFlyerIdentityRequest
     */
    'expected_user_id': string;
}
/**
 * Response for POST /api/v1/enterprise/seat-requests.
 * @export
 * @interface SeatRequestResponse
 */
export interface SeatRequestResponse {
    /**
     * 
     * @type {SeatRequestStatus}
     * @memberof SeatRequestResponse
     */
    'status': SeatRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof SeatRequestResponse
     */
    'requested_at': string;
}


/**
 * Outcome of a Full seat request: a new request emailed to admins, or one already open.
 * @export
 * @enum {string}
 */

export const SeatRequestStatus = {
    Requested: 'requested',
    AlreadyRequested: 'already_requested'
} as const;

export type SeatRequestStatus = typeof SeatRequestStatus[keyof typeof SeatRequestStatus];


/**
 * Access products assigned to an organization member.
 * @export
 * @enum {string}
 */

export const SeatType = {
    Dictation: 'dictation',
    Bundle: 'bundle',
    NoAccess: 'no-access'
} as const;

export type SeatType = typeof SeatType[keyof typeof SeatType];


/**
 * Body for `POST /api/v1/support/usage-data-erasure/self`: the categories to erase; omitted erases everything.
 * @export
 * @interface SelfErasureStartRequest
 */
export interface SelfErasureStartRequest {
    /**
     * 
     * @type {Array<DataCategory>}
     * @memberof SelfErasureStartRequest
     */
    'categories'?: Array<DataCategory> | null;
}
/**
 * Request model for self-invite to enterprise.
 * @export
 * @interface SelfInviteRequest
 */
export interface SelfInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof SelfInviteRequest
     */
    'message': string;
}
/**
 * Response model for self-invite endpoint.
 * @export
 * @interface SelfInviteResponse
 */
export interface SelfInviteResponse {
    /**
     * 
     * @type {string}
     * @memberof SelfInviteResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof SelfInviteResponse
     */
    'should_refetch'?: boolean | null;
}
/**
 * Request to refer oneself to a target platform or address.
 * @export
 * @interface SelfReferRequest
 */
export interface SelfReferRequest {
    /**
     * 
     * @type {string}
     * @memberof SelfReferRequest
     */
    'refer_to': string;
}
/**
 * An open checkout, a reused request UUID, or a refused checkout.
 * @export
 * @interface SelfServeCheckoutConflictDetail
 */
export interface SelfServeCheckoutConflictDetail {
    /**
     * 
     * @type {string}
     * @memberof SelfServeCheckoutConflictDetail
     */
    'code': SelfServeCheckoutConflictDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof SelfServeCheckoutConflictDetail
     */
    'message': string;
}

export const SelfServeCheckoutConflictDetailCodeEnum = {
    RequestIdReused: 'request_id_reused',
    CheckoutInProgress: 'checkout_in_progress',
    CheckoutRejected: 'checkout_rejected'
} as const;

export type SelfServeCheckoutConflictDetailCodeEnum = typeof SelfServeCheckoutConflictDetailCodeEnum[keyof typeof SelfServeCheckoutConflictDetailCodeEnum];

/**
 * The HTTP 409 envelope for a self-serve checkout conflict.
 * @export
 * @interface SelfServeCheckoutConflictResponse
 */
export interface SelfServeCheckoutConflictResponse {
    /**
     * 
     * @type {SelfServeCheckoutConflictDetail}
     * @memberof SelfServeCheckoutConflictResponse
     */
    'detail': SelfServeCheckoutConflictDetail;
}
/**
 * An unknown checkout outcome; retrying the same request returns its session.
 * @export
 * @interface SelfServeCheckoutUnavailableDetail
 */
export interface SelfServeCheckoutUnavailableDetail {
    /**
     * 
     * @type {string}
     * @memberof SelfServeCheckoutUnavailableDetail
     */
    'code': SelfServeCheckoutUnavailableDetailCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof SelfServeCheckoutUnavailableDetail
     */
    'message': string;
}

export const SelfServeCheckoutUnavailableDetailCodeEnum = {
    CheckoutOutcomeUnknown: 'checkout_outcome_unknown'
} as const;

export type SelfServeCheckoutUnavailableDetailCodeEnum = typeof SelfServeCheckoutUnavailableDetailCodeEnum[keyof typeof SelfServeCheckoutUnavailableDetailCodeEnum];

/**
 * The HTTP 503 envelope for an unknown checkout outcome.
 * @export
 * @interface SelfServeCheckoutUnavailableResponse
 */
export interface SelfServeCheckoutUnavailableResponse {
    /**
     * 
     * @type {SelfServeCheckoutUnavailableDetail}
     * @memberof SelfServeCheckoutUnavailableResponse
     */
    'detail': SelfServeCheckoutUnavailableDetail;
}
/**
 * Result of sending mail via a connector.  ``successful`` is the only payload; ``error`` carries a stable code the client maps to a toast (see ``GmailConnector.send_email``).
 * @export
 * @interface SendEmailResponse
 */
export interface SendEmailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendEmailResponse
     */
    'successful': boolean;
    /**
     * 
     * @type {string}
     * @memberof SendEmailResponse
     */
    'error'?: string | null;
}
/**
 * Request body for the marketing send endpoint.  Requires at least one explicit filter (emails, domain, or user_ids) to prevent accidentally blasting every user with a profile for the reporting month.
 * @export
 * @interface SendFlowStateRequest
 */
export interface SendFlowStateRequest {
    /**
     * 
     * @type {string}
     * @memberof SendFlowStateRequest
     */
    'reporting_month': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendFlowStateRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SendFlowStateRequest
     */
    'domain'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendFlowStateRequest
     */
    'user_ids'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SendFlowStateRequest
     */
    'all_users'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SendFlowStateRequest
     */
    'dry_run'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SendFlowStateRequest
     */
    'resend_failed'?: boolean;
}
/**
 * Request model for sending a pending invoice.
 * @export
 * @interface SendInvoiceRequest
 */
export interface SendInvoiceRequest {
    /**
     * Stripe draft invoice ID to finalize and send
     * @type {string}
     * @memberof SendInvoiceRequest
     */
    'invoice_id': string;
    /**
     * Purchase order number
     * @type {string}
     * @memberof SendInvoiceRequest
     */
    'po_number': string;
}
/**
 * Response model for sending an invoice.
 * @export
 * @interface SendInvoiceResponse
 */
export interface SendInvoiceResponse {
    /**
     * 
     * @type {string}
     * @memberof SendInvoiceResponse
     */
    'invoice_id': string;
    /**
     * 
     * @type {string}
     * @memberof SendInvoiceResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SendInvoiceResponse
     */
    'message': string;
}
/**
 * Destination phone number for an outbound SMS, split into country code and number.
 * @export
 * @interface SendSMSRequest
 */
export interface SendSMSRequest {
    /**
     * 
     * @type {string}
     * @memberof SendSMSRequest
     */
    'country_code': string;
    /**
     * 
     * @type {string}
     * @memberof SendSMSRequest
     */
    'number': string;
}
/**
 * The meeting or upcoming calendar event whose recurring series the rule follows; exactly one field is set.
 * @export
 * @interface SeriesRuleAnchor
 */
export interface SeriesRuleAnchor {
    /**
     * 
     * @type {string}
     * @memberof SeriesRuleAnchor
     */
    'meeting_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SeriesRuleAnchor
     */
    'event_key'?: string | null;
}
/**
 * Request to grant or revoke a customer member\'s enterprise superadmin role.
 * @export
 * @interface SetEnterpriseSuperadminRequest
 */
export interface SetEnterpriseSuperadminRequest {
    /**
     * 
     * @type {string}
     * @memberof SetEnterpriseSuperadminRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SetEnterpriseSuperadminRequest
     */
    'action': SetEnterpriseSuperadminRequestActionEnum;
}

export const SetEnterpriseSuperadminRequestActionEnum = {
    Grant: 'grant',
    Revoke: 'revoke'
} as const;

export type SetEnterpriseSuperadminRequestActionEnum = typeof SetEnterpriseSuperadminRequestActionEnum[keyof typeof SetEnterpriseSuperadminRequestActionEnum];

/**
 * Outcome of a superadmin grant or revoke, with the member\'s resulting role and WorkOS role sync.
 * @export
 * @interface SetEnterpriseSuperadminResponse
 */
export interface SetEnterpriseSuperadminResponse {
    /**
     * 
     * @type {string}
     * @memberof SetEnterpriseSuperadminResponse
     */
    'result': SetEnterpriseSuperadminResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof SetEnterpriseSuperadminResponse
     */
    'role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetEnterpriseSuperadminResponse
     */
    'workos_synced': boolean;
}

export const SetEnterpriseSuperadminResponseResultEnum = {
    Granted: 'granted',
    Revoked: 'revoked',
    Unchanged: 'unchanged'
} as const;

export type SetEnterpriseSuperadminResponseResultEnum = typeof SetEnterpriseSuperadminResponseResultEnum[keyof typeof SetEnterpriseSuperadminResponseResultEnum];

/**
 * Reports per triage verdict.
 * @export
 * @interface SeverityCounts
 */
export interface SeverityCounts {
    /**
     * 
     * @type {number}
     * @memberof SeverityCounts
     */
    's0'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCounts
     */
    's1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCounts
     */
    's2'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeverityCounts
     */
    's3'?: number;
}
/**
 * A single recipient in a batch invite request.  ``email`` is a plain string (not ``EmailStr``) on purpose: a malformed address is reported per-recipient in the response ``failed`` count rather than 422-ing the whole batch. Format is validated in the service layer.
 * @export
 * @interface ShareRecipientInput
 */
export interface ShareRecipientInput {
    /**
     * 
     * @type {string}
     * @memberof ShareRecipientInput
     */
    'email': string;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof ShareRecipientInput
     */
    'role'?: NoteShareRole;
}


/**
 * Move one of the caller\'s skills to their department or company, keeping its id.
 * @export
 * @interface ShareSkillRequest
 */
export interface ShareSkillRequest {
    /**
     * 
     * @type {SkillScope}
     * @memberof ShareSkillRequest
     */
    'scope': SkillScope;
}


/**
 * Full share state: slug, visibility, owner, and invited recipients.
 * @export
 * @interface ShareStateResponse
 */
export interface ShareStateResponse {
    /**
     * 
     * @type {string}
     * @memberof ShareStateResponse
     */
    'slug': string;
    /**
     * 
     * @type {NoteVisibility}
     * @memberof ShareStateResponse
     */
    'visibility': NoteVisibility;
    /**
     * 
     * @type {Owner}
     * @memberof ShareStateResponse
     */
    'owner': Owner;
    /**
     * 
     * @type {Array<RecipientEntry>}
     * @memberof ShareStateResponse
     */
    'recipients': Array<RecipientEntry>;
}


/**
 * Shared dictionary row for GET /shared (and the GET /team JSON shape).  Extends ``DictionaryItemBase`` (content fields also used by personal ``DictionaryItem``) with ``team_id`` / ``enterprise_id`` scope FKs (exactly one set; UI infers origin from nullability).
 * @export
 * @interface SharedDictionaryItem
 */
export interface SharedDictionaryItem {
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'replacement_html'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedDictionaryItem
     */
    'is_manual': boolean;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'modified_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof SharedDictionaryItem
     */
    'is_deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof SharedDictionaryItem
     */
    'frequency_used': number;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'last_used'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'source'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedDictionaryItem
     */
    'is_snippet': boolean;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'team_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'enterprise_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedDictionaryItem
     */
    'creator_id'?: string | null;
}
/**
 * Result of an admin approve/reject on one shared dictionary entry.
 * @export
 * @interface SharedEntryDecisionResponse
 */
export interface SharedEntryDecisionResponse {
    /**
     * 
     * @type {string}
     * @memberof SharedEntryDecisionResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SharedEntryDecisionResponse
     */
    'outcome': SharedEntryDecisionResponseOutcomeEnum;
}

export const SharedEntryDecisionResponseOutcomeEnum = {
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type SharedEntryDecisionResponseOutcomeEnum = typeof SharedEntryDecisionResponseOutcomeEnum[keyof typeof SharedEntryDecisionResponseOutcomeEnum];

/**
 * An attendee on the owner\'s calendar event for a shared note.  A calendar guest, not a Flow user, so deliberately not ``Profile``. ``email`` and ``avatar_url`` are filled only for a caller with transcript access; everyone else gets the name alone.
 * @export
 * @interface SharedNoteAttendee
 */
export interface SharedNoteAttendee {
    /**
     * 
     * @type {string}
     * @memberof SharedNoteAttendee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteAttendee
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteAttendee
     */
    'avatar_url'?: string | null;
}
/**
 * Shared note row for authenticated \"Shared with me\" lists.  Owned notes never appear in these rows, so every row is summary-only: `notes` is withheld.
 * @export
 * @interface SharedNoteListItem
 */
export interface SharedNoteListItem {
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'meeting_id': string;
    /**
     * 
     * @type {SharedNoteVia}
     * @memberof SharedNoteListItem
     */
    'via'?: SharedNoteVia;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'modified_at': string;
    /**
     * 
     * @type {Owner}
     * @memberof SharedNoteListItem
     */
    'owner': Owner;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof SharedNoteListItem
     */
    'caller_role': NoteShareRole;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListItem
     */
    'event_key'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedNoteListItem
     */
    'recorded_ms'?: number | null;
}


/**
 * Notes shared with the authenticated caller.
 * @export
 * @interface SharedNoteListResponse
 */
export interface SharedNoteListResponse {
    /**
     * 
     * @type {Array<SharedNoteListItem>}
     * @memberof SharedNoteListResponse
     */
    'notes': Array<SharedNoteListItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SharedNoteListResponse
     */
    'has_more'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteListResponse
     */
    'next_cursor'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SharedNoteListResponse
     */
    'folder_leg_included'?: boolean;
}
/**
 * Shared note payload returned to a caller with resolved access.  The owner gets the full body; every other role is summary-only — `notes` is withheld and `todos` is empty.
 * @export
 * @interface SharedNoteResponse
 */
export interface SharedNoteResponse {
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'modified_at': string;
    /**
     * 
     * @type {Owner}
     * @memberof SharedNoteResponse
     */
    'owner': Owner;
    /**
     * 
     * @type {string}
     * @memberof SharedNoteResponse
     */
    'meeting_start_at'?: string | null;
    /**
     * 
     * @type {Array<SharedNoteAttendee>}
     * @memberof SharedNoteResponse
     */
    'attendees'?: Array<SharedNoteAttendee>;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof SharedNoteResponse
     */
    'caller_role': NoteShareRole;
    /**
     * 
     * @type {boolean}
     * @memberof SharedNoteResponse
     */
    'transcript_access': boolean;
    /**
     * 
     * @type {TranscriptDenialReason}
     * @memberof SharedNoteResponse
     */
    'transcript_denial'?: TranscriptDenialReason | null;
    /**
     * 
     * @type {Array<SharedTodo>}
     * @memberof SharedNoteResponse
     */
    'todos'?: Array<SharedTodo>;
    /**
     * 
     * @type {boolean}
     * @memberof SharedNoteResponse
     */
    'has_action_items'?: boolean;
    /**
     * 
     * @type {ActionItemsAbsentReason}
     * @memberof SharedNoteResponse
     */
    'action_items_absent_reason'?: ActionItemsAbsentReason | null;
    /**
     * 
     * @type {number}
     * @memberof SharedNoteResponse
     */
    'viewer_action_item_count'?: number | null;
}


/**
 * Share state for a shared note as seen by any caller the access walk admits.  Disclosure is scoped to how the caller was admitted: ``recipients`` is populated only for the owner and explicitly-invited recipients — domain and link viewers get an empty list. ``owner.email`` is additionally null for anonymous callers.
 * @export
 * @interface SharedNoteShareStateResponse
 */
export interface SharedNoteShareStateResponse {
    /**
     * 
     * @type {string}
     * @memberof SharedNoteShareStateResponse
     */
    'slug': string;
    /**
     * 
     * @type {NoteVisibility}
     * @memberof SharedNoteShareStateResponse
     */
    'visibility': NoteVisibility;
    /**
     * 
     * @type {Owner}
     * @memberof SharedNoteShareStateResponse
     */
    'owner': Owner;
    /**
     * 
     * @type {Array<RecipientEntry>}
     * @memberof SharedNoteShareStateResponse
     */
    'recipients': Array<RecipientEntry>;
    /**
     * 
     * @type {NoteShareRole}
     * @memberof SharedNoteShareStateResponse
     */
    'caller_role': NoteShareRole;
}


/**
 * Refined transcript + speaker map for a shared note the caller can access.  ``transcript`` is the refined ``TranscriptEntry`` NDJSON text — the same body the meeting-status endpoint inlines as ``refined_transcript``. ``None`` covers absent, unreadable, and retention-erased alike, so viewers can\'t distinguish them.
 * @export
 * @interface SharedNoteTranscriptResponse
 */
export interface SharedNoteTranscriptResponse {
    /**
     * 
     * @type {string}
     * @memberof SharedNoteTranscriptResponse
     */
    'transcript': string | null;
    /**
     * 
     * @type {SpeakerMap}
     * @memberof SharedNoteTranscriptResponse
     */
    'speaker_map': SpeakerMap | null;
    /**
     * 
     * @type {TranscriptCorrections}
     * @memberof SharedNoteTranscriptResponse
     */
    'transcript_corrections'?: TranscriptCorrections | null;
}
/**
 * How a shared note reached the caller\'s \"Shared with me\" list.
 * @export
 * @enum {string}
 */

export const SharedNoteVia = {
    Invited: 'invited',
    Folder: 'folder',
    Both: 'both'
} as const;

export type SharedNoteVia = typeof SharedNoteVia[keyof typeof SharedNoteVia];


/**
 * Slugs to re-resolve against the caller\'s shared-with-me set.
 * @export
 * @interface SharedNotesBatchRequest
 */
export interface SharedNotesBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SharedNotesBatchRequest
     */
    'slugs': Array<string>;
    /**
     * Caller renders <wispr_name_chip> tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
     * @type {boolean}
     * @memberof SharedNotesBatchRequest
     */
    'supports_name_chips'?: boolean;
}
/**
 * Batch resolve result; a requested slug missing from ``notes`` should be dropped locally.
 * @export
 * @interface SharedNotesBatchResponse
 */
export interface SharedNotesBatchResponse {
    /**
     * 
     * @type {Array<SharedNoteListItem>}
     * @memberof SharedNotesBatchResponse
     */
    'notes': Array<SharedNoteListItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SharedNotesBatchResponse
     */
    'folder_leg_included'?: boolean;
}
/**
 * An action item attached to a shared note (read-only projection).
 * @export
 * @interface SharedTodo
 */
export interface SharedTodo {
    /**
     * 
     * @type {string}
     * @memberof SharedTodo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SharedTodo
     */
    'title': string;
    /**
     * 
     * @type {TodoStatus}
     * @memberof SharedTodo
     */
    'status': TodoStatus;
    /**
     * 
     * @type {string}
     * @memberof SharedTodo
     */
    'created_at': string;
}


/**
 * The speaker labels the owner received for the current refined revision, before any of their edits.  ``complete`` includes the summary\'s own LLM names; ``summary_pending`` and ``summary_missing`` carry the labels delivered with the transcript. Rows and labels are empty for every other status.
 * @export
 * @interface ShippedAttributionResponse
 */
export interface ShippedAttributionResponse {
    /**
     * 
     * @type {ShippedAttributionStatus}
     * @memberof ShippedAttributionResponse
     */
    'status': ShippedAttributionStatus;
    /**
     * 
     * @type {string}
     * @memberof ShippedAttributionResponse
     */
    'displayed_revision'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippedAttributionResponse
     */
    'job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippedAttributionResponse
     */
    'consensus_result'?: string | null;
    /**
     * 
     * @type {Array<ShippedAttributionRow>}
     * @memberof ShippedAttributionResponse
     */
    'rows'?: Array<ShippedAttributionRow>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ShippedAttributionResponse
     */
    'labels'?: { [key: string]: string; };
}


/**
 * One speech entry\'s timing and the ``refined:<id>`` speaker key it shipped with.
 * @export
 * @interface ShippedAttributionRow
 */
export interface ShippedAttributionRow {
    /**
     * 
     * @type {string}
     * @memberof ShippedAttributionRow
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ShippedAttributionRow
     */
    'start_ms': number;
    /**
     * 
     * @type {number}
     * @memberof ShippedAttributionRow
     */
    'end_ms': number;
    /**
     * 
     * @type {string}
     * @memberof ShippedAttributionRow
     */
    'speaker': string;
}
/**
 * Whether the viewer can show what the current refined revision shipped, and how complete that is.
 * @export
 * @enum {string}
 */

export const ShippedAttributionStatus = {
    Complete: 'complete',
    SummaryPending: 'summary_pending',
    SummaryMissing: 'summary_missing',
    Missing: 'missing',
    Unreadable: 'unreadable',
    NotShipped: 'not_shipped',
    RevisionMismatch: 'revision_mismatch'
} as const;

export type ShippedAttributionStatus = typeof ShippedAttributionStatus[keyof typeof ShippedAttributionStatus];


/**
 * Signer\'s legal name captured when accepting the HIPAA Business Associate Agreement.
 * @export
 * @interface SignHipaaBaaRequest
 */
export interface SignHipaaBaaRequest {
    /**
     * 
     * @type {string}
     * @memberof SignHipaaBaaRequest
     */
    'legal_name': string;
}
/**
 * Bounded diagnostics emitted by the consensus engine.
 * @export
 * @interface SignalQuality
 */
export interface SignalQuality {
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'vote_margin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'tile_agreement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'tile_log_event_count': number;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'tile_log_cadence_ms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'tile_log_longest_gap_ms'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'cluster_count': number;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'token_confidence_avg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'token_confidence_min'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SignalQuality
     */
    'token_count': number;
}
/**
 * Email sign-in request that additionally carries a captcha token.
 * @export
 * @interface SigninWithEmailCaptchaRequest
 */
export interface SigninWithEmailCaptchaRequest {
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'is_platform_user'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'workos_capable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'mcp_login_state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'provision'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailCaptchaRequest
     */
    'captcha_token': string;
}
/**
 * Email-and-password sign-in request with platform and WorkOS flags.
 * @export
 * @interface SigninWithEmailRequest
 */
export interface SigninWithEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailRequest
     */
    'is_platform_user'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailRequest
     */
    'workos_capable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailRequest
     */
    'mcp_login_state'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailRequest
     */
    'provision'?: boolean;
}
/**
 * Sign-in result: tokens, profile fields, and an optional error message.
 * @export
 * @interface SigninWithEmailResponse
 */
export interface SigninWithEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'access_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'refresh_token'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'redirect_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'avatar_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SigninWithEmailResponse
     */
    'onboarding_completed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'provider'?: SigninWithEmailResponseProviderEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'verification_method'?: SigninWithEmailResponseVerificationMethodEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SigninWithEmailResponse
     */
    'pending_authentication_token'?: string | null;
}

export const SigninWithEmailResponseProviderEnum = {
    Supabase: 'supabase',
    Workos: 'workos'
} as const;

export type SigninWithEmailResponseProviderEnum = typeof SigninWithEmailResponseProviderEnum[keyof typeof SigninWithEmailResponseProviderEnum];
export const SigninWithEmailResponseVerificationMethodEnum = {
    EmailOtp: 'email_otp'
} as const;

export type SigninWithEmailResponseVerificationMethodEnum = typeof SigninWithEmailResponseVerificationMethodEnum[keyof typeof SigninWithEmailResponseVerificationMethodEnum];

/**
 * Signup payload for an OAuth-authenticated user, with attribution fields.
 * @export
 * @interface SignupUserRequest
 */
export interface SignupUserRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'dub_click_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'referral'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'promo_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'team_invite_code'?: string | null;
    /**
     * 
     * @type {UtmParams}
     * @memberof SignupUserRequest
     */
    'utm'?: UtmParams | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'first_landing_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupUserRequest
     */
    'gravity_ads_consent'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'gravity_ads_consent_type'?: SignupUserRequestGravityAdsConsentTypeEnum | null;
    /**
     * 
     * @type {object}
     * @memberof SignupUserRequest
     */
    'gravity_user_data'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof SignupUserRequest
     */
    'gravity_client_context'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof SignupUserRequest
     */
    'gravity_event_source_url'?: string | null;
}

export const SignupUserRequestGravityAdsConsentTypeEnum = {
    Implicit: 'IMPLICIT',
    Explicit: 'EXPLICIT'
} as const;

export type SignupUserRequestGravityAdsConsentTypeEnum = typeof SignupUserRequestGravityAdsConsentTypeEnum[keyof typeof SignupUserRequestGravityAdsConsentTypeEnum];

/**
 * Email-and-password signup request guarded by a required captcha token.
 * @export
 * @interface SignupWithEmailCaptchaRequest
 */
export interface SignupWithEmailCaptchaRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'full_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'captcha_token': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'device_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'workos_capable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailCaptchaRequest
     */
    'redirect_url'?: string | null;
}
/**
 * Email-and-password signup request, optionally tied to a device code.
 * @export
 * @interface SignupWithEmailRequest
 */
export interface SignupWithEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailRequest
     */
    'full_name': string;
    /**
     * 
     * @type {string}
     * @memberof SignupWithEmailRequest
     */
    'device_code'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SignupWithEmailRequest
     */
    'workos_capable'?: boolean;
}
/**
 * One skill the caller can run: a named prompt for the Ask chat.
 * @export
 * @interface Skill
 */
export interface Skill {
    /**
     * A built-in\'s slug, or a user or team skill\'s UUID.
     * @type {string}
     * @memberof Skill
     */
    'id': string;
    /**
     * 
     * @type {SkillSource}
     * @memberof Skill
     */
    'source': SkillSource;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'name': string;
    /**
     * Lowercase and hyphenated; the user types it as `/<command>`.
     * @type {string}
     * @memberof Skill
     */
    'command': string;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'instructions': string;
    /**
     * An icon name; clients show their default for a name they don\'t know.
     * @type {string}
     * @memberof Skill
     */
    'icon': string;
    /**
     * 
     * @type {Array<SkillContext>}
     * @memberof Skill
     */
    'contexts': Array<SkillContext>;
    /**
     * 
     * @type {SkillCategory}
     * @memberof Skill
     */
    'category'?: SkillCategory | null;
    /**
     * 
     * @type {SkillScope}
     * @memberof Skill
     */
    'scope'?: SkillScope | null;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'created_by_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'last_edited_by_name'?: string | null;
    /**
     * A digest of what the skill tells the model: name, description, icon, contexts and instructions. Renaming the command does not change it.
     * @type {string}
     * @memberof Skill
     */
    'version': string;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'created_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'modified_at': string | null;
}


/**
 * The gallery section a built-in skill is grouped under.
 * @export
 * @enum {string}
 */

export const SkillCategory = {
    AfterMeeting: 'after_meeting',
    BeforeMeeting: 'before_meeting',
    AcrossMeetings: 'across_meetings'
} as const;

export type SkillCategory = typeof SkillCategory[keyof typeof SkillCategory];


/**
 * The machine-readable part of a skills 409.
 * @export
 * @interface SkillConflictDetail
 */
export interface SkillConflictDetail {
    /**
     * 
     * @type {SkillConflictReason}
     * @memberof SkillConflictDetail
     */
    'reason': SkillConflictReason;
}


/**
 * Why a create, edit or share was refused with 409.
 * @export
 * @enum {string}
 */

export const SkillConflictReason = {
    CommandReserved: 'command_reserved',
    CommandTaken: 'command_taken',
    LimitReached: 'limit_reached'
} as const;

export type SkillConflictReason = typeof SkillConflictReason[keyof typeof SkillConflictReason];


/**
 * The 409 body; clients switch on ``detail.reason``.
 * @export
 * @interface SkillConflictResponse
 */
export interface SkillConflictResponse {
    /**
     * 
     * @type {SkillConflictDetail}
     * @memberof SkillConflictResponse
     */
    'detail': SkillConflictDetail;
}
/**
 * Which Ask surface a skill runs in: ``meeting`` in the meeting drawer, ``cross_meeting`` in Ask Wispr.
 * @export
 * @enum {string}
 */

export const SkillContext = {
    Meeting: 'meeting',
    CrossMeeting: 'cross_meeting'
} as const;

export type SkillContext = typeof SkillContext[keyof typeof SkillContext];


/**
 * Who a team skill is shared with: the caller\'s department, or their whole company.
 * @export
 * @enum {string}
 */

export const SkillScope = {
    Department: 'department',
    Company: 'company'
} as const;

export type SkillScope = typeof SkillScope[keyof typeof SkillScope];


/**
 * Where a skill comes from.
 * @export
 * @enum {string}
 */

export const SkillSource = {
    Builtin: 'builtin',
    User: 'user',
    Team: 'team'
} as const;

export type SkillSource = typeof SkillSource[keyof typeof SkillSource];


/**
 * An extension omitted from a release\'s build output.
 * @export
 * @interface SkippedExtension
 */
export interface SkippedExtension {
    /**
     * 
     * @type {string}
     * @memberof SkippedExtension
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SkippedExtension
     */
    'reason': string;
}
/**
 * Self-serve plan and seat combinations.
 * @export
 * @enum {string}
 */

export const Sku = {
    TeamBundle: 'team_bundle',
    GrowthDictation: 'growth_dictation',
    GrowthBundle: 'growth_bundle',
    LegacyFlowForBusinessDictation: 'legacy_flow_for_business_dictation'
} as const;

export type Sku = typeof Sku[keyof typeof Sku];


/**
 * Counts for one prefetch entry; relevant means retained by selection_status.
 * @export
 * @interface SourceEvidence
 */
export interface SourceEvidence {
    /**
     * 
     * @type {string}
     * @memberof SourceEvidence
     */
    'status'?: SourceEvidenceStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SourceEvidence
     */
    'retrieved_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SourceEvidence
     */
    'relevant_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SourceEvidence
     */
    'recent_relevant_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SourceEvidence
     */
    'newest_evidence_age_seconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SourceEvidence
     */
    'truncated'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SourceEvidence
     */
    'selection_status'?: SourceEvidenceSelectionStatusEnum;
}

export const SourceEvidenceStatusEnum = {
    NotAttempted: 'not_attempted',
    Success: 'success',
    NotConnected: 'not_connected',
    PermissionDenied: 'permission_denied',
    EnterpriseDisabled: 'enterprise_disabled',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type SourceEvidenceStatusEnum = typeof SourceEvidenceStatusEnum[keyof typeof SourceEvidenceStatusEnum];
export const SourceEvidenceSelectionStatusEnum = {
    NotApplied: 'not_applied',
    Filtered: 'filtered',
    SmallPool: 'small_pool',
    PartialFailure: 'partial_failure',
    RecencyFallback: 'recency_fallback'
} as const;

export type SourceEvidenceSelectionStatusEnum = typeof SourceEvidenceSelectionStatusEnum[keyof typeof SourceEvidenceSelectionStatusEnum];

/**
 * One ``refined_id``\'s person slots in :attr:`SpeakerMap.assignments`.  Machine slots — ``dom`` (tile consensus), ``mic`` (reserved for the owner/mic channel), ``llm`` (post-summary LLM consensus) — are written only by the server, each mechanism rewriting only its own slot. ``consensus`` is the dual-written legacy ALIAS of the winning machine slot (``dom ?? mic ?? llm``) so pre-v2 clients keep resolving; a stored pre-v2 row carrying only ``consensus`` is normalized to ``dom`` at parse (the legacy slot was only ever written by the tile-consensus fold). ``user`` is written only from the client half of a sync-push composition. Resolution ladder: ``user > dom > mic > llm > consensus``. A merge is two ids\' user slots pointing at one person; an un-merge clears the user slot so resolution falls back to the machine slots.  ``voices`` is the server-written refine-time topology: the raw diarization voices the refine folded into this refined speaker, as namespaced keys over the provider\'s ``speaker`` labels in ``refined.raw.json`` — ``num:<n>`` for a positive integer label, ``label:<s>`` for a string (so ``1`` and ``\"1\"`` never collide). One key for a one-to-one chip, several when consensus merged voices; a row with only ``voices`` is a speaker no mechanism named. In segment mode one voice can be cut across several rows, so the lists are not disjoint. It describes the refine, not the current lines: a later manual reassignment moves entries without rewriting it. Clients never write it (a sync push keeps the server\'s value). The wire shape is the non-null array; a pre-field stored row omits it and parses as unknown (``[]``), and a ``null`` is tolerated at parse the same way rather than wedging the map.
 * @export
 * @interface SpeakerAssignment
 */
export interface SpeakerAssignment {
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'room'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'consensus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'user'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'mic'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'dom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAssignment
     */
    'llm'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpeakerAssignment
     */
    'voices'?: Array<string>;
}
/**
 * The recorded claim that supplied one machine slot during refinement.
 * @export
 * @interface SpeakerAttributionProvenance
 */
export interface SpeakerAttributionProvenance {
    /**
     * 
     * @type {number}
     * @memberof SpeakerAttributionProvenance
     */
    'canonical_id': number;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAttributionProvenance
     */
    'person_id': string;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAttributionProvenance
     */
    'slot': SpeakerAttributionProvenanceSlotEnum;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAttributionProvenance
     */
    'stage': SpeakerAttributionProvenanceStageEnum;
    /**
     * 
     * @type {string}
     * @memberof SpeakerAttributionProvenance
     */
    'via': SpeakerAttributionProvenanceViaEnum;
}

export const SpeakerAttributionProvenanceSlotEnum = {
    Dom: 'dom',
    Mic: 'mic'
} as const;

export type SpeakerAttributionProvenanceSlotEnum = typeof SpeakerAttributionProvenanceSlotEnum[keyof typeof SpeakerAttributionProvenanceSlotEnum];
export const SpeakerAttributionProvenanceStageEnum = {
    Assigner: 'assigner',
    GapFill: 'gap_fill',
    Relabeler: 'relabeler',
    ClassicalRescue: 'classical_rescue'
} as const;

export type SpeakerAttributionProvenanceStageEnum = typeof SpeakerAttributionProvenanceStageEnum[keyof typeof SpeakerAttributionProvenanceStageEnum];
export const SpeakerAttributionProvenanceViaEnum = {
    Time: 'time',
    Words: 'words',
    OnlyVoice: 'only_voice',
    ProviderMic: 'provider_mic',
    Contested: 'contested',
    Attendee: 'attendee',
    Paired: 'paired',
    Remaining: 'remaining',
    Relabel: 'relabel',
    Rescue: 'rescue'
} as const;

export type SpeakerAttributionProvenanceViaEnum = typeof SpeakerAttributionProvenanceViaEnum[keyof typeof SpeakerAttributionProvenanceViaEnum];

/**
 * The ``meetings.speaker_map`` blob (nullable JSONB on the meeting row).  ``people`` is keyed by person id (a plain uuid4 string, minted by whoever creates the person); ``assignments`` is keyed by ``refined_id`` (the transcript ``speaker.id``, serialized as a string key). ``rooms`` is the catalog of identified rooms; people and assignments store that id or null.
 * @export
 * @interface SpeakerMap
 */
export interface SpeakerMap {
    /**
     * 
     * @type {{ [key: string]: SpeakerPerson; }}
     * @memberof SpeakerMap
     */
    'people'?: { [key: string]: SpeakerPerson; };
    /**
     * 
     * @type {{ [key: string]: SpeakerAssignment; }}
     * @memberof SpeakerMap
     */
    'assignments'?: { [key: string]: SpeakerAssignment; };
    /**
     * 
     * @type {Array<SpeakerRoom>}
     * @memberof SpeakerMap
     */
    'rooms'?: Array<SpeakerRoom>;
}
/**
 * Request for a presigned S3 slot to upload a meeting\'s speaker-observation log.  Distinct from :class:`MeetingUploadUrlRequest`: NDJSON not audio, an 8 MiB cap not 500 MiB, and no ``context`` passthrough — this artifact carries observations the server reduces into canonical speakers, not refine/summary context.
 * @export
 * @interface SpeakerObservationsUploadUrlRequest
 */
export interface SpeakerObservationsUploadUrlRequest {
    /**
     * Observation-log MIME type; must be application/x-ndjson
     * @type {string}
     * @memberof SpeakerObservationsUploadUrlRequest
     */
    'content_type': string;
    /**
     * NDJSON body size in bytes
     * @type {number}
     * @memberof SpeakerObservationsUploadUrlRequest
     */
    'size_bytes': number;
}
/**
 * One person in :attr:`SpeakerMap.people`, keyed by a plain uuid4 string.  ``platform`` is immutable after mint; ``origin`` changes only via the calendar-merge upgrade (``platform`` → ``merged_cal_platform``) or the assignment promotion (``mention`` → ``user``); a rename (any origin, including a machine-minted person) changes only ``name``. ``origin=\"self\"`` represents the meeting owner (\"you\"). ``participantId`` is the server-derived stable calendar-attendee key — deliberately NOT an email (nothing PII-bearing rides the map) and NOT the ``calendar_participant`` row id (those rows are replaced on every calendar re-sync); present only on ``calendar`` / ``merged_cal_platform`` people. ``contactId`` is the UUID of the owner\'s contact row for this person, where ``participantId`` is keyed on one event and so differs per meeting. It is deliberately NOT the ``calendar_user`` row id and NOT the raw email (nothing PII-bearing rides the map). Owner-scoped — it identifies nobody outside the meeting owner\'s own rows — and nullable when no contact has been resolved for this map entry, so every reader needs a fallback.
 * @export
 * @interface SpeakerPerson
 */
export interface SpeakerPerson {
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'room'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SpeakerPerson
     */
    'roomVoice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'origin': SpeakerPersonOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'platform'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'participantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpeakerPerson
     */
    'contactId'?: string | null;
}

export const SpeakerPersonOriginEnum = {
    Platform: 'platform',
    Calendar: 'calendar',
    User: 'user',
    MergedCalPlatform: 'merged_cal_platform',
    Self: 'self',
    Llm: 'llm',
    Mention: 'mention'
} as const;

export type SpeakerPersonOriginEnum = typeof SpeakerPersonOriginEnum[keyof typeof SpeakerPersonOriginEnum];

/**
 * One identified room in :attr:`SpeakerMap.rooms`.
 * @export
 * @interface SpeakerRoom
 */
export interface SpeakerRoom {
    /**
     * Meeting-local room identity.
     * @type {string}
     * @memberof SpeakerRoom
     */
    'id': string;
    /**
     * User-editable room label; room identity remains meeting-local.
     * @type {string}
     * @memberof SpeakerRoom
     */
    'label': string;
}
/**
 * Client surface an event originated from.
 * @export
 * @enum {string}
 */

export const SrcBackendServiceSchemasApiClickhouseSource = {
    Desktop: 'desktop',
    Ios: 'ios',
    Web: 'web',
    Landing: 'landing'
} as const;

export type SrcBackendServiceSchemasApiClickhouseSource = typeof SrcBackendServiceSchemasApiClickhouseSource[keyof typeof SrcBackendServiceSchemasApiClickhouseSource];


/**
 * Valid platforms for direct download links.
 * @export
 * @enum {string}
 */

export const SrcBackendServiceSchemasApiReferralPlatform = {
    Ios: 'ios',
    MacApple: 'mac-apple',
    MacIntel: 'mac-intel',
    Windows: 'windows'
} as const;

export type SrcBackendServiceSchemasApiReferralPlatform = typeof SrcBackendServiceSchemasApiReferralPlatform[keyof typeof SrcBackendServiceSchemasApiReferralPlatform];


/**
 * Closed vocabulary of UI surfaces that trigger an LLM call.  Observability-only: never let a ``Source`` value influence routing, pricing, or attribution. Bounded so it\'s safe to use as a metric tag.
 * @export
 * @enum {string}
 */

export const SrcBackendServiceServicesLlmCostSource = {
    NotetakerChat: 'notetaker_chat',
    ScratchpadChat: 'scratchpad_chat',
    ScratchpadSuggestionPill: 'scratchpad_suggestion_pill',
    NotetakerSummary: 'notetaker_summary',
    NotetakerIdentity: 'notetaker_identity',
    NotetakerSummaryCandidate: 'notetaker_summary_candidate',
    NotetakerQuickSummary: 'notetaker_quick_summary',
    NotetakerFolderSuggestion: 'notetaker_folder_suggestion',
    NotetakerLiveNudges: 'notetaker_live_nudges',
    NotetakerEvaluation: 'notetaker_evaluation',
    MeetingTitle: 'meeting_title',
    WhatDidIMiss: 'what_did_i_miss',
    MakeMeSoundSmart: 'make_me_sound_smart',
    SuggestQuestions: 'suggest_questions',
    AgenticPreread: 'agentic_preread',
    MeetingReportTriage: 'meeting_report_triage',
    HistoryReplayJudge: 'history_replay_judge',
    TodoAutomation: 'todo_automation',
    MeetingRoomEvidence: 'meeting_room_evidence',
    PolishTransform: 'polish_transform',
    PromptEngineerTransform: 'prompt_engineer_transform',
    TurnToListTransform: 'turn_to_list_transform',
    TranslateToEnglishTransform: 'translate_to_english_transform',
    EmpathizeTransform: 'empathize_transform',
    CustomTransform: 'custom_transform',
    TranscriptRomanization: 'transcript_romanization',
    MeetingClassification: 'meeting_classification',
    MemoryCurator: 'memory_curator',
    MemoryDream: 'memory_dream',
    MemoryFill: 'memory_fill',
    MemoryTriage: 'memory_triage',
    Unknown: 'unknown'
} as const;

export type SrcBackendServiceServicesLlmCostSource = typeof SrcBackendServiceServicesLlmCostSource[keyof typeof SrcBackendServiceServicesLlmCostSource];


/**
 * Client platform.
 * @export
 * @enum {string}
 */

export const SrcCommonConstantsPlatform = {
    Desktop: 'desktop',
    Ios: 'ios',
    Android: 'android'
} as const;

export type SrcCommonConstantsPlatform = typeof SrcCommonConstantsPlatform[keyof typeof SrcCommonConstantsPlatform];


/**
 * One stage\'s bounded outcome, reason and wall time; never carries content.
 * @export
 * @interface StageReport
 */
export interface StageReport {
    /**
     * 
     * @type {string}
     * @memberof StageReport
     */
    'stage': StageReportStageEnum;
    /**
     * 
     * @type {string}
     * @memberof StageReport
     */
    'outcome': StageReportOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof StageReport
     */
    'reason'?: StageReportReasonEnum | null;
    /**
     * 
     * @type {number}
     * @memberof StageReport
     */
    'duration_ms': number;
    /**
     * 
     * @type {string}
     * @memberof StageReport
     */
    'variant'?: StageReportVariantEnum | null;
    /**
     * 
     * @type {string}
     * @memberof StageReport
     */
    'fallback_from'?: StageReportFallbackFromEnum | null;
}

export const StageReportStageEnum = {
    Evidence: 'evidence',
    Room: 'room',
    Cluster: 'cluster',
    Assign: 'assign',
    GapFill: 'gap_fill',
    ClassicalRescue: 'classical_rescue',
    Activate: 'activate',
    Unknown: 'unknown'
} as const;

export type StageReportStageEnum = typeof StageReportStageEnum[keyof typeof StageReportStageEnum];
export const StageReportOutcomeEnum = {
    Applied: 'applied',
    Degraded: 'degraded',
    Skipped: 'skipped',
    Failed: 'failed',
    Unknown: 'unknown'
} as const;

export type StageReportOutcomeEnum = typeof StageReportOutcomeEnum[keyof typeof StageReportOutcomeEnum];
export const StageReportReasonEnum = {
    Exception: 'exception',
    UpstreamNotApplied: 'upstream_not_applied',
    CalendarUnavailable: 'calendar_unavailable',
    AxReadError: 'ax_read_error',
    RoomNoTiles: 'room_no_tiles',
    RoomDisabled: 'room_disabled',
    RoomNotNeeded: 'room_not_needed',
    RoomCalendarRequired: 'room_calendar_required',
    RoomFailed: 'room_failed',
    RoomTimeout: 'room_timeout',
    NoEvidence: 'no_evidence',
    EmptyIntervals: 'empty_intervals',
    FoldBudget: 'fold_budget',
    ArtifactCorrupt: 'artifact_corrupt',
    SegmentWorkCap: 'segment_work_cap',
    SegmentUnitCeiling: 'segment_unit_ceiling',
    SegmentError: 'segment_error',
    NoClusterEvidence: 'no_cluster_evidence',
    RelabelerScored: 'relabeler_scored',
    RelabelerShadow: 'relabeler_shadow',
    RelabelerDisabled: 'relabeler_disabled',
    RelabelerIneligible: 'relabeler_ineligible',
    RelabelerFailed: 'relabeler_failed',
    RelabelerTimeout: 'relabeler_timeout',
    RelabelerTooLarge: 'relabeler_too_large',
    RelabelerNoJoin: 'relabeler_no_join',
    RescueNotEnrolled: 'rescue_not_enrolled',
    RescueNoAdmission: 'rescue_no_admission',
    RescueInputAlignment: 'rescue_input_alignment',
    RescueInvalidCanonicalId: 'rescue_invalid_canonical_id',
    RescueFeatureCap: 'rescue_feature_cap',
    RescueProjectionScopeRollback: 'rescue_projection_scope_rollback',
    RescueUnsupported: 'rescue_unsupported',
    RescueTimeout: 'rescue_timeout',
    RescueFailed: 'rescue_failed',
    SiblingRevisionActive: 'sibling_revision_active',
    Superseded: 'superseded',
    MeetingDeleted: 'meeting_deleted',
    Unknown: 'unknown'
} as const;

export type StageReportReasonEnum = typeof StageReportReasonEnum[keyof typeof StageReportReasonEnum];
export const StageReportVariantEnum = {
    Segment: 'segment',
    Cluster: 'cluster',
    Classical: 'classical',
    GradientBoost: 'gradient_boost',
    Rescue: 'rescue',
    Unknown: 'unknown'
} as const;

export type StageReportVariantEnum = typeof StageReportVariantEnum[keyof typeof StageReportVariantEnum];
export const StageReportFallbackFromEnum = {
    Segment: 'segment',
    Cluster: 'cluster',
    Classical: 'classical',
    GradientBoost: 'gradient_boost',
    Rescue: 'rescue',
    Unknown: 'unknown'
} as const;

export type StageReportFallbackFromEnum = typeof StageReportFallbackFromEnum[keyof typeof StageReportFallbackFromEnum];

/**
 * Desktop client sends a pre-aggregated correction delta for backfilling user_stats.
 * @export
 * @interface StatsBackfillRequest
 */
export interface StatsBackfillRequest {
    /**
     * 
     * @type {number}
     * @memberof StatsBackfillRequest
     */
    'desktop_words_corrected_delta': number;
}
/**
 * Logical Flow plan identifiers, mode-independent (resolved to Stripe ids at lookup).
 * @export
 * @enum {string}
 */

export const StripeProductOption = {
    FlowProMonthly: 'FLOW_PRO_MONTHLY',
    FlowProYearly: 'FLOW_PRO_YEARLY',
    FlowStudentMonthly: 'FLOW_STUDENT_MONTHLY',
    FlowStudentYearly: 'FLOW_STUDENT_YEARLY',
    FlowTeamMonthly: 'FLOW_TEAM_MONTHLY',
    FlowTeamYearly: 'FLOW_TEAM_YEARLY',
    FlowBusinessMonthly: 'FLOW_BUSINESS_MONTHLY',
    FlowBusinessYearly: 'FLOW_BUSINESS_YEARLY'
} as const;

export type StripeProductOption = typeof StripeProductOption[keyof typeof StripeProductOption];


/**
 * One entry in the student-challenge referral leaderboard.
 * @export
 * @interface StudentChallengeLeaderboardMember
 */
export interface StudentChallengeLeaderboardMember {
    /**
     * 
     * @type {string}
     * @memberof StudentChallengeLeaderboardMember
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudentChallengeLeaderboardMember
     */
    'last_initial'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StudentChallengeLeaderboardMember
     */
    'referral_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof StudentChallengeLeaderboardMember
     */
    'is_current_user': boolean;
}
/**
 * The student-challenge referral leaderboard.
 * @export
 * @interface StudentChallengeLeaderboardResponse
 */
export interface StudentChallengeLeaderboardResponse {
    /**
     * 
     * @type {Array<StudentChallengeLeaderboardMember>}
     * @memberof StudentChallengeLeaderboardResponse
     */
    'members': Array<StudentChallengeLeaderboardMember>;
}
/**
 * Request body carrying the user\'s onboarding answers and fulfilled intents.
 * @export
 * @interface SubmitOnboardingAnswersRequest
 */
export interface SubmitOnboardingAnswersRequest {
    /**
     * 
     * @type {{ [key: string]: AnswersValue; }}
     * @memberof SubmitOnboardingAnswersRequest
     */
    'answers': { [key: string]: AnswersValue; };
    /**
     * 
     * @type {Array<OnboardingIntent>}
     * @memberof SubmitOnboardingAnswersRequest
     */
    'fulfilled_intents'?: Array<OnboardingIntent>;
}
/**
 * Request schema for POST /typing-test/submit-score.
 * @export
 * @interface SubmitScoreRequest
 */
export interface SubmitScoreRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitScoreRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubmitScoreRequest
     */
    'display_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreRequest
     */
    'passage_id': number;
    /**
     * 
     * @type {string}
     * @memberof SubmitScoreRequest
     */
    'typed_text': string;
    /**
     * 
     * @type {Array<Keystroke>}
     * @memberof SubmitScoreRequest
     */
    'keystrokes': Array<Keystroke>;
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreRequest
     */
    'voice_wpm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreRequest
     */
    'voice_accuracy'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubmitScoreRequest
     */
    'limit'?: number;
}
/**
 * Rendered subscription state mirroring ``stripe_service.get_subscription_details``.  The fat ``subscription.changed`` event carries this so the client applies it directly — no follow-up ``GET /payment/subscription`` and therefore no replica-lag race. The producer builds it from the same read path as that endpoint but on the writer session (read-your-writes); see ``services/sync_ws/subscription_publisher.py``.  ``get_subscription_details`` returns a loosely-typed dict whose keys vary by branch (personal / enterprise / mobile / trial / none). The always-present keys are typed here; branch-conditional keys (``cancel_at``, ``past_due_at``, ``most_recent_enterprise_id``, ``team_domain_status``) are optional. ``extra`` is permitted so the payload stays a forward-compatible superset of the GET response: a new field added to that dict reaches the client without a schema bump, and the client ignores keys it doesn\'t know.
 * @export
 * @interface SubscriptionPayload
 */
export interface SubscriptionPayload {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'plan': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'growth_plan_variant'?: SubscriptionPayloadGrowthPlanVariantEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'is_subscribed': boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'source_of_subscription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'store'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'renews_at'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'trial_ends_at'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'credits'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'is_student'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'total_trial_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'cancel_at'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'cancel_at_period_end'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'past_due_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'most_recent_enterprise_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPayload
     */
    'team_domain_status'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'skip_default_trial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'team_trial_given'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'desktop_trial_given'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPayload
     */
    'mobile_trial_given'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'trial_extension_days_claimed'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'bonus_ends_at'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPayload
     */
    'grace_period_ends_at'?: number | null;
}

export const SubscriptionPayloadGrowthPlanVariantEnum = {
    Bundle: 'bundle',
    DictationOnly: 'dictation_only'
} as const;

export type SubscriptionPayloadGrowthPlanVariantEnum = typeof SubscriptionPayloadGrowthPlanVariantEnum[keyof typeof SubscriptionPayloadGrowthPlanVariantEnum];

/**
 * Response from ``POST /api/v1/payment/subscription-watch/start``.
 * @export
 * @interface SubscriptionWatchStartResponse
 */
export interface SubscriptionWatchStartResponse {
    /**
     * Opaque token; send as ``X-Billing-Watch-Token`` on the SSE stream.
     * @type {string}
     * @memberof SubscriptionWatchStartResponse
     */
    'watch_token': string;
    /**
     * UTC wall-clock time when the watch session ends.
     * @type {string}
     * @memberof SubscriptionWatchStartResponse
     */
    'expires_at': string;
}
/**
 * Estimated spend of one experiment candidate model in one bucket.
 * @export
 * @interface SummaryCandidateCost
 */
export interface SummaryCandidateCost {
    /**
     * 
     * @type {string}
     * @memberof SummaryCandidateCost
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryCandidateCost
     */
    'usd': number | null;
    /**
     * Runs that recorded token usage.
     * @type {number}
     * @memberof SummaryCandidateCost
     */
    'runs': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryCandidateCost
     */
    'usdPerSummary': number | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryCandidateCost
     */
    'start': string;
}
/**
 * Bounded children for a supported main-database dimension.
 * @export
 * @interface SummaryChipCohorts
 */
export interface SummaryChipCohorts {
    /**
     * 
     * @type {string}
     * @memberof SummaryChipCohorts
     */
    'status'?: SummaryChipCohortsStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipCohorts
     */
    'unsupported_dimensions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipCohorts
     */
    'supported_dimensions'?: Array<SummaryChipCohortsSupportedDimensionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof SummaryChipCohorts
     */
    'population'?: SummaryChipCohortsPopulationEnum;
    /**
     * 
     * @type {Array<SummaryChipGroup>}
     * @memberof SummaryChipCohorts
     */
    'groups'?: Array<SummaryChipGroup>;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryChipCohorts
     */
    'truncated'?: boolean;
}

export const SummaryChipCohortsStatusEnum = {
    Available: 'available',
    Unsupported: 'unsupported'
} as const;

export type SummaryChipCohortsStatusEnum = typeof SummaryChipCohortsStatusEnum[keyof typeof SummaryChipCohortsStatusEnum];
export const SummaryChipCohortsSupportedDimensionsEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type SummaryChipCohortsSupportedDimensionsEnum = typeof SummaryChipCohortsSupportedDimensionsEnum[keyof typeof SummaryChipCohortsSupportedDimensionsEnum];
export const SummaryChipCohortsPopulationEnum = {
    ConsentedIndividualPublishedMeetings: 'consented_individual_published_meetings'
} as const;

export type SummaryChipCohortsPopulationEnum = typeof SummaryChipCohortsPopulationEnum[keyof typeof SummaryChipCohortsPopulationEnum];

/**
 * One physical cohort\'s weighted counts.
 * @export
 * @interface SummaryChipGroup
 */
export interface SummaryChipGroup {
    /**
     * 
     * @type {string}
     * @memberof SummaryChipGroup
     */
    'value': string;
    /**
     * 
     * @type {SummaryChipSummary}
     * @memberof SummaryChipGroup
     */
    'summary': SummaryChipSummary;
}
/**
 * The largest supported cohorts, ranked by publication count.
 * @export
 * @interface SummaryChipGroupedTrend
 */
export interface SummaryChipGroupedTrend {
    /**
     * 
     * @type {string}
     * @memberof SummaryChipGroupedTrend
     */
    'status'?: SummaryChipGroupedTrendStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipGroupedTrend
     */
    'unsupported_dimensions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipGroupedTrend
     */
    'supported_dimensions'?: Array<SummaryChipGroupedTrendSupportedDimensionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof SummaryChipGroupedTrend
     */
    'population'?: SummaryChipGroupedTrendPopulationEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipGroupedTrend
     */
    'group_by': Array<SummaryChipGroupedTrendGroupByEnum>;
    /**
     * 
     * @type {Array<SummaryChipTrendGroup>}
     * @memberof SummaryChipGroupedTrend
     */
    'groups'?: Array<SummaryChipTrendGroup>;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryChipGroupedTrend
     */
    'truncated'?: boolean;
}

export const SummaryChipGroupedTrendStatusEnum = {
    Available: 'available',
    Unsupported: 'unsupported'
} as const;

export type SummaryChipGroupedTrendStatusEnum = typeof SummaryChipGroupedTrendStatusEnum[keyof typeof SummaryChipGroupedTrendStatusEnum];
export const SummaryChipGroupedTrendSupportedDimensionsEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type SummaryChipGroupedTrendSupportedDimensionsEnum = typeof SummaryChipGroupedTrendSupportedDimensionsEnum[keyof typeof SummaryChipGroupedTrendSupportedDimensionsEnum];
export const SummaryChipGroupedTrendPopulationEnum = {
    ConsentedIndividualPublishedMeetings: 'consented_individual_published_meetings'
} as const;

export type SummaryChipGroupedTrendPopulationEnum = typeof SummaryChipGroupedTrendPopulationEnum[keyof typeof SummaryChipGroupedTrendPopulationEnum];
export const SummaryChipGroupedTrendGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type SummaryChipGroupedTrendGroupByEnum = typeof SummaryChipGroupedTrendGroupByEnum[keyof typeof SummaryChipGroupedTrendGroupByEnum];

/**
 * Summary-chip measurements from the main database reader.
 * @export
 * @interface SummaryChipOverview
 */
export interface SummaryChipOverview {
    /**
     * 
     * @type {string}
     * @memberof SummaryChipOverview
     */
    'status'?: SummaryChipOverviewStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipOverview
     */
    'unsupported_dimensions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SummaryChipOverview
     */
    'supported_dimensions'?: Array<SummaryChipOverviewSupportedDimensionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof SummaryChipOverview
     */
    'population'?: SummaryChipOverviewPopulationEnum;
    /**
     * 
     * @type {SummaryChipSummary}
     * @memberof SummaryChipOverview
     */
    'summary'?: SummaryChipSummary;
    /**
     * 
     * @type {Array<SummaryChipTrendPoint>}
     * @memberof SummaryChipOverview
     */
    'trend'?: Array<SummaryChipTrendPoint>;
}

export const SummaryChipOverviewStatusEnum = {
    Available: 'available',
    Unsupported: 'unsupported'
} as const;

export type SummaryChipOverviewStatusEnum = typeof SummaryChipOverviewStatusEnum[keyof typeof SummaryChipOverviewStatusEnum];
export const SummaryChipOverviewSupportedDimensionsEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;

export type SummaryChipOverviewSupportedDimensionsEnum = typeof SummaryChipOverviewSupportedDimensionsEnum[keyof typeof SummaryChipOverviewSupportedDimensionsEnum];
export const SummaryChipOverviewPopulationEnum = {
    ConsentedIndividualPublishedMeetings: 'consented_individual_published_meetings'
} as const;

export type SummaryChipOverviewPopulationEnum = typeof SummaryChipOverviewPopulationEnum[keyof typeof SummaryChipOverviewPopulationEnum];

/**
 * Occurrence-weighted counts and their independently measured publication population.
 * @export
 * @interface SummaryChipSummary
 */
export interface SummaryChipSummary {
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'meeting_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'measured_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'eligible_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'zero_chip_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'unmeasured_meetings'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'speaker_chip_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof SummaryChipSummary
     */
    'named_speaker_chip_count'?: number;
}
/**
 * A physical cohort and its daily measurements.
 * @export
 * @interface SummaryChipTrendGroup
 */
export interface SummaryChipTrendGroup {
    /**
     * 
     * @type {Array<ObservationTrendPathItem>}
     * @memberof SummaryChipTrendGroup
     */
    'path': Array<ObservationTrendPathItem>;
    /**
     * 
     * @type {Array<SummaryChipTrendPoint>}
     * @memberof SummaryChipTrendGroup
     */
    'trend': Array<SummaryChipTrendPoint>;
}
/**
 * Daily UTC meeting-date aggregates.
 * @export
 * @interface SummaryChipTrendPoint
 */
export interface SummaryChipTrendPoint {
    /**
     * 
     * @type {string}
     * @memberof SummaryChipTrendPoint
     */
    'date': string;
    /**
     * 
     * @type {SummaryChipSummary}
     * @memberof SummaryChipTrendPoint
     */
    'summary': SummaryChipSummary;
}
/**
 * Spend estimated from recorded tokens, pricing every cache write at the 5-minute rate.
 * @export
 * @interface SummaryCost
 */
export interface SummaryCost {
    /**
     * Priced serving runs only.
     * @type {number}
     * @memberof SummaryCost
     */
    'overallUsd': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryCost
     */
    'usdPerSummary': number | null;
    /**
     * Serving runs that recorded tokens on a model with no price.
     * @type {number}
     * @memberof SummaryCost
     */
    'unpricedRuns': number;
    /**
     * Serving runs, only buckets with runs, oldest first.
     * @type {Array<SummaryCostBucket>}
     * @memberof SummaryCost
     */
    'buckets': Array<SummaryCostBucket>;
    /**
     * Most-run (prompt version, model) pair first, over the whole window: ignores the version filters.
     * @type {Array<SummaryCostVersion>}
     * @memberof SummaryCost
     */
    'byVersion': Array<SummaryCostVersion>;
    /**
     * Experiment candidate summaries, bucketed by when the comparison was captured, oldest first. Ignores the version filters.
     * @type {Array<SummaryCandidateCost>}
     * @memberof SummaryCost
     */
    'candidates': Array<SummaryCandidateCost>;
}
/**
 * Estimated spend per model in one UTC day, or one ISO week starting Monday.
 * @export
 * @interface SummaryCostBucket
 */
export interface SummaryCostBucket {
    /**
     * 
     * @type {string}
     * @memberof SummaryCostBucket
     */
    'start': string;
    /**
     * Most-run model first.
     * @type {Array<SummaryModelCost>}
     * @memberof SummaryCostBucket
     */
    'byModel': Array<SummaryModelCost>;
}
/**
 * Estimated spend of one prompt version on one model.
 * @export
 * @interface SummaryCostVersion
 */
export interface SummaryCostVersion {
    /**
     * 
     * @type {string}
     * @memberof SummaryCostVersion
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryCostVersion
     */
    'usd': number | null;
    /**
     * Runs that recorded token usage.
     * @type {number}
     * @memberof SummaryCostVersion
     */
    'runs': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryCostVersion
     */
    'usdPerSummary': number | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryCostVersion
     */
    'promptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryCostVersion
     */
    'promptLabel': string | null;
}
/**
 * A short-lived presigned GET for the rated meeting\'s audio.
 * @export
 * @interface SummaryFeedbackAdminAudioUrl
 */
export interface SummaryFeedbackAdminAudioUrl {
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminAudioUrl
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminAudioUrl
     */
    'expiresAt': string;
}
/**
 * One summary rating as internal admins see it. Customer Data is null whenever it is withheld.
 * @export
 * @interface SummaryFeedbackAdminDetail
 */
export interface SummaryFeedbackAdminDetail {
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'meetingId': string;
    /**
     * 
     * @type {SummaryFeedbackRating}
     * @memberof SummaryFeedbackAdminDetail
     */
    'rating': SummaryFeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'feedback': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'clearedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'reporterEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryFeedbackAdminDetail
     */
    'reporterIsInternal': boolean;
    /**
     * 
     * @type {ConsentBasis}
     * @memberof SummaryFeedbackAdminDetail
     */
    'consentBasis': ConsentBasis;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summarySha256': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'clientSummarySha256': string | null;
    /**
     * The client reported rating a different summary than the server stored.
     * @type {boolean}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summaryDrift': boolean;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summaryModel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summaryPromptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'promptLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summaryBody': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'summaryWithheldReason': SummaryFeedbackAdminDetailSummaryWithheldReasonEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryFeedbackAdminDetail
     */
    'meetingDeleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'audioStatus': SummaryFeedbackAdminDetailAudioStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'audioExpiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminDetail
     */
    'viewerMeetingId': string | null;
}

export const SummaryFeedbackAdminDetailSummaryWithheldReasonEnum = {
    NoConsent: 'no_consent',
    MeetingDeleted: 'meeting_deleted',
    NotStored: 'not_stored'
} as const;

export type SummaryFeedbackAdminDetailSummaryWithheldReasonEnum = typeof SummaryFeedbackAdminDetailSummaryWithheldReasonEnum[keyof typeof SummaryFeedbackAdminDetailSummaryWithheldReasonEnum];
export const SummaryFeedbackAdminDetailAudioStatusEnum = {
    Available: 'available',
    Expired: 'expired',
    Withheld: 'withheld',
    Absent: 'absent'
} as const;

export type SummaryFeedbackAdminDetailAudioStatusEnum = typeof SummaryFeedbackAdminDetailAudioStatusEnum[keyof typeof SummaryFeedbackAdminDetailAudioStatusEnum];

/**
 * One page of summary ratings, newest first.
 * @export
 * @interface SummaryFeedbackAdminList
 */
export interface SummaryFeedbackAdminList {
    /**
     * 
     * @type {Array<SummaryFeedbackAdminListItem>}
     * @memberof SummaryFeedbackAdminList
     */
    'items': Array<SummaryFeedbackAdminListItem>;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminList
     */
    'nextCursor': string | null;
    /**
     * Ratings matching the filters across every page.
     * @type {number}
     * @memberof SummaryFeedbackAdminList
     */
    'total': number;
}
/**
 * One summary rating in the admin index; carries no summary, audio key, or hash.
 * @export
 * @interface SummaryFeedbackAdminListItem
 */
export interface SummaryFeedbackAdminListItem {
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'meetingId': string;
    /**
     * 
     * @type {SummaryFeedbackRating}
     * @memberof SummaryFeedbackAdminListItem
     */
    'rating': SummaryFeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'submittedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'clearedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'reporterEmail': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryFeedbackAdminListItem
     */
    'reporterIsInternal': boolean;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'feedbackPreview': string | null;
    /**
     * 
     * @type {ConsentBasis}
     * @memberof SummaryFeedbackAdminListItem
     */
    'consentBasis': ConsentBasis;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'summaryPromptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'promptLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackAdminListItem
     */
    'summaryModel': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryFeedbackAdminListItem
     */
    'hasSummarySnapshot': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SummaryFeedbackAdminListItem
     */
    'meetingDeleted': boolean;
    /**
     * The same user rated this meeting again later.
     * @type {boolean}
     * @memberof SummaryFeedbackAdminListItem
     */
    'isSuperseded': boolean;
}


/**
 * Summary-rating rates over a window, overall, per time bucket, per prompt version, and per prompt and model.  Counts include internal (Wispr) users\' ratings.
 * @export
 * @interface SummaryFeedbackAdminStats
 */
export interface SummaryFeedbackAdminStats {
    /**
     * 
     * @type {SummaryFeedbackRateCounts}
     * @memberof SummaryFeedbackAdminStats
     */
    'overall': SummaryFeedbackRateCounts;
    /**
     * Only buckets with ratings, oldest first. When `since` or `until` falls inside a bucket, that edge bucket counts only the part of it within the window.
     * @type {Array<SummaryFeedbackStatsBucketCounts>}
     * @memberof SummaryFeedbackAdminStats
     */
    'buckets': Array<SummaryFeedbackStatsBucketCounts>;
    /**
     * Most-rated prompt version first.
     * @type {Array<SummaryFeedbackPromptCounts>}
     * @memberof SummaryFeedbackAdminStats
     */
    'byPrompt': Array<SummaryFeedbackPromptCounts>;
    /**
     * Most-rated (prompt version, model) pair first, over the whole window: ignores the version filters.
     * @type {Array<SummaryFeedbackVersionCounts>}
     * @memberof SummaryFeedbackAdminStats
     */
    'byVersion': Array<SummaryFeedbackVersionCounts>;
}
/**
 * Counts for summaries written by one prompt version.
 * @export
 * @interface SummaryFeedbackPromptCounts
 */
export interface SummaryFeedbackPromptCounts {
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackPromptCounts
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackPromptCounts
     */
    'down': number;
    /**
     * Distinct meetings among the counted ratings.
     * @type {number}
     * @memberof SummaryFeedbackPromptCounts
     */
    'meetings': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackPromptCounts
     */
    'promptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackPromptCounts
     */
    'promptLabel': string | null;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof SummaryFeedbackPromptCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackPromptCounts
     */
    'pctUp': number | null;
}
/**
 * Current 👍/👎 counts: each user\'s latest, unwithdrawn rating per meeting.
 * @export
 * @interface SummaryFeedbackRateCounts
 */
export interface SummaryFeedbackRateCounts {
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackRateCounts
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackRateCounts
     */
    'down': number;
    /**
     * Distinct meetings among the counted ratings.
     * @type {number}
     * @memberof SummaryFeedbackRateCounts
     */
    'meetings': number;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof SummaryFeedbackRateCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackRateCounts
     */
    'pctUp': number | null;
}
/**
 * The two ratings the summary thumbs control can submit.
 * @export
 * @enum {string}
 */

export const SummaryFeedbackRating = {
    Up: 'up',
    Down: 'down'
} as const;

export type SummaryFeedbackRating = typeof SummaryFeedbackRating[keyof typeof SummaryFeedbackRating];


/**
 * Counts for one UTC day, or one ISO week starting Monday.
 * @export
 * @interface SummaryFeedbackStatsBucketCounts
 */
export interface SummaryFeedbackStatsBucketCounts {
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'down': number;
    /**
     * Distinct meetings among the counted ratings.
     * @type {number}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'meetings': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'start': string;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackStatsBucketCounts
     */
    'pctUp': number | null;
}
/**
 * Counts for summaries written by one prompt version on one model.
 * @export
 * @interface SummaryFeedbackVersionCounts
 */
export interface SummaryFeedbackVersionCounts {
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackVersionCounts
     */
    'up': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackVersionCounts
     */
    'down': number;
    /**
     * Distinct meetings among the counted ratings.
     * @type {number}
     * @memberof SummaryFeedbackVersionCounts
     */
    'meetings': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackVersionCounts
     */
    'promptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackVersionCounts
     */
    'promptLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryFeedbackVersionCounts
     */
    'model': string | null;
    /**
     * Ratings counted.
     * @type {number}
     * @memberof SummaryFeedbackVersionCounts
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryFeedbackVersionCounts
     */
    'pctUp': number | null;
}
/**
 * Model-call latency of completed summary runs; runs from before it was recorded, or scrubbed since, are left out.
 * @export
 * @interface SummaryLatency
 */
export interface SummaryLatency {
    /**
     * 
     * @type {SummaryLatencyPercentiles}
     * @memberof SummaryLatency
     */
    'overall': SummaryLatencyPercentiles;
    /**
     * Only buckets with measured runs, oldest first.
     * @type {Array<SummaryLatencyBucket>}
     * @memberof SummaryLatency
     */
    'buckets': Array<SummaryLatencyBucket>;
    /**
     * Most-run (prompt version, model) pair first, over the whole window: ignores the version filters.
     * @type {Array<SummaryLatencyVersion>}
     * @memberof SummaryLatency
     */
    'byVersion': Array<SummaryLatencyVersion>;
}
/**
 * Latency percentiles for one UTC day, or one ISO week starting Monday.
 * @export
 * @interface SummaryLatencyBucket
 */
export interface SummaryLatencyBucket {
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyBucket
     */
    'p50': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyBucket
     */
    'p95': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyBucket
     */
    'p99': number | null;
    /**
     * Runs that recorded a latency, the population of the percentiles.
     * @type {number}
     * @memberof SummaryLatencyBucket
     */
    'measured': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryLatencyBucket
     */
    'start': string;
}
/**
 * Milliseconds one successful summary-model call took; null when no run in the group measured it.
 * @export
 * @interface SummaryLatencyPercentiles
 */
export interface SummaryLatencyPercentiles {
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyPercentiles
     */
    'p50': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyPercentiles
     */
    'p95': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyPercentiles
     */
    'p99': number | null;
    /**
     * Runs that recorded a latency, the population of the percentiles.
     * @type {number}
     * @memberof SummaryLatencyPercentiles
     */
    'measured': number;
}
/**
 * Latency percentiles for one prompt version on one model.
 * @export
 * @interface SummaryLatencyVersion
 */
export interface SummaryLatencyVersion {
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyVersion
     */
    'p50': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyVersion
     */
    'p95': number | null;
    /**
     * 
     * @type {number}
     * @memberof SummaryLatencyVersion
     */
    'p99': number | null;
    /**
     * Runs that recorded a latency, the population of the percentiles.
     * @type {number}
     * @memberof SummaryLatencyVersion
     */
    'measured': number;
    /**
     * 
     * @type {string}
     * @memberof SummaryLatencyVersion
     */
    'promptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryLatencyVersion
     */
    'promptLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryLatencyVersion
     */
    'model': string;
}
/**
 * Estimated spend of one model\'s runs.
 * @export
 * @interface SummaryModelCost
 */
export interface SummaryModelCost {
    /**
     * 
     * @type {string}
     * @memberof SummaryModelCost
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryModelCost
     */
    'usd': number | null;
    /**
     * Runs that recorded token usage.
     * @type {number}
     * @memberof SummaryModelCost
     */
    'runs': number;
    /**
     * 
     * @type {number}
     * @memberof SummaryModelCost
     */
    'usdPerSummary': number | null;
}
/**
 * Completed serving summary runs in a window: volume, model latency and estimated cost.  Runs are counted by when their summary phase was claimed and include internal (Wispr) users.
 * @export
 * @interface SummaryQualityStats
 */
export interface SummaryQualityStats {
    /**
     * 
     * @type {SummaryRunCounts}
     * @memberof SummaryQualityStats
     */
    'summaries': SummaryRunCounts;
    /**
     * 
     * @type {SummaryLatency}
     * @memberof SummaryQualityStats
     */
    'latency': SummaryLatency;
    /**
     * 
     * @type {SummaryCost}
     * @memberof SummaryQualityStats
     */
    'cost': SummaryCost;
}
/**
 * Completed summary runs in one UTC day, or one ISO week starting Monday.
 * @export
 * @interface SummaryRunBucket
 */
export interface SummaryRunBucket {
    /**
     * 
     * @type {string}
     * @memberof SummaryRunBucket
     */
    'start': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryRunBucket
     */
    'count': number;
}
/**
 * Every completed serving summary run, re-runs included.
 * @export
 * @interface SummaryRunCounts
 */
export interface SummaryRunCounts {
    /**
     * 
     * @type {number}
     * @memberof SummaryRunCounts
     */
    'overall': number;
    /**
     * Only buckets with runs, oldest first.
     * @type {Array<SummaryRunBucket>}
     * @memberof SummaryRunCounts
     */
    'buckets': Array<SummaryRunBucket>;
    /**
     * Most-run (prompt version, model) pair first, over the whole window: ignores the version filters.
     * @type {Array<SummaryRunVersion>}
     * @memberof SummaryRunCounts
     */
    'byVersion': Array<SummaryRunVersion>;
}
/**
 * Completed summary runs written by one prompt version on one model.
 * @export
 * @interface SummaryRunVersion
 */
export interface SummaryRunVersion {
    /**
     * 
     * @type {string}
     * @memberof SummaryRunVersion
     */
    'promptVersion': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryRunVersion
     */
    'promptLabel': string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryRunVersion
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof SummaryRunVersion
     */
    'count': number;
}
/**
 * Feedback submitted by an authenticated user, optionally with an attached image.
 * @export
 * @interface SupportFeedbackRequest
 */
export interface SupportFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportFeedbackRequest
     */
    'to': string;
    /**
     * 
     * @type {string}
     * @memberof SupportFeedbackRequest
     */
    'body': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SupportFeedbackRequest
     */
    'attachments'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {string}
     * @memberof SupportFeedbackRequest
     */
    'subject'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportFeedbackRequest
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportFeedbackRequest
     */
    'imageData'?: string | null;
    /**
     * 
     * @type {ImageType}
     * @memberof SupportFeedbackRequest
     */
    'imageType'?: ImageType | null;
    /**
     * 
     * @type {SrcCommonConstantsPlatform}
     * @memberof SupportFeedbackRequest
     */
    'platform'?: SrcCommonConstantsPlatform;
}


/**
 * Request model for the enterprise plan switch, with the Business purchase option.
 * @export
 * @interface SwitchEnterprisePlanRequest
 */
export interface SwitchEnterprisePlanRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchEnterprisePlanRequest
     */
    'plan': string;
    /**
     * 
     * @type {string}
     * @memberof SwitchEnterprisePlanRequest
     */
    'variant'?: SwitchEnterprisePlanRequestVariantEnum | null;
    /**
     * True when the admin accepted the MSA and DPA for a Growth (variant) switch.
     * @type {boolean}
     * @memberof SwitchEnterprisePlanRequest
     */
    'accepted_terms'?: boolean;
}

export const SwitchEnterprisePlanRequestVariantEnum = {
    Bundle: 'bundle',
    DictationOnly: 'dictation_only'
} as const;

export type SwitchEnterprisePlanRequestVariantEnum = typeof SwitchEnterprisePlanRequestVariantEnum[keyof typeof SwitchEnterprisePlanRequestVariantEnum];

/**
 * Request model for switching enterprise plans.
 * @export
 * @interface SwitchPlanRequest
 */
export interface SwitchPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof SwitchPlanRequest
     */
    'plan': string;
}
/**
 * Response from ``GET /api/v1/sync/check``.
 * @export
 * @interface SyncCheckResponse
 */
export interface SyncCheckResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncCheckResponse
     */
    'changed': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncCheckResponse
     */
    'unchanged': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SyncCheckResponse
     */
    'timestamps': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SyncCheckResponse
     */
    'client_region': SyncCheckResponseClientRegionEnum;
    /**
     * 
     * @type {IncidentStatusDetail}
     * @memberof SyncCheckResponse
     */
    'incident_status'?: IncidentStatusDetail | null;
}

export const SyncCheckResponseClientRegionEnum = {
    Us: 'us',
    Europe: 'europe',
    Apac: 'apac'
} as const;

export type SyncCheckResponseClientRegionEnum = typeof SyncCheckResponseClientRegionEnum[keyof typeof SyncCheckResponseClientRegionEnum];

/**
 * Client acknowledges receipt up to ``seq``.  Server uses for stream trimming heuristics.
 * @export
 * @interface SyncClientAck
 */
export interface SyncClientAck {
    /**
     * 
     * @type {string}
     * @memberof SyncClientAck
     */
    'type': SyncClientAckTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncClientAck
     */
    'seq': number;
}

export const SyncClientAckTypeEnum = {
    Ack: 'ack'
} as const;

export type SyncClientAckTypeEnum = typeof SyncClientAckTypeEnum[keyof typeof SyncClientAckTypeEnum];

/**
 * Wrapper for the client-frame union — same OpenAPI surfacing trick.
 * @export
 * @interface SyncClientFrameEnvelope
 */
export interface SyncClientFrameEnvelope {
    /**
     * 
     * @type {SyncFrame}
     * @memberof SyncClientFrameEnvelope
     */
    'sync_frame': SyncFrame;
}
/**
 * Client liveness probe; server replies with the next heartbeat.
 * @export
 * @interface SyncClientPing
 */
export interface SyncClientPing {
    /**
     * 
     * @type {string}
     * @memberof SyncClientPing
     */
    'type': SyncClientPingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SyncClientPing
     */
    'ts': string;
}

export const SyncClientPingTypeEnum = {
    Ping: 'ping'
} as const;

export type SyncClientPingTypeEnum = typeof SyncClientPingTypeEnum[keyof typeof SyncClientPingTypeEnum];

/**
 * First frame after the WS upgrade.  Establishes the subscription and optionally resumes from ``since`` (the client\'s last delivered sequence; omitted on a cold start).
 * @export
 * @interface SyncClientSubscribe
 */
export interface SyncClientSubscribe {
    /**
     * 
     * @type {string}
     * @memberof SyncClientSubscribe
     */
    'type': SyncClientSubscribeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncClientSubscribe
     */
    'since'?: number | null;
}

export const SyncClientSubscribeTypeEnum = {
    Subscribe: 'subscribe'
} as const;

export type SyncClientSubscribeTypeEnum = typeof SyncClientSubscribeTypeEnum[keyof typeof SyncClientSubscribeTypeEnum];

/**
 * Response model for syncing enterprise domains to WorkOS.
 * @export
 * @interface SyncDomainsToWorkosResponse
 */
export interface SyncDomainsToWorkosResponse {
    /**
     * 
     * @type {string}
     * @memberof SyncDomainsToWorkosResponse
     */
    'message': string;
    /**
     * Whether the domains were successfully synced to WorkOS
     * @type {boolean}
     * @memberof SyncDomainsToWorkosResponse
     */
    'workos_synced': boolean;
}
/**
 * @type SyncEvent
 * @export
 */
export type SyncEvent = { type: 'access.changed' } & SyncEventAccessChanged | { type: 'automations.changed' } & SyncEventAutomationsChanged | { type: 'calendar.changed' } & SyncEventCalendarChanged | { type: 'enterprise.membership_changed' } & SyncEventEnterpriseMembershipChanged | { type: 'enterprise.settings_changed' } & SyncEventEnterpriseSettingsChanged | { type: 'enterprise.subscription_changed' } & SyncEventEnterpriseSubscriptionChanged | { type: 'entitlements.changed' } & SyncEventEntitlementsChanged | { type: 'flow_state_job.completed' } & SyncEventFlowStateJobCompleted | { type: 'gap_too_large' } & SyncEventGapTooLarge | { type: 'heartbeat' } & SyncEventHeartbeat | { type: 'incident_banner.updated' } & SyncEventIncidentBannerUpdated | { type: 'learned_preferences.changed' } & SyncEventLearnedPreferencesChanged | { type: 'meeting.changed' } & SyncEventMeetingChanged | { type: 'meeting.speaker_map_changed' } & SyncEventMeetingSpeakerMapChanged | { type: 'meeting.transcript_changed' } & SyncEventMeetingTranscriptChanged | { type: 'meeting_import.changed' } & SyncEventMeetingImportChanged | { type: 'meetings_shared.changed' } & SyncEventMeetingsSharedChanged | { type: 'notes.changed' } & SyncEventNotesChanged | { type: 'notification.created' } & SyncEventNotificationCreated | { type: 'preferences.changed' } & SyncEventPreferencesChanged | { type: 'reconnect_resync' } & SyncEventReconnectResync | { type: 'subscription.changed' } & SyncEventSubscriptionChanged | { type: 'todos.changed' } & SyncEventTodosChanged | { type: 'unread_shares.changed' } & SyncEventUnreadSharesChanged | { type: 'unrecognized' } & SyncEventUnrecognized | { type: 'voice_profile.ready' } & SyncEventVoiceProfileReady;

/**
 * The user\'s served access decisions may have changed.  Thin — carries no snapshot; the client refetches ``GET /api/v1/access``.
 * @export
 * @interface SyncEventAccessChanged
 */
export interface SyncEventAccessChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventAccessChanged
     */
    'type': SyncEventAccessChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventAccessChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventAccessChanged
     */
    'ts': string;
}

export const SyncEventAccessChangedTypeEnum = {
    AccessChanged: 'access.changed'
} as const;

export type SyncEventAccessChangedTypeEnum = typeof SyncEventAccessChangedTypeEnum[keyof typeof SyncEventAccessChangedTypeEnum];

/**
 * Automations set changed.  Thin-ticket — the client refetches via the ``/automations/sync`` pull. Coarse (no automation id): the client re-pulls the whole resource, and a per-row event would mint unbounded Redis keys (the 2026-06-01 OOM).
 * @export
 * @interface SyncEventAutomationsChanged
 */
export interface SyncEventAutomationsChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventAutomationsChanged
     */
    'type': SyncEventAutomationsChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventAutomationsChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventAutomationsChanged
     */
    'ts': string;
}

export const SyncEventAutomationsChangedTypeEnum = {
    AutomationsChanged: 'automations.changed'
} as const;

export type SyncEventAutomationsChangedTypeEnum = typeof SyncEventAutomationsChangedTypeEnum[keyof typeof SyncEventAutomationsChangedTypeEnum];

/**
 * Calendar state changed.  Thin-ticket — client refetches the calendar list.
 * @export
 * @interface SyncEventCalendarChanged
 */
export interface SyncEventCalendarChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventCalendarChanged
     */
    'type': SyncEventCalendarChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventCalendarChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventCalendarChanged
     */
    'ts': string;
}

export const SyncEventCalendarChangedTypeEnum = {
    CalendarChanged: 'calendar.changed'
} as const;

export type SyncEventCalendarChangedTypeEnum = typeof SyncEventCalendarChangedTypeEnum[keyof typeof SyncEventCalendarChangedTypeEnum];

/**
 * An enterprise\'s membership roster changed (member added/removed via SCIM or admin action).  Thin — the client refetches its subscription state through ``GET /payment/subscription`` (enterprise role/seat reach the client through the billing path; there is no separate enterprise surface on desktop).  Fanned out to all current members plus the affected/removed user (so a removed user\'s client drops its enterprise state).
 * @export
 * @interface SyncEventEnterpriseMembershipChanged
 */
export interface SyncEventEnterpriseMembershipChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseMembershipChanged
     */
    'type': SyncEventEnterpriseMembershipChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventEnterpriseMembershipChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseMembershipChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseMembershipChanged
     */
    'enterprise_id': string;
}

export const SyncEventEnterpriseMembershipChangedTypeEnum = {
    EnterpriseMembershipChanged: 'enterprise.membership_changed'
} as const;

export type SyncEventEnterpriseMembershipChangedTypeEnum = typeof SyncEventEnterpriseMembershipChangedTypeEnum[keyof typeof SyncEventEnterpriseMembershipChangedTypeEnum];

/**
 * An enterprise\'s settings or gates changed (admin portal or an internal write).  Thin — every current member refetches the enterprise object through ``GET /enterprise``, which carries both halves (gates ∪ settings). One event covers both because they share that object and a single write can touch both (the ZDR lock floors ``allowShareData`` / ``allowCloudSync``).
 * @export
 * @interface SyncEventEnterpriseSettingsChanged
 */
export interface SyncEventEnterpriseSettingsChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSettingsChanged
     */
    'type': SyncEventEnterpriseSettingsChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventEnterpriseSettingsChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSettingsChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSettingsChanged
     */
    'enterprise_id': string;
}

export const SyncEventEnterpriseSettingsChangedTypeEnum = {
    EnterpriseSettingsChanged: 'enterprise.settings_changed'
} as const;

export type SyncEventEnterpriseSettingsChangedTypeEnum = typeof SyncEventEnterpriseSettingsChangedTypeEnum[keyof typeof SyncEventEnterpriseSettingsChangedTypeEnum];

/**
 * An enterprise\'s subscription changed (enterprise Stripe webhook or an admin plan switch).  Thin — every current member refetches its subscription state through the billing path, same routing as ``enterprise.membership_changed``.
 * @export
 * @interface SyncEventEnterpriseSubscriptionChanged
 */
export interface SyncEventEnterpriseSubscriptionChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSubscriptionChanged
     */
    'type': SyncEventEnterpriseSubscriptionChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventEnterpriseSubscriptionChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSubscriptionChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEnterpriseSubscriptionChanged
     */
    'enterprise_id': string;
}

export const SyncEventEnterpriseSubscriptionChangedTypeEnum = {
    EnterpriseSubscriptionChanged: 'enterprise.subscription_changed'
} as const;

export type SyncEventEnterpriseSubscriptionChangedTypeEnum = typeof SyncEventEnterpriseSubscriptionChangedTypeEnum[keyof typeof SyncEventEnterpriseSubscriptionChangedTypeEnum];

/**
 * The user\'s product entitlements changed.  Fat event — the complete bounded entitlement snapshot travels on the wire, matching ``GET /api/v1/entitlements`` without a follow-up fetch.
 * @export
 * @interface SyncEventEntitlementsChanged
 */
export interface SyncEventEntitlementsChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventEntitlementsChanged
     */
    'type': SyncEventEntitlementsChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventEntitlementsChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventEntitlementsChanged
     */
    'ts': string;
    /**
     * 
     * @type {UserEntitlementsResponse}
     * @memberof SyncEventEntitlementsChanged
     */
    'payload': UserEntitlementsResponse;
}

export const SyncEventEntitlementsChangedTypeEnum = {
    EntitlementsChanged: 'entitlements.changed'
} as const;

export type SyncEventEntitlementsChangedTypeEnum = typeof SyncEventEntitlementsChangedTypeEnum[keyof typeof SyncEventEntitlementsChangedTypeEnum];

/**
 * Wrapper that surfaces the ``SyncEvent`` union to OpenAPI.  The field name ``sync_event`` is load-bearing: openapi-generator-cli names the generated TS union type from this field, yielding ``SyncEvent``.
 * @export
 * @interface SyncEventEnvelope
 */
export interface SyncEventEnvelope {
    /**
     * 
     * @type {SyncEvent}
     * @memberof SyncEventEnvelope
     */
    'sync_event': SyncEvent;
}
/**
 * A flow-state-2025 background job finished and committed its LLM fields.  Fat event — the full ``FlowState2025Response`` (same shape the desktop polls via ``GET /llm/flow_state_2025``) travels on the wire so the client renders immediately without a follow-up REST fetch. Published from the background processor\'s completion transition (post-commit, read-your-writes).
 * @export
 * @interface SyncEventFlowStateJobCompleted
 */
export interface SyncEventFlowStateJobCompleted {
    /**
     * 
     * @type {string}
     * @memberof SyncEventFlowStateJobCompleted
     */
    'type': SyncEventFlowStateJobCompletedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventFlowStateJobCompleted
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventFlowStateJobCompleted
     */
    'ts': string;
    /**
     * 
     * @type {FlowState2025Response}
     * @memberof SyncEventFlowStateJobCompleted
     */
    'payload': FlowState2025Response;
}

export const SyncEventFlowStateJobCompletedTypeEnum = {
    FlowStateJobCompleted: 'flow_state_job.completed'
} as const;

export type SyncEventFlowStateJobCompletedTypeEnum = typeof SyncEventFlowStateJobCompletedTypeEnum[keyof typeof SyncEventFlowStateJobCompletedTypeEnum];

/**
 * Server response when the requested resume point is too old.  Emitted in response to ``subscribe { since: N }`` where the stream\'s oldest entry is newer than ``N`` — client must fall back to ``/sync/check``.
 * @export
 * @interface SyncEventGapTooLarge
 */
export interface SyncEventGapTooLarge {
    /**
     * 
     * @type {string}
     * @memberof SyncEventGapTooLarge
     */
    'type': SyncEventGapTooLargeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventGapTooLarge
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventGapTooLarge
     */
    'ts': string;
}

export const SyncEventGapTooLargeTypeEnum = {
    GapTooLarge: 'gap_too_large'
} as const;

export type SyncEventGapTooLargeTypeEnum = typeof SyncEventGapTooLargeTypeEnum[keyof typeof SyncEventGapTooLargeTypeEnum];

/**
 * Keepalive frame emitted by the server on a fixed cadence.
 * @export
 * @interface SyncEventHeartbeat
 */
export interface SyncEventHeartbeat {
    /**
     * 
     * @type {string}
     * @memberof SyncEventHeartbeat
     */
    'type': SyncEventHeartbeatTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventHeartbeat
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventHeartbeat
     */
    'ts': string;
}

export const SyncEventHeartbeatTypeEnum = {
    Heartbeat: 'heartbeat'
} as const;

export type SyncEventHeartbeatTypeEnum = typeof SyncEventHeartbeatTypeEnum[keyof typeof SyncEventHeartbeatTypeEnum];

/**
 * The production incident banner changed for ALL users (global fanout).  Fat event carrying the same ``IncidentStatusDetail`` the bootstrap ``/sync/check`` returns. ``payload=None`` means the incident was cleared — the client tears down its banner. Fanned out on the single ``sync:global`` channel every connected client subscribes to, not a per-user channel.
 * @export
 * @interface SyncEventIncidentBannerUpdated
 */
export interface SyncEventIncidentBannerUpdated {
    /**
     * 
     * @type {string}
     * @memberof SyncEventIncidentBannerUpdated
     */
    'type': SyncEventIncidentBannerUpdatedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventIncidentBannerUpdated
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventIncidentBannerUpdated
     */
    'ts': string;
    /**
     * 
     * @type {IncidentStatusDetail}
     * @memberof SyncEventIncidentBannerUpdated
     */
    'payload'?: IncidentStatusDetail | null;
}

export const SyncEventIncidentBannerUpdatedTypeEnum = {
    IncidentBannerUpdated: 'incident_banner.updated'
} as const;

export type SyncEventIncidentBannerUpdatedTypeEnum = typeof SyncEventIncidentBannerUpdatedTypeEnum[keyof typeof SyncEventIncidentBannerUpdatedTypeEnum];

/**
 * Learned preference state changed for one source.
 * @export
 * @interface SyncEventLearnedPreferencesChanged
 */
export interface SyncEventLearnedPreferencesChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventLearnedPreferencesChanged
     */
    'type': SyncEventLearnedPreferencesChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventLearnedPreferencesChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventLearnedPreferencesChanged
     */
    'ts': string;
    /**
     * 
     * @type {LearnedPreferenceSource}
     * @memberof SyncEventLearnedPreferencesChanged
     */
    'source': LearnedPreferenceSource;
    /**
     * 
     * @type {LearnedPreferencesResponse}
     * @memberof SyncEventLearnedPreferencesChanged
     */
    'payload': LearnedPreferencesResponse;
}

export const SyncEventLearnedPreferencesChangedTypeEnum = {
    LearnedPreferencesChanged: 'learned_preferences.changed'
} as const;

export type SyncEventLearnedPreferencesChangedTypeEnum = typeof SyncEventLearnedPreferencesChangedTypeEnum[keyof typeof SyncEventLearnedPreferencesChangedTypeEnum];

/**
 * A meeting row\'s user-visible state changed.  Thin-ticket — client refetches the meeting row. A resource-level ``changed`` shape (matching ``notes.changed`` / ``calendar.changed``) is preferred over ``ready`` variants that inline a payload: the row\'s fields can be edited cross-device or regenerated, so an inlined value rots the moment it can change again.  ``refine_status`` is an advisory hint carrying the refine pipeline\'s current stage (emitted on each transition so a client can render progress); the pulled row stays authoritative. Optional-with-default so pre-hint payloads still parse.
 * @export
 * @interface SyncEventMeetingChanged
 */
export interface SyncEventMeetingChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingChanged
     */
    'type': SyncEventMeetingChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingChanged
     */
    'meeting_id': string;
    /**
     * 
     * @type {RefineJobStatus}
     * @memberof SyncEventMeetingChanged
     */
    'refine_status'?: RefineJobStatus | null;
}

export const SyncEventMeetingChangedTypeEnum = {
    MeetingChanged: 'meeting.changed'
} as const;

export type SyncEventMeetingChangedTypeEnum = typeof SyncEventMeetingChangedTypeEnum[keyof typeof SyncEventMeetingChangedTypeEnum];

/**
 * A meeting-import run made progress or reached a terminal state.  Thin-ticket — the client refetches the run\'s status. Each imported meeting also reaches the client through ordinary meeting sync.
 * @export
 * @interface SyncEventMeetingImportChanged
 */
export interface SyncEventMeetingImportChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingImportChanged
     */
    'type': SyncEventMeetingImportChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingImportChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingImportChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingImportChanged
     */
    'run_id': string;
}

export const SyncEventMeetingImportChangedTypeEnum = {
    MeetingImportChanged: 'meeting_import.changed'
} as const;

export type SyncEventMeetingImportChangedTypeEnum = typeof SyncEventMeetingImportChangedTypeEnum[keyof typeof SyncEventMeetingImportChangedTypeEnum];

/**
 * The live speaker map for an in-progress recording changed.  Fat — the whole map rides inline, versioned per meeting, so a client applies it only when ``version`` is newer than the one it holds. Bounded by the consensus fold: one assignment per diarized voice, and ``lines`` maps at most the newest 512 live entry ids to a person where that line\'s own evidence disagrees with its voice\'s assignment (typically tens; about 30 KB at the largest).  ``version`` keeps counting across recording generations while voice keys restart with each one, so a client also drops a map whose ``generation`` is not the segment it is recording.
 * @export
 * @interface SyncEventMeetingSpeakerMapChanged
 */
export interface SyncEventMeetingSpeakerMapChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'type': SyncEventMeetingSpeakerMapChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'meeting_id': string;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'generation': number;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'version': number;
    /**
     * 
     * @type {{ [key: string]: SpeakerAssignment; }}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'assignments': { [key: string]: SpeakerAssignment; };
    /**
     * 
     * @type {{ [key: string]: SpeakerPerson; }}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'people': { [key: string]: SpeakerPerson; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SyncEventMeetingSpeakerMapChanged
     */
    'lines'?: { [key: string]: string; };
}

export const SyncEventMeetingSpeakerMapChangedTypeEnum = {
    MeetingSpeakerMapChanged: 'meeting.speaker_map_changed'
} as const;

export type SyncEventMeetingSpeakerMapChangedTypeEnum = typeof SyncEventMeetingSpeakerMapChangedTypeEnum[keyof typeof SyncEventMeetingSpeakerMapChangedTypeEnum];

/**
 * Refined transcript persisted for ``meeting_id``.  Thin-ticket — client refetches transcript bytes through the existing inline sync path.  Kept separate from ``meeting.changed`` because transcript bytes are a distinct surface (different consumers, different refetch path) from the meeting row\'s columns.
 * @export
 * @interface SyncEventMeetingTranscriptChanged
 */
export interface SyncEventMeetingTranscriptChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingTranscriptChanged
     */
    'type': SyncEventMeetingTranscriptChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingTranscriptChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingTranscriptChanged
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingTranscriptChanged
     */
    'meeting_id': string;
}

export const SyncEventMeetingTranscriptChangedTypeEnum = {
    MeetingTranscriptChanged: 'meeting.transcript_changed'
} as const;

export type SyncEventMeetingTranscriptChangedTypeEnum = typeof SyncEventMeetingTranscriptChangedTypeEnum[keyof typeof SyncEventMeetingTranscriptChangedTypeEnum];

/**
 * Shared-with-me set changed; client batch-resolves ``slugs`` (absent ⇒ drop locally).
 * @export
 * @interface SyncEventMeetingsSharedChanged
 */
export interface SyncEventMeetingsSharedChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingsSharedChanged
     */
    'type': SyncEventMeetingsSharedChangedTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyncEventMeetingsSharedChanged
     */
    'slugs': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SyncEventMeetingsSharedChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventMeetingsSharedChanged
     */
    'ts': string;
}

export const SyncEventMeetingsSharedChangedTypeEnum = {
    MeetingsSharedChanged: 'meetings_shared.changed'
} as const;

export type SyncEventMeetingsSharedChangedTypeEnum = typeof SyncEventMeetingsSharedChangedTypeEnum[keyof typeof SyncEventMeetingsSharedChangedTypeEnum];

/**
 * Notes set changed.  Thin-ticket — client refetches via the existing notes sync flow.
 * @export
 * @interface SyncEventNotesChanged
 */
export interface SyncEventNotesChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventNotesChanged
     */
    'type': SyncEventNotesChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventNotesChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventNotesChanged
     */
    'ts': string;
}

export const SyncEventNotesChangedTypeEnum = {
    NotesChanged: 'notes.changed'
} as const;

export type SyncEventNotesChangedTypeEnum = typeof SyncEventNotesChangedTypeEnum[keyof typeof SyncEventNotesChangedTypeEnum];

/**
 * A new notification has been created for the user.  Inline (fat) event: the entire ``NotificationResponse`` travels on the wire so the client can render a toast immediately without a follow-up REST fetch.
 * @export
 * @interface SyncEventNotificationCreated
 */
export interface SyncEventNotificationCreated {
    /**
     * 
     * @type {string}
     * @memberof SyncEventNotificationCreated
     */
    'type': SyncEventNotificationCreatedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventNotificationCreated
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventNotificationCreated
     */
    'ts': string;
    /**
     * 
     * @type {NotificationResponse}
     * @memberof SyncEventNotificationCreated
     */
    'payload': NotificationResponse;
}

export const SyncEventNotificationCreatedTypeEnum = {
    NotificationCreated: 'notification.created'
} as const;

export type SyncEventNotificationCreatedTypeEnum = typeof SyncEventNotificationCreatedTypeEnum[keyof typeof SyncEventNotificationCreatedTypeEnum];

/**
 * User preferences updated.  Inline (fat) — full ``PreferencesResponse`` travels on the wire so peers can converge via last-writer-wins on the ``modified_at`` echo.
 * @export
 * @interface SyncEventPreferencesChanged
 */
export interface SyncEventPreferencesChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventPreferencesChanged
     */
    'type': SyncEventPreferencesChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventPreferencesChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventPreferencesChanged
     */
    'ts': string;
    /**
     * 
     * @type {PreferencesResponse}
     * @memberof SyncEventPreferencesChanged
     */
    'payload': PreferencesResponse;
}

export const SyncEventPreferencesChangedTypeEnum = {
    PreferencesChanged: 'preferences.changed'
} as const;

export type SyncEventPreferencesChangedTypeEnum = typeof SyncEventPreferencesChangedTypeEnum[keyof typeof SyncEventPreferencesChangedTypeEnum];

/**
 * Server-initiated reconnect signal.  Client should drop its last_seq, reconnect, and call ``/sync/check`` to bootstrap from snapshot.
 * @export
 * @interface SyncEventReconnectResync
 */
export interface SyncEventReconnectResync {
    /**
     * 
     * @type {string}
     * @memberof SyncEventReconnectResync
     */
    'type': SyncEventReconnectResyncTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventReconnectResync
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventReconnectResync
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventReconnectResync
     */
    'reason': string;
}

export const SyncEventReconnectResyncTypeEnum = {
    ReconnectResync: 'reconnect_resync'
} as const;

export type SyncEventReconnectResyncTypeEnum = typeof SyncEventReconnectResyncTypeEnum[keyof typeof SyncEventReconnectResyncTypeEnum];

/**
 * The user\'s subscription state changed (Stripe or RevenueCat webhook).  Fat event — the full rendered ``SubscriptionPayload`` travels on the wire so the client applies it directly without a refetch. Built from the primary at publish time (read-your-writes), so it is never stale relative to the write that triggered it.
 * @export
 * @interface SyncEventSubscriptionChanged
 */
export interface SyncEventSubscriptionChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventSubscriptionChanged
     */
    'type': SyncEventSubscriptionChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventSubscriptionChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventSubscriptionChanged
     */
    'ts': string;
    /**
     * 
     * @type {SubscriptionPayload}
     * @memberof SyncEventSubscriptionChanged
     */
    'payload': SubscriptionPayload;
}

export const SyncEventSubscriptionChangedTypeEnum = {
    SubscriptionChanged: 'subscription.changed'
} as const;

export type SyncEventSubscriptionChangedTypeEnum = typeof SyncEventSubscriptionChangedTypeEnum[keyof typeof SyncEventSubscriptionChangedTypeEnum];

/**
 * Todos set changed.  Thin-ticket — client refetches via the existing ``/todos/sync`` flow. Coarse (no ``todo_id``): the client re-pulls the whole resource, and a per-row event would mint unbounded Redis keys (the 2026-06-01 OOM).
 * @export
 * @interface SyncEventTodosChanged
 */
export interface SyncEventTodosChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventTodosChanged
     */
    'type': SyncEventTodosChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventTodosChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventTodosChanged
     */
    'ts': string;
}

export const SyncEventTodosChangedTypeEnum = {
    TodosChanged: 'todos.changed'
} as const;

export type SyncEventTodosChangedTypeEnum = typeof SyncEventTodosChangedTypeEnum[keyof typeof SyncEventTodosChangedTypeEnum];

/**
 * The caller\'s unread-share set changed; thin — the client refetches ``GET /api/v1/unread-shares``.
 * @export
 * @interface SyncEventUnreadSharesChanged
 */
export interface SyncEventUnreadSharesChanged {
    /**
     * 
     * @type {string}
     * @memberof SyncEventUnreadSharesChanged
     */
    'type': SyncEventUnreadSharesChangedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventUnreadSharesChanged
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventUnreadSharesChanged
     */
    'ts': string;
}

export const SyncEventUnreadSharesChangedTypeEnum = {
    UnreadSharesChanged: 'unread_shares.changed'
} as const;

export type SyncEventUnreadSharesChangedTypeEnum = typeof SyncEventUnreadSharesChangedTypeEnum[keyof typeof SyncEventUnreadSharesChangedTypeEnum];

/**
 * Escape hatch for the admin test-publish endpoint.  Lets the server emit a well-formed envelope whose ``type`` the client doesn\'t know yet, so the desktop harness can verify the unknown-event-type path end-to-end without a server-side branch fabricating a real event.
 * @export
 * @interface SyncEventUnrecognized
 */
export interface SyncEventUnrecognized {
    /**
     * 
     * @type {string}
     * @memberof SyncEventUnrecognized
     */
    'type': SyncEventUnrecognizedTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventUnrecognized
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventUnrecognized
     */
    'ts': string;
    /**
     * 
     * @type {string}
     * @memberof SyncEventUnrecognized
     */
    'requested_event_type': string;
}

export const SyncEventUnrecognizedTypeEnum = {
    Unrecognized: 'unrecognized'
} as const;

export type SyncEventUnrecognizedTypeEnum = typeof SyncEventUnrecognizedTypeEnum[keyof typeof SyncEventUnrecognizedTypeEnum];

/**
 * A voice-profile background job finished and committed a profile row.  Fat event — the full ``VoiceProfileResponse`` (same shape the desktop polls via ``GET /llm/voice_profile``) travels on the wire so the client renders immediately without a follow-up REST fetch. Published from the background processor\'s completion transition (post-commit, read-your-writes).
 * @export
 * @interface SyncEventVoiceProfileReady
 */
export interface SyncEventVoiceProfileReady {
    /**
     * 
     * @type {string}
     * @memberof SyncEventVoiceProfileReady
     */
    'type': SyncEventVoiceProfileReadyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SyncEventVoiceProfileReady
     */
    'seq': number;
    /**
     * 
     * @type {string}
     * @memberof SyncEventVoiceProfileReady
     */
    'ts': string;
    /**
     * 
     * @type {VoiceProfileResponse}
     * @memberof SyncEventVoiceProfileReady
     */
    'payload': VoiceProfileResponse;
}

export const SyncEventVoiceProfileReadyTypeEnum = {
    VoiceProfileReady: 'voice_profile.ready'
} as const;

export type SyncEventVoiceProfileReadyTypeEnum = typeof SyncEventVoiceProfileReadyTypeEnum[keyof typeof SyncEventVoiceProfileReadyTypeEnum];

/**
 * @type SyncFrame
 * @export
 */
export type SyncFrame = { type: 'ack' } & SyncClientAck | { type: 'ping' } & SyncClientPing | { type: 'subscribe' } & SyncClientSubscribe;

/**
 * Model for meeting data in sync requests.  The live transcript is uploaded out-of-band via a presigned S3 PUT; the client then sets ``live_transcript_uploaded`` on its next sync and the server stamps the server-internal ``live_uploaded_at`` watermark without the bytes. The live transcript is never inlined on the wire — cross-device live view is unsupported.  ``refined_transcript`` is pull-only. The server inlines the refined NDJSON body when ``refined_uploaded_at`` advanced past the client\'s watermark — and only for clients that did not declare ``supports_refined_stamp_fetch`` (capable clients fetch the bytes out-of-band). The payload is one ``TranscriptEntry`` per line; the field is named without a content-type suffix because the client treats it as \"refined transcript\", not \"refined JSON\". Skipped on hard refresh — a 100-meeting backlog × 200 KB each would blow up the response when a device catches up after a long offline window.  ``refined_uploaded_at`` rides every pull (hard refresh included, which skips the inline bytes) as the client\'s reconciliation signal: when the row\'s stamp beats the client\'s locally persisted fetched-through stamp, it downloads the bytes out-of-band via ``GET /meetings/{id}/refined-transcript``. Response-only — a push carrying it never writes the column. ``live_uploaded_at`` stays deliberately NOT on the wire: cross-device live view is unsupported, so clients have no use for that watermark.
 * @export
 * @interface SyncMeetingInput
 */
export interface SyncMeetingInput {
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'modified_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'finalized'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'is_recording'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'calendar_external_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'transcript_deleted_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'refined_transcript'?: string | null;
    /**
     * 
     * @type {RefineJobStatus}
     * @memberof SyncMeetingInput
     */
    'refine_status'?: RefineJobStatus | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'refined_uploaded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'transcript_corrections_updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'slug'?: string | null;
    /**
     * 
     * @type {NoteVisibility}
     * @memberof SyncMeetingInput
     */
    'visibility'?: NoteVisibility | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'candidate_summary'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof SyncMeetingInput
     */
    'candidate_summary_metadata'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'live_transcript_uploaded'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'calendar_event_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'ended_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SyncMeetingInput
     */
    'recorded_ms'?: number | null;
    /**
     * 
     * @type {SpeakerMap}
     * @memberof SyncMeetingInput
     */
    'speaker_map'?: SpeakerMap | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'org_insights'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: InlineSpeakerAssignment; }}
     * @memberof SyncMeetingInput
     */
    'speaker_assignments'?: { [key: string]: InlineSpeakerAssignment; } | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SyncMeetingInput
     */
    'room_label_edits'?: { [key: string]: string; } | null;
    /**
     * 
     * @type {Array<ContactResponse>}
     * @memberof SyncMeetingInput
     */
    'contacts'?: Array<ContactResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'transcript_ready'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingInput
     */
    'summary_ready'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'summary_ready_event_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingInput
     */
    'import_source'?: string | null;
    /**
     * 
     * @type {CapturePlatform}
     * @memberof SyncMeetingInput
     */
    'capture_platform'?: CapturePlatform | null;
}


/**
 * Model for meeting data in sync requests.  The live transcript is uploaded out-of-band via a presigned S3 PUT; the client then sets ``live_transcript_uploaded`` on its next sync and the server stamps the server-internal ``live_uploaded_at`` watermark without the bytes. The live transcript is never inlined on the wire — cross-device live view is unsupported.  ``refined_transcript`` is pull-only. The server inlines the refined NDJSON body when ``refined_uploaded_at`` advanced past the client\'s watermark — and only for clients that did not declare ``supports_refined_stamp_fetch`` (capable clients fetch the bytes out-of-band). The payload is one ``TranscriptEntry`` per line; the field is named without a content-type suffix because the client treats it as \"refined transcript\", not \"refined JSON\". Skipped on hard refresh — a 100-meeting backlog × 200 KB each would blow up the response when a device catches up after a long offline window.  ``refined_uploaded_at`` rides every pull (hard refresh included, which skips the inline bytes) as the client\'s reconciliation signal: when the row\'s stamp beats the client\'s locally persisted fetched-through stamp, it downloads the bytes out-of-band via ``GET /meetings/{id}/refined-transcript``. Response-only — a push carrying it never writes the column. ``live_uploaded_at`` stays deliberately NOT on the wire: cross-device live view is unsupported, so clients have no use for that watermark.
 * @export
 * @interface SyncMeetingOutput
 */
export interface SyncMeetingOutput {
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'modified_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'finalized'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'is_recording'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'calendar_external_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'transcript_deleted_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'refined_transcript'?: string | null;
    /**
     * 
     * @type {RefineJobStatus}
     * @memberof SyncMeetingOutput
     */
    'refine_status'?: RefineJobStatus | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'refined_uploaded_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'transcript_corrections_updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'slug'?: string | null;
    /**
     * 
     * @type {NoteVisibility}
     * @memberof SyncMeetingOutput
     */
    'visibility'?: NoteVisibility | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'summary'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'current_job_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'candidate_summary'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof SyncMeetingOutput
     */
    'candidate_summary_metadata'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'live_transcript_uploaded'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'calendar_event_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'ended_at'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SyncMeetingOutput
     */
    'recorded_ms'?: number | null;
    /**
     * 
     * @type {SpeakerMap}
     * @memberof SyncMeetingOutput
     */
    'speaker_map'?: SpeakerMap | null;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'org_insights'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: InlineSpeakerAssignment; }}
     * @memberof SyncMeetingOutput
     */
    'speaker_assignments'?: { [key: string]: InlineSpeakerAssignment; } | null;
    /**
     * 
     * @type {Array<ContactResponse>}
     * @memberof SyncMeetingOutput
     */
    'contacts'?: Array<ContactResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'transcript_ready'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingOutput
     */
    'summary_ready'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'summary_ready_event_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingOutput
     */
    'import_source'?: string | null;
}


/**
 * Capture presence submitted alongside the meeting sync.
 * @export
 * @interface SyncMeetingRecordingState
 */
export interface SyncMeetingRecordingState {
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingRecordingState
     */
    'recording_session_id': string;
    /**
     * 
     * @type {number}
     * @memberof SyncMeetingRecordingState
     */
    'sequence': number;
    /**
     * 
     * @type {boolean}
     * @memberof SyncMeetingRecordingState
     */
    'is_recording': boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncMeetingRecordingState
     */
    'meeting_id': string;
}
/**
 * Request to re-sync an individual mobile subscription, by user id or email.
 * @export
 * @interface SyncMobileSubscriptionRequest
 */
export interface SyncMobileSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncMobileSubscriptionRequest
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncMobileSubscriptionRequest
     */
    'email'?: string | null;
    /**
     * Preview changes without committing. Set to false to apply.
     * @type {boolean}
     * @memberof SyncMobileSubscriptionRequest
     */
    'dry_run'?: boolean;
    /**
     * Write the row even when the resolved Play Store product id maps to no plan. Without it, a sync that would store an unresolvable id is refused instead.
     * @type {boolean}
     * @memberof SyncMobileSubscriptionRequest
     */
    'allow_unresolved_product_id'?: boolean;
}
/**
 * Model for note data in sync responses.
 * @export
 * @interface SyncNote
 */
export interface SyncNote {
    /**
     * 
     * @type {string}
     * @memberof SyncNote
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNote
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNote
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNote
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNote
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof SyncNote
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {Array<NoteImageKey>}
     * @memberof SyncNote
     */
    'image_keys'?: Array<NoteImageKey>;
}
/**
 * Model for note data in sync requests.  ``image_keys=None`` means preserve the server\'s existing image metadata. An explicit empty list means replace with no images and clean up removed blobs.
 * @export
 * @interface SyncNoteRequest
 */
export interface SyncNoteRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncNoteRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNoteRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNoteRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNoteRequest
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncNoteRequest
     */
    'content': string;
    /**
     * 
     * @type {boolean}
     * @memberof SyncNoteRequest
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {Array<NoteImageKey>}
     * @memberof SyncNoteRequest
     */
    'image_keys'?: Array<NoteImageKey> | null;
}
/**
 * Response shape for `GET /api/v1/calendar/sync` (Day 2).  Defined now so the contract is locked. `server_time` is the timestamp at which the server produced the response — desktop should use this as the next `since` cursor.  When `next_cursor` is non-null, the desktop should refetch immediately with ``since`` unchanged and ``cursor`` set to this value. When null, the result set fits in a single page and the desktop advances to ``server_time`` as the next ``since`` value.  ``mirror_revision`` is monotonic and increases whenever the server-side calendar mirror stops being the user\'s — a disconnect, or a switch to a different Google account. When the value exceeds the one it last applied, a client drops its mirrored calendar rows and its sync cursors, then re-bootstraps; rows a local meeting still references are kept, as are meeting notes. `0` means never invalidated.
 * @export
 * @interface SyncResponse
 */
export interface SyncResponse {
    /**
     * 
     * @type {Array<CalendarEventDTO>}
     * @memberof SyncResponse
     */
    'events': Array<CalendarEventDTO>;
    /**
     * 
     * @type {string}
     * @memberof SyncResponse
     */
    'serverTime': string;
    /**
     * 
     * @type {string}
     * @memberof SyncResponse
     */
    'nextCursor'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SyncResponse
     */
    'mirrorRevision'?: number;
    /**
     * This initial-sync page includes the requested 48-hour mirrored-event start window. False for delta or fully fenced feeds. Clients must use this acknowledgement, never infer coverage from the request.
     * @type {boolean}
     * @memberof SyncResponse
     */
    'recentHistoryIncluded'?: boolean;
    /**
     * 
     * @type {DerivedTraitsPayload}
     * @memberof SyncResponse
     */
    'derivedTraits'?: DerivedTraitsPayload;
}
/**
 * Request to re-sync an individual Stripe subscription, by subscription id or email.
 * @export
 * @interface SyncSubscriptionRequest
 */
export interface SyncSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncSubscriptionRequest
     */
    'stripe_subscription_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncSubscriptionRequest
     */
    'email'?: string | null;
    /**
     * Preview changes without committing. Set to false to apply.
     * @type {boolean}
     * @memberof SyncSubscriptionRequest
     */
    'dry_run'?: boolean;
}
/**
 * One todo on the ``/todos/sync`` pull.  The whole row travels (existence, title, status, archive, tombstone) — todos are not projected from note content, so the row is the single source of truth.  ``meeting_id`` is nullable: set ⟹ from that meeting; NULL ⟹ ad-hoc. Timestamps are Unix ms strings (symmetric with the request side). The pull includes ``is_deleted`` rows so the client can converge a tombstone.
 * @export
 * @interface SyncTodo
 */
export interface SyncTodo {
    /**
     * 
     * @type {string}
     * @memberof SyncTodo
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncTodo
     */
    'meeting_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncTodo
     */
    'title': string;
    /**
     * 
     * @type {TodoStatus}
     * @memberof SyncTodo
     */
    'status': TodoStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SyncTodo
     */
    'is_archived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncTodo
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncTodo
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SyncTodo
     */
    'modified_at': string;
}


/**
 * One pushed todo on ``POST /api/v1/todos/sync``.  Mirrors ``SyncNoteRequest`` (lenient, NOT ``extra=\"forbid\"``): the resource carries the whole row and gains fields over time, so an unknown field must not 422 the batch. ``meeting_id`` is ``UUID | None`` (B3): an ad-hoc todo has none, and the SQL tuple-IN pair-probe can\'t match NULL — the service uses a ``user_id``-scoped ``id IN (...)`` probe instead.  ``modified_at`` is the client-supplied edit time (Unix ms, as a string — same wire shape as ``SyncNoteRequest.modified_at``); it is the sole LWW key, whole-row replace, compared against the row\'s ``modified_at``. ``status`` is constrained to :class:`TodoStatus` and rejected at parse time (422) on a bad value — a closed set, unlike the lenient open-ended fields.
 * @export
 * @interface SyncTodoRequest
 */
export interface SyncTodoRequest {
    /**
     * 
     * @type {string}
     * @memberof SyncTodoRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyncTodoRequest
     */
    'meeting_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SyncTodoRequest
     */
    'title': string;
    /**
     * 
     * @type {TodoStatus}
     * @memberof SyncTodoRequest
     */
    'status': TodoStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SyncTodoRequest
     */
    'is_archived'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SyncTodoRequest
     */
    'is_deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SyncTodoRequest
     */
    'created_at': string;
    /**
     * Unix timestamp in ms of the client\'s edit (whole-row LWW key for this resource)
     * @type {string}
     * @memberof SyncTodoRequest
     */
    'modified_at': string;
}


/**
 * Approval state of a shared dictionary row.
 * @export
 * @enum {string}
 */

export const TeamDictionaryStatus = {
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type TeamDictionaryStatus = typeof TeamDictionaryStatus[keyof typeof TeamDictionaryStatus];


/**
 * A selectable team in the insights filter dropdown.
 * @export
 * @interface TeamFilterOption
 */
export interface TeamFilterOption {
    /**
     * 
     * @type {string}
     * @memberof TeamFilterOption
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamFilterOption
     */
    'name': string;
}
/**
 * Filters echoed back on every response. Null date fields = all-time.
 * @export
 * @interface TeamInsightsFilters
 */
export interface TeamInsightsFilters {
    /**
     * 
     * @type {string}
     * @memberof TeamInsightsFilters
     */
    'start_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamInsightsFilters
     */
    'end_date'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamInsightsFilters
     */
    'team_id'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInsightsFilters
     */
    'user_ids'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInsightsFilters
     */
    'app_keys'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamInsightsFilters
     */
    'app_categories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TeamInsightsFilters
     */
    'comparison_mode'?: TeamInsightsFiltersComparisonModeEnum | null;
}

export const TeamInsightsFiltersComparisonModeEnum = {
    Rolling: 'rolling',
    Calendar: 'calendar'
} as const;

export type TeamInsightsFiltersComparisonModeEnum = typeof TeamInsightsFiltersComparisonModeEnum[keyof typeof TeamInsightsFiltersComparisonModeEnum];

/**
 * Response model for a team invite link.
 * @export
 * @interface TeamInviteLinkResponse
 */
export interface TeamInviteLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof TeamInviteLinkResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TeamInviteLinkResponse
     */
    'invite_url': string;
    /**
     * 
     * @type {string}
     * @memberof TeamInviteLinkResponse
     */
    'enterprise_id': string;
}
/**
 * All teams visible to the caller.
 * @export
 * @interface TeamListResponse
 */
export interface TeamListResponse {
    /**
     * 
     * @type {Array<TeamResponse>}
     * @memberof TeamListResponse
     */
    'teams': Array<TeamResponse>;
}
/**
 * Per-team membership role stored in ``UserTeamMembership.role``.  Distinct from the enterprise-level role on ``User.enterprise_role`` — a user can be an enterprise ``superadmin`` while being a team-level ``member``, or vice versa.
 * @export
 * @enum {string}
 */

export const TeamMemberRole = {
    Admin: 'admin',
    Member: 'member'
} as const;

export type TeamMemberRole = typeof TeamMemberRole[keyof typeof TeamMemberRole];


/**
 * ``count`` is WAU(D) or MAU(D) for rolling-window modes.
 * @export
 * @interface TeamMembersDailyPoint
 */
export interface TeamMembersDailyPoint {
    /**
     * 
     * @type {string}
     * @memberof TeamMembersDailyPoint
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof TeamMembersDailyPoint
     */
    'count': number;
}
/**
 * Active-user timeseries for a single mode.  Per-day lookback: daily=1d, weekly=[D-7,D], monthly=[D-29,D], inactive=total_members-WAU. ``pct_change_vs_prev_period``: prior period picked by ``filters.comparison_mode`` when set, otherwise by shape detection. Lifetime (no ``start_date``) falls back to L7 vs L7-L14 (or mode-matched for team-members).
 * @export
 * @interface TeamMembersResponse
 */
export interface TeamMembersResponse {
    /**
     * 
     * @type {TeamInsightsFilters}
     * @memberof TeamMembersResponse
     */
    'filters_applied': TeamInsightsFilters;
    /**
     * 
     * @type {Array<string>}
     * @memberof TeamMembersResponse
     */
    'data_quality_flags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TeamMembersResponse
     */
    'total_members': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMembersResponse
     */
    'pct_change_vs_prev_period'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TeamMembersResponse
     */
    'mode': TeamMembersResponseModeEnum;
    /**
     * 
     * @type {Array<TeamMembersDailyPoint>}
     * @memberof TeamMembersResponse
     */
    'timeseries': Array<TeamMembersDailyPoint>;
}

export const TeamMembersResponseModeEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Inactive: 'inactive'
} as const;

export type TeamMembersResponseModeEnum = typeof TeamMembersResponseModeEnum[keyof typeof TeamMembersResponseModeEnum];

/**
 * A single ``UserTeamMembership`` row exposed to admin clients.
 * @export
 * @interface TeamMembershipResponse
 */
export interface TeamMembershipResponse {
    /**
     * 
     * @type {string}
     * @memberof TeamMembershipResponse
     */
    'team_id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMembershipResponse
     */
    'user_id': string;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof TeamMembershipResponse
     */
    'role': TeamMemberRole | null;
}


/**
 * Team details with live member count.
 * @export
 * @interface TeamResponse
 */
export interface TeamResponse {
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'cost_center_name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof TeamResponse
     */
    'member_count': number;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof TeamResponse
     */
    'billing_owner_email'?: string | null;
}
/**
 * Whether the caller has a team to share skills with, and how many each scope holds.
 * @export
 * @interface TeamSkillsSupport
 */
export interface TeamSkillsSupport {
    /**
     * Whether the caller is an active member of an active team.
     * @type {boolean}
     * @memberof TeamSkillsSupport
     */
    'supported': boolean;
    /**
     * How many skills one department may share.
     * @type {number}
     * @memberof TeamSkillsSupport
     */
    'department_max': number;
    /**
     * How many skills one company may share.
     * @type {number}
     * @memberof TeamSkillsSupport
     */
    'company_max': number;
    /**
     * Whether the caller may write company-wide skills: an admin, or the company lets every member.
     * @type {boolean}
     * @memberof TeamSkillsSupport
     */
    'can_share_company': boolean;
}
/**
 * Text surrounding the cursor in the textbox being dictated into.
 * @export
 * @interface TextboxContents
 */
export interface TextboxContents {
    /**
     * Text right before the cursor position or start of selected text
     * @type {string}
     * @memberof TextboxContents
     */
    'beforeText'?: string;
    /**
     * Highlited text in the textbox
     * @type {string}
     * @memberof TextboxContents
     */
    'selectedText'?: string;
    /**
     * Text right after the cursor position or end of selected text
     * @type {string}
     * @memberof TextboxContents
     */
    'afterText'?: string;
    /**
     * All of the text in the textbox
     * @type {string}
     * @memberof TextboxContents
     */
    'contents'?: string;
}
/**
 * Top 6 users (plus the caller) for each this-week leaderboard metric.  Streak and WPM are intentionally excluded — they\'re all-time only.
 * @export
 * @interface ThisWeekPodiums
 */
export interface ThisWeekPodiums {
    /**
     * 
     * @type {MetricPodium}
     * @memberof ThisWeekPodiums
     */
    'total_words'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof ThisWeekPodiums
     */
    'desktop_words'?: MetricPodium;
    /**
     * 
     * @type {MetricPodium}
     * @memberof ThisWeekPodiums
     */
    'mobile_words'?: MetricPodium;
}
/**
 * A user-facing toast the server asks the client to show.  Used today for the empty-result case (an APPEND suggestion whose model output is empty); the `error` variant is reserved for known recoverable failures the server wants to surface with suggestion-specific copy in a 200 response.  HTTP errors (timeouts, rate limits, unexpected exceptions) still flow as HTTPException responses — those don\'t carry a Toast and the client falls back to its generic \"transform failed\" copy.
 * @export
 * @interface Toast
 */
export interface Toast {
    /**
     * 
     * @type {ToastVariant}
     * @memberof Toast
     */
    'variant': ToastVariant;
    /**
     * 
     * @type {string}
     * @memberof Toast
     */
    'message': string;
}


/**
 * Visual style of a server-emitted toast on the client.  `info` is a neutral confirmation/notice; `error` is the styled error variant. The desktop meeting-recorder store\'s `showToast` accepts the same `\'info\' | \'error\'` union, so the variant flows through 1:1 without translation.
 * @export
 * @enum {string}
 */

export const ToastVariant = {
    Info: 'info',
    Error: 'error'
} as const;

export type ToastVariant = typeof ToastVariant[keyof typeof ToastVariant];


/**
 * Lifecycle status of a todo.
 * @export
 * @enum {string}
 */

export const TodoStatus = {
    Open: 'open',
    InProgress: 'in_progress',
    Done: 'done'
} as const;

export type TodoStatus = typeof TodoStatus[keyof typeof TodoStatus];


/**
 * Envelope for ``POST /api/v1/todos/sync``.
 * @export
 * @interface TodoSyncRequest
 */
export interface TodoSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof TodoSyncRequest
     */
    'last_sync_time'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TodoSyncRequest
     */
    'page_cursor'?: string | null;
    /**
     * When true, ignore last_sync_time and pull all of the user\'s todos regardless of it
     * @type {boolean}
     * @memberof TodoSyncRequest
     */
    'hard_refresh'?: boolean;
    /**
     * 
     * @type {Array<SyncTodoRequest>}
     * @memberof TodoSyncRequest
     */
    'todos': Array<SyncTodoRequest>;
}
/**
 * Response for ``POST /api/v1/todos/sync``.  ``acked`` is the subset of pushed ids the server accepted: a created/updated row, OR an existing-and-owned row that lost LWW (it exists, so the client stops retrying and lets the newer server value pull down). An id that could NOT be adopted — it exists under another user, or its non-null ``meeting_id`` isn\'t the caller\'s (FK race) — is omitted so the client retries. ``todos`` is the server→client pull. ``sync_time`` is the server snapshot high-water mark (Unix ms); the client persists it as the next ``last_sync_time`` only when ``next_page_cursor`` is null. While ``next_page_cursor`` is non-null, the client keeps its previous ``last_sync_time`` and sends ``next_page_cursor`` to continue the same capped pull.
 * @export
 * @interface TodoSyncResponse
 */
export interface TodoSyncResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof TodoSyncResponse
     */
    'acked': Array<string>;
    /**
     * 
     * @type {Array<SyncTodo>}
     * @memberof TodoSyncResponse
     */
    'todos': Array<SyncTodo>;
    /**
     * 
     * @type {string}
     * @memberof TodoSyncResponse
     */
    'sync_time': string;
    /**
     * 
     * @type {string}
     * @memberof TodoSyncResponse
     */
    'next_page_cursor'?: string | null;
}
/**
 * Request model for toggling domain deleted status.
 * @export
 * @interface ToggleDomainDeletedRequest
 */
export interface ToggleDomainDeletedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleDomainDeletedRequest
     */
    'deleted': boolean;
}
/**
 * Response model for toggling domain deleted status.
 * @export
 * @interface ToggleDomainDeletedResponse
 */
export interface ToggleDomainDeletedResponse {
    /**
     * 
     * @type {string}
     * @memberof ToggleDomainDeletedResponse
     */
    'message': string;
    /**
     * Whether active domains were successfully synced to WorkOS
     * @type {boolean}
     * @memberof ToggleDomainDeletedResponse
     */
    'workos_synced'?: boolean;
}
/**
 * Request to mint an access token for a client.
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * Integration-defined opaque client identifier; not required to be a UUID.
     * @type {string}
     * @memberof TokenRequest
     */
    'client_id': string;
    /**
     * 
     * @type {number}
     * @memberof TokenRequest
     */
    'duration_secs'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof TokenRequest
     */
    'metadata'?: object | null;
}
/**
 * A minted access token and its lifetime.
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    'access_token': string;
    /**
     * 
     * @type {number}
     * @memberof TokenResponse
     */
    'expires_in': number;
}
/**
 * A function/tool the LLM may call, as passed to the completion endpoint.
 * @export
 * @interface ToolCallDefinition
 */
export interface ToolCallDefinition {
    /**
     * The name of the function
     * @type {string}
     * @memberof ToolCallDefinition
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ToolCallDefinition
     */
    'description'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ToolCallDefinition
     */
    'parameters'?: object | null;
}
/**
 * Request model for tracking events.
 * @export
 * @interface TrackEventRequest
 */
export interface TrackEventRequest {
    /**
     * 
     * @type {string}
     * @memberof TrackEventRequest
     */
    'event': string;
    /**
     * 
     * @type {SrcBackendServiceSchemasApiClickhouseSource}
     * @memberof TrackEventRequest
     */
    'source': SrcBackendServiceSchemasApiClickhouseSource;
    /**
     * 
     * @type {object}
     * @memberof TrackEventRequest
     */
    'properties'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TrackEventRequest
     */
    'user_id': string;
}


/**
 * Supported tracking event names for web beacons.
 * @export
 * @enum {string}
 */

export const TrackingEventName = {
    AppDownload: 'app_download'
} as const;

export type TrackingEventName = typeof TrackingEventName[keyof typeof TrackingEventName];


/**
 * Request for tracking events from web beacons.
 * @export
 * @interface TrackingEventRequest
 */
export interface TrackingEventRequest {
    /**
     * Canonical event name
     * @type {TrackingEventName}
     * @memberof TrackingEventRequest
     */
    'event_name': TrackingEventName;
    /**
     * Client-generated event ID for Pixel dedup
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'event_id': string;
    /**
     * 
     * @type {AttributionPlatform}
     * @memberof TrackingEventRequest
     */
    'platform'?: AttributionPlatform;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'wispr_user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'fbp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'fbc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'fbclid'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingEventRequest
     */
    'fbclid_ts'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'ga_client_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'ga_session_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'gclid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'li_fat_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'wispr_click_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'msclkid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'ttclid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventRequest
     */
    'ttp'?: string | null;
}


/**
 * Response for tracking events.
 * @export
 * @interface TrackingEventResponse
 */
export interface TrackingEventResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TrackingEventResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrackingEventResponse
     */
    'message'?: string | null;
}
/**
 * @type TrajectoryInner
 * @export
 */
export type TrajectoryInner = { kind: 'chat' } & ChatStep | { kind: 'new_tab' } & NewTabStep | { kind: 'replace' } & ReplaceStep | { kind: 'rewrite' } & RewriteStep | { kind: 'user_prompt' } & UserPromptStep;

/**
 * One owner correction; the source artifact always retains original_text.
 * @export
 * @interface TranscriptCorrection
 */
export interface TranscriptCorrection {
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrection
     */
    'entry_id': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrection
     */
    'original_text': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrection
     */
    'edited_text': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrection
     */
    'updated_at': string;
}
/**
 * Apply overlays only to the exact revision and SHA256 of raw NDJSON bytes.
 * @export
 * @interface TranscriptCorrections
 */
export interface TranscriptCorrections {
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrections
     */
    'artifact_revision': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptCorrections
     */
    'artifact_digest': string;
    /**
     * 
     * @type {Array<TranscriptCorrection>}
     * @memberof TranscriptCorrections
     */
    'corrections': Array<TranscriptCorrection>;
}
/**
 * Why a shared note\'s transcript is withheld from the caller.  ``TIER`` is resolved before ``ORG_POLICY``, so a domain or link viewer never learns the owner org\'s content policy — only a caller the tier already trusts (owner or invited-by-email) can see ``ORG_POLICY``.
 * @export
 * @enum {string}
 */

export const TranscriptDenialReason = {
    Tier: 'tier',
    OrgPolicy: 'org_policy'
} as const;

export type TranscriptDenialReason = typeof TranscriptDenialReason[keyof typeof TranscriptDenialReason];


/**
 * Generator-safe wire model enforcing the three persisted entry shapes.
 * @export
 * @interface TranscriptEntry
 */
export interface TranscriptEntry {
    /**
     * 
     * @type {string}
     * @memberof TranscriptEntry
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptEntry
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptEntry
     */
    'text'?: string | null;
    /**
     * 
     * @type {TranscriptSpeaker}
     * @memberof TranscriptEntry
     */
    'speaker'?: TranscriptSpeaker | null;
    /**
     * 
     * @type {boolean}
     * @memberof TranscriptEntry
     */
    'latched'?: boolean;
    /**
     * 
     * @type {TranscriptMarkerType}
     * @memberof TranscriptEntry
     */
    'marker'?: TranscriptMarkerType | null;
    /**
     * 
     * @type {string}
     * @memberof TranscriptEntry
     */
    'label'?: string | null;
}


/**
 * Persisted non-speech transcript marker types.
 * @export
 * @enum {string}
 */

export const TranscriptMarkerType = {
    Paused: 'paused',
    Resumed: 'resumed',
    Dictated: 'dictated',
    AudioEvent: 'audio_event',
    SleepGap: 'sleep_gap'
} as const;

export type TranscriptMarkerType = typeof TranscriptMarkerType[keyof typeof TranscriptMarkerType];


/**
 * Canonical speaker identity; source and ID form the stable key.
 * @export
 * @interface TranscriptSpeaker
 */
export interface TranscriptSpeaker {
    /**
     * 
     * @type {number}
     * @memberof TranscriptSpeaker
     */
    'id': number;
    /**
     * 
     * @type {TranscriptSpeakerSource}
     * @memberof TranscriptSpeaker
     */
    'source': TranscriptSpeakerSource;
    /**
     * 
     * @type {string}
     * @memberof TranscriptSpeaker
     */
    'name': string | null;
}


/**
 * The transcript identity namespace that produced a speaker ID.
 * @export
 * @enum {string}
 */

export const TranscriptSpeakerSource = {
    Mic: 'mic',
    System: 'system',
    Refined: 'refined'
} as const;

export type TranscriptSpeakerSource = typeof TranscriptSpeakerSource[keyof typeof TranscriptSpeakerSource];


/**
 * Free-form (V2) transform request: content, trajectory, and optional tool/prompt steering.
 * @export
 * @interface TransformApplyDynamicRequest
 */
export interface TransformApplyDynamicRequest {
    /**
     * 
     * @type {SrcBackendServiceServicesLlmCostSource}
     * @memberof TransformApplyDynamicRequest
     */
    'source'?: SrcBackendServiceServicesLlmCostSource;
    /**
     * 
     * @type {TransformContent}
     * @memberof TransformApplyDynamicRequest
     */
    'content': TransformContent;
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplyDynamicRequest
     */
    'trajectory': Array<TrajectoryInner>;
    /**
     * 
     * @type {Array<ResponseTarget>}
     * @memberof TransformApplyDynamicRequest
     */
    'allowed_tools'?: Array<ResponseTarget> | null;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyDynamicRequest
     */
    'system_prompt_suffix'?: string | null;
}


/**
 * Free-form (V2) transform response: the assistant step(s) the transform produced.
 * @export
 * @interface TransformApplyDynamicResponse
 */
export interface TransformApplyDynamicResponse {
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplyDynamicResponse
     */
    'steps': Array<TrajectoryInner>;
}
/**
 * Legacy transform/apply request; supports both the old scalar and new array content shapes.  Carries the document(s) to transform plus exactly one source of intent (`suggestion_id`, `prompt`, or `trajectory`); the validator enforces the mutual-exclusion rules across the deprecated and current field shapes.
 * @export
 * @interface TransformApplyRequest
 */
export interface TransformApplyRequest {
    /**
     * 
     * @type {SrcBackendServiceServicesLlmCostSource}
     * @memberof TransformApplyRequest
     */
    'source'?: SrcBackendServiceServicesLlmCostSource;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyRequest
     */
    'context'?: string | null;
    /**
     * 
     * @type {Array<Content>}
     * @memberof TransformApplyRequest
     */
    'read_only_content'?: Array<Content> | null;
    /**
     * 
     * @type {Array<Content>}
     * @memberof TransformApplyRequest
     */
    'editable_content'?: Array<Content> | null;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyRequest
     */
    'prompt'?: string | null;
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplyRequest
     */
    'trajectory'?: Array<TrajectoryInner> | null;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyRequest
     */
    'suggestion_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransformApplyRequest
     */
    'suggestions_count'?: number | null;
    /**
     * 
     * @type {Array<ResponseTarget>}
     * @memberof TransformApplyRequest
     */
    'allowed_tools'?: Array<ResponseTarget> | null;
}


/**
 * Legacy transform/apply response: canonical `steps` plus deprecated mirror fields.  The deprecated `transformed_text` / `response_target` are always populated for older clients that predate the `steps` discriminated union.
 * @export
 * @interface TransformApplyResponse
 */
export interface TransformApplyResponse {
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplyResponse
     */
    'steps': Array<TrajectoryInner>;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyResponse
     */
    'suggestion_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformApplyResponse
     */
    'transformed_text': string;
    /**
     * 
     * @type {ResponseTarget}
     * @memberof TransformApplyResponse
     */
    'response_target': ResponseTarget;
    /**
     * 
     * @type {Array<TransformSuggestion>}
     * @memberof TransformApplyResponse
     */
    'suggestions'?: Array<TransformSuggestion> | null;
    /**
     * 
     * @type {Toast}
     * @memberof TransformApplyResponse
     */
    'toast'?: Toast | null;
}


/**
 * Catalog-suggestion (V2) transform request: content, prior turns, and the suggestion id.
 * @export
 * @interface TransformApplySuggestionRequest
 */
export interface TransformApplySuggestionRequest {
    /**
     * 
     * @type {SrcBackendServiceServicesLlmCostSource}
     * @memberof TransformApplySuggestionRequest
     */
    'source'?: SrcBackendServiceServicesLlmCostSource;
    /**
     * 
     * @type {TransformContent}
     * @memberof TransformApplySuggestionRequest
     */
    'content': TransformContent;
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplySuggestionRequest
     */
    'trajectory': Array<TrajectoryInner>;
    /**
     * 
     * @type {string}
     * @memberof TransformApplySuggestionRequest
     */
    'suggestion_id': string;
    /**
     * 
     * @type {number}
     * @memberof TransformApplySuggestionRequest
     */
    'suggestions_count'?: number | null;
}


/**
 * Catalog-suggestion (V2) transform response: steps, refreshed suggestions, optional toast.
 * @export
 * @interface TransformApplySuggestionResponse
 */
export interface TransformApplySuggestionResponse {
    /**
     * 
     * @type {Array<TrajectoryInner>}
     * @memberof TransformApplySuggestionResponse
     */
    'steps': Array<TrajectoryInner>;
    /**
     * 
     * @type {Array<TransformSuggestion>}
     * @memberof TransformApplySuggestionResponse
     */
    'suggestions'?: Array<TransformSuggestion> | null;
    /**
     * 
     * @type {Toast}
     * @memberof TransformApplySuggestionResponse
     */
    'toast'?: Toast | null;
}
/**
 * Grouping used to bucket transform suggestions in the client\'s chip UI.
 * @export
 * @enum {string}
 */

export const TransformCategory = {
    Tone: 'tone',
    Structural: 'structural',
    Meeting: 'meeting'
} as const;

export type TransformCategory = typeof TransformCategory[keyof typeof TransformCategory];


/**
 * Documents for a V2 transform: read-only grounding plus the editable targets.
 * @export
 * @interface TransformContent
 */
export interface TransformContent {
    /**
     * 
     * @type {Array<Content>}
     * @memberof TransformContent
     */
    'read_only': Array<Content>;
    /**
     * 
     * @type {Array<Content>}
     * @memberof TransformContent
     */
    'editable': Array<Content>;
}
/**
 * Wrapper pairing a transform with its provider config.
 * @export
 * @interface TransformProviderConfig
 */
export interface TransformProviderConfig {
    /**
     * 
     * @type {Provider}
     * @memberof TransformProviderConfig
     */
    'provider': Provider;
}
/**
 * Structured data the classifier may emit when picking the `transform` route.
 * @export
 * @interface TransformRouteData
 */
export interface TransformRouteData {
    /**
     * 
     * @type {string}
     * @memberof TransformRouteData
     */
    'matched_prompt_name'?: string | null;
}
/**
 * Terminal SSE ``error`` frame payload for ``POST /api/v1/transform/apply/stream``.
 * @export
 * @interface TransformStreamErrorPayload
 */
export interface TransformStreamErrorPayload {
    /**
     * 
     * @type {string}
     * @memberof TransformStreamErrorPayload
     */
    'detail': string;
}
/**
 * A catalog suggestion chip: its prompt, target artifact kind, and display metadata.
 * @export
 * @interface TransformSuggestion
 */
export interface TransformSuggestion {
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'label': string;
    /**
     * 
     * @type {TransformCategory}
     * @memberof TransformSuggestion
     */
    'category': TransformCategory;
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'prompt': string;
    /**
     * 
     * @type {ResponseTarget}
     * @memberof TransformSuggestion
     */
    'response_target': ResponseTarget;
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'section_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'empty_result_message'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestion
     */
    'model'?: string | null;
}


/**
 * Request for a batch of transform suggestions tailored to the given document content.
 * @export
 * @interface TransformSuggestionsRequest
 */
export interface TransformSuggestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof TransformSuggestionsRequest
     */
    'content'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransformSuggestionsRequest
     */
    'count'?: number;
}
/**
 * The generated batch of transform suggestions.
 * @export
 * @interface TransformSuggestionsResponse
 */
export interface TransformSuggestionsResponse {
    /**
     * 
     * @type {Array<TransformSuggestion>}
     * @memberof TransformSuggestionsResponse
     */
    'suggestions': Array<TransformSuggestion>;
}
/**
 * A user\'s assignment in the trial opt-in experiment.
 * @export
 * @enum {string}
 */

export const TrialVariant = {
    Control: 'control',
    OptInClaimed: 'opt_in_claimed',
    OptInDeclined: 'opt_in_declined'
} as const;

export type TrialVariant = typeof TrialVariant[keyof typeof TrialVariant];


/**
 * Response for the submit-score endpoint.
 * @export
 * @interface TypingTestResponse
 */
export interface TypingTestResponse {
    /**
     * 
     * @type {UserTypingTestStats}
     * @memberof TypingTestResponse
     */
    'stats'?: UserTypingTestStats | null;
    /**
     * 
     * @type {LeaderboardResponse}
     * @memberof TypingTestResponse
     */
    'leaderboard': LeaderboardResponse;
    /**
     * 
     * @type {string}
     * @memberof TypingTestResponse
     */
    'error'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TypingTestResponse
     */
    'submission_id'?: string | null;
}
/**
 * Response model for the static university domain list.
 * @export
 * @interface UniversityDomainsListResponse
 */
export interface UniversityDomainsListResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UniversityDomainsListResponse
     */
    'domains': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof UniversityDomainsListResponse
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof UniversityDomainsListResponse
     */
    'last_updated'?: string | null;
}
/**
 * A note shared with the caller by direct invite that the caller has not opened yet.
 * @export
 * @interface UnreadShare
 */
export interface UnreadShare {
    /**
     * 
     * @type {string}
     * @memberof UnreadShare
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof UnreadShare
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof UnreadShare
     */
    'shared_at': string;
    /**
     * 
     * @type {string}
     * @memberof UnreadShare
     */
    'announced_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof UnreadShare
     */
    'title': string | null;
    /**
     * 
     * @type {Owner}
     * @memberof UnreadShare
     */
    'owner': Owner;
}
/**
 * The caller\'s unread shares, newest first.
 * @export
 * @interface UnreadSharesResponse
 */
export interface UnreadSharesResponse {
    /**
     * 
     * @type {Array<UnreadShare>}
     * @memberof UnreadSharesResponse
     */
    'items': Array<UnreadShare>;
    /**
     * 
     * @type {boolean}
     * @memberof UnreadSharesResponse
     */
    'has_more': boolean;
}
/**
 * Notes to mark; ids that are unknown, already marked or no longer readable are ignored.
 * @export
 * @interface UnreadSharesUpdateRequest
 */
export interface UnreadSharesUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UnreadSharesUpdateRequest
     */
    'meeting_ids': Array<string>;
}
/**
 * Request body for renaming an organization API key.
 * @export
 * @interface UpdateAPIKeyRequest
 */
export interface UpdateAPIKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAPIKeyRequest
     */
    'name'?: string | null;
}
/**
 * Partial update. ``None`` means \"leave unchanged\", so new toggles stay additive.
 * @export
 * @interface UpdateAdminNotificationPreferencesRequest
 */
export interface UpdateAdminNotificationPreferencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAdminNotificationPreferencesRequest
     */
    'teammates_added_digest_enabled'?: boolean | null;
}
/**
 * Request body for setting the audit-log retention period.
 * @export
 * @interface UpdateAuditLogRetentionRequest
 */
export interface UpdateAuditLogRetentionRequest {
    /**
     * One of the two tiers WorkOS supports today.
     * @type {number}
     * @memberof UpdateAuditLogRetentionRequest
     */
    'retention_period_in_days': UpdateAuditLogRetentionRequestRetentionPeriodInDaysEnum;
}

export const UpdateAuditLogRetentionRequestRetentionPeriodInDaysEnum = {
    NUMBER_30: 30,
    NUMBER_365: 365
} as const;

export type UpdateAuditLogRetentionRequestRetentionPeriodInDaysEnum = typeof UpdateAuditLogRetentionRequestRetentionPeriodInDaysEnum[keyof typeof UpdateAuditLogRetentionRequestRetentionPeriodInDaysEnum];

/**
 * Partial-update request for an existing promo campaign.
 * @export
 * @interface UpdateCampaignRequest
 */
export interface UpdateCampaignRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {CampaignType}
     * @memberof UpdateCampaignRequest
     */
    'campaign_type'?: CampaignType | null;
    /**
     * 
     * @type {CampaignStatus}
     * @memberof UpdateCampaignRequest
     */
    'status'?: CampaignStatus | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignRequest
     */
    'trial_days'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'source_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'attribution_message'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCampaignRequest
     */
    'max_redemptions'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'starts_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'expires_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCampaignRequest
     */
    'description'?: string | null;
}


/**
 * Request to rename a cost center.
 * @export
 * @interface UpdateCostCenterRequest
 */
export interface UpdateCostCenterRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCostCenterRequest
     */
    'name': string;
}
/**
 * The domain-capture policy to set for the enterprise.
 * @export
 * @interface UpdateDomainCapturePolicyRequest
 */
export interface UpdateDomainCapturePolicyRequest {
    /**
     * 
     * @type {DomainCapturePolicy}
     * @memberof UpdateDomainCapturePolicyRequest
     */
    'policy': DomainCapturePolicy;
}


/**
 * Boolean feature gates to set for the enterprise.
 * @export
 * @interface UpdateEnterpriseGatesRequest
 */
export interface UpdateEnterpriseGatesRequest {
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof UpdateEnterpriseGatesRequest
     */
    'gates': { [key: string]: boolean; };
}
/**
 * Request model for renaming an enterprise.
 * @export
 * @interface UpdateEnterpriseNameRequest
 */
export interface UpdateEnterpriseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEnterpriseNameRequest
     */
    'name': string;
}
/**
 * Response model for renaming an enterprise.
 * @export
 * @interface UpdateEnterpriseNameResponse
 */
export interface UpdateEnterpriseNameResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateEnterpriseNameResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnterpriseNameResponse
     */
    'name': string;
}
/**
 * Fields to update on an enterprise (name and/or logo).
 * @export
 * @interface UpdateEnterpriseRequest
 */
export interface UpdateEnterpriseRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEnterpriseRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateEnterpriseRequest
     */
    'logo'?: string | null;
}
/**
 * Enterprise settings to update, with in-place validation of the IP allowlist.
 * @export
 * @interface UpdateEnterpriseSettingsRequest
 */
export interface UpdateEnterpriseSettingsRequest {
    /**
     * 
     * @type {object}
     * @memberof UpdateEnterpriseSettingsRequest
     */
    'settings': object;
    /**
     * Confirms a notetakerBlockedDomains entry that would also block the organization\'s own verified domains or a consumer mail provider. Without it such an entry returns 409.
     * @type {boolean}
     * @memberof UpdateEnterpriseSettingsRequest
     */
    'acknowledgeSelfBlock'?: boolean;
}
/**
 * Rename a folder; only the fields sent change. ``description: null`` clears it.
 * @export
 * @interface UpdateFolderRequest
 */
export interface UpdateFolderRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFolderRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFolderRequest
     */
    'description'?: string | null;
}
/**
 * The folder after the rename.
 * @export
 * @interface UpdateFolderResponse
 */
export interface UpdateFolderResponse {
    /**
     * 
     * @type {FolderSummary}
     * @memberof UpdateFolderResponse
     */
    'folder': FolderSummary;
}
/**
 * The new role to assign to an enterprise member.
 * @export
 * @interface UpdateMemberRoleRequest
 */
export interface UpdateMemberRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateMemberRoleRequest
     */
    'role'?: string;
}
/**
 * Apply one explicit Notetaker decision to current enterprise members.
 * @export
 * @interface UpdateNotetakerEntitlementsRequest
 */
export interface UpdateNotetakerEntitlementsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNotetakerEntitlementsRequest
     */
    'user_ids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotetakerEntitlementsRequest
     */
    'entitled': boolean | null;
}
/**
 * The member IDs and decision committed by the batch.
 * @export
 * @interface UpdateNotetakerEntitlementsResponse
 */
export interface UpdateNotetakerEntitlementsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateNotetakerEntitlementsResponse
     */
    'user_ids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotetakerEntitlementsResponse
     */
    'entitled': boolean | null;
}
/**
 * Request body for updating an organization\'s name and/or logo.
 * @export
 * @interface UpdateOrgRequest
 */
export interface UpdateOrgRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrgRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrgRequest
     */
    'logo'?: string | null;
}
/**
 * Request model for updating an enterprise pilot end date.
 * @export
 * @interface UpdatePilotEndRequest
 */
export interface UpdatePilotEndRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePilotEndRequest
     */
    'pilot_end': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePilotEndRequest
     */
    'cost_center_id'?: string | null;
}
/**
 * Response model for updating an enterprise pilot end date.
 * @export
 * @interface UpdatePilotEndResponse
 */
export interface UpdatePilotEndResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdatePilotEndResponse
     */
    'enterprise_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePilotEndResponse
     */
    'cost_center_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePilotEndResponse
     */
    'new_pilot_end': string;
}
/**
 * Request model for toggling preserve_contracted_seats on an enterprise.
 * @export
 * @interface UpdatePreserveContractedSeatsRequest
 */
export interface UpdatePreserveContractedSeatsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePreserveContractedSeatsRequest
     */
    'preserve_contracted_seats': boolean;
}
/**
 * Full replacement of the prod policy, guarded by the version the editor loaded.
 * @export
 * @interface UpdatePublicAPIPolicyRequest
 */
export interface UpdatePublicAPIPolicyRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePublicAPIPolicyRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePublicAPIPolicyRequest
     */
    'bucket_capacity': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePublicAPIPolicyRequest
     */
    'refill_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePublicAPIPolicyRequest
     */
    'refill_period_seconds': number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePublicAPIPolicyRequest
     */
    'expected_policy_version'?: number | null;
}
/**
 * Request body for changing an organization member\'s role.
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * 
     * @type {Role}
     * @memberof UpdateRoleRequest
     */
    'role': Role;
}


/**
 * Edit a user or team skill; only the fields sent change, and ``description: null`` clears it.
 * @export
 * @interface UpdateSkillRequest
 */
export interface UpdateSkillRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSkillRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkillRequest
     */
    'command'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkillRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateSkillRequest
     */
    'instructions'?: string | null;
    /**
     * 
     * @type {Array<SkillContext>}
     * @memberof UpdateSkillRequest
     */
    'contexts'?: Array<SkillContext> | null;
}
/**
 * Request payload for updating an existing shared dictionary item.  An update never moves a row between scopes, so it carries no scope fields: the row keeps its existing ``team_id`` / ``enterprise_id`` shape.
 * @export
 * @interface UpdateTeamDictionaryItem
 */
export interface UpdateTeamDictionaryItem {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamDictionaryItem
     */
    'word_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamDictionaryItem
     */
    'word': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamDictionaryItem
     */
    'replacement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamDictionaryItem
     */
    'replacement_html'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTeamDictionaryItem
     */
    'is_snippet': boolean;
}
/**
 * Set the per-team membership role for a user already on the team.
 * @export
 * @interface UpdateTeamMemberRoleRequest
 */
export interface UpdateTeamMemberRoleRequest {
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof UpdateTeamMemberRoleRequest
     */
    'role': TeamMemberRole;
}


/**
 * Rename an existing team.
 * @export
 * @interface UpdateTeamRequest
 */
export interface UpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTeamRequest
     */
    'name': string;
}
/**
 * Compare-and-set one entry; null reverts and an empty string deletes text.
 * @export
 * @interface UpdateTranscriptCorrectionRequest
 */
export interface UpdateTranscriptCorrectionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptCorrectionRequest
     */
    'expected_artifact_revision': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptCorrectionRequest
     */
    'expected_artifact_digest': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptCorrectionRequest
     */
    'entry_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptCorrectionRequest
     */
    'expected_effective_text': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptCorrectionRequest
     */
    'edited_text': string | null;
}
/**
 * Request model for updating user context; all fields optional for partial updates.  Syncs across all clients and feeds user context for downstream features like actions.
 * @export
 * @interface UpdateUserContextRequest
 */
export interface UpdateUserContextRequest {
    /**
     * 
     * @type {{ [key: string]: WritingSample; }}
     * @memberof UpdateUserContextRequest
     */
    'writing_samples'?: { [key: string]: WritingSample; } | null;
    /**
     * 
     * @type {{ [key: string]: PolishPrompt; }}
     * @memberof UpdateUserContextRequest
     */
    'polish_prompts'?: { [key: string]: PolishPrompt; } | null;
}
/**
 * Request model for updating a user\'s personal trial end date (internal admin).
 * @export
 * @interface UpdateUserTrialEndRequest
 */
export interface UpdateUserTrialEndRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserTrialEndRequest
     */
    'user_email': string;
    /**
     * New trial end date (YYYY-MM-DD). The date is interpreted as 23:59:59 UTC on that day; the server rejects dates whose end-of-day UTC has already passed, and caps the value at 365 days from now (UTC).
     * @type {string}
     * @memberof UpdateUserTrialEndRequest
     */
    'trial_end': string;
}
/**
 * Response model for updating a user\'s personal trial end date.
 * @export
 * @interface UpdateUserTrialEndResponse
 */
export interface UpdateUserTrialEndResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserTrialEndResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserTrialEndResponse
     */
    'user_email': string;
    /**
     * New trial end time as a Unix timestamp (seconds).
     * @type {number}
     * @memberof UpdateUserTrialEndResponse
     */
    'trial_ends_at': number;
}
/**
 * Request model for updating user roles in an enterprise.
 * @export
 * @interface UpdateUsersRoleRequest
 */
export interface UpdateUsersRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUsersRoleRequest
     */
    'email': string;
    /**
     * 
     * @type {EnterpriseRole}
     * @memberof UpdateUsersRoleRequest
     */
    'role': EnterpriseRole;
}


/**
 * Response model for bulk update users role operation.
 * @export
 * @interface UpdateUsersRoleResponse
 */
export interface UpdateUsersRoleResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateUsersRoleResponse
     */
    'updated_count': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUsersRoleResponse
     */
    'skipped_count'?: number;
    /**
     * 
     * @type {Array<FailedUpdateUserItem>}
     * @memberof UpdateUsersRoleResponse
     */
    'failed'?: Array<FailedUpdateUserItem>;
}
/**
 * Request model for setting or unlinking workos_directory_id on an enterprise.
 * @export
 * @interface UpdateWorkosDirectoryIdRequest
 */
export interface UpdateWorkosDirectoryIdRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkosDirectoryIdRequest
     */
    'workos_directory_id': string | null;
}
/**
 * Request for uploading history records.  The specific attribution platform (e.g. desktop_mac, desktop_windows) is passed as a query parameter, not in the body. Per-record platform fields only distinguish desktop/ios/android and lack OS specificity.  The destination user is the authenticated caller — never trust a client- supplied user identifier. Any extra fields (e.g. legacy clients still sending ``userId``) are silently ignored by Pydantic.
 * @export
 * @interface UploadHistoryRequest
 */
export interface UploadHistoryRequest {
    /**
     * 
     * @type {Array<Record>}
     * @memberof UploadHistoryRequest
     */
    'history': Array<Record>;
    /**
     * 
     * @type {string}
     * @memberof UploadHistoryRequest
     */
    'ga4_client_id'?: string | null;
}
/**
 * Batch upload of instruct chat sessions and route-classification records.
 * @export
 * @interface UploadInstructHistoryRequest
 */
export interface UploadInstructHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadInstructHistoryRequest
     */
    'user_id': string;
    /**
     * 
     * @type {Array<InstructChatSessionRecord>}
     * @memberof UploadInstructHistoryRequest
     */
    'instruct_chat_sessions'?: Array<InstructChatSessionRecord>;
    /**
     * 
     * @type {Array<InstructHistoryRecord>}
     * @memberof UploadInstructHistoryRequest
     */
    'instruct_history_records': Array<InstructHistoryRecord>;
}
/**
 * Result of an instruct-history upload: counts and saved ids.
 * @export
 * @interface UploadInstructHistoryResponse
 */
export interface UploadInstructHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadInstructHistoryResponse
     */
    'num_rows_saved': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadInstructHistoryResponse
     */
    'ids': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadInstructHistoryResponse
     */
    'session_ids'?: Array<string>;
}
/**
 * Bounded upload batch with an independent commit per chat.  Meeting ownership is validated for the whole batch before any write. A mid-batch conflict can leave earlier chats persisted; retry the whole batch (revisions are idempotent).
 * @export
 * @interface UploadNotetakerChatsRequest
 */
export interface UploadNotetakerChatsRequest {
    /**
     * 
     * @type {Array<NotetakerChatUpload>}
     * @memberof UploadNotetakerChatsRequest
     */
    'chats': Array<NotetakerChatUpload>;
}
/**
 * Per-chat acknowledgements for an upload batch.
 * @export
 * @interface UploadNotetakerChatsResponse
 */
export interface UploadNotetakerChatsResponse {
    /**
     * 
     * @type {Array<NotetakerChatUploadAck>}
     * @memberof UploadNotetakerChatsResponse
     */
    'chats': Array<NotetakerChatUploadAck>;
}
/**
 * Request payload for bulk-uploading polish records for a user.
 * @export
 * @interface UploadPolishRequest
 */
export interface UploadPolishRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadPolishRequest
     */
    'user_id': string;
    /**
     * 
     * @type {Array<PolishRecord>}
     * @memberof UploadPolishRequest
     */
    'polish_records': Array<PolishRecord>;
}
/**
 * Response confirming how many polish records were saved and their ids.
 * @export
 * @interface UploadPolishResponse
 */
export interface UploadPolishResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadPolishResponse
     */
    'num_rows_saved': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadPolishResponse
     */
    'ids': Array<string>;
}
/**
 * Request model for bulk-uploading voice preference records.
 * @export
 * @interface UploadUserVoicePreferencesRequest
 */
export interface UploadUserVoicePreferencesRequest {
    /**
     * 
     * @type {Array<VoicePreferenceUploadRecord>}
     * @memberof UploadUserVoicePreferencesRequest
     */
    'voice_preferences': Array<VoicePreferenceUploadRecord>;
}
/**
 * Response model confirming which voice preference records were saved.
 * @export
 * @interface UploadUserVoicePreferencesResponse
 */
export interface UploadUserVoicePreferencesResponse {
    /**
     * 
     * @type {number}
     * @memberof UploadUserVoicePreferencesResponse
     */
    'num_rows_saved': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadUserVoicePreferencesResponse
     */
    'ids': Array<string>;
}
/**
 * Request to set a shared note\'s visibility.
 * @export
 * @interface UpsertShareRequest
 */
export interface UpsertShareRequest {
    /**
     * 
     * @type {NoteVisibility}
     * @memberof UpsertShareRequest
     */
    'visibility': NoteVisibility;
}


/**
 * 
 * @export
 * @interface UsedProvider
 */
export interface UsedProvider {
    /**
     * 
     * @type {string}
     * @memberof UsedProvider
     */
    'kind'?: UsedProviderKindEnum;
    /**
     * 
     * @type {Model}
     * @memberof UsedProvider
     */
    'model': Model;
    /**
     * 
     * @type {Array<string>}
     * @memberof UsedProvider
     */
    'provider_order'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UsedProvider
     */
    'allow_fallbacks'?: boolean;
}

export const UsedProviderKindEnum = {
    Anthropic: 'anthropic'
} as const;

export type UsedProviderKindEnum = typeof UsedProviderKindEnum[keyof typeof UsedProviderKindEnum];

/**
 * Response model for user context.
 * @export
 * @interface UserContextResponse
 */
export interface UserContextResponse {
    /**
     * 
     * @type {string}
     * @memberof UserContextResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserContextResponse
     */
    'user_id': string;
    /**
     * 
     * @type {{ [key: string]: WritingSample; }}
     * @memberof UserContextResponse
     */
    'writing_samples'?: { [key: string]: WritingSample; } | null;
    /**
     * 
     * @type {{ [key: string]: PolishPrompt; }}
     * @memberof UserContextResponse
     */
    'polish_prompts'?: { [key: string]: PolishPrompt; } | null;
    /**
     * 
     * @type {string}
     * @memberof UserContextResponse
     */
    'modified_at': string;
}
/**
 * Entitlement values exposed to the current user.
 * @export
 * @interface UserEntitlements
 */
export interface UserEntitlements {
    /**
     * 
     * @type {boolean}
     * @memberof UserEntitlements
     */
    'notetaker'?: boolean | null;
}
/**
 * Current per-user entitlement snapshot.
 * @export
 * @interface UserEntitlementsResponse
 */
export interface UserEntitlementsResponse {
    /**
     * 
     * @type {UserEntitlements}
     * @memberof UserEntitlementsResponse
     */
    'entitlements': UserEntitlements;
}
/**
 * A selectable user in the insights typeahead filter.
 * @export
 * @interface UserFilterOption
 */
export interface UserFilterOption {
    /**
     * 
     * @type {string}
     * @memberof UserFilterOption
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserFilterOption
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserFilterOption
     */
    'email'?: string | null;
}
/**
 * Per-keystroke typeahead — separate from FilterOptionsResponse due to different caching and rate-limit profile.
 * @export
 * @interface UserFilterOptionsResponse
 */
export interface UserFilterOptionsResponse {
    /**
     * 
     * @type {Array<UserFilterOption>}
     * @memberof UserFilterOptionsResponse
     */
    'users': Array<UserFilterOption>;
    /**
     * 
     * @type {boolean}
     * @memberof UserFilterOptionsResponse
     */
    'has_more'?: boolean;
}
/**
 * Input for a single user in bulk add operations.
 * @export
 * @interface UserInput
 */
export interface UserInput {
    /**
     * 
     * @type {string}
     * @memberof UserInput
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserInput
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserInput
     */
    'last_name'?: string | null;
}
/**
 * A paginated list of user-metadata rows.
 * @export
 * @interface UserMetadataListResponse
 */
export interface UserMetadataListResponse {
    /**
     * 
     * @type {Array<UserMetadataResponse>}
     * @memberof UserMetadataListResponse
     */
    'rows': Array<UserMetadataResponse>;
    /**
     * 
     * @type {PaginationMetadata}
     * @memberof UserMetadataListResponse
     */
    'pagination': PaginationMetadata;
}
/**
 * Request body for querying user metadata with large UUID lists.
 * @export
 * @interface UserMetadataQueryRequest
 */
export interface UserMetadataQueryRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserMetadataQueryRequest
     */
    'uuids'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataQueryRequest
     */
    'start_time': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataQueryRequest
     */
    'end_time': string;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataQueryRequest
     */
    'page_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataQueryRequest
     */
    'page_number'?: number;
}
/**
 * Request model for ingesting user metadata into ClickHouse.
 * @export
 * @interface UserMetadataRequest
 */
export interface UserMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'event_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'modified_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'enriched_linked_in_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'enriched_job_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'industry'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataRequest
     */
    'employee_count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataRequest
     */
    'founded'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'locality'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'work_email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataRequest
     */
    'fundraising'?: string | null;
}
/**
 * A single user-metadata row returned from ClickHouse.
 * @export
 * @interface UserMetadataResponse
 */
export interface UserMetadataResponse {
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'metadata_date': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'enriched_linked_in_url': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'enriched_job_title': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'website': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'industry': string;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataResponse
     */
    'employee_count': number;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'locality': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof UserMetadataResponse
     */
    'founded': number;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'work_email': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'fundraising': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'modified_at': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'event_type': string;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponse
     */
    'id': string;
}
/**
 * A preferences update paired with its client-supplied modification timestamp.
 * @export
 * @interface UserPreference
 */
export interface UserPreference {
    /**
     * 
     * @type {UserPreferencesUpdate}
     * @memberof UserPreference
     */
    'preferences': UserPreferencesUpdate;
    /**
     * 
     * @type {string}
     * @memberof UserPreference
     */
    'modified_at'?: string | null;
}
/**
 * Full snapshot of a user\'s synced preferences (privacy, languages, personalization, onboarding).
 * @export
 * @interface UserPreferences
 */
export interface UserPreferences {
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'onboarding_role'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'onboarding_industry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'dictation_onboarding_reentry_completed_at'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'privacy_mode'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'share_data'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'cloud_sync'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'share_global_profile'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'teammates_added_digest_enabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserPreferences
     */
    'output_languages'?: Array<UserPreferencesOutputLanguagesEnum>;
    /**
     * 
     * @type {PersonalizationStyles}
     * @memberof UserPreferences
     */
    'personalization_styles'?: PersonalizationStyles;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferences
     */
    'personalizationOnboardingCompleted'?: boolean;
    /**
     * 
     * @type {PolishInstructions}
     * @memberof UserPreferences
     */
    'polish_instructions'?: PolishInstructions;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'auto_cleanup_level'?: UserPreferencesAutoCleanupLevelEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'local_data_policy'?: UserPreferencesLocalDataPolicyEnum | null;
    /**
     * 
     * @type {NotetakerTranscriptRetention}
     * @memberof UserPreferences
     */
    'notetaker_transcript_retention'?: NotetakerTranscriptRetention;
    /**
     * 
     * @type {NotetakerPreference}
     * @memberof UserPreferences
     */
    'notetaker_preference'?: NotetakerPreference;
    /**
     * 
     * @type {Array<OnboardingIntent>}
     * @memberof UserPreferences
     */
    'fulfilled_intents'?: Array<OnboardingIntent>;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'ui_locale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferences
     */
    'email_locale'?: string | null;
}

export const UserPreferencesOutputLanguagesEnum = {
    Empty: '',
    En: 'en',
    Engb: 'engb',
    Enca: 'enca',
    Zh: 'zh',
    Zhcn: 'zhcn',
    De: 'de',
    Dech: 'dech',
    Es: 'es',
    Ru: 'ru',
    Ko: 'ko',
    Fr: 'fr',
    Ja: 'ja',
    Pt: 'pt',
    Tr: 'tr',
    Pl: 'pl',
    Ca: 'ca',
    Nl: 'nl',
    Ar: 'ar',
    Sv: 'sv',
    It: 'it',
    Id: 'id',
    Hi: 'hi',
    Hien: 'hien',
    Fi: 'fi',
    Vi: 'vi',
    He: 'he',
    Uk: 'uk',
    El: 'el',
    Ms: 'ms',
    Cs: 'cs',
    Ro: 'ro',
    Da: 'da',
    Hu: 'hu',
    Ta: 'ta',
    No: 'no',
    Th: 'th',
    Ur: 'ur',
    Hr: 'hr',
    Bg: 'bg',
    Lt: 'lt',
    La: 'la',
    Mi: 'mi',
    Ml: 'ml',
    Cy: 'cy',
    Sk: 'sk',
    Te: 'te',
    Fa: 'fa',
    Lv: 'lv',
    Bn: 'bn',
    Sr: 'sr',
    Az: 'az',
    Sl: 'sl',
    Kn: 'kn',
    Et: 'et',
    Mk: 'mk',
    Br: 'br',
    Eu: 'eu',
    Is: 'is',
    Hy: 'hy',
    Ne: 'ne',
    Mn: 'mn',
    Bs: 'bs',
    Kk: 'kk',
    Sq: 'sq',
    Sw: 'sw',
    Gl: 'gl',
    Mr: 'mr',
    Pa: 'pa',
    Si: 'si',
    Km: 'km',
    Sn: 'sn',
    Yo: 'yo',
    So: 'so',
    Af: 'af',
    Oc: 'oc',
    Ka: 'ka',
    Be: 'be',
    Tg: 'tg',
    Sd: 'sd',
    Gu: 'gu',
    Am: 'am',
    Yi: 'yi',
    Lo: 'lo',
    Uz: 'uz',
    Fo: 'fo',
    Ht: 'ht',
    Ps: 'ps',
    Tk: 'tk',
    Nn: 'nn',
    Mt: 'mt',
    Sa: 'sa',
    Lb: 'lb',
    My: 'my',
    Bo: 'bo',
    Tl: 'tl',
    Mg: 'mg',
    As: 'as',
    Tt: 'tt',
    Haw: 'haw',
    Ln: 'ln',
    Ha: 'ha',
    Ba: 'ba',
    Jv: 'jv',
    Su: 'su',
    Yue: 'yue'
} as const;

export type UserPreferencesOutputLanguagesEnum = typeof UserPreferencesOutputLanguagesEnum[keyof typeof UserPreferencesOutputLanguagesEnum];
export const UserPreferencesAutoCleanupLevelEnum = {
    None: 'none',
    Light: 'light',
    Medium: 'medium',
    High: 'high',
    Full: 'full'
} as const;

export type UserPreferencesAutoCleanupLevelEnum = typeof UserPreferencesAutoCleanupLevelEnum[keyof typeof UserPreferencesAutoCleanupLevelEnum];
export const UserPreferencesLocalDataPolicyEnum = {
    StoreNormally: 'store_normally',
    DeleteAfter24h: 'delete_after_24h',
    NeverStore: 'never_store'
} as const;

export type UserPreferencesLocalDataPolicyEnum = typeof UserPreferencesLocalDataPolicyEnum[keyof typeof UserPreferencesLocalDataPolicyEnum];

/**
 * Partial update to user preferences.  All fields are optional but when present must follow the same validation rules as UserPreferences.
 * @export
 * @interface UserPreferencesUpdate
 */
export interface UserPreferencesUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'privacy_mode'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'share_data'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'cloud_sync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'share_global_profile'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'teammates_added_digest_enabled'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserPreferencesUpdate
     */
    'output_languages'?: Array<UserPreferencesUpdateOutputLanguagesEnum> | null;
    /**
     * 
     * @type {PersonalizationStyles}
     * @memberof UserPreferencesUpdate
     */
    'personalization_styles'?: PersonalizationStyles | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPreferencesUpdate
     */
    'personalizationOnboardingCompleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesUpdate
     */
    'dictation_onboarding_reentry_completed_at'?: string | null;
    /**
     * 
     * @type {PolishInstructions}
     * @memberof UserPreferencesUpdate
     */
    'polish_instructions'?: PolishInstructions | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesUpdate
     */
    'auto_cleanup_level'?: UserPreferencesUpdateAutoCleanupLevelEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesUpdate
     */
    'local_data_policy'?: UserPreferencesUpdateLocalDataPolicyEnum | null;
    /**
     * 
     * @type {NotetakerTranscriptRetention}
     * @memberof UserPreferencesUpdate
     */
    'notetaker_transcript_retention'?: NotetakerTranscriptRetention | null;
    /**
     * 
     * @type {NotetakerPreferenceUpdate}
     * @memberof UserPreferencesUpdate
     */
    'notetaker_preference'?: NotetakerPreferenceUpdate | null;
    /**
     * 
     * @type {Array<OnboardingIntent>}
     * @memberof UserPreferencesUpdate
     */
    'fulfilled_intents'?: Array<OnboardingIntent> | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesUpdate
     */
    'ui_locale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPreferencesUpdate
     */
    'email_locale'?: string | null;
}

export const UserPreferencesUpdateOutputLanguagesEnum = {
    Empty: '',
    En: 'en',
    Engb: 'engb',
    Enca: 'enca',
    Zh: 'zh',
    Zhcn: 'zhcn',
    De: 'de',
    Dech: 'dech',
    Es: 'es',
    Ru: 'ru',
    Ko: 'ko',
    Fr: 'fr',
    Ja: 'ja',
    Pt: 'pt',
    Tr: 'tr',
    Pl: 'pl',
    Ca: 'ca',
    Nl: 'nl',
    Ar: 'ar',
    Sv: 'sv',
    It: 'it',
    Id: 'id',
    Hi: 'hi',
    Hien: 'hien',
    Fi: 'fi',
    Vi: 'vi',
    He: 'he',
    Uk: 'uk',
    El: 'el',
    Ms: 'ms',
    Cs: 'cs',
    Ro: 'ro',
    Da: 'da',
    Hu: 'hu',
    Ta: 'ta',
    No: 'no',
    Th: 'th',
    Ur: 'ur',
    Hr: 'hr',
    Bg: 'bg',
    Lt: 'lt',
    La: 'la',
    Mi: 'mi',
    Ml: 'ml',
    Cy: 'cy',
    Sk: 'sk',
    Te: 'te',
    Fa: 'fa',
    Lv: 'lv',
    Bn: 'bn',
    Sr: 'sr',
    Az: 'az',
    Sl: 'sl',
    Kn: 'kn',
    Et: 'et',
    Mk: 'mk',
    Br: 'br',
    Eu: 'eu',
    Is: 'is',
    Hy: 'hy',
    Ne: 'ne',
    Mn: 'mn',
    Bs: 'bs',
    Kk: 'kk',
    Sq: 'sq',
    Sw: 'sw',
    Gl: 'gl',
    Mr: 'mr',
    Pa: 'pa',
    Si: 'si',
    Km: 'km',
    Sn: 'sn',
    Yo: 'yo',
    So: 'so',
    Af: 'af',
    Oc: 'oc',
    Ka: 'ka',
    Be: 'be',
    Tg: 'tg',
    Sd: 'sd',
    Gu: 'gu',
    Am: 'am',
    Yi: 'yi',
    Lo: 'lo',
    Uz: 'uz',
    Fo: 'fo',
    Ht: 'ht',
    Ps: 'ps',
    Tk: 'tk',
    Nn: 'nn',
    Mt: 'mt',
    Sa: 'sa',
    Lb: 'lb',
    My: 'my',
    Bo: 'bo',
    Tl: 'tl',
    Mg: 'mg',
    As: 'as',
    Tt: 'tt',
    Haw: 'haw',
    Ln: 'ln',
    Ha: 'ha',
    Ba: 'ba',
    Jv: 'jv',
    Su: 'su',
    Yue: 'yue'
} as const;

export type UserPreferencesUpdateOutputLanguagesEnum = typeof UserPreferencesUpdateOutputLanguagesEnum[keyof typeof UserPreferencesUpdateOutputLanguagesEnum];
export const UserPreferencesUpdateAutoCleanupLevelEnum = {
    None: 'none',
    Light: 'light',
    Medium: 'medium',
    High: 'high',
    Full: 'full'
} as const;

export type UserPreferencesUpdateAutoCleanupLevelEnum = typeof UserPreferencesUpdateAutoCleanupLevelEnum[keyof typeof UserPreferencesUpdateAutoCleanupLevelEnum];
export const UserPreferencesUpdateLocalDataPolicyEnum = {
    StoreNormally: 'store_normally',
    DeleteAfter24h: 'delete_after_24h',
    NeverStore: 'never_store'
} as const;

export type UserPreferencesUpdateLocalDataPolicyEnum = typeof UserPreferencesUpdateLocalDataPolicyEnum[keyof typeof UserPreferencesUpdateLocalDataPolicyEnum];

/**
 * User profile information (name fields).  Kept separate from UserPreference in case we add more profile-related fields in the future.
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'last_name'?: string | null;
}
/**
 * User profile returned to the client: name, email, user id and avatar.
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'user_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'avatar_url'?: string | null;
}
/**
 * A user turn in a transform trajectory.
 * @export
 * @interface UserPromptStep
 */
export interface UserPromptStep {
    /**
     * 
     * @type {string}
     * @memberof UserPromptStep
     */
    'kind'?: UserPromptStepKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UserPromptStep
     */
    'message': string;
}

export const UserPromptStepKindEnum = {
    UserPrompt: 'user_prompt'
} as const;

export type UserPromptStepKindEnum = typeof UserPromptStepKindEnum[keyof typeof UserPromptStepKindEnum];

/**
 * Whether the caller can keep their own skills, and how many.
 * @export
 * @interface UserSkillsSupport
 */
export interface UserSkillsSupport {
    /**
     * 
     * @type {boolean}
     * @memberof UserSkillsSupport
     */
    'supported': boolean;
    /**
     * How many skills one user may keep; a create beyond it is refused with 409 `limit_reached`.
     * @type {number}
     * @memberof UserSkillsSupport
     */
    'max': number;
}
/**
 * Aggregated dictation usage stats for a user, split by platform with leaderboard ranks.
 * @export
 * @interface UserStats
 */
export interface UserStats {
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'total_words'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'total_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'total_non_empty_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'words_per_minute'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'week_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'day_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'words_this_week'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserStats
     */
    'last_transcript_timestamp'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_total_words'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_total_words'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_total_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_total_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_total_non_empty_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_total_non_empty_duration'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_words_per_minute'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_words_per_minute'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_day_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_day_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_week_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_week_streak'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_words_this_week'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_words_this_week'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserStats
     */
    'desktop_last_transcript_timestamp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserStats
     */
    'mobile_last_transcript_timestamp'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserStats
     */
    'total_apps'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserStats
     */
    'desktop_total_apps'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserStats
     */
    'mobile_total_apps'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'first_weekly_limit_hit_at'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'total_words_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_words_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_words_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'words_per_minute_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'day_streak_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'words_this_week_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'desktop_words_this_week_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'mobile_words_this_week_rank'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserStats
     */
    'words_this_week_rank_change'?: number | null;
}
/**
 * Account-existence and auth-provider status for a queried email.
 * @export
 * @interface UserStatusResponse
 */
export interface UserStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserStatusResponse
     */
    'exists': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserStatusResponse
     */
    'provider': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserStatusResponse
     */
    'verified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserStatusResponse
     */
    'enforce_sso': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserStatusResponse
     */
    'scim_managed': boolean;
}
/**
 * Caller\'s stats from their most recent attempt (or just-submitted attempt).
 * @export
 * @interface UserTypingTestStats
 */
export interface UserTypingTestStats {
    /**
     * 
     * @type {number}
     * @memberof UserTypingTestStats
     */
    'typing_wpm': number;
    /**
     * 
     * @type {number}
     * @memberof UserTypingTestStats
     */
    'typing_accuracy': number;
    /**
     * 
     * @type {number}
     * @memberof UserTypingTestStats
     */
    'voice_wpm'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserTypingTestStats
     */
    'voice_accuracy'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTypingTestStats
     */
    'is_new_best': boolean;
}
/**
 * UTM attribution parameters carried through signup.
 * @export
 * @interface UtmParams
 */
export interface UtmParams {
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_medium'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UtmParams
     */
    'utm_campaign'?: string | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'input'?: any;
    /**
     * 
     * @type {object}
     * @memberof ValidationError
     */
    'ctx'?: object;
}
/**
 * The user\'s value for this metric (e.g. word count, day streak, or words-per-minute). Integer for counts/streaks; float for WPM.
 * @export
 * @interface Value
 */
export interface Value {
}
/**
 * Inputs for the Impact tab ROI widget.  ``monthly_minutes_saved`` is the team total over a trailing 30d window. Frontend derives per-user as ``monthly_minutes_saved / team_member_count`` and team value as ``(monthly_minutes_saved / 60) * salary_rate`` — shipping the total (not pre-divided) keeps per-user rounding from amplifying by team size.  ``monthly_cost_minor_units`` is the enterprise\'s normalized post-discount monthly recurring spend, in Stripe minor units (cents for USD, yen for JPY — divide by ``10 ** Intl.NumberFormat(...).resolvedOptions().maximumFractionDigits``). ``currency`` is the Stripe-lowercase ISO 4217 code. ``monthly_cost_minor_units`` is null when we can\'t compute the cost (no live sub, Stripe error). ``currency`` falls back to the DB-cached billing currency on Stripe errors so the FE stays currency-locked across transient blips.
 * @export
 * @interface ValueCalculator
 */
export interface ValueCalculator {
    /**
     * 
     * @type {number}
     * @memberof ValueCalculator
     */
    'team_member_count': number;
    /**
     * 
     * @type {number}
     * @memberof ValueCalculator
     */
    'monthly_minutes_saved': number;
    /**
     * 
     * @type {number}
     * @memberof ValueCalculator
     */
    'monthly_cost_minor_units': number | null;
    /**
     * 
     * @type {string}
     * @memberof ValueCalculator
     */
    'currency': string | null;
}
/**
 * Complete WorkOS email verification with an opaque challenge and six-digit code.
 * @export
 * @interface VerifyEmailOtpRequest
 */
export interface VerifyEmailOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailOtpRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyEmailOtpRequest
     */
    'pending_authentication_token': string;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyEmailOtpRequest
     */
    'should_complete_signup'?: boolean;
}
/**
 * @type VoiceActionEvent
 * @export
 */
export type VoiceActionEvent = { type: 'done' } & VoiceActionsDone | { type: 'error' } & VoiceActionsError | { type: 'pong' } & VoiceActionsPong | { type: 'session.ready' } & VoiceActionsSessionReady | { type: 'text.delta' } & VoiceActionsTextDelta | { type: 'text.final' } & VoiceActionsTextFinal | { type: 'tool.call' } & VoiceActionsToolCall | { type: 'transcript.delta' } & VoiceActionsTranscriptDelta | { type: 'transcript.final' } & VoiceActionsTranscriptFinal;

/**
 * @type VoiceActionFrame
 * @export
 */
export type VoiceActionFrame = { type: 'audio.append' } & VoiceActionsAudioAppend | { type: 'audio.commit' } & VoiceActionsAudioCommit | { type: 'ping' } & VoiceActionsPing | { type: 'session.close' } & VoiceActionsSessionClose | { type: 'session.start' } & VoiceActionsSessionStart | { type: 'session.update' } & VoiceActionsSessionUpdate | { type: 'text.input' } & VoiceActionsTextInput | { type: 'tool.result' } & VoiceActionsToolResult;

/**
 * A tool the client exposes to the model for this voice-actions session.
 * @export
 * @interface VoiceActionToolDefinition
 */
export interface VoiceActionToolDefinition {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionToolDefinition
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionToolDefinition
     */
    'description'?: string;
    /**
     * 
     * @type {object}
     * @memberof VoiceActionToolDefinition
     */
    'parameters'?: object;
}
/**
 * Client frame appending a chunk of PCM16 audio to the session\'s input buffer.
 * @export
 * @interface VoiceActionsAudioAppend
 */
export interface VoiceActionsAudioAppend {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsAudioAppend
     */
    'type': VoiceActionsAudioAppendTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsAudioAppend
     */
    'audio': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsAudioAppend
     */
    'encoding'?: VoiceActionsAudioAppendEncodingEnum;
    /**
     * 
     * @type {number}
     * @memberof VoiceActionsAudioAppend
     */
    'sample_rate'?: VoiceActionsAudioAppendSampleRateEnum;
    /**
     * 
     * @type {number}
     * @memberof VoiceActionsAudioAppend
     */
    'channels'?: VoiceActionsAudioAppendChannelsEnum;
    /**
     * 
     * @type {number}
     * @memberof VoiceActionsAudioAppend
     */
    'position'?: number | null;
}

export const VoiceActionsAudioAppendTypeEnum = {
    AudioAppend: 'audio.append'
} as const;

export type VoiceActionsAudioAppendTypeEnum = typeof VoiceActionsAudioAppendTypeEnum[keyof typeof VoiceActionsAudioAppendTypeEnum];
export const VoiceActionsAudioAppendEncodingEnum = {
    Pcm16: 'pcm16'
} as const;

export type VoiceActionsAudioAppendEncodingEnum = typeof VoiceActionsAudioAppendEncodingEnum[keyof typeof VoiceActionsAudioAppendEncodingEnum];
export const VoiceActionsAudioAppendSampleRateEnum = {
    NUMBER_24000: 24000
} as const;

export type VoiceActionsAudioAppendSampleRateEnum = typeof VoiceActionsAudioAppendSampleRateEnum[keyof typeof VoiceActionsAudioAppendSampleRateEnum];
export const VoiceActionsAudioAppendChannelsEnum = {
    NUMBER_1: 1
} as const;

export type VoiceActionsAudioAppendChannelsEnum = typeof VoiceActionsAudioAppendChannelsEnum[keyof typeof VoiceActionsAudioAppendChannelsEnum];

/**
 * Client frame committing the buffered audio and requesting a model response.
 * @export
 * @interface VoiceActionsAudioCommit
 */
export interface VoiceActionsAudioCommit {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsAudioCommit
     */
    'type': VoiceActionsAudioCommitTypeEnum;
}

export const VoiceActionsAudioCommitTypeEnum = {
    AudioCommit: 'audio.commit'
} as const;

export type VoiceActionsAudioCommitTypeEnum = typeof VoiceActionsAudioCommitTypeEnum[keyof typeof VoiceActionsAudioCommitTypeEnum];

/**
 * Envelope wrapping a single discriminated client frame.
 * @export
 * @interface VoiceActionsClientFrameEnvelope
 */
export interface VoiceActionsClientFrameEnvelope {
    /**
     * 
     * @type {VoiceActionFrame}
     * @memberof VoiceActionsClientFrameEnvelope
     */
    'voice_action_frame': VoiceActionFrame;
}
/**
 * Server frame signaling the model response turn is complete.
 * @export
 * @interface VoiceActionsDone
 */
export interface VoiceActionsDone {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsDone
     */
    'type': VoiceActionsDoneTypeEnum;
}

export const VoiceActionsDoneTypeEnum = {
    Done: 'done'
} as const;

export type VoiceActionsDoneTypeEnum = typeof VoiceActionsDoneTypeEnum[keyof typeof VoiceActionsDoneTypeEnum];

/**
 * Server frame reporting an error during the session.
 * @export
 * @interface VoiceActionsError
 */
export interface VoiceActionsError {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsError
     */
    'type': VoiceActionsErrorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsError
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsError
     */
    'code'?: string | null;
}

export const VoiceActionsErrorTypeEnum = {
    Error: 'error'
} as const;

export type VoiceActionsErrorTypeEnum = typeof VoiceActionsErrorTypeEnum[keyof typeof VoiceActionsErrorTypeEnum];

/**
 * Client keepalive frame; the server answers with a pong.
 * @export
 * @interface VoiceActionsPing
 */
export interface VoiceActionsPing {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsPing
     */
    'type': VoiceActionsPingTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsPing
     */
    'ts'?: string | null;
}

export const VoiceActionsPingTypeEnum = {
    Ping: 'ping'
} as const;

export type VoiceActionsPingTypeEnum = typeof VoiceActionsPingTypeEnum[keyof typeof VoiceActionsPingTypeEnum];

/**
 * Server keepalive frame answering a client ping.
 * @export
 * @interface VoiceActionsPong
 */
export interface VoiceActionsPong {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsPong
     */
    'type': VoiceActionsPongTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsPong
     */
    'ts'?: string | null;
}

export const VoiceActionsPongTypeEnum = {
    Pong: 'pong'
} as const;

export type VoiceActionsPongTypeEnum = typeof VoiceActionsPongTypeEnum[keyof typeof VoiceActionsPongTypeEnum];

/**
 * Envelope wrapping a single discriminated server frame.
 * @export
 * @interface VoiceActionsServerFrameEnvelope
 */
export interface VoiceActionsServerFrameEnvelope {
    /**
     * 
     * @type {VoiceActionEvent}
     * @memberof VoiceActionsServerFrameEnvelope
     */
    'voice_action_event': VoiceActionEvent;
}
/**
 * Client frame that closes the voice-actions session.
 * @export
 * @interface VoiceActionsSessionClose
 */
export interface VoiceActionsSessionClose {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionClose
     */
    'type': VoiceActionsSessionCloseTypeEnum;
}

export const VoiceActionsSessionCloseTypeEnum = {
    SessionClose: 'session.close'
} as const;

export type VoiceActionsSessionCloseTypeEnum = typeof VoiceActionsSessionCloseTypeEnum[keyof typeof VoiceActionsSessionCloseTypeEnum];

/**
 * Server frame confirming the session is open, naming the provider and model.
 * @export
 * @interface VoiceActionsSessionReady
 */
export interface VoiceActionsSessionReady {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionReady
     */
    'type': VoiceActionsSessionReadyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionReady
     */
    'provider'?: VoiceActionsSessionReadyProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionReady
     */
    'model': string;
}

export const VoiceActionsSessionReadyTypeEnum = {
    SessionReady: 'session.ready'
} as const;

export type VoiceActionsSessionReadyTypeEnum = typeof VoiceActionsSessionReadyTypeEnum[keyof typeof VoiceActionsSessionReadyTypeEnum];
export const VoiceActionsSessionReadyProviderEnum = {
    Openai: 'openai'
} as const;

export type VoiceActionsSessionReadyProviderEnum = typeof VoiceActionsSessionReadyProviderEnum[keyof typeof VoiceActionsSessionReadyProviderEnum];

/**
 * Client frame that opens a voice-actions session with instructions, tools, and context.
 * @export
 * @interface VoiceActionsSessionStart
 */
export interface VoiceActionsSessionStart {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionStart
     */
    'type': VoiceActionsSessionStartTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionStart
     */
    'instructions'?: string;
    /**
     * 
     * @type {Array<VoiceActionToolDefinition>}
     * @memberof VoiceActionsSessionStart
     */
    'tools'?: Array<VoiceActionToolDefinition>;
    /**
     * 
     * @type {object}
     * @memberof VoiceActionsSessionStart
     */
    'context'?: object;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionStart
     */
    'model'?: string | null;
}

export const VoiceActionsSessionStartTypeEnum = {
    SessionStart: 'session.start'
} as const;

export type VoiceActionsSessionStartTypeEnum = typeof VoiceActionsSessionStartTypeEnum[keyof typeof VoiceActionsSessionStartTypeEnum];

/**
 * Refresh the desktop context mid-session (app/textbox/AX context lands after session.start).
 * @export
 * @interface VoiceActionsSessionUpdate
 */
export interface VoiceActionsSessionUpdate {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsSessionUpdate
     */
    'type': VoiceActionsSessionUpdateTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof VoiceActionsSessionUpdate
     */
    'context'?: object;
}

export const VoiceActionsSessionUpdateTypeEnum = {
    SessionUpdate: 'session.update'
} as const;

export type VoiceActionsSessionUpdateTypeEnum = typeof VoiceActionsSessionUpdateTypeEnum[keyof typeof VoiceActionsSessionUpdateTypeEnum];

/**
 * Server frame carrying an incremental chunk of the model\'s text response.
 * @export
 * @interface VoiceActionsTextDelta
 */
export interface VoiceActionsTextDelta {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextDelta
     */
    'type': VoiceActionsTextDeltaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextDelta
     */
    'text': string;
}

export const VoiceActionsTextDeltaTypeEnum = {
    TextDelta: 'text.delta'
} as const;

export type VoiceActionsTextDeltaTypeEnum = typeof VoiceActionsTextDeltaTypeEnum[keyof typeof VoiceActionsTextDeltaTypeEnum];

/**
 * Server frame carrying the finalized model text response.
 * @export
 * @interface VoiceActionsTextFinal
 */
export interface VoiceActionsTextFinal {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextFinal
     */
    'type': VoiceActionsTextFinalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextFinal
     */
    'text': string;
}

export const VoiceActionsTextFinalTypeEnum = {
    TextFinal: 'text.final'
} as const;

export type VoiceActionsTextFinalTypeEnum = typeof VoiceActionsTextFinalTypeEnum[keyof typeof VoiceActionsTextFinalTypeEnum];

/**
 * Final transcript from the client\'s own ASR pipeline; triggers a model response.
 * @export
 * @interface VoiceActionsTextInput
 */
export interface VoiceActionsTextInput {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextInput
     */
    'type': VoiceActionsTextInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTextInput
     */
    'text': string;
}

export const VoiceActionsTextInputTypeEnum = {
    TextInput: 'text.input'
} as const;

export type VoiceActionsTextInputTypeEnum = typeof VoiceActionsTextInputTypeEnum[keyof typeof VoiceActionsTextInputTypeEnum];

/**
 * Server frame requesting the client invoke a tool with the given arguments.
 * @export
 * @interface VoiceActionsToolCall
 */
export interface VoiceActionsToolCall {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsToolCall
     */
    'type': VoiceActionsToolCallTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsToolCall
     */
    'call_id': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsToolCall
     */
    'name': string;
    /**
     * 
     * @type {object}
     * @memberof VoiceActionsToolCall
     */
    'arguments': object;
}

export const VoiceActionsToolCallTypeEnum = {
    ToolCall: 'tool.call'
} as const;

export type VoiceActionsToolCallTypeEnum = typeof VoiceActionsToolCallTypeEnum[keyof typeof VoiceActionsToolCallTypeEnum];

/**
 * Client frame returning the result of a tool call the model requested.
 * @export
 * @interface VoiceActionsToolResult
 */
export interface VoiceActionsToolResult {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsToolResult
     */
    'type': VoiceActionsToolResultTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsToolResult
     */
    'call_id': string;
    /**
     * 
     * @type {any}
     * @memberof VoiceActionsToolResult
     */
    'output': any;
}

export const VoiceActionsToolResultTypeEnum = {
    ToolResult: 'tool.result'
} as const;

export type VoiceActionsToolResultTypeEnum = typeof VoiceActionsToolResultTypeEnum[keyof typeof VoiceActionsToolResultTypeEnum];

/**
 * Server frame carrying an incremental chunk of the input transcript.
 * @export
 * @interface VoiceActionsTranscriptDelta
 */
export interface VoiceActionsTranscriptDelta {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTranscriptDelta
     */
    'type': VoiceActionsTranscriptDeltaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTranscriptDelta
     */
    'text': string;
}

export const VoiceActionsTranscriptDeltaTypeEnum = {
    TranscriptDelta: 'transcript.delta'
} as const;

export type VoiceActionsTranscriptDeltaTypeEnum = typeof VoiceActionsTranscriptDeltaTypeEnum[keyof typeof VoiceActionsTranscriptDeltaTypeEnum];

/**
 * Server frame carrying the finalized input transcript.
 * @export
 * @interface VoiceActionsTranscriptFinal
 */
export interface VoiceActionsTranscriptFinal {
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTranscriptFinal
     */
    'type': VoiceActionsTranscriptFinalTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VoiceActionsTranscriptFinal
     */
    'text': string;
}

export const VoiceActionsTranscriptFinalTypeEnum = {
    TranscriptFinal: 'transcript.final'
} as const;

export type VoiceActionsTranscriptFinalTypeEnum = typeof VoiceActionsTranscriptFinalTypeEnum[keyof typeof VoiceActionsTranscriptFinalTypeEnum];

/**
 * A voice preference row returned from GET /user_voice_preferences.
 * @export
 * @interface VoicePreferenceRecord
 */
export interface VoicePreferenceRecord {
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceRecord
     */
    'preference': string;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceRecord
     */
    'filter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceRecord
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceRecord
     */
    'modified_at': string;
}
/**
 * A single voice preference record uploaded from the desktop client.  `filter` is the LLM-derived scope string (e.g. \"app:gmail-language:de\"). `None` means a general preference that is not scoped to any dimension.
 * @export
 * @interface VoicePreferenceUploadRecord
 */
export interface VoicePreferenceUploadRecord {
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceUploadRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceUploadRecord
     */
    'preference': string;
    /**
     * 
     * @type {string}
     * @memberof VoicePreferenceUploadRecord
     */
    'filter'?: string | null;
}
/**
 * Processing state of a user\'s voice profile generation.
 * @export
 * @enum {string}
 */

export const VoiceProfileProcessingStatus = {
    NotStarted: 'NOT_STARTED',
    Processing: 'PROCESSING',
    Complete: 'COMPLETE',
    Failed: 'FAILED'
} as const;

export type VoiceProfileProcessingStatus = typeof VoiceProfileProcessingStatus[keyof typeof VoiceProfileProcessingStatus];


/**
 * A resolved team or personal Transforms voice profile for the requesting user.
 * @export
 * @interface VoiceProfilePromptEntry
 */
export interface VoiceProfilePromptEntry {
    /**
     * 
     * @type {string}
     * @memberof VoiceProfilePromptEntry
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfilePromptEntry
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfilePromptEntry
     */
    'prompt': string;
}
/**
 * Per-user Transforms voice profiles (prompt + display metadata).  ``team`` / ``personal`` are the resolved profiles for the requesting user, or ``None`` when they don\'t belong to a configured profile. The desktop ``transforms-personal-profile`` flag is a boolean gate only — when on, the client fetches this endpoint and shows whichever of ``team`` / ``personal`` are non-null (both when the user matches both).
 * @export
 * @interface VoiceProfilePromptsResponse
 */
export interface VoiceProfilePromptsResponse {
    /**
     * 
     * @type {VoiceProfilePromptEntry}
     * @memberof VoiceProfilePromptsResponse
     */
    'team'?: VoiceProfilePromptEntry | null;
    /**
     * 
     * @type {VoiceProfilePromptEntry}
     * @memberof VoiceProfilePromptsResponse
     */
    'personal'?: VoiceProfilePromptEntry | null;
}
/**
 * Request to build a voice profile from history rows plus peak-usage and word-frequency hints.
 * @export
 * @interface VoiceProfileRequest
 */
export interface VoiceProfileRequest {
    /**
     * 
     * @type {boolean}
     * @memberof VoiceProfileRequest
     */
    'privacy_mode': boolean;
    /**
     * 
     * @type {Array<HistoryRow>}
     * @memberof VoiceProfileRequest
     */
    'history_rows': Array<HistoryRow>;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileRequest
     */
    'timezone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileRequest
     */
    'peak_time_label': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileRequest
     */
    'peak_time_top_app': string;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileRequest
     */
    'most_used_word'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileRequest
     */
    'most_removed_word'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceProfileRequest
     */
    'word_count_milestone'?: VoiceProfileRequestWordCountMilestoneEnum | null;
}

export const VoiceProfileRequestWordCountMilestoneEnum = {
    NUMBER_2000: 2000,
    NUMBER_12000: 12000,
    NUMBER_37000: 37000,
    NUMBER_87000: 87000,
    NUMBER_162000: 162000,
    NUMBER_262000: 262000,
    NUMBER_362000: 362000,
    NUMBER_462000: 462000,
    NUMBER_562000: 562000,
    NUMBER_662000: 662000
} as const;

export type VoiceProfileRequestWordCountMilestoneEnum = typeof VoiceProfileRequestWordCountMilestoneEnum[keyof typeof VoiceProfileRequestWordCountMilestoneEnum];

/**
 * The generated voice profile and its processing status for a user.
 * @export
 * @interface VoiceProfileResponse
 */
export interface VoiceProfileResponse {
    /**
     * 
     * @type {VoiceProfileProcessingStatus}
     * @memberof VoiceProfileResponse
     */
    'processing_status': VoiceProfileProcessingStatus;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'headline'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'superpower_title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'superpower_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'peak_time_label'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'peak_time_description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'peak_time_top_app'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'catch_phrase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'catch_phrase_description'?: string | null;
    /**
     * 
     * @type {Persona}
     * @memberof VoiceProfileResponse
     */
    'persona'?: Persona | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'most_used_word'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'most_removed_word'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof VoiceProfileResponse
     */
    'word_count_milestone'?: VoiceProfileResponseWordCountMilestoneEnum | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceProfileResponse
     */
    'created_at'?: string | null;
}

export const VoiceProfileResponseWordCountMilestoneEnum = {
    NUMBER_2000: 2000,
    NUMBER_12000: 12000,
    NUMBER_37000: 37000,
    NUMBER_87000: 87000,
    NUMBER_162000: 162000,
    NUMBER_262000: 262000,
    NUMBER_362000: 362000,
    NUMBER_462000: 462000,
    NUMBER_562000: 562000,
    NUMBER_662000: 662000
} as const;

export type VoiceProfileResponseWordCountMilestoneEnum = typeof VoiceProfileResponseWordCountMilestoneEnum[keyof typeof VoiceProfileResponseWordCountMilestoneEnum];

/**
 * Compact leaderboard for one historical completed week.
 * @export
 * @interface WeeklyLeaderboard
 */
export interface WeeklyLeaderboard {
    /**
     * Sunday of the week (UTC), ISO YYYY-MM-DD. Historical closed weeks only; current week is never emitted.
     * @type {string}
     * @memberof WeeklyLeaderboard
     */
    'week_start': string;
    /**
     * Number of current enterprise members ranked for this week. Equal to team_member_count — independent of pagination (offset/limit/sort_near_user).
     * @type {number}
     * @memberof WeeklyLeaderboard
     */
    'total_users_ranked': number;
    /**
     * Top min(6, total_users_ranked) rows by rank (ascending). Ranks are unique (ROW_NUMBER-style) with user_id ASC tiebreak.
     * @type {Array<WeeklyLeaderboardEntry>}
     * @memberof WeeklyLeaderboard
     */
    'top_entries': Array<WeeklyLeaderboardEntry>;
    /**
     * 
     * @type {WeeklyLeaderboardEntry}
     * @memberof WeeklyLeaderboard
     */
    'requesting_user_entry': WeeklyLeaderboardEntry | null;
}
/**
 * A single user\'s rank and word total for one historical week.
 * @export
 * @interface WeeklyLeaderboardEntry
 */
export interface WeeklyLeaderboardEntry {
    /**
     * 
     * @type {string}
     * @memberof WeeklyLeaderboardEntry
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyLeaderboardEntry
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof WeeklyLeaderboardEntry
     */
    'last_name': string | null;
    /**
     * 1-based rank. Unique, no ties.
     * @type {number}
     * @memberof WeeklyLeaderboardEntry
     */
    'rank': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyLeaderboardEntry
     */
    'total_words': number;
}
/**
 * Closed taxonomy for a batch run\'s ``last_error``; raw exception text is never exposed.
 * @export
 * @enum {string}
 */

export const WeeklyStatsBatchErrorCategory = {
    TransientSource: 'transient_source',
    DownstreamSend: 'downstream_send',
    Gating: 'gating',
    Internal: 'internal',
    StaleReclaimed: 'stale_reclaimed'
} as const;

export type WeeklyStatsBatchErrorCategory = typeof WeeklyStatsBatchErrorCategory[keyof typeof WeeklyStatsBatchErrorCategory];


/**
 * Wrapper so \'no matching run\' is a 200 with a null ``run``, not a 404.
 * @export
 * @interface WeeklyStatsBatchLatestRunResponse
 */
export interface WeeklyStatsBatchLatestRunResponse {
    /**
     * 
     * @type {WeeklyStatsBatchRunStatusResponse}
     * @memberof WeeklyStatsBatchLatestRunResponse
     */
    'run': WeeklyStatsBatchRunStatusResponse | null;
}
/**
 * Terminal set is ``published`` | ``failed`` | ``aborted``; ``running`` is transient.  There is deliberately no ``published_partial``: a run reaches ``published`` once the primary pass completes and bulk publish ran for every ``written`` user, even when ``failed > 0``. ``aborted`` is the stale-reclaim outcome and never publishes.
 * @export
 * @enum {string}
 */

export const WeeklyStatsBatchRunStatus = {
    Running: 'running',
    Published: 'published',
    Failed: 'failed',
    Aborted: 'aborted'
} as const;

export type WeeklyStatsBatchRunStatus = typeof WeeklyStatsBatchRunStatus[keyof typeof WeeklyStatsBatchRunStatus];


/**
 * Status + counters for one ``weekly_stats_batch_runs`` row.
 * @export
 * @interface WeeklyStatsBatchRunStatusResponse
 */
export interface WeeklyStatsBatchRunStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'dry_run': boolean;
    /**
     * 
     * @type {WeeklyStatsBatchRunStatus}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'status': WeeklyStatsBatchRunStatus;
    /**
     * True only when status is \'running\' and heartbeat_at is older than the reclaim window.
     * @type {boolean}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'stale': boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'heartbeat_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'finished_at': string | null;
    /**
     * 
     * @type {WeeklyStatsBatchErrorCategory}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'last_error_category': WeeklyStatsBatchErrorCategory | null;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'candidates': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'flag_enabled': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'flag_gated': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'flag_error': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'skipped_erasure': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'written': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'published': number;
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsBatchRunStatusResponse
     */
    'failed': number;
}


/**
 * 202 body: the queued request\'s handle for the trigger-request status endpoint.
 * @export
 * @interface WeeklyStatsBatchTriggerAcceptedResponse
 */
export interface WeeklyStatsBatchTriggerAcceptedResponse {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerAcceptedResponse
     */
    'request_id': string;
    /**
     * 
     * @type {WeeklyStatsBatchTriggerRequestStatus}
     * @memberof WeeklyStatsBatchTriggerAcceptedResponse
     */
    'status': WeeklyStatsBatchTriggerRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerAcceptedResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyStatsBatchTriggerAcceptedResponse
     */
    'dry_run': boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerAcceptedResponse
     */
    'event_name': string;
}


/**
 * Request body for the async 202 manual batch trigger (WP-8456, poller-based).  ``dry_run`` defaults to True so a bare request can never enter the live journey; the API layer additionally requires a namespaced non-default ``event_name`` for dry runs (mirroring ``run_batch``\'s own guard, but failing fast with a 422).
 * @export
 * @interface WeeklyStatsBatchTriggerRequestBody
 */
export interface WeeklyStatsBatchTriggerRequestBody {
    /**
     * Sunday 00:00:00 UTC period cutoff (exclusive end).
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerRequestBody
     */
    'snapshot_at': string;
    /**
     * Dry runs skip publication pointers and require a namespaced event_name.
     * @type {boolean}
     * @memberof WeeklyStatsBatchTriggerRequestBody
     */
    'dry_run'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerRequestBody
     */
    'event_name'?: string | null;
}
/**
 * Manual-trigger lifecycle: ``requested`` → ``started`` → ``done`` | ``failed`` | ``skipped``.  ``skipped`` is a benign single-flight race (an active run already exists for the same ``(snapshot_at, dry_run)``), distinct from ``failed`` (a real error).
 * @export
 * @enum {string}
 */

export const WeeklyStatsBatchTriggerRequestStatus = {
    Requested: 'requested',
    Started: 'started',
    Done: 'done',
    Failed: 'failed',
    Skipped: 'skipped'
} as const;

export type WeeklyStatsBatchTriggerRequestStatus = typeof WeeklyStatsBatchTriggerRequestStatus[keyof typeof WeeklyStatsBatchTriggerRequestStatus];


/**
 * Status of one manual trigger request; ``batch_run_id`` links to the run status endpoint.
 * @export
 * @interface WeeklyStatsBatchTriggerStatusResponse
 */
export interface WeeklyStatsBatchTriggerStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'request_id': string;
    /**
     * 
     * @type {WeeklyStatsBatchTriggerRequestStatus}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'status': WeeklyStatsBatchTriggerRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'dry_run': boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'event_name': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'batch_run_id': string | null;
    /**
     * 
     * @type {WeeklyStatsBatchErrorCategory}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'last_error_category': WeeklyStatsBatchErrorCategory | null;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'started_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsBatchTriggerStatusResponse
     */
    'finished_at': string | null;
}


/**
 * Absolute signed metric deltas (``current − previous``); present only when eligibility passes.
 * @export
 * @interface WeeklyStatsDeltas
 */
export interface WeeklyStatsDeltas {
    /**
     * Signed current − previous word delta.
     * @type {number}
     * @memberof WeeklyStatsDeltas
     */
    'words': number;
    /**
     * Signed current − previous session delta.
     * @type {number}
     * @memberof WeeklyStatsDeltas
     */
    'sessions': number;
    /**
     * Signed current − previous active-day delta ([-7, 7]).
     * @type {number}
     * @memberof WeeklyStatsDeltas
     */
    'active_days': number;
    /**
     * Signed current − previous longest-streak delta ([-7, 7]).
     * @type {number}
     * @memberof WeeklyStatsDeltas
     */
    'longest_streak': number;
    /**
     * Signed current − previous WPM delta.
     * @type {number}
     * @memberof WeeklyStatsDeltas
     */
    'wpm': number;
}
/**
 * Whether this snapshot\'s ``deltas`` are meaningful, and why not when suppressed.
 * @export
 * @interface WeeklyStatsEligibility
 */
export interface WeeklyStatsEligibility {
    /**
     * True when deltas were computed for this snapshot.
     * @type {boolean}
     * @memberof WeeklyStatsEligibility
     */
    'deltas_eligible': boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsEligibility
     */
    'reason'?: WeeklyStatsEligibilityReasonEnum | null;
}

export const WeeklyStatsEligibilityReasonEnum = {
    Eligible: 'eligible',
    AccountTooNew: 'account_too_new',
    NoPreviousActivity: 'no_previous_activity'
} as const;

export type WeeklyStatsEligibilityReasonEnum = typeof WeeklyStatsEligibilityReasonEnum[keyof typeof WeeklyStatsEligibilityReasonEnum];

/**
 * One persisted (or reused) snapshot.
 * @export
 * @interface WeeklyStatsGenerateItem
 */
export interface WeeklyStatsGenerateItem {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateItem
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateItem
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateItem
     */
    'snapshot_id': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateItem
     */
    'payload_hash': string;
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyStatsGenerateItem
     */
    'reused': boolean;
    /**
     * 
     * @type {WeeklyStatsPayloadV1}
     * @memberof WeeklyStatsGenerateItem
     */
    'payload': WeeklyStatsPayloadV1;
}
/**
 * Audience + cutoff for weekly-stats snapshot generation.  ``purpose=canary`` (default): manual 1–10 @wispr.ai users, no prod audience/PostHog gates. ``purpose=production``: active-iOS resolver + words + PostHog gate; audience optional for targeted one-user testing (omit for full production run).
 * @export
 * @interface WeeklyStatsGenerateRequest
 */
export interface WeeklyStatsGenerateRequest {
    /**
     * Snapshot purpose: canary (manual cohort) or production (full audience + gates).
     * @type {string}
     * @memberof WeeklyStatsGenerateRequest
     */
    'purpose'?: WeeklyStatsGenerateRequestPurposeEnum;
    /**
     * Sunday 00:00:00 UTC period cutoff (exclusive end).
     * @type {string}
     * @memberof WeeklyStatsGenerateRequest
     */
    'snapshot_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeeklyStatsGenerateRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeeklyStatsGenerateRequest
     */
    'user_ids'?: Array<string> | null;
}

export const WeeklyStatsGenerateRequestPurposeEnum = {
    Canary: 'canary',
    Production: 'production'
} as const;

export type WeeklyStatsGenerateRequestPurposeEnum = typeof WeeklyStatsGenerateRequestPurposeEnum[keyof typeof WeeklyStatsGenerateRequestPurposeEnum];

/**
 * Generate response with snapshot keys for the processed cohort.
 * @export
 * @interface WeeklyStatsGenerateResponse
 */
export interface WeeklyStatsGenerateResponse {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'period_current_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'period_current_end': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'period_previous_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'period_previous_end': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsGenerateResponse
     */
    'purpose': WeeklyStatsGenerateResponsePurposeEnum;
    /**
     * 
     * @type {Array<WeeklyStatsGenerateItem>}
     * @memberof WeeklyStatsGenerateResponse
     */
    'items': Array<WeeklyStatsGenerateItem>;
    /**
     * 
     * @type {WeeklyStatsProductionCounters}
     * @memberof WeeklyStatsGenerateResponse
     */
    'counters'?: WeeklyStatsProductionCounters | null;
}

export const WeeklyStatsGenerateResponsePurposeEnum = {
    Canary: 'canary',
    Production: 'production'
} as const;

export type WeeklyStatsGenerateResponsePurposeEnum = typeof WeeklyStatsGenerateResponsePurposeEnum[keyof typeof WeeklyStatsGenerateResponsePurposeEnum];

/**
 * Versioned weekly-stats payload (persistence contract for WP-7885).
 * @export
 * @interface WeeklyStatsPayloadV1
 */
export interface WeeklyStatsPayloadV1 {
    /**
     * 
     * @type {number}
     * @memberof WeeklyStatsPayloadV1
     */
    'payload_version'?: WeeklyStatsPayloadV1PayloadVersionEnum;
    /**
     * 
     * @type {WeeklyStatsPeriodMetrics}
     * @memberof WeeklyStatsPayloadV1
     */
    'current': WeeklyStatsPeriodMetrics;
    /**
     * 
     * @type {WeeklyStatsPeriodMetrics}
     * @memberof WeeklyStatsPayloadV1
     */
    'previous': WeeklyStatsPeriodMetrics;
    /**
     * 
     * @type {WeeklyStatsDeltas}
     * @memberof WeeklyStatsPayloadV1
     */
    'deltas'?: WeeklyStatsDeltas | null;
    /**
     * 
     * @type {WeeklyStatsEligibility}
     * @memberof WeeklyStatsPayloadV1
     */
    'eligibility': WeeklyStatsEligibility;
}

export const WeeklyStatsPayloadV1PayloadVersionEnum = {
    NUMBER_1: 1
} as const;

export type WeeklyStatsPayloadV1PayloadVersionEnum = typeof WeeklyStatsPayloadV1PayloadVersionEnum[keyof typeof WeeklyStatsPayloadV1PayloadVersionEnum];

/**
 * One 7-day window of weekly stats metrics.
 * @export
 * @interface WeeklyStatsPeriodMetrics
 */
export interface WeeklyStatsPeriodMetrics {
    /**
     * Sum of word_count in the window.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'words': number;
    /**
     * Count of eligible dictation rows in the window.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'sessions': number;
    /**
     * Distinct UTC dates with positive words.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'active_days': number;
    /**
     * Longest consecutive active UTC days in-window.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'longest_streak': number;
    /**
     * Weighted WPM for the window; always present (never null).
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'wpm': number;
    /**
     * Numerator words from WPM-eligible History rows.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'wpm_words': number;
    /**
     * Sum of effective duration milliseconds from the same WPM-eligible rows.
     * @type {number}
     * @memberof WeeklyStatsPeriodMetrics
     */
    'wpm_duration_ms': number;
}
/**
 * One user\'s computed weekly-stats payload for admin preview.
 * @export
 * @interface WeeklyStatsPreviewItem
 */
export interface WeeklyStatsPreviewItem {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewItem
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewItem
     */
    'email': string;
    /**
     * 
     * @type {WeeklyStatsPayloadV1}
     * @memberof WeeklyStatsPreviewItem
     */
    'payload': WeeklyStatsPayloadV1;
}
/**
 * Request body for the internal weekly-stats compute-and-return preview.
 * @export
 * @interface WeeklyStatsPreviewRequest
 */
export interface WeeklyStatsPreviewRequest {
    /**
     * Sunday 00:00:00 UTC period cutoff (exclusive end).
     * @type {string}
     * @memberof WeeklyStatsPreviewRequest
     */
    'snapshot_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeeklyStatsPreviewRequest
     */
    'emails'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeeklyStatsPreviewRequest
     */
    'user_ids'?: Array<string> | null;
}
/**
 * Normalized cutoff/period bounds plus one payload per selected user.
 * @export
 * @interface WeeklyStatsPreviewResponse
 */
export interface WeeklyStatsPreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewResponse
     */
    'period_current_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewResponse
     */
    'period_current_end': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewResponse
     */
    'period_previous_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsPreviewResponse
     */
    'period_previous_end': string;
    /**
     * 
     * @type {Array<WeeklyStatsPreviewItem>}
     * @memberof WeeklyStatsPreviewResponse
     */
    'items': Array<WeeklyStatsPreviewItem>;
}
/**
 * Per-run gate counters for ``purpose=production`` generate runs.
 * @export
 * @interface WeeklyStatsProductionCounters
 */
export interface WeeklyStatsProductionCounters {
    /**
     * Total production candidates resolved from audience SQL.
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'candidates'?: number;
    /**
     * Skipped: total_words <= MIN_TOTAL_WORDS_DICTATED.
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'words_gated'?: number;
    /**
     * Passed PostHog gate (exact \'test\' variant).
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'flag_enabled'?: number;
    /**
     * Skipped: PostHog returned a non-test variant.
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'flag_gated'?: number;
    /**
     * Skipped: PostHog evaluation error (fail closed).
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'flag_error'?: number;
    /**
     * Snapshots actually persisted (new or reused).
     * @type {number}
     * @memberof WeeklyStatsProductionCounters
     */
    'written'?: number;
}
/**
 * Request body for the internal one-user weekly-stats Customer.io send test.
 * @export
 * @interface WeeklyStatsSendTestRequest
 */
export interface WeeklyStatsSendTestRequest {
    /**
     * Sunday 00:00:00 UTC period cutoff (exclusive end).
     * @type {string}
     * @memberof WeeklyStatsSendTestRequest
     */
    'snapshot_at': string;
    /**
     * Existing @wispr.ai user whose weekly stats are computed.
     * @type {string}
     * @memberof WeeklyStatsSendTestRequest
     */
    'source_email': string;
    /**
     * @wispr.ai Customer.io profile the event is fired to.
     * @type {string}
     * @memberof WeeklyStatsSendTestRequest
     */
    'send_to_email': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestRequest
     */
    'event_name'?: string | null;
}
/**
 * Result of firing a one-user weekly-stats Customer.io Track event.
 * @export
 * @interface WeeklyStatsSendTestResponse
 */
export interface WeeklyStatsSendTestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof WeeklyStatsSendTestResponse
     */
    'ok': boolean;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'event_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'error': string | null;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'event_name': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'source_email': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'send_to_email': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'snapshot_at': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'period_current_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'period_current_end': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'period_previous_start': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyStatsSendTestResponse
     */
    'period_previous_end': string;
    /**
     * 
     * @type {WeeklyStatsPayloadV1}
     * @memberof WeeklyStatsSendTestResponse
     */
    'payload': WeeklyStatsPayloadV1;
}
/**
 * Weekly word limits per platform; each client reads only its own entry.
 * @export
 * @interface WeeklyWordLimits
 */
export interface WeeklyWordLimits {
    /**
     * 
     * @type {number}
     * @memberof WeeklyWordLimits
     */
    'schema_version'?: WeeklyWordLimitsSchemaVersionEnum;
    /**
     * 
     * @type {PlatformWeeklyWordLimits}
     * @memberof WeeklyWordLimits
     */
    'ios': PlatformWeeklyWordLimits;
    /**
     * 
     * @type {PlatformWeeklyWordLimits}
     * @memberof WeeklyWordLimits
     */
    'android': PlatformWeeklyWordLimits;
    /**
     * 
     * @type {PlatformWeeklyWordLimits}
     * @memberof WeeklyWordLimits
     */
    'desktop': PlatformWeeklyWordLimits;
}

export const WeeklyWordLimitsSchemaVersionEnum = {
    NUMBER_1: 1
} as const;

export type WeeklyWordLimitsSchemaVersionEnum = typeof WeeklyWordLimitsSchemaVersionEnum[keyof typeof WeeklyWordLimitsSchemaVersionEnum];

/**
 * What the enroll call decided; only ``enrolled`` and ``already_decided`` can carry an experiment arm.
 * @export
 * @enum {string}
 */

export const WeeklyWordLimitsEnrollOutcome = {
    Enrolled: 'enrolled',
    NotAssigned: 'not_assigned',
    Excluded: 'excluded',
    AlreadyDecided: 'already_decided',
    NotEligible: 'not_eligible'
} as const;

export type WeeklyWordLimitsEnrollOutcome = typeof WeeklyWordLimitsEnrollOutcome[keyof typeof WeeklyWordLimitsEnrollOutcome];


/**
 * Sent once at the end of a client\'s onboarding flow; the user comes from the token.
 * @export
 * @interface WeeklyWordLimitsEnrollRequest
 */
export interface WeeklyWordLimitsEnrollRequest {
    /**
     * 
     * @type {WeeklyWordLimitsPlatform}
     * @memberof WeeklyWordLimitsEnrollRequest
     */
    'platform': WeeklyWordLimitsPlatform;
    /**
     * 1 for builds that apply served weekly word limits.
     * @type {number}
     * @memberof WeeklyWordLimitsEnrollRequest
     */
    'client_limits_version': number;
    /**
     * Which try this is, starting at 1; used for observability only.
     * @type {number}
     * @memberof WeeklyWordLimitsEnrollRequest
     */
    'attempt': number;
}


/**
 * The decision and the limits the client applies; send the exposure only for a ``source: experiment`` entry.
 * @export
 * @interface WeeklyWordLimitsEnrollResponse
 */
export interface WeeklyWordLimitsEnrollResponse {
    /**
     * 
     * @type {WeeklyWordLimitsEnrollOutcome}
     * @memberof WeeklyWordLimitsEnrollResponse
     */
    'outcome': WeeklyWordLimitsEnrollOutcome;
    /**
     * 
     * @type {WeeklyWordLimits}
     * @memberof WeeklyWordLimitsEnrollResponse
     */
    'weekly_word_limits': WeeklyWordLimits;
}


/**
 * The experiment arm whose limits are served.
 * @export
 * @interface WeeklyWordLimitsExperiment
 */
export interface WeeklyWordLimitsExperiment {
    /**
     * 
     * @type {string}
     * @memberof WeeklyWordLimitsExperiment
     */
    'flag_key': string;
    /**
     * 
     * @type {string}
     * @memberof WeeklyWordLimitsExperiment
     */
    'variant': string;
}
/**
 * A client platform with its own weekly word limits.
 * @export
 * @enum {string}
 */

export const WeeklyWordLimitsPlatform = {
    Ios: 'ios',
    Android: 'android',
    Desktop: 'desktop'
} as const;

export type WeeklyWordLimitsPlatform = typeof WeeklyWordLimitsPlatform[keyof typeof WeeklyWordLimitsPlatform];


/**
 * Where a platform\'s served limits came from.
 * @export
 * @enum {string}
 */

export const WeeklyWordLimitsSource = {
    Default: 'default',
    Experiment: 'experiment'
} as const;

export type WeeklyWordLimitsSource = typeof WeeklyWordLimitsSource[keyof typeof WeeklyWordLimitsSource];


/**
 * Configuration for an Anthropic Messages continuation.
 * @export
 * @interface WisprAgentAnthropicMessagesConfig
 */
export interface WisprAgentAnthropicMessagesConfig {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentAnthropicMessagesConfig
     */
    'kind': WisprAgentAnthropicMessagesConfigKindEnum;
    /**
     * Model strings that the Anthropic Messages API accepts.
     * @type {string}
     * @memberof WisprAgentAnthropicMessagesConfig
     */
    'model': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentAnthropicMessagesConfig
     */
    'effort'?: WisprAgentAnthropicMessagesConfigEffortEnum | null;
}

export const WisprAgentAnthropicMessagesConfigKindEnum = {
    AnthropicMessages: 'anthropic_messages'
} as const;

export type WisprAgentAnthropicMessagesConfigKindEnum = typeof WisprAgentAnthropicMessagesConfigKindEnum[keyof typeof WisprAgentAnthropicMessagesConfigKindEnum];
export const WisprAgentAnthropicMessagesConfigEffortEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type WisprAgentAnthropicMessagesConfigEffortEnum = typeof WisprAgentAnthropicMessagesConfigEffortEnum[keyof typeof WisprAgentAnthropicMessagesConfigEffortEnum];

/**
 * A request for provider-managed automatic context compaction.
 * @export
 * @interface WisprAgentAutoCompaction
 */
export interface WisprAgentAutoCompaction {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentAutoCompaction
     */
    'kind': WisprAgentAutoCompactionKindEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprAgentAutoCompaction
     */
    'threshold': number;
}

export const WisprAgentAutoCompactionKindEnum = {
    Auto: 'auto'
} as const;

export type WisprAgentAutoCompactionKindEnum = typeof WisprAgentAutoCompactionKindEnum[keyof typeof WisprAgentAutoCompactionKindEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const WisprAgentCapability = {
    Citations: 'citations',
    WebSearch: 'web_search',
    BackendPrompt: 'backend_prompt'
} as const;

export type WisprAgentCapability = typeof WisprAgentCapability[keyof typeof WisprAgentCapability];


/**
 * @type WisprAgentContentPart
 * @export
 */
export type WisprAgentContentPart = { type: 'external_citation' } & WisprExternalCitationV1 | { type: 'meeting_citation' } & WisprMeetingCitationV1 | { type: 'text' } & WisprAgentTextContentPart;

/**
 * 
 * @export
 * @enum {string}
 */

export const WisprAgentErrorCategory = {
    Connection: 'connection',
    Timeout: 'timeout',
    RateLimit: 'rate_limit',
    Quota: 'quota',
    Authentication: 'authentication',
    Permission: 'permission',
    InvalidRequest: 'invalid_request',
    ContextLimit: 'context_limit',
    ContentFilter: 'content_filter',
    ProviderError: 'provider_error',
    MalformedResponse: 'malformed_response',
    StreamEof: 'stream_eof',
    Configuration: 'configuration',
    Unknown: 'unknown'
} as const;

export type WisprAgentErrorCategory = typeof WisprAgentErrorCategory[keyof typeof WisprAgentErrorCategory];


/**
 * A classified failure before the agent response stream opens.
 * @export
 * @interface WisprAgentErrorResponse
 */
export interface WisprAgentErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentErrorResponse
     */
    'detail': string;
    /**
     * 
     * @type {WisprAgentErrorCategory}
     * @memberof WisprAgentErrorResponse
     */
    'error_category': WisprAgentErrorCategory;
    /**
     * 
     * @type {boolean}
     * @memberof WisprAgentErrorResponse
     */
    'retryable': boolean;
}


/**
 * A client function available to the agent.
 * @export
 * @interface WisprAgentFunctionTool
 */
export interface WisprAgentFunctionTool {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentFunctionTool
     */
    'type': WisprAgentFunctionToolTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentFunctionTool
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentFunctionTool
     */
    'description'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof WisprAgentFunctionTool
     */
    'input_schema': object;
}

export const WisprAgentFunctionToolTypeEnum = {
    Function: 'function'
} as const;

export type WisprAgentFunctionToolTypeEnum = typeof WisprAgentFunctionToolTypeEnum[keyof typeof WisprAgentFunctionToolTypeEnum];

/**
 * A requested managed MCP server whose effective policy is backend-owned.
 * @export
 * @interface WisprAgentManagedMcpServer
 */
export interface WisprAgentManagedMcpServer {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentManagedMcpServer
     */
    'type': WisprAgentManagedMcpServerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentManagedMcpServer
     */
    'server': WisprAgentManagedMcpServerServerEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof WisprAgentManagedMcpServer
     */
    'allowed_tools'?: Array<string> | null;
}

export const WisprAgentManagedMcpServerTypeEnum = {
    Managed: 'managed'
} as const;

export type WisprAgentManagedMcpServerTypeEnum = typeof WisprAgentManagedMcpServerTypeEnum[keyof typeof WisprAgentManagedMcpServerTypeEnum];
export const WisprAgentManagedMcpServerServerEnum = {
    Wispr: 'wispr'
} as const;

export type WisprAgentManagedMcpServerServerEnum = typeof WisprAgentManagedMcpServerServerEnum[keyof typeof WisprAgentManagedMcpServerServerEnum];

/**
 * Provisional assistant content appended to one message during an invocation.
 * @export
 * @interface WisprAgentMessageDeltaEvent
 */
export interface WisprAgentMessageDeltaEvent {
    /**
     * An incremental assistant message event.
     * @type {string}
     * @memberof WisprAgentMessageDeltaEvent
     */
    'type': WisprAgentMessageDeltaEventTypeEnum;
    /**
     * Opaque message identifier scoped to this invocation.
     * @type {string}
     * @memberof WisprAgentMessageDeltaEvent
     */
    'message_id': string;
    /**
     * New content parts to append to the provisional message.
     * @type {Array<WisprAgentContentPart>}
     * @memberof WisprAgentMessageDeltaEvent
     */
    'content': Array<WisprAgentContentPart>;
}

export const WisprAgentMessageDeltaEventTypeEnum = {
    MessageDelta: 'message.delta'
} as const;

export type WisprAgentMessageDeltaEventTypeEnum = typeof WisprAgentMessageDeltaEventTypeEnum[keyof typeof WisprAgentMessageDeltaEventTypeEnum];

/**
 * A semantic message in an agent trajectory.
 * @export
 * @interface WisprAgentMessageStepInput
 */
export interface WisprAgentMessageStepInput {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentMessageStepInput
     */
    'type': WisprAgentMessageStepInputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentMessageStepInput
     */
    'role': WisprAgentMessageStepInputRoleEnum;
    /**
     * 
     * @type {Array<WisprAgentContentPart>}
     * @memberof WisprAgentMessageStepInput
     */
    'content': Array<WisprAgentContentPart>;
}

export const WisprAgentMessageStepInputTypeEnum = {
    Message: 'message'
} as const;

export type WisprAgentMessageStepInputTypeEnum = typeof WisprAgentMessageStepInputTypeEnum[keyof typeof WisprAgentMessageStepInputTypeEnum];
export const WisprAgentMessageStepInputRoleEnum = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant'
} as const;

export type WisprAgentMessageStepInputRoleEnum = typeof WisprAgentMessageStepInputRoleEnum[keyof typeof WisprAgentMessageStepInputRoleEnum];

/**
 * A semantic message in an agent trajectory.
 * @export
 * @interface WisprAgentMessageStepOutput
 */
export interface WisprAgentMessageStepOutput {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentMessageStepOutput
     */
    'type': WisprAgentMessageStepOutputTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentMessageStepOutput
     */
    'role': WisprAgentMessageStepOutputRoleEnum;
    /**
     * 
     * @type {Array<WisprAgentContentPart>}
     * @memberof WisprAgentMessageStepOutput
     */
    'content': Array<WisprAgentContentPart>;
}

export const WisprAgentMessageStepOutputTypeEnum = {
    Message: 'message'
} as const;

export type WisprAgentMessageStepOutputTypeEnum = typeof WisprAgentMessageStepOutputTypeEnum[keyof typeof WisprAgentMessageStepOutputTypeEnum];
export const WisprAgentMessageStepOutputRoleEnum = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant'
} as const;

export type WisprAgentMessageStepOutputRoleEnum = typeof WisprAgentMessageStepOutputRoleEnum[keyof typeof WisprAgentMessageStepOutputRoleEnum];

/**
 * Provider-specific continuation state that clients round-trip unchanged.
 * @export
 * @interface WisprAgentOpaqueStep
 */
export interface WisprAgentOpaqueStep {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentOpaqueStep
     */
    'type': WisprAgentOpaqueStepTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentOpaqueStep
     */
    'provider': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentOpaqueStep
     */
    'payload': string;
}

export const WisprAgentOpaqueStepTypeEnum = {
    ProviderOpaque: 'provider_opaque'
} as const;

export type WisprAgentOpaqueStepTypeEnum = typeof WisprAgentOpaqueStepTypeEnum[keyof typeof WisprAgentOpaqueStepTypeEnum];

/**
 * Configuration for the OpenAI Responses Wispr agent.
 * @export
 * @interface WisprAgentOpenAIResponsesConfig
 */
export interface WisprAgentOpenAIResponsesConfig {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentOpenAIResponsesConfig
     */
    'kind': WisprAgentOpenAIResponsesConfigKindEnum;
    /**
     * Model strings that the OpenAI Responses API accepts.
     * @type {string}
     * @memberof WisprAgentOpenAIResponsesConfig
     */
    'model': string;
    /**
     * Reasoning effort strings that the OpenAI Responses API accepts.
     * @type {string}
     * @memberof WisprAgentOpenAIResponsesConfig
     */
    'reasoning': string;
}

export const WisprAgentOpenAIResponsesConfigKindEnum = {
    OpenaiResponses: 'openai_responses'
} as const;

export type WisprAgentOpenAIResponsesConfigKindEnum = typeof WisprAgentOpenAIResponsesConfigKindEnum[keyof typeof WisprAgentOpenAIResponsesConfigKindEnum];

/**
 * A row the server saved for this turn, at its canonical position.
 * @export
 * @interface WisprAgentPersistedMessage
 */
export interface WisprAgentPersistedMessage {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentPersistedMessage
     */
    'message_id': string;
    /**
     * 
     * @type {number}
     * @memberof WisprAgentPersistedMessage
     */
    'sequence_index': number;
}
/**
 * Request for one provider-neutral agent invocation.
 * @export
 * @interface WisprAgentRequest
 */
export interface WisprAgentRequest {
    /**
     * 
     * @type {Config}
     * @memberof WisprAgentRequest
     */
    'config': Config;
    /**
     * Chat surface the request comes from; selects the backend routing policy.
     * @type {string}
     * @memberof WisprAgentRequest
     */
    'surface'?: WisprAgentRequestSurfaceEnum;
    /**
     * 
     * @type {Array<WisprAgentStepInput>}
     * @memberof WisprAgentRequest
     */
    'trajectory': Array<WisprAgentStepInput>;
    /**
     * 
     * @type {number}
     * @memberof WisprAgentRequest
     */
    'max_output_tokens': number;
    /**
     * 
     * @type {Array<WisprAgentFunctionTool>}
     * @memberof WisprAgentRequest
     */
    'tools'?: Array<WisprAgentFunctionTool>;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentRequest
     */
    'tool_choice'?: WisprAgentRequestToolChoiceEnum;
    /**
     * 
     * @type {Array<WisprAgentManagedMcpServer>}
     * @memberof WisprAgentRequest
     */
    'mcp_servers'?: Array<WisprAgentManagedMcpServer>;
    /**
     * 
     * @type {WisprAgentAutoCompaction}
     * @memberof WisprAgentRequest
     */
    'compaction'?: WisprAgentAutoCompaction | null;
    /**
     * 
     * @type {Array<WisprAgentCapability>}
     * @memberof WisprAgentRequest
     */
    'capabilities'?: Array<WisprAgentCapability>;
    /**
     * 
     * @type {WisprAgentTurn}
     * @memberof WisprAgentRequest
     */
    'turn'?: WisprAgentTurn | null;
}

export const WisprAgentRequestSurfaceEnum = {
    L2: 'l2',
    Drawer: 'drawer'
} as const;

export type WisprAgentRequestSurfaceEnum = typeof WisprAgentRequestSurfaceEnum[keyof typeof WisprAgentRequestSurfaceEnum];
export const WisprAgentRequestToolChoiceEnum = {
    Auto: 'auto',
    None: 'none'
} as const;

export type WisprAgentRequestToolChoiceEnum = typeof WisprAgentRequestToolChoiceEnum[keyof typeof WisprAgentRequestToolChoiceEnum];

/**
 * Actionable output and the authoritative continuation trajectory.
 * @export
 * @interface WisprAgentResponse
 */
export interface WisprAgentResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponse
     */
    'status': WisprAgentResponseStatusEnum;
    /**
     * 
     * @type {Array<WisprAgentStepOutput>}
     * @memberof WisprAgentResponse
     */
    'output': Array<WisprAgentStepOutput>;
    /**
     * 
     * @type {Array<WisprAgentStepOutput>}
     * @memberof WisprAgentResponse
     */
    'new_trajectory': Array<WisprAgentStepOutput>;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponse
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponse
     */
    'model'?: string | null;
    /**
     * 
     * @type {Array<WisprAgentPersistedMessage>}
     * @memberof WisprAgentResponse
     */
    'persisted_messages'?: Array<WisprAgentPersistedMessage> | null;
}

export const WisprAgentResponseStatusEnum = {
    Completed: 'completed',
    Incomplete: 'incomplete'
} as const;

export type WisprAgentResponseStatusEnum = typeof WisprAgentResponseStatusEnum[keyof typeof WisprAgentResponseStatusEnum];

/**
 * The authoritative terminal result of an agent invocation.
 * @export
 * @interface WisprAgentResponseCompletedEvent
 */
export interface WisprAgentResponseCompletedEvent {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponseCompletedEvent
     */
    'type': WisprAgentResponseCompletedEventTypeEnum;
    /**
     * 
     * @type {WisprAgentResponse}
     * @memberof WisprAgentResponseCompletedEvent
     */
    'response': WisprAgentResponse;
}

export const WisprAgentResponseCompletedEventTypeEnum = {
    ResponseCompleted: 'response.completed'
} as const;

export type WisprAgentResponseCompletedEventTypeEnum = typeof WisprAgentResponseCompletedEventTypeEnum[keyof typeof WisprAgentResponseCompletedEventTypeEnum];

/**
 * First frame of a turn-bearing stream: the server\'s mode for this turn and what it guarantees.
 * @export
 * @interface WisprAgentResponseStartedEvent
 */
export interface WisprAgentResponseStartedEvent {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponseStartedEvent
     */
    'type': WisprAgentResponseStartedEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentResponseStartedEvent
     */
    'turn_id': string;
    /**
     * 
     * @type {WisprAgentTurnMode}
     * @memberof WisprAgentResponseStartedEvent
     */
    'mode': WisprAgentTurnMode;
    /**
     * The server writes this turn\'s rows; the client must not upload them.
     * @type {boolean}
     * @memberof WisprAgentResponseStartedEvent
     */
    'persisted': boolean;
    /**
     * Always false: this server never replays a turn. A client that loses the stream re-reads the chat.
     * @type {boolean}
     * @memberof WisprAgentResponseStartedEvent
     */
    'resumable': boolean;
    /**
     * The server\'s generation budget in seconds.
     * @type {number}
     * @memberof WisprAgentResponseStartedEvent
     */
    'deadline_s': number;
}

export const WisprAgentResponseStartedEventTypeEnum = {
    ResponseStarted: 'response.started'
} as const;

export type WisprAgentResponseStartedEventTypeEnum = typeof WisprAgentResponseStartedEventTypeEnum[keyof typeof WisprAgentResponseStartedEventTypeEnum];

/**
 * @type WisprAgentStepInput
 * @export
 */
export type WisprAgentStepInput = { type: 'message' } & WisprAgentMessageStepInput | { type: 'provider_opaque' } & WisprAgentOpaqueStep | { type: 'tool_call' } & WisprAgentToolCallStep | { type: 'tool_result' } & WisprAgentToolResultStep;

/**
 * @type WisprAgentStepOutput
 * @export
 */
export type WisprAgentStepOutput = { type: 'message' } & WisprAgentMessageStepOutput | { type: 'provider_opaque' } & WisprAgentOpaqueStep | { type: 'tool_call' } & WisprAgentToolCallStep | { type: 'tool_result' } & WisprAgentToolResultStep;

/**
 * 
 * @export
 * @enum {string}
 */

export const WisprAgentStreamErrorCode = {
    InvalidRequest: 'invalid_request',
    Timeout: 'timeout',
    UpstreamError: 'upstream_error',
    Cancelled: 'cancelled',
    Interrupted: 'interrupted'
} as const;

export type WisprAgentStreamErrorCode = typeof WisprAgentStreamErrorCode[keyof typeof WisprAgentStreamErrorCode];


/**
 * A terminal failure after the response stream has opened.
 * @export
 * @interface WisprAgentStreamErrorEvent
 */
export interface WisprAgentStreamErrorEvent {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentStreamErrorEvent
     */
    'type': WisprAgentStreamErrorEventTypeEnum;
    /**
     * 
     * @type {WisprAgentStreamErrorCode}
     * @memberof WisprAgentStreamErrorEvent
     */
    'code': WisprAgentStreamErrorCode;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentStreamErrorEvent
     */
    'detail': string;
    /**
     * 
     * @type {WisprAgentErrorCategory}
     * @memberof WisprAgentStreamErrorEvent
     */
    'error_category'?: WisprAgentErrorCategory | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprAgentStreamErrorEvent
     */
    'retryable'?: boolean;
}

export const WisprAgentStreamErrorEventTypeEnum = {
    Error: 'error'
} as const;

export type WisprAgentStreamErrorEventTypeEnum = typeof WisprAgentStreamErrorEventTypeEnum[keyof typeof WisprAgentStreamErrorEventTypeEnum];

/**
 * @type WisprAgentStreamItem
 * @export
 */
export type WisprAgentStreamItem = { type: 'error' } & WisprAgentStreamErrorEvent | { type: 'message.delta' } & WisprAgentMessageDeltaEvent | { type: 'response.completed' } & WisprAgentResponseCompletedEvent | { type: 'response.started' } & WisprAgentResponseStartedEvent | { type: 'tool_call.completed' } & WisprAgentToolCallCompletedEvent;

/**
 * Plain text wrapped as a model for reliable OpenAPI generation.
 * @export
 * @interface WisprAgentTextContentPart
 */
export interface WisprAgentTextContentPart {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentTextContentPart
     */
    'type': WisprAgentTextContentPartTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentTextContentPart
     */
    'text': string;
}

export const WisprAgentTextContentPartTypeEnum = {
    Text: 'text'
} as const;

export type WisprAgentTextContentPartTypeEnum = typeof WisprAgentTextContentPartTypeEnum[keyof typeof WisprAgentTextContentPartTypeEnum];

/**
 * A complete tool invocation available for progress presentation.
 * @export
 * @interface WisprAgentToolCallCompletedEvent
 */
export interface WisprAgentToolCallCompletedEvent {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallCompletedEvent
     */
    'type': WisprAgentToolCallCompletedEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallCompletedEvent
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallCompletedEvent
     */
    'arguments': string;
}

export const WisprAgentToolCallCompletedEventTypeEnum = {
    ToolCallCompleted: 'tool_call.completed'
} as const;

export type WisprAgentToolCallCompletedEventTypeEnum = typeof WisprAgentToolCallCompletedEventTypeEnum[keyof typeof WisprAgentToolCallCompletedEventTypeEnum];

/**
 * A model-requested tool invocation.
 * @export
 * @interface WisprAgentToolCallStep
 */
export interface WisprAgentToolCallStep {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallStep
     */
    'type': WisprAgentToolCallStepTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallStep
     */
    'call_id': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallStep
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallStep
     */
    'explanation': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolCallStep
     */
    'arguments': string;
}

export const WisprAgentToolCallStepTypeEnum = {
    ToolCall: 'tool_call'
} as const;

export type WisprAgentToolCallStepTypeEnum = typeof WisprAgentToolCallStepTypeEnum[keyof typeof WisprAgentToolCallStepTypeEnum];

/**
 * A tool result linked to its invocation.
 * @export
 * @interface WisprAgentToolResultStep
 */
export interface WisprAgentToolResultStep {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolResultStep
     */
    'type': WisprAgentToolResultStepTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolResultStep
     */
    'call_id': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentToolResultStep
     */
    'output': string;
}

export const WisprAgentToolResultStepTypeEnum = {
    ToolResult: 'tool_result'
} as const;

export type WisprAgentToolResultStepTypeEnum = typeof WisprAgentToolResultStepTypeEnum[keyof typeof WisprAgentToolResultStepTypeEnum];

/**
 * Opt-in durable-turn identity for one standalone Ask question; v1 covers hub chats only.
 * @export
 * @interface WisprAgentTurn
 */
export interface WisprAgentTurn {
    /**
     * 
     * @type {string}
     * @memberof WisprAgentTurn
     */
    'chat_id': string;
    /**
     * Shared by every attempt of one question; a Retry reuses it.
     * @type {string}
     * @memberof WisprAgentTurn
     */
    'turn_id': string;
    /**
     * 
     * @type {string}
     * @memberof WisprAgentTurn
     */
    'user_message_id': string;
    /**
     * This attempt\'s assistant row; the first answer row keeps it.
     * @type {string}
     * @memberof WisprAgentTurn
     */
    'assistant_message_id': string;
    /**
     * Used only when the chat is new.
     * @type {string}
     * @memberof WisprAgentTurn
     */
    'title': string;
    /**
     * 
     * @type {Array<WisprAgentContentPart>}
     * @memberof WisprAgentTurn
     */
    'user_content': Array<WisprAgentContentPart>;
    /**
     * Earlier attempts\' rows; the server supersedes every earlier assistant row of this turn.
     * @type {Array<string>}
     * @memberof WisprAgentTurn
     */
    'superseded_message_ids'?: Array<string>;
}
/**
 * Both outcomes are success; cancel is idempotent.
 * @export
 * @interface WisprAgentTurnCancelResponse
 */
export interface WisprAgentTurnCancelResponse {
    /**
     * accepted: the turn stops and ends with a cancelled frame, unless it was already ending; the terminal frame decides.
     * @type {string}
     * @memberof WisprAgentTurnCancelResponse
     */
    'outcome': WisprAgentTurnCancelResponseOutcomeEnum;
}

export const WisprAgentTurnCancelResponseOutcomeEnum = {
    Accepted: 'accepted',
    AlreadyTerminal: 'already_terminal'
} as const;

export type WisprAgentTurnCancelResponseOutcomeEnum = typeof WisprAgentTurnCancelResponseOutcomeEnum[keyof typeof WisprAgentTurnCancelResponseOutcomeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const WisprAgentTurnErrorDetail = {
    DuplicateTurn: 'duplicate_turn',
    TurnNotFound: 'turn_not_found',
    Degraded: 'degraded'
} as const;

export type WisprAgentTurnErrorDetail = typeof WisprAgentTurnErrorDetail[keyof typeof WisprAgentTurnErrorDetail];


/**
 * A turn request refused before any stream opens: still running, unknown, or degraded.
 * @export
 * @interface WisprAgentTurnErrorResponse
 */
export interface WisprAgentTurnErrorResponse {
    /**
     * 
     * @type {WisprAgentTurnErrorDetail}
     * @memberof WisprAgentTurnErrorResponse
     */
    'detail': WisprAgentTurnErrorDetail;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WisprAgentTurnMode = {
    TurnLegacy: 'turn_legacy',
    TurnFallback: 'turn_fallback',
    Durable: 'durable'
} as const;

export type WisprAgentTurnMode = typeof WisprAgentTurnMode[keyof typeof WisprAgentTurnMode];


/**
 * A citation that opens an external source.
 * @export
 * @interface WisprExternalCitationV1
 */
export interface WisprExternalCitationV1 {
    /**
     * 
     * @type {string}
     * @memberof WisprExternalCitationV1
     */
    'type': WisprExternalCitationV1TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprExternalCitationV1
     */
    'version': WisprExternalCitationV1VersionEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprExternalCitationV1
     */
    'provider': WisprExternalCitationV1ProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprExternalCitationV1
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof WisprExternalCitationV1
     */
    'url': string;
}

export const WisprExternalCitationV1TypeEnum = {
    ExternalCitation: 'external_citation'
} as const;

export type WisprExternalCitationV1TypeEnum = typeof WisprExternalCitationV1TypeEnum[keyof typeof WisprExternalCitationV1TypeEnum];
export const WisprExternalCitationV1VersionEnum = {
    NUMBER_1: 1
} as const;

export type WisprExternalCitationV1VersionEnum = typeof WisprExternalCitationV1VersionEnum[keyof typeof WisprExternalCitationV1VersionEnum];
export const WisprExternalCitationV1ProviderEnum = {
    Gmail: 'gmail',
    Slack: 'slack',
    Notion: 'notion',
    Calendar: 'calendar',
    Web: 'web'
} as const;

export type WisprExternalCitationV1ProviderEnum = typeof WisprExternalCitationV1ProviderEnum[keyof typeof WisprExternalCitationV1ProviderEnum];

/**
 * A citation that opens a Wispr meeting.
 * @export
 * @interface WisprMeetingCitationV1
 */
export interface WisprMeetingCitationV1 {
    /**
     * 
     * @type {string}
     * @memberof WisprMeetingCitationV1
     */
    'type': WisprMeetingCitationV1TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprMeetingCitationV1
     */
    'version': WisprMeetingCitationV1VersionEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprMeetingCitationV1
     */
    'meeting_id': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMeetingCitationV1
     */
    'title': string;
}

export const WisprMeetingCitationV1TypeEnum = {
    MeetingCitation: 'meeting_citation'
} as const;

export type WisprMeetingCitationV1TypeEnum = typeof WisprMeetingCitationV1TypeEnum[keyof typeof WisprMeetingCitationV1TypeEnum];
export const WisprMeetingCitationV1VersionEnum = {
    NUMBER_1: 1
} as const;

export type WisprMeetingCitationV1VersionEnum = typeof WisprMeetingCitationV1VersionEnum[keyof typeof WisprMeetingCitationV1VersionEnum];

/**
 * Consecutive lines of the current file written by one version (1-based ``start_line``).  ``before_history`` marks lines the hub cannot tie to a run: older than the oldest version read, or written by a write that is not a run. ``run_id`` is then null and ``created_at`` is that version\'s time, so they read as \"before\" it. Lines are the raw content split on ``\\n``, so ``\\r`` and a BOM stay on their lines and a trailing newline ends in an empty line.
 * @export
 * @interface WisprMemoryBlameHunk
 */
export interface WisprMemoryBlameHunk {
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryBlameHunk
     */
    'start_line': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryBlameHunk
     */
    'line_count': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryBlameHunk
     */
    'run_id': string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryBlameHunk
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryBlameHunk
     */
    'created_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryBlameHunk
     */
    'before_history': boolean;
}
/**
 * Which run wrote each line of a file\'s current version; immutable per ``head_version``.  ``runs`` summarizes every run the hunks name, newest first. ``truncated`` is set when the walk stopped at the version or byte cap, so lines an older kept version wrote read as ``before_history``.
 * @export
 * @interface WisprMemoryBlameResponse
 */
export interface WisprMemoryBlameResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryBlameResponse
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryBlameResponse
     */
    'head_version': number;
    /**
     * 
     * @type {Array<WisprMemoryBlameHunk>}
     * @memberof WisprMemoryBlameResponse
     */
    'hunks': Array<WisprMemoryBlameHunk>;
    /**
     * 
     * @type {Array<WisprMemoryRunSummary>}
     * @memberof WisprMemoryBlameResponse
     */
    'runs': Array<WisprMemoryRunSummary>;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryBlameResponse
     */
    'truncated': boolean;
}
/**
 * A dossier\'s person as the contacts and global profiles read now; none of it is stored in the file.  ``resolved`` is false when the contact was deleted or merged away. ``last_met_at`` is the last meeting they joined.
 * @export
 * @interface WisprMemoryContactCard
 */
export interface WisprMemoryContactCard {
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryContactCard
     */
    'resolved': boolean;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryContactCard
     */
    'display_name': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WisprMemoryContactCard
     */
    'emails': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryContactCard
     */
    'job_title': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryContactCard
     */
    'company_name': string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryContactCard
     */
    'joined_meeting_count': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryContactCard
     */
    'invited_meeting_count': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryContactCard
     */
    'mentioned_meeting_count': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryContactCard
     */
    'last_met_at': string | null;
}
/**
 * Source-agent work: ``running`` while an admitted run is before its deadline, ``queued`` while any is open.
 * @export
 * @interface WisprMemoryCuratorStatus
 */
export interface WisprMemoryCuratorStatus {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryCuratorStatus
     */
    'state': WisprMemoryCuratorStatusStateEnum;
    /**
     * Open source-agent invocations, capped at 999.
     * @type {number}
     * @memberof WisprMemoryCuratorStatus
     */
    'waiting_count': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryCuratorStatus
     */
    'last_run_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryCuratorStatus
     */
    'last_outcome': string | null;
}

export const WisprMemoryCuratorStatusStateEnum = {
    Off: 'off',
    Paused: 'paused',
    Idle: 'idle',
    Queued: 'queued',
    Running: 'running'
} as const;

export type WisprMemoryCuratorStatusStateEnum = typeof WisprMemoryCuratorStatusStateEnum[keyof typeof WisprMemoryCuratorStatusStateEnum];

/**
 * One line of a diff: unchanged, added or removed, with its 1-based line number on each side it exists on.
 * @export
 * @interface WisprMemoryDiffLine
 */
export interface WisprMemoryDiffLine {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDiffLine
     */
    'op': WisprMemoryDiffLineOpEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDiffLine
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryDiffLine
     */
    'old_line': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryDiffLine
     */
    'new_line': number | null;
}

export const WisprMemoryDiffLineOpEnum = {
    Equal: 'equal',
    Insert: 'insert',
    Delete: 'delete'
} as const;

export type WisprMemoryDiffLineOpEnum = typeof WisprMemoryDiffLineOpEnum[keyof typeof WisprMemoryDiffLineOpEnum];

/**
 * One retry-stable manual Dream request for the authenticated caller.
 * @export
 * @interface WisprMemoryDreamKickRequest
 */
export interface WisprMemoryDreamKickRequest {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamKickRequest
     */
    'operation_id': string;
}
/**
 * The Dreamer\'s current run, latest completed run and projected nightly slot.
 * @export
 * @interface WisprMemoryDreamerStatus
 */
export interface WisprMemoryDreamerStatus {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamerStatus
     */
    'state': WisprMemoryDreamerStatusStateEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamerStatus
     */
    'last_run_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamerStatus
     */
    'last_outcome': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamerStatus
     */
    'last_run_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryDreamerStatus
     */
    'next_run_at': string | null;
}

export const WisprMemoryDreamerStatusStateEnum = {
    Off: 'off',
    Paused: 'paused',
    Idle: 'idle',
    Queued: 'queued',
    Running: 'running'
} as const;

export type WisprMemoryDreamerStatusStateEnum = typeof WisprMemoryDreamerStatusStateEnum[keyof typeof WisprMemoryDreamerStatusStateEnum];

/**
 * The latest version of one live file.  A dossier also carries its ``contact``, null when it could not be read. ``is_self`` marks the owner\'s own dossier.
 * @export
 * @interface WisprMemoryFileResponse
 */
export interface WisprMemoryFileResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileResponse
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryFileResponse
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileResponse
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileResponse
     */
    'actor': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileResponse
     */
    'run_id': string | null;
    /**
     * 
     * @type {WisprMemoryContactCard}
     * @memberof WisprMemoryFileResponse
     */
    'contact'?: WisprMemoryContactCard | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryFileResponse
     */
    'is_self'?: boolean;
}
/**
 * One stored version of a file; ``content`` is null when that version deleted the file.
 * @export
 * @interface WisprMemoryFileVersionResponse
 */
export interface WisprMemoryFileVersionResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileVersionResponse
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryFileVersionResponse
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileVersionResponse
     */
    'content': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryFileVersionResponse
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileVersionResponse
     */
    'actor': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryFileVersionResponse
     */
    'created_at': string;
}
/**
 * The estimated prompt tokens one input part took.
 * @export
 * @interface WisprMemoryInputTokens
 */
export interface WisprMemoryInputTokens {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryInputTokens
     */
    'part': WisprMemoryInputTokensPartEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryInputTokens
     */
    'tokens': number;
}

export const WisprMemoryInputTokensPartEnum = {
    Gmail: 'gmail',
    Meeting: 'meeting',
    Slack: 'slack',
    OtherSource: 'other_source',
    Documents: 'documents',
    Instructions: 'instructions'
} as const;

export type WisprMemoryInputTokensPartEnum = typeof WisprMemoryInputTokensPartEnum[keyof typeof WisprMemoryInputTokensPartEnum];

/**
 * Ids for Wispr staff to find the caller\'s workflows in Temporal; absent for everyone else.
 * @export
 * @interface WisprMemoryInternalInfo
 */
export interface WisprMemoryInternalInfo {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryInternalInfo
     */
    'owner_environment': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WisprMemoryInternalInfo
     */
    'source_workflow_ids': { [key: string]: string; };
}
/**
 * The activation, source-wake or Dreamer-request outcome.
 * @export
 * @interface WisprMemoryKickResponse
 */
export interface WisprMemoryKickResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryKickResponse
     */
    'outcome': string;
}
/**
 * Finite source coverage and the current owner\'s live agent activity.
 * @export
 * @interface WisprMemoryOnboardingResponse
 */
export interface WisprMemoryOnboardingResponse {
    /**
     * waiting: Start is done, but memory is not on for this owner yet, or was turned off again. No source is read until it is on, so a pending or running source reads paused.
     * @type {string}
     * @memberof WisprMemoryOnboardingResponse
     */
    'state': WisprMemoryOnboardingResponseStateEnum;
    /**
     * 
     * @type {Array<WisprMemorySourceProgress>}
     * @memberof WisprMemoryOnboardingResponse
     */
    'sources': Array<WisprMemorySourceProgress>;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryOnboardingResponse
     */
    'items_left'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryOnboardingResponse
     */
    'onboarded': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryOnboardingResponse
     */
    'writable': boolean;
    /**
     * 
     * @type {WisprMemoryCuratorStatus}
     * @memberof WisprMemoryOnboardingResponse
     */
    'curator': WisprMemoryCuratorStatus | null;
    /**
     * 
     * @type {WisprMemoryDreamerStatus}
     * @memberof WisprMemoryOnboardingResponse
     */
    'dreamer'?: WisprMemoryDreamerStatus | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryOnboardingResponse
     */
    'latest_write_at': string | null;
    /**
     * 
     * @type {WisprMemoryInternalInfo}
     * @memberof WisprMemoryOnboardingResponse
     */
    'internal': WisprMemoryInternalInfo | null;
}

export const WisprMemoryOnboardingResponseStateEnum = {
    NotStarted: 'not_started',
    Running: 'running',
    Waiting: 'waiting',
    Done: 'done',
    Failed: 'failed'
} as const;

export type WisprMemoryOnboardingResponseStateEnum = typeof WisprMemoryOnboardingResponseStateEnum[keyof typeof WisprMemoryOnboardingResponseStateEnum];

/**
 * The estimated reply tokens one output part took; ``cards`` is extraction\'s fact cards, not a file.
 * @export
 * @interface WisprMemoryOutputTokens
 */
export interface WisprMemoryOutputTokens {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryOutputTokens
     */
    'part': WisprMemoryOutputTokensPartEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryOutputTokens
     */
    'tokens': number;
}

export const WisprMemoryOutputTokensPartEnum = {
    Cards: 'cards',
    Context: 'context',
    People: 'people',
    Threads: 'threads',
    Knowledge: 'knowledge',
    Timeline: 'timeline',
    Rules: 'rules',
    Other: 'other'
} as const;

export type WisprMemoryOutputTokensPartEnum = typeof WisprMemoryOutputTokensPartEnum[keyof typeof WisprMemoryOutputTokensPartEnum];

/**
 * What the reset did: ``reset``, or ``residuals_left`` when a wiped table still holds the user\'s rows.
 * @export
 * @interface WisprMemoryResetResponse
 */
export interface WisprMemoryResetResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryResetResponse
     */
    'outcome': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryResetResponse
     */
    'workflows_terminated': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WisprMemoryResetResponse
     */
    'deleted_by_table': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof WisprMemoryResetResponse
     */
    'residual_by_table': { [key: string]: number; };
}
/**
 * One model call of a run; ``input_tokens`` plus ``output_tokens`` over ``context_window`` is how full it got.
 * @export
 * @interface WisprMemoryRunCall
 */
export interface WisprMemoryRunCall {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunCall
     */
    'stage': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunCall
     */
    'model': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunCall
     */
    'input_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunCall
     */
    'cache_read_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunCall
     */
    'output_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunCall
     */
    'context_window': number | null;
    /**
     * 
     * @type {Array<WisprMemoryInputTokens>}
     * @memberof WisprMemoryRunCall
     */
    'input_parts': Array<WisprMemoryInputTokens>;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunCall
     */
    'cost_usd': number | null;
}
/**
 * One run: its summary, the files it changed (at most 500, ``truncated`` past that) and, for agent runs, its input.  ``interleaved`` is set when another run wrote one of these files between this run\'s chunks. ``came_in`` counts the events the run was shown by source, as its usage record or receipt names them; ``documents_read`` is set for Dream runs.
 * @export
 * @interface WisprMemoryRunDetailResponse
 */
export interface WisprMemoryRunDetailResponse {
    /**
     * 
     * @type {WisprMemoryRunSummary}
     * @memberof WisprMemoryRunDetailResponse
     */
    'run': WisprMemoryRunSummary;
    /**
     * 
     * @type {Array<WisprMemoryRunFile>}
     * @memberof WisprMemoryRunDetailResponse
     */
    'files': Array<WisprMemoryRunFile>;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryRunDetailResponse
     */
    'truncated': boolean;
    /**
     * 
     * @type {WisprMemoryRunInput}
     * @memberof WisprMemoryRunDetailResponse
     */
    'input': WisprMemoryRunInput | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryRunDetailResponse
     */
    'interleaved': boolean;
    /**
     * 
     * @type {WisprMemoryRunUsageDetail}
     * @memberof WisprMemoryRunDetailResponse
     */
    'usage_detail'?: WisprMemoryRunUsageDetail | null;
    /**
     * 
     * @type {Array<WisprMemorySourceCount>}
     * @memberof WisprMemoryRunDetailResponse
     */
    'came_in'?: Array<WisprMemorySourceCount>;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunDetailResponse
     */
    'documents_read'?: number | null;
}
/**
 * One file\'s change in one run, as line operations; ``truncated`` when the file passed the diff cap.
 * @export
 * @interface WisprMemoryRunDiffResponse
 */
export interface WisprMemoryRunDiffResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunDiffResponse
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunDiffResponse
     */
    'run_id': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunDiffResponse
     */
    'before_version': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunDiffResponse
     */
    'after_version': number;
    /**
     * 
     * @type {Array<WisprMemoryDiffLine>}
     * @memberof WisprMemoryRunDiffResponse
     */
    'lines': Array<WisprMemoryDiffLine>;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryRunDiffResponse
     */
    'truncated': boolean;
}
/**
 * One file a run changed: the version it wrote and the one before it.  ``history_pruned`` is set when the version before the run is no longer kept, so the change reads as modified with no base to diff against.
 * @export
 * @interface WisprMemoryRunFile
 */
export interface WisprMemoryRunFile {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunFile
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunFile
     */
    'family': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunFile
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunFile
     */
    'change': WisprMemoryRunFileChangeEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunFile
     */
    'before_version': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunFile
     */
    'after_version': number;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryRunFile
     */
    'history_pruned': boolean;
}

export const WisprMemoryRunFileChangeEnum = {
    Added: 'added',
    Modified: 'modified',
    Deleted: 'deleted'
} as const;

export type WisprMemoryRunFileChangeEnum = typeof WisprMemoryRunFileChangeEnum[keyof typeof WisprMemoryRunFileChangeEnum];

/**
 * Retained source-revision input count and currently authorized meeting IDs among those inputs.
 * @export
 * @interface WisprMemoryRunInput
 */
export interface WisprMemoryRunInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof WisprMemoryRunInput
     */
    'meeting_ids': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunInput
     */
    'event_count': number;
}
/**
 * One run derived from retained Document versions and the agent and Dreamer receipts.  ``run_id`` is opaque: pass it back unchanged. ``source`` is set for historical fill run keys. ``outcome`` is null when completion metadata is unavailable. ``tokens`` (in and out) and ``usage`` are set for agent and Dream runs that recorded their model usage, and ``items_read`` counts the retained events an agent run was shown or the sources and documents a Dream run read. A run that changed no file is recorded by its reserved Document receipt; ``label`` names the run when its receipt does and is null for other runs. This is not a permanent execution log.
 * @export
 * @interface WisprMemoryRunSummary
 */
export interface WisprMemoryRunSummary {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'run_id': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'kind': WisprMemoryRunSummaryKindEnum;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'source': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'started_at': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'last_at': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunSummary
     */
    'files_changed': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'outcome': string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunSummary
     */
    'tokens': number | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunSummary
     */
    'label'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunSummary
     */
    'items_read'?: number | null;
    /**
     * 
     * @type {WisprMemoryRunUsage}
     * @memberof WisprMemoryRunSummary
     */
    'usage'?: WisprMemoryRunUsage | null;
}

export const WisprMemoryRunSummaryKindEnum = {
    Start: 'start',
    Fill: 'fill',
    Curate: 'curate',
    Dream: 'dream'
} as const;

export type WisprMemoryRunSummaryKindEnum = typeof WisprMemoryRunSummaryKindEnum[keyof typeof WisprMemoryRunSummaryKindEnum];

/**
 * What a run\'s model calls billed, recorded when the run committed.  ``input_tokens`` counts every prompt token, ``cache_read_tokens`` of them included. The costs are estimates at the current list prices, cache writes in ``cache_cost_usd``; they are null when a call\'s model has no price.
 * @export
 * @interface WisprMemoryRunUsage
 */
export interface WisprMemoryRunUsage {
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'input_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'cache_read_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'output_tokens': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'cost_usd': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'input_cost_usd': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'cache_cost_usd': number | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryRunUsage
     */
    'output_cost_usd': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WisprMemoryRunUsage
     */
    'models': Array<string>;
}
/**
 * A run\'s tokens split by part, estimated from each part\'s size, and its calls in order.
 * @export
 * @interface WisprMemoryRunUsageDetail
 */
export interface WisprMemoryRunUsageDetail {
    /**
     * 
     * @type {Array<WisprMemoryInputTokens>}
     * @memberof WisprMemoryRunUsageDetail
     */
    'input_parts': Array<WisprMemoryInputTokens>;
    /**
     * 
     * @type {Array<WisprMemoryOutputTokens>}
     * @memberof WisprMemoryRunUsageDetail
     */
    'output_parts': Array<WisprMemoryOutputTokens>;
    /**
     * 
     * @type {Array<WisprMemoryRunCall>}
     * @memberof WisprMemoryRunUsageDetail
     */
    'calls': Array<WisprMemoryRunCall>;
}
/**
 * A newest-first page of runs from the last 90 days; pass ``next_cursor`` as ``cursor`` for the next page.
 * @export
 * @interface WisprMemoryRunsResponse
 */
export interface WisprMemoryRunsResponse {
    /**
     * 
     * @type {Array<WisprMemoryRunSummary>}
     * @memberof WisprMemoryRunsResponse
     */
    'runs': Array<WisprMemoryRunSummary>;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryRunsResponse
     */
    'next_cursor': string | null;
}
/**
 * One file with matches: its head version, match count and the first few matching lines.
 * @export
 * @interface WisprMemorySearchFile
 */
export interface WisprMemorySearchFile {
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchFile
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchFile
     */
    'family': string | null;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchFile
     */
    'title': string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySearchFile
     */
    'head_version': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySearchFile
     */
    'match_count': number;
    /**
     * 
     * @type {Array<WisprMemorySearchLine>}
     * @memberof WisprMemorySearchFile
     */
    'lines': Array<WisprMemorySearchLine>;
}
/**
 * One matching line, 1-based, trimmed to 200 characters.
 * @export
 * @interface WisprMemorySearchLine
 */
export interface WisprMemorySearchLine {
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySearchLine
     */
    'line': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchLine
     */
    'text': string;
}
/**
 * A matching path and its match count, for marking the tree.
 * @export
 * @interface WisprMemorySearchPathCount
 */
export interface WisprMemorySearchPathCount {
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchPathCount
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySearchPathCount
     */
    'match_count': number;
}
/**
 * A case-insensitive substring search over every current file\'s path, frontmatter and lines.
 * @export
 * @interface WisprMemorySearchRequest
 */
export interface WisprMemorySearchRequest {
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySearchRequest
     */
    'q': string;
}
/**
 * The top files with their lines, and every matching path (up to 1000) for the tree; ``truncated`` past a cap.
 * @export
 * @interface WisprMemorySearchResponse
 */
export interface WisprMemorySearchResponse {
    /**
     * 
     * @type {Array<WisprMemorySearchFile>}
     * @memberof WisprMemorySearchResponse
     */
    'files': Array<WisprMemorySearchFile>;
    /**
     * 
     * @type {Array<WisprMemorySearchPathCount>}
     * @memberof WisprMemorySearchResponse
     */
    'paths': Array<WisprMemorySearchPathCount>;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemorySearchResponse
     */
    'truncated': boolean;
}
/**
 * How many Inbox rows from one source a run read.
 * @export
 * @interface WisprMemorySourceCount
 */
export interface WisprMemorySourceCount {
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySourceCount
     */
    'source': WisprMemorySourceCountSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySourceCount
     */
    'count': number;
}

export const WisprMemorySourceCountSourceEnum = {
    Gmail: 'gmail',
    Meeting: 'meeting',
    Slack: 'slack',
    Other: 'other'
} as const;

export type WisprMemorySourceCountSourceEnum = typeof WisprMemorySourceCountSourceEnum[keyof typeof WisprMemorySourceCountSourceEnum];

/**
 * Wake one live source; ``force=True`` is refused in favor of a relearn.
 * @export
 * @interface WisprMemorySourceKickRequest
 */
export interface WisprMemorySourceKickRequest {
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemorySourceKickRequest
     */
    'force'?: boolean;
}
/**
 * A frozen historical source window and the facts observed while covering it.
 * @export
 * @interface WisprMemorySourceProgress
 */
export interface WisprMemorySourceProgress {
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'state': WisprMemorySourceProgressStateEnum;
    /**
     * Source items inspected in the frozen window.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'fetched': number;
    /**
     * Fetched items excluded by source admission.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'skipped': number;
    /**
     * Fetched items no longer available to the owner.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'unavailable': number;
    /**
     * Fetched items that could not be processed.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'failed': number;
    /**
     * Historical pages imported so far.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'pages_done'?: number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'error_code'?: string | null;
    /**
     * Inclusive lower bound of the frozen source window.
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'lower_bound': string;
    /**
     * Exclusive upper bound of the frozen source window.
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'upper_bound': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemorySourceProgress
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'processing_left'?: number | null;
    /**
     * Items this connection delivered, imported or live, that expired or failed before being learned from, capped at 999.
     * @type {number}
     * @memberof WisprMemorySourceProgress
     */
    'processing_failed'?: number;
}

export const WisprMemorySourceProgressStateEnum = {
    Pending: 'pending',
    Running: 'running',
    Paused: 'paused',
    Done: 'done',
    Failed: 'failed'
} as const;

export type WisprMemorySourceProgressStateEnum = typeof WisprMemorySourceProgressStateEnum[keyof typeof WisprMemorySourceProgressStateEnum];

/**
 * One live file in the caller\'s memory tree: its latest version\'s metadata, never its content.  ``family`` names the kind of file (``person``, ``people_index``, ``context``), null for a file of no family. ``title`` is a person\'s name from a dossier\'s frontmatter; null for every other family. ``is_self`` marks the owner\'s own dossier.
 * @export
 * @interface WisprMemoryTreeEntry
 */
export interface WisprMemoryTreeEntry {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryTreeEntry
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryTreeEntry
     */
    'family': string | null;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryTreeEntry
     */
    'version': number;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryTreeEntry
     */
    'size_bytes': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryTreeEntry
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryTreeEntry
     */
    'title': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryTreeEntry
     */
    'is_self'?: boolean;
}
/**
 * Live files under the requested prefix in path order; ``truncated`` when the entry cap cut the list.
 * @export
 * @interface WisprMemoryTreeResponse
 */
export interface WisprMemoryTreeResponse {
    /**
     * 
     * @type {Array<WisprMemoryTreeEntry>}
     * @memberof WisprMemoryTreeResponse
     */
    'entries': Array<WisprMemoryTreeEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryTreeResponse
     */
    'truncated': boolean;
}
/**
 * One stored version of a file; a version that deleted the file has ``deleted`` set and size 0.  ``run_id`` is the run that wrote it, null for a write the hub does not show as a run.
 * @export
 * @interface WisprMemoryVersionEntry
 */
export interface WisprMemoryVersionEntry {
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryVersionEntry
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryVersionEntry
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryVersionEntry
     */
    'actor': string;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryVersionEntry
     */
    'size_bytes': number;
    /**
     * 
     * @type {boolean}
     * @memberof WisprMemoryVersionEntry
     */
    'deleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryVersionEntry
     */
    'run_id': string | null;
}
/**
 * A newest-first page of one file\'s versions; pass ``next_cursor`` as ``before`` for the next page.
 * @export
 * @interface WisprMemoryVersionsResponse
 */
export interface WisprMemoryVersionsResponse {
    /**
     * 
     * @type {string}
     * @memberof WisprMemoryVersionsResponse
     */
    'path': string;
    /**
     * 
     * @type {Array<WisprMemoryVersionEntry>}
     * @memberof WisprMemoryVersionsResponse
     */
    'versions': Array<WisprMemoryVersionEntry>;
    /**
     * 
     * @type {number}
     * @memberof WisprMemoryVersionsResponse
     */
    'next_cursor': number | null;
}
/**
 * Words dictated on a single calendar day, split by desktop vs mobile.
 * @export
 * @interface WordsDictatedDailyPoint
 */
export interface WordsDictatedDailyPoint {
    /**
     * 
     * @type {string}
     * @memberof WordsDictatedDailyPoint
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedDailyPoint
     */
    'desktop': number;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedDailyPoint
     */
    'mobile': number;
}
/**
 * Headline + delta + daily/weekly timeseries.  ``pct_change_vs_prev_period`` is percent-scale (``12.34`` = 12.34%). The prior period is picked by ``filters.comparison_mode`` when set, otherwise by shape detection (calendar-aligned for YTD/MTD shapes, rolling otherwise). Lifetime (no ``start_date``) falls back to L7 vs L7-L14. ``null`` when prior=0 with non-zero current (undefined), or no comparable prior period exists.
 * @export
 * @interface WordsDictatedResponse
 */
export interface WordsDictatedResponse {
    /**
     * 
     * @type {TeamInsightsFilters}
     * @memberof WordsDictatedResponse
     */
    'filters_applied': TeamInsightsFilters;
    /**
     * 
     * @type {Array<string>}
     * @memberof WordsDictatedResponse
     */
    'data_quality_flags'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedResponse
     */
    'pct_change_vs_prev_period'?: number | null;
    /**
     * 
     * @type {WordsDictatedTimeseries}
     * @memberof WordsDictatedResponse
     */
    'timeseries': WordsDictatedTimeseries;
}
/**
 * Words-dictated series at both daily and weekly granularity.
 * @export
 * @interface WordsDictatedTimeseries
 */
export interface WordsDictatedTimeseries {
    /**
     * 
     * @type {Array<WordsDictatedDailyPoint>}
     * @memberof WordsDictatedTimeseries
     */
    'daily': Array<WordsDictatedDailyPoint>;
    /**
     * 
     * @type {Array<WordsDictatedWeeklyPoint>}
     * @memberof WordsDictatedTimeseries
     */
    'weekly': Array<WordsDictatedWeeklyPoint>;
}
/**
 * ``period`` is the ISO date of the week\'s Sunday (e.g. ``2026-04-12``).
 * @export
 * @interface WordsDictatedWeeklyPoint
 */
export interface WordsDictatedWeeklyPoint {
    /**
     * 
     * @type {string}
     * @memberof WordsDictatedWeeklyPoint
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedWeeklyPoint
     */
    'desktop': number;
    /**
     * 
     * @type {number}
     * @memberof WordsDictatedWeeklyPoint
     */
    'mobile': number;
}
/**
 * Envelope for 4xx migration errors that clients may handle explicitly.
 * @export
 * @interface WorkOSSessionMigrateClientErrorResponse
 */
export interface WorkOSSessionMigrateClientErrorResponse {
    /**
     * 
     * @type {WorkOSSessionMigrateErrorDetail}
     * @memberof WorkOSSessionMigrateClientErrorResponse
     */
    'detail': WorkOSSessionMigrateErrorDetail;
}
/**
 * Machine-readable error payload for client-handled session migration failures.
 * @export
 * @interface WorkOSSessionMigrateErrorDetail
 */
export interface WorkOSSessionMigrateErrorDetail {
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateErrorDetail
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateErrorDetail
     */
    'message': string;
}
/**
 * Typed response payload returned by WorkOS session migration.
 * @export
 * @interface WorkOSSessionMigrateResponse
 */
export interface WorkOSSessionMigrateResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateResponse
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateResponse
     */
    'refresh_token': string;
    /**
     * 
     * @type {WorkOSSessionMigrateUser}
     * @memberof WorkOSSessionMigrateResponse
     */
    'user': WorkOSSessionMigrateUser;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateResponse
     */
    'organization_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateResponse
     */
    'authentication_method'?: string | null;
}
/**
 * Envelope for 5xx migration errors returned as generic strings.
 * @export
 * @interface WorkOSSessionMigrateServerErrorResponse
 */
export interface WorkOSSessionMigrateServerErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateServerErrorResponse
     */
    'detail': string;
}
/**
 * User payload returned by WorkOS session migration.
 * @export
 * @interface WorkOSSessionMigrateUser
 */
export interface WorkOSSessionMigrateUser {
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateUser
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateUser
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateUser
     */
    'external_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateUser
     */
    'first_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOSSessionMigrateUser
     */
    'last_name'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkOSSessionMigrateUser
     */
    'email_verified'?: boolean | null;
}
/**
 * The retired per-event work states; ``EventEntry.state`` keeps the enum but is always null now.
 * @export
 * @enum {string}
 */

export const WorkState = {
    Pending: 'pending',
    Processing: 'processing',
    Retryable: 'retryable',
    Succeeded: 'succeeded',
    NoChange: 'no_change',
    Skipped: 'skipped',
    Quarantined: 'quarantined',
    Cancelled: 'cancelled',
    Superseded: 'superseded',
    ExpiredUnprocessed: 'expired_unprocessed'
} as const;

export type WorkState = typeof WorkState[keyof typeof WorkState];


/**
 * One event as read back from WorkOS — a distinct shape from `AuditLogEntry`.  Deliberately thin compared to `AuditLogEntry`: WorkOS\'s own schema returns names frozen at emit time (no live enrichment) and no `source`/`target_email` equivalent. See `services/audit_log/workos_audit_events.py`.
 * @export
 * @interface WorkosAuditLogEntry
 */
export interface WorkosAuditLogEntry {
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'event_id': string;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'actor_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'actor_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'actor_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'target_id': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'target_type': string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogEntry
     */
    'target_name': string | null;
    /**
     * 
     * @type {object}
     * @memberof WorkosAuditLogEntry
     */
    'raw_data': object;
}
/**
 * Paginated WorkOS-sourced response, no `total` (WorkOS\'s own schema returns neither).  Paginated by our own date-boundary narrowing, not WorkOS\'s own cursor (confirmed broken — see `services/audit_log/workos_audit_events.py`\'s module docstring).
 * @export
 * @interface WorkosAuditLogTableResponse
 */
export interface WorkosAuditLogTableResponse {
    /**
     * 
     * @type {Array<WorkosAuditLogEntry>}
     * @memberof WorkosAuditLogTableResponse
     */
    'rows': Array<WorkosAuditLogEntry>;
    /**
     * 
     * @type {string}
     * @memberof WorkosAuditLogTableResponse
     */
    'before': string | null;
    /**
     * True when this page hit the pagination boundary\'s known limitation: every row shares one timestamp, so older events in the range exist but can\'t be reached. `before` is null in that case too — there\'s nothing more to safely fetch.
     * @type {boolean}
     * @memberof WorkosAuditLogTableResponse
     */
    'truncated'?: boolean;
}
/**
 * A single WorkOS directory returned by the live directory-status lookup.
 * @export
 * @interface WorkosDirectoryItem
 */
export interface WorkosDirectoryItem {
    /**
     * 
     * @type {string}
     * @memberof WorkosDirectoryItem
     */
    'id': string;
    /**
     * WorkOS directory state (e.g. active, inactive, validating); unrecognized states pass through.
     * @type {string}
     * @memberof WorkosDirectoryItem
     */
    'state': string;
    /**
     * 
     * @type {string}
     * @memberof WorkosDirectoryItem
     */
    'name'?: string | null;
}
/**
 * Live WorkOS directory status for an enterprise; WorkOS failures degrade to status=unknown, never a 5xx.
 * @export
 * @interface WorkosDirectoryStatusResponse
 */
export interface WorkosDirectoryStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkosDirectoryStatusResponse
     */
    'status': WorkosDirectoryStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkosDirectoryStatusResponse
     */
    'reason'?: string | null;
    /**
     * 
     * @type {Array<WorkosDirectoryItem>}
     * @memberof WorkosDirectoryStatusResponse
     */
    'directories'?: Array<WorkosDirectoryItem> | null;
    /**
     * 
     * @type {string}
     * @memberof WorkosDirectoryStatusResponse
     */
    'workos_directory_id'?: string | null;
}

export const WorkosDirectoryStatusResponseStatusEnum = {
    Ok: 'ok',
    NotConnected: 'not_connected',
    Unknown: 'unknown'
} as const;

export type WorkosDirectoryStatusResponseStatusEnum = typeof WorkosDirectoryStatusResponseStatusEnum[keyof typeof WorkosDirectoryStatusResponseStatusEnum];

/**
 * Coverage of research observations returned to this process.
 * @export
 * @interface WriterResearch
 */
export interface WriterResearch {
    /**
     * 
     * @type {boolean}
     * @memberof WriterResearch
     */
    'complete'?: boolean;
    /**
     * 
     * @type {Array<ResearchCall>}
     * @memberof WriterResearch
     */
    'calls'?: Array<ResearchCall>;
}
/**
 * A single writing sample provided by the user for voice/style matching.
 * @export
 * @interface WritingSample
 */
export interface WritingSample {
    /**
     * 
     * @type {string}
     * @memberof WritingSample
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof WritingSample
     */
    'prompt_name'?: string | null;
}
/**
 * One Zoom meeting occurrence the picker lists; ``source_id`` is what confirm takes.
 * @export
 * @interface ZoomCatalogItem
 */
export interface ZoomCatalogItem {
    /**
     * 
     * @type {string}
     * @memberof ZoomCatalogItem
     */
    'source_id': string;
    /**
     * 
     * @type {string}
     * @memberof ZoomCatalogItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ZoomCatalogItem
     */
    'started_at': string;
    /**
     * 
     * @type {number}
     * @memberof ZoomCatalogItem
     */
    'duration_seconds': number;
    /**
     * 
     * @type {CatalogPiece}
     * @memberof ZoomCatalogItem
     */
    'transcript': CatalogPiece;
    /**
     * 
     * @type {CatalogPiece}
     * @memberof ZoomCatalogItem
     */
    'summary': CatalogPiece;
    /**
     * 
     * @type {boolean}
     * @memberof ZoomCatalogItem
     */
    'importable': boolean;
    /**
     * 
     * @type {CatalogReason}
     * @memberof ZoomCatalogItem
     */
    'reason'?: CatalogReason | null;
    /**
     * True when an earlier import run copied this meeting. Deleting the imported meeting does not clear it.
     * @type {boolean}
     * @memberof ZoomCatalogItem
     */
    'already_imported': boolean;
}


/**
 * One window of the caller\'s Zoom meetings, newest first.  Both dates are inclusive, in UTC. To load earlier meetings, ask again with ``before`` set to the day before ``window_start``.
 * @export
 * @interface ZoomCatalogResponse
 */
export interface ZoomCatalogResponse {
    /**
     * 
     * @type {string}
     * @memberof ZoomCatalogResponse
     */
    'window_start': string;
    /**
     * 
     * @type {string}
     * @memberof ZoomCatalogResponse
     */
    'window_end': string;
    /**
     * 
     * @type {Array<ZoomCatalogItem>}
     * @memberof ZoomCatalogResponse
     */
    'items': Array<ZoomCatalogItem>;
}
/**
 * Whether the user\'s Zoom account is connected, needs reconnecting, or is disconnected.
 * @export
 * @interface ZoomConnectionResponse
 */
export interface ZoomConnectionResponse {
    /**
     * 
     * @type {ZoomConnectionStatus}
     * @memberof ZoomConnectionResponse
     */
    'status': ZoomConnectionStatus;
}


/**
 * Whether the user\'s Zoom account can be used for an import.
 * @export
 * @enum {string}
 */

export const ZoomConnectionStatus = {
    Connected: 'connected',
    NeedsReauth: 'needs_reauth',
    Disconnected: 'disconnected'
} as const;

export type ZoomConnectionStatus = typeof ZoomConnectionStatus[keyof typeof ZoomConnectionStatus];



/**
 * AccessApi - axios parameter creator
 * @export
 */
export const AccessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return only the authenticated user\'s resolved access keys.
         * @summary Get Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccess: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessApi - functional programming interface
 * @export
 */
export const AccessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccessApiAxiosParamCreator(configuration)
    return {
        /**
         * Return only the authenticated user\'s resolved access keys.
         * @summary Get Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccess(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccess(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccessApi.getAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccessApi - factory interface
 * @export
 */
export const AccessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccessApiFp(configuration)
    return {
        /**
         * Return only the authenticated user\'s resolved access keys.
         * @summary Get Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccess(options?: RawAxiosRequestConfig): AxiosPromise<AccessResponse> {
            return localVarFp.getAccess(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccessApi - object-oriented interface
 * @export
 * @class AccessApi
 * @extends {BaseAPI}
 */
export class AccessApi extends BaseAPI {
    /**
     * Return only the authenticated user\'s resolved access keys.
     * @summary Get Access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessApi
     */
    public getAccess(options?: RawAxiosRequestConfig) {
        return AccessApiFp(this.configuration).getAccess(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ingest user metadata into ClickHouse.
         * @summary Ingest User Metadata Endpoint
         * @param {UserMetadataRequest} userMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestUserMetadataEndpoint: async (userMetadataRequest: UserMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMetadataRequest' is not null or undefined
            assertParamExists('ingestUserMetadataEndpoint', 'userMetadataRequest', userMetadataRequest)
            const localVarPath = `/api/v1/analytics/user-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch user metadata rows from ClickHouse with pagination using request body.
         * @summary Query User Metadata Endpoint
         * @param {UserMetadataQueryRequest} userMetadataQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryUserMetadataEndpoint: async (userMetadataQueryRequest: UserMetadataQueryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMetadataQueryRequest' is not null or undefined
            assertParamExists('queryUserMetadataEndpoint', 'userMetadataQueryRequest', userMetadataQueryRequest)
            const localVarPath = `/api/v1/analytics/user-metadata/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userMetadataQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated no-op retained for backward compatibility; validates and discards the payload (analytics moved to PostHog).
         * @summary Track Event Endpoint
         * @param {TrackEventRequest} trackEventRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        trackEventEndpoint: async (trackEventRequest: TrackEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackEventRequest' is not null or undefined
            assertParamExists('trackEventEndpoint', 'trackEventRequest', trackEventRequest)
            const localVarPath = `/api/v1/analytics/track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Ingest user metadata into ClickHouse.
         * @summary Ingest User Metadata Endpoint
         * @param {UserMetadataRequest} userMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestUserMetadataEndpoint(userMetadataRequest: UserMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestUserMetadataEndpoint(userMetadataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.ingestUserMetadataEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch user metadata rows from ClickHouse with pagination using request body.
         * @summary Query User Metadata Endpoint
         * @param {UserMetadataQueryRequest} userMetadataQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryUserMetadataEndpoint(userMetadataQueryRequest: UserMetadataQueryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMetadataListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryUserMetadataEndpoint(userMetadataQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.queryUserMetadataEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deprecated no-op retained for backward compatibility; validates and discards the payload (analytics moved to PostHog).
         * @summary Track Event Endpoint
         * @param {TrackEventRequest} trackEventRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async trackEventEndpoint(trackEventRequest: TrackEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackEventEndpoint(trackEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsApi.trackEventEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * Ingest user metadata into ClickHouse.
         * @summary Ingest User Metadata Endpoint
         * @param {UserMetadataRequest} userMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestUserMetadataEndpoint(userMetadataRequest: UserMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.ingestUserMetadataEndpoint(userMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch user metadata rows from ClickHouse with pagination using request body.
         * @summary Query User Metadata Endpoint
         * @param {UserMetadataQueryRequest} userMetadataQueryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryUserMetadataEndpoint(userMetadataQueryRequest: UserMetadataQueryRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserMetadataListResponse> {
            return localVarFp.queryUserMetadataEndpoint(userMetadataQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated no-op retained for backward compatibility; validates and discards the payload (analytics moved to PostHog).
         * @summary Track Event Endpoint
         * @param {TrackEventRequest} trackEventRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        trackEventEndpoint(trackEventRequest: TrackEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.trackEventEndpoint(trackEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * Ingest user metadata into ClickHouse.
     * @summary Ingest User Metadata Endpoint
     * @param {UserMetadataRequest} userMetadataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public ingestUserMetadataEndpoint(userMetadataRequest: UserMetadataRequest, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).ingestUserMetadataEndpoint(userMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch user metadata rows from ClickHouse with pagination using request body.
     * @summary Query User Metadata Endpoint
     * @param {UserMetadataQueryRequest} userMetadataQueryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public queryUserMetadataEndpoint(userMetadataQueryRequest: UserMetadataQueryRequest, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).queryUserMetadataEndpoint(userMetadataQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated no-op retained for backward compatibility; validates and discards the payload (analytics moved to PostHog).
     * @summary Track Event Endpoint
     * @param {TrackEventRequest} trackEventRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public trackEventEndpoint(trackEventRequest: TrackEventRequest, options?: RawAxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).trackEventEndpoint(trackEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsRegistryApi - axios parameter creator
 * @export
 */
export const AnalyticsRegistryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create or update a batch of analytics events in one request (internal admin only).
         * @summary Batch Save Events
         * @param {BatchSaveRequest} batchSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSaveEvents: async (batchSaveRequest: BatchSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchSaveRequest' is not null or undefined
            assertParamExists('batchSaveEvents', 'batchSaveRequest', batchSaveRequest)
            const localVarPath = `/api/v1/analytics-registry/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(batchSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the global analytics properties schema (internal admin only).
         * @summary Get Global Properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/analytics-registry/global-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all registered analytics events (internal admin only).
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/analytics-registry/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark a change set implemented (webhook-secret authenticated, called from CI).
         * @summary Mark Implemented
         * @param {string} changeSetId 
         * @param {string | null} [xWebhookSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markImplemented: async (changeSetId: string, xWebhookSecret?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeSetId' is not null or undefined
            assertParamExists('markImplemented', 'changeSetId', changeSetId)
            const localVarPath = `/api/v1/analytics-registry/change-sets/{change_set_id}/mark-implemented`
                .replace(`{${"change_set_id"}}`, encodeURIComponent(String(changeSetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xWebhookSecret != null) {
                localVarHeaderParameter['X-Webhook-Secret'] = String(xWebhookSecret);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish pending analytics changes as a new change set (internal admin only).
         * @summary Publish
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/analytics-registry/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Preview the analytics schema snapshot that publishing would produce (internal admin only).
         * @summary Publish Preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/analytics-registry/publish/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the global analytics properties schema (internal admin only).
         * @summary Save Global Properties
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGlobalProperties: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveGlobalProperties', 'body', body)
            const localVarPath = `/api/v1/analytics-registry/global-properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsRegistryApi - functional programming interface
 * @export
 */
export const AnalyticsRegistryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsRegistryApiAxiosParamCreator(configuration)
    return {
        /**
         * Create or update a batch of analytics events in one request (internal admin only).
         * @summary Batch Save Events
         * @param {BatchSaveRequest} batchSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchSaveEvents(batchSaveRequest: BatchSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BatchSaveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchSaveEvents(batchSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.batchSaveEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the global analytics properties schema (internal admin only).
         * @summary Get Global Properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlobalProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlobalProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.getGlobalProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all registered analytics events (internal admin only).
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AnalyticsEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.listEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark a change set implemented (webhook-secret authenticated, called from CI).
         * @summary Mark Implemented
         * @param {string} changeSetId 
         * @param {string | null} [xWebhookSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markImplemented(changeSetId: string, xWebhookSecret?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markImplemented(changeSetId, xWebhookSecret, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.markImplemented']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publish pending analytics changes as a new change set (internal admin only).
         * @summary Publish
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publish(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeSetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publish(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.publish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Preview the analytics schema snapshot that publishing would produce (internal admin only).
         * @summary Publish Preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.publishPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the global analytics properties schema (internal admin only).
         * @summary Save Global Properties
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveGlobalProperties(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveGlobalProperties(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalyticsRegistryApi.saveGlobalProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalyticsRegistryApi - factory interface
 * @export
 */
export const AnalyticsRegistryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsRegistryApiFp(configuration)
    return {
        /**
         * Create or update a batch of analytics events in one request (internal admin only).
         * @summary Batch Save Events
         * @param {BatchSaveRequest} batchSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchSaveEvents(batchSaveRequest: BatchSaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<BatchSaveResponse> {
            return localVarFp.batchSaveEvents(batchSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the global analytics properties schema (internal admin only).
         * @summary Get Global Properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalProperties(options?: RawAxiosRequestConfig): AxiosPromise<AnalyticsEventResponse> {
            return localVarFp.getGlobalProperties(options).then((request) => request(axios, basePath));
        },
        /**
         * List all registered analytics events (internal admin only).
         * @summary List Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents(options?: RawAxiosRequestConfig): AxiosPromise<Array<AnalyticsEventResponse>> {
            return localVarFp.listEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark a change set implemented (webhook-secret authenticated, called from CI).
         * @summary Mark Implemented
         * @param {string} changeSetId 
         * @param {string | null} [xWebhookSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markImplemented(changeSetId: string, xWebhookSecret?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.markImplemented(changeSetId, xWebhookSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish pending analytics changes as a new change set (internal admin only).
         * @summary Publish
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publish(options?: RawAxiosRequestConfig): AxiosPromise<ChangeSetResponse> {
            return localVarFp.publish(options).then((request) => request(axios, basePath));
        },
        /**
         * Preview the analytics schema snapshot that publishing would produce (internal admin only).
         * @summary Publish Preview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPreview(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.publishPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * Update the global analytics properties schema (internal admin only).
         * @summary Save Global Properties
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveGlobalProperties(body: object, options?: RawAxiosRequestConfig): AxiosPromise<AnalyticsEventResponse> {
            return localVarFp.saveGlobalProperties(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsRegistryApi - object-oriented interface
 * @export
 * @class AnalyticsRegistryApi
 * @extends {BaseAPI}
 */
export class AnalyticsRegistryApi extends BaseAPI {
    /**
     * Create or update a batch of analytics events in one request (internal admin only).
     * @summary Batch Save Events
     * @param {BatchSaveRequest} batchSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public batchSaveEvents(batchSaveRequest: BatchSaveRequest, options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).batchSaveEvents(batchSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the global analytics properties schema (internal admin only).
     * @summary Get Global Properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public getGlobalProperties(options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).getGlobalProperties(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all registered analytics events (internal admin only).
     * @summary List Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public listEvents(options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).listEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark a change set implemented (webhook-secret authenticated, called from CI).
     * @summary Mark Implemented
     * @param {string} changeSetId 
     * @param {string | null} [xWebhookSecret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public markImplemented(changeSetId: string, xWebhookSecret?: string | null, options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).markImplemented(changeSetId, xWebhookSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish pending analytics changes as a new change set (internal admin only).
     * @summary Publish
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public publish(options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).publish(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Preview the analytics schema snapshot that publishing would produce (internal admin only).
     * @summary Publish Preview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public publishPreview(options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).publishPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the global analytics properties schema (internal admin only).
     * @summary Save Global Properties
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsRegistryApi
     */
    public saveGlobalProperties(body: object, options?: RawAxiosRequestConfig) {
        return AnalyticsRegistryApiFp(this.configuration).saveGlobalProperties(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttributionTrackingApi - axios parameter creator
 * @export
 */
export const AttributionTrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Track when a user views the paywall/pricing screen.  This event can be sent multiple times (repeatable) and is deduplicated by the timestamp parameter.  ga4_client_id is optional for native apps (desktop, iOS, Android). If not provided, it will be derived from the user_id for cross-device attribution. Web clients should provide ga4_client_id from gtag.js cookies.
         * @summary Track Paywall Viewed
         * @param {PaywallViewedRequest} paywallViewedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackPaywallViewed: async (paywallViewedRequest: PaywallViewedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paywallViewedRequest' is not null or undefined
            assertParamExists('trackPaywallViewed', 'paywallViewedRequest', paywallViewedRequest)
            const localVarPath = `/api/v1/attribution/paywall-viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paywallViewedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributionTrackingApi - functional programming interface
 * @export
 */
export const AttributionTrackingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttributionTrackingApiAxiosParamCreator(configuration)
    return {
        /**
         * Track when a user views the paywall/pricing screen.  This event can be sent multiple times (repeatable) and is deduplicated by the timestamp parameter.  ga4_client_id is optional for native apps (desktop, iOS, Android). If not provided, it will be derived from the user_id for cross-device attribution. Web clients should provide ga4_client_id from gtag.js cookies.
         * @summary Track Paywall Viewed
         * @param {PaywallViewedRequest} paywallViewedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackPaywallViewed(paywallViewedRequest: PaywallViewedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttributionTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackPaywallViewed(paywallViewedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributionTrackingApi.trackPaywallViewed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttributionTrackingApi - factory interface
 * @export
 */
export const AttributionTrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttributionTrackingApiFp(configuration)
    return {
        /**
         * Track when a user views the paywall/pricing screen.  This event can be sent multiple times (repeatable) and is deduplicated by the timestamp parameter.  ga4_client_id is optional for native apps (desktop, iOS, Android). If not provided, it will be derived from the user_id for cross-device attribution. Web clients should provide ga4_client_id from gtag.js cookies.
         * @summary Track Paywall Viewed
         * @param {PaywallViewedRequest} paywallViewedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackPaywallViewed(paywallViewedRequest: PaywallViewedRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttributionTrackingResponse> {
            return localVarFp.trackPaywallViewed(paywallViewedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttributionTrackingApi - object-oriented interface
 * @export
 * @class AttributionTrackingApi
 * @extends {BaseAPI}
 */
export class AttributionTrackingApi extends BaseAPI {
    /**
     * Track when a user views the paywall/pricing screen.  This event can be sent multiple times (repeatable) and is deduplicated by the timestamp parameter.  ga4_client_id is optional for native apps (desktop, iOS, Android). If not provided, it will be derived from the user_id for cross-device attribution. Web clients should provide ga4_client_id from gtag.js cookies.
     * @summary Track Paywall Viewed
     * @param {PaywallViewedRequest} paywallViewedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributionTrackingApi
     */
    public trackPaywallViewed(paywallViewedRequest: PaywallViewedRequest, options?: RawAxiosRequestConfig) {
        return AttributionTrackingApiFp(this.configuration).trackPaywallViewed(paywallViewedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add an email to the notification waitlist.
         * @summary Add To Waitlist
         * @param {AddToWaitlistRequest} addToWaitlistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToWaitlist: async (addToWaitlistRequest: AddToWaitlistRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addToWaitlistRequest' is not null or undefined
            assertParamExists('addToWaitlist', 'addToWaitlistRequest', addToWaitlistRequest)
            const localVarPath = `/add_to_waitlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addToWaitlistRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the Apple App Site Association file for universal links.
         * @summary Apple App Site Association
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/apple-app-site-association`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Apple callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Apple Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleCallback: async (source?: string | null, isPlatformUser?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apple/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin Apple OAuth sign-in and redirect the caller to the provider.
         * @summary Apple Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleSignIn: async (source?: string | null, isPlatformUser?: boolean, client?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/apple/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the AuthKit Apple OAuth callback and complete sign-in.
         * @summary Authkit Apple Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitAppleCallback: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/apple/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin AuthKit-backed Apple sign-in and redirect the caller to the provider.
         * @summary Authkit Apple Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitAppleSignIn: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/apple/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the AuthKit Google OAuth callback and complete sign-in.
         * @summary Authkit Google Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitGoogleCallback: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/google/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin AuthKit-backed Google sign-in and redirect the caller to the provider.
         * @summary Authkit Google Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitGoogleSignIn: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/google/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the AuthKit Microsoft OAuth callback and complete sign-in.
         * @summary Authkit Microsoft Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitMicrosoftCallback: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/microsoft/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin AuthKit-backed Microsoft sign-in and redirect the caller to the provider.
         * @summary Authkit Microsoft Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitMicrosoftSignIn: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/microsoft/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the AuthKit enterprise SSO callback and complete sign-in.
         * @summary Authkit Sso Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitSsoCallback: async (source?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/sso/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin AuthKit-backed enterprise SSO sign-in and redirect the caller to the provider.
         * @summary Authkit Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitSsoSignIn: async (source?: string | null, email?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authkit/sso/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a raw email signup and redirect verified users to onboarding.
         * @summary Confirm Email
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail: async (email?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/confirm_raw_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user and email them a password reset link (Wispr admins only).  Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (createUserRequest: CreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserRequest' is not null or undefined
            assertParamExists('createUser', 'createUserRequest', createUserRequest)
            const localVarPath = `/email/create-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit auth tokens for a pending desktop device code after web sign-in.  Pushes tokens to a Redis list, which the Server-Sent Events (SSE) stream picks up on its next poll (1-4s).
         * @summary Device Complete
         * @param {DeviceCodeCompleteRequest} deviceCodeCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceComplete: async (deviceCodeCompleteRequest: DeviceCodeCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceCodeCompleteRequest' is not null or undefined
            assertParamExists('deviceComplete', 'deviceCodeCompleteRequest', deviceCodeCompleteRequest)
            const localVarPath = `/device/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceCodeCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll for device-code auth tokens.  Pops the main list and keeps the same 30s recovery copy the stream keeps, so tokens whose stream frame or poll response was lost are served again by the next poll or stream within that window.
         * @summary Device Poll
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicePoll: async (deviceCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceCode' is not null or undefined
            assertParamExists('devicePoll', 'deviceCode', deviceCode)
            const localVarPath = `/device/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceCode !== undefined) {
                localVarQueryParameter['device_code'] = deviceCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stream device-code auth tokens to the desktop via Server-Sent Events until they arrive or timeout.  Polls the Redis list every second at first, then less often (``utils/sse_poll.py``), and sends a heartbeat every ~25s so the Application Load Balancer (ALB) idle timeout doesn\'t cut the stream.
         * @summary Device Stream
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStream: async (deviceCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceCode' is not null or undefined
            assertParamExists('deviceStream', 'deviceCode', deviceCode)
            const localVarPath = `/device/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (deviceCode !== undefined) {
                localVarQueryParameter['device_code'] = deviceCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle email verification callback from Supabase.
         * @summary Email Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether the given user\'s email is verified (via the email_confirmed_at field).
         * @summary Email Verification Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailVerificationStatus: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('emailVerificationStatus', 'userId', userId)
            const localVarPath = `/email_verification_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Google callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Google Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback: async (source?: string | null, isPlatformUser?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin Google OAuth sign-in and redirect the caller to the provider.
         * @summary Google Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignIn: async (source?: string | null, isPlatformUser?: boolean, client?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/google/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a static health check payload.
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle Microsoft callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Microsoft Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftCallback: async (source?: string | null, isPlatformUser?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/microsoft/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin Microsoft OAuth sign-in and redirect the caller to the provider.
         * @summary Microsoft Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftSignIn: async (source?: string | null, isPlatformUser?: boolean, client?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/microsoft/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exchange the caller\'s access token for a WorkOS session payload.  409 detail.code disambiguates terminal local tokens (workos_token_not_migratable) from upstream conflicts. 429 detail.code=workos_session_migration_rate_limited is retryable after a backoff.
         * @summary Migrate Workos Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateWorkosSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/sessions/migrate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a password-reset email for the given user.
         * @summary Request Reset Password
         * @param {RequestResetPasswordRequest} requestResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPassword: async (requestResetPasswordRequest: RequestResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestResetPasswordRequest' is not null or undefined
            assertParamExists('requestResetPassword', 'requestResetPasswordRequest', requestResetPasswordRequest)
            const localVarPath = `/email/request-reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a password-reset email for the given user, requiring a captcha token.
         * @summary Request Reset Password Captcha
         * @param {RequestResetPasswordCaptchaRequest} requestResetPasswordCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPasswordCaptcha: async (requestResetPasswordCaptchaRequest: RequestResetPasswordCaptchaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestResetPasswordCaptchaRequest' is not null or undefined
            assertParamExists('requestResetPasswordCaptcha', 'requestResetPasswordCaptchaRequest', requestResetPasswordCaptchaRequest)
            const localVarPath = `/email/request-reset-password-captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestResetPasswordCaptchaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend the email verification message for the given user.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail: async (resendVerificationEmailRequest: ResendVerificationEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationEmailRequest' is not null or undefined
            assertParamExists('resendVerificationEmail', 'resendVerificationEmailRequest', resendVerificationEmailRequest)
            const localVarPath = `/email/resend-verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend the email verification message for the given user, requiring a captcha token.
         * @summary Resend Verification Email Captcha
         * @param {ResendVerificationEmailCaptchaRequest} resendVerificationEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmailCaptcha: async (resendVerificationEmailCaptchaRequest: ResendVerificationEmailCaptchaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationEmailCaptchaRequest' is not null or undefined
            assertParamExists('resendVerificationEmailCaptcha', 'resendVerificationEmailCaptchaRequest', resendVerificationEmailCaptchaRequest)
            const localVarPath = `/email/resend-verification-email-captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationEmailCaptchaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a new password from a valid reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/email/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the password-reset email callback from Supabase.
         * @summary Reset Password Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordCallback: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email/reset-password-callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a WorkOS opaque-token password reset and mirror it to Supabase.
         * @summary Reset Password Workos
         * @param {ResetPasswordWorkosRequest} resetPasswordWorkosRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWorkos: async (resetPasswordWorkosRequest: ResetPasswordWorkosRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordWorkosRequest' is not null or undefined
            assertParamExists('resetPasswordWorkos', 'resetPasswordWorkosRequest', resetPasswordWorkosRequest)
            const localVarPath = `/email/reset-password-workos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordWorkosRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in a user with email and password.
         * @summary Sign In With Email
         * @param {SigninWithEmailRequest} signinWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithEmail: async (signinWithEmailRequest: SigninWithEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signinWithEmailRequest' is not null or undefined
            assertParamExists('signInWithEmail', 'signinWithEmailRequest', signinWithEmailRequest)
            const localVarPath = `/email/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signinWithEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign in a user with email and password, requiring a captcha token.
         * @summary Sign In With Email Captcha
         * @param {SigninWithEmailCaptchaRequest} signinWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithEmailCaptcha: async (signinWithEmailCaptchaRequest: SigninWithEmailCaptchaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signinWithEmailCaptchaRequest' is not null or undefined
            assertParamExists('signInWithEmailCaptcha', 'signinWithEmailCaptchaRequest', signinWithEmailCaptchaRequest)
            const localVarPath = `/email/signin-captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signinWithEmailCaptchaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up a new user with email and password.
         * @summary Sign Up With Email
         * @param {SignupWithEmailRequest} signupWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmail: async (signupWithEmailRequest: SignupWithEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupWithEmailRequest' is not null or undefined
            assertParamExists('signUpWithEmail', 'signupWithEmailRequest', signupWithEmailRequest)
            const localVarPath = `/email/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupWithEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up a new user with email and password, requiring a captcha token.
         * @summary Sign Up With Email Captcha
         * @param {SignupWithEmailCaptchaRequest} signupWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmailCaptcha: async (signupWithEmailCaptchaRequest: SignupWithEmailCaptchaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupWithEmailCaptchaRequest' is not null or undefined
            assertParamExists('signUpWithEmailCaptcha', 'signupWithEmailCaptchaRequest', signupWithEmailCaptchaRequest)
            const localVarPath = `/email/signup-captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupWithEmailCaptchaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up a new user from the Webflow marketing site.
         * @summary Signup
         * @param {SignupUserRequest} signupUserRequest 
         * @param {string | null} [trialPromo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupUserRequest: SignupUserRequest, trialPromo?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupUserRequest' is not null or undefined
            assertParamExists('signup', 'signupUserRequest', signupUserRequest)
            const localVarPath = `/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (trialPromo !== undefined) {
                localVarQueryParameter['trial_promo'] = trialPromo;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign up a raw email (no OAuth) user from the Webflow marketing site.
         * @summary Signup Raw Email
         * @param {RawEmailSignupRequest} rawEmailSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupRawEmail: async (rawEmailSignupRequest: RawEmailSignupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rawEmailSignupRequest' is not null or undefined
            assertParamExists('signupRawEmail', 'rawEmailSignupRequest', rawEmailSignupRequest)
            const localVarPath = `/signup_raw_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rawEmailSignupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle shared AuthKit, SP-initiated, and IdP-initiated SSO callbacks.  AuthKit: Probable AuthKit state → AuthKit callback, even when session is present. SP-initiated: Has session parameter → uses PKCE-enabled Supabase client. IdP-initiated: No session parameter → uses admin Supabase client.
         * @summary Sso Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoCallback: async (source?: string | null, isPlatformUser?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sso/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin enterprise SSO sign-in, routing @wispr.ai emails through AuthKit when enabled.
         * @summary Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSignIn: async (source?: string | null, email?: string | null, isPlatformUser?: boolean, client?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sso/sign_in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (isPlatformUser !== undefined) {
                localVarQueryParameter['is_platform_user'] = isPlatformUser;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return sign-in status and available auth methods for the given email.
         * @summary User Status
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userStatus: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('userStatus', 'email', email)
            const localVarPath = `/user_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate an email address for signup via Twilio SendGrid\'s API.
         * @summary Validate Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('validateEmail', 'email', email)
            const localVarPath = `/email/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete WorkOS password email verification.
         * @summary Verify Email Otp
         * @param {VerifyEmailOtpRequest} verifyEmailOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailOtp: async (verifyEmailOtpRequest: VerifyEmailOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmailOtpRequest' is not null or undefined
            assertParamExists('verifyEmailOtp', 'verifyEmailOtpRequest', verifyEmailOtpRequest)
            const localVarPath = `/email/verify-email-otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmailOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the deployed build\'s commit hash and timestamp.
         * @summary Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exercise the shared auth and rate-limit path to warm a cold worker.
         * @summary Warmup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmup: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/warmup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * Add an email to the notification waitlist.
         * @summary Add To Waitlist
         * @param {AddToWaitlistRequest} addToWaitlistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToWaitlist(addToWaitlistRequest: AddToWaitlistRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToWaitlist(addToWaitlistRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.addToWaitlist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the Apple App Site Association file for universal links.
         * @summary Apple App Site Association
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleAppSiteAssociation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleAppSiteAssociation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.appleAppSiteAssociation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Apple callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Apple Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleCallback(source, isPlatformUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.appleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin Apple OAuth sign-in and redirect the caller to the provider.
         * @summary Apple Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleSignIn(source, isPlatformUser, client, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.appleSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the AuthKit Apple OAuth callback and complete sign-in.
         * @summary Authkit Apple Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitAppleCallback(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitAppleCallback(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitAppleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin AuthKit-backed Apple sign-in and redirect the caller to the provider.
         * @summary Authkit Apple Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitAppleSignIn(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitAppleSignIn(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitAppleSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the AuthKit Google OAuth callback and complete sign-in.
         * @summary Authkit Google Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitGoogleCallback(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitGoogleCallback(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitGoogleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin AuthKit-backed Google sign-in and redirect the caller to the provider.
         * @summary Authkit Google Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitGoogleSignIn(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitGoogleSignIn(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitGoogleSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the AuthKit Microsoft OAuth callback and complete sign-in.
         * @summary Authkit Microsoft Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitMicrosoftCallback(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitMicrosoftCallback(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitMicrosoftCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin AuthKit-backed Microsoft sign-in and redirect the caller to the provider.
         * @summary Authkit Microsoft Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitMicrosoftSignIn(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitMicrosoftSignIn(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitMicrosoftSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the AuthKit enterprise SSO callback and complete sign-in.
         * @summary Authkit Sso Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitSsoCallback(source?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitSsoCallback(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitSsoCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin AuthKit-backed enterprise SSO sign-in and redirect the caller to the provider.
         * @summary Authkit Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authkitSsoSignIn(source?: string | null, email?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authkitSsoSignIn(source, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authkitSsoSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm a raw email signup and redirect verified users to onboarding.
         * @summary Confirm Email
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmEmail(email?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.confirmEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user and email them a password reset link (Wispr admins only).  Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(createUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit auth tokens for a pending desktop device code after web sign-in.  Pushes tokens to a Redis list, which the Server-Sent Events (SSE) stream picks up on its next poll (1-4s).
         * @summary Device Complete
         * @param {DeviceCodeCompleteRequest} deviceCodeCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceComplete(deviceCodeCompleteRequest: DeviceCodeCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceComplete(deviceCodeCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.deviceComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll for device-code auth tokens.  Pops the main list and keeps the same 30s recovery copy the stream keeps, so tokens whose stream frame or poll response was lost are served again by the next poll or stream within that window.
         * @summary Device Poll
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async devicePoll(deviceCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.devicePoll(deviceCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.devicePoll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stream device-code auth tokens to the desktop via Server-Sent Events until they arrive or timeout.  Polls the Redis list every second at first, then less often (``utils/sse_poll.py``), and sends a heartbeat every ~25s so the Application Load Balancer (ALB) idle timeout doesn\'t cut the stream.
         * @summary Device Stream
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceStream(deviceCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deviceStream(deviceCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.deviceStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle email verification callback from Supabase.
         * @summary Email Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.emailCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether the given user\'s email is verified (via the email_confirmed_at field).
         * @summary Email Verification Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailVerificationStatus(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailVerificationStatus(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.emailVerificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Google callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Google Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleCallback(source, isPlatformUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.googleCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin Google OAuth sign-in and redirect the caller to the provider.
         * @summary Google Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleSignIn(source, isPlatformUser, client, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.googleSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a static health check payload.
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle Microsoft callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Microsoft Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async microsoftCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.microsoftCallback(source, isPlatformUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.microsoftCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin Microsoft OAuth sign-in and redirect the caller to the provider.
         * @summary Microsoft Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async microsoftSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.microsoftSignIn(source, isPlatformUser, client, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.microsoftSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exchange the caller\'s access token for a WorkOS session payload.  409 detail.code disambiguates terminal local tokens (workos_token_not_migratable) from upstream conflicts. 429 detail.code=workos_session_migration_rate_limited is retryable after a backoff.
         * @summary Migrate Workos Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateWorkosSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOSSessionMigrateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateWorkosSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.migrateWorkosSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a password-reset email for the given user.
         * @summary Request Reset Password
         * @param {RequestResetPasswordRequest} requestResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestResetPassword(requestResetPasswordRequest: RequestResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestResetPassword(requestResetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.requestResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a password-reset email for the given user, requiring a captcha token.
         * @summary Request Reset Password Captcha
         * @param {RequestResetPasswordCaptchaRequest} requestResetPasswordCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest: RequestResetPasswordCaptchaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.requestResetPasswordCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend the email verification message for the given user.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationEmail(resendVerificationEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend the email verification message for the given user, requiring a captcha token.
         * @summary Resend Verification Email Captcha
         * @param {ResendVerificationEmailCaptchaRequest} resendVerificationEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest: ResendVerificationEmailCaptchaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resendVerificationEmailCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a new password from a valid reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the password-reset email callback from Supabase.
         * @summary Reset Password Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordCallback(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordCallback(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPasswordCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm a WorkOS opaque-token password reset and mirror it to Supabase.
         * @summary Reset Password Workos
         * @param {ResetPasswordWorkosRequest} resetPasswordWorkosRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPasswordWorkos(resetPasswordWorkosRequest: ResetPasswordWorkosRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPasswordWorkos(resetPasswordWorkosRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.resetPasswordWorkos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign in a user with email and password.
         * @summary Sign In With Email
         * @param {SigninWithEmailRequest} signinWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signInWithEmail(signinWithEmailRequest: SigninWithEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninWithEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signInWithEmail(signinWithEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signInWithEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign in a user with email and password, requiring a captcha token.
         * @summary Sign In With Email Captcha
         * @param {SigninWithEmailCaptchaRequest} signinWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signInWithEmailCaptcha(signinWithEmailCaptchaRequest: SigninWithEmailCaptchaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninWithEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signInWithEmailCaptcha(signinWithEmailCaptchaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signInWithEmailCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign up a new user with email and password.
         * @summary Sign Up With Email
         * @param {SignupWithEmailRequest} signupWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpWithEmail(signupWithEmailRequest: SignupWithEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninWithEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpWithEmail(signupWithEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signUpWithEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign up a new user with email and password, requiring a captcha token.
         * @summary Sign Up With Email Captcha
         * @param {SignupWithEmailCaptchaRequest} signupWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpWithEmailCaptcha(signupWithEmailCaptchaRequest: SignupWithEmailCaptchaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninWithEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpWithEmailCaptcha(signupWithEmailCaptchaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signUpWithEmailCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign up a new user from the Webflow marketing site.
         * @summary Signup
         * @param {SignupUserRequest} signupUserRequest 
         * @param {string | null} [trialPromo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupUserRequest: SignupUserRequest, trialPromo?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupUserRequest, trialPromo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign up a raw email (no OAuth) user from the Webflow marketing site.
         * @summary Signup Raw Email
         * @param {RawEmailSignupRequest} rawEmailSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signupRawEmail(rawEmailSignupRequest: RawEmailSignupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signupRawEmail(rawEmailSignupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.signupRawEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle shared AuthKit, SP-initiated, and IdP-initiated SSO callbacks.  AuthKit: Probable AuthKit state → AuthKit callback, even when session is present. SP-initiated: Has session parameter → uses PKCE-enabled Supabase client. IdP-initiated: No session parameter → uses admin Supabase client.
         * @summary Sso Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ssoCallback(source, isPlatformUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.ssoCallback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin enterprise SSO sign-in, routing @wispr.ai emails through AuthKit when enabled.
         * @summary Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSignIn(source?: string | null, email?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ssoSignIn(source, email, isPlatformUser, client, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.ssoSignIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return sign-in status and available auth methods for the given email.
         * @summary User Status
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userStatus(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userStatus(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.userStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate an email address for signup via Twilio SendGrid\'s API.
         * @summary Validate Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.validateEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete WorkOS password email verification.
         * @summary Verify Email Otp
         * @param {VerifyEmailOtpRequest} verifyEmailOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmailOtp(verifyEmailOtpRequest: VerifyEmailOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SigninWithEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmailOtp(verifyEmailOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.verifyEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the deployed build\'s commit hash and timestamp.
         * @summary Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async version(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.version(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.version']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exercise the shared auth and rate-limit path to warm a cold worker.
         * @summary Warmup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warmup(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warmup(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.warmup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * Add an email to the notification waitlist.
         * @summary Add To Waitlist
         * @param {AddToWaitlistRequest} addToWaitlistRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToWaitlist(addToWaitlistRequest: AddToWaitlistRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.addToWaitlist(addToWaitlistRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the Apple App Site Association file for universal links.
         * @summary Apple App Site Association
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.appleAppSiteAssociation(options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Apple callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Apple Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.appleCallback(source, isPlatformUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin Apple OAuth sign-in and redirect the caller to the provider.
         * @summary Apple Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.appleSignIn(source, isPlatformUser, client, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the AuthKit Apple OAuth callback and complete sign-in.
         * @summary Authkit Apple Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitAppleCallback(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.authkitAppleCallback(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin AuthKit-backed Apple sign-in and redirect the caller to the provider.
         * @summary Authkit Apple Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitAppleSignIn(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.authkitAppleSignIn(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the AuthKit Google OAuth callback and complete sign-in.
         * @summary Authkit Google Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitGoogleCallback(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.authkitGoogleCallback(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin AuthKit-backed Google sign-in and redirect the caller to the provider.
         * @summary Authkit Google Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitGoogleSignIn(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.authkitGoogleSignIn(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the AuthKit Microsoft OAuth callback and complete sign-in.
         * @summary Authkit Microsoft Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitMicrosoftCallback(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.authkitMicrosoftCallback(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin AuthKit-backed Microsoft sign-in and redirect the caller to the provider.
         * @summary Authkit Microsoft Sign In
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitMicrosoftSignIn(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.authkitMicrosoftSignIn(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the AuthKit enterprise SSO callback and complete sign-in.
         * @summary Authkit Sso Callback
         * @param {string | null} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitSsoCallback(source?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.authkitSsoCallback(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin AuthKit-backed enterprise SSO sign-in and redirect the caller to the provider.
         * @summary Authkit Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authkitSsoSignIn(source?: string | null, email?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.authkitSsoSignIn(source, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a raw email signup and redirect verified users to onboarding.
         * @summary Confirm Email
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(email?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.confirmEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user and email them a password reset link (Wispr admins only).  Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Create User
         * @param {CreateUserRequest} createUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createUser(createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit auth tokens for a pending desktop device code after web sign-in.  Pushes tokens to a Redis list, which the Server-Sent Events (SSE) stream picks up on its next poll (1-4s).
         * @summary Device Complete
         * @param {DeviceCodeCompleteRequest} deviceCodeCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceComplete(deviceCodeCompleteRequest: DeviceCodeCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deviceComplete(deviceCodeCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll for device-code auth tokens.  Pops the main list and keeps the same 30s recovery copy the stream keeps, so tokens whose stream frame or poll response was lost are served again by the next poll or stream within that window.
         * @summary Device Poll
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicePoll(deviceCode: string, options?: RawAxiosRequestConfig): AxiosPromise<DeviceAuthResponse> {
            return localVarFp.devicePoll(deviceCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Stream device-code auth tokens to the desktop via Server-Sent Events until they arrive or timeout.  Polls the Redis list every second at first, then less often (``utils/sse_poll.py``), and sends a heartbeat every ~25s so the Application Load Balancer (ALB) idle timeout doesn\'t cut the stream.
         * @summary Device Stream
         * @param {string} deviceCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceStream(deviceCode: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deviceStream(deviceCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle email verification callback from Supabase.
         * @summary Email Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCallback(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.emailCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether the given user\'s email is verified (via the email_confirmed_at field).
         * @summary Email Verification Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailVerificationStatus(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.emailVerificationStatus(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Google callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Google Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.googleCallback(source, isPlatformUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin Google OAuth sign-in and redirect the caller to the provider.
         * @summary Google Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.googleSignIn(source, isPlatformUser, client, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a static health check payload.
         * @summary Health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         * Handle Microsoft callbacks through AuthKit-shaped state or legacy Supabase sessions.
         * @summary Microsoft Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.microsoftCallback(source, isPlatformUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin Microsoft OAuth sign-in and redirect the caller to the provider.
         * @summary Microsoft Sign In
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        microsoftSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.microsoftSignIn(source, isPlatformUser, client, options).then((request) => request(axios, basePath));
        },
        /**
         * Exchange the caller\'s access token for a WorkOS session payload.  409 detail.code disambiguates terminal local tokens (workos_token_not_migratable) from upstream conflicts. 429 detail.code=workos_session_migration_rate_limited is retryable after a backoff.
         * @summary Migrate Workos Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateWorkosSession(options?: RawAxiosRequestConfig): AxiosPromise<WorkOSSessionMigrateResponse> {
            return localVarFp.migrateWorkosSession(options).then((request) => request(axios, basePath));
        },
        /**
         * Send a password-reset email for the given user.
         * @summary Request Reset Password
         * @param {RequestResetPasswordRequest} requestResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPassword(requestResetPasswordRequest: RequestResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.requestResetPassword(requestResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a password-reset email for the given user, requiring a captcha token.
         * @summary Request Reset Password Captcha
         * @param {RequestResetPasswordCaptchaRequest} requestResetPasswordCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest: RequestResetPasswordCaptchaRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend the email verification message for the given user.
         * @summary Resend Verification Email
         * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resendVerificationEmail(resendVerificationEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend the email verification message for the given user, requiring a captcha token.
         * @summary Resend Verification Email Captcha
         * @param {ResendVerificationEmailCaptchaRequest} resendVerificationEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest: ResendVerificationEmailCaptchaRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a new password from a valid reset token.
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the password-reset email callback from Supabase.
         * @summary Reset Password Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordCallback(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.resetPasswordCallback(options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a WorkOS opaque-token password reset and mirror it to Supabase.
         * @summary Reset Password Workos
         * @param {ResetPasswordWorkosRequest} resetPasswordWorkosRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPasswordWorkos(resetPasswordWorkosRequest: ResetPasswordWorkosRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.resetPasswordWorkos(resetPasswordWorkosRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign in a user with email and password.
         * @summary Sign In With Email
         * @param {SigninWithEmailRequest} signinWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithEmail(signinWithEmailRequest: SigninWithEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigninWithEmailResponse> {
            return localVarFp.signInWithEmail(signinWithEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign in a user with email and password, requiring a captcha token.
         * @summary Sign In With Email Captcha
         * @param {SigninWithEmailCaptchaRequest} signinWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithEmailCaptcha(signinWithEmailCaptchaRequest: SigninWithEmailCaptchaRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigninWithEmailResponse> {
            return localVarFp.signInWithEmailCaptcha(signinWithEmailCaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up a new user with email and password.
         * @summary Sign Up With Email
         * @param {SignupWithEmailRequest} signupWithEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmail(signupWithEmailRequest: SignupWithEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigninWithEmailResponse> {
            return localVarFp.signUpWithEmail(signupWithEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up a new user with email and password, requiring a captcha token.
         * @summary Sign Up With Email Captcha
         * @param {SignupWithEmailCaptchaRequest} signupWithEmailCaptchaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpWithEmailCaptcha(signupWithEmailCaptchaRequest: SignupWithEmailCaptchaRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigninWithEmailResponse> {
            return localVarFp.signUpWithEmailCaptcha(signupWithEmailCaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up a new user from the Webflow marketing site.
         * @summary Signup
         * @param {SignupUserRequest} signupUserRequest 
         * @param {string | null} [trialPromo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupUserRequest: SignupUserRequest, trialPromo?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.signup(signupUserRequest, trialPromo, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign up a raw email (no OAuth) user from the Webflow marketing site.
         * @summary Signup Raw Email
         * @param {RawEmailSignupRequest} rawEmailSignupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupRawEmail(rawEmailSignupRequest: RawEmailSignupRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.signupRawEmail(rawEmailSignupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle shared AuthKit, SP-initiated, and IdP-initiated SSO callbacks.  AuthKit: Probable AuthKit state → AuthKit callback, even when session is present. SP-initiated: Has session parameter → uses PKCE-enabled Supabase client. IdP-initiated: No session parameter → uses admin Supabase client.
         * @summary Sso Callback
         * @param {string | null} [source] 
         * @param {boolean} [isPlatformUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.ssoCallback(source, isPlatformUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin enterprise SSO sign-in, routing @wispr.ai emails through AuthKit when enabled.
         * @summary Sso Sign In
         * @param {string | null} [source] 
         * @param {string | null} [email] 
         * @param {boolean} [isPlatformUser] 
         * @param {string | null} [client] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSignIn(source?: string | null, email?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.ssoSignIn(source, email, isPlatformUser, client, options).then((request) => request(axios, basePath));
        },
        /**
         * Return sign-in status and available auth methods for the given email.
         * @summary User Status
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userStatus(email: string, options?: RawAxiosRequestConfig): AxiosPromise<UserStatusResponse> {
            return localVarFp.userStatus(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate an email address for signup via Twilio SendGrid\'s API.
         * @summary Validate Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.validateEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete WorkOS password email verification.
         * @summary Verify Email Otp
         * @param {VerifyEmailOtpRequest} verifyEmailOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailOtp(verifyEmailOtpRequest: VerifyEmailOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<SigninWithEmailResponse> {
            return localVarFp.verifyEmailOtp(verifyEmailOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the deployed build\'s commit hash and timestamp.
         * @summary Version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.version(options).then((request) => request(axios, basePath));
        },
        /**
         * Exercise the shared auth and rate-limit path to warm a cold worker.
         * @summary Warmup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmup(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.warmup(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * Add an email to the notification waitlist.
     * @summary Add To Waitlist
     * @param {AddToWaitlistRequest} addToWaitlistRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public addToWaitlist(addToWaitlistRequest: AddToWaitlistRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).addToWaitlist(addToWaitlistRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the Apple App Site Association file for universal links.
     * @summary Apple App Site Association
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public appleAppSiteAssociation(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).appleAppSiteAssociation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Apple callbacks through AuthKit-shaped state or legacy Supabase sessions.
     * @summary Apple Callback
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public appleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).appleCallback(source, isPlatformUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin Apple OAuth sign-in and redirect the caller to the provider.
     * @summary Apple Sign In
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {string | null} [client] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public appleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).appleSignIn(source, isPlatformUser, client, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the AuthKit Apple OAuth callback and complete sign-in.
     * @summary Authkit Apple Callback
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitAppleCallback(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitAppleCallback(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin AuthKit-backed Apple sign-in and redirect the caller to the provider.
     * @summary Authkit Apple Sign In
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitAppleSignIn(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitAppleSignIn(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the AuthKit Google OAuth callback and complete sign-in.
     * @summary Authkit Google Callback
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitGoogleCallback(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitGoogleCallback(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin AuthKit-backed Google sign-in and redirect the caller to the provider.
     * @summary Authkit Google Sign In
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitGoogleSignIn(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitGoogleSignIn(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the AuthKit Microsoft OAuth callback and complete sign-in.
     * @summary Authkit Microsoft Callback
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitMicrosoftCallback(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitMicrosoftCallback(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin AuthKit-backed Microsoft sign-in and redirect the caller to the provider.
     * @summary Authkit Microsoft Sign In
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitMicrosoftSignIn(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitMicrosoftSignIn(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the AuthKit enterprise SSO callback and complete sign-in.
     * @summary Authkit Sso Callback
     * @param {string | null} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitSsoCallback(source?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitSsoCallback(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin AuthKit-backed enterprise SSO sign-in and redirect the caller to the provider.
     * @summary Authkit Sso Sign In
     * @param {string | null} [source] 
     * @param {string | null} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authkitSsoSignIn(source?: string | null, email?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authkitSsoSignIn(source, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a raw email signup and redirect verified users to onboarding.
     * @summary Confirm Email
     * @param {string | null} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public confirmEmail(email?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).confirmEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user and email them a password reset link (Wispr admins only).  Only accessible by Wispr admins (@wispr.ai emails).
     * @summary Create User
     * @param {CreateUserRequest} createUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public createUser(createUserRequest: CreateUserRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).createUser(createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit auth tokens for a pending desktop device code after web sign-in.  Pushes tokens to a Redis list, which the Server-Sent Events (SSE) stream picks up on its next poll (1-4s).
     * @summary Device Complete
     * @param {DeviceCodeCompleteRequest} deviceCodeCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public deviceComplete(deviceCodeCompleteRequest: DeviceCodeCompleteRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).deviceComplete(deviceCodeCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll for device-code auth tokens.  Pops the main list and keeps the same 30s recovery copy the stream keeps, so tokens whose stream frame or poll response was lost are served again by the next poll or stream within that window.
     * @summary Device Poll
     * @param {string} deviceCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public devicePoll(deviceCode: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).devicePoll(deviceCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stream device-code auth tokens to the desktop via Server-Sent Events until they arrive or timeout.  Polls the Redis list every second at first, then less often (``utils/sse_poll.py``), and sends a heartbeat every ~25s so the Application Load Balancer (ALB) idle timeout doesn\'t cut the stream.
     * @summary Device Stream
     * @param {string} deviceCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public deviceStream(deviceCode: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).deviceStream(deviceCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle email verification callback from Supabase.
     * @summary Email Callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public emailCallback(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).emailCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether the given user\'s email is verified (via the email_confirmed_at field).
     * @summary Email Verification Status
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public emailVerificationStatus(userId: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).emailVerificationStatus(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Google callbacks through AuthKit-shaped state or legacy Supabase sessions.
     * @summary Google Callback
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public googleCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).googleCallback(source, isPlatformUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin Google OAuth sign-in and redirect the caller to the provider.
     * @summary Google Sign In
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {string | null} [client] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public googleSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).googleSignIn(source, isPlatformUser, client, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a static health check payload.
     * @summary Health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public health(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle Microsoft callbacks through AuthKit-shaped state or legacy Supabase sessions.
     * @summary Microsoft Callback
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public microsoftCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).microsoftCallback(source, isPlatformUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin Microsoft OAuth sign-in and redirect the caller to the provider.
     * @summary Microsoft Sign In
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {string | null} [client] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public microsoftSignIn(source?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).microsoftSignIn(source, isPlatformUser, client, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exchange the caller\'s access token for a WorkOS session payload.  409 detail.code disambiguates terminal local tokens (workos_token_not_migratable) from upstream conflicts. 429 detail.code=workos_session_migration_rate_limited is retryable after a backoff.
     * @summary Migrate Workos Session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public migrateWorkosSession(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).migrateWorkosSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a password-reset email for the given user.
     * @summary Request Reset Password
     * @param {RequestResetPasswordRequest} requestResetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public requestResetPassword(requestResetPasswordRequest: RequestResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).requestResetPassword(requestResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a password-reset email for the given user, requiring a captcha token.
     * @summary Request Reset Password Captcha
     * @param {RequestResetPasswordCaptchaRequest} requestResetPasswordCaptchaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest: RequestResetPasswordCaptchaRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).requestResetPasswordCaptcha(requestResetPasswordCaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend the email verification message for the given user.
     * @summary Resend Verification Email
     * @param {ResendVerificationEmailRequest} resendVerificationEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resendVerificationEmail(resendVerificationEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend the email verification message for the given user, requiring a captcha token.
     * @summary Resend Verification Email Captcha
     * @param {ResendVerificationEmailCaptchaRequest} resendVerificationEmailCaptchaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest: ResendVerificationEmailCaptchaRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resendVerificationEmailCaptcha(resendVerificationEmailCaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a new password from a valid reset token.
     * @summary Reset Password
     * @param {ResetPasswordRequest} resetPasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the password-reset email callback from Supabase.
     * @summary Reset Password Callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPasswordCallback(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPasswordCallback(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a WorkOS opaque-token password reset and mirror it to Supabase.
     * @summary Reset Password Workos
     * @param {ResetPasswordWorkosRequest} resetPasswordWorkosRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public resetPasswordWorkos(resetPasswordWorkosRequest: ResetPasswordWorkosRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).resetPasswordWorkos(resetPasswordWorkosRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign in a user with email and password.
     * @summary Sign In With Email
     * @param {SigninWithEmailRequest} signinWithEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signInWithEmail(signinWithEmailRequest: SigninWithEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signInWithEmail(signinWithEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign in a user with email and password, requiring a captcha token.
     * @summary Sign In With Email Captcha
     * @param {SigninWithEmailCaptchaRequest} signinWithEmailCaptchaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signInWithEmailCaptcha(signinWithEmailCaptchaRequest: SigninWithEmailCaptchaRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signInWithEmailCaptcha(signinWithEmailCaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up a new user with email and password.
     * @summary Sign Up With Email
     * @param {SignupWithEmailRequest} signupWithEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signUpWithEmail(signupWithEmailRequest: SignupWithEmailRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signUpWithEmail(signupWithEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up a new user with email and password, requiring a captcha token.
     * @summary Sign Up With Email Captcha
     * @param {SignupWithEmailCaptchaRequest} signupWithEmailCaptchaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signUpWithEmailCaptcha(signupWithEmailCaptchaRequest: SignupWithEmailCaptchaRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signUpWithEmailCaptcha(signupWithEmailCaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up a new user from the Webflow marketing site.
     * @summary Signup
     * @param {SignupUserRequest} signupUserRequest 
     * @param {string | null} [trialPromo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signup(signupUserRequest: SignupUserRequest, trialPromo?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signup(signupUserRequest, trialPromo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign up a raw email (no OAuth) user from the Webflow marketing site.
     * @summary Signup Raw Email
     * @param {RawEmailSignupRequest} rawEmailSignupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public signupRawEmail(rawEmailSignupRequest: RawEmailSignupRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).signupRawEmail(rawEmailSignupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle shared AuthKit, SP-initiated, and IdP-initiated SSO callbacks.  AuthKit: Probable AuthKit state → AuthKit callback, even when session is present. SP-initiated: Has session parameter → uses PKCE-enabled Supabase client. IdP-initiated: No session parameter → uses admin Supabase client.
     * @summary Sso Callback
     * @param {string | null} [source] 
     * @param {boolean} [isPlatformUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public ssoCallback(source?: string | null, isPlatformUser?: boolean, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).ssoCallback(source, isPlatformUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin enterprise SSO sign-in, routing @wispr.ai emails through AuthKit when enabled.
     * @summary Sso Sign In
     * @param {string | null} [source] 
     * @param {string | null} [email] 
     * @param {boolean} [isPlatformUser] 
     * @param {string | null} [client] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public ssoSignIn(source?: string | null, email?: string | null, isPlatformUser?: boolean, client?: string | null, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).ssoSignIn(source, email, isPlatformUser, client, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return sign-in status and available auth methods for the given email.
     * @summary User Status
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public userStatus(email: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).userStatus(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate an email address for signup via Twilio SendGrid\'s API.
     * @summary Validate Email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public validateEmail(email: string, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).validateEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete WorkOS password email verification.
     * @summary Verify Email Otp
     * @param {VerifyEmailOtpRequest} verifyEmailOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public verifyEmailOtp(verifyEmailOtpRequest: VerifyEmailOtpRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).verifyEmailOtp(verifyEmailOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the deployed build\'s commit hash and timestamp.
     * @summary Version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public version(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).version(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exercise the shared auth and rate-limit path to warm a cold worker.
     * @summary Warmup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public warmup(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).warmup(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AutomationsApi - axios parameter creator
 * @export
 */
export const AutomationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an event via the authenticated user\'s connected Google Calendar account.  Backs the todo add-calendar automation card. The organizer is the principal; attendees and description are optional. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Add Calendar Event
         * @param {AutomationAddCalendarRequest} automationAddCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCalendarEvent: async (automationAddCalendarRequest: AutomationAddCalendarRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'automationAddCalendarRequest' is not null or undefined
            assertParamExists('addCalendarEvent', 'automationAddCalendarRequest', automationAddCalendarRequest)
            const localVarPath = `/api/v1/automations/add-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automationAddCalendarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send an email via the authenticated user\'s connected Gmail account.  Backs the todo send-email automation card. The sender is the principal; recipients come from the body. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Send Email
         * @param {AutomationSendEmailRequest} automationSendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail: async (automationSendEmailRequest: AutomationSendEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'automationSendEmailRequest' is not null or undefined
            assertParamExists('sendEmail', 'automationSendEmailRequest', automationSendEmailRequest)
            const localVarPath = `/api/v1/automations/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automationSendEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send an Ask Anything email card through the user\'s connected Gmail and return the action envelope.  Unlike ``/send-email`` it is Notetaker-gated, takes Cc, and returns ``{status, error, retry_after_s, result_url, provider_ref}``. Handled failures, including an enterprise-disabled Gmail connector, return 200 with ``status`` ``failed`` or ``unknown``; auth, the Notetaker gate, rate limits, validation and unexpected errors map to non-2xx. Each call sends: there is no idempotency key.
         * @summary Send Gmail Action Route
         * @param {AutomationGmailSendActionRequest} automationGmailSendActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGmailActionRoute: async (automationGmailSendActionRequest: AutomationGmailSendActionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'automationGmailSendActionRequest' is not null or undefined
            assertParamExists('sendGmailActionRoute', 'automationGmailSendActionRequest', automationGmailSendActionRequest)
            const localVarPath = `/api/v1/automations/actions/gmail/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automationGmailSendActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pull the user\'s server-authored automations (delta on ``modified_at``, capped + paged).
         * @summary Sync Automations
         * @param {AutomationSyncRequest} automationSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAutomations: async (automationSyncRequest: AutomationSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'automationSyncRequest' is not null or undefined
            assertParamExists('syncAutomations', 'automationSyncRequest', automationSyncRequest)
            const localVarPath = `/api/v1/automations/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(automationSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AutomationsApi - functional programming interface
 * @export
 */
export const AutomationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AutomationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an event via the authenticated user\'s connected Google Calendar account.  Backs the todo add-calendar automation card. The organizer is the principal; attendees and description are optional. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Add Calendar Event
         * @param {AutomationAddCalendarRequest} automationAddCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCalendarEvent(automationAddCalendarRequest: AutomationAddCalendarRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddCalendarEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCalendarEvent(automationAddCalendarRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutomationsApi.addCalendarEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send an email via the authenticated user\'s connected Gmail account.  Backs the todo send-email automation card. The sender is the principal; recipients come from the body. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Send Email
         * @param {AutomationSendEmailRequest} automationSendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmail(automationSendEmailRequest: AutomationSendEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmail(automationSendEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutomationsApi.sendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send an Ask Anything email card through the user\'s connected Gmail and return the action envelope.  Unlike ``/send-email`` it is Notetaker-gated, takes Cc, and returns ``{status, error, retry_after_s, result_url, provider_ref}``. Handled failures, including an enterprise-disabled Gmail connector, return 200 with ``status`` ``failed`` or ``unknown``; auth, the Notetaker gate, rate limits, validation and unexpected errors map to non-2xx. Each call sends: there is no idempotency key.
         * @summary Send Gmail Action Route
         * @param {AutomationGmailSendActionRequest} automationGmailSendActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendGmailActionRoute(automationGmailSendActionRequest: AutomationGmailSendActionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendGmailActionRoute(automationGmailSendActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutomationsApi.sendGmailActionRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pull the user\'s server-authored automations (delta on ``modified_at``, capped + paged).
         * @summary Sync Automations
         * @param {AutomationSyncRequest} automationSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAutomations(automationSyncRequest: AutomationSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AutomationSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAutomations(automationSyncRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AutomationsApi.syncAutomations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AutomationsApi - factory interface
 * @export
 */
export const AutomationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AutomationsApiFp(configuration)
    return {
        /**
         * Create an event via the authenticated user\'s connected Google Calendar account.  Backs the todo add-calendar automation card. The organizer is the principal; attendees and description are optional. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Add Calendar Event
         * @param {AutomationAddCalendarRequest} automationAddCalendarRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCalendarEvent(automationAddCalendarRequest: AutomationAddCalendarRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddCalendarEventResponse> {
            return localVarFp.addCalendarEvent(automationAddCalendarRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send an email via the authenticated user\'s connected Gmail account.  Backs the todo send-email automation card. The sender is the principal; recipients come from the body. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
         * @summary Send Email
         * @param {AutomationSendEmailRequest} automationSendEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmail(automationSendEmailRequest: AutomationSendEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendEmailResponse> {
            return localVarFp.sendEmail(automationSendEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send an Ask Anything email card through the user\'s connected Gmail and return the action envelope.  Unlike ``/send-email`` it is Notetaker-gated, takes Cc, and returns ``{status, error, retry_after_s, result_url, provider_ref}``. Handled failures, including an enterprise-disabled Gmail connector, return 200 with ``status`` ``failed`` or ``unknown``; auth, the Notetaker gate, rate limits, validation and unexpected errors map to non-2xx. Each call sends: there is no idempotency key.
         * @summary Send Gmail Action Route
         * @param {AutomationGmailSendActionRequest} automationGmailSendActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGmailActionRoute(automationGmailSendActionRequest: AutomationGmailSendActionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConnectorActionResponse> {
            return localVarFp.sendGmailActionRoute(automationGmailSendActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Pull the user\'s server-authored automations (delta on ``modified_at``, capped + paged).
         * @summary Sync Automations
         * @param {AutomationSyncRequest} automationSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAutomations(automationSyncRequest: AutomationSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AutomationSyncResponse> {
            return localVarFp.syncAutomations(automationSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AutomationsApi - object-oriented interface
 * @export
 * @class AutomationsApi
 * @extends {BaseAPI}
 */
export class AutomationsApi extends BaseAPI {
    /**
     * Create an event via the authenticated user\'s connected Google Calendar account.  Backs the todo add-calendar automation card. The organizer is the principal; attendees and description are optional. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
     * @summary Add Calendar Event
     * @param {AutomationAddCalendarRequest} automationAddCalendarRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    public addCalendarEvent(automationAddCalendarRequest: AutomationAddCalendarRequest, options?: RawAxiosRequestConfig) {
        return AutomationsApiFp(this.configuration).addCalendarEvent(automationAddCalendarRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send an email via the authenticated user\'s connected Gmail account.  Backs the todo send-email automation card. The sender is the principal; recipients come from the body. Handled failures return 200 with ``successful=false`` + an ``error`` code so the client can render a specific toast; only auth/ratelimit/validation/unexpected map to non-2xx.
     * @summary Send Email
     * @param {AutomationSendEmailRequest} automationSendEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    public sendEmail(automationSendEmailRequest: AutomationSendEmailRequest, options?: RawAxiosRequestConfig) {
        return AutomationsApiFp(this.configuration).sendEmail(automationSendEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send an Ask Anything email card through the user\'s connected Gmail and return the action envelope.  Unlike ``/send-email`` it is Notetaker-gated, takes Cc, and returns ``{status, error, retry_after_s, result_url, provider_ref}``. Handled failures, including an enterprise-disabled Gmail connector, return 200 with ``status`` ``failed`` or ``unknown``; auth, the Notetaker gate, rate limits, validation and unexpected errors map to non-2xx. Each call sends: there is no idempotency key.
     * @summary Send Gmail Action Route
     * @param {AutomationGmailSendActionRequest} automationGmailSendActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    public sendGmailActionRoute(automationGmailSendActionRequest: AutomationGmailSendActionRequest, options?: RawAxiosRequestConfig) {
        return AutomationsApiFp(this.configuration).sendGmailActionRoute(automationGmailSendActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pull the user\'s server-authored automations (delta on ``modified_at``, capped + paged).
     * @summary Sync Automations
     * @param {AutomationSyncRequest} automationSyncRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AutomationsApi
     */
    public syncAutomations(automationSyncRequest: AutomationSyncRequest, options?: RawAxiosRequestConfig) {
        return AutomationsApiFp(this.configuration).syncAutomations(automationSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalendarApi - axios parameter creator
 * @export
 */
export const CalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Whether the org\'s Notetaker domain rules block this event, with the matched attendees.  404 rather than 403 for an event we do not hold for this user: a Google ``external_id`` is shared across every attendee\'s copy, so an unscoped lookup would be cross-tenant and a 403 would confirm the id exists in another org.  A cancelled event still gets a real verdict — unlike the pre-read route, there is always an answer to give, and 404 here would read to the client as check-failed, i.e. allow.  Returns 200 with ``blocked: false`` for a solo user or an org with no rules.
         * @summary Get Event Notetaker Policy
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventNotetakerPolicy: async (externalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventNotetakerPolicy', 'externalId', externalId)
            const localVarPath = `/api/v1/calendar/events/{external_id}/notetaker-policy`
                .replace(`{${"external_id"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate or dispatch a pre-read for an upcoming calendar event.  The desktop already has the Flow Event Key from the sync payload, so callers identify the event by that string rather than the internal UUID. The query layer scopes by ``user_id`` — a stranger\'s Flow Event Key matches no row.  When ``useAgenticPreread`` is false (the default), the handler synchronously builds context and calls the LLM; the worst case is bounded by the generator\'s 30s Anthropic client timeout.  When ``useAgenticPreread`` is true, the handler dispatches a managed-agent session in the background and returns an empty response immediately. The desktop picks up the deliverable via the ``agentic_prereads`` sync resource once the webhook completes.  Events that already ended are fetch-only: the latest stored pre-read is returned as-is, and nothing is ever generated or dispatched for them.  Returns 404 only when the event isn\'t eligible for a pre-read at all:  * No CalendarEvent for the authenticated user and requested Flow Event Key. * The event is cancelled. * The event already ended and has no stored pre-read.  When the event exists but the LLM-side generator fails (rate limits, validation errors, transient outages), the response is still 200 with a minimal calendar-derived fallback so the desktop can render the pre-read card with baseline metadata instead of an empty failure state. The generator already logged + counted the failure.
         * @summary Get Event Preread
         * @param {string} externalId 
         * @param {boolean} [useAgenticPreread] When true, dispatch a managed-agent pre-read session asynchronously and return an empty response. The desktop picks up the result via the &#x60;&#x60;agentic_prereads&#x60;&#x60; sync resource.
         * @param {string | null} [trigger] Optional client-supplied hint describing why the pre-read is being fetched. Allowed values: precache, reminder, debug, sync. Used for telemetry only — unknown values fall through silently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPreread: async (externalId: string, useAgenticPreread?: boolean, trigger?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('getEventPreread', 'externalId', externalId)
            const localVarPath = `/api/v1/calendar/events/{external_id}/preread`
                .replace(`{${"external_id"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (useAgenticPreread !== undefined) {
                localVarQueryParameter['useAgenticPreread'] = useAgenticPreread;
            }

            if (trigger !== undefined) {
                localVarQueryParameter['trigger'] = trigger;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the authenticated user\'s calendar events matching the given externalIds.  Designed for the desktop to re-fetch events linked to past notes whose local calendar cache was pruned. No ``start_at_utc`` filter — past events are returned. Cancelled events are included so the desktop can render the correct state. A stranger\'s ``externalId`` matches no row (query is ``user_id``-scoped). Event order is unspecified; callers look events up by ``externalId``.
         * @summary Get Events Batch
         * @param {string} ids Comma-separated calendar &#x60;&#x60;externalId&#x60;&#x60; values to look up. At most 50 per request; missing ids are absent from the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsBatch: async (ids: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getEventsBatch', 'ids', ids)
            const localVarPath = `/api/v1/calendar/events/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resync every active Calendar Slot for the authenticated user.  Google completes its backfill and watch recovery before this request returns. Outlook is accepted onto the durable calendar-backfill queue; its worker later performs the forced reseed and publishes ``calendar.changed``. A successful provider is reported even if another provider fails, so the desktop still refreshes its local calendar after partial progress.  Args:     user: Authenticated user identity.     db: Main-database executor.  Returns:     Current aggregate event count and whether at least one active provider made progress.  Raises:     HTTPForbidden: Every active, enabled Calendar Slot is blocked by enterprise policy.
         * @summary Manual Resync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualResync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/resync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit feedback on a cached pre-read.  Internal reports retain the rich Slack payload. External reports use a strict allowlist and a separate channel.
         * @summary Submit Event Preread Feedback
         * @param {PrereadFeedbackRequest} prereadFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEventPrereadFeedback: async (prereadFeedbackRequest: PrereadFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prereadFeedbackRequest' is not null or undefined
            assertParamExists('submitEventPrereadFeedback', 'prereadFeedbackRequest', prereadFeedbackRequest)
            const localVarPath = `/api/v1/calendar/preread/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prereadFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return agentic pre-read deliverables the desktop has not synced yet.  Read-only: never dispatches a managed-agent session. The webhook writes rows to ``preread_generation`` and bumps the ``agentic_prereads`` sync resource; this endpoint is how the desktop ingests those rows.  Incremental mode (``since`` provided): rows with ``generated_at > since``, ordered ascending by ``(generated_at, id)``. Initial mode (``since`` omitted): every successful agentic row for the user, regardless of event age.
         * @summary Sync Agentic Prereads
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to receive all agentic deliverables for upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAgenticPrereads: async (since?: string | null, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/prereads/agentic_sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return calendar events the desktop hasn\'t seen yet.  Two modes:  * ``since`` provided — incremental: events with ``updated_at > since``,   ordered ascending by ``(updated_at, id)``. Stable across rows that   share an ``updated_at`` (e.g. webhook bulk fan-out). * ``since`` null — initial sync: events with ``start_at_utc >= now`` by   default. ``include_recent`` extends this lower bound by the recent-history   window documented on the parameter, while preserving the same upcoming-event   horizon. Ordered ascending by ``(start_at_utc, id)``.  The response anchors on the server clock — desktop uses ``serverTime`` as the next ``since``. Capped at ``SYNC_PAGE_LIMIT`` events per response; when more remain ``nextCursor`` is non-null and the caller should refetch immediately with the same ``since`` and ``include_recent`` values and the new cursor.
         * @summary Sync Calendar
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to get all upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; and &#x60;include_recent&#x60; values.
         * @param {boolean} [launch] When true, the desktop is signalling a genuine app launch; the server schedules a background incremental sync to catch the user up. Defaults false; routine change-pulls omit it.
         * @param {boolean} [includeRecent] On initial sync, extend the event start-time lower bound from now to 48 hours earlier, keeping future events within the 7-day horizon. Ignored for delta sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCalendar: async (since?: string | null, cursor?: string | null, launch?: boolean, includeRecent?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (launch !== undefined) {
                localVarQueryParameter['launch'] = launch;
            }

            if (includeRecent !== undefined) {
                localVarQueryParameter['include_recent'] = includeRecent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verdicts the desktop has not seen yet, as `blocked` booleans only.  Addresses stay on the per-event route: this feed reaches five clients, and shipping attendee emails to all of them would persist them to every device\'s local storage.  Rows are filtered to the org\'s current ``rulesVersion``, so a rules change makes every prior verdict absent here. The client must reset ``since`` and ``cursor`` to null when the returned version differs from its stored one — without that reset it would wait on a ``computed_at`` that never moves and hold a stale verdict forever. A rules change *mid-pagination* is caught server-side: the cursor carries the version it was issued under, and a stale one restarts the run rather than splicing two rule sets together.
         * @summary Sync Notetaker Policy
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync, and whenever &#x60;rulesVersion&#x60; differs from the stored one.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotetakerPolicy: async (since?: string | null, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/calendar/notetaker-policy/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set one meeting\'s calendar notice and auto-share without touching the global setting.  404 for an event we do not hold for this user, as for ``notetaker-policy``. 409 once the meeting has ended, and 409 ``notes_ready`` for a calendar notice change once a meeting recorded against it has a summary: the invite may already carry the notes link. 422 for ``domain`` when the owner\'s email has no custom domain: auto-share would silently skip that audience. The Google invite is rewritten in the background.
         * @summary Update Event Notetaker Controls
         * @param {string} externalId 
         * @param {NotetakerControlsRequest} notetakerControlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventNotetakerControls: async (externalId: string, notetakerControlsRequest: NotetakerControlsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('updateEventNotetakerControls', 'externalId', externalId)
            // verify required parameter 'notetakerControlsRequest' is not null or undefined
            assertParamExists('updateEventNotetakerControls', 'notetakerControlsRequest', notetakerControlsRequest)
            const localVarPath = `/api/v1/calendar/events/{external_id}/notetaker-controls`
                .replace(`{${"external_id"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notetakerControlsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Desktop calls this on schedule or arm. Always 200; skip/failure is per id. Never gates recording.
         * @summary Write Notetaker Notices
         * @param {NotetakerNoticeRequest} notetakerNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeNotetakerNotices: async (notetakerNoticeRequest: NotetakerNoticeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notetakerNoticeRequest' is not null or undefined
            assertParamExists('writeNotetakerNotices', 'notetakerNoticeRequest', notetakerNoticeRequest)
            const localVarPath = `/api/v1/calendar/notetaker-notices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notetakerNoticeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalendarApi - functional programming interface
 * @export
 */
export const CalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * Whether the org\'s Notetaker domain rules block this event, with the matched attendees.  404 rather than 403 for an event we do not hold for this user: a Google ``external_id`` is shared across every attendee\'s copy, so an unscoped lookup would be cross-tenant and a 403 would confirm the id exists in another org.  A cancelled event still gets a real verdict — unlike the pre-read route, there is always an answer to give, and 404 here would read to the client as check-failed, i.e. allow.  Returns 200 with ``blocked: false`` for a solo user or an org with no rules.
         * @summary Get Event Notetaker Policy
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventNotetakerPolicy(externalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotetakerPolicyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventNotetakerPolicy(externalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getEventNotetakerPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate or dispatch a pre-read for an upcoming calendar event.  The desktop already has the Flow Event Key from the sync payload, so callers identify the event by that string rather than the internal UUID. The query layer scopes by ``user_id`` — a stranger\'s Flow Event Key matches no row.  When ``useAgenticPreread`` is false (the default), the handler synchronously builds context and calls the LLM; the worst case is bounded by the generator\'s 30s Anthropic client timeout.  When ``useAgenticPreread`` is true, the handler dispatches a managed-agent session in the background and returns an empty response immediately. The desktop picks up the deliverable via the ``agentic_prereads`` sync resource once the webhook completes.  Events that already ended are fetch-only: the latest stored pre-read is returned as-is, and nothing is ever generated or dispatched for them.  Returns 404 only when the event isn\'t eligible for a pre-read at all:  * No CalendarEvent for the authenticated user and requested Flow Event Key. * The event is cancelled. * The event already ended and has no stored pre-read.  When the event exists but the LLM-side generator fails (rate limits, validation errors, transient outages), the response is still 200 with a minimal calendar-derived fallback so the desktop can render the pre-read card with baseline metadata instead of an empty failure state. The generator already logged + counted the failure.
         * @summary Get Event Preread
         * @param {string} externalId 
         * @param {boolean} [useAgenticPreread] When true, dispatch a managed-agent pre-read session asynchronously and return an empty response. The desktop picks up the result via the &#x60;&#x60;agentic_prereads&#x60;&#x60; sync resource.
         * @param {string | null} [trigger] Optional client-supplied hint describing why the pre-read is being fetched. Allowed values: precache, reminder, debug, sync. Used for telemetry only — unknown values fall through silently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventPreread(externalId: string, useAgenticPreread?: boolean, trigger?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrereadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventPreread(externalId, useAgenticPreread, trigger, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getEventPreread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the authenticated user\'s calendar events matching the given externalIds.  Designed for the desktop to re-fetch events linked to past notes whose local calendar cache was pruned. No ``start_at_utc`` filter — past events are returned. Cancelled events are included so the desktop can render the correct state. A stranger\'s ``externalId`` matches no row (query is ``user_id``-scoped). Event order is unspecified; callers look events up by ``externalId``.
         * @summary Get Events Batch
         * @param {string} ids Comma-separated calendar &#x60;&#x60;externalId&#x60;&#x60; values to look up. At most 50 per request; missing ids are absent from the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventsBatch(ids: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventsBatch(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.getEventsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resync every active Calendar Slot for the authenticated user.  Google completes its backfill and watch recovery before this request returns. Outlook is accepted onto the durable calendar-backfill queue; its worker later performs the forced reseed and publishes ``calendar.changed``. A successful provider is reported even if another provider fails, so the desktop still refreshes its local calendar after partial progress.  Args:     user: Authenticated user identity.     db: Main-database executor.  Returns:     Current aggregate event count and whether at least one active provider made progress.  Raises:     HTTPForbidden: Every active, enabled Calendar Slot is blocked by enterprise policy.
         * @summary Manual Resync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manualResync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manualResync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.manualResync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit feedback on a cached pre-read.  Internal reports retain the rich Slack payload. External reports use a strict allowlist and a separate channel.
         * @summary Submit Event Preread Feedback
         * @param {PrereadFeedbackRequest} prereadFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitEventPrereadFeedback(prereadFeedbackRequest: PrereadFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitEventPrereadFeedback(prereadFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.submitEventPrereadFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return agentic pre-read deliverables the desktop has not synced yet.  Read-only: never dispatches a managed-agent session. The webhook writes rows to ``preread_generation`` and bumps the ``agentic_prereads`` sync resource; this endpoint is how the desktop ingests those rows.  Incremental mode (``since`` provided): rows with ``generated_at > since``, ordered ascending by ``(generated_at, id)``. Initial mode (``since`` omitted): every successful agentic row for the user, regardless of event age.
         * @summary Sync Agentic Prereads
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to receive all agentic deliverables for upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAgenticPrereads(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgenticPrereadSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAgenticPrereads(since, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncAgenticPrereads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return calendar events the desktop hasn\'t seen yet.  Two modes:  * ``since`` provided — incremental: events with ``updated_at > since``,   ordered ascending by ``(updated_at, id)``. Stable across rows that   share an ``updated_at`` (e.g. webhook bulk fan-out). * ``since`` null — initial sync: events with ``start_at_utc >= now`` by   default. ``include_recent`` extends this lower bound by the recent-history   window documented on the parameter, while preserving the same upcoming-event   horizon. Ordered ascending by ``(start_at_utc, id)``.  The response anchors on the server clock — desktop uses ``serverTime`` as the next ``since``. Capped at ``SYNC_PAGE_LIMIT`` events per response; when more remain ``nextCursor`` is non-null and the caller should refetch immediately with the same ``since`` and ``include_recent`` values and the new cursor.
         * @summary Sync Calendar
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to get all upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; and &#x60;include_recent&#x60; values.
         * @param {boolean} [launch] When true, the desktop is signalling a genuine app launch; the server schedules a background incremental sync to catch the user up. Defaults false; routine change-pulls omit it.
         * @param {boolean} [includeRecent] On initial sync, extend the event start-time lower bound from now to 48 hours earlier, keeping future events within the 7-day horizon. Ignored for delta sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncCalendar(since?: string | null, cursor?: string | null, launch?: boolean, includeRecent?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncCalendar(since, cursor, launch, includeRecent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncCalendar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verdicts the desktop has not seen yet, as `blocked` booleans only.  Addresses stay on the per-event route: this feed reaches five clients, and shipping attendee emails to all of them would persist them to every device\'s local storage.  Rows are filtered to the org\'s current ``rulesVersion``, so a rules change makes every prior verdict absent here. The client must reset ``since`` and ``cursor`` to null when the returned version differs from its stored one — without that reset it would wait on a ``computed_at`` that never moves and hold a stale verdict forever. A rules change *mid-pagination* is caught server-side: the cursor carries the version it was issued under, and a stale one restarts the run rather than splicing two rule sets together.
         * @summary Sync Notetaker Policy
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync, and whenever &#x60;rulesVersion&#x60; differs from the stored one.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncNotetakerPolicy(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotetakerPolicySyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncNotetakerPolicy(since, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.syncNotetakerPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set one meeting\'s calendar notice and auto-share without touching the global setting.  404 for an event we do not hold for this user, as for ``notetaker-policy``. 409 once the meeting has ended, and 409 ``notes_ready`` for a calendar notice change once a meeting recorded against it has a summary: the invite may already carry the notes link. 422 for ``domain`` when the owner\'s email has no custom domain: auto-share would silently skip that audience. The Google invite is rewritten in the background.
         * @summary Update Event Notetaker Controls
         * @param {string} externalId 
         * @param {NotetakerControlsRequest} notetakerControlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventNotetakerControls(externalId: string, notetakerControlsRequest: NotetakerControlsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarEventDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventNotetakerControls(externalId, notetakerControlsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.updateEventNotetakerControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Desktop calls this on schedule or arm. Always 200; skip/failure is per id. Never gates recording.
         * @summary Write Notetaker Notices
         * @param {NotetakerNoticeRequest} notetakerNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeNotetakerNotices(notetakerNoticeRequest: NotetakerNoticeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotetakerNoticeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeNotetakerNotices(notetakerNoticeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalendarApi.writeNotetakerNotices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalendarApi - factory interface
 * @export
 */
export const CalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalendarApiFp(configuration)
    return {
        /**
         * Whether the org\'s Notetaker domain rules block this event, with the matched attendees.  404 rather than 403 for an event we do not hold for this user: a Google ``external_id`` is shared across every attendee\'s copy, so an unscoped lookup would be cross-tenant and a 403 would confirm the id exists in another org.  A cancelled event still gets a real verdict — unlike the pre-read route, there is always an answer to give, and 404 here would read to the client as check-failed, i.e. allow.  Returns 200 with ``blocked: false`` for a solo user or an org with no rules.
         * @summary Get Event Notetaker Policy
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventNotetakerPolicy(externalId: string, options?: RawAxiosRequestConfig): AxiosPromise<NotetakerPolicyResponse> {
            return localVarFp.getEventNotetakerPolicy(externalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate or dispatch a pre-read for an upcoming calendar event.  The desktop already has the Flow Event Key from the sync payload, so callers identify the event by that string rather than the internal UUID. The query layer scopes by ``user_id`` — a stranger\'s Flow Event Key matches no row.  When ``useAgenticPreread`` is false (the default), the handler synchronously builds context and calls the LLM; the worst case is bounded by the generator\'s 30s Anthropic client timeout.  When ``useAgenticPreread`` is true, the handler dispatches a managed-agent session in the background and returns an empty response immediately. The desktop picks up the deliverable via the ``agentic_prereads`` sync resource once the webhook completes.  Events that already ended are fetch-only: the latest stored pre-read is returned as-is, and nothing is ever generated or dispatched for them.  Returns 404 only when the event isn\'t eligible for a pre-read at all:  * No CalendarEvent for the authenticated user and requested Flow Event Key. * The event is cancelled. * The event already ended and has no stored pre-read.  When the event exists but the LLM-side generator fails (rate limits, validation errors, transient outages), the response is still 200 with a minimal calendar-derived fallback so the desktop can render the pre-read card with baseline metadata instead of an empty failure state. The generator already logged + counted the failure.
         * @summary Get Event Preread
         * @param {string} externalId 
         * @param {boolean} [useAgenticPreread] When true, dispatch a managed-agent pre-read session asynchronously and return an empty response. The desktop picks up the result via the &#x60;&#x60;agentic_prereads&#x60;&#x60; sync resource.
         * @param {string | null} [trigger] Optional client-supplied hint describing why the pre-read is being fetched. Allowed values: precache, reminder, debug, sync. Used for telemetry only — unknown values fall through silently.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPreread(externalId: string, useAgenticPreread?: boolean, trigger?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PrereadResponse> {
            return localVarFp.getEventPreread(externalId, useAgenticPreread, trigger, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the authenticated user\'s calendar events matching the given externalIds.  Designed for the desktop to re-fetch events linked to past notes whose local calendar cache was pruned. No ``start_at_utc`` filter — past events are returned. Cancelled events are included so the desktop can render the correct state. A stranger\'s ``externalId`` matches no row (query is ``user_id``-scoped). Event order is unspecified; callers look events up by ``externalId``.
         * @summary Get Events Batch
         * @param {string} ids Comma-separated calendar &#x60;&#x60;externalId&#x60;&#x60; values to look up. At most 50 per request; missing ids are absent from the response.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventsBatch(ids: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventBatchResponse> {
            return localVarFp.getEventsBatch(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Resync every active Calendar Slot for the authenticated user.  Google completes its backfill and watch recovery before this request returns. Outlook is accepted onto the durable calendar-backfill queue; its worker later performs the forced reseed and publishes ``calendar.changed``. A successful provider is reported even if another provider fails, so the desktop still refreshes its local calendar after partial progress.  Args:     user: Authenticated user identity.     db: Main-database executor.  Returns:     Current aggregate event count and whether at least one active provider made progress.  Raises:     HTTPForbidden: Every active, enabled Calendar Slot is blocked by enterprise policy.
         * @summary Manual Resync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manualResync(options?: RawAxiosRequestConfig): AxiosPromise<ResyncResponse> {
            return localVarFp.manualResync(options).then((request) => request(axios, basePath));
        },
        /**
         * Submit feedback on a cached pre-read.  Internal reports retain the rich Slack payload. External reports use a strict allowlist and a separate channel.
         * @summary Submit Event Preread Feedback
         * @param {PrereadFeedbackRequest} prereadFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitEventPrereadFeedback(prereadFeedbackRequest: PrereadFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitEventPrereadFeedback(prereadFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return agentic pre-read deliverables the desktop has not synced yet.  Read-only: never dispatches a managed-agent session. The webhook writes rows to ``preread_generation`` and bumps the ``agentic_prereads`` sync resource; this endpoint is how the desktop ingests those rows.  Incremental mode (``since`` provided): rows with ``generated_at > since``, ordered ascending by ``(generated_at, id)``. Initial mode (``since`` omitted): every successful agentic row for the user, regardless of event age.
         * @summary Sync Agentic Prereads
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to receive all agentic deliverables for upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAgenticPrereads(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AgenticPrereadSyncResponse> {
            return localVarFp.syncAgenticPrereads(since, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Return calendar events the desktop hasn\'t seen yet.  Two modes:  * ``since`` provided — incremental: events with ``updated_at > since``,   ordered ascending by ``(updated_at, id)``. Stable across rows that   share an ``updated_at`` (e.g. webhook bulk fan-out). * ``since`` null — initial sync: events with ``start_at_utc >= now`` by   default. ``include_recent`` extends this lower bound by the recent-history   window documented on the parameter, while preserving the same upcoming-event   horizon. Ordered ascending by ``(start_at_utc, id)``.  The response anchors on the server clock — desktop uses ``serverTime`` as the next ``since``. Capped at ``SYNC_PAGE_LIMIT`` events per response; when more remain ``nextCursor`` is non-null and the caller should refetch immediately with the same ``since`` and ``include_recent`` values and the new cursor.
         * @summary Sync Calendar
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to get all upcoming events.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; and &#x60;include_recent&#x60; values.
         * @param {boolean} [launch] When true, the desktop is signalling a genuine app launch; the server schedules a background incremental sync to catch the user up. Defaults false; routine change-pulls omit it.
         * @param {boolean} [includeRecent] On initial sync, extend the event start-time lower bound from now to 48 hours earlier, keeping future events within the 7-day horizon. Ignored for delta sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncCalendar(since?: string | null, cursor?: string | null, launch?: boolean, includeRecent?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SyncResponse> {
            return localVarFp.syncCalendar(since, cursor, launch, includeRecent, options).then((request) => request(axios, basePath));
        },
        /**
         * Verdicts the desktop has not seen yet, as `blocked` booleans only.  Addresses stay on the per-event route: this feed reaches five clients, and shipping attendee emails to all of them would persist them to every device\'s local storage.  Rows are filtered to the org\'s current ``rulesVersion``, so a rules change makes every prior verdict absent here. The client must reset ``since`` and ``cursor`` to null when the returned version differs from its stored one — without that reset it would wait on a ``computed_at`` that never moves and hold a stale verdict forever. A rules change *mid-pagination* is caught server-side: the cursor carries the version it was issued under, and a stale one restarts the run rather than splicing two rule sets together.
         * @summary Sync Notetaker Policy
         * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync, and whenever &#x60;rulesVersion&#x60; differs from the stored one.
         * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotetakerPolicy(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<NotetakerPolicySyncResponse> {
            return localVarFp.syncNotetakerPolicy(since, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Set one meeting\'s calendar notice and auto-share without touching the global setting.  404 for an event we do not hold for this user, as for ``notetaker-policy``. 409 once the meeting has ended, and 409 ``notes_ready`` for a calendar notice change once a meeting recorded against it has a summary: the invite may already carry the notes link. 422 for ``domain`` when the owner\'s email has no custom domain: auto-share would silently skip that audience. The Google invite is rewritten in the background.
         * @summary Update Event Notetaker Controls
         * @param {string} externalId 
         * @param {NotetakerControlsRequest} notetakerControlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventNotetakerControls(externalId: string, notetakerControlsRequest: NotetakerControlsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalendarEventDTO> {
            return localVarFp.updateEventNotetakerControls(externalId, notetakerControlsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Desktop calls this on schedule or arm. Always 200; skip/failure is per id. Never gates recording.
         * @summary Write Notetaker Notices
         * @param {NotetakerNoticeRequest} notetakerNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeNotetakerNotices(notetakerNoticeRequest: NotetakerNoticeRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotetakerNoticeResponse> {
            return localVarFp.writeNotetakerNotices(notetakerNoticeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalendarApi - object-oriented interface
 * @export
 * @class CalendarApi
 * @extends {BaseAPI}
 */
export class CalendarApi extends BaseAPI {
    /**
     * Whether the org\'s Notetaker domain rules block this event, with the matched attendees.  404 rather than 403 for an event we do not hold for this user: a Google ``external_id`` is shared across every attendee\'s copy, so an unscoped lookup would be cross-tenant and a 403 would confirm the id exists in another org.  A cancelled event still gets a real verdict — unlike the pre-read route, there is always an answer to give, and 404 here would read to the client as check-failed, i.e. allow.  Returns 200 with ``blocked: false`` for a solo user or an org with no rules.
     * @summary Get Event Notetaker Policy
     * @param {string} externalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getEventNotetakerPolicy(externalId: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getEventNotetakerPolicy(externalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate or dispatch a pre-read for an upcoming calendar event.  The desktop already has the Flow Event Key from the sync payload, so callers identify the event by that string rather than the internal UUID. The query layer scopes by ``user_id`` — a stranger\'s Flow Event Key matches no row.  When ``useAgenticPreread`` is false (the default), the handler synchronously builds context and calls the LLM; the worst case is bounded by the generator\'s 30s Anthropic client timeout.  When ``useAgenticPreread`` is true, the handler dispatches a managed-agent session in the background and returns an empty response immediately. The desktop picks up the deliverable via the ``agentic_prereads`` sync resource once the webhook completes.  Events that already ended are fetch-only: the latest stored pre-read is returned as-is, and nothing is ever generated or dispatched for them.  Returns 404 only when the event isn\'t eligible for a pre-read at all:  * No CalendarEvent for the authenticated user and requested Flow Event Key. * The event is cancelled. * The event already ended and has no stored pre-read.  When the event exists but the LLM-side generator fails (rate limits, validation errors, transient outages), the response is still 200 with a minimal calendar-derived fallback so the desktop can render the pre-read card with baseline metadata instead of an empty failure state. The generator already logged + counted the failure.
     * @summary Get Event Preread
     * @param {string} externalId 
     * @param {boolean} [useAgenticPreread] When true, dispatch a managed-agent pre-read session asynchronously and return an empty response. The desktop picks up the result via the &#x60;&#x60;agentic_prereads&#x60;&#x60; sync resource.
     * @param {string | null} [trigger] Optional client-supplied hint describing why the pre-read is being fetched. Allowed values: precache, reminder, debug, sync. Used for telemetry only — unknown values fall through silently.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getEventPreread(externalId: string, useAgenticPreread?: boolean, trigger?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getEventPreread(externalId, useAgenticPreread, trigger, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the authenticated user\'s calendar events matching the given externalIds.  Designed for the desktop to re-fetch events linked to past notes whose local calendar cache was pruned. No ``start_at_utc`` filter — past events are returned. Cancelled events are included so the desktop can render the correct state. A stranger\'s ``externalId`` matches no row (query is ``user_id``-scoped). Event order is unspecified; callers look events up by ``externalId``.
     * @summary Get Events Batch
     * @param {string} ids Comma-separated calendar &#x60;&#x60;externalId&#x60;&#x60; values to look up. At most 50 per request; missing ids are absent from the response.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public getEventsBatch(ids: string, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).getEventsBatch(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resync every active Calendar Slot for the authenticated user.  Google completes its backfill and watch recovery before this request returns. Outlook is accepted onto the durable calendar-backfill queue; its worker later performs the forced reseed and publishes ``calendar.changed``. A successful provider is reported even if another provider fails, so the desktop still refreshes its local calendar after partial progress.  Args:     user: Authenticated user identity.     db: Main-database executor.  Returns:     Current aggregate event count and whether at least one active provider made progress.  Raises:     HTTPForbidden: Every active, enabled Calendar Slot is blocked by enterprise policy.
     * @summary Manual Resync
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public manualResync(options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).manualResync(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit feedback on a cached pre-read.  Internal reports retain the rich Slack payload. External reports use a strict allowlist and a separate channel.
     * @summary Submit Event Preread Feedback
     * @param {PrereadFeedbackRequest} prereadFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public submitEventPrereadFeedback(prereadFeedbackRequest: PrereadFeedbackRequest, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).submitEventPrereadFeedback(prereadFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return agentic pre-read deliverables the desktop has not synced yet.  Read-only: never dispatches a managed-agent session. The webhook writes rows to ``preread_generation`` and bumps the ``agentic_prereads`` sync resource; this endpoint is how the desktop ingests those rows.  Incremental mode (``since`` provided): rows with ``generated_at > since``, ordered ascending by ``(generated_at, id)``. Initial mode (``since`` omitted): every successful agentic row for the user, regardless of event age.
     * @summary Sync Agentic Prereads
     * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to receive all agentic deliverables for upcoming events.
     * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncAgenticPrereads(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncAgenticPrereads(since, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return calendar events the desktop hasn\'t seen yet.  Two modes:  * ``since`` provided — incremental: events with ``updated_at > since``,   ordered ascending by ``(updated_at, id)``. Stable across rows that   share an ``updated_at`` (e.g. webhook bulk fan-out). * ``since`` null — initial sync: events with ``start_at_utc >= now`` by   default. ``include_recent`` extends this lower bound by the recent-history   window documented on the parameter, while preserving the same upcoming-event   horizon. Ordered ascending by ``(start_at_utc, id)``.  The response anchors on the server clock — desktop uses ``serverTime`` as the next ``since``. Capped at ``SYNC_PAGE_LIMIT`` events per response; when more remain ``nextCursor`` is non-null and the caller should refetch immediately with the same ``since`` and ``include_recent`` values and the new cursor.
     * @summary Sync Calendar
     * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync to get all upcoming events.
     * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;. Only meaningful when paired with the same &#x60;since&#x60; and &#x60;include_recent&#x60; values.
     * @param {boolean} [launch] When true, the desktop is signalling a genuine app launch; the server schedules a background incremental sync to catch the user up. Defaults false; routine change-pulls omit it.
     * @param {boolean} [includeRecent] On initial sync, extend the event start-time lower bound from now to 48 hours earlier, keeping future events within the 7-day horizon. Ignored for delta sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncCalendar(since?: string | null, cursor?: string | null, launch?: boolean, includeRecent?: boolean, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncCalendar(since, cursor, launch, includeRecent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verdicts the desktop has not seen yet, as `blocked` booleans only.  Addresses stay on the per-event route: this feed reaches five clients, and shipping attendee emails to all of them would persist them to every device\'s local storage.  Rows are filtered to the org\'s current ``rulesVersion``, so a rules change makes every prior verdict absent here. The client must reset ``since`` and ``cursor`` to null when the returned version differs from its stored one — without that reset it would wait on a ``computed_at`` that never moves and hold a stale verdict forever. A rules change *mid-pagination* is caught server-side: the cursor carries the version it was issued under, and a stale one restarts the run rather than splicing two rule sets together.
     * @summary Sync Notetaker Policy
     * @param {string | null} [since] ISO 8601 timestamp from the previous response\&#39;s &#x60;serverTime&#x60;. Omit on first sync, and whenever &#x60;rulesVersion&#x60; differs from the stored one.
     * @param {string | null} [cursor] Pagination cursor from the previous response\&#39;s &#x60;nextCursor&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public syncNotetakerPolicy(since?: string | null, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).syncNotetakerPolicy(since, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set one meeting\'s calendar notice and auto-share without touching the global setting.  404 for an event we do not hold for this user, as for ``notetaker-policy``. 409 once the meeting has ended, and 409 ``notes_ready`` for a calendar notice change once a meeting recorded against it has a summary: the invite may already carry the notes link. 422 for ``domain`` when the owner\'s email has no custom domain: auto-share would silently skip that audience. The Google invite is rewritten in the background.
     * @summary Update Event Notetaker Controls
     * @param {string} externalId 
     * @param {NotetakerControlsRequest} notetakerControlsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public updateEventNotetakerControls(externalId: string, notetakerControlsRequest: NotetakerControlsRequest, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).updateEventNotetakerControls(externalId, notetakerControlsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Desktop calls this on schedule or arm. Always 200; skip/failure is per id. Never gates recording.
     * @summary Write Notetaker Notices
     * @param {NotetakerNoticeRequest} notetakerNoticeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalendarApi
     */
    public writeNotetakerNotices(notetakerNoticeRequest: NotetakerNoticeRequest, options?: RawAxiosRequestConfig) {
        return CalendarApiFp(this.configuration).writeNotetakerNotices(notetakerNoticeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConnectorsApi - axios parameter creator
 * @export
 */
export const ConnectorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Start a first-connection Add Attempt for one explicitly selected Provider.
         * @summary Create Calendar Authorization Attempt
         * @param {CalendarOAuthAttemptCreateRequest} calendarOAuthAttemptCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarAuthorizationAttempt: async (calendarOAuthAttemptCreateRequest: CalendarOAuthAttemptCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarOAuthAttemptCreateRequest' is not null or undefined
            assertParamExists('createCalendarAuthorizationAttempt', 'calendarOAuthAttemptCreateRequest', calendarOAuthAttemptCreateRequest)
            const localVarPath = `/api/v1/connectors/authorization-attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarOAuthAttemptCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start Reconnect for one exact Slot owned by the authenticated user.
         * @summary Create Calendar Reconnect Attempt
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarReconnectAttempt: async (slotId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slotId' is not null or undefined
            assertParamExists('createCalendarReconnectAttempt', 'slotId', slotId)
            const localVarPath = `/api/v1/connectors/connections/{slot_id}/reconnect`
                .replace(`{${"slot_id"}}`, encodeURIComponent(String(slotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect the given connector for the authenticated user.
         * @summary Disconnect
         * @param {DisconnectRequest} disconnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect: async (disconnectRequest: DisconnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'disconnectRequest' is not null or undefined
            assertParamExists('disconnect', 'disconnectRequest', disconnectRequest)
            const localVarPath = `/api/v1/connectors/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disconnectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll one opaque Attempt without disclosing whether another owner created it.
         * @summary Get Calendar Authorization Attempt Status
         * @param {string} attemptId 
         * @param {GetCalendarAuthorizationAttemptStatusProviderEnum} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarAuthorizationAttemptStatus: async (attemptId: string, provider: GetCalendarAuthorizationAttemptStatusProviderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getCalendarAuthorizationAttemptStatus', 'attemptId', attemptId)
            // verify required parameter 'provider' is not null or undefined
            assertParamExists('getCalendarAuthorizationAttemptStatus', 'provider', provider)
            const localVarPath = `/api/v1/connectors/authorization-attempts/{attempt_id}`
                .replace(`{${"attempt_id"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List every calendar Slot owned by the authenticated user.
         * @summary Get Calendar Connection Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarConnectionCatalog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/connectors/connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a connection\'s status, kicking off calendar setup when it first goes ACTIVE.
         * @summary Get Connection Status
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionStatus: async (connectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectionId' is not null or undefined
            assertParamExists('getConnectionStatus', 'connectionId', connectionId)
            const localVarPath = `/api/v1/connectors/connection/{connection_id}/status`
                .replace(`{${"connection_id"}}`, encodeURIComponent(String(connectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Begin an OAuth connection flow for a connector and return its authorization redirect.
         * @summary Initiate Connection
         * @param {InitiateConnectionRequest} initiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateConnection: async (initiateConnectionRequest: InitiateConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateConnectionRequest' is not null or undefined
            assertParamExists('initiateConnection', 'initiateConnectionRequest', initiateConnectionRequest)
            const localVarPath = `/api/v1/connectors/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the user\'s Google Calendar events within the requested time window.
         * @summary List Calendar Events
         * @param {ListCalendarEventsRequest} listCalendarEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarEvents: async (listCalendarEventsRequest: ListCalendarEventsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listCalendarEventsRequest' is not null or undefined
            assertParamExists('listCalendarEvents', 'listCalendarEventsRequest', listCalendarEventsRequest)
            const localVarPath = `/api/v1/connectors/list_calendar_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listCalendarEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the authenticated user\'s connectors and their connection status.
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/connectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forward a raw connection request straight to the underlying connector (prototypes only).  Production code should use the `/connect` endpoint, as that is the only way to have a stable API through provider changes. Users of this endpoint should assume breaking changes might occur arbitrarily.
         * @summary Raw Initiate Connection
         * @param {RawInitiateConnectionRequest} rawInitiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rawInitiateConnection: async (rawInitiateConnectionRequest: RawInitiateConnectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rawInitiateConnectionRequest' is not null or undefined
            assertParamExists('rawInitiateConnection', 'rawInitiateConnectionRequest', rawInitiateConnectionRequest)
            const localVarPath = `/api/v1/connectors/raw_connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rawInitiateConnectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConnectorsApi - functional programming interface
 * @export
 */
export const ConnectorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConnectorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Start a first-connection Add Attempt for one explicitly selected Provider.
         * @summary Create Calendar Authorization Attempt
         * @param {CalendarOAuthAttemptCreateRequest} calendarOAuthAttemptCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest: CalendarOAuthAttemptCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarOAuthAttemptInitiationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.createCalendarAuthorizationAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start Reconnect for one exact Slot owned by the authenticated user.
         * @summary Create Calendar Reconnect Attempt
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCalendarReconnectAttempt(slotId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarOAuthAttemptInitiationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCalendarReconnectAttempt(slotId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.createCalendarReconnectAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect the given connector for the authenticated user.
         * @summary Disconnect
         * @param {DisconnectRequest} disconnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnect(disconnectRequest: DisconnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnect(disconnectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.disconnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Poll one opaque Attempt without disclosing whether another owner created it.
         * @summary Get Calendar Authorization Attempt Status
         * @param {string} attemptId 
         * @param {GetCalendarAuthorizationAttemptStatusProviderEnum} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarAuthorizationAttemptStatus(attemptId: string, provider: GetCalendarAuthorizationAttemptStatusProviderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarOAuthAttemptStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarAuthorizationAttemptStatus(attemptId, provider, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getCalendarAuthorizationAttemptStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List every calendar Slot owned by the authenticated user.
         * @summary Get Calendar Connection Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarConnectionCatalog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalendarConnectionCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarConnectionCatalog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getCalendarConnectionCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a connection\'s status, kicking off calendar setup when it first goes ACTIVE.
         * @summary Get Connection Status
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionStatus(connectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectionStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionStatus(connectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.getConnectionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Begin an OAuth connection flow for a connector and return its authorization redirect.
         * @summary Initiate Connection
         * @param {InitiateConnectionRequest} initiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateConnection(initiateConnectionRequest: InitiateConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateConnection(initiateConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.initiateConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the user\'s Google Calendar events within the requested time window.
         * @summary List Calendar Events
         * @param {ListCalendarEventsRequest} listCalendarEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCalendarEvents(listCalendarEventsRequest: ListCalendarEventsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCalendarEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCalendarEvents(listCalendarEventsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.listCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the authenticated user\'s connectors and their connection status.
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConnectors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConnectorsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConnectors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.listConnectors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Forward a raw connection request straight to the underlying connector (prototypes only).  Production code should use the `/connect` endpoint, as that is the only way to have a stable API through provider changes. Users of this endpoint should assume breaking changes might occur arbitrarily.
         * @summary Raw Initiate Connection
         * @param {RawInitiateConnectionRequest} rawInitiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rawInitiateConnection(rawInitiateConnectionRequest: RawInitiateConnectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rawInitiateConnection(rawInitiateConnectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConnectorsApi.rawInitiateConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConnectorsApi - factory interface
 * @export
 */
export const ConnectorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConnectorsApiFp(configuration)
    return {
        /**
         * Start a first-connection Add Attempt for one explicitly selected Provider.
         * @summary Create Calendar Authorization Attempt
         * @param {CalendarOAuthAttemptCreateRequest} calendarOAuthAttemptCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest: CalendarOAuthAttemptCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalendarOAuthAttemptInitiationResponse> {
            return localVarFp.createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start Reconnect for one exact Slot owned by the authenticated user.
         * @summary Create Calendar Reconnect Attempt
         * @param {string} slotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCalendarReconnectAttempt(slotId: string, options?: RawAxiosRequestConfig): AxiosPromise<CalendarOAuthAttemptInitiationResponse> {
            return localVarFp.createCalendarReconnectAttempt(slotId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect the given connector for the authenticated user.
         * @summary Disconnect
         * @param {DisconnectRequest} disconnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnect(disconnectRequest: DisconnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<DisconnectResponse> {
            return localVarFp.disconnect(disconnectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll one opaque Attempt without disclosing whether another owner created it.
         * @summary Get Calendar Authorization Attempt Status
         * @param {string} attemptId 
         * @param {GetCalendarAuthorizationAttemptStatusProviderEnum} provider 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarAuthorizationAttemptStatus(attemptId: string, provider: GetCalendarAuthorizationAttemptStatusProviderEnum, options?: RawAxiosRequestConfig): AxiosPromise<CalendarOAuthAttemptStatusResponse> {
            return localVarFp.getCalendarAuthorizationAttemptStatus(attemptId, provider, options).then((request) => request(axios, basePath));
        },
        /**
         * List every calendar Slot owned by the authenticated user.
         * @summary Get Calendar Connection Catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarConnectionCatalog(options?: RawAxiosRequestConfig): AxiosPromise<CalendarConnectionCatalogResponse> {
            return localVarFp.getCalendarConnectionCatalog(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a connection\'s status, kicking off calendar setup when it first goes ACTIVE.
         * @summary Get Connection Status
         * @param {string} connectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionStatus(connectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ConnectionStatusResponse> {
            return localVarFp.getConnectionStatus(connectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Begin an OAuth connection flow for a connector and return its authorization redirect.
         * @summary Initiate Connection
         * @param {InitiateConnectionRequest} initiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateConnection(initiateConnectionRequest: InitiateConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InitiateConnectionResponse> {
            return localVarFp.initiateConnection(initiateConnectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List the user\'s Google Calendar events within the requested time window.
         * @summary List Calendar Events
         * @param {ListCalendarEventsRequest} listCalendarEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCalendarEvents(listCalendarEventsRequest: ListCalendarEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCalendarEventsResponse> {
            return localVarFp.listCalendarEvents(listCalendarEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List the authenticated user\'s connectors and their connection status.
         * @summary List Connectors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConnectors(options?: RawAxiosRequestConfig): AxiosPromise<ConnectorsResponse> {
            return localVarFp.listConnectors(options).then((request) => request(axios, basePath));
        },
        /**
         * Forward a raw connection request straight to the underlying connector (prototypes only).  Production code should use the `/connect` endpoint, as that is the only way to have a stable API through provider changes. Users of this endpoint should assume breaking changes might occur arbitrarily.
         * @summary Raw Initiate Connection
         * @param {RawInitiateConnectionRequest} rawInitiateConnectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rawInitiateConnection(rawInitiateConnectionRequest: RawInitiateConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InitiateConnectionResponse> {
            return localVarFp.rawInitiateConnection(rawInitiateConnectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConnectorsApi - object-oriented interface
 * @export
 * @class ConnectorsApi
 * @extends {BaseAPI}
 */
export class ConnectorsApi extends BaseAPI {
    /**
     * Start a first-connection Add Attempt for one explicitly selected Provider.
     * @summary Create Calendar Authorization Attempt
     * @param {CalendarOAuthAttemptCreateRequest} calendarOAuthAttemptCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest: CalendarOAuthAttemptCreateRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).createCalendarAuthorizationAttempt(calendarOAuthAttemptCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start Reconnect for one exact Slot owned by the authenticated user.
     * @summary Create Calendar Reconnect Attempt
     * @param {string} slotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public createCalendarReconnectAttempt(slotId: string, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).createCalendarReconnectAttempt(slotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect the given connector for the authenticated user.
     * @summary Disconnect
     * @param {DisconnectRequest} disconnectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public disconnect(disconnectRequest: DisconnectRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).disconnect(disconnectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll one opaque Attempt without disclosing whether another owner created it.
     * @summary Get Calendar Authorization Attempt Status
     * @param {string} attemptId 
     * @param {GetCalendarAuthorizationAttemptStatusProviderEnum} provider 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public getCalendarAuthorizationAttemptStatus(attemptId: string, provider: GetCalendarAuthorizationAttemptStatusProviderEnum, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getCalendarAuthorizationAttemptStatus(attemptId, provider, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List every calendar Slot owned by the authenticated user.
     * @summary Get Calendar Connection Catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public getCalendarConnectionCatalog(options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getCalendarConnectionCatalog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a connection\'s status, kicking off calendar setup when it first goes ACTIVE.
     * @summary Get Connection Status
     * @param {string} connectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public getConnectionStatus(connectionId: string, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).getConnectionStatus(connectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Begin an OAuth connection flow for a connector and return its authorization redirect.
     * @summary Initiate Connection
     * @param {InitiateConnectionRequest} initiateConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public initiateConnection(initiateConnectionRequest: InitiateConnectionRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).initiateConnection(initiateConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the user\'s Google Calendar events within the requested time window.
     * @summary List Calendar Events
     * @param {ListCalendarEventsRequest} listCalendarEventsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public listCalendarEvents(listCalendarEventsRequest: ListCalendarEventsRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).listCalendarEvents(listCalendarEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the authenticated user\'s connectors and their connection status.
     * @summary List Connectors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public listConnectors(options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).listConnectors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forward a raw connection request straight to the underlying connector (prototypes only).  Production code should use the `/connect` endpoint, as that is the only way to have a stable API through provider changes. Users of this endpoint should assume breaking changes might occur arbitrarily.
     * @summary Raw Initiate Connection
     * @param {RawInitiateConnectionRequest} rawInitiateConnectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConnectorsApi
     */
    public rawInitiateConnection(rawInitiateConnectionRequest: RawInitiateConnectionRequest, options?: RawAxiosRequestConfig) {
        return ConnectorsApiFp(this.configuration).rawInitiateConnection(rawInitiateConnectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCalendarAuthorizationAttemptStatusProviderEnum = {
    Calendar: 'calendar',
    Outlook: 'outlook'
} as const;
export type GetCalendarAuthorizationAttemptStatusProviderEnum = typeof GetCalendarAuthorizationAttemptStatusProviderEnum[keyof typeof GetCalendarAuthorizationAttemptStatusProviderEnum];


/**
 * ContactsApi - axios parameter creator
 * @export
 */
export const ContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a contact belonging to the authenticated user.
         * @summary Create Contact
         * @param {ContactCreateRequest} contactCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (contactCreateRequest: ContactCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactCreateRequest' is not null or undefined
            assertParamExists('createContact', 'contactCreateRequest', contactCreateRequest)
            const localVarPath = `/api/v1/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one contact belonging to the authenticated user.
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContact', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch one contact belonging to the authenticated user.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContact', 'contactId', contactId)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch visible contacts for the authenticated user.
         * @summary Get Contacts Batch
         * @param {ContactBatchRequest} contactBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactsBatch: async (contactBatchRequest: ContactBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactBatchRequest' is not null or undefined
            assertParamExists('getContactsBatch', 'contactBatchRequest', contactBatchRequest)
            const localVarPath = `/api/v1/contacts/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the authenticated user\'s contacts.
         * @summary Search Contacts
         * @param {string | null} [query] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [meetingId] Promote contacts invited to this meeting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContacts: async (query?: string | null, limit?: number, offset?: number, meetingId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/contacts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (meetingId !== undefined) {
                localVarQueryParameter['meeting_id'] = meetingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an owned contact and return its basic fields; merge them into cached details or refetch details.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateRequest} contactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (contactId: string, contactUpdateRequest: ContactUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContact', 'contactId', contactId)
            // verify required parameter 'contactUpdateRequest' is not null or undefined
            assertParamExists('updateContact', 'contactUpdateRequest', contactUpdateRequest)
            const localVarPath = `/api/v1/contacts/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactsApi - functional programming interface
 * @export
 */
export const ContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a contact belonging to the authenticated user.
         * @summary Create Contact
         * @param {ContactCreateRequest} contactCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(contactCreateRequest: ContactCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(contactCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one contact belonging to the authenticated user.
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.deleteContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch one contact belonging to the authenticated user.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch visible contacts for the authenticated user.
         * @summary Get Contacts Batch
         * @param {ContactBatchRequest} contactBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactsBatch(contactBatchRequest: ContactBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactsBatch(contactBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.getContactsBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the authenticated user\'s contacts.
         * @summary Search Contacts
         * @param {string | null} [query] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [meetingId] Promote contacts invited to this meeting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContacts(query?: string | null, limit?: number, offset?: number, meetingId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContacts(query, limit, offset, meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.searchContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an owned contact and return its basic fields; merge them into cached details or refetch details.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateRequest} contactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(contactId: string, contactUpdateRequest: ContactUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(contactId, contactUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactsApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactsApi - factory interface
 * @export
 */
export const ContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactsApiFp(configuration)
    return {
        /**
         * Create a contact belonging to the authenticated user.
         * @summary Create Contact
         * @param {ContactCreateRequest} contactCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(contactCreateRequest: ContactCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponse> {
            return localVarFp.createContact(contactCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one contact belonging to the authenticated user.
         * @summary Delete Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(contactId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch one contact belonging to the authenticated user.
         * @summary Get Contact
         * @param {string} contactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(contactId: string, options?: RawAxiosRequestConfig): AxiosPromise<ContactDetailResponse> {
            return localVarFp.getContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch visible contacts for the authenticated user.
         * @summary Get Contacts Batch
         * @param {ContactBatchRequest} contactBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactsBatch(contactBatchRequest: ContactBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContactBatchResponse> {
            return localVarFp.getContactsBatch(contactBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search the authenticated user\'s contacts.
         * @summary Search Contacts
         * @param {string | null} [query] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [meetingId] Promote contacts invited to this meeting.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContacts(query?: string | null, limit?: number, offset?: number, meetingId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ContactSearchResponse> {
            return localVarFp.searchContacts(query, limit, offset, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an owned contact and return its basic fields; merge them into cached details or refetch details.
         * @summary Update Contact
         * @param {string} contactId 
         * @param {ContactUpdateRequest} contactUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(contactId: string, contactUpdateRequest: ContactUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContactResponse> {
            return localVarFp.updateContact(contactId, contactUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactsApi - object-oriented interface
 * @export
 * @class ContactsApi
 * @extends {BaseAPI}
 */
export class ContactsApi extends BaseAPI {
    /**
     * Create a contact belonging to the authenticated user.
     * @summary Create Contact
     * @param {ContactCreateRequest} contactCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public createContact(contactCreateRequest: ContactCreateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).createContact(contactCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one contact belonging to the authenticated user.
     * @summary Delete Contact
     * @param {string} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public deleteContact(contactId: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).deleteContact(contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch one contact belonging to the authenticated user.
     * @summary Get Contact
     * @param {string} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContact(contactId: string, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContact(contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch visible contacts for the authenticated user.
     * @summary Get Contacts Batch
     * @param {ContactBatchRequest} contactBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public getContactsBatch(contactBatchRequest: ContactBatchRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).getContactsBatch(contactBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search the authenticated user\'s contacts.
     * @summary Search Contacts
     * @param {string | null} [query] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [meetingId] Promote contacts invited to this meeting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public searchContacts(query?: string | null, limit?: number, offset?: number, meetingId?: string | null, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).searchContacts(query, limit, offset, meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an owned contact and return its basic fields; merge them into cached details or refetch details.
     * @summary Update Contact
     * @param {string} contactId 
     * @param {ContactUpdateRequest} contactUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactsApi
     */
    public updateContact(contactId: string, contactUpdateRequest: ContactUpdateRequest, options?: RawAxiosRequestConfig) {
        return ContactsApiFp(this.configuration).updateContact(contactId, contactUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CostCentersApi - axios parameter creator
 * @export
 */
export const CostCentersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Commit a batch of self-serve seat changes as an enterprise admin.  A 200 response confirms the assignments were committed. If the outcome is unknown (503), retry the same request_id and changes to confirm the result.
         * @summary Change Cost Center Seats
         * @param {string} costCenterId 
         * @param {ChangeCostCenterSeatsRequest} changeCostCenterSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCostCenterSeats: async (costCenterId: string, changeCostCenterSeatsRequest: ChangeCostCenterSeatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('changeCostCenterSeats', 'costCenterId', costCenterId)
            // verify required parameter 'changeCostCenterSeatsRequest' is not null or undefined
            assertParamExists('changeCostCenterSeats', 'changeCostCenterSeatsRequest', changeCostCenterSeatsRequest)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}/seat-changes`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeCostCenterSeatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new cost center for an enterprise (break-away intent step).  The cost center is named after the caller\'s current team. The team is not moved into the new CC until the Stripe checkout webhook fires. The caller must be an enterprise admin.
         * @summary Create Cost Center
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCenter: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('createCostCenter', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/{enterprise_id}/cost-centers`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe checkout session for a cost center in break-away intent state.  The new cost center inherits the parent enterprise\'s negotiated price — callers do not pick a plan. The team that will move is inferred from the caller\'s current active membership (no team_id in the request body).
         * @summary Create Cost Center Billing
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCenterBilling: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('createCostCenterBilling', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}/billing`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a cost center.  Refuses if the cost center has an active Stripe subscription or teams still referencing it. The caller must be an enterprise admin.
         * @summary Delete Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCostCenter: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('deleteCostCenter', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the pre-checkout summary for an in-flight break-away.  Called after ``create_cost_center`` and before ``create_cost_center_billing`` to surface team name, source cost center, member counts, and the per-seat price math so the admin can confirm before being redirected to Stripe.  Caller must be an enterprise admin of the owning enterprise or the new CC\'s ``billing_owner_user_id``.
         * @summary Get Break Away Preview
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBreakAwayPreview: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('getBreakAwayPreview', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}/break-away-preview`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single cost center by id.  The caller must be an admin of the enterprise that owns this cost center.
         * @summary Get Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostCenter: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('getCostCenter', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all cost centers for an enterprise.  The caller must be an enterprise admin. Each entry includes a computed ``team_count`` fetched via a single GROUP BY query.
         * @summary List Cost Centers
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCenters: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listCostCenters', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/{enterprise_id}/cost-centers`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Open a self-serve cost center\'s subscription through hosted Stripe Checkout as an enterprise admin.  Retrying with the same request_id and body returns the same session. A new request_id expires an unpaid open session and returns a new one; the old link stops working. Payment is confirmed from Stripe after the admin completes Checkout, not from the redirect.
         * @summary Open Cost Center Self Serve Checkout
         * @param {string} costCenterId 
         * @param {OpenSelfServeCheckoutRequest} openSelfServeCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openCostCenterSelfServeCheckout: async (costCenterId: string, openSelfServeCheckoutRequest: OpenSelfServeCheckoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('openCostCenterSelfServeCheckout', 'costCenterId', costCenterId)
            // verify required parameter 'openSelfServeCheckoutRequest' is not null or undefined
            assertParamExists('openCostCenterSelfServeCheckout', 'openSelfServeCheckoutRequest', openSelfServeCheckoutRequest)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}/self-serve-checkout`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openSelfServeCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename a cost center.  Caller must be an enterprise admin or the cost center\'s billing owner.
         * @summary Update Cost Center
         * @param {string} costCenterId 
         * @param {UpdateCostCenterRequest} updateCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCenter: async (costCenterId: string, updateCostCenterRequest: UpdateCostCenterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('updateCostCenter', 'costCenterId', costCenterId)
            // verify required parameter 'updateCostCenterRequest' is not null or undefined
            assertParamExists('updateCostCenter', 'updateCostCenterRequest', updateCostCenterRequest)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCostCenterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CostCentersApi - functional programming interface
 * @export
 */
export const CostCentersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CostCentersApiAxiosParamCreator(configuration)
    return {
        /**
         * Commit a batch of self-serve seat changes as an enterprise admin.  A 200 response confirms the assignments were committed. If the outcome is unknown (503), retry the same request_id and changes to confirm the result.
         * @summary Change Cost Center Seats
         * @param {string} costCenterId 
         * @param {ChangeCostCenterSeatsRequest} changeCostCenterSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeCostCenterSeats(costCenterId: string, changeCostCenterSeatsRequest: ChangeCostCenterSeatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangeCostCenterSeatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeCostCenterSeats(costCenterId, changeCostCenterSeatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.changeCostCenterSeats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new cost center for an enterprise (break-away intent step).  The cost center is named after the caller\'s current team. The team is not moved into the new CC until the Stripe checkout webhook fires. The caller must be an enterprise admin.
         * @summary Create Cost Center
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCostCenter(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostCenterDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCostCenter(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.createCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe checkout session for a cost center in break-away intent state.  The new cost center inherits the parent enterprise\'s negotiated price — callers do not pick a plan. The team that will move is inferred from the caller\'s current active membership (no team_id in the request body).
         * @summary Create Cost Center Billing
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCostCenterBilling(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCostCenterBilling(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.createCostCenterBilling']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a cost center.  Refuses if the cost center has an active Stripe subscription or teams still referencing it. The caller must be an enterprise admin.
         * @summary Delete Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCostCenter(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.deleteCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the pre-checkout summary for an in-flight break-away.  Called after ``create_cost_center`` and before ``create_cost_center_billing`` to surface team name, source cost center, member counts, and the per-seat price math so the admin can confirm before being redirected to Stripe.  Caller must be an enterprise admin of the owning enterprise or the new CC\'s ``billing_owner_user_id``.
         * @summary Get Break Away Preview
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBreakAwayPreview(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BreakAwayPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBreakAwayPreview(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.getBreakAwayPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single cost center by id.  The caller must be an admin of the enterprise that owns this cost center.
         * @summary Get Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostCenterDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCostCenter(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.getCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all cost centers for an enterprise.  The caller must be an enterprise admin. Each entry includes a computed ``team_count`` fetched via a single GROUP BY query.
         * @summary List Cost Centers
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCostCenters(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostCenterListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCostCenters(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.listCostCenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Open a self-serve cost center\'s subscription through hosted Stripe Checkout as an enterprise admin.  Retrying with the same request_id and body returns the same session. A new request_id expires an unpaid open session and returns a new one; the old link stops working. Payment is confirmed from Stripe after the admin completes Checkout, not from the redirect.
         * @summary Open Cost Center Self Serve Checkout
         * @param {string} costCenterId 
         * @param {OpenSelfServeCheckoutRequest} openSelfServeCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openCostCenterSelfServeCheckout(costCenterId: string, openSelfServeCheckoutRequest: OpenSelfServeCheckoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openCostCenterSelfServeCheckout(costCenterId, openSelfServeCheckoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.openCostCenterSelfServeCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename a cost center.  Caller must be an enterprise admin or the cost center\'s billing owner.
         * @summary Update Cost Center
         * @param {string} costCenterId 
         * @param {UpdateCostCenterRequest} updateCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCostCenter(costCenterId: string, updateCostCenterRequest: UpdateCostCenterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostCenterDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCostCenter(costCenterId, updateCostCenterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CostCentersApi.updateCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CostCentersApi - factory interface
 * @export
 */
export const CostCentersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CostCentersApiFp(configuration)
    return {
        /**
         * Commit a batch of self-serve seat changes as an enterprise admin.  A 200 response confirms the assignments were committed. If the outcome is unknown (503), retry the same request_id and changes to confirm the result.
         * @summary Change Cost Center Seats
         * @param {string} costCenterId 
         * @param {ChangeCostCenterSeatsRequest} changeCostCenterSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeCostCenterSeats(costCenterId: string, changeCostCenterSeatsRequest: ChangeCostCenterSeatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChangeCostCenterSeatsResponse> {
            return localVarFp.changeCostCenterSeats(costCenterId, changeCostCenterSeatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new cost center for an enterprise (break-away intent step).  The cost center is named after the caller\'s current team. The team is not moved into the new CC until the Stripe checkout webhook fires. The caller must be an enterprise admin.
         * @summary Create Cost Center
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCenter(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<CostCenterDetailResponse> {
            return localVarFp.createCostCenter(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe checkout session for a cost center in break-away intent state.  The new cost center inherits the parent enterprise\'s negotiated price — callers do not pick a plan. The team that will move is inferred from the caller\'s current active membership (no team_id in the request body).
         * @summary Create Cost Center Billing
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCostCenterBilling(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutUrlResponse> {
            return localVarFp.createCostCenterBilling(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a cost center.  Refuses if the cost center has an active Stripe subscription or teams still referencing it. The caller must be an enterprise admin.
         * @summary Delete Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCostCenter(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the pre-checkout summary for an in-flight break-away.  Called after ``create_cost_center`` and before ``create_cost_center_billing`` to surface team name, source cost center, member counts, and the per-seat price math so the admin can confirm before being redirected to Stripe.  Caller must be an enterprise admin of the owning enterprise or the new CC\'s ``billing_owner_user_id``.
         * @summary Get Break Away Preview
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBreakAwayPreview(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<BreakAwayPreview> {
            return localVarFp.getBreakAwayPreview(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single cost center by id.  The caller must be an admin of the enterprise that owns this cost center.
         * @summary Get Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<CostCenterDetailResponse> {
            return localVarFp.getCostCenter(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all cost centers for an enterprise.  The caller must be an enterprise admin. Each entry includes a computed ``team_count`` fetched via a single GROUP BY query.
         * @summary List Cost Centers
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCenters(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<CostCenterListResponse> {
            return localVarFp.listCostCenters(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Open a self-serve cost center\'s subscription through hosted Stripe Checkout as an enterprise admin.  Retrying with the same request_id and body returns the same session. A new request_id expires an unpaid open session and returns a new one; the old link stops working. Payment is confirmed from Stripe after the admin completes Checkout, not from the redirect.
         * @summary Open Cost Center Self Serve Checkout
         * @param {string} costCenterId 
         * @param {OpenSelfServeCheckoutRequest} openSelfServeCheckoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openCostCenterSelfServeCheckout(costCenterId: string, openSelfServeCheckoutRequest: OpenSelfServeCheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutUrlResponse> {
            return localVarFp.openCostCenterSelfServeCheckout(costCenterId, openSelfServeCheckoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename a cost center.  Caller must be an enterprise admin or the cost center\'s billing owner.
         * @summary Update Cost Center
         * @param {string} costCenterId 
         * @param {UpdateCostCenterRequest} updateCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCenter(costCenterId: string, updateCostCenterRequest: UpdateCostCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostCenterDetailResponse> {
            return localVarFp.updateCostCenter(costCenterId, updateCostCenterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CostCentersApi - object-oriented interface
 * @export
 * @class CostCentersApi
 * @extends {BaseAPI}
 */
export class CostCentersApi extends BaseAPI {
    /**
     * Commit a batch of self-serve seat changes as an enterprise admin.  A 200 response confirms the assignments were committed. If the outcome is unknown (503), retry the same request_id and changes to confirm the result.
     * @summary Change Cost Center Seats
     * @param {string} costCenterId 
     * @param {ChangeCostCenterSeatsRequest} changeCostCenterSeatsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public changeCostCenterSeats(costCenterId: string, changeCostCenterSeatsRequest: ChangeCostCenterSeatsRequest, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).changeCostCenterSeats(costCenterId, changeCostCenterSeatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new cost center for an enterprise (break-away intent step).  The cost center is named after the caller\'s current team. The team is not moved into the new CC until the Stripe checkout webhook fires. The caller must be an enterprise admin.
     * @summary Create Cost Center
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public createCostCenter(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).createCostCenter(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe checkout session for a cost center in break-away intent state.  The new cost center inherits the parent enterprise\'s negotiated price — callers do not pick a plan. The team that will move is inferred from the caller\'s current active membership (no team_id in the request body).
     * @summary Create Cost Center Billing
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public createCostCenterBilling(costCenterId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).createCostCenterBilling(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a cost center.  Refuses if the cost center has an active Stripe subscription or teams still referencing it. The caller must be an enterprise admin.
     * @summary Delete Cost Center
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public deleteCostCenter(costCenterId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).deleteCostCenter(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the pre-checkout summary for an in-flight break-away.  Called after ``create_cost_center`` and before ``create_cost_center_billing`` to surface team name, source cost center, member counts, and the per-seat price math so the admin can confirm before being redirected to Stripe.  Caller must be an enterprise admin of the owning enterprise or the new CC\'s ``billing_owner_user_id``.
     * @summary Get Break Away Preview
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public getBreakAwayPreview(costCenterId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).getBreakAwayPreview(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single cost center by id.  The caller must be an admin of the enterprise that owns this cost center.
     * @summary Get Cost Center
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public getCostCenter(costCenterId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).getCostCenter(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all cost centers for an enterprise.  The caller must be an enterprise admin. Each entry includes a computed ``team_count`` fetched via a single GROUP BY query.
     * @summary List Cost Centers
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public listCostCenters(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).listCostCenters(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Open a self-serve cost center\'s subscription through hosted Stripe Checkout as an enterprise admin.  Retrying with the same request_id and body returns the same session. A new request_id expires an unpaid open session and returns a new one; the old link stops working. Payment is confirmed from Stripe after the admin completes Checkout, not from the redirect.
     * @summary Open Cost Center Self Serve Checkout
     * @param {string} costCenterId 
     * @param {OpenSelfServeCheckoutRequest} openSelfServeCheckoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public openCostCenterSelfServeCheckout(costCenterId: string, openSelfServeCheckoutRequest: OpenSelfServeCheckoutRequest, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).openCostCenterSelfServeCheckout(costCenterId, openSelfServeCheckoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename a cost center.  Caller must be an enterprise admin or the cost center\'s billing owner.
     * @summary Update Cost Center
     * @param {string} costCenterId 
     * @param {UpdateCostCenterRequest} updateCostCenterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostCentersApi
     */
    public updateCostCenter(costCenterId: string, updateCostCenterRequest: UpdateCostCenterRequest, options?: RawAxiosRequestConfig) {
        return CostCentersApiFp(this.configuration).updateCostCenter(costCenterId, updateCostCenterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashApi - axios parameter creator
 * @export
 */
export const DashApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pre-auth bootstrap endpoint for the Chrome extension.  The extension does NOT have an org API key. It exchanges an install ID for a short-lived `client_key` (JWT) which can be used to connect to `/client_ws` or `/client_ws_v2`.  **Preferred (header-based):** pass the token via the ``Sec-WebSocket-Protocol`` header::      new WebSocket(url, [\"access_token\", clientKey])  **Legacy (query-param):** ``/client_ws?client_key=<JWT>`` is still supported for backward compatibility but is discouraged because tokens in URLs can appear in server access logs.
         * @summary Chrome Extension Client Key
         * @param {ChromeExtensionClientKeyRequest} chromeExtensionClientKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeExtensionClientKey: async (chromeExtensionClientKeyRequest: ChromeExtensionClientKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chromeExtensionClientKeyRequest' is not null or undefined
            assertParamExists('chromeExtensionClientKey', 'chromeExtensionClientKeyRequest', chromeExtensionClientKeyRequest)
            const localVarPath = `/api/v1/dash/chrome_extension/client_key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chromeExtensionClientKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transcribe a single audio payload using client-token (JWT) authentication.  Functionally identical to ``/api`` but authenticates with client tokens instead of an org API key.
         * @summary Client Api
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientApi: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('clientApi', 'body', body)
            const localVarPath = `/api/v1/dash/client_api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transcribe a single audio payload using API-key authentication.
         * @summary Dash Api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dash/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a short-lived token scoped to the organization authenticated by the API key.
         * @summary Generate Access Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken: async (tokenRequest: TokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequest' is not null or undefined
            assertParamExists('generateAccessToken', 'tokenRequest', tokenRequest)
            const localVarPath = `/api/v1/dash/generate_access_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue a short-lived anonymous access token for the Webflow marketing-site demo.
         * @summary Generate Webflow Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebflowToken: async (tokenRequest: TokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequest' is not null or undefined
            assertParamExists('generateWebflowToken', 'tokenRequest', tokenRequest)
            const localVarPath = `/api/v1/dash/webflow_demo/generate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a previously issued client access token, authenticated by API key.
         * @summary Revoke User Token
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeUserToken: async (revokeTokenRequest: RevokeTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokeTokenRequest' is not null or undefined
            assertParamExists('revokeUserToken', 'revokeTokenRequest', revokeTokenRequest)
            const localVarPath = `/api/v1/dash/revoke_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Warm up the Dash service (returns a fixed ready status).
         * @summary Warmup Dash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmupDash: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dash/warmup_dash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashApi - functional programming interface
 * @export
 */
export const DashApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashApiAxiosParamCreator(configuration)
    return {
        /**
         * Pre-auth bootstrap endpoint for the Chrome extension.  The extension does NOT have an org API key. It exchanges an install ID for a short-lived `client_key` (JWT) which can be used to connect to `/client_ws` or `/client_ws_v2`.  **Preferred (header-based):** pass the token via the ``Sec-WebSocket-Protocol`` header::      new WebSocket(url, [\"access_token\", clientKey])  **Legacy (query-param):** ``/client_ws?client_key=<JWT>`` is still supported for backward compatibility but is discouraged because tokens in URLs can appear in server access logs.
         * @summary Chrome Extension Client Key
         * @param {ChromeExtensionClientKeyRequest} chromeExtensionClientKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chromeExtensionClientKey(chromeExtensionClientKeyRequest: ChromeExtensionClientKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChromeExtensionClientKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chromeExtensionClientKey(chromeExtensionClientKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.chromeExtensionClientKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transcribe a single audio payload using client-token (JWT) authentication.  Functionally identical to ``/api`` but authenticates with client tokens instead of an org API key.
         * @summary Client Api
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientApi(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientApi(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.clientApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transcribe a single audio payload using API-key authentication.
         * @summary Dash Api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.dashApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue a short-lived token scoped to the organization authenticated by the API key.
         * @summary Generate Access Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAccessToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAccessToken(tokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.generateAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue a short-lived anonymous access token for the Webflow marketing-site demo.
         * @summary Generate Webflow Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWebflowToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWebflowToken(tokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.generateWebflowToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a previously issued client access token, authenticated by API key.
         * @summary Revoke User Token
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeUserToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeUserToken(revokeTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.revokeUserToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Warm up the Dash service (returns a fixed ready status).
         * @summary Warmup Dash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async warmupDash(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.warmupDash(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashApi.warmupDash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashApi - factory interface
 * @export
 */
export const DashApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashApiFp(configuration)
    return {
        /**
         * Pre-auth bootstrap endpoint for the Chrome extension.  The extension does NOT have an org API key. It exchanges an install ID for a short-lived `client_key` (JWT) which can be used to connect to `/client_ws` or `/client_ws_v2`.  **Preferred (header-based):** pass the token via the ``Sec-WebSocket-Protocol`` header::      new WebSocket(url, [\"access_token\", clientKey])  **Legacy (query-param):** ``/client_ws?client_key=<JWT>`` is still supported for backward compatibility but is discouraged because tokens in URLs can appear in server access logs.
         * @summary Chrome Extension Client Key
         * @param {ChromeExtensionClientKeyRequest} chromeExtensionClientKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chromeExtensionClientKey(chromeExtensionClientKeyRequest: ChromeExtensionClientKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChromeExtensionClientKeyResponse> {
            return localVarFp.chromeExtensionClientKey(chromeExtensionClientKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Transcribe a single audio payload using client-token (JWT) authentication.  Functionally identical to ``/api`` but authenticates with client tokens instead of an org API key.
         * @summary Client Api
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientApi(body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.clientApi(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Transcribe a single audio payload using API-key authentication.
         * @summary Dash Api
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashApi(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.dashApi(options).then((request) => request(axios, basePath));
        },
        /**
         * Issue a short-lived token scoped to the organization authenticated by the API key.
         * @summary Generate Access Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.generateAccessToken(tokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue a short-lived anonymous access token for the Webflow marketing-site demo.
         * @summary Generate Webflow Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWebflowToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenResponse> {
            return localVarFp.generateWebflowToken(tokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a previously issued client access token, authenticated by API key.
         * @summary Revoke User Token
         * @param {RevokeTokenRequest} revokeTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeUserToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revokeUserToken(revokeTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Warm up the Dash service (returns a fixed ready status).
         * @summary Warmup Dash
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warmupDash(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.warmupDash(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashApi - object-oriented interface
 * @export
 * @class DashApi
 * @extends {BaseAPI}
 */
export class DashApi extends BaseAPI {
    /**
     * Pre-auth bootstrap endpoint for the Chrome extension.  The extension does NOT have an org API key. It exchanges an install ID for a short-lived `client_key` (JWT) which can be used to connect to `/client_ws` or `/client_ws_v2`.  **Preferred (header-based):** pass the token via the ``Sec-WebSocket-Protocol`` header::      new WebSocket(url, [\"access_token\", clientKey])  **Legacy (query-param):** ``/client_ws?client_key=<JWT>`` is still supported for backward compatibility but is discouraged because tokens in URLs can appear in server access logs.
     * @summary Chrome Extension Client Key
     * @param {ChromeExtensionClientKeyRequest} chromeExtensionClientKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public chromeExtensionClientKey(chromeExtensionClientKeyRequest: ChromeExtensionClientKeyRequest, options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).chromeExtensionClientKey(chromeExtensionClientKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transcribe a single audio payload using client-token (JWT) authentication.  Functionally identical to ``/api`` but authenticates with client tokens instead of an org API key.
     * @summary Client Api
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public clientApi(body: any, options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).clientApi(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transcribe a single audio payload using API-key authentication.
     * @summary Dash Api
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public dashApi(options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).dashApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue a short-lived token scoped to the organization authenticated by the API key.
     * @summary Generate Access Token
     * @param {TokenRequest} tokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public generateAccessToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).generateAccessToken(tokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue a short-lived anonymous access token for the Webflow marketing-site demo.
     * @summary Generate Webflow Token
     * @param {TokenRequest} tokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public generateWebflowToken(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).generateWebflowToken(tokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a previously issued client access token, authenticated by API key.
     * @summary Revoke User Token
     * @param {RevokeTokenRequest} revokeTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public revokeUserToken(revokeTokenRequest: RevokeTokenRequest, options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).revokeUserToken(revokeTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Warm up the Dash service (returns a fixed ready status).
     * @summary Warmup Dash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashApi
     */
    public warmupDash(options?: RawAxiosRequestConfig) {
        return DashApiFp(this.configuration).warmupDash(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataExportApi - axios parameter creator
 * @export
 */
export const DataExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel the authenticated member\'s in-flight export request.  A no-op when nothing is in flight: the current terminal status is returned unchanged. Available while self-serve intake is switched off, so a member can always stop a request they did not make.  Args:     request:            The incoming request; impersonation state is read from it.     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     service:            Data-export service.  Returns:     The status after the cancel.
         * @summary Cancel Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDataExport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/data-export/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stream the authenticated member\'s finished export artifact.  Authenticated bytes rather than a presigned URL, and the gate is re-run here rather than trusted from request time: a presigned link outlives sign-out, session revocation and an org turning export off, and it is a link the member is meant to move around.  **No session-freshness check, deliberately.** The artifact is the member\'s to fetch for the whole retention window, and the email that announces it may be read days later — a freshness bound here would strand the member on the one step that has no in-app remedy. Revocation is what this route relies on instead: sign-out, an org flip and an erasure all stop it within a request. Reconsider once a re-auth flow exists on the client (`DATA_EXPORT_MAX_SESSION_AGE_HOURS`).  Args:     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     db:                 Database executor.  Returns:     The artifact, streamed, as an attachment.  Raises:     HTTPException: Nothing to hand over (404), past retention (410), the org withdrew         permission (403), or an erasure is in flight (409).
         * @summary Download Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDataExport: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/data-export/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Status of the authenticated member\'s latest export request.  ``not_found`` when the member has never requested one. Readable while self-serve intake is switched off.  Args:     response:      The outgoing response; marked uncacheable.     _ip_limiter:   Per-IP rate limit, resolved before authentication.     user:          The authenticated, fully provisioned member.     _user_limiter: Per-user rate limit, resolved after authentication.     service:       Data-export service.  Returns:     The redacted status of the latest request.
         * @summary Get Data Export Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExportStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/data-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request an export of the authenticated member\'s own data.  Accepted requests are fulfilled asynchronously; poll ``GET`` or wait for the readiness notification. Refused with 403 when the member\'s organization does not allow self-serve export, 409 while an export is already in flight, and 429 inside the cooldown after a completed export. No body, or no ``categories``, is the full export.  Args:     request:           The incoming request; impersonation state is read from it.     _ip_limiter:       Per-IP rate limit, resolved before authentication.     user:              The authenticated, fully provisioned member.     _user_limiter:     Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     _fresh_session:    Refuses sessions that authenticated too long ago.     service:           Data-export service.     data:              Optional body naming the categories to export.  Returns:     The in-flight status of the accepted request.  Raises:     HTTPForbidden: The member\'s organization denies self-serve export.     HTTPConflict: An export is already in flight for this member.     HTTPException: 429: A completed export is too recent; ``Retry-After`` says when to retry.     HTTPBadGateway: The export could not be started; retry.     HTTPServiceUnavailable: Self-serve export, or the scoped export for this member, is switched off.
         * @summary Request Data Export
         * @param {DataExportStartRequest} [dataExportStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDataExport: async (dataExportStartRequest?: DataExportStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/data-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataExportApi - functional programming interface
 * @export
 */
export const DataExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataExportApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel the authenticated member\'s in-flight export request.  A no-op when nothing is in flight: the current terminal status is returned unchanged. Available while self-serve intake is switched off, so a member can always stop a request they did not make.  Args:     request:            The incoming request; impersonation state is read from it.     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     service:            Data-export service.  Returns:     The status after the cancel.
         * @summary Cancel Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDataExport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDataExport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.cancelDataExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stream the authenticated member\'s finished export artifact.  Authenticated bytes rather than a presigned URL, and the gate is re-run here rather than trusted from request time: a presigned link outlives sign-out, session revocation and an org turning export off, and it is a link the member is meant to move around.  **No session-freshness check, deliberately.** The artifact is the member\'s to fetch for the whole retention window, and the email that announces it may be read days later — a freshness bound here would strand the member on the one step that has no in-app remedy. Revocation is what this route relies on instead: sign-out, an org flip and an erasure all stop it within a request. Reconsider once a re-auth flow exists on the client (`DATA_EXPORT_MAX_SESSION_AGE_HOURS`).  Args:     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     db:                 Database executor.  Returns:     The artifact, streamed, as an attachment.  Raises:     HTTPException: Nothing to hand over (404), past retention (410), the org withdrew         permission (403), or an erasure is in flight (409).
         * @summary Download Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDataExport(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDataExport(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.downloadDataExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Status of the authenticated member\'s latest export request.  ``not_found`` when the member has never requested one. Readable while self-serve intake is switched off.  Args:     response:      The outgoing response; marked uncacheable.     _ip_limiter:   Per-IP rate limit, resolved before authentication.     user:          The authenticated, fully provisioned member.     _user_limiter: Per-user rate limit, resolved after authentication.     service:       Data-export service.  Returns:     The redacted status of the latest request.
         * @summary Get Data Export Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDataExportStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDataExportStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.getDataExportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request an export of the authenticated member\'s own data.  Accepted requests are fulfilled asynchronously; poll ``GET`` or wait for the readiness notification. Refused with 403 when the member\'s organization does not allow self-serve export, 409 while an export is already in flight, and 429 inside the cooldown after a completed export. No body, or no ``categories``, is the full export.  Args:     request:           The incoming request; impersonation state is read from it.     _ip_limiter:       Per-IP rate limit, resolved before authentication.     user:              The authenticated, fully provisioned member.     _user_limiter:     Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     _fresh_session:    Refuses sessions that authenticated too long ago.     service:           Data-export service.     data:              Optional body naming the categories to export.  Returns:     The in-flight status of the accepted request.  Raises:     HTTPForbidden: The member\'s organization denies self-serve export.     HTTPConflict: An export is already in flight for this member.     HTTPException: 429: A completed export is too recent; ``Retry-After`` says when to retry.     HTTPBadGateway: The export could not be started; retry.     HTTPServiceUnavailable: Self-serve export, or the scoped export for this member, is switched off.
         * @summary Request Data Export
         * @param {DataExportStartRequest} [dataExportStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDataExport(dataExportStartRequest?: DataExportStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDataExport(dataExportStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.requestDataExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataExportApi - factory interface
 * @export
 */
export const DataExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataExportApiFp(configuration)
    return {
        /**
         * Cancel the authenticated member\'s in-flight export request.  A no-op when nothing is in flight: the current terminal status is returned unchanged. Available while self-serve intake is switched off, so a member can always stop a request they did not make.  Args:     request:            The incoming request; impersonation state is read from it.     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     service:            Data-export service.  Returns:     The status after the cancel.
         * @summary Cancel Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDataExport(options?: RawAxiosRequestConfig): AxiosPromise<DataExportStatusResponse> {
            return localVarFp.cancelDataExport(options).then((request) => request(axios, basePath));
        },
        /**
         * Stream the authenticated member\'s finished export artifact.  Authenticated bytes rather than a presigned URL, and the gate is re-run here rather than trusted from request time: a presigned link outlives sign-out, session revocation and an org turning export off, and it is a link the member is meant to move around.  **No session-freshness check, deliberately.** The artifact is the member\'s to fetch for the whole retention window, and the email that announces it may be read days later — a freshness bound here would strand the member on the one step that has no in-app remedy. Revocation is what this route relies on instead: sign-out, an org flip and an erasure all stop it within a request. Reconsider once a re-auth flow exists on the client (`DATA_EXPORT_MAX_SESSION_AGE_HOURS`).  Args:     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     db:                 Database executor.  Returns:     The artifact, streamed, as an attachment.  Raises:     HTTPException: Nothing to hand over (404), past retention (410), the org withdrew         permission (403), or an erasure is in flight (409).
         * @summary Download Data Export
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDataExport(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.downloadDataExport(options).then((request) => request(axios, basePath));
        },
        /**
         * Status of the authenticated member\'s latest export request.  ``not_found`` when the member has never requested one. Readable while self-serve intake is switched off.  Args:     response:      The outgoing response; marked uncacheable.     _ip_limiter:   Per-IP rate limit, resolved before authentication.     user:          The authenticated, fully provisioned member.     _user_limiter: Per-user rate limit, resolved after authentication.     service:       Data-export service.  Returns:     The redacted status of the latest request.
         * @summary Get Data Export Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataExportStatus(options?: RawAxiosRequestConfig): AxiosPromise<DataExportStatusResponse> {
            return localVarFp.getDataExportStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Request an export of the authenticated member\'s own data.  Accepted requests are fulfilled asynchronously; poll ``GET`` or wait for the readiness notification. Refused with 403 when the member\'s organization does not allow self-serve export, 409 while an export is already in flight, and 429 inside the cooldown after a completed export. No body, or no ``categories``, is the full export.  Args:     request:           The incoming request; impersonation state is read from it.     _ip_limiter:       Per-IP rate limit, resolved before authentication.     user:              The authenticated, fully provisioned member.     _user_limiter:     Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     _fresh_session:    Refuses sessions that authenticated too long ago.     service:           Data-export service.     data:              Optional body naming the categories to export.  Returns:     The in-flight status of the accepted request.  Raises:     HTTPForbidden: The member\'s organization denies self-serve export.     HTTPConflict: An export is already in flight for this member.     HTTPException: 429: A completed export is too recent; ``Retry-After`` says when to retry.     HTTPBadGateway: The export could not be started; retry.     HTTPServiceUnavailable: Self-serve export, or the scoped export for this member, is switched off.
         * @summary Request Data Export
         * @param {DataExportStartRequest} [dataExportStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDataExport(dataExportStartRequest?: DataExportStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataExportStatusResponse> {
            return localVarFp.requestDataExport(dataExportStartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataExportApi - object-oriented interface
 * @export
 * @class DataExportApi
 * @extends {BaseAPI}
 */
export class DataExportApi extends BaseAPI {
    /**
     * Cancel the authenticated member\'s in-flight export request.  A no-op when nothing is in flight: the current terminal status is returned unchanged. Available while self-serve intake is switched off, so a member can always stop a request they did not make.  Args:     request:            The incoming request; impersonation state is read from it.     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     service:            Data-export service.  Returns:     The status after the cancel.
     * @summary Cancel Data Export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public cancelDataExport(options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).cancelDataExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stream the authenticated member\'s finished export artifact.  Authenticated bytes rather than a presigned URL, and the gate is re-run here rather than trusted from request time: a presigned link outlives sign-out, session revocation and an org turning export off, and it is a link the member is meant to move around.  **No session-freshness check, deliberately.** The artifact is the member\'s to fetch for the whole retention window, and the email that announces it may be read days later — a freshness bound here would strand the member on the one step that has no in-app remedy. Revocation is what this route relies on instead: sign-out, an org flip and an erasure all stop it within a request. Reconsider once a re-auth flow exists on the client (`DATA_EXPORT_MAX_SESSION_AGE_HOURS`).  Args:     _ip_limiter:        Per-IP rate limit, resolved before authentication.     user:               The authenticated, fully provisioned member.     _user_limiter:      Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     db:                 Database executor.  Returns:     The artifact, streamed, as an attachment.  Raises:     HTTPException: Nothing to hand over (404), past retention (410), the org withdrew         permission (403), or an erasure is in flight (409).
     * @summary Download Data Export
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public downloadDataExport(options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).downloadDataExport(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Status of the authenticated member\'s latest export request.  ``not_found`` when the member has never requested one. Readable while self-serve intake is switched off.  Args:     response:      The outgoing response; marked uncacheable.     _ip_limiter:   Per-IP rate limit, resolved before authentication.     user:          The authenticated, fully provisioned member.     _user_limiter: Per-user rate limit, resolved after authentication.     service:       Data-export service.  Returns:     The redacted status of the latest request.
     * @summary Get Data Export Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public getDataExportStatus(options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).getDataExportStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request an export of the authenticated member\'s own data.  Accepted requests are fulfilled asynchronously; poll ``GET`` or wait for the readiness notification. Refused with 403 when the member\'s organization does not allow self-serve export, 409 while an export is already in flight, and 429 inside the cooldown after a completed export. No body, or no ``categories``, is the full export.  Args:     request:           The incoming request; impersonation state is read from it.     _ip_limiter:       Per-IP rate limit, resolved before authentication.     user:              The authenticated, fully provisioned member.     _user_limiter:     Per-user rate limit, resolved after authentication.     _not_impersonating: Refuses admin impersonation sessions.     _fresh_session:    Refuses sessions that authenticated too long ago.     service:           Data-export service.     data:              Optional body naming the categories to export.  Returns:     The in-flight status of the accepted request.  Raises:     HTTPForbidden: The member\'s organization denies self-serve export.     HTTPConflict: An export is already in flight for this member.     HTTPException: 429: A completed export is too recent; ``Retry-After`` says when to retry.     HTTPBadGateway: The export could not be started; retry.     HTTPServiceUnavailable: Self-serve export, or the scoped export for this member, is switched off.
     * @summary Request Data Export
     * @param {DataExportStartRequest} [dataExportStartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public requestDataExport(dataExportStartRequest?: DataExportStartRequest, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).requestDataExport(dataExportStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readRootGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readRootGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.readRootGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.readRootGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Read Root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readRootGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readRootGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DictionaryApi - axios parameter creator
 * @export
 */
export const DictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Promote a pending shared entry to approved, in place.  Scoped to the caller\'s enterprise and reaches every department in it, so an admin can decide on an entry submitted by a team they are not a member of.
         * @summary Approve Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveSharedEntry: async (wordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('approveSharedEntry', 'wordId', wordId)
            const localVarPath = `/api/v1/dictionary/admin/shared/{word_id}/approve`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk create team dictionary items with upsert semantics.
         * @summary Bulk Create Team Dictionary Items
         * @param {Array<CreateTeamDictionaryItem>} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateTeamDictionaryItems: async (createTeamDictionaryItem: Array<CreateTeamDictionaryItem>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTeamDictionaryItem' is not null or undefined
            assertParamExists('bulkCreateTeamDictionaryItems', 'createTeamDictionaryItem', createTeamDictionaryItem)
            const localVarPath = `/api/v1/dictionary/team/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamDictionaryItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a team dictionary item.
         * @summary Create Team Dictionary Item
         * @param {CreateTeamDictionaryItem} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamDictionaryItem: async (createTeamDictionaryItem: CreateTeamDictionaryItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTeamDictionaryItem' is not null or undefined
            assertParamExists('createTeamDictionaryItem', 'createTeamDictionaryItem', createTeamDictionaryItem)
            const localVarPath = `/api/v1/dictionary/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamDictionaryItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team dictionary item.
         * @summary Delete Team Dictionary Item
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamDictionaryItem: async (wordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('deleteTeamDictionaryItem', 'wordId', wordId)
            const localVarPath = `/api/v1/dictionary/team/{word_id}`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enterprise-wide shared library for the admin portal: admin-only, scope from the caller\'s token.  Spans every department and omits soft-deleted rows, unlike the caller-scoped ``GET /shared``.
         * @summary Get Admin Shared Dictionary
         * @param {boolean | null} [isSnippet] Snippets when true, words when false, both when omitted.
         * @param {string | null} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetAdminSharedDictionaryStatusEnum} [status] Approval state to match exactly; every state when omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSharedDictionary: async (isSnippet?: boolean | null, search?: string | null, limit?: number, offset?: number, status?: GetAdminSharedDictionaryStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionary/admin/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isSnippet !== undefined) {
                localVarQueryParameter['is_snippet'] = isSnippet;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user\'s personal dictionary.
         * @summary Get Personal Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalDictionary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionary/personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the caller\'s effective shared dictionary (enterprise-wide entries plus their team).
         * @summary Get Shared Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedDictionary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionary/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user\'s team\'s dictionary.
         * @summary Get Team Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDictionary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dictionary/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject a pending shared entry, deleting it so the same word can be submitted again.  Only entries awaiting a decision can be rejected; an already-approved entry is removed through the ordinary delete, which leaves the tombstone clients need to converge.
         * @summary Reject Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectSharedEntry: async (wordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('rejectSharedEntry', 'wordId', wordId)
            const localVarPath = `/api/v1/dictionary/admin/shared/{word_id}/reject`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a word to a user\'s personal dictionary.
         * @summary Update Personal Dictionary
         * @param {Array<DictionaryItem>} dictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalDictionary: async (dictionaryItem: Array<DictionaryItem>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryItem' is not null or undefined
            assertParamExists('updatePersonalDictionary', 'dictionaryItem', dictionaryItem)
            const localVarPath = `/api/v1/dictionary/personal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a team dictionary item.
         * @summary Update Team Dictionary Item
         * @param {UpdateTeamDictionaryItem} updateTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamDictionaryItem: async (updateTeamDictionaryItem: UpdateTeamDictionaryItem, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateTeamDictionaryItem' is not null or undefined
            assertParamExists('updateTeamDictionaryItem', 'updateTeamDictionaryItem', updateTeamDictionaryItem)
            const localVarPath = `/api/v1/dictionary/team/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamDictionaryItem, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionaryApi - functional programming interface
 * @export
 */
export const DictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * Promote a pending shared entry to approved, in place.  Scoped to the caller\'s enterprise and reaches every department in it, so an admin can decide on an entry submitted by a team they are not a member of.
         * @summary Approve Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveSharedEntry(wordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedEntryDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveSharedEntry(wordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.approveSharedEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk create team dictionary items with upsert semantics.
         * @summary Bulk Create Team Dictionary Items
         * @param {Array<CreateTeamDictionaryItem>} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateTeamDictionaryItems(createTeamDictionaryItem: Array<CreateTeamDictionaryItem>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkCreateTeamDictionaryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateTeamDictionaryItems(createTeamDictionaryItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.bulkCreateTeamDictionaryItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a team dictionary item.
         * @summary Create Team Dictionary Item
         * @param {CreateTeamDictionaryItem} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamDictionaryItem(createTeamDictionaryItem: CreateTeamDictionaryItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTeamDictionaryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamDictionaryItem(createTeamDictionaryItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.createTeamDictionaryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a team dictionary item.
         * @summary Delete Team Dictionary Item
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamDictionaryItem(wordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamDictionaryItem(wordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.deleteTeamDictionaryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enterprise-wide shared library for the admin portal: admin-only, scope from the caller\'s token.  Spans every department and omits soft-deleted rows, unlike the caller-scoped ``GET /shared``.
         * @summary Get Admin Shared Dictionary
         * @param {boolean | null} [isSnippet] Snippets when true, words when false, both when omitted.
         * @param {string | null} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetAdminSharedDictionaryStatusEnum} [status] Approval state to match exactly; every state when omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSharedDictionary(isSnippet?: boolean | null, search?: string | null, limit?: number, offset?: number, status?: GetAdminSharedDictionaryStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSharedDictionaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSharedDictionary(isSnippet, search, limit, offset, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.getAdminSharedDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a user\'s personal dictionary.
         * @summary Get Personal Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonalDictionary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonalDictionary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.getPersonalDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the caller\'s effective shared dictionary (enterprise-wide entries plus their team).
         * @summary Get Shared Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedDictionary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SharedDictionaryItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedDictionary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.getSharedDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a user\'s team\'s dictionary.
         * @summary Get Team Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamDictionary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamDictionary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.getTeamDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject a pending shared entry, deleting it so the same word can be submitted again.  Only entries awaiting a decision can be rejected; an already-approved entry is removed through the ordinary delete, which leaves the tombstone clients need to converge.
         * @summary Reject Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectSharedEntry(wordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedEntryDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectSharedEntry(wordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.rejectSharedEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a word to a user\'s personal dictionary.
         * @summary Update Personal Dictionary
         * @param {Array<DictionaryItem>} dictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonalDictionary(dictionaryItem: Array<DictionaryItem>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonalDictionary(dictionaryItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.updatePersonalDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a team dictionary item.
         * @summary Update Team Dictionary Item
         * @param {UpdateTeamDictionaryItem} updateTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamDictionaryItem(updateTeamDictionaryItem: UpdateTeamDictionaryItem, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamDictionaryItem(updateTeamDictionaryItem, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.updateTeamDictionaryItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionaryApi - factory interface
 * @export
 */
export const DictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionaryApiFp(configuration)
    return {
        /**
         * Promote a pending shared entry to approved, in place.  Scoped to the caller\'s enterprise and reaches every department in it, so an admin can decide on an entry submitted by a team they are not a member of.
         * @summary Approve Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveSharedEntry(wordId: string, options?: RawAxiosRequestConfig): AxiosPromise<SharedEntryDecisionResponse> {
            return localVarFp.approveSharedEntry(wordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk create team dictionary items with upsert semantics.
         * @summary Bulk Create Team Dictionary Items
         * @param {Array<CreateTeamDictionaryItem>} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateTeamDictionaryItems(createTeamDictionaryItem: Array<CreateTeamDictionaryItem>, options?: RawAxiosRequestConfig): AxiosPromise<BulkCreateTeamDictionaryResult> {
            return localVarFp.bulkCreateTeamDictionaryItems(createTeamDictionaryItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a team dictionary item.
         * @summary Create Team Dictionary Item
         * @param {CreateTeamDictionaryItem} createTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamDictionaryItem(createTeamDictionaryItem: CreateTeamDictionaryItem, options?: RawAxiosRequestConfig): AxiosPromise<CreateTeamDictionaryResult> {
            return localVarFp.createTeamDictionaryItem(createTeamDictionaryItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team dictionary item.
         * @summary Delete Team Dictionary Item
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamDictionaryItem(wordId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteTeamDictionaryItem(wordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enterprise-wide shared library for the admin portal: admin-only, scope from the caller\'s token.  Spans every department and omits soft-deleted rows, unlike the caller-scoped ``GET /shared``.
         * @summary Get Admin Shared Dictionary
         * @param {boolean | null} [isSnippet] Snippets when true, words when false, both when omitted.
         * @param {string | null} [search] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetAdminSharedDictionaryStatusEnum} [status] Approval state to match exactly; every state when omitted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSharedDictionary(isSnippet?: boolean | null, search?: string | null, limit?: number, offset?: number, status?: GetAdminSharedDictionaryStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<AdminSharedDictionaryResponse> {
            return localVarFp.getAdminSharedDictionary(isSnippet, search, limit, offset, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user\'s personal dictionary.
         * @summary Get Personal Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalDictionary(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getPersonalDictionary(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the caller\'s effective shared dictionary (enterprise-wide entries plus their team).
         * @summary Get Shared Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedDictionary(options?: RawAxiosRequestConfig): AxiosPromise<Array<SharedDictionaryItem>> {
            return localVarFp.getSharedDictionary(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user\'s team\'s dictionary.
         * @summary Get Team Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDictionary(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTeamDictionary(options).then((request) => request(axios, basePath));
        },
        /**
         * Reject a pending shared entry, deleting it so the same word can be submitted again.  Only entries awaiting a decision can be rejected; an already-approved entry is removed through the ordinary delete, which leaves the tombstone clients need to converge.
         * @summary Reject Shared Entry
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectSharedEntry(wordId: string, options?: RawAxiosRequestConfig): AxiosPromise<SharedEntryDecisionResponse> {
            return localVarFp.rejectSharedEntry(wordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a word to a user\'s personal dictionary.
         * @summary Update Personal Dictionary
         * @param {Array<DictionaryItem>} dictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonalDictionary(dictionaryItem: Array<DictionaryItem>, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updatePersonalDictionary(dictionaryItem, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a team dictionary item.
         * @summary Update Team Dictionary Item
         * @param {UpdateTeamDictionaryItem} updateTeamDictionaryItem 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamDictionaryItem(updateTeamDictionaryItem: UpdateTeamDictionaryItem, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateTeamDictionaryItem(updateTeamDictionaryItem, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionaryApi - object-oriented interface
 * @export
 * @class DictionaryApi
 * @extends {BaseAPI}
 */
export class DictionaryApi extends BaseAPI {
    /**
     * Promote a pending shared entry to approved, in place.  Scoped to the caller\'s enterprise and reaches every department in it, so an admin can decide on an entry submitted by a team they are not a member of.
     * @summary Approve Shared Entry
     * @param {string} wordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public approveSharedEntry(wordId: string, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).approveSharedEntry(wordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk create team dictionary items with upsert semantics.
     * @summary Bulk Create Team Dictionary Items
     * @param {Array<CreateTeamDictionaryItem>} createTeamDictionaryItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public bulkCreateTeamDictionaryItems(createTeamDictionaryItem: Array<CreateTeamDictionaryItem>, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).bulkCreateTeamDictionaryItems(createTeamDictionaryItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a team dictionary item.
     * @summary Create Team Dictionary Item
     * @param {CreateTeamDictionaryItem} createTeamDictionaryItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public createTeamDictionaryItem(createTeamDictionaryItem: CreateTeamDictionaryItem, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).createTeamDictionaryItem(createTeamDictionaryItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team dictionary item.
     * @summary Delete Team Dictionary Item
     * @param {string} wordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public deleteTeamDictionaryItem(wordId: string, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).deleteTeamDictionaryItem(wordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enterprise-wide shared library for the admin portal: admin-only, scope from the caller\'s token.  Spans every department and omits soft-deleted rows, unlike the caller-scoped ``GET /shared``.
     * @summary Get Admin Shared Dictionary
     * @param {boolean | null} [isSnippet] Snippets when true, words when false, both when omitted.
     * @param {string | null} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {GetAdminSharedDictionaryStatusEnum} [status] Approval state to match exactly; every state when omitted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public getAdminSharedDictionary(isSnippet?: boolean | null, search?: string | null, limit?: number, offset?: number, status?: GetAdminSharedDictionaryStatusEnum, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).getAdminSharedDictionary(isSnippet, search, limit, offset, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user\'s personal dictionary.
     * @summary Get Personal Dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public getPersonalDictionary(options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).getPersonalDictionary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the caller\'s effective shared dictionary (enterprise-wide entries plus their team).
     * @summary Get Shared Dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public getSharedDictionary(options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).getSharedDictionary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user\'s team\'s dictionary.
     * @summary Get Team Dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public getTeamDictionary(options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).getTeamDictionary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject a pending shared entry, deleting it so the same word can be submitted again.  Only entries awaiting a decision can be rejected; an already-approved entry is removed through the ordinary delete, which leaves the tombstone clients need to converge.
     * @summary Reject Shared Entry
     * @param {string} wordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public rejectSharedEntry(wordId: string, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).rejectSharedEntry(wordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a word to a user\'s personal dictionary.
     * @summary Update Personal Dictionary
     * @param {Array<DictionaryItem>} dictionaryItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public updatePersonalDictionary(dictionaryItem: Array<DictionaryItem>, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).updatePersonalDictionary(dictionaryItem, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a team dictionary item.
     * @summary Update Team Dictionary Item
     * @param {UpdateTeamDictionaryItem} updateTeamDictionaryItem 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApi
     */
    public updateTeamDictionaryItem(updateTeamDictionaryItem: UpdateTeamDictionaryItem, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).updateTeamDictionaryItem(updateTeamDictionaryItem, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminSharedDictionaryStatusEnum = {
    Pending: 'pending',
    Approved: 'approved'
} as const;
export type GetAdminSharedDictionaryStatusEnum = typeof GetAdminSharedDictionaryStatusEnum[keyof typeof GetAdminSharedDictionaryStatusEnum];


/**
 * EnterpriseApi - axios parameter creator
 * @export
 */
export const EnterpriseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept an enterprise invitation by invite ID.
         * @summary Accept Enterprise Invite
         * @param {AcceptEnterpriseInviteRequest} acceptEnterpriseInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEnterpriseInvite: async (acceptEnterpriseInviteRequest: AcceptEnterpriseInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptEnterpriseInviteRequest' is not null or undefined
            assertParamExists('acceptEnterpriseInvite', 'acceptEnterpriseInviteRequest', acceptEnterpriseInviteRequest)
            const localVarPath = `/api/v1/enterprise/invitations/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptEnterpriseInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept a join request and add the user to the enterprise.
         * @summary Accept Join Request
         * @param {AcceptJoinRequestRequest} acceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptJoinRequest: async (acceptJoinRequestRequest: AcceptJoinRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptJoinRequestRequest' is not null or undefined
            assertParamExists('acceptJoinRequest', 'acceptJoinRequestRequest', acceptJoinRequestRequest)
            const localVarPath = `/api/v1/enterprise/join-requests/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptJoinRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept a team invite link and join the enterprise.
         * @summary Accept Team Invite Link
         * @param {AcceptTeamInviteLinkRequest} acceptTeamInviteLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInviteLink: async (acceptTeamInviteLinkRequest: AcceptTeamInviteLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptTeamInviteLinkRequest' is not null or undefined
            assertParamExists('acceptTeamInviteLink', 'acceptTeamInviteLinkRequest', acceptTeamInviteLinkRequest)
            const localVarPath = `/api/v1/enterprise/invite-link/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptTeamInviteLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept multiple join requests for an enterprise with optimized bulk processing.
         * @summary Bulk Accept Join Request
         * @param {BulkAcceptJoinRequestRequest} bulkAcceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAcceptJoinRequest: async (bulkAcceptJoinRequestRequest: BulkAcceptJoinRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkAcceptJoinRequestRequest' is not null or undefined
            assertParamExists('bulkAcceptJoinRequest', 'bulkAcceptJoinRequestRequest', bulkAcceptJoinRequestRequest)
            const localVarPath = `/api/v1/enterprise/join-requests/bulk-accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAcceptJoinRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by admins.
         * @summary Bulk Invite Users
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsers: async (bulkInviteRequest: BulkInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkInviteRequest' is not null or undefined
            assertParamExists('bulkInviteUsers', 'bulkInviteRequest', bulkInviteRequest)
            const localVarPath = `/api/v1/enterprise/invitations/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by support team.
         * @summary Bulk Invite Users Support
         * @param {string} enterpriseId 
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsersSupport: async (enterpriseId: string, bulkInviteRequest: BulkInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('bulkInviteUsersSupport', 'enterpriseId', enterpriseId)
            // verify required parameter 'bulkInviteRequest' is not null or undefined
            assertParamExists('bulkInviteUsersSupport', 'bulkInviteRequest', bulkInviteRequest)
            const localVarPath = `/api/v1/enterprise/invitations/bulk/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match. Admin-only.
         * @summary Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDomainVerification: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('checkDomainVerification', 'domainId', domainId)
            const localVarPath = `/api/v1/enterprise/domains/{domain_id}/check-verification`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the eligibility status of the user for an enterprise.
         * @summary Check Enterprise Eligibility
         * @param {CheckEnterpriseEligibilityRequest} checkEnterpriseEligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEnterpriseEligibility: async (checkEnterpriseEligibilityRequest: CheckEnterpriseEligibilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkEnterpriseEligibilityRequest' is not null or undefined
            assertParamExists('checkEnterpriseEligibility', 'checkEnterpriseEligibilityRequest', checkEnterpriseEligibilityRequest)
            const localVarPath = `/api/v1/enterprise/check-eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkEnterpriseEligibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ask whether to post the consent chat notice for a joined calendar event.  Every business outcome is a 200: callers outside an enterprise, or with no matching calendar event, are told to post.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether to post, wait and ask again, or skip because a colleague already posted.
         * @summary Claim Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimConsentNotice: async (consentNoticeRequest: ConsentNoticeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentNoticeRequest' is not null or undefined
            assertParamExists('claimConsentNotice', 'consentNoticeRequest', consentNoticeRequest)
            const localVarPath = `/api/v1/enterprise/consent/notice/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentNoticeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm consent for an enterprise member\'s Notetaker meeting.  Args:     data:            Optional client-known meeting identifier.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated enterprise member.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the enterprise setting read.  Returns:     The server timestamp for the confirmation.
         * @summary Confirm Consent
         * @param {ConsentConfirmRequest} consentConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmConsent: async (consentConfirmRequest: ConsentConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentConfirmRequest' is not null or undefined
            assertParamExists('confirmConsent', 'consentConfirmRequest', consentConfirmRequest)
            const localVarPath = `/api/v1/enterprise/consent/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record that the caller\'s consent chat notice was posted for a joined calendar event.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the posted notice was recorded for the caller\'s enterprise.
         * @summary Confirm Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmConsentNotice: async (consentNoticeRequest: ConsentNoticeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentNoticeRequest' is not null or undefined
            assertParamExists('confirmConsentNotice', 'consentNoticeRequest', consentNoticeRequest)
            const localVarPath = `/api/v1/enterprise/consent/notice/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentNoticeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Connect Wispr to your SSO provider.
         * @summary Connect Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSso: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/sso/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Contact the admins of the enterprise. If invite_email is provided, the contact form is an invite request.
         * @summary Contact Admin
         * @param {ContactAdminRequest} contactAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactAdmin: async (contactAdminRequest: ContactAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactAdminRequest' is not null or undefined
            assertParamExists('contactAdmin', 'contactAdminRequest', contactAdminRequest)
            const localVarPath = `/api/v1/enterprise/contact-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mint a WorkOS-hosted URL for viewing this enterprise\'s audit log events.  Fallback for when the embedded Events tab\'s own read fails — same 404 contract as `GET /audit-logs/workos` (not opted in vs. a genuine WorkOS failure), read-only: never creates a WorkOS organization, and not gated on `AUDIT_LOG_STREAMING_UI_VISIBLE` (that gate is for SIEM log-stream configuration, unrelated to viewing events).
         * @summary Create Audit Logs Portal Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuditLogsPortalLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/audit-logs/workos/portal-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorize the current organization\'s superadmin to manage API keys in WorkOS.  Impersonation is forbidden. Requires the public-api-key-management rollout flag and existing WorkOS organization, user, membership, and widget permission.
         * @summary Create Enterprise Api Keys Widget Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseApiKeysWidgetToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/api-keys/widget-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new enterprise.
         * @summary Create Enterprise New
         * @param {CreateEnterpriseRequestNew} createEnterpriseRequestNew 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseNew: async (createEnterpriseRequestNew: CreateEnterpriseRequestNew, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEnterpriseRequestNew' is not null or undefined
            assertParamExists('createEnterpriseNew', 'createEnterpriseRequestNew', createEnterpriseRequestNew)
            const localVarPath = `/api/v1/enterprise/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEnterpriseRequestNew, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Self-serve Notetaker early access for the caller\'s own enterprise. Only accessible by admins.
         * @summary Enable Notetaker Early Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableNotetakerEarlyAccess: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/notetaker/early-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Current SIEM streaming destination and retention for the caller\'s enterprise.  Read-only: never creates or mutates the enterprise\'s WorkOS organization.
         * @summary Get Audit Log Streaming Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogStreamingStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/audit-log-streaming/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated, filter-bounded audit log for an enterprise, newest first.  Authorization scoping: the ``enterprise_id`` override is honored only for Wispr internal admins. For everyone else the route resolves to the caller\'s own enterprise (admin required); a customer supplying a different enterprise\'s id gets 404 rather than a cross-tenant read.
         * @summary Get Audit Logs
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [actorUserId] 
         * @param {string | null} [targetUserId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise; a foreign id from a customer returns 404.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogs: async (start?: string, end?: string, eventTypes?: Array<AuditAction> | null, actorUserId?: string | null, targetUserId?: string | null, limit?: number, offset?: number, enterpriseId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString().substring(0,10) :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString().substring(0,10) :
                    end;
            }

            if (eventTypes) {
                localVarQueryParameter['event_types'] = eventTypes;
            }

            if (actorUserId !== undefined) {
                localVarQueryParameter['actor_user_id'] = actorUserId;
            }

            if (targetUserId !== undefined) {
                localVarQueryParameter['target_user_id'] = targetUserId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get info about the user\'s email domain, or the domain of the enterprise they belong to.  This can be distinct from the info associated with their team. Returns the users on that domain, the team members whose team owns that domain, and related domain-level details.
         * @summary Get Domain Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/domain-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of the user\'s domain.
         * @summary Get Domain Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/domain-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the enterprise ID for the authenticated user if they belong to one.
         * @summary Get Enterprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterprise: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all invitations for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all join requests for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinRequests: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/join-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Single-member detail payload for the admin-portal member-detail page.  Returns the same row shape as ``/members/table`` — lifetime ``totalWords`` and ``lastUsedAt`` from ``user_stats`` plus ``role`` and ``joinedAt``. Filter-aware chart totals come from ``/insights/words-dictated`` and ``/insights/desktop-apps`` so this endpoint stays Postgres-only and parameter-free.  Access model mirrors the team-insights endpoints: a Wispr internal admin bypasses the enterprise-membership check and can view any user; a regular enterprise admin is scoped to their own tenant. For regular admins both 404 paths (user doesn\'t exist / user in another enterprise) share an identical Postgres latency profile so timing cannot distinguish them.
         * @summary Get Member Detail
         * @param {string} userId user_id of the enterprise member to fetch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberDetail: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMemberDetail', 'userId', userId)
            const localVarPath = `/api/v1/enterprise/members/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redacted status of a current member\'s Notetaker data erasure (admins only; never under impersonation).
         * @summary Get Member Notetaker Erasure Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberNotetakerErasureStatus: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getMemberNotetakerErasureStatus', 'userId', userId)
            const localVarPath = `/api/v1/enterprise/members/{user_id}/notetaker-data-erasure`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all members of the user\'s enterprise.
         * @summary Get Members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the unfiltered enterprise member count for the page header denominator.  Respects the protected-enterprise admin-roles visibility rule so the count matches what the member table can ever surface to the caller.
         * @summary Get Members Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/members/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated enterprise members table for the admin portal.  Authorization scoping: when ``enterprise_id`` is omitted, the route derives it from ``ensure_enterprise_member`` (default behavior for the customer- facing admin portal). When supplied, the override is restricted to Wispr internal admins via ``ensure_internal_admin_with_role``. The ``team_id`` query parameter only narrows the resulting set further via the active-membership join.
         * @summary Get Members Table
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise.
         * @param {string | null} [search] 
         * @param {GetMembersTableStatusEnum} [status] 
         * @param {string | null} [teamId] 
         * @param {GetMembersTableSortByEnum} [sortBy] 
         * @param {GetMembersTableSortDirEnum} [sortDir] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetMembersTableWordsWindowEnum} [wordsWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersTable: async (enterpriseId?: string | null, search?: string | null, status?: GetMembersTableStatusEnum, teamId?: string | null, sortBy?: GetMembersTableSortByEnum, sortDir?: GetMembersTableSortDirEnum, limit?: number, offset?: number, wordsWindow?: GetMembersTableWordsWindowEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/members/table`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (wordsWindow !== undefined) {
                localVarQueryParameter['words_window'] = wordsWindow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the caller\'s anti-spoofed egress IP.  Used by the admin-portal lockout-guard modal so a (potentially locked-out) admin can read what IP they appear from before editing the allowlist. Listed in IP_ALLOWLIST_EXEMPT_PATHS so it remains reachable from outside the enterprise allowlist — that is the entire point.
         * @summary Get My Current Ip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCurrentIp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/my-current-ip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all invitations for the user.
         * @summary Get My Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/invitations/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the pending enterprise join requests for the current user.
         * @summary Get My Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyJoinRequests: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/join-requests/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the seat type for the user\'s enterprise.
         * @summary Get My Seat Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySeatInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/my-seat-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Whether the caller has an open Full seat request in their current enterprise, and whether they may make one.
         * @summary Get My Seat Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySeatRequest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/seat-requests/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the next invoice for the user\'s enterprise.
         * @summary Get Next Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextInvoice: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/next-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read the calling admin\'s email notification preferences.
         * @summary Get Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get or create a shareable invite link for the enterprise. Only accessible by admins.
         * @summary Get Team Invite Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInviteLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/invite-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reads audit events live from WorkOS — the enterprise admin Events tab\'s read path.  404s (not empty) when the enterprise has no `workos_org_id`, so the caller can tell \"not opted in\" from \"opted in, no events yet.\"
         * @summary Get Workos Audit Events
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [before] A previous page\&#39;s own &#x60;before&#x60; value, for pagination. Omit for the first page.
         * @param {number} [limit] Rows per page. One of (20, 50, 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkosAuditEvents: async (start?: string, end?: string, eventTypes?: Array<AuditAction> | null, before?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/audit-logs/workos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString().substring(0,10) :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString().substring(0,10) :
                    end;
            }

            if (eventTypes) {
                localVarQueryParameter['event_types'] = eventTypes;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = (before as any instanceof Date) ?
                    (before as any).toISOString() :
                    before;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification. Admin-only.
         * @summary Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateDomainVerification: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('initiateDomainVerification', 'domainId', domainId)
            const localVarPath = `/api/v1/enterprise/domains/{domain_id}/initiate-verification`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a user to join the enterprise. Only accessible by admins.
         * @summary Invite User
         * @param {InviteRequest} inviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteRequest: InviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteRequest' is not null or undefined
            assertParamExists('inviteUser', 'inviteRequest', inviteRequest)
            const localVarPath = `/api/v1/enterprise/invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only list of the admin\'s enterprise domains and their verification status.  Verification itself (issuing and checking the TXT record) is performed by a Wispr superadmin via the internal API; team admins see status only.
         * @summary List Domain Verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDomainVerifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/domains/verifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject an enterprise join request (admins only).
         * @summary Reject Join Request
         * @param {DeleteJoinRequestRequest} deleteJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectJoinRequest: async (deleteJoinRequestRequest: DeleteJoinRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteJoinRequestRequest' is not null or undefined
            assertParamExists('rejectJoinRequest', 'deleteJoinRequestRequest', deleteJoinRequestRequest)
            const localVarPath = `/api/v1/enterprise/join-requests/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteJoinRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rejoin the most recent enterprise the user was a member of. Gives the user a 24-hour trial regardless of team_trial_given.
         * @summary Rejoin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejoin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/rejoin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Give up the caller\'s pending consent-notice claim when its notice was not posted.  Only the caller\'s own pending claim is released; a posted notice or a colleague\'s claim is left alone.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the caller\'s pending claim was released for colleagues to take.
         * @summary Release Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseConsentNotice: async (consentNoticeRequest: ConsentNoticeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentNoticeRequest' is not null or undefined
            assertParamExists('releaseConsentNotice', 'consentNoticeRequest', consentNoticeRequest)
            const localVarPath = `/api/v1/enterprise/consent/notice/release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consentNoticeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a member from the enterprise. Only accessible by admins.
         * @summary Remove Member
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeMember', 'userId', userId)
            const localVarPath = `/api/v1/enterprise/members/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a member from the enterprise. Only accessible by support team.
         * @summary Remove Member Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMemberSupport: async (userId: string, enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeMemberSupport', 'userId', userId)
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('removeMemberSupport', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/members/{user_id}/support`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ask the caller\'s enterprise admins for a Full seat. Emails them once per open request.
         * @summary Request Full Seat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestFullSeat: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/seat-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend pending or errored invitations by id, each at most once per minute.  Accessible by enterprise admins, and by Wispr internal admins viewing the enterprise as admin.
         * @summary Resend Invitations
         * @param {ResendInvitationsRequest} resendInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitations: async (resendInvitationsRequest: ResendInvitationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendInvitationsRequest' is not null or undefined
            assertParamExists('resendInvitations', 'resendInvitationsRequest', resendInvitationsRequest)
            const localVarPath = `/api/v1/enterprise/invitations/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendInvitationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Revoke Enterprise Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeEnterpriseHipaaBaa: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/hipaa-baa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by admins.
         * @summary Revoke Invitation
         * @param {string} email 
         * @param {RevokeInvitationRequest} revokeInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation: async (email: string, revokeInvitationRequest: RevokeInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('revokeInvitation', 'email', email)
            // verify required parameter 'revokeInvitationRequest' is not null or undefined
            assertParamExists('revokeInvitation', 'revokeInvitationRequest', revokeInvitationRequest)
            const localVarPath = `/api/v1/enterprise/invitations/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokeInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by support team.
         * @summary Revoke Invitation Support
         * @param {string} email 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitationSupport: async (email: string, enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('revokeInvitationSupport', 'email', email)
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('revokeInvitationSupport', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/invitations/{email}/support`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request the admins to invite the user to the enterprise.
         * @summary Self Invite
         * @param {SelfInviteRequest} selfInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfInvite: async (selfInviteRequest: SelfInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selfInviteRequest' is not null or undefined
            assertParamExists('selfInvite', 'selfInviteRequest', selfInviteRequest)
            const localVarPath = `/api/v1/enterprise/self-invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selfInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ensure the enterprise has a WorkOS organization, then return a setup/manage URL.  The explicit action that may create a WorkOS organization — mirrors `POST /sso`. Always an external redirect; WorkOS has no inline/iframe setup path.
         * @summary Setup Audit Log Streaming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupAuditLogStreaming: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/audit-log-streaming/setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set up SCIM directory sync for the enterprise (admins only).
         * @summary Setup Scim
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupScim: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/scim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set up SSO for the enterprise (admins only).
         * @summary Setup Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupSso: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Sign Enterprise Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signEnterpriseHipaaBaa: async (signHipaaBaaRequest: SignHipaaBaaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signHipaaBaaRequest' is not null or undefined
            assertParamExists('signEnterpriseHipaaBaa', 'signHipaaBaaRequest', signHipaaBaaRequest)
            const localVarPath = `/api/v1/enterprise/hipaa-baa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signHipaaBaaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Erase every Notetaker meeting a current member owns; their account and other data stay (admins only).  Runs the meetings-scoped usage-data erasure on Temporal. Never under impersonation.
         * @summary Start Member Notetaker Erasure
         * @param {string} userId 
         * @param {AdminNotetakerErasureRequest} adminNotetakerErasureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMemberNotetakerErasure: async (userId: string, adminNotetakerErasureRequest: AdminNotetakerErasureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('startMemberNotetakerErasure', 'userId', userId)
            // verify required parameter 'adminNotetakerErasureRequest' is not null or undefined
            assertParamExists('startMemberNotetakerErasure', 'adminNotetakerErasureRequest', adminNotetakerErasureRequest)
            const localVarPath = `/api/v1/enterprise/members/{user_id}/notetaker-data-erasure`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotetakerErasureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the audit-log retention period. WorkOS supports exactly 30 or 365 days today.
         * @summary Update Audit Log Streaming Retention
         * @param {UpdateAuditLogRetentionRequest} updateAuditLogRetentionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuditLogStreamingRetention: async (updateAuditLogRetentionRequest: UpdateAuditLogRetentionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAuditLogRetentionRequest' is not null or undefined
            assertParamExists('updateAuditLogStreamingRetention', 'updateAuditLogRetentionRequest', updateAuditLogRetentionRequest)
            const localVarPath = `/api/v1/enterprise/audit-log-streaming/retention`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAuditLogRetentionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the per-domain capture policy. Admin-only; domain must belong to the caller\'s enterprise.
         * @summary Update Domain Capture Policy
         * @param {string} domainId 
         * @param {UpdateDomainCapturePolicyRequest} updateDomainCapturePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDomainCapturePolicy: async (domainId: string, updateDomainCapturePolicyRequest: UpdateDomainCapturePolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('updateDomainCapturePolicy', 'domainId', domainId)
            // verify required parameter 'updateDomainCapturePolicyRequest' is not null or undefined
            assertParamExists('updateDomainCapturePolicy', 'updateDomainCapturePolicyRequest', updateDomainCapturePolicyRequest)
            const localVarPath = `/api/v1/enterprise/domains/{domain_id}/capture-policy`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDomainCapturePolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update enterprise details. Only accessible by admins.
         * @summary Update Enterprise
         * @param {UpdateEnterpriseRequest} updateEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterprise: async (updateEnterpriseRequest: UpdateEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEnterpriseRequest' is not null or undefined
            assertParamExists('updateEnterprise', 'updateEnterpriseRequest', updateEnterpriseRequest)
            const localVarPath = `/api/v1/enterprise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update enterprise settings. Only accessible by admins.
         * @summary Update Enterprise Settings
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseSettings: async (updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEnterpriseSettingsRequest' is not null or undefined
            assertParamExists('updateEnterpriseSettings', 'updateEnterpriseSettingsRequest', updateEnterpriseSettingsRequest)
            const localVarPath = `/api/v1/enterprise/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the role of an enterprise member (admins only).  Disabled when the enterprise has no billing, since in that case every member is already treated as an admin.
         * @summary Update Member Role
         * @param {string} userId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole: async (userId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMemberRole', 'userId', userId)
            // verify required parameter 'updateMemberRoleRequest' is not null or undefined
            assertParamExists('updateMemberRole', 'updateMemberRoleRequest', updateMemberRoleRequest)
            const localVarPath = `/api/v1/enterprise/members/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the role of a member in the enterprise. Only accessible by support team.
         * @summary Update Member Role Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRoleSupport: async (userId: string, enterpriseId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMemberRoleSupport', 'userId', userId)
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateMemberRoleSupport', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateMemberRoleRequest' is not null or undefined
            assertParamExists('updateMemberRoleSupport', 'updateMemberRoleRequest', updateMemberRoleRequest)
            const localVarPath = `/api/v1/enterprise/members/{user_id}/support`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMemberRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the calling admin\'s email notification preferences. No caller-supplied id: always self-scoped.
         * @summary Update Notification Preferences
         * @param {UpdateAdminNotificationPreferencesRequest} updateAdminNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences: async (updateAdminNotificationPreferencesRequest: UpdateAdminNotificationPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAdminNotificationPreferencesRequest' is not null or undefined
            assertParamExists('updateNotificationPreferences', 'updateAdminNotificationPreferencesRequest', updateAdminNotificationPreferencesRequest)
            const localVarPath = `/api/v1/enterprise/notification-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdminNotificationPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle an inbound WorkOS SCIM webhook.
         * @summary Workos Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workosWebhook: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/enterprise/workos/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnterpriseApi - functional programming interface
 * @export
 */
export const EnterpriseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnterpriseApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept an enterprise invitation by invite ID.
         * @summary Accept Enterprise Invite
         * @param {AcceptEnterpriseInviteRequest} acceptEnterpriseInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptEnterpriseInvite(acceptEnterpriseInviteRequest: AcceptEnterpriseInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptEnterpriseInvite(acceptEnterpriseInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.acceptEnterpriseInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept a join request and add the user to the enterprise.
         * @summary Accept Join Request
         * @param {AcceptJoinRequestRequest} acceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptJoinRequest(acceptJoinRequestRequest: AcceptJoinRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptJoinRequest(acceptJoinRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.acceptJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept a team invite link and join the enterprise.
         * @summary Accept Team Invite Link
         * @param {AcceptTeamInviteLinkRequest} acceptTeamInviteLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTeamInviteLink(acceptTeamInviteLinkRequest: AcceptTeamInviteLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTeamInviteLink(acceptTeamInviteLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.acceptTeamInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept multiple join requests for an enterprise with optimized bulk processing.
         * @summary Bulk Accept Join Request
         * @param {BulkAcceptJoinRequestRequest} bulkAcceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest: BulkAcceptJoinRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.bulkAcceptJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by admins.
         * @summary Bulk Invite Users
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkInviteUsers(bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkInviteUsers(bulkInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.bulkInviteUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by support team.
         * @summary Bulk Invite Users Support
         * @param {string} enterpriseId 
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkInviteUsersSupport(enterpriseId: string, bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkInviteUsersSupport(enterpriseId, bulkInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.bulkInviteUsersSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match. Admin-only.
         * @summary Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkDomainVerification(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkDomainVerification(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.checkDomainVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the eligibility status of the user for an enterprise.
         * @summary Check Enterprise Eligibility
         * @param {CheckEnterpriseEligibilityRequest} checkEnterpriseEligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkEnterpriseEligibility(checkEnterpriseEligibilityRequest: CheckEnterpriseEligibilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkEnterpriseEligibility(checkEnterpriseEligibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.checkEnterpriseEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ask whether to post the consent chat notice for a joined calendar event.  Every business outcome is a 200: callers outside an enterprise, or with no matching calendar event, are told to post.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether to post, wait and ask again, or skip because a colleague already posted.
         * @summary Claim Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentNoticeClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimConsentNotice(consentNoticeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.claimConsentNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm consent for an enterprise member\'s Notetaker meeting.  Args:     data:            Optional client-known meeting identifier.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated enterprise member.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the enterprise setting read.  Returns:     The server timestamp for the confirmation.
         * @summary Confirm Consent
         * @param {ConsentConfirmRequest} consentConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmConsent(consentConfirmRequest: ConsentConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentConfirmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmConsent(consentConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.confirmConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Record that the caller\'s consent chat notice was posted for a joined calendar event.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the posted notice was recorded for the caller\'s enterprise.
         * @summary Confirm Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentNoticeConfirmResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmConsentNotice(consentNoticeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.confirmConsentNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Connect Wispr to your SSO provider.
         * @summary Connect Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectSso(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectSso(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.connectSso']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Contact the admins of the enterprise. If invite_email is provided, the contact form is an invite request.
         * @summary Contact Admin
         * @param {ContactAdminRequest} contactAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactAdmin(contactAdminRequest: ContactAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactAdmin(contactAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.contactAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mint a WorkOS-hosted URL for viewing this enterprise\'s audit log events.  Fallback for when the embedded Events tab\'s own read fails — same 404 contract as `GET /audit-logs/workos` (not opted in vs. a genuine WorkOS failure), read-only: never creates a WorkOS organization, and not gated on `AUDIT_LOG_STREAMING_UI_VISIBLE` (that gate is for SIEM log-stream configuration, unrelated to viewing events).
         * @summary Create Audit Logs Portal Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAuditLogsPortalLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogsPortalLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAuditLogsPortalLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.createAuditLogsPortalLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorize the current organization\'s superadmin to manage API keys in WorkOS.  Impersonation is forbidden. Requires the public-api-key-management rollout flag and existing WorkOS organization, user, membership, and widget permission.
         * @summary Create Enterprise Api Keys Widget Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnterpriseApiKeysWidgetToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseAPIKeysWidgetTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnterpriseApiKeysWidgetToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.createEnterpriseApiKeysWidgetToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new enterprise.
         * @summary Create Enterprise New
         * @param {CreateEnterpriseRequestNew} createEnterpriseRequestNew 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnterpriseNew(createEnterpriseRequestNew: CreateEnterpriseRequestNew, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnterpriseNew(createEnterpriseRequestNew, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.createEnterpriseNew']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Self-serve Notetaker early access for the caller\'s own enterprise. Only accessible by admins.
         * @summary Enable Notetaker Early Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableNotetakerEarlyAccess(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableNotetakerEarlyAccess(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.enableNotetakerEarlyAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Current SIEM streaming destination and retention for the caller\'s enterprise.  Read-only: never creates or mutates the enterprise\'s WorkOS organization.
         * @summary Get Audit Log Streaming Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLogStreamingStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogStreamingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogStreamingStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getAuditLogStreamingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated, filter-bounded audit log for an enterprise, newest first.  Authorization scoping: the ``enterprise_id`` override is honored only for Wispr internal admins. For everyone else the route resolves to the caller\'s own enterprise (admin required); a customer supplying a different enterprise\'s id gets 404 rather than a cross-tenant read.
         * @summary Get Audit Logs
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [actorUserId] 
         * @param {string | null} [targetUserId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise; a foreign id from a customer returns 404.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuditLogs(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, actorUserId?: string | null, targetUserId?: string | null, limit?: number, offset?: number, enterpriseId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogs(start, end, eventTypes, actorUserId, targetUserId, limit, offset, enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get info about the user\'s email domain, or the domain of the enterprise they belong to.  This can be distinct from the info associated with their team. Returns the users on that domain, the team members whose team owns that domain, and related domain-level details.
         * @summary Get Domain Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDomainInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomainInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getDomainInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of the user\'s domain.
         * @summary Get Domain Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDomainStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDomainStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getDomainStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the enterprise ID for the authenticated user if they belong to one.
         * @summary Get Enterprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterprise(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterprise(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all invitations for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all join requests for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJoinRequests(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JoinRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJoinRequests(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getJoinRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Single-member detail payload for the admin-portal member-detail page.  Returns the same row shape as ``/members/table`` — lifetime ``totalWords`` and ``lastUsedAt`` from ``user_stats`` plus ``role`` and ``joinedAt``. Filter-aware chart totals come from ``/insights/words-dictated`` and ``/insights/desktop-apps`` so this endpoint stays Postgres-only and parameter-free.  Access model mirrors the team-insights endpoints: a Wispr internal admin bypasses the enterprise-membership check and can view any user; a regular enterprise admin is scoped to their own tenant. For regular admins both 404 paths (user doesn\'t exist / user in another enterprise) share an identical Postgres latency profile so timing cannot distinguish them.
         * @summary Get Member Detail
         * @param {string} userId user_id of the enterprise member to fetch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberDetail(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseMemberDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberDetail(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMemberDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redacted status of a current member\'s Notetaker data erasure (admins only; never under impersonation).
         * @summary Get Member Notetaker Erasure Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberNotetakerErasureStatus(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberNotetakerErasureStatus(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMemberNotetakerErasureStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all members of the user\'s enterprise.
         * @summary Get Members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the unfiltered enterprise member count for the page header denominator.  Respects the protected-enterprise admin-roles visibility rule so the count matches what the member table can ever surface to the caller.
         * @summary Get Members Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembersCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseMembersCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembersCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMembersCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated enterprise members table for the admin portal.  Authorization scoping: when ``enterprise_id`` is omitted, the route derives it from ``ensure_enterprise_member`` (default behavior for the customer- facing admin portal). When supplied, the override is restricted to Wispr internal admins via ``ensure_internal_admin_with_role``. The ``team_id`` query parameter only narrows the resulting set further via the active-membership join.
         * @summary Get Members Table
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise.
         * @param {string | null} [search] 
         * @param {GetMembersTableStatusEnum} [status] 
         * @param {string | null} [teamId] 
         * @param {GetMembersTableSortByEnum} [sortBy] 
         * @param {GetMembersTableSortDirEnum} [sortDir] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetMembersTableWordsWindowEnum} [wordsWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembersTable(enterpriseId?: string | null, search?: string | null, status?: GetMembersTableStatusEnum, teamId?: string | null, sortBy?: GetMembersTableSortByEnum, sortDir?: GetMembersTableSortDirEnum, limit?: number, offset?: number, wordsWindow?: GetMembersTableWordsWindowEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseMembersTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembersTable(enterpriseId, search, status, teamId, sortBy, sortDir, limit, offset, wordsWindow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMembersTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the caller\'s anti-spoofed egress IP.  Used by the admin-portal lockout-guard modal so a (potentially locked-out) admin can read what IP they appear from before editing the allowlist. Listed in IP_ALLOWLIST_EXEMPT_PATHS so it remains reachable from outside the enterprise allowlist — that is the entire point.
         * @summary Get My Current Ip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCurrentIp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyCurrentIpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCurrentIp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMyCurrentIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all invitations for the user.
         * @summary Get My Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMyInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the pending enterprise join requests for the current user.
         * @summary Get My Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyJoinRequests(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JoinRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyJoinRequests(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMyJoinRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the seat type for the user\'s enterprise.
         * @summary Get My Seat Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySeatInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySeatInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMySeatInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Whether the caller has an open Full seat request in their current enterprise, and whether they may make one.
         * @summary Get My Seat Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySeatRequest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MySeatRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySeatRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getMySeatRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the next invoice for the user\'s enterprise.
         * @summary Get Next Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextInvoice(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextInvoice(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getNextInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read the calling admin\'s email notification preferences.
         * @summary Get Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get or create a shareable invite link for the enterprise. Only accessible by admins.
         * @summary Get Team Invite Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamInviteLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamInviteLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamInviteLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getTeamInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reads audit events live from WorkOS — the enterprise admin Events tab\'s read path.  404s (not empty) when the enterprise has no `workos_org_id`, so the caller can tell \"not opted in\" from \"opted in, no events yet.\"
         * @summary Get Workos Audit Events
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [before] A previous page\&#39;s own &#x60;before&#x60; value, for pagination. Omit for the first page.
         * @param {number} [limit] Rows per page. One of (20, 50, 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkosAuditEvents(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, before?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkosAuditLogTableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkosAuditEvents(start, end, eventTypes, before, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.getWorkosAuditEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification. Admin-only.
         * @summary Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationInitiateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateDomainVerification(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.initiateDomainVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite a user to join the enterprise. Only accessible by admins.
         * @summary Invite User
         * @param {InviteRequest} inviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteRequest: InviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(inviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only list of the admin\'s enterprise domains and their verification status.  Verification itself (issuing and checking the TXT record) is performed by a Wispr superadmin via the internal API; team admins see status only.
         * @summary List Domain Verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDomainVerifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDomainVerificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDomainVerifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.listDomainVerifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reject an enterprise join request (admins only).
         * @summary Reject Join Request
         * @param {DeleteJoinRequestRequest} deleteJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectJoinRequest(deleteJoinRequestRequest: DeleteJoinRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectJoinRequest(deleteJoinRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.rejectJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rejoin the most recent enterprise the user was a member of. Gives the user a 24-hour trial regardless of team_trial_given.
         * @summary Rejoin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejoin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejoin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.rejoin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Give up the caller\'s pending consent-notice claim when its notice was not posted.  Only the caller\'s own pending claim is released; a posted notice or a colleague\'s claim is left alone.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the caller\'s pending claim was released for colleagues to take.
         * @summary Release Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentNoticeReleaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseConsentNotice(consentNoticeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.releaseConsentNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a member from the enterprise. Only accessible by admins.
         * @summary Remove Member
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMember(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMember(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.removeMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a member from the enterprise. Only accessible by support team.
         * @summary Remove Member Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMemberSupport(userId: string, enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMemberSupport(userId, enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.removeMemberSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ask the caller\'s enterprise admins for a Full seat. Emails them once per open request.
         * @summary Request Full Seat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestFullSeat(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeatRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestFullSeat(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.requestFullSeat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend pending or errored invitations by id, each at most once per minute.  Accessible by enterprise admins, and by Wispr internal admins viewing the enterprise as admin.
         * @summary Resend Invitations
         * @param {ResendInvitationsRequest} resendInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvitations(resendInvitationsRequest: ResendInvitationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendInvitationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvitations(resendInvitationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.resendInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Revoke Enterprise Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeEnterpriseHipaaBaa(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeEnterpriseHipaaBaa(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.revokeEnterpriseHipaaBaa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by admins.
         * @summary Revoke Invitation
         * @param {string} email 
         * @param {RevokeInvitationRequest} revokeInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitation(email: string, revokeInvitationRequest: RevokeInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitation(email, revokeInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.revokeInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by support team.
         * @summary Revoke Invitation Support
         * @param {string} email 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitationSupport(email: string, enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitationSupport(email, enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.revokeInvitationSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request the admins to invite the user to the enterprise.
         * @summary Self Invite
         * @param {SelfInviteRequest} selfInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async selfInvite(selfInviteRequest: SelfInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SelfInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.selfInvite(selfInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.selfInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ensure the enterprise has a WorkOS organization, then return a setup/manage URL.  The explicit action that may create a WorkOS organization — mirrors `POST /sso`. Always an external redirect; WorkOS has no inline/iframe setup path.
         * @summary Setup Audit Log Streaming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupAuditLogStreaming(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogStreamingPortalLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupAuditLogStreaming(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.setupAuditLogStreaming']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set up SCIM directory sync for the enterprise (admins only).
         * @summary Setup Scim
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupScim(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupScim(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.setupScim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set up SSO for the enterprise (admins only).
         * @summary Setup Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupSso(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupSso(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.setupSso']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Sign Enterprise Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signEnterpriseHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signEnterpriseHipaaBaa(signHipaaBaaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.signEnterpriseHipaaBaa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Erase every Notetaker meeting a current member owns; their account and other data stay (admins only).  Runs the meetings-scoped usage-data erasure on Temporal. Never under impersonation.
         * @summary Start Member Notetaker Erasure
         * @param {string} userId 
         * @param {AdminNotetakerErasureRequest} adminNotetakerErasureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startMemberNotetakerErasure(userId: string, adminNotetakerErasureRequest: AdminNotetakerErasureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startMemberNotetakerErasure(userId, adminNotetakerErasureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.startMemberNotetakerErasure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the audit-log retention period. WorkOS supports exactly 30 or 365 days today.
         * @summary Update Audit Log Streaming Retention
         * @param {UpdateAuditLogRetentionRequest} updateAuditLogRetentionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAuditLogStreamingRetention(updateAuditLogRetentionRequest: UpdateAuditLogRetentionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditLogStreamingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAuditLogStreamingRetention(updateAuditLogRetentionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateAuditLogStreamingRetention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the per-domain capture policy. Admin-only; domain must belong to the caller\'s enterprise.
         * @summary Update Domain Capture Policy
         * @param {string} domainId 
         * @param {UpdateDomainCapturePolicyRequest} updateDomainCapturePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDomainCapturePolicy(domainId: string, updateDomainCapturePolicyRequest: UpdateDomainCapturePolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDomainCapturePolicy(domainId, updateDomainCapturePolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateDomainCapturePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update enterprise details. Only accessible by admins.
         * @summary Update Enterprise
         * @param {UpdateEnterpriseRequest} updateEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnterprise(updateEnterpriseRequest: UpdateEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterprise(updateEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update enterprise settings. Only accessible by admins.
         * @summary Update Enterprise Settings
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnterpriseSettings(updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterpriseSettings(updateEnterpriseSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateEnterpriseSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the role of an enterprise member (admins only).  Disabled when the enterprise has no billing, since in that case every member is already treated as an admin.
         * @summary Update Member Role
         * @param {string} userId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberRole(userId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberRole(userId, updateMemberRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateMemberRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the role of a member in the enterprise. Only accessible by support team.
         * @summary Update Member Role Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberRoleSupport(userId: string, enterpriseId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberRoleSupport(userId, enterpriseId, updateMemberRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateMemberRoleSupport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the calling admin\'s email notification preferences. No caller-supplied id: always self-scoped.
         * @summary Update Notification Preferences
         * @param {UpdateAdminNotificationPreferencesRequest} updateAdminNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationPreferences(updateAdminNotificationPreferencesRequest: UpdateAdminNotificationPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationPreferences(updateAdminNotificationPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.updateNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle an inbound WorkOS SCIM webhook.
         * @summary Workos Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workosWebhook(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workosWebhook(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnterpriseApi.workosWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnterpriseApi - factory interface
 * @export
 */
export const EnterpriseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnterpriseApiFp(configuration)
    return {
        /**
         * Accept an enterprise invitation by invite ID.
         * @summary Accept Enterprise Invite
         * @param {AcceptEnterpriseInviteRequest} acceptEnterpriseInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptEnterpriseInvite(acceptEnterpriseInviteRequest: AcceptEnterpriseInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptEnterpriseInvite(acceptEnterpriseInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept a join request and add the user to the enterprise.
         * @summary Accept Join Request
         * @param {AcceptJoinRequestRequest} acceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptJoinRequest(acceptJoinRequestRequest: AcceptJoinRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptJoinRequest(acceptJoinRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept a team invite link and join the enterprise.
         * @summary Accept Team Invite Link
         * @param {AcceptTeamInviteLinkRequest} acceptTeamInviteLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInviteLink(acceptTeamInviteLinkRequest: AcceptTeamInviteLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptTeamInviteLink(acceptTeamInviteLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept multiple join requests for an enterprise with optimized bulk processing.
         * @summary Bulk Accept Join Request
         * @param {BulkAcceptJoinRequestRequest} bulkAcceptJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest: BulkAcceptJoinRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by admins.
         * @summary Bulk Invite Users
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsers(bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkInviteResponse> {
            return localVarFp.bulkInviteUsers(bulkInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite multiple users to join the enterprise. Only accessible by support team.
         * @summary Bulk Invite Users Support
         * @param {string} enterpriseId 
         * @param {BulkInviteRequest} bulkInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkInviteUsersSupport(enterpriseId: string, bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkInviteResponse> {
            return localVarFp.bulkInviteUsersSupport(enterpriseId, bulkInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match. Admin-only.
         * @summary Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkDomainVerification(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationStatus> {
            return localVarFp.checkDomainVerification(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the eligibility status of the user for an enterprise.
         * @summary Check Enterprise Eligibility
         * @param {CheckEnterpriseEligibilityRequest} checkEnterpriseEligibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkEnterpriseEligibility(checkEnterpriseEligibilityRequest: CheckEnterpriseEligibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.checkEnterpriseEligibility(checkEnterpriseEligibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Ask whether to post the consent chat notice for a joined calendar event.  Every business outcome is a 200: callers outside an enterprise, or with no matching calendar event, are told to post.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether to post, wait and ask again, or skip because a colleague already posted.
         * @summary Claim Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentNoticeClaimResponse> {
            return localVarFp.claimConsentNotice(consentNoticeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm consent for an enterprise member\'s Notetaker meeting.  Args:     data:            Optional client-known meeting identifier.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated enterprise member.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the enterprise setting read.  Returns:     The server timestamp for the confirmation.
         * @summary Confirm Consent
         * @param {ConsentConfirmRequest} consentConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmConsent(consentConfirmRequest: ConsentConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentConfirmResponse> {
            return localVarFp.confirmConsent(consentConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Record that the caller\'s consent chat notice was posted for a joined calendar event.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the posted notice was recorded for the caller\'s enterprise.
         * @summary Confirm Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentNoticeConfirmResponse> {
            return localVarFp.confirmConsentNotice(consentNoticeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Connect Wispr to your SSO provider.
         * @summary Connect Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectSso(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.connectSso(options).then((request) => request(axios, basePath));
        },
        /**
         * Contact the admins of the enterprise. If invite_email is provided, the contact form is an invite request.
         * @summary Contact Admin
         * @param {ContactAdminRequest} contactAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactAdmin(contactAdminRequest: ContactAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ContactAdminResponse> {
            return localVarFp.contactAdmin(contactAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mint a WorkOS-hosted URL for viewing this enterprise\'s audit log events.  Fallback for when the embedded Events tab\'s own read fails — same 404 contract as `GET /audit-logs/workos` (not opted in vs. a genuine WorkOS failure), read-only: never creates a WorkOS organization, and not gated on `AUDIT_LOG_STREAMING_UI_VISIBLE` (that gate is for SIEM log-stream configuration, unrelated to viewing events).
         * @summary Create Audit Logs Portal Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuditLogsPortalLink(options?: RawAxiosRequestConfig): AxiosPromise<AuditLogsPortalLinkResponse> {
            return localVarFp.createAuditLogsPortalLink(options).then((request) => request(axios, basePath));
        },
        /**
         * Authorize the current organization\'s superadmin to manage API keys in WorkOS.  Impersonation is forbidden. Requires the public-api-key-management rollout flag and existing WorkOS organization, user, membership, and widget permission.
         * @summary Create Enterprise Api Keys Widget Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseApiKeysWidgetToken(options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseAPIKeysWidgetTokenResponse> {
            return localVarFp.createEnterpriseApiKeysWidgetToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new enterprise.
         * @summary Create Enterprise New
         * @param {CreateEnterpriseRequestNew} createEnterpriseRequestNew 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseNew(createEnterpriseRequestNew: CreateEnterpriseRequestNew, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEnterpriseNew(createEnterpriseRequestNew, options).then((request) => request(axios, basePath));
        },
        /**
         * Self-serve Notetaker early access for the caller\'s own enterprise. Only accessible by admins.
         * @summary Enable Notetaker Early Access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableNotetakerEarlyAccess(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enableNotetakerEarlyAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * Current SIEM streaming destination and retention for the caller\'s enterprise.  Read-only: never creates or mutates the enterprise\'s WorkOS organization.
         * @summary Get Audit Log Streaming Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogStreamingStatus(options?: RawAxiosRequestConfig): AxiosPromise<AuditLogStreamingStatusResponse> {
            return localVarFp.getAuditLogStreamingStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated, filter-bounded audit log for an enterprise, newest first.  Authorization scoping: the ``enterprise_id`` override is honored only for Wispr internal admins. For everyone else the route resolves to the caller\'s own enterprise (admin required); a customer supplying a different enterprise\'s id gets 404 rather than a cross-tenant read.
         * @summary Get Audit Logs
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [actorUserId] 
         * @param {string | null} [targetUserId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise; a foreign id from a customer returns 404.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuditLogs(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, actorUserId?: string | null, targetUserId?: string | null, limit?: number, offset?: number, enterpriseId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogTableResponse> {
            return localVarFp.getAuditLogs(start, end, eventTypes, actorUserId, targetUserId, limit, offset, enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get info about the user\'s email domain, or the domain of the enterprise they belong to.  This can be distinct from the info associated with their team. Returns the users on that domain, the team members whose team owns that domain, and related domain-level details.
         * @summary Get Domain Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainInfo(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDomainInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of the user\'s domain.
         * @summary Get Domain Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDomainStatus(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getDomainStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the enterprise ID for the authenticated user if they belong to one.
         * @summary Get Enterprise
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterprise(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getEnterprise(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all invitations for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitations(options?: RawAxiosRequestConfig): AxiosPromise<InvitesResponse> {
            return localVarFp.getInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all join requests for the user\'s enterprise. Only accessible by enterprise admins.
         * @summary Get Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJoinRequests(options?: RawAxiosRequestConfig): AxiosPromise<Array<JoinRequest>> {
            return localVarFp.getJoinRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * Single-member detail payload for the admin-portal member-detail page.  Returns the same row shape as ``/members/table`` — lifetime ``totalWords`` and ``lastUsedAt`` from ``user_stats`` plus ``role`` and ``joinedAt``. Filter-aware chart totals come from ``/insights/words-dictated`` and ``/insights/desktop-apps`` so this endpoint stays Postgres-only and parameter-free.  Access model mirrors the team-insights endpoints: a Wispr internal admin bypasses the enterprise-membership check and can view any user; a regular enterprise admin is scoped to their own tenant. For regular admins both 404 paths (user doesn\'t exist / user in another enterprise) share an identical Postgres latency profile so timing cannot distinguish them.
         * @summary Get Member Detail
         * @param {string} userId user_id of the enterprise member to fetch.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberDetail(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseMemberDetailResponse> {
            return localVarFp.getMemberDetail(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Redacted status of a current member\'s Notetaker data erasure (admins only; never under impersonation).
         * @summary Get Member Notetaker Erasure Status
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberNotetakerErasureStatus(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStatusResponse> {
            return localVarFp.getMemberNotetakerErasureStatus(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all members of the user\'s enterprise.
         * @summary Get Members
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers(options?: RawAxiosRequestConfig): AxiosPromise<MembersResponse> {
            return localVarFp.getMembers(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the unfiltered enterprise member count for the page header denominator.  Respects the protected-enterprise admin-roles visibility rule so the count matches what the member table can ever surface to the caller.
         * @summary Get Members Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersCount(options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseMembersCountResponse> {
            return localVarFp.getMembersCount(options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated enterprise members table for the admin portal.  Authorization scoping: when ``enterprise_id`` is omitted, the route derives it from ``ensure_enterprise_member`` (default behavior for the customer- facing admin portal). When supplied, the override is restricted to Wispr internal admins via ``ensure_internal_admin_with_role``. The ``team_id`` query parameter only narrows the resulting set further via the active-membership join.
         * @summary Get Members Table
         * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise.
         * @param {string | null} [search] 
         * @param {GetMembersTableStatusEnum} [status] 
         * @param {string | null} [teamId] 
         * @param {GetMembersTableSortByEnum} [sortBy] 
         * @param {GetMembersTableSortDirEnum} [sortDir] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {GetMembersTableWordsWindowEnum} [wordsWindow] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersTable(enterpriseId?: string | null, search?: string | null, status?: GetMembersTableStatusEnum, teamId?: string | null, sortBy?: GetMembersTableSortByEnum, sortDir?: GetMembersTableSortDirEnum, limit?: number, offset?: number, wordsWindow?: GetMembersTableWordsWindowEnum, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseMembersTableResponse> {
            return localVarFp.getMembersTable(enterpriseId, search, status, teamId, sortBy, sortDir, limit, offset, wordsWindow, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the caller\'s anti-spoofed egress IP.  Used by the admin-portal lockout-guard modal so a (potentially locked-out) admin can read what IP they appear from before editing the allowlist. Listed in IP_ALLOWLIST_EXEMPT_PATHS so it remains reachable from outside the enterprise allowlist — that is the entire point.
         * @summary Get My Current Ip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCurrentIp(options?: RawAxiosRequestConfig): AxiosPromise<MyCurrentIpResponse> {
            return localVarFp.getMyCurrentIp(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all invitations for the user.
         * @summary Get My Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyInvitations(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getMyInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the pending enterprise join requests for the current user.
         * @summary Get My Join Requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyJoinRequests(options?: RawAxiosRequestConfig): AxiosPromise<Array<JoinRequest>> {
            return localVarFp.getMyJoinRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the seat type for the user\'s enterprise.
         * @summary Get My Seat Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySeatInfo(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getMySeatInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Whether the caller has an open Full seat request in their current enterprise, and whether they may make one.
         * @summary Get My Seat Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySeatRequest(options?: RawAxiosRequestConfig): AxiosPromise<MySeatRequestResponse> {
            return localVarFp.getMySeatRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the next invoice for the user\'s enterprise.
         * @summary Get Next Invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextInvoice(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getNextInvoice(options).then((request) => request(axios, basePath));
        },
        /**
         * Read the calling admin\'s email notification preferences.
         * @summary Get Notification Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationPreferences(options?: RawAxiosRequestConfig): AxiosPromise<AdminNotificationPreferencesResponse> {
            return localVarFp.getNotificationPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * Get or create a shareable invite link for the enterprise. Only accessible by admins.
         * @summary Get Team Invite Link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInviteLink(options?: RawAxiosRequestConfig): AxiosPromise<TeamInviteLinkResponse> {
            return localVarFp.getTeamInviteLink(options).then((request) => request(axios, basePath));
        },
        /**
         * Reads audit events live from WorkOS — the enterprise admin Events tab\'s read path.  404s (not empty) when the enterprise has no `workos_org_id`, so the caller can tell \"not opted in\" from \"opted in, no events yet.\"
         * @summary Get Workos Audit Events
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {Array<AuditAction> | null} [eventTypes] 
         * @param {string | null} [before] A previous page\&#39;s own &#x60;before&#x60; value, for pagination. Omit for the first page.
         * @param {number} [limit] Rows per page. One of (20, 50, 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkosAuditEvents(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, before?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<WorkosAuditLogTableResponse> {
            return localVarFp.getWorkosAuditEvents(start, end, eventTypes, before, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification. Admin-only.
         * @summary Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationInitiateResponse> {
            return localVarFp.initiateDomainVerification(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite a user to join the enterprise. Only accessible by admins.
         * @summary Invite User
         * @param {InviteRequest} inviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(inviteRequest: InviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteResponse> {
            return localVarFp.inviteUser(inviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only list of the admin\'s enterprise domains and their verification status.  Verification itself (issuing and checking the TXT record) is performed by a Wispr superadmin via the internal API; team admins see status only.
         * @summary List Domain Verifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDomainVerifications(options?: RawAxiosRequestConfig): AxiosPromise<ListDomainVerificationsResponse> {
            return localVarFp.listDomainVerifications(options).then((request) => request(axios, basePath));
        },
        /**
         * Reject an enterprise join request (admins only).
         * @summary Reject Join Request
         * @param {DeleteJoinRequestRequest} deleteJoinRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectJoinRequest(deleteJoinRequestRequest: DeleteJoinRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.rejectJoinRequest(deleteJoinRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rejoin the most recent enterprise the user was a member of. Gives the user a 24-hour trial regardless of team_trial_given.
         * @summary Rejoin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejoin(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.rejoin(options).then((request) => request(axios, basePath));
        },
        /**
         * Give up the caller\'s pending consent-notice claim when its notice was not posted.  Only the caller\'s own pending claim is released; a posted notice or a colleague\'s claim is left alone.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the caller\'s pending claim was released for colleagues to take.
         * @summary Release Consent Notice
         * @param {ConsentNoticeRequest} consentNoticeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentNoticeReleaseResponse> {
            return localVarFp.releaseConsentNotice(consentNoticeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a member from the enterprise. Only accessible by admins.
         * @summary Remove Member
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.removeMember(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a member from the enterprise. Only accessible by support team.
         * @summary Remove Member Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMemberSupport(userId: string, enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.removeMemberSupport(userId, enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Ask the caller\'s enterprise admins for a Full seat. Emails them once per open request.
         * @summary Request Full Seat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestFullSeat(options?: RawAxiosRequestConfig): AxiosPromise<SeatRequestResponse> {
            return localVarFp.requestFullSeat(options).then((request) => request(axios, basePath));
        },
        /**
         * Resend pending or errored invitations by id, each at most once per minute.  Accessible by enterprise admins, and by Wispr internal admins viewing the enterprise as admin.
         * @summary Resend Invitations
         * @param {ResendInvitationsRequest} resendInvitationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvitations(resendInvitationsRequest: ResendInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResendInvitationsResponse> {
            return localVarFp.resendInvitations(resendInvitationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Revoke Enterprise Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeEnterpriseHipaaBaa(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revokeEnterpriseHipaaBaa(options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by admins.
         * @summary Revoke Invitation
         * @param {string} email 
         * @param {RevokeInvitationRequest} revokeInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(email: string, revokeInvitationRequest: RevokeInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revokeInvitation(email, revokeInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke an invitation to join the enterprise. Only accessible by support team.
         * @summary Revoke Invitation Support
         * @param {string} email 
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitationSupport(email: string, enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revokeInvitationSupport(email, enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Request the admins to invite the user to the enterprise.
         * @summary Self Invite
         * @param {SelfInviteRequest} selfInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        selfInvite(selfInviteRequest: SelfInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SelfInviteResponse> {
            return localVarFp.selfInvite(selfInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Ensure the enterprise has a WorkOS organization, then return a setup/manage URL.  The explicit action that may create a WorkOS organization — mirrors `POST /sso`. Always an external redirect; WorkOS has no inline/iframe setup path.
         * @summary Setup Audit Log Streaming
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupAuditLogStreaming(options?: RawAxiosRequestConfig): AxiosPromise<AuditLogStreamingPortalLinkResponse> {
            return localVarFp.setupAuditLogStreaming(options).then((request) => request(axios, basePath));
        },
        /**
         * Set up SCIM directory sync for the enterprise (admins only).
         * @summary Setup Scim
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupScim(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.setupScim(options).then((request) => request(axios, basePath));
        },
        /**
         * Set up SSO for the enterprise (admins only).
         * @summary Setup Sso
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupSso(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.setupSso(options).then((request) => request(axios, basePath));
        },
        /**
         * Sign a HIPAA Business Associate Agreement for the entire enterprise.
         * @summary Sign Enterprise Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signEnterpriseHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.signEnterpriseHipaaBaa(signHipaaBaaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Erase every Notetaker meeting a current member owns; their account and other data stay (admins only).  Runs the meetings-scoped usage-data erasure on Temporal. Never under impersonation.
         * @summary Start Member Notetaker Erasure
         * @param {string} userId 
         * @param {AdminNotetakerErasureRequest} adminNotetakerErasureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMemberNotetakerErasure(userId: string, adminNotetakerErasureRequest: AdminNotetakerErasureRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStartResponse> {
            return localVarFp.startMemberNotetakerErasure(userId, adminNotetakerErasureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the audit-log retention period. WorkOS supports exactly 30 or 365 days today.
         * @summary Update Audit Log Streaming Retention
         * @param {UpdateAuditLogRetentionRequest} updateAuditLogRetentionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAuditLogStreamingRetention(updateAuditLogRetentionRequest: UpdateAuditLogRetentionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuditLogStreamingStatusResponse> {
            return localVarFp.updateAuditLogStreamingRetention(updateAuditLogRetentionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the per-domain capture policy. Admin-only; domain must belong to the caller\'s enterprise.
         * @summary Update Domain Capture Policy
         * @param {string} domainId 
         * @param {UpdateDomainCapturePolicyRequest} updateDomainCapturePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDomainCapturePolicy(domainId: string, updateDomainCapturePolicyRequest: UpdateDomainCapturePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationStatus> {
            return localVarFp.updateDomainCapturePolicy(domainId, updateDomainCapturePolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update enterprise details. Only accessible by admins.
         * @summary Update Enterprise
         * @param {UpdateEnterpriseRequest} updateEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterprise(updateEnterpriseRequest: UpdateEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateEnterprise(updateEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update enterprise settings. Only accessible by admins.
         * @summary Update Enterprise Settings
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseSettings(updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateEnterpriseSettings(updateEnterpriseSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the role of an enterprise member (admins only).  Disabled when the enterprise has no billing, since in that case every member is already treated as an admin.
         * @summary Update Member Role
         * @param {string} userId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole(userId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateMemberRole(userId, updateMemberRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the role of a member in the enterprise. Only accessible by support team.
         * @summary Update Member Role Support
         * @param {string} userId 
         * @param {string} enterpriseId 
         * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRoleSupport(userId: string, enterpriseId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateMemberRoleSupport(userId, enterpriseId, updateMemberRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the calling admin\'s email notification preferences. No caller-supplied id: always self-scoped.
         * @summary Update Notification Preferences
         * @param {UpdateAdminNotificationPreferencesRequest} updateAdminNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences(updateAdminNotificationPreferencesRequest: UpdateAdminNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNotificationPreferencesResponse> {
            return localVarFp.updateNotificationPreferences(updateAdminNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle an inbound WorkOS SCIM webhook.
         * @summary Workos Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workosWebhook(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.workosWebhook(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnterpriseApi - object-oriented interface
 * @export
 * @class EnterpriseApi
 * @extends {BaseAPI}
 */
export class EnterpriseApi extends BaseAPI {
    /**
     * Accept an enterprise invitation by invite ID.
     * @summary Accept Enterprise Invite
     * @param {AcceptEnterpriseInviteRequest} acceptEnterpriseInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public acceptEnterpriseInvite(acceptEnterpriseInviteRequest: AcceptEnterpriseInviteRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).acceptEnterpriseInvite(acceptEnterpriseInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept a join request and add the user to the enterprise.
     * @summary Accept Join Request
     * @param {AcceptJoinRequestRequest} acceptJoinRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public acceptJoinRequest(acceptJoinRequestRequest: AcceptJoinRequestRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).acceptJoinRequest(acceptJoinRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept a team invite link and join the enterprise.
     * @summary Accept Team Invite Link
     * @param {AcceptTeamInviteLinkRequest} acceptTeamInviteLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public acceptTeamInviteLink(acceptTeamInviteLinkRequest: AcceptTeamInviteLinkRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).acceptTeamInviteLink(acceptTeamInviteLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept multiple join requests for an enterprise with optimized bulk processing.
     * @summary Bulk Accept Join Request
     * @param {BulkAcceptJoinRequestRequest} bulkAcceptJoinRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest: BulkAcceptJoinRequestRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).bulkAcceptJoinRequest(bulkAcceptJoinRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite multiple users to join the enterprise. Only accessible by admins.
     * @summary Bulk Invite Users
     * @param {BulkInviteRequest} bulkInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public bulkInviteUsers(bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).bulkInviteUsers(bulkInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite multiple users to join the enterprise. Only accessible by support team.
     * @summary Bulk Invite Users Support
     * @param {string} enterpriseId 
     * @param {BulkInviteRequest} bulkInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public bulkInviteUsersSupport(enterpriseId: string, bulkInviteRequest: BulkInviteRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).bulkInviteUsersSupport(enterpriseId, bulkInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query public DNS and flip the domain to verified on exact token match. Admin-only.
     * @summary Check Domain Verification
     * @param {string} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public checkDomainVerification(domainId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).checkDomainVerification(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the eligibility status of the user for an enterprise.
     * @summary Check Enterprise Eligibility
     * @param {CheckEnterpriseEligibilityRequest} checkEnterpriseEligibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public checkEnterpriseEligibility(checkEnterpriseEligibilityRequest: CheckEnterpriseEligibilityRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).checkEnterpriseEligibility(checkEnterpriseEligibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ask whether to post the consent chat notice for a joined calendar event.  Every business outcome is a 200: callers outside an enterprise, or with no matching calendar event, are told to post.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether to post, wait and ask again, or skip because a colleague already posted.
     * @summary Claim Consent Notice
     * @param {ConsentNoticeRequest} consentNoticeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public claimConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).claimConsentNotice(consentNoticeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm consent for an enterprise member\'s Notetaker meeting.  Args:     data:            Optional client-known meeting identifier.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated enterprise member.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the enterprise setting read.  Returns:     The server timestamp for the confirmation.
     * @summary Confirm Consent
     * @param {ConsentConfirmRequest} consentConfirmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public confirmConsent(consentConfirmRequest: ConsentConfirmRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).confirmConsent(consentConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record that the caller\'s consent chat notice was posted for a joined calendar event.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the posted notice was recorded for the caller\'s enterprise.
     * @summary Confirm Consent Notice
     * @param {ConsentNoticeRequest} consentNoticeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public confirmConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).confirmConsentNotice(consentNoticeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Connect Wispr to your SSO provider.
     * @summary Connect Sso
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public connectSso(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).connectSso(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Contact the admins of the enterprise. If invite_email is provided, the contact form is an invite request.
     * @summary Contact Admin
     * @param {ContactAdminRequest} contactAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public contactAdmin(contactAdminRequest: ContactAdminRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).contactAdmin(contactAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mint a WorkOS-hosted URL for viewing this enterprise\'s audit log events.  Fallback for when the embedded Events tab\'s own read fails — same 404 contract as `GET /audit-logs/workos` (not opted in vs. a genuine WorkOS failure), read-only: never creates a WorkOS organization, and not gated on `AUDIT_LOG_STREAMING_UI_VISIBLE` (that gate is for SIEM log-stream configuration, unrelated to viewing events).
     * @summary Create Audit Logs Portal Link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public createAuditLogsPortalLink(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).createAuditLogsPortalLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authorize the current organization\'s superadmin to manage API keys in WorkOS.  Impersonation is forbidden. Requires the public-api-key-management rollout flag and existing WorkOS organization, user, membership, and widget permission.
     * @summary Create Enterprise Api Keys Widget Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public createEnterpriseApiKeysWidgetToken(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).createEnterpriseApiKeysWidgetToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new enterprise.
     * @summary Create Enterprise New
     * @param {CreateEnterpriseRequestNew} createEnterpriseRequestNew 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public createEnterpriseNew(createEnterpriseRequestNew: CreateEnterpriseRequestNew, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).createEnterpriseNew(createEnterpriseRequestNew, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Self-serve Notetaker early access for the caller\'s own enterprise. Only accessible by admins.
     * @summary Enable Notetaker Early Access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public enableNotetakerEarlyAccess(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).enableNotetakerEarlyAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Current SIEM streaming destination and retention for the caller\'s enterprise.  Read-only: never creates or mutates the enterprise\'s WorkOS organization.
     * @summary Get Audit Log Streaming Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getAuditLogStreamingStatus(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getAuditLogStreamingStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated, filter-bounded audit log for an enterprise, newest first.  Authorization scoping: the ``enterprise_id`` override is honored only for Wispr internal admins. For everyone else the route resolves to the caller\'s own enterprise (admin required); a customer supplying a different enterprise\'s id gets 404 rather than a cross-tenant read.
     * @summary Get Audit Logs
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {Array<AuditAction> | null} [eventTypes] 
     * @param {string | null} [actorUserId] 
     * @param {string | null} [targetUserId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise; a foreign id from a customer returns 404.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getAuditLogs(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, actorUserId?: string | null, targetUserId?: string | null, limit?: number, offset?: number, enterpriseId?: string | null, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getAuditLogs(start, end, eventTypes, actorUserId, targetUserId, limit, offset, enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get info about the user\'s email domain, or the domain of the enterprise they belong to.  This can be distinct from the info associated with their team. Returns the users on that domain, the team members whose team owns that domain, and related domain-level details.
     * @summary Get Domain Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getDomainInfo(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getDomainInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of the user\'s domain.
     * @summary Get Domain Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getDomainStatus(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getDomainStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the enterprise ID for the authenticated user if they belong to one.
     * @summary Get Enterprise
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getEnterprise(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getEnterprise(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all invitations for the user\'s enterprise. Only accessible by enterprise admins.
     * @summary Get Invitations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getInvitations(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all join requests for the user\'s enterprise. Only accessible by enterprise admins.
     * @summary Get Join Requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getJoinRequests(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getJoinRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Single-member detail payload for the admin-portal member-detail page.  Returns the same row shape as ``/members/table`` — lifetime ``totalWords`` and ``lastUsedAt`` from ``user_stats`` plus ``role`` and ``joinedAt``. Filter-aware chart totals come from ``/insights/words-dictated`` and ``/insights/desktop-apps`` so this endpoint stays Postgres-only and parameter-free.  Access model mirrors the team-insights endpoints: a Wispr internal admin bypasses the enterprise-membership check and can view any user; a regular enterprise admin is scoped to their own tenant. For regular admins both 404 paths (user doesn\'t exist / user in another enterprise) share an identical Postgres latency profile so timing cannot distinguish them.
     * @summary Get Member Detail
     * @param {string} userId user_id of the enterprise member to fetch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMemberDetail(userId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMemberDetail(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redacted status of a current member\'s Notetaker data erasure (admins only; never under impersonation).
     * @summary Get Member Notetaker Erasure Status
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMemberNotetakerErasureStatus(userId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMemberNotetakerErasureStatus(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all members of the user\'s enterprise.
     * @summary Get Members
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMembers(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMembers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the unfiltered enterprise member count for the page header denominator.  Respects the protected-enterprise admin-roles visibility rule so the count matches what the member table can ever surface to the caller.
     * @summary Get Members Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMembersCount(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMembersCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated enterprise members table for the admin portal.  Authorization scoping: when ``enterprise_id`` is omitted, the route derives it from ``ensure_enterprise_member`` (default behavior for the customer- facing admin portal). When supplied, the override is restricted to Wispr internal admins via ``ensure_internal_admin_with_role``. The ``team_id`` query parameter only narrows the resulting set further via the active-membership join.
     * @summary Get Members Table
     * @param {string | null} [enterpriseId] Wispr-internal-admin override. Customer enterprise admins must omit this and the route resolves to their own enterprise.
     * @param {string | null} [search] 
     * @param {GetMembersTableStatusEnum} [status] 
     * @param {string | null} [teamId] 
     * @param {GetMembersTableSortByEnum} [sortBy] 
     * @param {GetMembersTableSortDirEnum} [sortDir] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {GetMembersTableWordsWindowEnum} [wordsWindow] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMembersTable(enterpriseId?: string | null, search?: string | null, status?: GetMembersTableStatusEnum, teamId?: string | null, sortBy?: GetMembersTableSortByEnum, sortDir?: GetMembersTableSortDirEnum, limit?: number, offset?: number, wordsWindow?: GetMembersTableWordsWindowEnum, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMembersTable(enterpriseId, search, status, teamId, sortBy, sortDir, limit, offset, wordsWindow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the caller\'s anti-spoofed egress IP.  Used by the admin-portal lockout-guard modal so a (potentially locked-out) admin can read what IP they appear from before editing the allowlist. Listed in IP_ALLOWLIST_EXEMPT_PATHS so it remains reachable from outside the enterprise allowlist — that is the entire point.
     * @summary Get My Current Ip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMyCurrentIp(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMyCurrentIp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all invitations for the user.
     * @summary Get My Invitations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMyInvitations(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMyInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the pending enterprise join requests for the current user.
     * @summary Get My Join Requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMyJoinRequests(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMyJoinRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the seat type for the user\'s enterprise.
     * @summary Get My Seat Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMySeatInfo(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMySeatInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Whether the caller has an open Full seat request in their current enterprise, and whether they may make one.
     * @summary Get My Seat Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getMySeatRequest(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getMySeatRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the next invoice for the user\'s enterprise.
     * @summary Get Next Invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getNextInvoice(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getNextInvoice(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read the calling admin\'s email notification preferences.
     * @summary Get Notification Preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getNotificationPreferences(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getNotificationPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get or create a shareable invite link for the enterprise. Only accessible by admins.
     * @summary Get Team Invite Link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getTeamInviteLink(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getTeamInviteLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reads audit events live from WorkOS — the enterprise admin Events tab\'s read path.  404s (not empty) when the enterprise has no `workos_org_id`, so the caller can tell \"not opted in\" from \"opted in, no events yet.\"
     * @summary Get Workos Audit Events
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {Array<AuditAction> | null} [eventTypes] 
     * @param {string | null} [before] A previous page\&#39;s own &#x60;before&#x60; value, for pagination. Omit for the first page.
     * @param {number} [limit] Rows per page. One of (20, 50, 100).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public getWorkosAuditEvents(start?: string, end?: string, eventTypes?: Array<AuditAction> | null, before?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).getWorkosAuditEvents(start, end, eventTypes, before, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue (or reuse) a DNS TXT token for domain ownership verification. Admin-only.
     * @summary Initiate Domain Verification
     * @param {string} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public initiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).initiateDomainVerification(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite a user to join the enterprise. Only accessible by admins.
     * @summary Invite User
     * @param {InviteRequest} inviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public inviteUser(inviteRequest: InviteRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).inviteUser(inviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only list of the admin\'s enterprise domains and their verification status.  Verification itself (issuing and checking the TXT record) is performed by a Wispr superadmin via the internal API; team admins see status only.
     * @summary List Domain Verifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public listDomainVerifications(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).listDomainVerifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject an enterprise join request (admins only).
     * @summary Reject Join Request
     * @param {DeleteJoinRequestRequest} deleteJoinRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public rejectJoinRequest(deleteJoinRequestRequest: DeleteJoinRequestRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).rejectJoinRequest(deleteJoinRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rejoin the most recent enterprise the user was a member of. Gives the user a 24-hour trial regardless of team_trial_given.
     * @summary Rejoin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public rejoin(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).rejoin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Give up the caller\'s pending consent-notice claim when its notice was not posted.  Only the caller\'s own pending claim is released; a posted notice or a colleague\'s claim is left alone.  Args:     request:         Incoming request, read for an admin impersonation session.     data:            Claim id and the caller\'s own calendar event id.     limiter:         Per-IP rate limit, resolved before authentication.     user:            Authenticated caller.     user_id_limiter: Per-user rate limit, resolved after authentication.     db:              Database executor for the calendar event read.  Returns:     Whether the caller\'s pending claim was released for colleagues to take.
     * @summary Release Consent Notice
     * @param {ConsentNoticeRequest} consentNoticeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public releaseConsentNotice(consentNoticeRequest: ConsentNoticeRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).releaseConsentNotice(consentNoticeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a member from the enterprise. Only accessible by admins.
     * @summary Remove Member
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public removeMember(userId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).removeMember(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a member from the enterprise. Only accessible by support team.
     * @summary Remove Member Support
     * @param {string} userId 
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public removeMemberSupport(userId: string, enterpriseId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).removeMemberSupport(userId, enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ask the caller\'s enterprise admins for a Full seat. Emails them once per open request.
     * @summary Request Full Seat
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public requestFullSeat(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).requestFullSeat(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend pending or errored invitations by id, each at most once per minute.  Accessible by enterprise admins, and by Wispr internal admins viewing the enterprise as admin.
     * @summary Resend Invitations
     * @param {ResendInvitationsRequest} resendInvitationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public resendInvitations(resendInvitationsRequest: ResendInvitationsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).resendInvitations(resendInvitationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a HIPAA Business Associate Agreement for the entire enterprise.
     * @summary Revoke Enterprise Hipaa Baa
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public revokeEnterpriseHipaaBaa(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).revokeEnterpriseHipaaBaa(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke an invitation to join the enterprise. Only accessible by admins.
     * @summary Revoke Invitation
     * @param {string} email 
     * @param {RevokeInvitationRequest} revokeInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public revokeInvitation(email: string, revokeInvitationRequest: RevokeInvitationRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).revokeInvitation(email, revokeInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke an invitation to join the enterprise. Only accessible by support team.
     * @summary Revoke Invitation Support
     * @param {string} email 
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public revokeInvitationSupport(email: string, enterpriseId: string, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).revokeInvitationSupport(email, enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request the admins to invite the user to the enterprise.
     * @summary Self Invite
     * @param {SelfInviteRequest} selfInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public selfInvite(selfInviteRequest: SelfInviteRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).selfInvite(selfInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ensure the enterprise has a WorkOS organization, then return a setup/manage URL.  The explicit action that may create a WorkOS organization — mirrors `POST /sso`. Always an external redirect; WorkOS has no inline/iframe setup path.
     * @summary Setup Audit Log Streaming
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public setupAuditLogStreaming(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).setupAuditLogStreaming(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set up SCIM directory sync for the enterprise (admins only).
     * @summary Setup Scim
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public setupScim(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).setupScim(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set up SSO for the enterprise (admins only).
     * @summary Setup Sso
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public setupSso(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).setupSso(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign a HIPAA Business Associate Agreement for the entire enterprise.
     * @summary Sign Enterprise Hipaa Baa
     * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public signEnterpriseHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).signEnterpriseHipaaBaa(signHipaaBaaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Erase every Notetaker meeting a current member owns; their account and other data stay (admins only).  Runs the meetings-scoped usage-data erasure on Temporal. Never under impersonation.
     * @summary Start Member Notetaker Erasure
     * @param {string} userId 
     * @param {AdminNotetakerErasureRequest} adminNotetakerErasureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public startMemberNotetakerErasure(userId: string, adminNotetakerErasureRequest: AdminNotetakerErasureRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).startMemberNotetakerErasure(userId, adminNotetakerErasureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the audit-log retention period. WorkOS supports exactly 30 or 365 days today.
     * @summary Update Audit Log Streaming Retention
     * @param {UpdateAuditLogRetentionRequest} updateAuditLogRetentionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateAuditLogStreamingRetention(updateAuditLogRetentionRequest: UpdateAuditLogRetentionRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateAuditLogStreamingRetention(updateAuditLogRetentionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the per-domain capture policy. Admin-only; domain must belong to the caller\'s enterprise.
     * @summary Update Domain Capture Policy
     * @param {string} domainId 
     * @param {UpdateDomainCapturePolicyRequest} updateDomainCapturePolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateDomainCapturePolicy(domainId: string, updateDomainCapturePolicyRequest: UpdateDomainCapturePolicyRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateDomainCapturePolicy(domainId, updateDomainCapturePolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update enterprise details. Only accessible by admins.
     * @summary Update Enterprise
     * @param {UpdateEnterpriseRequest} updateEnterpriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateEnterprise(updateEnterpriseRequest: UpdateEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateEnterprise(updateEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update enterprise settings. Only accessible by admins.
     * @summary Update Enterprise Settings
     * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateEnterpriseSettings(updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateEnterpriseSettings(updateEnterpriseSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the role of an enterprise member (admins only).  Disabled when the enterprise has no billing, since in that case every member is already treated as an admin.
     * @summary Update Member Role
     * @param {string} userId 
     * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateMemberRole(userId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateMemberRole(userId, updateMemberRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the role of a member in the enterprise. Only accessible by support team.
     * @summary Update Member Role Support
     * @param {string} userId 
     * @param {string} enterpriseId 
     * @param {UpdateMemberRoleRequest} updateMemberRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateMemberRoleSupport(userId: string, enterpriseId: string, updateMemberRoleRequest: UpdateMemberRoleRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateMemberRoleSupport(userId, enterpriseId, updateMemberRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the calling admin\'s email notification preferences. No caller-supplied id: always self-scoped.
     * @summary Update Notification Preferences
     * @param {UpdateAdminNotificationPreferencesRequest} updateAdminNotificationPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public updateNotificationPreferences(updateAdminNotificationPreferencesRequest: UpdateAdminNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).updateNotificationPreferences(updateAdminNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle an inbound WorkOS SCIM webhook.
     * @summary Workos Webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnterpriseApi
     */
    public workosWebhook(options?: RawAxiosRequestConfig) {
        return EnterpriseApiFp(this.configuration).workosWebhook(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMembersTableStatusEnum = {
    Active: 'active',
    Trialing: 'trialing'
} as const;
export type GetMembersTableStatusEnum = typeof GetMembersTableStatusEnum[keyof typeof GetMembersTableStatusEnum];
/**
 * @export
 */
export const GetMembersTableSortByEnum = {
    Name: 'name',
    Email: 'email',
    Status: 'status',
    Team: 'team',
    Role: 'role',
    TotalWords: 'totalWords',
    Wpm: 'wpm',
    LastUsedAt: 'lastUsedAt'
} as const;
export type GetMembersTableSortByEnum = typeof GetMembersTableSortByEnum[keyof typeof GetMembersTableSortByEnum];
/**
 * @export
 */
export const GetMembersTableSortDirEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetMembersTableSortDirEnum = typeof GetMembersTableSortDirEnum[keyof typeof GetMembersTableSortDirEnum];
/**
 * @export
 */
export const GetMembersTableWordsWindowEnum = {
    AllTime: 'all_time',
    Last7Days: 'last_7_days',
    Last30Days: 'last_30_days',
    ThisMonth: 'this_month',
    LastMonth: 'last_month',
    ThisYear: 'this_year'
} as const;
export type GetMembersTableWordsWindowEnum = typeof GetMembersTableWordsWindowEnum[keyof typeof GetMembersTableWordsWindowEnum];


/**
 * EntitlementsApi - axios parameter creator
 * @export
 */
export const EntitlementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return only the authenticated user\'s entitlement snapshot.
         * @summary Get User Entitlements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEntitlements: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/entitlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntitlementsApi - functional programming interface
 * @export
 */
export const EntitlementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntitlementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return only the authenticated user\'s entitlement snapshot.
         * @summary Get User Entitlements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEntitlements(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEntitlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEntitlements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntitlementsApi.getUserEntitlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntitlementsApi - factory interface
 * @export
 */
export const EntitlementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntitlementsApiFp(configuration)
    return {
        /**
         * Return only the authenticated user\'s entitlement snapshot.
         * @summary Get User Entitlements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEntitlements(options?: RawAxiosRequestConfig): AxiosPromise<UserEntitlementsResponse> {
            return localVarFp.getUserEntitlements(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntitlementsApi - object-oriented interface
 * @export
 * @class EntitlementsApi
 * @extends {BaseAPI}
 */
export class EntitlementsApi extends BaseAPI {
    /**
     * Return only the authenticated user\'s entitlement snapshot.
     * @summary Get User Entitlements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitlementsApi
     */
    public getUserEntitlements(options?: RawAxiosRequestConfig) {
        return EntitlementsApiFp(this.configuration).getUserEntitlements(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FoldersApi - axios parameter creator
 * @export
 */
export const FoldersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Share a folder the caller owns with a department of their company, or with the whole company. Idempotent.
         * @summary Add Folder Grant
         * @param {string} folderId 
         * @param {AddFolderGrantRequest} addFolderGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderGrant: async (folderId: string, addFolderGrantRequest: AddFolderGrantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('addFolderGrant', 'folderId', folderId)
            // verify required parameter 'addFolderGrantRequest' is not null or undefined
            assertParamExists('addFolderGrant', 'addFolderGrantRequest', addFolderGrantRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/grants`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFolderGrantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add one of the caller\'s own meetings to a folder the caller owns, or belongs to while the owner\'s org audience admits them. Idempotent.  A new add also returns the domain an attendee-domain rule may follow from the meeting, if any.
         * @summary Add Folder Meeting
         * @param {string} folderId 
         * @param {AddFolderMeetingRequest} addFolderMeetingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderMeeting: async (folderId: string, addFolderMeetingRequest: AddFolderMeetingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('addFolderMeeting', 'folderId', folderId)
            // verify required parameter 'addFolderMeetingRequest' is not null or undefined
            assertParamExists('addFolderMeeting', 'addFolderMeetingRequest', addFolderMeetingRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/meetings`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFolderMeetingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add existing accounts to a folder the caller owns; one outcome per address, never a 422 for a bad one.
         * @summary Add Folder Members
         * @param {string} folderId 
         * @param {AddFolderMembersRequest} addFolderMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderMembers: async (folderId: string, addFolderMembersRequest: AddFolderMembersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('addFolderMembers', 'folderId', folderId)
            // verify required parameter 'addFolderMembersRequest' is not null or undefined
            assertParamExists('addFolderMembers', 'addFolderMembersRequest', addFolderMembersRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/members`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFolderMembersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add the caller\'s meetings with someone from one email domain to a folder as they sync, past ones if asked.
         * @summary Create Domain Rule
         * @param {string} folderId 
         * @param {CreateDomainRuleRequest} createDomainRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainRule: async (folderId: string, createDomainRuleRequest: CreateDomainRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('createDomainRule', 'folderId', folderId)
            // verify required parameter 'createDomainRuleRequest' is not null or undefined
            assertParamExists('createDomainRule', 'createDomainRuleRequest', createDomainRuleRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/meeting-rules/domain`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDomainRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a folder owned by the caller.
         * @summary Create Folder
         * @param {CreateFolderRequest} createFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (createFolderRequest: CreateFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderRequest' is not null or undefined
            assertParamExists('createFolder', 'createFolderRequest', createFolderRequest)
            const localVarPath = `/api/v1/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an upcoming calendar event\'s meeting to a folder: the caller\'s meetings with its key are added. Idempotent.
         * @summary Create Meeting Rule
         * @param {string} folderId 
         * @param {CreateMeetingRuleRequest} createMeetingRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingRule: async (folderId: string, createMeetingRuleRequest: CreateMeetingRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('createMeetingRule', 'folderId', folderId)
            // verify required parameter 'createMeetingRuleRequest' is not null or undefined
            assertParamExists('createMeetingRule', 'createMeetingRuleRequest', createMeetingRuleRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/meeting-rules`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMeetingRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add the caller\'s meetings in a recurring series to a folder, existing ones now and new ones as they sync.
         * @summary Create Series Rule
         * @param {string} folderId 
         * @param {CreateSeriesRuleRequest} createSeriesRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeriesRule: async (folderId: string, createSeriesRuleRequest: CreateSeriesRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('createSeriesRule', 'folderId', folderId)
            // verify required parameter 'createSeriesRuleRequest' is not null or undefined
            assertParamExists('createSeriesRule', 'createSeriesRuleRequest', createSeriesRuleRequest)
            const localVarPath = `/api/v1/folders/{folder_id}/meeting-rules/series`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSeriesRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a folder the caller owns. Its notes stay; only the links go.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteFolder', 'folderId', folderId)
            const localVarPath = `/api/v1/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop a rule adding meetings to a folder; meetings already added stay. No rule is still a 204.  A domain rule can be stopped while domain rules are off, so a rule that shares meetings can always be ended.
         * @summary Delete Meeting Rule
         * @param {string} folderId 
         * @param {DeleteMeetingRuleKindEnum} kind 
         * @param {string} matchValue The event\&#39;s Flow Event Key (&#x60;calendar_external_id&#x60;), or a series rule\&#39;s &#x60;match_value&#x60; as listed; never a path segment, as Microsoft keys break paths.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeetingRule: async (folderId: string, kind: DeleteMeetingRuleKindEnum, matchValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('deleteMeetingRule', 'folderId', folderId)
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('deleteMeetingRule', 'kind', kind)
            // verify required parameter 'matchValue' is not null or undefined
            assertParamExists('deleteMeetingRule', 'matchValue', matchValue)
            const localVarPath = `/api/v1/folders/{folder_id}/meeting-rules`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (matchValue !== undefined) {
                localVarQueryParameter['match_value'] = matchValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The domain a rule may follow from the caller\'s meeting, read without adding it; null, never an error, on failure.
         * @summary Get Meeting Rule Domain
         * @param {string} meetingId One of the caller\&#39;s meetings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingRuleDomain: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingRuleDomain', 'meetingId', meetingId)
            const localVarPath = `/api/v1/folders/meeting-rule-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (meetingId !== undefined) {
                localVarQueryParameter['meeting_id'] = meetingId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave a folder the caller is a member of.
         * @summary Leave Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('leaveFolder', 'folderId', folderId)
            const localVarPath = `/api/v1/folders/{folder_id}/members/leave`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s company and its active departments, for sharing a folder; empty for a consumer.
         * @summary List Folder Grant Targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderGrantTargets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/folders/grant-targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Keyset page of a folder\'s meetings; members get summary-only rows.
         * @summary List Folder Meetings
         * @param {string} folderId 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderMeetings: async (folderId: string, limit?: number, cursor?: string | null, supportsNameChips?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('listFolderMeetings', 'folderId', folderId)
            const localVarPath = `/api/v1/folders/{folder_id}/meetings`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (supportsNameChips !== undefined) {
                localVarQueryParameter['supports_name_chips'] = supportsNameChips;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Owner and members of a folder; ``user_id`` on member rows only for the owner.
         * @summary List Folder Members
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderMembers: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('listFolderMembers', 'folderId', folderId)
            const localVarPath = `/api/v1/folders/{folder_id}/members`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Folders the caller owns or is a member of.
         * @summary List Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s live meeting rules on folders they can still add meetings to, newest first.
         * @summary List Meeting Rules
         * @param {string | null} [matchValue] Only the rules for this calendar event key or series key.
         * @param {Array<ListMeetingRulesKindsEnum>} [kinds] Which rule kinds to list; &#x60;calendar_event&#x60; when absent. &#x60;recurring_series&#x60; is opt-in and 404s while series rules are off. &#x60;attendee_domain&#x60; is opt-in and lists even while domain rules are off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeetingRules: async (matchValue?: string | null, kinds?: Array<ListMeetingRulesKindsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/folders/meeting-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (matchValue !== undefined) {
                localVarQueryParameter['match_value'] = matchValue;
            }

            if (kinds) {
                localVarQueryParameter['kinds'] = kinds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a department or company grant from a folder the caller owns; notes already filed stay.
         * @summary Remove Folder Grant
         * @param {string} folderId 
         * @param {string} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderGrant: async (folderId: string, grantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('removeFolderGrant', 'folderId', folderId)
            // verify required parameter 'grantId' is not null or undefined
            assertParamExists('removeFolderGrant', 'grantId', grantId)
            const localVarPath = `/api/v1/folders/{folder_id}/grants/{grant_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)))
                .replace(`{${"grant_id"}}`, encodeURIComponent(String(grantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a meeting from a folder, returning the domain of the caller\'s rule on it that matches the meeting.
         * @summary Remove Folder Meeting
         * @param {string} folderId 
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderMeeting: async (folderId: string, meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('removeFolderMeeting', 'folderId', folderId)
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('removeFolderMeeting', 'meetingId', meetingId)
            const localVarPath = `/api/v1/folders/{folder_id}/meetings/{meeting_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)))
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a member from a folder the caller owns.
         * @summary Remove Folder Member
         * @param {string} folderId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderMember: async (folderId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('removeFolderMember', 'folderId', folderId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeFolderMember', 'userId', userId)
            const localVarPath = `/api/v1/folders/{folder_id}/members/{user_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename a folder the caller owns; only the fields sent change.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {UpdateFolderRequest} updateFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder: async (folderId: string, updateFolderRequest: UpdateFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('updateFolder', 'folderId', folderId)
            // verify required parameter 'updateFolderRequest' is not null or undefined
            assertParamExists('updateFolder', 'updateFolderRequest', updateFolderRequest)
            const localVarPath = `/api/v1/folders/{folder_id}`
                .replace(`{${"folder_id"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FoldersApi - functional programming interface
 * @export
 */
export const FoldersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FoldersApiAxiosParamCreator(configuration)
    return {
        /**
         * Share a folder the caller owns with a department of their company, or with the whole company. Idempotent.
         * @summary Add Folder Grant
         * @param {string} folderId 
         * @param {AddFolderGrantRequest} addFolderGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFolderGrant(folderId: string, addFolderGrantRequest: AddFolderGrantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFolderGrantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFolderGrant(folderId, addFolderGrantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.addFolderGrant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add one of the caller\'s own meetings to a folder the caller owns, or belongs to while the owner\'s org audience admits them. Idempotent.  A new add also returns the domain an attendee-domain rule may follow from the meeting, if any.
         * @summary Add Folder Meeting
         * @param {string} folderId 
         * @param {AddFolderMeetingRequest} addFolderMeetingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFolderMeeting(folderId: string, addFolderMeetingRequest: AddFolderMeetingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFolderMeetingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFolderMeeting(folderId, addFolderMeetingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.addFolderMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add existing accounts to a folder the caller owns; one outcome per address, never a 422 for a bad one.
         * @summary Add Folder Members
         * @param {string} folderId 
         * @param {AddFolderMembersRequest} addFolderMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFolderMembers(folderId: string, addFolderMembersRequest: AddFolderMembersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFolderMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFolderMembers(folderId, addFolderMembersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.addFolderMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add the caller\'s meetings with someone from one email domain to a folder as they sync, past ones if asked.
         * @summary Create Domain Rule
         * @param {string} folderId 
         * @param {CreateDomainRuleRequest} createDomainRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDomainRule(folderId: string, createDomainRuleRequest: CreateDomainRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateDomainRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDomainRule(folderId, createDomainRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.createDomainRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a folder owned by the caller.
         * @summary Create Folder
         * @param {CreateFolderRequest} createFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(createFolderRequest: CreateFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(createFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.createFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add an upcoming calendar event\'s meeting to a folder: the caller\'s meetings with its key are added. Idempotent.
         * @summary Create Meeting Rule
         * @param {string} folderId 
         * @param {CreateMeetingRuleRequest} createMeetingRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeetingRule(folderId: string, createMeetingRuleRequest: CreateMeetingRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateMeetingRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeetingRule(folderId, createMeetingRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.createMeetingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add the caller\'s meetings in a recurring series to a folder, existing ones now and new ones as they sync.
         * @summary Create Series Rule
         * @param {string} folderId 
         * @param {CreateSeriesRuleRequest} createSeriesRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSeriesRule(folderId: string, createSeriesRuleRequest: CreateSeriesRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSeriesRuleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSeriesRule(folderId, createSeriesRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.createSeriesRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a folder the caller owns. Its notes stay; only the links go.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.deleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop a rule adding meetings to a folder; meetings already added stay. No rule is still a 204.  A domain rule can be stopped while domain rules are off, so a rule that shares meetings can always be ended.
         * @summary Delete Meeting Rule
         * @param {string} folderId 
         * @param {DeleteMeetingRuleKindEnum} kind 
         * @param {string} matchValue The event\&#39;s Flow Event Key (&#x60;calendar_external_id&#x60;), or a series rule\&#39;s &#x60;match_value&#x60; as listed; never a path segment, as Microsoft keys break paths.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeetingRule(folderId: string, kind: DeleteMeetingRuleKindEnum, matchValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeetingRule(folderId, kind, matchValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.deleteMeetingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The domain a rule may follow from the caller\'s meeting, read without adding it; null, never an error, on failure.
         * @summary Get Meeting Rule Domain
         * @param {string} meetingId One of the caller\&#39;s meetings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingRuleDomain(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingRuleDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingRuleDomain(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.getMeetingRuleDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Leave a folder the caller is a member of.
         * @summary Leave Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.leaveFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The caller\'s company and its active departments, for sharing a folder; empty for a consumer.
         * @summary List Folder Grant Targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFolderGrantTargets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderGrantTargetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFolderGrantTargets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.listFolderGrantTargets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Keyset page of a folder\'s meetings; members get summary-only rows.
         * @summary List Folder Meetings
         * @param {string} folderId 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFolderMeetings(folderId: string, limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderMeetingListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFolderMeetings(folderId, limit, cursor, supportsNameChips, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.listFolderMeetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Owner and members of a folder; ``user_id`` on member rows only for the owner.
         * @summary List Folder Members
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFolderMembers(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderMemberListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFolderMembers(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.listFolderMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Folders the caller owns or is a member of.
         * @summary List Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFolders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FolderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFolders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.listFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The caller\'s live meeting rules on folders they can still add meetings to, newest first.
         * @summary List Meeting Rules
         * @param {string | null} [matchValue] Only the rules for this calendar event key or series key.
         * @param {Array<ListMeetingRulesKindsEnum>} [kinds] Which rule kinds to list; &#x60;calendar_event&#x60; when absent. &#x60;recurring_series&#x60; is opt-in and 404s while series rules are off. &#x60;attendee_domain&#x60; is opt-in and lists even while domain rules are off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMeetingRules(matchValue?: string | null, kinds?: Array<ListMeetingRulesKindsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingRuleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMeetingRules(matchValue, kinds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.listMeetingRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a department or company grant from a folder the caller owns; notes already filed stay.
         * @summary Remove Folder Grant
         * @param {string} folderId 
         * @param {string} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFolderGrant(folderId: string, grantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFolderGrant(folderId, grantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.removeFolderGrant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a meeting from a folder, returning the domain of the caller\'s rule on it that matches the meeting.
         * @summary Remove Folder Meeting
         * @param {string} folderId 
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFolderMeeting(folderId: string, meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveFolderMeetingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFolderMeeting(folderId, meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.removeFolderMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a member from a folder the caller owns.
         * @summary Remove Folder Member
         * @param {string} folderId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFolderMember(folderId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFolderMember(folderId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.removeFolderMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename a folder the caller owns; only the fields sent change.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {UpdateFolderRequest} updateFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolder(folderId: string, updateFolderRequest: UpdateFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolder(folderId, updateFolderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FoldersApi.updateFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FoldersApi - factory interface
 * @export
 */
export const FoldersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FoldersApiFp(configuration)
    return {
        /**
         * Share a folder the caller owns with a department of their company, or with the whole company. Idempotent.
         * @summary Add Folder Grant
         * @param {string} folderId 
         * @param {AddFolderGrantRequest} addFolderGrantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderGrant(folderId: string, addFolderGrantRequest: AddFolderGrantRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddFolderGrantResponse> {
            return localVarFp.addFolderGrant(folderId, addFolderGrantRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add one of the caller\'s own meetings to a folder the caller owns, or belongs to while the owner\'s org audience admits them. Idempotent.  A new add also returns the domain an attendee-domain rule may follow from the meeting, if any.
         * @summary Add Folder Meeting
         * @param {string} folderId 
         * @param {AddFolderMeetingRequest} addFolderMeetingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderMeeting(folderId: string, addFolderMeetingRequest: AddFolderMeetingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddFolderMeetingResponse> {
            return localVarFp.addFolderMeeting(folderId, addFolderMeetingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add existing accounts to a folder the caller owns; one outcome per address, never a 422 for a bad one.
         * @summary Add Folder Members
         * @param {string} folderId 
         * @param {AddFolderMembersRequest} addFolderMembersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFolderMembers(folderId: string, addFolderMembersRequest: AddFolderMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddFolderMembersResponse> {
            return localVarFp.addFolderMembers(folderId, addFolderMembersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add the caller\'s meetings with someone from one email domain to a folder as they sync, past ones if asked.
         * @summary Create Domain Rule
         * @param {string} folderId 
         * @param {CreateDomainRuleRequest} createDomainRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainRule(folderId: string, createDomainRuleRequest: CreateDomainRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateDomainRuleResponse> {
            return localVarFp.createDomainRule(folderId, createDomainRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a folder owned by the caller.
         * @summary Create Folder
         * @param {CreateFolderRequest} createFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(createFolderRequest: CreateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateFolderResponse> {
            return localVarFp.createFolder(createFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add an upcoming calendar event\'s meeting to a folder: the caller\'s meetings with its key are added. Idempotent.
         * @summary Create Meeting Rule
         * @param {string} folderId 
         * @param {CreateMeetingRuleRequest} createMeetingRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingRule(folderId: string, createMeetingRuleRequest: CreateMeetingRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateMeetingRuleResponse> {
            return localVarFp.createMeetingRule(folderId, createMeetingRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add the caller\'s meetings in a recurring series to a folder, existing ones now and new ones as they sync.
         * @summary Create Series Rule
         * @param {string} folderId 
         * @param {CreateSeriesRuleRequest} createSeriesRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeriesRule(folderId: string, createSeriesRuleRequest: CreateSeriesRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSeriesRuleResponse> {
            return localVarFp.createSeriesRule(folderId, createSeriesRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a folder the caller owns. Its notes stay; only the links go.
         * @summary Delete Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop a rule adding meetings to a folder; meetings already added stay. No rule is still a 204.  A domain rule can be stopped while domain rules are off, so a rule that shares meetings can always be ended.
         * @summary Delete Meeting Rule
         * @param {string} folderId 
         * @param {DeleteMeetingRuleKindEnum} kind 
         * @param {string} matchValue The event\&#39;s Flow Event Key (&#x60;calendar_external_id&#x60;), or a series rule\&#39;s &#x60;match_value&#x60; as listed; never a path segment, as Microsoft keys break paths.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeetingRule(folderId: string, kind: DeleteMeetingRuleKindEnum, matchValue: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMeetingRule(folderId, kind, matchValue, options).then((request) => request(axios, basePath));
        },
        /**
         * The domain a rule may follow from the caller\'s meeting, read without adding it; null, never an error, on failure.
         * @summary Get Meeting Rule Domain
         * @param {string} meetingId One of the caller\&#39;s meetings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingRuleDomain(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingRuleDomainResponse> {
            return localVarFp.getMeetingRuleDomain(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Leave a folder the caller is a member of.
         * @summary Leave Folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leaveFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s company and its active departments, for sharing a folder; empty for a consumer.
         * @summary List Folder Grant Targets
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderGrantTargets(options?: RawAxiosRequestConfig): AxiosPromise<FolderGrantTargetsResponse> {
            return localVarFp.listFolderGrantTargets(options).then((request) => request(axios, basePath));
        },
        /**
         * Keyset page of a folder\'s meetings; members get summary-only rows.
         * @summary List Folder Meetings
         * @param {string} folderId 
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderMeetings(folderId: string, limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FolderMeetingListResponse> {
            return localVarFp.listFolderMeetings(folderId, limit, cursor, supportsNameChips, options).then((request) => request(axios, basePath));
        },
        /**
         * Owner and members of a folder; ``user_id`` on member rows only for the owner.
         * @summary List Folder Members
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolderMembers(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<FolderMemberListResponse> {
            return localVarFp.listFolderMembers(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Folders the caller owns or is a member of.
         * @summary List Folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFolders(options?: RawAxiosRequestConfig): AxiosPromise<FolderListResponse> {
            return localVarFp.listFolders(options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s live meeting rules on folders they can still add meetings to, newest first.
         * @summary List Meeting Rules
         * @param {string | null} [matchValue] Only the rules for this calendar event key or series key.
         * @param {Array<ListMeetingRulesKindsEnum>} [kinds] Which rule kinds to list; &#x60;calendar_event&#x60; when absent. &#x60;recurring_series&#x60; is opt-in and 404s while series rules are off. &#x60;attendee_domain&#x60; is opt-in and lists even while domain rules are off.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeetingRules(matchValue?: string | null, kinds?: Array<ListMeetingRulesKindsEnum>, options?: RawAxiosRequestConfig): AxiosPromise<MeetingRuleListResponse> {
            return localVarFp.listMeetingRules(matchValue, kinds, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a department or company grant from a folder the caller owns; notes already filed stay.
         * @summary Remove Folder Grant
         * @param {string} folderId 
         * @param {string} grantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderGrant(folderId: string, grantId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeFolderGrant(folderId, grantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a meeting from a folder, returning the domain of the caller\'s rule on it that matches the meeting.
         * @summary Remove Folder Meeting
         * @param {string} folderId 
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderMeeting(folderId: string, meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<RemoveFolderMeetingResponse> {
            return localVarFp.removeFolderMeeting(folderId, meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a member from a folder the caller owns.
         * @summary Remove Folder Member
         * @param {string} folderId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFolderMember(folderId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeFolderMember(folderId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename a folder the caller owns; only the fields sent change.
         * @summary Update Folder
         * @param {string} folderId 
         * @param {UpdateFolderRequest} updateFolderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder(folderId: string, updateFolderRequest: UpdateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateFolderResponse> {
            return localVarFp.updateFolder(folderId, updateFolderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FoldersApi - object-oriented interface
 * @export
 * @class FoldersApi
 * @extends {BaseAPI}
 */
export class FoldersApi extends BaseAPI {
    /**
     * Share a folder the caller owns with a department of their company, or with the whole company. Idempotent.
     * @summary Add Folder Grant
     * @param {string} folderId 
     * @param {AddFolderGrantRequest} addFolderGrantRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public addFolderGrant(folderId: string, addFolderGrantRequest: AddFolderGrantRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).addFolderGrant(folderId, addFolderGrantRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add one of the caller\'s own meetings to a folder the caller owns, or belongs to while the owner\'s org audience admits them. Idempotent.  A new add also returns the domain an attendee-domain rule may follow from the meeting, if any.
     * @summary Add Folder Meeting
     * @param {string} folderId 
     * @param {AddFolderMeetingRequest} addFolderMeetingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public addFolderMeeting(folderId: string, addFolderMeetingRequest: AddFolderMeetingRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).addFolderMeeting(folderId, addFolderMeetingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add existing accounts to a folder the caller owns; one outcome per address, never a 422 for a bad one.
     * @summary Add Folder Members
     * @param {string} folderId 
     * @param {AddFolderMembersRequest} addFolderMembersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public addFolderMembers(folderId: string, addFolderMembersRequest: AddFolderMembersRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).addFolderMembers(folderId, addFolderMembersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add the caller\'s meetings with someone from one email domain to a folder as they sync, past ones if asked.
     * @summary Create Domain Rule
     * @param {string} folderId 
     * @param {CreateDomainRuleRequest} createDomainRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createDomainRule(folderId: string, createDomainRuleRequest: CreateDomainRuleRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createDomainRule(folderId, createDomainRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a folder owned by the caller.
     * @summary Create Folder
     * @param {CreateFolderRequest} createFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createFolder(createFolderRequest: CreateFolderRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createFolder(createFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add an upcoming calendar event\'s meeting to a folder: the caller\'s meetings with its key are added. Idempotent.
     * @summary Create Meeting Rule
     * @param {string} folderId 
     * @param {CreateMeetingRuleRequest} createMeetingRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createMeetingRule(folderId: string, createMeetingRuleRequest: CreateMeetingRuleRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createMeetingRule(folderId, createMeetingRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add the caller\'s meetings in a recurring series to a folder, existing ones now and new ones as they sync.
     * @summary Create Series Rule
     * @param {string} folderId 
     * @param {CreateSeriesRuleRequest} createSeriesRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createSeriesRule(folderId: string, createSeriesRuleRequest: CreateSeriesRuleRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createSeriesRule(folderId, createSeriesRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a folder the caller owns. Its notes stay; only the links go.
     * @summary Delete Folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public deleteFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).deleteFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop a rule adding meetings to a folder; meetings already added stay. No rule is still a 204.  A domain rule can be stopped while domain rules are off, so a rule that shares meetings can always be ended.
     * @summary Delete Meeting Rule
     * @param {string} folderId 
     * @param {DeleteMeetingRuleKindEnum} kind 
     * @param {string} matchValue The event\&#39;s Flow Event Key (&#x60;calendar_external_id&#x60;), or a series rule\&#39;s &#x60;match_value&#x60; as listed; never a path segment, as Microsoft keys break paths.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public deleteMeetingRule(folderId: string, kind: DeleteMeetingRuleKindEnum, matchValue: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).deleteMeetingRule(folderId, kind, matchValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The domain a rule may follow from the caller\'s meeting, read without adding it; null, never an error, on failure.
     * @summary Get Meeting Rule Domain
     * @param {string} meetingId One of the caller\&#39;s meetings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public getMeetingRuleDomain(meetingId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).getMeetingRuleDomain(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Leave a folder the caller is a member of.
     * @summary Leave Folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public leaveFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).leaveFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s company and its active departments, for sharing a folder; empty for a consumer.
     * @summary List Folder Grant Targets
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public listFolderGrantTargets(options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).listFolderGrantTargets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Keyset page of a folder\'s meetings; members get summary-only rows.
     * @summary List Folder Meetings
     * @param {string} folderId 
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public listFolderMeetings(folderId: string, limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).listFolderMeetings(folderId, limit, cursor, supportsNameChips, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Owner and members of a folder; ``user_id`` on member rows only for the owner.
     * @summary List Folder Members
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public listFolderMembers(folderId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).listFolderMembers(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Folders the caller owns or is a member of.
     * @summary List Folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public listFolders(options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).listFolders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s live meeting rules on folders they can still add meetings to, newest first.
     * @summary List Meeting Rules
     * @param {string | null} [matchValue] Only the rules for this calendar event key or series key.
     * @param {Array<ListMeetingRulesKindsEnum>} [kinds] Which rule kinds to list; &#x60;calendar_event&#x60; when absent. &#x60;recurring_series&#x60; is opt-in and 404s while series rules are off. &#x60;attendee_domain&#x60; is opt-in and lists even while domain rules are off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public listMeetingRules(matchValue?: string | null, kinds?: Array<ListMeetingRulesKindsEnum>, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).listMeetingRules(matchValue, kinds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a department or company grant from a folder the caller owns; notes already filed stay.
     * @summary Remove Folder Grant
     * @param {string} folderId 
     * @param {string} grantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public removeFolderGrant(folderId: string, grantId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).removeFolderGrant(folderId, grantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a meeting from a folder, returning the domain of the caller\'s rule on it that matches the meeting.
     * @summary Remove Folder Meeting
     * @param {string} folderId 
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public removeFolderMeeting(folderId: string, meetingId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).removeFolderMeeting(folderId, meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a member from a folder the caller owns.
     * @summary Remove Folder Member
     * @param {string} folderId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public removeFolderMember(folderId: string, userId: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).removeFolderMember(folderId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename a folder the caller owns; only the fields sent change.
     * @summary Update Folder
     * @param {string} folderId 
     * @param {UpdateFolderRequest} updateFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public updateFolder(folderId: string, updateFolderRequest: UpdateFolderRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).updateFolder(folderId, updateFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DeleteMeetingRuleKindEnum = {
    CalendarEvent: 'calendar_event',
    RecurringSeries: 'recurring_series',
    AttendeeDomain: 'attendee_domain'
} as const;
export type DeleteMeetingRuleKindEnum = typeof DeleteMeetingRuleKindEnum[keyof typeof DeleteMeetingRuleKindEnum];
/**
 * @export
 */
export const ListMeetingRulesKindsEnum = {
    CalendarEvent: 'calendar_event',
    RecurringSeries: 'recurring_series',
    AttendeeDomain: 'attendee_domain'
} as const;
export type ListMeetingRulesKindsEnum = typeof ListMeetingRulesKindsEnum[keyof typeof ListMeetingRulesKindsEnum];


/**
 * GeoApi - axios parameter creator
 * @export
 */
export const GeoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return the nearest base10 server for the client\'s IP (GET variant).
         * @summary Get Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBase10Server: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geo/base10`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the client\'s country code and deployment region derived from IP.
         * @summary Get Geo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all known gRPC server model IDs so clients can probe latency and pick the fastest.
         * @summary Get Grpc Server List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrpcServerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geo/base10/grpc-servers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the nearest base10 (or gRPC) server for the client\'s IP (POST variant).
         * @summary Post Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBase10Server: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geo/base10`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeoApi - functional programming interface
 * @export
 */
export const GeoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeoApiAxiosParamCreator(configuration)
    return {
        /**
         * Return the nearest base10 server for the client\'s IP (GET variant).
         * @summary Get Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBase10Server(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBase10Server(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getBase10Server']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the client\'s country code and deployment region derived from IP.
         * @summary Get Geo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getGeo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all known gRPC server model IDs so clients can probe latency and pick the fastest.
         * @summary Get Grpc Server List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrpcServerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrpcServerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.getGrpcServerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the nearest base10 (or gRPC) server for the client\'s IP (POST variant).
         * @summary Post Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postBase10Server(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postBase10Server(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeoApi.postBase10Server']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeoApi - factory interface
 * @export
 */
export const GeoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeoApiFp(configuration)
    return {
        /**
         * Return the nearest base10 server for the client\'s IP (GET variant).
         * @summary Get Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBase10Server(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getBase10Server(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the client\'s country code and deployment region derived from IP.
         * @summary Get Geo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeo(options?: RawAxiosRequestConfig): AxiosPromise<GeoResponse> {
            return localVarFp.getGeo(options).then((request) => request(axios, basePath));
        },
        /**
         * Return all known gRPC server model IDs so clients can probe latency and pick the fastest.
         * @summary Get Grpc Server List
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrpcServerList(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getGrpcServerList(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the nearest base10 (or gRPC) server for the client\'s IP (POST variant).
         * @summary Post Base10 Server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postBase10Server(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.postBase10Server(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeoApi - object-oriented interface
 * @export
 * @class GeoApi
 * @extends {BaseAPI}
 */
export class GeoApi extends BaseAPI {
    /**
     * Return the nearest base10 server for the client\'s IP (GET variant).
     * @summary Get Base10 Server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoApi
     */
    public getBase10Server(options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getBase10Server(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the client\'s country code and deployment region derived from IP.
     * @summary Get Geo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoApi
     */
    public getGeo(options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getGeo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all known gRPC server model IDs so clients can probe latency and pick the fastest.
     * @summary Get Grpc Server List
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoApi
     */
    public getGrpcServerList(options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).getGrpcServerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the nearest base10 (or gRPC) server for the client\'s IP (POST variant).
     * @summary Post Base10 Server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeoApi
     */
    public postBase10Server(options?: RawAxiosRequestConfig) {
        return GeoApiFp(this.configuration).postBase10Server(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HistoryApi - axios parameter creator
 * @export
 */
export const HistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Feedback History
         * @param {HistoryFeedbackRequest} historyFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackHistory: async (historyFeedbackRequest: HistoryFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'historyFeedbackRequest' is not null or undefined
            assertParamExists('feedbackHistory', 'historyFeedbackRequest', historyFeedbackRequest)
            const localVarPath = `/history/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(historyFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cross-device context stats (email, ai, work, personal_messaging, document, other) derived from ClickHouse usage_History.
         * @summary Get Context Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContextStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/context-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get history statistics for all users in the enterprise. Accessible by any enterprise member (admin or non-admin). Used for the enterprise usage dashboard and leaderboard.  Podiums and the 4-week historical leaderboard are served by dedicated endpoints: ``GET /history/stats/enterprise/podiums`` and ``GET /history/stats/enterprise/weekly-ranks``.  Note: This endpoint returns all metrics regardless of subscription tier. The frontend is responsible for controlling access to individual metrics based on subscription level and admin status: - Admins can see aggregate metrics (total words, team size, etc.) - Only Enterprise tier admins can see individual teammate breakdowns - Non-admin Enterprise members can see the leaderboard with blurred teammate values Non-Enterprise admins will see the data but the frontend will blur/hide individual metrics and show an upgrade prompt.
         * @summary Get Enterprise History Stats
         * @param {EnterpriseSortBy | null} [sortBy] Column to sort/paginate by. Defaults to total_words.
         * @param {EnterpriseSortOrder} [order] Sort direction
         * @param {number} [offset] Pagination offset. Used only when &#x60;&#x60;limit&#x60;&#x60; is set.
         * @param {number | null} [limit] Page size for leaderboard-style pagination. Omit to return the full enterprise roster (no SQL LIMIT). Pass with offset to fetch a page.
         * @param {string | null} [sortNearUser] User ID to center the page around
         * @param {Array<EnterpriseUsageOmit>} [omit] Optional sections to omit for smaller payloads. Repeat the parameter (e.g. omit&#x3D;apps&amp;omit&#x3D;daily_word_counts). &#x60;apps&#x60; skips app ARRAY columns in Postgres and removes app lists from JSON. &#x60;daily_word_counts&#x60; skips the ClickHouse query and omits that array from JSON.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseHistoryStats: async (sortBy?: EnterpriseSortBy | null, order?: EnterpriseSortOrder, offset?: number, limit?: number | null, sortNearUser?: string | null, omit?: Array<EnterpriseUsageOmit>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/stats/enterprise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortNearUser !== undefined) {
                localVarQueryParameter['sort_near_user'] = sortNearUser;
            }

            if (omit) {
                localVarQueryParameter['omit'] = omit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the top-6 podiums for every ranked metric for the caller\'s enterprise.  Cached in Redis for 5 minutes. Unlike weekly ranks, invalidation is TTL-only (no membership hash in the key), so removed members can appear until the cache entry expires.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.
         * @summary Get Enterprise Podiums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterprisePodiums: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/stats/enterprise/podiums`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the 4-week historical leaderboard for the caller\'s enterprise.  Backed by the same Redis-cached rankings the dashboard already uses; the cache key rotates after the Sunday 23:45 UTC ``reset_weekly_words`` cron (TTL 8 days). Like podiums, membership is not part of the key, so removed or new members may appear in cached data until the entry expires.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.
         * @summary Get Enterprise Weekly Ranks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseWeeklyRanks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/stats/enterprise/weekly-ranks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user\'s history statistics
         * @summary Get History Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/history/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Overwrite user\'s history stats. This should only be called by the client when the remote user stats data are corrupted and should be overwritten with the local data. Client is responsible for ensuring that the local stats are preferred before calling this endpoint.
         * @summary Overwrite History Stats
         * @param {OverwriteHistoryStatsRequest} overwriteHistoryStatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteHistoryStats: async (overwriteHistoryStatsRequest: OverwriteHistoryStatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'overwriteHistoryStatsRequest' is not null or undefined
            assertParamExists('overwriteHistoryStats', 'overwriteHistoryStatsRequest', overwriteHistoryStatsRequest)
            const localVarPath = `/history/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overwriteHistoryStatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload History
         * @param {UploadHistoryRequest} uploadHistoryRequest 
         * @param {AttributionPlatform | null} [platform] Attribution platform (e.g. desktop_mac, desktop_windows)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHistory: async (uploadHistoryRequest: UploadHistoryRequest, platform?: AttributionPlatform | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadHistoryRequest' is not null or undefined
            assertParamExists('uploadHistory', 'uploadHistoryRequest', uploadHistoryRequest)
            const localVarPath = `/history/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write mobile words this week to the database.
         * @summary Write Mobile Words This Week
         * @param {number} wordsThisWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeMobileWordsThisWeek: async (wordsThisWeek: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordsThisWeek' is not null or undefined
            assertParamExists('writeMobileWordsThisWeek', 'wordsThisWeek', wordsThisWeek)
            const localVarPath = `/history/mobile-words-this-week`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (wordsThisWeek !== undefined) {
                localVarQueryParameter['words_this_week'] = wordsThisWeek;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HistoryApi - functional programming interface
 * @export
 */
export const HistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Feedback History
         * @param {HistoryFeedbackRequest} historyFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackHistory(historyFeedbackRequest: HistoryFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackHistory(historyFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.feedbackHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get cross-device context stats (email, ai, work, personal_messaging, document, other) derived from ClickHouse usage_History.
         * @summary Get Context Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContextStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContextStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContextStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getContextStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get history statistics for all users in the enterprise. Accessible by any enterprise member (admin or non-admin). Used for the enterprise usage dashboard and leaderboard.  Podiums and the 4-week historical leaderboard are served by dedicated endpoints: ``GET /history/stats/enterprise/podiums`` and ``GET /history/stats/enterprise/weekly-ranks``.  Note: This endpoint returns all metrics regardless of subscription tier. The frontend is responsible for controlling access to individual metrics based on subscription level and admin status: - Admins can see aggregate metrics (total words, team size, etc.) - Only Enterprise tier admins can see individual teammate breakdowns - Non-admin Enterprise members can see the leaderboard with blurred teammate values Non-Enterprise admins will see the data but the frontend will blur/hide individual metrics and show an upgrade prompt.
         * @summary Get Enterprise History Stats
         * @param {EnterpriseSortBy | null} [sortBy] Column to sort/paginate by. Defaults to total_words.
         * @param {EnterpriseSortOrder} [order] Sort direction
         * @param {number} [offset] Pagination offset. Used only when &#x60;&#x60;limit&#x60;&#x60; is set.
         * @param {number | null} [limit] Page size for leaderboard-style pagination. Omit to return the full enterprise roster (no SQL LIMIT). Pass with offset to fetch a page.
         * @param {string | null} [sortNearUser] User ID to center the page around
         * @param {Array<EnterpriseUsageOmit>} [omit] Optional sections to omit for smaller payloads. Repeat the parameter (e.g. omit&#x3D;apps&amp;omit&#x3D;daily_word_counts). &#x60;apps&#x60; skips app ARRAY columns in Postgres and removes app lists from JSON. &#x60;daily_word_counts&#x60; skips the ClickHouse query and omits that array from JSON.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseHistoryStats(sortBy?: EnterpriseSortBy | null, order?: EnterpriseSortOrder, offset?: number, limit?: number | null, sortNearUser?: string | null, omit?: Array<EnterpriseUsageOmit>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseHistoryStats(sortBy, order, offset, limit, sortNearUser, omit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getEnterpriseHistoryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the top-6 podiums for every ranked metric for the caller\'s enterprise.  Cached in Redis for 5 minutes. Unlike weekly ranks, invalidation is TTL-only (no membership hash in the key), so removed members can appear until the cache entry expires.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.
         * @summary Get Enterprise Podiums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterprisePodiums(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterprisePodiumsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterprisePodiums(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getEnterprisePodiums']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the 4-week historical leaderboard for the caller\'s enterprise.  Backed by the same Redis-cached rankings the dashboard already uses; the cache key rotates after the Sunday 23:45 UTC ``reset_weekly_words`` cron (TTL 8 days). Like podiums, membership is not part of the key, so removed or new members may appear in cached data until the entry expires.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.
         * @summary Get Enterprise Weekly Ranks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseWeeklyRanks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseWeeklyRanksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseWeeklyRanks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getEnterpriseWeeklyRanks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user\'s history statistics
         * @summary Get History Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHistoryStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHistoryStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.getHistoryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Overwrite user\'s history stats. This should only be called by the client when the remote user stats data are corrupted and should be overwritten with the local data. Client is responsible for ensuring that the local stats are preferred before calling this endpoint.
         * @summary Overwrite History Stats
         * @param {OverwriteHistoryStatsRequest} overwriteHistoryStatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async overwriteHistoryStats(overwriteHistoryStatsRequest: OverwriteHistoryStatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.overwriteHistoryStats(overwriteHistoryStatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.overwriteHistoryStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload History
         * @param {UploadHistoryRequest} uploadHistoryRequest 
         * @param {AttributionPlatform | null} [platform] Attribution platform (e.g. desktop_mac, desktop_windows)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadHistory(uploadHistoryRequest: UploadHistoryRequest, platform?: AttributionPlatform | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadHistory(uploadHistoryRequest, platform, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.uploadHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write mobile words this week to the database.
         * @summary Write Mobile Words This Week
         * @param {number} wordsThisWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeMobileWordsThisWeek(wordsThisWeek: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeMobileWordsThisWeek(wordsThisWeek, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HistoryApi.writeMobileWordsThisWeek']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HistoryApi - factory interface
 * @export
 */
export const HistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Feedback History
         * @param {HistoryFeedbackRequest} historyFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackHistory(historyFeedbackRequest: HistoryFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.feedbackHistory(historyFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cross-device context stats (email, ai, work, personal_messaging, document, other) derived from ClickHouse usage_History.
         * @summary Get Context Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContextStats(options?: RawAxiosRequestConfig): AxiosPromise<ContextStatsResponse> {
            return localVarFp.getContextStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Get history statistics for all users in the enterprise. Accessible by any enterprise member (admin or non-admin). Used for the enterprise usage dashboard and leaderboard.  Podiums and the 4-week historical leaderboard are served by dedicated endpoints: ``GET /history/stats/enterprise/podiums`` and ``GET /history/stats/enterprise/weekly-ranks``.  Note: This endpoint returns all metrics regardless of subscription tier. The frontend is responsible for controlling access to individual metrics based on subscription level and admin status: - Admins can see aggregate metrics (total words, team size, etc.) - Only Enterprise tier admins can see individual teammate breakdowns - Non-admin Enterprise members can see the leaderboard with blurred teammate values Non-Enterprise admins will see the data but the frontend will blur/hide individual metrics and show an upgrade prompt.
         * @summary Get Enterprise History Stats
         * @param {EnterpriseSortBy | null} [sortBy] Column to sort/paginate by. Defaults to total_words.
         * @param {EnterpriseSortOrder} [order] Sort direction
         * @param {number} [offset] Pagination offset. Used only when &#x60;&#x60;limit&#x60;&#x60; is set.
         * @param {number | null} [limit] Page size for leaderboard-style pagination. Omit to return the full enterprise roster (no SQL LIMIT). Pass with offset to fetch a page.
         * @param {string | null} [sortNearUser] User ID to center the page around
         * @param {Array<EnterpriseUsageOmit>} [omit] Optional sections to omit for smaller payloads. Repeat the parameter (e.g. omit&#x3D;apps&amp;omit&#x3D;daily_word_counts). &#x60;apps&#x60; skips app ARRAY columns in Postgres and removes app lists from JSON. &#x60;daily_word_counts&#x60; skips the ClickHouse query and omits that array from JSON.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseHistoryStats(sortBy?: EnterpriseSortBy | null, order?: EnterpriseSortOrder, offset?: number, limit?: number | null, sortNearUser?: string | null, omit?: Array<EnterpriseUsageOmit>, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseUsageResponse> {
            return localVarFp.getEnterpriseHistoryStats(sortBy, order, offset, limit, sortNearUser, omit, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the top-6 podiums for every ranked metric for the caller\'s enterprise.  Cached in Redis for 5 minutes. Unlike weekly ranks, invalidation is TTL-only (no membership hash in the key), so removed members can appear until the cache entry expires.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.
         * @summary Get Enterprise Podiums
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterprisePodiums(options?: RawAxiosRequestConfig): AxiosPromise<EnterprisePodiumsResponse> {
            return localVarFp.getEnterprisePodiums(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the 4-week historical leaderboard for the caller\'s enterprise.  Backed by the same Redis-cached rankings the dashboard already uses; the cache key rotates after the Sunday 23:45 UTC ``reset_weekly_words`` cron (TTL 8 days). Like podiums, membership is not part of the key, so removed or new members may appear in cached data until the entry expires.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.
         * @summary Get Enterprise Weekly Ranks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseWeeklyRanks(options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseWeeklyRanksResponse> {
            return localVarFp.getEnterpriseWeeklyRanks(options).then((request) => request(axios, basePath));
        },
        /**
         * Get user\'s history statistics
         * @summary Get History Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoryStats(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getHistoryStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Overwrite user\'s history stats. This should only be called by the client when the remote user stats data are corrupted and should be overwritten with the local data. Client is responsible for ensuring that the local stats are preferred before calling this endpoint.
         * @summary Overwrite History Stats
         * @param {OverwriteHistoryStatsRequest} overwriteHistoryStatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        overwriteHistoryStats(overwriteHistoryStatsRequest: OverwriteHistoryStatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.overwriteHistoryStats(overwriteHistoryStatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload History
         * @param {UploadHistoryRequest} uploadHistoryRequest 
         * @param {AttributionPlatform | null} [platform] Attribution platform (e.g. desktop_mac, desktop_windows)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadHistory(uploadHistoryRequest: UploadHistoryRequest, platform?: AttributionPlatform | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadHistory(uploadHistoryRequest, platform, options).then((request) => request(axios, basePath));
        },
        /**
         * Write mobile words this week to the database.
         * @summary Write Mobile Words This Week
         * @param {number} wordsThisWeek 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeMobileWordsThisWeek(wordsThisWeek: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.writeMobileWordsThisWeek(wordsThisWeek, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HistoryApi - object-oriented interface
 * @export
 * @class HistoryApi
 * @extends {BaseAPI}
 */
export class HistoryApi extends BaseAPI {
    /**
     * 
     * @summary Feedback History
     * @param {HistoryFeedbackRequest} historyFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public feedbackHistory(historyFeedbackRequest: HistoryFeedbackRequest, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).feedbackHistory(historyFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cross-device context stats (email, ai, work, personal_messaging, document, other) derived from ClickHouse usage_History.
     * @summary Get Context Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getContextStats(options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getContextStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get history statistics for all users in the enterprise. Accessible by any enterprise member (admin or non-admin). Used for the enterprise usage dashboard and leaderboard.  Podiums and the 4-week historical leaderboard are served by dedicated endpoints: ``GET /history/stats/enterprise/podiums`` and ``GET /history/stats/enterprise/weekly-ranks``.  Note: This endpoint returns all metrics regardless of subscription tier. The frontend is responsible for controlling access to individual metrics based on subscription level and admin status: - Admins can see aggregate metrics (total words, team size, etc.) - Only Enterprise tier admins can see individual teammate breakdowns - Non-admin Enterprise members can see the leaderboard with blurred teammate values Non-Enterprise admins will see the data but the frontend will blur/hide individual metrics and show an upgrade prompt.
     * @summary Get Enterprise History Stats
     * @param {EnterpriseSortBy | null} [sortBy] Column to sort/paginate by. Defaults to total_words.
     * @param {EnterpriseSortOrder} [order] Sort direction
     * @param {number} [offset] Pagination offset. Used only when &#x60;&#x60;limit&#x60;&#x60; is set.
     * @param {number | null} [limit] Page size for leaderboard-style pagination. Omit to return the full enterprise roster (no SQL LIMIT). Pass with offset to fetch a page.
     * @param {string | null} [sortNearUser] User ID to center the page around
     * @param {Array<EnterpriseUsageOmit>} [omit] Optional sections to omit for smaller payloads. Repeat the parameter (e.g. omit&#x3D;apps&amp;omit&#x3D;daily_word_counts). &#x60;apps&#x60; skips app ARRAY columns in Postgres and removes app lists from JSON. &#x60;daily_word_counts&#x60; skips the ClickHouse query and omits that array from JSON.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getEnterpriseHistoryStats(sortBy?: EnterpriseSortBy | null, order?: EnterpriseSortOrder, offset?: number, limit?: number | null, sortNearUser?: string | null, omit?: Array<EnterpriseUsageOmit>, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getEnterpriseHistoryStats(sortBy, order, offset, limit, sortNearUser, omit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the top-6 podiums for every ranked metric for the caller\'s enterprise.  Cached in Redis for 5 minutes. Unlike weekly ranks, invalidation is TTL-only (no membership hash in the key), so removed members can appear until the cache entry expires.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.
     * @summary Get Enterprise Podiums
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getEnterprisePodiums(options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getEnterprisePodiums(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the 4-week historical leaderboard for the caller\'s enterprise.  Backed by the same Redis-cached rankings the dashboard already uses; the cache key rotates after the Sunday 23:45 UTC ``reset_weekly_words`` cron (TTL 8 days). Like podiums, membership is not part of the key, so removed or new members may appear in cached data until the entry expires.  Auth + ``hideLeaderboard`` checks run before Redis; on a cache hit the handler skips the full-roster Postgres query.  Note: Like ``GET /history/stats/enterprise``, this does not enforce subscription tier; the client is responsible for tier-based gating of leaderboard features.
     * @summary Get Enterprise Weekly Ranks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getEnterpriseWeeklyRanks(options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getEnterpriseWeeklyRanks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user\'s history statistics
     * @summary Get History Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public getHistoryStats(options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).getHistoryStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Overwrite user\'s history stats. This should only be called by the client when the remote user stats data are corrupted and should be overwritten with the local data. Client is responsible for ensuring that the local stats are preferred before calling this endpoint.
     * @summary Overwrite History Stats
     * @param {OverwriteHistoryStatsRequest} overwriteHistoryStatsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public overwriteHistoryStats(overwriteHistoryStatsRequest: OverwriteHistoryStatsRequest, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).overwriteHistoryStats(overwriteHistoryStatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload History
     * @param {UploadHistoryRequest} uploadHistoryRequest 
     * @param {AttributionPlatform | null} [platform] Attribution platform (e.g. desktop_mac, desktop_windows)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public uploadHistory(uploadHistoryRequest: UploadHistoryRequest, platform?: AttributionPlatform | null, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).uploadHistory(uploadHistoryRequest, platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write mobile words this week to the database.
     * @summary Write Mobile Words This Week
     * @param {number} wordsThisWeek 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HistoryApi
     */
    public writeMobileWordsThisWeek(wordsThisWeek: number, options?: RawAxiosRequestConfig) {
        return HistoryApiFp(this.configuration).writeMobileWordsThisWeek(wordsThisWeek, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IncidentsApi - axios parameter creator
 * @export
 */
export const IncidentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return the current incident/outage status for the caller\'s region.  No auth required. On any lookup failure the endpoint returns 200 with ``client_region=\"us\"`` and ``incident_status=null`` so the pre-login screen is never blocked by a status-check error.
         * @summary Get Incident Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncidentStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/incidents/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IncidentsApi - functional programming interface
 * @export
 */
export const IncidentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IncidentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return the current incident/outage status for the caller\'s region.  No auth required. On any lookup failure the endpoint returns 200 with ``client_region=\"us\"`` and ``incident_status=null`` so the pre-login screen is never blocked by a status-check error.
         * @summary Get Incident Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIncidentStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncidentStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIncidentStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IncidentsApi.getIncidentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IncidentsApi - factory interface
 * @export
 */
export const IncidentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IncidentsApiFp(configuration)
    return {
        /**
         * Return the current incident/outage status for the caller\'s region.  No auth required. On any lookup failure the endpoint returns 200 with ``client_region=\"us\"`` and ``incident_status=null`` so the pre-login screen is never blocked by a status-check error.
         * @summary Get Incident Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIncidentStatus(options?: RawAxiosRequestConfig): AxiosPromise<IncidentStatusResponse> {
            return localVarFp.getIncidentStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IncidentsApi - object-oriented interface
 * @export
 * @class IncidentsApi
 * @extends {BaseAPI}
 */
export class IncidentsApi extends BaseAPI {
    /**
     * Return the current incident/outage status for the caller\'s region.  No auth required. On any lookup failure the endpoint returns 200 with ``client_region=\"us\"`` and ``incident_status=null`` so the pre-login screen is never blocked by a status-check error.
     * @summary Get Incident Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncidentsApi
     */
    public getIncidentStatus(options?: RawAxiosRequestConfig) {
        return IncidentsApiFp(this.configuration).getIncidentStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InsightsApi - axios parameter creator
 * @export
 */
export const InsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * One-shot backfill of desktop_total_words_corrected from client SQLite history.
         * @summary Desktop Corrections Backfill
         * @param {StatsBackfillRequest} statsBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desktopCorrectionsBackfill: async (statsBackfillRequest: StatsBackfillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statsBackfillRequest' is not null or undefined
            assertParamExists('desktopCorrectionsBackfill', 'statsBackfillRequest', statsBackfillRequest)
            const localVarPath = `/api/v1/insights/desktop-corrections-backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statsBackfillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return heatmap data for a date range. Defaults to the last 365 days.
         * @summary Get Heatmap
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatmap: async (since?: string, until?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/insights/heatmap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString().substring(0,10) :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString().substring(0,10) :
                    until;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return stats data for the Insights tab (no heatmap).
         * @summary Get Insights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsights: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InsightsApi - functional programming interface
 * @export
 */
export const InsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * One-shot backfill of desktop_total_words_corrected from client SQLite history.
         * @summary Desktop Corrections Backfill
         * @param {StatsBackfillRequest} statsBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async desktopCorrectionsBackfill(statsBackfillRequest: StatsBackfillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.desktopCorrectionsBackfill(statsBackfillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.desktopCorrectionsBackfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return heatmap data for a date range. Defaults to the last 365 days.
         * @summary Get Heatmap
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeatmap(since?: string, until?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HeatmapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeatmap(since, until, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getHeatmap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return stats data for the Insights tab (no heatmap).
         * @summary Get Insights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInsights(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInsights(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InsightsApi.getInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InsightsApi - factory interface
 * @export
 */
export const InsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InsightsApiFp(configuration)
    return {
        /**
         * One-shot backfill of desktop_total_words_corrected from client SQLite history.
         * @summary Desktop Corrections Backfill
         * @param {StatsBackfillRequest} statsBackfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desktopCorrectionsBackfill(statsBackfillRequest: StatsBackfillRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.desktopCorrectionsBackfill(statsBackfillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return heatmap data for a date range. Defaults to the last 365 days.
         * @summary Get Heatmap
         * @param {string} [since] 
         * @param {string} [until] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeatmap(since?: string, until?: string, options?: RawAxiosRequestConfig): AxiosPromise<HeatmapResponse> {
            return localVarFp.getHeatmap(since, until, options).then((request) => request(axios, basePath));
        },
        /**
         * Return stats data for the Insights tab (no heatmap).
         * @summary Get Insights
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInsights(options?: RawAxiosRequestConfig): AxiosPromise<InsightsResponse> {
            return localVarFp.getInsights(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InsightsApi - object-oriented interface
 * @export
 * @class InsightsApi
 * @extends {BaseAPI}
 */
export class InsightsApi extends BaseAPI {
    /**
     * One-shot backfill of desktop_total_words_corrected from client SQLite history.
     * @summary Desktop Corrections Backfill
     * @param {StatsBackfillRequest} statsBackfillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public desktopCorrectionsBackfill(statsBackfillRequest: StatsBackfillRequest, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).desktopCorrectionsBackfill(statsBackfillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return heatmap data for a date range. Defaults to the last 365 days.
     * @summary Get Heatmap
     * @param {string} [since] 
     * @param {string} [until] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getHeatmap(since?: string, until?: string, options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getHeatmap(since, until, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return stats data for the Insights tab (no heatmap).
     * @summary Get Insights
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InsightsApi
     */
    public getInsights(options?: RawAxiosRequestConfig) {
        return InsightsApiFp(this.configuration).getInsights(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InstructHistoryApi - axios parameter creator
 * @export
 */
export const InstructHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload instruct-history (route-classification) rows for a user.
         * @summary Upload Instruct History
         * @param {UploadInstructHistoryRequest} uploadInstructHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInstructHistory: async (uploadInstructHistoryRequest: UploadInstructHistoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadInstructHistoryRequest' is not null or undefined
            assertParamExists('uploadInstructHistory', 'uploadInstructHistoryRequest', uploadInstructHistoryRequest)
            const localVarPath = `/api/v1/instruct_history/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadInstructHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstructHistoryApi - functional programming interface
 * @export
 */
export const InstructHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstructHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload instruct-history (route-classification) rows for a user.
         * @summary Upload Instruct History
         * @param {UploadInstructHistoryRequest} uploadInstructHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadInstructHistory(uploadInstructHistoryRequest: UploadInstructHistoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadInstructHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadInstructHistory(uploadInstructHistoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstructHistoryApi.uploadInstructHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstructHistoryApi - factory interface
 * @export
 */
export const InstructHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstructHistoryApiFp(configuration)
    return {
        /**
         * Upload instruct-history (route-classification) rows for a user.
         * @summary Upload Instruct History
         * @param {UploadInstructHistoryRequest} uploadInstructHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInstructHistory(uploadInstructHistoryRequest: UploadInstructHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadInstructHistoryResponse> {
            return localVarFp.uploadInstructHistory(uploadInstructHistoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InstructHistoryApi - object-oriented interface
 * @export
 * @class InstructHistoryApi
 * @extends {BaseAPI}
 */
export class InstructHistoryApi extends BaseAPI {
    /**
     * Upload instruct-history (route-classification) rows for a user.
     * @summary Upload Instruct History
     * @param {UploadInstructHistoryRequest} uploadInstructHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstructHistoryApi
     */
    public uploadInstructHistory(uploadInstructHistoryRequest: UploadInstructHistoryRequest, options?: RawAxiosRequestConfig) {
        return InstructHistoryApiFp(this.configuration).uploadInstructHistory(uploadInstructHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalApi - axios parameter creator
 * @export
 */
export const InternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a domain to an enterprise (internal admin only).  If the enterprise has SSO enabled (workos_org_id), the domain will also be synced to WorkOS. The response includes a `workos_synced` field indicating whether the sync was successful.
         * @summary Add Enterprise Domain
         * @param {AddEnterpriseDomainRequest} addEnterpriseDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEnterpriseDomain: async (addEnterpriseDomainRequest: AddEnterpriseDomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addEnterpriseDomainRequest' is not null or undefined
            assertParamExists('addEnterpriseDomain', 'addEnterpriseDomainRequest', addEnterpriseDomainRequest)
            const localVarPath = `/api/v1/internal/add-enterprise-domain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEnterpriseDomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add user(s) to an enterprise (internal admin only).  - If a user is not in any enterprise: onboards them to the enterprise - If a user is already in this enterprise: skips them (included in skipped_count) - If a user is in a different enterprise: marks as failed - If a user is not found and create_missing_users is False: marks as failed - If a user is not found and create_missing_users is True: sends a pending   enterprise invitation (does not create an auth/User row)  Partial success: Adds all users that can be added and returns details about failures.
         * @summary Add Users To Enterprise
         * @param {string} enterpriseId 
         * @param {AddUsersToEnterpriseRequest} addUsersToEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersToEnterprise: async (enterpriseId: string, addUsersToEnterpriseRequest: AddUsersToEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('addUsersToEnterprise', 'enterpriseId', enterpriseId)
            // verify required parameter 'addUsersToEnterpriseRequest' is not null or undefined
            assertParamExists('addUsersToEnterprise', 'addUsersToEnterpriseRequest', addUsersToEnterpriseRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUsersToEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a file to bulk add users to an enterprise (internal admin only).  File contains emails separated by commas or newlines, without headers or name columns.  When create_missing_users is False (default): emails must belong to existing users.  When create_missing_users is True: emails with no User row are invited; existing users are still force-added.
         * @summary Add Users To Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {boolean} [createMissingUsers] 
         * @param {EnterpriseRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersToEnterpriseFileUpload: async (enterpriseId: string, file: File, createMissingUsers?: boolean, role?: EnterpriseRole, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('addUsersToEnterpriseFileUpload', 'enterpriseId', enterpriseId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('addUsersToEnterpriseFileUpload', 'file', file)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/upload`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (createMissingUsers !== undefined) {
                localVarQueryParameter['create_missing_users'] = createMissingUsers;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply a referral code to a user on their behalf. Admin only.
         * @summary Admin Apply Referral
         * @param {AdminApplyReferralRequest} adminApplyReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApplyReferral: async (adminApplyReferralRequest: AdminApplyReferralRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminApplyReferralRequest' is not null or undefined
            assertParamExists('adminApplyReferral', 'adminApplyReferralRequest', adminApplyReferralRequest)
            const localVarPath = `/api/v1/internal/referral/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminApplyReferralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Super-admin: list all stored voice memories for a list of users.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin List User Memories
         * @param {AdminMemoryListRequest} adminMemoryListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListUserMemories: async (adminMemoryListRequest: AdminMemoryListRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminMemoryListRequest' is not null or undefined
            assertParamExists('adminListUserMemories', 'adminMemoryListRequest', adminMemoryListRequest)
            const localVarPath = `/api/v1/internal/memory/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminMemoryListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Look up a user by email or user_id and return their profile and subscription info.
         * @summary Admin Lookup User
         * @param {string} q Email address or user_id to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLookupUser: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('adminLookupUser', 'q', q)
            const localVarPath = `/api/v1/internal/users/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Super-admin: semantic-search voice memory for a list of users by a context query.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin Search User Memories
         * @param {AdminMemorySearchRequest} adminMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchUserMemories: async (adminMemorySearchRequest: AdminMemorySearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminMemorySearchRequest' is not null or undefined
            assertParamExists('adminSearchUserMemories', 'adminMemorySearchRequest', adminMemorySearchRequest)
            const localVarPath = `/api/v1/internal/memory/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminMemorySearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Overwrite a user\'s stripe_customer_id (dry-run by default).
         * @summary Admin Update Stripe Customer Id
         * @param {AdminUpdateStripeCustomerIdRequest} adminUpdateStripeCustomerIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateStripeCustomerId: async (adminUpdateStripeCustomerIdRequest: AdminUpdateStripeCustomerIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateStripeCustomerIdRequest' is not null or undefined
            assertParamExists('adminUpdateStripeCustomerId', 'adminUpdateStripeCustomerIdRequest', adminUpdateStripeCustomerIdRequest)
            const localVarPath = `/api/v1/internal/users/stripe-customer-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateStripeCustomerIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commit: async (commitRequest: CommitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitRequest' is not null or undefined
            assertParamExists('commit', 'commitRequest', commitRequest)
            const localVarPath = `/api/v1/internal/billing-ops/commit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commit_1: async (commitRequest: CommitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commitRequest' is not null or undefined
            assertParamExists('commit_1', 'commitRequest', commitRequest)
            const localVarPath = `/api/v1/internal/billing-ops/commit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new enterprise billing config (internal admin only).
         * @summary Create Billing Config
         * @param {EnterpriseBillingConfigCreate} enterpriseBillingConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingConfig: async (enterpriseBillingConfigCreate: EnterpriseBillingConfigCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseBillingConfigCreate' is not null or undefined
            assertParamExists('createBillingConfig', 'enterpriseBillingConfigCreate', enterpriseBillingConfigCreate)
            const localVarPath = `/api/v1/internal/billing-configs/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enterpriseBillingConfigCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a domain to the block list (internal admin only).
         * @summary Create Blocked Domain
         * @param {AddBlockedDomainRequest} addBlockedDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlockedDomain: async (addBlockedDomainRequest: AddBlockedDomainRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addBlockedDomainRequest' is not null or undefined
            assertParamExists('createBlockedDomain', 'addBlockedDomainRequest', addBlockedDomainRequest)
            const localVarPath = `/api/v1/internal/blocked-domains/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBlockedDomainRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an enterprise pilot: sales-owned access until ``trial_end``, then ended automatically.
         * @summary Create Enterprise Pilot
         * @param {CreateEnterprisePilotRequest} createEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterprisePilot: async (createEnterprisePilotRequest: CreateEnterprisePilotRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEnterprisePilotRequest' is not null or undefined
            assertParamExists('createEnterprisePilot', 'createEnterprisePilotRequest', createEnterprisePilotRequest)
            const localVarPath = `/api/v1/internal/enterprises/create-pilot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEnterprisePilotRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new promo campaign (internal admin only).
         * @summary Create Promo Campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCampaign: async (createCampaignRequest: CreateCampaignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCampaignRequest' is not null or undefined
            assertParamExists('createPromoCampaign', 'createCampaignRequest', createCampaignRequest)
            const localVarPath = `/api/v1/internal/promo/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate new codes for a promo campaign (internal admin only).
         * @summary Create Promo Codes
         * @param {string} campaignId 
         * @param {CreateCodesRequest} createCodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCodes: async (campaignId: string, createCodesRequest: CreateCodesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('createPromoCodes', 'campaignId', campaignId)
            // verify required parameter 'createCodesRequest' is not null or undefined
            assertParamExists('createPromoCodes', 'createCodesRequest', createCodesRequest)
            const localVarPath = `/api/v1/internal/promo/campaigns/{campaign_id}/codes`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCodesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a sales-led enterprise with deferred invoicing.  Creates the enterprise, Stripe subscription, and a draft invoice. The invoice stays as a draft until sales unpauses collection via /send-invoice (below).  With `billing_provider=sales_owned` no Stripe objects are created: the enterprise\'s General cost center goes live as `sales_owned` and billing stays in Salesforce.
         * @summary Create Sales Led Enterprise
         * @param {CreateSalesLedEnterpriseRequest} createSalesLedEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLedEnterprise: async (createSalesLedEnterpriseRequest: CreateSalesLedEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSalesLedEnterpriseRequest' is not null or undefined
            assertParamExists('createSalesLedEnterprise', 'createSalesLedEnterpriseRequest', createSalesLedEnterpriseRequest)
            const localVarPath = `/api/v1/internal/enterprises/create-sales-led`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesLedEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a sales-led enterprise with a negotiated custom billing config.  Superadmin-gated counterpart to /create-sales-led: takes the same payload plus a required `custom_billing_config`. Splitting it out keeps the auth escalation visible in the route signature and OpenAPI, matching the sensitivity of /billing-configs/create.
         * @summary Create Sales Led Enterprise Custom Billing
         * @param {CreateSalesLedEnterpriseCustomBillingRequest} createSalesLedEnterpriseCustomBillingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLedEnterpriseCustomBilling: async (createSalesLedEnterpriseCustomBillingRequest: CreateSalesLedEnterpriseCustomBillingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSalesLedEnterpriseCustomBillingRequest' is not null or undefined
            assertParamExists('createSalesLedEnterpriseCustomBilling', 'createSalesLedEnterpriseCustomBillingRequest', createSalesLedEnterpriseCustomBillingRequest)
            const localVarPath = `/api/v1/internal/enterprises/create-sales-led-custom-billing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSalesLedEnterpriseCustomBillingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an enterprise billing config (internal admin only).
         * @summary Delete Billing Config
         * @param {string} configId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillingConfig: async (configId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configId' is not null or undefined
            assertParamExists('deleteBillingConfig', 'configId', configId)
            const localVarPath = `/api/v1/internal/billing-configs/{config_id}`
                .replace(`{${"config_id"}}`, encodeURIComponent(String(configId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a domain from the block list (internal admin only).
         * @summary Delete Blocked Domain
         * @param {string} blockedDomainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedDomain: async (blockedDomainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blockedDomainId' is not null or undefined
            assertParamExists('deleteBlockedDomain', 'blockedDomainId', blockedDomainId)
            const localVarPath = `/api/v1/internal/blocked-domains/{blocked_domain_id}`
                .replace(`{${"blocked_domain_id"}}`, encodeURIComponent(String(blockedDomainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drop the working copy; the next load starts from the consensus prefill or the finalized bundle.
         * @summary Discard Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {number} expectedVersion Version the client loaded; 409 if the row has moved on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardMeetingAttributionGroundTruth: async (meetingId: string, expectedVersion: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('discardMeetingAttributionGroundTruth', 'meetingId', meetingId)
            // verify required parameter 'expectedVersion' is not null or undefined
            assertParamExists('discardMeetingAttributionGroundTruth', 'expectedVersion', expectedVersion)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/ground-truth`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (expectedVersion !== undefined) {
                localVarQueryParameter['expected_version'] = expectedVersion;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorize a version-matched private extension download.
         * @summary Download Extension Bundle
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExtensionBundle: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('downloadExtensionBundle', 'version', version)
            const localVarPath = `/api/v1/internal/extensions/bundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export all codes for a promo campaign as a CSV attachment (internal admin only).
         * @summary Export Promo Codes Csv
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPromoCodesCsv: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('exportPromoCodesCsv', 'campaignId', campaignId)
            const localVarPath = `/api/v1/internal/promo/campaigns/{campaign_id}/codes/export`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write the complete working copy to the durable bundle store as a new generation.
         * @summary Finalize Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtFinalizeRequest} meetingAttributionGtFinalizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeMeetingAttributionGroundTruth: async (meetingId: string, meetingAttributionGtFinalizeRequest: MeetingAttributionGtFinalizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('finalizeMeetingAttributionGroundTruth', 'meetingId', meetingId)
            // verify required parameter 'meetingAttributionGtFinalizeRequest' is not null or undefined
            assertParamExists('finalizeMeetingAttributionGroundTruth', 'meetingAttributionGtFinalizeRequest', meetingAttributionGtFinalizeRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/ground-truth/finalize`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingAttributionGtFinalizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSendFlowStateEmails: async (generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAndSendFlowStateRequest' is not null or undefined
            assertParamExists('generateAndSendFlowStateEmails', 'generateAndSendFlowStateRequest', generateAndSendFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/generate-send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAndSendFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFlowStateProfiles: async (generateFlowStateRequest: GenerateFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateFlowStateRequest' is not null or undefined
            assertParamExists('generateFlowStateProfiles', 'generateFlowStateRequest', generateFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyStats: async (weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsGenerateRequest' is not null or undefined
            assertParamExists('generateWeeklyStats', 'weeklyStatsGenerateRequest', weeklyStatsGenerateRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all blocked domains (internal admin only).
         * @summary Get Blocked Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedDomains: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/blocked-domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get enterprise details including domains (internal admin only).
         * @summary Get Enterprise Details
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseDetails: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getEnterpriseDetails', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprise/{enterprise_id}`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get members of an enterprise with pagination, search, and sort (internal admin only).
         * @summary Get Enterprise Members
         * @param {string} enterpriseId 
         * @param {number} [limit] Maximum number of members to return
         * @param {number} [offset] Number of members to skip
         * @param {string | null} [search] Case-insensitive search across name and email
         * @param {GetEnterpriseMembersSortByEnum} [sortBy] 
         * @param {GetEnterpriseMembersSortDirEnum} [sortDir] 
         * @param {EnterpriseRole | null} [role] Only members with this role, matched case-insensitively
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseMembers: async (enterpriseId: string, limit?: number, offset?: number, search?: string | null, sortBy?: GetEnterpriseMembersSortByEnum, sortDir?: GetEnterpriseMembersSortDirEnum, role?: EnterpriseRole | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getEnterpriseMembers', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sort_dir'] = sortDir;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getFlowStateJob', 'jobId', jobId)
            const localVarPath = `/api/v1/internal/marketing/flow-state/jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateMonthSummary: async (reportingMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingMonth' is not null or undefined
            assertParamExists('getFlowStateMonthSummary', 'reportingMonth', reportingMonth)
            const localVarPath = `/api/v1/internal/marketing/flow-state/months/{reporting_month}`
                .replace(`{${"reporting_month"}}`, encodeURIComponent(String(reportingMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWeeklyStatsBatchRun: async (snapshotAt: string, dryRun: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotAt' is not null or undefined
            assertParamExists('getLatestWeeklyStatsBatchRun', 'snapshotAt', snapshotAt)
            // verify required parameter 'dryRun' is not null or undefined
            assertParamExists('getLatestWeeklyStatsBatchRun', 'dryRun', dryRun)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/runs/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (snapshotAt !== undefined) {
                localVarQueryParameter['snapshot_at'] = (snapshotAt as any instanceof Date) ?
                    (snapshotAt as any).toISOString() :
                    snapshotAt;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a scoped playback or download audio URL when the meeting has audio.
         * @summary Get Meeting Attribution Audio Url
         * @param {string} meetingId 
         * @param {boolean} [download] 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionAudioUrl: async (meetingId: string, download?: boolean, jobId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionAudioUrl', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/audio-url`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (download !== undefined) {
                localVarQueryParameter['download'] = download;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the saved ground-truth document for a meeting, or null when none exists.
         * @summary Get Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruth: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionGroundTruth', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/ground-truth`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Per-person and per-platform annotation progress across all ground-truth meetings.
         * @summary Get Meeting Attribution Ground Truth Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruthLeaderboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meetings/attribution/ground-truth/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the raw JSON pinned to the annotation\'s prefill identity.
         * @summary Get Meeting Attribution Ground Truth Raw
         * @param {string} meetingId 
         * @param {string} expectedPrefillVersion 
         * @param {string} expectedRawSha256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruthRaw: async (meetingId: string, expectedPrefillVersion: string, expectedRawSha256: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionGroundTruthRaw', 'meetingId', meetingId)
            // verify required parameter 'expectedPrefillVersion' is not null or undefined
            assertParamExists('getMeetingAttributionGroundTruthRaw', 'expectedPrefillVersion', expectedPrefillVersion)
            // verify required parameter 'expectedRawSha256' is not null or undefined
            assertParamExists('getMeetingAttributionGroundTruthRaw', 'expectedRawSha256', expectedRawSha256)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/ground-truth/raw`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (expectedPrefillVersion !== undefined) {
                localVarQueryParameter['expected_prefill_version'] = expectedPrefillVersion;
            }

            if (expectedRawSha256 !== undefined) {
                localVarQueryParameter['expected_raw_sha256'] = expectedRawSha256;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the finalized guard-bundle export for a meeting\'s saved ground truth.
         * @summary Get Meeting Attribution Gt Export
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGtExport: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionGtExport', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/gt/export`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a machine-drafted prefill, annotation eligibility, and any saved document.
         * @summary Get Meeting Attribution Gt Prefill
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGtPrefill: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionGtPrefill', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/gt-prefill`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the live meeting\'s refine jobs for internal inspection.
         * @summary Get Meeting Attribution Jobs
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionJobs: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionJobs', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/jobs`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the exact stored live-transcript NDJSON body.
         * @summary Get Meeting Attribution Live
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionLive: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionLive', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/live`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return paired raw provider inputs for the displayed refinement.
         * @summary Get Meeting Attribution Provider Artifacts
         * @param {string} meetingId 
         * @param {string | null} [expectedRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionProviderArtifacts: async (meetingId: string, expectedRevision?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionProviderArtifacts', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/provider-artifacts`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (expectedRevision !== undefined) {
                localVarQueryParameter['expected_revision'] = expectedRevision;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the exact stored refined-transcript NDJSON body.
         * @summary Get Meeting Attribution Refined
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRefined: async (meetingId: string, jobId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionRefined', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/refined`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the exact stored archived refine JSON body.
         * @summary Get Meeting Attribution Refined Raw
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRefinedRaw: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionRefinedRaw', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/refined-raw`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the stored speaker-relabeler comparison for the meeting\'s current refined revision, if any.
         * @summary Get Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRelabeler: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionRelabeler', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/relabeler`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the speaker labels refine shipped for the meeting\'s current refined revision, before user edits.
         * @summary Get Meeting Attribution Shipped
         * @param {string} meetingId 
         * @param {string | null} [revision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionShipped: async (meetingId: string, revision?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionShipped', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/shipped`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (revision !== undefined) {
                localVarQueryParameter['revision'] = revision;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the meeting\'s persisted durable speaker map when valid.
         * @summary Get Meeting Attribution Speaker Map
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionSpeakerMap: async (meetingId: string, jobId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionSpeakerMap', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/speaker-map`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the exact stored speaker-observation NDJSON body.
         * @summary Get Meeting Attribution Speaker Observations
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionSpeakerObservations: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionSpeakerObservations', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/speaker-observations`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Serve the caller\'s blind two-sided comparison for the meeting, computing and storing it on first read.
         * @summary Get Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionTurnPreference: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingAttributionTurnPreference', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/turn-preference`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Votes per provider and a sign test over every finished blind turn-preference session.
         * @summary Get Meeting Attribution Turn Preference Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionTurnPreferenceResults: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meetings/attribution/turn-preference/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if an enterprise has a pending draft invoice (internal admin only).
         * @summary Get Pending Invoice
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingInvoice: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getPendingInvoice', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/pending-invoice`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single promo campaign by ID (internal admin only).
         * @summary Get Promo Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCampaign: async (campaignId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('getPromoCampaign', 'campaignId', campaignId)
            const localVarPath = `/api/v1/internal/promo/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * An enterprise\'s prod Public API access policy, or null (internal superadmin only).
         * @summary Get Public Api Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicApiAccess: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getPublicApiAccess', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/public-api-access`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the public/webmail domain list (internal admin only).
         * @summary Get Public Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicDomains: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/public-domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the university domain list (internal admin only).
         * @summary Get University Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniversityDomains: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/university-domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getWeeklyStatsBatchRun', 'runId', runId)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchTriggerRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getWeeklyStatsBatchTriggerRequest', 'requestId', requestId)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/trigger-requests/{request_id}`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Live WorkOS directory status for an enterprise (internal admin only).  Lists the enterprise\'s directories straight from WorkOS and echoes the stored directory ID; WorkOS failures degrade to a 200 ``unknown`` payload, never a 5xx.  Args:     enterprise_id:    The enterprise whose directory status to check.     internal_service: Injected internal admin service.     user:             The authenticated caller; must be a Wispr internal admin.  Returns:     The three-shape status payload (``ok`` / ``not_connected`` / ``unknown``) as JSON.
         * @summary Get Workos Directory Status
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkosDirectoryStatus: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getWorkosDirectoryStatus', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/workos-directory-status`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create missing users and apply per-user or fallback personal trial end dates.
         * @summary Internal Bulk Provision User Trial End
         * @param {BulkProvisionUserTrialEndRequest} bulkProvisionUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBulkProvisionUserTrialEnd: async (bulkProvisionUserTrialEndRequest: BulkProvisionUserTrialEndRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkProvisionUserTrialEndRequest' is not null or undefined
            assertParamExists('internalBulkProvisionUserTrialEnd', 'bulkProvisionUserTrialEndRequest', bulkProvisionUserTrialEndRequest)
            const localVarPath = `/api/v1/internal/users/trial-end/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkProvisionUserTrialEndRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override the personal trial end date for a list of users (support action).  Applies the same date to every user; per-user failures (e.g. unknown email) are reported in the response rows instead of failing the batch.  Args:     request:          Incoming request (required by the rate limiter dependencies).     data:             Target user emails and the trial end date to apply.     internal_service: Injected internal admin service.     user:             Authenticated caller; must be an internal admin with an admin role.  Returns:     Per-user results plus updated_count/failed_count/total_count.  Raises:     HTTPException: 400: trial_end is in the past or exceeds the 365-day cap.     HTTPInternalServerError: Unexpected failure while processing the batch.
         * @summary Internal Bulk Update User Trial End
         * @param {BulkUpdateUserTrialEndRequest} bulkUpdateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBulkUpdateUserTrialEnd: async (bulkUpdateUserTrialEndRequest: BulkUpdateUserTrialEndRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateUserTrialEndRequest' is not null or undefined
            assertParamExists('internalBulkUpdateUserTrialEnd', 'bulkUpdateUserTrialEndRequest', bulkUpdateUserTrialEndRequest)
            const localVarPath = `/api/v1/internal/users/trial-end/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateUserTrialEndRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match.
         * @summary Internal Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCheckDomainVerification: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('internalCheckDomainVerification', 'domainId', domainId)
            const localVarPath = `/api/v1/internal/domains/{domain_id}/check-verification`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new enterprise for a given name/domain, and set the given email as the admin user.  Creates a new user, enterprise, and Stripe customer. Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Internal Create Enterprise
         * @param {CreateEnterpriseFromAdminRequest} createEnterpriseFromAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateEnterprise: async (createEnterpriseFromAdminRequest: CreateEnterpriseFromAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEnterpriseFromAdminRequest' is not null or undefined
            assertParamExists('internalCreateEnterprise', 'createEnterpriseFromAdminRequest', createEnterpriseFromAdminRequest)
            const localVarPath = `/api/v1/internal/enterprises/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEnterpriseFromAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disband an enterprise. Cancels Stripe subscription, removes all members, and sends a Slack notification.
         * @summary Internal Disband Enterprise
         * @param {string} enterpriseId 
         * @param {DisbandEnterpriseRequest} disbandEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalDisbandEnterprise: async (enterpriseId: string, disbandEnterpriseRequest: DisbandEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('internalDisbandEnterprise', 'enterpriseId', enterpriseId)
            // verify required parameter 'disbandEnterpriseRequest' is not null or undefined
            assertParamExists('internalDisbandEnterprise', 'disbandEnterpriseRequest', disbandEnterpriseRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/disband`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disbandEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return current verification status (including TXT record) for a single domain.
         * @summary Internal Get Domain Verification Status
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalGetDomainVerificationStatus: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('internalGetDomainVerificationStatus', 'domainId', domainId)
            const localVarPath = `/api/v1/internal/domains/{domain_id}/verification-status`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification.
         * @summary Internal Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalInitiateDomainVerification: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('internalInitiateDomainVerification', 'domainId', domainId)
            const localVarPath = `/api/v1/internal/domains/{domain_id}/initiate-verification`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPreviewCostCenterProvision: async (internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalCostCenterProvisionRequest' is not null or undefined
            assertParamExists('internalPreviewCostCenterProvision', 'internalCostCenterProvisionRequest', internalCostCenterProvisionRequest)
            const localVarPath = `/api/v1/internal/cost-centers/preview-provision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalCostCenterProvisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPreviewCostCenterProvision_2: async (internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalCostCenterProvisionRequest' is not null or undefined
            assertParamExists('internalPreviewCostCenterProvision_2', 'internalCostCenterProvisionRequest', internalCostCenterProvisionRequest)
            const localVarPath = `/api/v1/internal/cost-centers/preview-provision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalCostCenterProvisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProvisionCostCenter: async (internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalCostCenterProvisionRequest' is not null or undefined
            assertParamExists('internalProvisionCostCenter', 'internalCostCenterProvisionRequest', internalCostCenterProvisionRequest)
            const localVarPath = `/api/v1/internal/cost-centers/provision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalCostCenterProvisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProvisionCostCenter_3: async (internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalCostCenterProvisionRequest' is not null or undefined
            assertParamExists('internalProvisionCostCenter_3', 'internalCostCenterProvisionRequest', internalCostCenterProvisionRequest)
            const localVarPath = `/api/v1/internal/cost-centers/provision`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalCostCenterProvisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Wispr-controlled enterprise gates (internal admin only).  Any @wispr.ai admin can flip keys in ADMIN_GATES; SUPERADMIN_GATES require an @wispr.ai superadmin (enforced inside update_gates).
         * @summary Internal Update Enterprise Gates
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseGatesRequest} updateEnterpriseGatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateEnterpriseGates: async (enterpriseId: string, updateEnterpriseGatesRequest: UpdateEnterpriseGatesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('internalUpdateEnterpriseGates', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateEnterpriseGatesRequest' is not null or undefined
            assertParamExists('internalUpdateEnterpriseGates', 'updateEnterpriseGatesRequest', updateEnterpriseGatesRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/gates`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseGatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override customer-settable enterprise settings (internal admin only, for support fixups).  Gate keys (usageExportAllowed, zdrLocked, restrictDomainAccess) are not accepted here — use PATCH /enterprises/{id}/gates. Per-key compliance enforcement (e.g. ZDR cannot be flipped when zdrLocked is True except by a superadmin) lives in update_settings.
         * @summary Internal Update Enterprise Settings
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateEnterpriseSettings: async (enterpriseId: string, updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('internalUpdateEnterpriseSettings', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateEnterpriseSettingsRequest' is not null or undefined
            assertParamExists('internalUpdateEnterpriseSettings', 'updateEnterpriseSettingsRequest', updateEnterpriseSettingsRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/settings`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Override a user\'s personal trial end date (support action). Capped at 365 days.
         * @summary Internal Update User Trial End
         * @param {UpdateUserTrialEndRequest} updateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateUserTrialEnd: async (updateUserTrialEndRequest: UpdateUserTrialEndRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserTrialEndRequest' is not null or undefined
            assertParamExists('internalUpdateUserTrialEnd', 'updateUserTrialEndRequest', updateUserTrialEndRequest)
            const localVarPath = `/api/v1/internal/users/trial-end`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserTrialEndRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all enterprise billing configs (internal admin only).
         * @summary List Billing Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillingConfigs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/billing-configs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCentersForEnterprise: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listCostCentersForEnterprise', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/billing-ops/cost-centers/{enterprise_id}`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCentersForEnterprise_4: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listCostCentersForEnterprise_4', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/billing-ops/cost-centers/{enterprise_id}`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List enterprise pilots, optionally filtered by active/expired status (internal admin only).
         * @summary List Enterprise Pilots
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {ListEnterprisePilotsStatusEnum} [status] Filter by status: \&#39;active\&#39;, \&#39;expired\&#39;, or omit for all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnterprisePilots: async (limit?: number, offset?: number, status?: ListEnterprisePilotsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/enterprises/pilots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Scan eligible finalized meetings, including unannotated meetings, without reading transcript artifacts.
         * @summary List Meeting Relabeler Inventory
         * @param {string | null} [cursor] 
         * @param {string | null} [cutoff] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeetingRelabelerInventory: async (cursor?: string | null, cutoff?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meetings/attribution/relabeler/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (cutoff !== undefined) {
                localVarQueryParameter['cutoff'] = (cutoff as any instanceof Date) ?
                    (cutoff as any).toISOString() :
                    cutoff;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/billing-ops/operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperations_5: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/billing-ops/operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List promo campaigns with pagination (internal admin only).
         * @summary List Promo Campaigns
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoCampaigns: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/promo/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the codes for a promo campaign with pagination (internal admin only).
         * @summary List Promo Codes
         * @param {string} campaignId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoCodes: async (campaignId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('listPromoCodes', 'campaignId', campaignId)
            const localVarPath = `/api/v1/internal/promo/campaigns/{campaign_id}/codes`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List promo redemptions, optionally filtered by campaign (internal admin only).
         * @summary List Promo Redemptions
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [campaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoRedemptions: async (limit?: number, offset?: number, campaignId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/promo/redemptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (campaignId !== undefined) {
                localVarQueryParameter['campaign_id'] = campaignId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentInvoicesForCostCenter: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('listRecentInvoicesForCostCenter', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/internal/billing-ops/invoices/{cost_center_id}`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentInvoicesForCostCenter_6: async (costCenterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('listRecentInvoicesForCostCenter_6', 'costCenterId', costCenterId)
            const localVarPath = `/api/v1/internal/billing-ops/invoices/{cost_center_id}`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Identify transcript keywords for an eligible internal reviewer.
         * @summary Post Meeting Attribution Gt Keywords
         * @param {string} meetingId 
         * @param {MeetingAttributionGtKeywordsRequest} meetingAttributionGtKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeetingAttributionGtKeywords: async (meetingId: string, meetingAttributionGtKeywordsRequest: MeetingAttributionGtKeywordsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('postMeetingAttributionGtKeywords', 'meetingId', meetingId)
            // verify required parameter 'meetingAttributionGtKeywordsRequest' is not null or undefined
            assertParamExists('postMeetingAttributionGtKeywords', 'meetingAttributionGtKeywordsRequest', meetingAttributionGtKeywordsRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/gt-keywords`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingAttributionGtKeywordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview: async (previewRequest: PreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewRequest' is not null or undefined
            assertParamExists('preview', 'previewRequest', previewRequest)
            const localVarPath = `/api/v1/internal/billing-ops/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dry-run preview of a single enterprise\'s directory sync.  Computes the link/provision/remove diff against WorkOS without mutating anything, so the admin can confirm before running the actual sync.
         * @summary Preview Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewEnterpriseDirectoryUsers: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('previewEnterpriseDirectoryUsers', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/sync-directory-users/preview`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFlowStateProfiles: async (flowStatePreviewRequest: FlowStatePreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowStatePreviewRequest' is not null or undefined
            assertParamExists('previewFlowStateProfiles', 'flowStatePreviewRequest', flowStatePreviewRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowStatePreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run one explicitly selected, non-persistent consensus preview.
         * @summary Preview Meeting Speaker Consensus
         * @param {string} meetingId 
         * @param {ConsensusPreviewRequest} consensusPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMeetingSpeakerConsensus: async (meetingId: string, consensusPreviewRequest: ConsensusPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('previewMeetingSpeakerConsensus', 'meetingId', meetingId)
            // verify required parameter 'consensusPreviewRequest' is not null or undefined
            assertParamExists('previewMeetingSpeakerConsensus', 'consensusPreviewRequest', consensusPreviewRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/speaker-consensus/preview`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consensusPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWeeklyStats: async (weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsPreviewRequest' is not null or undefined
            assertParamExists('previewWeeklyStats', 'weeklyStatsPreviewRequest', weeklyStatsPreviewRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview_7: async (previewRequest: PreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewRequest' is not null or undefined
            assertParamExists('preview_7', 'previewRequest', previewRequest)
            const localVarPath = `/api/v1/internal/billing-ops/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or replace an enterprise\'s prod Public API access policy (internal superadmin only).  Pass the `policy_version` you loaded as `expected_policy_version`, or null when there is no policy yet; a concurrent edit returns 409.
         * @summary Put Public Api Access
         * @param {string} enterpriseId 
         * @param {UpdatePublicAPIPolicyRequest} updatePublicAPIPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPublicApiAccess: async (enterpriseId: string, updatePublicAPIPolicyRequest: UpdatePublicAPIPolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('putPublicApiAccess', 'enterpriseId', enterpriseId)
            // verify required parameter 'updatePublicAPIPolicyRequest' is not null or undefined
            assertParamExists('putPublicApiAccess', 'updatePublicAPIPolicyRequest', updatePublicAPIPolicyRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/public-api-access`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePublicAPIPolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reactivate an ended enterprise pilot as a sales-owned pilot (internal admin only).  Resolves the admin email + primary domain server-side from the enterprise\'s existing records, then delegates to the standard create-pilot flow. Use update-pilot-end instead when the pilot is still live.
         * @summary Reactivate Enterprise Pilot
         * @param {string} enterpriseId 
         * @param {ReactivateEnterprisePilotRequest} reactivateEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEnterprisePilot: async (enterpriseId: string, reactivateEnterprisePilotRequest: ReactivateEnterprisePilotRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('reactivateEnterprisePilot', 'enterpriseId', enterpriseId)
            // verify required parameter 'reactivateEnterprisePilotRequest' is not null or undefined
            assertParamExists('reactivateEnterprisePilot', 'reactivateEnterprisePilotRequest', reactivateEnterprisePilotRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/reactivate-pilot`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactivateEnterprisePilotRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove user(s) from an enterprise by email (internal admin only).  Looks up users by email and removes those that belong to this enterprise. Users not found or not in this enterprise are skipped.
         * @summary Remove Users From Enterprise
         * @param {string} enterpriseId 
         * @param {RemoveUsersFromEnterpriseRequest} removeUsersFromEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromEnterprise: async (enterpriseId: string, removeUsersFromEnterpriseRequest: RemoveUsersFromEnterpriseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('removeUsersFromEnterprise', 'enterpriseId', enterpriseId)
            // verify required parameter 'removeUsersFromEnterpriseRequest' is not null or undefined
            assertParamExists('removeUsersFromEnterprise', 'removeUsersFromEnterpriseRequest', removeUsersFromEnterpriseRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/remove`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeUsersFromEnterpriseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a file to bulk remove users from an enterprise (internal admin only).  Removes users from the enterprise, clears their enterprise association, updates Stripe seats, and triggers all necessary side effects.  File format: plain text with emails separated by commas or newlines.
         * @summary Remove Users From Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromEnterpriseFileUpload: async (enterpriseId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('removeUsersFromEnterpriseFileUpload', 'enterpriseId', enterpriseId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('removeUsersFromEnterpriseFileUpload', 'file', file)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/remove/upload`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rerun the speaker-relabeler comparison on stored artifacts; save it for the refined revision when possible.
         * @summary Replay Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayMeetingAttributionRelabeler: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('replayMeetingAttributionRelabeler', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/relabeler/replay`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rebuild, fold by fold, the speaker labels the live transcript showed during the meeting.
         * @summary Replay Meeting Live Speakers
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayMeetingLiveSpeakers: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('replayMeetingLiveSpeakers', 'meetingId', meetingId)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/live-replay`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace the meeting\'s published transcript and summary by re-running one job\'s retained audio.
         * @summary Rerun Meeting Attribution Job
         * @param {string} meetingId 
         * @param {string} sourceJobId 
         * @param {MeetingAttributionJobRerunRequest} meetingAttributionJobRerunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rerunMeetingAttributionJob: async (meetingId: string, sourceJobId: string, meetingAttributionJobRerunRequest: MeetingAttributionJobRerunRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('rerunMeetingAttributionJob', 'meetingId', meetingId)
            // verify required parameter 'sourceJobId' is not null or undefined
            assertParamExists('rerunMeetingAttributionJob', 'sourceJobId', sourceJobId)
            // verify required parameter 'meetingAttributionJobRerunRequest' is not null or undefined
            assertParamExists('rerunMeetingAttributionJob', 'meetingAttributionJobRerunRequest', meetingAttributionJobRerunRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/jobs/{source_job_id}/rerun`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"source_job_id"}}`, encodeURIComponent(String(sourceJobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingAttributionJobRerunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suspend a sales-owned enterprise\'s access (superadmin only).  Cancels the enterprise\'s `sales_owned` cost center; the UPDATE is scoped to that provider so Stripe-billed rows are never touched. Memberships stay; access ends on the next entitlement read. Resume by re-running /enterprises/create-sales-led with `billing_provider=sales_owned`.
         * @summary Revoke Sales Owned Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSalesOwnedAccess: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('revokeSalesOwnedAccess', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/revoke-sales-owned-access`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update the ground-truth document under optimistic-concurrency control.
         * @summary Save Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtSaveRequest} meetingAttributionGtSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeetingAttributionGroundTruth: async (meetingId: string, meetingAttributionGtSaveRequest: MeetingAttributionGtSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('saveMeetingAttributionGroundTruth', 'meetingId', meetingId)
            // verify required parameter 'meetingAttributionGtSaveRequest' is not null or undefined
            assertParamExists('saveMeetingAttributionGroundTruth', 'meetingAttributionGtSaveRequest', meetingAttributionGtSaveRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/ground-truth`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingAttributionGtSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Record the caller\'s picks once and finish their session.
         * @summary Save Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {MeetingAttributionTurnPreferenceVotesRequest} meetingAttributionTurnPreferenceVotesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeetingAttributionTurnPreference: async (meetingId: string, meetingAttributionTurnPreferenceVotesRequest: MeetingAttributionTurnPreferenceVotesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('saveMeetingAttributionTurnPreference', 'meetingId', meetingId)
            // verify required parameter 'meetingAttributionTurnPreferenceVotesRequest' is not null or undefined
            assertParamExists('saveMeetingAttributionTurnPreference', 'meetingAttributionTurnPreferenceVotesRequest', meetingAttributionTurnPreferenceVotesRequest)
            const localVarPath = `/api/v1/internal/meetings/{meeting_id}/attribution/turn-preference`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingAttributionTurnPreferenceVotesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search enterprises by name or ID (internal admin only).
         * @summary Search Enterprises
         * @param {string} search Search term for enterprise name or ID
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEnterprises: async (search: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'search' is not null or undefined
            assertParamExists('searchEnterprises', 'search', search)
            const localVarPath = `/api/v1/internal/enterprises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a pending invoice for a sales-led enterprise with PO number.
         * @summary Send Enterprise Invoice
         * @param {string} enterpriseId 
         * @param {SendInvoiceRequest} sendInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEnterpriseInvoice: async (enterpriseId: string, sendInvoiceRequest: SendInvoiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('sendEnterpriseInvoice', 'enterpriseId', enterpriseId)
            // verify required parameter 'sendInvoiceRequest' is not null or undefined
            assertParamExists('sendEnterpriseInvoice', 'sendInvoiceRequest', sendInvoiceRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/send-invoice`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFlowStateEmails: async (sendFlowStateRequest: SendFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendFlowStateRequest' is not null or undefined
            assertParamExists('sendFlowStateEmails', 'sendFlowStateRequest', sendFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWeeklyStats: async (weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsSendTestRequest' is not null or undefined
            assertParamExists('sendTestWeeklyStats', 'weeklyStatsSendTestRequest', weeklyStatsSendTestRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/send-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsSendTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant or revoke a customer member\'s enterprise superadmin role (internal superadmin only).  After the Wispr role change commits, the member\'s WorkOS organization role is moved to match. A WorkOS failure leaves the Wispr change in place and reports `workos_synced: false`; repeating the request retries it.
         * @summary Set Enterprise Superadmin
         * @param {string} enterpriseId 
         * @param {SetEnterpriseSuperadminRequest} setEnterpriseSuperadminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEnterpriseSuperadmin: async (enterpriseId: string, setEnterpriseSuperadminRequest: SetEnterpriseSuperadminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('setEnterpriseSuperadmin', 'enterpriseId', enterpriseId)
            // verify required parameter 'setEnterpriseSuperadminRequest' is not null or undefined
            assertParamExists('setEnterpriseSuperadmin', 'setEnterpriseSuperadminRequest', setEnterpriseSuperadminRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/superadmin`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setEnterpriseSuperadminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync all enterprises that have a WorkOS directory with their SCIM directory users.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_all_completed\' to see results.
         * @summary Sync All Enterprise Directory Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllEnterpriseDirectoryUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/enterprises/sync-all-directory-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync a single enterprise\'s DB users with its WorkOS SCIM directory.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_completed\' to see results.
         * @summary Sync Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEnterpriseDirectoryUsers: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('syncEnterpriseDirectoryUsers', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/sync-directory-users`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync all active (non-deleted) domains for an enterprise to WorkOS (internal admin only).  Use this endpoint to retry WorkOS sync if a previous add/toggle operation reported workos_synced=false.
         * @summary Sync Enterprise Domains To Workos
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEnterpriseDomainsToWorkos: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('syncEnterpriseDomainsToWorkos', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/sync-workos`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle domain deleted status for an enterprise (internal admin only).  When deleted=true, the domain is hidden from customer settings, auto-invite is disabled for that domain, and the domain is removed from WorkOS SSO.
         * @summary Toggle Domain Deleted
         * @param {string} enterpriseId 
         * @param {string} domainId 
         * @param {ToggleDomainDeletedRequest} toggleDomainDeletedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDomainDeleted: async (enterpriseId: string, domainId: string, toggleDomainDeletedRequest: ToggleDomainDeletedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('toggleDomainDeleted', 'enterpriseId', enterpriseId)
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('toggleDomainDeleted', 'domainId', domainId)
            // verify required parameter 'toggleDomainDeletedRequest' is not null or undefined
            assertParamExists('toggleDomainDeleted', 'toggleDomainDeletedRequest', toggleDomainDeletedRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/domains/{domain_id}/toggle-deleted`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)))
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleDomainDeletedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a single promo code (internal admin only).
         * @summary Toggle Promo Code Active
         * @param {string} codeId 
         * @param {boolean} isActive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePromoCodeActive: async (codeId: string, isActive: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeId' is not null or undefined
            assertParamExists('togglePromoCodeActive', 'codeId', codeId)
            // verify required parameter 'isActive' is not null or undefined
            assertParamExists('togglePromoCodeActive', 'isActive', isActive)
            const localVarPath = `/api/v1/internal/promo/codes/{code_id}`
                .replace(`{${"code_id"}}`, encodeURIComponent(String(codeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerWeeklyStatsBatchRun: async (weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsBatchTriggerRequestBody' is not null or undefined
            assertParamExists('triggerWeeklyStatsBatchRun', 'weeklyStatsBatchTriggerRequestBody', weeklyStatsBatchTriggerRequestBody)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsBatchTriggerRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an enterprise billing config (internal admin only).
         * @summary Update Billing Config
         * @param {string} configId 
         * @param {EnterpriseBillingConfigUpdate} enterpriseBillingConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingConfig: async (configId: string, enterpriseBillingConfigUpdate: EnterpriseBillingConfigUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configId' is not null or undefined
            assertParamExists('updateBillingConfig', 'configId', configId)
            // verify required parameter 'enterpriseBillingConfigUpdate' is not null or undefined
            assertParamExists('updateBillingConfig', 'enterpriseBillingConfigUpdate', enterpriseBillingConfigUpdate)
            const localVarPath = `/api/v1/internal/billing-configs/{config_id}`
                .replace(`{${"config_id"}}`, encodeURIComponent(String(configId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enterpriseBillingConfigUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename an enterprise (internal admin only).  No-ops when the trimmed name matches the current name. Rejects a name already used by another active enterprise with 409. Does not update the WorkOS organization label.  Args:     request:          The incoming HTTP request (rate-limiter dependency contract).     enterprise_id:    The enterprise to rename.     data:             Request body carrying the new name.     internal_service: Injected internal admin service.     user:             The authenticated user; must be an internal Wispr admin.  Returns:     ORJSONResponse: The enterprise id and its new name.  Raises:     HTTPException: Propagated unchanged when it is what the rename itself already raised.     HTTPInternalServerError: The rename failed for an unexpected reason.
         * @summary Update Enterprise Name
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseNameRequest} updateEnterpriseNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseName: async (enterpriseId: string, updateEnterpriseNameRequest: UpdateEnterpriseNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateEnterpriseName', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateEnterpriseNameRequest' is not null or undefined
            assertParamExists('updateEnterpriseName', 'updateEnterpriseNameRequest', updateEnterpriseNameRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/name`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEnterpriseNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the pilot end date for an enterprise (internal admin with role only).  The new pilot_end must be at least 24 hours in the future. A sales-owned pilot is updated in our database; a legacy pilot\'s Stripe trial_end is updated (a webhook syncs it back to ``cost_center.pilot_end``). ``cost_center_id`` is optional: omit it to target the enterprise\'s oldest live cost center (legacy behavior), or pass it to target a specific one when the enterprise has 2+ live cost centers.
         * @summary Update Enterprise Pilot End
         * @param {string} enterpriseId 
         * @param {UpdatePilotEndRequest} updatePilotEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterprisePilotEnd: async (enterpriseId: string, updatePilotEndRequest: UpdatePilotEndRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateEnterprisePilotEnd', 'enterpriseId', enterpriseId)
            // verify required parameter 'updatePilotEndRequest' is not null or undefined
            assertParamExists('updateEnterprisePilotEnd', 'updatePilotEndRequest', updatePilotEndRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/update-pilot-end`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePilotEndRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a pilot override for selected members as a Wispr internal admin.
         * @summary Update Notetaker Entitlements
         * @param {string} enterpriseId 
         * @param {UpdateNotetakerEntitlementsRequest} updateNotetakerEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotetakerEntitlements: async (enterpriseId: string, updateNotetakerEntitlementsRequest: UpdateNotetakerEntitlementsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateNotetakerEntitlements', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateNotetakerEntitlementsRequest' is not null or undefined
            assertParamExists('updateNotetakerEntitlements', 'updateNotetakerEntitlementsRequest', updateNotetakerEntitlementsRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/notetaker-entitlements`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotetakerEntitlementsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle preserve_contracted_seats for an enterprise (internal admin only).
         * @summary Update Preserve Contracted Seats
         * @param {string} enterpriseId 
         * @param {UpdatePreserveContractedSeatsRequest} updatePreserveContractedSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreserveContractedSeats: async (enterpriseId: string, updatePreserveContractedSeatsRequest: UpdatePreserveContractedSeatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updatePreserveContractedSeats', 'enterpriseId', enterpriseId)
            // verify required parameter 'updatePreserveContractedSeatsRequest' is not null or undefined
            assertParamExists('updatePreserveContractedSeats', 'updatePreserveContractedSeatsRequest', updatePreserveContractedSeatsRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/preserve-seats`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePreserveContractedSeatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing promo campaign (internal admin only).
         * @summary Update Promo Campaign
         * @param {string} campaignId 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCampaign: async (campaignId: string, updateCampaignRequest: UpdateCampaignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('updatePromoCampaign', 'campaignId', campaignId)
            // verify required parameter 'updateCampaignRequest' is not null or undefined
            assertParamExists('updatePromoCampaign', 'updateCampaignRequest', updateCampaignRequest)
            const localVarPath = `/api/v1/internal/promo/campaigns/{campaign_id}`
                .replace(`{${"campaign_id"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCampaignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a single user\'s role in an enterprise (internal admin only).  - User must exist and be in this enterprise - Cannot demote if it would leave enterprise with zero admins
         * @summary Update User Enterprise Role
         * @param {string} enterpriseId 
         * @param {UpdateUsersRoleRequest} updateUsersRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEnterpriseRole: async (enterpriseId: string, updateUsersRoleRequest: UpdateUsersRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateUserEnterpriseRole', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateUsersRoleRequest' is not null or undefined
            assertParamExists('updateUserEnterpriseRole', 'updateUsersRoleRequest', updateUsersRoleRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/update-role`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUsersRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a CSV/text file to bulk update user roles (internal admin only).  File format: plain text with emails separated by commas or newlines. Role is specified as a query parameter.
         * @summary Update User Roles File Upload
         * @param {string} enterpriseId 
         * @param {EnterpriseRole} role Target role: \&#39;admin\&#39; or \&#39;member\&#39;
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesFileUpload: async (enterpriseId: string, role: EnterpriseRole, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateUserRolesFileUpload', 'enterpriseId', enterpriseId)
            // verify required parameter 'role' is not null or undefined
            assertParamExists('updateUserRolesFileUpload', 'role', role)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateUserRolesFileUpload', 'file', file)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/members/update-role-bulk`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set or unlink workos_directory_id for an enterprise (internal admin only).
         * @summary Update Workos Directory Id
         * @param {string} enterpriseId 
         * @param {UpdateWorkosDirectoryIdRequest} updateWorkosDirectoryIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkosDirectoryId: async (enterpriseId: string, updateWorkosDirectoryIdRequest: UpdateWorkosDirectoryIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('updateWorkosDirectoryId', 'enterpriseId', enterpriseId)
            // verify required parameter 'updateWorkosDirectoryIdRequest' is not null or undefined
            assertParamExists('updateWorkosDirectoryId', 'updateWorkosDirectoryIdRequest', updateWorkosDirectoryIdRequest)
            const localVarPath = `/api/v1/internal/enterprises/{enterprise_id}/workos-directory-id`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWorkosDirectoryIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a domain to an enterprise (internal admin only).  If the enterprise has SSO enabled (workos_org_id), the domain will also be synced to WorkOS. The response includes a `workos_synced` field indicating whether the sync was successful.
         * @summary Add Enterprise Domain
         * @param {AddEnterpriseDomainRequest} addEnterpriseDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEnterpriseDomain(addEnterpriseDomainRequest: AddEnterpriseDomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddEnterpriseDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEnterpriseDomain(addEnterpriseDomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.addEnterpriseDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add user(s) to an enterprise (internal admin only).  - If a user is not in any enterprise: onboards them to the enterprise - If a user is already in this enterprise: skips them (included in skipped_count) - If a user is in a different enterprise: marks as failed - If a user is not found and create_missing_users is False: marks as failed - If a user is not found and create_missing_users is True: sends a pending   enterprise invitation (does not create an auth/User row)  Partial success: Adds all users that can be added and returns details about failures.
         * @summary Add Users To Enterprise
         * @param {string} enterpriseId 
         * @param {AddUsersToEnterpriseRequest} addUsersToEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUsersToEnterprise(enterpriseId: string, addUsersToEnterpriseRequest: AddUsersToEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddUsersToEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUsersToEnterprise(enterpriseId, addUsersToEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.addUsersToEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a file to bulk add users to an enterprise (internal admin only).  File contains emails separated by commas or newlines, without headers or name columns.  When create_missing_users is False (default): emails must belong to existing users.  When create_missing_users is True: emails with no User row are invited; existing users are still force-added.
         * @summary Add Users To Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {boolean} [createMissingUsers] 
         * @param {EnterpriseRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUsersToEnterpriseFileUpload(enterpriseId: string, file: File, createMissingUsers?: boolean, role?: EnterpriseRole, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddUsersToEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUsersToEnterpriseFileUpload(enterpriseId, file, createMissingUsers, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.addUsersToEnterpriseFileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply a referral code to a user on their behalf. Admin only.
         * @summary Admin Apply Referral
         * @param {AdminApplyReferralRequest} adminApplyReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminApplyReferral(adminApplyReferralRequest: AdminApplyReferralRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminApplyReferralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminApplyReferral(adminApplyReferralRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.adminApplyReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Super-admin: list all stored voice memories for a list of users.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin List User Memories
         * @param {AdminMemoryListRequest} adminMemoryListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListUserMemories(adminMemoryListRequest: AdminMemoryListRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMemoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListUserMemories(adminMemoryListRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.adminListUserMemories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Look up a user by email or user_id and return their profile and subscription info.
         * @summary Admin Lookup User
         * @param {string} q Email address or user_id to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLookupUser(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserLookupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLookupUser(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.adminLookupUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Super-admin: semantic-search voice memory for a list of users by a context query.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin Search User Memories
         * @param {AdminMemorySearchRequest} adminMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSearchUserMemories(adminMemorySearchRequest: AdminMemorySearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMemorySearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSearchUserMemories(adminMemorySearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.adminSearchUserMemories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Overwrite a user\'s stripe_customer_id (dry-run by default).
         * @summary Admin Update Stripe Customer Id
         * @param {AdminUpdateStripeCustomerIdRequest} adminUpdateStripeCustomerIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest: AdminUpdateStripeCustomerIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUpdateStripeCustomerIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.adminUpdateStripeCustomerId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commit(commitRequest: CommitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commit(commitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.commit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commit_1(commitRequest: CommitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commit_1(commitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.commit_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new enterprise billing config (internal admin only).
         * @summary Create Billing Config
         * @param {EnterpriseBillingConfigCreate} enterpriseBillingConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBillingConfig(enterpriseBillingConfigCreate: EnterpriseBillingConfigCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseBillingConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBillingConfig(enterpriseBillingConfigCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createBillingConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a domain to the block list (internal admin only).
         * @summary Create Blocked Domain
         * @param {AddBlockedDomainRequest} addBlockedDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBlockedDomain(addBlockedDomainRequest: AddBlockedDomainRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddBlockedDomainResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBlockedDomain(addBlockedDomainRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createBlockedDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an enterprise pilot: sales-owned access until ``trial_end``, then ended automatically.
         * @summary Create Enterprise Pilot
         * @param {CreateEnterprisePilotRequest} createEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnterprisePilot(createEnterprisePilotRequest: CreateEnterprisePilotRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnterprisePilot(createEnterprisePilotRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createEnterprisePilot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new promo campaign (internal admin only).
         * @summary Create Promo Campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoCampaign(createCampaignRequest: CreateCampaignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoCampaign(createCampaignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createPromoCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate new codes for a promo campaign (internal admin only).
         * @summary Create Promo Codes
         * @param {string} campaignId 
         * @param {CreateCodesRequest} createCodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromoCodes(campaignId: string, createCodesRequest: CreateCodesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateCodesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromoCodes(campaignId, createCodesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createPromoCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a sales-led enterprise with deferred invoicing.  Creates the enterprise, Stripe subscription, and a draft invoice. The invoice stays as a draft until sales unpauses collection via /send-invoice (below).  With `billing_provider=sales_owned` no Stripe objects are created: the enterprise\'s General cost center goes live as `sales_owned` and billing stays in Salesforce.
         * @summary Create Sales Led Enterprise
         * @param {CreateSalesLedEnterpriseRequest} createSalesLedEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesLedEnterprise(createSalesLedEnterpriseRequest: CreateSalesLedEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSalesLedEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesLedEnterprise(createSalesLedEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createSalesLedEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a sales-led enterprise with a negotiated custom billing config.  Superadmin-gated counterpart to /create-sales-led: takes the same payload plus a required `custom_billing_config`. Splitting it out keeps the auth escalation visible in the route signature and OpenAPI, matching the sensitivity of /billing-configs/create.
         * @summary Create Sales Led Enterprise Custom Billing
         * @param {CreateSalesLedEnterpriseCustomBillingRequest} createSalesLedEnterpriseCustomBillingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest: CreateSalesLedEnterpriseCustomBillingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSalesLedEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.createSalesLedEnterpriseCustomBilling']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an enterprise billing config (internal admin only).
         * @summary Delete Billing Config
         * @param {string} configId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBillingConfig(configId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBillingConfig(configId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.deleteBillingConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a domain from the block list (internal admin only).
         * @summary Delete Blocked Domain
         * @param {string} blockedDomainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteBlockedDomain(blockedDomainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteBlockedDomain(blockedDomainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.deleteBlockedDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Drop the working copy; the next load starts from the consensus prefill or the finalized bundle.
         * @summary Discard Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {number} expectedVersion Version the client loaded; 409 if the row has moved on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discardMeetingAttributionGroundTruth(meetingId: string, expectedVersion: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtDiscardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discardMeetingAttributionGroundTruth(meetingId, expectedVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.discardMeetingAttributionGroundTruth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorize a version-matched private extension download.
         * @summary Download Extension Bundle
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadExtensionBundle(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtensionBundleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadExtensionBundle(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.downloadExtensionBundle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export all codes for a promo campaign as a CSV attachment (internal admin only).
         * @summary Export Promo Codes Csv
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportPromoCodesCsv(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportPromoCodesCsv(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.exportPromoCodesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write the complete working copy to the durable bundle store as a new generation.
         * @summary Finalize Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtFinalizeRequest} meetingAttributionGtFinalizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finalizeMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtFinalizeRequest: MeetingAttributionGtFinalizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtFinalizeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finalizeMeetingAttributionGroundTruth(meetingId, meetingAttributionGtFinalizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.finalizeMeetingAttributionGroundTruth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.generateAndSendFlowStateEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFlowStateProfiles(generateFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.generateFlowStateProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsGenerateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWeeklyStats(weeklyStatsGenerateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.generateWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all blocked domains (internal admin only).
         * @summary Get Blocked Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockedDomains(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedDomainsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockedDomains(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getBlockedDomains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get enterprise details including domains (internal admin only).
         * @summary Get Enterprise Details
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseDetails(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseDetails(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getEnterpriseDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get members of an enterprise with pagination, search, and sort (internal admin only).
         * @summary Get Enterprise Members
         * @param {string} enterpriseId 
         * @param {number} [limit] Maximum number of members to return
         * @param {number} [offset] Number of members to skip
         * @param {string | null} [search] Case-insensitive search across name and email
         * @param {GetEnterpriseMembersSortByEnum} [sortBy] 
         * @param {GetEnterpriseMembersSortDirEnum} [sortDir] 
         * @param {EnterpriseRole | null} [role] Only members with this role, matched case-insensitively
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEnterpriseMembers(enterpriseId: string, limit?: number, offset?: number, search?: string | null, sortBy?: GetEnterpriseMembersSortByEnum, sortDir?: GetEnterpriseMembersSortDirEnum, role?: EnterpriseRole | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEnterpriseMembers(enterpriseId, limit, offset, search, sortBy, sortDir, role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getEnterpriseMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowStateJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getFlowStateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowStateMonthSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowStateMonthSummary(reportingMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getFlowStateMonthSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchLatestRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getLatestWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a scoped playback or download audio URL when the meeting has audio.
         * @summary Get Meeting Attribution Audio Url
         * @param {string} meetingId 
         * @param {boolean} [download] 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionAudioUrl(meetingId: string, download?: boolean, jobId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAudioUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionAudioUrl(meetingId, download, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionAudioUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the saved ground-truth document for a meeting, or null when none exists.
         * @summary Get Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionGroundTruth(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtDocumentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionGroundTruth(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionGroundTruth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Per-person and per-platform annotation progress across all ground-truth meetings.
         * @summary Get Meeting Attribution Ground Truth Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionGroundTruthLeaderboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionGroundTruthLeaderboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionGroundTruthLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the raw JSON pinned to the annotation\'s prefill identity.
         * @summary Get Meeting Attribution Ground Truth Raw
         * @param {string} meetingId 
         * @param {string} expectedPrefillVersion 
         * @param {string} expectedRawSha256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionGroundTruthRaw(meetingId: string, expectedPrefillVersion: string, expectedRawSha256: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionGroundTruthRaw(meetingId, expectedPrefillVersion, expectedRawSha256, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionGroundTruthRaw']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the finalized guard-bundle export for a meeting\'s saved ground truth.
         * @summary Get Meeting Attribution Gt Export
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionGtExport(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionGtExport(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionGtExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a machine-drafted prefill, annotation eligibility, and any saved document.
         * @summary Get Meeting Attribution Gt Prefill
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionGtPrefill(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtPrefillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionGtPrefill(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionGtPrefill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the live meeting\'s refine jobs for internal inspection.
         * @summary Get Meeting Attribution Jobs
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionJobs(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionJobs(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the exact stored live-transcript NDJSON body.
         * @summary Get Meeting Attribution Live
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionLive(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionLive(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionLive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return paired raw provider inputs for the displayed refinement.
         * @summary Get Meeting Attribution Provider Artifacts
         * @param {string} meetingId 
         * @param {string | null} [expectedRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionProviderArtifacts(meetingId: string, expectedRevision?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProviderArtifactsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionProviderArtifacts(meetingId, expectedRevision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionProviderArtifacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the exact stored refined-transcript NDJSON body.
         * @summary Get Meeting Attribution Refined
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionRefined(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionRefined(meetingId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionRefined']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the exact stored archived refine JSON body.
         * @summary Get Meeting Attribution Refined Raw
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionRefinedRaw(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionRefinedRaw(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionRefinedRaw']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the stored speaker-relabeler comparison for the meeting\'s current refined revision, if any.
         * @summary Get Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelabelerComparisonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionRelabeler(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionRelabeler']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the speaker labels refine shipped for the meeting\'s current refined revision, before user edits.
         * @summary Get Meeting Attribution Shipped
         * @param {string} meetingId 
         * @param {string | null} [revision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionShipped(meetingId: string, revision?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippedAttributionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionShipped(meetingId, revision, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionShipped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the meeting\'s persisted durable speaker map when valid.
         * @summary Get Meeting Attribution Speaker Map
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionSpeakerMap(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingSpeakerMapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionSpeakerMap(meetingId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionSpeakerMap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the exact stored speaker-observation NDJSON body.
         * @summary Get Meeting Attribution Speaker Observations
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionSpeakerObservations(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionSpeakerObservations(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionSpeakerObservations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Serve the caller\'s blind two-sided comparison for the meeting, computing and storing it on first read.
         * @summary Get Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionTurnPreference(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionTurnPreferenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionTurnPreference(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionTurnPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Votes per provider and a sign test over every finished blind turn-preference session.
         * @summary Get Meeting Attribution Turn Preference Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingAttributionTurnPreferenceResults(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionTurnPreferenceResultsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingAttributionTurnPreferenceResults(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getMeetingAttributionTurnPreferenceResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if an enterprise has a pending draft invoice (internal admin only).
         * @summary Get Pending Invoice
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingInvoice(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingInvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingInvoice(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getPendingInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single promo campaign by ID (internal admin only).
         * @summary Get Promo Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromoCampaign(campaignId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromoCampaign(campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getPromoCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * An enterprise\'s prod Public API access policy, or null (internal superadmin only).
         * @summary Get Public Api Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicApiAccess(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicAPIPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicApiAccess(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getPublicApiAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the public/webmail domain list (internal admin only).
         * @summary Get Public Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicDomains(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicDomainsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicDomains(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getPublicDomains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the university domain list (internal admin only).
         * @summary Get University Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUniversityDomains(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UniversityDomainsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUniversityDomains(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getUniversityDomains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchRunStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyStatsBatchRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchTriggerStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyStatsBatchTriggerRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getWeeklyStatsBatchTriggerRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Live WorkOS directory status for an enterprise (internal admin only).  Lists the enterprise\'s directories straight from WorkOS and echoes the stored directory ID; WorkOS failures degrade to a 200 ``unknown`` payload, never a 5xx.  Args:     enterprise_id:    The enterprise whose directory status to check.     internal_service: Injected internal admin service.     user:             The authenticated caller; must be a Wispr internal admin.  Returns:     The three-shape status payload (``ok`` / ``not_connected`` / ``unknown``) as JSON.
         * @summary Get Workos Directory Status
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkosDirectoryStatus(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkosDirectoryStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkosDirectoryStatus(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.getWorkosDirectoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create missing users and apply per-user or fallback personal trial end dates.
         * @summary Internal Bulk Provision User Trial End
         * @param {BulkProvisionUserTrialEndRequest} bulkProvisionUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest: BulkProvisionUserTrialEndRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateUserTrialEndResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalBulkProvisionUserTrialEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override the personal trial end date for a list of users (support action).  Applies the same date to every user; per-user failures (e.g. unknown email) are reported in the response rows instead of failing the batch.  Args:     request:          Incoming request (required by the rate limiter dependencies).     data:             Target user emails and the trial end date to apply.     internal_service: Injected internal admin service.     user:             Authenticated caller; must be an internal admin with an admin role.  Returns:     Per-user results plus updated_count/failed_count/total_count.  Raises:     HTTPException: 400: trial_end is in the past or exceeds the 365-day cap.     HTTPInternalServerError: Unexpected failure while processing the batch.
         * @summary Internal Bulk Update User Trial End
         * @param {BulkUpdateUserTrialEndRequest} bulkUpdateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest: BulkUpdateUserTrialEndRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateUserTrialEndResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalBulkUpdateUserTrialEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match.
         * @summary Internal Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCheckDomainVerification(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCheckDomainVerification(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalCheckDomainVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new enterprise for a given name/domain, and set the given email as the admin user.  Creates a new user, enterprise, and Stripe customer. Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Internal Create Enterprise
         * @param {CreateEnterpriseFromAdminRequest} createEnterpriseFromAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalCreateEnterprise(createEnterpriseFromAdminRequest: CreateEnterpriseFromAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalCreateEnterprise(createEnterpriseFromAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalCreateEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disband an enterprise. Cancels Stripe subscription, removes all members, and sends a Slack notification.
         * @summary Internal Disband Enterprise
         * @param {string} enterpriseId 
         * @param {DisbandEnterpriseRequest} disbandEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalDisbandEnterprise(enterpriseId: string, disbandEnterpriseRequest: DisbandEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisbandEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalDisbandEnterprise(enterpriseId, disbandEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalDisbandEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return current verification status (including TXT record) for a single domain.
         * @summary Internal Get Domain Verification Status
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalGetDomainVerificationStatus(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalGetDomainVerificationStatus(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalGetDomainVerificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification.
         * @summary Internal Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalInitiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DomainVerificationInitiateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalInitiateDomainVerification(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalInitiateDomainVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPreviewCostCenterProvision(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalCostCenterProvisionPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPreviewCostCenterProvision(internalCostCenterProvisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalPreviewCostCenterProvision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalCostCenterProvisionPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalPreviewCostCenterProvision_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalProvisionCostCenter(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalCostCenterProvisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalProvisionCostCenter(internalCostCenterProvisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalProvisionCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalProvisionCostCenter_3(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InternalCostCenterProvisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalProvisionCostCenter_3(internalCostCenterProvisionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalProvisionCostCenter_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Wispr-controlled enterprise gates (internal admin only).  Any @wispr.ai admin can flip keys in ADMIN_GATES; SUPERADMIN_GATES require an @wispr.ai superadmin (enforced inside update_gates).
         * @summary Internal Update Enterprise Gates
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseGatesRequest} updateEnterpriseGatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalUpdateEnterpriseGates(enterpriseId: string, updateEnterpriseGatesRequest: UpdateEnterpriseGatesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalUpdateEnterpriseGates(enterpriseId, updateEnterpriseGatesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalUpdateEnterpriseGates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override customer-settable enterprise settings (internal admin only, for support fixups).  Gate keys (usageExportAllowed, zdrLocked, restrictDomainAccess) are not accepted here — use PATCH /enterprises/{id}/gates. Per-key compliance enforcement (e.g. ZDR cannot be flipped when zdrLocked is True except by a superadmin) lives in update_settings.
         * @summary Internal Update Enterprise Settings
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalUpdateEnterpriseSettings(enterpriseId: string, updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalUpdateEnterpriseSettings(enterpriseId, updateEnterpriseSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalUpdateEnterpriseSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Override a user\'s personal trial end date (support action). Capped at 365 days.
         * @summary Internal Update User Trial End
         * @param {UpdateUserTrialEndRequest} updateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalUpdateUserTrialEnd(updateUserTrialEndRequest: UpdateUserTrialEndRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUserTrialEndResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalUpdateUserTrialEnd(updateUserTrialEndRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.internalUpdateUserTrialEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all enterprise billing configs (internal admin only).
         * @summary List Billing Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillingConfigs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseBillingConfigListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillingConfigs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listBillingConfigs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCostCentersForEnterprise(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCostCentersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCostCentersForEnterprise(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listCostCentersForEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCostCentersForEnterprise_4(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCostCentersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCostCentersForEnterprise_4(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listCostCentersForEnterprise_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List enterprise pilots, optionally filtered by active/expired status (internal admin only).
         * @summary List Enterprise Pilots
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {ListEnterprisePilotsStatusEnum} [status] Filter by status: \&#39;active\&#39;, \&#39;expired\&#39;, or omit for all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnterprisePilots(limit?: number, offset?: number, status?: ListEnterprisePilotsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterprisePilotsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnterprisePilots(limit, offset, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listEnterprisePilots']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Scan eligible finalized meetings, including unannotated meetings, without reading transcript artifacts.
         * @summary List Meeting Relabeler Inventory
         * @param {string | null} [cursor] 
         * @param {string | null} [cutoff] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMeetingRelabelerInventory(cursor?: string | null, cutoff?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelabelerInventoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMeetingRelabelerInventory(cursor, cutoff, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listMeetingRelabelerInventory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOperationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOperations_5(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOperationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOperations_5(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listOperations_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List promo campaigns with pagination (internal admin only).
         * @summary List Promo Campaigns
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromoCampaigns(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromoCampaigns(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listPromoCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the codes for a promo campaign with pagination (internal admin only).
         * @summary List Promo Codes
         * @param {string} campaignId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromoCodes(campaignId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromoCodes(campaignId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listPromoCodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List promo redemptions, optionally filtered by campaign (internal admin only).
         * @summary List Promo Redemptions
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [campaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPromoRedemptions(limit?: number, offset?: number, campaignId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedemptionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPromoRedemptions(limit, offset, campaignId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listPromoRedemptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecentInvoicesForCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRecentInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecentInvoicesForCostCenter(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listRecentInvoicesForCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecentInvoicesForCostCenter_6(costCenterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRecentInvoicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecentInvoicesForCostCenter_6(costCenterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.listRecentInvoicesForCostCenter_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Identify transcript keywords for an eligible internal reviewer.
         * @summary Post Meeting Attribution Gt Keywords
         * @param {string} meetingId 
         * @param {MeetingAttributionGtKeywordsRequest} meetingAttributionGtKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMeetingAttributionGtKeywords(meetingId: string, meetingAttributionGtKeywordsRequest: MeetingAttributionGtKeywordsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtKeywordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMeetingAttributionGtKeywords(meetingId, meetingAttributionGtKeywordsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.postMeetingAttributionGtKeywords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preview(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preview(previewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.preview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dry-run preview of a single enterprise\'s directory sync.  Computes the link/provision/remove diff against WorkOS without mutating anything, so the admin can confirm before running the actual sync.
         * @summary Preview Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectorySyncPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewEnterpriseDirectoryUsers(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.previewEnterpriseDirectoryUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowStateProfilePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFlowStateProfiles(flowStatePreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.previewFlowStateProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run one explicitly selected, non-persistent consensus preview.
         * @summary Preview Meeting Speaker Consensus
         * @param {string} meetingId 
         * @param {ConsensusPreviewRequest} consensusPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewMeetingSpeakerConsensus(meetingId: string, consensusPreviewRequest: ConsensusPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsensusPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewMeetingSpeakerConsensus(meetingId, consensusPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.previewMeetingSpeakerConsensus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewWeeklyStats(weeklyStatsPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.previewWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preview_7(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preview_7(previewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.preview_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or replace an enterprise\'s prod Public API access policy (internal superadmin only).  Pass the `policy_version` you loaded as `expected_policy_version`, or null when there is no policy yet; a concurrent edit returns 409.
         * @summary Put Public Api Access
         * @param {string} enterpriseId 
         * @param {UpdatePublicAPIPolicyRequest} updatePublicAPIPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPublicApiAccess(enterpriseId: string, updatePublicAPIPolicyRequest: UpdatePublicAPIPolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicAPIPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPublicApiAccess(enterpriseId, updatePublicAPIPolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.putPublicApiAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reactivate an ended enterprise pilot as a sales-owned pilot (internal admin only).  Resolves the admin email + primary domain server-side from the enterprise\'s existing records, then delegates to the standard create-pilot flow. Use update-pilot-end instead when the pilot is still live.
         * @summary Reactivate Enterprise Pilot
         * @param {string} enterpriseId 
         * @param {ReactivateEnterprisePilotRequest} reactivateEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactivateEnterprisePilot(enterpriseId: string, reactivateEnterprisePilotRequest: ReactivateEnterprisePilotRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactivateEnterprisePilot(enterpriseId, reactivateEnterprisePilotRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.reactivateEnterprisePilot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove user(s) from an enterprise by email (internal admin only).  Looks up users by email and removes those that belong to this enterprise. Users not found or not in this enterprise are skipped.
         * @summary Remove Users From Enterprise
         * @param {string} enterpriseId 
         * @param {RemoveUsersFromEnterpriseRequest} removeUsersFromEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUsersFromEnterprise(enterpriseId: string, removeUsersFromEnterpriseRequest: RemoveUsersFromEnterpriseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveUsersFromEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUsersFromEnterprise(enterpriseId, removeUsersFromEnterpriseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.removeUsersFromEnterprise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a file to bulk remove users from an enterprise (internal admin only).  Removes users from the enterprise, clears their enterprise association, updates Stripe seats, and triggers all necessary side effects.  File format: plain text with emails separated by commas or newlines.
         * @summary Remove Users From Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUsersFromEnterpriseFileUpload(enterpriseId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemoveUsersFromEnterpriseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUsersFromEnterpriseFileUpload(enterpriseId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.removeUsersFromEnterpriseFileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rerun the speaker-relabeler comparison on stored artifacts; save it for the refined revision when possible.
         * @summary Replay Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replayMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelabelerReplayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replayMeetingAttributionRelabeler(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.replayMeetingAttributionRelabeler']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rebuild, fold by fold, the speaker labels the live transcript showed during the meeting.
         * @summary Replay Meeting Live Speakers
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replayMeetingLiveSpeakers(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LiveReplayResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replayMeetingLiveSpeakers(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.replayMeetingLiveSpeakers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace the meeting\'s published transcript and summary by re-running one job\'s retained audio.
         * @summary Rerun Meeting Attribution Job
         * @param {string} meetingId 
         * @param {string} sourceJobId 
         * @param {MeetingAttributionJobRerunRequest} meetingAttributionJobRerunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rerunMeetingAttributionJob(meetingId: string, sourceJobId: string, meetingAttributionJobRerunRequest: MeetingAttributionJobRerunRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionJobRerunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rerunMeetingAttributionJob(meetingId, sourceJobId, meetingAttributionJobRerunRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.rerunMeetingAttributionJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suspend a sales-owned enterprise\'s access (superadmin only).  Cancels the enterprise\'s `sales_owned` cost center; the UPDATE is scoped to that provider so Stripe-billed rows are never touched. Memberships stay; access ends on the next entitlement read. Resume by re-running /enterprises/create-sales-led with `billing_provider=sales_owned`.
         * @summary Revoke Sales Owned Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSalesOwnedAccess(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RevokeSalesOwnedAccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSalesOwnedAccess(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.revokeSalesOwnedAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update the ground-truth document under optimistic-concurrency control.
         * @summary Save Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtSaveRequest} meetingAttributionGtSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtSaveRequest: MeetingAttributionGtSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionGtSaveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMeetingAttributionGroundTruth(meetingId, meetingAttributionGtSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.saveMeetingAttributionGroundTruth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Record the caller\'s picks once and finish their session.
         * @summary Save Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {MeetingAttributionTurnPreferenceVotesRequest} meetingAttributionTurnPreferenceVotesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMeetingAttributionTurnPreference(meetingId: string, meetingAttributionTurnPreferenceVotesRequest: MeetingAttributionTurnPreferenceVotesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingAttributionTurnPreferenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMeetingAttributionTurnPreference(meetingId, meetingAttributionTurnPreferenceVotesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.saveMeetingAttributionTurnPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search enterprises by name or ID (internal admin only).
         * @summary Search Enterprises
         * @param {string} search Search term for enterprise name or ID
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEnterprises(search: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AllEnterprisesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEnterprises(search, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.searchEnterprises']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a pending invoice for a sales-led enterprise with PO number.
         * @summary Send Enterprise Invoice
         * @param {string} enterpriseId 
         * @param {SendInvoiceRequest} sendInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEnterpriseInvoice(enterpriseId: string, sendInvoiceRequest: SendInvoiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendInvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEnterpriseInvoice(enterpriseId, sendInvoiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.sendEnterpriseInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFlowStateEmails(sendFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.sendFlowStateEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsSendTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestWeeklyStats(weeklyStatsSendTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.sendTestWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant or revoke a customer member\'s enterprise superadmin role (internal superadmin only).  After the Wispr role change commits, the member\'s WorkOS organization role is moved to match. A WorkOS failure leaves the Wispr change in place and reports `workos_synced: false`; repeating the request retries it.
         * @summary Set Enterprise Superadmin
         * @param {string} enterpriseId 
         * @param {SetEnterpriseSuperadminRequest} setEnterpriseSuperadminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setEnterpriseSuperadmin(enterpriseId: string, setEnterpriseSuperadminRequest: SetEnterpriseSuperadminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetEnterpriseSuperadminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setEnterpriseSuperadmin(enterpriseId, setEnterpriseSuperadminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.setEnterpriseSuperadmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync all enterprises that have a WorkOS directory with their SCIM directory users.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_all_completed\' to see results.
         * @summary Sync All Enterprise Directory Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncAllEnterpriseDirectoryUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectorySyncStartedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncAllEnterpriseDirectoryUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.syncAllEnterpriseDirectoryUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync a single enterprise\'s DB users with its WorkOS SCIM directory.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_completed\' to see results.
         * @summary Sync Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectorySyncStartedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncEnterpriseDirectoryUsers(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.syncEnterpriseDirectoryUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync all active (non-deleted) domains for an enterprise to WorkOS (internal admin only).  Use this endpoint to retry WorkOS sync if a previous add/toggle operation reported workos_synced=false.
         * @summary Sync Enterprise Domains To Workos
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncEnterpriseDomainsToWorkos(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncDomainsToWorkosResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncEnterpriseDomainsToWorkos(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.syncEnterpriseDomainsToWorkos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle domain deleted status for an enterprise (internal admin only).  When deleted=true, the domain is hidden from customer settings, auto-invite is disabled for that domain, and the domain is removed from WorkOS SSO.
         * @summary Toggle Domain Deleted
         * @param {string} enterpriseId 
         * @param {string} domainId 
         * @param {ToggleDomainDeletedRequest} toggleDomainDeletedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleDomainDeleted(enterpriseId: string, domainId: string, toggleDomainDeletedRequest: ToggleDomainDeletedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToggleDomainDeletedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleDomainDeleted(enterpriseId, domainId, toggleDomainDeletedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.toggleDomainDeleted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a single promo code (internal admin only).
         * @summary Toggle Promo Code Active
         * @param {string} codeId 
         * @param {boolean} isActive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async togglePromoCodeActive(codeId: string, isActive: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.togglePromoCodeActive(codeId, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.togglePromoCodeActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchTriggerAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.triggerWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an enterprise billing config (internal admin only).
         * @summary Update Billing Config
         * @param {string} configId 
         * @param {EnterpriseBillingConfigUpdate} enterpriseBillingConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBillingConfig(configId: string, enterpriseBillingConfigUpdate: EnterpriseBillingConfigUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseBillingConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBillingConfig(configId, enterpriseBillingConfigUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateBillingConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename an enterprise (internal admin only).  No-ops when the trimmed name matches the current name. Rejects a name already used by another active enterprise with 409. Does not update the WorkOS organization label.  Args:     request:          The incoming HTTP request (rate-limiter dependency contract).     enterprise_id:    The enterprise to rename.     data:             Request body carrying the new name.     internal_service: Injected internal admin service.     user:             The authenticated user; must be an internal Wispr admin.  Returns:     ORJSONResponse: The enterprise id and its new name.  Raises:     HTTPException: Propagated unchanged when it is what the rename itself already raised.     HTTPInternalServerError: The rename failed for an unexpected reason.
         * @summary Update Enterprise Name
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseNameRequest} updateEnterpriseNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnterpriseName(enterpriseId: string, updateEnterpriseNameRequest: UpdateEnterpriseNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEnterpriseNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterpriseName(enterpriseId, updateEnterpriseNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateEnterpriseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the pilot end date for an enterprise (internal admin with role only).  The new pilot_end must be at least 24 hours in the future. A sales-owned pilot is updated in our database; a legacy pilot\'s Stripe trial_end is updated (a webhook syncs it back to ``cost_center.pilot_end``). ``cost_center_id`` is optional: omit it to target the enterprise\'s oldest live cost center (legacy behavior), or pass it to target a specific one when the enterprise has 2+ live cost centers.
         * @summary Update Enterprise Pilot End
         * @param {string} enterpriseId 
         * @param {UpdatePilotEndRequest} updatePilotEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEnterprisePilotEnd(enterpriseId: string, updatePilotEndRequest: UpdatePilotEndRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdatePilotEndResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEnterprisePilotEnd(enterpriseId, updatePilotEndRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateEnterprisePilotEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a pilot override for selected members as a Wispr internal admin.
         * @summary Update Notetaker Entitlements
         * @param {string} enterpriseId 
         * @param {UpdateNotetakerEntitlementsRequest} updateNotetakerEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotetakerEntitlements(enterpriseId: string, updateNotetakerEntitlementsRequest: UpdateNotetakerEntitlementsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateNotetakerEntitlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotetakerEntitlements(enterpriseId, updateNotetakerEntitlementsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateNotetakerEntitlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle preserve_contracted_seats for an enterprise (internal admin only).
         * @summary Update Preserve Contracted Seats
         * @param {string} enterpriseId 
         * @param {UpdatePreserveContractedSeatsRequest} updatePreserveContractedSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreserveContractedSeats(enterpriseId: string, updatePreserveContractedSeatsRequest: UpdatePreserveContractedSeatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreserveContractedSeats(enterpriseId, updatePreserveContractedSeatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updatePreserveContractedSeats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing promo campaign (internal admin only).
         * @summary Update Promo Campaign
         * @param {string} campaignId 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePromoCampaign(campaignId: string, updateCampaignRequest: UpdateCampaignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePromoCampaign(campaignId, updateCampaignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updatePromoCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a single user\'s role in an enterprise (internal admin only).  - User must exist and be in this enterprise - Cannot demote if it would leave enterprise with zero admins
         * @summary Update User Enterprise Role
         * @param {string} enterpriseId 
         * @param {UpdateUsersRoleRequest} updateUsersRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEnterpriseRole(enterpriseId: string, updateUsersRoleRequest: UpdateUsersRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUsersRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEnterpriseRole(enterpriseId, updateUsersRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateUserEnterpriseRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a CSV/text file to bulk update user roles (internal admin only).  File format: plain text with emails separated by commas or newlines. Role is specified as a query parameter.
         * @summary Update User Roles File Upload
         * @param {string} enterpriseId 
         * @param {EnterpriseRole} role Target role: \&#39;admin\&#39; or \&#39;member\&#39;
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRolesFileUpload(enterpriseId: string, role: EnterpriseRole, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateUsersRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRolesFileUpload(enterpriseId, role, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateUserRolesFileUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set or unlink workos_directory_id for an enterprise (internal admin only).
         * @summary Update Workos Directory Id
         * @param {string} enterpriseId 
         * @param {UpdateWorkosDirectoryIdRequest} updateWorkosDirectoryIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkosDirectoryId(enterpriseId: string, updateWorkosDirectoryIdRequest: UpdateWorkosDirectoryIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkosDirectoryId(enterpriseId, updateWorkosDirectoryIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalApi.updateWorkosDirectoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalApiFp(configuration)
    return {
        /**
         * Add a domain to an enterprise (internal admin only).  If the enterprise has SSO enabled (workos_org_id), the domain will also be synced to WorkOS. The response includes a `workos_synced` field indicating whether the sync was successful.
         * @summary Add Enterprise Domain
         * @param {AddEnterpriseDomainRequest} addEnterpriseDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEnterpriseDomain(addEnterpriseDomainRequest: AddEnterpriseDomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddEnterpriseDomainResponse> {
            return localVarFp.addEnterpriseDomain(addEnterpriseDomainRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add user(s) to an enterprise (internal admin only).  - If a user is not in any enterprise: onboards them to the enterprise - If a user is already in this enterprise: skips them (included in skipped_count) - If a user is in a different enterprise: marks as failed - If a user is not found and create_missing_users is False: marks as failed - If a user is not found and create_missing_users is True: sends a pending   enterprise invitation (does not create an auth/User row)  Partial success: Adds all users that can be added and returns details about failures.
         * @summary Add Users To Enterprise
         * @param {string} enterpriseId 
         * @param {AddUsersToEnterpriseRequest} addUsersToEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersToEnterprise(enterpriseId: string, addUsersToEnterpriseRequest: AddUsersToEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddUsersToEnterpriseResponse> {
            return localVarFp.addUsersToEnterprise(enterpriseId, addUsersToEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a file to bulk add users to an enterprise (internal admin only).  File contains emails separated by commas or newlines, without headers or name columns.  When create_missing_users is False (default): emails must belong to existing users.  When create_missing_users is True: emails with no User row are invited; existing users are still force-added.
         * @summary Add Users To Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {boolean} [createMissingUsers] 
         * @param {EnterpriseRole} [role] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersToEnterpriseFileUpload(enterpriseId: string, file: File, createMissingUsers?: boolean, role?: EnterpriseRole, options?: RawAxiosRequestConfig): AxiosPromise<AddUsersToEnterpriseResponse> {
            return localVarFp.addUsersToEnterpriseFileUpload(enterpriseId, file, createMissingUsers, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply a referral code to a user on their behalf. Admin only.
         * @summary Admin Apply Referral
         * @param {AdminApplyReferralRequest} adminApplyReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminApplyReferral(adminApplyReferralRequest: AdminApplyReferralRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminApplyReferralResponse> {
            return localVarFp.adminApplyReferral(adminApplyReferralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Super-admin: list all stored voice memories for a list of users.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin List User Memories
         * @param {AdminMemoryListRequest} adminMemoryListRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListUserMemories(adminMemoryListRequest: AdminMemoryListRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMemoryListResponse> {
            return localVarFp.adminListUserMemories(adminMemoryListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Look up a user by email or user_id and return their profile and subscription info.
         * @summary Admin Lookup User
         * @param {string} q Email address or user_id to look up
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLookupUser(q: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserLookupResponse> {
            return localVarFp.adminLookupUser(q, options).then((request) => request(axios, basePath));
        },
        /**
         * Super-admin: semantic-search voice memory for a list of users by a context query.  Reads private cross-user memory — restricted to Wispr super-admins.
         * @summary Admin Search User Memories
         * @param {AdminMemorySearchRequest} adminMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchUserMemories(adminMemorySearchRequest: AdminMemorySearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMemorySearchResponse> {
            return localVarFp.adminSearchUserMemories(adminMemorySearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Overwrite a user\'s stripe_customer_id (dry-run by default).
         * @summary Admin Update Stripe Customer Id
         * @param {AdminUpdateStripeCustomerIdRequest} adminUpdateStripeCustomerIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest: AdminUpdateStripeCustomerIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUpdateStripeCustomerIdResponse> {
            return localVarFp.adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commit(commitRequest: CommitRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitResponse> {
            return localVarFp.commit(commitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute the op and emit a structured log line. No DB write.
         * @summary Commit
         * @param {CommitRequest} commitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commit_1(commitRequest: CommitRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommitResponse> {
            return localVarFp.commit_1(commitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new enterprise billing config (internal admin only).
         * @summary Create Billing Config
         * @param {EnterpriseBillingConfigCreate} enterpriseBillingConfigCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingConfig(enterpriseBillingConfigCreate: EnterpriseBillingConfigCreate, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseBillingConfigResponse> {
            return localVarFp.createBillingConfig(enterpriseBillingConfigCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a domain to the block list (internal admin only).
         * @summary Create Blocked Domain
         * @param {AddBlockedDomainRequest} addBlockedDomainRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBlockedDomain(addBlockedDomainRequest: AddBlockedDomainRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddBlockedDomainResponse> {
            return localVarFp.createBlockedDomain(addBlockedDomainRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an enterprise pilot: sales-owned access until ``trial_end``, then ended automatically.
         * @summary Create Enterprise Pilot
         * @param {CreateEnterprisePilotRequest} createEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterprisePilot(createEnterprisePilotRequest: CreateEnterprisePilotRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEnterprisePilot(createEnterprisePilotRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new promo campaign (internal admin only).
         * @summary Create Promo Campaign
         * @param {CreateCampaignRequest} createCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCampaign(createCampaignRequest: CreateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignListItem> {
            return localVarFp.createPromoCampaign(createCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate new codes for a promo campaign (internal admin only).
         * @summary Create Promo Codes
         * @param {string} campaignId 
         * @param {CreateCodesRequest} createCodesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromoCodes(campaignId: string, createCodesRequest: CreateCodesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateCodesResponse> {
            return localVarFp.createPromoCodes(campaignId, createCodesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a sales-led enterprise with deferred invoicing.  Creates the enterprise, Stripe subscription, and a draft invoice. The invoice stays as a draft until sales unpauses collection via /send-invoice (below).  With `billing_provider=sales_owned` no Stripe objects are created: the enterprise\'s General cost center goes live as `sales_owned` and billing stays in Salesforce.
         * @summary Create Sales Led Enterprise
         * @param {CreateSalesLedEnterpriseRequest} createSalesLedEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLedEnterprise(createSalesLedEnterpriseRequest: CreateSalesLedEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSalesLedEnterpriseResponse> {
            return localVarFp.createSalesLedEnterprise(createSalesLedEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a sales-led enterprise with a negotiated custom billing config.  Superadmin-gated counterpart to /create-sales-led: takes the same payload plus a required `custom_billing_config`. Splitting it out keeps the auth escalation visible in the route signature and OpenAPI, matching the sensitivity of /billing-configs/create.
         * @summary Create Sales Led Enterprise Custom Billing
         * @param {CreateSalesLedEnterpriseCustomBillingRequest} createSalesLedEnterpriseCustomBillingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest: CreateSalesLedEnterpriseCustomBillingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSalesLedEnterpriseResponse> {
            return localVarFp.createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an enterprise billing config (internal admin only).
         * @summary Delete Billing Config
         * @param {string} configId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillingConfig(configId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteBillingConfig(configId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a domain from the block list (internal admin only).
         * @summary Delete Blocked Domain
         * @param {string} blockedDomainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBlockedDomain(blockedDomainId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteBlockedDomain(blockedDomainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Drop the working copy; the next load starts from the consensus prefill or the finalized bundle.
         * @summary Discard Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {number} expectedVersion Version the client loaded; 409 if the row has moved on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discardMeetingAttributionGroundTruth(meetingId: string, expectedVersion: number, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtDiscardResponse> {
            return localVarFp.discardMeetingAttributionGroundTruth(meetingId, expectedVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorize a version-matched private extension download.
         * @summary Download Extension Bundle
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadExtensionBundle(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ExtensionBundleResponse> {
            return localVarFp.downloadExtensionBundle(version, options).then((request) => request(axios, basePath));
        },
        /**
         * Export all codes for a promo campaign as a CSV attachment (internal admin only).
         * @summary Export Promo Codes Csv
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportPromoCodesCsv(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportPromoCodesCsv(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Write the complete working copy to the durable bundle store as a new generation.
         * @summary Finalize Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtFinalizeRequest} meetingAttributionGtFinalizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finalizeMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtFinalizeRequest: MeetingAttributionGtFinalizeRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtFinalizeResponse> {
            return localVarFp.finalizeMeetingAttributionGroundTruth(meetingId, meetingAttributionGtFinalizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.generateFlowStateProfiles(generateFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsGenerateResponse> {
            return localVarFp.generateWeeklyStats(weeklyStatsGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all blocked domains (internal admin only).
         * @summary Get Blocked Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedDomains(options?: RawAxiosRequestConfig): AxiosPromise<BlockedDomainsListResponse> {
            return localVarFp.getBlockedDomains(options).then((request) => request(axios, basePath));
        },
        /**
         * Get enterprise details including domains (internal admin only).
         * @summary Get Enterprise Details
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseDetails(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseDetailsResponse> {
            return localVarFp.getEnterpriseDetails(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get members of an enterprise with pagination, search, and sort (internal admin only).
         * @summary Get Enterprise Members
         * @param {string} enterpriseId 
         * @param {number} [limit] Maximum number of members to return
         * @param {number} [offset] Number of members to skip
         * @param {string | null} [search] Case-insensitive search across name and email
         * @param {GetEnterpriseMembersSortByEnum} [sortBy] 
         * @param {GetEnterpriseMembersSortDirEnum} [sortDir] 
         * @param {EnterpriseRole | null} [role] Only members with this role, matched case-insensitively
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnterpriseMembers(enterpriseId: string, limit?: number, offset?: number, search?: string | null, sortBy?: GetEnterpriseMembersSortByEnum, sortDir?: GetEnterpriseMembersSortDirEnum, role?: EnterpriseRole | null, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseMembersResponse> {
            return localVarFp.getEnterpriseMembers(enterpriseId, limit, offset, search, sortBy, sortDir, role, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobStatusResponse> {
            return localVarFp.getFlowStateJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<FlowStateMonthSummaryResponse> {
            return localVarFp.getFlowStateMonthSummary(reportingMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchLatestRunResponse> {
            return localVarFp.getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a scoped playback or download audio URL when the meeting has audio.
         * @summary Get Meeting Attribution Audio Url
         * @param {string} meetingId 
         * @param {boolean} [download] 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionAudioUrl(meetingId: string, download?: boolean, jobId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAudioUrlResponse> {
            return localVarFp.getMeetingAttributionAudioUrl(meetingId, download, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the saved ground-truth document for a meeting, or null when none exists.
         * @summary Get Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruth(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtDocumentResponse> {
            return localVarFp.getMeetingAttributionGroundTruth(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Per-person and per-platform annotation progress across all ground-truth meetings.
         * @summary Get Meeting Attribution Ground Truth Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruthLeaderboard(options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtLeaderboardResponse> {
            return localVarFp.getMeetingAttributionGroundTruthLeaderboard(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the raw JSON pinned to the annotation\'s prefill identity.
         * @summary Get Meeting Attribution Ground Truth Raw
         * @param {string} meetingId 
         * @param {string} expectedPrefillVersion 
         * @param {string} expectedRawSha256 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGroundTruthRaw(meetingId: string, expectedPrefillVersion: string, expectedRawSha256: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeetingAttributionGroundTruthRaw(meetingId, expectedPrefillVersion, expectedRawSha256, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the finalized guard-bundle export for a meeting\'s saved ground truth.
         * @summary Get Meeting Attribution Gt Export
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGtExport(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtExportResponse> {
            return localVarFp.getMeetingAttributionGtExport(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a machine-drafted prefill, annotation eligibility, and any saved document.
         * @summary Get Meeting Attribution Gt Prefill
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionGtPrefill(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtPrefillResponse> {
            return localVarFp.getMeetingAttributionGtPrefill(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the live meeting\'s refine jobs for internal inspection.
         * @summary Get Meeting Attribution Jobs
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionJobs(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionJobsResponse> {
            return localVarFp.getMeetingAttributionJobs(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the exact stored live-transcript NDJSON body.
         * @summary Get Meeting Attribution Live
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionLive(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeetingAttributionLive(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return paired raw provider inputs for the displayed refinement.
         * @summary Get Meeting Attribution Provider Artifacts
         * @param {string} meetingId 
         * @param {string | null} [expectedRevision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionProviderArtifacts(meetingId: string, expectedRevision?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ProviderArtifactsResponse> {
            return localVarFp.getMeetingAttributionProviderArtifacts(meetingId, expectedRevision, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the exact stored refined-transcript NDJSON body.
         * @summary Get Meeting Attribution Refined
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRefined(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeetingAttributionRefined(meetingId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the exact stored archived refine JSON body.
         * @summary Get Meeting Attribution Refined Raw
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRefinedRaw(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeetingAttributionRefinedRaw(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the stored speaker-relabeler comparison for the meeting\'s current refined revision, if any.
         * @summary Get Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<RelabelerComparisonResponse> {
            return localVarFp.getMeetingAttributionRelabeler(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the speaker labels refine shipped for the meeting\'s current refined revision, before user edits.
         * @summary Get Meeting Attribution Shipped
         * @param {string} meetingId 
         * @param {string | null} [revision] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionShipped(meetingId: string, revision?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ShippedAttributionResponse> {
            return localVarFp.getMeetingAttributionShipped(meetingId, revision, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the meeting\'s persisted durable speaker map when valid.
         * @summary Get Meeting Attribution Speaker Map
         * @param {string} meetingId 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionSpeakerMap(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<MeetingSpeakerMapResponse> {
            return localVarFp.getMeetingAttributionSpeakerMap(meetingId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the exact stored speaker-observation NDJSON body.
         * @summary Get Meeting Attribution Speaker Observations
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionSpeakerObservations(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getMeetingAttributionSpeakerObservations(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Serve the caller\'s blind two-sided comparison for the meeting, computing and storing it on first read.
         * @summary Get Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionTurnPreference(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionTurnPreferenceResponse> {
            return localVarFp.getMeetingAttributionTurnPreference(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Votes per provider and a sign test over every finished blind turn-preference session.
         * @summary Get Meeting Attribution Turn Preference Results
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingAttributionTurnPreferenceResults(options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionTurnPreferenceResultsResponse> {
            return localVarFp.getMeetingAttributionTurnPreferenceResults(options).then((request) => request(axios, basePath));
        },
        /**
         * Check if an enterprise has a pending draft invoice (internal admin only).
         * @summary Get Pending Invoice
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingInvoice(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<PendingInvoiceResponse> {
            return localVarFp.getPendingInvoice(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single promo campaign by ID (internal admin only).
         * @summary Get Promo Campaign
         * @param {string} campaignId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromoCampaign(campaignId: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignListItem> {
            return localVarFp.getPromoCampaign(campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * An enterprise\'s prod Public API access policy, or null (internal superadmin only).
         * @summary Get Public Api Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicApiAccess(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicAPIPolicy> {
            return localVarFp.getPublicApiAccess(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the public/webmail domain list (internal admin only).
         * @summary Get Public Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicDomains(options?: RawAxiosRequestConfig): AxiosPromise<PublicDomainsListResponse> {
            return localVarFp.getPublicDomains(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the university domain list (internal admin only).
         * @summary Get University Domains
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniversityDomains(options?: RawAxiosRequestConfig): AxiosPromise<UniversityDomainsListResponse> {
            return localVarFp.getUniversityDomains(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchRunStatusResponse> {
            return localVarFp.getWeeklyStatsBatchRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchTriggerStatusResponse> {
            return localVarFp.getWeeklyStatsBatchTriggerRequest(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Live WorkOS directory status for an enterprise (internal admin only).  Lists the enterprise\'s directories straight from WorkOS and echoes the stored directory ID; WorkOS failures degrade to a 200 ``unknown`` payload, never a 5xx.  Args:     enterprise_id:    The enterprise whose directory status to check.     internal_service: Injected internal admin service.     user:             The authenticated caller; must be a Wispr internal admin.  Returns:     The three-shape status payload (``ok`` / ``not_connected`` / ``unknown``) as JSON.
         * @summary Get Workos Directory Status
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkosDirectoryStatus(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkosDirectoryStatusResponse> {
            return localVarFp.getWorkosDirectoryStatus(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create missing users and apply per-user or fallback personal trial end dates.
         * @summary Internal Bulk Provision User Trial End
         * @param {BulkProvisionUserTrialEndRequest} bulkProvisionUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest: BulkProvisionUserTrialEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateUserTrialEndResponse> {
            return localVarFp.internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Override the personal trial end date for a list of users (support action).  Applies the same date to every user; per-user failures (e.g. unknown email) are reported in the response rows instead of failing the batch.  Args:     request:          Incoming request (required by the rate limiter dependencies).     data:             Target user emails and the trial end date to apply.     internal_service: Injected internal admin service.     user:             Authenticated caller; must be an internal admin with an admin role.  Returns:     Per-user results plus updated_count/failed_count/total_count.  Raises:     HTTPException: 400: trial_end is in the past or exceeds the 365-day cap.     HTTPInternalServerError: Unexpected failure while processing the batch.
         * @summary Internal Bulk Update User Trial End
         * @param {BulkUpdateUserTrialEndRequest} bulkUpdateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest: BulkUpdateUserTrialEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkUpdateUserTrialEndResponse> {
            return localVarFp.internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Query public DNS and flip the domain to verified on exact token match.
         * @summary Internal Check Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCheckDomainVerification(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationStatus> {
            return localVarFp.internalCheckDomainVerification(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new enterprise for a given name/domain, and set the given email as the admin user.  Creates a new user, enterprise, and Stripe customer. Only accessible by Wispr admins (@wispr.ai emails).
         * @summary Internal Create Enterprise
         * @param {CreateEnterpriseFromAdminRequest} createEnterpriseFromAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCreateEnterprise(createEnterpriseFromAdminRequest: CreateEnterpriseFromAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.internalCreateEnterprise(createEnterpriseFromAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Disband an enterprise. Cancels Stripe subscription, removes all members, and sends a Slack notification.
         * @summary Internal Disband Enterprise
         * @param {string} enterpriseId 
         * @param {DisbandEnterpriseRequest} disbandEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalDisbandEnterprise(enterpriseId: string, disbandEnterpriseRequest: DisbandEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<DisbandEnterpriseResponse> {
            return localVarFp.internalDisbandEnterprise(enterpriseId, disbandEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return current verification status (including TXT record) for a single domain.
         * @summary Internal Get Domain Verification Status
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalGetDomainVerificationStatus(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationStatus> {
            return localVarFp.internalGetDomainVerificationStatus(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Issue (or reuse) a DNS TXT token for domain ownership verification.
         * @summary Internal Initiate Domain Verification
         * @param {string} domainId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalInitiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<DomainVerificationInitiateResponse> {
            return localVarFp.internalInitiateDomainVerification(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPreviewCostCenterProvision(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalCostCenterProvisionPreviewResponse> {
            return localVarFp.internalPreviewCostCenterProvision(internalCostCenterProvisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
         * @summary Internal Preview Cost Center Provision
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalCostCenterProvisionPreviewResponse> {
            return localVarFp.internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProvisionCostCenter(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalCostCenterProvisionResponse> {
            return localVarFp.internalProvisionCostCenter(internalCostCenterProvisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
         * @summary Internal Provision Cost Center
         * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProvisionCostCenter_3(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig): AxiosPromise<InternalCostCenterProvisionResponse> {
            return localVarFp.internalProvisionCostCenter_3(internalCostCenterProvisionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Wispr-controlled enterprise gates (internal admin only).  Any @wispr.ai admin can flip keys in ADMIN_GATES; SUPERADMIN_GATES require an @wispr.ai superadmin (enforced inside update_gates).
         * @summary Internal Update Enterprise Gates
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseGatesRequest} updateEnterpriseGatesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateEnterpriseGates(enterpriseId: string, updateEnterpriseGatesRequest: UpdateEnterpriseGatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.internalUpdateEnterpriseGates(enterpriseId, updateEnterpriseGatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Override customer-settable enterprise settings (internal admin only, for support fixups).  Gate keys (usageExportAllowed, zdrLocked, restrictDomainAccess) are not accepted here — use PATCH /enterprises/{id}/gates. Per-key compliance enforcement (e.g. ZDR cannot be flipped when zdrLocked is True except by a superadmin) lives in update_settings.
         * @summary Internal Update Enterprise Settings
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateEnterpriseSettings(enterpriseId: string, updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.internalUpdateEnterpriseSettings(enterpriseId, updateEnterpriseSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Override a user\'s personal trial end date (support action). Capped at 365 days.
         * @summary Internal Update User Trial End
         * @param {UpdateUserTrialEndRequest} updateUserTrialEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUpdateUserTrialEnd(updateUserTrialEndRequest: UpdateUserTrialEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUserTrialEndResponse> {
            return localVarFp.internalUpdateUserTrialEnd(updateUserTrialEndRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List all enterprise billing configs (internal admin only).
         * @summary List Billing Configs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillingConfigs(options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseBillingConfigListResponse> {
            return localVarFp.listBillingConfigs(options).then((request) => request(axios, basePath));
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCentersForEnterprise(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<ListCostCentersResponse> {
            return localVarFp.listCostCentersForEnterprise(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
         * @summary List Cost Centers For Enterprise
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCostCentersForEnterprise_4(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<ListCostCentersResponse> {
            return localVarFp.listCostCentersForEnterprise_4(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * List enterprise pilots, optionally filtered by active/expired status (internal admin only).
         * @summary List Enterprise Pilots
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {ListEnterprisePilotsStatusEnum} [status] Filter by status: \&#39;active\&#39;, \&#39;expired\&#39;, or omit for all
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnterprisePilots(limit?: number, offset?: number, status?: ListEnterprisePilotsStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<EnterprisePilotsResponse> {
            return localVarFp.listEnterprisePilots(limit, offset, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Scan eligible finalized meetings, including unannotated meetings, without reading transcript artifacts.
         * @summary List Meeting Relabeler Inventory
         * @param {string | null} [cursor] 
         * @param {string | null} [cutoff] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMeetingRelabelerInventory(cursor?: string | null, cutoff?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<RelabelerInventoryResponse> {
            return localVarFp.listMeetingRelabelerInventory(cursor, cutoff, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperations(options?: RawAxiosRequestConfig): AxiosPromise<ListOperationsResponse> {
            return localVarFp.listOperations(options).then((request) => request(axios, basePath));
        },
        /**
         * List every registered operation along with its JSON schema for the form renderer.
         * @summary List Operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOperations_5(options?: RawAxiosRequestConfig): AxiosPromise<ListOperationsResponse> {
            return localVarFp.listOperations_5(options).then((request) => request(axios, basePath));
        },
        /**
         * List promo campaigns with pagination (internal admin only).
         * @summary List Promo Campaigns
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoCampaigns(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<CampaignListResponse> {
            return localVarFp.listPromoCampaigns(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * List the codes for a promo campaign with pagination (internal admin only).
         * @summary List Promo Codes
         * @param {string} campaignId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoCodes(campaignId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<CodeListResponse> {
            return localVarFp.listPromoCodes(campaignId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * List promo redemptions, optionally filtered by campaign (internal admin only).
         * @summary List Promo Redemptions
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [campaignId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPromoRedemptions(limit?: number, offset?: number, campaignId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<RedemptionListResponse> {
            return localVarFp.listPromoRedemptions(limit, offset, campaignId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentInvoicesForCostCenter(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<ListRecentInvoicesResponse> {
            return localVarFp.listRecentInvoicesForCostCenter(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
         * @summary List Recent Invoices For Cost Center
         * @param {string} costCenterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentInvoicesForCostCenter_6(costCenterId: string, options?: RawAxiosRequestConfig): AxiosPromise<ListRecentInvoicesResponse> {
            return localVarFp.listRecentInvoicesForCostCenter_6(costCenterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Identify transcript keywords for an eligible internal reviewer.
         * @summary Post Meeting Attribution Gt Keywords
         * @param {string} meetingId 
         * @param {MeetingAttributionGtKeywordsRequest} meetingAttributionGtKeywordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMeetingAttributionGtKeywords(meetingId: string, meetingAttributionGtKeywordsRequest: MeetingAttributionGtKeywordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtKeywordsResponse> {
            return localVarFp.postMeetingAttributionGtKeywords(meetingId, meetingAttributionGtKeywordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewResponse> {
            return localVarFp.preview(previewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Dry-run preview of a single enterprise\'s directory sync.  Computes the link/provision/remove diff against WorkOS without mutating anything, so the admin can confirm before running the actual sync.
         * @summary Preview Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<DirectorySyncPreview> {
            return localVarFp.previewEnterpriseDirectoryUsers(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<FlowStateProfilePreviewResponse> {
            return localVarFp.previewFlowStateProfiles(flowStatePreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run one explicitly selected, non-persistent consensus preview.
         * @summary Preview Meeting Speaker Consensus
         * @param {string} meetingId 
         * @param {ConsensusPreviewRequest} consensusPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewMeetingSpeakerConsensus(meetingId: string, consensusPreviewRequest: ConsensusPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsensusPreviewResponse> {
            return localVarFp.previewMeetingSpeakerConsensus(meetingId, consensusPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsPreviewResponse> {
            return localVarFp.previewWeeklyStats(weeklyStatsPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate input and run the op\'s preview.
         * @summary Preview
         * @param {PreviewRequest} previewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preview_7(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewResponse> {
            return localVarFp.preview_7(previewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or replace an enterprise\'s prod Public API access policy (internal superadmin only).  Pass the `policy_version` you loaded as `expected_policy_version`, or null when there is no policy yet; a concurrent edit returns 409.
         * @summary Put Public Api Access
         * @param {string} enterpriseId 
         * @param {UpdatePublicAPIPolicyRequest} updatePublicAPIPolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPublicApiAccess(enterpriseId: string, updatePublicAPIPolicyRequest: UpdatePublicAPIPolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublicAPIPolicy> {
            return localVarFp.putPublicApiAccess(enterpriseId, updatePublicAPIPolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reactivate an ended enterprise pilot as a sales-owned pilot (internal admin only).  Resolves the admin email + primary domain server-side from the enterprise\'s existing records, then delegates to the standard create-pilot flow. Use update-pilot-end instead when the pilot is still live.
         * @summary Reactivate Enterprise Pilot
         * @param {string} enterpriseId 
         * @param {ReactivateEnterprisePilotRequest} reactivateEnterprisePilotRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactivateEnterprisePilot(enterpriseId: string, reactivateEnterprisePilotRequest: ReactivateEnterprisePilotRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.reactivateEnterprisePilot(enterpriseId, reactivateEnterprisePilotRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove user(s) from an enterprise by email (internal admin only).  Looks up users by email and removes those that belong to this enterprise. Users not found or not in this enterprise are skipped.
         * @summary Remove Users From Enterprise
         * @param {string} enterpriseId 
         * @param {RemoveUsersFromEnterpriseRequest} removeUsersFromEnterpriseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromEnterprise(enterpriseId: string, removeUsersFromEnterpriseRequest: RemoveUsersFromEnterpriseRequest, options?: RawAxiosRequestConfig): AxiosPromise<RemoveUsersFromEnterpriseResponse> {
            return localVarFp.removeUsersFromEnterprise(enterpriseId, removeUsersFromEnterpriseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a file to bulk remove users from an enterprise (internal admin only).  Removes users from the enterprise, clears their enterprise association, updates Stripe seats, and triggers all necessary side effects.  File format: plain text with emails separated by commas or newlines.
         * @summary Remove Users From Enterprise File Upload
         * @param {string} enterpriseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUsersFromEnterpriseFileUpload(enterpriseId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<RemoveUsersFromEnterpriseResponse> {
            return localVarFp.removeUsersFromEnterpriseFileUpload(enterpriseId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Rerun the speaker-relabeler comparison on stored artifacts; save it for the refined revision when possible.
         * @summary Replay Meeting Attribution Relabeler
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<RelabelerReplayResponse> {
            return localVarFp.replayMeetingAttributionRelabeler(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Rebuild, fold by fold, the speaker labels the live transcript showed during the meeting.
         * @summary Replay Meeting Live Speakers
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayMeetingLiveSpeakers(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<LiveReplayResponse> {
            return localVarFp.replayMeetingLiveSpeakers(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace the meeting\'s published transcript and summary by re-running one job\'s retained audio.
         * @summary Rerun Meeting Attribution Job
         * @param {string} meetingId 
         * @param {string} sourceJobId 
         * @param {MeetingAttributionJobRerunRequest} meetingAttributionJobRerunRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rerunMeetingAttributionJob(meetingId: string, sourceJobId: string, meetingAttributionJobRerunRequest: MeetingAttributionJobRerunRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionJobRerunResponse> {
            return localVarFp.rerunMeetingAttributionJob(meetingId, sourceJobId, meetingAttributionJobRerunRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Suspend a sales-owned enterprise\'s access (superadmin only).  Cancels the enterprise\'s `sales_owned` cost center; the UPDATE is scoped to that provider so Stripe-billed rows are never touched. Memberships stay; access ends on the next entitlement read. Resume by re-running /enterprises/create-sales-led with `billing_provider=sales_owned`.
         * @summary Revoke Sales Owned Access
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSalesOwnedAccess(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<RevokeSalesOwnedAccessResponse> {
            return localVarFp.revokeSalesOwnedAccess(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update the ground-truth document under optimistic-concurrency control.
         * @summary Save Meeting Attribution Ground Truth
         * @param {string} meetingId 
         * @param {MeetingAttributionGtSaveRequest} meetingAttributionGtSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtSaveRequest: MeetingAttributionGtSaveRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionGtSaveResponse> {
            return localVarFp.saveMeetingAttributionGroundTruth(meetingId, meetingAttributionGtSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Record the caller\'s picks once and finish their session.
         * @summary Save Meeting Attribution Turn Preference
         * @param {string} meetingId 
         * @param {MeetingAttributionTurnPreferenceVotesRequest} meetingAttributionTurnPreferenceVotesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeetingAttributionTurnPreference(meetingId: string, meetingAttributionTurnPreferenceVotesRequest: MeetingAttributionTurnPreferenceVotesRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingAttributionTurnPreferenceResponse> {
            return localVarFp.saveMeetingAttributionTurnPreference(meetingId, meetingAttributionTurnPreferenceVotesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Search enterprises by name or ID (internal admin only).
         * @summary Search Enterprises
         * @param {string} search Search term for enterprise name or ID
         * @param {number} [limit] Maximum number of results
         * @param {number} [offset] Number of results to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEnterprises(search: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<AllEnterprisesResponse> {
            return localVarFp.searchEnterprises(search, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a pending invoice for a sales-led enterprise with PO number.
         * @summary Send Enterprise Invoice
         * @param {string} enterpriseId 
         * @param {SendInvoiceRequest} sendInvoiceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEnterpriseInvoice(enterpriseId: string, sendInvoiceRequest: SendInvoiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendInvoiceResponse> {
            return localVarFp.sendEnterpriseInvoice(enterpriseId, sendInvoiceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.sendFlowStateEmails(sendFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsSendTestResponse> {
            return localVarFp.sendTestWeeklyStats(weeklyStatsSendTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant or revoke a customer member\'s enterprise superadmin role (internal superadmin only).  After the Wispr role change commits, the member\'s WorkOS organization role is moved to match. A WorkOS failure leaves the Wispr change in place and reports `workos_synced: false`; repeating the request retries it.
         * @summary Set Enterprise Superadmin
         * @param {string} enterpriseId 
         * @param {SetEnterpriseSuperadminRequest} setEnterpriseSuperadminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEnterpriseSuperadmin(enterpriseId: string, setEnterpriseSuperadminRequest: SetEnterpriseSuperadminRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetEnterpriseSuperadminResponse> {
            return localVarFp.setEnterpriseSuperadmin(enterpriseId, setEnterpriseSuperadminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync all enterprises that have a WorkOS directory with their SCIM directory users.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_all_completed\' to see results.
         * @summary Sync All Enterprise Directory Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAllEnterpriseDirectoryUsers(options?: RawAxiosRequestConfig): AxiosPromise<DirectorySyncStartedResponse> {
            return localVarFp.syncAllEnterpriseDirectoryUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Sync a single enterprise\'s DB users with its WorkOS SCIM directory.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_completed\' to see results.
         * @summary Sync Enterprise Directory Users
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<DirectorySyncStartedResponse> {
            return localVarFp.syncEnterpriseDirectoryUsers(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync all active (non-deleted) domains for an enterprise to WorkOS (internal admin only).  Use this endpoint to retry WorkOS sync if a previous add/toggle operation reported workos_synced=false.
         * @summary Sync Enterprise Domains To Workos
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncEnterpriseDomainsToWorkos(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<SyncDomainsToWorkosResponse> {
            return localVarFp.syncEnterpriseDomainsToWorkos(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle domain deleted status for an enterprise (internal admin only).  When deleted=true, the domain is hidden from customer settings, auto-invite is disabled for that domain, and the domain is removed from WorkOS SSO.
         * @summary Toggle Domain Deleted
         * @param {string} enterpriseId 
         * @param {string} domainId 
         * @param {ToggleDomainDeletedRequest} toggleDomainDeletedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDomainDeleted(enterpriseId: string, domainId: string, toggleDomainDeletedRequest: ToggleDomainDeletedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ToggleDomainDeletedResponse> {
            return localVarFp.toggleDomainDeleted(enterpriseId, domainId, toggleDomainDeletedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a single promo code (internal admin only).
         * @summary Toggle Promo Code Active
         * @param {string} codeId 
         * @param {boolean} isActive 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        togglePromoCodeActive(codeId: string, isActive: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CodeListItem> {
            return localVarFp.togglePromoCodeActive(codeId, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchTriggerAcceptedResponse> {
            return localVarFp.triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an enterprise billing config (internal admin only).
         * @summary Update Billing Config
         * @param {string} configId 
         * @param {EnterpriseBillingConfigUpdate} enterpriseBillingConfigUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingConfig(configId: string, enterpriseBillingConfigUpdate: EnterpriseBillingConfigUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EnterpriseBillingConfigResponse> {
            return localVarFp.updateBillingConfig(configId, enterpriseBillingConfigUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename an enterprise (internal admin only).  No-ops when the trimmed name matches the current name. Rejects a name already used by another active enterprise with 409. Does not update the WorkOS organization label.  Args:     request:          The incoming HTTP request (rate-limiter dependency contract).     enterprise_id:    The enterprise to rename.     data:             Request body carrying the new name.     internal_service: Injected internal admin service.     user:             The authenticated user; must be an internal Wispr admin.  Returns:     ORJSONResponse: The enterprise id and its new name.  Raises:     HTTPException: Propagated unchanged when it is what the rename itself already raised.     HTTPInternalServerError: The rename failed for an unexpected reason.
         * @summary Update Enterprise Name
         * @param {string} enterpriseId 
         * @param {UpdateEnterpriseNameRequest} updateEnterpriseNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterpriseName(enterpriseId: string, updateEnterpriseNameRequest: UpdateEnterpriseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateEnterpriseNameResponse> {
            return localVarFp.updateEnterpriseName(enterpriseId, updateEnterpriseNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the pilot end date for an enterprise (internal admin with role only).  The new pilot_end must be at least 24 hours in the future. A sales-owned pilot is updated in our database; a legacy pilot\'s Stripe trial_end is updated (a webhook syncs it back to ``cost_center.pilot_end``). ``cost_center_id`` is optional: omit it to target the enterprise\'s oldest live cost center (legacy behavior), or pass it to target a specific one when the enterprise has 2+ live cost centers.
         * @summary Update Enterprise Pilot End
         * @param {string} enterpriseId 
         * @param {UpdatePilotEndRequest} updatePilotEndRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEnterprisePilotEnd(enterpriseId: string, updatePilotEndRequest: UpdatePilotEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdatePilotEndResponse> {
            return localVarFp.updateEnterprisePilotEnd(enterpriseId, updatePilotEndRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a pilot override for selected members as a Wispr internal admin.
         * @summary Update Notetaker Entitlements
         * @param {string} enterpriseId 
         * @param {UpdateNotetakerEntitlementsRequest} updateNotetakerEntitlementsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotetakerEntitlements(enterpriseId: string, updateNotetakerEntitlementsRequest: UpdateNotetakerEntitlementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateNotetakerEntitlementsResponse> {
            return localVarFp.updateNotetakerEntitlements(enterpriseId, updateNotetakerEntitlementsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle preserve_contracted_seats for an enterprise (internal admin only).
         * @summary Update Preserve Contracted Seats
         * @param {string} enterpriseId 
         * @param {UpdatePreserveContractedSeatsRequest} updatePreserveContractedSeatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreserveContractedSeats(enterpriseId: string, updatePreserveContractedSeatsRequest: UpdatePreserveContractedSeatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updatePreserveContractedSeats(enterpriseId, updatePreserveContractedSeatsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing promo campaign (internal admin only).
         * @summary Update Promo Campaign
         * @param {string} campaignId 
         * @param {UpdateCampaignRequest} updateCampaignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePromoCampaign(campaignId: string, updateCampaignRequest: UpdateCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignListItem> {
            return localVarFp.updatePromoCampaign(campaignId, updateCampaignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a single user\'s role in an enterprise (internal admin only).  - User must exist and be in this enterprise - Cannot demote if it would leave enterprise with zero admins
         * @summary Update User Enterprise Role
         * @param {string} enterpriseId 
         * @param {UpdateUsersRoleRequest} updateUsersRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEnterpriseRole(enterpriseId: string, updateUsersRoleRequest: UpdateUsersRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUsersRoleResponse> {
            return localVarFp.updateUserEnterpriseRole(enterpriseId, updateUsersRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a CSV/text file to bulk update user roles (internal admin only).  File format: plain text with emails separated by commas or newlines. Role is specified as a query parameter.
         * @summary Update User Roles File Upload
         * @param {string} enterpriseId 
         * @param {EnterpriseRole} role Target role: \&#39;admin\&#39; or \&#39;member\&#39;
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesFileUpload(enterpriseId: string, role: EnterpriseRole, file: File, options?: RawAxiosRequestConfig): AxiosPromise<UpdateUsersRoleResponse> {
            return localVarFp.updateUserRolesFileUpload(enterpriseId, role, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Set or unlink workos_directory_id for an enterprise (internal admin only).
         * @summary Update Workos Directory Id
         * @param {string} enterpriseId 
         * @param {UpdateWorkosDirectoryIdRequest} updateWorkosDirectoryIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkosDirectoryId(enterpriseId: string, updateWorkosDirectoryIdRequest: UpdateWorkosDirectoryIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateWorkosDirectoryId(enterpriseId, updateWorkosDirectoryIdRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     * Add a domain to an enterprise (internal admin only).  If the enterprise has SSO enabled (workos_org_id), the domain will also be synced to WorkOS. The response includes a `workos_synced` field indicating whether the sync was successful.
     * @summary Add Enterprise Domain
     * @param {AddEnterpriseDomainRequest} addEnterpriseDomainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addEnterpriseDomain(addEnterpriseDomainRequest: AddEnterpriseDomainRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).addEnterpriseDomain(addEnterpriseDomainRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add user(s) to an enterprise (internal admin only).  - If a user is not in any enterprise: onboards them to the enterprise - If a user is already in this enterprise: skips them (included in skipped_count) - If a user is in a different enterprise: marks as failed - If a user is not found and create_missing_users is False: marks as failed - If a user is not found and create_missing_users is True: sends a pending   enterprise invitation (does not create an auth/User row)  Partial success: Adds all users that can be added and returns details about failures.
     * @summary Add Users To Enterprise
     * @param {string} enterpriseId 
     * @param {AddUsersToEnterpriseRequest} addUsersToEnterpriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addUsersToEnterprise(enterpriseId: string, addUsersToEnterpriseRequest: AddUsersToEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).addUsersToEnterprise(enterpriseId, addUsersToEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a file to bulk add users to an enterprise (internal admin only).  File contains emails separated by commas or newlines, without headers or name columns.  When create_missing_users is False (default): emails must belong to existing users.  When create_missing_users is True: emails with no User row are invited; existing users are still force-added.
     * @summary Add Users To Enterprise File Upload
     * @param {string} enterpriseId 
     * @param {File} file 
     * @param {boolean} [createMissingUsers] 
     * @param {EnterpriseRole} [role] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public addUsersToEnterpriseFileUpload(enterpriseId: string, file: File, createMissingUsers?: boolean, role?: EnterpriseRole, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).addUsersToEnterpriseFileUpload(enterpriseId, file, createMissingUsers, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply a referral code to a user on their behalf. Admin only.
     * @summary Admin Apply Referral
     * @param {AdminApplyReferralRequest} adminApplyReferralRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public adminApplyReferral(adminApplyReferralRequest: AdminApplyReferralRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).adminApplyReferral(adminApplyReferralRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Super-admin: list all stored voice memories for a list of users.  Reads private cross-user memory — restricted to Wispr super-admins.
     * @summary Admin List User Memories
     * @param {AdminMemoryListRequest} adminMemoryListRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public adminListUserMemories(adminMemoryListRequest: AdminMemoryListRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).adminListUserMemories(adminMemoryListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Look up a user by email or user_id and return their profile and subscription info.
     * @summary Admin Lookup User
     * @param {string} q Email address or user_id to look up
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public adminLookupUser(q: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).adminLookupUser(q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Super-admin: semantic-search voice memory for a list of users by a context query.  Reads private cross-user memory — restricted to Wispr super-admins.
     * @summary Admin Search User Memories
     * @param {AdminMemorySearchRequest} adminMemorySearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public adminSearchUserMemories(adminMemorySearchRequest: AdminMemorySearchRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).adminSearchUserMemories(adminMemorySearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Overwrite a user\'s stripe_customer_id (dry-run by default).
     * @summary Admin Update Stripe Customer Id
     * @param {AdminUpdateStripeCustomerIdRequest} adminUpdateStripeCustomerIdRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest: AdminUpdateStripeCustomerIdRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).adminUpdateStripeCustomerId(adminUpdateStripeCustomerIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute the op and emit a structured log line. No DB write.
     * @summary Commit
     * @param {CommitRequest} commitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public commit(commitRequest: CommitRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).commit(commitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute the op and emit a structured log line. No DB write.
     * @summary Commit
     * @param {CommitRequest} commitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public commit_1(commitRequest: CommitRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).commit_1(commitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new enterprise billing config (internal admin only).
     * @summary Create Billing Config
     * @param {EnterpriseBillingConfigCreate} enterpriseBillingConfigCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createBillingConfig(enterpriseBillingConfigCreate: EnterpriseBillingConfigCreate, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createBillingConfig(enterpriseBillingConfigCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a domain to the block list (internal admin only).
     * @summary Create Blocked Domain
     * @param {AddBlockedDomainRequest} addBlockedDomainRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createBlockedDomain(addBlockedDomainRequest: AddBlockedDomainRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createBlockedDomain(addBlockedDomainRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an enterprise pilot: sales-owned access until ``trial_end``, then ended automatically.
     * @summary Create Enterprise Pilot
     * @param {CreateEnterprisePilotRequest} createEnterprisePilotRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createEnterprisePilot(createEnterprisePilotRequest: CreateEnterprisePilotRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createEnterprisePilot(createEnterprisePilotRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new promo campaign (internal admin only).
     * @summary Create Promo Campaign
     * @param {CreateCampaignRequest} createCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createPromoCampaign(createCampaignRequest: CreateCampaignRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createPromoCampaign(createCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate new codes for a promo campaign (internal admin only).
     * @summary Create Promo Codes
     * @param {string} campaignId 
     * @param {CreateCodesRequest} createCodesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createPromoCodes(campaignId: string, createCodesRequest: CreateCodesRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createPromoCodes(campaignId, createCodesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a sales-led enterprise with deferred invoicing.  Creates the enterprise, Stripe subscription, and a draft invoice. The invoice stays as a draft until sales unpauses collection via /send-invoice (below).  With `billing_provider=sales_owned` no Stripe objects are created: the enterprise\'s General cost center goes live as `sales_owned` and billing stays in Salesforce.
     * @summary Create Sales Led Enterprise
     * @param {CreateSalesLedEnterpriseRequest} createSalesLedEnterpriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createSalesLedEnterprise(createSalesLedEnterpriseRequest: CreateSalesLedEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createSalesLedEnterprise(createSalesLedEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a sales-led enterprise with a negotiated custom billing config.  Superadmin-gated counterpart to /create-sales-led: takes the same payload plus a required `custom_billing_config`. Splitting it out keeps the auth escalation visible in the route signature and OpenAPI, matching the sensitivity of /billing-configs/create.
     * @summary Create Sales Led Enterprise Custom Billing
     * @param {CreateSalesLedEnterpriseCustomBillingRequest} createSalesLedEnterpriseCustomBillingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest: CreateSalesLedEnterpriseCustomBillingRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).createSalesLedEnterpriseCustomBilling(createSalesLedEnterpriseCustomBillingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an enterprise billing config (internal admin only).
     * @summary Delete Billing Config
     * @param {string} configId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteBillingConfig(configId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).deleteBillingConfig(configId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a domain from the block list (internal admin only).
     * @summary Delete Blocked Domain
     * @param {string} blockedDomainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public deleteBlockedDomain(blockedDomainId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).deleteBlockedDomain(blockedDomainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Drop the working copy; the next load starts from the consensus prefill or the finalized bundle.
     * @summary Discard Meeting Attribution Ground Truth
     * @param {string} meetingId 
     * @param {number} expectedVersion Version the client loaded; 409 if the row has moved on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public discardMeetingAttributionGroundTruth(meetingId: string, expectedVersion: number, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).discardMeetingAttributionGroundTruth(meetingId, expectedVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authorize a version-matched private extension download.
     * @summary Download Extension Bundle
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public downloadExtensionBundle(version: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).downloadExtensionBundle(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export all codes for a promo campaign as a CSV attachment (internal admin only).
     * @summary Export Promo Codes Csv
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public exportPromoCodesCsv(campaignId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).exportPromoCodesCsv(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write the complete working copy to the durable bundle store as a new generation.
     * @summary Finalize Meeting Attribution Ground Truth
     * @param {string} meetingId 
     * @param {MeetingAttributionGtFinalizeRequest} meetingAttributionGtFinalizeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public finalizeMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtFinalizeRequest: MeetingAttributionGtFinalizeRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).finalizeMeetingAttributionGroundTruth(meetingId, meetingAttributionGtFinalizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enqueue a generate+send job for all eligible Flow State profiles.
     * @summary Generate And Send Flow State Emails
     * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off a background job that builds per-user Flow State profiles.
     * @summary Generate Flow State Profiles
     * @param {GenerateFlowStateRequest} generateFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).generateFlowStateProfiles(generateFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
     * @summary Generate Weekly Stats
     * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).generateWeeklyStats(weeklyStatsGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all blocked domains (internal admin only).
     * @summary Get Blocked Domains
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getBlockedDomains(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getBlockedDomains(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get enterprise details including domains (internal admin only).
     * @summary Get Enterprise Details
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getEnterpriseDetails(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getEnterpriseDetails(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get members of an enterprise with pagination, search, and sort (internal admin only).
     * @summary Get Enterprise Members
     * @param {string} enterpriseId 
     * @param {number} [limit] Maximum number of members to return
     * @param {number} [offset] Number of members to skip
     * @param {string | null} [search] Case-insensitive search across name and email
     * @param {GetEnterpriseMembersSortByEnum} [sortBy] 
     * @param {GetEnterpriseMembersSortDirEnum} [sortDir] 
     * @param {EnterpriseRole | null} [role] Only members with this role, matched case-insensitively
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getEnterpriseMembers(enterpriseId: string, limit?: number, offset?: number, search?: string | null, sortBy?: GetEnterpriseMembersSortByEnum, sortDir?: GetEnterpriseMembersSortDirEnum, role?: EnterpriseRole | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getEnterpriseMembers(enterpriseId, limit, offset, search, sortBy, sortDir, role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the latest persisted state of a marketing job.
     * @summary Get Flow State Job
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getFlowStateJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return month-level Flow State generation/send state for the admin portal.
     * @summary Get Flow State Month Summary
     * @param {string} reportingMonth First day of the reporting month.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getFlowStateMonthSummary(reportingMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
     * @summary Get Latest Weekly Stats Batch Run
     * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
     * @param {boolean} dryRun Dry-run flag to match.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a scoped playback or download audio URL when the meeting has audio.
     * @summary Get Meeting Attribution Audio Url
     * @param {string} meetingId 
     * @param {boolean} [download] 
     * @param {string | null} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionAudioUrl(meetingId: string, download?: boolean, jobId?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionAudioUrl(meetingId, download, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the saved ground-truth document for a meeting, or null when none exists.
     * @summary Get Meeting Attribution Ground Truth
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionGroundTruth(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionGroundTruth(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Per-person and per-platform annotation progress across all ground-truth meetings.
     * @summary Get Meeting Attribution Ground Truth Leaderboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionGroundTruthLeaderboard(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionGroundTruthLeaderboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the raw JSON pinned to the annotation\'s prefill identity.
     * @summary Get Meeting Attribution Ground Truth Raw
     * @param {string} meetingId 
     * @param {string} expectedPrefillVersion 
     * @param {string} expectedRawSha256 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionGroundTruthRaw(meetingId: string, expectedPrefillVersion: string, expectedRawSha256: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionGroundTruthRaw(meetingId, expectedPrefillVersion, expectedRawSha256, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the finalized guard-bundle export for a meeting\'s saved ground truth.
     * @summary Get Meeting Attribution Gt Export
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionGtExport(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionGtExport(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a machine-drafted prefill, annotation eligibility, and any saved document.
     * @summary Get Meeting Attribution Gt Prefill
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionGtPrefill(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionGtPrefill(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the live meeting\'s refine jobs for internal inspection.
     * @summary Get Meeting Attribution Jobs
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionJobs(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionJobs(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the exact stored live-transcript NDJSON body.
     * @summary Get Meeting Attribution Live
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionLive(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionLive(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return paired raw provider inputs for the displayed refinement.
     * @summary Get Meeting Attribution Provider Artifacts
     * @param {string} meetingId 
     * @param {string | null} [expectedRevision] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionProviderArtifacts(meetingId: string, expectedRevision?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionProviderArtifacts(meetingId, expectedRevision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the exact stored refined-transcript NDJSON body.
     * @summary Get Meeting Attribution Refined
     * @param {string} meetingId 
     * @param {string | null} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionRefined(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionRefined(meetingId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the exact stored archived refine JSON body.
     * @summary Get Meeting Attribution Refined Raw
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionRefinedRaw(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionRefinedRaw(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the stored speaker-relabeler comparison for the meeting\'s current refined revision, if any.
     * @summary Get Meeting Attribution Relabeler
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionRelabeler(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the speaker labels refine shipped for the meeting\'s current refined revision, before user edits.
     * @summary Get Meeting Attribution Shipped
     * @param {string} meetingId 
     * @param {string | null} [revision] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionShipped(meetingId: string, revision?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionShipped(meetingId, revision, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the meeting\'s persisted durable speaker map when valid.
     * @summary Get Meeting Attribution Speaker Map
     * @param {string} meetingId 
     * @param {string | null} [jobId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionSpeakerMap(meetingId: string, jobId?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionSpeakerMap(meetingId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the exact stored speaker-observation NDJSON body.
     * @summary Get Meeting Attribution Speaker Observations
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionSpeakerObservations(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionSpeakerObservations(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Serve the caller\'s blind two-sided comparison for the meeting, computing and storing it on first read.
     * @summary Get Meeting Attribution Turn Preference
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionTurnPreference(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionTurnPreference(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Votes per provider and a sign test over every finished blind turn-preference session.
     * @summary Get Meeting Attribution Turn Preference Results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getMeetingAttributionTurnPreferenceResults(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getMeetingAttributionTurnPreferenceResults(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if an enterprise has a pending draft invoice (internal admin only).
     * @summary Get Pending Invoice
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getPendingInvoice(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getPendingInvoice(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single promo campaign by ID (internal admin only).
     * @summary Get Promo Campaign
     * @param {string} campaignId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getPromoCampaign(campaignId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getPromoCampaign(campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * An enterprise\'s prod Public API access policy, or null (internal superadmin only).
     * @summary Get Public Api Access
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getPublicApiAccess(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getPublicApiAccess(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the public/webmail domain list (internal admin only).
     * @summary Get Public Domains
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getPublicDomains(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getPublicDomains(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the university domain list (internal admin only).
     * @summary Get University Domains
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getUniversityDomains(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getUniversityDomains(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
     * @summary Get Weekly Stats Batch Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getWeeklyStatsBatchRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
     * @summary Get Weekly Stats Batch Trigger Request
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getWeeklyStatsBatchTriggerRequest(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Live WorkOS directory status for an enterprise (internal admin only).  Lists the enterprise\'s directories straight from WorkOS and echoes the stored directory ID; WorkOS failures degrade to a 200 ``unknown`` payload, never a 5xx.  Args:     enterprise_id:    The enterprise whose directory status to check.     internal_service: Injected internal admin service.     user:             The authenticated caller; must be a Wispr internal admin.  Returns:     The three-shape status payload (``ok`` / ``not_connected`` / ``unknown``) as JSON.
     * @summary Get Workos Directory Status
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public getWorkosDirectoryStatus(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).getWorkosDirectoryStatus(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create missing users and apply per-user or fallback personal trial end dates.
     * @summary Internal Bulk Provision User Trial End
     * @param {BulkProvisionUserTrialEndRequest} bulkProvisionUserTrialEndRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest: BulkProvisionUserTrialEndRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalBulkProvisionUserTrialEnd(bulkProvisionUserTrialEndRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override the personal trial end date for a list of users (support action).  Applies the same date to every user; per-user failures (e.g. unknown email) are reported in the response rows instead of failing the batch.  Args:     request:          Incoming request (required by the rate limiter dependencies).     data:             Target user emails and the trial end date to apply.     internal_service: Injected internal admin service.     user:             Authenticated caller; must be an internal admin with an admin role.  Returns:     Per-user results plus updated_count/failed_count/total_count.  Raises:     HTTPException: 400: trial_end is in the past or exceeds the 365-day cap.     HTTPInternalServerError: Unexpected failure while processing the batch.
     * @summary Internal Bulk Update User Trial End
     * @param {BulkUpdateUserTrialEndRequest} bulkUpdateUserTrialEndRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest: BulkUpdateUserTrialEndRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalBulkUpdateUserTrialEnd(bulkUpdateUserTrialEndRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query public DNS and flip the domain to verified on exact token match.
     * @summary Internal Check Domain Verification
     * @param {string} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalCheckDomainVerification(domainId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalCheckDomainVerification(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new enterprise for a given name/domain, and set the given email as the admin user.  Creates a new user, enterprise, and Stripe customer. Only accessible by Wispr admins (@wispr.ai emails).
     * @summary Internal Create Enterprise
     * @param {CreateEnterpriseFromAdminRequest} createEnterpriseFromAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalCreateEnterprise(createEnterpriseFromAdminRequest: CreateEnterpriseFromAdminRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalCreateEnterprise(createEnterpriseFromAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disband an enterprise. Cancels Stripe subscription, removes all members, and sends a Slack notification.
     * @summary Internal Disband Enterprise
     * @param {string} enterpriseId 
     * @param {DisbandEnterpriseRequest} disbandEnterpriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalDisbandEnterprise(enterpriseId: string, disbandEnterpriseRequest: DisbandEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalDisbandEnterprise(enterpriseId, disbandEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return current verification status (including TXT record) for a single domain.
     * @summary Internal Get Domain Verification Status
     * @param {string} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalGetDomainVerificationStatus(domainId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalGetDomainVerificationStatus(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issue (or reuse) a DNS TXT token for domain ownership verification.
     * @summary Internal Initiate Domain Verification
     * @param {string} domainId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalInitiateDomainVerification(domainId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalInitiateDomainVerification(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
     * @summary Internal Preview Cost Center Provision
     * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalPreviewCostCenterProvision(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalPreviewCostCenterProvision(internalCostCenterProvisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Server-computed preview of a sales-led cost-center provisioning. No writes, no Stripe mutations.
     * @summary Internal Preview Cost Center Provision
     * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalPreviewCostCenterProvision_2(internalCostCenterProvisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
     * @summary Internal Provision Cost Center
     * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalProvisionCostCenter(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalProvisionCostCenter(internalCostCenterProvisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provision a sales-led cost center for a target enterprise.  Creates the team + membership swap + a send_invoice Stripe subscription at the standard annual Enterprise price, with the invoice emailed to the picked user. Provision-or-revert: a stripe_create or stamp failure auto-reverts (rolls back the rows, restores the prior membership, cancels the orphaned subscription) and is safe to retry; only an invoice_send failure leaves the cost center ACTIVE for a manual finalize/send.
     * @summary Internal Provision Cost Center
     * @param {InternalCostCenterProvisionRequest} internalCostCenterProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalProvisionCostCenter_3(internalCostCenterProvisionRequest: InternalCostCenterProvisionRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalProvisionCostCenter_3(internalCostCenterProvisionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Wispr-controlled enterprise gates (internal admin only).  Any @wispr.ai admin can flip keys in ADMIN_GATES; SUPERADMIN_GATES require an @wispr.ai superadmin (enforced inside update_gates).
     * @summary Internal Update Enterprise Gates
     * @param {string} enterpriseId 
     * @param {UpdateEnterpriseGatesRequest} updateEnterpriseGatesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalUpdateEnterpriseGates(enterpriseId: string, updateEnterpriseGatesRequest: UpdateEnterpriseGatesRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalUpdateEnterpriseGates(enterpriseId, updateEnterpriseGatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override customer-settable enterprise settings (internal admin only, for support fixups).  Gate keys (usageExportAllowed, zdrLocked, restrictDomainAccess) are not accepted here — use PATCH /enterprises/{id}/gates. Per-key compliance enforcement (e.g. ZDR cannot be flipped when zdrLocked is True except by a superadmin) lives in update_settings.
     * @summary Internal Update Enterprise Settings
     * @param {string} enterpriseId 
     * @param {UpdateEnterpriseSettingsRequest} updateEnterpriseSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalUpdateEnterpriseSettings(enterpriseId: string, updateEnterpriseSettingsRequest: UpdateEnterpriseSettingsRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalUpdateEnterpriseSettings(enterpriseId, updateEnterpriseSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Override a user\'s personal trial end date (support action). Capped at 365 days.
     * @summary Internal Update User Trial End
     * @param {UpdateUserTrialEndRequest} updateUserTrialEndRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public internalUpdateUserTrialEnd(updateUserTrialEndRequest: UpdateUserTrialEndRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).internalUpdateUserTrialEnd(updateUserTrialEndRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all enterprise billing configs (internal admin only).
     * @summary List Billing Configs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listBillingConfigs(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listBillingConfigs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
     * @summary List Cost Centers For Enterprise
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listCostCentersForEnterprise(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listCostCentersForEnterprise(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List cost centers under ``enterprise_id`` for the operator-UI picker.  The UI auto-selects the only cost_center when an enterprise has exactly one; with multiple, the operator must pick which cost_center the op targets. Rows come back sorted by ``created_at`` ascending.
     * @summary List Cost Centers For Enterprise
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listCostCentersForEnterprise_4(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listCostCentersForEnterprise_4(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List enterprise pilots, optionally filtered by active/expired status (internal admin only).
     * @summary List Enterprise Pilots
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {ListEnterprisePilotsStatusEnum} [status] Filter by status: \&#39;active\&#39;, \&#39;expired\&#39;, or omit for all
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listEnterprisePilots(limit?: number, offset?: number, status?: ListEnterprisePilotsStatusEnum, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listEnterprisePilots(limit, offset, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Scan eligible finalized meetings, including unannotated meetings, without reading transcript artifacts.
     * @summary List Meeting Relabeler Inventory
     * @param {string | null} [cursor] 
     * @param {string | null} [cutoff] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listMeetingRelabelerInventory(cursor?: string | null, cutoff?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listMeetingRelabelerInventory(cursor, cutoff, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List every registered operation along with its JSON schema for the form renderer.
     * @summary List Operations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listOperations(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listOperations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List every registered operation along with its JSON schema for the form renderer.
     * @summary List Operations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listOperations_5(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listOperations_5(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List promo campaigns with pagination (internal admin only).
     * @summary List Promo Campaigns
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listPromoCampaigns(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listPromoCampaigns(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the codes for a promo campaign with pagination (internal admin only).
     * @summary List Promo Codes
     * @param {string} campaignId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listPromoCodes(campaignId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listPromoCodes(campaignId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List promo redemptions, optionally filtered by campaign (internal admin only).
     * @summary List Promo Redemptions
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [campaignId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listPromoRedemptions(limit?: number, offset?: number, campaignId?: string | null, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listPromoRedemptions(limit, offset, campaignId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
     * @summary List Recent Invoices For Cost Center
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listRecentInvoicesForCostCenter(costCenterId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listRecentInvoicesForCostCenter(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the latest draft + latest open Stripe invoices for a cost_center.  Powers the operator-UI invoice picker. The ``open`` slot subsumes past_due (Stripe treats past_due as ``open`` past its due_date); acting on it inside ``add_po_to_invoice`` triggers the void-and-reissue path, so the UI surfaces a \"will void and re-issue\" warning when that card is picked. The ``draft`` slot is editable in place. Either or both may be ``null``.
     * @summary List Recent Invoices For Cost Center
     * @param {string} costCenterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public listRecentInvoicesForCostCenter_6(costCenterId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).listRecentInvoicesForCostCenter_6(costCenterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Identify transcript keywords for an eligible internal reviewer.
     * @summary Post Meeting Attribution Gt Keywords
     * @param {string} meetingId 
     * @param {MeetingAttributionGtKeywordsRequest} meetingAttributionGtKeywordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public postMeetingAttributionGtKeywords(meetingId: string, meetingAttributionGtKeywordsRequest: MeetingAttributionGtKeywordsRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).postMeetingAttributionGtKeywords(meetingId, meetingAttributionGtKeywordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate input and run the op\'s preview.
     * @summary Preview
     * @param {PreviewRequest} previewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public preview(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).preview(previewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dry-run preview of a single enterprise\'s directory sync.  Computes the link/provision/remove diff against WorkOS without mutating anything, so the admin can confirm before running the actual sync.
     * @summary Preview Enterprise Directory Users
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public previewEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).previewEnterpriseDirectoryUsers(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return generated profile rows for review before dispatch.
     * @summary Preview Flow State Profiles
     * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).previewFlowStateProfiles(flowStatePreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run one explicitly selected, non-persistent consensus preview.
     * @summary Preview Meeting Speaker Consensus
     * @param {string} meetingId 
     * @param {ConsensusPreviewRequest} consensusPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public previewMeetingSpeakerConsensus(meetingId: string, consensusPreviewRequest: ConsensusPreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).previewMeetingSpeakerConsensus(meetingId, consensusPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
     * @summary Preview Weekly Stats
     * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).previewWeeklyStats(weeklyStatsPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate input and run the op\'s preview.
     * @summary Preview
     * @param {PreviewRequest} previewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public preview_7(previewRequest: PreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).preview_7(previewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or replace an enterprise\'s prod Public API access policy (internal superadmin only).  Pass the `policy_version` you loaded as `expected_policy_version`, or null when there is no policy yet; a concurrent edit returns 409.
     * @summary Put Public Api Access
     * @param {string} enterpriseId 
     * @param {UpdatePublicAPIPolicyRequest} updatePublicAPIPolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public putPublicApiAccess(enterpriseId: string, updatePublicAPIPolicyRequest: UpdatePublicAPIPolicyRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).putPublicApiAccess(enterpriseId, updatePublicAPIPolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reactivate an ended enterprise pilot as a sales-owned pilot (internal admin only).  Resolves the admin email + primary domain server-side from the enterprise\'s existing records, then delegates to the standard create-pilot flow. Use update-pilot-end instead when the pilot is still live.
     * @summary Reactivate Enterprise Pilot
     * @param {string} enterpriseId 
     * @param {ReactivateEnterprisePilotRequest} reactivateEnterprisePilotRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public reactivateEnterprisePilot(enterpriseId: string, reactivateEnterprisePilotRequest: ReactivateEnterprisePilotRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).reactivateEnterprisePilot(enterpriseId, reactivateEnterprisePilotRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove user(s) from an enterprise by email (internal admin only).  Looks up users by email and removes those that belong to this enterprise. Users not found or not in this enterprise are skipped.
     * @summary Remove Users From Enterprise
     * @param {string} enterpriseId 
     * @param {RemoveUsersFromEnterpriseRequest} removeUsersFromEnterpriseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public removeUsersFromEnterprise(enterpriseId: string, removeUsersFromEnterpriseRequest: RemoveUsersFromEnterpriseRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).removeUsersFromEnterprise(enterpriseId, removeUsersFromEnterpriseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a file to bulk remove users from an enterprise (internal admin only).  Removes users from the enterprise, clears their enterprise association, updates Stripe seats, and triggers all necessary side effects.  File format: plain text with emails separated by commas or newlines.
     * @summary Remove Users From Enterprise File Upload
     * @param {string} enterpriseId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public removeUsersFromEnterpriseFileUpload(enterpriseId: string, file: File, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).removeUsersFromEnterpriseFileUpload(enterpriseId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rerun the speaker-relabeler comparison on stored artifacts; save it for the refined revision when possible.
     * @summary Replay Meeting Attribution Relabeler
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replayMeetingAttributionRelabeler(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).replayMeetingAttributionRelabeler(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rebuild, fold by fold, the speaker labels the live transcript showed during the meeting.
     * @summary Replay Meeting Live Speakers
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public replayMeetingLiveSpeakers(meetingId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).replayMeetingLiveSpeakers(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace the meeting\'s published transcript and summary by re-running one job\'s retained audio.
     * @summary Rerun Meeting Attribution Job
     * @param {string} meetingId 
     * @param {string} sourceJobId 
     * @param {MeetingAttributionJobRerunRequest} meetingAttributionJobRerunRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public rerunMeetingAttributionJob(meetingId: string, sourceJobId: string, meetingAttributionJobRerunRequest: MeetingAttributionJobRerunRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).rerunMeetingAttributionJob(meetingId, sourceJobId, meetingAttributionJobRerunRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suspend a sales-owned enterprise\'s access (superadmin only).  Cancels the enterprise\'s `sales_owned` cost center; the UPDATE is scoped to that provider so Stripe-billed rows are never touched. Memberships stay; access ends on the next entitlement read. Resume by re-running /enterprises/create-sales-led with `billing_provider=sales_owned`.
     * @summary Revoke Sales Owned Access
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public revokeSalesOwnedAccess(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).revokeSalesOwnedAccess(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update the ground-truth document under optimistic-concurrency control.
     * @summary Save Meeting Attribution Ground Truth
     * @param {string} meetingId 
     * @param {MeetingAttributionGtSaveRequest} meetingAttributionGtSaveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveMeetingAttributionGroundTruth(meetingId: string, meetingAttributionGtSaveRequest: MeetingAttributionGtSaveRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).saveMeetingAttributionGroundTruth(meetingId, meetingAttributionGtSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Record the caller\'s picks once and finish their session.
     * @summary Save Meeting Attribution Turn Preference
     * @param {string} meetingId 
     * @param {MeetingAttributionTurnPreferenceVotesRequest} meetingAttributionTurnPreferenceVotesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public saveMeetingAttributionTurnPreference(meetingId: string, meetingAttributionTurnPreferenceVotesRequest: MeetingAttributionTurnPreferenceVotesRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).saveMeetingAttributionTurnPreference(meetingId, meetingAttributionTurnPreferenceVotesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search enterprises by name or ID (internal admin only).
     * @summary Search Enterprises
     * @param {string} search Search term for enterprise name or ID
     * @param {number} [limit] Maximum number of results
     * @param {number} [offset] Number of results to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public searchEnterprises(search: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).searchEnterprises(search, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a pending invoice for a sales-led enterprise with PO number.
     * @summary Send Enterprise Invoice
     * @param {string} enterpriseId 
     * @param {SendInvoiceRequest} sendInvoiceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendEnterpriseInvoice(enterpriseId: string, sendInvoiceRequest: SendInvoiceRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).sendEnterpriseInvoice(enterpriseId, sendInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off a background job that dispatches Flow State events to Customer.io.
     * @summary Send Flow State Emails
     * @param {SendFlowStateRequest} sendFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).sendFlowStateEmails(sendFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
     * @summary Send Test Weekly Stats
     * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).sendTestWeeklyStats(weeklyStatsSendTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant or revoke a customer member\'s enterprise superadmin role (internal superadmin only).  After the Wispr role change commits, the member\'s WorkOS organization role is moved to match. A WorkOS failure leaves the Wispr change in place and reports `workos_synced: false`; repeating the request retries it.
     * @summary Set Enterprise Superadmin
     * @param {string} enterpriseId 
     * @param {SetEnterpriseSuperadminRequest} setEnterpriseSuperadminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public setEnterpriseSuperadmin(enterpriseId: string, setEnterpriseSuperadminRequest: SetEnterpriseSuperadminRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).setEnterpriseSuperadmin(enterpriseId, setEnterpriseSuperadminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync all enterprises that have a WorkOS directory with their SCIM directory users.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_all_completed\' to see results.
     * @summary Sync All Enterprise Directory Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public syncAllEnterpriseDirectoryUsers(options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).syncAllEnterpriseDirectoryUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync a single enterprise\'s DB users with its WorkOS SCIM directory.  Dispatches the sync as a background task and returns immediately. Search Sentry logs (project flow-backend) for \'directory_sync_completed\' to see results.
     * @summary Sync Enterprise Directory Users
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public syncEnterpriseDirectoryUsers(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).syncEnterpriseDirectoryUsers(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync all active (non-deleted) domains for an enterprise to WorkOS (internal admin only).  Use this endpoint to retry WorkOS sync if a previous add/toggle operation reported workos_synced=false.
     * @summary Sync Enterprise Domains To Workos
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public syncEnterpriseDomainsToWorkos(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).syncEnterpriseDomainsToWorkos(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle domain deleted status for an enterprise (internal admin only).  When deleted=true, the domain is hidden from customer settings, auto-invite is disabled for that domain, and the domain is removed from WorkOS SSO.
     * @summary Toggle Domain Deleted
     * @param {string} enterpriseId 
     * @param {string} domainId 
     * @param {ToggleDomainDeletedRequest} toggleDomainDeletedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public toggleDomainDeleted(enterpriseId: string, domainId: string, toggleDomainDeletedRequest: ToggleDomainDeletedRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).toggleDomainDeleted(enterpriseId, domainId, toggleDomainDeletedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a single promo code (internal admin only).
     * @summary Toggle Promo Code Active
     * @param {string} codeId 
     * @param {boolean} isActive 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public togglePromoCodeActive(codeId: string, isActive: boolean, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).togglePromoCodeActive(codeId, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
     * @summary Trigger Weekly Stats Batch Run
     * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an enterprise billing config (internal admin only).
     * @summary Update Billing Config
     * @param {string} configId 
     * @param {EnterpriseBillingConfigUpdate} enterpriseBillingConfigUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateBillingConfig(configId: string, enterpriseBillingConfigUpdate: EnterpriseBillingConfigUpdate, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateBillingConfig(configId, enterpriseBillingConfigUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename an enterprise (internal admin only).  No-ops when the trimmed name matches the current name. Rejects a name already used by another active enterprise with 409. Does not update the WorkOS organization label.  Args:     request:          The incoming HTTP request (rate-limiter dependency contract).     enterprise_id:    The enterprise to rename.     data:             Request body carrying the new name.     internal_service: Injected internal admin service.     user:             The authenticated user; must be an internal Wispr admin.  Returns:     ORJSONResponse: The enterprise id and its new name.  Raises:     HTTPException: Propagated unchanged when it is what the rename itself already raised.     HTTPInternalServerError: The rename failed for an unexpected reason.
     * @summary Update Enterprise Name
     * @param {string} enterpriseId 
     * @param {UpdateEnterpriseNameRequest} updateEnterpriseNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateEnterpriseName(enterpriseId: string, updateEnterpriseNameRequest: UpdateEnterpriseNameRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateEnterpriseName(enterpriseId, updateEnterpriseNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the pilot end date for an enterprise (internal admin with role only).  The new pilot_end must be at least 24 hours in the future. A sales-owned pilot is updated in our database; a legacy pilot\'s Stripe trial_end is updated (a webhook syncs it back to ``cost_center.pilot_end``). ``cost_center_id`` is optional: omit it to target the enterprise\'s oldest live cost center (legacy behavior), or pass it to target a specific one when the enterprise has 2+ live cost centers.
     * @summary Update Enterprise Pilot End
     * @param {string} enterpriseId 
     * @param {UpdatePilotEndRequest} updatePilotEndRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateEnterprisePilotEnd(enterpriseId: string, updatePilotEndRequest: UpdatePilotEndRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateEnterprisePilotEnd(enterpriseId, updatePilotEndRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a pilot override for selected members as a Wispr internal admin.
     * @summary Update Notetaker Entitlements
     * @param {string} enterpriseId 
     * @param {UpdateNotetakerEntitlementsRequest} updateNotetakerEntitlementsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateNotetakerEntitlements(enterpriseId: string, updateNotetakerEntitlementsRequest: UpdateNotetakerEntitlementsRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateNotetakerEntitlements(enterpriseId, updateNotetakerEntitlementsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle preserve_contracted_seats for an enterprise (internal admin only).
     * @summary Update Preserve Contracted Seats
     * @param {string} enterpriseId 
     * @param {UpdatePreserveContractedSeatsRequest} updatePreserveContractedSeatsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updatePreserveContractedSeats(enterpriseId: string, updatePreserveContractedSeatsRequest: UpdatePreserveContractedSeatsRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updatePreserveContractedSeats(enterpriseId, updatePreserveContractedSeatsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing promo campaign (internal admin only).
     * @summary Update Promo Campaign
     * @param {string} campaignId 
     * @param {UpdateCampaignRequest} updateCampaignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updatePromoCampaign(campaignId: string, updateCampaignRequest: UpdateCampaignRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updatePromoCampaign(campaignId, updateCampaignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a single user\'s role in an enterprise (internal admin only).  - User must exist and be in this enterprise - Cannot demote if it would leave enterprise with zero admins
     * @summary Update User Enterprise Role
     * @param {string} enterpriseId 
     * @param {UpdateUsersRoleRequest} updateUsersRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateUserEnterpriseRole(enterpriseId: string, updateUsersRoleRequest: UpdateUsersRoleRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateUserEnterpriseRole(enterpriseId, updateUsersRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a CSV/text file to bulk update user roles (internal admin only).  File format: plain text with emails separated by commas or newlines. Role is specified as a query parameter.
     * @summary Update User Roles File Upload
     * @param {string} enterpriseId 
     * @param {EnterpriseRole} role Target role: \&#39;admin\&#39; or \&#39;member\&#39;
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateUserRolesFileUpload(enterpriseId: string, role: EnterpriseRole, file: File, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateUserRolesFileUpload(enterpriseId, role, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set or unlink workos_directory_id for an enterprise (internal admin only).
     * @summary Update Workos Directory Id
     * @param {string} enterpriseId 
     * @param {UpdateWorkosDirectoryIdRequest} updateWorkosDirectoryIdRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public updateWorkosDirectoryId(enterpriseId: string, updateWorkosDirectoryIdRequest: UpdateWorkosDirectoryIdRequest, options?: RawAxiosRequestConfig) {
        return InternalApiFp(this.configuration).updateWorkosDirectoryId(enterpriseId, updateWorkosDirectoryIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetEnterpriseMembersSortByEnum = {
    Name: 'name',
    Email: 'email',
    JoinedAt: 'joinedAt',
    Role: 'role'
} as const;
export type GetEnterpriseMembersSortByEnum = typeof GetEnterpriseMembersSortByEnum[keyof typeof GetEnterpriseMembersSortByEnum];
/**
 * @export
 */
export const GetEnterpriseMembersSortDirEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetEnterpriseMembersSortDirEnum = typeof GetEnterpriseMembersSortDirEnum[keyof typeof GetEnterpriseMembersSortDirEnum];
/**
 * @export
 */
export const ListEnterprisePilotsStatusEnum = {
    Active: 'active',
    Expired: 'expired'
} as const;
export type ListEnterprisePilotsStatusEnum = typeof ListEnterprisePilotsStatusEnum[keyof typeof ListEnterprisePilotsStatusEnum];


/**
 * InternalMarketingApi - axios parameter creator
 * @export
 */
export const InternalMarketingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSendFlowStateEmails: async (generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateAndSendFlowStateRequest' is not null or undefined
            assertParamExists('generateAndSendFlowStateEmails', 'generateAndSendFlowStateRequest', generateAndSendFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/generate-send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateAndSendFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFlowStateProfiles: async (generateFlowStateRequest: GenerateFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateFlowStateRequest' is not null or undefined
            assertParamExists('generateFlowStateProfiles', 'generateFlowStateRequest', generateFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyStats: async (weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsGenerateRequest' is not null or undefined
            assertParamExists('generateWeeklyStats', 'weeklyStatsGenerateRequest', weeklyStatsGenerateRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsGenerateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getFlowStateJob', 'jobId', jobId)
            const localVarPath = `/api/v1/internal/marketing/flow-state/jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateMonthSummary: async (reportingMonth: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingMonth' is not null or undefined
            assertParamExists('getFlowStateMonthSummary', 'reportingMonth', reportingMonth)
            const localVarPath = `/api/v1/internal/marketing/flow-state/months/{reporting_month}`
                .replace(`{${"reporting_month"}}`, encodeURIComponent(String(reportingMonth)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWeeklyStatsBatchRun: async (snapshotAt: string, dryRun: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotAt' is not null or undefined
            assertParamExists('getLatestWeeklyStatsBatchRun', 'snapshotAt', snapshotAt)
            // verify required parameter 'dryRun' is not null or undefined
            assertParamExists('getLatestWeeklyStatsBatchRun', 'dryRun', dryRun)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/runs/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (snapshotAt !== undefined) {
                localVarQueryParameter['snapshot_at'] = (snapshotAt as any instanceof Date) ?
                    (snapshotAt as any).toISOString() :
                    snapshotAt;
            }

            if (dryRun !== undefined) {
                localVarQueryParameter['dry_run'] = dryRun;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getWeeklyStatsBatchRun', 'runId', runId)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchTriggerRequest: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getWeeklyStatsBatchTriggerRequest', 'requestId', requestId)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/trigger-requests/{request_id}`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFlowStateProfiles: async (flowStatePreviewRequest: FlowStatePreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowStatePreviewRequest' is not null or undefined
            assertParamExists('previewFlowStateProfiles', 'flowStatePreviewRequest', flowStatePreviewRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowStatePreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWeeklyStats: async (weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsPreviewRequest' is not null or undefined
            assertParamExists('previewWeeklyStats', 'weeklyStatsPreviewRequest', weeklyStatsPreviewRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFlowStateEmails: async (sendFlowStateRequest: SendFlowStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendFlowStateRequest' is not null or undefined
            assertParamExists('sendFlowStateEmails', 'sendFlowStateRequest', sendFlowStateRequest)
            const localVarPath = `/api/v1/internal/marketing/flow-state/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendFlowStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWeeklyStats: async (weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsSendTestRequest' is not null or undefined
            assertParamExists('sendTestWeeklyStats', 'weeklyStatsSendTestRequest', weeklyStatsSendTestRequest)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/send-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsSendTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerWeeklyStatsBatchRun: async (weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyStatsBatchTriggerRequestBody' is not null or undefined
            assertParamExists('triggerWeeklyStatsBatchRun', 'weeklyStatsBatchTriggerRequestBody', weeklyStatsBatchTriggerRequestBody)
            const localVarPath = `/api/v1/internal/marketing/weekly-stats/batch/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyStatsBatchTriggerRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalMarketingApi - functional programming interface
 * @export
 */
export const InternalMarketingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalMarketingApiAxiosParamCreator(configuration)
    return {
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.generateAndSendFlowStateEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateFlowStateProfiles(generateFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.generateFlowStateProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsGenerateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateWeeklyStats(weeklyStatsGenerateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.generateWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowStateJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.getFlowStateJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowStateMonthSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFlowStateMonthSummary(reportingMonth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.getFlowStateMonthSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchLatestRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.getLatestWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchRunStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyStatsBatchRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.getWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchTriggerStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeeklyStatsBatchTriggerRequest(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.getWeeklyStatsBatchTriggerRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowStateProfilePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFlowStateProfiles(flowStatePreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.previewFlowStateProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewWeeklyStats(weeklyStatsPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.previewWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketingJobResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFlowStateEmails(sendFlowStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.sendFlowStateEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsSendTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestWeeklyStats(weeklyStatsSendTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.sendTestWeeklyStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyStatsBatchTriggerAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalMarketingApi.triggerWeeklyStatsBatchRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalMarketingApi - factory interface
 * @export
 */
export const InternalMarketingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalMarketingApiFp(configuration)
    return {
        /**
         * Enqueue a generate+send job for all eligible Flow State profiles.
         * @summary Generate And Send Flow State Emails
         * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off a background job that builds per-user Flow State profiles.
         * @summary Generate Flow State Profiles
         * @param {GenerateFlowStateRequest} generateFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.generateFlowStateProfiles(generateFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
         * @summary Generate Weekly Stats
         * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsGenerateResponse> {
            return localVarFp.generateWeeklyStats(weeklyStatsGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest persisted state of a marketing job.
         * @summary Get Flow State Job
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobStatusResponse> {
            return localVarFp.getFlowStateJob(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return month-level Flow State generation/send state for the admin portal.
         * @summary Get Flow State Month Summary
         * @param {string} reportingMonth First day of the reporting month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig): AxiosPromise<FlowStateMonthSummaryResponse> {
            return localVarFp.getFlowStateMonthSummary(reportingMonth, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
         * @summary Get Latest Weekly Stats Batch Run
         * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
         * @param {boolean} dryRun Dry-run flag to match.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchLatestRunResponse> {
            return localVarFp.getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
         * @summary Get Weekly Stats Batch Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchRunStatusResponse> {
            return localVarFp.getWeeklyStatsBatchRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
         * @summary Get Weekly Stats Batch Trigger Request
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchTriggerStatusResponse> {
            return localVarFp.getWeeklyStatsBatchTriggerRequest(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return generated profile rows for review before dispatch.
         * @summary Preview Flow State Profiles
         * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<FlowStateProfilePreviewResponse> {
            return localVarFp.previewFlowStateProfiles(flowStatePreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
         * @summary Preview Weekly Stats
         * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsPreviewResponse> {
            return localVarFp.previewWeeklyStats(weeklyStatsPreviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off a background job that dispatches Flow State events to Customer.io.
         * @summary Send Flow State Emails
         * @param {SendFlowStateRequest} sendFlowStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MarketingJobResponse> {
            return localVarFp.sendFlowStateEmails(sendFlowStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
         * @summary Send Test Weekly Stats
         * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsSendTestResponse> {
            return localVarFp.sendTestWeeklyStats(weeklyStatsSendTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
         * @summary Trigger Weekly Stats Batch Run
         * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyStatsBatchTriggerAcceptedResponse> {
            return localVarFp.triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalMarketingApi - object-oriented interface
 * @export
 * @class InternalMarketingApi
 * @extends {BaseAPI}
 */
export class InternalMarketingApi extends BaseAPI {
    /**
     * Enqueue a generate+send job for all eligible Flow State profiles.
     * @summary Generate And Send Flow State Emails
     * @param {GenerateAndSendFlowStateRequest} generateAndSendFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public generateAndSendFlowStateEmails(generateAndSendFlowStateRequest: GenerateAndSendFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).generateAndSendFlowStateEmails(generateAndSendFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off a background job that builds per-user Flow State profiles.
     * @summary Generate Flow State Profiles
     * @param {GenerateFlowStateRequest} generateFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public generateFlowStateProfiles(generateFlowStateRequest: GenerateFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).generateFlowStateProfiles(generateFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Persist weekly-stats snapshots. ``purpose=canary``: internal cohort. ``purpose=production``: full iOS audience + PostHog gate.
     * @summary Generate Weekly Stats
     * @param {WeeklyStatsGenerateRequest} weeklyStatsGenerateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public generateWeeklyStats(weeklyStatsGenerateRequest: WeeklyStatsGenerateRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).generateWeeklyStats(weeklyStatsGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the latest persisted state of a marketing job.
     * @summary Get Flow State Job
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public getFlowStateJob(jobId: string, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).getFlowStateJob(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return month-level Flow State generation/send state for the admin portal.
     * @summary Get Flow State Month Summary
     * @param {string} reportingMonth First day of the reporting month.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public getFlowStateMonthSummary(reportingMonth: string, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).getFlowStateMonthSummary(reportingMonth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the most recent batch run for a ``(snapshot_at, dry_run)`` pair; null ``run`` when none exists.
     * @summary Get Latest Weekly Stats Batch Run
     * @param {string} snapshotAt Sunday 00:00:00 UTC period cutoff to match. Must be timezone-aware.
     * @param {boolean} dryRun Dry-run flag to match.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public getLatestWeeklyStatsBatchRun(snapshotAt: string, dryRun: boolean, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).getLatestWeeklyStatsBatchRun(snapshotAt, dryRun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch one batch run\'s status, counters, staleness, and category-mapped last error.
     * @summary Get Weekly Stats Batch Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public getWeeklyStatsBatchRun(runId: string, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).getWeeklyStatsBatchRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch one manual trigger request\'s status; ``batch_run_id`` links to the run status endpoint.
     * @summary Get Weekly Stats Batch Trigger Request
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public getWeeklyStatsBatchTriggerRequest(requestId: string, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).getWeeklyStatsBatchTriggerRequest(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return generated profile rows for review before dispatch.
     * @summary Preview Flow State Profiles
     * @param {FlowStatePreviewRequest} flowStatePreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public previewFlowStateProfiles(flowStatePreviewRequest: FlowStatePreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).previewFlowStateProfiles(flowStatePreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compute weekly metrics for 1–10 ``@wispr.ai`` users without DB writes.
     * @summary Preview Weekly Stats
     * @param {WeeklyStatsPreviewRequest} weeklyStatsPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public previewWeeklyStats(weeklyStatsPreviewRequest: WeeklyStatsPreviewRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).previewWeeklyStats(weeklyStatsPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off a background job that dispatches Flow State events to Customer.io.
     * @summary Send Flow State Emails
     * @param {SendFlowStateRequest} sendFlowStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public sendFlowStateEmails(sendFlowStateRequest: SendFlowStateRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).sendFlowStateEmails(sendFlowStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compute one ``@wispr.ai`` user\'s weekly stats and fire it as a Customer.io Track event.
     * @summary Send Test Weekly Stats
     * @param {WeeklyStatsSendTestRequest} weeklyStatsSendTestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public sendTestWeeklyStats(weeklyStatsSendTestRequest: WeeklyStatsSendTestRequest, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).sendTestWeeklyStats(weeklyStatsSendTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Queue an off-schedule batch run; the trigger poller executes it within ~5 minutes.  202-and-poll: poll ``/batch/trigger-requests/{request_id}`` for the request, then ``/batch/runs/{batch_run_id}`` once the run starts. The batch executes on the cron worker under the same Redis lock and DB single-flight as the Sunday cron, so it never runs concurrently with it (see the service module docstring). A failed request may not carry ``batch_run_id``; check ``GET /batch/runs/latest`` for the corresponding run in that case.
     * @summary Trigger Weekly Stats Batch Run
     * @param {WeeklyStatsBatchTriggerRequestBody} weeklyStatsBatchTriggerRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalMarketingApi
     */
    public triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody: WeeklyStatsBatchTriggerRequestBody, options?: RawAxiosRequestConfig) {
        return InternalMarketingApiFp(this.configuration).triggerWeeklyStatsBatchRun(weeklyStatsBatchTriggerRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KeyboardTelemetryApi - axios parameter creator
 * @export
 */
export const KeyboardTelemetryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept one aggregated keyboard-touch batch and insert its cells into ClickHouse.  Gated behind a kill switch (404 when disabled) and the shared data-sharing consent check (403 when not permitted). Idempotent on ``batch_id``: a duplicate delivery returns ``accepted=0`` without re-inserting. Returns 503 when Redis is unavailable for the idempotency claim or when a ClickHouse insert fails ambiguously.  Args:     body:       The batch of aggregated touch cells to ingest.     user:       The authenticated Supabase user submitting the batch.     db:         Database executor used for the consent/compliance gate.     redis:      Redis client backing the idempotency claim.     _rate_limit: Per-user rate-limit guard (fails closed).  Returns:     KbTouchIngestResponse: The count of cells accepted for insertion.  Raises:     HTTPNotFound: Telemetry ingest is disabled.     HTTPForbidden: Data sharing is not permitted for the user.     HTTPServiceUnavailable: Redis or ClickHouse was unavailable and the batch was not durably accepted.
         * @summary Ingest keyboard touch aggregate cells (staging-gated)
         * @param {KbTouchBatch} kbTouchBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestKeyboardTelemetry: async (kbTouchBatch: KbTouchBatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kbTouchBatch' is not null or undefined
            assertParamExists('ingestKeyboardTelemetry', 'kbTouchBatch', kbTouchBatch)
            const localVarPath = `/api/v1/keyboard_telemetry/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(kbTouchBatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeyboardTelemetryApi - functional programming interface
 * @export
 */
export const KeyboardTelemetryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeyboardTelemetryApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept one aggregated keyboard-touch batch and insert its cells into ClickHouse.  Gated behind a kill switch (404 when disabled) and the shared data-sharing consent check (403 when not permitted). Idempotent on ``batch_id``: a duplicate delivery returns ``accepted=0`` without re-inserting. Returns 503 when Redis is unavailable for the idempotency claim or when a ClickHouse insert fails ambiguously.  Args:     body:       The batch of aggregated touch cells to ingest.     user:       The authenticated Supabase user submitting the batch.     db:         Database executor used for the consent/compliance gate.     redis:      Redis client backing the idempotency claim.     _rate_limit: Per-user rate-limit guard (fails closed).  Returns:     KbTouchIngestResponse: The count of cells accepted for insertion.  Raises:     HTTPNotFound: Telemetry ingest is disabled.     HTTPForbidden: Data sharing is not permitted for the user.     HTTPServiceUnavailable: Redis or ClickHouse was unavailable and the batch was not durably accepted.
         * @summary Ingest keyboard touch aggregate cells (staging-gated)
         * @param {KbTouchBatch} kbTouchBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestKeyboardTelemetry(kbTouchBatch: KbTouchBatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KbTouchIngestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestKeyboardTelemetry(kbTouchBatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeyboardTelemetryApi.ingestKeyboardTelemetry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KeyboardTelemetryApi - factory interface
 * @export
 */
export const KeyboardTelemetryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeyboardTelemetryApiFp(configuration)
    return {
        /**
         * Accept one aggregated keyboard-touch batch and insert its cells into ClickHouse.  Gated behind a kill switch (404 when disabled) and the shared data-sharing consent check (403 when not permitted). Idempotent on ``batch_id``: a duplicate delivery returns ``accepted=0`` without re-inserting. Returns 503 when Redis is unavailable for the idempotency claim or when a ClickHouse insert fails ambiguously.  Args:     body:       The batch of aggregated touch cells to ingest.     user:       The authenticated Supabase user submitting the batch.     db:         Database executor used for the consent/compliance gate.     redis:      Redis client backing the idempotency claim.     _rate_limit: Per-user rate-limit guard (fails closed).  Returns:     KbTouchIngestResponse: The count of cells accepted for insertion.  Raises:     HTTPNotFound: Telemetry ingest is disabled.     HTTPForbidden: Data sharing is not permitted for the user.     HTTPServiceUnavailable: Redis or ClickHouse was unavailable and the batch was not durably accepted.
         * @summary Ingest keyboard touch aggregate cells (staging-gated)
         * @param {KbTouchBatch} kbTouchBatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestKeyboardTelemetry(kbTouchBatch: KbTouchBatch, options?: RawAxiosRequestConfig): AxiosPromise<KbTouchIngestResponse> {
            return localVarFp.ingestKeyboardTelemetry(kbTouchBatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeyboardTelemetryApi - object-oriented interface
 * @export
 * @class KeyboardTelemetryApi
 * @extends {BaseAPI}
 */
export class KeyboardTelemetryApi extends BaseAPI {
    /**
     * Accept one aggregated keyboard-touch batch and insert its cells into ClickHouse.  Gated behind a kill switch (404 when disabled) and the shared data-sharing consent check (403 when not permitted). Idempotent on ``batch_id``: a duplicate delivery returns ``accepted=0`` without re-inserting. Returns 503 when Redis is unavailable for the idempotency claim or when a ClickHouse insert fails ambiguously.  Args:     body:       The batch of aggregated touch cells to ingest.     user:       The authenticated Supabase user submitting the batch.     db:         Database executor used for the consent/compliance gate.     redis:      Redis client backing the idempotency claim.     _rate_limit: Per-user rate-limit guard (fails closed).  Returns:     KbTouchIngestResponse: The count of cells accepted for insertion.  Raises:     HTTPNotFound: Telemetry ingest is disabled.     HTTPForbidden: Data sharing is not permitted for the user.     HTTPServiceUnavailable: Redis or ClickHouse was unavailable and the batch was not durably accepted.
     * @summary Ingest keyboard touch aggregate cells (staging-gated)
     * @param {KbTouchBatch} kbTouchBatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyboardTelemetryApi
     */
    public ingestKeyboardTelemetry(kbTouchBatch: KbTouchBatch, options?: RawAxiosRequestConfig) {
        return KeyboardTelemetryApiFp(this.configuration).ingestKeyboardTelemetry(kbTouchBatch, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LLMApi - axios parameter creator
 * @export
 */
export const LLMApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stream one provider-neutral agent invocation.  A `turn` adds frame ids and response.started; a turn admitted as durable runs apart from this request, and the server saves its chat rows.
         * @summary Agent Response
         * @param {WisprAgentRequest} wisprAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentResponse: async (wisprAgentRequest: WisprAgentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wisprAgentRequest' is not null or undefined
            assertParamExists('agentResponse', 'wisprAgentRequest', wisprAgentRequest)
            const localVarPath = `/llm/agent_response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wisprAgentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transcribe audio to raw text and return the detected language (ASR only, no formatting).
         * @summary Asr
         * @param {BodyAsrLlmAsrPost} bodyAsrLlmAsrPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asr: async (bodyAsrLlmAsrPost: BodyAsrLlmAsrPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyAsrLlmAsrPost' is not null or undefined
            assertParamExists('asr', 'bodyAsrLlmAsrPost', bodyAsrLlmAsrPost)
            const localVarPath = `/llm/asr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyAsrLlmAsrPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run the chunked ASR pipeline over streamed audio packets with prior-turn context.
         * @summary Asr Audio Chunks
         * @param {AsrAudioChunksRequest} asrAudioChunksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asrAudioChunks: async (asrAudioChunksRequest: AsrAudioChunksRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'asrAudioChunksRequest' is not null or undefined
            assertParamExists('asrAudioChunks', 'asrAudioChunksRequest', asrAudioChunksRequest)
            const localVarPath = `/llm/asr_audio_chunks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(asrAudioChunksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop a durable turn; it ends with a cancelled frame unless it already holds its terminal one.
         * @summary Cancel Agent Turn
         * @param {string} turnId 
         * @param {string | null} [assistantMessageId] Cancel only this attempt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAgentTurn: async (turnId: string, assistantMessageId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'turnId' is not null or undefined
            assertParamExists('cancelAgentTurn', 'turnId', turnId)
            const localVarPath = `/llm/agent_turns/{turn_id}/cancel`
                .replace(`{${"turn_id"}}`, encodeURIComponent(String(turnId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (assistantMessageId !== undefined) {
                localVarQueryParameter['assistant_message_id'] = assistantMessageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check whether a transcribed message makes sense in context.  Returns a score from 0.0 (nonsensical) to 1.0 (makes perfect sense). Used to warn users before they send a potentially embarrassing message.
         * @summary Check Sensibility
         * @param {CheckSensibilityRequest} checkSensibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSensibility: async (checkSensibilityRequest: CheckSensibilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkSensibilityRequest' is not null or undefined
            assertParamExists('checkSensibility', 'checkSensibilityRequest', checkSensibilityRequest)
            const localVarPath = `/llm/check_sensibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkSensibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Classify voice input into one of the provided routes.  Returns the matched route plus optional per-route structured data the classifier emits, and an ``is_instruction`` flag (true when the route is anything other than plain dictation).
         * @summary Classify Intent
         * @param {ClassifyIntentRequest} classifyIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        classifyIntent: async (classifyIntentRequest: ClassifyIntentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classifyIntentRequest' is not null or undefined
            assertParamExists('classifyIntent', 'classifyIntentRequest', classifyIntentRequest)
            const localVarPath = `/llm/classify_intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(classifyIntentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply a command-mode instruction to the selected text and return the edited result.
         * @summary Command Mode
         * @param {CommandModeRequest} commandModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandMode: async (commandModeRequest: CommandModeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commandModeRequest' is not null or undefined
            assertParamExists('commandMode', 'commandModeRequest', commandModeRequest)
            const localVarPath = `/llm/command_mode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Route a command-mode instruction for premium users; return 403 for non-premium users.
         * @summary Command Mode Route
         * @param {CommandModeRouteRequest} commandModeRouteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandModeRoute: async (commandModeRouteRequest: CommandModeRouteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commandModeRouteRequest' is not null or undefined
            assertParamExists('commandModeRoute', 'commandModeRouteRequest', commandModeRouteRequest)
            const localVarPath = `/llm/command_mode_route`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandModeRouteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a raw chat completion against the configured provider and return the model output.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completion: async (completionRequest: CompletionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completionRequest' is not null or undefined
            assertParamExists('completion', 'completionRequest', completionRequest)
            const localVarPath = `/llm/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off background computation of the user\'s Flow State 2025 recap and return its status.
         * @summary Create Flow State 2025
         * @param {HistoryRowsRequest} historyRowsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowState2025: async (historyRowsRequest: HistoryRowsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'historyRowsRequest' is not null or undefined
            assertParamExists('createFlowState2025', 'historyRowsRequest', historyRowsRequest)
            const localVarPath = `/llm/flow_state_2025`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(historyRowsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kick off background generation of the user\'s voice profile and return its status.
         * @summary Create Voice Profile
         * @param {VoiceProfileRequest} voiceProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceProfile: async (voiceProfileRequest: VoiceProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'voiceProfileRequest' is not null or undefined
            assertParamExists('createVoiceProfile', 'voiceProfileRequest', voiceProfileRequest)
            const localVarPath = `/llm/voice_profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Classify a text message into a formality level (very_casual, casual, or formal).  Bases the judgement on capitalization, punctuation, and other use of informal language.
         * @summary Detect Formality
         * @param {DetectFormalityRequest} detectFormalityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFormality: async (detectFormalityRequest: DetectFormalityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detectFormalityRequest' is not null or undefined
            assertParamExists('detectFormality', 'detectFormalityRequest', detectFormalityRequest)
            const localVarPath = `/llm/detect_formality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(detectFormalityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forward a dictation request to the Baseten flow-chain, attaching the server-held API key.  The body passes through verbatim, so clients keep owning the flow-chain request contract and this endpoint needs no change when that contract evolves.
         * @summary Dictation
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictation: async (body: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('dictation', 'body', body)
            const localVarPath = `/llm/dictation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extract candidate ASR vocabulary words from the current textbox text.
         * @summary Extract Asr Words
         * @param {ExtractASRWordsRequest} extractASRWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractAsrWords: async (extractASRWordsRequest: ExtractASRWordsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractASRWordsRequest' is not null or undefined
            assertParamExists('extractAsrWords', 'extractASRWordsRequest', extractASRWordsRequest)
            const localVarPath = `/llm/extract_asr_words`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extractASRWordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extract proper nouns, technical, or domain terms edited between the pasted and edited text.
         * @summary Extract Edited Words
         * @param {ExtractEditedWordsRequest} extractEditedWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractEditedWords: async (extractEditedWordsRequest: ExtractEditedWordsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractEditedWordsRequest' is not null or undefined
            assertParamExists('extractEditedWords', 'extractEditedWordsRequest', extractEditedWordsRequest)
            const localVarPath = `/llm/extract_edited_words`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extractEditedWordsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the user\'s computed Flow State 2025 recap and its processing status.
         * @summary Fetch Flow State 2025
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFlowState2025: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/llm/flow_state_2025`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the user\'s most recent voice profile.
         * @summary Fetch Latest Voice Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLatestVoiceProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/llm/voice_profile/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch the user\'s voice profile, optionally for a specific word-count milestone.
         * @summary Fetch Voice Profile
         * @param {FetchVoiceProfileWordCountMilestoneEnum} [wordCountMilestone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVoiceProfile: async (wordCountMilestone?: FetchVoiceProfileWordCountMilestoneEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/llm/voice_profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (wordCountMilestone !== undefined) {
                localVarQueryParameter['word_count_milestone'] = wordCountMilestone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transcribe and format dictation audio into finished text (the core dictation endpoint).
         * @summary Flow Api
         * @param {BodyFlowApiLlmApiPost} bodyFlowApiLlmApiPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowApi: async (bodyFlowApiLlmApiPost: BodyFlowApiLlmApiPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyFlowApiLlmApiPost' is not null or undefined
            assertParamExists('flowApi', 'bodyFlowApiLlmApiPost', bodyFlowApiLlmApiPost)
            const localVarPath = `/llm/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyFlowApiLlmApiPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a demo chat reply using the persona prompt selected by the request\'s workflow.
         * @summary Flow Response
         * @param {FlowResponseRequest} flowResponseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowResponse: async (flowResponseRequest: FlowResponseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowResponseRequest' is not null or undefined
            assertParamExists('flowResponse', 'flowResponseRequest', flowResponseRequest)
            const localVarPath = `/llm/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(flowResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Format non-English transcript text, returning 400 on empty input and 422 on output divergence.
         * @summary Format Non English Endpoint
         * @param {NonEnglishFormattingRequest} nonEnglishFormattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatNonEnglishEndpoint: async (nonEnglishFormattingRequest: NonEnglishFormattingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nonEnglishFormattingRequest' is not null or undefined
            assertParamExists('formatNonEnglishEndpoint', 'nonEnglishFormattingRequest', nonEnglishFormattingRequest)
            const localVarPath = `/llm/format_non_english`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nonEnglishFormattingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Format raw transcript text with the requested formatting model.
         * @summary Formatting
         * @param {FormattingRequest} formattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatting: async (formattingRequest: FormattingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formattingRequest' is not null or undefined
            assertParamExists('formatting', 'formattingRequest', formattingRequest)
            const localVarPath = `/llm/formatting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formattingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute an instruct-mode instruction against the provided screen/app context.
         * @summary Instruct Mode
         * @param {InstructModeRequest} instructModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instructMode: async (instructModeRequest: InstructModeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instructModeRequest' is not null or undefined
            assertParamExists('instructMode', 'instructModeRequest', instructModeRequest)
            const localVarPath = `/llm/instruct_mode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instructModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extract text from a base64-encoded image via OCR.
         * @summary Ocr
         * @param {OCRRequest} oCRRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocr: async (oCRRequest: OCRRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oCRRequest' is not null or undefined
            assertParamExists('ocr', 'oCRRequest', oCRRequest)
            const localVarPath = `/llm/ocr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oCRRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rewrite selected text using the user\'s polish instructions, samples, or custom prompt.
         * @summary Polish Text
         * @param {PolishTextRequest} polishTextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polishText: async (polishTextRequest: PolishTextRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'polishTextRequest' is not null or undefined
            assertParamExists('polishText', 'polishTextRequest', polishTextRequest)
            const localVarPath = `/llm/polish_text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(polishTextRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LLMApi - functional programming interface
 * @export
 */
export const LLMApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LLMApiAxiosParamCreator(configuration)
    return {
        /**
         * Stream one provider-neutral agent invocation.  A `turn` adds frame ids and response.started; a turn admitted as durable runs apart from this request, and the server saves its chat rows.
         * @summary Agent Response
         * @param {WisprAgentRequest} wisprAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentResponse(wisprAgentRequest: WisprAgentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentResponse(wisprAgentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.agentResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transcribe audio to raw text and return the detected language (ASR only, no formatting).
         * @summary Asr
         * @param {BodyAsrLlmAsrPost} bodyAsrLlmAsrPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asr(bodyAsrLlmAsrPost: BodyAsrLlmAsrPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asr(bodyAsrLlmAsrPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.asr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run the chunked ASR pipeline over streamed audio packets with prior-turn context.
         * @summary Asr Audio Chunks
         * @param {AsrAudioChunksRequest} asrAudioChunksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async asrAudioChunks(asrAudioChunksRequest: AsrAudioChunksRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.asrAudioChunks(asrAudioChunksRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.asrAudioChunks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop a durable turn; it ends with a cancelled frame unless it already holds its terminal one.
         * @summary Cancel Agent Turn
         * @param {string} turnId 
         * @param {string | null} [assistantMessageId] Cancel only this attempt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelAgentTurn(turnId: string, assistantMessageId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprAgentTurnCancelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelAgentTurn(turnId, assistantMessageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.cancelAgentTurn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check whether a transcribed message makes sense in context.  Returns a score from 0.0 (nonsensical) to 1.0 (makes perfect sense). Used to warn users before they send a potentially embarrassing message.
         * @summary Check Sensibility
         * @param {CheckSensibilityRequest} checkSensibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSensibility(checkSensibilityRequest: CheckSensibilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckSensibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSensibility(checkSensibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.checkSensibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Classify voice input into one of the provided routes.  Returns the matched route plus optional per-route structured data the classifier emits, and an ``is_instruction`` flag (true when the route is anything other than plain dictation).
         * @summary Classify Intent
         * @param {ClassifyIntentRequest} classifyIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async classifyIntent(classifyIntentRequest: ClassifyIntentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassifyIntentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.classifyIntent(classifyIntentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.classifyIntent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply a command-mode instruction to the selected text and return the edited result.
         * @summary Command Mode
         * @param {CommandModeRequest} commandModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandMode(commandModeRequest: CommandModeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandMode(commandModeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.commandMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Route a command-mode instruction for premium users; return 403 for non-premium users.
         * @summary Command Mode Route
         * @param {CommandModeRouteRequest} commandModeRouteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandModeRoute(commandModeRouteRequest: CommandModeRouteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandModeRoute(commandModeRouteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.commandModeRoute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a raw chat completion against the configured provider and return the model output.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completion(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completion(completionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.completion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off background computation of the user\'s Flow State 2025 recap and return its status.
         * @summary Create Flow State 2025
         * @param {HistoryRowsRequest} historyRowsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlowState2025(historyRowsRequest: HistoryRowsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowState2025Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlowState2025(historyRowsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.createFlowState2025']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kick off background generation of the user\'s voice profile and return its status.
         * @summary Create Voice Profile
         * @param {VoiceProfileRequest} voiceProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoiceProfile(voiceProfileRequest: VoiceProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoiceProfile(voiceProfileRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.createVoiceProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Classify a text message into a formality level (very_casual, casual, or formal).  Bases the judgement on capitalization, punctuation, and other use of informal language.
         * @summary Detect Formality
         * @param {DetectFormalityRequest} detectFormalityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async detectFormality(detectFormalityRequest: DetectFormalityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetectFormalityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.detectFormality(detectFormalityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.detectFormality']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Forward a dictation request to the Baseten flow-chain, attaching the server-held API key.  The body passes through verbatim, so clients keep owning the flow-chain request contract and this endpoint needs no change when that contract evolves.
         * @summary Dictation
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictation(body: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictation(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.dictation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extract candidate ASR vocabulary words from the current textbox text.
         * @summary Extract Asr Words
         * @param {ExtractASRWordsRequest} extractASRWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractAsrWords(extractASRWordsRequest: ExtractASRWordsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractAsrWords(extractASRWordsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.extractAsrWords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extract proper nouns, technical, or domain terms edited between the pasted and edited text.
         * @summary Extract Edited Words
         * @param {ExtractEditedWordsRequest} extractEditedWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractEditedWords(extractEditedWordsRequest: ExtractEditedWordsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractEditedWordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractEditedWords(extractEditedWordsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.extractEditedWords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the user\'s computed Flow State 2025 recap and its processing status.
         * @summary Fetch Flow State 2025
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchFlowState2025(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlowState2025Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchFlowState2025(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.fetchFlowState2025']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the user\'s most recent voice profile.
         * @summary Fetch Latest Voice Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchLatestVoiceProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchLatestVoiceProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.fetchLatestVoiceProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch the user\'s voice profile, optionally for a specific word-count milestone.
         * @summary Fetch Voice Profile
         * @param {FetchVoiceProfileWordCountMilestoneEnum} [wordCountMilestone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchVoiceProfile(wordCountMilestone?: FetchVoiceProfileWordCountMilestoneEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchVoiceProfile(wordCountMilestone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.fetchVoiceProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transcribe and format dictation audio into finished text (the core dictation endpoint).
         * @summary Flow Api
         * @param {BodyFlowApiLlmApiPost} bodyFlowApiLlmApiPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowApi(bodyFlowApiLlmApiPost: BodyFlowApiLlmApiPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowApi(bodyFlowApiLlmApiPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.flowApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a demo chat reply using the persona prompt selected by the request\'s workflow.
         * @summary Flow Response
         * @param {FlowResponseRequest} flowResponseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async flowResponse(flowResponseRequest: FlowResponseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.flowResponse(flowResponseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.flowResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Format non-English transcript text, returning 400 on empty input and 422 on output divergence.
         * @summary Format Non English Endpoint
         * @param {NonEnglishFormattingRequest} nonEnglishFormattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formatNonEnglishEndpoint(nonEnglishFormattingRequest: NonEnglishFormattingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formatNonEnglishEndpoint(nonEnglishFormattingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.formatNonEnglishEndpoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Format raw transcript text with the requested formatting model.
         * @summary Formatting
         * @param {FormattingRequest} formattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formatting(formattingRequest: FormattingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formatting(formattingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.formatting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Execute an instruct-mode instruction against the provided screen/app context.
         * @summary Instruct Mode
         * @param {InstructModeRequest} instructModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instructMode(instructModeRequest: InstructModeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstructModeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instructMode(instructModeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.instructMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extract text from a base64-encoded image via OCR.
         * @summary Ocr
         * @param {OCRRequest} oCRRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ocr(oCRRequest: OCRRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ocr(oCRRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.ocr']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rewrite selected text using the user\'s polish instructions, samples, or custom prompt.
         * @summary Polish Text
         * @param {PolishTextRequest} polishTextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async polishText(polishTextRequest: PolishTextRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolishTextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.polishText(polishTextRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LLMApi.polishText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LLMApi - factory interface
 * @export
 */
export const LLMApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LLMApiFp(configuration)
    return {
        /**
         * Stream one provider-neutral agent invocation.  A `turn` adds frame ids and response.started; a turn admitted as durable runs apart from this request, and the server saves its chat rows.
         * @summary Agent Response
         * @param {WisprAgentRequest} wisprAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentResponse(wisprAgentRequest: WisprAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.agentResponse(wisprAgentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Transcribe audio to raw text and return the detected language (ASR only, no formatting).
         * @summary Asr
         * @param {BodyAsrLlmAsrPost} bodyAsrLlmAsrPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asr(bodyAsrLlmAsrPost: BodyAsrLlmAsrPost, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.asr(bodyAsrLlmAsrPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Run the chunked ASR pipeline over streamed audio packets with prior-turn context.
         * @summary Asr Audio Chunks
         * @param {AsrAudioChunksRequest} asrAudioChunksRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        asrAudioChunks(asrAudioChunksRequest: AsrAudioChunksRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.asrAudioChunks(asrAudioChunksRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop a durable turn; it ends with a cancelled frame unless it already holds its terminal one.
         * @summary Cancel Agent Turn
         * @param {string} turnId 
         * @param {string | null} [assistantMessageId] Cancel only this attempt.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelAgentTurn(turnId: string, assistantMessageId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<WisprAgentTurnCancelResponse> {
            return localVarFp.cancelAgentTurn(turnId, assistantMessageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check whether a transcribed message makes sense in context.  Returns a score from 0.0 (nonsensical) to 1.0 (makes perfect sense). Used to warn users before they send a potentially embarrassing message.
         * @summary Check Sensibility
         * @param {CheckSensibilityRequest} checkSensibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSensibility(checkSensibilityRequest: CheckSensibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckSensibilityResponse> {
            return localVarFp.checkSensibility(checkSensibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Classify voice input into one of the provided routes.  Returns the matched route plus optional per-route structured data the classifier emits, and an ``is_instruction`` flag (true when the route is anything other than plain dictation).
         * @summary Classify Intent
         * @param {ClassifyIntentRequest} classifyIntentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        classifyIntent(classifyIntentRequest: ClassifyIntentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClassifyIntentResponse> {
            return localVarFp.classifyIntent(classifyIntentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply a command-mode instruction to the selected text and return the edited result.
         * @summary Command Mode
         * @param {CommandModeRequest} commandModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandMode(commandModeRequest: CommandModeRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.commandMode(commandModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Route a command-mode instruction for premium users; return 403 for non-premium users.
         * @summary Command Mode Route
         * @param {CommandModeRouteRequest} commandModeRouteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandModeRoute(commandModeRouteRequest: CommandModeRouteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.commandModeRoute(commandModeRouteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run a raw chat completion against the configured provider and return the model output.
         * @summary Completion
         * @param {CompletionRequest} completionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completion(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.completion(completionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off background computation of the user\'s Flow State 2025 recap and return its status.
         * @summary Create Flow State 2025
         * @param {HistoryRowsRequest} historyRowsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlowState2025(historyRowsRequest: HistoryRowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<FlowState2025Response> {
            return localVarFp.createFlowState2025(historyRowsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Kick off background generation of the user\'s voice profile and return its status.
         * @summary Create Voice Profile
         * @param {VoiceProfileRequest} voiceProfileRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceProfile(voiceProfileRequest: VoiceProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<VoiceProfileResponse> {
            return localVarFp.createVoiceProfile(voiceProfileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Classify a text message into a formality level (very_casual, casual, or formal).  Bases the judgement on capitalization, punctuation, and other use of informal language.
         * @summary Detect Formality
         * @param {DetectFormalityRequest} detectFormalityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detectFormality(detectFormalityRequest: DetectFormalityRequest, options?: RawAxiosRequestConfig): AxiosPromise<DetectFormalityResponse> {
            return localVarFp.detectFormality(detectFormalityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Forward a dictation request to the Baseten flow-chain, attaching the server-held API key.  The body passes through verbatim, so clients keep owning the flow-chain request contract and this endpoint needs no change when that contract evolves.
         * @summary Dictation
         * @param {any} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictation(body: any, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.dictation(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Extract candidate ASR vocabulary words from the current textbox text.
         * @summary Extract Asr Words
         * @param {ExtractASRWordsRequest} extractASRWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractAsrWords(extractASRWordsRequest: ExtractASRWordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.extractAsrWords(extractASRWordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Extract proper nouns, technical, or domain terms edited between the pasted and edited text.
         * @summary Extract Edited Words
         * @param {ExtractEditedWordsRequest} extractEditedWordsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractEditedWords(extractEditedWordsRequest: ExtractEditedWordsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractEditedWordsResponse> {
            return localVarFp.extractEditedWords(extractEditedWordsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the user\'s computed Flow State 2025 recap and its processing status.
         * @summary Fetch Flow State 2025
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchFlowState2025(options?: RawAxiosRequestConfig): AxiosPromise<FlowState2025Response> {
            return localVarFp.fetchFlowState2025(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the user\'s most recent voice profile.
         * @summary Fetch Latest Voice Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLatestVoiceProfile(options?: RawAxiosRequestConfig): AxiosPromise<VoiceProfileResponse> {
            return localVarFp.fetchLatestVoiceProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch the user\'s voice profile, optionally for a specific word-count milestone.
         * @summary Fetch Voice Profile
         * @param {FetchVoiceProfileWordCountMilestoneEnum} [wordCountMilestone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchVoiceProfile(wordCountMilestone?: FetchVoiceProfileWordCountMilestoneEnum, options?: RawAxiosRequestConfig): AxiosPromise<VoiceProfileResponse> {
            return localVarFp.fetchVoiceProfile(wordCountMilestone, options).then((request) => request(axios, basePath));
        },
        /**
         * Transcribe and format dictation audio into finished text (the core dictation endpoint).
         * @summary Flow Api
         * @param {BodyFlowApiLlmApiPost} bodyFlowApiLlmApiPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowApi(bodyFlowApiLlmApiPost: BodyFlowApiLlmApiPost, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.flowApi(bodyFlowApiLlmApiPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a demo chat reply using the persona prompt selected by the request\'s workflow.
         * @summary Flow Response
         * @param {FlowResponseRequest} flowResponseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        flowResponse(flowResponseRequest: FlowResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.flowResponse(flowResponseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Format non-English transcript text, returning 400 on empty input and 422 on output divergence.
         * @summary Format Non English Endpoint
         * @param {NonEnglishFormattingRequest} nonEnglishFormattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatNonEnglishEndpoint(nonEnglishFormattingRequest: NonEnglishFormattingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.formatNonEnglishEndpoint(nonEnglishFormattingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Format raw transcript text with the requested formatting model.
         * @summary Formatting
         * @param {FormattingRequest} formattingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formatting(formattingRequest: FormattingRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.formatting(formattingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute an instruct-mode instruction against the provided screen/app context.
         * @summary Instruct Mode
         * @param {InstructModeRequest} instructModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instructMode(instructModeRequest: InstructModeRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstructModeResponse> {
            return localVarFp.instructMode(instructModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Extract text from a base64-encoded image via OCR.
         * @summary Ocr
         * @param {OCRRequest} oCRRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ocr(oCRRequest: OCRRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.ocr(oCRRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rewrite selected text using the user\'s polish instructions, samples, or custom prompt.
         * @summary Polish Text
         * @param {PolishTextRequest} polishTextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        polishText(polishTextRequest: PolishTextRequest, options?: RawAxiosRequestConfig): AxiosPromise<PolishTextResponse> {
            return localVarFp.polishText(polishTextRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LLMApi - object-oriented interface
 * @export
 * @class LLMApi
 * @extends {BaseAPI}
 */
export class LLMApi extends BaseAPI {
    /**
     * Stream one provider-neutral agent invocation.  A `turn` adds frame ids and response.started; a turn admitted as durable runs apart from this request, and the server saves its chat rows.
     * @summary Agent Response
     * @param {WisprAgentRequest} wisprAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public agentResponse(wisprAgentRequest: WisprAgentRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).agentResponse(wisprAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transcribe audio to raw text and return the detected language (ASR only, no formatting).
     * @summary Asr
     * @param {BodyAsrLlmAsrPost} bodyAsrLlmAsrPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public asr(bodyAsrLlmAsrPost: BodyAsrLlmAsrPost, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).asr(bodyAsrLlmAsrPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run the chunked ASR pipeline over streamed audio packets with prior-turn context.
     * @summary Asr Audio Chunks
     * @param {AsrAudioChunksRequest} asrAudioChunksRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public asrAudioChunks(asrAudioChunksRequest: AsrAudioChunksRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).asrAudioChunks(asrAudioChunksRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop a durable turn; it ends with a cancelled frame unless it already holds its terminal one.
     * @summary Cancel Agent Turn
     * @param {string} turnId 
     * @param {string | null} [assistantMessageId] Cancel only this attempt.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public cancelAgentTurn(turnId: string, assistantMessageId?: string | null, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).cancelAgentTurn(turnId, assistantMessageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check whether a transcribed message makes sense in context.  Returns a score from 0.0 (nonsensical) to 1.0 (makes perfect sense). Used to warn users before they send a potentially embarrassing message.
     * @summary Check Sensibility
     * @param {CheckSensibilityRequest} checkSensibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public checkSensibility(checkSensibilityRequest: CheckSensibilityRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).checkSensibility(checkSensibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Classify voice input into one of the provided routes.  Returns the matched route plus optional per-route structured data the classifier emits, and an ``is_instruction`` flag (true when the route is anything other than plain dictation).
     * @summary Classify Intent
     * @param {ClassifyIntentRequest} classifyIntentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public classifyIntent(classifyIntentRequest: ClassifyIntentRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).classifyIntent(classifyIntentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply a command-mode instruction to the selected text and return the edited result.
     * @summary Command Mode
     * @param {CommandModeRequest} commandModeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public commandMode(commandModeRequest: CommandModeRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).commandMode(commandModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Route a command-mode instruction for premium users; return 403 for non-premium users.
     * @summary Command Mode Route
     * @param {CommandModeRouteRequest} commandModeRouteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public commandModeRoute(commandModeRouteRequest: CommandModeRouteRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).commandModeRoute(commandModeRouteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a raw chat completion against the configured provider and return the model output.
     * @summary Completion
     * @param {CompletionRequest} completionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public completion(completionRequest: CompletionRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).completion(completionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off background computation of the user\'s Flow State 2025 recap and return its status.
     * @summary Create Flow State 2025
     * @param {HistoryRowsRequest} historyRowsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public createFlowState2025(historyRowsRequest: HistoryRowsRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).createFlowState2025(historyRowsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kick off background generation of the user\'s voice profile and return its status.
     * @summary Create Voice Profile
     * @param {VoiceProfileRequest} voiceProfileRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public createVoiceProfile(voiceProfileRequest: VoiceProfileRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).createVoiceProfile(voiceProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Classify a text message into a formality level (very_casual, casual, or formal).  Bases the judgement on capitalization, punctuation, and other use of informal language.
     * @summary Detect Formality
     * @param {DetectFormalityRequest} detectFormalityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public detectFormality(detectFormalityRequest: DetectFormalityRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).detectFormality(detectFormalityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forward a dictation request to the Baseten flow-chain, attaching the server-held API key.  The body passes through verbatim, so clients keep owning the flow-chain request contract and this endpoint needs no change when that contract evolves.
     * @summary Dictation
     * @param {any} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public dictation(body: any, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).dictation(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extract candidate ASR vocabulary words from the current textbox text.
     * @summary Extract Asr Words
     * @param {ExtractASRWordsRequest} extractASRWordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public extractAsrWords(extractASRWordsRequest: ExtractASRWordsRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).extractAsrWords(extractASRWordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extract proper nouns, technical, or domain terms edited between the pasted and edited text.
     * @summary Extract Edited Words
     * @param {ExtractEditedWordsRequest} extractEditedWordsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public extractEditedWords(extractEditedWordsRequest: ExtractEditedWordsRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).extractEditedWords(extractEditedWordsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the user\'s computed Flow State 2025 recap and its processing status.
     * @summary Fetch Flow State 2025
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public fetchFlowState2025(options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).fetchFlowState2025(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the user\'s most recent voice profile.
     * @summary Fetch Latest Voice Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public fetchLatestVoiceProfile(options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).fetchLatestVoiceProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch the user\'s voice profile, optionally for a specific word-count milestone.
     * @summary Fetch Voice Profile
     * @param {FetchVoiceProfileWordCountMilestoneEnum} [wordCountMilestone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public fetchVoiceProfile(wordCountMilestone?: FetchVoiceProfileWordCountMilestoneEnum, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).fetchVoiceProfile(wordCountMilestone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transcribe and format dictation audio into finished text (the core dictation endpoint).
     * @summary Flow Api
     * @param {BodyFlowApiLlmApiPost} bodyFlowApiLlmApiPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public flowApi(bodyFlowApiLlmApiPost: BodyFlowApiLlmApiPost, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).flowApi(bodyFlowApiLlmApiPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a demo chat reply using the persona prompt selected by the request\'s workflow.
     * @summary Flow Response
     * @param {FlowResponseRequest} flowResponseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public flowResponse(flowResponseRequest: FlowResponseRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).flowResponse(flowResponseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Format non-English transcript text, returning 400 on empty input and 422 on output divergence.
     * @summary Format Non English Endpoint
     * @param {NonEnglishFormattingRequest} nonEnglishFormattingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public formatNonEnglishEndpoint(nonEnglishFormattingRequest: NonEnglishFormattingRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).formatNonEnglishEndpoint(nonEnglishFormattingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Format raw transcript text with the requested formatting model.
     * @summary Formatting
     * @param {FormattingRequest} formattingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public formatting(formattingRequest: FormattingRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).formatting(formattingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute an instruct-mode instruction against the provided screen/app context.
     * @summary Instruct Mode
     * @param {InstructModeRequest} instructModeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public instructMode(instructModeRequest: InstructModeRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).instructMode(instructModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extract text from a base64-encoded image via OCR.
     * @summary Ocr
     * @param {OCRRequest} oCRRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public ocr(oCRRequest: OCRRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).ocr(oCRRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rewrite selected text using the user\'s polish instructions, samples, or custom prompt.
     * @summary Polish Text
     * @param {PolishTextRequest} polishTextRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LLMApi
     */
    public polishText(polishTextRequest: PolishTextRequest, options?: RawAxiosRequestConfig) {
        return LLMApiFp(this.configuration).polishText(polishTextRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const FetchVoiceProfileWordCountMilestoneEnum = {
    NUMBER_2000: 2000,
    NUMBER_12000: 12000,
    NUMBER_37000: 37000,
    NUMBER_87000: 87000,
    NUMBER_162000: 162000,
    NUMBER_262000: 262000,
    NUMBER_362000: 362000,
    NUMBER_462000: 462000,
    NUMBER_562000: 562000,
    NUMBER_662000: 662000
} as const;
export type FetchVoiceProfileWordCountMilestoneEnum = typeof FetchVoiceProfileWordCountMilestoneEnum[keyof typeof FetchVoiceProfileWordCountMilestoneEnum];


/**
 * LearnedPreferencesApi - axios parameter creator
 * @export
 */
export const LearnedPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Purge the learned profile for the requested source, leaving the connector grant in place.
         * @summary Disconnect Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectLearnedPreferences: async (source: LearnedPreferenceSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('disconnectLearnedPreferences', 'source', source)
            const localVarPath = `/api/v1/learned-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or coalesce a background preference analysis run for the requested source.
         * @summary Generate Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLearnedPreferences: async (source: LearnedPreferenceSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('generateLearnedPreferences', 'source', source)
            const localVarPath = `/api/v1/learned-preferences/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return connection and analysis state for the requested source.
         * @summary Get Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearnedPreferences: async (source: LearnedPreferenceSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getLearnedPreferences', 'source', source)
            const localVarPath = `/api/v1/learned-preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the current instruct style prompt for the requested source, if one is usable.
         * @summary Get Learned Preferences Prompt
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearnedPreferencesPrompt: async (source: LearnedPreferenceSource, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getLearnedPreferencesPrompt', 'source', source)
            const localVarPath = `/api/v1/learned-preferences/prompt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LearnedPreferencesApi - functional programming interface
 * @export
 */
export const LearnedPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LearnedPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Purge the learned profile for the requested source, leaving the connector grant in place.
         * @summary Disconnect Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectLearnedPreferences(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearnedPreferencesApi.disconnectLearnedPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or coalesce a background preference analysis run for the requested source.
         * @summary Generate Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLearnedPreferences(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearnedPreferencesApi.generateLearnedPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return connection and analysis state for the requested source.
         * @summary Get Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedPreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearnedPreferences(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearnedPreferencesApi.getLearnedPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the current instruct style prompt for the requested source, if one is usable.
         * @summary Get Learned Preferences Prompt
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLearnedPreferencesPrompt(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnedPreferencesPromptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLearnedPreferencesPrompt(source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LearnedPreferencesApi.getLearnedPreferencesPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LearnedPreferencesApi - factory interface
 * @export
 */
export const LearnedPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LearnedPreferencesApiFp(configuration)
    return {
        /**
         * Purge the learned profile for the requested source, leaving the connector grant in place.
         * @summary Disconnect Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): AxiosPromise<DisconnectResponse> {
            return localVarFp.disconnectLearnedPreferences(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or coalesce a background preference analysis run for the requested source.
         * @summary Generate Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): AxiosPromise<LearnedPreferencesResponse> {
            return localVarFp.generateLearnedPreferences(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Return connection and analysis state for the requested source.
         * @summary Get Learned Preferences
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): AxiosPromise<LearnedPreferencesResponse> {
            return localVarFp.getLearnedPreferences(source, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the current instruct style prompt for the requested source, if one is usable.
         * @summary Get Learned Preferences Prompt
         * @param {LearnedPreferenceSource} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearnedPreferencesPrompt(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig): AxiosPromise<LearnedPreferencesPromptResponse> {
            return localVarFp.getLearnedPreferencesPrompt(source, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LearnedPreferencesApi - object-oriented interface
 * @export
 * @class LearnedPreferencesApi
 * @extends {BaseAPI}
 */
export class LearnedPreferencesApi extends BaseAPI {
    /**
     * Purge the learned profile for the requested source, leaving the connector grant in place.
     * @summary Disconnect Learned Preferences
     * @param {LearnedPreferenceSource} source 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearnedPreferencesApi
     */
    public disconnectLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig) {
        return LearnedPreferencesApiFp(this.configuration).disconnectLearnedPreferences(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or coalesce a background preference analysis run for the requested source.
     * @summary Generate Learned Preferences
     * @param {LearnedPreferenceSource} source 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearnedPreferencesApi
     */
    public generateLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig) {
        return LearnedPreferencesApiFp(this.configuration).generateLearnedPreferences(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return connection and analysis state for the requested source.
     * @summary Get Learned Preferences
     * @param {LearnedPreferenceSource} source 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearnedPreferencesApi
     */
    public getLearnedPreferences(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig) {
        return LearnedPreferencesApiFp(this.configuration).getLearnedPreferences(source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the current instruct style prompt for the requested source, if one is usable.
     * @summary Get Learned Preferences Prompt
     * @param {LearnedPreferenceSource} source 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearnedPreferencesApi
     */
    public getLearnedPreferencesPrompt(source: LearnedPreferenceSource, options?: RawAxiosRequestConfig) {
        return LearnedPreferencesApiFp(this.configuration).getLearnedPreferencesPrompt(source, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LinkedInApi - axios parameter creator
 * @export
 */
export const LinkedInApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Begin the LinkedIn OAuth flow: redirect the user to LinkedIn\'s consent screen.
         * @summary Linkedin Connect
         * @param {string} [source] 
         * @param {string} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinConnect: async (source?: string, platform?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/linkedin/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the caller\'s LinkedIn integration; best-effort delete the signal first.
         * @summary Linkedin Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinDisconnect: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/linkedin/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the caller\'s LinkedIn connection state.
         * @summary Linkedin Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/linkedin/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LinkedInApi - functional programming interface
 * @export
 */
export const LinkedInApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LinkedInApiAxiosParamCreator(configuration)
    return {
        /**
         * Begin the LinkedIn OAuth flow: redirect the user to LinkedIn\'s consent screen.
         * @summary Linkedin Connect
         * @param {string} [source] 
         * @param {string} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkedinConnect(source?: string, platform?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkedinConnect(source, platform, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedInApi.linkedinConnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the caller\'s LinkedIn integration; best-effort delete the signal first.
         * @summary Linkedin Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkedinDisconnect(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedInDisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkedinDisconnect(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedInApi.linkedinDisconnect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the caller\'s LinkedIn connection state.
         * @summary Linkedin Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkedinStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedInStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkedinStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedInApi.linkedinStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LinkedInApi - factory interface
 * @export
 */
export const LinkedInApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LinkedInApiFp(configuration)
    return {
        /**
         * Begin the LinkedIn OAuth flow: redirect the user to LinkedIn\'s consent screen.
         * @summary Linkedin Connect
         * @param {string} [source] 
         * @param {string} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinConnect(source?: string, platform?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.linkedinConnect(source, platform, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the caller\'s LinkedIn integration; best-effort delete the signal first.
         * @summary Linkedin Disconnect
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinDisconnect(options?: RawAxiosRequestConfig): AxiosPromise<LinkedInDisconnectResponse> {
            return localVarFp.linkedinDisconnect(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the caller\'s LinkedIn connection state.
         * @summary Linkedin Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkedinStatus(options?: RawAxiosRequestConfig): AxiosPromise<LinkedInStatusResponse> {
            return localVarFp.linkedinStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LinkedInApi - object-oriented interface
 * @export
 * @class LinkedInApi
 * @extends {BaseAPI}
 */
export class LinkedInApi extends BaseAPI {
    /**
     * Begin the LinkedIn OAuth flow: redirect the user to LinkedIn\'s consent screen.
     * @summary Linkedin Connect
     * @param {string} [source] 
     * @param {string} [platform] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedInApi
     */
    public linkedinConnect(source?: string, platform?: string, options?: RawAxiosRequestConfig) {
        return LinkedInApiFp(this.configuration).linkedinConnect(source, platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the caller\'s LinkedIn integration; best-effort delete the signal first.
     * @summary Linkedin Disconnect
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedInApi
     */
    public linkedinDisconnect(options?: RawAxiosRequestConfig) {
        return LinkedInApiFp(this.configuration).linkedinDisconnect(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the caller\'s LinkedIn connection state.
     * @summary Linkedin Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedInApi
     */
    public linkedinStatus(options?: RawAxiosRequestConfig) {
        return LinkedInApiFp(this.configuration).linkedinStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MarketingApi - axios parameter creator
 * @export
 */
export const MarketingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Base
         * @param {string | null} [page] 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectBase: async (page?: string | null, subpage?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/marketing/redirect/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (subpage !== undefined) {
                localVarQueryParameter['subpage'] = subpage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page
         * @param {string | null} page 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectPage: async (page: string | null, subpage?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('marketingRedirectPage', 'page', page)
            const localVarPath = `/marketing/redirect/{page}`
                .replace(`{${"page"}}`, encodeURIComponent(String(page)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (subpage !== undefined) {
                localVarQueryParameter['subpage'] = subpage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page Subpage
         * @param {string | null} page 
         * @param {string | null} subpage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectPageSubpage: async (page: string | null, subpage: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('marketingRedirectPageSubpage', 'page', page)
            // verify required parameter 'subpage' is not null or undefined
            assertParamExists('marketingRedirectPageSubpage', 'subpage', subpage)
            const localVarPath = `/marketing/redirect/{page}/{subpage}`
                .replace(`{${"page"}}`, encodeURIComponent(String(page)))
                .replace(`{${"subpage"}}`, encodeURIComponent(String(subpage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle the Customer.io onboarding-campaign webhook.  Returns first-week usage statistics for the user identified by the request email.
         * @summary Onboarding Webhook
         * @param {OnboardingWebhookRequest} onboardingWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingWebhook: async (onboardingWebhookRequest: OnboardingWebhookRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'onboardingWebhookRequest' is not null or undefined
            assertParamExists('onboardingWebhook', 'onboardingWebhookRequest', onboardingWebhookRequest)
            const localVarPath = `/marketing/onboarding-webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(onboardingWebhookRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz Results Email
         * @param {MicQuizEmailRequest} micQuizEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMicQuizResultsEmail: async (micQuizEmailRequest: MicQuizEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'micQuizEmailRequest' is not null or undefined
            assertParamExists('sendMicQuizResultsEmail', 'micQuizEmailRequest', micQuizEmailRequest)
            const localVarPath = `/marketing/mic-quiz/email-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(micQuizEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the V2 microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz V2 Results Email
         * @param {MicQuizV2EmailRequest} micQuizV2EmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMicQuizV2ResultsEmail: async (micQuizV2EmailRequest: MicQuizV2EmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'micQuizV2EmailRequest' is not null or undefined
            assertParamExists('sendMicQuizV2ResultsEmail', 'micQuizV2EmailRequest', micQuizV2EmailRequest)
            const localVarPath = `/marketing/mic-quiz/email-results-v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(micQuizV2EmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketingApi - functional programming interface
 * @export
 */
export const MarketingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketingApiAxiosParamCreator(configuration)
    return {
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Base
         * @param {string | null} [page] 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingRedirectBase(page?: string | null, subpage?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingRedirectBase(page, subpage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.marketingRedirectBase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page
         * @param {string | null} page 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingRedirectPage(page: string | null, subpage?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingRedirectPage(page, subpage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.marketingRedirectPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page Subpage
         * @param {string | null} page 
         * @param {string | null} subpage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketingRedirectPageSubpage(page: string | null, subpage: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketingRedirectPageSubpage(page, subpage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.marketingRedirectPageSubpage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle the Customer.io onboarding-campaign webhook.  Returns first-week usage statistics for the user identified by the request email.
         * @summary Onboarding Webhook
         * @param {OnboardingWebhookRequest} onboardingWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onboardingWebhook(onboardingWebhookRequest: OnboardingWebhookRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onboardingWebhook(onboardingWebhookRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.onboardingWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send the microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz Results Email
         * @param {MicQuizEmailRequest} micQuizEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMicQuizResultsEmail(micQuizEmailRequest: MicQuizEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMicQuizResultsEmail(micQuizEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.sendMicQuizResultsEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send the V2 microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz V2 Results Email
         * @param {MicQuizV2EmailRequest} micQuizV2EmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMicQuizV2ResultsEmail(micQuizV2EmailRequest: MicQuizV2EmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMicQuizV2ResultsEmail(micQuizV2EmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketingApi.sendMicQuizV2ResultsEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketingApi - factory interface
 * @export
 */
export const MarketingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketingApiFp(configuration)
    return {
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Base
         * @param {string | null} [page] 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectBase(page?: string | null, subpage?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.marketingRedirectBase(page, subpage, options).then((request) => request(axios, basePath));
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page
         * @param {string | null} page 
         * @param {string | null} [subpage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectPage(page: string | null, subpage?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.marketingRedirectPage(page, subpage, options).then((request) => request(axios, basePath));
        },
        /**
         * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
         * @summary Marketing Redirect Page Subpage
         * @param {string | null} page 
         * @param {string | null} subpage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketingRedirectPageSubpage(page: string | null, subpage: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.marketingRedirectPageSubpage(page, subpage, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle the Customer.io onboarding-campaign webhook.  Returns first-week usage statistics for the user identified by the request email.
         * @summary Onboarding Webhook
         * @param {OnboardingWebhookRequest} onboardingWebhookRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingWebhook(onboardingWebhookRequest: OnboardingWebhookRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.onboardingWebhook(onboardingWebhookRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz Results Email
         * @param {MicQuizEmailRequest} micQuizEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMicQuizResultsEmail(micQuizEmailRequest: MicQuizEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendMicQuizResultsEmail(micQuizEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the V2 microphone quiz results email to the authenticated user.
         * @summary Send Mic Quiz V2 Results Email
         * @param {MicQuizV2EmailRequest} micQuizV2EmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMicQuizV2ResultsEmail(micQuizV2EmailRequest: MicQuizV2EmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendMicQuizV2ResultsEmail(micQuizV2EmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketingApi - object-oriented interface
 * @export
 * @class MarketingApi
 * @extends {BaseAPI}
 */
export class MarketingApi extends BaseAPI {
    /**
     * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
     * @summary Marketing Redirect Base
     * @param {string | null} [page] 
     * @param {string | null} [subpage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public marketingRedirectBase(page?: string | null, subpage?: string | null, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).marketingRedirectBase(page, subpage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
     * @summary Marketing Redirect Page
     * @param {string | null} page 
     * @param {string | null} [subpage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public marketingRedirectPage(page: string | null, subpage?: string | null, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).marketingRedirectPage(page, subpage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redirect to a page that prompts the user to open the app or download it.  ``page`` and ``subpage`` are optional path parameters. All query parameters are preserved and passed through to the deeplink.
     * @summary Marketing Redirect Page Subpage
     * @param {string | null} page 
     * @param {string | null} subpage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public marketingRedirectPageSubpage(page: string | null, subpage: string | null, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).marketingRedirectPageSubpage(page, subpage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle the Customer.io onboarding-campaign webhook.  Returns first-week usage statistics for the user identified by the request email.
     * @summary Onboarding Webhook
     * @param {OnboardingWebhookRequest} onboardingWebhookRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public onboardingWebhook(onboardingWebhookRequest: OnboardingWebhookRequest, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).onboardingWebhook(onboardingWebhookRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the microphone quiz results email to the authenticated user.
     * @summary Send Mic Quiz Results Email
     * @param {MicQuizEmailRequest} micQuizEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public sendMicQuizResultsEmail(micQuizEmailRequest: MicQuizEmailRequest, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).sendMicQuizResultsEmail(micQuizEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the V2 microphone quiz results email to the authenticated user.
     * @summary Send Mic Quiz V2 Results Email
     * @param {MicQuizV2EmailRequest} micQuizV2EmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketingApi
     */
    public sendMicQuizV2ResultsEmail(micQuizV2EmailRequest: MicQuizV2EmailRequest, options?: RawAxiosRequestConfig) {
        return MarketingApiFp(this.configuration).sendMicQuizV2ResultsEmail(micQuizV2EmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingImportApi - axios parameter creator
 * @export
 */
export const MeetingImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFirefliesImportRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('cancelFirefliesImportRun', 'runId', runId)
            const localVarPath = `/api/v1/meeting-import/fireflies/runs/{run_id}/cancel`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelZoomImportRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('cancelZoomImportRun', 'runId', runId)
            const localVarPath = `/api/v1/meeting-import/zoom/runs/{run_id}/cancel`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a selection of Fireflies meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs. A key already used for a Zoom run is a 409 naming that run.  Args:     body:         The selected transcript ids and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPServiceUnavailable: Fireflies import is switched off, or the run could not be started.
         * @summary Confirm Fireflies Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFirefliesImportRun: async (meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingImportRunCreateRequest' is not null or undefined
            assertParamExists('confirmFirefliesImportRun', 'meetingImportRunCreateRequest', meetingImportRunCreateRequest)
            const localVarPath = `/api/v1/meeting-import/fireflies/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingImportRunCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm a selection of Zoom meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs.  Args:     body:         The selected occurrences and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPServiceUnavailable: Zoom import is switched off, or the run could not be started.
         * @summary Confirm Zoom Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmZoomImportRun: async (meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingImportRunCreateRequest' is not null or undefined
            assertParamExists('confirmZoomImportRun', 'meetingImportRunCreateRequest', meetingImportRunCreateRequest)
            const localVarPath = `/api/v1/meeting-import/zoom/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingImportRunCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a pasted Fireflies API key against Fireflies and store it encrypted. The key is never returned.  Args:     body:         The pasted personal API key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     db:           Database executor.  Returns:     The connection status, ``connected`` on success.  Raises:     HTTPBadRequest: 400 ``fireflies_invalid_key`` when Fireflies refuses the key or it is blank or malformed.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer, or import is off.
         * @summary Connect Fireflies Account
         * @param {FirefliesConnectRequest} firefliesConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFirefliesAccount: async (firefliesConnectRequest: FirefliesConnectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firefliesConnectRequest' is not null or undefined
            assertParamExists('connectFirefliesAccount', 'firefliesConnectRequest', firefliesConnectRequest)
            const localVarPath = `/api/v1/meeting-import/fireflies/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(firefliesConnectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start a Zoom connection for meeting import and return Zoom\'s authorization URL.
         * @summary Connect Zoom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectZoom: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/zoom/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the stored Fireflies key; succeeds when nothing is connected, and the key stays valid at Fireflies.
         * @summary Disconnect Fireflies Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectFirefliesAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/fireflies/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disconnect the user\'s Zoom account; succeeds when nothing is connected.
         * @summary Disconnect Zoom Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectZoomAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/zoom/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List one page of the caller\'s Fireflies meetings and say which can be imported.  Args:     skip:         How many of the newest meetings to pass over; use the previous page\'s ``next_skip``.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The page\'s meetings, newest first, whether more follow, and the ``skip`` that fetches them.  Raises:     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPForbidden: 403 ``fireflies_reconnect_required`` when Fireflies refuses the stored key.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer or refused the request.
         * @summary Get Fireflies Catalog
         * @param {number} [skip] How many of the newest meetings to pass over; use the previous page\&#39;s &#x60;&#x60;next_skip&#x60;&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesCatalog: async (skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/fireflies/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report whether the user\'s Fireflies account is connected, needs reconnecting, or is disconnected.
         * @summary Get Fireflies Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/fireflies/connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesImportRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getFirefliesImportRun', 'runId', runId)
            const localVarPath = `/api/v1/meeting-import/fireflies/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the caller\'s Zoom meetings for one 30-day window and say which can be imported.  Args:     before:       Last day of the window, inclusive, UTC; defaults to today.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The window\'s dates and its meetings, newest first.  Raises:     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPForbidden: 403 ``zoom_reconnect_required`` when Zoom refuses the connection.     HTTPServiceUnavailable: 503 ``zoom_unavailable`` when Zoom did not answer.
         * @summary Get Zoom Catalog
         * @param {string | null} [before] Last day of the window, inclusive, UTC. Defaults to today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomCatalog: async (before?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/zoom/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (before !== undefined) {
                localVarQueryParameter['before'] = (before as any instanceof Date) ?
                    (before as any).toISOString().substring(0,10) :
                    before;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report whether the user\'s Zoom account is connected, needs reconnecting, or is disconnected.
         * @summary Get Zoom Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meeting-import/zoom/connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomImportRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getZoomImportRun', 'runId', runId)
            const localVarPath = `/api/v1/meeting-import/zoom/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingImportApi - functional programming interface
 * @export
 */
export const MeetingImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelFirefliesImportRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.cancelFirefliesImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelZoomImportRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelZoomImportRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.cancelZoomImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm a selection of Fireflies meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs. A key already used for a Zoom run is a 409 naming that run.  Args:     body:         The selected transcript ids and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPServiceUnavailable: Fireflies import is switched off, or the run could not be started.
         * @summary Confirm Fireflies Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmFirefliesImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmFirefliesImportRun(meetingImportRunCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.confirmFirefliesImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Confirm a selection of Zoom meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs.  Args:     body:         The selected occurrences and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPServiceUnavailable: Zoom import is switched off, or the run could not be started.
         * @summary Confirm Zoom Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmZoomImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmZoomImportRun(meetingImportRunCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.confirmZoomImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a pasted Fireflies API key against Fireflies and store it encrypted. The key is never returned.  Args:     body:         The pasted personal API key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     db:           Database executor.  Returns:     The connection status, ``connected`` on success.  Raises:     HTTPBadRequest: 400 ``fireflies_invalid_key`` when Fireflies refuses the key or it is blank or malformed.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer, or import is off.
         * @summary Connect Fireflies Account
         * @param {FirefliesConnectRequest} firefliesConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectFirefliesAccount(firefliesConnectRequest: FirefliesConnectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirefliesConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectFirefliesAccount(firefliesConnectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.connectFirefliesAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start a Zoom connection for meeting import and return Zoom\'s authorization URL.
         * @summary Connect Zoom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async connectZoom(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.connectZoom(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.connectZoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the stored Fireflies key; succeeds when nothing is connected, and the key stays valid at Fireflies.
         * @summary Disconnect Fireflies Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectFirefliesAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectFirefliesAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.disconnectFirefliesAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disconnect the user\'s Zoom account; succeeds when nothing is connected.
         * @summary Disconnect Zoom Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disconnectZoomAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisconnectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disconnectZoomAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.disconnectZoomAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List one page of the caller\'s Fireflies meetings and say which can be imported.  Args:     skip:         How many of the newest meetings to pass over; use the previous page\'s ``next_skip``.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The page\'s meetings, newest first, whether more follow, and the ``skip`` that fetches them.  Raises:     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPForbidden: 403 ``fireflies_reconnect_required`` when Fireflies refuses the stored key.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer or refused the request.
         * @summary Get Fireflies Catalog
         * @param {number} [skip] How many of the newest meetings to pass over; use the previous page\&#39;s &#x60;&#x60;next_skip&#x60;&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirefliesCatalog(skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirefliesCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirefliesCatalog(skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getFirefliesCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report whether the user\'s Fireflies account is connected, needs reconnecting, or is disconnected.
         * @summary Get Fireflies Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirefliesConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirefliesConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirefliesConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getFirefliesConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirefliesImportRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getFirefliesImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the caller\'s Zoom meetings for one 30-day window and say which can be imported.  Args:     before:       Last day of the window, inclusive, UTC; defaults to today.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The window\'s dates and its meetings, newest first.  Raises:     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPForbidden: 403 ``zoom_reconnect_required`` when Zoom refuses the connection.     HTTPServiceUnavailable: 503 ``zoom_unavailable`` when Zoom did not answer.
         * @summary Get Zoom Catalog
         * @param {string | null} [before] Last day of the window, inclusive, UTC. Defaults to today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomCatalog(before?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoomCatalogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomCatalog(before, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getZoomCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report whether the user\'s Zoom account is connected, needs reconnecting, or is disconnected.
         * @summary Get Zoom Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZoomConnectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getZoomConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZoomImportRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingImportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZoomImportRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingImportApi.getZoomImportRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingImportApi - factory interface
 * @export
 */
export const MeetingImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingImportApiFp(configuration)
    return {
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.cancelFirefliesImportRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Cancel Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelZoomImportRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.cancelZoomImportRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a selection of Fireflies meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs. A key already used for a Zoom run is a 409 naming that run.  Args:     body:         The selected transcript ids and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPServiceUnavailable: Fireflies import is switched off, or the run could not be started.
         * @summary Confirm Fireflies Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmFirefliesImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.confirmFirefliesImportRun(meetingImportRunCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Confirm a selection of Zoom meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs.  Args:     body:         The selected occurrences and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPServiceUnavailable: Zoom import is switched off, or the run could not be started.
         * @summary Confirm Zoom Import Run
         * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmZoomImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.confirmZoomImportRun(meetingImportRunCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a pasted Fireflies API key against Fireflies and store it encrypted. The key is never returned.  Args:     body:         The pasted personal API key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     db:           Database executor.  Returns:     The connection status, ``connected`` on success.  Raises:     HTTPBadRequest: 400 ``fireflies_invalid_key`` when Fireflies refuses the key or it is blank or malformed.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer, or import is off.
         * @summary Connect Fireflies Account
         * @param {FirefliesConnectRequest} firefliesConnectRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectFirefliesAccount(firefliesConnectRequest: FirefliesConnectRequest, options?: RawAxiosRequestConfig): AxiosPromise<FirefliesConnectionResponse> {
            return localVarFp.connectFirefliesAccount(firefliesConnectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start a Zoom connection for meeting import and return Zoom\'s authorization URL.
         * @summary Connect Zoom
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectZoom(options?: RawAxiosRequestConfig): AxiosPromise<InitiateConnectionResponse> {
            return localVarFp.connectZoom(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the stored Fireflies key; succeeds when nothing is connected, and the key stays valid at Fireflies.
         * @summary Disconnect Fireflies Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectFirefliesAccount(options?: RawAxiosRequestConfig): AxiosPromise<DisconnectResponse> {
            return localVarFp.disconnectFirefliesAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Disconnect the user\'s Zoom account; succeeds when nothing is connected.
         * @summary Disconnect Zoom Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disconnectZoomAccount(options?: RawAxiosRequestConfig): AxiosPromise<DisconnectResponse> {
            return localVarFp.disconnectZoomAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * List one page of the caller\'s Fireflies meetings and say which can be imported.  Args:     skip:         How many of the newest meetings to pass over; use the previous page\'s ``next_skip``.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The page\'s meetings, newest first, whether more follow, and the ``skip`` that fetches them.  Raises:     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPForbidden: 403 ``fireflies_reconnect_required`` when Fireflies refuses the stored key.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer or refused the request.
         * @summary Get Fireflies Catalog
         * @param {number} [skip] How many of the newest meetings to pass over; use the previous page\&#39;s &#x60;&#x60;next_skip&#x60;&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesCatalog(skip?: number, options?: RawAxiosRequestConfig): AxiosPromise<FirefliesCatalogResponse> {
            return localVarFp.getFirefliesCatalog(skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Report whether the user\'s Fireflies account is connected, needs reconnecting, or is disconnected.
         * @summary Get Fireflies Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesConnection(options?: RawAxiosRequestConfig): AxiosPromise<FirefliesConnectionResponse> {
            return localVarFp.getFirefliesConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Fireflies Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.getFirefliesImportRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the caller\'s Zoom meetings for one 30-day window and say which can be imported.  Args:     before:       Last day of the window, inclusive, UTC; defaults to today.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The window\'s dates and its meetings, newest first.  Raises:     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPForbidden: 403 ``zoom_reconnect_required`` when Zoom refuses the connection.     HTTPServiceUnavailable: 503 ``zoom_unavailable`` when Zoom did not answer.
         * @summary Get Zoom Catalog
         * @param {string | null} [before] Last day of the window, inclusive, UTC. Defaults to today.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomCatalog(before?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ZoomCatalogResponse> {
            return localVarFp.getZoomCatalog(before, options).then((request) => request(axios, basePath));
        },
        /**
         * Report whether the user\'s Zoom account is connected, needs reconnecting, or is disconnected.
         * @summary Get Zoom Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomConnection(options?: RawAxiosRequestConfig): AxiosPromise<ZoomConnectionResponse> {
            return localVarFp.getZoomConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
         * @summary Get Zoom Import Run
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZoomImportRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingImportRunResponse> {
            return localVarFp.getZoomImportRun(runId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingImportApi - object-oriented interface
 * @export
 * @class MeetingImportApi
 * @extends {BaseAPI}
 */
export class MeetingImportApi extends BaseAPI {
    /**
     * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
     * @summary Cancel Fireflies Import Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public cancelFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).cancelFirefliesImportRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel one of the caller\'s import runs. Ungated; meetings already copied stay.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status after the cancel.  Raises:     HTTPNotFound: The caller has no run with this id.
     * @summary Cancel Zoom Import Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public cancelZoomImportRun(runId: string, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).cancelZoomImportRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a selection of Fireflies meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs. A key already used for a Zoom run is a 409 naming that run.  Args:     body:         The selected transcript ids and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPServiceUnavailable: Fireflies import is switched off, or the run could not be started.
     * @summary Confirm Fireflies Import Run
     * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public confirmFirefliesImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).confirmFirefliesImportRun(meetingImportRunCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Confirm a selection of Zoom meetings and start copying them.  Answers once the copy has started. Resending the same ``idempotency_key`` returns the original run, even when the resent selection differs.  Args:     body:         The selected occurrences and the client\'s idempotency key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The new run\'s progress.  Raises:     HTTPException: 409 with ``{\"code\": \"import_run_active\", \"run_id\": ...}`` while another run is active.     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPServiceUnavailable: Zoom import is switched off, or the run could not be started.
     * @summary Confirm Zoom Import Run
     * @param {MeetingImportRunCreateRequest} meetingImportRunCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public confirmZoomImportRun(meetingImportRunCreateRequest: MeetingImportRunCreateRequest, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).confirmZoomImportRun(meetingImportRunCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a pasted Fireflies API key against Fireflies and store it encrypted. The key is never returned.  Args:     body:         The pasted personal API key.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     db:           Database executor.  Returns:     The connection status, ``connected`` on success.  Raises:     HTTPBadRequest: 400 ``fireflies_invalid_key`` when Fireflies refuses the key or it is blank or malformed.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer, or import is off.
     * @summary Connect Fireflies Account
     * @param {FirefliesConnectRequest} firefliesConnectRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public connectFirefliesAccount(firefliesConnectRequest: FirefliesConnectRequest, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).connectFirefliesAccount(firefliesConnectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start a Zoom connection for meeting import and return Zoom\'s authorization URL.
     * @summary Connect Zoom
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public connectZoom(options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).connectZoom(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the stored Fireflies key; succeeds when nothing is connected, and the key stays valid at Fireflies.
     * @summary Disconnect Fireflies Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public disconnectFirefliesAccount(options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).disconnectFirefliesAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disconnect the user\'s Zoom account; succeeds when nothing is connected.
     * @summary Disconnect Zoom Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public disconnectZoomAccount(options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).disconnectZoomAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List one page of the caller\'s Fireflies meetings and say which can be imported.  Args:     skip:         How many of the newest meetings to pass over; use the previous page\'s ``next_skip``.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The page\'s meetings, newest first, whether more follow, and the ``skip`` that fetches them.  Raises:     HTTPConflict: 409 with ``{\"code\": \"fireflies_not_connected\"}``.     HTTPForbidden: 403 ``fireflies_reconnect_required`` when Fireflies refuses the stored key.     HTTPServiceUnavailable: 503 ``fireflies_unavailable`` when Fireflies did not answer or refused the request.
     * @summary Get Fireflies Catalog
     * @param {number} [skip] How many of the newest meetings to pass over; use the previous page\&#39;s &#x60;&#x60;next_skip&#x60;&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getFirefliesCatalog(skip?: number, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getFirefliesCatalog(skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report whether the user\'s Fireflies account is connected, needs reconnecting, or is disconnected.
     * @summary Get Fireflies Connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getFirefliesConnection(options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getFirefliesConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
     * @summary Get Fireflies Import Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getFirefliesImportRun(runId: string, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getFirefliesImportRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the caller\'s Zoom meetings for one 30-day window and say which can be imported.  Args:     before:       Last day of the window, inclusive, UTC; defaults to today.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Catalog service.  Returns:     The window\'s dates and its meetings, newest first.  Raises:     HTTPConflict: 409 with ``{\"code\": \"zoom_not_connected\"}``.     HTTPForbidden: 403 ``zoom_reconnect_required`` when Zoom refuses the connection.     HTTPServiceUnavailable: 503 ``zoom_unavailable`` when Zoom did not answer.
     * @summary Get Zoom Catalog
     * @param {string | null} [before] Last day of the window, inclusive, UTC. Defaults to today.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getZoomCatalog(before?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getZoomCatalog(before, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report whether the user\'s Zoom account is connected, needs reconnecting, or is disconnected.
     * @summary Get Zoom Connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getZoomConnection(options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getZoomConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Progress of one of the caller\'s import runs. Ungated, so a blocked user can still follow a run.  Args:     run_id:       The run, as returned by confirm.     ip_limiter:   Per-IP rate limit, resolved before authentication.     user:         The authenticated caller.     user_limiter: Per-user rate limit, resolved after authentication.     service:      Import run service.  Returns:     The run\'s status and per-outcome counts.  Raises:     HTTPNotFound: The caller has no run with this id.
     * @summary Get Zoom Import Run
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingImportApi
     */
    public getZoomImportRun(runId: string, options?: RawAxiosRequestConfig) {
        return MeetingImportApiFp(this.configuration).getZoomImportRun(runId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingObservabilityApi - axios parameter creator
 * @export
 */
export const MeetingObservabilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return collected speaker-label metrics, filter values, and recency.
         * @summary Get Meeting Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityOsEnum} [os] 
         * @param {GetMeetingObservabilityClientEnum} [client] 
         * @param {GetMeetingObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservability: async (startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityPlatformEnum, os?: GetMeetingObservabilityOsEnum, client?: GetMeetingObservabilityClientEnum, calendarEvent?: GetMeetingObservabilityCalendarEventEnum, participantSource?: GetMeetingObservabilityParticipantSourceEnum, participantBucket?: GetMeetingObservabilityParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/observability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Group collected meetings by one selected dimension.
         * @summary Get Meeting Observability Cohorts
         * @param {GetMeetingObservabilityCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityCohortsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityCohortsOsEnum} [os] 
         * @param {GetMeetingObservabilityCohortsClientEnum} [client] 
         * @param {GetMeetingObservabilityCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityCohortsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityCohorts: async (groupBy: GetMeetingObservabilityCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityCohortsPlatformEnum, os?: GetMeetingObservabilityCohortsOsEnum, client?: GetMeetingObservabilityCohortsClientEnum, calendarEvent?: GetMeetingObservabilityCohortsCalendarEventEnum, participantSource?: GetMeetingObservabilityCohortsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityCohortsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityCohortsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityCohortsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityCohortsNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getMeetingObservabilityCohorts', 'groupBy', groupBy)
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/observability/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Page collected meetings and authorized attribution-viewer links.
         * @summary Get Meeting Observability Meetings
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityMeetingsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityMeetingsOsEnum} [os] 
         * @param {GetMeetingObservabilityMeetingsClientEnum} [client] 
         * @param {GetMeetingObservabilityMeetingsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityMeetingsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityMeetingsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityMeetingsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityMeetingsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityMeetingsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityMeetingsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {GetMeetingObservabilityMeetingsLabelSourceEnum} [labelSource] 
         * @param {GetMeetingObservabilityMeetingsLabelRuleEnum} [labelRule] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityMeetings: async (startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityMeetingsPlatformEnum, os?: GetMeetingObservabilityMeetingsOsEnum, client?: GetMeetingObservabilityMeetingsClientEnum, calendarEvent?: GetMeetingObservabilityMeetingsCalendarEventEnum, participantSource?: GetMeetingObservabilityMeetingsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityMeetingsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityMeetingsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityMeetingsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityMeetingsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityMeetingsNegateEnum>, limit?: number, cursor?: string | null, labelSource?: GetMeetingObservabilityMeetingsLabelSourceEnum, labelRule?: GetMeetingObservabilityMeetingsLabelRuleEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/observability/meetings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (labelSource !== undefined) {
                localVarQueryParameter['label_source'] = labelSource;
            }

            if (labelRule !== undefined) {
                localVarQueryParameter['label_rule'] = labelRule;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return daily measurements for the largest combined physical meeting cohorts.
         * @summary Get Meeting Observability Trend
         * @param {Array<GetMeetingObservabilityTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityTrendPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityTrendOsEnum} [os] 
         * @param {GetMeetingObservabilityTrendClientEnum} [client] 
         * @param {GetMeetingObservabilityTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityTrendParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityTrendAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityTrend: async (groupBy: Array<GetMeetingObservabilityTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityTrendPlatformEnum, os?: GetMeetingObservabilityTrendOsEnum, client?: GetMeetingObservabilityTrendClientEnum, calendarEvent?: GetMeetingObservabilityTrendCalendarEventEnum, participantSource?: GetMeetingObservabilityTrendParticipantSourceEnum, participantBucket?: GetMeetingObservabilityTrendParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityTrendUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityTrendAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityTrendNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getMeetingObservabilityTrend', 'groupBy', groupBy)
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/observability/trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }

            if (groupBy) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Group publication-time summary chips by a supported main-database dimension.
         * @summary Get Summary Chip Cohorts
         * @param {GetSummaryChipCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipCohortsPlatformEnum} [platform] 
         * @param {GetSummaryChipCohortsOsEnum} [os] 
         * @param {GetSummaryChipCohortsClientEnum} [client] 
         * @param {GetSummaryChipCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipCohortsAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipCohorts: async (groupBy: GetSummaryChipCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipCohortsPlatformEnum, os?: GetSummaryChipCohortsOsEnum, client?: GetSummaryChipCohortsClientEnum, calendarEvent?: GetSummaryChipCohortsCalendarEventEnum, participantSource?: GetSummaryChipCohortsParticipantSourceEnum, participantBucket?: GetSummaryChipCohortsParticipantBucketEnum, userMeetingBucket?: GetSummaryChipCohortsUserMeetingBucketEnum, axBucket?: GetSummaryChipCohortsAxBucketEnum, recordingLengthBucket?: GetSummaryChipCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipCohortsNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getSummaryChipCohorts', 'groupBy', groupBy)
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/summary-chips/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return publication-time summary-chip coverage for consented individual meetings.
         * @summary Get Summary Chip Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipObservabilityPlatformEnum} [platform] 
         * @param {GetSummaryChipObservabilityOsEnum} [os] 
         * @param {GetSummaryChipObservabilityClientEnum} [client] 
         * @param {GetSummaryChipObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipObservabilityAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipObservability: async (startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipObservabilityPlatformEnum, os?: GetSummaryChipObservabilityOsEnum, client?: GetSummaryChipObservabilityClientEnum, calendarEvent?: GetSummaryChipObservabilityCalendarEventEnum, participantSource?: GetSummaryChipObservabilityParticipantSourceEnum, participantBucket?: GetSummaryChipObservabilityParticipantBucketEnum, userMeetingBucket?: GetSummaryChipObservabilityUserMeetingBucketEnum, axBucket?: GetSummaryChipObservabilityAxBucketEnum, recordingLengthBucket?: GetSummaryChipObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipObservabilityNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/summary-chips`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return daily summary-chip measurements for the largest supported publication cohorts.
         * @summary Get Summary Chip Trend
         * @param {Array<GetSummaryChipTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipTrendPlatformEnum} [platform] 
         * @param {GetSummaryChipTrendOsEnum} [os] 
         * @param {GetSummaryChipTrendClientEnum} [client] 
         * @param {GetSummaryChipTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipTrendParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipTrendAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipTrend: async (groupBy: Array<GetSummaryChipTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipTrendPlatformEnum, os?: GetSummaryChipTrendOsEnum, client?: GetSummaryChipTrendClientEnum, calendarEvent?: GetSummaryChipTrendCalendarEventEnum, participantSource?: GetSummaryChipTrendParticipantSourceEnum, participantBucket?: GetSummaryChipTrendParticipantBucketEnum, userMeetingBucket?: GetSummaryChipTrendUserMeetingBucketEnum, axBucket?: GetSummaryChipTrendAxBucketEnum, recordingLengthBucket?: GetSummaryChipTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipTrendNegateEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBy' is not null or undefined
            assertParamExists('getSummaryChipTrend', 'groupBy', groupBy)
            const localVarPath = `/api/v1/internal/meeting-speaker-labels/summary-chips/trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (os !== undefined) {
                localVarQueryParameter['os'] = os;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (calendarEvent !== undefined) {
                localVarQueryParameter['calendar_event'] = calendarEvent;
            }

            if (participantSource !== undefined) {
                localVarQueryParameter['participant_source'] = participantSource;
            }

            if (participantBucket !== undefined) {
                localVarQueryParameter['participant_bucket'] = participantBucket;
            }

            if (userMeetingBucket !== undefined) {
                localVarQueryParameter['user_meeting_bucket'] = userMeetingBucket;
            }

            if (axBucket !== undefined) {
                localVarQueryParameter['ax_bucket'] = axBucket;
            }

            if (recordingLengthBucket !== undefined) {
                localVarQueryParameter['recording_length_bucket'] = recordingLengthBucket;
            }

            if (backendVersion !== undefined) {
                localVarQueryParameter['backend_version'] = backendVersion;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (negate) {
                localVarQueryParameter['negate'] = negate;
            }

            if (groupBy) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingObservabilityApi - functional programming interface
 * @export
 */
export const MeetingObservabilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingObservabilityApiAxiosParamCreator(configuration)
    return {
        /**
         * Return collected speaker-label metrics, filter values, and recency.
         * @summary Get Meeting Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityOsEnum} [os] 
         * @param {GetMeetingObservabilityClientEnum} [client] 
         * @param {GetMeetingObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingObservability(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityPlatformEnum, os?: GetMeetingObservabilityOsEnum, client?: GetMeetingObservabilityClientEnum, calendarEvent?: GetMeetingObservabilityCalendarEventEnum, participantSource?: GetMeetingObservabilityParticipantSourceEnum, participantBucket?: GetMeetingObservabilityParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getMeetingObservability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Group collected meetings by one selected dimension.
         * @summary Get Meeting Observability Cohorts
         * @param {GetMeetingObservabilityCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityCohortsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityCohortsOsEnum} [os] 
         * @param {GetMeetingObservabilityCohortsClientEnum} [client] 
         * @param {GetMeetingObservabilityCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityCohortsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingObservabilityCohorts(groupBy: GetMeetingObservabilityCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityCohortsPlatformEnum, os?: GetMeetingObservabilityCohortsOsEnum, client?: GetMeetingObservabilityCohortsClientEnum, calendarEvent?: GetMeetingObservabilityCohortsCalendarEventEnum, participantSource?: GetMeetingObservabilityCohortsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityCohortsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityCohortsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityCohortsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityCohortsNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationCohorts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingObservabilityCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getMeetingObservabilityCohorts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Page collected meetings and authorized attribution-viewer links.
         * @summary Get Meeting Observability Meetings
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityMeetingsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityMeetingsOsEnum} [os] 
         * @param {GetMeetingObservabilityMeetingsClientEnum} [client] 
         * @param {GetMeetingObservabilityMeetingsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityMeetingsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityMeetingsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityMeetingsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityMeetingsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityMeetingsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityMeetingsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {GetMeetingObservabilityMeetingsLabelSourceEnum} [labelSource] 
         * @param {GetMeetingObservabilityMeetingsLabelRuleEnum} [labelRule] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingObservabilityMeetings(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityMeetingsPlatformEnum, os?: GetMeetingObservabilityMeetingsOsEnum, client?: GetMeetingObservabilityMeetingsClientEnum, calendarEvent?: GetMeetingObservabilityMeetingsCalendarEventEnum, participantSource?: GetMeetingObservabilityMeetingsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityMeetingsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityMeetingsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityMeetingsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityMeetingsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityMeetingsNegateEnum>, limit?: number, cursor?: string | null, labelSource?: GetMeetingObservabilityMeetingsLabelSourceEnum, labelRule?: GetMeetingObservabilityMeetingsLabelRuleEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingSpeakerLabelMeetings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingObservabilityMeetings(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, limit, cursor, labelSource, labelRule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getMeetingObservabilityMeetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return daily measurements for the largest combined physical meeting cohorts.
         * @summary Get Meeting Observability Trend
         * @param {Array<GetMeetingObservabilityTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityTrendPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityTrendOsEnum} [os] 
         * @param {GetMeetingObservabilityTrendClientEnum} [client] 
         * @param {GetMeetingObservabilityTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityTrendParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityTrendAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingObservabilityTrend(groupBy: Array<GetMeetingObservabilityTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityTrendPlatformEnum, os?: GetMeetingObservabilityTrendOsEnum, client?: GetMeetingObservabilityTrendClientEnum, calendarEvent?: GetMeetingObservabilityTrendCalendarEventEnum, participantSource?: GetMeetingObservabilityTrendParticipantSourceEnum, participantBucket?: GetMeetingObservabilityTrendParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityTrendUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityTrendAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityTrendNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObservationGroupedTrend>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingObservabilityTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getMeetingObservabilityTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Group publication-time summary chips by a supported main-database dimension.
         * @summary Get Summary Chip Cohorts
         * @param {GetSummaryChipCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipCohortsPlatformEnum} [platform] 
         * @param {GetSummaryChipCohortsOsEnum} [os] 
         * @param {GetSummaryChipCohortsClientEnum} [client] 
         * @param {GetSummaryChipCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipCohortsAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryChipCohorts(groupBy: GetSummaryChipCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipCohortsPlatformEnum, os?: GetSummaryChipCohortsOsEnum, client?: GetSummaryChipCohortsClientEnum, calendarEvent?: GetSummaryChipCohortsCalendarEventEnum, participantSource?: GetSummaryChipCohortsParticipantSourceEnum, participantBucket?: GetSummaryChipCohortsParticipantBucketEnum, userMeetingBucket?: GetSummaryChipCohortsUserMeetingBucketEnum, axBucket?: GetSummaryChipCohortsAxBucketEnum, recordingLengthBucket?: GetSummaryChipCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipCohortsNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryChipCohorts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryChipCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getSummaryChipCohorts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return publication-time summary-chip coverage for consented individual meetings.
         * @summary Get Summary Chip Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipObservabilityPlatformEnum} [platform] 
         * @param {GetSummaryChipObservabilityOsEnum} [os] 
         * @param {GetSummaryChipObservabilityClientEnum} [client] 
         * @param {GetSummaryChipObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipObservabilityAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryChipObservability(startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipObservabilityPlatformEnum, os?: GetSummaryChipObservabilityOsEnum, client?: GetSummaryChipObservabilityClientEnum, calendarEvent?: GetSummaryChipObservabilityCalendarEventEnum, participantSource?: GetSummaryChipObservabilityParticipantSourceEnum, participantBucket?: GetSummaryChipObservabilityParticipantBucketEnum, userMeetingBucket?: GetSummaryChipObservabilityUserMeetingBucketEnum, axBucket?: GetSummaryChipObservabilityAxBucketEnum, recordingLengthBucket?: GetSummaryChipObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipObservabilityNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryChipOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryChipObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getSummaryChipObservability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return daily summary-chip measurements for the largest supported publication cohorts.
         * @summary Get Summary Chip Trend
         * @param {Array<GetSummaryChipTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipTrendPlatformEnum} [platform] 
         * @param {GetSummaryChipTrendOsEnum} [os] 
         * @param {GetSummaryChipTrendClientEnum} [client] 
         * @param {GetSummaryChipTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipTrendParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipTrendAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryChipTrend(groupBy: Array<GetSummaryChipTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipTrendPlatformEnum, os?: GetSummaryChipTrendOsEnum, client?: GetSummaryChipTrendClientEnum, calendarEvent?: GetSummaryChipTrendCalendarEventEnum, participantSource?: GetSummaryChipTrendParticipantSourceEnum, participantBucket?: GetSummaryChipTrendParticipantBucketEnum, userMeetingBucket?: GetSummaryChipTrendUserMeetingBucketEnum, axBucket?: GetSummaryChipTrendAxBucketEnum, recordingLengthBucket?: GetSummaryChipTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipTrendNegateEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryChipGroupedTrend>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryChipTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingObservabilityApi.getSummaryChipTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingObservabilityApi - factory interface
 * @export
 */
export const MeetingObservabilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingObservabilityApiFp(configuration)
    return {
        /**
         * Return collected speaker-label metrics, filter values, and recency.
         * @summary Get Meeting Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityOsEnum} [os] 
         * @param {GetMeetingObservabilityClientEnum} [client] 
         * @param {GetMeetingObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservability(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityPlatformEnum, os?: GetMeetingObservabilityOsEnum, client?: GetMeetingObservabilityClientEnum, calendarEvent?: GetMeetingObservabilityCalendarEventEnum, participantSource?: GetMeetingObservabilityParticipantSourceEnum, participantBucket?: GetMeetingObservabilityParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<ObservationOverview> {
            return localVarFp.getMeetingObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
        /**
         * Group collected meetings by one selected dimension.
         * @summary Get Meeting Observability Cohorts
         * @param {GetMeetingObservabilityCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityCohortsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityCohortsOsEnum} [os] 
         * @param {GetMeetingObservabilityCohortsClientEnum} [client] 
         * @param {GetMeetingObservabilityCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityCohortsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityCohorts(groupBy: GetMeetingObservabilityCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityCohortsPlatformEnum, os?: GetMeetingObservabilityCohortsOsEnum, client?: GetMeetingObservabilityCohortsClientEnum, calendarEvent?: GetMeetingObservabilityCohortsCalendarEventEnum, participantSource?: GetMeetingObservabilityCohortsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityCohortsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityCohortsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityCohortsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityCohortsNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<ObservationCohorts> {
            return localVarFp.getMeetingObservabilityCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
        /**
         * Page collected meetings and authorized attribution-viewer links.
         * @summary Get Meeting Observability Meetings
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityMeetingsPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityMeetingsOsEnum} [os] 
         * @param {GetMeetingObservabilityMeetingsClientEnum} [client] 
         * @param {GetMeetingObservabilityMeetingsCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityMeetingsParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityMeetingsParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityMeetingsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityMeetingsAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityMeetingsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityMeetingsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {GetMeetingObservabilityMeetingsLabelSourceEnum} [labelSource] 
         * @param {GetMeetingObservabilityMeetingsLabelRuleEnum} [labelRule] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityMeetings(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityMeetingsPlatformEnum, os?: GetMeetingObservabilityMeetingsOsEnum, client?: GetMeetingObservabilityMeetingsClientEnum, calendarEvent?: GetMeetingObservabilityMeetingsCalendarEventEnum, participantSource?: GetMeetingObservabilityMeetingsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityMeetingsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityMeetingsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityMeetingsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityMeetingsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityMeetingsNegateEnum>, limit?: number, cursor?: string | null, labelSource?: GetMeetingObservabilityMeetingsLabelSourceEnum, labelRule?: GetMeetingObservabilityMeetingsLabelRuleEnum, options?: RawAxiosRequestConfig): AxiosPromise<MeetingSpeakerLabelMeetings> {
            return localVarFp.getMeetingObservabilityMeetings(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, limit, cursor, labelSource, labelRule, options).then((request) => request(axios, basePath));
        },
        /**
         * Return daily measurements for the largest combined physical meeting cohorts.
         * @summary Get Meeting Observability Trend
         * @param {Array<GetMeetingObservabilityTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingObservabilityTrendPlatformEnum} [platform] 
         * @param {GetMeetingObservabilityTrendOsEnum} [os] 
         * @param {GetMeetingObservabilityTrendClientEnum} [client] 
         * @param {GetMeetingObservabilityTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetMeetingObservabilityTrendParticipantSourceEnum} [participantSource] 
         * @param {GetMeetingObservabilityTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetMeetingObservabilityTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetMeetingObservabilityTrendAxBucketEnum} [axBucket] 
         * @param {GetMeetingObservabilityTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetMeetingObservabilityTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingObservabilityTrend(groupBy: Array<GetMeetingObservabilityTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityTrendPlatformEnum, os?: GetMeetingObservabilityTrendOsEnum, client?: GetMeetingObservabilityTrendClientEnum, calendarEvent?: GetMeetingObservabilityTrendCalendarEventEnum, participantSource?: GetMeetingObservabilityTrendParticipantSourceEnum, participantBucket?: GetMeetingObservabilityTrendParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityTrendUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityTrendAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityTrendNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<ObservationGroupedTrend> {
            return localVarFp.getMeetingObservabilityTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
        /**
         * Group publication-time summary chips by a supported main-database dimension.
         * @summary Get Summary Chip Cohorts
         * @param {GetSummaryChipCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipCohortsPlatformEnum} [platform] 
         * @param {GetSummaryChipCohortsOsEnum} [os] 
         * @param {GetSummaryChipCohortsClientEnum} [client] 
         * @param {GetSummaryChipCohortsCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipCohortsParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipCohortsParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipCohortsUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipCohortsAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipCohorts(groupBy: GetSummaryChipCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipCohortsPlatformEnum, os?: GetSummaryChipCohortsOsEnum, client?: GetSummaryChipCohortsClientEnum, calendarEvent?: GetSummaryChipCohortsCalendarEventEnum, participantSource?: GetSummaryChipCohortsParticipantSourceEnum, participantBucket?: GetSummaryChipCohortsParticipantBucketEnum, userMeetingBucket?: GetSummaryChipCohortsUserMeetingBucketEnum, axBucket?: GetSummaryChipCohortsAxBucketEnum, recordingLengthBucket?: GetSummaryChipCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipCohortsNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<SummaryChipCohorts> {
            return localVarFp.getSummaryChipCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
        /**
         * Return publication-time summary-chip coverage for consented individual meetings.
         * @summary Get Summary Chip Observability
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipObservabilityPlatformEnum} [platform] 
         * @param {GetSummaryChipObservabilityOsEnum} [os] 
         * @param {GetSummaryChipObservabilityClientEnum} [client] 
         * @param {GetSummaryChipObservabilityCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipObservabilityParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipObservabilityParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipObservabilityAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipObservability(startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipObservabilityPlatformEnum, os?: GetSummaryChipObservabilityOsEnum, client?: GetSummaryChipObservabilityClientEnum, calendarEvent?: GetSummaryChipObservabilityCalendarEventEnum, participantSource?: GetSummaryChipObservabilityParticipantSourceEnum, participantBucket?: GetSummaryChipObservabilityParticipantBucketEnum, userMeetingBucket?: GetSummaryChipObservabilityUserMeetingBucketEnum, axBucket?: GetSummaryChipObservabilityAxBucketEnum, recordingLengthBucket?: GetSummaryChipObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipObservabilityNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<SummaryChipOverview> {
            return localVarFp.getSummaryChipObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
        /**
         * Return daily summary-chip measurements for the largest supported publication cohorts.
         * @summary Get Summary Chip Trend
         * @param {Array<GetSummaryChipTrendGroupByEnum>} groupBy 
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetSummaryChipTrendPlatformEnum} [platform] 
         * @param {GetSummaryChipTrendOsEnum} [os] 
         * @param {GetSummaryChipTrendClientEnum} [client] 
         * @param {GetSummaryChipTrendCalendarEventEnum} [calendarEvent] 
         * @param {GetSummaryChipTrendParticipantSourceEnum} [participantSource] 
         * @param {GetSummaryChipTrendParticipantBucketEnum} [participantBucket] 
         * @param {GetSummaryChipTrendUserMeetingBucketEnum} [userMeetingBucket] 
         * @param {GetSummaryChipTrendAxBucketEnum} [axBucket] 
         * @param {GetSummaryChipTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
         * @param {string | null} [backendVersion] 
         * @param {string | null} [appVersion] 
         * @param {Array<GetSummaryChipTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryChipTrend(groupBy: Array<GetSummaryChipTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipTrendPlatformEnum, os?: GetSummaryChipTrendOsEnum, client?: GetSummaryChipTrendClientEnum, calendarEvent?: GetSummaryChipTrendCalendarEventEnum, participantSource?: GetSummaryChipTrendParticipantSourceEnum, participantBucket?: GetSummaryChipTrendParticipantBucketEnum, userMeetingBucket?: GetSummaryChipTrendUserMeetingBucketEnum, axBucket?: GetSummaryChipTrendAxBucketEnum, recordingLengthBucket?: GetSummaryChipTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipTrendNegateEnum>, options?: RawAxiosRequestConfig): AxiosPromise<SummaryChipGroupedTrend> {
            return localVarFp.getSummaryChipTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingObservabilityApi - object-oriented interface
 * @export
 * @class MeetingObservabilityApi
 * @extends {BaseAPI}
 */
export class MeetingObservabilityApi extends BaseAPI {
    /**
     * Return collected speaker-label metrics, filter values, and recency.
     * @summary Get Meeting Observability
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingObservabilityPlatformEnum} [platform] 
     * @param {GetMeetingObservabilityOsEnum} [os] 
     * @param {GetMeetingObservabilityClientEnum} [client] 
     * @param {GetMeetingObservabilityCalendarEventEnum} [calendarEvent] 
     * @param {GetMeetingObservabilityParticipantSourceEnum} [participantSource] 
     * @param {GetMeetingObservabilityParticipantBucketEnum} [participantBucket] 
     * @param {GetMeetingObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetMeetingObservabilityAxBucketEnum} [axBucket] 
     * @param {GetMeetingObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetMeetingObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getMeetingObservability(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityPlatformEnum, os?: GetMeetingObservabilityOsEnum, client?: GetMeetingObservabilityClientEnum, calendarEvent?: GetMeetingObservabilityCalendarEventEnum, participantSource?: GetMeetingObservabilityParticipantSourceEnum, participantBucket?: GetMeetingObservabilityParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getMeetingObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Group collected meetings by one selected dimension.
     * @summary Get Meeting Observability Cohorts
     * @param {GetMeetingObservabilityCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingObservabilityCohortsPlatformEnum} [platform] 
     * @param {GetMeetingObservabilityCohortsOsEnum} [os] 
     * @param {GetMeetingObservabilityCohortsClientEnum} [client] 
     * @param {GetMeetingObservabilityCohortsCalendarEventEnum} [calendarEvent] 
     * @param {GetMeetingObservabilityCohortsParticipantSourceEnum} [participantSource] 
     * @param {GetMeetingObservabilityCohortsParticipantBucketEnum} [participantBucket] 
     * @param {GetMeetingObservabilityCohortsUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetMeetingObservabilityCohortsAxBucketEnum} [axBucket] 
     * @param {GetMeetingObservabilityCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetMeetingObservabilityCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getMeetingObservabilityCohorts(groupBy: GetMeetingObservabilityCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityCohortsPlatformEnum, os?: GetMeetingObservabilityCohortsOsEnum, client?: GetMeetingObservabilityCohortsClientEnum, calendarEvent?: GetMeetingObservabilityCohortsCalendarEventEnum, participantSource?: GetMeetingObservabilityCohortsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityCohortsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityCohortsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityCohortsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityCohortsNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getMeetingObservabilityCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Page collected meetings and authorized attribution-viewer links.
     * @summary Get Meeting Observability Meetings
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingObservabilityMeetingsPlatformEnum} [platform] 
     * @param {GetMeetingObservabilityMeetingsOsEnum} [os] 
     * @param {GetMeetingObservabilityMeetingsClientEnum} [client] 
     * @param {GetMeetingObservabilityMeetingsCalendarEventEnum} [calendarEvent] 
     * @param {GetMeetingObservabilityMeetingsParticipantSourceEnum} [participantSource] 
     * @param {GetMeetingObservabilityMeetingsParticipantBucketEnum} [participantBucket] 
     * @param {GetMeetingObservabilityMeetingsUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetMeetingObservabilityMeetingsAxBucketEnum} [axBucket] 
     * @param {GetMeetingObservabilityMeetingsRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetMeetingObservabilityMeetingsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {GetMeetingObservabilityMeetingsLabelSourceEnum} [labelSource] 
     * @param {GetMeetingObservabilityMeetingsLabelRuleEnum} [labelRule] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getMeetingObservabilityMeetings(startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityMeetingsPlatformEnum, os?: GetMeetingObservabilityMeetingsOsEnum, client?: GetMeetingObservabilityMeetingsClientEnum, calendarEvent?: GetMeetingObservabilityMeetingsCalendarEventEnum, participantSource?: GetMeetingObservabilityMeetingsParticipantSourceEnum, participantBucket?: GetMeetingObservabilityMeetingsParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityMeetingsUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityMeetingsAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityMeetingsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityMeetingsNegateEnum>, limit?: number, cursor?: string | null, labelSource?: GetMeetingObservabilityMeetingsLabelSourceEnum, labelRule?: GetMeetingObservabilityMeetingsLabelRuleEnum, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getMeetingObservabilityMeetings(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, limit, cursor, labelSource, labelRule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return daily measurements for the largest combined physical meeting cohorts.
     * @summary Get Meeting Observability Trend
     * @param {Array<GetMeetingObservabilityTrendGroupByEnum>} groupBy 
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingObservabilityTrendPlatformEnum} [platform] 
     * @param {GetMeetingObservabilityTrendOsEnum} [os] 
     * @param {GetMeetingObservabilityTrendClientEnum} [client] 
     * @param {GetMeetingObservabilityTrendCalendarEventEnum} [calendarEvent] 
     * @param {GetMeetingObservabilityTrendParticipantSourceEnum} [participantSource] 
     * @param {GetMeetingObservabilityTrendParticipantBucketEnum} [participantBucket] 
     * @param {GetMeetingObservabilityTrendUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetMeetingObservabilityTrendAxBucketEnum} [axBucket] 
     * @param {GetMeetingObservabilityTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetMeetingObservabilityTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getMeetingObservabilityTrend(groupBy: Array<GetMeetingObservabilityTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetMeetingObservabilityTrendPlatformEnum, os?: GetMeetingObservabilityTrendOsEnum, client?: GetMeetingObservabilityTrendClientEnum, calendarEvent?: GetMeetingObservabilityTrendCalendarEventEnum, participantSource?: GetMeetingObservabilityTrendParticipantSourceEnum, participantBucket?: GetMeetingObservabilityTrendParticipantBucketEnum, userMeetingBucket?: GetMeetingObservabilityTrendUserMeetingBucketEnum, axBucket?: GetMeetingObservabilityTrendAxBucketEnum, recordingLengthBucket?: GetMeetingObservabilityTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetMeetingObservabilityTrendNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getMeetingObservabilityTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Group publication-time summary chips by a supported main-database dimension.
     * @summary Get Summary Chip Cohorts
     * @param {GetSummaryChipCohortsGroupByEnum} groupBy Meeting dimension to split the filtered population by.
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetSummaryChipCohortsPlatformEnum} [platform] 
     * @param {GetSummaryChipCohortsOsEnum} [os] 
     * @param {GetSummaryChipCohortsClientEnum} [client] 
     * @param {GetSummaryChipCohortsCalendarEventEnum} [calendarEvent] 
     * @param {GetSummaryChipCohortsParticipantSourceEnum} [participantSource] 
     * @param {GetSummaryChipCohortsParticipantBucketEnum} [participantBucket] 
     * @param {GetSummaryChipCohortsUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetSummaryChipCohortsAxBucketEnum} [axBucket] 
     * @param {GetSummaryChipCohortsRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetSummaryChipCohortsNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getSummaryChipCohorts(groupBy: GetSummaryChipCohortsGroupByEnum, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipCohortsPlatformEnum, os?: GetSummaryChipCohortsOsEnum, client?: GetSummaryChipCohortsClientEnum, calendarEvent?: GetSummaryChipCohortsCalendarEventEnum, participantSource?: GetSummaryChipCohortsParticipantSourceEnum, participantBucket?: GetSummaryChipCohortsParticipantBucketEnum, userMeetingBucket?: GetSummaryChipCohortsUserMeetingBucketEnum, axBucket?: GetSummaryChipCohortsAxBucketEnum, recordingLengthBucket?: GetSummaryChipCohortsRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipCohortsNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getSummaryChipCohorts(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return publication-time summary-chip coverage for consented individual meetings.
     * @summary Get Summary Chip Observability
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetSummaryChipObservabilityPlatformEnum} [platform] 
     * @param {GetSummaryChipObservabilityOsEnum} [os] 
     * @param {GetSummaryChipObservabilityClientEnum} [client] 
     * @param {GetSummaryChipObservabilityCalendarEventEnum} [calendarEvent] 
     * @param {GetSummaryChipObservabilityParticipantSourceEnum} [participantSource] 
     * @param {GetSummaryChipObservabilityParticipantBucketEnum} [participantBucket] 
     * @param {GetSummaryChipObservabilityUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetSummaryChipObservabilityAxBucketEnum} [axBucket] 
     * @param {GetSummaryChipObservabilityRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetSummaryChipObservabilityNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getSummaryChipObservability(startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipObservabilityPlatformEnum, os?: GetSummaryChipObservabilityOsEnum, client?: GetSummaryChipObservabilityClientEnum, calendarEvent?: GetSummaryChipObservabilityCalendarEventEnum, participantSource?: GetSummaryChipObservabilityParticipantSourceEnum, participantBucket?: GetSummaryChipObservabilityParticipantBucketEnum, userMeetingBucket?: GetSummaryChipObservabilityUserMeetingBucketEnum, axBucket?: GetSummaryChipObservabilityAxBucketEnum, recordingLengthBucket?: GetSummaryChipObservabilityRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipObservabilityNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getSummaryChipObservability(startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return daily summary-chip measurements for the largest supported publication cohorts.
     * @summary Get Summary Chip Trend
     * @param {Array<GetSummaryChipTrendGroupByEnum>} groupBy 
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetSummaryChipTrendPlatformEnum} [platform] 
     * @param {GetSummaryChipTrendOsEnum} [os] 
     * @param {GetSummaryChipTrendClientEnum} [client] 
     * @param {GetSummaryChipTrendCalendarEventEnum} [calendarEvent] 
     * @param {GetSummaryChipTrendParticipantSourceEnum} [participantSource] 
     * @param {GetSummaryChipTrendParticipantBucketEnum} [participantBucket] 
     * @param {GetSummaryChipTrendUserMeetingBucketEnum} [userMeetingBucket] 
     * @param {GetSummaryChipTrendAxBucketEnum} [axBucket] 
     * @param {GetSummaryChipTrendRecordingLengthBucketEnum} [recordingLengthBucket] 
     * @param {string | null} [backendVersion] 
     * @param {string | null} [appVersion] 
     * @param {Array<GetSummaryChipTrendNegateEnum>} [negate] Dimensions whose supplied values are excluded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingObservabilityApi
     */
    public getSummaryChipTrend(groupBy: Array<GetSummaryChipTrendGroupByEnum>, startAt?: string | null, endAt?: string | null, platform?: GetSummaryChipTrendPlatformEnum, os?: GetSummaryChipTrendOsEnum, client?: GetSummaryChipTrendClientEnum, calendarEvent?: GetSummaryChipTrendCalendarEventEnum, participantSource?: GetSummaryChipTrendParticipantSourceEnum, participantBucket?: GetSummaryChipTrendParticipantBucketEnum, userMeetingBucket?: GetSummaryChipTrendUserMeetingBucketEnum, axBucket?: GetSummaryChipTrendAxBucketEnum, recordingLengthBucket?: GetSummaryChipTrendRecordingLengthBucketEnum, backendVersion?: string | null, appVersion?: string | null, negate?: Array<GetSummaryChipTrendNegateEnum>, options?: RawAxiosRequestConfig) {
        return MeetingObservabilityApiFp(this.configuration).getSummaryChipTrend(groupBy, startAt, endAt, platform, os, client, calendarEvent, participantSource, participantBucket, userMeetingBucket, axBucket, recordingLengthBucket, backendVersion, appVersion, negate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMeetingObservabilityPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityPlatformEnum = typeof GetMeetingObservabilityPlatformEnum[keyof typeof GetMeetingObservabilityPlatformEnum];
/**
 * @export
 */
export const GetMeetingObservabilityOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityOsEnum = typeof GetMeetingObservabilityOsEnum[keyof typeof GetMeetingObservabilityOsEnum];
/**
 * @export
 */
export const GetMeetingObservabilityClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityClientEnum = typeof GetMeetingObservabilityClientEnum[keyof typeof GetMeetingObservabilityClientEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityCalendarEventEnum = typeof GetMeetingObservabilityCalendarEventEnum[keyof typeof GetMeetingObservabilityCalendarEventEnum];
/**
 * @export
 */
export const GetMeetingObservabilityParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetMeetingObservabilityParticipantSourceEnum = typeof GetMeetingObservabilityParticipantSourceEnum[keyof typeof GetMeetingObservabilityParticipantSourceEnum];
/**
 * @export
 */
export const GetMeetingObservabilityParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetMeetingObservabilityParticipantBucketEnum = typeof GetMeetingObservabilityParticipantBucketEnum[keyof typeof GetMeetingObservabilityParticipantBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetMeetingObservabilityUserMeetingBucketEnum = typeof GetMeetingObservabilityUserMeetingBucketEnum[keyof typeof GetMeetingObservabilityUserMeetingBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetMeetingObservabilityAxBucketEnum = typeof GetMeetingObservabilityAxBucketEnum[keyof typeof GetMeetingObservabilityAxBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetMeetingObservabilityRecordingLengthBucketEnum = typeof GetMeetingObservabilityRecordingLengthBucketEnum[keyof typeof GetMeetingObservabilityRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityNegateEnum = typeof GetMeetingObservabilityNegateEnum[keyof typeof GetMeetingObservabilityNegateEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityCohortsGroupByEnum = typeof GetMeetingObservabilityCohortsGroupByEnum[keyof typeof GetMeetingObservabilityCohortsGroupByEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityCohortsPlatformEnum = typeof GetMeetingObservabilityCohortsPlatformEnum[keyof typeof GetMeetingObservabilityCohortsPlatformEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityCohortsOsEnum = typeof GetMeetingObservabilityCohortsOsEnum[keyof typeof GetMeetingObservabilityCohortsOsEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityCohortsClientEnum = typeof GetMeetingObservabilityCohortsClientEnum[keyof typeof GetMeetingObservabilityCohortsClientEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityCohortsCalendarEventEnum = typeof GetMeetingObservabilityCohortsCalendarEventEnum[keyof typeof GetMeetingObservabilityCohortsCalendarEventEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetMeetingObservabilityCohortsParticipantSourceEnum = typeof GetMeetingObservabilityCohortsParticipantSourceEnum[keyof typeof GetMeetingObservabilityCohortsParticipantSourceEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetMeetingObservabilityCohortsParticipantBucketEnum = typeof GetMeetingObservabilityCohortsParticipantBucketEnum[keyof typeof GetMeetingObservabilityCohortsParticipantBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetMeetingObservabilityCohortsUserMeetingBucketEnum = typeof GetMeetingObservabilityCohortsUserMeetingBucketEnum[keyof typeof GetMeetingObservabilityCohortsUserMeetingBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetMeetingObservabilityCohortsAxBucketEnum = typeof GetMeetingObservabilityCohortsAxBucketEnum[keyof typeof GetMeetingObservabilityCohortsAxBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetMeetingObservabilityCohortsRecordingLengthBucketEnum = typeof GetMeetingObservabilityCohortsRecordingLengthBucketEnum[keyof typeof GetMeetingObservabilityCohortsRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityCohortsNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityCohortsNegateEnum = typeof GetMeetingObservabilityCohortsNegateEnum[keyof typeof GetMeetingObservabilityCohortsNegateEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityMeetingsPlatformEnum = typeof GetMeetingObservabilityMeetingsPlatformEnum[keyof typeof GetMeetingObservabilityMeetingsPlatformEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityMeetingsOsEnum = typeof GetMeetingObservabilityMeetingsOsEnum[keyof typeof GetMeetingObservabilityMeetingsOsEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityMeetingsClientEnum = typeof GetMeetingObservabilityMeetingsClientEnum[keyof typeof GetMeetingObservabilityMeetingsClientEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityMeetingsCalendarEventEnum = typeof GetMeetingObservabilityMeetingsCalendarEventEnum[keyof typeof GetMeetingObservabilityMeetingsCalendarEventEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetMeetingObservabilityMeetingsParticipantSourceEnum = typeof GetMeetingObservabilityMeetingsParticipantSourceEnum[keyof typeof GetMeetingObservabilityMeetingsParticipantSourceEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetMeetingObservabilityMeetingsParticipantBucketEnum = typeof GetMeetingObservabilityMeetingsParticipantBucketEnum[keyof typeof GetMeetingObservabilityMeetingsParticipantBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetMeetingObservabilityMeetingsUserMeetingBucketEnum = typeof GetMeetingObservabilityMeetingsUserMeetingBucketEnum[keyof typeof GetMeetingObservabilityMeetingsUserMeetingBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetMeetingObservabilityMeetingsAxBucketEnum = typeof GetMeetingObservabilityMeetingsAxBucketEnum[keyof typeof GetMeetingObservabilityMeetingsAxBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetMeetingObservabilityMeetingsRecordingLengthBucketEnum = typeof GetMeetingObservabilityMeetingsRecordingLengthBucketEnum[keyof typeof GetMeetingObservabilityMeetingsRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityMeetingsNegateEnum = typeof GetMeetingObservabilityMeetingsNegateEnum[keyof typeof GetMeetingObservabilityMeetingsNegateEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsLabelSourceEnum = {
    Ax: 'ax',
    Channel: 'channel',
    Llm: 'llm',
    Unnamed: 'unnamed'
} as const;
export type GetMeetingObservabilityMeetingsLabelSourceEnum = typeof GetMeetingObservabilityMeetingsLabelSourceEnum[keyof typeof GetMeetingObservabilityMeetingsLabelSourceEnum];
/**
 * @export
 */
export const GetMeetingObservabilityMeetingsLabelRuleEnum = {
    Dom: 'dom',
    DomContested: 'dom_contested',
    Rescue: 'rescue',
    MicContentOwner: 'mic_content_owner',
    MicSoleSpeakerOwner: 'mic_sole_speaker_owner',
    SystemContentAttendee: 'system_content_attendee',
    PairedSoleAttendee: 'paired_sole_attendee',
    RosterCalendar: 'roster_calendar',
    RosterOther: 'roster_other',
    NamingLinkCalendar: 'naming_link_calendar',
    NamingLinkOther: 'naming_link_other',
    NamingCreated: 'naming_created',
    Prior: 'prior',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityMeetingsLabelRuleEnum = typeof GetMeetingObservabilityMeetingsLabelRuleEnum[keyof typeof GetMeetingObservabilityMeetingsLabelRuleEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityTrendGroupByEnum = typeof GetMeetingObservabilityTrendGroupByEnum[keyof typeof GetMeetingObservabilityTrendGroupByEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityTrendPlatformEnum = typeof GetMeetingObservabilityTrendPlatformEnum[keyof typeof GetMeetingObservabilityTrendPlatformEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityTrendOsEnum = typeof GetMeetingObservabilityTrendOsEnum[keyof typeof GetMeetingObservabilityTrendOsEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityTrendClientEnum = typeof GetMeetingObservabilityTrendClientEnum[keyof typeof GetMeetingObservabilityTrendClientEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetMeetingObservabilityTrendCalendarEventEnum = typeof GetMeetingObservabilityTrendCalendarEventEnum[keyof typeof GetMeetingObservabilityTrendCalendarEventEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetMeetingObservabilityTrendParticipantSourceEnum = typeof GetMeetingObservabilityTrendParticipantSourceEnum[keyof typeof GetMeetingObservabilityTrendParticipantSourceEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetMeetingObservabilityTrendParticipantBucketEnum = typeof GetMeetingObservabilityTrendParticipantBucketEnum[keyof typeof GetMeetingObservabilityTrendParticipantBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetMeetingObservabilityTrendUserMeetingBucketEnum = typeof GetMeetingObservabilityTrendUserMeetingBucketEnum[keyof typeof GetMeetingObservabilityTrendUserMeetingBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetMeetingObservabilityTrendAxBucketEnum = typeof GetMeetingObservabilityTrendAxBucketEnum[keyof typeof GetMeetingObservabilityTrendAxBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetMeetingObservabilityTrendRecordingLengthBucketEnum = typeof GetMeetingObservabilityTrendRecordingLengthBucketEnum[keyof typeof GetMeetingObservabilityTrendRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetMeetingObservabilityTrendNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetMeetingObservabilityTrendNegateEnum = typeof GetMeetingObservabilityTrendNegateEnum[keyof typeof GetMeetingObservabilityTrendNegateEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetSummaryChipCohortsGroupByEnum = typeof GetSummaryChipCohortsGroupByEnum[keyof typeof GetSummaryChipCohortsGroupByEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipCohortsPlatformEnum = typeof GetSummaryChipCohortsPlatformEnum[keyof typeof GetSummaryChipCohortsPlatformEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipCohortsOsEnum = typeof GetSummaryChipCohortsOsEnum[keyof typeof GetSummaryChipCohortsOsEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipCohortsClientEnum = typeof GetSummaryChipCohortsClientEnum[keyof typeof GetSummaryChipCohortsClientEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipCohortsCalendarEventEnum = typeof GetSummaryChipCohortsCalendarEventEnum[keyof typeof GetSummaryChipCohortsCalendarEventEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetSummaryChipCohortsParticipantSourceEnum = typeof GetSummaryChipCohortsParticipantSourceEnum[keyof typeof GetSummaryChipCohortsParticipantSourceEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetSummaryChipCohortsParticipantBucketEnum = typeof GetSummaryChipCohortsParticipantBucketEnum[keyof typeof GetSummaryChipCohortsParticipantBucketEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetSummaryChipCohortsUserMeetingBucketEnum = typeof GetSummaryChipCohortsUserMeetingBucketEnum[keyof typeof GetSummaryChipCohortsUserMeetingBucketEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetSummaryChipCohortsAxBucketEnum = typeof GetSummaryChipCohortsAxBucketEnum[keyof typeof GetSummaryChipCohortsAxBucketEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetSummaryChipCohortsRecordingLengthBucketEnum = typeof GetSummaryChipCohortsRecordingLengthBucketEnum[keyof typeof GetSummaryChipCohortsRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetSummaryChipCohortsNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetSummaryChipCohortsNegateEnum = typeof GetSummaryChipCohortsNegateEnum[keyof typeof GetSummaryChipCohortsNegateEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipObservabilityPlatformEnum = typeof GetSummaryChipObservabilityPlatformEnum[keyof typeof GetSummaryChipObservabilityPlatformEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipObservabilityOsEnum = typeof GetSummaryChipObservabilityOsEnum[keyof typeof GetSummaryChipObservabilityOsEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipObservabilityClientEnum = typeof GetSummaryChipObservabilityClientEnum[keyof typeof GetSummaryChipObservabilityClientEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipObservabilityCalendarEventEnum = typeof GetSummaryChipObservabilityCalendarEventEnum[keyof typeof GetSummaryChipObservabilityCalendarEventEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetSummaryChipObservabilityParticipantSourceEnum = typeof GetSummaryChipObservabilityParticipantSourceEnum[keyof typeof GetSummaryChipObservabilityParticipantSourceEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetSummaryChipObservabilityParticipantBucketEnum = typeof GetSummaryChipObservabilityParticipantBucketEnum[keyof typeof GetSummaryChipObservabilityParticipantBucketEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetSummaryChipObservabilityUserMeetingBucketEnum = typeof GetSummaryChipObservabilityUserMeetingBucketEnum[keyof typeof GetSummaryChipObservabilityUserMeetingBucketEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetSummaryChipObservabilityAxBucketEnum = typeof GetSummaryChipObservabilityAxBucketEnum[keyof typeof GetSummaryChipObservabilityAxBucketEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetSummaryChipObservabilityRecordingLengthBucketEnum = typeof GetSummaryChipObservabilityRecordingLengthBucketEnum[keyof typeof GetSummaryChipObservabilityRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetSummaryChipObservabilityNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetSummaryChipObservabilityNegateEnum = typeof GetSummaryChipObservabilityNegateEnum[keyof typeof GetSummaryChipObservabilityNegateEnum];
/**
 * @export
 */
export const GetSummaryChipTrendGroupByEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetSummaryChipTrendGroupByEnum = typeof GetSummaryChipTrendGroupByEnum[keyof typeof GetSummaryChipTrendGroupByEnum];
/**
 * @export
 */
export const GetSummaryChipTrendPlatformEnum = {
    GoogleMeet: 'google_meet',
    Teams: 'teams',
    Zoom: 'zoom',
    Slack: 'slack',
    InPerson: 'in_person',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipTrendPlatformEnum = typeof GetSummaryChipTrendPlatformEnum[keyof typeof GetSummaryChipTrendPlatformEnum];
/**
 * @export
 */
export const GetSummaryChipTrendOsEnum = {
    Macos: 'macos',
    Windows: 'windows',
    Ios: 'ios',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipTrendOsEnum = typeof GetSummaryChipTrendOsEnum[keyof typeof GetSummaryChipTrendOsEnum];
/**
 * @export
 */
export const GetSummaryChipTrendClientEnum = {
    Chrome: 'chrome',
    Edge: 'edge',
    Brave: 'brave',
    Arc: 'arc',
    Comet: 'comet',
    Dia: 'dia',
    Native: 'native',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipTrendClientEnum = typeof GetSummaryChipTrendClientEnum[keyof typeof GetSummaryChipTrendClientEnum];
/**
 * @export
 */
export const GetSummaryChipTrendCalendarEventEnum = {
    None: 'none',
    Google: 'google',
    Outlook: 'outlook',
    Unknown: 'unknown'
} as const;
export type GetSummaryChipTrendCalendarEventEnum = typeof GetSummaryChipTrendCalendarEventEnum[keyof typeof GetSummaryChipTrendCalendarEventEnum];
/**
 * @export
 */
export const GetSummaryChipTrendParticipantSourceEnum = {
    Canonical: 'canonical',
    Invited: 'invited'
} as const;
export type GetSummaryChipTrendParticipantSourceEnum = typeof GetSummaryChipTrendParticipantSourceEnum[keyof typeof GetSummaryChipTrendParticipantSourceEnum];
/**
 * @export
 */
export const GetSummaryChipTrendParticipantBucketEnum = {
    Unknown: 'unknown',
    _0: '0',
    _1: '1',
    _2: '2',
    _35: '3-5',
    _612: '6-12',
    _13: '13+'
} as const;
export type GetSummaryChipTrendParticipantBucketEnum = typeof GetSummaryChipTrendParticipantBucketEnum[keyof typeof GetSummaryChipTrendParticipantBucketEnum];
/**
 * @export
 */
export const GetSummaryChipTrendUserMeetingBucketEnum = {
    Unknown: 'unknown',
    _1: '1',
    _23: '2-3',
    _48: '4-8',
    _920: '9-20',
    _21: '21+'
} as const;
export type GetSummaryChipTrendUserMeetingBucketEnum = typeof GetSummaryChipTrendUserMeetingBucketEnum[keyof typeof GetSummaryChipTrendUserMeetingBucketEnum];
/**
 * @export
 */
export const GetSummaryChipTrendAxBucketEnum = {
    Unknown: 'unknown',
    NotApplicable: 'not_applicable',
    _0: '0',
    _025: '0-25',
    _2550: '25-50',
    _5075: '50-75',
    _75100: '75-100'
} as const;
export type GetSummaryChipTrendAxBucketEnum = typeof GetSummaryChipTrendAxBucketEnum[keyof typeof GetSummaryChipTrendAxBucketEnum];
/**
 * @export
 */
export const GetSummaryChipTrendRecordingLengthBucketEnum = {
    Unknown: 'unknown',
    _05: '0-5',
    _515: '5-15',
    _1530: '15-30',
    _3060: '30-60',
    _6090: '60-90',
    _90: '90+'
} as const;
export type GetSummaryChipTrendRecordingLengthBucketEnum = typeof GetSummaryChipTrendRecordingLengthBucketEnum[keyof typeof GetSummaryChipTrendRecordingLengthBucketEnum];
/**
 * @export
 */
export const GetSummaryChipTrendNegateEnum = {
    Platform: 'platform',
    Os: 'os',
    Client: 'client',
    CalendarEvent: 'calendar_event',
    ParticipantBucket: 'participant_bucket',
    UserMeetingBucket: 'user_meeting_bucket',
    AxBucket: 'ax_bucket',
    RecordingLengthBucket: 'recording_length_bucket',
    BackendVersion: 'backend_version',
    AppVersion: 'app_version'
} as const;
export type GetSummaryChipTrendNegateEnum = typeof GetSummaryChipTrendNegateEnum[keyof typeof GetSummaryChipTrendNegateEnum];


/**
 * MeetingPeopleApi - axios parameter creator
 * @export
 */
export const MeetingPeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Everyone identified in this meeting, merged from its speaker map and calendar attendees.  A GET rather than the sibling picker\'s POST: there is no search term, so nothing PII-bearing lands in the access-log request line. Notetaker-gated unlike ``/people``, which reads only calendar contacts — the speaker map this merges in is transcript-derived.  Args:     meeting_id: Meeting to resolve participants for.     user: Authenticated caller (injected).     db: Database executor (injected).  Returns:     The caller\'s identity and the meeting\'s participants.  Raises:     HTTPUnauthorized: when the token carries no user id.     HTTPNotFound: when the caller does not own the meeting.
         * @summary Get Meeting Participants
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingParticipants: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingParticipants', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/participants`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suggest people to share this meeting\'s notes with.  A POST because the search term is a person\'s name or email and the uvicorn access log records full request lines to CloudWatch, Logtail and Sentry Logs; a body never reaches those sinks. Ungated on Cloud Sync like the sibling share reads — a people lookup persists nothing and reads no transcript-derived data.  The per-user limiter is declared after the auth dep so it buckets by user rather than by IP — FastAPI resolves signature deps in order, and above auth ``request.state.user_id`` is still unset.  Args:     meeting_id: Meeting the picker is open on.     body: Optional search term and row cap.     user: Authenticated caller (injected).     service: People-picker service (injected).  Returns:     Ranked people, prefix matches before substring matches.  Raises:     HTTPNotFound: when the caller does not own the meeting.
         * @summary Search Meeting People
         * @param {string} meetingId 
         * @param {MeetingPeopleRequest} meetingPeopleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMeetingPeople: async (meetingId: string, meetingPeopleRequest: MeetingPeopleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('searchMeetingPeople', 'meetingId', meetingId)
            // verify required parameter 'meetingPeopleRequest' is not null or undefined
            assertParamExists('searchMeetingPeople', 'meetingPeopleRequest', meetingPeopleRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/people`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingPeopleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingPeopleApi - functional programming interface
 * @export
 */
export const MeetingPeopleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingPeopleApiAxiosParamCreator(configuration)
    return {
        /**
         * Everyone identified in this meeting, merged from its speaker map and calendar attendees.  A GET rather than the sibling picker\'s POST: there is no search term, so nothing PII-bearing lands in the access-log request line. Notetaker-gated unlike ``/people``, which reads only calendar contacts — the speaker map this merges in is transcript-derived.  Args:     meeting_id: Meeting to resolve participants for.     user: Authenticated caller (injected).     db: Database executor (injected).  Returns:     The caller\'s identity and the meeting\'s participants.  Raises:     HTTPUnauthorized: when the token carries no user id.     HTTPNotFound: when the caller does not own the meeting.
         * @summary Get Meeting Participants
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingParticipants(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingParticipantsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingParticipants(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPeopleApi.getMeetingParticipants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suggest people to share this meeting\'s notes with.  A POST because the search term is a person\'s name or email and the uvicorn access log records full request lines to CloudWatch, Logtail and Sentry Logs; a body never reaches those sinks. Ungated on Cloud Sync like the sibling share reads — a people lookup persists nothing and reads no transcript-derived data.  The per-user limiter is declared after the auth dep so it buckets by user rather than by IP — FastAPI resolves signature deps in order, and above auth ``request.state.user_id`` is still unset.  Args:     meeting_id: Meeting the picker is open on.     body: Optional search term and row cap.     user: Authenticated caller (injected).     service: People-picker service (injected).  Returns:     Ranked people, prefix matches before substring matches.  Raises:     HTTPNotFound: when the caller does not own the meeting.
         * @summary Search Meeting People
         * @param {string} meetingId 
         * @param {MeetingPeopleRequest} meetingPeopleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMeetingPeople(meetingId: string, meetingPeopleRequest: MeetingPeopleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingPeopleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMeetingPeople(meetingId, meetingPeopleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingPeopleApi.searchMeetingPeople']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingPeopleApi - factory interface
 * @export
 */
export const MeetingPeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingPeopleApiFp(configuration)
    return {
        /**
         * Everyone identified in this meeting, merged from its speaker map and calendar attendees.  A GET rather than the sibling picker\'s POST: there is no search term, so nothing PII-bearing lands in the access-log request line. Notetaker-gated unlike ``/people``, which reads only calendar contacts — the speaker map this merges in is transcript-derived.  Args:     meeting_id: Meeting to resolve participants for.     user: Authenticated caller (injected).     db: Database executor (injected).  Returns:     The caller\'s identity and the meeting\'s participants.  Raises:     HTTPUnauthorized: when the token carries no user id.     HTTPNotFound: when the caller does not own the meeting.
         * @summary Get Meeting Participants
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingParticipants(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingParticipantsResponse> {
            return localVarFp.getMeetingParticipants(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Suggest people to share this meeting\'s notes with.  A POST because the search term is a person\'s name or email and the uvicorn access log records full request lines to CloudWatch, Logtail and Sentry Logs; a body never reaches those sinks. Ungated on Cloud Sync like the sibling share reads — a people lookup persists nothing and reads no transcript-derived data.  The per-user limiter is declared after the auth dep so it buckets by user rather than by IP — FastAPI resolves signature deps in order, and above auth ``request.state.user_id`` is still unset.  Args:     meeting_id: Meeting the picker is open on.     body: Optional search term and row cap.     user: Authenticated caller (injected).     service: People-picker service (injected).  Returns:     Ranked people, prefix matches before substring matches.  Raises:     HTTPNotFound: when the caller does not own the meeting.
         * @summary Search Meeting People
         * @param {string} meetingId 
         * @param {MeetingPeopleRequest} meetingPeopleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMeetingPeople(meetingId: string, meetingPeopleRequest: MeetingPeopleRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingPeopleResponse> {
            return localVarFp.searchMeetingPeople(meetingId, meetingPeopleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingPeopleApi - object-oriented interface
 * @export
 * @class MeetingPeopleApi
 * @extends {BaseAPI}
 */
export class MeetingPeopleApi extends BaseAPI {
    /**
     * Everyone identified in this meeting, merged from its speaker map and calendar attendees.  A GET rather than the sibling picker\'s POST: there is no search term, so nothing PII-bearing lands in the access-log request line. Notetaker-gated unlike ``/people``, which reads only calendar contacts — the speaker map this merges in is transcript-derived.  Args:     meeting_id: Meeting to resolve participants for.     user: Authenticated caller (injected).     db: Database executor (injected).  Returns:     The caller\'s identity and the meeting\'s participants.  Raises:     HTTPUnauthorized: when the token carries no user id.     HTTPNotFound: when the caller does not own the meeting.
     * @summary Get Meeting Participants
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPeopleApi
     */
    public getMeetingParticipants(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingPeopleApiFp(this.configuration).getMeetingParticipants(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suggest people to share this meeting\'s notes with.  A POST because the search term is a person\'s name or email and the uvicorn access log records full request lines to CloudWatch, Logtail and Sentry Logs; a body never reaches those sinks. Ungated on Cloud Sync like the sibling share reads — a people lookup persists nothing and reads no transcript-derived data.  The per-user limiter is declared after the auth dep so it buckets by user rather than by IP — FastAPI resolves signature deps in order, and above auth ``request.state.user_id`` is still unset.  Args:     meeting_id: Meeting the picker is open on.     body: Optional search term and row cap.     user: Authenticated caller (injected).     service: People-picker service (injected).  Returns:     Ranked people, prefix matches before substring matches.  Raises:     HTTPNotFound: when the caller does not own the meeting.
     * @summary Search Meeting People
     * @param {string} meetingId 
     * @param {MeetingPeopleRequest} meetingPeopleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingPeopleApi
     */
    public searchMeetingPeople(meetingId: string, meetingPeopleRequest: MeetingPeopleRequest, options?: RawAxiosRequestConfig) {
        return MeetingPeopleApiFp(this.configuration).searchMeetingPeople(meetingId, meetingPeopleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingReportsObservabilityApi - axios parameter creator
 * @export
 */
export const MeetingReportsObservabilityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Page individual reports with Slack pointers and authorized viewer links.
         * @summary Get Meeting Reports
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Opaque continuation from the previous page. It pins the window that page was served for, overriding start_at/end_at, so a defaulted window does not slide between pages.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReports: async (startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-reports/observability/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }

            if (outputDeviceFamily !== undefined) {
                localVarQueryParameter['output_device_family'] = outputDeviceFamily;
            }

            if (outputDevice !== undefined) {
                localVarQueryParameter['output_device'] = outputDevice;
            }

            if (micDevice !== undefined) {
                localVarQueryParameter['mic_device'] = micDevice;
            }

            if (meetingPlatform !== undefined) {
                localVarQueryParameter['meeting_platform'] = meetingPlatform;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (knownIssue !== undefined) {
                localVarQueryParameter['known_issue'] = knownIssue;
            }

            if (jobStatus !== undefined) {
                localVarQueryParameter['job_status'] = jobStatus;
            }

            if (reportCategory !== undefined) {
                localVarQueryParameter['report_category'] = reportCategory;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }

            if (wisprUser !== undefined) {
                localVarQueryParameter['wispr_user'] = wisprUser;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Top values of every dimension inside the filtered population.
         * @summary Get Meeting Reports Cohorts
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsCohortsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsCohortsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsCohorts: async (startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsCohortsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsCohortsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-reports/observability/cohorts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }

            if (outputDeviceFamily !== undefined) {
                localVarQueryParameter['output_device_family'] = outputDeviceFamily;
            }

            if (outputDevice !== undefined) {
                localVarQueryParameter['output_device'] = outputDevice;
            }

            if (micDevice !== undefined) {
                localVarQueryParameter['mic_device'] = micDevice;
            }

            if (meetingPlatform !== undefined) {
                localVarQueryParameter['meeting_platform'] = meetingPlatform;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (knownIssue !== undefined) {
                localVarQueryParameter['known_issue'] = knownIssue;
            }

            if (jobStatus !== undefined) {
                localVarQueryParameter['job_status'] = jobStatus;
            }

            if (reportCategory !== undefined) {
                localVarQueryParameter['report_category'] = reportCategory;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }

            if (wisprUser !== undefined) {
                localVarQueryParameter['wispr_user'] = wisprUser;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Board rows for one dimension (signature by default), heaviest first.
         * @summary Get Meeting Reports Groups
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsGroupsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsGroupsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {GetMeetingReportsGroupsGroupByEnum} [groupBy] Dimension each board row represents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsGroups: async (startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsGroupsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsGroupsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, groupBy?: GetMeetingReportsGroupsGroupByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-reports/observability/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }

            if (outputDeviceFamily !== undefined) {
                localVarQueryParameter['output_device_family'] = outputDeviceFamily;
            }

            if (outputDevice !== undefined) {
                localVarQueryParameter['output_device'] = outputDevice;
            }

            if (micDevice !== undefined) {
                localVarQueryParameter['mic_device'] = micDevice;
            }

            if (meetingPlatform !== undefined) {
                localVarQueryParameter['meeting_platform'] = meetingPlatform;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (knownIssue !== undefined) {
                localVarQueryParameter['known_issue'] = knownIssue;
            }

            if (jobStatus !== undefined) {
                localVarQueryParameter['job_status'] = jobStatus;
            }

            if (reportCategory !== undefined) {
                localVarQueryParameter['report_category'] = reportCategory;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }

            if (wisprUser !== undefined) {
                localVarQueryParameter['wispr_user'] = wisprUser;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (groupBy !== undefined) {
                localVarQueryParameter['group_by'] = groupBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Counters, prior-window comparison, daily severity trend, and filter values.
         * @summary Get Meeting Reports Overview
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsOverviewSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsOverviewReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsOverview: async (startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsOverviewSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsOverviewReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-reports/observability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }

            if (outputDeviceFamily !== undefined) {
                localVarQueryParameter['output_device_family'] = outputDeviceFamily;
            }

            if (outputDevice !== undefined) {
                localVarQueryParameter['output_device'] = outputDevice;
            }

            if (micDevice !== undefined) {
                localVarQueryParameter['mic_device'] = micDevice;
            }

            if (meetingPlatform !== undefined) {
                localVarQueryParameter['meeting_platform'] = meetingPlatform;
            }

            if (appVersion !== undefined) {
                localVarQueryParameter['app_version'] = appVersion;
            }

            if (knownIssue !== undefined) {
                localVarQueryParameter['known_issue'] = knownIssue;
            }

            if (jobStatus !== undefined) {
                localVarQueryParameter['job_status'] = jobStatus;
            }

            if (reportCategory !== undefined) {
                localVarQueryParameter['report_category'] = reportCategory;
            }

            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }

            if (wisprUser !== undefined) {
                localVarQueryParameter['wispr_user'] = wisprUser;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingReportsObservabilityApi - functional programming interface
 * @export
 */
export const MeetingReportsObservabilityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingReportsObservabilityApiAxiosParamCreator(configuration)
    return {
        /**
         * Page individual reports with Slack pointers and authorized viewer links.
         * @summary Get Meeting Reports
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Opaque continuation from the previous page. It pins the window that page was served for, overriding start_at/end_at, so a defaulted window does not slide between pages.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingReports(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingReportItems>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingReports(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingReportsObservabilityApi.getMeetingReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Top values of every dimension inside the filtered population.
         * @summary Get Meeting Reports Cohorts
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsCohortsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsCohortsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingReportsCohorts(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsCohortsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsCohortsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportCohorts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingReportsCohorts(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingReportsObservabilityApi.getMeetingReportsCohorts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Board rows for one dimension (signature by default), heaviest first.
         * @summary Get Meeting Reports Groups
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsGroupsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsGroupsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {GetMeetingReportsGroupsGroupByEnum} [groupBy] Dimension each board row represents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingReportsGroups(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsGroupsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsGroupsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, groupBy?: GetMeetingReportsGroupsGroupByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportGroups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingReportsGroups(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, groupBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingReportsObservabilityApi.getMeetingReportsGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Counters, prior-window comparison, daily severity trend, and filter values.
         * @summary Get Meeting Reports Overview
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsOverviewSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsOverviewReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingReportsOverview(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsOverviewSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsOverviewReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingReportsOverview(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingReportsObservabilityApi.getMeetingReportsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingReportsObservabilityApi - factory interface
 * @export
 */
export const MeetingReportsObservabilityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingReportsObservabilityApiFp(configuration)
    return {
        /**
         * Page individual reports with Slack pointers and authorized viewer links.
         * @summary Get Meeting Reports
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {number} [limit] 
         * @param {string | null} [cursor] Opaque continuation from the previous page. It pins the window that page was served for, overriding start_at/end_at, so a defaulted window does not slide between pages.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReports(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<MeetingReportItems> {
            return localVarFp.getMeetingReports(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, limit, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * Top values of every dimension inside the filtered population.
         * @summary Get Meeting Reports Cohorts
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsCohortsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsCohortsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsCohorts(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsCohortsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsCohortsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ReportCohorts> {
            return localVarFp.getMeetingReportsCohorts(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Board rows for one dimension (signature by default), heaviest first.
         * @summary Get Meeting Reports Groups
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsGroupsSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsGroupsReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {GetMeetingReportsGroupsGroupByEnum} [groupBy] Dimension each board row represents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsGroups(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsGroupsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsGroupsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, groupBy?: GetMeetingReportsGroupsGroupByEnum, options?: RawAxiosRequestConfig): AxiosPromise<ReportGroups> {
            return localVarFp.getMeetingReportsGroups(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, groupBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Counters, prior-window comparison, daily severity trend, and filter values.
         * @summary Get Meeting Reports Overview
         * @param {string | null} [startAt] 
         * @param {string | null} [endAt] 
         * @param {GetMeetingReportsOverviewSeverityEnum} [severity] 
         * @param {string | null} [signature] 
         * @param {string | null} [outputDeviceFamily] 
         * @param {string | null} [outputDevice] 
         * @param {string | null} [micDevice] 
         * @param {string | null} [meetingPlatform] 
         * @param {string | null} [appVersion] 
         * @param {string | null} [knownIssue] 
         * @param {string | null} [jobStatus] 
         * @param {string | null} [reportCategory] 
         * @param {GetMeetingReportsOverviewReportTypeEnum} [reportType] 
         * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
         * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingReportsOverview(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsOverviewSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsOverviewReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ReportOverview> {
            return localVarFp.getMeetingReportsOverview(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingReportsObservabilityApi - object-oriented interface
 * @export
 * @class MeetingReportsObservabilityApi
 * @extends {BaseAPI}
 */
export class MeetingReportsObservabilityApi extends BaseAPI {
    /**
     * Page individual reports with Slack pointers and authorized viewer links.
     * @summary Get Meeting Reports
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingReportsSeverityEnum} [severity] 
     * @param {string | null} [signature] 
     * @param {string | null} [outputDeviceFamily] 
     * @param {string | null} [outputDevice] 
     * @param {string | null} [micDevice] 
     * @param {string | null} [meetingPlatform] 
     * @param {string | null} [appVersion] 
     * @param {string | null} [knownIssue] 
     * @param {string | null} [jobStatus] 
     * @param {string | null} [reportCategory] 
     * @param {GetMeetingReportsReportTypeEnum} [reportType] 
     * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
     * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
     * @param {number} [limit] 
     * @param {string | null} [cursor] Opaque continuation from the previous page. It pins the window that page was served for, overriding start_at/end_at, so a defaulted window does not slide between pages.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingReportsObservabilityApi
     */
    public getMeetingReports(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingReportsObservabilityApiFp(this.configuration).getMeetingReports(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Top values of every dimension inside the filtered population.
     * @summary Get Meeting Reports Cohorts
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingReportsCohortsSeverityEnum} [severity] 
     * @param {string | null} [signature] 
     * @param {string | null} [outputDeviceFamily] 
     * @param {string | null} [outputDevice] 
     * @param {string | null} [micDevice] 
     * @param {string | null} [meetingPlatform] 
     * @param {string | null} [appVersion] 
     * @param {string | null} [knownIssue] 
     * @param {string | null} [jobStatus] 
     * @param {string | null} [reportCategory] 
     * @param {GetMeetingReportsCohortsReportTypeEnum} [reportType] 
     * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
     * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingReportsObservabilityApi
     */
    public getMeetingReportsCohorts(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsCohortsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsCohortsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingReportsObservabilityApiFp(this.configuration).getMeetingReportsCohorts(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Board rows for one dimension (signature by default), heaviest first.
     * @summary Get Meeting Reports Groups
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingReportsGroupsSeverityEnum} [severity] 
     * @param {string | null} [signature] 
     * @param {string | null} [outputDeviceFamily] 
     * @param {string | null} [outputDevice] 
     * @param {string | null} [micDevice] 
     * @param {string | null} [meetingPlatform] 
     * @param {string | null} [appVersion] 
     * @param {string | null} [knownIssue] 
     * @param {string | null} [jobStatus] 
     * @param {string | null} [reportCategory] 
     * @param {GetMeetingReportsGroupsReportTypeEnum} [reportType] 
     * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
     * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
     * @param {GetMeetingReportsGroupsGroupByEnum} [groupBy] Dimension each board row represents.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingReportsObservabilityApi
     */
    public getMeetingReportsGroups(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsGroupsSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsGroupsReportTypeEnum, wisprUser?: boolean | null, search?: string | null, groupBy?: GetMeetingReportsGroupsGroupByEnum, options?: RawAxiosRequestConfig) {
        return MeetingReportsObservabilityApiFp(this.configuration).getMeetingReportsGroups(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, groupBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Counters, prior-window comparison, daily severity trend, and filter values.
     * @summary Get Meeting Reports Overview
     * @param {string | null} [startAt] 
     * @param {string | null} [endAt] 
     * @param {GetMeetingReportsOverviewSeverityEnum} [severity] 
     * @param {string | null} [signature] 
     * @param {string | null} [outputDeviceFamily] 
     * @param {string | null} [outputDevice] 
     * @param {string | null} [micDevice] 
     * @param {string | null} [meetingPlatform] 
     * @param {string | null} [appVersion] 
     * @param {string | null} [knownIssue] 
     * @param {string | null} [jobStatus] 
     * @param {string | null} [reportCategory] 
     * @param {GetMeetingReportsOverviewReportTypeEnum} [reportType] 
     * @param {boolean | null} [wisprUser] True keeps reports filed by wispr.ai accounts; false keeps everyone else\&#39;s.
     * @param {string | null} [search] Case-insensitive match over signature, known issue, feedback, triage rationale, devices, platform, and version.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingReportsObservabilityApi
     */
    public getMeetingReportsOverview(startAt?: string | null, endAt?: string | null, severity?: GetMeetingReportsOverviewSeverityEnum, signature?: string | null, outputDeviceFamily?: string | null, outputDevice?: string | null, micDevice?: string | null, meetingPlatform?: string | null, appVersion?: string | null, knownIssue?: string | null, jobStatus?: string | null, reportCategory?: string | null, reportType?: GetMeetingReportsOverviewReportTypeEnum, wisprUser?: boolean | null, search?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingReportsObservabilityApiFp(this.configuration).getMeetingReportsOverview(startAt, endAt, severity, signature, outputDeviceFamily, outputDevice, micDevice, meetingPlatform, appVersion, knownIssue, jobStatus, reportCategory, reportType, wisprUser, search, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMeetingReportsSeverityEnum = {
    S0: 's0',
    S1: 's1',
    S2: 's2',
    S3: 's3'
} as const;
export type GetMeetingReportsSeverityEnum = typeof GetMeetingReportsSeverityEnum[keyof typeof GetMeetingReportsSeverityEnum];
/**
 * @export
 */
export const GetMeetingReportsReportTypeEnum = {
    Meeting: 'meeting',
    Inline: 'inline'
} as const;
export type GetMeetingReportsReportTypeEnum = typeof GetMeetingReportsReportTypeEnum[keyof typeof GetMeetingReportsReportTypeEnum];
/**
 * @export
 */
export const GetMeetingReportsCohortsSeverityEnum = {
    S0: 's0',
    S1: 's1',
    S2: 's2',
    S3: 's3'
} as const;
export type GetMeetingReportsCohortsSeverityEnum = typeof GetMeetingReportsCohortsSeverityEnum[keyof typeof GetMeetingReportsCohortsSeverityEnum];
/**
 * @export
 */
export const GetMeetingReportsCohortsReportTypeEnum = {
    Meeting: 'meeting',
    Inline: 'inline'
} as const;
export type GetMeetingReportsCohortsReportTypeEnum = typeof GetMeetingReportsCohortsReportTypeEnum[keyof typeof GetMeetingReportsCohortsReportTypeEnum];
/**
 * @export
 */
export const GetMeetingReportsGroupsSeverityEnum = {
    S0: 's0',
    S1: 's1',
    S2: 's2',
    S3: 's3'
} as const;
export type GetMeetingReportsGroupsSeverityEnum = typeof GetMeetingReportsGroupsSeverityEnum[keyof typeof GetMeetingReportsGroupsSeverityEnum];
/**
 * @export
 */
export const GetMeetingReportsGroupsReportTypeEnum = {
    Meeting: 'meeting',
    Inline: 'inline'
} as const;
export type GetMeetingReportsGroupsReportTypeEnum = typeof GetMeetingReportsGroupsReportTypeEnum[keyof typeof GetMeetingReportsGroupsReportTypeEnum];
/**
 * @export
 */
export const GetMeetingReportsGroupsGroupByEnum = {
    Signature: 'signature',
    OutputDeviceFamily: 'output_device_family',
    OutputDevice: 'output_device',
    MicDevice: 'mic_device',
    MeetingPlatform: 'meeting_platform',
    AppVersion: 'app_version',
    KnownIssue: 'known_issue',
    JobStatus: 'job_status',
    ReportCategory: 'report_category',
    ReportType: 'report_type',
    Severity: 'severity'
} as const;
export type GetMeetingReportsGroupsGroupByEnum = typeof GetMeetingReportsGroupsGroupByEnum[keyof typeof GetMeetingReportsGroupsGroupByEnum];
/**
 * @export
 */
export const GetMeetingReportsOverviewSeverityEnum = {
    S0: 's0',
    S1: 's1',
    S2: 's2',
    S3: 's3'
} as const;
export type GetMeetingReportsOverviewSeverityEnum = typeof GetMeetingReportsOverviewSeverityEnum[keyof typeof GetMeetingReportsOverviewSeverityEnum];
/**
 * @export
 */
export const GetMeetingReportsOverviewReportTypeEnum = {
    Meeting: 'meeting',
    Inline: 'inline'
} as const;
export type GetMeetingReportsOverviewReportTypeEnum = typeof GetMeetingReportsOverviewReportTypeEnum[keyof typeof GetMeetingReportsOverviewReportTypeEnum];


/**
 * MeetingShareApi - axios parameter creator
 * @export
 */
export const MeetingShareApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Invite one or more recipients to an already-created share in a single call.  Each recipient is processed independently and tallied in the response: an address the owner\'s enterprise policy bars from external sharing is counted under ``not_eligible`` rather than failing the whole request, and a malformed address or self-invite is counted under ``failed``. Operates on an existing share only — returns 404 if the meeting hasn\'t been shared yet (create the link first via PUT /{meeting_id}/share). The response carries the refreshed share state, so no follow-up GET is needed.
         * @summary Add Meeting Share Recipients
         * @param {string} meetingId 
         * @param {AddRecipientsRequest} addRecipientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeetingShareRecipients: async (meetingId: string, addRecipientsRequest: AddRecipientsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('addMeetingShareRecipients', 'meetingId', meetingId)
            // verify required parameter 'addRecipientsRequest' is not null or undefined
            assertParamExists('addMeetingShareRecipients', 'addRecipientsRequest', addRecipientsRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/share/recipients`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRecipientsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hard-delete a recipient by email, revoking their invited access immediately.  (meeting_id, email) is the recipient\'s natural key — the same key add uses — so clients never need a surrogate id round trip.
         * @summary Delete Meeting Share Recipient
         * @param {string} meetingId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeetingShareRecipient: async (meetingId: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('deleteMeetingShareRecipient', 'meetingId', meetingId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('deleteMeetingShareRecipient', 'email', email)
            const localVarPath = `/api/v1/meetings/{meeting_id}/share/recipients/{email}`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return full share state for a meeting the caller owns.  Pure read: returns 404 until sharing has been enabled (POST /{meeting_id}/share). The slug is only ever minted by the dedicated create route, never as a side effect of a read.
         * @summary Get Meeting Share State
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingShareState: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingShareState', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/share`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the refined transcript + speaker map for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike. The transcript is disclosed only to the note owner and explicitly-invited recipients, and only when the owner\'s organization shares transcripts at all; any other admitted caller (domain or link viewer, or an invited recipient of a notes-only org) gets the same 200 ``transcript: null`` body as an absent, unreadable, or retention-erased transcript — the cases are deliberately indistinguishable and the client shows its empty state.
         * @summary Get Shared Meeting Note Transcript
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedMeetingNoteTranscript: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getSharedMeetingNoteTranscript', 'slug', slug)
            const localVarPath = `/api/v1/meetings/shared/{slug}/transcript`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return share state (owner, recipients, visibility, caller role) for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike (no existence leak). Disclosure is least-privilege: recipient emails are shown only to the owner and explicitly-invited recipients — domain and link viewers get an empty ``recipients`` list — and the owner\'s email is null for anonymous callers. Read-only by construction: share mutation stays on the owner-gated /{meeting_id}/share routes.  Args:     slug:  Share slug from the public note URL.     user:  Optionally authenticated caller (``Depends(get_optional_authenticated_user)``).     service: Meeting share service (``Depends(get_meeting_share_service)``).  Returns:     The share state with the caller\'s resolved role.  Raises:     HTTPNotFound: unknown slug or caller has no access (indistinguishable).
         * @summary Get Shared Note Share State
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedNoteShareState: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getSharedNoteShareState', 'slug', slug)
            const localVarPath = `/api/v1/meetings/shared/{slug}/share`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return notes shared with the authenticated caller, plus folder-shared notes when allowed.
         * @summary List Shared Meeting Notes
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedMeetingNotes: async (limit?: number, cursor?: string | null, supportsNameChips?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meetings/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (supportsNameChips !== undefined) {
                localVarQueryParameter['supports_name_chips'] = supportsNameChips;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve a share slug to the note payload.  Auth is optional and Cloud Sync is NOT required: an anyone-with-link note must be viewable by anonymous callers, so the only protection on this path is a per-IP rate limit. When a valid token is present we additionally honor the owner / invited-recipient / domain-match access tiers; anonymous callers can only ever read anyone-with-link notes.  Returns 404 for both unknown slugs and accessible-but-no-access cases to prevent information leakage about share existence.
         * @summary Resolve Shared Meeting Note
         * @param {string} slug 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {boolean} [includeActionItems] Caller shows the recipient action-items tag, so compute &#x60;has_action_items&#x60;. Omit it and the field is always false: the check can wait on a feature-flag lookup, so callers that ignore the field skip it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedMeetingNote: async (slug: string, supportsNameChips?: boolean, includeActionItems?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('resolveSharedMeetingNote', 'slug', slug)
            const localVarPath = `/api/v1/meetings/shared/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (supportsNameChips !== undefined) {
                localVarQueryParameter['supports_name_chips'] = supportsNameChips;
            }

            if (includeActionItems !== undefined) {
                localVarQueryParameter['include_action_items'] = includeActionItems;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Batch-resolve share slugs for the caller; absent slugs are no longer shared.
         * @summary Resolve Shared Meeting Notes Batch
         * @param {SharedNotesBatchRequest} sharedNotesBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedMeetingNotesBatch: async (sharedNotesBatchRequest: SharedNotesBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sharedNotesBatchRequest' is not null or undefined
            assertParamExists('resolveSharedMeetingNotesBatch', 'sharedNotesBatchRequest', sharedNotesBatchRequest)
            const localVarPath = `/api/v1/meetings/shared/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sharedNotesBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update the share for a meeting the caller owns. Idempotent.  The single write entry point for share state: the first call mints the slug with the requested visibility, later calls just update visibility — so \"share publicly\" is one round trip.
         * @summary Upsert Meeting Share
         * @param {string} meetingId 
         * @param {UpsertShareRequest} upsertShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertMeetingShare: async (meetingId: string, upsertShareRequest: UpsertShareRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('upsertMeetingShare', 'meetingId', meetingId)
            // verify required parameter 'upsertShareRequest' is not null or undefined
            assertParamExists('upsertMeetingShare', 'upsertShareRequest', upsertShareRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/share`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertShareRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingShareApi - functional programming interface
 * @export
 */
export const MeetingShareApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingShareApiAxiosParamCreator(configuration)
    return {
        /**
         * Invite one or more recipients to an already-created share in a single call.  Each recipient is processed independently and tallied in the response: an address the owner\'s enterprise policy bars from external sharing is counted under ``not_eligible`` rather than failing the whole request, and a malformed address or self-invite is counted under ``failed``. Operates on an existing share only — returns 404 if the meeting hasn\'t been shared yet (create the link first via PUT /{meeting_id}/share). The response carries the refreshed share state, so no follow-up GET is needed.
         * @summary Add Meeting Share Recipients
         * @param {string} meetingId 
         * @param {AddRecipientsRequest} addRecipientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMeetingShareRecipients(meetingId: string, addRecipientsRequest: AddRecipientsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddRecipientsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMeetingShareRecipients(meetingId, addRecipientsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.addMeetingShareRecipients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hard-delete a recipient by email, revoking their invited access immediately.  (meeting_id, email) is the recipient\'s natural key — the same key add uses — so clients never need a surrogate id round trip.
         * @summary Delete Meeting Share Recipient
         * @param {string} meetingId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeetingShareRecipient(meetingId: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeetingShareRecipient(meetingId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.deleteMeetingShareRecipient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return full share state for a meeting the caller owns.  Pure read: returns 404 until sharing has been enabled (POST /{meeting_id}/share). The slug is only ever minted by the dedicated create route, never as a side effect of a read.
         * @summary Get Meeting Share State
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingShareState(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingShareState(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.getMeetingShareState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the refined transcript + speaker map for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike. The transcript is disclosed only to the note owner and explicitly-invited recipients, and only when the owner\'s organization shares transcripts at all; any other admitted caller (domain or link viewer, or an invited recipient of a notes-only org) gets the same 200 ``transcript: null`` body as an absent, unreadable, or retention-erased transcript — the cases are deliberately indistinguishable and the client shows its empty state.
         * @summary Get Shared Meeting Note Transcript
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedMeetingNoteTranscript(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedNoteTranscriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedMeetingNoteTranscript(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.getSharedMeetingNoteTranscript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return share state (owner, recipients, visibility, caller role) for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike (no existence leak). Disclosure is least-privilege: recipient emails are shown only to the owner and explicitly-invited recipients — domain and link viewers get an empty ``recipients`` list — and the owner\'s email is null for anonymous callers. Read-only by construction: share mutation stays on the owner-gated /{meeting_id}/share routes.  Args:     slug:  Share slug from the public note URL.     user:  Optionally authenticated caller (``Depends(get_optional_authenticated_user)``).     service: Meeting share service (``Depends(get_meeting_share_service)``).  Returns:     The share state with the caller\'s resolved role.  Raises:     HTTPNotFound: unknown slug or caller has no access (indistinguishable).
         * @summary Get Shared Note Share State
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSharedNoteShareState(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedNoteShareStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSharedNoteShareState(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.getSharedNoteShareState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return notes shared with the authenticated caller, plus folder-shared notes when allowed.
         * @summary List Shared Meeting Notes
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSharedMeetingNotes(limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedNoteListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSharedMeetingNotes(limit, cursor, supportsNameChips, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.listSharedMeetingNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve a share slug to the note payload.  Auth is optional and Cloud Sync is NOT required: an anyone-with-link note must be viewable by anonymous callers, so the only protection on this path is a per-IP rate limit. When a valid token is present we additionally honor the owner / invited-recipient / domain-match access tiers; anonymous callers can only ever read anyone-with-link notes.  Returns 404 for both unknown slugs and accessible-but-no-access cases to prevent information leakage about share existence.
         * @summary Resolve Shared Meeting Note
         * @param {string} slug 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {boolean} [includeActionItems] Caller shows the recipient action-items tag, so compute &#x60;has_action_items&#x60;. Omit it and the field is always false: the check can wait on a feature-flag lookup, so callers that ignore the field skip it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveSharedMeetingNote(slug: string, supportsNameChips?: boolean, includeActionItems?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedNoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveSharedMeetingNote(slug, supportsNameChips, includeActionItems, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.resolveSharedMeetingNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Batch-resolve share slugs for the caller; absent slugs are no longer shared.
         * @summary Resolve Shared Meeting Notes Batch
         * @param {SharedNotesBatchRequest} sharedNotesBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveSharedMeetingNotesBatch(sharedNotesBatchRequest: SharedNotesBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedNotesBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveSharedMeetingNotesBatch(sharedNotesBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.resolveSharedMeetingNotesBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update the share for a meeting the caller owns. Idempotent.  The single write entry point for share state: the first call mints the slug with the requested visibility, later calls just update visibility — so \"share publicly\" is one round trip.
         * @summary Upsert Meeting Share
         * @param {string} meetingId 
         * @param {UpsertShareRequest} upsertShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertMeetingShare(meetingId: string, upsertShareRequest: UpsertShareRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShareStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertMeetingShare(meetingId, upsertShareRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingShareApi.upsertMeetingShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingShareApi - factory interface
 * @export
 */
export const MeetingShareApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingShareApiFp(configuration)
    return {
        /**
         * Invite one or more recipients to an already-created share in a single call.  Each recipient is processed independently and tallied in the response: an address the owner\'s enterprise policy bars from external sharing is counted under ``not_eligible`` rather than failing the whole request, and a malformed address or self-invite is counted under ``failed``. Operates on an existing share only — returns 404 if the meeting hasn\'t been shared yet (create the link first via PUT /{meeting_id}/share). The response carries the refreshed share state, so no follow-up GET is needed.
         * @summary Add Meeting Share Recipients
         * @param {string} meetingId 
         * @param {AddRecipientsRequest} addRecipientsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeetingShareRecipients(meetingId: string, addRecipientsRequest: AddRecipientsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AddRecipientsResponse> {
            return localVarFp.addMeetingShareRecipients(meetingId, addRecipientsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Hard-delete a recipient by email, revoking their invited access immediately.  (meeting_id, email) is the recipient\'s natural key — the same key add uses — so clients never need a surrogate id round trip.
         * @summary Delete Meeting Share Recipient
         * @param {string} meetingId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeetingShareRecipient(meetingId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMeetingShareRecipient(meetingId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Return full share state for a meeting the caller owns.  Pure read: returns 404 until sharing has been enabled (POST /{meeting_id}/share). The slug is only ever minted by the dedicated create route, never as a side effect of a read.
         * @summary Get Meeting Share State
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingShareState(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<ShareStateResponse> {
            return localVarFp.getMeetingShareState(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the refined transcript + speaker map for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike. The transcript is disclosed only to the note owner and explicitly-invited recipients, and only when the owner\'s organization shares transcripts at all; any other admitted caller (domain or link viewer, or an invited recipient of a notes-only org) gets the same 200 ``transcript: null`` body as an absent, unreadable, or retention-erased transcript — the cases are deliberately indistinguishable and the client shows its empty state.
         * @summary Get Shared Meeting Note Transcript
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedMeetingNoteTranscript(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<SharedNoteTranscriptResponse> {
            return localVarFp.getSharedMeetingNoteTranscript(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Return share state (owner, recipients, visibility, caller role) for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike (no existence leak). Disclosure is least-privilege: recipient emails are shown only to the owner and explicitly-invited recipients — domain and link viewers get an empty ``recipients`` list — and the owner\'s email is null for anonymous callers. Read-only by construction: share mutation stays on the owner-gated /{meeting_id}/share routes.  Args:     slug:  Share slug from the public note URL.     user:  Optionally authenticated caller (``Depends(get_optional_authenticated_user)``).     service: Meeting share service (``Depends(get_meeting_share_service)``).  Returns:     The share state with the caller\'s resolved role.  Raises:     HTTPNotFound: unknown slug or caller has no access (indistinguishable).
         * @summary Get Shared Note Share State
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedNoteShareState(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<SharedNoteShareStateResponse> {
            return localVarFp.getSharedNoteShareState(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Return notes shared with the authenticated caller, plus folder-shared notes when allowed.
         * @summary List Shared Meeting Notes
         * @param {number} [limit] 
         * @param {string | null} [cursor] 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSharedMeetingNotes(limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SharedNoteListResponse> {
            return localVarFp.listSharedMeetingNotes(limit, cursor, supportsNameChips, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve a share slug to the note payload.  Auth is optional and Cloud Sync is NOT required: an anyone-with-link note must be viewable by anonymous callers, so the only protection on this path is a per-IP rate limit. When a valid token is present we additionally honor the owner / invited-recipient / domain-match access tiers; anonymous callers can only ever read anyone-with-link notes.  Returns 404 for both unknown slugs and accessible-but-no-access cases to prevent information leakage about share existence.
         * @summary Resolve Shared Meeting Note
         * @param {string} slug 
         * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
         * @param {boolean} [includeActionItems] Caller shows the recipient action-items tag, so compute &#x60;has_action_items&#x60;. Omit it and the field is always false: the check can wait on a feature-flag lookup, so callers that ignore the field skip it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedMeetingNote(slug: string, supportsNameChips?: boolean, includeActionItems?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SharedNoteResponse> {
            return localVarFp.resolveSharedMeetingNote(slug, supportsNameChips, includeActionItems, options).then((request) => request(axios, basePath));
        },
        /**
         * Batch-resolve share slugs for the caller; absent slugs are no longer shared.
         * @summary Resolve Shared Meeting Notes Batch
         * @param {SharedNotesBatchRequest} sharedNotesBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedMeetingNotesBatch(sharedNotesBatchRequest: SharedNotesBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<SharedNotesBatchResponse> {
            return localVarFp.resolveSharedMeetingNotesBatch(sharedNotesBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update the share for a meeting the caller owns. Idempotent.  The single write entry point for share state: the first call mints the slug with the requested visibility, later calls just update visibility — so \"share publicly\" is one round trip.
         * @summary Upsert Meeting Share
         * @param {string} meetingId 
         * @param {UpsertShareRequest} upsertShareRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertMeetingShare(meetingId: string, upsertShareRequest: UpsertShareRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShareStateResponse> {
            return localVarFp.upsertMeetingShare(meetingId, upsertShareRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingShareApi - object-oriented interface
 * @export
 * @class MeetingShareApi
 * @extends {BaseAPI}
 */
export class MeetingShareApi extends BaseAPI {
    /**
     * Invite one or more recipients to an already-created share in a single call.  Each recipient is processed independently and tallied in the response: an address the owner\'s enterprise policy bars from external sharing is counted under ``not_eligible`` rather than failing the whole request, and a malformed address or self-invite is counted under ``failed``. Operates on an existing share only — returns 404 if the meeting hasn\'t been shared yet (create the link first via PUT /{meeting_id}/share). The response carries the refreshed share state, so no follow-up GET is needed.
     * @summary Add Meeting Share Recipients
     * @param {string} meetingId 
     * @param {AddRecipientsRequest} addRecipientsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public addMeetingShareRecipients(meetingId: string, addRecipientsRequest: AddRecipientsRequest, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).addMeetingShareRecipients(meetingId, addRecipientsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hard-delete a recipient by email, revoking their invited access immediately.  (meeting_id, email) is the recipient\'s natural key — the same key add uses — so clients never need a surrogate id round trip.
     * @summary Delete Meeting Share Recipient
     * @param {string} meetingId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public deleteMeetingShareRecipient(meetingId: string, email: string, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).deleteMeetingShareRecipient(meetingId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return full share state for a meeting the caller owns.  Pure read: returns 404 until sharing has been enabled (POST /{meeting_id}/share). The slug is only ever minted by the dedicated create route, never as a side effect of a read.
     * @summary Get Meeting Share State
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public getMeetingShareState(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).getMeetingShareState(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the refined transcript + speaker map for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike. The transcript is disclosed only to the note owner and explicitly-invited recipients, and only when the owner\'s organization shares transcripts at all; any other admitted caller (domain or link viewer, or an invited recipient of a notes-only org) gets the same 200 ``transcript: null`` body as an absent, unreadable, or retention-erased transcript — the cases are deliberately indistinguishable and the client shows its empty state.
     * @summary Get Shared Meeting Note Transcript
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public getSharedMeetingNoteTranscript(slug: string, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).getSharedMeetingNoteTranscript(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return share state (owner, recipients, visibility, caller role) for a shared note.  Same access model as resolving the note itself: auth optional, no Cloud Sync gate, per-IP rate limit, and 404 for unknown slug and no-access alike (no existence leak). Disclosure is least-privilege: recipient emails are shown only to the owner and explicitly-invited recipients — domain and link viewers get an empty ``recipients`` list — and the owner\'s email is null for anonymous callers. Read-only by construction: share mutation stays on the owner-gated /{meeting_id}/share routes.  Args:     slug:  Share slug from the public note URL.     user:  Optionally authenticated caller (``Depends(get_optional_authenticated_user)``).     service: Meeting share service (``Depends(get_meeting_share_service)``).  Returns:     The share state with the caller\'s resolved role.  Raises:     HTTPNotFound: unknown slug or caller has no access (indistinguishable).
     * @summary Get Shared Note Share State
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public getSharedNoteShareState(slug: string, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).getSharedNoteShareState(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return notes shared with the authenticated caller, plus folder-shared notes when allowed.
     * @summary List Shared Meeting Notes
     * @param {number} [limit] 
     * @param {string | null} [cursor] 
     * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public listSharedMeetingNotes(limit?: number, cursor?: string | null, supportsNameChips?: boolean, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).listSharedMeetingNotes(limit, cursor, supportsNameChips, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve a share slug to the note payload.  Auth is optional and Cloud Sync is NOT required: an anyone-with-link note must be viewable by anonymous callers, so the only protection on this path is a per-IP rate limit. When a valid token is present we additionally honor the owner / invited-recipient / domain-match access tiers; anonymous callers can only ever read anyone-with-link notes.  Returns 404 for both unknown slugs and accessible-but-no-access cases to prevent information leakage about share existence.
     * @summary Resolve Shared Meeting Note
     * @param {string} slug 
     * @param {boolean} [supportsNameChips] Caller renders &lt;wispr_name_chip&gt; tokens. Omit it to receive speaker names as plain text; a client without the renderer would show the raw token.
     * @param {boolean} [includeActionItems] Caller shows the recipient action-items tag, so compute &#x60;has_action_items&#x60;. Omit it and the field is always false: the check can wait on a feature-flag lookup, so callers that ignore the field skip it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public resolveSharedMeetingNote(slug: string, supportsNameChips?: boolean, includeActionItems?: boolean, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).resolveSharedMeetingNote(slug, supportsNameChips, includeActionItems, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Batch-resolve share slugs for the caller; absent slugs are no longer shared.
     * @summary Resolve Shared Meeting Notes Batch
     * @param {SharedNotesBatchRequest} sharedNotesBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public resolveSharedMeetingNotesBatch(sharedNotesBatchRequest: SharedNotesBatchRequest, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).resolveSharedMeetingNotesBatch(sharedNotesBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update the share for a meeting the caller owns. Idempotent.  The single write entry point for share state: the first call mints the slug with the requested visibility, later calls just update visibility — so \"share publicly\" is one round trip.
     * @summary Upsert Meeting Share
     * @param {string} meetingId 
     * @param {UpsertShareRequest} upsertShareRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingShareApi
     */
    public upsertMeetingShare(meetingId: string, upsertShareRequest: UpsertShareRequest, options?: RawAxiosRequestConfig) {
        return MeetingShareApiFp(this.configuration).upsertMeetingShare(meetingId, upsertShareRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingSummaryFeedbackApi - axios parameter creator
 * @export
 */
export const MeetingSummaryFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Rate a meeting\'s summary 👍/👎 with an optional note.  Idempotent on ``id``: resending the same submission returns 204 without writing again.  Args:     meeting_id: Meeting whose summary is rated.     body:       The rating, optional note, and client-generated submission id.     user:       Authenticated caller (injected).     db:         Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         403: Notetaker is not allowed for this user.         404: The meeting is missing, deleted, or not the caller\'s.         409: The meeting has no summary, or the id belongs to a different submission.
         * @summary Submit Summary Feedback
         * @param {string} meetingId 
         * @param {MeetingSummaryFeedbackRequest} meetingSummaryFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSummaryFeedback: async (meetingId: string, meetingSummaryFeedbackRequest: MeetingSummaryFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('submitSummaryFeedback', 'meetingId', meetingId)
            // verify required parameter 'meetingSummaryFeedbackRequest' is not null or undefined
            assertParamExists('submitSummaryFeedback', 'meetingSummaryFeedbackRequest', meetingSummaryFeedbackRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/summary-feedback`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingSummaryFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Withdraw a summary rating and drop its note, summary snapshot and audio pointer.  Repeating the call is a no-op that keeps the first withdrawal time.  Args:     meeting_id:  Meeting the rating belongs to.     feedback_id: Id of the submission to withdraw.     user:        Authenticated caller (injected).     db:          Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         404: No submission with this id for the caller on this meeting.
         * @summary Withdraw Summary Feedback
         * @param {string} meetingId 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawSummaryFeedback: async (meetingId: string, feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('withdrawSummaryFeedback', 'meetingId', meetingId)
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('withdrawSummaryFeedback', 'feedbackId', feedbackId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/summary-feedback/{feedback_id}`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)))
                .replace(`{${"feedback_id"}}`, encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingSummaryFeedbackApi - functional programming interface
 * @export
 */
export const MeetingSummaryFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingSummaryFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * Rate a meeting\'s summary 👍/👎 with an optional note.  Idempotent on ``id``: resending the same submission returns 204 without writing again.  Args:     meeting_id: Meeting whose summary is rated.     body:       The rating, optional note, and client-generated submission id.     user:       Authenticated caller (injected).     db:         Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         403: Notetaker is not allowed for this user.         404: The meeting is missing, deleted, or not the caller\'s.         409: The meeting has no summary, or the id belongs to a different submission.
         * @summary Submit Summary Feedback
         * @param {string} meetingId 
         * @param {MeetingSummaryFeedbackRequest} meetingSummaryFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitSummaryFeedback(meetingId: string, meetingSummaryFeedbackRequest: MeetingSummaryFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitSummaryFeedback(meetingId, meetingSummaryFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackApi.submitSummaryFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Withdraw a summary rating and drop its note, summary snapshot and audio pointer.  Repeating the call is a no-op that keeps the first withdrawal time.  Args:     meeting_id:  Meeting the rating belongs to.     feedback_id: Id of the submission to withdraw.     user:        Authenticated caller (injected).     db:          Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         404: No submission with this id for the caller on this meeting.
         * @summary Withdraw Summary Feedback
         * @param {string} meetingId 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawSummaryFeedback(meetingId: string, feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawSummaryFeedback(meetingId, feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackApi.withdrawSummaryFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingSummaryFeedbackApi - factory interface
 * @export
 */
export const MeetingSummaryFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingSummaryFeedbackApiFp(configuration)
    return {
        /**
         * Rate a meeting\'s summary 👍/👎 with an optional note.  Idempotent on ``id``: resending the same submission returns 204 without writing again.  Args:     meeting_id: Meeting whose summary is rated.     body:       The rating, optional note, and client-generated submission id.     user:       Authenticated caller (injected).     db:         Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         403: Notetaker is not allowed for this user.         404: The meeting is missing, deleted, or not the caller\'s.         409: The meeting has no summary, or the id belongs to a different submission.
         * @summary Submit Summary Feedback
         * @param {string} meetingId 
         * @param {MeetingSummaryFeedbackRequest} meetingSummaryFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSummaryFeedback(meetingId: string, meetingSummaryFeedbackRequest: MeetingSummaryFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitSummaryFeedback(meetingId, meetingSummaryFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Withdraw a summary rating and drop its note, summary snapshot and audio pointer.  Repeating the call is a no-op that keeps the first withdrawal time.  Args:     meeting_id:  Meeting the rating belongs to.     feedback_id: Id of the submission to withdraw.     user:        Authenticated caller (injected).     db:          Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         404: No submission with this id for the caller on this meeting.
         * @summary Withdraw Summary Feedback
         * @param {string} meetingId 
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawSummaryFeedback(meetingId: string, feedbackId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.withdrawSummaryFeedback(meetingId, feedbackId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingSummaryFeedbackApi - object-oriented interface
 * @export
 * @class MeetingSummaryFeedbackApi
 * @extends {BaseAPI}
 */
export class MeetingSummaryFeedbackApi extends BaseAPI {
    /**
     * Rate a meeting\'s summary 👍/👎 with an optional note.  Idempotent on ``id``: resending the same submission returns 204 without writing again.  Args:     meeting_id: Meeting whose summary is rated.     body:       The rating, optional note, and client-generated submission id.     user:       Authenticated caller (injected).     db:         Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         403: Notetaker is not allowed for this user.         404: The meeting is missing, deleted, or not the caller\'s.         409: The meeting has no summary, or the id belongs to a different submission.
     * @summary Submit Summary Feedback
     * @param {string} meetingId 
     * @param {MeetingSummaryFeedbackRequest} meetingSummaryFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackApi
     */
    public submitSummaryFeedback(meetingId: string, meetingSummaryFeedbackRequest: MeetingSummaryFeedbackRequest, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackApiFp(this.configuration).submitSummaryFeedback(meetingId, meetingSummaryFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Withdraw a summary rating and drop its note, summary snapshot and audio pointer.  Repeating the call is a no-op that keeps the first withdrawal time.  Args:     meeting_id:  Meeting the rating belongs to.     feedback_id: Id of the submission to withdraw.     user:        Authenticated caller (injected).     db:          Database executor (injected).  Returns:     An empty 204 response.  Raises:     HTTPException:         404: No submission with this id for the caller on this meeting.
     * @summary Withdraw Summary Feedback
     * @param {string} meetingId 
     * @param {string} feedbackId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackApi
     */
    public withdrawSummaryFeedback(meetingId: string, feedbackId: string, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackApiFp(this.configuration).withdrawSummaryFeedback(meetingId, feedbackId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MeetingSummaryFeedbackAdminApi - axios parameter creator
 * @export
 */
export const MeetingSummaryFeedbackAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Presign the rated meeting\'s audio for at most 15 minutes. Every attempt is audited.  Args:     feedback_id: Id of the rating whose audio to play.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The presigned URL and when it stops working.
         * @summary Create Summary Feedback Audio Url
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryFeedbackAudioUrl: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('createSummaryFeedbackAudioUrl', 'feedbackId', feedbackId)
            const localVarPath = `/api/v1/internal/meeting-summary-feedback/{feedback_id}/audio-url`
                .replace(`{${"feedback_id"}}`, encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One summary rating with its snapshot, provenance, and audio status. Every read is audited.  Args:     feedback_id: Id of the rating.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The rating; the summary body is null whenever consent or a deletion withholds it.
         * @summary Get Summary Feedback Admin Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFeedbackAdminDetail: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('getSummaryFeedbackAdminDetail', 'feedbackId', feedbackId)
            const localVarPath = `/api/v1/internal/meeting-summary-feedback/{feedback_id}`
                .replace(`{${"feedback_id"}}`, encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 👍/👎 rates from each user\'s latest unwithdrawn rating per meeting. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trend; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only summaries written by this prompt hash, when set; ``byVersion`` ignores it.     summary_model:  Count only summaries written by this model, when set; ``byVersion`` ignores it.     user:           Authenticated internal admin (injected).  Returns:     Overall, per-bucket, per-prompt-version and per-version counts.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Feedback Admin Stats
         * @param {string} since Count pairs last rated at or after this time.
         * @param {string} until Count pairs last rated before this time.
         * @param {GetSummaryFeedbackAdminStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFeedbackAdminStats: async (since: string, until: string, bucket?: GetSummaryFeedbackAdminStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'since' is not null or undefined
            assertParamExists('getSummaryFeedbackAdminStats', 'since', since)
            // verify required parameter 'until' is not null or undefined
            assertParamExists('getSummaryFeedbackAdminStats', 'until', until)
            const localVarPath = `/api/v1/internal/meeting-summary-feedback/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (promptVersion !== undefined) {
                localVarQueryParameter['promptVersion'] = promptVersion;
            }

            if (summaryModel !== undefined) {
                localVarQueryParameter['summaryModel'] = summaryModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Summary ratings newest first, without the summary, audio, or hashes. Every page is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     rating:         Only ratings of this kind, when set.     prompt_version: Only ratings of summaries written by this prompt hash, when set.     summary_model:  Only ratings of summaries written by this model, when set.     since:          Only ratings created at or after this time, when set.     until:          Only ratings created before this time, when set.     limit:          Page size.     cursor:         Continuation from the previous page\'s ``nextCursor``.     user:           Authenticated internal admin (injected).  Returns:     One page of ratings and the cursor for the next, if any.  Raises:     HTTPException: 422 when ``since`` is not before ``until``.
         * @summary List Summary Feedback Admin
         * @param {SummaryFeedbackRating | null} [rating] 
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {string | null} [since] Only ratings created at or after this time, with a UTC offset.
         * @param {string | null} [until] Only ratings created before this time, with a UTC offset.
         * @param {number} [limit] 
         * @param {string | null} [cursor] &#x60;nextCursor&#x60; from the previous page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSummaryFeedbackAdmin: async (rating?: SummaryFeedbackRating | null, promptVersion?: string | null, summaryModel?: string | null, since?: string | null, until?: string | null, limit?: number, cursor?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/meeting-summary-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            if (promptVersion !== undefined) {
                localVarQueryParameter['promptVersion'] = promptVersion;
            }

            if (summaryModel !== undefined) {
                localVarQueryParameter['summaryModel'] = summaryModel;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingSummaryFeedbackAdminApi - functional programming interface
 * @export
 */
export const MeetingSummaryFeedbackAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingSummaryFeedbackAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Presign the rated meeting\'s audio for at most 15 minutes. Every attempt is audited.  Args:     feedback_id: Id of the rating whose audio to play.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The presigned URL and when it stops working.
         * @summary Create Summary Feedback Audio Url
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSummaryFeedbackAudioUrl(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryFeedbackAdminAudioUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSummaryFeedbackAudioUrl(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackAdminApi.createSummaryFeedbackAudioUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One summary rating with its snapshot, provenance, and audio status. Every read is audited.  Args:     feedback_id: Id of the rating.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The rating; the summary body is null whenever consent or a deletion withholds it.
         * @summary Get Summary Feedback Admin Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryFeedbackAdminDetail(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryFeedbackAdminDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryFeedbackAdminDetail(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackAdminApi.getSummaryFeedbackAdminDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 👍/👎 rates from each user\'s latest unwithdrawn rating per meeting. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trend; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only summaries written by this prompt hash, when set; ``byVersion`` ignores it.     summary_model:  Count only summaries written by this model, when set; ``byVersion`` ignores it.     user:           Authenticated internal admin (injected).  Returns:     Overall, per-bucket, per-prompt-version and per-version counts.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Feedback Admin Stats
         * @param {string} since Count pairs last rated at or after this time.
         * @param {string} until Count pairs last rated before this time.
         * @param {GetSummaryFeedbackAdminStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryFeedbackAdminStats(since: string, until: string, bucket?: GetSummaryFeedbackAdminStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryFeedbackAdminStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryFeedbackAdminStats(since, until, bucket, promptVersion, summaryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackAdminApi.getSummaryFeedbackAdminStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Summary ratings newest first, without the summary, audio, or hashes. Every page is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     rating:         Only ratings of this kind, when set.     prompt_version: Only ratings of summaries written by this prompt hash, when set.     summary_model:  Only ratings of summaries written by this model, when set.     since:          Only ratings created at or after this time, when set.     until:          Only ratings created before this time, when set.     limit:          Page size.     cursor:         Continuation from the previous page\'s ``nextCursor``.     user:           Authenticated internal admin (injected).  Returns:     One page of ratings and the cursor for the next, if any.  Raises:     HTTPException: 422 when ``since`` is not before ``until``.
         * @summary List Summary Feedback Admin
         * @param {SummaryFeedbackRating | null} [rating] 
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {string | null} [since] Only ratings created at or after this time, with a UTC offset.
         * @param {string | null} [until] Only ratings created before this time, with a UTC offset.
         * @param {number} [limit] 
         * @param {string | null} [cursor] &#x60;nextCursor&#x60; from the previous page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSummaryFeedbackAdmin(rating?: SummaryFeedbackRating | null, promptVersion?: string | null, summaryModel?: string | null, since?: string | null, until?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryFeedbackAdminList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSummaryFeedbackAdmin(rating, promptVersion, summaryModel, since, until, limit, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingSummaryFeedbackAdminApi.listSummaryFeedbackAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingSummaryFeedbackAdminApi - factory interface
 * @export
 */
export const MeetingSummaryFeedbackAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingSummaryFeedbackAdminApiFp(configuration)
    return {
        /**
         * Presign the rated meeting\'s audio for at most 15 minutes. Every attempt is audited.  Args:     feedback_id: Id of the rating whose audio to play.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The presigned URL and when it stops working.
         * @summary Create Summary Feedback Audio Url
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryFeedbackAudioUrl(feedbackId: string, options?: RawAxiosRequestConfig): AxiosPromise<SummaryFeedbackAdminAudioUrl> {
            return localVarFp.createSummaryFeedbackAudioUrl(feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * One summary rating with its snapshot, provenance, and audio status. Every read is audited.  Args:     feedback_id: Id of the rating.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The rating; the summary body is null whenever consent or a deletion withholds it.
         * @summary Get Summary Feedback Admin Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFeedbackAdminDetail(feedbackId: string, options?: RawAxiosRequestConfig): AxiosPromise<SummaryFeedbackAdminDetail> {
            return localVarFp.getSummaryFeedbackAdminDetail(feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * 👍/👎 rates from each user\'s latest unwithdrawn rating per meeting. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trend; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only summaries written by this prompt hash, when set; ``byVersion`` ignores it.     summary_model:  Count only summaries written by this model, when set; ``byVersion`` ignores it.     user:           Authenticated internal admin (injected).  Returns:     Overall, per-bucket, per-prompt-version and per-version counts.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Feedback Admin Stats
         * @param {string} since Count pairs last rated at or after this time.
         * @param {string} until Count pairs last rated before this time.
         * @param {GetSummaryFeedbackAdminStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFeedbackAdminStats(since: string, until: string, bucket?: GetSummaryFeedbackAdminStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SummaryFeedbackAdminStats> {
            return localVarFp.getSummaryFeedbackAdminStats(since, until, bucket, promptVersion, summaryModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Summary ratings newest first, without the summary, audio, or hashes. Every page is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     rating:         Only ratings of this kind, when set.     prompt_version: Only ratings of summaries written by this prompt hash, when set.     summary_model:  Only ratings of summaries written by this model, when set.     since:          Only ratings created at or after this time, when set.     until:          Only ratings created before this time, when set.     limit:          Page size.     cursor:         Continuation from the previous page\'s ``nextCursor``.     user:           Authenticated internal admin (injected).  Returns:     One page of ratings and the cursor for the next, if any.  Raises:     HTTPException: 422 when ``since`` is not before ``until``.
         * @summary List Summary Feedback Admin
         * @param {SummaryFeedbackRating | null} [rating] 
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote the summary.
         * @param {string | null} [since] Only ratings created at or after this time, with a UTC offset.
         * @param {string | null} [until] Only ratings created before this time, with a UTC offset.
         * @param {number} [limit] 
         * @param {string | null} [cursor] &#x60;nextCursor&#x60; from the previous page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSummaryFeedbackAdmin(rating?: SummaryFeedbackRating | null, promptVersion?: string | null, summaryModel?: string | null, since?: string | null, until?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SummaryFeedbackAdminList> {
            return localVarFp.listSummaryFeedbackAdmin(rating, promptVersion, summaryModel, since, until, limit, cursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingSummaryFeedbackAdminApi - object-oriented interface
 * @export
 * @class MeetingSummaryFeedbackAdminApi
 * @extends {BaseAPI}
 */
export class MeetingSummaryFeedbackAdminApi extends BaseAPI {
    /**
     * Presign the rated meeting\'s audio for at most 15 minutes. Every attempt is audited.  Args:     feedback_id: Id of the rating whose audio to play.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The presigned URL and when it stops working.
     * @summary Create Summary Feedback Audio Url
     * @param {string} feedbackId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackAdminApi
     */
    public createSummaryFeedbackAudioUrl(feedbackId: string, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackAdminApiFp(this.configuration).createSummaryFeedbackAudioUrl(feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One summary rating with its snapshot, provenance, and audio status. Every read is audited.  Args:     feedback_id: Id of the rating.     request:     Incoming request, checked for impersonation.     response:    Outgoing response, marked ``no-store``.     user:        Authenticated internal admin (injected).  Returns:     The rating; the summary body is null whenever consent or a deletion withholds it.
     * @summary Get Summary Feedback Admin Detail
     * @param {string} feedbackId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackAdminApi
     */
    public getSummaryFeedbackAdminDetail(feedbackId: string, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackAdminApiFp(this.configuration).getSummaryFeedbackAdminDetail(feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 👍/👎 rates from each user\'s latest unwithdrawn rating per meeting. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trend; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only summaries written by this prompt hash, when set; ``byVersion`` ignores it.     summary_model:  Count only summaries written by this model, when set; ``byVersion`` ignores it.     user:           Authenticated internal admin (injected).  Returns:     Overall, per-bucket, per-prompt-version and per-version counts.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
     * @summary Get Summary Feedback Admin Stats
     * @param {string} since Count pairs last rated at or after this time.
     * @param {string} until Count pairs last rated before this time.
     * @param {GetSummaryFeedbackAdminStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
     * @param {string | null} [promptVersion] 12-hex summary prompt hash.
     * @param {string | null} [summaryModel] Exact model that wrote the summary.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackAdminApi
     */
    public getSummaryFeedbackAdminStats(since: string, until: string, bucket?: GetSummaryFeedbackAdminStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackAdminApiFp(this.configuration).getSummaryFeedbackAdminStats(since, until, bucket, promptVersion, summaryModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Summary ratings newest first, without the summary, audio, or hashes. Every page is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     rating:         Only ratings of this kind, when set.     prompt_version: Only ratings of summaries written by this prompt hash, when set.     summary_model:  Only ratings of summaries written by this model, when set.     since:          Only ratings created at or after this time, when set.     until:          Only ratings created before this time, when set.     limit:          Page size.     cursor:         Continuation from the previous page\'s ``nextCursor``.     user:           Authenticated internal admin (injected).  Returns:     One page of ratings and the cursor for the next, if any.  Raises:     HTTPException: 422 when ``since`` is not before ``until``.
     * @summary List Summary Feedback Admin
     * @param {SummaryFeedbackRating | null} [rating] 
     * @param {string | null} [promptVersion] 12-hex summary prompt hash.
     * @param {string | null} [summaryModel] Exact model that wrote the summary.
     * @param {string | null} [since] Only ratings created at or after this time, with a UTC offset.
     * @param {string | null} [until] Only ratings created before this time, with a UTC offset.
     * @param {number} [limit] 
     * @param {string | null} [cursor] &#x60;nextCursor&#x60; from the previous page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingSummaryFeedbackAdminApi
     */
    public listSummaryFeedbackAdmin(rating?: SummaryFeedbackRating | null, promptVersion?: string | null, summaryModel?: string | null, since?: string | null, until?: string | null, limit?: number, cursor?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingSummaryFeedbackAdminApiFp(this.configuration).listSummaryFeedbackAdmin(rating, promptVersion, summaryModel, since, until, limit, cursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetSummaryFeedbackAdminStatsBucketEnum = {
    Day: 'day',
    Week: 'week'
} as const;
export type GetSummaryFeedbackAdminStatsBucketEnum = typeof GetSummaryFeedbackAdminStatsBucketEnum[keyof typeof GetSummaryFeedbackAdminStatsBucketEnum];


/**
 * MeetingsApi - axios parameter creator
 * @export
 */
export const MeetingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign one refined meeting speaker to an owner-scoped contact.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose speaker map should change.     body:       Refined speaker id and selected contact id.     user:       Authenticated owner used to scope both resources.     db:         Main Postgres executor used to enforce Notetaker eligibility.     service:    Atomic speaker-contact assignment service.  Returns:     The authoritative speaker map after assignment.  Raises:     HTTPNotFound: The meeting or contact is not visible to the authenticated owner.     HTTPConflict: The stored speaker map cannot safely accept the assignment.     HTTPUnprocessableEntity: The selected contact has no usable display name.
         * @summary Assign Speaker Contact
         * @param {string} meetingId 
         * @param {MeetingSpeakerContactAssignmentRequest} meetingSpeakerContactAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSpeakerContact: async (meetingId: string, meetingSpeakerContactAssignmentRequest: MeetingSpeakerContactAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('assignSpeakerContact', 'meetingId', meetingId)
            // verify required parameter 'meetingSpeakerContactAssignmentRequest' is not null or undefined
            assertParamExists('assignSpeakerContact', 'meetingSpeakerContactAssignmentRequest', meetingSpeakerContactAssignmentRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/speaker-contact`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingSpeakerContactAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clear the summary-model-comparison candidate after the owner voted on it.  Nulls ``candidate_summary``/``candidate_summary_metadata`` and bumps the sync stamp so the next pull delivers the row without the candidate. ``summary`` is untouched. The optional vote is stored on the captured comparison; older clients send none, and an unrecognized value is stored as NULL rather than blocking the clear. Idempotent: 204 whether or not a candidate was present; 404 for unknown/deleted meetings and meetings owned by another user.
         * @summary Clear Candidate Summary
         * @param {string} meetingId 
         * @param {string | null} [outcome] The owner\&#39;s vote; unknown values store NULL.
         * @param {string | null} [candidatePosition] 1 or 2: the card the candidate was shown in; others store NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearCandidateSummary: async (meetingId: string, outcome?: string | null, candidatePosition?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('clearCandidateSummary', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/candidate-summary`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (candidatePosition !== undefined) {
                localVarQueryParameter['candidate_position'] = candidatePosition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s live-transcript NDJSON.  Sibling to :func:`create_speaker_observations_upload_url`: the desktop PUTs ``live.ndjson`` directly to S3 instead of inlining it in the sync body. Same no-job-side-effects contract — it never touches ``meeting_refine_jobs``. The key is server-composed via :func:`live_ndjson_key`, never derived from client input.  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`LIVE_TRANSCRIPT_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Live Transcript Upload Url
         * @param {string} meetingId 
         * @param {LiveTranscriptUploadUrlRequest} liveTranscriptUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiveTranscriptUploadUrl: async (meetingId: string, liveTranscriptUploadUrlRequest: LiveTranscriptUploadUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('createLiveTranscriptUploadUrl', 'meetingId', meetingId)
            // verify required parameter 'liveTranscriptUploadUrlRequest' is not null or undefined
            assertParamExists('createLiveTranscriptUploadUrl', 'liveTranscriptUploadUrlRequest', liveTranscriptUploadUrlRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/live-transcript/upload-url`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(liveTranscriptUploadUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Suggest at most one of the caller\'s shared folders for their meeting in progress; nothing is stored.  Every outcome after admission is a 200, and `suggestion` is `null` unless a shared folder clearly fits. The client shows a non-null suggestion once; after a `null` it asks again only at its next periodic check.
         * @summary Create Meeting Folder Suggestion
         * @param {string} meetingId 
         * @param {MeetingFolderSuggestionRequest} meetingFolderSuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingFolderSuggestion: async (meetingId: string, meetingFolderSuggestionRequest: MeetingFolderSuggestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('createMeetingFolderSuggestion', 'meetingId', meetingId)
            // verify required parameter 'meetingFolderSuggestionRequest' is not null or undefined
            assertParamExists('createMeetingFolderSuggestion', 'meetingFolderSuggestionRequest', meetingFolderSuggestionRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/folder-suggestion`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingFolderSuggestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Summarize the caller\'s live transcript with a fast model, or a fallback model if it fails; nothing is stored.  Every generation outcome is a 200: `ok` carries `summary_markdown`, `too_short` means the transcript is under the summary word floor, and `unavailable` means no quick summary could be made this time. The client shows no quick summary for the last two and never retries.
         * @summary Create Meeting Quick Summary
         * @param {string} meetingId 
         * @param {MeetingQuickSummaryRequest} meetingQuickSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingQuickSummary: async (meetingId: string, meetingQuickSummaryRequest: MeetingQuickSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('createMeetingQuickSummary', 'meetingId', meetingId)
            // verify required parameter 'meetingQuickSummaryRequest' is not null or undefined
            assertParamExists('createMeetingQuickSummary', 'meetingQuickSummaryRequest', meetingQuickSummaryRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/quick-summary`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingQuickSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Seal a job\'s complete audio snapshot and renew delivery for identical retries.
         * @summary Create Meeting Upload Url
         * @param {string} meetingId 
         * @param {MeetingUploadUrlRequest} meetingUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingUploadUrl: async (meetingId: string, meetingUploadUrlRequest: MeetingUploadUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('createMeetingUploadUrl', 'meetingId', meetingId)
            // verify required parameter 'meetingUploadUrlRequest' is not null or undefined
            assertParamExists('createMeetingUploadUrl', 'meetingUploadUrlRequest', meetingUploadUrlRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/upload-url`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingUploadUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s speaker-observation log.  Sibling to :func:`create_meeting_upload_url` but with no job side effects: it never touches ``meeting_refine_jobs`` (the audio route\'s upsert revives failed/abandoned jobs and clobbers the audio key — a stuck observation artifact must not delay or disturb the transcript). The key is server-composed via :func:`speaker_observations_key`, never derived from client input. The client PUTs the artifact directly to S3; Phase-1 transcript persistence reads it from S3 on demand (no confirm leg).  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`SPEAKER_OBS_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Speaker Observations Upload Url
         * @param {string} meetingId 
         * @param {SpeakerObservationsUploadUrlRequest} speakerObservationsUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpeakerObservationsUploadUrl: async (meetingId: string, speakerObservationsUploadUrlRequest: SpeakerObservationsUploadUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('createSpeakerObservationsUploadUrl', 'meetingId', meetingId)
            // verify required parameter 'speakerObservationsUploadUrlRequest' is not null or undefined
            assertParamExists('createSpeakerObservationsUploadUrl', 'speakerObservationsUploadUrlRequest', speakerObservationsUploadUrlRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/speaker-observations/upload-url`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(speakerObservationsUploadUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a meeting and reap its transcript blobs from S3.  Flips ``is_deleted=true``, then best-effort-deletes everything under ``users/{user_id}/meetings/transcripts/{meeting_id}/`` plus the legacy flat key. Bumps the sync timestamp so other devices observe the deletion on their next pull.  Returns 204 on both first-delete and idempotent re-delete. Returns 404 for unknown meetings and meetings owned by another user (we do not leak existence to non-owners).
         * @summary Delete Meeting
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeeting: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('deleteMeeting', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report a meeting\'s refine progress and inline what the client is missing.  The desktop polls this as a recovery channel parallel to sync, passing the refine status it currently believes (``transcribing`` or ``summarizing``). The server returns its own job status and inlines the refined transcript only when it is ahead of the client. A 404 means the meeting doesn\'t exist on the server, so the client re-pushes it via sync.
         * @summary Get Meeting Status
         * @param {string} meetingId 
         * @param {RefineJobStatus} clientStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingStatus: async (meetingId: string, clientStatus: RefineJobStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getMeetingStatus', 'meetingId', meetingId)
            // verify required parameter 'clientStatus' is not null or undefined
            assertParamExists('getMeetingStatus', 'clientStatus', clientStatus)
            const localVarPath = `/api/v1/meetings/{meeting_id}/status`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (clientStatus !== undefined) {
                localVarQueryParameter['client_status'] = clientStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report the caller\'s Notetaker recording allowance for the current week.  The week rolls implicitly: a week with no counter row reads as zero, so no row is created on read.  Args:     current_user: The authenticated caller.     db:           Executor used to read the week\'s counter.  Returns:     The counted/limit/remaining triple plus the week\'s UTC-Monday bounds.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.
         * @summary Get Notetaker Weekly Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotetakerWeeklyQuota: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meetings/weekly-quota`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mint a presigned S3 GET for a meeting\'s refined-transcript NDJSON.  The desktop calls this when a pull row\'s ``refined_uploaded_at`` stamp beats its locally persisted fetched-through stamp, then downloads ``refined.ndjson`` straight from S3 — the bytes never transit the API. Presign-only: no ``meeting_refine_jobs`` side effects (same contract as the live-transcript / speaker-observations presigns).  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined transcript to fetch.     user:       Authenticated caller; the row lookup is scoped to their id.     db:         Request-scoped executor (replica read).  Returns:     The presigned GET URL and its absolute expiry.  Raises:     HTTPNotFound: Meeting missing/foreign/deleted, transcript erased, or no         ``refined_uploaded_at`` stamp yet.
         * @summary Get Refined Transcript Download Url
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinedTranscriptDownloadUrl: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getRefinedTranscriptDownloadUrl', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/refined-transcript`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read the current immutable transcript identity and owner corrections.
         * @summary Get Transcript Corrections
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptCorrections: async (meetingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('getTranscriptCorrections', 'meetingId', meetingId)
            const localVarPath = `/api/v1/meetings/{meeting_id}/transcript-corrections`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reassign selected refined transcript bubbles to an existing person.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose selected refined entries should change.     body:       Revision-fenced entry ids and target person id.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, target refined speaker id, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Selection, target person, artifact, or speaker-map topology is invalid.
         * @summary Reassign Meeting Transcript Speakers
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerReassignmentRequest} meetingTranscriptSpeakerReassignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignMeetingTranscriptSpeakers: async (meetingId: string, meetingTranscriptSpeakerReassignmentRequest: MeetingTranscriptSpeakerReassignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('reassignMeetingTranscriptSpeakers', 'meetingId', meetingId)
            // verify required parameter 'meetingTranscriptSpeakerReassignmentRequest' is not null or undefined
            assertParamExists('reassignMeetingTranscriptSpeakers', 'meetingTranscriptSpeakerReassignmentRequest', meetingTranscriptSpeakerReassignmentRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/transcript-speakers`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingTranscriptSpeakerReassignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report ordered audio-capture liveness for an owned meeting.
         * @summary Report Recording State
         * @param {string} meetingId 
         * @param {MeetingRecordingStateRequest} meetingRecordingStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRecordingState: async (meetingId: string, meetingRecordingStateRequest: MeetingRecordingStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('reportRecordingState', 'meetingId', meetingId)
            // verify required parameter 'meetingRecordingStateRequest' is not null or undefined
            assertParamExists('reportRecordingState', 'meetingRecordingStateRequest', meetingRecordingStateRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/recording-state`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingRecordingStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Separate one refined speaker into several along its raw voices.  The speaker\'s bubbles are re-cut from the retained raw payload wherever the raw voice crosses a partition boundary; every other bubble is untouched. 403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined speaker should be separated.     body:       Revision-fenced speaker id and voice partitions.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, one refined speaker id per partition, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Partition, speaker, artifact, map topology, or raw payload is invalid;         a distinct detail when the active revision is romanized and can never be split.
         * @summary Split Meeting Transcript Speaker
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerSplitRequest} meetingTranscriptSpeakerSplitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitMeetingTranscriptSpeaker: async (meetingId: string, meetingTranscriptSpeakerSplitRequest: MeetingTranscriptSpeakerSplitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('splitMeetingTranscriptSpeaker', 'meetingId', meetingId)
            // verify required parameter 'meetingTranscriptSpeakerSplitRequest' is not null or undefined
            assertParamExists('splitMeetingTranscriptSpeaker', 'meetingTranscriptSpeakerSplitRequest', meetingTranscriptSpeakerSplitRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/transcript-speakers/split`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingTranscriptSpeakerSplitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reconcile the client\'s meetings against the server and return the delta.  Gated on the caller\'s Notetaker eligibility. Acks the client\'s pushed meetings, pulls the server-side changes the client is missing, and echoes the sync watermark the client should resume from.  Args:     sync_request:     The client\'s pushed meetings, watermark, and cursor.     current_user:     The authenticated caller.     meetings_service: Service that performs the reconciliation.     storage:          Backing store for meeting transcripts.  Returns:     The acked meetings, the pulled delta, the next watermark, and the     pagination cursor.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.     HTTPUnprocessableEntity: a pushed field exceeds its size cap, or ``recorded_ms`` is out of range.     HTTPException: propagated unchanged when it is what the reconciliation itself already raised.     HTTPInternalServerError: reconciliation fails unexpectedly (the original error is         logged with a truncated message and full traceback, then         wrapped).
         * @summary Sync Meetings
         * @param {MeetingSyncRequest} meetingSyncRequest 
         * @param {number | null} [contentLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeetings: async (meetingSyncRequest: MeetingSyncRequest, contentLength?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingSyncRequest' is not null or undefined
            assertParamExists('syncMeetings', 'meetingSyncRequest', meetingSyncRequest)
            const localVarPath = `/api/v1/meetings/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (contentLength != null) {
                localVarHeaderParameter['content-length'] = typeof contentLength === 'string'
                    ? contentLength
                    : JSON.stringify(contentLength);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(meetingSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compare-and-set an owner\'s speech correction, or revert with edited_text=null.
         * @summary Update Transcript Correction
         * @param {string} meetingId 
         * @param {UpdateTranscriptCorrectionRequest} updateTranscriptCorrectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTranscriptCorrection: async (meetingId: string, updateTranscriptCorrectionRequest: UpdateTranscriptCorrectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meetingId' is not null or undefined
            assertParamExists('updateTranscriptCorrection', 'meetingId', meetingId)
            // verify required parameter 'updateTranscriptCorrectionRequest' is not null or undefined
            assertParamExists('updateTranscriptCorrection', 'updateTranscriptCorrectionRequest', updateTranscriptCorrectionRequest)
            const localVarPath = `/api/v1/meetings/{meeting_id}/transcript-corrections`
                .replace(`{${"meeting_id"}}`, encodeURIComponent(String(meetingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTranscriptCorrectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeetingsApi - functional programming interface
 * @export
 */
export const MeetingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeetingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign one refined meeting speaker to an owner-scoped contact.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose speaker map should change.     body:       Refined speaker id and selected contact id.     user:       Authenticated owner used to scope both resources.     db:         Main Postgres executor used to enforce Notetaker eligibility.     service:    Atomic speaker-contact assignment service.  Returns:     The authoritative speaker map after assignment.  Raises:     HTTPNotFound: The meeting or contact is not visible to the authenticated owner.     HTTPConflict: The stored speaker map cannot safely accept the assignment.     HTTPUnprocessableEntity: The selected contact has no usable display name.
         * @summary Assign Speaker Contact
         * @param {string} meetingId 
         * @param {MeetingSpeakerContactAssignmentRequest} meetingSpeakerContactAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSpeakerContact(meetingId: string, meetingSpeakerContactAssignmentRequest: MeetingSpeakerContactAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpeakerMap>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSpeakerContact(meetingId, meetingSpeakerContactAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.assignSpeakerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clear the summary-model-comparison candidate after the owner voted on it.  Nulls ``candidate_summary``/``candidate_summary_metadata`` and bumps the sync stamp so the next pull delivers the row without the candidate. ``summary`` is untouched. The optional vote is stored on the captured comparison; older clients send none, and an unrecognized value is stored as NULL rather than blocking the clear. Idempotent: 204 whether or not a candidate was present; 404 for unknown/deleted meetings and meetings owned by another user.
         * @summary Clear Candidate Summary
         * @param {string} meetingId 
         * @param {string | null} [outcome] The owner\&#39;s vote; unknown values store NULL.
         * @param {string | null} [candidatePosition] 1 or 2: the card the candidate was shown in; others store NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearCandidateSummary(meetingId: string, outcome?: string | null, candidatePosition?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearCandidateSummary(meetingId, outcome, candidatePosition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.clearCandidateSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s live-transcript NDJSON.  Sibling to :func:`create_speaker_observations_upload_url`: the desktop PUTs ``live.ndjson`` directly to S3 instead of inlining it in the sync body. Same no-job-side-effects contract — it never touches ``meeting_refine_jobs``. The key is server-composed via :func:`live_ndjson_key`, never derived from client input.  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`LIVE_TRANSCRIPT_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Live Transcript Upload Url
         * @param {string} meetingId 
         * @param {LiveTranscriptUploadUrlRequest} liveTranscriptUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLiveTranscriptUploadUrl(meetingId: string, liveTranscriptUploadUrlRequest: LiveTranscriptUploadUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLiveTranscriptUploadUrl(meetingId, liveTranscriptUploadUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.createLiveTranscriptUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Suggest at most one of the caller\'s shared folders for their meeting in progress; nothing is stored.  Every outcome after admission is a 200, and `suggestion` is `null` unless a shared folder clearly fits. The client shows a non-null suggestion once; after a `null` it asks again only at its next periodic check.
         * @summary Create Meeting Folder Suggestion
         * @param {string} meetingId 
         * @param {MeetingFolderSuggestionRequest} meetingFolderSuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeetingFolderSuggestion(meetingId: string, meetingFolderSuggestionRequest: MeetingFolderSuggestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingFolderSuggestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeetingFolderSuggestion(meetingId, meetingFolderSuggestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.createMeetingFolderSuggestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Summarize the caller\'s live transcript with a fast model, or a fallback model if it fails; nothing is stored.  Every generation outcome is a 200: `ok` carries `summary_markdown`, `too_short` means the transcript is under the summary word floor, and `unavailable` means no quick summary could be made this time. The client shows no quick summary for the last two and never retries.
         * @summary Create Meeting Quick Summary
         * @param {string} meetingId 
         * @param {MeetingQuickSummaryRequest} meetingQuickSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeetingQuickSummary(meetingId: string, meetingQuickSummaryRequest: MeetingQuickSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingQuickSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeetingQuickSummary(meetingId, meetingQuickSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.createMeetingQuickSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Seal a job\'s complete audio snapshot and renew delivery for identical retries.
         * @summary Create Meeting Upload Url
         * @param {string} meetingId 
         * @param {MeetingUploadUrlRequest} meetingUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMeetingUploadUrl(meetingId: string, meetingUploadUrlRequest: MeetingUploadUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMeetingUploadUrl(meetingId, meetingUploadUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.createMeetingUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s speaker-observation log.  Sibling to :func:`create_meeting_upload_url` but with no job side effects: it never touches ``meeting_refine_jobs`` (the audio route\'s upsert revives failed/abandoned jobs and clobbers the audio key — a stuck observation artifact must not delay or disturb the transcript). The key is server-composed via :func:`speaker_observations_key`, never derived from client input. The client PUTs the artifact directly to S3; Phase-1 transcript persistence reads it from S3 on demand (no confirm leg).  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`SPEAKER_OBS_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Speaker Observations Upload Url
         * @param {string} meetingId 
         * @param {SpeakerObservationsUploadUrlRequest} speakerObservationsUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSpeakerObservationsUploadUrl(meetingId: string, speakerObservationsUploadUrlRequest: SpeakerObservationsUploadUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingUploadUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSpeakerObservationsUploadUrl(meetingId, speakerObservationsUploadUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.createSpeakerObservationsUploadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft-delete a meeting and reap its transcript blobs from S3.  Flips ``is_deleted=true``, then best-effort-deletes everything under ``users/{user_id}/meetings/transcripts/{meeting_id}/`` plus the legacy flat key. Bumps the sync timestamp so other devices observe the deletion on their next pull.  Returns 204 on both first-delete and idempotent re-delete. Returns 404 for unknown meetings and meetings owned by another user (we do not leak existence to non-owners).
         * @summary Delete Meeting
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeeting(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeeting(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.deleteMeeting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report a meeting\'s refine progress and inline what the client is missing.  The desktop polls this as a recovery channel parallel to sync, passing the refine status it currently believes (``transcribing`` or ``summarizing``). The server returns its own job status and inlines the refined transcript only when it is ahead of the client. A 404 means the meeting doesn\'t exist on the server, so the client re-pushes it via sync.
         * @summary Get Meeting Status
         * @param {string} meetingId 
         * @param {RefineJobStatus} clientStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMeetingStatus(meetingId: string, clientStatus: RefineJobStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMeetingStatus(meetingId, clientStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.getMeetingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report the caller\'s Notetaker recording allowance for the current week.  The week rolls implicitly: a week with no counter row reads as zero, so no row is created on read.  Args:     current_user: The authenticated caller.     db:           Executor used to read the week\'s counter.  Returns:     The counted/limit/remaining triple plus the week\'s UTC-Monday bounds.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.
         * @summary Get Notetaker Weekly Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotetakerWeeklyQuota(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotetakerWeeklyQuotaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotetakerWeeklyQuota(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.getNotetakerWeeklyQuota']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mint a presigned S3 GET for a meeting\'s refined-transcript NDJSON.  The desktop calls this when a pull row\'s ``refined_uploaded_at`` stamp beats its locally persisted fetched-through stamp, then downloads ``refined.ndjson`` straight from S3 — the bytes never transit the API. Presign-only: no ``meeting_refine_jobs`` side effects (same contract as the live-transcript / speaker-observations presigns).  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined transcript to fetch.     user:       Authenticated caller; the row lookup is scoped to their id.     db:         Request-scoped executor (replica read).  Returns:     The presigned GET URL and its absolute expiry.  Raises:     HTTPNotFound: Meeting missing/foreign/deleted, transcript erased, or no         ``refined_uploaded_at`` stamp yet.
         * @summary Get Refined Transcript Download Url
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefinedTranscriptDownloadUrl(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingRefinedTranscriptUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRefinedTranscriptDownloadUrl(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.getRefinedTranscriptDownloadUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read the current immutable transcript identity and owner corrections.
         * @summary Get Transcript Corrections
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptCorrections(meetingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptCorrections>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptCorrections(meetingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.getTranscriptCorrections']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reassign selected refined transcript bubbles to an existing person.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose selected refined entries should change.     body:       Revision-fenced entry ids and target person id.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, target refined speaker id, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Selection, target person, artifact, or speaker-map topology is invalid.
         * @summary Reassign Meeting Transcript Speakers
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerReassignmentRequest} meetingTranscriptSpeakerReassignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reassignMeetingTranscriptSpeakers(meetingId: string, meetingTranscriptSpeakerReassignmentRequest: MeetingTranscriptSpeakerReassignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingTranscriptSpeakerReassignmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reassignMeetingTranscriptSpeakers(meetingId, meetingTranscriptSpeakerReassignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.reassignMeetingTranscriptSpeakers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report ordered audio-capture liveness for an owned meeting.
         * @summary Report Recording State
         * @param {string} meetingId 
         * @param {MeetingRecordingStateRequest} meetingRecordingStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportRecordingState(meetingId: string, meetingRecordingStateRequest: MeetingRecordingStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingRecordingStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportRecordingState(meetingId, meetingRecordingStateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.reportRecordingState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Separate one refined speaker into several along its raw voices.  The speaker\'s bubbles are re-cut from the retained raw payload wherever the raw voice crosses a partition boundary; every other bubble is untouched. 403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined speaker should be separated.     body:       Revision-fenced speaker id and voice partitions.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, one refined speaker id per partition, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Partition, speaker, artifact, map topology, or raw payload is invalid;         a distinct detail when the active revision is romanized and can never be split.
         * @summary Split Meeting Transcript Speaker
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerSplitRequest} meetingTranscriptSpeakerSplitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async splitMeetingTranscriptSpeaker(meetingId: string, meetingTranscriptSpeakerSplitRequest: MeetingTranscriptSpeakerSplitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingTranscriptSpeakerSplitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.splitMeetingTranscriptSpeaker(meetingId, meetingTranscriptSpeakerSplitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.splitMeetingTranscriptSpeaker']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reconcile the client\'s meetings against the server and return the delta.  Gated on the caller\'s Notetaker eligibility. Acks the client\'s pushed meetings, pulls the server-side changes the client is missing, and echoes the sync watermark the client should resume from.  Args:     sync_request:     The client\'s pushed meetings, watermark, and cursor.     current_user:     The authenticated caller.     meetings_service: Service that performs the reconciliation.     storage:          Backing store for meeting transcripts.  Returns:     The acked meetings, the pulled delta, the next watermark, and the     pagination cursor.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.     HTTPUnprocessableEntity: a pushed field exceeds its size cap, or ``recorded_ms`` is out of range.     HTTPException: propagated unchanged when it is what the reconciliation itself already raised.     HTTPInternalServerError: reconciliation fails unexpectedly (the original error is         logged with a truncated message and full traceback, then         wrapped).
         * @summary Sync Meetings
         * @param {MeetingSyncRequest} meetingSyncRequest 
         * @param {number | null} [contentLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncMeetings(meetingSyncRequest: MeetingSyncRequest, contentLength?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncMeetings(meetingSyncRequest, contentLength, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.syncMeetings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compare-and-set an owner\'s speech correction, or revert with edited_text=null.
         * @summary Update Transcript Correction
         * @param {string} meetingId 
         * @param {UpdateTranscriptCorrectionRequest} updateTranscriptCorrectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTranscriptCorrection(meetingId: string, updateTranscriptCorrectionRequest: UpdateTranscriptCorrectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranscriptCorrections>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTranscriptCorrection(meetingId, updateTranscriptCorrectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeetingsApi.updateTranscriptCorrection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeetingsApi - factory interface
 * @export
 */
export const MeetingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeetingsApiFp(configuration)
    return {
        /**
         * Assign one refined meeting speaker to an owner-scoped contact.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose speaker map should change.     body:       Refined speaker id and selected contact id.     user:       Authenticated owner used to scope both resources.     db:         Main Postgres executor used to enforce Notetaker eligibility.     service:    Atomic speaker-contact assignment service.  Returns:     The authoritative speaker map after assignment.  Raises:     HTTPNotFound: The meeting or contact is not visible to the authenticated owner.     HTTPConflict: The stored speaker map cannot safely accept the assignment.     HTTPUnprocessableEntity: The selected contact has no usable display name.
         * @summary Assign Speaker Contact
         * @param {string} meetingId 
         * @param {MeetingSpeakerContactAssignmentRequest} meetingSpeakerContactAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSpeakerContact(meetingId: string, meetingSpeakerContactAssignmentRequest: MeetingSpeakerContactAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<SpeakerMap> {
            return localVarFp.assignSpeakerContact(meetingId, meetingSpeakerContactAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Clear the summary-model-comparison candidate after the owner voted on it.  Nulls ``candidate_summary``/``candidate_summary_metadata`` and bumps the sync stamp so the next pull delivers the row without the candidate. ``summary`` is untouched. The optional vote is stored on the captured comparison; older clients send none, and an unrecognized value is stored as NULL rather than blocking the clear. Idempotent: 204 whether or not a candidate was present; 404 for unknown/deleted meetings and meetings owned by another user.
         * @summary Clear Candidate Summary
         * @param {string} meetingId 
         * @param {string | null} [outcome] The owner\&#39;s vote; unknown values store NULL.
         * @param {string | null} [candidatePosition] 1 or 2: the card the candidate was shown in; others store NULL.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearCandidateSummary(meetingId: string, outcome?: string | null, candidatePosition?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearCandidateSummary(meetingId, outcome, candidatePosition, options).then((request) => request(axios, basePath));
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s live-transcript NDJSON.  Sibling to :func:`create_speaker_observations_upload_url`: the desktop PUTs ``live.ndjson`` directly to S3 instead of inlining it in the sync body. Same no-job-side-effects contract — it never touches ``meeting_refine_jobs``. The key is server-composed via :func:`live_ndjson_key`, never derived from client input.  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`LIVE_TRANSCRIPT_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Live Transcript Upload Url
         * @param {string} meetingId 
         * @param {LiveTranscriptUploadUrlRequest} liveTranscriptUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLiveTranscriptUploadUrl(meetingId: string, liveTranscriptUploadUrlRequest: LiveTranscriptUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingUploadUrlResponse> {
            return localVarFp.createLiveTranscriptUploadUrl(meetingId, liveTranscriptUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Suggest at most one of the caller\'s shared folders for their meeting in progress; nothing is stored.  Every outcome after admission is a 200, and `suggestion` is `null` unless a shared folder clearly fits. The client shows a non-null suggestion once; after a `null` it asks again only at its next periodic check.
         * @summary Create Meeting Folder Suggestion
         * @param {string} meetingId 
         * @param {MeetingFolderSuggestionRequest} meetingFolderSuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingFolderSuggestion(meetingId: string, meetingFolderSuggestionRequest: MeetingFolderSuggestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingFolderSuggestionResponse> {
            return localVarFp.createMeetingFolderSuggestion(meetingId, meetingFolderSuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Summarize the caller\'s live transcript with a fast model, or a fallback model if it fails; nothing is stored.  Every generation outcome is a 200: `ok` carries `summary_markdown`, `too_short` means the transcript is under the summary word floor, and `unavailable` means no quick summary could be made this time. The client shows no quick summary for the last two and never retries.
         * @summary Create Meeting Quick Summary
         * @param {string} meetingId 
         * @param {MeetingQuickSummaryRequest} meetingQuickSummaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingQuickSummary(meetingId: string, meetingQuickSummaryRequest: MeetingQuickSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingQuickSummaryResponse> {
            return localVarFp.createMeetingQuickSummary(meetingId, meetingQuickSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Seal a job\'s complete audio snapshot and renew delivery for identical retries.
         * @summary Create Meeting Upload Url
         * @param {string} meetingId 
         * @param {MeetingUploadUrlRequest} meetingUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMeetingUploadUrl(meetingId: string, meetingUploadUrlRequest: MeetingUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingUploadUrlResponse> {
            return localVarFp.createMeetingUploadUrl(meetingId, meetingUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mint a presigned S3 POST for a meeting\'s speaker-observation log.  Sibling to :func:`create_meeting_upload_url` but with no job side effects: it never touches ``meeting_refine_jobs`` (the audio route\'s upsert revives failed/abandoned jobs and clobbers the audio key — a stuck observation artifact must not delay or disturb the transcript). The key is server-composed via :func:`speaker_observations_key`, never derived from client input. The client PUTs the artifact directly to S3; Phase-1 transcript persistence reads it from S3 on demand (no confirm leg).  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`SPEAKER_OBS_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
         * @summary Create Speaker Observations Upload Url
         * @param {string} meetingId 
         * @param {SpeakerObservationsUploadUrlRequest} speakerObservationsUploadUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSpeakerObservationsUploadUrl(meetingId: string, speakerObservationsUploadUrlRequest: SpeakerObservationsUploadUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingUploadUrlResponse> {
            return localVarFp.createSpeakerObservationsUploadUrl(meetingId, speakerObservationsUploadUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a meeting and reap its transcript blobs from S3.  Flips ``is_deleted=true``, then best-effort-deletes everything under ``users/{user_id}/meetings/transcripts/{meeting_id}/`` plus the legacy flat key. Bumps the sync timestamp so other devices observe the deletion on their next pull.  Returns 204 on both first-delete and idempotent re-delete. Returns 404 for unknown meetings and meetings owned by another user (we do not leak existence to non-owners).
         * @summary Delete Meeting
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeeting(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteMeeting(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Report a meeting\'s refine progress and inline what the client is missing.  The desktop polls this as a recovery channel parallel to sync, passing the refine status it currently believes (``transcribing`` or ``summarizing``). The server returns its own job status and inlines the refined transcript only when it is ahead of the client. A 404 means the meeting doesn\'t exist on the server, so the client re-pushes it via sync.
         * @summary Get Meeting Status
         * @param {string} meetingId 
         * @param {RefineJobStatus} clientStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMeetingStatus(meetingId: string, clientStatus: RefineJobStatus, options?: RawAxiosRequestConfig): AxiosPromise<MeetingStatusResponse> {
            return localVarFp.getMeetingStatus(meetingId, clientStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * Report the caller\'s Notetaker recording allowance for the current week.  The week rolls implicitly: a week with no counter row reads as zero, so no row is created on read.  Args:     current_user: The authenticated caller.     db:           Executor used to read the week\'s counter.  Returns:     The counted/limit/remaining triple plus the week\'s UTC-Monday bounds.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.
         * @summary Get Notetaker Weekly Quota
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotetakerWeeklyQuota(options?: RawAxiosRequestConfig): AxiosPromise<NotetakerWeeklyQuotaResponse> {
            return localVarFp.getNotetakerWeeklyQuota(options).then((request) => request(axios, basePath));
        },
        /**
         * Mint a presigned S3 GET for a meeting\'s refined-transcript NDJSON.  The desktop calls this when a pull row\'s ``refined_uploaded_at`` stamp beats its locally persisted fetched-through stamp, then downloads ``refined.ndjson`` straight from S3 — the bytes never transit the API. Presign-only: no ``meeting_refine_jobs`` side effects (same contract as the live-transcript / speaker-observations presigns).  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined transcript to fetch.     user:       Authenticated caller; the row lookup is scoped to their id.     db:         Request-scoped executor (replica read).  Returns:     The presigned GET URL and its absolute expiry.  Raises:     HTTPNotFound: Meeting missing/foreign/deleted, transcript erased, or no         ``refined_uploaded_at`` stamp yet.
         * @summary Get Refined Transcript Download Url
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinedTranscriptDownloadUrl(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<MeetingRefinedTranscriptUrlResponse> {
            return localVarFp.getRefinedTranscriptDownloadUrl(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read the current immutable transcript identity and owner corrections.
         * @summary Get Transcript Corrections
         * @param {string} meetingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptCorrections(meetingId: string, options?: RawAxiosRequestConfig): AxiosPromise<TranscriptCorrections> {
            return localVarFp.getTranscriptCorrections(meetingId, options).then((request) => request(axios, basePath));
        },
        /**
         * Reassign selected refined transcript bubbles to an existing person.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose selected refined entries should change.     body:       Revision-fenced entry ids and target person id.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, target refined speaker id, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Selection, target person, artifact, or speaker-map topology is invalid.
         * @summary Reassign Meeting Transcript Speakers
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerReassignmentRequest} meetingTranscriptSpeakerReassignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reassignMeetingTranscriptSpeakers(meetingId: string, meetingTranscriptSpeakerReassignmentRequest: MeetingTranscriptSpeakerReassignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingTranscriptSpeakerReassignmentResponse> {
            return localVarFp.reassignMeetingTranscriptSpeakers(meetingId, meetingTranscriptSpeakerReassignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Report ordered audio-capture liveness for an owned meeting.
         * @summary Report Recording State
         * @param {string} meetingId 
         * @param {MeetingRecordingStateRequest} meetingRecordingStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportRecordingState(meetingId: string, meetingRecordingStateRequest: MeetingRecordingStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingRecordingStateResponse> {
            return localVarFp.reportRecordingState(meetingId, meetingRecordingStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Separate one refined speaker into several along its raw voices.  The speaker\'s bubbles are re-cut from the retained raw payload wherever the raw voice crosses a partition boundary; every other bubble is untouched. 403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined speaker should be separated.     body:       Revision-fenced speaker id and voice partitions.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, one refined speaker id per partition, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Partition, speaker, artifact, map topology, or raw payload is invalid;         a distinct detail when the active revision is romanized and can never be split.
         * @summary Split Meeting Transcript Speaker
         * @param {string} meetingId 
         * @param {MeetingTranscriptSpeakerSplitRequest} meetingTranscriptSpeakerSplitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        splitMeetingTranscriptSpeaker(meetingId: string, meetingTranscriptSpeakerSplitRequest: MeetingTranscriptSpeakerSplitRequest, options?: RawAxiosRequestConfig): AxiosPromise<MeetingTranscriptSpeakerSplitResponse> {
            return localVarFp.splitMeetingTranscriptSpeaker(meetingId, meetingTranscriptSpeakerSplitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reconcile the client\'s meetings against the server and return the delta.  Gated on the caller\'s Notetaker eligibility. Acks the client\'s pushed meetings, pulls the server-side changes the client is missing, and echoes the sync watermark the client should resume from.  Args:     sync_request:     The client\'s pushed meetings, watermark, and cursor.     current_user:     The authenticated caller.     meetings_service: Service that performs the reconciliation.     storage:          Backing store for meeting transcripts.  Returns:     The acked meetings, the pulled delta, the next watermark, and the     pagination cursor.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.     HTTPUnprocessableEntity: a pushed field exceeds its size cap, or ``recorded_ms`` is out of range.     HTTPException: propagated unchanged when it is what the reconciliation itself already raised.     HTTPInternalServerError: reconciliation fails unexpectedly (the original error is         logged with a truncated message and full traceback, then         wrapped).
         * @summary Sync Meetings
         * @param {MeetingSyncRequest} meetingSyncRequest 
         * @param {number | null} [contentLength] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncMeetings(meetingSyncRequest: MeetingSyncRequest, contentLength?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<MeetingSyncResponse> {
            return localVarFp.syncMeetings(meetingSyncRequest, contentLength, options).then((request) => request(axios, basePath));
        },
        /**
         * Compare-and-set an owner\'s speech correction, or revert with edited_text=null.
         * @summary Update Transcript Correction
         * @param {string} meetingId 
         * @param {UpdateTranscriptCorrectionRequest} updateTranscriptCorrectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTranscriptCorrection(meetingId: string, updateTranscriptCorrectionRequest: UpdateTranscriptCorrectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TranscriptCorrections> {
            return localVarFp.updateTranscriptCorrection(meetingId, updateTranscriptCorrectionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeetingsApi - object-oriented interface
 * @export
 * @class MeetingsApi
 * @extends {BaseAPI}
 */
export class MeetingsApi extends BaseAPI {
    /**
     * Assign one refined meeting speaker to an owner-scoped contact.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose speaker map should change.     body:       Refined speaker id and selected contact id.     user:       Authenticated owner used to scope both resources.     db:         Main Postgres executor used to enforce Notetaker eligibility.     service:    Atomic speaker-contact assignment service.  Returns:     The authoritative speaker map after assignment.  Raises:     HTTPNotFound: The meeting or contact is not visible to the authenticated owner.     HTTPConflict: The stored speaker map cannot safely accept the assignment.     HTTPUnprocessableEntity: The selected contact has no usable display name.
     * @summary Assign Speaker Contact
     * @param {string} meetingId 
     * @param {MeetingSpeakerContactAssignmentRequest} meetingSpeakerContactAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public assignSpeakerContact(meetingId: string, meetingSpeakerContactAssignmentRequest: MeetingSpeakerContactAssignmentRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).assignSpeakerContact(meetingId, meetingSpeakerContactAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clear the summary-model-comparison candidate after the owner voted on it.  Nulls ``candidate_summary``/``candidate_summary_metadata`` and bumps the sync stamp so the next pull delivers the row without the candidate. ``summary`` is untouched. The optional vote is stored on the captured comparison; older clients send none, and an unrecognized value is stored as NULL rather than blocking the clear. Idempotent: 204 whether or not a candidate was present; 404 for unknown/deleted meetings and meetings owned by another user.
     * @summary Clear Candidate Summary
     * @param {string} meetingId 
     * @param {string | null} [outcome] The owner\&#39;s vote; unknown values store NULL.
     * @param {string | null} [candidatePosition] 1 or 2: the card the candidate was shown in; others store NULL.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public clearCandidateSummary(meetingId: string, outcome?: string | null, candidatePosition?: string | null, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).clearCandidateSummary(meetingId, outcome, candidatePosition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mint a presigned S3 POST for a meeting\'s live-transcript NDJSON.  Sibling to :func:`create_speaker_observations_upload_url`: the desktop PUTs ``live.ndjson`` directly to S3 instead of inlining it in the sync body. Same no-job-side-effects contract — it never touches ``meeting_refine_jobs``. The key is server-composed via :func:`live_ndjson_key`, never derived from client input.  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`LIVE_TRANSCRIPT_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
     * @summary Create Live Transcript Upload Url
     * @param {string} meetingId 
     * @param {LiveTranscriptUploadUrlRequest} liveTranscriptUploadUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public createLiveTranscriptUploadUrl(meetingId: string, liveTranscriptUploadUrlRequest: LiveTranscriptUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).createLiveTranscriptUploadUrl(meetingId, liveTranscriptUploadUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Suggest at most one of the caller\'s shared folders for their meeting in progress; nothing is stored.  Every outcome after admission is a 200, and `suggestion` is `null` unless a shared folder clearly fits. The client shows a non-null suggestion once; after a `null` it asks again only at its next periodic check.
     * @summary Create Meeting Folder Suggestion
     * @param {string} meetingId 
     * @param {MeetingFolderSuggestionRequest} meetingFolderSuggestionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public createMeetingFolderSuggestion(meetingId: string, meetingFolderSuggestionRequest: MeetingFolderSuggestionRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).createMeetingFolderSuggestion(meetingId, meetingFolderSuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Summarize the caller\'s live transcript with a fast model, or a fallback model if it fails; nothing is stored.  Every generation outcome is a 200: `ok` carries `summary_markdown`, `too_short` means the transcript is under the summary word floor, and `unavailable` means no quick summary could be made this time. The client shows no quick summary for the last two and never retries.
     * @summary Create Meeting Quick Summary
     * @param {string} meetingId 
     * @param {MeetingQuickSummaryRequest} meetingQuickSummaryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public createMeetingQuickSummary(meetingId: string, meetingQuickSummaryRequest: MeetingQuickSummaryRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).createMeetingQuickSummary(meetingId, meetingQuickSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Seal a job\'s complete audio snapshot and renew delivery for identical retries.
     * @summary Create Meeting Upload Url
     * @param {string} meetingId 
     * @param {MeetingUploadUrlRequest} meetingUploadUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public createMeetingUploadUrl(meetingId: string, meetingUploadUrlRequest: MeetingUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).createMeetingUploadUrl(meetingId, meetingUploadUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mint a presigned S3 POST for a meeting\'s speaker-observation log.  Sibling to :func:`create_meeting_upload_url` but with no job side effects: it never touches ``meeting_refine_jobs`` (the audio route\'s upsert revives failed/abandoned jobs and clobbers the audio key — a stuck observation artifact must not delay or disturb the transcript). The key is server-composed via :func:`speaker_observations_key`, never derived from client input. The client PUTs the artifact directly to S3; Phase-1 transcript persistence reads it from S3 on demand (no confirm leg).  Errors map as:  * 404 — meeting doesn\'t exist for this user (or is deleted). * 413 — ``size_bytes`` exceeds :data:`SPEAKER_OBS_MAX_BYTES`. * 415 — content type is not ``application/x-ndjson``.
     * @summary Create Speaker Observations Upload Url
     * @param {string} meetingId 
     * @param {SpeakerObservationsUploadUrlRequest} speakerObservationsUploadUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public createSpeakerObservationsUploadUrl(meetingId: string, speakerObservationsUploadUrlRequest: SpeakerObservationsUploadUrlRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).createSpeakerObservationsUploadUrl(meetingId, speakerObservationsUploadUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a meeting and reap its transcript blobs from S3.  Flips ``is_deleted=true``, then best-effort-deletes everything under ``users/{user_id}/meetings/transcripts/{meeting_id}/`` plus the legacy flat key. Bumps the sync timestamp so other devices observe the deletion on their next pull.  Returns 204 on both first-delete and idempotent re-delete. Returns 404 for unknown meetings and meetings owned by another user (we do not leak existence to non-owners).
     * @summary Delete Meeting
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public deleteMeeting(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).deleteMeeting(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report a meeting\'s refine progress and inline what the client is missing.  The desktop polls this as a recovery channel parallel to sync, passing the refine status it currently believes (``transcribing`` or ``summarizing``). The server returns its own job status and inlines the refined transcript only when it is ahead of the client. A 404 means the meeting doesn\'t exist on the server, so the client re-pushes it via sync.
     * @summary Get Meeting Status
     * @param {string} meetingId 
     * @param {RefineJobStatus} clientStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public getMeetingStatus(meetingId: string, clientStatus: RefineJobStatus, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).getMeetingStatus(meetingId, clientStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report the caller\'s Notetaker recording allowance for the current week.  The week rolls implicitly: a week with no counter row reads as zero, so no row is created on read.  Args:     current_user: The authenticated caller.     db:           Executor used to read the week\'s counter.  Returns:     The counted/limit/remaining triple plus the week\'s UTC-Monday bounds.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.
     * @summary Get Notetaker Weekly Quota
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public getNotetakerWeeklyQuota(options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).getNotetakerWeeklyQuota(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mint a presigned S3 GET for a meeting\'s refined-transcript NDJSON.  The desktop calls this when a pull row\'s ``refined_uploaded_at`` stamp beats its locally persisted fetched-through stamp, then downloads ``refined.ndjson`` straight from S3 — the bytes never transit the API. Presign-only: no ``meeting_refine_jobs`` side effects (same contract as the live-transcript / speaker-observations presigns).  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined transcript to fetch.     user:       Authenticated caller; the row lookup is scoped to their id.     db:         Request-scoped executor (replica read).  Returns:     The presigned GET URL and its absolute expiry.  Raises:     HTTPNotFound: Meeting missing/foreign/deleted, transcript erased, or no         ``refined_uploaded_at`` stamp yet.
     * @summary Get Refined Transcript Download Url
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public getRefinedTranscriptDownloadUrl(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).getRefinedTranscriptDownloadUrl(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read the current immutable transcript identity and owner corrections.
     * @summary Get Transcript Corrections
     * @param {string} meetingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public getTranscriptCorrections(meetingId: string, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).getTranscriptCorrections(meetingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reassign selected refined transcript bubbles to an existing person.  403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose selected refined entries should change.     body:       Revision-fenced entry ids and target person id.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, target refined speaker id, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Selection, target person, artifact, or speaker-map topology is invalid.
     * @summary Reassign Meeting Transcript Speakers
     * @param {string} meetingId 
     * @param {MeetingTranscriptSpeakerReassignmentRequest} meetingTranscriptSpeakerReassignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public reassignMeetingTranscriptSpeakers(meetingId: string, meetingTranscriptSpeakerReassignmentRequest: MeetingTranscriptSpeakerReassignmentRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).reassignMeetingTranscriptSpeakers(meetingId, meetingTranscriptSpeakerReassignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report ordered audio-capture liveness for an owned meeting.
     * @summary Report Recording State
     * @param {string} meetingId 
     * @param {MeetingRecordingStateRequest} meetingRecordingStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public reportRecordingState(meetingId: string, meetingRecordingStateRequest: MeetingRecordingStateRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).reportRecordingState(meetingId, meetingRecordingStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Separate one refined speaker into several along its raw voices.  The speaker\'s bubbles are re-cut from the retained raw payload wherever the raw voice crosses a partition boundary; every other bubble is untouched. 403 when Notetaker is not allowed for this user (raised by ``ensure_notetaker_allowed``).  Args:     meeting_id: Meeting whose refined speaker should be separated.     body:       Revision-fenced speaker id and voice partitions.     user:       Authenticated caller used to scope every meeting/job lookup.     db:         Main Postgres executor.     storage:    Refined transcript object storage.  Returns:     The activated revision stamp, one refined speaker id per partition, and changed count.  Raises:     HTTPNotFound: Meeting is absent, foreign, deleted, erased, or has no refined transcript.     HTTPConflict: Client revision is stale or refinement is not complete.     HTTPUnprocessableEntity: Partition, speaker, artifact, map topology, or raw payload is invalid;         a distinct detail when the active revision is romanized and can never be split.
     * @summary Split Meeting Transcript Speaker
     * @param {string} meetingId 
     * @param {MeetingTranscriptSpeakerSplitRequest} meetingTranscriptSpeakerSplitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public splitMeetingTranscriptSpeaker(meetingId: string, meetingTranscriptSpeakerSplitRequest: MeetingTranscriptSpeakerSplitRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).splitMeetingTranscriptSpeaker(meetingId, meetingTranscriptSpeakerSplitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reconcile the client\'s meetings against the server and return the delta.  Gated on the caller\'s Notetaker eligibility. Acks the client\'s pushed meetings, pulls the server-side changes the client is missing, and echoes the sync watermark the client should resume from.  Args:     sync_request:     The client\'s pushed meetings, watermark, and cursor.     current_user:     The authenticated caller.     meetings_service: Service that performs the reconciliation.     storage:          Backing store for meeting transcripts.  Returns:     The acked meetings, the pulled delta, the next watermark, and the     pagination cursor.  Raises:     HTTPUnauthorized: the authenticated token carries no user id.     HTTPUnprocessableEntity: a pushed field exceeds its size cap, or ``recorded_ms`` is out of range.     HTTPException: propagated unchanged when it is what the reconciliation itself already raised.     HTTPInternalServerError: reconciliation fails unexpectedly (the original error is         logged with a truncated message and full traceback, then         wrapped).
     * @summary Sync Meetings
     * @param {MeetingSyncRequest} meetingSyncRequest 
     * @param {number | null} [contentLength] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public syncMeetings(meetingSyncRequest: MeetingSyncRequest, contentLength?: number | null, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).syncMeetings(meetingSyncRequest, contentLength, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compare-and-set an owner\'s speech correction, or revert with edited_text=null.
     * @summary Update Transcript Correction
     * @param {string} meetingId 
     * @param {UpdateTranscriptCorrectionRequest} updateTranscriptCorrectionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeetingsApi
     */
    public updateTranscriptCorrection(meetingId: string, updateTranscriptCorrectionRequest: UpdateTranscriptCorrectionRequest, options?: RawAxiosRequestConfig) {
        return MeetingsApiFp(this.configuration).updateTranscriptCorrection(meetingId, updateTranscriptCorrectionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MemoryApi - axios parameter creator
 * @export
 */
export const MemoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept a batch of ActionEnvelopes and schedule fire-and-forget Graphiti writes (202).
         * @summary Ingest a batch of ActionEvents into the voice memory system
         * @param {MemoryIngestRequest} memoryIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMemory: async (memoryIngestRequest: MemoryIngestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryIngestRequest' is not null or undefined
            assertParamExists('ingestMemory', 'memoryIngestRequest', memoryIngestRequest)
            const localVarPath = `/api/v1/memory/ingest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memoryIngestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Debug: raw Graphiti episodes + a broad fact/node sample. Prompt consumers use ``/context``.
         * @summary Debug: list the caller\'s raw Graphiti voice memories
         * @param {number} [limitEpisodes] Max episodes to return
         * @param {number} [maxFacts] Max facts from broad semantic search
         * @param {number} [maxNodes] Max entity nodes from broad semantic search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemory: async (limitEpisodes?: number, maxFacts?: number, maxNodes?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/memory/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limitEpisodes !== undefined) {
                localVarQueryParameter['limit_episodes'] = limitEpisodes;
            }

            if (maxFacts !== undefined) {
                localVarQueryParameter['max_facts'] = maxFacts;
            }

            if (maxNodes !== undefined) {
                localVarQueryParameter['max_nodes'] = maxNodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return compact, prompt-ready Graphiti memory: the client-facing prompt contract.
         * @summary Return compact prompt-ready voice memory context
         * @param {MemoryContextRequest} memoryContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryContext: async (memoryContextRequest: MemoryContextRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryContextRequest' is not null or undefined
            assertParamExists('memoryContext', 'memoryContextRequest', memoryContextRequest)
            const localVarPath = `/api/v1/memory/context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memoryContextRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether Graphiti\'s ``/health`` endpoint responds.
         * @summary Check voice-memory Graphiti connectivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/memory/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Debug: raw Graphiti fact/node search for the caller\'s dictation context (passthrough).
         * @summary Debug: raw Graphiti search over the caller\'s voice memory
         * @param {MemorySearchRequest} memorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMemory: async (memorySearchRequest: MemorySearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memorySearchRequest' is not null or undefined
            assertParamExists('searchMemory', 'memorySearchRequest', memorySearchRequest)
            const localVarPath = `/api/v1/memory/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memorySearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MemoryApi - functional programming interface
 * @export
 */
export const MemoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MemoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept a batch of ActionEnvelopes and schedule fire-and-forget Graphiti writes (202).
         * @summary Ingest a batch of ActionEvents into the voice memory system
         * @param {MemoryIngestRequest} memoryIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ingestMemory(memoryIngestRequest: MemoryIngestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryIngestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ingestMemory(memoryIngestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.ingestMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Debug: raw Graphiti episodes + a broad fact/node sample. Prompt consumers use ``/context``.
         * @summary Debug: list the caller\'s raw Graphiti voice memories
         * @param {number} [limitEpisodes] Max episodes to return
         * @param {number} [maxFacts] Max facts from broad semantic search
         * @param {number} [maxNodes] Max entity nodes from broad semantic search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMemory(limitEpisodes?: number, maxFacts?: number, maxNodes?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMemory(limitEpisodes, maxFacts, maxNodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.listMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return compact, prompt-ready Graphiti memory: the client-facing prompt contract.
         * @summary Return compact prompt-ready voice memory context
         * @param {MemoryContextRequest} memoryContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryContext(memoryContextRequest: MemoryContextRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryContextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryContext(memoryContextRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.memoryContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether Graphiti\'s ``/health`` endpoint responds.
         * @summary Check voice-memory Graphiti connectivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.memoryHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Debug: raw Graphiti fact/node search for the caller\'s dictation context (passthrough).
         * @summary Debug: raw Graphiti search over the caller\'s voice memory
         * @param {MemorySearchRequest} memorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMemory(memorySearchRequest: MemorySearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemorySearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMemory(memorySearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MemoryApi.searchMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MemoryApi - factory interface
 * @export
 */
export const MemoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MemoryApiFp(configuration)
    return {
        /**
         * Accept a batch of ActionEnvelopes and schedule fire-and-forget Graphiti writes (202).
         * @summary Ingest a batch of ActionEvents into the voice memory system
         * @param {MemoryIngestRequest} memoryIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ingestMemory(memoryIngestRequest: MemoryIngestRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryIngestResponse> {
            return localVarFp.ingestMemory(memoryIngestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Debug: raw Graphiti episodes + a broad fact/node sample. Prompt consumers use ``/context``.
         * @summary Debug: list the caller\'s raw Graphiti voice memories
         * @param {number} [limitEpisodes] Max episodes to return
         * @param {number} [maxFacts] Max facts from broad semantic search
         * @param {number} [maxNodes] Max entity nodes from broad semantic search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemory(limitEpisodes?: number, maxFacts?: number, maxNodes?: number, options?: RawAxiosRequestConfig): AxiosPromise<MemoryListResponse> {
            return localVarFp.listMemory(limitEpisodes, maxFacts, maxNodes, options).then((request) => request(axios, basePath));
        },
        /**
         * Return compact, prompt-ready Graphiti memory: the client-facing prompt contract.
         * @summary Return compact prompt-ready voice memory context
         * @param {MemoryContextRequest} memoryContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryContext(memoryContextRequest: MemoryContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryContextResponse> {
            return localVarFp.memoryContext(memoryContextRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether Graphiti\'s ``/health`` endpoint responds.
         * @summary Check voice-memory Graphiti connectivity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryHealth(options?: RawAxiosRequestConfig): AxiosPromise<MemoryHealthResponse> {
            return localVarFp.memoryHealth(options).then((request) => request(axios, basePath));
        },
        /**
         * Debug: raw Graphiti fact/node search for the caller\'s dictation context (passthrough).
         * @summary Debug: raw Graphiti search over the caller\'s voice memory
         * @param {MemorySearchRequest} memorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMemory(memorySearchRequest: MemorySearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemorySearchResponse> {
            return localVarFp.searchMemory(memorySearchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MemoryApi - object-oriented interface
 * @export
 * @class MemoryApi
 * @extends {BaseAPI}
 */
export class MemoryApi extends BaseAPI {
    /**
     * Accept a batch of ActionEnvelopes and schedule fire-and-forget Graphiti writes (202).
     * @summary Ingest a batch of ActionEvents into the voice memory system
     * @param {MemoryIngestRequest} memoryIngestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryApi
     */
    public ingestMemory(memoryIngestRequest: MemoryIngestRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).ingestMemory(memoryIngestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Debug: raw Graphiti episodes + a broad fact/node sample. Prompt consumers use ``/context``.
     * @summary Debug: list the caller\'s raw Graphiti voice memories
     * @param {number} [limitEpisodes] Max episodes to return
     * @param {number} [maxFacts] Max facts from broad semantic search
     * @param {number} [maxNodes] Max entity nodes from broad semantic search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryApi
     */
    public listMemory(limitEpisodes?: number, maxFacts?: number, maxNodes?: number, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).listMemory(limitEpisodes, maxFacts, maxNodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return compact, prompt-ready Graphiti memory: the client-facing prompt contract.
     * @summary Return compact prompt-ready voice memory context
     * @param {MemoryContextRequest} memoryContextRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryApi
     */
    public memoryContext(memoryContextRequest: MemoryContextRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).memoryContext(memoryContextRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether Graphiti\'s ``/health`` endpoint responds.
     * @summary Check voice-memory Graphiti connectivity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryApi
     */
    public memoryHealth(options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).memoryHealth(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Debug: raw Graphiti fact/node search for the caller\'s dictation context (passthrough).
     * @summary Debug: raw Graphiti search over the caller\'s voice memory
     * @param {MemorySearchRequest} memorySearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemoryApi
     */
    public searchMemory(memorySearchRequest: MemorySearchRequest, options?: RawAxiosRequestConfig) {
        return MemoryApiFp(this.configuration).searchMemory(memorySearchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotesApi - axios parameter creator
 * @export
 */
export const NotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sync notes with the server.
         * @summary Sync Notes
         * @param {NoteSyncRequest} noteSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotes: async (noteSyncRequest: NoteSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteSyncRequest' is not null or undefined
            assertParamExists('syncNotes', 'noteSyncRequest', noteSyncRequest)
            const localVarPath = `/api/v1/notes/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noteSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotesApi - functional programming interface
 * @export
 */
export const NotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotesApiAxiosParamCreator(configuration)
    return {
        /**
         * Sync notes with the server.
         * @summary Sync Notes
         * @param {NoteSyncRequest} noteSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncNotes(noteSyncRequest: NoteSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncNotes(noteSyncRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotesApi.syncNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotesApi - factory interface
 * @export
 */
export const NotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotesApiFp(configuration)
    return {
        /**
         * Sync notes with the server.
         * @summary Sync Notes
         * @param {NoteSyncRequest} noteSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncNotes(noteSyncRequest: NoteSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<NoteSyncResponse> {
            return localVarFp.syncNotes(noteSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotesApi - object-oriented interface
 * @export
 * @class NotesApi
 * @extends {BaseAPI}
 */
export class NotesApi extends BaseAPI {
    /**
     * Sync notes with the server.
     * @summary Sync Notes
     * @param {NoteSyncRequest} noteSyncRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotesApi
     */
    public syncNotes(noteSyncRequest: NoteSyncRequest, options?: RawAxiosRequestConfig) {
        return NotesApiFp(this.configuration).syncNotes(noteSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotetakerChatsApi - axios parameter creator
 * @export
 */
export const NotetakerChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a chat even after Cloud Sync has been disabled.
         * @summary Delete Notetaker Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotetakerChat: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('deleteNotetakerChat', 'chatId', chatId)
            const localVarPath = `/api/v1/notetaker-chats/{chat_id}`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Load one chronological page of messages for a session.  Without ``cursor`` or ``after`` the page holds the newest messages; pass ``next_cursor`` to fetch older messages as the user scrolls up. Pass ``after`` instead to fetch the oldest messages after a known ``sequence_index`` (continue with ``next_after``).
         * @summary List Notetaker Chat Messages
         * @param {string} chatId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {number | null} [after] Messages with a greater sequence_index, oldest first; not with cursor. Rows edited in place keep their index, so watch the chat\&#39;s modified_at for edits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotetakerChatMessages: async (chatId: string, cursor?: string | null, limit?: number, after?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('listNotetakerChatMessages', 'chatId', chatId)
            const localVarPath = `/api/v1/notetaker-chats/{chat_id}/messages`
                .replace(`{${"chat_id"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List hub or meeting-scoped sessions, newest activity first.  Omit ``cursor`` for the most recent page; pass ``next_cursor`` to continue into older sessions.
         * @summary List Notetaker Chats
         * @param {NotetakerChatScope} [scope] 
         * @param {string | null} [meetingId] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotetakerChats: async (scope?: NotetakerChatScope, meetingId?: string | null, cursor?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notetaker-chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (meetingId !== undefined) {
                localVarQueryParameter['meeting_id'] = meetingId;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload chat mutations when Cloud Sync is enabled.  Referenced meetings are validated up front, so a missing or unowned meeting rejects the entire batch before any write. Each chat then commits independently; a mid-batch conflict can leave earlier chats persisted. Clients should retry the whole batch because revisions are idempotent.  403 when Notetaker is not allowed for this user (Cloud Sync, HIPAA, or org policy; raised by ``ensure_notetaker_allowed``).  Args:     body: Batch of chat mutations to upload.     user: Authenticated owner of the chats and referenced meetings.     db:   Main database executor used for meeting validation.  Returns:     Acknowledgements for every successfully applied chat mutation.  Raises:     HTTPNotFound: A referenced meeting is missing or not owned by the caller.     HTTPConflict: A chat mutation conflicts with canonical state.
         * @summary Upload Notetaker Chats
         * @param {UploadNotetakerChatsRequest} uploadNotetakerChatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNotetakerChats: async (uploadNotetakerChatsRequest: UploadNotetakerChatsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadNotetakerChatsRequest' is not null or undefined
            assertParamExists('uploadNotetakerChats', 'uploadNotetakerChatsRequest', uploadNotetakerChatsRequest)
            const localVarPath = `/api/v1/notetaker-chats/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadNotetakerChatsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotetakerChatsApi - functional programming interface
 * @export
 */
export const NotetakerChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotetakerChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a chat even after Cloud Sync has been disabled.
         * @summary Delete Notetaker Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotetakerChat(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotetakerChat(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotetakerChatsApi.deleteNotetakerChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Load one chronological page of messages for a session.  Without ``cursor`` or ``after`` the page holds the newest messages; pass ``next_cursor`` to fetch older messages as the user scrolls up. Pass ``after`` instead to fetch the oldest messages after a known ``sequence_index`` (continue with ``next_after``).
         * @summary List Notetaker Chat Messages
         * @param {string} chatId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {number | null} [after] Messages with a greater sequence_index, oldest first; not with cursor. Rows edited in place keep their index, so watch the chat\&#39;s modified_at for edits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotetakerChatMessages(chatId: string, cursor?: string | null, limit?: number, after?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotetakerChatMessagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotetakerChatMessages(chatId, cursor, limit, after, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotetakerChatsApi.listNotetakerChatMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List hub or meeting-scoped sessions, newest activity first.  Omit ``cursor`` for the most recent page; pass ``next_cursor`` to continue into older sessions.
         * @summary List Notetaker Chats
         * @param {NotetakerChatScope} [scope] 
         * @param {string | null} [meetingId] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotetakerChats(scope?: NotetakerChatScope, meetingId?: string | null, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListNotetakerChatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotetakerChats(scope, meetingId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotetakerChatsApi.listNotetakerChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload chat mutations when Cloud Sync is enabled.  Referenced meetings are validated up front, so a missing or unowned meeting rejects the entire batch before any write. Each chat then commits independently; a mid-batch conflict can leave earlier chats persisted. Clients should retry the whole batch because revisions are idempotent.  403 when Notetaker is not allowed for this user (Cloud Sync, HIPAA, or org policy; raised by ``ensure_notetaker_allowed``).  Args:     body: Batch of chat mutations to upload.     user: Authenticated owner of the chats and referenced meetings.     db:   Main database executor used for meeting validation.  Returns:     Acknowledgements for every successfully applied chat mutation.  Raises:     HTTPNotFound: A referenced meeting is missing or not owned by the caller.     HTTPConflict: A chat mutation conflicts with canonical state.
         * @summary Upload Notetaker Chats
         * @param {UploadNotetakerChatsRequest} uploadNotetakerChatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadNotetakerChats(uploadNotetakerChatsRequest: UploadNotetakerChatsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadNotetakerChatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadNotetakerChats(uploadNotetakerChatsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotetakerChatsApi.uploadNotetakerChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotetakerChatsApi - factory interface
 * @export
 */
export const NotetakerChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotetakerChatsApiFp(configuration)
    return {
        /**
         * Delete a chat even after Cloud Sync has been disabled.
         * @summary Delete Notetaker Chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotetakerChat(chatId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteNotetakerChat(chatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Load one chronological page of messages for a session.  Without ``cursor`` or ``after`` the page holds the newest messages; pass ``next_cursor`` to fetch older messages as the user scrolls up. Pass ``after`` instead to fetch the oldest messages after a known ``sequence_index`` (continue with ``next_after``).
         * @summary List Notetaker Chat Messages
         * @param {string} chatId 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {number | null} [after] Messages with a greater sequence_index, oldest first; not with cursor. Rows edited in place keep their index, so watch the chat\&#39;s modified_at for edits.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotetakerChatMessages(chatId: string, cursor?: string | null, limit?: number, after?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<ListNotetakerChatMessagesResponse> {
            return localVarFp.listNotetakerChatMessages(chatId, cursor, limit, after, options).then((request) => request(axios, basePath));
        },
        /**
         * List hub or meeting-scoped sessions, newest activity first.  Omit ``cursor`` for the most recent page; pass ``next_cursor`` to continue into older sessions.
         * @summary List Notetaker Chats
         * @param {NotetakerChatScope} [scope] 
         * @param {string | null} [meetingId] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotetakerChats(scope?: NotetakerChatScope, meetingId?: string | null, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListNotetakerChatsResponse> {
            return localVarFp.listNotetakerChats(scope, meetingId, cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload chat mutations when Cloud Sync is enabled.  Referenced meetings are validated up front, so a missing or unowned meeting rejects the entire batch before any write. Each chat then commits independently; a mid-batch conflict can leave earlier chats persisted. Clients should retry the whole batch because revisions are idempotent.  403 when Notetaker is not allowed for this user (Cloud Sync, HIPAA, or org policy; raised by ``ensure_notetaker_allowed``).  Args:     body: Batch of chat mutations to upload.     user: Authenticated owner of the chats and referenced meetings.     db:   Main database executor used for meeting validation.  Returns:     Acknowledgements for every successfully applied chat mutation.  Raises:     HTTPNotFound: A referenced meeting is missing or not owned by the caller.     HTTPConflict: A chat mutation conflicts with canonical state.
         * @summary Upload Notetaker Chats
         * @param {UploadNotetakerChatsRequest} uploadNotetakerChatsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadNotetakerChats(uploadNotetakerChatsRequest: UploadNotetakerChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadNotetakerChatsResponse> {
            return localVarFp.uploadNotetakerChats(uploadNotetakerChatsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotetakerChatsApi - object-oriented interface
 * @export
 * @class NotetakerChatsApi
 * @extends {BaseAPI}
 */
export class NotetakerChatsApi extends BaseAPI {
    /**
     * Delete a chat even after Cloud Sync has been disabled.
     * @summary Delete Notetaker Chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotetakerChatsApi
     */
    public deleteNotetakerChat(chatId: string, options?: RawAxiosRequestConfig) {
        return NotetakerChatsApiFp(this.configuration).deleteNotetakerChat(chatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Load one chronological page of messages for a session.  Without ``cursor`` or ``after`` the page holds the newest messages; pass ``next_cursor`` to fetch older messages as the user scrolls up. Pass ``after`` instead to fetch the oldest messages after a known ``sequence_index`` (continue with ``next_after``).
     * @summary List Notetaker Chat Messages
     * @param {string} chatId 
     * @param {string | null} [cursor] 
     * @param {number} [limit] 
     * @param {number | null} [after] Messages with a greater sequence_index, oldest first; not with cursor. Rows edited in place keep their index, so watch the chat\&#39;s modified_at for edits.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotetakerChatsApi
     */
    public listNotetakerChatMessages(chatId: string, cursor?: string | null, limit?: number, after?: number | null, options?: RawAxiosRequestConfig) {
        return NotetakerChatsApiFp(this.configuration).listNotetakerChatMessages(chatId, cursor, limit, after, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List hub or meeting-scoped sessions, newest activity first.  Omit ``cursor`` for the most recent page; pass ``next_cursor`` to continue into older sessions.
     * @summary List Notetaker Chats
     * @param {NotetakerChatScope} [scope] 
     * @param {string | null} [meetingId] 
     * @param {string | null} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotetakerChatsApi
     */
    public listNotetakerChats(scope?: NotetakerChatScope, meetingId?: string | null, cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return NotetakerChatsApiFp(this.configuration).listNotetakerChats(scope, meetingId, cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload chat mutations when Cloud Sync is enabled.  Referenced meetings are validated up front, so a missing or unowned meeting rejects the entire batch before any write. Each chat then commits independently; a mid-batch conflict can leave earlier chats persisted. Clients should retry the whole batch because revisions are idempotent.  403 when Notetaker is not allowed for this user (Cloud Sync, HIPAA, or org policy; raised by ``ensure_notetaker_allowed``).  Args:     body: Batch of chat mutations to upload.     user: Authenticated owner of the chats and referenced meetings.     db:   Main database executor used for meeting validation.  Returns:     Acknowledgements for every successfully applied chat mutation.  Raises:     HTTPNotFound: A referenced meeting is missing or not owned by the caller.     HTTPConflict: A chat mutation conflicts with canonical state.
     * @summary Upload Notetaker Chats
     * @param {UploadNotetakerChatsRequest} uploadNotetakerChatsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotetakerChatsApi
     */
    public uploadNotetakerChats(uploadNotetakerChatsRequest: UploadNotetakerChatsRequest, options?: RawAxiosRequestConfig) {
        return NotetakerChatsApiFp(this.configuration).uploadNotetakerChats(uploadNotetakerChatsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archive all of the current user\'s notifications.
         * @summary Archive All Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAllNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/archive_all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive the given notifications. Only the notifications owned by the caller are archived.
         * @summary Archive Notification
         * @param {ArchiveNotificationRequest} archiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNotification: async (archiveNotificationRequest: ArchiveNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'archiveNotificationRequest' is not null or undefined
            assertParamExists('archiveNotification', 'archiveNotificationRequest', archiveNotificationRequest)
            const localVarPath = `/api/v1/notification/archive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archiveNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Broadcast an announcement notification to all users (wispr.ai admins only).  Used by the admin dashboard to fan a single announcement out to every user; restricted to wispr.ai admin accounts.
         * @summary Create Announcement
         * @param {BulkAnnouncementCreateRequest} bulkAnnouncementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement: async (bulkAnnouncementCreateRequest: BulkAnnouncementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkAnnouncementCreateRequest' is not null or undefined
            assertParamExists('createAnnouncement', 'bulkAnnouncementCreateRequest', bulkAnnouncementCreateRequest)
            const localVarPath = `/api/v1/notification/internal/announce`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAnnouncementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a notification for the specified user emails (wispr.ai admins only).  Used by the admin dashboard to send targeted notifications; restricted to wispr.ai admin accounts.
         * @summary Create Internal Notification
         * @param {InternalNotificationCreateRequest} internalNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInternalNotification: async (internalNotificationCreateRequest: InternalNotificationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'internalNotificationCreateRequest' is not null or undefined
            assertParamExists('createInternalNotification', 'internalNotificationCreateRequest', internalNotificationCreateRequest)
            const localVarPath = `/api/v1/notification/internal/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalNotificationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a notification for the current user, triggered by a client-side event.
         * @summary Create Notification
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (notificationCreateRequest: NotificationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationCreateRequest' is not null or undefined
            assertParamExists('createNotification', 'notificationCreateRequest', notificationCreateRequest)
            const localVarPath = `/api/v1/notification/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a notification by ID (internal; protected by the root API key).
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotification', 'notificationId', notificationId)
            const localVarPath = `/api/v1/notification/internal/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a paginated list of the current user\'s notifications plus the unread count.  Supports filtering by archived status and platform, and takes the client\'s last-read timestamp (Unix milliseconds) to compute the unread count.
         * @summary Get Notifications
         * @param {boolean | null} [isArchived] Filter by archived status
         * @param {NotificationPlatformType | null} [platform] Filter by platform type (desktop, ios, both)
         * @param {string | null} [lastNotificationReadTime] Timestamp of last read notification as Unix timestamp in milliseconds. Example: 1763423065738
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (isArchived?: boolean | null, platform?: NotificationPlatformType | null, lastNotificationReadTime?: string | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isArchived !== undefined) {
                localVarQueryParameter['is_archived'] = isArchived;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (lastNotificationReadTime !== undefined) {
                localVarQueryParameter['last_notification_read_time'] = lastNotificationReadTime;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Text the iOS beta download link to the supplied phone number.
         * @summary Send Ios Download Link
         * @param {SendSMSRequest} sendSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendIosDownloadLink: async (sendSMSRequest: SendSMSRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendSMSRequest' is not null or undefined
            assertParamExists('sendIosDownloadLink', 'sendSMSRequest', sendSMSRequest)
            const localVarPath = `/api/v1/notification/send-ios`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendSMSRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * Archive all of the current user\'s notifications.
         * @summary Archive All Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveAllNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveAllNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.archiveAllNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive the given notifications. Only the notifications owned by the caller are archived.
         * @summary Archive Notification
         * @param {ArchiveNotificationRequest} archiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveNotification(archiveNotificationRequest: ArchiveNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveNotification(archiveNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.archiveNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Broadcast an announcement notification to all users (wispr.ai admins only).  Used by the admin dashboard to fan a single announcement out to every user; restricted to wispr.ai admin accounts.
         * @summary Create Announcement
         * @param {BulkAnnouncementCreateRequest} bulkAnnouncementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAnnouncement(bulkAnnouncementCreateRequest: BulkAnnouncementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAnnouncement(bulkAnnouncementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createAnnouncement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a notification for the specified user emails (wispr.ai admins only).  Used by the admin dashboard to send targeted notifications; restricted to wispr.ai admin accounts.
         * @summary Create Internal Notification
         * @param {InternalNotificationCreateRequest} internalNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInternalNotification(internalNotificationCreateRequest: InternalNotificationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInternalNotification(internalNotificationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createInternalNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a notification for the current user, triggered by a client-side event.
         * @summary Create Notification
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(notificationCreateRequest: NotificationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(notificationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.createNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a notification by ID (internal; protected by the root API key).
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.deleteNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a paginated list of the current user\'s notifications plus the unread count.  Supports filtering by archived status and platform, and takes the client\'s last-read timestamp (Unix milliseconds) to compute the unread count.
         * @summary Get Notifications
         * @param {boolean | null} [isArchived] Filter by archived status
         * @param {NotificationPlatformType | null} [platform] Filter by platform type (desktop, ios, both)
         * @param {string | null} [lastNotificationReadTime] Timestamp of last read notification as Unix timestamp in milliseconds. Example: 1763423065738
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(isArchived?: boolean | null, platform?: NotificationPlatformType | null, lastNotificationReadTime?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(isArchived, platform, lastNotificationReadTime, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Text the iOS beta download link to the supplied phone number.
         * @summary Send Ios Download Link
         * @param {SendSMSRequest} sendSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendIosDownloadLink(sendSMSRequest: SendSMSRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendIosDownloadLink(sendSMSRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.sendIosDownloadLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * Archive all of the current user\'s notifications.
         * @summary Archive All Notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveAllNotifications(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.archiveAllNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * Archive the given notifications. Only the notifications owned by the caller are archived.
         * @summary Archive Notification
         * @param {ArchiveNotificationRequest} archiveNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveNotification(archiveNotificationRequest: ArchiveNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.archiveNotification(archiveNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Broadcast an announcement notification to all users (wispr.ai admins only).  Used by the admin dashboard to fan a single announcement out to every user; restricted to wispr.ai admin accounts.
         * @summary Create Announcement
         * @param {BulkAnnouncementCreateRequest} bulkAnnouncementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnnouncement(bulkAnnouncementCreateRequest: BulkAnnouncementCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createAnnouncement(bulkAnnouncementCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a notification for the specified user emails (wispr.ai admins only).  Used by the admin dashboard to send targeted notifications; restricted to wispr.ai admin accounts.
         * @summary Create Internal Notification
         * @param {InternalNotificationCreateRequest} internalNotificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInternalNotification(internalNotificationCreateRequest: InternalNotificationCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createInternalNotification(internalNotificationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a notification for the current user, triggered by a client-side event.
         * @summary Create Notification
         * @param {NotificationCreateRequest} notificationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(notificationCreateRequest: NotificationCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<NotificationResponse> {
            return localVarFp.createNotification(notificationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a notification by ID (internal; protected by the root API key).
         * @summary Delete Notification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a paginated list of the current user\'s notifications plus the unread count.  Supports filtering by archived status and platform, and takes the client\'s last-read timestamp (Unix milliseconds) to compute the unread count.
         * @summary Get Notifications
         * @param {boolean | null} [isArchived] Filter by archived status
         * @param {NotificationPlatformType | null} [platform] Filter by platform type (desktop, ios, both)
         * @param {string | null} [lastNotificationReadTime] Timestamp of last read notification as Unix timestamp in milliseconds. Example: 1763423065738
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(isArchived?: boolean | null, platform?: NotificationPlatformType | null, lastNotificationReadTime?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<NotificationListResponse> {
            return localVarFp.getNotifications(isArchived, platform, lastNotificationReadTime, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Text the iOS beta download link to the supplied phone number.
         * @summary Send Ios Download Link
         * @param {SendSMSRequest} sendSMSRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendIosDownloadLink(sendSMSRequest: SendSMSRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendIosDownloadLink(sendSMSRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * Archive all of the current user\'s notifications.
     * @summary Archive All Notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public archiveAllNotifications(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).archiveAllNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive the given notifications. Only the notifications owned by the caller are archived.
     * @summary Archive Notification
     * @param {ArchiveNotificationRequest} archiveNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public archiveNotification(archiveNotificationRequest: ArchiveNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).archiveNotification(archiveNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Broadcast an announcement notification to all users (wispr.ai admins only).  Used by the admin dashboard to fan a single announcement out to every user; restricted to wispr.ai admin accounts.
     * @summary Create Announcement
     * @param {BulkAnnouncementCreateRequest} bulkAnnouncementCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public createAnnouncement(bulkAnnouncementCreateRequest: BulkAnnouncementCreateRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createAnnouncement(bulkAnnouncementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a notification for the specified user emails (wispr.ai admins only).  Used by the admin dashboard to send targeted notifications; restricted to wispr.ai admin accounts.
     * @summary Create Internal Notification
     * @param {InternalNotificationCreateRequest} internalNotificationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public createInternalNotification(internalNotificationCreateRequest: InternalNotificationCreateRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createInternalNotification(internalNotificationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a notification for the current user, triggered by a client-side event.
     * @summary Create Notification
     * @param {NotificationCreateRequest} notificationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public createNotification(notificationCreateRequest: NotificationCreateRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).createNotification(notificationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a notification by ID (internal; protected by the root API key).
     * @summary Delete Notification
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public deleteNotification(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).deleteNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a paginated list of the current user\'s notifications plus the unread count.  Supports filtering by archived status and platform, and takes the client\'s last-read timestamp (Unix milliseconds) to compute the unread count.
     * @summary Get Notifications
     * @param {boolean | null} [isArchived] Filter by archived status
     * @param {NotificationPlatformType | null} [platform] Filter by platform type (desktop, ios, both)
     * @param {string | null} [lastNotificationReadTime] Timestamp of last read notification as Unix timestamp in milliseconds. Example: 1763423065738
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotifications(isArchived?: boolean | null, platform?: NotificationPlatformType | null, lastNotificationReadTime?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotifications(isArchived, platform, lastNotificationReadTime, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Text the iOS beta download link to the supplied phone number.
     * @summary Send Ios Download Link
     * @param {SendSMSRequest} sendSMSRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public sendIosDownloadLink(sendSMSRequest: SendSMSRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).sendIosDownloadLink(sendSMSRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Render the cancelled-checkout page for an abandoned Stripe session.  Stripe always substitutes ``{CHECKOUT_SESSION_ID}`` in the registered cancel_url before redirecting, so a legitimate hit always carries a ``session_id``. Declaring it required lets FastAPI 422 bot/crawler traffic at the boundary (no Stripe call, no template render) and closes the log-amplification vector on this unauthenticated endpoint. Value-level garbage (``undefined``, ``null``, unreplaced ``{CHECKOUT_SESSION_ID}`` literals) is filtered in the service. No bearer tokens are accepted here — the Stripe session_id is the capability token.
         * @summary Cancel
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('cancel', 'sessionId', sessionId)
            const localVarPath = `/api/v1/payment/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel the current user\'s subscription.
         * @summary Cancel Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a bank-transfer invoice for the given plan (EU customers).
         * @summary Create Bank Transfer Invoice
         * @param {StripeProductOption} plan 
         * @param {string} [currency] 
         * @param {EUCountry} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransferInvoice: async (plan: StripeProductOption, currency?: string, country?: EUCountry, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plan' is not null or undefined
            assertParamExists('createBankTransferInvoice', 'plan', plan)
            const localVarPath = `/api/v1/payment/create-bank-transfer-invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plan !== undefined) {
                localVarQueryParameter['plan'] = plan;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe Checkout session.
         * @summary Create Checkout Session
         * @param {StripeProductOption} plan 
         * @param {boolean} [customRedirect] 
         * @param {string | null} [promoCode] 
         * @param {string} [currency] 
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Re-validated server-side against the registry; invalid or stale claims fall back to canonical pricing.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession: async (plan: StripeProductOption, customRedirect?: boolean, promoCode?: string | null, currency?: string, variant?: string | null, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'plan' is not null or undefined
            assertParamExists('createCheckoutSession', 'plan', plan)
            const localVarPath = `/api/v1/payment/create-checkout-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (plan !== undefined) {
                localVarQueryParameter['plan'] = plan;
            }

            if (customRedirect !== undefined) {
                localVarQueryParameter['custom_redirect'] = customRedirect;
            }

            if (promoCode !== undefined) {
                localVarQueryParameter['promo_code'] = promoCode;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (ga4ClientId !== undefined) {
                localVarQueryParameter['ga4_client_id'] = ga4ClientId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (fbp !== undefined) {
                localVarQueryParameter['fbp'] = fbp;
            }

            if (fbc !== undefined) {
                localVarQueryParameter['fbc'] = fbc;
            }

            if (utmSource !== undefined) {
                localVarQueryParameter['utm_source'] = utmSource;
            }

            if (utmMedium !== undefined) {
                localVarQueryParameter['utm_medium'] = utmMedium;
            }

            if (utmCampaign !== undefined) {
                localVarQueryParameter['utm_campaign'] = utmCampaign;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an enterprise Stripe Checkout session.  Optional GA4 params for attribution tracking.
         * @summary Create Enterprise Checkout Session
         * @param {CreateEnterpriseCheckoutRequest} createEnterpriseCheckoutRequest 
         * @param {Currency} [currency] Deprecated: ignored for pricing. The checkout currency is resolved server-side from the caller\&#39;s IP (WP-7177). Retained only for backwards compatibility with existing clients.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseCheckoutSession: async (createEnterpriseCheckoutRequest: CreateEnterpriseCheckoutRequest, currency?: Currency, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEnterpriseCheckoutRequest' is not null or undefined
            assertParamExists('createEnterpriseCheckoutSession', 'createEnterpriseCheckoutRequest', createEnterpriseCheckoutRequest)
            const localVarPath = `/api/v1/payment/create_enterprise_checkout_session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (ga4ClientId !== undefined) {
                localVarQueryParameter['ga4_client_id'] = ga4ClientId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (fbp !== undefined) {
                localVarQueryParameter['fbp'] = fbp;
            }

            if (fbc !== undefined) {
                localVarQueryParameter['fbc'] = fbc;
            }

            if (utmSource !== undefined) {
                localVarQueryParameter['utm_source'] = utmSource;
            }

            if (utmMedium !== undefined) {
                localVarQueryParameter['utm_medium'] = utmMedium;
            }

            if (utmCampaign !== undefined) {
                localVarQueryParameter['utm_campaign'] = utmCampaign;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEnterpriseCheckoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Stripe promotion code from a coupon for the given email (root API key).
         * @summary Create Promotion Code
         * @param {string} couponCode 
         * @param {string} email 
         * @param {number} [expiresInDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromotionCode: async (couponCode: string, email: string, expiresInDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponCode' is not null or undefined
            assertParamExists('createPromotionCode', 'couponCode', couponCode)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('createPromotionCode', 'email', email)
            const localVarPath = `/api/v1/payment/create-promotion-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (couponCode !== undefined) {
                localVarQueryParameter['coupon_code'] = couponCode;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (expiresInDays !== undefined) {
                localVarQueryParameter['expires_in_days'] = expiresInDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a URL to the Stripe customer billing portal for the current user.
         * @summary Customer Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerPortal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/customer-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a URL to the Stripe billing portal for the caller\'s enterprise (admins only).
         * @summary Enterprise Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterprisePortal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/enterprise-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Render the payment error page for a failed checkout.
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/error`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the currency for a given country code.
         * @summary Get Currency By Country Code
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyByCountryCode: async (countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getCurrencyByCountryCode', 'countryCode', countryCode)
            const localVarPath = `/api/v1/payment/currency/by-country-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['country_code'] = countryCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the current user\'s subscription details, applying pending enterprise auto-join first.
         * @summary Get Subscription Details
         * @param {string | null} [deviceId] The device ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails: async (deviceId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deviceId !== undefined) {
                localVarQueryParameter['device_id'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle an incoming Stripe metadata webhook event.
         * @summary Metadata Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataWebhookReceived: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/metadata-webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Migrate a user\'s subscription (personal or enterprise) to a new currency.  - If the user belongs to an enterprise (has `enterprise_id`), attempt to migrate   the enterprise subscription. - Otherwise, migrate the user\'s personal subscription.
         * @summary Migrate Subscription
         * @param {Currency} targetCurrency 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateSubscription: async (targetCurrency: Currency, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetCurrency' is not null or undefined
            assertParamExists('migrateSubscription', 'targetCurrency', targetCurrency)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('migrateSubscription', 'userId', userId)
            const localVarPath = `/api/v1/payment/migrate-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (targetCurrency !== undefined) {
                localVarQueryParameter['target_currency'] = targetCurrency;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the catalog pricing grid for an explicit currency, without an IP lookup.  Powers the current-plan billing card, which prices in the subscription\'s own currency rather than the caller\'s geo-IP currency. Public catalog pricing only — no user data.
         * @summary Pricing By Currency
         * @param {Currency} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingByCurrency: async (currency: Currency, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('pricingByCurrency', 'currency', currency)
            const localVarPath = `/api/v1/payment/pricing/by-currency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return location-aware pricing resolved from the caller\'s IP.
         * @summary Pricing By Ip
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Returns variant-specific price IDs for the resolved currency; invalid or stale claims fall back to canonical pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingByIp: async (variant?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/pricing/by-ip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle a RevenueCat webhook.
         * @summary Revenuecat Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenuecatWebhookReceived: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/revenuecat/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start (or atomically replace) a billing subscription invalidation watch session.
         * @summary Subscription Watch Start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionWatchStart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/subscription-watch/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SSE stream of ``subscription_changed`` invalidations for billing UI (20m TTL).
         * @summary Subscription Watch Stream
         * @param {string} xBillingWatchToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionWatchStream: async (xBillingWatchToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBillingWatchToken' is not null or undefined
            assertParamExists('subscriptionWatchStream', 'xBillingWatchToken', xBillingWatchToken)
            const localVarPath = `/api/v1/payment/subscription-watch/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            if (xBillingWatchToken != null) {
                localVarHeaderParameter['X-Billing-Watch-Token'] = String(xBillingWatchToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Render the post-checkout success page for a completed payment.
         * @summary Success
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        success: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('success', 'sessionId', sessionId)
            const localVarPath = `/api/v1/payment/success`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Switch an enterprise subscription to a new plan.  This endpoint: 1. Validates the user is an admin 2. Validates the new plan is valid and different from current 3. Records MSA and DPA acceptance for a Growth (variant) switch, and reports a missing one 4. Updates the subscription in Stripe 5. Updates the database record 6. Returns the updated subscription details
         * @summary Switch Enterprise Plan
         * @param {SwitchEnterprisePlanRequest} switchEnterprisePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchEnterprisePlan: async (switchEnterprisePlanRequest: SwitchEnterprisePlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'switchEnterprisePlanRequest' is not null or undefined
            assertParamExists('switchEnterprisePlan', 'switchEnterprisePlanRequest', switchEnterprisePlanRequest)
            const localVarPath = `/api/v1/payment/enterprise/switch-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchEnterprisePlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Switch the current user\'s subscription to a new plan.
         * @summary Switch Plan
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchPlan: async (switchPlanRequest: SwitchPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'switchPlanRequest' is not null or undefined
            assertParamExists('switchPlan', 'switchPlanRequest', switchPlanRequest)
            const localVarPath = `/api/v1/payment/switch-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Switch a user\'s subscription plan by email (internal support tool, root API key).
         * @summary Switch Support Plan
         * @param {string} email The email of the user to switch the plan for
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchSupportPlan: async (email: string, switchPlanRequest: SwitchPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('switchSupportPlan', 'email', email)
            // verify required parameter 'switchPlanRequest' is not null or undefined
            assertParamExists('switchSupportPlan', 'switchPlanRequest', switchPlanRequest)
            const localVarPath = `/api/v1/payment/support/switch-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(switchPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle an incoming Stripe webhook event.
         * @summary Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookReceived: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Render the cancelled-checkout page for an abandoned Stripe session.  Stripe always substitutes ``{CHECKOUT_SESSION_ID}`` in the registered cancel_url before redirecting, so a legitimate hit always carries a ``session_id``. Declaring it required lets FastAPI 422 bot/crawler traffic at the boundary (no Stripe call, no template render) and closes the log-amplification vector on this unauthenticated endpoint. Value-level garbage (``undefined``, ``null``, unreplaced ``{CHECKOUT_SESSION_ID}`` literals) is filtered in the service. No bearer tokens are accepted here — the Stripe session_id is the capability token.
         * @summary Cancel
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel the current user\'s subscription.
         * @summary Cancel Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a bank-transfer invoice for the given plan (EU customers).
         * @summary Create Bank Transfer Invoice
         * @param {StripeProductOption} plan 
         * @param {string} [currency] 
         * @param {EUCountry} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankTransferInvoice(plan: StripeProductOption, currency?: string, country?: EUCountry, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankTransferInvoice(plan, currency, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createBankTransferInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe Checkout session.
         * @summary Create Checkout Session
         * @param {StripeProductOption} plan 
         * @param {boolean} [customRedirect] 
         * @param {string | null} [promoCode] 
         * @param {string} [currency] 
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Re-validated server-side against the registry; invalid or stale claims fall back to canonical pricing.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCheckoutSession(plan: StripeProductOption, customRedirect?: boolean, promoCode?: string | null, currency?: string, variant?: string | null, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCheckoutSession(plan, customRedirect, promoCode, currency, variant, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an enterprise Stripe Checkout session.  Optional GA4 params for attribution tracking.
         * @summary Create Enterprise Checkout Session
         * @param {CreateEnterpriseCheckoutRequest} createEnterpriseCheckoutRequest 
         * @param {Currency} [currency] Deprecated: ignored for pricing. The checkout currency is resolved server-side from the caller\&#39;s IP (WP-7177). Retained only for backwards compatibility with existing clients.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest: CreateEnterpriseCheckoutRequest, currency?: Currency, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest, currency, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createEnterpriseCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Stripe promotion code from a coupon for the given email (root API key).
         * @summary Create Promotion Code
         * @param {string} couponCode 
         * @param {string} email 
         * @param {number} [expiresInDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPromotionCode(couponCode: string, email: string, expiresInDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPromotionCode(couponCode, email, expiresInDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.createPromotionCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a URL to the Stripe customer billing portal for the current user.
         * @summary Customer Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerPortal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerPortal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.customerPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a URL to the Stripe billing portal for the caller\'s enterprise (admins only).
         * @summary Enterprise Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enterprisePortal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enterprisePortal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.enterprisePortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Render the payment error page for a failed checkout.
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async error(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.error(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.error']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the currency for a given country code.
         * @summary Get Currency By Country Code
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencyByCountryCode(countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencyByCountryCode(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getCurrencyByCountryCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the current user\'s subscription details, applying pending enterprise auto-join first.
         * @summary Get Subscription Details
         * @param {string | null} [deviceId] The device ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionDetails(deviceId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionDetails(deviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.getSubscriptionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle an incoming Stripe metadata webhook event.
         * @summary Metadata Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metadataWebhookReceived(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metadataWebhookReceived(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.metadataWebhookReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Migrate a user\'s subscription (personal or enterprise) to a new currency.  - If the user belongs to an enterprise (has `enterprise_id`), attempt to migrate   the enterprise subscription. - Otherwise, migrate the user\'s personal subscription.
         * @summary Migrate Subscription
         * @param {Currency} targetCurrency 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async migrateSubscription(targetCurrency: Currency, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.migrateSubscription(targetCurrency, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.migrateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the catalog pricing grid for an explicit currency, without an IP lookup.  Powers the current-plan billing card, which prices in the subscription\'s own currency rather than the caller\'s geo-IP currency. Public catalog pricing only — no user data.
         * @summary Pricing By Currency
         * @param {Currency} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingByCurrency(currency: Currency, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyPricingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingByCurrency(currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.pricingByCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return location-aware pricing resolved from the caller\'s IP.
         * @summary Pricing By Ip
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Returns variant-specific price IDs for the resolved currency; invalid or stale claims fall back to canonical pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingByIp(variant?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingByIpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingByIp(variant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.pricingByIp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle a RevenueCat webhook.
         * @summary Revenuecat Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revenuecatWebhookReceived(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revenuecatWebhookReceived(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.revenuecatWebhookReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start (or atomically replace) a billing subscription invalidation watch session.
         * @summary Subscription Watch Start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionWatchStart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionWatchStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionWatchStart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.subscriptionWatchStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SSE stream of ``subscription_changed`` invalidations for billing UI (20m TTL).
         * @summary Subscription Watch Stream
         * @param {string} xBillingWatchToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscriptionWatchStream(xBillingWatchToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionWatchStream(xBillingWatchToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.subscriptionWatchStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Render the post-checkout success page for a completed payment.
         * @summary Success
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async success(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.success(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.success']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Switch an enterprise subscription to a new plan.  This endpoint: 1. Validates the user is an admin 2. Validates the new plan is valid and different from current 3. Records MSA and DPA acceptance for a Growth (variant) switch, and reports a missing one 4. Updates the subscription in Stripe 5. Updates the database record 6. Returns the updated subscription details
         * @summary Switch Enterprise Plan
         * @param {SwitchEnterprisePlanRequest} switchEnterprisePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchEnterprisePlan(switchEnterprisePlanRequest: SwitchEnterprisePlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchEnterprisePlan(switchEnterprisePlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.switchEnterprisePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Switch the current user\'s subscription to a new plan.
         * @summary Switch Plan
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchPlan(switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchPlan(switchPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.switchPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Switch a user\'s subscription plan by email (internal support tool, root API key).
         * @summary Switch Support Plan
         * @param {string} email The email of the user to switch the plan for
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async switchSupportPlan(email: string, switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.switchSupportPlan(email, switchPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.switchSupportPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle an incoming Stripe webhook event.
         * @summary Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookReceived(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookReceived(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentsApi.webhookReceived']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * Render the cancelled-checkout page for an abandoned Stripe session.  Stripe always substitutes ``{CHECKOUT_SESSION_ID}`` in the registered cancel_url before redirecting, so a legitimate hit always carries a ``session_id``. Declaring it required lets FastAPI 422 bot/crawler traffic at the boundary (no Stripe call, no template render) and closes the log-amplification vector on this unauthenticated endpoint. Value-level garbage (``undefined``, ``null``, unreplaced ``{CHECKOUT_SESSION_ID}`` literals) is filtered in the service. No bearer tokens are accepted here — the Stripe session_id is the capability token.
         * @summary Cancel
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.cancel(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel the current user\'s subscription.
         * @summary Cancel Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.cancelSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a bank-transfer invoice for the given plan (EU customers).
         * @summary Create Bank Transfer Invoice
         * @param {StripeProductOption} plan 
         * @param {string} [currency] 
         * @param {EUCountry} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankTransferInvoice(plan: StripeProductOption, currency?: string, country?: EUCountry, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createBankTransferInvoice(plan, currency, country, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe Checkout session.
         * @summary Create Checkout Session
         * @param {StripeProductOption} plan 
         * @param {boolean} [customRedirect] 
         * @param {string | null} [promoCode] 
         * @param {string} [currency] 
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Re-validated server-side against the registry; invalid or stale claims fall back to canonical pricing.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCheckoutSession(plan: StripeProductOption, customRedirect?: boolean, promoCode?: string | null, currency?: string, variant?: string | null, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createCheckoutSession(plan, customRedirect, promoCode, currency, variant, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an enterprise Stripe Checkout session.  Optional GA4 params for attribution tracking.
         * @summary Create Enterprise Checkout Session
         * @param {CreateEnterpriseCheckoutRequest} createEnterpriseCheckoutRequest 
         * @param {Currency} [currency] Deprecated: ignored for pricing. The checkout currency is resolved server-side from the caller\&#39;s IP (WP-7177). Retained only for backwards compatibility with existing clients.
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest: CreateEnterpriseCheckoutRequest, currency?: Currency, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest, currency, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Stripe promotion code from a coupon for the given email (root API key).
         * @summary Create Promotion Code
         * @param {string} couponCode 
         * @param {string} email 
         * @param {number} [expiresInDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPromotionCode(couponCode: string, email: string, expiresInDays?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createPromotionCode(couponCode, email, expiresInDays, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a URL to the Stripe customer billing portal for the current user.
         * @summary Customer Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerPortal(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.customerPortal(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a URL to the Stripe billing portal for the caller\'s enterprise (admins only).
         * @summary Enterprise Portal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enterprisePortal(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.enterprisePortal(options).then((request) => request(axios, basePath));
        },
        /**
         * Render the payment error page for a failed checkout.
         * @summary Error
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        error(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.error(options).then((request) => request(axios, basePath));
        },
        /**
         * Return the currency for a given country code.
         * @summary Get Currency By Country Code
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencyByCountryCode(countryCode: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCurrencyByCountryCode(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the current user\'s subscription details, applying pending enterprise auto-join first.
         * @summary Get Subscription Details
         * @param {string | null} [deviceId] The device ID of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionDetails(deviceId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getSubscriptionDetails(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle an incoming Stripe metadata webhook event.
         * @summary Metadata Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metadataWebhookReceived(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.metadataWebhookReceived(options).then((request) => request(axios, basePath));
        },
        /**
         * Migrate a user\'s subscription (personal or enterprise) to a new currency.  - If the user belongs to an enterprise (has `enterprise_id`), attempt to migrate   the enterprise subscription. - Otherwise, migrate the user\'s personal subscription.
         * @summary Migrate Subscription
         * @param {Currency} targetCurrency 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateSubscription(targetCurrency: Currency, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.migrateSubscription(targetCurrency, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the catalog pricing grid for an explicit currency, without an IP lookup.  Powers the current-plan billing card, which prices in the subscription\'s own currency rather than the caller\'s geo-IP currency. Public catalog pricing only — no user data.
         * @summary Pricing By Currency
         * @param {Currency} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingByCurrency(currency: Currency, options?: RawAxiosRequestConfig): AxiosPromise<CurrencyPricingResponse> {
            return localVarFp.pricingByCurrency(currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Return location-aware pricing resolved from the caller\'s IP.
         * @summary Pricing By Ip
         * @param {string | null} [variant] Optional pricing-experiment variant claim. Returns variant-specific price IDs for the resolved currency; invalid or stale claims fall back to canonical pricing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingByIp(variant?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PricingByIpResponse> {
            return localVarFp.pricingByIp(variant, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle a RevenueCat webhook.
         * @summary Revenuecat Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revenuecatWebhookReceived(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revenuecatWebhookReceived(options).then((request) => request(axios, basePath));
        },
        /**
         * Start (or atomically replace) a billing subscription invalidation watch session.
         * @summary Subscription Watch Start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionWatchStart(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionWatchStartResponse> {
            return localVarFp.subscriptionWatchStart(options).then((request) => request(axios, basePath));
        },
        /**
         * SSE stream of ``subscription_changed`` invalidations for billing UI (20m TTL).
         * @summary Subscription Watch Stream
         * @param {string} xBillingWatchToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscriptionWatchStream(xBillingWatchToken: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.subscriptionWatchStream(xBillingWatchToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Render the post-checkout success page for a completed payment.
         * @summary Success
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        success(sessionId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.success(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Switch an enterprise subscription to a new plan.  This endpoint: 1. Validates the user is an admin 2. Validates the new plan is valid and different from current 3. Records MSA and DPA acceptance for a Growth (variant) switch, and reports a missing one 4. Updates the subscription in Stripe 5. Updates the database record 6. Returns the updated subscription details
         * @summary Switch Enterprise Plan
         * @param {SwitchEnterprisePlanRequest} switchEnterprisePlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchEnterprisePlan(switchEnterprisePlanRequest: SwitchEnterprisePlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.switchEnterprisePlan(switchEnterprisePlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Switch the current user\'s subscription to a new plan.
         * @summary Switch Plan
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchPlan(switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.switchPlan(switchPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Switch a user\'s subscription plan by email (internal support tool, root API key).
         * @summary Switch Support Plan
         * @param {string} email The email of the user to switch the plan for
         * @param {SwitchPlanRequest} switchPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchSupportPlan(email: string, switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.switchSupportPlan(email, switchPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle an incoming Stripe webhook event.
         * @summary Webhook Received
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookReceived(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.webhookReceived(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * Render the cancelled-checkout page for an abandoned Stripe session.  Stripe always substitutes ``{CHECKOUT_SESSION_ID}`` in the registered cancel_url before redirecting, so a legitimate hit always carries a ``session_id``. Declaring it required lets FastAPI 422 bot/crawler traffic at the boundary (no Stripe call, no template render) and closes the log-amplification vector on this unauthenticated endpoint. Value-level garbage (``undefined``, ``null``, unreplaced ``{CHECKOUT_SESSION_ID}`` literals) is filtered in the service. No bearer tokens are accepted here — the Stripe session_id is the capability token.
     * @summary Cancel
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public cancel(sessionId: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).cancel(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel the current user\'s subscription.
     * @summary Cancel Subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public cancelSubscription(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).cancelSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a bank-transfer invoice for the given plan (EU customers).
     * @summary Create Bank Transfer Invoice
     * @param {StripeProductOption} plan 
     * @param {string} [currency] 
     * @param {EUCountry} [country] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createBankTransferInvoice(plan: StripeProductOption, currency?: string, country?: EUCountry, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createBankTransferInvoice(plan, currency, country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe Checkout session.
     * @summary Create Checkout Session
     * @param {StripeProductOption} plan 
     * @param {boolean} [customRedirect] 
     * @param {string | null} [promoCode] 
     * @param {string} [currency] 
     * @param {string | null} [variant] Optional pricing-experiment variant claim. Re-validated server-side against the registry; invalid or stale claims fall back to canonical pricing.
     * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
     * @param {string | null} [platform] Platform for attribution tracking
     * @param {string | null} [fbp] Meta _fbp cookie value
     * @param {string | null} [fbc] Meta _fbc click ID cookie value
     * @param {string | null} [utmSource] UTM source parameter
     * @param {string | null} [utmMedium] UTM medium parameter
     * @param {string | null} [utmCampaign] UTM campaign parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createCheckoutSession(plan: StripeProductOption, customRedirect?: boolean, promoCode?: string | null, currency?: string, variant?: string | null, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createCheckoutSession(plan, customRedirect, promoCode, currency, variant, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an enterprise Stripe Checkout session.  Optional GA4 params for attribution tracking.
     * @summary Create Enterprise Checkout Session
     * @param {CreateEnterpriseCheckoutRequest} createEnterpriseCheckoutRequest 
     * @param {Currency} [currency] Deprecated: ignored for pricing. The checkout currency is resolved server-side from the caller\&#39;s IP (WP-7177). Retained only for backwards compatibility with existing clients.
     * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
     * @param {string | null} [platform] Platform for attribution tracking
     * @param {string | null} [fbp] Meta _fbp cookie value
     * @param {string | null} [fbc] Meta _fbc click ID cookie value
     * @param {string | null} [utmSource] UTM source parameter
     * @param {string | null} [utmMedium] UTM medium parameter
     * @param {string | null} [utmCampaign] UTM campaign parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest: CreateEnterpriseCheckoutRequest, currency?: Currency, ga4ClientId?: string | null, platform?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createEnterpriseCheckoutSession(createEnterpriseCheckoutRequest, currency, ga4ClientId, platform, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Stripe promotion code from a coupon for the given email (root API key).
     * @summary Create Promotion Code
     * @param {string} couponCode 
     * @param {string} email 
     * @param {number} [expiresInDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public createPromotionCode(couponCode: string, email: string, expiresInDays?: number, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).createPromotionCode(couponCode, email, expiresInDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a URL to the Stripe customer billing portal for the current user.
     * @summary Customer Portal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public customerPortal(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).customerPortal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a URL to the Stripe billing portal for the caller\'s enterprise (admins only).
     * @summary Enterprise Portal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public enterprisePortal(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).enterprisePortal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Render the payment error page for a failed checkout.
     * @summary Error
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public error(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).error(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the currency for a given country code.
     * @summary Get Currency By Country Code
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getCurrencyByCountryCode(countryCode: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getCurrencyByCountryCode(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the current user\'s subscription details, applying pending enterprise auto-join first.
     * @summary Get Subscription Details
     * @param {string | null} [deviceId] The device ID of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public getSubscriptionDetails(deviceId?: string | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).getSubscriptionDetails(deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle an incoming Stripe metadata webhook event.
     * @summary Metadata Webhook Received
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public metadataWebhookReceived(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).metadataWebhookReceived(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Migrate a user\'s subscription (personal or enterprise) to a new currency.  - If the user belongs to an enterprise (has `enterprise_id`), attempt to migrate   the enterprise subscription. - Otherwise, migrate the user\'s personal subscription.
     * @summary Migrate Subscription
     * @param {Currency} targetCurrency 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public migrateSubscription(targetCurrency: Currency, userId: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).migrateSubscription(targetCurrency, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the catalog pricing grid for an explicit currency, without an IP lookup.  Powers the current-plan billing card, which prices in the subscription\'s own currency rather than the caller\'s geo-IP currency. Public catalog pricing only — no user data.
     * @summary Pricing By Currency
     * @param {Currency} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public pricingByCurrency(currency: Currency, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).pricingByCurrency(currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return location-aware pricing resolved from the caller\'s IP.
     * @summary Pricing By Ip
     * @param {string | null} [variant] Optional pricing-experiment variant claim. Returns variant-specific price IDs for the resolved currency; invalid or stale claims fall back to canonical pricing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public pricingByIp(variant?: string | null, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).pricingByIp(variant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle a RevenueCat webhook.
     * @summary Revenuecat Webhook Received
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public revenuecatWebhookReceived(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).revenuecatWebhookReceived(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start (or atomically replace) a billing subscription invalidation watch session.
     * @summary Subscription Watch Start
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public subscriptionWatchStart(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).subscriptionWatchStart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SSE stream of ``subscription_changed`` invalidations for billing UI (20m TTL).
     * @summary Subscription Watch Stream
     * @param {string} xBillingWatchToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public subscriptionWatchStream(xBillingWatchToken: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).subscriptionWatchStream(xBillingWatchToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Render the post-checkout success page for a completed payment.
     * @summary Success
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public success(sessionId: string, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).success(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Switch an enterprise subscription to a new plan.  This endpoint: 1. Validates the user is an admin 2. Validates the new plan is valid and different from current 3. Records MSA and DPA acceptance for a Growth (variant) switch, and reports a missing one 4. Updates the subscription in Stripe 5. Updates the database record 6. Returns the updated subscription details
     * @summary Switch Enterprise Plan
     * @param {SwitchEnterprisePlanRequest} switchEnterprisePlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public switchEnterprisePlan(switchEnterprisePlanRequest: SwitchEnterprisePlanRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).switchEnterprisePlan(switchEnterprisePlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Switch the current user\'s subscription to a new plan.
     * @summary Switch Plan
     * @param {SwitchPlanRequest} switchPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public switchPlan(switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).switchPlan(switchPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Switch a user\'s subscription plan by email (internal support tool, root API key).
     * @summary Switch Support Plan
     * @param {string} email The email of the user to switch the plan for
     * @param {SwitchPlanRequest} switchPlanRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public switchSupportPlan(email: string, switchPlanRequest: SwitchPlanRequest, options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).switchSupportPlan(email, switchPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle an incoming Stripe webhook event.
     * @summary Webhook Received
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public webhookReceived(options?: RawAxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).webhookReceived(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlatformApi - axios parameter creator
 * @export
 */
export const PlatformApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new API key for the organization and return its secret.
         * @summary Create Api Key
         * @param {string} organizationId 
         * @param {CreateAPIKeyRequest} createAPIKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey: async (organizationId: string, createAPIKeyRequest: CreateAPIKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createApiKey', 'organizationId', organizationId)
            // verify required parameter 'createAPIKeyRequest' is not null or undefined
            assertParamExists('createApiKey', 'createAPIKeyRequest', createAPIKeyRequest)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/api_keys`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAPIKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new platform organization owned by the authenticated user.
         * @summary Create Organization
         * @param {CreateOrgRequest} createOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization: async (createOrgRequest: CreateOrgRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrgRequest' is not null or undefined
            assertParamExists('createOrganization', 'createOrgRequest', createOrgRequest)
            const localVarPath = `/api/v1/platform/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrgRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite one or more users to the organization with a given role (admin only).
         * @summary Create User Invitation
         * @param {string} organizationId 
         * @param {CreateUserInviteRequest} createUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation: async (organizationId: string, createUserInviteRequest: CreateUserInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('createUserInvitation', 'organizationId', organizationId)
            // verify required parameter 'createUserInviteRequest' is not null or undefined
            assertParamExists('createUserInvitation', 'createUserInviteRequest', createUserInviteRequest)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/invitations`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization API key (admin only).
         * @summary Delete Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: async (organizationId: string, apiKeyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteApiKey', 'organizationId', organizationId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKey', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/api_keys/{api_key_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a pending invitation by email (admin only).
         * @summary Delete User Invitation
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation: async (organizationId: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteUserInvitation', 'organizationId', organizationId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('deleteUserInvitation', 'email', email)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/invitations/{email}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the organization\'s current (open) invoice.
         * @summary Get Active Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveInvoice: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getActiveInvoice', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/billing/invoice/current`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the organization\'s remaining billing credits.
         * @summary Get Credits
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCredits', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/billing/credits`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single organization the caller is a member of.
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganization', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the organization\'s current billing-period usage.
         * @summary Get Usage
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUsage', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/billing/usage`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the organization\'s pending invitations.
         * @summary Get User Invitations
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvitations: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getUserInvitations', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/invitations`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List an organization\'s API keys (metadata only, not the secret values).
         * @summary List Api Keys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeys: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listApiKeys', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/api_keys`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the organizations the authenticated user is a member of.
         * @summary List Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/platform/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the organization\'s members.
         * @summary List Users
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (organizationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listUsers', 'organizationId', organizationId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/users`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run a one-shot transcription against the organization\'s first API key for the playground UI.
         * @summary Playground
         * @param {string} organizationId 
         * @param {BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost} bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playground: async (organizationId: string, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost: BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('playground', 'organizationId', organizationId)
            // verify required parameter 'bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost' is not null or undefined
            assertParamExists('playground', 'bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost', bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/playground`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a member from the organization (admin only).
         * @summary Remove User
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser: async (organizationId: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('removeUser', 'organizationId', organizationId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('removeUser', 'email', email)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/users/{email}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename an organization API key (admin only).
         * @summary Update Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {UpdateAPIKeyRequest} [updateAPIKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKey: async (organizationId: string, apiKeyId: string, updateAPIKeyRequest?: UpdateAPIKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateApiKey', 'organizationId', organizationId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('updateApiKey', 'apiKeyId', apiKeyId)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/api_keys/{api_key_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAPIKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an organization\'s name and/or logo (admin only).
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrgRequest} updateOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (organizationId: string, updateOrgRequest: UpdateOrgRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganization', 'organizationId', organizationId)
            // verify required parameter 'updateOrgRequest' is not null or undefined
            assertParamExists('updateOrganization', 'updateOrgRequest', updateOrgRequest)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrgRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change an organization member\'s role (admin only).
         * @summary Update User Role
         * @param {string} organizationId 
         * @param {string} email 
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole: async (organizationId: string, email: string, updateRoleRequest: UpdateRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateUserRole', 'organizationId', organizationId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateUserRole', 'email', email)
            // verify required parameter 'updateRoleRequest' is not null or undefined
            assertParamExists('updateUserRole', 'updateRoleRequest', updateRoleRequest)
            const localVarPath = `/api/v1/platform/organizations/{organization_id}/users/{email}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlatformApi - functional programming interface
 * @export
 */
export const PlatformApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlatformApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new API key for the organization and return its secret.
         * @summary Create Api Key
         * @param {string} organizationId 
         * @param {CreateAPIKeyRequest} createAPIKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKey(organizationId: string, createAPIKeyRequest: CreateAPIKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKey(organizationId, createAPIKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.createApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new platform organization owned by the authenticated user.
         * @summary Create Organization
         * @param {CreateOrgRequest} createOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganization(createOrgRequest: CreateOrgRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganization(createOrgRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.createOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite one or more users to the organization with a given role (admin only).
         * @summary Create User Invitation
         * @param {string} organizationId 
         * @param {CreateUserInviteRequest} createUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserInvitation(organizationId: string, createUserInviteRequest: CreateUserInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserInvitation(organizationId, createUserInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.createUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization API key (admin only).
         * @summary Delete Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKey(organizationId: string, apiKeyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKey(organizationId, apiKeyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.deleteApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a pending invitation by email (admin only).
         * @summary Delete User Invitation
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserInvitation(organizationId: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserInvitation(organizationId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.deleteUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the organization\'s current (open) invoice.
         * @summary Get Active Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveInvoice(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveInvoice(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.getActiveInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the organization\'s remaining billing credits.
         * @summary Get Credits
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCredits(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCredits(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.getCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single organization the caller is a member of.
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganization(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.getOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the organization\'s current billing-period usage.
         * @summary Get Usage
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsage(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsage(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.getUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the organization\'s pending invitations.
         * @summary Get User Invitations
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInvitations(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInvitations(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.getUserInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List an organization\'s API keys (metadata only, not the secret values).
         * @summary List Api Keys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listApiKeys(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listApiKeys(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.listApiKeys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the organizations the authenticated user is a member of.
         * @summary List Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.listOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the organization\'s members.
         * @summary List Users
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(organizationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.listUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run a one-shot transcription against the organization\'s first API key for the playground UI.
         * @summary Playground
         * @param {string} organizationId 
         * @param {BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost} bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async playground(organizationId: string, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost: BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.playground(organizationId, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.playground']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a member from the organization (admin only).
         * @summary Remove User
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUser(organizationId: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUser(organizationId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.removeUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename an organization API key (admin only).
         * @summary Update Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {UpdateAPIKeyRequest} [updateAPIKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateApiKey(organizationId: string, apiKeyId: string, updateAPIKeyRequest?: UpdateAPIKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateApiKey(organizationId, apiKeyId, updateAPIKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.updateApiKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an organization\'s name and/or logo (admin only).
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrgRequest} updateOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(organizationId: string, updateOrgRequest: UpdateOrgRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(organizationId, updateOrgRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.updateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Change an organization member\'s role (admin only).
         * @summary Update User Role
         * @param {string} organizationId 
         * @param {string} email 
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRole(organizationId: string, email: string, updateRoleRequest: UpdateRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRole(organizationId, email, updateRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlatformApi.updateUserRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlatformApi - factory interface
 * @export
 */
export const PlatformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlatformApiFp(configuration)
    return {
        /**
         * Create a new API key for the organization and return its secret.
         * @summary Create Api Key
         * @param {string} organizationId 
         * @param {CreateAPIKeyRequest} createAPIKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKey(organizationId: string, createAPIKeyRequest: CreateAPIKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createApiKey(organizationId, createAPIKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new platform organization owned by the authenticated user.
         * @summary Create Organization
         * @param {CreateOrgRequest} createOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(createOrgRequest: CreateOrgRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createOrganization(createOrgRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite one or more users to the organization with a given role (admin only).
         * @summary Create User Invitation
         * @param {string} organizationId 
         * @param {CreateUserInviteRequest} createUserInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserInvitation(organizationId: string, createUserInviteRequest: CreateUserInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createUserInvitation(organizationId, createUserInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization API key (admin only).
         * @summary Delete Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(organizationId: string, apiKeyId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteApiKey(organizationId, apiKeyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a pending invitation by email (admin only).
         * @summary Delete User Invitation
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserInvitation(organizationId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteUserInvitation(organizationId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the organization\'s current (open) invoice.
         * @summary Get Active Invoice
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveInvoice(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getActiveInvoice(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the organization\'s remaining billing credits.
         * @summary Get Credits
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCredits(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getCredits(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single organization the caller is a member of.
         * @summary Get Organization
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganization(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getOrganization(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the organization\'s current billing-period usage.
         * @summary Get Usage
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUsage(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the organization\'s pending invitations.
         * @summary Get User Invitations
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInvitations(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserInvitations(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List an organization\'s API keys (metadata only, not the secret values).
         * @summary List Api Keys
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApiKeys(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listApiKeys(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List the organizations the authenticated user is a member of.
         * @summary List Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizations(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listOrganizations(options).then((request) => request(axios, basePath));
        },
        /**
         * List the organization\'s members.
         * @summary List Users
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(organizationId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.listUsers(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Run a one-shot transcription against the organization\'s first API key for the playground UI.
         * @summary Playground
         * @param {string} organizationId 
         * @param {BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost} bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        playground(organizationId: string, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost: BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.playground(organizationId, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a member from the organization (admin only).
         * @summary Remove User
         * @param {string} organizationId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser(organizationId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.removeUser(organizationId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename an organization API key (admin only).
         * @summary Update Api Key
         * @param {string} organizationId 
         * @param {string} apiKeyId 
         * @param {UpdateAPIKeyRequest} [updateAPIKeyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApiKey(organizationId: string, apiKeyId: string, updateAPIKeyRequest?: UpdateAPIKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateApiKey(organizationId, apiKeyId, updateAPIKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an organization\'s name and/or logo (admin only).
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrgRequest} updateOrgRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(organizationId: string, updateOrgRequest: UpdateOrgRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateOrganization(organizationId, updateOrgRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change an organization member\'s role (admin only).
         * @summary Update User Role
         * @param {string} organizationId 
         * @param {string} email 
         * @param {UpdateRoleRequest} updateRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRole(organizationId: string, email: string, updateRoleRequest: UpdateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateUserRole(organizationId, email, updateRoleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlatformApi - object-oriented interface
 * @export
 * @class PlatformApi
 * @extends {BaseAPI}
 */
export class PlatformApi extends BaseAPI {
    /**
     * Create a new API key for the organization and return its secret.
     * @summary Create Api Key
     * @param {string} organizationId 
     * @param {CreateAPIKeyRequest} createAPIKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public createApiKey(organizationId: string, createAPIKeyRequest: CreateAPIKeyRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).createApiKey(organizationId, createAPIKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new platform organization owned by the authenticated user.
     * @summary Create Organization
     * @param {CreateOrgRequest} createOrgRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public createOrganization(createOrgRequest: CreateOrgRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).createOrganization(createOrgRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite one or more users to the organization with a given role (admin only).
     * @summary Create User Invitation
     * @param {string} organizationId 
     * @param {CreateUserInviteRequest} createUserInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public createUserInvitation(organizationId: string, createUserInviteRequest: CreateUserInviteRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).createUserInvitation(organizationId, createUserInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization API key (admin only).
     * @summary Delete Api Key
     * @param {string} organizationId 
     * @param {string} apiKeyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public deleteApiKey(organizationId: string, apiKeyId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).deleteApiKey(organizationId, apiKeyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a pending invitation by email (admin only).
     * @summary Delete User Invitation
     * @param {string} organizationId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public deleteUserInvitation(organizationId: string, email: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).deleteUserInvitation(organizationId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the organization\'s current (open) invoice.
     * @summary Get Active Invoice
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public getActiveInvoice(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).getActiveInvoice(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the organization\'s remaining billing credits.
     * @summary Get Credits
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public getCredits(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).getCredits(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single organization the caller is a member of.
     * @summary Get Organization
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public getOrganization(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).getOrganization(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the organization\'s current billing-period usage.
     * @summary Get Usage
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public getUsage(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).getUsage(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the organization\'s pending invitations.
     * @summary Get User Invitations
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public getUserInvitations(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).getUserInvitations(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List an organization\'s API keys (metadata only, not the secret values).
     * @summary List Api Keys
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public listApiKeys(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).listApiKeys(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the organizations the authenticated user is a member of.
     * @summary List Organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public listOrganizations(options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).listOrganizations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the organization\'s members.
     * @summary List Users
     * @param {string} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public listUsers(organizationId: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).listUsers(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run a one-shot transcription against the organization\'s first API key for the playground UI.
     * @summary Playground
     * @param {string} organizationId 
     * @param {BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost} bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public playground(organizationId: string, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost: BodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).playground(organizationId, bodyPlaygroundApiV1PlatformOrganizationsOrganizationIdPlaygroundPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a member from the organization (admin only).
     * @summary Remove User
     * @param {string} organizationId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public removeUser(organizationId: string, email: string, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).removeUser(organizationId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename an organization API key (admin only).
     * @summary Update Api Key
     * @param {string} organizationId 
     * @param {string} apiKeyId 
     * @param {UpdateAPIKeyRequest} [updateAPIKeyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public updateApiKey(organizationId: string, apiKeyId: string, updateAPIKeyRequest?: UpdateAPIKeyRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).updateApiKey(organizationId, apiKeyId, updateAPIKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an organization\'s name and/or logo (admin only).
     * @summary Update Organization
     * @param {string} organizationId 
     * @param {UpdateOrgRequest} updateOrgRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public updateOrganization(organizationId: string, updateOrgRequest: UpdateOrgRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).updateOrganization(organizationId, updateOrgRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change an organization member\'s role (admin only).
     * @summary Update User Role
     * @param {string} organizationId 
     * @param {string} email 
     * @param {UpdateRoleRequest} updateRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlatformApi
     */
    public updateUserRole(organizationId: string, email: string, updateRoleRequest: UpdateRoleRequest, options?: RawAxiosRequestConfig) {
        return PlatformApiFp(this.configuration).updateUserRole(organizationId, email, updateRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PolishApi - axios parameter creator
 * @export
 */
export const PolishApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Upload polish records for the authenticated user.
         * @summary Upload Polish
         * @param {UploadPolishRequest} uploadPolishRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolish: async (uploadPolishRequest: UploadPolishRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadPolishRequest' is not null or undefined
            assertParamExists('uploadPolish', 'uploadPolishRequest', uploadPolishRequest)
            const localVarPath = `/api/v1/polish/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadPolishRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PolishApi - functional programming interface
 * @export
 */
export const PolishApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PolishApiAxiosParamCreator(configuration)
    return {
        /**
         * Upload polish records for the authenticated user.
         * @summary Upload Polish
         * @param {UploadPolishRequest} uploadPolishRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPolish(uploadPolishRequest: UploadPolishRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadPolishResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPolish(uploadPolishRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PolishApi.uploadPolish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PolishApi - factory interface
 * @export
 */
export const PolishApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PolishApiFp(configuration)
    return {
        /**
         * Upload polish records for the authenticated user.
         * @summary Upload Polish
         * @param {UploadPolishRequest} uploadPolishRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPolish(uploadPolishRequest: UploadPolishRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadPolishResponse> {
            return localVarFp.uploadPolish(uploadPolishRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PolishApi - object-oriented interface
 * @export
 * @class PolishApi
 * @extends {BaseAPI}
 */
export class PolishApi extends BaseAPI {
    /**
     * Upload polish records for the authenticated user.
     * @summary Upload Polish
     * @param {UploadPolishRequest} uploadPolishRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PolishApi
     */
    public uploadPolish(uploadPolishRequest: UploadPolishRequest, options?: RawAxiosRequestConfig) {
        return PolishApiFp(this.configuration).uploadPolish(uploadPolishRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PrereadFeedbackAdminApi - axios parameter creator
 * @export
 */
export const PrereadFeedbackAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Read one report and its uniquely matched brief under current data-sharing permission.
         * @summary Get Preread Feedback Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackDetail: async (feedbackId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedbackId' is not null or undefined
            assertParamExists('getPrereadFeedbackDetail', 'feedbackId', feedbackId)
            const localVarPath = `/api/v1/internal/preread-feedback/{feedback_id}`
                .replace(`{${"feedback_id"}}`, encodeURIComponent(String(feedbackId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count individual filtered reports and their ratings in sparse UTC day or week buckets.
         * @summary Get Preread Feedback Rating Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackRatingStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackRatingStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackRatingStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackRatingStatsBucketEnum} [bucket] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackRatingStats: async (since: string, until: string, source?: GetPrereadFeedbackRatingStatsSourceEnum, rating?: GetPrereadFeedbackRatingStatsRatingEnum, model?: GetPrereadFeedbackRatingStatsModelEnum, bucket?: GetPrereadFeedbackRatingStatsBucketEnum, matchedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'since' is not null or undefined
            assertParamExists('getPrereadFeedbackRatingStats', 'since', since)
            // verify required parameter 'until' is not null or undefined
            assertParamExists('getPrereadFeedbackRatingStats', 'until', until)
            const localVarPath = `/api/v1/internal/preread-feedback/rating-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (matchedOnly !== undefined) {
                localVarQueryParameter['matched_only'] = matchedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Compare all attempts by generation time or distinct reported briefs by report time.
         * @summary Get Preread Feedback Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackStatsScopeEnum} [scope] 
         * @param {GetPrereadFeedbackStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackStatsBucketEnum} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackStats: async (since: string, until: string, scope?: GetPrereadFeedbackStatsScopeEnum, source?: GetPrereadFeedbackStatsSourceEnum, rating?: GetPrereadFeedbackStatsRatingEnum, model?: GetPrereadFeedbackStatsModelEnum, bucket?: GetPrereadFeedbackStatsBucketEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'since' is not null or undefined
            assertParamExists('getPrereadFeedbackStats', 'since', since)
            // verify required parameter 'until' is not null or undefined
            assertParamExists('getPrereadFeedbackStats', 'until', until)
            const localVarPath = `/api/v1/internal/preread-feedback/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List owned reports from both feedback channels, newest first.
         * @summary List Preread Feedback
         * @param {ListPrereadFeedbackSourceEnum} [source] 
         * @param {ListPrereadFeedbackRatingEnum} [rating] 
         * @param {ListPrereadFeedbackModelEnum} [model] 
         * @param {string | null} [since] 
         * @param {string | null} [until] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPrereadFeedback: async (source?: ListPrereadFeedbackSourceEnum, rating?: ListPrereadFeedbackRatingEnum, model?: ListPrereadFeedbackModelEnum, since?: string | null, until?: string | null, cursor?: string | null, limit?: number, matchedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/internal/preread-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (matchedOnly !== undefined) {
                localVarQueryParameter['matched_only'] = matchedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrereadFeedbackAdminApi - functional programming interface
 * @export
 */
export const PrereadFeedbackAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrereadFeedbackAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Read one report and its uniquely matched brief under current data-sharing permission.
         * @summary Get Preread Feedback Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrereadFeedbackDetail(feedbackId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrereadFeedbackDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrereadFeedbackDetail(feedbackId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrereadFeedbackAdminApi.getPrereadFeedbackDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count individual filtered reports and their ratings in sparse UTC day or week buckets.
         * @summary Get Preread Feedback Rating Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackRatingStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackRatingStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackRatingStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackRatingStatsBucketEnum} [bucket] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrereadFeedbackRatingStats(since: string, until: string, source?: GetPrereadFeedbackRatingStatsSourceEnum, rating?: GetPrereadFeedbackRatingStatsRatingEnum, model?: GetPrereadFeedbackRatingStatsModelEnum, bucket?: GetPrereadFeedbackRatingStatsBucketEnum, matchedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrereadFeedbackRatingStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrereadFeedbackRatingStats(since, until, source, rating, model, bucket, matchedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrereadFeedbackAdminApi.getPrereadFeedbackRatingStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Compare all attempts by generation time or distinct reported briefs by report time.
         * @summary Get Preread Feedback Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackStatsScopeEnum} [scope] 
         * @param {GetPrereadFeedbackStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackStatsBucketEnum} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrereadFeedbackStats(since: string, until: string, scope?: GetPrereadFeedbackStatsScopeEnum, source?: GetPrereadFeedbackStatsSourceEnum, rating?: GetPrereadFeedbackStatsRatingEnum, model?: GetPrereadFeedbackStatsModelEnum, bucket?: GetPrereadFeedbackStatsBucketEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrereadFeedbackStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrereadFeedbackStats(since, until, scope, source, rating, model, bucket, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrereadFeedbackAdminApi.getPrereadFeedbackStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List owned reports from both feedback channels, newest first.
         * @summary List Preread Feedback
         * @param {ListPrereadFeedbackSourceEnum} [source] 
         * @param {ListPrereadFeedbackRatingEnum} [rating] 
         * @param {ListPrereadFeedbackModelEnum} [model] 
         * @param {string | null} [since] 
         * @param {string | null} [until] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPrereadFeedback(source?: ListPrereadFeedbackSourceEnum, rating?: ListPrereadFeedbackRatingEnum, model?: ListPrereadFeedbackModelEnum, since?: string | null, until?: string | null, cursor?: string | null, limit?: number, matchedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrereadFeedbackList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPrereadFeedback(source, rating, model, since, until, cursor, limit, matchedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrereadFeedbackAdminApi.listPrereadFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrereadFeedbackAdminApi - factory interface
 * @export
 */
export const PrereadFeedbackAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrereadFeedbackAdminApiFp(configuration)
    return {
        /**
         * Read one report and its uniquely matched brief under current data-sharing permission.
         * @summary Get Preread Feedback Detail
         * @param {string} feedbackId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackDetail(feedbackId: string, options?: RawAxiosRequestConfig): AxiosPromise<PrereadFeedbackDetail> {
            return localVarFp.getPrereadFeedbackDetail(feedbackId, options).then((request) => request(axios, basePath));
        },
        /**
         * Count individual filtered reports and their ratings in sparse UTC day or week buckets.
         * @summary Get Preread Feedback Rating Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackRatingStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackRatingStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackRatingStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackRatingStatsBucketEnum} [bucket] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackRatingStats(since: string, until: string, source?: GetPrereadFeedbackRatingStatsSourceEnum, rating?: GetPrereadFeedbackRatingStatsRatingEnum, model?: GetPrereadFeedbackRatingStatsModelEnum, bucket?: GetPrereadFeedbackRatingStatsBucketEnum, matchedOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PrereadFeedbackRatingStats> {
            return localVarFp.getPrereadFeedbackRatingStats(since, until, source, rating, model, bucket, matchedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Compare all attempts by generation time or distinct reported briefs by report time.
         * @summary Get Preread Feedback Stats
         * @param {string} since 
         * @param {string} until 
         * @param {GetPrereadFeedbackStatsScopeEnum} [scope] 
         * @param {GetPrereadFeedbackStatsSourceEnum} [source] 
         * @param {GetPrereadFeedbackStatsRatingEnum} [rating] 
         * @param {GetPrereadFeedbackStatsModelEnum} [model] 
         * @param {GetPrereadFeedbackStatsBucketEnum} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrereadFeedbackStats(since: string, until: string, scope?: GetPrereadFeedbackStatsScopeEnum, source?: GetPrereadFeedbackStatsSourceEnum, rating?: GetPrereadFeedbackStatsRatingEnum, model?: GetPrereadFeedbackStatsModelEnum, bucket?: GetPrereadFeedbackStatsBucketEnum, options?: RawAxiosRequestConfig): AxiosPromise<PrereadFeedbackStats> {
            return localVarFp.getPrereadFeedbackStats(since, until, scope, source, rating, model, bucket, options).then((request) => request(axios, basePath));
        },
        /**
         * List owned reports from both feedback channels, newest first.
         * @summary List Preread Feedback
         * @param {ListPrereadFeedbackSourceEnum} [source] 
         * @param {ListPrereadFeedbackRatingEnum} [rating] 
         * @param {ListPrereadFeedbackModelEnum} [model] 
         * @param {string | null} [since] 
         * @param {string | null} [until] 
         * @param {string | null} [cursor] 
         * @param {number} [limit] 
         * @param {boolean} [matchedOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPrereadFeedback(source?: ListPrereadFeedbackSourceEnum, rating?: ListPrereadFeedbackRatingEnum, model?: ListPrereadFeedbackModelEnum, since?: string | null, until?: string | null, cursor?: string | null, limit?: number, matchedOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PrereadFeedbackList> {
            return localVarFp.listPrereadFeedback(source, rating, model, since, until, cursor, limit, matchedOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrereadFeedbackAdminApi - object-oriented interface
 * @export
 * @class PrereadFeedbackAdminApi
 * @extends {BaseAPI}
 */
export class PrereadFeedbackAdminApi extends BaseAPI {
    /**
     * Read one report and its uniquely matched brief under current data-sharing permission.
     * @summary Get Preread Feedback Detail
     * @param {string} feedbackId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrereadFeedbackAdminApi
     */
    public getPrereadFeedbackDetail(feedbackId: string, options?: RawAxiosRequestConfig) {
        return PrereadFeedbackAdminApiFp(this.configuration).getPrereadFeedbackDetail(feedbackId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count individual filtered reports and their ratings in sparse UTC day or week buckets.
     * @summary Get Preread Feedback Rating Stats
     * @param {string} since 
     * @param {string} until 
     * @param {GetPrereadFeedbackRatingStatsSourceEnum} [source] 
     * @param {GetPrereadFeedbackRatingStatsRatingEnum} [rating] 
     * @param {GetPrereadFeedbackRatingStatsModelEnum} [model] 
     * @param {GetPrereadFeedbackRatingStatsBucketEnum} [bucket] 
     * @param {boolean} [matchedOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrereadFeedbackAdminApi
     */
    public getPrereadFeedbackRatingStats(since: string, until: string, source?: GetPrereadFeedbackRatingStatsSourceEnum, rating?: GetPrereadFeedbackRatingStatsRatingEnum, model?: GetPrereadFeedbackRatingStatsModelEnum, bucket?: GetPrereadFeedbackRatingStatsBucketEnum, matchedOnly?: boolean, options?: RawAxiosRequestConfig) {
        return PrereadFeedbackAdminApiFp(this.configuration).getPrereadFeedbackRatingStats(since, until, source, rating, model, bucket, matchedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Compare all attempts by generation time or distinct reported briefs by report time.
     * @summary Get Preread Feedback Stats
     * @param {string} since 
     * @param {string} until 
     * @param {GetPrereadFeedbackStatsScopeEnum} [scope] 
     * @param {GetPrereadFeedbackStatsSourceEnum} [source] 
     * @param {GetPrereadFeedbackStatsRatingEnum} [rating] 
     * @param {GetPrereadFeedbackStatsModelEnum} [model] 
     * @param {GetPrereadFeedbackStatsBucketEnum} [bucket] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrereadFeedbackAdminApi
     */
    public getPrereadFeedbackStats(since: string, until: string, scope?: GetPrereadFeedbackStatsScopeEnum, source?: GetPrereadFeedbackStatsSourceEnum, rating?: GetPrereadFeedbackStatsRatingEnum, model?: GetPrereadFeedbackStatsModelEnum, bucket?: GetPrereadFeedbackStatsBucketEnum, options?: RawAxiosRequestConfig) {
        return PrereadFeedbackAdminApiFp(this.configuration).getPrereadFeedbackStats(since, until, scope, source, rating, model, bucket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List owned reports from both feedback channels, newest first.
     * @summary List Preread Feedback
     * @param {ListPrereadFeedbackSourceEnum} [source] 
     * @param {ListPrereadFeedbackRatingEnum} [rating] 
     * @param {ListPrereadFeedbackModelEnum} [model] 
     * @param {string | null} [since] 
     * @param {string | null} [until] 
     * @param {string | null} [cursor] 
     * @param {number} [limit] 
     * @param {boolean} [matchedOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrereadFeedbackAdminApi
     */
    public listPrereadFeedback(source?: ListPrereadFeedbackSourceEnum, rating?: ListPrereadFeedbackRatingEnum, model?: ListPrereadFeedbackModelEnum, since?: string | null, until?: string | null, cursor?: string | null, limit?: number, matchedOnly?: boolean, options?: RawAxiosRequestConfig) {
        return PrereadFeedbackAdminApiFp(this.configuration).listPrereadFeedback(source, rating, model, since, until, cursor, limit, matchedOnly, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetPrereadFeedbackRatingStatsSourceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type GetPrereadFeedbackRatingStatsSourceEnum = typeof GetPrereadFeedbackRatingStatsSourceEnum[keyof typeof GetPrereadFeedbackRatingStatsSourceEnum];
/**
 * @export
 */
export const GetPrereadFeedbackRatingStatsRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;
export type GetPrereadFeedbackRatingStatsRatingEnum = typeof GetPrereadFeedbackRatingStatsRatingEnum[keyof typeof GetPrereadFeedbackRatingStatsRatingEnum];
/**
 * @export
 */
export const GetPrereadFeedbackRatingStatsModelEnum = {
    Luna: 'luna',
    Claude: 'claude'
} as const;
export type GetPrereadFeedbackRatingStatsModelEnum = typeof GetPrereadFeedbackRatingStatsModelEnum[keyof typeof GetPrereadFeedbackRatingStatsModelEnum];
/**
 * @export
 */
export const GetPrereadFeedbackRatingStatsBucketEnum = {
    Day: 'day',
    Week: 'week'
} as const;
export type GetPrereadFeedbackRatingStatsBucketEnum = typeof GetPrereadFeedbackRatingStatsBucketEnum[keyof typeof GetPrereadFeedbackRatingStatsBucketEnum];
/**
 * @export
 */
export const GetPrereadFeedbackStatsScopeEnum = {
    All: 'all',
    Reported: 'reported'
} as const;
export type GetPrereadFeedbackStatsScopeEnum = typeof GetPrereadFeedbackStatsScopeEnum[keyof typeof GetPrereadFeedbackStatsScopeEnum];
/**
 * @export
 */
export const GetPrereadFeedbackStatsSourceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type GetPrereadFeedbackStatsSourceEnum = typeof GetPrereadFeedbackStatsSourceEnum[keyof typeof GetPrereadFeedbackStatsSourceEnum];
/**
 * @export
 */
export const GetPrereadFeedbackStatsRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;
export type GetPrereadFeedbackStatsRatingEnum = typeof GetPrereadFeedbackStatsRatingEnum[keyof typeof GetPrereadFeedbackStatsRatingEnum];
/**
 * @export
 */
export const GetPrereadFeedbackStatsModelEnum = {
    Luna: 'luna',
    Claude: 'claude'
} as const;
export type GetPrereadFeedbackStatsModelEnum = typeof GetPrereadFeedbackStatsModelEnum[keyof typeof GetPrereadFeedbackStatsModelEnum];
/**
 * @export
 */
export const GetPrereadFeedbackStatsBucketEnum = {
    Day: 'day',
    Week: 'week'
} as const;
export type GetPrereadFeedbackStatsBucketEnum = typeof GetPrereadFeedbackStatsBucketEnum[keyof typeof GetPrereadFeedbackStatsBucketEnum];
/**
 * @export
 */
export const ListPrereadFeedbackSourceEnum = {
    Internal: 'internal',
    External: 'external'
} as const;
export type ListPrereadFeedbackSourceEnum = typeof ListPrereadFeedbackSourceEnum[keyof typeof ListPrereadFeedbackSourceEnum];
/**
 * @export
 */
export const ListPrereadFeedbackRatingEnum = {
    Up: 'up',
    Down: 'down'
} as const;
export type ListPrereadFeedbackRatingEnum = typeof ListPrereadFeedbackRatingEnum[keyof typeof ListPrereadFeedbackRatingEnum];
/**
 * @export
 */
export const ListPrereadFeedbackModelEnum = {
    Luna: 'luna',
    Claude: 'claude'
} as const;
export type ListPrereadFeedbackModelEnum = typeof ListPrereadFeedbackModelEnum[keyof typeof ListPrereadFeedbackModelEnum];


/**
 * PromotionsApi - axios parameter creator
 * @export
 */
export const PromotionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Validate and attach a promo code to the current user for their next checkout.
         * @summary Apply Promo Code
         * @param {ApplyPromoCodeRequest} applyPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCode: async (applyPromoCodeRequest: ApplyPromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyPromoCodeRequest' is not null or undefined
            assertParamExists('applyPromoCode', 'applyPromoCodeRequest', applyPromoCodeRequest)
            const localVarPath = `/api/v1/promos/campaign/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyPromoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current Android waitlist rank for the authenticated user.  Returns referral_code, current_rank, total_boost, referrals_count, and desktop_dictation_bonus_earned.
         * @summary Get Android Waitlist Rank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWaitlistRank: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promos/android_waitlist_rank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user\'s pending promo info (for paywall/onboarding display).  Returns 200 with campaign details if a pending promo exists, or 204 if not.
         * @summary Get Pending Promo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPromo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/promos/campaign/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit phone number for Android waitlist boost.  Awards 30,000 points on first submission.
         * @summary Submit Phone Number
         * @param {PhoneNumberSubmitRequest} phoneNumberSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPhoneNumber: async (phoneNumberSubmitRequest: PhoneNumberSubmitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumberSubmitRequest' is not null or undefined
            assertParamExists('submitPhoneNumber', 'phoneNumberSubmitRequest', phoneNumberSubmitRequest)
            const localVarPath = `/api/v1/promos/android_waitlist/phone_number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(phoneNumberSubmitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate a promo code and return attribution info without applying it.
         * @summary Validate Promo Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePromoCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('validatePromoCode', 'code', code)
            const localVarPath = `/api/v1/promos/campaign/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify a social share screenshot and award boost points.  Upload a screenshot of your social media post about Wispr Flow. The screenshot will be verified using AI to confirm: - The post mentions Wispr Flow or contains a wisprflow.ai URL - The post was actually published (not just composed) - The platform (Twitter/X, LinkedIn, WhatsApp, or Slack)  Boost points awarded: - Twitter/X: 50,000 points - LinkedIn: 50,000 points - WhatsApp: 20,000 points - Slack: 20,000 points  Each platform can only be claimed once per user.  File requirements: - PNG or JPEG format only - Maximum file size: 20MB
         * @summary Verify Social Share
         * @param {File} screenshot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySocialShare: async (screenshot: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'screenshot' is not null or undefined
            assertParamExists('verifySocialShare', 'screenshot', screenshot)
            const localVarPath = `/api/v1/promos/android_waitlist/verify_social_share`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (screenshot !== undefined) { 
                localVarFormParams.append('screenshot', screenshot as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromotionsApi - functional programming interface
 * @export
 */
export const PromotionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromotionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Validate and attach a promo code to the current user for their next checkout.
         * @summary Apply Promo Code
         * @param {ApplyPromoCodeRequest} applyPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyPromoCode(applyPromoCodeRequest: ApplyPromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignPromoDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyPromoCode(applyPromoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.applyPromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current Android waitlist rank for the authenticated user.  Returns referral_code, current_rank, total_boost, referrals_count, and desktop_dictation_bonus_earned.
         * @summary Get Android Waitlist Rank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAndroidWaitlistRank(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AndroidWaitlistRankResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAndroidWaitlistRank(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.getAndroidWaitlistRank']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current user\'s pending promo info (for paywall/onboarding display).  Returns 200 with campaign details if a pending promo exists, or 204 if not.
         * @summary Get Pending Promo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingPromo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignPromoDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingPromo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.getPendingPromo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit phone number for Android waitlist boost.  Awards 30,000 points on first submission.
         * @summary Submit Phone Number
         * @param {PhoneNumberSubmitRequest} phoneNumberSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPhoneNumber(phoneNumberSubmitRequest: PhoneNumberSubmitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoostActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPhoneNumber(phoneNumberSubmitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.submitPhoneNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate a promo code and return attribution info without applying it.
         * @summary Validate Promo Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePromoCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignPromoDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePromoCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.validatePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify a social share screenshot and award boost points.  Upload a screenshot of your social media post about Wispr Flow. The screenshot will be verified using AI to confirm: - The post mentions Wispr Flow or contains a wisprflow.ai URL - The post was actually published (not just composed) - The platform (Twitter/X, LinkedIn, WhatsApp, or Slack)  Boost points awarded: - Twitter/X: 50,000 points - LinkedIn: 50,000 points - WhatsApp: 20,000 points - Slack: 20,000 points  Each platform can only be claimed once per user.  File requirements: - PNG or JPEG format only - Maximum file size: 20MB
         * @summary Verify Social Share
         * @param {File} screenshot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifySocialShare(screenshot: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoostActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifySocialShare(screenshot, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionsApi.verifySocialShare']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PromotionsApi - factory interface
 * @export
 */
export const PromotionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromotionsApiFp(configuration)
    return {
        /**
         * Validate and attach a promo code to the current user for their next checkout.
         * @summary Apply Promo Code
         * @param {ApplyPromoCodeRequest} applyPromoCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyPromoCode(applyPromoCodeRequest: ApplyPromoCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CampaignPromoDetails> {
            return localVarFp.applyPromoCode(applyPromoCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current Android waitlist rank for the authenticated user.  Returns referral_code, current_rank, total_boost, referrals_count, and desktop_dictation_bonus_earned.
         * @summary Get Android Waitlist Rank
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAndroidWaitlistRank(options?: RawAxiosRequestConfig): AxiosPromise<AndroidWaitlistRankResponse> {
            return localVarFp.getAndroidWaitlistRank(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current user\'s pending promo info (for paywall/onboarding display).  Returns 200 with campaign details if a pending promo exists, or 204 if not.
         * @summary Get Pending Promo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingPromo(options?: RawAxiosRequestConfig): AxiosPromise<CampaignPromoDetails> {
            return localVarFp.getPendingPromo(options).then((request) => request(axios, basePath));
        },
        /**
         * Submit phone number for Android waitlist boost.  Awards 30,000 points on first submission.
         * @summary Submit Phone Number
         * @param {PhoneNumberSubmitRequest} phoneNumberSubmitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPhoneNumber(phoneNumberSubmitRequest: PhoneNumberSubmitRequest, options?: RawAxiosRequestConfig): AxiosPromise<BoostActionResponse> {
            return localVarFp.submitPhoneNumber(phoneNumberSubmitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate a promo code and return attribution info without applying it.
         * @summary Validate Promo Code
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePromoCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<CampaignPromoDetails> {
            return localVarFp.validatePromoCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify a social share screenshot and award boost points.  Upload a screenshot of your social media post about Wispr Flow. The screenshot will be verified using AI to confirm: - The post mentions Wispr Flow or contains a wisprflow.ai URL - The post was actually published (not just composed) - The platform (Twitter/X, LinkedIn, WhatsApp, or Slack)  Boost points awarded: - Twitter/X: 50,000 points - LinkedIn: 50,000 points - WhatsApp: 20,000 points - Slack: 20,000 points  Each platform can only be claimed once per user.  File requirements: - PNG or JPEG format only - Maximum file size: 20MB
         * @summary Verify Social Share
         * @param {File} screenshot 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySocialShare(screenshot: File, options?: RawAxiosRequestConfig): AxiosPromise<BoostActionResponse> {
            return localVarFp.verifySocialShare(screenshot, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromotionsApi - object-oriented interface
 * @export
 * @class PromotionsApi
 * @extends {BaseAPI}
 */
export class PromotionsApi extends BaseAPI {
    /**
     * Validate and attach a promo code to the current user for their next checkout.
     * @summary Apply Promo Code
     * @param {ApplyPromoCodeRequest} applyPromoCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public applyPromoCode(applyPromoCodeRequest: ApplyPromoCodeRequest, options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).applyPromoCode(applyPromoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current Android waitlist rank for the authenticated user.  Returns referral_code, current_rank, total_boost, referrals_count, and desktop_dictation_bonus_earned.
     * @summary Get Android Waitlist Rank
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public getAndroidWaitlistRank(options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).getAndroidWaitlistRank(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current user\'s pending promo info (for paywall/onboarding display).  Returns 200 with campaign details if a pending promo exists, or 204 if not.
     * @summary Get Pending Promo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public getPendingPromo(options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).getPendingPromo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit phone number for Android waitlist boost.  Awards 30,000 points on first submission.
     * @summary Submit Phone Number
     * @param {PhoneNumberSubmitRequest} phoneNumberSubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public submitPhoneNumber(phoneNumberSubmitRequest: PhoneNumberSubmitRequest, options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).submitPhoneNumber(phoneNumberSubmitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate a promo code and return attribution info without applying it.
     * @summary Validate Promo Code
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public validatePromoCode(code: string, options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).validatePromoCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify a social share screenshot and award boost points.  Upload a screenshot of your social media post about Wispr Flow. The screenshot will be verified using AI to confirm: - The post mentions Wispr Flow or contains a wisprflow.ai URL - The post was actually published (not just composed) - The platform (Twitter/X, LinkedIn, WhatsApp, or Slack)  Boost points awarded: - Twitter/X: 50,000 points - LinkedIn: 50,000 points - WhatsApp: 20,000 points - Slack: 20,000 points  Each platform can only be claimed once per user.  File requirements: - PNG or JPEG format only - Maximum file size: 20MB
     * @summary Verify Social Share
     * @param {File} screenshot 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionsApi
     */
    public verifySocialShare(screenshot: File, options?: RawAxiosRequestConfig) {
        return PromotionsApiFp(this.configuration).verifySocialShare(screenshot, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferralApi - axios parameter creator
 * @export
 */
export const ReferralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Apply a referral code for the authenticated user, optionally reconciling Stripe credits.
         * @summary Apply Referral Code
         * @param {ApplyReferralCodeRequest} applyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyReferralCode: async (applyReferralCodeRequest: ApplyReferralCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyReferralCodeRequest' is not null or undefined
            assertParamExists('applyReferralCode', 'applyReferralCodeRequest', applyReferralCodeRequest)
            const localVarPath = `/api/v1/referral/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyReferralCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s referral code. Deprecated — use `GET /api/v1/referral/`.  The `user_id` path parameter is ignored; the code returned is always the caller\'s.
         * @summary Get Referral Code
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReferralCode: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getReferralCode', 'userId', userId)
            const localVarPath = `/api/v1/referral/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get comprehensive referral info for the authenticated user.  Includes their referral code (generated if needed), the name of who referred them (referer_name), and the list of people they have referred (referrals).
         * @summary Get Referrals Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referral/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the student referral challenge leaderboard.  Only readable by users bucketed into the `leaderboard` variant of the `student-referral-challenge` PostHog experiment — the same enrollment that surfaces this leaderboard in the client. Eligibility (variant, school domain, and challenge window) is resolved server-side in one call, keyed on the user\'s id (the client\'s PostHog distinct id), so it can\'t be spoofed by the caller. Fails closed (403) on any PostHog error, non-`leaderboard` variant, or missing/invalid domain. Returns first_name, last_initial (only), referral_count, and is_current_user (never a user id).
         * @summary Get Student Challenge Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentChallengeLeaderboard: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referral/student-challenge/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the total referral credit/reward balance for the authenticated user.
         * @summary Get Total Credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCredits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referral/credits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send referral emails to a list of addresses and record them as pending referrals.
         * @summary Refer Emails
         * @param {ReferEmailsRequest} referEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referEmails: async (referEmailsRequest: ReferEmailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referEmailsRequest' is not null or undefined
            assertParamExists('referEmails', 'referEmailsRequest', referEmailsRequest)
            const localVarPath = `/api/v1/referral/refer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(referEmailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenerate the user\'s referral code based on their current first name.
         * @summary Regenerate Referral Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateReferralCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/referral/regenerate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a platform-specific download-link email to a recipient (unauthenticated, rate-limited).
         * @summary Send Download Link
         * @param {DirectDownloadLinkRequest} directDownloadLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDownloadLink: async (directDownloadLinkRequest: DirectDownloadLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directDownloadLinkRequest' is not null or undefined
            assertParamExists('sendDownloadLink', 'directDownloadLinkRequest', directDownloadLinkRequest)
            const localVarPath = `/api/v1/referral/download-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directDownloadLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a generic app-download email to the user (``refer_to`` must be \"ios\" or \"desktop\").
         * @summary Send Generic Download Email
         * @param {SelfReferRequest} selfReferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGenericDownloadEmail: async (selfReferRequest: SelfReferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selfReferRequest' is not null or undefined
            assertParamExists('sendGenericDownloadEmail', 'selfReferRequest', selfReferRequest)
            const localVarPath = `/api/v1/referral/self-refer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selfReferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferralApi - functional programming interface
 * @export
 */
export const ReferralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferralApiAxiosParamCreator(configuration)
    return {
        /**
         * Apply a referral code for the authenticated user, optionally reconciling Stripe credits.
         * @summary Apply Referral Code
         * @param {ApplyReferralCodeRequest} applyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyReferralCode(applyReferralCodeRequest: ApplyReferralCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyReferralCode(applyReferralCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.applyReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s referral code. Deprecated — use `GET /api/v1/referral/`.  The `user_id` path parameter is ignored; the code returned is always the caller\'s.
         * @summary Get Referral Code
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getReferralCode(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralCode(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.getReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get comprehensive referral info for the authenticated user.  Includes their referral code (generated if needed), the name of who referred them (referer_name), and the list of people they have referred (referrals).
         * @summary Get Referrals Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralsInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralsInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.getReferralsInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the student referral challenge leaderboard.  Only readable by users bucketed into the `leaderboard` variant of the `student-referral-challenge` PostHog experiment — the same enrollment that surfaces this leaderboard in the client. Eligibility (variant, school domain, and challenge window) is resolved server-side in one call, keyed on the user\'s id (the client\'s PostHog distinct id), so it can\'t be spoofed by the caller. Fails closed (403) on any PostHog error, non-`leaderboard` variant, or missing/invalid domain. Returns first_name, last_initial (only), referral_count, and is_current_user (never a user id).
         * @summary Get Student Challenge Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudentChallengeLeaderboard(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentChallengeLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudentChallengeLeaderboard(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.getStudentChallengeLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the total referral credit/reward balance for the authenticated user.
         * @summary Get Total Credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotalCredits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotalCredits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.getTotalCredits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send referral emails to a list of addresses and record them as pending referrals.
         * @summary Refer Emails
         * @param {ReferEmailsRequest} referEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async referEmails(referEmailsRequest: ReferEmailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.referEmails(referEmailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.referEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Regenerate the user\'s referral code based on their current first name.
         * @summary Regenerate Referral Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateReferralCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateReferralCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.regenerateReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a platform-specific download-link email to a recipient (unauthenticated, rate-limited).
         * @summary Send Download Link
         * @param {DirectDownloadLinkRequest} directDownloadLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendDownloadLink(directDownloadLinkRequest: DirectDownloadLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendDownloadLink(directDownloadLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.sendDownloadLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send a generic app-download email to the user (``refer_to`` must be \"ios\" or \"desktop\").
         * @summary Send Generic Download Email
         * @param {SelfReferRequest} selfReferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendGenericDownloadEmail(selfReferRequest: SelfReferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendGenericDownloadEmail(selfReferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferralApi.sendGenericDownloadEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferralApi - factory interface
 * @export
 */
export const ReferralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferralApiFp(configuration)
    return {
        /**
         * Apply a referral code for the authenticated user, optionally reconciling Stripe credits.
         * @summary Apply Referral Code
         * @param {ApplyReferralCodeRequest} applyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyReferralCode(applyReferralCodeRequest: ApplyReferralCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.applyReferralCode(applyReferralCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s referral code. Deprecated — use `GET /api/v1/referral/`.  The `user_id` path parameter is ignored; the code returned is always the caller\'s.
         * @summary Get Referral Code
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReferralCode(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<ReferralCodeResponse> {
            return localVarFp.getReferralCode(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get comprehensive referral info for the authenticated user.  Includes their referral code (generated if needed), the name of who referred them (referer_name), and the list of people they have referred (referrals).
         * @summary Get Referrals Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralsInfo(options?: RawAxiosRequestConfig): AxiosPromise<ReferralInfoResponse> {
            return localVarFp.getReferralsInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the student referral challenge leaderboard.  Only readable by users bucketed into the `leaderboard` variant of the `student-referral-challenge` PostHog experiment — the same enrollment that surfaces this leaderboard in the client. Eligibility (variant, school domain, and challenge window) is resolved server-side in one call, keyed on the user\'s id (the client\'s PostHog distinct id), so it can\'t be spoofed by the caller. Fails closed (403) on any PostHog error, non-`leaderboard` variant, or missing/invalid domain. Returns first_name, last_initial (only), referral_count, and is_current_user (never a user id).
         * @summary Get Student Challenge Leaderboard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentChallengeLeaderboard(options?: RawAxiosRequestConfig): AxiosPromise<StudentChallengeLeaderboardResponse> {
            return localVarFp.getStudentChallengeLeaderboard(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the total referral credit/reward balance for the authenticated user.
         * @summary Get Total Credits
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalCredits(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTotalCredits(options).then((request) => request(axios, basePath));
        },
        /**
         * Send referral emails to a list of addresses and record them as pending referrals.
         * @summary Refer Emails
         * @param {ReferEmailsRequest} referEmailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        referEmails(referEmailsRequest: ReferEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.referEmails(referEmailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenerate the user\'s referral code based on their current first name.
         * @summary Regenerate Referral Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateReferralCode(options?: RawAxiosRequestConfig): AxiosPromise<ReferralCodeResponse> {
            return localVarFp.regenerateReferralCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Send a platform-specific download-link email to a recipient (unauthenticated, rate-limited).
         * @summary Send Download Link
         * @param {DirectDownloadLinkRequest} directDownloadLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendDownloadLink(directDownloadLinkRequest: DirectDownloadLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendDownloadLink(directDownloadLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send a generic app-download email to the user (``refer_to`` must be \"ios\" or \"desktop\").
         * @summary Send Generic Download Email
         * @param {SelfReferRequest} selfReferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendGenericDownloadEmail(selfReferRequest: SelfReferRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendGenericDownloadEmail(selfReferRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferralApi - object-oriented interface
 * @export
 * @class ReferralApi
 * @extends {BaseAPI}
 */
export class ReferralApi extends BaseAPI {
    /**
     * Apply a referral code for the authenticated user, optionally reconciling Stripe credits.
     * @summary Apply Referral Code
     * @param {ApplyReferralCodeRequest} applyReferralCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public applyReferralCode(applyReferralCodeRequest: ApplyReferralCodeRequest, options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).applyReferralCode(applyReferralCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s referral code. Deprecated — use `GET /api/v1/referral/`.  The `user_id` path parameter is ignored; the code returned is always the caller\'s.
     * @summary Get Referral Code
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public getReferralCode(userId: string, options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).getReferralCode(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get comprehensive referral info for the authenticated user.  Includes their referral code (generated if needed), the name of who referred them (referer_name), and the list of people they have referred (referrals).
     * @summary Get Referrals Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public getReferralsInfo(options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).getReferralsInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the student referral challenge leaderboard.  Only readable by users bucketed into the `leaderboard` variant of the `student-referral-challenge` PostHog experiment — the same enrollment that surfaces this leaderboard in the client. Eligibility (variant, school domain, and challenge window) is resolved server-side in one call, keyed on the user\'s id (the client\'s PostHog distinct id), so it can\'t be spoofed by the caller. Fails closed (403) on any PostHog error, non-`leaderboard` variant, or missing/invalid domain. Returns first_name, last_initial (only), referral_count, and is_current_user (never a user id).
     * @summary Get Student Challenge Leaderboard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public getStudentChallengeLeaderboard(options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).getStudentChallengeLeaderboard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the total referral credit/reward balance for the authenticated user.
     * @summary Get Total Credits
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public getTotalCredits(options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).getTotalCredits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send referral emails to a list of addresses and record them as pending referrals.
     * @summary Refer Emails
     * @param {ReferEmailsRequest} referEmailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public referEmails(referEmailsRequest: ReferEmailsRequest, options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).referEmails(referEmailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenerate the user\'s referral code based on their current first name.
     * @summary Regenerate Referral Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public regenerateReferralCode(options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).regenerateReferralCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a platform-specific download-link email to a recipient (unauthenticated, rate-limited).
     * @summary Send Download Link
     * @param {DirectDownloadLinkRequest} directDownloadLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public sendDownloadLink(directDownloadLinkRequest: DirectDownloadLinkRequest, options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).sendDownloadLink(directDownloadLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send a generic app-download email to the user (``refer_to`` must be \"ios\" or \"desktop\").
     * @summary Send Generic Download Email
     * @param {SelfReferRequest} selfReferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferralApi
     */
    public sendGenericDownloadEmail(selfReferRequest: SelfReferRequest, options?: RawAxiosRequestConfig) {
        return ReferralApiFp(this.configuration).sendGenericDownloadEmail(selfReferRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SMSApi - axios parameter creator
 * @export
 */
export const SMSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Report whether the authenticated user has any recorded SMS events.
         * @summary Check User Has Sms Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserHasSmsEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sms/user-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle an incoming SMS webhook from Twilio and reply with TwiML.
         * @summary Handle Incoming Sms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleIncomingSms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sms/handle-incoming-sms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SMSApi - functional programming interface
 * @export
 */
export const SMSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SMSApiAxiosParamCreator(configuration)
    return {
        /**
         * Report whether the authenticated user has any recorded SMS events.
         * @summary Check User Has Sms Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserHasSmsEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserHasSmsEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.checkUserHasSmsEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle an incoming SMS webhook from Twilio and reply with TwiML.
         * @summary Handle Incoming Sms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleIncomingSms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleIncomingSms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.handleIncomingSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SMSApi - factory interface
 * @export
 */
export const SMSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SMSApiFp(configuration)
    return {
        /**
         * Report whether the authenticated user has any recorded SMS events.
         * @summary Check User Has Sms Events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserHasSmsEvents(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.checkUserHasSmsEvents(options).then((request) => request(axios, basePath));
        },
        /**
         * Handle an incoming SMS webhook from Twilio and reply with TwiML.
         * @summary Handle Incoming Sms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleIncomingSms(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.handleIncomingSms(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SMSApi - object-oriented interface
 * @export
 * @class SMSApi
 * @extends {BaseAPI}
 */
export class SMSApi extends BaseAPI {
    /**
     * Report whether the authenticated user has any recorded SMS events.
     * @summary Check User Has Sms Events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public checkUserHasSmsEvents(options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).checkUserHasSmsEvents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle an incoming SMS webhook from Twilio and reply with TwiML.
     * @summary Handle Incoming Sms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public handleIncomingSms(options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).handleIncomingSms(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SandboxUserApi - axios parameter creator
 * @export
 */
export const SandboxUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a sandbox user and sign in.     **Authentication Required**: Must be logged in with a @wispr.ai email address.     This endpoint:     1. Creates a Supabase user with @wispr.test email     2. Creates all necessary database records with onboarding NOT completed     3. Returns auth tokens for immediate sign-in
         * @summary Create and sign in a sandbox user
         * @param {CreateSandboxUserRequest} createSandboxUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndSigninSandboxUser: async (createSandboxUserRequest: CreateSandboxUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSandboxUserRequest' is not null or undefined
            assertParamExists('createAndSigninSandboxUser', 'createSandboxUserRequest', createSandboxUserRequest)
            const localVarPath = `/api/v1/sandbox-user/create-and-signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSandboxUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a sandbox user\'s data from all tables and services.     This endpoint:     1. Validates the user has a @wispr.test email     2. Returns 200 after synchronous deletion when the Temporal rollout is disabled     3. Returns 202 after Temporal accepts the deletion when the rollout is enabled     4. Deletes data from: main DB (incl. Subscription via CASCADE), usage DB, Customer.io, Segment, PostHog, ClickHouse     5. Cancels any active subscriptions via Stripe     6. Deletes from Supabase and WorkOS identity providers     **WARNING**: This permanently deletes all data for the sandbox user and their enterprise if they\'re the only member.
         * @summary Destroy a sandbox user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySandboxUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sandbox-user/destroy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SandboxUserApi - functional programming interface
 * @export
 */
export const SandboxUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SandboxUserApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a sandbox user and sign in.     **Authentication Required**: Must be logged in with a @wispr.ai email address.     This endpoint:     1. Creates a Supabase user with @wispr.test email     2. Creates all necessary database records with onboarding NOT completed     3. Returns auth tokens for immediate sign-in
         * @summary Create and sign in a sandbox user
         * @param {CreateSandboxUserRequest} createSandboxUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAndSigninSandboxUser(createSandboxUserRequest: CreateSandboxUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSandboxUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAndSigninSandboxUser(createSandboxUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SandboxUserApi.createAndSigninSandboxUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a sandbox user\'s data from all tables and services.     This endpoint:     1. Validates the user has a @wispr.test email     2. Returns 200 after synchronous deletion when the Temporal rollout is disabled     3. Returns 202 after Temporal accepts the deletion when the rollout is enabled     4. Deletes data from: main DB (incl. Subscription via CASCADE), usage DB, Customer.io, Segment, PostHog, ClickHouse     5. Cancels any active subscriptions via Stripe     6. Deletes from Supabase and WorkOS identity providers     **WARNING**: This permanently deletes all data for the sandbox user and their enterprise if they\'re the only member.
         * @summary Destroy a sandbox user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroySandboxUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DestroySandboxUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroySandboxUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SandboxUserApi.destroySandboxUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SandboxUserApi - factory interface
 * @export
 */
export const SandboxUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SandboxUserApiFp(configuration)
    return {
        /**
         * Create a sandbox user and sign in.     **Authentication Required**: Must be logged in with a @wispr.ai email address.     This endpoint:     1. Creates a Supabase user with @wispr.test email     2. Creates all necessary database records with onboarding NOT completed     3. Returns auth tokens for immediate sign-in
         * @summary Create and sign in a sandbox user
         * @param {CreateSandboxUserRequest} createSandboxUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAndSigninSandboxUser(createSandboxUserRequest: CreateSandboxUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateSandboxUserResponse> {
            return localVarFp.createAndSigninSandboxUser(createSandboxUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a sandbox user\'s data from all tables and services.     This endpoint:     1. Validates the user has a @wispr.test email     2. Returns 200 after synchronous deletion when the Temporal rollout is disabled     3. Returns 202 after Temporal accepts the deletion when the rollout is enabled     4. Deletes data from: main DB (incl. Subscription via CASCADE), usage DB, Customer.io, Segment, PostHog, ClickHouse     5. Cancels any active subscriptions via Stripe     6. Deletes from Supabase and WorkOS identity providers     **WARNING**: This permanently deletes all data for the sandbox user and their enterprise if they\'re the only member.
         * @summary Destroy a sandbox user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySandboxUser(options?: RawAxiosRequestConfig): AxiosPromise<DestroySandboxUserResponse> {
            return localVarFp.destroySandboxUser(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SandboxUserApi - object-oriented interface
 * @export
 * @class SandboxUserApi
 * @extends {BaseAPI}
 */
export class SandboxUserApi extends BaseAPI {
    /**
     * Create a sandbox user and sign in.     **Authentication Required**: Must be logged in with a @wispr.ai email address.     This endpoint:     1. Creates a Supabase user with @wispr.test email     2. Creates all necessary database records with onboarding NOT completed     3. Returns auth tokens for immediate sign-in
     * @summary Create and sign in a sandbox user
     * @param {CreateSandboxUserRequest} createSandboxUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxUserApi
     */
    public createAndSigninSandboxUser(createSandboxUserRequest: CreateSandboxUserRequest, options?: RawAxiosRequestConfig) {
        return SandboxUserApiFp(this.configuration).createAndSigninSandboxUser(createSandboxUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a sandbox user\'s data from all tables and services.     This endpoint:     1. Validates the user has a @wispr.test email     2. Returns 200 after synchronous deletion when the Temporal rollout is disabled     3. Returns 202 after Temporal accepts the deletion when the rollout is enabled     4. Deletes data from: main DB (incl. Subscription via CASCADE), usage DB, Customer.io, Segment, PostHog, ClickHouse     5. Cancels any active subscriptions via Stripe     6. Deletes from Supabase and WorkOS identity providers     **WARNING**: This permanently deletes all data for the sandbox user and their enterprise if they\'re the only member.
     * @summary Destroy a sandbox user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SandboxUserApi
     */
    public destroySandboxUser(options?: RawAxiosRequestConfig) {
        return SandboxUserApiFp(this.configuration).destroySandboxUser(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SkillsApi - axios parameter creator
 * @export
 */
export const SkillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create one of the caller\'s skills, or with ``scope`` a team skill; retrying with the same id is safe.
         * @summary Create Skill
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkill: async (createSkillRequest: CreateSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSkillRequest' is not null or undefined
            assertParamExists('createSkill', 'createSkillRequest', createSkillRequest)
            const localVarPath = `/api/v1/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one of the caller\'s skills, or a team skill in their scope, for good.
         * @summary Delete Skill
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkill: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('deleteSkill', 'skillId', skillId)
            const localVarPath = `/api/v1/skills/{skill_id}`
                .replace(`{${"skill_id"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skills the caller can run: built-ins in catalog order, then their own, their department\'s and their company\'s.
         * @summary List Skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkills: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move one of the caller\'s skills to their department or company, keeping its id; a retry returns it as moved.
         * @summary Share Skill
         * @param {string} skillId 
         * @param {ShareSkillRequest} shareSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareSkill: async (skillId: string, shareSkillRequest: ShareSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('shareSkill', 'skillId', skillId)
            // verify required parameter 'shareSkillRequest' is not null or undefined
            assertParamExists('shareSkill', 'shareSkillRequest', shareSkillRequest)
            const localVarPath = `/api/v1/skills/{skill_id}/share`
                .replace(`{${"skill_id"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit one of the caller\'s skills or a team skill in their scope; only the fields sent change.
         * @summary Update Skill
         * @param {string} skillId 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkill: async (skillId: string, updateSkillRequest: UpdateSkillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('updateSkill', 'skillId', skillId)
            // verify required parameter 'updateSkillRequest' is not null or undefined
            assertParamExists('updateSkill', 'updateSkillRequest', updateSkillRequest)
            const localVarPath = `/api/v1/skills/{skill_id}`
                .replace(`{${"skill_id"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSkillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkillsApi - functional programming interface
 * @export
 */
export const SkillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkillsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create one of the caller\'s skills, or with ``scope`` a team skill; retrying with the same id is safe.
         * @summary Create Skill
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSkill(createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSkill(createSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.createSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one of the caller\'s skills, or a team skill in their scope, for good.
         * @summary Delete Skill
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSkill(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSkill(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.deleteSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Skills the caller can run: built-ins in catalog order, then their own, their department\'s and their company\'s.
         * @summary List Skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSkills(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSkills(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.listSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move one of the caller\'s skills to their department or company, keeping its id; a retry returns it as moved.
         * @summary Share Skill
         * @param {string} skillId 
         * @param {ShareSkillRequest} shareSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareSkill(skillId: string, shareSkillRequest: ShareSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareSkill(skillId, shareSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.shareSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit one of the caller\'s skills or a team skill in their scope; only the fields sent change.
         * @summary Update Skill
         * @param {string} skillId 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSkill(skillId: string, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Skill>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSkill(skillId, updateSkillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SkillsApi.updateSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SkillsApi - factory interface
 * @export
 */
export const SkillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkillsApiFp(configuration)
    return {
        /**
         * Create one of the caller\'s skills, or with ``scope`` a team skill; retrying with the same id is safe.
         * @summary Create Skill
         * @param {CreateSkillRequest} createSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSkill(createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.createSkill(createSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one of the caller\'s skills, or a team skill in their scope, for good.
         * @summary Delete Skill
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSkill(skillId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSkill(skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * Skills the caller can run: built-ins in catalog order, then their own, their department\'s and their company\'s.
         * @summary List Skills
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSkills(options?: RawAxiosRequestConfig): AxiosPromise<ListSkillsResponse> {
            return localVarFp.listSkills(options).then((request) => request(axios, basePath));
        },
        /**
         * Move one of the caller\'s skills to their department or company, keeping its id; a retry returns it as moved.
         * @summary Share Skill
         * @param {string} skillId 
         * @param {ShareSkillRequest} shareSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareSkill(skillId: string, shareSkillRequest: ShareSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.shareSkill(skillId, shareSkillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit one of the caller\'s skills or a team skill in their scope; only the fields sent change.
         * @summary Update Skill
         * @param {string} skillId 
         * @param {UpdateSkillRequest} updateSkillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSkill(skillId: string, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<Skill> {
            return localVarFp.updateSkill(skillId, updateSkillRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkillsApi - object-oriented interface
 * @export
 * @class SkillsApi
 * @extends {BaseAPI}
 */
export class SkillsApi extends BaseAPI {
    /**
     * Create one of the caller\'s skills, or with ``scope`` a team skill; retrying with the same id is safe.
     * @summary Create Skill
     * @param {CreateSkillRequest} createSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public createSkill(createSkillRequest: CreateSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).createSkill(createSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one of the caller\'s skills, or a team skill in their scope, for good.
     * @summary Delete Skill
     * @param {string} skillId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public deleteSkill(skillId: string, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).deleteSkill(skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skills the caller can run: built-ins in catalog order, then their own, their department\'s and their company\'s.
     * @summary List Skills
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public listSkills(options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).listSkills(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move one of the caller\'s skills to their department or company, keeping its id; a retry returns it as moved.
     * @summary Share Skill
     * @param {string} skillId 
     * @param {ShareSkillRequest} shareSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public shareSkill(skillId: string, shareSkillRequest: ShareSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).shareSkill(skillId, shareSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit one of the caller\'s skills or a team skill in their scope; only the fields sent change.
     * @summary Update Skill
     * @param {string} skillId 
     * @param {UpdateSkillRequest} updateSkillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkillsApi
     */
    public updateSkill(skillId: string, updateSkillRequest: UpdateSkillRequest, options?: RawAxiosRequestConfig) {
        return SkillsApiFp(this.configuration).updateSkill(skillId, updateSkillRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SummaryQualityAdminApi - axios parameter creator
 * @export
 */
export const SummaryQualityAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Completed summary runs\' volume, model latency and estimated cost. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trends; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only runs of this prompt hash, when set; ``byVersion`` and candidates ignore it.     summary_model:  Count only runs of this model, when set; ``byVersion`` and candidates ignore it.     user:           Authenticated internal admin (injected).  Returns:     Run counts, latency percentiles and cost, overall, per bucket and per prompt version and model.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Quality Stats
         * @param {string} since Count runs whose summary started at or after this time.
         * @param {string} until Count runs whose summary started before this time.
         * @param {GetSummaryQualityStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryQualityStats: async (since: string, until: string, bucket?: GetSummaryQualityStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'since' is not null or undefined
            assertParamExists('getSummaryQualityStats', 'since', since)
            // verify required parameter 'until' is not null or undefined
            assertParamExists('getSummaryQualityStats', 'until', until)
            const localVarPath = `/api/v1/internal/summary-quality/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (since !== undefined) {
                localVarQueryParameter['since'] = (since as any instanceof Date) ?
                    (since as any).toISOString() :
                    since;
            }

            if (until !== undefined) {
                localVarQueryParameter['until'] = (until as any instanceof Date) ?
                    (until as any).toISOString() :
                    until;
            }

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }

            if (promptVersion !== undefined) {
                localVarQueryParameter['promptVersion'] = promptVersion;
            }

            if (summaryModel !== undefined) {
                localVarQueryParameter['summaryModel'] = summaryModel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummaryQualityAdminApi - functional programming interface
 * @export
 */
export const SummaryQualityAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SummaryQualityAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Completed summary runs\' volume, model latency and estimated cost. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trends; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only runs of this prompt hash, when set; ``byVersion`` and candidates ignore it.     summary_model:  Count only runs of this model, when set; ``byVersion`` and candidates ignore it.     user:           Authenticated internal admin (injected).  Returns:     Run counts, latency percentiles and cost, overall, per bucket and per prompt version and model.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Quality Stats
         * @param {string} since Count runs whose summary started at or after this time.
         * @param {string} until Count runs whose summary started before this time.
         * @param {GetSummaryQualityStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryQualityStats(since: string, until: string, bucket?: GetSummaryQualityStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SummaryQualityStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryQualityStats(since, until, bucket, promptVersion, summaryModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummaryQualityAdminApi.getSummaryQualityStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SummaryQualityAdminApi - factory interface
 * @export
 */
export const SummaryQualityAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SummaryQualityAdminApiFp(configuration)
    return {
        /**
         * Completed summary runs\' volume, model latency and estimated cost. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trends; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only runs of this prompt hash, when set; ``byVersion`` and candidates ignore it.     summary_model:  Count only runs of this model, when set; ``byVersion`` and candidates ignore it.     user:           Authenticated internal admin (injected).  Returns:     Run counts, latency percentiles and cost, overall, per bucket and per prompt version and model.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
         * @summary Get Summary Quality Stats
         * @param {string} since Count runs whose summary started at or after this time.
         * @param {string} until Count runs whose summary started before this time.
         * @param {GetSummaryQualityStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
         * @param {string | null} [promptVersion] 12-hex summary prompt hash.
         * @param {string | null} [summaryModel] Exact model that wrote it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryQualityStats(since: string, until: string, bucket?: GetSummaryQualityStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<SummaryQualityStats> {
            return localVarFp.getSummaryQualityStats(since, until, bucket, promptVersion, summaryModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SummaryQualityAdminApi - object-oriented interface
 * @export
 * @class SummaryQualityAdminApi
 * @extends {BaseAPI}
 */
export class SummaryQualityAdminApi extends BaseAPI {
    /**
     * Completed summary runs\' volume, model latency and estimated cost. Every read is audited.  Args:     request:        Incoming request, checked for impersonation.     response:       Outgoing response, marked ``no-store``.     since:          Start of the window, inclusive.     until:          End of the window, exclusive.     bucket:         Time bucket for the trends; windows are capped at 366 days, or 1098 for weeks.     prompt_version: Count only runs of this prompt hash, when set; ``byVersion`` and candidates ignore it.     summary_model:  Count only runs of this model, when set; ``byVersion`` and candidates ignore it.     user:           Authenticated internal admin (injected).  Returns:     Run counts, latency percentiles and cost, overall, per bucket and per prompt version and model.  Raises:     HTTPException: 422 when ``since`` is not before ``until`` or the window exceeds the bucket\'s cap.
     * @summary Get Summary Quality Stats
     * @param {string} since Count runs whose summary started at or after this time.
     * @param {string} until Count runs whose summary started before this time.
     * @param {GetSummaryQualityStatsBucketEnum} [bucket] UTC day, or ISO week from Monday.
     * @param {string | null} [promptVersion] 12-hex summary prompt hash.
     * @param {string | null} [summaryModel] Exact model that wrote it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummaryQualityAdminApi
     */
    public getSummaryQualityStats(since: string, until: string, bucket?: GetSummaryQualityStatsBucketEnum, promptVersion?: string | null, summaryModel?: string | null, options?: RawAxiosRequestConfig) {
        return SummaryQualityAdminApiFp(this.configuration).getSummaryQualityStats(since, until, bucket, promptVersion, summaryModel, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetSummaryQualityStatsBucketEnum = {
    Day: 'day',
    Week: 'week'
} as const;
export type GetSummaryQualityStatsBucketEnum = typeof GetSummaryQualityStatsBucketEnum[keyof typeof GetSummaryQualityStatsBucketEnum];


/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sync an enterprise\'s workspace, users, or invoices into Attio (root API key).
         * @summary Attio Sync
         * @param {string} enterpriseId 
         * @param {AttioSyncTypeOfSyncEnum} [typeOfSync] Type of sync: \&#39;workspace\&#39; or \&#39;users\&#39; or \&#39;invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attioSync: async (enterpriseId: string, typeOfSync?: AttioSyncTypeOfSyncEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('attioSync', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/support/attio-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (typeOfSync !== undefined) {
                localVarQueryParameter['type_of_sync'] = typeOfSync;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Create Pylon Feedback
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPylonFeedback: async (body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createPylonFeedback', 'body', body)
            const localVarPath = `/api/v1/support/pylon-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (body !== undefined) { 
                localVarFormParams.append('body', body as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

    
            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (comment !== undefined) { 
                localVarFormParams.append('comment', comment as any);
            }
    
            if (platform !== undefined) { 
                localVarFormParams.append('platform', platform as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the authenticated user and all their data.
         * @summary Delete User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/support/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Frontapp Feedback
         * @param {string} to 
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontappFeedback: async (to: string, body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'to' is not null or undefined
            assertParamExists('frontappFeedback', 'to', to)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('frontappFeedback', 'body', body)
            const localVarPath = `/api/v1/support/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (to !== undefined) { 
                localVarFormParams.append('to', to as any);
            }
    
            if (body !== undefined) { 
                localVarFormParams.append('body', body as any);
            }
                if (attachments) {
                attachments.forEach((element) => {
                    localVarFormParams.append('attachments', element as any);
                })
            }

    
            if (subject !== undefined) { 
                localVarFormParams.append('subject', subject as any);
            }
    
            if (comment !== undefined) { 
                localVarFormParams.append('comment', comment as any);
            }
    
            if (platform !== undefined) { 
                localVarFormParams.append('platform', platform as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a Pylon support ticket from feedback that includes an attached image.
         * @summary Frontapp Feedback With Image
         * @param {SupportFeedbackRequest} supportFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontappFeedbackWithImage: async (supportFeedbackRequest: SupportFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportFeedbackRequest' is not null or undefined
            assertParamExists('frontappFeedbackWithImage', 'supportFeedbackRequest', supportFeedbackRequest)
            const localVarPath = `/api/v1/support/image-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return PII-safe status for an opaque request ID.
         * @summary Get Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDeletionStatus: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAccountDeletionStatus', 'requestId', requestId)
            const localVarPath = `/api/v1/support/account-deletions/{request_id}`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return status only when the request belongs to the authenticated identity.
         * @summary Get Own Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnAccountDeletionStatus: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getOwnAccountDeletionStatus', 'requestId', requestId)
            const localVarPath = `/api/v1/support/users/deletion/{request_id}`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redacted status of the authenticated user\'s own erasure (JWT; never under impersonation).
         * @summary Get Own Usage Data Erasure Status
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories; omitted reads the full erasure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnUsageDataErasureStatus: async (categories?: Array<DataCategory> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/support/usage-data-erasure/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redacted erasure status by `user_id` or `email` (root API key; ids/enums/counts only).  In-flight from Temporal (`describe_workflow` + the progress query), terminal from the audit row, or a clean not-found. PII (raw email / content / errors) never appears.
         * @summary Get Usage Data Erasure Status
         * @param {string | null} [userId] Target user id
         * @param {string | null} [email] Target user email
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageDataErasureStatus: async (userId?: string | null, email?: string | null, categories?: Array<DataCategory> | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/support/usage-data-erasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (categories) {
                localVarQueryParameter['categories'] = categories;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Look up deletion status by email without echoing the identity.
         * @summary Lookup Account Deletion
         * @param {GdprRequestLookupByEmailRequest} gdprRequestLookupByEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupAccountDeletion: async (gdprRequestLookupByEmailRequest: GdprRequestLookupByEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gdprRequestLookupByEmailRequest' is not null or undefined
            assertParamExists('lookupAccountDeletion', 'gdprRequestLookupByEmailRequest', gdprRequestLookupByEmailRequest)
            const localVarPath = `/api/v1/support/account-deletions/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gdprRequestLookupByEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit feedback before authenticating, for login or account-creation issues.
         * @summary Pre Login Feedback
         * @param {PreLoginFeedbackRequest} preLoginFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preLoginFeedback: async (preLoginFeedbackRequest: PreLoginFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preLoginFeedbackRequest' is not null or undefined
            assertParamExists('preLoginFeedback', 'preLoginFeedbackRequest', preLoginFeedbackRequest)
            const localVarPath = `/api/v1/support/pre-login-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preLoginFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retry a failed request or recover a dispatch that never bound a Temporal run.
         * @summary Retry Account Deletion
         * @param {string} requestId 
         * @param {GdprRequestRetryRequest} gdprRequestRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAccountDeletion: async (requestId: string, gdprRequestRetryRequest: GdprRequestRetryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('retryAccountDeletion', 'requestId', requestId)
            // verify required parameter 'gdprRequestRetryRequest' is not null or undefined
            assertParamExists('retryAccountDeletion', 'gdprRequestRetryRequest', gdprRequestRetryRequest)
            const localVarPath = `/api/v1/support/account-deletions/{request_id}/retry`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gdprRequestRetryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send user feedback (with optional audio and image) to Slack.
         * @summary Send Feedback Slack
         * @param {SrcCommonConstantsPlatform} platform 
         * @param {File | null} [audio] 
         * @param {string | null} [asrText] 
         * @param {string | null} [formattedText] 
         * @param {string | null} [feedback] 
         * @param {string | null} [logs] 
         * @param {string | null} [imageData] 
         * @param {ImageType | null} [imageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedbackSlack: async (platform: SrcCommonConstantsPlatform, audio?: File | null, asrText?: string | null, formattedText?: string | null, feedback?: string | null, logs?: string | null, imageData?: string | null, imageType?: ImageType | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('sendFeedbackSlack', 'platform', platform)
            const localVarPath = `/api/v1/support/slack/{platform}`
                .replace(`{${"platform"}}`, encodeURIComponent(String(platform)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (audio !== undefined) { 
                localVarFormParams.append('audio', audio as any);
            }
    
            if (asrText !== undefined) { 
                localVarFormParams.append('asr_text', asrText as any);
            }
    
            if (formattedText !== undefined) { 
                localVarFormParams.append('formatted_text', formattedText as any);
            }
    
            if (feedback !== undefined) { 
                localVarFormParams.append('feedback', feedback as any);
            }
    
            if (logs !== undefined) { 
                localVarFormParams.append('logs', logs as any);
            }
    
            if (imageData !== undefined) { 
                localVarFormParams.append('image_data', imageData as any);
            }
    
            if (imageType !== undefined) { 
                localVarFormParams.append('image_type', imageType as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Forward an instruct-mode feedback submission to the instruct-mode Slack channel.
         * @summary Send Instruct Feedback
         * @param {InstructFeedbackRequest} instructFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInstructFeedback: async (instructFeedbackRequest: InstructFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'instructFeedbackRequest' is not null or undefined
            assertParamExists('sendInstructFeedback', 'instructFeedbackRequest', instructFeedbackRequest)
            const localVarPath = `/api/v1/support/instruct-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(instructFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Erase the authenticated user\'s own usage data, all or chosen categories (JWT; never under impersonation).
         * @summary Start Own Usage Data Erasure
         * @param {SelfErasureStartRequest} selfErasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOwnUsageDataErasure: async (selfErasureStartRequest: SelfErasureStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'selfErasureStartRequest' is not null or undefined
            assertParamExists('startOwnUsageDataErasure', 'selfErasureStartRequest', selfErasureStartRequest)
            const localVarPath = `/api/v1/support/usage-data-erasure/self`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(selfErasureStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start an account-preserving usage-data erasure (support staff, root API key).  Gated by the root API key — the same key that authorizes account deletion (`support_delete_user`); no JWT path. Email is the PRIMARY identifier; `user_id`+`confirm_orphan` is the orphan/no-email fallback. `actor`/`reason` are recorded UNTRUSTED. A `start_workflow` failure surfaces as 5xx (nothing persisted pre-start; the caller retries — idempotent via USE_EXISTING).
         * @summary Start Usage Data Erasure
         * @param {ErasureStartRequest} erasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startUsageDataErasure: async (erasureStartRequest: ErasureStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'erasureStartRequest' is not null or undefined
            assertParamExists('startUsageDataErasure', 'erasureStartRequest', erasureStartRequest)
            const localVarPath = `/api/v1/support/usage-data-erasure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(erasureStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit NPS free-text feedback for a customer and campaign.
         * @summary Submit Nps Feedback
         * @param {NPSFeedbackRequest} nPSFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNpsFeedback: async (nPSFeedbackRequest: NPSFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nPSFeedbackRequest' is not null or undefined
            assertParamExists('submitNpsFeedback', 'nPSFeedbackRequest', nPSFeedbackRequest)
            const localVarPath = `/api/v1/support/nps/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nPSFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit an NPS score for a customer and campaign.
         * @summary Submit Nps Score
         * @param {NPSScoreRequest} nPSScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNpsScore: async (nPSScoreRequest: NPSScoreRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'nPSScoreRequest' is not null or undefined
            assertParamExists('submitNpsScore', 'nPSScoreRequest', nPSScoreRequest)
            const localVarPath = `/api/v1/support/nps/score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nPSScoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a user\'s active Stripe subscription and refund based on request.  - refund=\"full\": refund entire current cycle amount - refund=\"partial\": prorated refund for unused period - refund=\"no\": cancel immediately with no refund
         * @summary Support Cancel Subscription
         * @param {CancelSubscriptionRequest} cancelSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportCancelSubscription: async (cancelSubscriptionRequest: CancelSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelSubscriptionRequest' is not null or undefined
            assertParamExists('supportCancelSubscription', 'cancelSubscriptionRequest', cancelSubscriptionRequest)
            const localVarPath = `/api/v1/support/cancel-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a user and all their data (support staff only).  Requires the root API key and is intended for support staff only. The rollout-gated path schedules immediate asynchronous erasure.
         * @summary Support Delete User
         * @param {string} email 
         * @param {GdprRequestStartRequest} [gdprRequestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportDeleteUser: async (email: string, gdprRequestStartRequest?: GdprRequestStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('supportDeleteUser', 'email', email)
            const localVarPath = `/api/v1/support/users/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gdprRequestStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync a user\'s mobile_subscription row from current RevenueCat state.  Intended to patch up state after missed webhooks. Future webhooks with newer event timestamps will still override this sync via the upsert stale-event guard.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the mobile_subscription table
         * @summary Sync Individual Mobile Subscription
         * @param {SyncMobileSubscriptionRequest} syncMobileSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIndividualMobileSubscription: async (syncMobileSubscriptionRequest: SyncMobileSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncMobileSubscriptionRequest' is not null or undefined
            assertParamExists('syncIndividualMobileSubscription', 'syncMobileSubscriptionRequest', syncMobileSubscriptionRequest)
            const localVarPath = `/api/v1/support/sync-individual-mobile-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncMobileSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync a user\'s individual Stripe subscription row from current Stripe state.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the subscription table
         * @summary Sync Individual Stripe Subscription
         * @param {SyncSubscriptionRequest} syncSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIndividualStripeSubscription: async (syncSubscriptionRequest: SyncSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncSubscriptionRequest' is not null or undefined
            assertParamExists('syncIndividualStripeSubscription', 'syncSubscriptionRequest', syncSubscriptionRequest)
            const localVarPath = `/api/v1/support/sync-individual-stripe-subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update by email or enqueue an issue; enabled strict refresh ignores reenable_if_disabled.
         * @summary Update Pylon Account
         * @param {string | null} [email] 
         * @param {boolean} [reenableIfDisabled] 
         * @param {PylonAccountUpdateRequest} [pylonAccountUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePylonAccount: async (email?: string | null, reenableIfDisabled?: boolean, pylonAccountUpdateRequest?: PylonAccountUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/support/update-pylon-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication PylonWebhookKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Pylon-Webhook-Key", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (reenableIfDisabled !== undefined) {
                localVarQueryParameter['reenable_if_disabled'] = reenableIfDisabled;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pylonAccountUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept a refresh of an existing enterprise account.
         * @summary Update Pylon Enterprise Account
         * @param {PylonEnterpriseRefreshRequest} pylonEnterpriseRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePylonEnterpriseAccount: async (pylonEnterpriseRefreshRequest: PylonEnterpriseRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pylonEnterpriseRefreshRequest' is not null or undefined
            assertParamExists('updatePylonEnterpriseAccount', 'pylonEnterpriseRefreshRequest', pylonEnterpriseRefreshRequest)
            const localVarPath = `/api/v1/support/update-pylon-enterprise-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication PylonWebhookKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Pylon-Webhook-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pylonEnterpriseRefreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validate that a Supabase user exists for the email and matches the DB user_id.
         * @summary Validate User
         * @param {string} email The email of the user to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUser: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('validateUser', 'email', email)
            const localVarPath = `/api/v1/support/validate-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * Sync an enterprise\'s workspace, users, or invoices into Attio (root API key).
         * @summary Attio Sync
         * @param {string} enterpriseId 
         * @param {AttioSyncTypeOfSyncEnum} [typeOfSync] Type of sync: \&#39;workspace\&#39; or \&#39;users\&#39; or \&#39;invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attioSync(enterpriseId: string, typeOfSync?: AttioSyncTypeOfSyncEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attioSync(enterpriseId, typeOfSync, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.attioSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Create Pylon Feedback
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPylonFeedback(body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPylonFeedback(body, attachments, subject, comment, platform, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.createPylonFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the authenticated user and all their data.
         * @summary Delete User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Frontapp Feedback
         * @param {string} to 
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontappFeedback(to: string, body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontappFeedback(to, body, attachments, subject, comment, platform, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.frontappFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a Pylon support ticket from feedback that includes an attached image.
         * @summary Frontapp Feedback With Image
         * @param {SupportFeedbackRequest} supportFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async frontappFeedbackWithImage(supportFeedbackRequest: SupportFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.frontappFeedbackWithImage(supportFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.frontappFeedbackWithImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return PII-safe status for an opaque request ID.
         * @summary Get Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountDeletionStatus(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.getAccountDeletionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return status only when the request belongs to the authenticated identity.
         * @summary Get Own Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnAccountDeletionStatus(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.getOwnAccountDeletionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redacted status of the authenticated user\'s own erasure (JWT; never under impersonation).
         * @summary Get Own Usage Data Erasure Status
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories; omitted reads the full erasure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnUsageDataErasureStatus(categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnUsageDataErasureStatus(categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.getOwnUsageDataErasureStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redacted erasure status by `user_id` or `email` (root API key; ids/enums/counts only).  In-flight from Temporal (`describe_workflow` + the progress query), terminal from the audit row, or a clean not-found. PII (raw email / content / errors) never appears.
         * @summary Get Usage Data Erasure Status
         * @param {string | null} [userId] Target user id
         * @param {string | null} [email] Target user email
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageDataErasureStatus(userId?: string | null, email?: string | null, categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageDataErasureStatus(userId, email, categories, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.getUsageDataErasureStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Look up deletion status by email without echoing the identity.
         * @summary Lookup Account Deletion
         * @param {GdprRequestLookupByEmailRequest} gdprRequestLookupByEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupAccountDeletion(gdprRequestLookupByEmailRequest: GdprRequestLookupByEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupAccountDeletion(gdprRequestLookupByEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.lookupAccountDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit feedback before authenticating, for login or account-creation issues.
         * @summary Pre Login Feedback
         * @param {PreLoginFeedbackRequest} preLoginFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preLoginFeedback(preLoginFeedbackRequest: PreLoginFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.preLoginFeedback(preLoginFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.preLoginFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retry a failed request or recover a dispatch that never bound a Temporal run.
         * @summary Retry Account Deletion
         * @param {string} requestId 
         * @param {GdprRequestRetryRequest} gdprRequestRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryAccountDeletion(requestId: string, gdprRequestRetryRequest: GdprRequestRetryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryAccountDeletion(requestId, gdprRequestRetryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.retryAccountDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send user feedback (with optional audio and image) to Slack.
         * @summary Send Feedback Slack
         * @param {SrcCommonConstantsPlatform} platform 
         * @param {File | null} [audio] 
         * @param {string | null} [asrText] 
         * @param {string | null} [formattedText] 
         * @param {string | null} [feedback] 
         * @param {string | null} [logs] 
         * @param {string | null} [imageData] 
         * @param {ImageType | null} [imageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFeedbackSlack(platform: SrcCommonConstantsPlatform, audio?: File | null, asrText?: string | null, formattedText?: string | null, feedback?: string | null, logs?: string | null, imageData?: string | null, imageType?: ImageType | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFeedbackSlack(platform, audio, asrText, formattedText, feedback, logs, imageData, imageType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.sendFeedbackSlack']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Forward an instruct-mode feedback submission to the instruct-mode Slack channel.
         * @summary Send Instruct Feedback
         * @param {InstructFeedbackRequest} instructFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInstructFeedback(instructFeedbackRequest: InstructFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInstructFeedback(instructFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.sendInstructFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Erase the authenticated user\'s own usage data, all or chosen categories (JWT; never under impersonation).
         * @summary Start Own Usage Data Erasure
         * @param {SelfErasureStartRequest} selfErasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startOwnUsageDataErasure(selfErasureStartRequest: SelfErasureStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startOwnUsageDataErasure(selfErasureStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.startOwnUsageDataErasure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start an account-preserving usage-data erasure (support staff, root API key).  Gated by the root API key — the same key that authorizes account deletion (`support_delete_user`); no JWT path. Email is the PRIMARY identifier; `user_id`+`confirm_orphan` is the orphan/no-email fallback. `actor`/`reason` are recorded UNTRUSTED. A `start_workflow` failure surfaces as 5xx (nothing persisted pre-start; the caller retries — idempotent via USE_EXISTING).
         * @summary Start Usage Data Erasure
         * @param {ErasureStartRequest} erasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startUsageDataErasure(erasureStartRequest: ErasureStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ErasureStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startUsageDataErasure(erasureStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.startUsageDataErasure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit NPS free-text feedback for a customer and campaign.
         * @summary Submit Nps Feedback
         * @param {NPSFeedbackRequest} nPSFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitNpsFeedback(nPSFeedbackRequest: NPSFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitNpsFeedback(nPSFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.submitNpsFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit an NPS score for a customer and campaign.
         * @summary Submit Nps Score
         * @param {NPSScoreRequest} nPSScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitNpsScore(nPSScoreRequest: NPSScoreRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitNpsScore(nPSScoreRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.submitNpsScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a user\'s active Stripe subscription and refund based on request.  - refund=\"full\": refund entire current cycle amount - refund=\"partial\": prorated refund for unused period - refund=\"no\": cancel immediately with no refund
         * @summary Support Cancel Subscription
         * @param {CancelSubscriptionRequest} cancelSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportCancelSubscription(cancelSubscriptionRequest: CancelSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportCancelSubscription(cancelSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.supportCancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a user and all their data (support staff only).  Requires the root API key and is intended for support staff only. The rollout-gated path schedules immediate asynchronous erasure.
         * @summary Support Delete User
         * @param {string} email 
         * @param {GdprRequestStartRequest} [gdprRequestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supportDeleteUser(email: string, gdprRequestStartRequest?: GdprRequestStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GdprRequestAcceptedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supportDeleteUser(email, gdprRequestStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.supportDeleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync a user\'s mobile_subscription row from current RevenueCat state.  Intended to patch up state after missed webhooks. Future webhooks with newer event timestamps will still override this sync via the upsert stale-event guard.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the mobile_subscription table
         * @summary Sync Individual Mobile Subscription
         * @param {SyncMobileSubscriptionRequest} syncMobileSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncIndividualMobileSubscription(syncMobileSubscriptionRequest: SyncMobileSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncIndividualMobileSubscription(syncMobileSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.syncIndividualMobileSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync a user\'s individual Stripe subscription row from current Stripe state.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the subscription table
         * @summary Sync Individual Stripe Subscription
         * @param {SyncSubscriptionRequest} syncSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncIndividualStripeSubscription(syncSubscriptionRequest: SyncSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncIndividualStripeSubscription(syncSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.syncIndividualStripeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update by email or enqueue an issue; enabled strict refresh ignores reenable_if_disabled.
         * @summary Update Pylon Account
         * @param {string | null} [email] 
         * @param {boolean} [reenableIfDisabled] 
         * @param {PylonAccountUpdateRequest} [pylonAccountUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePylonAccount(email?: string | null, reenableIfDisabled?: boolean, pylonAccountUpdateRequest?: PylonAccountUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePylonAccount(email, reenableIfDisabled, pylonAccountUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.updatePylonAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept a refresh of an existing enterprise account.
         * @summary Update Pylon Enterprise Account
         * @param {PylonEnterpriseRefreshRequest} pylonEnterpriseRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest: PylonEnterpriseRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PylonEnterpriseRefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.updatePylonEnterpriseAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validate that a Supabase user exists for the email and matches the DB user_id.
         * @summary Validate User
         * @param {string} email The email of the user to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateUser(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateUser(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupportApi.validateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)
    return {
        /**
         * Sync an enterprise\'s workspace, users, or invoices into Attio (root API key).
         * @summary Attio Sync
         * @param {string} enterpriseId 
         * @param {AttioSyncTypeOfSyncEnum} [typeOfSync] Type of sync: \&#39;workspace\&#39; or \&#39;users\&#39; or \&#39;invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attioSync(enterpriseId: string, typeOfSync?: AttioSyncTypeOfSyncEnum, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.attioSync(enterpriseId, typeOfSync, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Create Pylon Feedback
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPylonFeedback(body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createPylonFeedback(body, attachments, subject, comment, platform, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the authenticated user and all their data.
         * @summary Delete User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestAcceptedResponse> {
            return localVarFp.deleteUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
         * @summary Frontapp Feedback
         * @param {string} to 
         * @param {string} body 
         * @param {Array<File>} [attachments] 
         * @param {string | null} [subject] 
         * @param {string | null} [comment] 
         * @param {SrcCommonConstantsPlatform} [platform] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontappFeedback(to: string, body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.frontappFeedback(to, body, attachments, subject, comment, platform, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a Pylon support ticket from feedback that includes an attached image.
         * @summary Frontapp Feedback With Image
         * @param {SupportFeedbackRequest} supportFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frontappFeedbackWithImage(supportFeedbackRequest: SupportFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.frontappFeedbackWithImage(supportFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return PII-safe status for an opaque request ID.
         * @summary Get Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestStatusResponse> {
            return localVarFp.getAccountDeletionStatus(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return status only when the request belongs to the authenticated identity.
         * @summary Get Own Account Deletion Status
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestStatusResponse> {
            return localVarFp.getOwnAccountDeletionStatus(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Redacted status of the authenticated user\'s own erasure (JWT; never under impersonation).
         * @summary Get Own Usage Data Erasure Status
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories; omitted reads the full erasure
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnUsageDataErasureStatus(categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStatusResponse> {
            return localVarFp.getOwnUsageDataErasureStatus(categories, options).then((request) => request(axios, basePath));
        },
        /**
         * Redacted erasure status by `user_id` or `email` (root API key; ids/enums/counts only).  In-flight from Temporal (`describe_workflow` + the progress query), terminal from the audit row, or a clean not-found. PII (raw email / content / errors) never appears.
         * @summary Get Usage Data Erasure Status
         * @param {string | null} [userId] Target user id
         * @param {string | null} [email] Target user email
         * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageDataErasureStatus(userId?: string | null, email?: string | null, categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStatusResponse> {
            return localVarFp.getUsageDataErasureStatus(userId, email, categories, options).then((request) => request(axios, basePath));
        },
        /**
         * Look up deletion status by email without echoing the identity.
         * @summary Lookup Account Deletion
         * @param {GdprRequestLookupByEmailRequest} gdprRequestLookupByEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupAccountDeletion(gdprRequestLookupByEmailRequest: GdprRequestLookupByEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestStatusResponse> {
            return localVarFp.lookupAccountDeletion(gdprRequestLookupByEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit feedback before authenticating, for login or account-creation issues.
         * @summary Pre Login Feedback
         * @param {PreLoginFeedbackRequest} preLoginFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preLoginFeedback(preLoginFeedbackRequest: PreLoginFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.preLoginFeedback(preLoginFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry a failed request or recover a dispatch that never bound a Temporal run.
         * @summary Retry Account Deletion
         * @param {string} requestId 
         * @param {GdprRequestRetryRequest} gdprRequestRetryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAccountDeletion(requestId: string, gdprRequestRetryRequest: GdprRequestRetryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestAcceptedResponse> {
            return localVarFp.retryAccountDeletion(requestId, gdprRequestRetryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send user feedback (with optional audio and image) to Slack.
         * @summary Send Feedback Slack
         * @param {SrcCommonConstantsPlatform} platform 
         * @param {File | null} [audio] 
         * @param {string | null} [asrText] 
         * @param {string | null} [formattedText] 
         * @param {string | null} [feedback] 
         * @param {string | null} [logs] 
         * @param {string | null} [imageData] 
         * @param {ImageType | null} [imageType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFeedbackSlack(platform: SrcCommonConstantsPlatform, audio?: File | null, asrText?: string | null, formattedText?: string | null, feedback?: string | null, logs?: string | null, imageData?: string | null, imageType?: ImageType | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendFeedbackSlack(platform, audio, asrText, formattedText, feedback, logs, imageData, imageType, options).then((request) => request(axios, basePath));
        },
        /**
         * Forward an instruct-mode feedback submission to the instruct-mode Slack channel.
         * @summary Send Instruct Feedback
         * @param {InstructFeedbackRequest} instructFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInstructFeedback(instructFeedbackRequest: InstructFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.sendInstructFeedback(instructFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Erase the authenticated user\'s own usage data, all or chosen categories (JWT; never under impersonation).
         * @summary Start Own Usage Data Erasure
         * @param {SelfErasureStartRequest} selfErasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOwnUsageDataErasure(selfErasureStartRequest: SelfErasureStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStartResponse> {
            return localVarFp.startOwnUsageDataErasure(selfErasureStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Start an account-preserving usage-data erasure (support staff, root API key).  Gated by the root API key — the same key that authorizes account deletion (`support_delete_user`); no JWT path. Email is the PRIMARY identifier; `user_id`+`confirm_orphan` is the orphan/no-email fallback. `actor`/`reason` are recorded UNTRUSTED. A `start_workflow` failure surfaces as 5xx (nothing persisted pre-start; the caller retries — idempotent via USE_EXISTING).
         * @summary Start Usage Data Erasure
         * @param {ErasureStartRequest} erasureStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startUsageDataErasure(erasureStartRequest: ErasureStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<ErasureStartResponse> {
            return localVarFp.startUsageDataErasure(erasureStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit NPS free-text feedback for a customer and campaign.
         * @summary Submit Nps Feedback
         * @param {NPSFeedbackRequest} nPSFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNpsFeedback(nPSFeedbackRequest: NPSFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submitNpsFeedback(nPSFeedbackRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit an NPS score for a customer and campaign.
         * @summary Submit Nps Score
         * @param {NPSScoreRequest} nPSScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitNpsScore(nPSScoreRequest: NPSScoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submitNpsScore(nPSScoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a user\'s active Stripe subscription and refund based on request.  - refund=\"full\": refund entire current cycle amount - refund=\"partial\": prorated refund for unused period - refund=\"no\": cancel immediately with no refund
         * @summary Support Cancel Subscription
         * @param {CancelSubscriptionRequest} cancelSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportCancelSubscription(cancelSubscriptionRequest: CancelSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.supportCancelSubscription(cancelSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a user and all their data (support staff only).  Requires the root API key and is intended for support staff only. The rollout-gated path schedules immediate asynchronous erasure.
         * @summary Support Delete User
         * @param {string} email 
         * @param {GdprRequestStartRequest} [gdprRequestStartRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supportDeleteUser(email: string, gdprRequestStartRequest?: GdprRequestStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<GdprRequestAcceptedResponse> {
            return localVarFp.supportDeleteUser(email, gdprRequestStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync a user\'s mobile_subscription row from current RevenueCat state.  Intended to patch up state after missed webhooks. Future webhooks with newer event timestamps will still override this sync via the upsert stale-event guard.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the mobile_subscription table
         * @summary Sync Individual Mobile Subscription
         * @param {SyncMobileSubscriptionRequest} syncMobileSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIndividualMobileSubscription(syncMobileSubscriptionRequest: SyncMobileSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.syncIndividualMobileSubscription(syncMobileSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sync a user\'s individual Stripe subscription row from current Stripe state.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the subscription table
         * @summary Sync Individual Stripe Subscription
         * @param {SyncSubscriptionRequest} syncSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncIndividualStripeSubscription(syncSubscriptionRequest: SyncSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.syncIndividualStripeSubscription(syncSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update by email or enqueue an issue; enabled strict refresh ignores reenable_if_disabled.
         * @summary Update Pylon Account
         * @param {string | null} [email] 
         * @param {boolean} [reenableIfDisabled] 
         * @param {PylonAccountUpdateRequest} [pylonAccountUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePylonAccount(email?: string | null, reenableIfDisabled?: boolean, pylonAccountUpdateRequest?: PylonAccountUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updatePylonAccount(email, reenableIfDisabled, pylonAccountUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept a refresh of an existing enterprise account.
         * @summary Update Pylon Enterprise Account
         * @param {PylonEnterpriseRefreshRequest} pylonEnterpriseRefreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest: PylonEnterpriseRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<PylonEnterpriseRefreshResponse> {
            return localVarFp.updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validate that a Supabase user exists for the email and matches the DB user_id.
         * @summary Validate User
         * @param {string} email The email of the user to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUser(email: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.validateUser(email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI {
    /**
     * Sync an enterprise\'s workspace, users, or invoices into Attio (root API key).
     * @summary Attio Sync
     * @param {string} enterpriseId 
     * @param {AttioSyncTypeOfSyncEnum} [typeOfSync] Type of sync: \&#39;workspace\&#39; or \&#39;users\&#39; or \&#39;invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public attioSync(enterpriseId: string, typeOfSync?: AttioSyncTypeOfSyncEnum, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).attioSync(enterpriseId, typeOfSync, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
     * @summary Create Pylon Feedback
     * @param {string} body 
     * @param {Array<File>} [attachments] 
     * @param {string | null} [subject] 
     * @param {string | null} [comment] 
     * @param {SrcCommonConstantsPlatform} [platform] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public createPylonFeedback(body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).createPylonFeedback(body, attachments, subject, comment, platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the authenticated user and all their data.
     * @summary Delete User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public deleteUser(options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).deleteUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Pylon support ticket from feedback, attaching the user\'s location-based pricing.
     * @summary Frontapp Feedback
     * @param {string} to 
     * @param {string} body 
     * @param {Array<File>} [attachments] 
     * @param {string | null} [subject] 
     * @param {string | null} [comment] 
     * @param {SrcCommonConstantsPlatform} [platform] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public frontappFeedback(to: string, body: string, attachments?: Array<File>, subject?: string | null, comment?: string | null, platform?: SrcCommonConstantsPlatform, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).frontappFeedback(to, body, attachments, subject, comment, platform, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a Pylon support ticket from feedback that includes an attached image.
     * @summary Frontapp Feedback With Image
     * @param {SupportFeedbackRequest} supportFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public frontappFeedbackWithImage(supportFeedbackRequest: SupportFeedbackRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).frontappFeedbackWithImage(supportFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return PII-safe status for an opaque request ID.
     * @summary Get Account Deletion Status
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).getAccountDeletionStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return status only when the request belongs to the authenticated identity.
     * @summary Get Own Account Deletion Status
     * @param {string} requestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getOwnAccountDeletionStatus(requestId: string, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).getOwnAccountDeletionStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redacted status of the authenticated user\'s own erasure (JWT; never under impersonation).
     * @summary Get Own Usage Data Erasure Status
     * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories; omitted reads the full erasure
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getOwnUsageDataErasureStatus(categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).getOwnUsageDataErasureStatus(categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redacted erasure status by `user_id` or `email` (root API key; ids/enums/counts only).  In-flight from Temporal (`describe_workflow` + the progress query), terminal from the audit row, or a clean not-found. PII (raw email / content / errors) never appears.
     * @summary Get Usage Data Erasure Status
     * @param {string | null} [userId] Target user id
     * @param {string | null} [email] Target user email
     * @param {Array<DataCategory> | null} [categories] Read the scoped run with exactly these categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getUsageDataErasureStatus(userId?: string | null, email?: string | null, categories?: Array<DataCategory> | null, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).getUsageDataErasureStatus(userId, email, categories, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Look up deletion status by email without echoing the identity.
     * @summary Lookup Account Deletion
     * @param {GdprRequestLookupByEmailRequest} gdprRequestLookupByEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public lookupAccountDeletion(gdprRequestLookupByEmailRequest: GdprRequestLookupByEmailRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).lookupAccountDeletion(gdprRequestLookupByEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit feedback before authenticating, for login or account-creation issues.
     * @summary Pre Login Feedback
     * @param {PreLoginFeedbackRequest} preLoginFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public preLoginFeedback(preLoginFeedbackRequest: PreLoginFeedbackRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).preLoginFeedback(preLoginFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retry a failed request or recover a dispatch that never bound a Temporal run.
     * @summary Retry Account Deletion
     * @param {string} requestId 
     * @param {GdprRequestRetryRequest} gdprRequestRetryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public retryAccountDeletion(requestId: string, gdprRequestRetryRequest: GdprRequestRetryRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).retryAccountDeletion(requestId, gdprRequestRetryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send user feedback (with optional audio and image) to Slack.
     * @summary Send Feedback Slack
     * @param {SrcCommonConstantsPlatform} platform 
     * @param {File | null} [audio] 
     * @param {string | null} [asrText] 
     * @param {string | null} [formattedText] 
     * @param {string | null} [feedback] 
     * @param {string | null} [logs] 
     * @param {string | null} [imageData] 
     * @param {ImageType | null} [imageType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public sendFeedbackSlack(platform: SrcCommonConstantsPlatform, audio?: File | null, asrText?: string | null, formattedText?: string | null, feedback?: string | null, logs?: string | null, imageData?: string | null, imageType?: ImageType | null, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).sendFeedbackSlack(platform, audio, asrText, formattedText, feedback, logs, imageData, imageType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Forward an instruct-mode feedback submission to the instruct-mode Slack channel.
     * @summary Send Instruct Feedback
     * @param {InstructFeedbackRequest} instructFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public sendInstructFeedback(instructFeedbackRequest: InstructFeedbackRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).sendInstructFeedback(instructFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Erase the authenticated user\'s own usage data, all or chosen categories (JWT; never under impersonation).
     * @summary Start Own Usage Data Erasure
     * @param {SelfErasureStartRequest} selfErasureStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public startOwnUsageDataErasure(selfErasureStartRequest: SelfErasureStartRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).startOwnUsageDataErasure(selfErasureStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start an account-preserving usage-data erasure (support staff, root API key).  Gated by the root API key — the same key that authorizes account deletion (`support_delete_user`); no JWT path. Email is the PRIMARY identifier; `user_id`+`confirm_orphan` is the orphan/no-email fallback. `actor`/`reason` are recorded UNTRUSTED. A `start_workflow` failure surfaces as 5xx (nothing persisted pre-start; the caller retries — idempotent via USE_EXISTING).
     * @summary Start Usage Data Erasure
     * @param {ErasureStartRequest} erasureStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public startUsageDataErasure(erasureStartRequest: ErasureStartRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).startUsageDataErasure(erasureStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit NPS free-text feedback for a customer and campaign.
     * @summary Submit Nps Feedback
     * @param {NPSFeedbackRequest} nPSFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public submitNpsFeedback(nPSFeedbackRequest: NPSFeedbackRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).submitNpsFeedback(nPSFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit an NPS score for a customer and campaign.
     * @summary Submit Nps Score
     * @param {NPSScoreRequest} nPSScoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public submitNpsScore(nPSScoreRequest: NPSScoreRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).submitNpsScore(nPSScoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a user\'s active Stripe subscription and refund based on request.  - refund=\"full\": refund entire current cycle amount - refund=\"partial\": prorated refund for unused period - refund=\"no\": cancel immediately with no refund
     * @summary Support Cancel Subscription
     * @param {CancelSubscriptionRequest} cancelSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportCancelSubscription(cancelSubscriptionRequest: CancelSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportCancelSubscription(cancelSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a user and all their data (support staff only).  Requires the root API key and is intended for support staff only. The rollout-gated path schedules immediate asynchronous erasure.
     * @summary Support Delete User
     * @param {string} email 
     * @param {GdprRequestStartRequest} [gdprRequestStartRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public supportDeleteUser(email: string, gdprRequestStartRequest?: GdprRequestStartRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).supportDeleteUser(email, gdprRequestStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync a user\'s mobile_subscription row from current RevenueCat state.  Intended to patch up state after missed webhooks. Future webhooks with newer event timestamps will still override this sync via the upsert stale-event guard.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the mobile_subscription table
     * @summary Sync Individual Mobile Subscription
     * @param {SyncMobileSubscriptionRequest} syncMobileSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public syncIndividualMobileSubscription(syncMobileSubscriptionRequest: SyncMobileSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).syncIndividualMobileSubscription(syncMobileSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync a user\'s individual Stripe subscription row from current Stripe state.  - dry_run=true (default): preview before/after diff without writing - dry_run=false: apply changes to the subscription table
     * @summary Sync Individual Stripe Subscription
     * @param {SyncSubscriptionRequest} syncSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public syncIndividualStripeSubscription(syncSubscriptionRequest: SyncSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).syncIndividualStripeSubscription(syncSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update by email or enqueue an issue; enabled strict refresh ignores reenable_if_disabled.
     * @summary Update Pylon Account
     * @param {string | null} [email] 
     * @param {boolean} [reenableIfDisabled] 
     * @param {PylonAccountUpdateRequest} [pylonAccountUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public updatePylonAccount(email?: string | null, reenableIfDisabled?: boolean, pylonAccountUpdateRequest?: PylonAccountUpdateRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).updatePylonAccount(email, reenableIfDisabled, pylonAccountUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept a refresh of an existing enterprise account.
     * @summary Update Pylon Enterprise Account
     * @param {PylonEnterpriseRefreshRequest} pylonEnterpriseRefreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest: PylonEnterpriseRefreshRequest, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).updatePylonEnterpriseAccount(pylonEnterpriseRefreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validate that a Supabase user exists for the email and matches the DB user_id.
     * @summary Validate User
     * @param {string} email The email of the user to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public validateUser(email: string, options?: RawAxiosRequestConfig) {
        return SupportApiFp(this.configuration).validateUser(email, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AttioSyncTypeOfSyncEnum = {
    Workspace: 'workspace',
    Users: 'users',
    Invoices: 'invoices'
} as const;
export type AttioSyncTypeOfSyncEnum = typeof AttioSyncTypeOfSyncEnum[keyof typeof AttioSyncTypeOfSyncEnum];


/**
 * SyncApi - axios parameter creator
 * @export
 */
export const SyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check which sync-managed resources have changed for the current user.  Auth: JWT-only (``Authenticated()``). This endpoint must NOT use ``get_current_user_stateless`` — its only DB touch is the IP-allowlist check inside ``Authenticated()`` (a per-user cached join, skipped while enforcement is disabled). If this endpoint is ever extended to return actual user data, upgrade auth accordingly.  Returns 503 if Redis is unreachable so the client can skip the cycle and retry on the next interval.
         * @summary Check Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSync: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sync/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncApi - functional programming interface
 * @export
 */
export const SyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SyncApiAxiosParamCreator(configuration)
    return {
        /**
         * Check which sync-managed resources have changed for the current user.  Auth: JWT-only (``Authenticated()``). This endpoint must NOT use ``get_current_user_stateless`` — its only DB touch is the IP-allowlist check inside ``Authenticated()`` (a per-user cached join, skipped while enforcement is disabled). If this endpoint is ever extended to return actual user data, upgrade auth accordingly.  Returns 503 if Redis is unreachable so the client can skip the cycle and retry on the next interval.
         * @summary Check Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkSync(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkSync(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncApi.checkSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SyncApi - factory interface
 * @export
 */
export const SyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SyncApiFp(configuration)
    return {
        /**
         * Check which sync-managed resources have changed for the current user.  Auth: JWT-only (``Authenticated()``). This endpoint must NOT use ``get_current_user_stateless`` — its only DB touch is the IP-allowlist check inside ``Authenticated()`` (a per-user cached join, skipped while enforcement is disabled). If this endpoint is ever extended to return actual user data, upgrade auth accordingly.  Returns 503 if Redis is unreachable so the client can skip the cycle and retry on the next interval.
         * @summary Check Sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkSync(options?: RawAxiosRequestConfig): AxiosPromise<SyncCheckResponse> {
            return localVarFp.checkSync(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncApi - object-oriented interface
 * @export
 * @class SyncApi
 * @extends {BaseAPI}
 */
export class SyncApi extends BaseAPI {
    /**
     * Check which sync-managed resources have changed for the current user.  Auth: JWT-only (``Authenticated()``). This endpoint must NOT use ``get_current_user_stateless`` — its only DB touch is the IP-allowlist check inside ``Authenticated()`` (a per-user cached join, skipped while enforcement is disabled). If this endpoint is ever extended to return actual user data, upgrade auth accordingly.  Returns 503 if Redis is unreachable so the client can skip the cycle and retry on the next interval.
     * @summary Check Sync
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncApi
     */
    public checkSync(options?: RawAxiosRequestConfig) {
        return SyncApiFp(this.configuration).checkSync(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SyncWSApi - axios parameter creator
 * @export
 */
export const SyncWSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Synthesize one or more sync events for ``user_id``.  ``burst > 1`` is the gap-too-large drill: publishing more than the replay buffer size (``publisher.REPLAY_MAXLEN``) forces the oldest entries out so a reconnecting client with a stale ``since`` falls through to ``/sync/check``.
         * @summary Admin Test Publish
         * @param {AdminTestPublishRequest} adminTestPublishRequest 
         * @param {number} [burst] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTestPublish: async (adminTestPublishRequest: AdminTestPublishRequest, burst?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminTestPublishRequest' is not null or undefined
            assertParamExists('adminTestPublish', 'adminTestPublishRequest', adminTestPublishRequest)
            const localVarPath = `/api/v1/sync/ws/admin/test-publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (burst !== undefined) {
                localVarQueryParameter['burst'] = burst;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminTestPublishRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a stub so the nudge frames and payloads appear in the OpenAPI spec, and thus the generated clients.
         * @summary Meeting Nudge Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingNudgeSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sync/ws/meeting/nudge-schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Companion to ``/ws/schema`` for the client-to-server frame union.
         * @summary Sync Ws Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWsClientSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sync/ws/client-schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a stub envelope so the ``SyncEvent`` union appears in the OpenAPI spec.  Exists so the discriminated union is reachable from the spec (and thus the generated TS client). Admin-gating isn\'t required — it returns no user data.
         * @summary Sync Ws Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWsSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sync/ws/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SyncWSApi - functional programming interface
 * @export
 */
export const SyncWSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SyncWSApiAxiosParamCreator(configuration)
    return {
        /**
         * Synthesize one or more sync events for ``user_id``.  ``burst > 1`` is the gap-too-large drill: publishing more than the replay buffer size (``publisher.REPLAY_MAXLEN``) forces the oldest entries out so a reconnecting client with a stale ``since`` falls through to ``/sync/check``.
         * @summary Admin Test Publish
         * @param {AdminTestPublishRequest} adminTestPublishRequest 
         * @param {number} [burst] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTestPublish(adminTestPublishRequest: AdminTestPublishRequest, burst?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTestPublishResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTestPublish(adminTestPublishRequest, burst, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncWSApi.adminTestPublish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a stub so the nudge frames and payloads appear in the OpenAPI spec, and thus the generated clients.
         * @summary Meeting Nudge Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meetingNudgeSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingNudgeSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meetingNudgeSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncWSApi.meetingNudgeSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Companion to ``/ws/schema`` for the client-to-server frame union.
         * @summary Sync Ws Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWsClientSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncClientFrameEnvelope>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWsClientSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncWSApi.syncWsClientSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a stub envelope so the ``SyncEvent`` union appears in the OpenAPI spec.  Exists so the discriminated union is reachable from the spec (and thus the generated TS client). Admin-gating isn\'t required — it returns no user data.
         * @summary Sync Ws Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncWsSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncEventEnvelope>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncWsSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SyncWSApi.syncWsSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SyncWSApi - factory interface
 * @export
 */
export const SyncWSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SyncWSApiFp(configuration)
    return {
        /**
         * Synthesize one or more sync events for ``user_id``.  ``burst > 1`` is the gap-too-large drill: publishing more than the replay buffer size (``publisher.REPLAY_MAXLEN``) forces the oldest entries out so a reconnecting client with a stale ``since`` falls through to ``/sync/check``.
         * @summary Admin Test Publish
         * @param {AdminTestPublishRequest} adminTestPublishRequest 
         * @param {number} [burst] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTestPublish(adminTestPublishRequest: AdminTestPublishRequest, burst?: number, options?: RawAxiosRequestConfig): AxiosPromise<AdminTestPublishResponse> {
            return localVarFp.adminTestPublish(adminTestPublishRequest, burst, options).then((request) => request(axios, basePath));
        },
        /**
         * Return a stub so the nudge frames and payloads appear in the OpenAPI spec, and thus the generated clients.
         * @summary Meeting Nudge Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meetingNudgeSchema(options?: RawAxiosRequestConfig): AxiosPromise<MeetingNudgeSchema> {
            return localVarFp.meetingNudgeSchema(options).then((request) => request(axios, basePath));
        },
        /**
         * Companion to ``/ws/schema`` for the client-to-server frame union.
         * @summary Sync Ws Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWsClientSchema(options?: RawAxiosRequestConfig): AxiosPromise<SyncClientFrameEnvelope> {
            return localVarFp.syncWsClientSchema(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a stub envelope so the ``SyncEvent`` union appears in the OpenAPI spec.  Exists so the discriminated union is reachable from the spec (and thus the generated TS client). Admin-gating isn\'t required — it returns no user data.
         * @summary Sync Ws Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncWsSchema(options?: RawAxiosRequestConfig): AxiosPromise<SyncEventEnvelope> {
            return localVarFp.syncWsSchema(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SyncWSApi - object-oriented interface
 * @export
 * @class SyncWSApi
 * @extends {BaseAPI}
 */
export class SyncWSApi extends BaseAPI {
    /**
     * Synthesize one or more sync events for ``user_id``.  ``burst > 1`` is the gap-too-large drill: publishing more than the replay buffer size (``publisher.REPLAY_MAXLEN``) forces the oldest entries out so a reconnecting client with a stale ``since`` falls through to ``/sync/check``.
     * @summary Admin Test Publish
     * @param {AdminTestPublishRequest} adminTestPublishRequest 
     * @param {number} [burst] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncWSApi
     */
    public adminTestPublish(adminTestPublishRequest: AdminTestPublishRequest, burst?: number, options?: RawAxiosRequestConfig) {
        return SyncWSApiFp(this.configuration).adminTestPublish(adminTestPublishRequest, burst, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a stub so the nudge frames and payloads appear in the OpenAPI spec, and thus the generated clients.
     * @summary Meeting Nudge Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncWSApi
     */
    public meetingNudgeSchema(options?: RawAxiosRequestConfig) {
        return SyncWSApiFp(this.configuration).meetingNudgeSchema(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Companion to ``/ws/schema`` for the client-to-server frame union.
     * @summary Sync Ws Client Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncWSApi
     */
    public syncWsClientSchema(options?: RawAxiosRequestConfig) {
        return SyncWSApiFp(this.configuration).syncWsClientSchema(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a stub envelope so the ``SyncEvent`` union appears in the OpenAPI spec.  Exists so the discriminated union is reachable from the spec (and thus the generated TS client). Admin-gating isn\'t required — it returns no user data.
     * @summary Sync Ws Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SyncWSApi
     */
    public syncWsSchema(options?: RawAxiosRequestConfig) {
        return SyncWSApiFp(this.configuration).syncWsSchema(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamInsightsApi - axios parameter creator
 * @export
 */
export const TeamInsightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dimensional CSV of words/dictations for the Usage page export popover.
         * @summary Export Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {Array<ExportWordsDictatedColumnsEnum>} [columns] Dimensions to include as CSV columns. Order is fixed by the design; duplicates are deduped server-side.
         * @param {ExportWordsDictatedComparisonModeEnum} [comparisonMode] Accepted for shape parity with &#x60;&#x60;/words-dictated&#x60;&#x60; — CSV export has no pct_change column so this is unused.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWordsDictated: async (enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, columns?: Array<ExportWordsDictatedColumnsEnum>, comparisonMode?: ExportWordsDictatedComparisonModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('exportWordsDictated', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/words-dictated/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (userIds) {
                localVarQueryParameter['user_ids'] = userIds;
            }

            if (appKeys) {
                localVarQueryParameter['app_keys'] = appKeys;
            }

            if (appCategories) {
                localVarQueryParameter['app_categories'] = appCategories;
            }

            if (columns) {
                localVarQueryParameter['columns'] = columns;
            }

            if (comparisonMode !== undefined) {
                localVarQueryParameter['comparison_mode'] = comparisonMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Distinct app count + app list (top-2000 from CH, capped). ``app_keys``/``app_categories`` OR-semantics.
         * @summary Get Desktop Apps
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetDesktopAppsComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesktopApps: async (enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetDesktopAppsComparisonModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getDesktopApps', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/desktop-apps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (userIds) {
                localVarQueryParameter['user_ids'] = userIds;
            }

            if (appKeys) {
                localVarQueryParameter['app_keys'] = appKeys;
            }

            if (appCategories) {
                localVarQueryParameter['app_categories'] = appCategories;
            }

            if (comparisonMode !== undefined) {
                localVarQueryParameter['comparison_mode'] = comparisonMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All Impact cards in one round trip. ``team_id`` is the only filter.
         * @summary Get Impact
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImpact: async (enterpriseId: string, teamId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getImpact', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/impact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Total members + active-user timeseries. ``mode`` controls per-day aggregation granularity.
         * @summary Get Team Members
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {GetTeamMembersModeEnum} [mode] 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetTeamMembersComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers: async (enterpriseId: string, mode?: GetTeamMembersModeEnum, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetTeamMembersComparisonModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getTeamMembers', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/team-members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (userIds) {
                localVarQueryParameter['user_ids'] = userIds;
            }

            if (appKeys) {
                localVarQueryParameter['app_keys'] = appKeys;
            }

            if (appCategories) {
                localVarQueryParameter['app_categories'] = appCategories;
            }

            if (comparisonMode !== undefined) {
                localVarQueryParameter['comparison_mode'] = comparisonMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Words Dictated headline + delta + timeseries. ``app_keys``/``app_categories`` use OR-semantics.
         * @summary Get Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetWordsDictatedComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days (for Last 7/30 days). &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift (for This month, Last month, This year). Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWordsDictated: async (enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetWordsDictatedComparisonModeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('getWordsDictated', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/words-dictated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['team_id'] = teamId;
            }

            if (userIds) {
                localVarQueryParameter['user_ids'] = userIds;
            }

            if (appKeys) {
                localVarQueryParameter['app_keys'] = appKeys;
            }

            if (appCategories) {
                localVarQueryParameter['app_categories'] = appCategories;
            }

            if (comparisonMode !== undefined) {
                localVarQueryParameter['comparison_mode'] = comparisonMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Page-load dropdowns: teams + apps + categories.
         * @summary List Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFilterOptions: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listFilterOptions', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/filter-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Typeahead user search over the requested enterprise.
         * @summary List User Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [q] Prefix on first/last/email
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserFilterOptions: async (enterpriseId: string, q?: string | null, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listUserFilterOptions', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/insights/filter-options/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (enterpriseId !== undefined) {
                localVarQueryParameter['enterprise_id'] = enterpriseId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamInsightsApi - functional programming interface
 * @export
 */
export const TeamInsightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamInsightsApiAxiosParamCreator(configuration)
    return {
        /**
         * Dimensional CSV of words/dictations for the Usage page export popover.
         * @summary Export Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {Array<ExportWordsDictatedColumnsEnum>} [columns] Dimensions to include as CSV columns. Order is fixed by the design; duplicates are deduped server-side.
         * @param {ExportWordsDictatedComparisonModeEnum} [comparisonMode] Accepted for shape parity with &#x60;&#x60;/words-dictated&#x60;&#x60; — CSV export has no pct_change column so this is unused.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, columns?: Array<ExportWordsDictatedColumnsEnum>, comparisonMode?: ExportWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, columns, comparisonMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.exportWordsDictated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Distinct app count + app list (top-2000 from CH, capped). ``app_keys``/``app_categories`` OR-semantics.
         * @summary Get Desktop Apps
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetDesktopAppsComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDesktopApps(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetDesktopAppsComparisonModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DesktopAppsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDesktopApps(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.getDesktopApps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * All Impact cards in one round trip. ``team_id`` is the only filter.
         * @summary Get Impact
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImpact(enterpriseId: string, teamId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImpact(enterpriseId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.getImpact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Total members + active-user timeseries. ``mode`` controls per-day aggregation granularity.
         * @summary Get Team Members
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {GetTeamMembersModeEnum} [mode] 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetTeamMembersComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMembers(enterpriseId: string, mode?: GetTeamMembersModeEnum, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetTeamMembersComparisonModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMembers(enterpriseId, mode, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.getTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Words Dictated headline + delta + timeseries. ``app_keys``/``app_categories`` use OR-semantics.
         * @summary Get Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetWordsDictatedComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days (for Last 7/30 days). &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift (for This month, Last month, This year). Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WordsDictatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.getWordsDictated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Page-load dropdowns: teams + apps + categories.
         * @summary List Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFilterOptions(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFilterOptions(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.listFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Typeahead user search over the requested enterprise.
         * @summary List User Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [q] Prefix on first/last/email
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserFilterOptions(enterpriseId: string, q?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserFilterOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserFilterOptions(enterpriseId, q, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamInsightsApi.listUserFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamInsightsApi - factory interface
 * @export
 */
export const TeamInsightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamInsightsApiFp(configuration)
    return {
        /**
         * Dimensional CSV of words/dictations for the Usage page export popover.
         * @summary Export Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {Array<ExportWordsDictatedColumnsEnum>} [columns] Dimensions to include as CSV columns. Order is fixed by the design; duplicates are deduped server-side.
         * @param {ExportWordsDictatedComparisonModeEnum} [comparisonMode] Accepted for shape parity with &#x60;&#x60;/words-dictated&#x60;&#x60; — CSV export has no pct_change column so this is unused.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, columns?: Array<ExportWordsDictatedColumnsEnum>, comparisonMode?: ExportWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.exportWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, columns, comparisonMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Distinct app count + app list (top-2000 from CH, capped). ``app_keys``/``app_categories`` OR-semantics.
         * @summary Get Desktop Apps
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetDesktopAppsComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDesktopApps(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetDesktopAppsComparisonModeEnum, options?: RawAxiosRequestConfig): AxiosPromise<DesktopAppsResponse> {
            return localVarFp.getDesktopApps(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(axios, basePath));
        },
        /**
         * All Impact cards in one round trip. ``team_id`` is the only filter.
         * @summary Get Impact
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImpact(enterpriseId: string, teamId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<ImpactResponse> {
            return localVarFp.getImpact(enterpriseId, teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Total members + active-user timeseries. ``mode`` controls per-day aggregation granularity.
         * @summary Get Team Members
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {GetTeamMembersModeEnum} [mode] 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetTeamMembersComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers(enterpriseId: string, mode?: GetTeamMembersModeEnum, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetTeamMembersComparisonModeEnum, options?: RawAxiosRequestConfig): AxiosPromise<TeamMembersResponse> {
            return localVarFp.getTeamMembers(enterpriseId, mode, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Words Dictated headline + delta + timeseries. ``app_keys``/``app_categories`` use OR-semantics.
         * @summary Get Words Dictated
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {string | null} [teamId] 
         * @param {Array<string>} [userIds] 
         * @param {Array<string>} [appKeys] 
         * @param {Array<string>} [appCategories] 
         * @param {GetWordsDictatedComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days (for Last 7/30 days). &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift (for This month, Last month, This year). Omit to use shape detection.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig): AxiosPromise<WordsDictatedResponse> {
            return localVarFp.getWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(axios, basePath));
        },
        /**
         * Page-load dropdowns: teams + apps + categories.
         * @summary List Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFilterOptions(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterOptionsResponse> {
            return localVarFp.listFilterOptions(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Typeahead user search over the requested enterprise.
         * @summary List User Filter Options
         * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
         * @param {string | null} [q] Prefix on first/last/email
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserFilterOptions(enterpriseId: string, q?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<UserFilterOptionsResponse> {
            return localVarFp.listUserFilterOptions(enterpriseId, q, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamInsightsApi - object-oriented interface
 * @export
 * @class TeamInsightsApi
 * @extends {BaseAPI}
 */
export class TeamInsightsApi extends BaseAPI {
    /**
     * Dimensional CSV of words/dictations for the Usage page export popover.
     * @summary Export Words Dictated
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [teamId] 
     * @param {Array<string>} [userIds] 
     * @param {Array<string>} [appKeys] 
     * @param {Array<string>} [appCategories] 
     * @param {Array<ExportWordsDictatedColumnsEnum>} [columns] Dimensions to include as CSV columns. Order is fixed by the design; duplicates are deduped server-side.
     * @param {ExportWordsDictatedComparisonModeEnum} [comparisonMode] Accepted for shape parity with &#x60;&#x60;/words-dictated&#x60;&#x60; — CSV export has no pct_change column so this is unused.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public exportWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, columns?: Array<ExportWordsDictatedColumnsEnum>, comparisonMode?: ExportWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).exportWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, columns, comparisonMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Distinct app count + app list (top-2000 from CH, capped). ``app_keys``/``app_categories`` OR-semantics.
     * @summary Get Desktop Apps
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [teamId] 
     * @param {Array<string>} [userIds] 
     * @param {Array<string>} [appKeys] 
     * @param {Array<string>} [appCategories] 
     * @param {GetDesktopAppsComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public getDesktopApps(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetDesktopAppsComparisonModeEnum, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).getDesktopApps(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * All Impact cards in one round trip. ``team_id`` is the only filter.
     * @summary Get Impact
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {string | null} [teamId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public getImpact(enterpriseId: string, teamId?: string | null, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).getImpact(enterpriseId, teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Total members + active-user timeseries. ``mode`` controls per-day aggregation granularity.
     * @summary Get Team Members
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {GetTeamMembersModeEnum} [mode] 
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [teamId] 
     * @param {Array<string>} [userIds] 
     * @param {Array<string>} [appKeys] 
     * @param {Array<string>} [appCategories] 
     * @param {GetTeamMembersComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days. &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift. Omit to use shape detection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public getTeamMembers(enterpriseId: string, mode?: GetTeamMembersModeEnum, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetTeamMembersComparisonModeEnum, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).getTeamMembers(enterpriseId, mode, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Words Dictated headline + delta + timeseries. ``app_keys``/``app_categories`` use OR-semantics.
     * @summary Get Words Dictated
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {string | null} [startDate] 
     * @param {string | null} [endDate] 
     * @param {string | null} [teamId] 
     * @param {Array<string>} [userIds] 
     * @param {Array<string>} [appKeys] 
     * @param {Array<string>} [appCategories] 
     * @param {GetWordsDictatedComparisonModeEnum} [comparisonMode] How pct_change picks the prior window. &#x60;&#x60;rolling&#x60;&#x60; &#x3D; trailing N days vs prior N days (for Last 7/30 days). &#x60;&#x60;calendar&#x60;&#x60; &#x3D; MoM/YoY shift (for This month, Last month, This year). Omit to use shape detection.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public getWordsDictated(enterpriseId: string, startDate?: string | null, endDate?: string | null, teamId?: string | null, userIds?: Array<string>, appKeys?: Array<string>, appCategories?: Array<string>, comparisonMode?: GetWordsDictatedComparisonModeEnum, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).getWordsDictated(enterpriseId, startDate, endDate, teamId, userIds, appKeys, appCategories, comparisonMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Page-load dropdowns: teams + apps + categories.
     * @summary List Filter Options
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public listFilterOptions(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).listFilterOptions(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Typeahead user search over the requested enterprise.
     * @summary List User Filter Options
     * @param {string} enterpriseId Enterprise to query. Wispr admins may pass any; enterprise admins must pass their own.
     * @param {string | null} [q] Prefix on first/last/email
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamInsightsApi
     */
    public listUserFilterOptions(enterpriseId: string, q?: string | null, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return TeamInsightsApiFp(this.configuration).listUserFilterOptions(enterpriseId, q, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ExportWordsDictatedColumnsEnum = {
    User: 'user',
    Email: 'email',
    Team: 'team',
    AppType: 'app_type',
    App: 'app'
} as const;
export type ExportWordsDictatedColumnsEnum = typeof ExportWordsDictatedColumnsEnum[keyof typeof ExportWordsDictatedColumnsEnum];
/**
 * @export
 */
export const ExportWordsDictatedComparisonModeEnum = {
    Rolling: 'rolling',
    Calendar: 'calendar'
} as const;
export type ExportWordsDictatedComparisonModeEnum = typeof ExportWordsDictatedComparisonModeEnum[keyof typeof ExportWordsDictatedComparisonModeEnum];
/**
 * @export
 */
export const GetDesktopAppsComparisonModeEnum = {
    Rolling: 'rolling',
    Calendar: 'calendar'
} as const;
export type GetDesktopAppsComparisonModeEnum = typeof GetDesktopAppsComparisonModeEnum[keyof typeof GetDesktopAppsComparisonModeEnum];
/**
 * @export
 */
export const GetTeamMembersModeEnum = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Inactive: 'inactive'
} as const;
export type GetTeamMembersModeEnum = typeof GetTeamMembersModeEnum[keyof typeof GetTeamMembersModeEnum];
/**
 * @export
 */
export const GetTeamMembersComparisonModeEnum = {
    Rolling: 'rolling',
    Calendar: 'calendar'
} as const;
export type GetTeamMembersComparisonModeEnum = typeof GetTeamMembersComparisonModeEnum[keyof typeof GetTeamMembersComparisonModeEnum];
/**
 * @export
 */
export const GetWordsDictatedComparisonModeEnum = {
    Rolling: 'rolling',
    Calendar: 'calendar'
} as const;
export type GetWordsDictatedComparisonModeEnum = typeof GetWordsDictatedComparisonModeEnum[keyof typeof GetWordsDictatedComparisonModeEnum];


/**
 * TeamsApi - axios parameter creator
 * @export
 */
export const TeamsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new team under a cost center.  The caller must be an enterprise admin or an active member of some team in the cost center.
         * @summary Create Team
         * @param {string} costCenterId 
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (costCenterId: string, createTeamRequest: CreateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'costCenterId' is not null or undefined
            assertParamExists('createTeam', 'costCenterId', costCenterId)
            // verify required parameter 'createTeamRequest' is not null or undefined
            assertParamExists('createTeam', 'createTeamRequest', createTeamRequest)
            const localVarPath = `/api/v1/cost-centers/{cost_center_id}/teams`
                .replace(`{${"cost_center_id"}}`, encodeURIComponent(String(costCenterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disband a team (soft-delete).  Sets ``team.status=disbanded`` and soft-removes all active memberships with ``removal_method=team_disbanded``. The caller must be an enterprise admin or the cost center\'s ``billing_owner_user_id``.
         * @summary Disband Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disbandTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('disbandTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return the caller\'s cost center plus active members of every team in it.  Powers the create-department dialog\'s cost-center-scoped picker — callers can pull any active member of their CC into a new team (intra-CC move). Each member row carries its ``team_id`` so the frontend can scope the successor-admin field to caller\'s old teammates only.  404 if the caller has no active team membership (e.g. orphaned by SCIM provisioning before placement; or after their only team was disbanded).
         * @summary Get Active Cost Center For Caller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCostCenterForCaller: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me/active-cost-center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a single team by id.  The caller must be an enterprise admin or an active member of the team. Cross-enterprise callers receive 404 (not 403) to avoid leaking existence.
         * @summary Get Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pending enterprise member self-selects into a team via the desktop picker.  Multi-team enterprises leave new SCIM/auto-add users in a pending state (no team membership). The desktop client renders a team picker; selecting a team calls this endpoint, which inserts the membership with ``add_method=team_picker`` and reconciles seats for the team\'s cost center outside the DB transaction.  Returns 400 when the user has no enterprise, 404 when the team is missing, disbanded, or in another enterprise, and 409 when the user already has an active membership in the enterprise.
         * @summary Join Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinTeam: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('joinTeam', 'teamId', teamId)
            const localVarPath = `/api/v1/teams/{team_id}/join`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active teams for an enterprise.  Any user in the enterprise can call this — including pending users with ``enterprise_id`` set but no team membership, who need this list to render the desktop team picker. Cross-enterprise callers receive 404 (not 403) to avoid leaking enterprise existence.
         * @summary List Teams
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams: async (enterpriseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enterpriseId' is not null or undefined
            assertParamExists('listTeams', 'enterpriseId', enterpriseId)
            const localVarPath = `/api/v1/enterprise/{enterprise_id}/teams`
                .replace(`{${"enterprise_id"}}`, encodeURIComponent(String(enterpriseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move an enterprise user into this team from their current team.  The caller must be an enterprise admin or an admin of the destination team. After the move, the refreshed team and its member count are returned.
         * @summary Move Member To Team
         * @param {string} teamId 
         * @param {MoveMemberRequest} moveMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveMemberToTeam: async (teamId: string, moveMemberRequest: MoveMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('moveMemberToTeam', 'teamId', teamId)
            // verify required parameter 'moveMemberRequest' is not null or undefined
            assertParamExists('moveMemberToTeam', 'moveMemberRequest', moveMemberRequest)
            const localVarPath = `/api/v1/teams/{team_id}/members`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveMemberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reassign a team to a different cost center within the same enterprise.  Caller must be an enterprise admin. The destination CC must be in a live billing status and belong to the same enterprise. The source CC must retain at least one team after the move.
         * @summary Move Team To Cost Center
         * @param {string} teamId 
         * @param {MoveTeamToCostCenterRequest} moveTeamToCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamToCostCenter: async (teamId: string, moveTeamToCostCenterRequest: MoveTeamToCostCenterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('moveTeamToCostCenter', 'teamId', teamId)
            // verify required parameter 'moveTeamToCostCenterRequest' is not null or undefined
            assertParamExists('moveTeamToCostCenter', 'moveTeamToCostCenterRequest', moveTeamToCostCenterRequest)
            const localVarPath = `/api/v1/teams/{team_id}/cost-center`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveTeamToCostCenterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rename a team.  The caller must be an enterprise admin or team admin.
         * @summary Update Team
         * @param {string} teamId 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (teamId: string, updateTeamRequest: UpdateTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeam', 'teamId', teamId)
            // verify required parameter 'updateTeamRequest' is not null or undefined
            assertParamExists('updateTeam', 'updateTeamRequest', updateTeamRequest)
            const localVarPath = `/api/v1/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the per-team role of a member already on the team.  Caller must be an enterprise admin OR the cost center\'s billing owner. Refuses to demote the team\'s last effective admin (counting enterprise-level superadmins/it_admins) when the team still has other active members.
         * @summary Update Team Member Role
         * @param {string} teamId 
         * @param {string} userId 
         * @param {UpdateTeamMemberRoleRequest} updateTeamMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberRole: async (teamId: string, userId: string, updateTeamMemberRoleRequest: UpdateTeamMemberRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'userId', userId)
            // verify required parameter 'updateTeamMemberRoleRequest' is not null or undefined
            assertParamExists('updateTeamMemberRole', 'updateTeamMemberRoleRequest', updateTeamMemberRoleRequest)
            const localVarPath = `/api/v1/teams/{team_id}/members/{user_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTeamMemberRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamsApi - functional programming interface
 * @export
 */
export const TeamsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new team under a cost center.  The caller must be an enterprise admin or an active member of some team in the cost center.
         * @summary Create Team
         * @param {string} costCenterId 
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(costCenterId: string, createTeamRequest: CreateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(costCenterId, createTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disband a team (soft-delete).  Sets ``team.status=disbanded`` and soft-removes all active memberships with ``removal_method=team_disbanded``. The caller must be an enterprise admin or the cost center\'s ``billing_owner_user_id``.
         * @summary Disband Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disbandTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disbandTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.disbandTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return the caller\'s cost center plus active members of every team in it.  Powers the create-department dialog\'s cost-center-scoped picker — callers can pull any active member of their CC into a new team (intra-CC move). Each member row carries its ``team_id`` so the frontend can scope the successor-admin field to caller\'s old teammates only.  404 if the caller has no active team membership (e.g. orphaned by SCIM provisioning before placement; or after their only team was disbanded).
         * @summary Get Active Cost Center For Caller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveCostCenterForCaller(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveCostCenterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveCostCenterForCaller(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getActiveCostCenterForCaller']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a single team by id.  The caller must be an enterprise admin or an active member of the team. Cross-enterprise callers receive 404 (not 403) to avoid leaking existence.
         * @summary Get Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pending enterprise member self-selects into a team via the desktop picker.  Multi-team enterprises leave new SCIM/auto-add users in a pending state (no team membership). The desktop client renders a team picker; selecting a team calls this endpoint, which inserts the membership with ``add_method=team_picker`` and reconciles seats for the team\'s cost center outside the DB transaction.  Returns 400 when the user has no enterprise, 404 when the team is missing, disbanded, or in another enterprise, and 409 when the user already has an active membership in the enterprise.
         * @summary Join Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinTeam(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinTeam(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.joinTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active teams for an enterprise.  Any user in the enterprise can call this — including pending users with ``enterprise_id`` set but no team membership, who need this list to render the desktop team picker. Cross-enterprise callers receive 404 (not 403) to avoid leaking enterprise existence.
         * @summary List Teams
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeams(enterpriseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeams(enterpriseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.listTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move an enterprise user into this team from their current team.  The caller must be an enterprise admin or an admin of the destination team. After the move, the refreshed team and its member count are returned.
         * @summary Move Member To Team
         * @param {string} teamId 
         * @param {MoveMemberRequest} moveMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveMemberToTeam(teamId: string, moveMemberRequest: MoveMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveMemberToTeam(teamId, moveMemberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.moveMemberToTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reassign a team to a different cost center within the same enterprise.  Caller must be an enterprise admin. The destination CC must be in a live billing status and belong to the same enterprise. The source CC must retain at least one team after the move.
         * @summary Move Team To Cost Center
         * @param {string} teamId 
         * @param {MoveTeamToCostCenterRequest} moveTeamToCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveTeamToCostCenter(teamId: string, moveTeamToCostCenterRequest: MoveTeamToCostCenterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveTeamToCostCenter(teamId, moveTeamToCostCenterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.moveTeamToCostCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rename a team.  The caller must be an enterprise admin or team admin.
         * @summary Update Team
         * @param {string} teamId 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(teamId: string, updateTeamRequest: UpdateTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(teamId, updateTeamRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the per-team role of a member already on the team.  Caller must be an enterprise admin OR the cost center\'s billing owner. Refuses to demote the team\'s last effective admin (counting enterprise-level superadmins/it_admins) when the team still has other active members.
         * @summary Update Team Member Role
         * @param {string} teamId 
         * @param {string} userId 
         * @param {UpdateTeamMemberRoleRequest} updateTeamMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMemberRole(teamId: string, userId: string, updateTeamMemberRoleRequest: UpdateTeamMemberRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMembershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMemberRole(teamId, userId, updateTeamMemberRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamsApi.updateTeamMemberRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamsApi - factory interface
 * @export
 */
export const TeamsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamsApiFp(configuration)
    return {
        /**
         * Create a new team under a cost center.  The caller must be an enterprise admin or an active member of some team in the cost center.
         * @summary Create Team
         * @param {string} costCenterId 
         * @param {CreateTeamRequest} createTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(costCenterId: string, createTeamRequest: CreateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.createTeam(costCenterId, createTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Disband a team (soft-delete).  Sets ``team.status=disbanded`` and soft-removes all active memberships with ``removal_method=team_disbanded``. The caller must be an enterprise admin or the cost center\'s ``billing_owner_user_id``.
         * @summary Disband Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disbandTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disbandTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the caller\'s cost center plus active members of every team in it.  Powers the create-department dialog\'s cost-center-scoped picker — callers can pull any active member of their CC into a new team (intra-CC move). Each member row carries its ``team_id`` so the frontend can scope the successor-admin field to caller\'s old teammates only.  404 if the caller has no active team membership (e.g. orphaned by SCIM provisioning before placement; or after their only team was disbanded).
         * @summary Get Active Cost Center For Caller
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveCostCenterForCaller(options?: RawAxiosRequestConfig): AxiosPromise<ActiveCostCenterResponse> {
            return localVarFp.getActiveCostCenterForCaller(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a single team by id.  The caller must be an enterprise admin or an active member of the team. Cross-enterprise callers receive 404 (not 403) to avoid leaking existence.
         * @summary Get Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.getTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Pending enterprise member self-selects into a team via the desktop picker.  Multi-team enterprises leave new SCIM/auto-add users in a pending state (no team membership). The desktop client renders a team picker; selecting a team calls this endpoint, which inserts the membership with ``add_method=team_picker`` and reconciles seats for the team\'s cost center outside the DB transaction.  Returns 400 when the user has no enterprise, 404 when the team is missing, disbanded, or in another enterprise, and 409 when the user already has an active membership in the enterprise.
         * @summary Join Team
         * @param {string} teamId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinTeam(teamId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.joinTeam(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active teams for an enterprise.  Any user in the enterprise can call this — including pending users with ``enterprise_id`` set but no team membership, who need this list to render the desktop team picker. Cross-enterprise callers receive 404 (not 403) to avoid leaking enterprise existence.
         * @summary List Teams
         * @param {string} enterpriseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams(enterpriseId: string, options?: RawAxiosRequestConfig): AxiosPromise<TeamListResponse> {
            return localVarFp.listTeams(enterpriseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Move an enterprise user into this team from their current team.  The caller must be an enterprise admin or an admin of the destination team. After the move, the refreshed team and its member count are returned.
         * @summary Move Member To Team
         * @param {string} teamId 
         * @param {MoveMemberRequest} moveMemberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveMemberToTeam(teamId: string, moveMemberRequest: MoveMemberRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.moveMemberToTeam(teamId, moveMemberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reassign a team to a different cost center within the same enterprise.  Caller must be an enterprise admin. The destination CC must be in a live billing status and belong to the same enterprise. The source CC must retain at least one team after the move.
         * @summary Move Team To Cost Center
         * @param {string} teamId 
         * @param {MoveTeamToCostCenterRequest} moveTeamToCostCenterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveTeamToCostCenter(teamId: string, moveTeamToCostCenterRequest: MoveTeamToCostCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.moveTeamToCostCenter(teamId, moveTeamToCostCenterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rename a team.  The caller must be an enterprise admin or team admin.
         * @summary Update Team
         * @param {string} teamId 
         * @param {UpdateTeamRequest} updateTeamRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId: string, updateTeamRequest: UpdateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamResponse> {
            return localVarFp.updateTeam(teamId, updateTeamRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the per-team role of a member already on the team.  Caller must be an enterprise admin OR the cost center\'s billing owner. Refuses to demote the team\'s last effective admin (counting enterprise-level superadmins/it_admins) when the team still has other active members.
         * @summary Update Team Member Role
         * @param {string} teamId 
         * @param {string} userId 
         * @param {UpdateTeamMemberRoleRequest} updateTeamMemberRoleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberRole(teamId: string, userId: string, updateTeamMemberRoleRequest: UpdateTeamMemberRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMembershipResponse> {
            return localVarFp.updateTeamMemberRole(teamId, userId, updateTeamMemberRoleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamsApi - object-oriented interface
 * @export
 * @class TeamsApi
 * @extends {BaseAPI}
 */
export class TeamsApi extends BaseAPI {
    /**
     * Create a new team under a cost center.  The caller must be an enterprise admin or an active member of some team in the cost center.
     * @summary Create Team
     * @param {string} costCenterId 
     * @param {CreateTeamRequest} createTeamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public createTeam(costCenterId: string, createTeamRequest: CreateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).createTeam(costCenterId, createTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disband a team (soft-delete).  Sets ``team.status=disbanded`` and soft-removes all active memberships with ``removal_method=team_disbanded``. The caller must be an enterprise admin or the cost center\'s ``billing_owner_user_id``.
     * @summary Disband Team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public disbandTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).disbandTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return the caller\'s cost center plus active members of every team in it.  Powers the create-department dialog\'s cost-center-scoped picker — callers can pull any active member of their CC into a new team (intra-CC move). Each member row carries its ``team_id`` so the frontend can scope the successor-admin field to caller\'s old teammates only.  404 if the caller has no active team membership (e.g. orphaned by SCIM provisioning before placement; or after their only team was disbanded).
     * @summary Get Active Cost Center For Caller
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getActiveCostCenterForCaller(options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getActiveCostCenterForCaller(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a single team by id.  The caller must be an enterprise admin or an active member of the team. Cross-enterprise callers receive 404 (not 403) to avoid leaking existence.
     * @summary Get Team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public getTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).getTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pending enterprise member self-selects into a team via the desktop picker.  Multi-team enterprises leave new SCIM/auto-add users in a pending state (no team membership). The desktop client renders a team picker; selecting a team calls this endpoint, which inserts the membership with ``add_method=team_picker`` and reconciles seats for the team\'s cost center outside the DB transaction.  Returns 400 when the user has no enterprise, 404 when the team is missing, disbanded, or in another enterprise, and 409 when the user already has an active membership in the enterprise.
     * @summary Join Team
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public joinTeam(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).joinTeam(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active teams for an enterprise.  Any user in the enterprise can call this — including pending users with ``enterprise_id`` set but no team membership, who need this list to render the desktop team picker. Cross-enterprise callers receive 404 (not 403) to avoid leaking enterprise existence.
     * @summary List Teams
     * @param {string} enterpriseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public listTeams(enterpriseId: string, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).listTeams(enterpriseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move an enterprise user into this team from their current team.  The caller must be an enterprise admin or an admin of the destination team. After the move, the refreshed team and its member count are returned.
     * @summary Move Member To Team
     * @param {string} teamId 
     * @param {MoveMemberRequest} moveMemberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public moveMemberToTeam(teamId: string, moveMemberRequest: MoveMemberRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).moveMemberToTeam(teamId, moveMemberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reassign a team to a different cost center within the same enterprise.  Caller must be an enterprise admin. The destination CC must be in a live billing status and belong to the same enterprise. The source CC must retain at least one team after the move.
     * @summary Move Team To Cost Center
     * @param {string} teamId 
     * @param {MoveTeamToCostCenterRequest} moveTeamToCostCenterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public moveTeamToCostCenter(teamId: string, moveTeamToCostCenterRequest: MoveTeamToCostCenterRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).moveTeamToCostCenter(teamId, moveTeamToCostCenterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rename a team.  The caller must be an enterprise admin or team admin.
     * @summary Update Team
     * @param {string} teamId 
     * @param {UpdateTeamRequest} updateTeamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public updateTeam(teamId: string, updateTeamRequest: UpdateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).updateTeam(teamId, updateTeamRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the per-team role of a member already on the team.  Caller must be an enterprise admin OR the cost center\'s billing owner. Refuses to demote the team\'s last effective admin (counting enterprise-level superadmins/it_admins) when the team still has other active members.
     * @summary Update Team Member Role
     * @param {string} teamId 
     * @param {string} userId 
     * @param {UpdateTeamMemberRoleRequest} updateTeamMemberRoleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamsApi
     */
    public updateTeamMemberRole(teamId: string, userId: string, updateTeamMemberRoleRequest: UpdateTeamMemberRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamsApiFp(this.configuration).updateTeamMemberRole(teamId, userId, updateTeamMemberRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TodosApi - axios parameter creator
 * @export
 */
export const TodosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Bidirectionally sync the user\'s todos (whole-row, LWW on ``modified_at``).  Ingest is INSERT-adopt with guards: a pushed id that exists under another user, or whose non-null ``meeting_id`` isn\'t the caller\'s, is omitted from ``acked`` so the client retries; everything else is created/updated. The pull carries every todo the user owns (capped), including tombstones.
         * @summary Sync Todos
         * @param {TodoSyncRequest} todoSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodos: async (todoSyncRequest: TodoSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'todoSyncRequest' is not null or undefined
            assertParamExists('syncTodos', 'todoSyncRequest', todoSyncRequest)
            const localVarPath = `/api/v1/todos/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(todoSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TodosApi - functional programming interface
 * @export
 */
export const TodosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TodosApiAxiosParamCreator(configuration)
    return {
        /**
         * Bidirectionally sync the user\'s todos (whole-row, LWW on ``modified_at``).  Ingest is INSERT-adopt with guards: a pushed id that exists under another user, or whose non-null ``meeting_id`` isn\'t the caller\'s, is omitted from ``acked`` so the client retries; everything else is created/updated. The pull carries every todo the user owns (capped), including tombstones.
         * @summary Sync Todos
         * @param {TodoSyncRequest} todoSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncTodos(todoSyncRequest: TodoSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoSyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncTodos(todoSyncRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TodosApi.syncTodos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TodosApi - factory interface
 * @export
 */
export const TodosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TodosApiFp(configuration)
    return {
        /**
         * Bidirectionally sync the user\'s todos (whole-row, LWW on ``modified_at``).  Ingest is INSERT-adopt with guards: a pushed id that exists under another user, or whose non-null ``meeting_id`` isn\'t the caller\'s, is omitted from ``acked`` so the client retries; everything else is created/updated. The pull carries every todo the user owns (capped), including tombstones.
         * @summary Sync Todos
         * @param {TodoSyncRequest} todoSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncTodos(todoSyncRequest: TodoSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<TodoSyncResponse> {
            return localVarFp.syncTodos(todoSyncRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TodosApi - object-oriented interface
 * @export
 * @class TodosApi
 * @extends {BaseAPI}
 */
export class TodosApi extends BaseAPI {
    /**
     * Bidirectionally sync the user\'s todos (whole-row, LWW on ``modified_at``).  Ingest is INSERT-adopt with guards: a pushed id that exists under another user, or whose non-null ``meeting_id`` isn\'t the caller\'s, is omitted from ``acked`` so the client retries; everything else is created/updated. The pull carries every todo the user owns (capped), including tombstones.
     * @summary Sync Todos
     * @param {TodoSyncRequest} todoSyncRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TodosApi
     */
    public syncTodos(todoSyncRequest: TodoSyncRequest, options?: RawAxiosRequestConfig) {
        return TodosApiFp(this.configuration).syncTodos(todoSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrackingApi - axios parameter creator
 * @export
 */
export const TrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ingest tracking events from web beacons (Webflow).  Currently supports: - app_download -> Lead event (first per account, via attribution service)
         * @summary Track Event
         * @param {TrackingEventRequest} trackingEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackEvent: async (trackingEventRequest: TrackingEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trackingEventRequest' is not null or undefined
            assertParamExists('trackEvent', 'trackingEventRequest', trackingEventRequest)
            const localVarPath = `/api/v1/tracking/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrackingApi - functional programming interface
 * @export
 */
export const TrackingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrackingApiAxiosParamCreator(configuration)
    return {
        /**
         * Ingest tracking events from web beacons (Webflow).  Currently supports: - app_download -> Lead event (first per account, via attribution service)
         * @summary Track Event
         * @param {TrackingEventRequest} trackingEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trackEvent(trackingEventRequest: TrackingEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackingEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trackEvent(trackingEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrackingApi.trackEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrackingApi - factory interface
 * @export
 */
export const TrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrackingApiFp(configuration)
    return {
        /**
         * Ingest tracking events from web beacons (Webflow).  Currently supports: - app_download -> Lead event (first per account, via attribution service)
         * @summary Track Event
         * @param {TrackingEventRequest} trackingEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trackEvent(trackingEventRequest: TrackingEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrackingEventResponse> {
            return localVarFp.trackEvent(trackingEventRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TrackingApi - object-oriented interface
 * @export
 * @class TrackingApi
 * @extends {BaseAPI}
 */
export class TrackingApi extends BaseAPI {
    /**
     * Ingest tracking events from web beacons (Webflow).  Currently supports: - app_download -> Lead event (first per account, via attribution service)
     * @summary Track Event
     * @param {TrackingEventRequest} trackingEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrackingApi
     */
    public trackEvent(trackingEventRequest: TrackingEventRequest, options?: RawAxiosRequestConfig) {
        return TrackingApiFp(this.configuration).trackEvent(trackingEventRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransformApi - axios parameter creator
 * @export
 */
export const TransformApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Apply a transform to the request text and return the result.
         * @summary Apply Transform
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransform: async (transformApplyRequest: TransformApplyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplyRequest' is not null or undefined
            assertParamExists('applyTransform', 'transformApplyRequest', transformApplyRequest)
            const localVarPath = `/api/v1/transform/apply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply a dynamic (free-form instruction) transform (V2) to the request text.
         * @summary Apply Transform Dynamic
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformDynamic: async (transformApplyDynamicRequest: TransformApplyDynamicRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplyDynamicRequest' is not null or undefined
            assertParamExists('applyTransformDynamic', 'transformApplyDynamicRequest', transformApplyDynamicRequest)
            const localVarPath = `/api/v1/transform/apply/dynamic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplyDynamicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SSE variant of :func:`apply_transform_dynamic`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformDynamicStream``.
         * @summary Apply Transform Dynamic Stream
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformDynamicStream: async (transformApplyDynamicRequest: TransformApplyDynamicRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplyDynamicRequest' is not null or undefined
            assertParamExists('applyTransformDynamicStream', 'transformApplyDynamicRequest', transformApplyDynamicRequest)
            const localVarPath = `/api/v1/transform/apply/dynamic/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplyDynamicRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SSE variant of :func:`apply_transform`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformStream``.
         * @summary Apply Transform Stream
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformStream: async (transformApplyRequest: TransformApplyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplyRequest' is not null or undefined
            assertParamExists('applyTransformStream', 'transformApplyRequest', transformApplyRequest)
            const localVarPath = `/api/v1/transform/apply/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Apply a named suggestion transform (V2) to the request text.
         * @summary Apply Transform Suggestion
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformSuggestion: async (transformApplySuggestionRequest: TransformApplySuggestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplySuggestionRequest' is not null or undefined
            assertParamExists('applyTransformSuggestion', 'transformApplySuggestionRequest', transformApplySuggestionRequest)
            const localVarPath = `/api/v1/transform/apply/suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplySuggestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SSE variant of :func:`apply_transform_suggestion`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformSuggestionStream``.
         * @summary Apply Transform Suggestion Stream
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformSuggestionStream: async (transformApplySuggestionRequest: TransformApplySuggestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformApplySuggestionRequest' is not null or undefined
            assertParamExists('applyTransformSuggestionStream', 'transformApplySuggestionRequest', transformApplySuggestionRequest)
            const localVarPath = `/api/v1/transform/apply/suggestion/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformApplySuggestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return suggested transforms for the given text and context.
         * @summary Get Suggestions
         * @param {TransformSuggestionsRequest} transformSuggestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: async (transformSuggestionsRequest: TransformSuggestionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transformSuggestionsRequest' is not null or undefined
            assertParamExists('getSuggestions', 'transformSuggestionsRequest', transformSuggestionsRequest)
            const localVarPath = `/api/v1/transform/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transformSuggestionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resolve the requesting user\'s team/personal Transforms voice profiles.  Returns both when the user matches a personal email and a team domain. Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``getVoiceProfilePrompts``.
         * @summary Transforms Voice Prompts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformsVoicePrompts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transform/transforms-voice-prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransformApi - functional programming interface
 * @export
 */
export const TransformApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransformApiAxiosParamCreator(configuration)
    return {
        /**
         * Apply a transform to the request text and return the result.
         * @summary Apply Transform
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransform(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransformApplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransform(transformApplyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransform']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply a dynamic (free-form instruction) transform (V2) to the request text.
         * @summary Apply Transform Dynamic
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransformDynamic(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransformApplyDynamicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransformDynamic(transformApplyDynamicRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransformDynamic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SSE variant of :func:`apply_transform_dynamic`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformDynamicStream``.
         * @summary Apply Transform Dynamic Stream
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransformDynamicStream(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransformDynamicStream(transformApplyDynamicRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransformDynamicStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SSE variant of :func:`apply_transform`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformStream``.
         * @summary Apply Transform Stream
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransformStream(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransformStream(transformApplyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransformStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Apply a named suggestion transform (V2) to the request text.
         * @summary Apply Transform Suggestion
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransformSuggestion(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransformApplySuggestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransformSuggestion(transformApplySuggestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransformSuggestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * SSE variant of :func:`apply_transform_suggestion`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformSuggestionStream``.
         * @summary Apply Transform Suggestion Stream
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyTransformSuggestionStream(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyTransformSuggestionStream(transformApplySuggestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.applyTransformSuggestionStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return suggested transforms for the given text and context.
         * @summary Get Suggestions
         * @param {TransformSuggestionsRequest} transformSuggestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestions(transformSuggestionsRequest: TransformSuggestionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransformSuggestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestions(transformSuggestionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.getSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resolve the requesting user\'s team/personal Transforms voice profiles.  Returns both when the user matches a personal email and a team domain. Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``getVoiceProfilePrompts``.
         * @summary Transforms Voice Prompts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transformsVoicePrompts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceProfilePromptsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transformsVoicePrompts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransformApi.transformsVoicePrompts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransformApi - factory interface
 * @export
 */
export const TransformApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransformApiFp(configuration)
    return {
        /**
         * Apply a transform to the request text and return the result.
         * @summary Apply Transform
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransform(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransformApplyResponse> {
            return localVarFp.applyTransform(transformApplyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply a dynamic (free-form instruction) transform (V2) to the request text.
         * @summary Apply Transform Dynamic
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformDynamic(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransformApplyDynamicResponse> {
            return localVarFp.applyTransformDynamic(transformApplyDynamicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SSE variant of :func:`apply_transform_dynamic`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformDynamicStream``.
         * @summary Apply Transform Dynamic Stream
         * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformDynamicStream(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.applyTransformDynamicStream(transformApplyDynamicRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SSE variant of :func:`apply_transform`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformStream``.
         * @summary Apply Transform Stream
         * @param {TransformApplyRequest} transformApplyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformStream(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.applyTransformStream(transformApplyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Apply a named suggestion transform (V2) to the request text.
         * @summary Apply Transform Suggestion
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformSuggestion(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransformApplySuggestionResponse> {
            return localVarFp.applyTransformSuggestion(transformApplySuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * SSE variant of :func:`apply_transform_suggestion`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformSuggestionStream``.
         * @summary Apply Transform Suggestion Stream
         * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyTransformSuggestionStream(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.applyTransformSuggestionStream(transformApplySuggestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Return suggested transforms for the given text and context.
         * @summary Get Suggestions
         * @param {TransformSuggestionsRequest} transformSuggestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions(transformSuggestionsRequest: TransformSuggestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransformSuggestionsResponse> {
            return localVarFp.getSuggestions(transformSuggestionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resolve the requesting user\'s team/personal Transforms voice profiles.  Returns both when the user matches a personal email and a team domain. Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``getVoiceProfilePrompts``.
         * @summary Transforms Voice Prompts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transformsVoicePrompts(options?: RawAxiosRequestConfig): AxiosPromise<VoiceProfilePromptsResponse> {
            return localVarFp.transformsVoicePrompts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransformApi - object-oriented interface
 * @export
 * @class TransformApi
 * @extends {BaseAPI}
 */
export class TransformApi extends BaseAPI {
    /**
     * Apply a transform to the request text and return the result.
     * @summary Apply Transform
     * @param {TransformApplyRequest} transformApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransform(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransform(transformApplyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply a dynamic (free-form instruction) transform (V2) to the request text.
     * @summary Apply Transform Dynamic
     * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransformDynamic(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransformDynamic(transformApplyDynamicRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SSE variant of :func:`apply_transform_dynamic`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformDynamicStream``.
     * @summary Apply Transform Dynamic Stream
     * @param {TransformApplyDynamicRequest} transformApplyDynamicRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransformDynamicStream(transformApplyDynamicRequest: TransformApplyDynamicRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransformDynamicStream(transformApplyDynamicRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SSE variant of :func:`apply_transform`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformStream``.
     * @summary Apply Transform Stream
     * @param {TransformApplyRequest} transformApplyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransformStream(transformApplyRequest: TransformApplyRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransformStream(transformApplyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Apply a named suggestion transform (V2) to the request text.
     * @summary Apply Transform Suggestion
     * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransformSuggestion(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransformSuggestion(transformApplySuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SSE variant of :func:`apply_transform_suggestion`.  Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``applyTransformSuggestionStream``.
     * @summary Apply Transform Suggestion Stream
     * @param {TransformApplySuggestionRequest} transformApplySuggestionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public applyTransformSuggestionStream(transformApplySuggestionRequest: TransformApplySuggestionRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).applyTransformSuggestionStream(transformApplySuggestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return suggested transforms for the given text and context.
     * @summary Get Suggestions
     * @param {TransformSuggestionsRequest} transformSuggestionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public getSuggestions(transformSuggestionsRequest: TransformSuggestionsRequest, options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).getSuggestions(transformSuggestionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resolve the requesting user\'s team/personal Transforms voice profiles.  Returns both when the user matches a personal email and a team domain. Client: ``desktop/src/main/backend/ariaWeb.ts`` → ``getVoiceProfilePrompts``.
     * @summary Transforms Voice Prompts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransformApi
     */
    public transformsVoicePrompts(options?: RawAxiosRequestConfig) {
        return TransformApiFp(this.configuration).transformsVoicePrompts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TypingTestApi - axios parameter creator
 * @export
 */
export const TypingTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch the current typing test leaderboard, including the caller\'s rank when authenticated.  The `email` query parameter is accepted but ignored: resolving a rank from a caller-supplied email let anyone read another person\'s display name and WPM. Anonymous submitters get their rank from the submit-score response instead.
         * @summary Get Leaderboard
         * @param {number} [limit] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard: async (limit?: number, email?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/typing-test/leaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch a random typing test passage for a given language.
         * @summary Get Passage
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPassage: async (language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/typing-test/passage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a typing test score. Validates keystrokes server-side and records the attempt.
         * @summary Submit Score
         * @param {SubmitScoreRequest} submitScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitScore: async (submitScoreRequest: SubmitScoreRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitScoreRequest' is not null or undefined
            assertParamExists('submitScore', 'submitScoreRequest', submitScoreRequest)
            const localVarPath = `/api/v1/typing-test/submit-score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitScoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TypingTestApi - functional programming interface
 * @export
 */
export const TypingTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TypingTestApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch the current typing test leaderboard, including the caller\'s rank when authenticated.  The `email` query parameter is accepted but ignored: resolving a rank from a caller-supplied email let anyone read another person\'s display name and WPM. Anonymous submitters get their rank from the submit-score response instead.
         * @summary Get Leaderboard
         * @param {number} [limit] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeaderboard(limit?: number, email?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeaderboard(limit, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingTestApi.getLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch a random typing test passage for a given language.
         * @summary Get Passage
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPassage(language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PassageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPassage(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingTestApi.getPassage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit a typing test score. Validates keystrokes server-side and records the attempt.
         * @summary Submit Score
         * @param {SubmitScoreRequest} submitScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitScore(submitScoreRequest: SubmitScoreRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypingTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitScore(submitScoreRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TypingTestApi.submitScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TypingTestApi - factory interface
 * @export
 */
export const TypingTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TypingTestApiFp(configuration)
    return {
        /**
         * Fetch the current typing test leaderboard, including the caller\'s rank when authenticated.  The `email` query parameter is accepted but ignored: resolving a rank from a caller-supplied email let anyone read another person\'s display name and WPM. Anonymous submitters get their rank from the submit-score response instead.
         * @summary Get Leaderboard
         * @param {number} [limit] 
         * @param {string | null} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeaderboard(limit?: number, email?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<LeaderboardResponse> {
            return localVarFp.getLeaderboard(limit, email, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch a random typing test passage for a given language.
         * @summary Get Passage
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPassage(language?: string, options?: RawAxiosRequestConfig): AxiosPromise<PassageResponse> {
            return localVarFp.getPassage(language, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a typing test score. Validates keystrokes server-side and records the attempt.
         * @summary Submit Score
         * @param {SubmitScoreRequest} submitScoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitScore(submitScoreRequest: SubmitScoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<TypingTestResponse> {
            return localVarFp.submitScore(submitScoreRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TypingTestApi - object-oriented interface
 * @export
 * @class TypingTestApi
 * @extends {BaseAPI}
 */
export class TypingTestApi extends BaseAPI {
    /**
     * Fetch the current typing test leaderboard, including the caller\'s rank when authenticated.  The `email` query parameter is accepted but ignored: resolving a rank from a caller-supplied email let anyone read another person\'s display name and WPM. Anonymous submitters get their rank from the submit-score response instead.
     * @summary Get Leaderboard
     * @param {number} [limit] 
     * @param {string | null} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingTestApi
     */
    public getLeaderboard(limit?: number, email?: string | null, options?: RawAxiosRequestConfig) {
        return TypingTestApiFp(this.configuration).getLeaderboard(limit, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch a random typing test passage for a given language.
     * @summary Get Passage
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingTestApi
     */
    public getPassage(language?: string, options?: RawAxiosRequestConfig) {
        return TypingTestApiFp(this.configuration).getPassage(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a typing test score. Validates keystrokes server-side and records the attempt.
     * @summary Submit Score
     * @param {SubmitScoreRequest} submitScoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TypingTestApi
     */
    public submitScore(submitScoreRequest: SubmitScoreRequest, options?: RawAxiosRequestConfig) {
        return TypingTestApiFp(this.configuration).submitScore(submitScoreRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnreadSharesApi - axios parameter creator
 * @export
 */
export const UnreadSharesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return the caller\'s unread invited notes that they can still open, newest first.
         * @summary List Unread Shares
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnreadShares: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/unread-shares`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark the caller\'s notes as announced; unknown or already-announced ids are ignored.
         * @summary Mark Unread Shares Announced
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUnreadSharesAnnounced: async (unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unreadSharesUpdateRequest' is not null or undefined
            assertParamExists('markUnreadSharesAnnounced', 'unreadSharesUpdateRequest', unreadSharesUpdateRequest)
            const localVarPath = `/api/v1/unread-shares/announced`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unreadSharesUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark the caller\'s notes as read; unknown or already-read ids are ignored.
         * @summary Mark Unread Shares Read
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUnreadSharesRead: async (unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unreadSharesUpdateRequest' is not null or undefined
            assertParamExists('markUnreadSharesRead', 'unreadSharesUpdateRequest', unreadSharesUpdateRequest)
            const localVarPath = `/api/v1/unread-shares/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unreadSharesUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnreadSharesApi - functional programming interface
 * @export
 */
export const UnreadSharesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnreadSharesApiAxiosParamCreator(configuration)
    return {
        /**
         * Return the caller\'s unread invited notes that they can still open, newest first.
         * @summary List Unread Shares
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUnreadShares(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadSharesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUnreadShares(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnreadSharesApi.listUnreadShares']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark the caller\'s notes as announced; unknown or already-announced ids are ignored.
         * @summary Mark Unread Shares Announced
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markUnreadSharesAnnounced(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markUnreadSharesAnnounced(unreadSharesUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnreadSharesApi.markUnreadSharesAnnounced']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark the caller\'s notes as read; unknown or already-read ids are ignored.
         * @summary Mark Unread Shares Read
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markUnreadSharesRead(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markUnreadSharesRead(unreadSharesUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnreadSharesApi.markUnreadSharesRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnreadSharesApi - factory interface
 * @export
 */
export const UnreadSharesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnreadSharesApiFp(configuration)
    return {
        /**
         * Return the caller\'s unread invited notes that they can still open, newest first.
         * @summary List Unread Shares
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUnreadShares(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<UnreadSharesResponse> {
            return localVarFp.listUnreadShares(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark the caller\'s notes as announced; unknown or already-announced ids are ignored.
         * @summary Mark Unread Shares Announced
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUnreadSharesAnnounced(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markUnreadSharesAnnounced(unreadSharesUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark the caller\'s notes as read; unknown or already-read ids are ignored.
         * @summary Mark Unread Shares Read
         * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUnreadSharesRead(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markUnreadSharesRead(unreadSharesUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnreadSharesApi - object-oriented interface
 * @export
 * @class UnreadSharesApi
 * @extends {BaseAPI}
 */
export class UnreadSharesApi extends BaseAPI {
    /**
     * Return the caller\'s unread invited notes that they can still open, newest first.
     * @summary List Unread Shares
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnreadSharesApi
     */
    public listUnreadShares(limit?: number, options?: RawAxiosRequestConfig) {
        return UnreadSharesApiFp(this.configuration).listUnreadShares(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark the caller\'s notes as announced; unknown or already-announced ids are ignored.
     * @summary Mark Unread Shares Announced
     * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnreadSharesApi
     */
    public markUnreadSharesAnnounced(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig) {
        return UnreadSharesApiFp(this.configuration).markUnreadSharesAnnounced(unreadSharesUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark the caller\'s notes as read; unknown or already-read ids are ignored.
     * @summary Mark Unread Shares Read
     * @param {UnreadSharesUpdateRequest} unreadSharesUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnreadSharesApi
     */
    public markUnreadSharesRead(unreadSharesUpdateRequest: UnreadSharesUpdateRequest, options?: RawAxiosRequestConfig) {
        return UnreadSharesApiFp(this.configuration).markUnreadSharesRead(unreadSharesUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserContextApi - axios parameter creator
 * @export
 */
export const UserContextApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete the current user\'s context.
         * @summary Delete User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserContext: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user\'s context.
         * @summary Get User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContext: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update the current user\'s context.
         * @summary Update User Context
         * @param {UpdateUserContextRequest} updateUserContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserContext: async (updateUserContextRequest: UpdateUserContextRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserContextRequest' is not null or undefined
            assertParamExists('updateUserContext', 'updateUserContextRequest', updateUserContextRequest)
            const localVarPath = `/api/v1/user_context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserContextRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserContextApi - functional programming interface
 * @export
 */
export const UserContextApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserContextApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete the current user\'s context.
         * @summary Delete User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserContext(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserContext(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserContextApi.deleteUserContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current user\'s context.
         * @summary Get User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserContext(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserContext(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserContextApi.getUserContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create or update the current user\'s context.
         * @summary Update User Context
         * @param {UpdateUserContextRequest} updateUserContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserContext(updateUserContextRequest: UpdateUserContextRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserContextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserContext(updateUserContextRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserContextApi.updateUserContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserContextApi - factory interface
 * @export
 */
export const UserContextApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserContextApiFp(configuration)
    return {
        /**
         * Delete the current user\'s context.
         * @summary Delete User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserContext(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserContext(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current user\'s context.
         * @summary Get User Context
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserContext(options?: RawAxiosRequestConfig): AxiosPromise<UserContextResponse> {
            return localVarFp.getUserContext(options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update the current user\'s context.
         * @summary Update User Context
         * @param {UpdateUserContextRequest} updateUserContextRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserContext(updateUserContextRequest: UpdateUserContextRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserContextResponse> {
            return localVarFp.updateUserContext(updateUserContextRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserContextApi - object-oriented interface
 * @export
 * @class UserContextApi
 * @extends {BaseAPI}
 */
export class UserContextApi extends BaseAPI {
    /**
     * Delete the current user\'s context.
     * @summary Delete User Context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserContextApi
     */
    public deleteUserContext(options?: RawAxiosRequestConfig) {
        return UserContextApiFp(this.configuration).deleteUserContext(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current user\'s context.
     * @summary Get User Context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserContextApi
     */
    public getUserContext(options?: RawAxiosRequestConfig) {
        return UserContextApiFp(this.configuration).getUserContext(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update the current user\'s context.
     * @summary Update User Context
     * @param {UpdateUserContextRequest} updateUserContextRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserContextApi
     */
    public updateUserContext(updateUserContextRequest: UpdateUserContextRequest, options?: RawAxiosRequestConfig) {
        return UserContextApiFp(this.configuration).updateUserContext(updateUserContextRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserManagementApi - axios parameter creator
 * @export
 */
export const UserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Claim a trial extension day for dictating 100+ words.  Users can claim once per day, up to 7 days total, within 7 days of onboarding.
         * @summary Claim Trial Extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimTrialExtension: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/claim_trial_extension`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the authenticated user\'s entire dictionary.
         * @summary Delete User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserDictionary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a single word from the authenticated user\'s dictionary.
         * @summary Delete Word In Dictionary
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWordInDictionary: async (wordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wordId' is not null or undefined
            assertParamExists('deleteWordInDictionary', 'wordId', wordId)
            const localVarPath = `/api/v1/user/dictionary/{word_id}`
                .replace(`{${"word_id"}}`, encodeURIComponent(String(wordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export all data associated with a user\'s email address (root API key).  Returns a JSON file containing all user data from main_db, usage_db, and platform_db.
         * @summary Export User Data
         * @param {string} email The email address of the user to export data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserData: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('exportUserData', 'email', email)
            const localVarPath = `/api/v1/user/export_data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the status of the user\'s HIPAA Business Associate Agreement.
         * @summary Get Hipaa Baa Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHipaaBaaStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/hipaa-baa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List the third-party MCP clients this user has connected, most recently connected first.
         * @summary Get Mcp Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMcpConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/mcp_connection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of platforms the user has registered.
         * @summary Get Registered Devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredDevices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/registered_devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s student status.
         * @summary Get Student Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/student_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s trial status.
         * @summary Get Trial Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/trial_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s dictionary.
         * @summary Get User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDictionary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s ID.
         * @summary Get User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/user-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s preferences.
         * @summary Get User Preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreference: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s profile information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the authenticated user\'s usage stats.
         * @summary Get User Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/user_stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark onboarding completed and activate trial if eligible and claimed.
         * @summary Onboarding Complete
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {TrialVariant | null} [trialVariant] Trial variant for experiment. None &#x3D; auto-grant (legacy/control)
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingComplete: async (platform?: string | null, trialVariant?: TrialVariant | null, ga4ClientId?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/onboarding_complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (trialVariant !== undefined) {
                localVarQueryParameter['trial_variant'] = trialVariant;
            }

            if (ga4ClientId !== undefined) {
                localVarQueryParameter['ga4_client_id'] = ga4ClientId;
            }

            if (fbp !== undefined) {
                localVarQueryParameter['fbp'] = fbp;
            }

            if (fbc !== undefined) {
                localVarQueryParameter['fbc'] = fbc;
            }

            if (utmSource !== undefined) {
                localVarQueryParameter['utm_source'] = utmSource;
            }

            if (utmMedium !== undefined) {
                localVarQueryParameter['utm_medium'] = utmMedium;
            }

            if (utmCampaign !== undefined) {
                localVarQueryParameter['utm_campaign'] = utmCampaign;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register a device for the authenticated user.
         * @summary Register Device
         * @param {RegisterDeviceRequest} registerDeviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: async (registerDeviceRequest: RegisterDeviceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDeviceRequest' is not null or undefined
            assertParamExists('registerDevice', 'registerDeviceRequest', registerDeviceRequest)
            const localVarPath = `/api/v1/user/register_device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke the user\'s HIPAA Business Associate Agreement.
         * @summary Revoke Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeHipaaBaa: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user/hipaa-baa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Persist an install identity only for the account the client intended.  Args:     data:         Install identity and expected authenticated account.     user:         Verified account identity.     user_service: User persistence service.     user_limiter: Per-user request limit, resolved after authentication.  Returns:     An empty acknowledgement after the identity has been committed.  Raises:     HTTPConflict:         409: The request was prepared for a different authenticated account.
         * @summary Save Appsflyer Identity
         * @param {SaveAppsFlyerIdentityRequest} saveAppsFlyerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppsflyerIdentity: async (saveAppsFlyerIdentityRequest: SaveAppsFlyerIdentityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveAppsFlyerIdentityRequest' is not null or undefined
            assertParamExists('saveAppsflyerIdentity', 'saveAppsFlyerIdentityRequest', saveAppsFlyerIdentityRequest)
            const localVarPath = `/api/v1/user/appsflyer-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAppsFlyerIdentityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store onboarding answers and mark fulfilled intents.  Called by the web SPA after signup completes and the user row is provisioned.
         * @summary Save Onboarding Answers
         * @param {SubmitOnboardingAnswersRequest} submitOnboardingAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingAnswers: async (submitOnboardingAnswersRequest: SubmitOnboardingAnswersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submitOnboardingAnswersRequest' is not null or undefined
            assertParamExists('saveOnboardingAnswers', 'submitOnboardingAnswersRequest', submitOnboardingAnswersRequest)
            const localVarPath = `/api/v1/user/onboarding-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submitOnboardingAnswersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sign the user\'s HIPAA Business Associate Agreement.
         * @summary Sign Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signHipaaBaa: async (signHipaaBaaRequest: SignHipaaBaaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signHipaaBaaRequest' is not null or undefined
            assertParamExists('signHipaaBaa', 'signHipaaBaaRequest', signHipaaBaaRequest)
            const localVarPath = `/api/v1/user/hipaa-baa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signHipaaBaaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a user\'s student status by email (root API key).  When ``from_now`` is true the trial period is recomputed from the current time; otherwise it is calculated from the original reference point.
         * @summary Update Student Status
         * @param {BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost} bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStudentStatus: async (bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost: BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost' is not null or undefined
            assertParamExists('updateStudentStatus', 'bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost', bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost)
            const localVarPath = `/api/v1/user/update_student_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add words to the authenticated user\'s dictionary.
         * @summary Update User Dictionary
         * @param {Array<DictionaryItemOld>} dictionaryItemOld 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDictionary: async (dictionaryItemOld: Array<DictionaryItemOld>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryItemOld' is not null or undefined
            assertParamExists('updateUserDictionary', 'dictionaryItemOld', dictionaryItemOld)
            const localVarPath = `/api/v1/user/dictionary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryItemOld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the authenticated user\'s preferences.
         * @summary Update User Preference
         * @param {UserPreference} userPreference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreference: async (userPreference: UserPreference, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPreference' is not null or undefined
            assertParamExists('updateUserPreference', 'userPreference', userPreference)
            const localVarPath = `/api/v1/user/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPreference, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the authenticated user\'s profile (first and last name).
         * @summary Update User Profile
         * @param {UserProfile} userProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (userProfile: UserProfile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userProfile' is not null or undefined
            assertParamExists('updateUserProfile', 'userProfile', userProfile)
            const localVarPath = `/api/v1/user/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userProfile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserManagementApi - functional programming interface
 * @export
 */
export const UserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Claim a trial extension day for dictating 100+ words.  Users can claim once per day, up to 7 days total, within 7 days of onboarding.
         * @summary Claim Trial Extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimTrialExtension(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimTrialExtension(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.claimTrialExtension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the authenticated user\'s entire dictionary.
         * @summary Delete User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserDictionary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserDictionary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.deleteUserDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a single word from the authenticated user\'s dictionary.
         * @summary Delete Word In Dictionary
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteWordInDictionary(wordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteWordInDictionary(wordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.deleteWordInDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export all data associated with a user\'s email address (root API key).  Returns a JSON file containing all user data from main_db, usage_db, and platform_db.
         * @summary Export User Data
         * @param {string} email The email address of the user to export data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportUserData(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportUserData(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.exportUserData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the status of the user\'s HIPAA Business Associate Agreement.
         * @summary Get Hipaa Baa Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHipaaBaaStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHipaaBaaStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getHipaaBaaStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List the third-party MCP clients this user has connected, most recently connected first.
         * @summary Get Mcp Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMcpConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<McpConnectionStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMcpConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getMcpConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of platforms the user has registered.
         * @summary Get Registered Devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRegisteredDevices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRegisteredDevices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getRegisteredDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s student status.
         * @summary Get Student Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudentStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudentStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getStudentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s trial status.
         * @summary Get Trial Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getTrialStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s dictionary.
         * @summary Get User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDictionary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDictionary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s ID.
         * @summary Get User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s preferences.
         * @summary Get User Preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPreference(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPreference(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s profile information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the authenticated user\'s usage stats.
         * @summary Get User Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark onboarding completed and activate trial if eligible and claimed.
         * @summary Onboarding Complete
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {TrialVariant | null} [trialVariant] Trial variant for experiment. None &#x3D; auto-grant (legacy/control)
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async onboardingComplete(platform?: string | null, trialVariant?: TrialVariant | null, ga4ClientId?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.onboardingComplete(platform, trialVariant, ga4ClientId, fbp, fbc, utmSource, utmMedium, utmCampaign, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.onboardingComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register a device for the authenticated user.
         * @summary Register Device
         * @param {RegisterDeviceRequest} registerDeviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerDevice(registerDeviceRequest: RegisterDeviceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerDevice(registerDeviceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.registerDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke the user\'s HIPAA Business Associate Agreement.
         * @summary Revoke Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeHipaaBaa(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeHipaaBaa(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.revokeHipaaBaa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Persist an install identity only for the account the client intended.  Args:     data:         Install identity and expected authenticated account.     user:         Verified account identity.     user_service: User persistence service.     user_limiter: Per-user request limit, resolved after authentication.  Returns:     An empty acknowledgement after the identity has been committed.  Raises:     HTTPConflict:         409: The request was prepared for a different authenticated account.
         * @summary Save Appsflyer Identity
         * @param {SaveAppsFlyerIdentityRequest} saveAppsFlyerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAppsflyerIdentity(saveAppsFlyerIdentityRequest: SaveAppsFlyerIdentityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAppsflyerIdentity(saveAppsFlyerIdentityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.saveAppsflyerIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Store onboarding answers and mark fulfilled intents.  Called by the web SPA after signup completes and the user row is provisioned.
         * @summary Save Onboarding Answers
         * @param {SubmitOnboardingAnswersRequest} submitOnboardingAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveOnboardingAnswers(submitOnboardingAnswersRequest: SubmitOnboardingAnswersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OnboardingAnswersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveOnboardingAnswers(submitOnboardingAnswersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.saveOnboardingAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sign the user\'s HIPAA Business Associate Agreement.
         * @summary Sign Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signHipaaBaa(signHipaaBaaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.signHipaaBaa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set a user\'s student status by email (root API key).  When ``from_now`` is true the trial period is recomputed from the current time; otherwise it is calculated from the original reference point.
         * @summary Update Student Status
         * @param {BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost} bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost: BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.updateStudentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add words to the authenticated user\'s dictionary.
         * @summary Update User Dictionary
         * @param {Array<DictionaryItemOld>} dictionaryItemOld 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDictionary(dictionaryItemOld: Array<DictionaryItemOld>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDictionary(dictionaryItemOld, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.updateUserDictionary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the authenticated user\'s preferences.
         * @summary Update User Preference
         * @param {UserPreference} userPreference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPreference(userPreference: UserPreference, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPreference(userPreference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.updateUserPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the authenticated user\'s profile (first and last name).
         * @summary Update User Profile
         * @param {UserProfile} userProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(userProfile: UserProfile, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(userProfile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserManagementApi - factory interface
 * @export
 */
export const UserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserManagementApiFp(configuration)
    return {
        /**
         * Claim a trial extension day for dictating 100+ words.  Users can claim once per day, up to 7 days total, within 7 days of onboarding.
         * @summary Claim Trial Extension
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimTrialExtension(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.claimTrialExtension(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the authenticated user\'s entire dictionary.
         * @summary Delete User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserDictionary(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteUserDictionary(options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a single word from the authenticated user\'s dictionary.
         * @summary Delete Word In Dictionary
         * @param {string} wordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteWordInDictionary(wordId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteWordInDictionary(wordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Export all data associated with a user\'s email address (root API key).  Returns a JSON file containing all user data from main_db, usage_db, and platform_db.
         * @summary Export User Data
         * @param {string} email The email address of the user to export data for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportUserData(email: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportUserData(email, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the status of the user\'s HIPAA Business Associate Agreement.
         * @summary Get Hipaa Baa Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHipaaBaaStatus(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getHipaaBaaStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * List the third-party MCP clients this user has connected, most recently connected first.
         * @summary Get Mcp Connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMcpConnection(options?: RawAxiosRequestConfig): AxiosPromise<McpConnectionStatusResponse> {
            return localVarFp.getMcpConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of platforms the user has registered.
         * @summary Get Registered Devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegisteredDevices(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getRegisteredDevices(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s student status.
         * @summary Get Student Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentStatus(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getStudentStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s trial status.
         * @summary Get Trial Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialStatus(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTrialStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s dictionary.
         * @summary Get User Dictionary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDictionary(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserDictionary(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s ID.
         * @summary Get User Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserId(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s preferences.
         * @summary Get User Preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPreference(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserPreference(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s profile information.
         * @summary Get User Profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileResponse> {
            return localVarFp.getUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the authenticated user\'s usage stats.
         * @summary Get User Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserStats(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getUserStats(options).then((request) => request(axios, basePath));
        },
        /**
         * Mark onboarding completed and activate trial if eligible and claimed.
         * @summary Onboarding Complete
         * @param {string | null} [platform] Platform for attribution tracking
         * @param {TrialVariant | null} [trialVariant] Trial variant for experiment. None &#x3D; auto-grant (legacy/control)
         * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
         * @param {string | null} [fbp] Meta _fbp cookie value
         * @param {string | null} [fbc] Meta _fbc click ID cookie value
         * @param {string | null} [utmSource] UTM source parameter
         * @param {string | null} [utmMedium] UTM medium parameter
         * @param {string | null} [utmCampaign] UTM campaign parameter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingComplete(platform?: string | null, trialVariant?: TrialVariant | null, ga4ClientId?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.onboardingComplete(platform, trialVariant, ga4ClientId, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(axios, basePath));
        },
        /**
         * Register a device for the authenticated user.
         * @summary Register Device
         * @param {RegisterDeviceRequest} registerDeviceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice(registerDeviceRequest: RegisterDeviceRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.registerDevice(registerDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke the user\'s HIPAA Business Associate Agreement.
         * @summary Revoke Hipaa Baa
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeHipaaBaa(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.revokeHipaaBaa(options).then((request) => request(axios, basePath));
        },
        /**
         * Persist an install identity only for the account the client intended.  Args:     data:         Install identity and expected authenticated account.     user:         Verified account identity.     user_service: User persistence service.     user_limiter: Per-user request limit, resolved after authentication.  Returns:     An empty acknowledgement after the identity has been committed.  Raises:     HTTPConflict:         409: The request was prepared for a different authenticated account.
         * @summary Save Appsflyer Identity
         * @param {SaveAppsFlyerIdentityRequest} saveAppsFlyerIdentityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAppsflyerIdentity(saveAppsFlyerIdentityRequest: SaveAppsFlyerIdentityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.saveAppsflyerIdentity(saveAppsFlyerIdentityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Store onboarding answers and mark fulfilled intents.  Called by the web SPA after signup completes and the user row is provisioned.
         * @summary Save Onboarding Answers
         * @param {SubmitOnboardingAnswersRequest} submitOnboardingAnswersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveOnboardingAnswers(submitOnboardingAnswersRequest: SubmitOnboardingAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<OnboardingAnswersResponse> {
            return localVarFp.saveOnboardingAnswers(submitOnboardingAnswersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sign the user\'s HIPAA Business Associate Agreement.
         * @summary Sign Hipaa Baa
         * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.signHipaaBaa(signHipaaBaaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Set a user\'s student status by email (root API key).  When ``from_now`` is true the trial period is recomputed from the current time; otherwise it is calculated from the original reference point.
         * @summary Update Student Status
         * @param {BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost} bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost: BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Add words to the authenticated user\'s dictionary.
         * @summary Update User Dictionary
         * @param {Array<DictionaryItemOld>} dictionaryItemOld 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDictionary(dictionaryItemOld: Array<DictionaryItemOld>, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateUserDictionary(dictionaryItemOld, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the authenticated user\'s preferences.
         * @summary Update User Preference
         * @param {UserPreference} userPreference 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreference(userPreference: UserPreference, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateUserPreference(userPreference, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the authenticated user\'s profile (first and last name).
         * @summary Update User Profile
         * @param {UserProfile} userProfile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(userProfile: UserProfile, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateUserProfile(userProfile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserManagementApi - object-oriented interface
 * @export
 * @class UserManagementApi
 * @extends {BaseAPI}
 */
export class UserManagementApi extends BaseAPI {
    /**
     * Claim a trial extension day for dictating 100+ words.  Users can claim once per day, up to 7 days total, within 7 days of onboarding.
     * @summary Claim Trial Extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public claimTrialExtension(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).claimTrialExtension(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the authenticated user\'s entire dictionary.
     * @summary Delete User Dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public deleteUserDictionary(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).deleteUserDictionary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a single word from the authenticated user\'s dictionary.
     * @summary Delete Word In Dictionary
     * @param {string} wordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public deleteWordInDictionary(wordId: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).deleteWordInDictionary(wordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export all data associated with a user\'s email address (root API key).  Returns a JSON file containing all user data from main_db, usage_db, and platform_db.
     * @summary Export User Data
     * @param {string} email The email address of the user to export data for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public exportUserData(email: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).exportUserData(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the status of the user\'s HIPAA Business Associate Agreement.
     * @summary Get Hipaa Baa Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getHipaaBaaStatus(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getHipaaBaaStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List the third-party MCP clients this user has connected, most recently connected first.
     * @summary Get Mcp Connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getMcpConnection(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getMcpConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of platforms the user has registered.
     * @summary Get Registered Devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getRegisteredDevices(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getRegisteredDevices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s student status.
     * @summary Get Student Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getStudentStatus(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getStudentStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s trial status.
     * @summary Get Trial Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getTrialStatus(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getTrialStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s dictionary.
     * @summary Get User Dictionary
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserDictionary(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserDictionary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s ID.
     * @summary Get User Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserId(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s preferences.
     * @summary Get User Preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserPreference(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserPreference(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s profile information.
     * @summary Get User Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserProfile(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the authenticated user\'s usage stats.
     * @summary Get User Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserStats(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark onboarding completed and activate trial if eligible and claimed.
     * @summary Onboarding Complete
     * @param {string | null} [platform] Platform for attribution tracking
     * @param {TrialVariant | null} [trialVariant] Trial variant for experiment. None &#x3D; auto-grant (legacy/control)
     * @param {string | null} [ga4ClientId] GA4 client_id for attribution tracking
     * @param {string | null} [fbp] Meta _fbp cookie value
     * @param {string | null} [fbc] Meta _fbc click ID cookie value
     * @param {string | null} [utmSource] UTM source parameter
     * @param {string | null} [utmMedium] UTM medium parameter
     * @param {string | null} [utmCampaign] UTM campaign parameter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public onboardingComplete(platform?: string | null, trialVariant?: TrialVariant | null, ga4ClientId?: string | null, fbp?: string | null, fbc?: string | null, utmSource?: string | null, utmMedium?: string | null, utmCampaign?: string | null, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).onboardingComplete(platform, trialVariant, ga4ClientId, fbp, fbc, utmSource, utmMedium, utmCampaign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register a device for the authenticated user.
     * @summary Register Device
     * @param {RegisterDeviceRequest} registerDeviceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public registerDevice(registerDeviceRequest: RegisterDeviceRequest, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).registerDevice(registerDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke the user\'s HIPAA Business Associate Agreement.
     * @summary Revoke Hipaa Baa
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public revokeHipaaBaa(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).revokeHipaaBaa(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Persist an install identity only for the account the client intended.  Args:     data:         Install identity and expected authenticated account.     user:         Verified account identity.     user_service: User persistence service.     user_limiter: Per-user request limit, resolved after authentication.  Returns:     An empty acknowledgement after the identity has been committed.  Raises:     HTTPConflict:         409: The request was prepared for a different authenticated account.
     * @summary Save Appsflyer Identity
     * @param {SaveAppsFlyerIdentityRequest} saveAppsFlyerIdentityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public saveAppsflyerIdentity(saveAppsFlyerIdentityRequest: SaveAppsFlyerIdentityRequest, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).saveAppsflyerIdentity(saveAppsFlyerIdentityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store onboarding answers and mark fulfilled intents.  Called by the web SPA after signup completes and the user row is provisioned.
     * @summary Save Onboarding Answers
     * @param {SubmitOnboardingAnswersRequest} submitOnboardingAnswersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public saveOnboardingAnswers(submitOnboardingAnswersRequest: SubmitOnboardingAnswersRequest, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).saveOnboardingAnswers(submitOnboardingAnswersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sign the user\'s HIPAA Business Associate Agreement.
     * @summary Sign Hipaa Baa
     * @param {SignHipaaBaaRequest} signHipaaBaaRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public signHipaaBaa(signHipaaBaaRequest: SignHipaaBaaRequest, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).signHipaaBaa(signHipaaBaaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set a user\'s student status by email (root API key).  When ``from_now`` is true the trial period is recomputed from the current time; otherwise it is calculated from the original reference point.
     * @summary Update Student Status
     * @param {BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost} bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost: BodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).updateStudentStatus(bodyUpdateStudentStatusApiV1UserUpdateStudentStatusPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add words to the authenticated user\'s dictionary.
     * @summary Update User Dictionary
     * @param {Array<DictionaryItemOld>} dictionaryItemOld 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public updateUserDictionary(dictionaryItemOld: Array<DictionaryItemOld>, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).updateUserDictionary(dictionaryItemOld, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the authenticated user\'s preferences.
     * @summary Update User Preference
     * @param {UserPreference} userPreference 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public updateUserPreference(userPreference: UserPreference, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).updateUserPreference(userPreference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the authenticated user\'s profile (first and last name).
     * @summary Update User Profile
     * @param {UserProfile} userProfile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public updateUserProfile(userProfile: UserProfile, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).updateUserProfile(userProfile, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserVoicePreferencesApi - axios parameter creator
 * @export
 */
export const UserVoicePreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return all voice preference records for the authenticated user.
         * @summary List User Voice Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserVoicePreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user_voice_preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upsert a batch of voice preference records for the authenticated user.  The desktop client generates each record\'s UUID locally. Re-uploading the same record is idempotent: the existing row is updated, not duplicated. Each saved row is also scheduled for Graphiti voice-memory ingest (202-style, fire-and-forget — same as POST /memory/ingest).
         * @summary Upload User Voice Preferences
         * @param {UploadUserVoicePreferencesRequest} uploadUserVoicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserVoicePreferences: async (uploadUserVoicePreferencesRequest: UploadUserVoicePreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadUserVoicePreferencesRequest' is not null or undefined
            assertParamExists('uploadUserVoicePreferences', 'uploadUserVoicePreferencesRequest', uploadUserVoicePreferencesRequest)
            const localVarPath = `/api/v1/user_voice_preferences/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadUserVoicePreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserVoicePreferencesApi - functional programming interface
 * @export
 */
export const UserVoicePreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserVoicePreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * Return all voice preference records for the authenticated user.
         * @summary List User Voice Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserVoicePreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserVoicePreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserVoicePreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVoicePreferencesApi.listUserVoicePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upsert a batch of voice preference records for the authenticated user.  The desktop client generates each record\'s UUID locally. Re-uploading the same record is idempotent: the existing row is updated, not duplicated. Each saved row is also scheduled for Graphiti voice-memory ingest (202-style, fire-and-forget — same as POST /memory/ingest).
         * @summary Upload User Voice Preferences
         * @param {UploadUserVoicePreferencesRequest} uploadUserVoicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadUserVoicePreferences(uploadUserVoicePreferencesRequest: UploadUserVoicePreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadUserVoicePreferencesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadUserVoicePreferences(uploadUserVoicePreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserVoicePreferencesApi.uploadUserVoicePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserVoicePreferencesApi - factory interface
 * @export
 */
export const UserVoicePreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserVoicePreferencesApiFp(configuration)
    return {
        /**
         * Return all voice preference records for the authenticated user.
         * @summary List User Voice Preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserVoicePreferences(options?: RawAxiosRequestConfig): AxiosPromise<ListUserVoicePreferencesResponse> {
            return localVarFp.listUserVoicePreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * Upsert a batch of voice preference records for the authenticated user.  The desktop client generates each record\'s UUID locally. Re-uploading the same record is idempotent: the existing row is updated, not duplicated. Each saved row is also scheduled for Graphiti voice-memory ingest (202-style, fire-and-forget — same as POST /memory/ingest).
         * @summary Upload User Voice Preferences
         * @param {UploadUserVoicePreferencesRequest} uploadUserVoicePreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadUserVoicePreferences(uploadUserVoicePreferencesRequest: UploadUserVoicePreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadUserVoicePreferencesResponse> {
            return localVarFp.uploadUserVoicePreferences(uploadUserVoicePreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserVoicePreferencesApi - object-oriented interface
 * @export
 * @class UserVoicePreferencesApi
 * @extends {BaseAPI}
 */
export class UserVoicePreferencesApi extends BaseAPI {
    /**
     * Return all voice preference records for the authenticated user.
     * @summary List User Voice Preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVoicePreferencesApi
     */
    public listUserVoicePreferences(options?: RawAxiosRequestConfig) {
        return UserVoicePreferencesApiFp(this.configuration).listUserVoicePreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upsert a batch of voice preference records for the authenticated user.  The desktop client generates each record\'s UUID locally. Re-uploading the same record is idempotent: the existing row is updated, not duplicated. Each saved row is also scheduled for Graphiti voice-memory ingest (202-style, fire-and-forget — same as POST /memory/ingest).
     * @summary Upload User Voice Preferences
     * @param {UploadUserVoicePreferencesRequest} uploadUserVoicePreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserVoicePreferencesApi
     */
    public uploadUserVoicePreferences(uploadUserVoicePreferencesRequest: UploadUserVoicePreferencesRequest, options?: RawAxiosRequestConfig) {
        return UserVoicePreferencesApiFp(this.configuration).uploadUserVoicePreferences(uploadUserVoicePreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VoiceActionsApi - axios parameter creator
 * @export
 */
export const VoiceActionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Return a representative client-to-server frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceActionsRealtimeClientSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/voice-actions/realtime/client-schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a representative server-to-client frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceActionsRealtimeSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/voice-actions/realtime/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoiceActionsApi - functional programming interface
 * @export
 */
export const VoiceActionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoiceActionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Return a representative client-to-server frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceActionsRealtimeClientSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceActionsClientFrameEnvelope>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceActionsRealtimeClientSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceActionsApi.voiceActionsRealtimeClientSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return a representative server-to-client frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceActionsRealtimeSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceActionsServerFrameEnvelope>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceActionsRealtimeSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceActionsApi.voiceActionsRealtimeSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoiceActionsApi - factory interface
 * @export
 */
export const VoiceActionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoiceActionsApiFp(configuration)
    return {
        /**
         * Return a representative client-to-server frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Client Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceActionsRealtimeClientSchema(options?: RawAxiosRequestConfig): AxiosPromise<VoiceActionsClientFrameEnvelope> {
            return localVarFp.voiceActionsRealtimeClientSchema(options).then((request) => request(axios, basePath));
        },
        /**
         * Return a representative server-to-client frame so the envelope schema surfaces in OpenAPI.
         * @summary Voice Actions Realtime Schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceActionsRealtimeSchema(options?: RawAxiosRequestConfig): AxiosPromise<VoiceActionsServerFrameEnvelope> {
            return localVarFp.voiceActionsRealtimeSchema(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoiceActionsApi - object-oriented interface
 * @export
 * @class VoiceActionsApi
 * @extends {BaseAPI}
 */
export class VoiceActionsApi extends BaseAPI {
    /**
     * Return a representative client-to-server frame so the envelope schema surfaces in OpenAPI.
     * @summary Voice Actions Realtime Client Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceActionsApi
     */
    public voiceActionsRealtimeClientSchema(options?: RawAxiosRequestConfig) {
        return VoiceActionsApiFp(this.configuration).voiceActionsRealtimeClientSchema(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return a representative server-to-client frame so the envelope schema surfaces in OpenAPI.
     * @summary Voice Actions Realtime Schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceActionsApi
     */
    public voiceActionsRealtimeSchema(options?: RawAxiosRequestConfig) {
        return VoiceActionsApiFp(this.configuration).voiceActionsRealtimeSchema(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WeeklyWordLimitsApi - axios parameter creator
 * @export
 */
export const WeeklyWordLimitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Decide the authenticated user\'s weekly word limit experiment arm at the end of onboarding.  Call once per user and platform. A ``503`` wrote nothing and is safe to retry.
         * @summary Enroll Weekly Word Limits
         * @param {WeeklyWordLimitsEnrollRequest} weeklyWordLimitsEnrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollWeeklyWordLimits: async (weeklyWordLimitsEnrollRequest: WeeklyWordLimitsEnrollRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'weeklyWordLimitsEnrollRequest' is not null or undefined
            assertParamExists('enrollWeeklyWordLimits', 'weeklyWordLimitsEnrollRequest', weeklyWordLimitsEnrollRequest)
            const localVarPath = `/api/v1/weekly-word-limits/enroll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(weeklyWordLimitsEnrollRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WeeklyWordLimitsApi - functional programming interface
 * @export
 */
export const WeeklyWordLimitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WeeklyWordLimitsApiAxiosParamCreator(configuration)
    return {
        /**
         * Decide the authenticated user\'s weekly word limit experiment arm at the end of onboarding.  Call once per user and platform. A ``503`` wrote nothing and is safe to retry.
         * @summary Enroll Weekly Word Limits
         * @param {WeeklyWordLimitsEnrollRequest} weeklyWordLimitsEnrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest: WeeklyWordLimitsEnrollRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WeeklyWordLimitsEnrollResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WeeklyWordLimitsApi.enrollWeeklyWordLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WeeklyWordLimitsApi - factory interface
 * @export
 */
export const WeeklyWordLimitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WeeklyWordLimitsApiFp(configuration)
    return {
        /**
         * Decide the authenticated user\'s weekly word limit experiment arm at the end of onboarding.  Call once per user and platform. A ``503`` wrote nothing and is safe to retry.
         * @summary Enroll Weekly Word Limits
         * @param {WeeklyWordLimitsEnrollRequest} weeklyWordLimitsEnrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest: WeeklyWordLimitsEnrollRequest, options?: RawAxiosRequestConfig): AxiosPromise<WeeklyWordLimitsEnrollResponse> {
            return localVarFp.enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WeeklyWordLimitsApi - object-oriented interface
 * @export
 * @class WeeklyWordLimitsApi
 * @extends {BaseAPI}
 */
export class WeeklyWordLimitsApi extends BaseAPI {
    /**
     * Decide the authenticated user\'s weekly word limit experiment arm at the end of onboarding.  Call once per user and platform. A ``503`` wrote nothing and is safe to retry.
     * @summary Enroll Weekly Word Limits
     * @param {WeeklyWordLimitsEnrollRequest} weeklyWordLimitsEnrollRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WeeklyWordLimitsApi
     */
    public enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest: WeeklyWordLimitsEnrollRequest, options?: RawAxiosRequestConfig) {
        return WeeklyWordLimitsApiFp(this.configuration).enrollWeeklyWordLimits(weeklyWordLimitsEnrollRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WisprMemoryApi - axios parameter creator
 * @export
 */
export const WisprMemoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Which run wrote each line of one of the caller\'s live files.
         * @summary Get Wispr Memory Blame
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryBlame: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getWisprMemoryBlame', 'path', path)
            const localVarPath = `/api/v1/wispr-memory/blame`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The latest version of one of the caller\'s files.
         * @summary Get Wispr Memory File
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryFile: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getWisprMemoryFile', 'path', path)
            const localVarPath = `/api/v1/wispr-memory/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One stored version of one of the caller\'s files; ``content`` is null for a deletion.
         * @summary Get Wispr Memory File Version
         * @param {number} version 
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryFileVersion: async (version: number, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('getWisprMemoryFileVersion', 'version', version)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getWisprMemoryFileVersion', 'path', path)
            const localVarPath = `/api/v1/wispr-memory/versions/{version}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s finite source-coverage counts, open agent work and Dreamer schedule.
         * @summary Get Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryOnboarding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One retained run: changed files, source-revision input count and available owned meeting references.
         * @summary Get Wispr Memory Run
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getWisprMemoryRun', 'runId', runId)
            const localVarPath = `/api/v1/wispr-memory/runs/{run_id}`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * One file\'s change in one run, as line operations.
         * @summary Get Wispr Memory Run Diff
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryRunDiff: async (runId: string, path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getWisprMemoryRunDiff', 'runId', runId)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getWisprMemoryRunDiff', 'path', path)
            const localVarPath = `/api/v1/wispr-memory/runs/{run_id}/diff`
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The caller\'s live files under ``prefix``: path, version, size and write time, never content.
         * @summary Get Wispr Memory Tree
         * @param {string} [prefix] Path prefix; empty for the whole tree.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryTree: async (prefix?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (prefix !== undefined) {
                localVarQueryParameter['prefix'] = prefix;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wake every connected source; ``not_queued`` means memory is not active or no wake was accepted. Staff only.
         * @summary Kick Own Wispr Memory Curator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemoryCurator: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/debug/curator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start the caller\'s exact manual Dreamer request; ``not_queued`` means it was not accepted. Staff only.
         * @summary Kick Own Wispr Memory Dreamer
         * @param {WisprMemoryDreamKickRequest} wisprMemoryDreamKickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemoryDreamer: async (wisprMemoryDreamKickRequest: WisprMemoryDreamKickRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wisprMemoryDreamKickRequest' is not null or undefined
            assertParamExists('kickOwnWisprMemoryDreamer', 'wisprMemoryDreamKickRequest', wisprMemoryDreamKickRequest)
            const localVarPath = `/api/v1/wispr-memory/debug/dreamer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wisprMemoryDreamKickRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wake one live source of an active owner; a relearn rebuilds memory from the archive. Staff only.
         * @summary Kick Own Wispr Memory Source
         * @param {string} source A source from the status, e.g. &#x60;gmail&#x60;.
         * @param {WisprMemorySourceKickRequest} [wisprMemorySourceKickRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemorySource: async (source: string, wisprMemorySourceKickRequest?: WisprMemorySourceKickRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'source' is not null or undefined
            assertParamExists('kickOwnWisprMemorySource', 'source', source)
            const localVarPath = `/api/v1/wispr-memory/debug/sources/{source}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wisprMemorySourceKickRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A newest-first page of one file\'s versions, deleted ones included.
         * @summary List Wispr Memory File Versions
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {number | null} [before] Return versions below this one (the cursor).
         * @param {number} [limit] Maximum document versions to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWisprMemoryFileVersions: async (path: string, before?: number | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('listWisprMemoryFileVersions', 'path', path)
            const localVarPath = `/api/v1/wispr-memory/versions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }

            if (before !== undefined) {
                localVarQueryParameter['before'] = before;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A newest-first page of the caller\'s agent and Dreamer runs in the last 90 days.  A run that changed no file is listed by its receipt.
         * @summary List Wispr Memory Runs
         * @param {string | null} [cursor] &#x60;next_cursor&#x60; from the previous page.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWisprMemoryRuns: async (cursor?: string | null, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCheckout: async (checkoutRequest: CheckoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutRequest' is not null or undefined
            assertParamExists('memoryWorkbenchCheckout', 'checkoutRequest', checkoutRequest)
            const localVarPath = `/api/v1/wispr-memory/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCheckout_1: async (checkoutRequest: CheckoutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkoutRequest' is not null or undefined
            assertParamExists('memoryWorkbenchCheckout_1', 'checkoutRequest', checkoutRequest)
            const localVarPath = `/api/v1/wispr-memory/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCommit: async (memoryCommitRequest: MemoryCommitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryCommitRequest' is not null or undefined
            assertParamExists('memoryWorkbenchCommit', 'memoryCommitRequest', memoryCommitRequest)
            const localVarPath = `/api/v1/wispr-memory/commits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memoryCommitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCommit_2: async (memoryCommitRequest: MemoryCommitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memoryCommitRequest' is not null or undefined
            assertParamExists('memoryWorkbenchCommit_2', 'memoryCommitRequest', memoryCommitRequest)
            const localVarPath = `/api/v1/wispr-memory/commits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memoryCommitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchEvents: async (after?: string | null, limit?: number, runId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (runId !== undefined) {
                localVarQueryParameter['run_id'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchEvents_3: async (after?: string | null, limit?: number, runId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (runId !== undefined) {
                localVarQueryParameter['run_id'] = runId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchGrep: async (grepRequest: GrepRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grepRequest' is not null or undefined
            assertParamExists('memoryWorkbenchGrep', 'grepRequest', grepRequest)
            const localVarPath = `/api/v1/wispr-memory/grep`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchGrep_4: async (grepRequest: GrepRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'grepRequest' is not null or undefined
            assertParamExists('memoryWorkbenchGrep_4', 'grepRequest', grepRequest)
            const localVarPath = `/api/v1/wispr-memory/grep`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grepRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stop the caller\'s Dreamer and erase documents, retained revisions, source progress and agent work. Staff only.  The next Start builds memory again from empty.
         * @summary Reset Own Wispr Memory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOwnWisprMemory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/debug/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every current file of the caller\'s whose path, frontmatter or lines contain the query, case-insensitively.
         * @summary Search Wispr Memory
         * @param {WisprMemorySearchRequest} wisprMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWisprMemory: async (wisprMemorySearchRequest: WisprMemorySearchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wisprMemorySearchRequest' is not null or undefined
            assertParamExists('searchWisprMemory', 'wisprMemorySearchRequest', wisprMemorySearchRequest)
            const localVarPath = `/api/v1/wispr-memory/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wisprMemorySearchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activate the caller\'s memory: seed the fresh tree and freeze initial coverage of their available sources.  A first Start, or the first after a wipe, also turns the owner on and requests a sync of its sources. Repeated Start preserves existing coverage and the owner\'s execution mode.
         * @summary Start Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWisprMemoryOnboarding: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/wispr-memory/onboarding/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyHeaderPatched required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WisprMemoryApi - functional programming interface
 * @export
 */
export const WisprMemoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WisprMemoryApiAxiosParamCreator(configuration)
    return {
        /**
         * Which run wrote each line of one of the caller\'s live files.
         * @summary Get Wispr Memory Blame
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryBlame(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryBlameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryBlame(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryBlame']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The latest version of one of the caller\'s files.
         * @summary Get Wispr Memory File
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryFile(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryFile(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One stored version of one of the caller\'s files; ``content`` is null for a deletion.
         * @summary Get Wispr Memory File Version
         * @param {number} version 
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryFileVersion(version: number, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryFileVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryFileVersion(version, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryFileVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The caller\'s finite source-coverage counts, open agent work and Dreamer schedule.
         * @summary Get Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryOnboarding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryOnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryOnboarding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One retained run: changed files, source-revision input count and available owned meeting references.
         * @summary Get Wispr Memory Run
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryRunDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * One file\'s change in one run, as line operations.
         * @summary Get Wispr Memory Run Diff
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryRunDiff(runId: string, path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryRunDiffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryRunDiff(runId, path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryRunDiff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The caller\'s live files under ``prefix``: path, version, size and write time, never content.
         * @summary Get Wispr Memory Tree
         * @param {string} [prefix] Path prefix; empty for the whole tree.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWisprMemoryTree(prefix?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWisprMemoryTree(prefix, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.getWisprMemoryTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wake every connected source; ``not_queued`` means memory is not active or no wake was accepted. Staff only.
         * @summary Kick Own Wispr Memory Curator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kickOwnWisprMemoryCurator(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryKickResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kickOwnWisprMemoryCurator(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.kickOwnWisprMemoryCurator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start the caller\'s exact manual Dreamer request; ``not_queued`` means it was not accepted. Staff only.
         * @summary Kick Own Wispr Memory Dreamer
         * @param {WisprMemoryDreamKickRequest} wisprMemoryDreamKickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest: WisprMemoryDreamKickRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryKickResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.kickOwnWisprMemoryDreamer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wake one live source of an active owner; a relearn rebuilds memory from the archive. Staff only.
         * @summary Kick Own Wispr Memory Source
         * @param {string} source A source from the status, e.g. &#x60;gmail&#x60;.
         * @param {WisprMemorySourceKickRequest} [wisprMemorySourceKickRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kickOwnWisprMemorySource(source: string, wisprMemorySourceKickRequest?: WisprMemorySourceKickRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryKickResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kickOwnWisprMemorySource(source, wisprMemorySourceKickRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.kickOwnWisprMemorySource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A newest-first page of one file\'s versions, deleted ones included.
         * @summary List Wispr Memory File Versions
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {number | null} [before] Return versions below this one (the cursor).
         * @param {number} [limit] Maximum document versions to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWisprMemoryFileVersions(path: string, before?: number | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWisprMemoryFileVersions(path, before, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.listWisprMemoryFileVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A newest-first page of the caller\'s agent and Dreamer runs in the last 90 days.  A run that changed no file is listed by its receipt.
         * @summary List Wispr Memory Runs
         * @param {string | null} [cursor] &#x60;next_cursor&#x60; from the previous page.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listWisprMemoryRuns(cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryRunsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listWisprMemoryRuns(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.listWisprMemoryRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchCheckout(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchCheckout(checkoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchCheckout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchCheckout_1(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchCheckout_1(checkoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchCheckout_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchCommit(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryCommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchCommit(memoryCommitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchCommit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchCommit_2(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemoryCommitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchCommit_2(memoryCommitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchCommit_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchEvents(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchEvents(after, limit, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchEvents_3(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchEvents_3(after, limit, runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchEvents_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchGrep(grepRequest: GrepRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchGrep(grepRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchGrep']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async memoryWorkbenchGrep_4(grepRequest: GrepRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GrepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.memoryWorkbenchGrep_4(grepRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.memoryWorkbenchGrep_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stop the caller\'s Dreamer and erase documents, retained revisions, source progress and agent work. Staff only.  The next Start builds memory again from empty.
         * @summary Reset Own Wispr Memory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetOwnWisprMemory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryResetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetOwnWisprMemory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.resetOwnWisprMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every current file of the caller\'s whose path, frontmatter or lines contain the query, case-insensitively.
         * @summary Search Wispr Memory
         * @param {WisprMemorySearchRequest} wisprMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWisprMemory(wisprMemorySearchRequest: WisprMemorySearchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemorySearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWisprMemory(wisprMemorySearchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.searchWisprMemory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Activate the caller\'s memory: seed the fresh tree and freeze initial coverage of their available sources.  A first Start, or the first after a wipe, also turns the owner on and requests a sync of its sources. Repeated Start preserves existing coverage and the owner\'s execution mode.
         * @summary Start Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startWisprMemoryOnboarding(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WisprMemoryOnboardingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startWisprMemoryOnboarding(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WisprMemoryApi.startWisprMemoryOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WisprMemoryApi - factory interface
 * @export
 */
export const WisprMemoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WisprMemoryApiFp(configuration)
    return {
        /**
         * Which run wrote each line of one of the caller\'s live files.
         * @summary Get Wispr Memory Blame
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryBlame(path: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryBlameResponse> {
            return localVarFp.getWisprMemoryBlame(path, options).then((request) => request(axios, basePath));
        },
        /**
         * The latest version of one of the caller\'s files.
         * @summary Get Wispr Memory File
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryFile(path: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryFileResponse> {
            return localVarFp.getWisprMemoryFile(path, options).then((request) => request(axios, basePath));
        },
        /**
         * One stored version of one of the caller\'s files; ``content`` is null for a deletion.
         * @summary Get Wispr Memory File Version
         * @param {number} version 
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryFileVersion(version: number, path: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryFileVersionResponse> {
            return localVarFp.getWisprMemoryFileVersion(version, path, options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s finite source-coverage counts, open agent work and Dreamer schedule.
         * @summary Get Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryOnboarding(options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryOnboardingResponse> {
            return localVarFp.getWisprMemoryOnboarding(options).then((request) => request(axios, basePath));
        },
        /**
         * One retained run: changed files, source-revision input count and available owned meeting references.
         * @summary Get Wispr Memory Run
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryRun(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryRunDetailResponse> {
            return localVarFp.getWisprMemoryRun(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * One file\'s change in one run, as line operations.
         * @summary Get Wispr Memory Run Diff
         * @param {string} runId A run id from &#x60;/runs&#x60;.
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryRunDiff(runId: string, path: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryRunDiffResponse> {
            return localVarFp.getWisprMemoryRunDiff(runId, path, options).then((request) => request(axios, basePath));
        },
        /**
         * The caller\'s live files under ``prefix``: path, version, size and write time, never content.
         * @summary Get Wispr Memory Tree
         * @param {string} [prefix] Path prefix; empty for the whole tree.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWisprMemoryTree(prefix?: string, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryTreeResponse> {
            return localVarFp.getWisprMemoryTree(prefix, options).then((request) => request(axios, basePath));
        },
        /**
         * Wake every connected source; ``not_queued`` means memory is not active or no wake was accepted. Staff only.
         * @summary Kick Own Wispr Memory Curator
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemoryCurator(options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryKickResponse> {
            return localVarFp.kickOwnWisprMemoryCurator(options).then((request) => request(axios, basePath));
        },
        /**
         * Start the caller\'s exact manual Dreamer request; ``not_queued`` means it was not accepted. Staff only.
         * @summary Kick Own Wispr Memory Dreamer
         * @param {WisprMemoryDreamKickRequest} wisprMemoryDreamKickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest: WisprMemoryDreamKickRequest, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryKickResponse> {
            return localVarFp.kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Wake one live source of an active owner; a relearn rebuilds memory from the archive. Staff only.
         * @summary Kick Own Wispr Memory Source
         * @param {string} source A source from the status, e.g. &#x60;gmail&#x60;.
         * @param {WisprMemorySourceKickRequest} [wisprMemorySourceKickRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kickOwnWisprMemorySource(source: string, wisprMemorySourceKickRequest?: WisprMemorySourceKickRequest, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryKickResponse> {
            return localVarFp.kickOwnWisprMemorySource(source, wisprMemorySourceKickRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * A newest-first page of one file\'s versions, deleted ones included.
         * @summary List Wispr Memory File Versions
         * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
         * @param {number | null} [before] Return versions below this one (the cursor).
         * @param {number} [limit] Maximum document versions to return.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWisprMemoryFileVersions(path: string, before?: number | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryVersionsResponse> {
            return localVarFp.listWisprMemoryFileVersions(path, before, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * A newest-first page of the caller\'s agent and Dreamer runs in the last 90 days.  A run that changed no file is listed by its receipt.
         * @summary List Wispr Memory Runs
         * @param {string | null} [cursor] &#x60;next_cursor&#x60; from the previous page.
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWisprMemoryRuns(cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryRunsResponse> {
            return localVarFp.listWisprMemoryRuns(cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCheckout(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutResponse> {
            return localVarFp.memoryWorkbenchCheckout(checkoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Read bounded eligible heads and reject lifecycle changes during the read.
         * @summary Memory Workbench Checkout
         * @param {CheckoutRequest} checkoutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCheckout_1(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutResponse> {
            return localVarFp.memoryWorkbenchCheckout_1(checkoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCommit(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryCommitResponse> {
            return localVarFp.memoryWorkbenchCommit(memoryCommitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Run the authenticated commit memory operation.
         * @summary Memory Workbench Commit
         * @param {MemoryCommitRequest} memoryCommitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchCommit_2(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemoryCommitResponse> {
            return localVarFp.memoryWorkbenchCommit_2(memoryCommitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchEvents(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<EventPage> {
            return localVarFp.memoryWorkbenchEvents(after, limit, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Page retained events, only the ones one run was shown when ``run_id`` is given.
         * @summary Memory Workbench Events
         * @param {string | null} [after] Continue after this event identifier.
         * @param {number} [limit] Maximum events to return.
         * @param {string | null} [runId] Only the events this run was shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchEvents_3(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<EventPage> {
            return localVarFp.memoryWorkbenchEvents_3(after, limit, runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchGrep(grepRequest: GrepRequest, options?: RawAxiosRequestConfig): AxiosPromise<GrepResponse> {
            return localVarFp.memoryWorkbenchGrep(grepRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Find literal matching lines within the bounded eligible checkout.
         * @summary Memory Workbench Grep
         * @param {GrepRequest} grepRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        memoryWorkbenchGrep_4(grepRequest: GrepRequest, options?: RawAxiosRequestConfig): AxiosPromise<GrepResponse> {
            return localVarFp.memoryWorkbenchGrep_4(grepRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stop the caller\'s Dreamer and erase documents, retained revisions, source progress and agent work. Staff only.  The next Start builds memory again from empty.
         * @summary Reset Own Wispr Memory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetOwnWisprMemory(options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryResetResponse> {
            return localVarFp.resetOwnWisprMemory(options).then((request) => request(axios, basePath));
        },
        /**
         * Every current file of the caller\'s whose path, frontmatter or lines contain the query, case-insensitively.
         * @summary Search Wispr Memory
         * @param {WisprMemorySearchRequest} wisprMemorySearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWisprMemory(wisprMemorySearchRequest: WisprMemorySearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<WisprMemorySearchResponse> {
            return localVarFp.searchWisprMemory(wisprMemorySearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Activate the caller\'s memory: seed the fresh tree and freeze initial coverage of their available sources.  A first Start, or the first after a wipe, also turns the owner on and requests a sync of its sources. Repeated Start preserves existing coverage and the owner\'s execution mode.
         * @summary Start Wispr Memory Onboarding
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWisprMemoryOnboarding(options?: RawAxiosRequestConfig): AxiosPromise<WisprMemoryOnboardingResponse> {
            return localVarFp.startWisprMemoryOnboarding(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WisprMemoryApi - object-oriented interface
 * @export
 * @class WisprMemoryApi
 * @extends {BaseAPI}
 */
export class WisprMemoryApi extends BaseAPI {
    /**
     * Which run wrote each line of one of the caller\'s live files.
     * @summary Get Wispr Memory Blame
     * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryBlame(path: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryBlame(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The latest version of one of the caller\'s files.
     * @summary Get Wispr Memory File
     * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryFile(path: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryFile(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One stored version of one of the caller\'s files; ``content`` is null for a deletion.
     * @summary Get Wispr Memory File Version
     * @param {number} version 
     * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryFileVersion(version: number, path: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryFileVersion(version, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s finite source-coverage counts, open agent work and Dreamer schedule.
     * @summary Get Wispr Memory Onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryOnboarding(options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryOnboarding(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One retained run: changed files, source-revision input count and available owned meeting references.
     * @summary Get Wispr Memory Run
     * @param {string} runId A run id from &#x60;/runs&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryRun(runId: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryRun(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * One file\'s change in one run, as line operations.
     * @summary Get Wispr Memory Run Diff
     * @param {string} runId A run id from &#x60;/runs&#x60;.
     * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryRunDiff(runId: string, path: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryRunDiff(runId, path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The caller\'s live files under ``prefix``: path, version, size and write time, never content.
     * @summary Get Wispr Memory Tree
     * @param {string} [prefix] Path prefix; empty for the whole tree.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public getWisprMemoryTree(prefix?: string, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).getWisprMemoryTree(prefix, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wake every connected source; ``not_queued`` means memory is not active or no wake was accepted. Staff only.
     * @summary Kick Own Wispr Memory Curator
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public kickOwnWisprMemoryCurator(options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).kickOwnWisprMemoryCurator(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start the caller\'s exact manual Dreamer request; ``not_queued`` means it was not accepted. Staff only.
     * @summary Kick Own Wispr Memory Dreamer
     * @param {WisprMemoryDreamKickRequest} wisprMemoryDreamKickRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest: WisprMemoryDreamKickRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).kickOwnWisprMemoryDreamer(wisprMemoryDreamKickRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wake one live source of an active owner; a relearn rebuilds memory from the archive. Staff only.
     * @summary Kick Own Wispr Memory Source
     * @param {string} source A source from the status, e.g. &#x60;gmail&#x60;.
     * @param {WisprMemorySourceKickRequest} [wisprMemorySourceKickRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public kickOwnWisprMemorySource(source: string, wisprMemorySourceKickRequest?: WisprMemorySourceKickRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).kickOwnWisprMemorySource(source, wisprMemorySourceKickRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A newest-first page of one file\'s versions, deleted ones included.
     * @summary List Wispr Memory File Versions
     * @param {string} path File path, e.g. &#x60;people/&lt;contact id&gt;.md&#x60;.
     * @param {number | null} [before] Return versions below this one (the cursor).
     * @param {number} [limit] Maximum document versions to return.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public listWisprMemoryFileVersions(path: string, before?: number | null, limit?: number, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).listWisprMemoryFileVersions(path, before, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A newest-first page of the caller\'s agent and Dreamer runs in the last 90 days.  A run that changed no file is listed by its receipt.
     * @summary List Wispr Memory Runs
     * @param {string | null} [cursor] &#x60;next_cursor&#x60; from the previous page.
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public listWisprMemoryRuns(cursor?: string | null, limit?: number, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).listWisprMemoryRuns(cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read bounded eligible heads and reject lifecycle changes during the read.
     * @summary Memory Workbench Checkout
     * @param {CheckoutRequest} checkoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchCheckout(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchCheckout(checkoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read bounded eligible heads and reject lifecycle changes during the read.
     * @summary Memory Workbench Checkout
     * @param {CheckoutRequest} checkoutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchCheckout_1(checkoutRequest: CheckoutRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchCheckout_1(checkoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run the authenticated commit memory operation.
     * @summary Memory Workbench Commit
     * @param {MemoryCommitRequest} memoryCommitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchCommit(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchCommit(memoryCommitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Run the authenticated commit memory operation.
     * @summary Memory Workbench Commit
     * @param {MemoryCommitRequest} memoryCommitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchCommit_2(memoryCommitRequest: MemoryCommitRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchCommit_2(memoryCommitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Page retained events, only the ones one run was shown when ``run_id`` is given.
     * @summary Memory Workbench Events
     * @param {string | null} [after] Continue after this event identifier.
     * @param {number} [limit] Maximum events to return.
     * @param {string | null} [runId] Only the events this run was shown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchEvents(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchEvents(after, limit, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Page retained events, only the ones one run was shown when ``run_id`` is given.
     * @summary Memory Workbench Events
     * @param {string | null} [after] Continue after this event identifier.
     * @param {number} [limit] Maximum events to return.
     * @param {string | null} [runId] Only the events this run was shown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchEvents_3(after?: string | null, limit?: number, runId?: string | null, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchEvents_3(after, limit, runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find literal matching lines within the bounded eligible checkout.
     * @summary Memory Workbench Grep
     * @param {GrepRequest} grepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchGrep(grepRequest: GrepRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchGrep(grepRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find literal matching lines within the bounded eligible checkout.
     * @summary Memory Workbench Grep
     * @param {GrepRequest} grepRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public memoryWorkbenchGrep_4(grepRequest: GrepRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).memoryWorkbenchGrep_4(grepRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stop the caller\'s Dreamer and erase documents, retained revisions, source progress and agent work. Staff only.  The next Start builds memory again from empty.
     * @summary Reset Own Wispr Memory
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public resetOwnWisprMemory(options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).resetOwnWisprMemory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every current file of the caller\'s whose path, frontmatter or lines contain the query, case-insensitively.
     * @summary Search Wispr Memory
     * @param {WisprMemorySearchRequest} wisprMemorySearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public searchWisprMemory(wisprMemorySearchRequest: WisprMemorySearchRequest, options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).searchWisprMemory(wisprMemorySearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activate the caller\'s memory: seed the fresh tree and freeze initial coverage of their available sources.  A first Start, or the first after a wipe, also turns the owner on and requests a sync of its sources. Repeated Start preserves existing coverage and the owner\'s execution mode.
     * @summary Start Wispr Memory Onboarding
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WisprMemoryApi
     */
    public startWisprMemoryOnboarding(options?: RawAxiosRequestConfig) {
        return WisprMemoryApiFp(this.configuration).startWisprMemoryOnboarding(options).then((request) => request(this.axios, this.basePath));
    }
}



